export const quran: {
	id: string;
	number: string;
	number_in_surah: string;
	text: string;
	page: string;
	surah_id: string;
	hizb_id: string;
	juz_id: string;
	sajda: string;
	created_at: string;
	updated_at: string;
}[] = [
	{
		id: '1',
		number: '1',
		text: '﻿بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ',
		number_in_surah: '1',
		page: '1',
		surah_id: '1',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '2',
		number: '2',
		text: 'ٱلْحَمْدُ لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '2',
		page: '1',
		surah_id: '1',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '3',
		number: '3',
		text: 'ٱلرَّحْمَٰنِ ٱلرَّحِيمِ',
		number_in_surah: '3',
		page: '1',
		surah_id: '1',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '4',
		number: '4',
		text: 'مَٰلِكِ يَوْمِ ٱلدِّينِ',
		number_in_surah: '4',
		page: '1',
		surah_id: '1',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '5',
		number: '5',
		text: 'إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ',
		number_in_surah: '5',
		page: '1',
		surah_id: '1',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '6',
		number: '6',
		text: 'ٱهْدِنَا ٱلصِّرَٰطَ ٱلْمُسْتَقِيمَ',
		number_in_surah: '6',
		page: '1',
		surah_id: '1',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '7',
		number: '7',
		text: 'صِرَٰطَ ٱلَّذِينَ أَنْعَمْتَ عَلَيْهِمْ غَيْرِ ٱلْمَغْضُوبِ عَلَيْهِمْ وَلَا ٱلضَّآلِّينَ',
		number_in_surah: '7',
		page: '1',
		surah_id: '1',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '8',
		number: '8',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓمٓ',
		number_in_surah: '1',
		page: '2',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '9',
		number: '9',
		text: 'ذَٰلِكَ ٱلْكِتَٰبُ لَا رَيْبَ ۛ فِيهِ ۛ هُدًۭى لِّلْمُتَّقِينَ',
		number_in_surah: '2',
		page: '2',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '10',
		number: '10',
		text: 'ٱلَّذِينَ يُؤْمِنُونَ بِٱلْغَيْبِ وَيُقِيمُونَ ٱلصَّلَوٰةَ وَمِمَّا رَزَقْنَٰهُمْ يُنفِقُونَ',
		number_in_surah: '3',
		page: '2',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '11',
		number: '11',
		text: 'وَٱلَّذِينَ يُؤْمِنُونَ بِمَآ أُنزِلَ إِلَيْكَ وَمَآ أُنزِلَ مِن قَبْلِكَ وَبِٱلْءَاخِرَةِ هُمْ يُوقِنُونَ',
		number_in_surah: '4',
		page: '2',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '12',
		number: '12',
		text: 'أُو۟لَٰٓئِكَ عَلَىٰ هُدًۭى مِّن رَّبِّهِمْ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '5',
		page: '2',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '13',
		number: '13',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ سَوَآءٌ عَلَيْهِمْ ءَأَنذَرْتَهُمْ أَمْ لَمْ تُنذِرْهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '6',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '14',
		number: '14',
		text: 'خَتَمَ ٱللَّهُ عَلَىٰ قُلُوبِهِمْ وَعَلَىٰ سَمْعِهِمْ ۖ وَعَلَىٰٓ أَبْصَٰرِهِمْ غِشَٰوَةٌۭ ۖ وَلَهُمْ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '7',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '15',
		number: '15',
		text: 'وَمِنَ ٱلنَّاسِ مَن يَقُولُ ءَامَنَّا بِٱللَّهِ وَبِٱلْيَوْمِ ٱلْءَاخِرِ وَمَا هُم بِمُؤْمِنِينَ',
		number_in_surah: '8',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '16',
		number: '16',
		text: 'يُخَٰدِعُونَ ٱللَّهَ وَٱلَّذِينَ ءَامَنُوا۟ وَمَا يَخْدَعُونَ إِلَّآ أَنفُسَهُمْ وَمَا يَشْعُرُونَ',
		number_in_surah: '9',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '17',
		number: '17',
		text: 'فِى قُلُوبِهِم مَّرَضٌۭ فَزَادَهُمُ ٱللَّهُ مَرَضًۭا ۖ وَلَهُمْ عَذَابٌ أَلِيمٌۢ بِمَا كَانُوا۟ يَكْذِبُونَ',
		number_in_surah: '10',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '18',
		number: '18',
		text: 'وَإِذَا قِيلَ لَهُمْ لَا تُفْسِدُوا۟ فِى ٱلْأَرْضِ قَالُوٓا۟ إِنَّمَا نَحْنُ مُصْلِحُونَ',
		number_in_surah: '11',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '19',
		number: '19',
		text: 'أَلَآ إِنَّهُمْ هُمُ ٱلْمُفْسِدُونَ وَلَٰكِن لَّا يَشْعُرُونَ',
		number_in_surah: '12',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '20',
		number: '20',
		text: 'وَإِذَا قِيلَ لَهُمْ ءَامِنُوا۟ كَمَآ ءَامَنَ ٱلنَّاسُ قَالُوٓا۟ أَنُؤْمِنُ كَمَآ ءَامَنَ ٱلسُّفَهَآءُ ۗ أَلَآ إِنَّهُمْ هُمُ ٱلسُّفَهَآءُ وَلَٰكِن لَّا يَعْلَمُونَ',
		number_in_surah: '13',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '21',
		number: '21',
		text: 'وَإِذَا لَقُوا۟ ٱلَّذِينَ ءَامَنُوا۟ قَالُوٓا۟ ءَامَنَّا وَإِذَا خَلَوْا۟ إِلَىٰ شَيَٰطِينِهِمْ قَالُوٓا۟ إِنَّا مَعَكُمْ إِنَّمَا نَحْنُ مُسْتَهْزِءُونَ',
		number_in_surah: '14',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '22',
		number: '22',
		text: 'ٱللَّهُ يَسْتَهْزِئُ بِهِمْ وَيَمُدُّهُمْ فِى طُغْيَٰنِهِمْ يَعْمَهُونَ',
		number_in_surah: '15',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '23',
		number: '23',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ ٱشْتَرَوُا۟ ٱلضَّلَٰلَةَ بِٱلْهُدَىٰ فَمَا رَبِحَت تِّجَٰرَتُهُمْ وَمَا كَانُوا۟ مُهْتَدِينَ',
		number_in_surah: '16',
		page: '3',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '24',
		number: '24',
		text: 'مَثَلُهُمْ كَمَثَلِ ٱلَّذِى ٱسْتَوْقَدَ نَارًۭا فَلَمَّآ أَضَآءَتْ مَا حَوْلَهُۥ ذَهَبَ ٱللَّهُ بِنُورِهِمْ وَتَرَكَهُمْ فِى ظُلُمَٰتٍۢ لَّا يُبْصِرُونَ',
		number_in_surah: '17',
		page: '4',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '25',
		number: '25',
		text: 'صُمٌّۢ بُكْمٌ عُمْىٌۭ فَهُمْ لَا يَرْجِعُونَ',
		number_in_surah: '18',
		page: '4',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '26',
		number: '26',
		text: 'أَوْ كَصَيِّبٍۢ مِّنَ ٱلسَّمَآءِ فِيهِ ظُلُمَٰتٌۭ وَرَعْدٌۭ وَبَرْقٌۭ يَجْعَلُونَ أَصَٰبِعَهُمْ فِىٓ ءَاذَانِهِم مِّنَ ٱلصَّوَٰعِقِ حَذَرَ ٱلْمَوْتِ ۚ وَٱللَّهُ مُحِيطٌۢ بِٱلْكَٰفِرِينَ',
		number_in_surah: '19',
		page: '4',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '27',
		number: '27',
		text: 'يَكَادُ ٱلْبَرْقُ يَخْطَفُ أَبْصَٰرَهُمْ ۖ كُلَّمَآ أَضَآءَ لَهُم مَّشَوْا۟ فِيهِ وَإِذَآ أَظْلَمَ عَلَيْهِمْ قَامُوا۟ ۚ وَلَوْ شَآءَ ٱللَّهُ لَذَهَبَ بِسَمْعِهِمْ وَأَبْصَٰرِهِمْ ۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '20',
		page: '4',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '28',
		number: '28',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ ٱعْبُدُوا۟ رَبَّكُمُ ٱلَّذِى خَلَقَكُمْ وَٱلَّذِينَ مِن قَبْلِكُمْ لَعَلَّكُمْ تَتَّقُونَ',
		number_in_surah: '21',
		page: '4',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '29',
		number: '29',
		text: 'ٱلَّذِى جَعَلَ لَكُمُ ٱلْأَرْضَ فِرَٰشًۭا وَٱلسَّمَآءَ بِنَآءًۭ وَأَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَخْرَجَ بِهِۦ مِنَ ٱلثَّمَرَٰتِ رِزْقًۭا لَّكُمْ ۖ فَلَا تَجْعَلُوا۟ لِلَّهِ أَندَادًۭا وَأَنتُمْ تَعْلَمُونَ',
		number_in_surah: '22',
		page: '4',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '30',
		number: '30',
		text: 'وَإِن كُنتُمْ فِى رَيْبٍۢ مِّمَّا نَزَّلْنَا عَلَىٰ عَبْدِنَا فَأْتُوا۟ بِسُورَةٍۢ مِّن مِّثْلِهِۦ وَٱدْعُوا۟ شُهَدَآءَكُم مِّن دُونِ ٱللَّهِ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '23',
		page: '4',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '31',
		number: '31',
		text: 'فَإِن لَّمْ تَفْعَلُوا۟ وَلَن تَفْعَلُوا۟ فَٱتَّقُوا۟ ٱلنَّارَ ٱلَّتِى وَقُودُهَا ٱلنَّاسُ وَٱلْحِجَارَةُ ۖ أُعِدَّتْ لِلْكَٰفِرِينَ',
		number_in_surah: '24',
		page: '4',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '32',
		number: '32',
		text: 'وَبَشِّرِ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ أَنَّ لَهُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۖ كُلَّمَا رُزِقُوا۟ مِنْهَا مِن ثَمَرَةٍۢ رِّزْقًۭا ۙ قَالُوا۟ هَٰذَا ٱلَّذِى رُزِقْنَا مِن قَبْلُ ۖ وَأُتُوا۟ بِهِۦ مُتَشَٰبِهًۭا ۖ وَلَهُمْ فِيهَآ أَزْوَٰجٌۭ مُّطَهَّرَةٌۭ ۖ وَهُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '25',
		page: '5',
		surah_id: '2',
		hizb_id: '1',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '33',
		number: '33',
		text: '۞ إِنَّ ٱللَّهَ لَا يَسْتَحْىِۦٓ أَن يَضْرِبَ مَثَلًۭا مَّا بَعُوضَةًۭ فَمَا فَوْقَهَا ۚ فَأَمَّا ٱلَّذِينَ ءَامَنُوا۟ فَيَعْلَمُونَ أَنَّهُ ٱلْحَقُّ مِن رَّبِّهِمْ ۖ وَأَمَّا ٱلَّذِينَ كَفَرُوا۟ فَيَقُولُونَ مَاذَآ أَرَادَ ٱللَّهُ بِهَٰذَا مَثَلًۭا ۘ يُضِلُّ بِهِۦ كَثِيرًۭا وَيَهْدِى بِهِۦ كَثِيرًۭا ۚ وَمَا يُضِلُّ بِهِۦٓ إِلَّا ٱلْفَٰسِقِينَ',
		number_in_surah: '26',
		page: '5',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '34',
		number: '34',
		text: 'ٱلَّذِينَ يَنقُضُونَ عَهْدَ ٱللَّهِ مِنۢ بَعْدِ مِيثَٰقِهِۦ وَيَقْطَعُونَ مَآ أَمَرَ ٱللَّهُ بِهِۦٓ أَن يُوصَلَ وَيُفْسِدُونَ فِى ٱلْأَرْضِ ۚ أُو۟لَٰٓئِكَ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '27',
		page: '5',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '35',
		number: '35',
		text: 'كَيْفَ تَكْفُرُونَ بِٱللَّهِ وَكُنتُمْ أَمْوَٰتًۭا فَأَحْيَٰكُمْ ۖ ثُمَّ يُمِيتُكُمْ ثُمَّ يُحْيِيكُمْ ثُمَّ إِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '28',
		page: '5',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '36',
		number: '36',
		text: 'هُوَ ٱلَّذِى خَلَقَ لَكُم مَّا فِى ٱلْأَرْضِ جَمِيعًۭا ثُمَّ ٱسْتَوَىٰٓ إِلَى ٱلسَّمَآءِ فَسَوَّىٰهُنَّ سَبْعَ سَمَٰوَٰتٍۢ ۚ وَهُوَ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '29',
		page: '5',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '37',
		number: '37',
		text: 'وَإِذْ قَالَ رَبُّكَ لِلْمَلَٰٓئِكَةِ إِنِّى جَاعِلٌۭ فِى ٱلْأَرْضِ خَلِيفَةًۭ ۖ قَالُوٓا۟ أَتَجْعَلُ فِيهَا مَن يُفْسِدُ فِيهَا وَيَسْفِكُ ٱلدِّمَآءَ وَنَحْنُ نُسَبِّحُ بِحَمْدِكَ وَنُقَدِّسُ لَكَ ۖ قَالَ إِنِّىٓ أَعْلَمُ مَا لَا تَعْلَمُونَ',
		number_in_surah: '30',
		page: '6',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '38',
		number: '38',
		text: 'وَعَلَّمَ ءَادَمَ ٱلْأَسْمَآءَ كُلَّهَا ثُمَّ عَرَضَهُمْ عَلَى ٱلْمَلَٰٓئِكَةِ فَقَالَ أَنۢبِـُٔونِى بِأَسْمَآءِ هَٰٓؤُلَآءِ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '31',
		page: '6',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '39',
		number: '39',
		text: 'قَالُوا۟ سُبْحَٰنَكَ لَا عِلْمَ لَنَآ إِلَّا مَا عَلَّمْتَنَآ ۖ إِنَّكَ أَنتَ ٱلْعَلِيمُ ٱلْحَكِيمُ',
		number_in_surah: '32',
		page: '6',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '40',
		number: '40',
		text: 'قَالَ يَٰٓـَٔادَمُ أَنۢبِئْهُم بِأَسْمَآئِهِمْ ۖ فَلَمَّآ أَنۢبَأَهُم بِأَسْمَآئِهِمْ قَالَ أَلَمْ أَقُل لَّكُمْ إِنِّىٓ أَعْلَمُ غَيْبَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَأَعْلَمُ مَا تُبْدُونَ وَمَا كُنتُمْ تَكْتُمُونَ',
		number_in_surah: '33',
		page: '6',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '41',
		number: '41',
		text: 'وَإِذْ قُلْنَا لِلْمَلَٰٓئِكَةِ ٱسْجُدُوا۟ لِءَادَمَ فَسَجَدُوٓا۟ إِلَّآ إِبْلِيسَ أَبَىٰ وَٱسْتَكْبَرَ وَكَانَ مِنَ ٱلْكَٰفِرِينَ',
		number_in_surah: '34',
		page: '6',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '42',
		number: '42',
		text: 'وَقُلْنَا يَٰٓـَٔادَمُ ٱسْكُنْ أَنتَ وَزَوْجُكَ ٱلْجَنَّةَ وَكُلَا مِنْهَا رَغَدًا حَيْثُ شِئْتُمَا وَلَا تَقْرَبَا هَٰذِهِ ٱلشَّجَرَةَ فَتَكُونَا مِنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '35',
		page: '6',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '43',
		number: '43',
		text: 'فَأَزَلَّهُمَا ٱلشَّيْطَٰنُ عَنْهَا فَأَخْرَجَهُمَا مِمَّا كَانَا فِيهِ ۖ وَقُلْنَا ٱهْبِطُوا۟ بَعْضُكُمْ لِبَعْضٍ عَدُوٌّۭ ۖ وَلَكُمْ فِى ٱلْأَرْضِ مُسْتَقَرٌّۭ وَمَتَٰعٌ إِلَىٰ حِينٍۢ',
		number_in_surah: '36',
		page: '6',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '44',
		number: '44',
		text: 'فَتَلَقَّىٰٓ ءَادَمُ مِن رَّبِّهِۦ كَلِمَٰتٍۢ فَتَابَ عَلَيْهِ ۚ إِنَّهُۥ هُوَ ٱلتَّوَّابُ ٱلرَّحِيمُ',
		number_in_surah: '37',
		page: '6',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '45',
		number: '45',
		text: 'قُلْنَا ٱهْبِطُوا۟ مِنْهَا جَمِيعًۭا ۖ فَإِمَّا يَأْتِيَنَّكُم مِّنِّى هُدًۭى فَمَن تَبِعَ هُدَاىَ فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '38',
		page: '7',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '46',
		number: '46',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ وَكَذَّبُوا۟ بِـَٔايَٰتِنَآ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '39',
		page: '7',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '47',
		number: '47',
		text: 'يَٰبَنِىٓ إِسْرَٰٓءِيلَ ٱذْكُرُوا۟ نِعْمَتِىَ ٱلَّتِىٓ أَنْعَمْتُ عَلَيْكُمْ وَأَوْفُوا۟ بِعَهْدِىٓ أُوفِ بِعَهْدِكُمْ وَإِيَّٰىَ فَٱرْهَبُونِ',
		number_in_surah: '40',
		page: '7',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '48',
		number: '48',
		text: 'وَءَامِنُوا۟ بِمَآ أَنزَلْتُ مُصَدِّقًۭا لِّمَا مَعَكُمْ وَلَا تَكُونُوٓا۟ أَوَّلَ كَافِرٍۭ بِهِۦ ۖ وَلَا تَشْتَرُوا۟ بِـَٔايَٰتِى ثَمَنًۭا قَلِيلًۭا وَإِيَّٰىَ فَٱتَّقُونِ',
		number_in_surah: '41',
		page: '7',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '49',
		number: '49',
		text: 'وَلَا تَلْبِسُوا۟ ٱلْحَقَّ بِٱلْبَٰطِلِ وَتَكْتُمُوا۟ ٱلْحَقَّ وَأَنتُمْ تَعْلَمُونَ',
		number_in_surah: '42',
		page: '7',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '50',
		number: '50',
		text: 'وَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَءَاتُوا۟ ٱلزَّكَوٰةَ وَٱرْكَعُوا۟ مَعَ ٱلرَّٰكِعِينَ',
		number_in_surah: '43',
		page: '7',
		surah_id: '2',
		hizb_id: '2',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '51',
		number: '51',
		text: '۞ أَتَأْمُرُونَ ٱلنَّاسَ بِٱلْبِرِّ وَتَنسَوْنَ أَنفُسَكُمْ وَأَنتُمْ تَتْلُونَ ٱلْكِتَٰبَ ۚ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '44',
		page: '7',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '52',
		number: '52',
		text: 'وَٱسْتَعِينُوا۟ بِٱلصَّبْرِ وَٱلصَّلَوٰةِ ۚ وَإِنَّهَا لَكَبِيرَةٌ إِلَّا عَلَى ٱلْخَٰشِعِينَ',
		number_in_surah: '45',
		page: '7',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '53',
		number: '53',
		text: 'ٱلَّذِينَ يَظُنُّونَ أَنَّهُم مُّلَٰقُوا۟ رَبِّهِمْ وَأَنَّهُمْ إِلَيْهِ رَٰجِعُونَ',
		number_in_surah: '46',
		page: '7',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '54',
		number: '54',
		text: 'يَٰبَنِىٓ إِسْرَٰٓءِيلَ ٱذْكُرُوا۟ نِعْمَتِىَ ٱلَّتِىٓ أَنْعَمْتُ عَلَيْكُمْ وَأَنِّى فَضَّلْتُكُمْ عَلَى ٱلْعَٰلَمِينَ',
		number_in_surah: '47',
		page: '7',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '55',
		number: '55',
		text: 'وَٱتَّقُوا۟ يَوْمًۭا لَّا تَجْزِى نَفْسٌ عَن نَّفْسٍۢ شَيْـًۭٔا وَلَا يُقْبَلُ مِنْهَا شَفَٰعَةٌۭ وَلَا يُؤْخَذُ مِنْهَا عَدْلٌۭ وَلَا هُمْ يُنصَرُونَ',
		number_in_surah: '48',
		page: '7',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '56',
		number: '56',
		text: 'وَإِذْ نَجَّيْنَٰكُم مِّنْ ءَالِ فِرْعَوْنَ يَسُومُونَكُمْ سُوٓءَ ٱلْعَذَابِ يُذَبِّحُونَ أَبْنَآءَكُمْ وَيَسْتَحْيُونَ نِسَآءَكُمْ ۚ وَفِى ذَٰلِكُم بَلَآءٌۭ مِّن رَّبِّكُمْ عَظِيمٌۭ',
		number_in_surah: '49',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '57',
		number: '57',
		text: 'وَإِذْ فَرَقْنَا بِكُمُ ٱلْبَحْرَ فَأَنجَيْنَٰكُمْ وَأَغْرَقْنَآ ءَالَ فِرْعَوْنَ وَأَنتُمْ تَنظُرُونَ',
		number_in_surah: '50',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '58',
		number: '58',
		text: 'وَإِذْ وَٰعَدْنَا مُوسَىٰٓ أَرْبَعِينَ لَيْلَةًۭ ثُمَّ ٱتَّخَذْتُمُ ٱلْعِجْلَ مِنۢ بَعْدِهِۦ وَأَنتُمْ ظَٰلِمُونَ',
		number_in_surah: '51',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '59',
		number: '59',
		text: 'ثُمَّ عَفَوْنَا عَنكُم مِّنۢ بَعْدِ ذَٰلِكَ لَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '52',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '60',
		number: '60',
		text: 'وَإِذْ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ وَٱلْفُرْقَانَ لَعَلَّكُمْ تَهْتَدُونَ',
		number_in_surah: '53',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '61',
		number: '61',
		text: 'وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِۦ يَٰقَوْمِ إِنَّكُمْ ظَلَمْتُمْ أَنفُسَكُم بِٱتِّخَاذِكُمُ ٱلْعِجْلَ فَتُوبُوٓا۟ إِلَىٰ بَارِئِكُمْ فَٱقْتُلُوٓا۟ أَنفُسَكُمْ ذَٰلِكُمْ خَيْرٌۭ لَّكُمْ عِندَ بَارِئِكُمْ فَتَابَ عَلَيْكُمْ ۚ إِنَّهُۥ هُوَ ٱلتَّوَّابُ ٱلرَّحِيمُ',
		number_in_surah: '54',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '62',
		number: '62',
		text: 'وَإِذْ قُلْتُمْ يَٰمُوسَىٰ لَن نُّؤْمِنَ لَكَ حَتَّىٰ نَرَى ٱللَّهَ جَهْرَةًۭ فَأَخَذَتْكُمُ ٱلصَّٰعِقَةُ وَأَنتُمْ تَنظُرُونَ',
		number_in_surah: '55',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '63',
		number: '63',
		text: 'ثُمَّ بَعَثْنَٰكُم مِّنۢ بَعْدِ مَوْتِكُمْ لَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '56',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '64',
		number: '64',
		text: 'وَظَلَّلْنَا عَلَيْكُمُ ٱلْغَمَامَ وَأَنزَلْنَا عَلَيْكُمُ ٱلْمَنَّ وَٱلسَّلْوَىٰ ۖ كُلُوا۟ مِن طَيِّبَٰتِ مَا رَزَقْنَٰكُمْ ۖ وَمَا ظَلَمُونَا وَلَٰكِن كَانُوٓا۟ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '57',
		page: '8',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '65',
		number: '65',
		text: 'وَإِذْ قُلْنَا ٱدْخُلُوا۟ هَٰذِهِ ٱلْقَرْيَةَ فَكُلُوا۟ مِنْهَا حَيْثُ شِئْتُمْ رَغَدًۭا وَٱدْخُلُوا۟ ٱلْبَابَ سُجَّدًۭا وَقُولُوا۟ حِطَّةٌۭ نَّغْفِرْ لَكُمْ خَطَٰيَٰكُمْ ۚ وَسَنَزِيدُ ٱلْمُحْسِنِينَ',
		number_in_surah: '58',
		page: '9',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '66',
		number: '66',
		text: 'فَبَدَّلَ ٱلَّذِينَ ظَلَمُوا۟ قَوْلًا غَيْرَ ٱلَّذِى قِيلَ لَهُمْ فَأَنزَلْنَا عَلَى ٱلَّذِينَ ظَلَمُوا۟ رِجْزًۭا مِّنَ ٱلسَّمَآءِ بِمَا كَانُوا۟ يَفْسُقُونَ',
		number_in_surah: '59',
		page: '9',
		surah_id: '2',
		hizb_id: '3',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '67',
		number: '67',
		text: '۞ وَإِذِ ٱسْتَسْقَىٰ مُوسَىٰ لِقَوْمِهِۦ فَقُلْنَا ٱضْرِب بِّعَصَاكَ ٱلْحَجَرَ ۖ فَٱنفَجَرَتْ مِنْهُ ٱثْنَتَا عَشْرَةَ عَيْنًۭا ۖ قَدْ عَلِمَ كُلُّ أُنَاسٍۢ مَّشْرَبَهُمْ ۖ كُلُوا۟ وَٱشْرَبُوا۟ مِن رِّزْقِ ٱللَّهِ وَلَا تَعْثَوْا۟ فِى ٱلْأَرْضِ مُفْسِدِينَ',
		number_in_surah: '60',
		page: '9',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '68',
		number: '68',
		text: 'وَإِذْ قُلْتُمْ يَٰمُوسَىٰ لَن نَّصْبِرَ عَلَىٰ طَعَامٍۢ وَٰحِدٍۢ فَٱدْعُ لَنَا رَبَّكَ يُخْرِجْ لَنَا مِمَّا تُنۢبِتُ ٱلْأَرْضُ مِنۢ بَقْلِهَا وَقِثَّآئِهَا وَفُومِهَا وَعَدَسِهَا وَبَصَلِهَا ۖ قَالَ أَتَسْتَبْدِلُونَ ٱلَّذِى هُوَ أَدْنَىٰ بِٱلَّذِى هُوَ خَيْرٌ ۚ ٱهْبِطُوا۟ مِصْرًۭا فَإِنَّ لَكُم مَّا سَأَلْتُمْ ۗ وَضُرِبَتْ عَلَيْهِمُ ٱلذِّلَّةُ وَٱلْمَسْكَنَةُ وَبَآءُو بِغَضَبٍۢ مِّنَ ٱللَّهِ ۗ ذَٰلِكَ بِأَنَّهُمْ كَانُوا۟ يَكْفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَيَقْتُلُونَ ٱلنَّبِيِّۦنَ بِغَيْرِ ٱلْحَقِّ ۗ ذَٰلِكَ بِمَا عَصَوا۟ وَّكَانُوا۟ يَعْتَدُونَ',
		number_in_surah: '61',
		page: '9',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '69',
		number: '69',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَٱلَّذِينَ هَادُوا۟ وَٱلنَّصَٰرَىٰ وَٱلصَّٰبِـِٔينَ مَنْ ءَامَنَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَعَمِلَ صَٰلِحًۭا فَلَهُمْ أَجْرُهُمْ عِندَ رَبِّهِمْ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '62',
		page: '10',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '70',
		number: '70',
		text: 'وَإِذْ أَخَذْنَا مِيثَٰقَكُمْ وَرَفَعْنَا فَوْقَكُمُ ٱلطُّورَ خُذُوا۟ مَآ ءَاتَيْنَٰكُم بِقُوَّةٍۢ وَٱذْكُرُوا۟ مَا فِيهِ لَعَلَّكُمْ تَتَّقُونَ',
		number_in_surah: '63',
		page: '10',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '71',
		number: '71',
		text: 'ثُمَّ تَوَلَّيْتُم مِّنۢ بَعْدِ ذَٰلِكَ ۖ فَلَوْلَا فَضْلُ ٱللَّهِ عَلَيْكُمْ وَرَحْمَتُهُۥ لَكُنتُم مِّنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '64',
		page: '10',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '72',
		number: '72',
		text: 'وَلَقَدْ عَلِمْتُمُ ٱلَّذِينَ ٱعْتَدَوْا۟ مِنكُمْ فِى ٱلسَّبْتِ فَقُلْنَا لَهُمْ كُونُوا۟ قِرَدَةً خَٰسِـِٔينَ',
		number_in_surah: '65',
		page: '10',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '73',
		number: '73',
		text: 'فَجَعَلْنَٰهَا نَكَٰلًۭا لِّمَا بَيْنَ يَدَيْهَا وَمَا خَلْفَهَا وَمَوْعِظَةًۭ لِّلْمُتَّقِينَ',
		number_in_surah: '66',
		page: '10',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '74',
		number: '74',
		text: 'وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِۦٓ إِنَّ ٱللَّهَ يَأْمُرُكُمْ أَن تَذْبَحُوا۟ بَقَرَةًۭ ۖ قَالُوٓا۟ أَتَتَّخِذُنَا هُزُوًۭا ۖ قَالَ أَعُوذُ بِٱللَّهِ أَنْ أَكُونَ مِنَ ٱلْجَٰهِلِينَ',
		number_in_surah: '67',
		page: '10',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '75',
		number: '75',
		text: 'قَالُوا۟ ٱدْعُ لَنَا رَبَّكَ يُبَيِّن لَّنَا مَا هِىَ ۚ قَالَ إِنَّهُۥ يَقُولُ إِنَّهَا بَقَرَةٌۭ لَّا فَارِضٌۭ وَلَا بِكْرٌ عَوَانٌۢ بَيْنَ ذَٰلِكَ ۖ فَٱفْعَلُوا۟ مَا تُؤْمَرُونَ',
		number_in_surah: '68',
		page: '10',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '76',
		number: '76',
		text: 'قَالُوا۟ ٱدْعُ لَنَا رَبَّكَ يُبَيِّن لَّنَا مَا لَوْنُهَا ۚ قَالَ إِنَّهُۥ يَقُولُ إِنَّهَا بَقَرَةٌۭ صَفْرَآءُ فَاقِعٌۭ لَّوْنُهَا تَسُرُّ ٱلنَّٰظِرِينَ',
		number_in_surah: '69',
		page: '10',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '77',
		number: '77',
		text: 'قَالُوا۟ ٱدْعُ لَنَا رَبَّكَ يُبَيِّن لَّنَا مَا هِىَ إِنَّ ٱلْبَقَرَ تَشَٰبَهَ عَلَيْنَا وَإِنَّآ إِن شَآءَ ٱللَّهُ لَمُهْتَدُونَ',
		number_in_surah: '70',
		page: '11',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '78',
		number: '78',
		text: 'قَالَ إِنَّهُۥ يَقُولُ إِنَّهَا بَقَرَةٌۭ لَّا ذَلُولٌۭ تُثِيرُ ٱلْأَرْضَ وَلَا تَسْقِى ٱلْحَرْثَ مُسَلَّمَةٌۭ لَّا شِيَةَ فِيهَا ۚ قَالُوا۟ ٱلْـَٰٔنَ جِئْتَ بِٱلْحَقِّ ۚ فَذَبَحُوهَا وَمَا كَادُوا۟ يَفْعَلُونَ',
		number_in_surah: '71',
		page: '11',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '79',
		number: '79',
		text: 'وَإِذْ قَتَلْتُمْ نَفْسًۭا فَٱدَّٰرَْٰٔتُمْ فِيهَا ۖ وَٱللَّهُ مُخْرِجٌۭ مَّا كُنتُمْ تَكْتُمُونَ',
		number_in_surah: '72',
		page: '11',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '80',
		number: '80',
		text: 'فَقُلْنَا ٱضْرِبُوهُ بِبَعْضِهَا ۚ كَذَٰلِكَ يُحْىِ ٱللَّهُ ٱلْمَوْتَىٰ وَيُرِيكُمْ ءَايَٰتِهِۦ لَعَلَّكُمْ تَعْقِلُونَ',
		number_in_surah: '73',
		page: '11',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '81',
		number: '81',
		text: 'ثُمَّ قَسَتْ قُلُوبُكُم مِّنۢ بَعْدِ ذَٰلِكَ فَهِىَ كَٱلْحِجَارَةِ أَوْ أَشَدُّ قَسْوَةًۭ ۚ وَإِنَّ مِنَ ٱلْحِجَارَةِ لَمَا يَتَفَجَّرُ مِنْهُ ٱلْأَنْهَٰرُ ۚ وَإِنَّ مِنْهَا لَمَا يَشَّقَّقُ فَيَخْرُجُ مِنْهُ ٱلْمَآءُ ۚ وَإِنَّ مِنْهَا لَمَا يَهْبِطُ مِنْ خَشْيَةِ ٱللَّهِ ۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعْمَلُونَ',
		number_in_surah: '74',
		page: '11',
		surah_id: '2',
		hizb_id: '4',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '82',
		number: '82',
		text: '۞ أَفَتَطْمَعُونَ أَن يُؤْمِنُوا۟ لَكُمْ وَقَدْ كَانَ فَرِيقٌۭ مِّنْهُمْ يَسْمَعُونَ كَلَٰمَ ٱللَّهِ ثُمَّ يُحَرِّفُونَهُۥ مِنۢ بَعْدِ مَا عَقَلُوهُ وَهُمْ يَعْلَمُونَ',
		number_in_surah: '75',
		page: '11',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '83',
		number: '83',
		text: 'وَإِذَا لَقُوا۟ ٱلَّذِينَ ءَامَنُوا۟ قَالُوٓا۟ ءَامَنَّا وَإِذَا خَلَا بَعْضُهُمْ إِلَىٰ بَعْضٍۢ قَالُوٓا۟ أَتُحَدِّثُونَهُم بِمَا فَتَحَ ٱللَّهُ عَلَيْكُمْ لِيُحَآجُّوكُم بِهِۦ عِندَ رَبِّكُمْ ۚ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '76',
		page: '11',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '84',
		number: '84',
		text: 'أَوَلَا يَعْلَمُونَ أَنَّ ٱللَّهَ يَعْلَمُ مَا يُسِرُّونَ وَمَا يُعْلِنُونَ',
		number_in_surah: '77',
		page: '12',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '85',
		number: '85',
		text: 'وَمِنْهُمْ أُمِّيُّونَ لَا يَعْلَمُونَ ٱلْكِتَٰبَ إِلَّآ أَمَانِىَّ وَإِنْ هُمْ إِلَّا يَظُنُّونَ',
		number_in_surah: '78',
		page: '12',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '86',
		number: '86',
		text: 'فَوَيْلٌۭ لِّلَّذِينَ يَكْتُبُونَ ٱلْكِتَٰبَ بِأَيْدِيهِمْ ثُمَّ يَقُولُونَ هَٰذَا مِنْ عِندِ ٱللَّهِ لِيَشْتَرُوا۟ بِهِۦ ثَمَنًۭا قَلِيلًۭا ۖ فَوَيْلٌۭ لَّهُم مِّمَّا كَتَبَتْ أَيْدِيهِمْ وَوَيْلٌۭ لَّهُم مِّمَّا يَكْسِبُونَ',
		number_in_surah: '79',
		page: '12',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '87',
		number: '87',
		text: 'وَقَالُوا۟ لَن تَمَسَّنَا ٱلنَّارُ إِلَّآ أَيَّامًۭا مَّعْدُودَةًۭ ۚ قُلْ أَتَّخَذْتُمْ عِندَ ٱللَّهِ عَهْدًۭا فَلَن يُخْلِفَ ٱللَّهُ عَهْدَهُۥٓ ۖ أَمْ تَقُولُونَ عَلَى ٱللَّهِ مَا لَا تَعْلَمُونَ',
		number_in_surah: '80',
		page: '12',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '88',
		number: '88',
		text: 'بَلَىٰ مَن كَسَبَ سَيِّئَةًۭ وَأَحَٰطَتْ بِهِۦ خَطِيٓـَٔتُهُۥ فَأُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '81',
		page: '12',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '89',
		number: '89',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَنَّةِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '82',
		page: '12',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '90',
		number: '90',
		text: 'وَإِذْ أَخَذْنَا مِيثَٰقَ بَنِىٓ إِسْرَٰٓءِيلَ لَا تَعْبُدُونَ إِلَّا ٱللَّهَ وَبِٱلْوَٰلِدَيْنِ إِحْسَانًۭا وَذِى ٱلْقُرْبَىٰ وَٱلْيَتَٰمَىٰ وَٱلْمَسَٰكِينِ وَقُولُوا۟ لِلنَّاسِ حُسْنًۭا وَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَءَاتُوا۟ ٱلزَّكَوٰةَ ثُمَّ تَوَلَّيْتُمْ إِلَّا قَلِيلًۭا مِّنكُمْ وَأَنتُم مُّعْرِضُونَ',
		number_in_surah: '83',
		page: '12',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '91',
		number: '91',
		text: 'وَإِذْ أَخَذْنَا مِيثَٰقَكُمْ لَا تَسْفِكُونَ دِمَآءَكُمْ وَلَا تُخْرِجُونَ أَنفُسَكُم مِّن دِيَٰرِكُمْ ثُمَّ أَقْرَرْتُمْ وَأَنتُمْ تَشْهَدُونَ',
		number_in_surah: '84',
		page: '13',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '92',
		number: '92',
		text: 'ثُمَّ أَنتُمْ هَٰٓؤُلَآءِ تَقْتُلُونَ أَنفُسَكُمْ وَتُخْرِجُونَ فَرِيقًۭا مِّنكُم مِّن دِيَٰرِهِمْ تَظَٰهَرُونَ عَلَيْهِم بِٱلْإِثْمِ وَٱلْعُدْوَٰنِ وَإِن يَأْتُوكُمْ أُسَٰرَىٰ تُفَٰدُوهُمْ وَهُوَ مُحَرَّمٌ عَلَيْكُمْ إِخْرَاجُهُمْ ۚ أَفَتُؤْمِنُونَ بِبَعْضِ ٱلْكِتَٰبِ وَتَكْفُرُونَ بِبَعْضٍۢ ۚ فَمَا جَزَآءُ مَن يَفْعَلُ ذَٰلِكَ مِنكُمْ إِلَّا خِزْىٌۭ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ وَيَوْمَ ٱلْقِيَٰمَةِ يُرَدُّونَ إِلَىٰٓ أَشَدِّ ٱلْعَذَابِ ۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعْمَلُونَ',
		number_in_surah: '85',
		page: '13',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '93',
		number: '93',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ ٱشْتَرَوُا۟ ٱلْحَيَوٰةَ ٱلدُّنْيَا بِٱلْءَاخِرَةِ ۖ فَلَا يُخَفَّفُ عَنْهُمُ ٱلْعَذَابُ وَلَا هُمْ يُنصَرُونَ',
		number_in_surah: '86',
		page: '13',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '94',
		number: '94',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ وَقَفَّيْنَا مِنۢ بَعْدِهِۦ بِٱلرُّسُلِ ۖ وَءَاتَيْنَا عِيسَى ٱبْنَ مَرْيَمَ ٱلْبَيِّنَٰتِ وَأَيَّدْنَٰهُ بِرُوحِ ٱلْقُدُسِ ۗ أَفَكُلَّمَا جَآءَكُمْ رَسُولٌۢ بِمَا لَا تَهْوَىٰٓ أَنفُسُكُمُ ٱسْتَكْبَرْتُمْ فَفَرِيقًۭا كَذَّبْتُمْ وَفَرِيقًۭا تَقْتُلُونَ',
		number_in_surah: '87',
		page: '13',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '95',
		number: '95',
		text: 'وَقَالُوا۟ قُلُوبُنَا غُلْفٌۢ ۚ بَل لَّعَنَهُمُ ٱللَّهُ بِكُفْرِهِمْ فَقَلِيلًۭا مَّا يُؤْمِنُونَ',
		number_in_surah: '88',
		page: '13',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '96',
		number: '96',
		text: 'وَلَمَّا جَآءَهُمْ كِتَٰبٌۭ مِّنْ عِندِ ٱللَّهِ مُصَدِّقٌۭ لِّمَا مَعَهُمْ وَكَانُوا۟ مِن قَبْلُ يَسْتَفْتِحُونَ عَلَى ٱلَّذِينَ كَفَرُوا۟ فَلَمَّا جَآءَهُم مَّا عَرَفُوا۟ كَفَرُوا۟ بِهِۦ ۚ فَلَعْنَةُ ٱللَّهِ عَلَى ٱلْكَٰفِرِينَ',
		number_in_surah: '89',
		page: '14',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '97',
		number: '97',
		text: 'بِئْسَمَا ٱشْتَرَوْا۟ بِهِۦٓ أَنفُسَهُمْ أَن يَكْفُرُوا۟ بِمَآ أَنزَلَ ٱللَّهُ بَغْيًا أَن يُنَزِّلَ ٱللَّهُ مِن فَضْلِهِۦ عَلَىٰ مَن يَشَآءُ مِنْ عِبَادِهِۦ ۖ فَبَآءُو بِغَضَبٍ عَلَىٰ غَضَبٍۢ ۚ وَلِلْكَٰفِرِينَ عَذَابٌۭ مُّهِينٌۭ',
		number_in_surah: '90',
		page: '14',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '98',
		number: '98',
		text: 'وَإِذَا قِيلَ لَهُمْ ءَامِنُوا۟ بِمَآ أَنزَلَ ٱللَّهُ قَالُوا۟ نُؤْمِنُ بِمَآ أُنزِلَ عَلَيْنَا وَيَكْفُرُونَ بِمَا وَرَآءَهُۥ وَهُوَ ٱلْحَقُّ مُصَدِّقًۭا لِّمَا مَعَهُمْ ۗ قُلْ فَلِمَ تَقْتُلُونَ أَنۢبِيَآءَ ٱللَّهِ مِن قَبْلُ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '91',
		page: '14',
		surah_id: '2',
		hizb_id: '5',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '99',
		number: '99',
		text: '۞ وَلَقَدْ جَآءَكُم مُّوسَىٰ بِٱلْبَيِّنَٰتِ ثُمَّ ٱتَّخَذْتُمُ ٱلْعِجْلَ مِنۢ بَعْدِهِۦ وَأَنتُمْ ظَٰلِمُونَ',
		number_in_surah: '92',
		page: '14',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '100',
		number: '100',
		text: 'وَإِذْ أَخَذْنَا مِيثَٰقَكُمْ وَرَفَعْنَا فَوْقَكُمُ ٱلطُّورَ خُذُوا۟ مَآ ءَاتَيْنَٰكُم بِقُوَّةٍۢ وَٱسْمَعُوا۟ ۖ قَالُوا۟ سَمِعْنَا وَعَصَيْنَا وَأُشْرِبُوا۟ فِى قُلُوبِهِمُ ٱلْعِجْلَ بِكُفْرِهِمْ ۚ قُلْ بِئْسَمَا يَأْمُرُكُم بِهِۦٓ إِيمَٰنُكُمْ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '93',
		page: '14',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '101',
		number: '101',
		text: 'قُلْ إِن كَانَتْ لَكُمُ ٱلدَّارُ ٱلْءَاخِرَةُ عِندَ ٱللَّهِ خَالِصَةًۭ مِّن دُونِ ٱلنَّاسِ فَتَمَنَّوُا۟ ٱلْمَوْتَ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '94',
		page: '15',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '102',
		number: '102',
		text: 'وَلَن يَتَمَنَّوْهُ أَبَدًۢا بِمَا قَدَّمَتْ أَيْدِيهِمْ ۗ وَٱللَّهُ عَلِيمٌۢ بِٱلظَّٰلِمِينَ',
		number_in_surah: '95',
		page: '15',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '103',
		number: '103',
		text: 'وَلَتَجِدَنَّهُمْ أَحْرَصَ ٱلنَّاسِ عَلَىٰ حَيَوٰةٍۢ وَمِنَ ٱلَّذِينَ أَشْرَكُوا۟ ۚ يَوَدُّ أَحَدُهُمْ لَوْ يُعَمَّرُ أَلْفَ سَنَةٍۢ وَمَا هُوَ بِمُزَحْزِحِهِۦ مِنَ ٱلْعَذَابِ أَن يُعَمَّرَ ۗ وَٱللَّهُ بَصِيرٌۢ بِمَا يَعْمَلُونَ',
		number_in_surah: '96',
		page: '15',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '104',
		number: '104',
		text: 'قُلْ مَن كَانَ عَدُوًّۭا لِّجِبْرِيلَ فَإِنَّهُۥ نَزَّلَهُۥ عَلَىٰ قَلْبِكَ بِإِذْنِ ٱللَّهِ مُصَدِّقًۭا لِّمَا بَيْنَ يَدَيْهِ وَهُدًۭى وَبُشْرَىٰ لِلْمُؤْمِنِينَ',
		number_in_surah: '97',
		page: '15',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '105',
		number: '105',
		text: 'مَن كَانَ عَدُوًّۭا لِّلَّهِ وَمَلَٰٓئِكَتِهِۦ وَرُسُلِهِۦ وَجِبْرِيلَ وَمِيكَىٰلَ فَإِنَّ ٱللَّهَ عَدُوٌّۭ لِّلْكَٰفِرِينَ',
		number_in_surah: '98',
		page: '15',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '106',
		number: '106',
		text: 'وَلَقَدْ أَنزَلْنَآ إِلَيْكَ ءَايَٰتٍۭ بَيِّنَٰتٍۢ ۖ وَمَا يَكْفُرُ بِهَآ إِلَّا ٱلْفَٰسِقُونَ',
		number_in_surah: '99',
		page: '15',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '107',
		number: '107',
		text: 'أَوَكُلَّمَا عَٰهَدُوا۟ عَهْدًۭا نَّبَذَهُۥ فَرِيقٌۭ مِّنْهُم ۚ بَلْ أَكْثَرُهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '100',
		page: '15',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '108',
		number: '108',
		text: 'وَلَمَّا جَآءَهُمْ رَسُولٌۭ مِّنْ عِندِ ٱللَّهِ مُصَدِّقٌۭ لِّمَا مَعَهُمْ نَبَذَ فَرِيقٌۭ مِّنَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ كِتَٰبَ ٱللَّهِ وَرَآءَ ظُهُورِهِمْ كَأَنَّهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '101',
		page: '15',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '109',
		number: '109',
		text: 'وَٱتَّبَعُوا۟ مَا تَتْلُوا۟ ٱلشَّيَٰطِينُ عَلَىٰ مُلْكِ سُلَيْمَٰنَ ۖ وَمَا كَفَرَ سُلَيْمَٰنُ وَلَٰكِنَّ ٱلشَّيَٰطِينَ كَفَرُوا۟ يُعَلِّمُونَ ٱلنَّاسَ ٱلسِّحْرَ وَمَآ أُنزِلَ عَلَى ٱلْمَلَكَيْنِ بِبَابِلَ هَٰرُوتَ وَمَٰرُوتَ ۚ وَمَا يُعَلِّمَانِ مِنْ أَحَدٍ حَتَّىٰ يَقُولَآ إِنَّمَا نَحْنُ فِتْنَةٌۭ فَلَا تَكْفُرْ ۖ فَيَتَعَلَّمُونَ مِنْهُمَا مَا يُفَرِّقُونَ بِهِۦ بَيْنَ ٱلْمَرْءِ وَزَوْجِهِۦ ۚ وَمَا هُم بِضَآرِّينَ بِهِۦ مِنْ أَحَدٍ إِلَّا بِإِذْنِ ٱللَّهِ ۚ وَيَتَعَلَّمُونَ مَا يَضُرُّهُمْ وَلَا يَنفَعُهُمْ ۚ وَلَقَدْ عَلِمُوا۟ لَمَنِ ٱشْتَرَىٰهُ مَا لَهُۥ فِى ٱلْءَاخِرَةِ مِنْ خَلَٰقٍۢ ۚ وَلَبِئْسَ مَا شَرَوْا۟ بِهِۦٓ أَنفُسَهُمْ ۚ لَوْ كَانُوا۟ يَعْلَمُونَ',
		number_in_surah: '102',
		page: '16',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '110',
		number: '110',
		text: 'وَلَوْ أَنَّهُمْ ءَامَنُوا۟ وَٱتَّقَوْا۟ لَمَثُوبَةٌۭ مِّنْ عِندِ ٱللَّهِ خَيْرٌۭ ۖ لَّوْ كَانُوا۟ يَعْلَمُونَ',
		number_in_surah: '103',
		page: '16',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '111',
		number: '111',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَقُولُوا۟ رَٰعِنَا وَقُولُوا۟ ٱنظُرْنَا وَٱسْمَعُوا۟ ۗ وَلِلْكَٰفِرِينَ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '104',
		page: '16',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '112',
		number: '112',
		text: 'مَّا يَوَدُّ ٱلَّذِينَ كَفَرُوا۟ مِنْ أَهْلِ ٱلْكِتَٰبِ وَلَا ٱلْمُشْرِكِينَ أَن يُنَزَّلَ عَلَيْكُم مِّنْ خَيْرٍۢ مِّن رَّبِّكُمْ ۗ وَٱللَّهُ يَخْتَصُّ بِرَحْمَتِهِۦ مَن يَشَآءُ ۚ وَٱللَّهُ ذُو ٱلْفَضْلِ ٱلْعَظِيمِ',
		number_in_surah: '105',
		page: '16',
		surah_id: '2',
		hizb_id: '6',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '113',
		number: '113',
		text: '۞ مَا نَنسَخْ مِنْ ءَايَةٍ أَوْ نُنسِهَا نَأْتِ بِخَيْرٍۢ مِّنْهَآ أَوْ مِثْلِهَآ ۗ أَلَمْ تَعْلَمْ أَنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '106',
		page: '17',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '114',
		number: '114',
		text: 'أَلَمْ تَعْلَمْ أَنَّ ٱللَّهَ لَهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۗ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِن وَلِىٍّۢ وَلَا نَصِيرٍ',
		number_in_surah: '107',
		page: '17',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '115',
		number: '115',
		text: 'أَمْ تُرِيدُونَ أَن تَسْـَٔلُوا۟ رَسُولَكُمْ كَمَا سُئِلَ مُوسَىٰ مِن قَبْلُ ۗ وَمَن يَتَبَدَّلِ ٱلْكُفْرَ بِٱلْإِيمَٰنِ فَقَدْ ضَلَّ سَوَآءَ ٱلسَّبِيلِ',
		number_in_surah: '108',
		page: '17',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '116',
		number: '116',
		text: 'وَدَّ كَثِيرٌۭ مِّنْ أَهْلِ ٱلْكِتَٰبِ لَوْ يَرُدُّونَكُم مِّنۢ بَعْدِ إِيمَٰنِكُمْ كُفَّارًا حَسَدًۭا مِّنْ عِندِ أَنفُسِهِم مِّنۢ بَعْدِ مَا تَبَيَّنَ لَهُمُ ٱلْحَقُّ ۖ فَٱعْفُوا۟ وَٱصْفَحُوا۟ حَتَّىٰ يَأْتِىَ ٱللَّهُ بِأَمْرِهِۦٓ ۗ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '109',
		page: '17',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '117',
		number: '117',
		text: 'وَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَءَاتُوا۟ ٱلزَّكَوٰةَ ۚ وَمَا تُقَدِّمُوا۟ لِأَنفُسِكُم مِّنْ خَيْرٍۢ تَجِدُوهُ عِندَ ٱللَّهِ ۗ إِنَّ ٱللَّهَ بِمَا تَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '110',
		page: '17',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '118',
		number: '118',
		text: 'وَقَالُوا۟ لَن يَدْخُلَ ٱلْجَنَّةَ إِلَّا مَن كَانَ هُودًا أَوْ نَصَٰرَىٰ ۗ تِلْكَ أَمَانِيُّهُمْ ۗ قُلْ هَاتُوا۟ بُرْهَٰنَكُمْ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '111',
		page: '17',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '119',
		number: '119',
		text: 'بَلَىٰ مَنْ أَسْلَمَ وَجْهَهُۥ لِلَّهِ وَهُوَ مُحْسِنٌۭ فَلَهُۥٓ أَجْرُهُۥ عِندَ رَبِّهِۦ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '112',
		page: '17',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '120',
		number: '120',
		text: 'وَقَالَتِ ٱلْيَهُودُ لَيْسَتِ ٱلنَّصَٰرَىٰ عَلَىٰ شَىْءٍۢ وَقَالَتِ ٱلنَّصَٰرَىٰ لَيْسَتِ ٱلْيَهُودُ عَلَىٰ شَىْءٍۢ وَهُمْ يَتْلُونَ ٱلْكِتَٰبَ ۗ كَذَٰلِكَ قَالَ ٱلَّذِينَ لَا يَعْلَمُونَ مِثْلَ قَوْلِهِمْ ۚ فَٱللَّهُ يَحْكُمُ بَيْنَهُمْ يَوْمَ ٱلْقِيَٰمَةِ فِيمَا كَانُوا۟ فِيهِ يَخْتَلِفُونَ',
		number_in_surah: '113',
		page: '18',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '121',
		number: '121',
		text: 'وَمَنْ أَظْلَمُ مِمَّن مَّنَعَ مَسَٰجِدَ ٱللَّهِ أَن يُذْكَرَ فِيهَا ٱسْمُهُۥ وَسَعَىٰ فِى خَرَابِهَآ ۚ أُو۟لَٰٓئِكَ مَا كَانَ لَهُمْ أَن يَدْخُلُوهَآ إِلَّا خَآئِفِينَ ۚ لَهُمْ فِى ٱلدُّنْيَا خِزْىٌۭ وَلَهُمْ فِى ٱلْءَاخِرَةِ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '114',
		page: '18',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '122',
		number: '122',
		text: 'وَلِلَّهِ ٱلْمَشْرِقُ وَٱلْمَغْرِبُ ۚ فَأَيْنَمَا تُوَلُّوا۟ فَثَمَّ وَجْهُ ٱللَّهِ ۚ إِنَّ ٱللَّهَ وَٰسِعٌ عَلِيمٌۭ',
		number_in_surah: '115',
		page: '18',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '123',
		number: '123',
		text: 'وَقَالُوا۟ ٱتَّخَذَ ٱللَّهُ وَلَدًۭا ۗ سُبْحَٰنَهُۥ ۖ بَل لَّهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ كُلٌّۭ لَّهُۥ قَٰنِتُونَ',
		number_in_surah: '116',
		page: '18',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '124',
		number: '124',
		text: 'بَدِيعُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ وَإِذَا قَضَىٰٓ أَمْرًۭا فَإِنَّمَا يَقُولُ لَهُۥ كُن فَيَكُونُ',
		number_in_surah: '117',
		page: '18',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '125',
		number: '125',
		text: 'وَقَالَ ٱلَّذِينَ لَا يَعْلَمُونَ لَوْلَا يُكَلِّمُنَا ٱللَّهُ أَوْ تَأْتِينَآ ءَايَةٌۭ ۗ كَذَٰلِكَ قَالَ ٱلَّذِينَ مِن قَبْلِهِم مِّثْلَ قَوْلِهِمْ ۘ تَشَٰبَهَتْ قُلُوبُهُمْ ۗ قَدْ بَيَّنَّا ٱلْءَايَٰتِ لِقَوْمٍۢ يُوقِنُونَ',
		number_in_surah: '118',
		page: '18',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '126',
		number: '126',
		text: 'إِنَّآ أَرْسَلْنَٰكَ بِٱلْحَقِّ بَشِيرًۭا وَنَذِيرًۭا ۖ وَلَا تُسْـَٔلُ عَنْ أَصْحَٰبِ ٱلْجَحِيمِ',
		number_in_surah: '119',
		page: '18',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '127',
		number: '127',
		text: 'وَلَن تَرْضَىٰ عَنكَ ٱلْيَهُودُ وَلَا ٱلنَّصَٰرَىٰ حَتَّىٰ تَتَّبِعَ مِلَّتَهُمْ ۗ قُلْ إِنَّ هُدَى ٱللَّهِ هُوَ ٱلْهُدَىٰ ۗ وَلَئِنِ ٱتَّبَعْتَ أَهْوَآءَهُم بَعْدَ ٱلَّذِى جَآءَكَ مِنَ ٱلْعِلْمِ ۙ مَا لَكَ مِنَ ٱللَّهِ مِن وَلِىٍّۢ وَلَا نَصِيرٍ',
		number_in_surah: '120',
		page: '19',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '128',
		number: '128',
		text: 'ٱلَّذِينَ ءَاتَيْنَٰهُمُ ٱلْكِتَٰبَ يَتْلُونَهُۥ حَقَّ تِلَاوَتِهِۦٓ أُو۟لَٰٓئِكَ يُؤْمِنُونَ بِهِۦ ۗ وَمَن يَكْفُرْ بِهِۦ فَأُو۟لَٰٓئِكَ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '121',
		page: '19',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '129',
		number: '129',
		text: 'يَٰبَنِىٓ إِسْرَٰٓءِيلَ ٱذْكُرُوا۟ نِعْمَتِىَ ٱلَّتِىٓ أَنْعَمْتُ عَلَيْكُمْ وَأَنِّى فَضَّلْتُكُمْ عَلَى ٱلْعَٰلَمِينَ',
		number_in_surah: '122',
		page: '19',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '130',
		number: '130',
		text: 'وَٱتَّقُوا۟ يَوْمًۭا لَّا تَجْزِى نَفْسٌ عَن نَّفْسٍۢ شَيْـًۭٔا وَلَا يُقْبَلُ مِنْهَا عَدْلٌۭ وَلَا تَنفَعُهَا شَفَٰعَةٌۭ وَلَا هُمْ يُنصَرُونَ',
		number_in_surah: '123',
		page: '19',
		surah_id: '2',
		hizb_id: '7',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '131',
		number: '131',
		text: '۞ وَإِذِ ٱبْتَلَىٰٓ إِبْرَٰهِۦمَ رَبُّهُۥ بِكَلِمَٰتٍۢ فَأَتَمَّهُنَّ ۖ قَالَ إِنِّى جَاعِلُكَ لِلنَّاسِ إِمَامًۭا ۖ قَالَ وَمِن ذُرِّيَّتِى ۖ قَالَ لَا يَنَالُ عَهْدِى ٱلظَّٰلِمِينَ',
		number_in_surah: '124',
		page: '19',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '132',
		number: '132',
		text: 'وَإِذْ جَعَلْنَا ٱلْبَيْتَ مَثَابَةًۭ لِّلنَّاسِ وَأَمْنًۭا وَٱتَّخِذُوا۟ مِن مَّقَامِ إِبْرَٰهِۦمَ مُصَلًّۭى ۖ وَعَهِدْنَآ إِلَىٰٓ إِبْرَٰهِۦمَ وَإِسْمَٰعِيلَ أَن طَهِّرَا بَيْتِىَ لِلطَّآئِفِينَ وَٱلْعَٰكِفِينَ وَٱلرُّكَّعِ ٱلسُّجُودِ',
		number_in_surah: '125',
		page: '19',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '133',
		number: '133',
		text: 'وَإِذْ قَالَ إِبْرَٰهِۦمُ رَبِّ ٱجْعَلْ هَٰذَا بَلَدًا ءَامِنًۭا وَٱرْزُقْ أَهْلَهُۥ مِنَ ٱلثَّمَرَٰتِ مَنْ ءَامَنَ مِنْهُم بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ ۖ قَالَ وَمَن كَفَرَ فَأُمَتِّعُهُۥ قَلِيلًۭا ثُمَّ أَضْطَرُّهُۥٓ إِلَىٰ عَذَابِ ٱلنَّارِ ۖ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '126',
		page: '19',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '134',
		number: '134',
		text: 'وَإِذْ يَرْفَعُ إِبْرَٰهِۦمُ ٱلْقَوَاعِدَ مِنَ ٱلْبَيْتِ وَإِسْمَٰعِيلُ رَبَّنَا تَقَبَّلْ مِنَّآ ۖ إِنَّكَ أَنتَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '127',
		page: '20',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '135',
		number: '135',
		text: 'رَبَّنَا وَٱجْعَلْنَا مُسْلِمَيْنِ لَكَ وَمِن ذُرِّيَّتِنَآ أُمَّةًۭ مُّسْلِمَةًۭ لَّكَ وَأَرِنَا مَنَاسِكَنَا وَتُبْ عَلَيْنَآ ۖ إِنَّكَ أَنتَ ٱلتَّوَّابُ ٱلرَّحِيمُ',
		number_in_surah: '128',
		page: '20',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '136',
		number: '136',
		text: 'رَبَّنَا وَٱبْعَثْ فِيهِمْ رَسُولًۭا مِّنْهُمْ يَتْلُوا۟ عَلَيْهِمْ ءَايَٰتِكَ وَيُعَلِّمُهُمُ ٱلْكِتَٰبَ وَٱلْحِكْمَةَ وَيُزَكِّيهِمْ ۚ إِنَّكَ أَنتَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '129',
		page: '20',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '137',
		number: '137',
		text: 'وَمَن يَرْغَبُ عَن مِّلَّةِ إِبْرَٰهِۦمَ إِلَّا مَن سَفِهَ نَفْسَهُۥ ۚ وَلَقَدِ ٱصْطَفَيْنَٰهُ فِى ٱلدُّنْيَا ۖ وَإِنَّهُۥ فِى ٱلْءَاخِرَةِ لَمِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '130',
		page: '20',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '138',
		number: '138',
		text: 'إِذْ قَالَ لَهُۥ رَبُّهُۥٓ أَسْلِمْ ۖ قَالَ أَسْلَمْتُ لِرَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '131',
		page: '20',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '139',
		number: '139',
		text: 'وَوَصَّىٰ بِهَآ إِبْرَٰهِۦمُ بَنِيهِ وَيَعْقُوبُ يَٰبَنِىَّ إِنَّ ٱللَّهَ ٱصْطَفَىٰ لَكُمُ ٱلدِّينَ فَلَا تَمُوتُنَّ إِلَّا وَأَنتُم مُّسْلِمُونَ',
		number_in_surah: '132',
		page: '20',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '140',
		number: '140',
		text: 'أَمْ كُنتُمْ شُهَدَآءَ إِذْ حَضَرَ يَعْقُوبَ ٱلْمَوْتُ إِذْ قَالَ لِبَنِيهِ مَا تَعْبُدُونَ مِنۢ بَعْدِى قَالُوا۟ نَعْبُدُ إِلَٰهَكَ وَإِلَٰهَ ءَابَآئِكَ إِبْرَٰهِۦمَ وَإِسْمَٰعِيلَ وَإِسْحَٰقَ إِلَٰهًۭا وَٰحِدًۭا وَنَحْنُ لَهُۥ مُسْلِمُونَ',
		number_in_surah: '133',
		page: '20',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '141',
		number: '141',
		text: 'تِلْكَ أُمَّةٌۭ قَدْ خَلَتْ ۖ لَهَا مَا كَسَبَتْ وَلَكُم مَّا كَسَبْتُمْ ۖ وَلَا تُسْـَٔلُونَ عَمَّا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '134',
		page: '20',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '142',
		number: '142',
		text: 'وَقَالُوا۟ كُونُوا۟ هُودًا أَوْ نَصَٰرَىٰ تَهْتَدُوا۟ ۗ قُلْ بَلْ مِلَّةَ إِبْرَٰهِۦمَ حَنِيفًۭا ۖ وَمَا كَانَ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '135',
		page: '21',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '143',
		number: '143',
		text: 'قُولُوٓا۟ ءَامَنَّا بِٱللَّهِ وَمَآ أُنزِلَ إِلَيْنَا وَمَآ أُنزِلَ إِلَىٰٓ إِبْرَٰهِۦمَ وَإِسْمَٰعِيلَ وَإِسْحَٰقَ وَيَعْقُوبَ وَٱلْأَسْبَاطِ وَمَآ أُوتِىَ مُوسَىٰ وَعِيسَىٰ وَمَآ أُوتِىَ ٱلنَّبِيُّونَ مِن رَّبِّهِمْ لَا نُفَرِّقُ بَيْنَ أَحَدٍۢ مِّنْهُمْ وَنَحْنُ لَهُۥ مُسْلِمُونَ',
		number_in_surah: '136',
		page: '21',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '144',
		number: '144',
		text: 'فَإِنْ ءَامَنُوا۟ بِمِثْلِ مَآ ءَامَنتُم بِهِۦ فَقَدِ ٱهْتَدَوا۟ ۖ وَّإِن تَوَلَّوْا۟ فَإِنَّمَا هُمْ فِى شِقَاقٍۢ ۖ فَسَيَكْفِيكَهُمُ ٱللَّهُ ۚ وَهُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '137',
		page: '21',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '145',
		number: '145',
		text: 'صِبْغَةَ ٱللَّهِ ۖ وَمَنْ أَحْسَنُ مِنَ ٱللَّهِ صِبْغَةًۭ ۖ وَنَحْنُ لَهُۥ عَٰبِدُونَ',
		number_in_surah: '138',
		page: '21',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '146',
		number: '146',
		text: 'قُلْ أَتُحَآجُّونَنَا فِى ٱللَّهِ وَهُوَ رَبُّنَا وَرَبُّكُمْ وَلَنَآ أَعْمَٰلُنَا وَلَكُمْ أَعْمَٰلُكُمْ وَنَحْنُ لَهُۥ مُخْلِصُونَ',
		number_in_surah: '139',
		page: '21',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '147',
		number: '147',
		text: 'أَمْ تَقُولُونَ إِنَّ إِبْرَٰهِۦمَ وَإِسْمَٰعِيلَ وَإِسْحَٰقَ وَيَعْقُوبَ وَٱلْأَسْبَاطَ كَانُوا۟ هُودًا أَوْ نَصَٰرَىٰ ۗ قُلْ ءَأَنتُمْ أَعْلَمُ أَمِ ٱللَّهُ ۗ وَمَنْ أَظْلَمُ مِمَّن كَتَمَ شَهَٰدَةً عِندَهُۥ مِنَ ٱللَّهِ ۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعْمَلُونَ',
		number_in_surah: '140',
		page: '21',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '148',
		number: '148',
		text: 'تِلْكَ أُمَّةٌۭ قَدْ خَلَتْ ۖ لَهَا مَا كَسَبَتْ وَلَكُم مَّا كَسَبْتُمْ ۖ وَلَا تُسْـَٔلُونَ عَمَّا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '141',
		page: '21',
		surah_id: '2',
		hizb_id: '8',
		juz_id: '1',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '149',
		number: '149',
		text: '۞ سَيَقُولُ ٱلسُّفَهَآءُ مِنَ ٱلنَّاسِ مَا وَلَّىٰهُمْ عَن قِبْلَتِهِمُ ٱلَّتِى كَانُوا۟ عَلَيْهَا ۚ قُل لِّلَّهِ ٱلْمَشْرِقُ وَٱلْمَغْرِبُ ۚ يَهْدِى مَن يَشَآءُ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '142',
		page: '22',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '150',
		number: '150',
		text: 'وَكَذَٰلِكَ جَعَلْنَٰكُمْ أُمَّةًۭ وَسَطًۭا لِّتَكُونُوا۟ شُهَدَآءَ عَلَى ٱلنَّاسِ وَيَكُونَ ٱلرَّسُولُ عَلَيْكُمْ شَهِيدًۭا ۗ وَمَا جَعَلْنَا ٱلْقِبْلَةَ ٱلَّتِى كُنتَ عَلَيْهَآ إِلَّا لِنَعْلَمَ مَن يَتَّبِعُ ٱلرَّسُولَ مِمَّن يَنقَلِبُ عَلَىٰ عَقِبَيْهِ ۚ وَإِن كَانَتْ لَكَبِيرَةً إِلَّا عَلَى ٱلَّذِينَ هَدَى ٱللَّهُ ۗ وَمَا كَانَ ٱللَّهُ لِيُضِيعَ إِيمَٰنَكُمْ ۚ إِنَّ ٱللَّهَ بِٱلنَّاسِ لَرَءُوفٌۭ رَّحِيمٌۭ',
		number_in_surah: '143',
		page: '22',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '151',
		number: '151',
		text: 'قَدْ نَرَىٰ تَقَلُّبَ وَجْهِكَ فِى ٱلسَّمَآءِ ۖ فَلَنُوَلِّيَنَّكَ قِبْلَةًۭ تَرْضَىٰهَا ۚ فَوَلِّ وَجْهَكَ شَطْرَ ٱلْمَسْجِدِ ٱلْحَرَامِ ۚ وَحَيْثُ مَا كُنتُمْ فَوَلُّوا۟ وُجُوهَكُمْ شَطْرَهُۥ ۗ وَإِنَّ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ لَيَعْلَمُونَ أَنَّهُ ٱلْحَقُّ مِن رَّبِّهِمْ ۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا يَعْمَلُونَ',
		number_in_surah: '144',
		page: '22',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '152',
		number: '152',
		text: 'وَلَئِنْ أَتَيْتَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ بِكُلِّ ءَايَةٍۢ مَّا تَبِعُوا۟ قِبْلَتَكَ ۚ وَمَآ أَنتَ بِتَابِعٍۢ قِبْلَتَهُمْ ۚ وَمَا بَعْضُهُم بِتَابِعٍۢ قِبْلَةَ بَعْضٍۢ ۚ وَلَئِنِ ٱتَّبَعْتَ أَهْوَآءَهُم مِّنۢ بَعْدِ مَا جَآءَكَ مِنَ ٱلْعِلْمِ ۙ إِنَّكَ إِذًۭا لَّمِنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '145',
		page: '22',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '153',
		number: '153',
		text: 'ٱلَّذِينَ ءَاتَيْنَٰهُمُ ٱلْكِتَٰبَ يَعْرِفُونَهُۥ كَمَا يَعْرِفُونَ أَبْنَآءَهُمْ ۖ وَإِنَّ فَرِيقًۭا مِّنْهُمْ لَيَكْتُمُونَ ٱلْحَقَّ وَهُمْ يَعْلَمُونَ',
		number_in_surah: '146',
		page: '23',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '154',
		number: '154',
		text: 'ٱلْحَقُّ مِن رَّبِّكَ ۖ فَلَا تَكُونَنَّ مِنَ ٱلْمُمْتَرِينَ',
		number_in_surah: '147',
		page: '23',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '155',
		number: '155',
		text: 'وَلِكُلٍّۢ وِجْهَةٌ هُوَ مُوَلِّيهَا ۖ فَٱسْتَبِقُوا۟ ٱلْخَيْرَٰتِ ۚ أَيْنَ مَا تَكُونُوا۟ يَأْتِ بِكُمُ ٱللَّهُ جَمِيعًا ۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '148',
		page: '23',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '156',
		number: '156',
		text: 'وَمِنْ حَيْثُ خَرَجْتَ فَوَلِّ وَجْهَكَ شَطْرَ ٱلْمَسْجِدِ ٱلْحَرَامِ ۖ وَإِنَّهُۥ لَلْحَقُّ مِن رَّبِّكَ ۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعْمَلُونَ',
		number_in_surah: '149',
		page: '23',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '157',
		number: '157',
		text: 'وَمِنْ حَيْثُ خَرَجْتَ فَوَلِّ وَجْهَكَ شَطْرَ ٱلْمَسْجِدِ ٱلْحَرَامِ ۚ وَحَيْثُ مَا كُنتُمْ فَوَلُّوا۟ وُجُوهَكُمْ شَطْرَهُۥ لِئَلَّا يَكُونَ لِلنَّاسِ عَلَيْكُمْ حُجَّةٌ إِلَّا ٱلَّذِينَ ظَلَمُوا۟ مِنْهُمْ فَلَا تَخْشَوْهُمْ وَٱخْشَوْنِى وَلِأُتِمَّ نِعْمَتِى عَلَيْكُمْ وَلَعَلَّكُمْ تَهْتَدُونَ',
		number_in_surah: '150',
		page: '23',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '158',
		number: '158',
		text: 'كَمَآ أَرْسَلْنَا فِيكُمْ رَسُولًۭا مِّنكُمْ يَتْلُوا۟ عَلَيْكُمْ ءَايَٰتِنَا وَيُزَكِّيكُمْ وَيُعَلِّمُكُمُ ٱلْكِتَٰبَ وَٱلْحِكْمَةَ وَيُعَلِّمُكُم مَّا لَمْ تَكُونُوا۟ تَعْلَمُونَ',
		number_in_surah: '151',
		page: '23',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '159',
		number: '159',
		text: 'فَٱذْكُرُونِىٓ أَذْكُرْكُمْ وَٱشْكُرُوا۟ لِى وَلَا تَكْفُرُونِ',
		number_in_surah: '152',
		page: '23',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '160',
		number: '160',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱسْتَعِينُوا۟ بِٱلصَّبْرِ وَٱلصَّلَوٰةِ ۚ إِنَّ ٱللَّهَ مَعَ ٱلصَّٰبِرِينَ',
		number_in_surah: '153',
		page: '23',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '161',
		number: '161',
		text: 'وَلَا تَقُولُوا۟ لِمَن يُقْتَلُ فِى سَبِيلِ ٱللَّهِ أَمْوَٰتٌۢ ۚ بَلْ أَحْيَآءٌۭ وَلَٰكِن لَّا تَشْعُرُونَ',
		number_in_surah: '154',
		page: '24',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '162',
		number: '162',
		text: 'وَلَنَبْلُوَنَّكُم بِشَىْءٍۢ مِّنَ ٱلْخَوْفِ وَٱلْجُوعِ وَنَقْصٍۢ مِّنَ ٱلْأَمْوَٰلِ وَٱلْأَنفُسِ وَٱلثَّمَرَٰتِ ۗ وَبَشِّرِ ٱلصَّٰبِرِينَ',
		number_in_surah: '155',
		page: '24',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '163',
		number: '163',
		text: 'ٱلَّذِينَ إِذَآ أَصَٰبَتْهُم مُّصِيبَةٌۭ قَالُوٓا۟ إِنَّا لِلَّهِ وَإِنَّآ إِلَيْهِ رَٰجِعُونَ',
		number_in_surah: '156',
		page: '24',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '164',
		number: '164',
		text: 'أُو۟لَٰٓئِكَ عَلَيْهِمْ صَلَوَٰتٌۭ مِّن رَّبِّهِمْ وَرَحْمَةٌۭ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُهْتَدُونَ',
		number_in_surah: '157',
		page: '24',
		surah_id: '2',
		hizb_id: '9',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '165',
		number: '165',
		text: '۞ إِنَّ ٱلصَّفَا وَٱلْمَرْوَةَ مِن شَعَآئِرِ ٱللَّهِ ۖ فَمَنْ حَجَّ ٱلْبَيْتَ أَوِ ٱعْتَمَرَ فَلَا جُنَاحَ عَلَيْهِ أَن يَطَّوَّفَ بِهِمَا ۚ وَمَن تَطَوَّعَ خَيْرًۭا فَإِنَّ ٱللَّهَ شَاكِرٌ عَلِيمٌ',
		number_in_surah: '158',
		page: '24',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '166',
		number: '166',
		text: 'إِنَّ ٱلَّذِينَ يَكْتُمُونَ مَآ أَنزَلْنَا مِنَ ٱلْبَيِّنَٰتِ وَٱلْهُدَىٰ مِنۢ بَعْدِ مَا بَيَّنَّٰهُ لِلنَّاسِ فِى ٱلْكِتَٰبِ ۙ أُو۟لَٰٓئِكَ يَلْعَنُهُمُ ٱللَّهُ وَيَلْعَنُهُمُ ٱللَّٰعِنُونَ',
		number_in_surah: '159',
		page: '24',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '167',
		number: '167',
		text: 'إِلَّا ٱلَّذِينَ تَابُوا۟ وَأَصْلَحُوا۟ وَبَيَّنُوا۟ فَأُو۟لَٰٓئِكَ أَتُوبُ عَلَيْهِمْ ۚ وَأَنَا ٱلتَّوَّابُ ٱلرَّحِيمُ',
		number_in_surah: '160',
		page: '24',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '168',
		number: '168',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ وَمَاتُوا۟ وَهُمْ كُفَّارٌ أُو۟لَٰٓئِكَ عَلَيْهِمْ لَعْنَةُ ٱللَّهِ وَٱلْمَلَٰٓئِكَةِ وَٱلنَّاسِ أَجْمَعِينَ',
		number_in_surah: '161',
		page: '24',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '169',
		number: '169',
		text: 'خَٰلِدِينَ فِيهَا ۖ لَا يُخَفَّفُ عَنْهُمُ ٱلْعَذَابُ وَلَا هُمْ يُنظَرُونَ',
		number_in_surah: '162',
		page: '24',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '170',
		number: '170',
		text: 'وَإِلَٰهُكُمْ إِلَٰهٌۭ وَٰحِدٌۭ ۖ لَّآ إِلَٰهَ إِلَّا هُوَ ٱلرَّحْمَٰنُ ٱلرَّحِيمُ',
		number_in_surah: '163',
		page: '24',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '171',
		number: '171',
		text: 'إِنَّ فِى خَلْقِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَٱخْتِلَٰفِ ٱلَّيْلِ وَٱلنَّهَارِ وَٱلْفُلْكِ ٱلَّتِى تَجْرِى فِى ٱلْبَحْرِ بِمَا يَنفَعُ ٱلنَّاسَ وَمَآ أَنزَلَ ٱللَّهُ مِنَ ٱلسَّمَآءِ مِن مَّآءٍۢ فَأَحْيَا بِهِ ٱلْأَرْضَ بَعْدَ مَوْتِهَا وَبَثَّ فِيهَا مِن كُلِّ دَآبَّةٍۢ وَتَصْرِيفِ ٱلرِّيَٰحِ وَٱلسَّحَابِ ٱلْمُسَخَّرِ بَيْنَ ٱلسَّمَآءِ وَٱلْأَرْضِ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَعْقِلُونَ',
		number_in_surah: '164',
		page: '25',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '172',
		number: '172',
		text: 'وَمِنَ ٱلنَّاسِ مَن يَتَّخِذُ مِن دُونِ ٱللَّهِ أَندَادًۭا يُحِبُّونَهُمْ كَحُبِّ ٱللَّهِ ۖ وَٱلَّذِينَ ءَامَنُوٓا۟ أَشَدُّ حُبًّۭا لِّلَّهِ ۗ وَلَوْ يَرَى ٱلَّذِينَ ظَلَمُوٓا۟ إِذْ يَرَوْنَ ٱلْعَذَابَ أَنَّ ٱلْقُوَّةَ لِلَّهِ جَمِيعًۭا وَأَنَّ ٱللَّهَ شَدِيدُ ٱلْعَذَابِ',
		number_in_surah: '165',
		page: '25',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '173',
		number: '173',
		text: 'إِذْ تَبَرَّأَ ٱلَّذِينَ ٱتُّبِعُوا۟ مِنَ ٱلَّذِينَ ٱتَّبَعُوا۟ وَرَأَوُا۟ ٱلْعَذَابَ وَتَقَطَّعَتْ بِهِمُ ٱلْأَسْبَابُ',
		number_in_surah: '166',
		page: '25',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '174',
		number: '174',
		text: 'وَقَالَ ٱلَّذِينَ ٱتَّبَعُوا۟ لَوْ أَنَّ لَنَا كَرَّةًۭ فَنَتَبَرَّأَ مِنْهُمْ كَمَا تَبَرَّءُوا۟ مِنَّا ۗ كَذَٰلِكَ يُرِيهِمُ ٱللَّهُ أَعْمَٰلَهُمْ حَسَرَٰتٍ عَلَيْهِمْ ۖ وَمَا هُم بِخَٰرِجِينَ مِنَ ٱلنَّارِ',
		number_in_surah: '167',
		page: '25',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '175',
		number: '175',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ كُلُوا۟ مِمَّا فِى ٱلْأَرْضِ حَلَٰلًۭا طَيِّبًۭا وَلَا تَتَّبِعُوا۟ خُطُوَٰتِ ٱلشَّيْطَٰنِ ۚ إِنَّهُۥ لَكُمْ عَدُوٌّۭ مُّبِينٌ',
		number_in_surah: '168',
		page: '25',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '176',
		number: '176',
		text: 'إِنَّمَا يَأْمُرُكُم بِٱلسُّوٓءِ وَٱلْفَحْشَآءِ وَأَن تَقُولُوا۟ عَلَى ٱللَّهِ مَا لَا تَعْلَمُونَ',
		number_in_surah: '169',
		page: '25',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '177',
		number: '177',
		text: 'وَإِذَا قِيلَ لَهُمُ ٱتَّبِعُوا۟ مَآ أَنزَلَ ٱللَّهُ قَالُوا۟ بَلْ نَتَّبِعُ مَآ أَلْفَيْنَا عَلَيْهِ ءَابَآءَنَآ ۗ أَوَلَوْ كَانَ ءَابَآؤُهُمْ لَا يَعْقِلُونَ شَيْـًۭٔا وَلَا يَهْتَدُونَ',
		number_in_surah: '170',
		page: '26',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '178',
		number: '178',
		text: 'وَمَثَلُ ٱلَّذِينَ كَفَرُوا۟ كَمَثَلِ ٱلَّذِى يَنْعِقُ بِمَا لَا يَسْمَعُ إِلَّا دُعَآءًۭ وَنِدَآءًۭ ۚ صُمٌّۢ بُكْمٌ عُمْىٌۭ فَهُمْ لَا يَعْقِلُونَ',
		number_in_surah: '171',
		page: '26',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '179',
		number: '179',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ كُلُوا۟ مِن طَيِّبَٰتِ مَا رَزَقْنَٰكُمْ وَٱشْكُرُوا۟ لِلَّهِ إِن كُنتُمْ إِيَّاهُ تَعْبُدُونَ',
		number_in_surah: '172',
		page: '26',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '180',
		number: '180',
		text: 'إِنَّمَا حَرَّمَ عَلَيْكُمُ ٱلْمَيْتَةَ وَٱلدَّمَ وَلَحْمَ ٱلْخِنزِيرِ وَمَآ أُهِلَّ بِهِۦ لِغَيْرِ ٱللَّهِ ۖ فَمَنِ ٱضْطُرَّ غَيْرَ بَاغٍۢ وَلَا عَادٍۢ فَلَآ إِثْمَ عَلَيْهِ ۚ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '173',
		page: '26',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '181',
		number: '181',
		text: 'إِنَّ ٱلَّذِينَ يَكْتُمُونَ مَآ أَنزَلَ ٱللَّهُ مِنَ ٱلْكِتَٰبِ وَيَشْتَرُونَ بِهِۦ ثَمَنًۭا قَلِيلًا ۙ أُو۟لَٰٓئِكَ مَا يَأْكُلُونَ فِى بُطُونِهِمْ إِلَّا ٱلنَّارَ وَلَا يُكَلِّمُهُمُ ٱللَّهُ يَوْمَ ٱلْقِيَٰمَةِ وَلَا يُزَكِّيهِمْ وَلَهُمْ عَذَابٌ أَلِيمٌ',
		number_in_surah: '174',
		page: '26',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '182',
		number: '182',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ ٱشْتَرَوُا۟ ٱلضَّلَٰلَةَ بِٱلْهُدَىٰ وَٱلْعَذَابَ بِٱلْمَغْفِرَةِ ۚ فَمَآ أَصْبَرَهُمْ عَلَى ٱلنَّارِ',
		number_in_surah: '175',
		page: '26',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '183',
		number: '183',
		text: 'ذَٰلِكَ بِأَنَّ ٱللَّهَ نَزَّلَ ٱلْكِتَٰبَ بِٱلْحَقِّ ۗ وَإِنَّ ٱلَّذِينَ ٱخْتَلَفُوا۟ فِى ٱلْكِتَٰبِ لَفِى شِقَاقٍۭ بَعِيدٍۢ',
		number_in_surah: '176',
		page: '26',
		surah_id: '2',
		hizb_id: '10',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '184',
		number: '184',
		text: '۞ لَّيْسَ ٱلْبِرَّ أَن تُوَلُّوا۟ وُجُوهَكُمْ قِبَلَ ٱلْمَشْرِقِ وَٱلْمَغْرِبِ وَلَٰكِنَّ ٱلْبِرَّ مَنْ ءَامَنَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَٱلْمَلَٰٓئِكَةِ وَٱلْكِتَٰبِ وَٱلنَّبِيِّۦنَ وَءَاتَى ٱلْمَالَ عَلَىٰ حُبِّهِۦ ذَوِى ٱلْقُرْبَىٰ وَٱلْيَتَٰمَىٰ وَٱلْمَسَٰكِينَ وَٱبْنَ ٱلسَّبِيلِ وَٱلسَّآئِلِينَ وَفِى ٱلرِّقَابِ وَأَقَامَ ٱلصَّلَوٰةَ وَءَاتَى ٱلزَّكَوٰةَ وَٱلْمُوفُونَ بِعَهْدِهِمْ إِذَا عَٰهَدُوا۟ ۖ وَٱلصَّٰبِرِينَ فِى ٱلْبَأْسَآءِ وَٱلضَّرَّآءِ وَحِينَ ٱلْبَأْسِ ۗ أُو۟لَٰٓئِكَ ٱلَّذِينَ صَدَقُوا۟ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُتَّقُونَ',
		number_in_surah: '177',
		page: '27',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '185',
		number: '185',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ كُتِبَ عَلَيْكُمُ ٱلْقِصَاصُ فِى ٱلْقَتْلَى ۖ ٱلْحُرُّ بِٱلْحُرِّ وَٱلْعَبْدُ بِٱلْعَبْدِ وَٱلْأُنثَىٰ بِٱلْأُنثَىٰ ۚ فَمَنْ عُفِىَ لَهُۥ مِنْ أَخِيهِ شَىْءٌۭ فَٱتِّبَاعٌۢ بِٱلْمَعْرُوفِ وَأَدَآءٌ إِلَيْهِ بِإِحْسَٰنٍۢ ۗ ذَٰلِكَ تَخْفِيفٌۭ مِّن رَّبِّكُمْ وَرَحْمَةٌۭ ۗ فَمَنِ ٱعْتَدَىٰ بَعْدَ ذَٰلِكَ فَلَهُۥ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '178',
		page: '27',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '186',
		number: '186',
		text: 'وَلَكُمْ فِى ٱلْقِصَاصِ حَيَوٰةٌۭ يَٰٓأُو۟لِى ٱلْأَلْبَٰبِ لَعَلَّكُمْ تَتَّقُونَ',
		number_in_surah: '179',
		page: '27',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '187',
		number: '187',
		text: 'كُتِبَ عَلَيْكُمْ إِذَا حَضَرَ أَحَدَكُمُ ٱلْمَوْتُ إِن تَرَكَ خَيْرًا ٱلْوَصِيَّةُ لِلْوَٰلِدَيْنِ وَٱلْأَقْرَبِينَ بِٱلْمَعْرُوفِ ۖ حَقًّا عَلَى ٱلْمُتَّقِينَ',
		number_in_surah: '180',
		page: '27',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '188',
		number: '188',
		text: 'فَمَنۢ بَدَّلَهُۥ بَعْدَمَا سَمِعَهُۥ فَإِنَّمَآ إِثْمُهُۥ عَلَى ٱلَّذِينَ يُبَدِّلُونَهُۥٓ ۚ إِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '181',
		page: '27',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '189',
		number: '189',
		text: 'فَمَنْ خَافَ مِن مُّوصٍۢ جَنَفًا أَوْ إِثْمًۭا فَأَصْلَحَ بَيْنَهُمْ فَلَآ إِثْمَ عَلَيْهِ ۚ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '182',
		page: '28',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '190',
		number: '190',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ كُتِبَ عَلَيْكُمُ ٱلصِّيَامُ كَمَا كُتِبَ عَلَى ٱلَّذِينَ مِن قَبْلِكُمْ لَعَلَّكُمْ تَتَّقُونَ',
		number_in_surah: '183',
		page: '28',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '191',
		number: '191',
		text: 'أَيَّامًۭا مَّعْدُودَٰتٍۢ ۚ فَمَن كَانَ مِنكُم مَّرِيضًا أَوْ عَلَىٰ سَفَرٍۢ فَعِدَّةٌۭ مِّنْ أَيَّامٍ أُخَرَ ۚ وَعَلَى ٱلَّذِينَ يُطِيقُونَهُۥ فِدْيَةٌۭ طَعَامُ مِسْكِينٍۢ ۖ فَمَن تَطَوَّعَ خَيْرًۭا فَهُوَ خَيْرٌۭ لَّهُۥ ۚ وَأَن تَصُومُوا۟ خَيْرٌۭ لَّكُمْ ۖ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '184',
		page: '28',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '192',
		number: '192',
		text: 'شَهْرُ رَمَضَانَ ٱلَّذِىٓ أُنزِلَ فِيهِ ٱلْقُرْءَانُ هُدًۭى لِّلنَّاسِ وَبَيِّنَٰتٍۢ مِّنَ ٱلْهُدَىٰ وَٱلْفُرْقَانِ ۚ فَمَن شَهِدَ مِنكُمُ ٱلشَّهْرَ فَلْيَصُمْهُ ۖ وَمَن كَانَ مَرِيضًا أَوْ عَلَىٰ سَفَرٍۢ فَعِدَّةٌۭ مِّنْ أَيَّامٍ أُخَرَ ۗ يُرِيدُ ٱللَّهُ بِكُمُ ٱلْيُسْرَ وَلَا يُرِيدُ بِكُمُ ٱلْعُسْرَ وَلِتُكْمِلُوا۟ ٱلْعِدَّةَ وَلِتُكَبِّرُوا۟ ٱللَّهَ عَلَىٰ مَا هَدَىٰكُمْ وَلَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '185',
		page: '28',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '193',
		number: '193',
		text: 'وَإِذَا سَأَلَكَ عِبَادِى عَنِّى فَإِنِّى قَرِيبٌ ۖ أُجِيبُ دَعْوَةَ ٱلدَّاعِ إِذَا دَعَانِ ۖ فَلْيَسْتَجِيبُوا۟ لِى وَلْيُؤْمِنُوا۟ بِى لَعَلَّهُمْ يَرْشُدُونَ',
		number_in_surah: '186',
		page: '28',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '194',
		number: '194',
		text: 'أُحِلَّ لَكُمْ لَيْلَةَ ٱلصِّيَامِ ٱلرَّفَثُ إِلَىٰ نِسَآئِكُمْ ۚ هُنَّ لِبَاسٌۭ لَّكُمْ وَأَنتُمْ لِبَاسٌۭ لَّهُنَّ ۗ عَلِمَ ٱللَّهُ أَنَّكُمْ كُنتُمْ تَخْتَانُونَ أَنفُسَكُمْ فَتَابَ عَلَيْكُمْ وَعَفَا عَنكُمْ ۖ فَٱلْـَٰٔنَ بَٰشِرُوهُنَّ وَٱبْتَغُوا۟ مَا كَتَبَ ٱللَّهُ لَكُمْ ۚ وَكُلُوا۟ وَٱشْرَبُوا۟ حَتَّىٰ يَتَبَيَّنَ لَكُمُ ٱلْخَيْطُ ٱلْأَبْيَضُ مِنَ ٱلْخَيْطِ ٱلْأَسْوَدِ مِنَ ٱلْفَجْرِ ۖ ثُمَّ أَتِمُّوا۟ ٱلصِّيَامَ إِلَى ٱلَّيْلِ ۚ وَلَا تُبَٰشِرُوهُنَّ وَأَنتُمْ عَٰكِفُونَ فِى ٱلْمَسَٰجِدِ ۗ تِلْكَ حُدُودُ ٱللَّهِ فَلَا تَقْرَبُوهَا ۗ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ ءَايَٰتِهِۦ لِلنَّاسِ لَعَلَّهُمْ يَتَّقُونَ',
		number_in_surah: '187',
		page: '29',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '195',
		number: '195',
		text: 'وَلَا تَأْكُلُوٓا۟ أَمْوَٰلَكُم بَيْنَكُم بِٱلْبَٰطِلِ وَتُدْلُوا۟ بِهَآ إِلَى ٱلْحُكَّامِ لِتَأْكُلُوا۟ فَرِيقًۭا مِّنْ أَمْوَٰلِ ٱلنَّاسِ بِٱلْإِثْمِ وَأَنتُمْ تَعْلَمُونَ',
		number_in_surah: '188',
		page: '29',
		surah_id: '2',
		hizb_id: '11',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '196',
		number: '196',
		text: '۞ يَسْـَٔلُونَكَ عَنِ ٱلْأَهِلَّةِ ۖ قُلْ هِىَ مَوَٰقِيتُ لِلنَّاسِ وَٱلْحَجِّ ۗ وَلَيْسَ ٱلْبِرُّ بِأَن تَأْتُوا۟ ٱلْبُيُوتَ مِن ظُهُورِهَا وَلَٰكِنَّ ٱلْبِرَّ مَنِ ٱتَّقَىٰ ۗ وَأْتُوا۟ ٱلْبُيُوتَ مِنْ أَبْوَٰبِهَا ۚ وَٱتَّقُوا۟ ٱللَّهَ لَعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '189',
		page: '29',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '197',
		number: '197',
		text: 'وَقَٰتِلُوا۟ فِى سَبِيلِ ٱللَّهِ ٱلَّذِينَ يُقَٰتِلُونَكُمْ وَلَا تَعْتَدُوٓا۟ ۚ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلْمُعْتَدِينَ',
		number_in_surah: '190',
		page: '29',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '198',
		number: '198',
		text: 'وَٱقْتُلُوهُمْ حَيْثُ ثَقِفْتُمُوهُمْ وَأَخْرِجُوهُم مِّنْ حَيْثُ أَخْرَجُوكُمْ ۚ وَٱلْفِتْنَةُ أَشَدُّ مِنَ ٱلْقَتْلِ ۚ وَلَا تُقَٰتِلُوهُمْ عِندَ ٱلْمَسْجِدِ ٱلْحَرَامِ حَتَّىٰ يُقَٰتِلُوكُمْ فِيهِ ۖ فَإِن قَٰتَلُوكُمْ فَٱقْتُلُوهُمْ ۗ كَذَٰلِكَ جَزَآءُ ٱلْكَٰفِرِينَ',
		number_in_surah: '191',
		page: '30',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '199',
		number: '199',
		text: 'فَإِنِ ٱنتَهَوْا۟ فَإِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '192',
		page: '30',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '200',
		number: '200',
		text: 'وَقَٰتِلُوهُمْ حَتَّىٰ لَا تَكُونَ فِتْنَةٌۭ وَيَكُونَ ٱلدِّينُ لِلَّهِ ۖ فَإِنِ ٱنتَهَوْا۟ فَلَا عُدْوَٰنَ إِلَّا عَلَى ٱلظَّٰلِمِينَ',
		number_in_surah: '193',
		page: '30',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '201',
		number: '201',
		text: 'ٱلشَّهْرُ ٱلْحَرَامُ بِٱلشَّهْرِ ٱلْحَرَامِ وَٱلْحُرُمَٰتُ قِصَاصٌۭ ۚ فَمَنِ ٱعْتَدَىٰ عَلَيْكُمْ فَٱعْتَدُوا۟ عَلَيْهِ بِمِثْلِ مَا ٱعْتَدَىٰ عَلَيْكُمْ ۚ وَٱتَّقُوا۟ ٱللَّهَ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ مَعَ ٱلْمُتَّقِينَ',
		number_in_surah: '194',
		page: '30',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '202',
		number: '202',
		text: 'وَأَنفِقُوا۟ فِى سَبِيلِ ٱللَّهِ وَلَا تُلْقُوا۟ بِأَيْدِيكُمْ إِلَى ٱلتَّهْلُكَةِ ۛ وَأَحْسِنُوٓا۟ ۛ إِنَّ ٱللَّهَ يُحِبُّ ٱلْمُحْسِنِينَ',
		number_in_surah: '195',
		page: '30',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '203',
		number: '203',
		text: 'وَأَتِمُّوا۟ ٱلْحَجَّ وَٱلْعُمْرَةَ لِلَّهِ ۚ فَإِنْ أُحْصِرْتُمْ فَمَا ٱسْتَيْسَرَ مِنَ ٱلْهَدْىِ ۖ وَلَا تَحْلِقُوا۟ رُءُوسَكُمْ حَتَّىٰ يَبْلُغَ ٱلْهَدْىُ مَحِلَّهُۥ ۚ فَمَن كَانَ مِنكُم مَّرِيضًا أَوْ بِهِۦٓ أَذًۭى مِّن رَّأْسِهِۦ فَفِدْيَةٌۭ مِّن صِيَامٍ أَوْ صَدَقَةٍ أَوْ نُسُكٍۢ ۚ فَإِذَآ أَمِنتُمْ فَمَن تَمَتَّعَ بِٱلْعُمْرَةِ إِلَى ٱلْحَجِّ فَمَا ٱسْتَيْسَرَ مِنَ ٱلْهَدْىِ ۚ فَمَن لَّمْ يَجِدْ فَصِيَامُ ثَلَٰثَةِ أَيَّامٍۢ فِى ٱلْحَجِّ وَسَبْعَةٍ إِذَا رَجَعْتُمْ ۗ تِلْكَ عَشَرَةٌۭ كَامِلَةٌۭ ۗ ذَٰلِكَ لِمَن لَّمْ يَكُنْ أَهْلُهُۥ حَاضِرِى ٱلْمَسْجِدِ ٱلْحَرَامِ ۚ وَٱتَّقُوا۟ ٱللَّهَ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '196',
		page: '30',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '204',
		number: '204',
		text: 'ٱلْحَجُّ أَشْهُرٌۭ مَّعْلُومَٰتٌۭ ۚ فَمَن فَرَضَ فِيهِنَّ ٱلْحَجَّ فَلَا رَفَثَ وَلَا فُسُوقَ وَلَا جِدَالَ فِى ٱلْحَجِّ ۗ وَمَا تَفْعَلُوا۟ مِنْ خَيْرٍۢ يَعْلَمْهُ ٱللَّهُ ۗ وَتَزَوَّدُوا۟ فَإِنَّ خَيْرَ ٱلزَّادِ ٱلتَّقْوَىٰ ۚ وَٱتَّقُونِ يَٰٓأُو۟لِى ٱلْأَلْبَٰبِ',
		number_in_surah: '197',
		page: '31',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '205',
		number: '205',
		text: 'لَيْسَ عَلَيْكُمْ جُنَاحٌ أَن تَبْتَغُوا۟ فَضْلًۭا مِّن رَّبِّكُمْ ۚ فَإِذَآ أَفَضْتُم مِّنْ عَرَفَٰتٍۢ فَٱذْكُرُوا۟ ٱللَّهَ عِندَ ٱلْمَشْعَرِ ٱلْحَرَامِ ۖ وَٱذْكُرُوهُ كَمَا هَدَىٰكُمْ وَإِن كُنتُم مِّن قَبْلِهِۦ لَمِنَ ٱلضَّآلِّينَ',
		number_in_surah: '198',
		page: '31',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '206',
		number: '206',
		text: 'ثُمَّ أَفِيضُوا۟ مِنْ حَيْثُ أَفَاضَ ٱلنَّاسُ وَٱسْتَغْفِرُوا۟ ٱللَّهَ ۚ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '199',
		page: '31',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '207',
		number: '207',
		text: 'فَإِذَا قَضَيْتُم مَّنَٰسِكَكُمْ فَٱذْكُرُوا۟ ٱللَّهَ كَذِكْرِكُمْ ءَابَآءَكُمْ أَوْ أَشَدَّ ذِكْرًۭا ۗ فَمِنَ ٱلنَّاسِ مَن يَقُولُ رَبَّنَآ ءَاتِنَا فِى ٱلدُّنْيَا وَمَا لَهُۥ فِى ٱلْءَاخِرَةِ مِنْ خَلَٰقٍۢ',
		number_in_surah: '200',
		page: '31',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '208',
		number: '208',
		text: 'وَمِنْهُم مَّن يَقُولُ رَبَّنَآ ءَاتِنَا فِى ٱلدُّنْيَا حَسَنَةًۭ وَفِى ٱلْءَاخِرَةِ حَسَنَةًۭ وَقِنَا عَذَابَ ٱلنَّارِ',
		number_in_surah: '201',
		page: '31',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '209',
		number: '209',
		text: 'أُو۟لَٰٓئِكَ لَهُمْ نَصِيبٌۭ مِّمَّا كَسَبُوا۟ ۚ وَٱللَّهُ سَرِيعُ ٱلْحِسَابِ',
		number_in_surah: '202',
		page: '31',
		surah_id: '2',
		hizb_id: '12',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '210',
		number: '210',
		text: '۞ وَٱذْكُرُوا۟ ٱللَّهَ فِىٓ أَيَّامٍۢ مَّعْدُودَٰتٍۢ ۚ فَمَن تَعَجَّلَ فِى يَوْمَيْنِ فَلَآ إِثْمَ عَلَيْهِ وَمَن تَأَخَّرَ فَلَآ إِثْمَ عَلَيْهِ ۚ لِمَنِ ٱتَّقَىٰ ۗ وَٱتَّقُوا۟ ٱللَّهَ وَٱعْلَمُوٓا۟ أَنَّكُمْ إِلَيْهِ تُحْشَرُونَ',
		number_in_surah: '203',
		page: '32',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '211',
		number: '211',
		text: 'وَمِنَ ٱلنَّاسِ مَن يُعْجِبُكَ قَوْلُهُۥ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا وَيُشْهِدُ ٱللَّهَ عَلَىٰ مَا فِى قَلْبِهِۦ وَهُوَ أَلَدُّ ٱلْخِصَامِ',
		number_in_surah: '204',
		page: '32',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '212',
		number: '212',
		text: 'وَإِذَا تَوَلَّىٰ سَعَىٰ فِى ٱلْأَرْضِ لِيُفْسِدَ فِيهَا وَيُهْلِكَ ٱلْحَرْثَ وَٱلنَّسْلَ ۗ وَٱللَّهُ لَا يُحِبُّ ٱلْفَسَادَ',
		number_in_surah: '205',
		page: '32',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '213',
		number: '213',
		text: 'وَإِذَا قِيلَ لَهُ ٱتَّقِ ٱللَّهَ أَخَذَتْهُ ٱلْعِزَّةُ بِٱلْإِثْمِ ۚ فَحَسْبُهُۥ جَهَنَّمُ ۚ وَلَبِئْسَ ٱلْمِهَادُ',
		number_in_surah: '206',
		page: '32',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:54',
		updated_at: '2018-06-07 08:06:54',
	},
	{
		id: '214',
		number: '214',
		text: 'وَمِنَ ٱلنَّاسِ مَن يَشْرِى نَفْسَهُ ٱبْتِغَآءَ مَرْضَاتِ ٱللَّهِ ۗ وَٱللَّهُ رَءُوفٌۢ بِٱلْعِبَادِ',
		number_in_surah: '207',
		page: '32',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '215',
		number: '215',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱدْخُلُوا۟ فِى ٱلسِّلْمِ كَآفَّةًۭ وَلَا تَتَّبِعُوا۟ خُطُوَٰتِ ٱلشَّيْطَٰنِ ۚ إِنَّهُۥ لَكُمْ عَدُوٌّۭ مُّبِينٌۭ',
		number_in_surah: '208',
		page: '32',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '216',
		number: '216',
		text: 'فَإِن زَلَلْتُم مِّنۢ بَعْدِ مَا جَآءَتْكُمُ ٱلْبَيِّنَٰتُ فَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌ',
		number_in_surah: '209',
		page: '32',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '217',
		number: '217',
		text: 'هَلْ يَنظُرُونَ إِلَّآ أَن يَأْتِيَهُمُ ٱللَّهُ فِى ظُلَلٍۢ مِّنَ ٱلْغَمَامِ وَٱلْمَلَٰٓئِكَةُ وَقُضِىَ ٱلْأَمْرُ ۚ وَإِلَى ٱللَّهِ تُرْجَعُ ٱلْأُمُورُ',
		number_in_surah: '210',
		page: '32',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '218',
		number: '218',
		text: 'سَلْ بَنِىٓ إِسْرَٰٓءِيلَ كَمْ ءَاتَيْنَٰهُم مِّنْ ءَايَةٍۭ بَيِّنَةٍۢ ۗ وَمَن يُبَدِّلْ نِعْمَةَ ٱللَّهِ مِنۢ بَعْدِ مَا جَآءَتْهُ فَإِنَّ ٱللَّهَ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '211',
		page: '33',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '219',
		number: '219',
		text: 'زُيِّنَ لِلَّذِينَ كَفَرُوا۟ ٱلْحَيَوٰةُ ٱلدُّنْيَا وَيَسْخَرُونَ مِنَ ٱلَّذِينَ ءَامَنُوا۟ ۘ وَٱلَّذِينَ ٱتَّقَوْا۟ فَوْقَهُمْ يَوْمَ ٱلْقِيَٰمَةِ ۗ وَٱللَّهُ يَرْزُقُ مَن يَشَآءُ بِغَيْرِ حِسَابٍۢ',
		number_in_surah: '212',
		page: '33',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '220',
		number: '220',
		text: 'كَانَ ٱلنَّاسُ أُمَّةًۭ وَٰحِدَةًۭ فَبَعَثَ ٱللَّهُ ٱلنَّبِيِّۦنَ مُبَشِّرِينَ وَمُنذِرِينَ وَأَنزَلَ مَعَهُمُ ٱلْكِتَٰبَ بِٱلْحَقِّ لِيَحْكُمَ بَيْنَ ٱلنَّاسِ فِيمَا ٱخْتَلَفُوا۟ فِيهِ ۚ وَمَا ٱخْتَلَفَ فِيهِ إِلَّا ٱلَّذِينَ أُوتُوهُ مِنۢ بَعْدِ مَا جَآءَتْهُمُ ٱلْبَيِّنَٰتُ بَغْيًۢا بَيْنَهُمْ ۖ فَهَدَى ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ لِمَا ٱخْتَلَفُوا۟ فِيهِ مِنَ ٱلْحَقِّ بِإِذْنِهِۦ ۗ وَٱللَّهُ يَهْدِى مَن يَشَآءُ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍ',
		number_in_surah: '213',
		page: '33',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '221',
		number: '221',
		text: 'أَمْ حَسِبْتُمْ أَن تَدْخُلُوا۟ ٱلْجَنَّةَ وَلَمَّا يَأْتِكُم مَّثَلُ ٱلَّذِينَ خَلَوْا۟ مِن قَبْلِكُم ۖ مَّسَّتْهُمُ ٱلْبَأْسَآءُ وَٱلضَّرَّآءُ وَزُلْزِلُوا۟ حَتَّىٰ يَقُولَ ٱلرَّسُولُ وَٱلَّذِينَ ءَامَنُوا۟ مَعَهُۥ مَتَىٰ نَصْرُ ٱللَّهِ ۗ أَلَآ إِنَّ نَصْرَ ٱللَّهِ قَرِيبٌۭ',
		number_in_surah: '214',
		page: '33',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '222',
		number: '222',
		text: 'يَسْـَٔلُونَكَ مَاذَا يُنفِقُونَ ۖ قُلْ مَآ أَنفَقْتُم مِّنْ خَيْرٍۢ فَلِلْوَٰلِدَيْنِ وَٱلْأَقْرَبِينَ وَٱلْيَتَٰمَىٰ وَٱلْمَسَٰكِينِ وَٱبْنِ ٱلسَّبِيلِ ۗ وَمَا تَفْعَلُوا۟ مِنْ خَيْرٍۢ فَإِنَّ ٱللَّهَ بِهِۦ عَلِيمٌۭ',
		number_in_surah: '215',
		page: '33',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '223',
		number: '223',
		text: 'كُتِبَ عَلَيْكُمُ ٱلْقِتَالُ وَهُوَ كُرْهٌۭ لَّكُمْ ۖ وَعَسَىٰٓ أَن تَكْرَهُوا۟ شَيْـًۭٔا وَهُوَ خَيْرٌۭ لَّكُمْ ۖ وَعَسَىٰٓ أَن تُحِبُّوا۟ شَيْـًۭٔا وَهُوَ شَرٌّۭ لَّكُمْ ۗ وَٱللَّهُ يَعْلَمُ وَأَنتُمْ لَا تَعْلَمُونَ',
		number_in_surah: '216',
		page: '34',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '224',
		number: '224',
		text: 'يَسْـَٔلُونَكَ عَنِ ٱلشَّهْرِ ٱلْحَرَامِ قِتَالٍۢ فِيهِ ۖ قُلْ قِتَالٌۭ فِيهِ كَبِيرٌۭ ۖ وَصَدٌّ عَن سَبِيلِ ٱللَّهِ وَكُفْرٌۢ بِهِۦ وَٱلْمَسْجِدِ ٱلْحَرَامِ وَإِخْرَاجُ أَهْلِهِۦ مِنْهُ أَكْبَرُ عِندَ ٱللَّهِ ۚ وَٱلْفِتْنَةُ أَكْبَرُ مِنَ ٱلْقَتْلِ ۗ وَلَا يَزَالُونَ يُقَٰتِلُونَكُمْ حَتَّىٰ يَرُدُّوكُمْ عَن دِينِكُمْ إِنِ ٱسْتَطَٰعُوا۟ ۚ وَمَن يَرْتَدِدْ مِنكُمْ عَن دِينِهِۦ فَيَمُتْ وَهُوَ كَافِرٌۭ فَأُو۟لَٰٓئِكَ حَبِطَتْ أَعْمَٰلُهُمْ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ ۖ وَأُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '217',
		page: '34',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '225',
		number: '225',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَٱلَّذِينَ هَاجَرُوا۟ وَجَٰهَدُوا۟ فِى سَبِيلِ ٱللَّهِ أُو۟لَٰٓئِكَ يَرْجُونَ رَحْمَتَ ٱللَّهِ ۚ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '218',
		page: '34',
		surah_id: '2',
		hizb_id: '13',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '226',
		number: '226',
		text: '۞ يَسْـَٔلُونَكَ عَنِ ٱلْخَمْرِ وَٱلْمَيْسِرِ ۖ قُلْ فِيهِمَآ إِثْمٌۭ كَبِيرٌۭ وَمَنَٰفِعُ لِلنَّاسِ وَإِثْمُهُمَآ أَكْبَرُ مِن نَّفْعِهِمَا ۗ وَيَسْـَٔلُونَكَ مَاذَا يُنفِقُونَ قُلِ ٱلْعَفْوَ ۗ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمُ ٱلْءَايَٰتِ لَعَلَّكُمْ تَتَفَكَّرُونَ',
		number_in_surah: '219',
		page: '34',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '227',
		number: '227',
		text: 'فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ ۗ وَيَسْـَٔلُونَكَ عَنِ ٱلْيَتَٰمَىٰ ۖ قُلْ إِصْلَاحٌۭ لَّهُمْ خَيْرٌۭ ۖ وَإِن تُخَالِطُوهُمْ فَإِخْوَٰنُكُمْ ۚ وَٱللَّهُ يَعْلَمُ ٱلْمُفْسِدَ مِنَ ٱلْمُصْلِحِ ۚ وَلَوْ شَآءَ ٱللَّهُ لَأَعْنَتَكُمْ ۚ إِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '220',
		page: '35',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '228',
		number: '228',
		text: 'وَلَا تَنكِحُوا۟ ٱلْمُشْرِكَٰتِ حَتَّىٰ يُؤْمِنَّ ۚ وَلَأَمَةٌۭ مُّؤْمِنَةٌ خَيْرٌۭ مِّن مُّشْرِكَةٍۢ وَلَوْ أَعْجَبَتْكُمْ ۗ وَلَا تُنكِحُوا۟ ٱلْمُشْرِكِينَ حَتَّىٰ يُؤْمِنُوا۟ ۚ وَلَعَبْدٌۭ مُّؤْمِنٌ خَيْرٌۭ مِّن مُّشْرِكٍۢ وَلَوْ أَعْجَبَكُمْ ۗ أُو۟لَٰٓئِكَ يَدْعُونَ إِلَى ٱلنَّارِ ۖ وَٱللَّهُ يَدْعُوٓا۟ إِلَى ٱلْجَنَّةِ وَٱلْمَغْفِرَةِ بِإِذْنِهِۦ ۖ وَيُبَيِّنُ ءَايَٰتِهِۦ لِلنَّاسِ لَعَلَّهُمْ يَتَذَكَّرُونَ',
		number_in_surah: '221',
		page: '35',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '229',
		number: '229',
		text: 'وَيَسْـَٔلُونَكَ عَنِ ٱلْمَحِيضِ ۖ قُلْ هُوَ أَذًۭى فَٱعْتَزِلُوا۟ ٱلنِّسَآءَ فِى ٱلْمَحِيضِ ۖ وَلَا تَقْرَبُوهُنَّ حَتَّىٰ يَطْهُرْنَ ۖ فَإِذَا تَطَهَّرْنَ فَأْتُوهُنَّ مِنْ حَيْثُ أَمَرَكُمُ ٱللَّهُ ۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلتَّوَّٰبِينَ وَيُحِبُّ ٱلْمُتَطَهِّرِينَ',
		number_in_surah: '222',
		page: '35',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '230',
		number: '230',
		text: 'نِسَآؤُكُمْ حَرْثٌۭ لَّكُمْ فَأْتُوا۟ حَرْثَكُمْ أَنَّىٰ شِئْتُمْ ۖ وَقَدِّمُوا۟ لِأَنفُسِكُمْ ۚ وَٱتَّقُوا۟ ٱللَّهَ وَٱعْلَمُوٓا۟ أَنَّكُم مُّلَٰقُوهُ ۗ وَبَشِّرِ ٱلْمُؤْمِنِينَ',
		number_in_surah: '223',
		page: '35',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '231',
		number: '231',
		text: 'وَلَا تَجْعَلُوا۟ ٱللَّهَ عُرْضَةًۭ لِّأَيْمَٰنِكُمْ أَن تَبَرُّوا۟ وَتَتَّقُوا۟ وَتُصْلِحُوا۟ بَيْنَ ٱلنَّاسِ ۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '224',
		page: '35',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '232',
		number: '232',
		text: 'لَّا يُؤَاخِذُكُمُ ٱللَّهُ بِٱللَّغْوِ فِىٓ أَيْمَٰنِكُمْ وَلَٰكِن يُؤَاخِذُكُم بِمَا كَسَبَتْ قُلُوبُكُمْ ۗ وَٱللَّهُ غَفُورٌ حَلِيمٌۭ',
		number_in_surah: '225',
		page: '36',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '233',
		number: '233',
		text: 'لِّلَّذِينَ يُؤْلُونَ مِن نِّسَآئِهِمْ تَرَبُّصُ أَرْبَعَةِ أَشْهُرٍۢ ۖ فَإِن فَآءُو فَإِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '226',
		page: '36',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '234',
		number: '234',
		text: 'وَإِنْ عَزَمُوا۟ ٱلطَّلَٰقَ فَإِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '227',
		page: '36',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '235',
		number: '235',
		text: 'وَٱلْمُطَلَّقَٰتُ يَتَرَبَّصْنَ بِأَنفُسِهِنَّ ثَلَٰثَةَ قُرُوٓءٍۢ ۚ وَلَا يَحِلُّ لَهُنَّ أَن يَكْتُمْنَ مَا خَلَقَ ٱللَّهُ فِىٓ أَرْحَامِهِنَّ إِن كُنَّ يُؤْمِنَّ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ ۚ وَبُعُولَتُهُنَّ أَحَقُّ بِرَدِّهِنَّ فِى ذَٰلِكَ إِنْ أَرَادُوٓا۟ إِصْلَٰحًۭا ۚ وَلَهُنَّ مِثْلُ ٱلَّذِى عَلَيْهِنَّ بِٱلْمَعْرُوفِ ۚ وَلِلرِّجَالِ عَلَيْهِنَّ دَرَجَةٌۭ ۗ وَٱللَّهُ عَزِيزٌ حَكِيمٌ',
		number_in_surah: '228',
		page: '36',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '236',
		number: '236',
		text: 'ٱلطَّلَٰقُ مَرَّتَانِ ۖ فَإِمْسَاكٌۢ بِمَعْرُوفٍ أَوْ تَسْرِيحٌۢ بِإِحْسَٰنٍۢ ۗ وَلَا يَحِلُّ لَكُمْ أَن تَأْخُذُوا۟ مِمَّآ ءَاتَيْتُمُوهُنَّ شَيْـًٔا إِلَّآ أَن يَخَافَآ أَلَّا يُقِيمَا حُدُودَ ٱللَّهِ ۖ فَإِنْ خِفْتُمْ أَلَّا يُقِيمَا حُدُودَ ٱللَّهِ فَلَا جُنَاحَ عَلَيْهِمَا فِيمَا ٱفْتَدَتْ بِهِۦ ۗ تِلْكَ حُدُودُ ٱللَّهِ فَلَا تَعْتَدُوهَا ۚ وَمَن يَتَعَدَّ حُدُودَ ٱللَّهِ فَأُو۟لَٰٓئِكَ هُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '229',
		page: '36',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '237',
		number: '237',
		text: 'فَإِن طَلَّقَهَا فَلَا تَحِلُّ لَهُۥ مِنۢ بَعْدُ حَتَّىٰ تَنكِحَ زَوْجًا غَيْرَهُۥ ۗ فَإِن طَلَّقَهَا فَلَا جُنَاحَ عَلَيْهِمَآ أَن يَتَرَاجَعَآ إِن ظَنَّآ أَن يُقِيمَا حُدُودَ ٱللَّهِ ۗ وَتِلْكَ حُدُودُ ٱللَّهِ يُبَيِّنُهَا لِقَوْمٍۢ يَعْلَمُونَ',
		number_in_surah: '230',
		page: '36',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '238',
		number: '238',
		text: 'وَإِذَا طَلَّقْتُمُ ٱلنِّسَآءَ فَبَلَغْنَ أَجَلَهُنَّ فَأَمْسِكُوهُنَّ بِمَعْرُوفٍ أَوْ سَرِّحُوهُنَّ بِمَعْرُوفٍۢ ۚ وَلَا تُمْسِكُوهُنَّ ضِرَارًۭا لِّتَعْتَدُوا۟ ۚ وَمَن يَفْعَلْ ذَٰلِكَ فَقَدْ ظَلَمَ نَفْسَهُۥ ۚ وَلَا تَتَّخِذُوٓا۟ ءَايَٰتِ ٱللَّهِ هُزُوًۭا ۚ وَٱذْكُرُوا۟ نِعْمَتَ ٱللَّهِ عَلَيْكُمْ وَمَآ أَنزَلَ عَلَيْكُم مِّنَ ٱلْكِتَٰبِ وَٱلْحِكْمَةِ يَعِظُكُم بِهِۦ ۚ وَٱتَّقُوا۟ ٱللَّهَ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '231',
		page: '37',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '239',
		number: '239',
		text: 'وَإِذَا طَلَّقْتُمُ ٱلنِّسَآءَ فَبَلَغْنَ أَجَلَهُنَّ فَلَا تَعْضُلُوهُنَّ أَن يَنكِحْنَ أَزْوَٰجَهُنَّ إِذَا تَرَٰضَوْا۟ بَيْنَهُم بِٱلْمَعْرُوفِ ۗ ذَٰلِكَ يُوعَظُ بِهِۦ مَن كَانَ مِنكُمْ يُؤْمِنُ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ ۗ ذَٰلِكُمْ أَزْكَىٰ لَكُمْ وَأَطْهَرُ ۗ وَٱللَّهُ يَعْلَمُ وَأَنتُمْ لَا تَعْلَمُونَ',
		number_in_surah: '232',
		page: '37',
		surah_id: '2',
		hizb_id: '14',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '240',
		number: '240',
		text: '۞ وَٱلْوَٰلِدَٰتُ يُرْضِعْنَ أَوْلَٰدَهُنَّ حَوْلَيْنِ كَامِلَيْنِ ۖ لِمَنْ أَرَادَ أَن يُتِمَّ ٱلرَّضَاعَةَ ۚ وَعَلَى ٱلْمَوْلُودِ لَهُۥ رِزْقُهُنَّ وَكِسْوَتُهُنَّ بِٱلْمَعْرُوفِ ۚ لَا تُكَلَّفُ نَفْسٌ إِلَّا وُسْعَهَا ۚ لَا تُضَآرَّ وَٰلِدَةٌۢ بِوَلَدِهَا وَلَا مَوْلُودٌۭ لَّهُۥ بِوَلَدِهِۦ ۚ وَعَلَى ٱلْوَارِثِ مِثْلُ ذَٰلِكَ ۗ فَإِنْ أَرَادَا فِصَالًا عَن تَرَاضٍۢ مِّنْهُمَا وَتَشَاوُرٍۢ فَلَا جُنَاحَ عَلَيْهِمَا ۗ وَإِنْ أَرَدتُّمْ أَن تَسْتَرْضِعُوٓا۟ أَوْلَٰدَكُمْ فَلَا جُنَاحَ عَلَيْكُمْ إِذَا سَلَّمْتُم مَّآ ءَاتَيْتُم بِٱلْمَعْرُوفِ ۗ وَٱتَّقُوا۟ ٱللَّهَ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ بِمَا تَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '233',
		page: '37',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '241',
		number: '241',
		text: 'وَٱلَّذِينَ يُتَوَفَّوْنَ مِنكُمْ وَيَذَرُونَ أَزْوَٰجًۭا يَتَرَبَّصْنَ بِأَنفُسِهِنَّ أَرْبَعَةَ أَشْهُرٍۢ وَعَشْرًۭا ۖ فَإِذَا بَلَغْنَ أَجَلَهُنَّ فَلَا جُنَاحَ عَلَيْكُمْ فِيمَا فَعَلْنَ فِىٓ أَنفُسِهِنَّ بِٱلْمَعْرُوفِ ۗ وَٱللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '234',
		page: '38',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '242',
		number: '242',
		text: 'وَلَا جُنَاحَ عَلَيْكُمْ فِيمَا عَرَّضْتُم بِهِۦ مِنْ خِطْبَةِ ٱلنِّسَآءِ أَوْ أَكْنَنتُمْ فِىٓ أَنفُسِكُمْ ۚ عَلِمَ ٱللَّهُ أَنَّكُمْ سَتَذْكُرُونَهُنَّ وَلَٰكِن لَّا تُوَاعِدُوهُنَّ سِرًّا إِلَّآ أَن تَقُولُوا۟ قَوْلًۭا مَّعْرُوفًۭا ۚ وَلَا تَعْزِمُوا۟ عُقْدَةَ ٱلنِّكَاحِ حَتَّىٰ يَبْلُغَ ٱلْكِتَٰبُ أَجَلَهُۥ ۚ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ يَعْلَمُ مَا فِىٓ أَنفُسِكُمْ فَٱحْذَرُوهُ ۚ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ غَفُورٌ حَلِيمٌۭ',
		number_in_surah: '235',
		page: '38',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '243',
		number: '243',
		text: 'لَّا جُنَاحَ عَلَيْكُمْ إِن طَلَّقْتُمُ ٱلنِّسَآءَ مَا لَمْ تَمَسُّوهُنَّ أَوْ تَفْرِضُوا۟ لَهُنَّ فَرِيضَةًۭ ۚ وَمَتِّعُوهُنَّ عَلَى ٱلْمُوسِعِ قَدَرُهُۥ وَعَلَى ٱلْمُقْتِرِ قَدَرُهُۥ مَتَٰعًۢا بِٱلْمَعْرُوفِ ۖ حَقًّا عَلَى ٱلْمُحْسِنِينَ',
		number_in_surah: '236',
		page: '38',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '244',
		number: '244',
		text: 'وَإِن طَلَّقْتُمُوهُنَّ مِن قَبْلِ أَن تَمَسُّوهُنَّ وَقَدْ فَرَضْتُمْ لَهُنَّ فَرِيضَةًۭ فَنِصْفُ مَا فَرَضْتُمْ إِلَّآ أَن يَعْفُونَ أَوْ يَعْفُوَا۟ ٱلَّذِى بِيَدِهِۦ عُقْدَةُ ٱلنِّكَاحِ ۚ وَأَن تَعْفُوٓا۟ أَقْرَبُ لِلتَّقْوَىٰ ۚ وَلَا تَنسَوُا۟ ٱلْفَضْلَ بَيْنَكُمْ ۚ إِنَّ ٱللَّهَ بِمَا تَعْمَلُونَ بَصِيرٌ',
		number_in_surah: '237',
		page: '38',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '245',
		number: '245',
		text: 'حَٰفِظُوا۟ عَلَى ٱلصَّلَوَٰتِ وَٱلصَّلَوٰةِ ٱلْوُسْطَىٰ وَقُومُوا۟ لِلَّهِ قَٰنِتِينَ',
		number_in_surah: '238',
		page: '39',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '246',
		number: '246',
		text: 'فَإِنْ خِفْتُمْ فَرِجَالًا أَوْ رُكْبَانًۭا ۖ فَإِذَآ أَمِنتُمْ فَٱذْكُرُوا۟ ٱللَّهَ كَمَا عَلَّمَكُم مَّا لَمْ تَكُونُوا۟ تَعْلَمُونَ',
		number_in_surah: '239',
		page: '39',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '247',
		number: '247',
		text: 'وَٱلَّذِينَ يُتَوَفَّوْنَ مِنكُمْ وَيَذَرُونَ أَزْوَٰجًۭا وَصِيَّةًۭ لِّأَزْوَٰجِهِم مَّتَٰعًا إِلَى ٱلْحَوْلِ غَيْرَ إِخْرَاجٍۢ ۚ فَإِنْ خَرَجْنَ فَلَا جُنَاحَ عَلَيْكُمْ فِى مَا فَعَلْنَ فِىٓ أَنفُسِهِنَّ مِن مَّعْرُوفٍۢ ۗ وَٱللَّهُ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '240',
		page: '39',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '248',
		number: '248',
		text: 'وَلِلْمُطَلَّقَٰتِ مَتَٰعٌۢ بِٱلْمَعْرُوفِ ۖ حَقًّا عَلَى ٱلْمُتَّقِينَ',
		number_in_surah: '241',
		page: '39',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '249',
		number: '249',
		text: 'كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمْ ءَايَٰتِهِۦ لَعَلَّكُمْ تَعْقِلُونَ',
		number_in_surah: '242',
		page: '39',
		surah_id: '2',
		hizb_id: '15',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '250',
		number: '250',
		text: '۞ أَلَمْ تَرَ إِلَى ٱلَّذِينَ خَرَجُوا۟ مِن دِيَٰرِهِمْ وَهُمْ أُلُوفٌ حَذَرَ ٱلْمَوْتِ فَقَالَ لَهُمُ ٱللَّهُ مُوتُوا۟ ثُمَّ أَحْيَٰهُمْ ۚ إِنَّ ٱللَّهَ لَذُو فَضْلٍ عَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَشْكُرُونَ',
		number_in_surah: '243',
		page: '39',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '251',
		number: '251',
		text: 'وَقَٰتِلُوا۟ فِى سَبِيلِ ٱللَّهِ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '244',
		page: '39',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '252',
		number: '252',
		text: 'مَّن ذَا ٱلَّذِى يُقْرِضُ ٱللَّهَ قَرْضًا حَسَنًۭا فَيُضَٰعِفَهُۥ لَهُۥٓ أَضْعَافًۭا كَثِيرَةًۭ ۚ وَٱللَّهُ يَقْبِضُ وَيَبْصُۜطُ وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '245',
		page: '39',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '253',
		number: '253',
		text: 'أَلَمْ تَرَ إِلَى ٱلْمَلَإِ مِنۢ بَنِىٓ إِسْرَٰٓءِيلَ مِنۢ بَعْدِ مُوسَىٰٓ إِذْ قَالُوا۟ لِنَبِىٍّۢ لَّهُمُ ٱبْعَثْ لَنَا مَلِكًۭا نُّقَٰتِلْ فِى سَبِيلِ ٱللَّهِ ۖ قَالَ هَلْ عَسَيْتُمْ إِن كُتِبَ عَلَيْكُمُ ٱلْقِتَالُ أَلَّا تُقَٰتِلُوا۟ ۖ قَالُوا۟ وَمَا لَنَآ أَلَّا نُقَٰتِلَ فِى سَبِيلِ ٱللَّهِ وَقَدْ أُخْرِجْنَا مِن دِيَٰرِنَا وَأَبْنَآئِنَا ۖ فَلَمَّا كُتِبَ عَلَيْهِمُ ٱلْقِتَالُ تَوَلَّوْا۟ إِلَّا قَلِيلًۭا مِّنْهُمْ ۗ وَٱللَّهُ عَلِيمٌۢ بِٱلظَّٰلِمِينَ',
		number_in_surah: '246',
		page: '40',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '254',
		number: '254',
		text: 'وَقَالَ لَهُمْ نَبِيُّهُمْ إِنَّ ٱللَّهَ قَدْ بَعَثَ لَكُمْ طَالُوتَ مَلِكًۭا ۚ قَالُوٓا۟ أَنَّىٰ يَكُونُ لَهُ ٱلْمُلْكُ عَلَيْنَا وَنَحْنُ أَحَقُّ بِٱلْمُلْكِ مِنْهُ وَلَمْ يُؤْتَ سَعَةًۭ مِّنَ ٱلْمَالِ ۚ قَالَ إِنَّ ٱللَّهَ ٱصْطَفَىٰهُ عَلَيْكُمْ وَزَادَهُۥ بَسْطَةًۭ فِى ٱلْعِلْمِ وَٱلْجِسْمِ ۖ وَٱللَّهُ يُؤْتِى مُلْكَهُۥ مَن يَشَآءُ ۚ وَٱللَّهُ وَٰسِعٌ عَلِيمٌۭ',
		number_in_surah: '247',
		page: '40',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '255',
		number: '255',
		text: 'وَقَالَ لَهُمْ نَبِيُّهُمْ إِنَّ ءَايَةَ مُلْكِهِۦٓ أَن يَأْتِيَكُمُ ٱلتَّابُوتُ فِيهِ سَكِينَةٌۭ مِّن رَّبِّكُمْ وَبَقِيَّةٌۭ مِّمَّا تَرَكَ ءَالُ مُوسَىٰ وَءَالُ هَٰرُونَ تَحْمِلُهُ ٱلْمَلَٰٓئِكَةُ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لَّكُمْ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '248',
		page: '40',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '256',
		number: '256',
		text: 'فَلَمَّا فَصَلَ طَالُوتُ بِٱلْجُنُودِ قَالَ إِنَّ ٱللَّهَ مُبْتَلِيكُم بِنَهَرٍۢ فَمَن شَرِبَ مِنْهُ فَلَيْسَ مِنِّى وَمَن لَّمْ يَطْعَمْهُ فَإِنَّهُۥ مِنِّىٓ إِلَّا مَنِ ٱغْتَرَفَ غُرْفَةًۢ بِيَدِهِۦ ۚ فَشَرِبُوا۟ مِنْهُ إِلَّا قَلِيلًۭا مِّنْهُمْ ۚ فَلَمَّا جَاوَزَهُۥ هُوَ وَٱلَّذِينَ ءَامَنُوا۟ مَعَهُۥ قَالُوا۟ لَا طَاقَةَ لَنَا ٱلْيَوْمَ بِجَالُوتَ وَجُنُودِهِۦ ۚ قَالَ ٱلَّذِينَ يَظُنُّونَ أَنَّهُم مُّلَٰقُوا۟ ٱللَّهِ كَم مِّن فِئَةٍۢ قَلِيلَةٍ غَلَبَتْ فِئَةًۭ كَثِيرَةًۢ بِإِذْنِ ٱللَّهِ ۗ وَٱللَّهُ مَعَ ٱلصَّٰبِرِينَ',
		number_in_surah: '249',
		page: '41',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '257',
		number: '257',
		text: 'وَلَمَّا بَرَزُوا۟ لِجَالُوتَ وَجُنُودِهِۦ قَالُوا۟ رَبَّنَآ أَفْرِغْ عَلَيْنَا صَبْرًۭا وَثَبِّتْ أَقْدَامَنَا وَٱنصُرْنَا عَلَى ٱلْقَوْمِ ٱلْكَٰفِرِينَ',
		number_in_surah: '250',
		page: '41',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '258',
		number: '258',
		text: 'فَهَزَمُوهُم بِإِذْنِ ٱللَّهِ وَقَتَلَ دَاوُۥدُ جَالُوتَ وَءَاتَىٰهُ ٱللَّهُ ٱلْمُلْكَ وَٱلْحِكْمَةَ وَعَلَّمَهُۥ مِمَّا يَشَآءُ ۗ وَلَوْلَا دَفْعُ ٱللَّهِ ٱلنَّاسَ بَعْضَهُم بِبَعْضٍۢ لَّفَسَدَتِ ٱلْأَرْضُ وَلَٰكِنَّ ٱللَّهَ ذُو فَضْلٍ عَلَى ٱلْعَٰلَمِينَ',
		number_in_surah: '251',
		page: '41',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '259',
		number: '259',
		text: 'تِلْكَ ءَايَٰتُ ٱللَّهِ نَتْلُوهَا عَلَيْكَ بِٱلْحَقِّ ۚ وَإِنَّكَ لَمِنَ ٱلْمُرْسَلِينَ',
		number_in_surah: '252',
		page: '41',
		surah_id: '2',
		hizb_id: '16',
		juz_id: '2',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '260',
		number: '260',
		text: '۞ تِلْكَ ٱلرُّسُلُ فَضَّلْنَا بَعْضَهُمْ عَلَىٰ بَعْضٍۢ ۘ مِّنْهُم مَّن كَلَّمَ ٱللَّهُ ۖ وَرَفَعَ بَعْضَهُمْ دَرَجَٰتٍۢ ۚ وَءَاتَيْنَا عِيسَى ٱبْنَ مَرْيَمَ ٱلْبَيِّنَٰتِ وَأَيَّدْنَٰهُ بِرُوحِ ٱلْقُدُسِ ۗ وَلَوْ شَآءَ ٱللَّهُ مَا ٱقْتَتَلَ ٱلَّذِينَ مِنۢ بَعْدِهِم مِّنۢ بَعْدِ مَا جَآءَتْهُمُ ٱلْبَيِّنَٰتُ وَلَٰكِنِ ٱخْتَلَفُوا۟ فَمِنْهُم مَّنْ ءَامَنَ وَمِنْهُم مَّن كَفَرَ ۚ وَلَوْ شَآءَ ٱللَّهُ مَا ٱقْتَتَلُوا۟ وَلَٰكِنَّ ٱللَّهَ يَفْعَلُ مَا يُرِيدُ',
		number_in_surah: '253',
		page: '42',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '261',
		number: '261',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ أَنفِقُوا۟ مِمَّا رَزَقْنَٰكُم مِّن قَبْلِ أَن يَأْتِىَ يَوْمٌۭ لَّا بَيْعٌۭ فِيهِ وَلَا خُلَّةٌۭ وَلَا شَفَٰعَةٌۭ ۗ وَٱلْكَٰفِرُونَ هُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '254',
		page: '42',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '262',
		number: '262',
		text: 'ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ٱلْحَىُّ ٱلْقَيُّومُ ۚ لَا تَأْخُذُهُۥ سِنَةٌۭ وَلَا نَوْمٌۭ ۚ لَّهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۗ مَن ذَا ٱلَّذِى يَشْفَعُ عِندَهُۥٓ إِلَّا بِإِذْنِهِۦ ۚ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَىْءٍۢ مِّنْ عِلْمِهِۦٓ إِلَّا بِمَا شَآءَ ۚ وَسِعَ كُرْسِيُّهُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ ۖ وَلَا يَـُٔودُهُۥ حِفْظُهُمَا ۚ وَهُوَ ٱلْعَلِىُّ ٱلْعَظِيمُ',
		number_in_surah: '255',
		page: '42',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '263',
		number: '263',
		text: 'لَآ إِكْرَاهَ فِى ٱلدِّينِ ۖ قَد تَّبَيَّنَ ٱلرُّشْدُ مِنَ ٱلْغَىِّ ۚ فَمَن يَكْفُرْ بِٱلطَّٰغُوتِ وَيُؤْمِنۢ بِٱللَّهِ فَقَدِ ٱسْتَمْسَكَ بِٱلْعُرْوَةِ ٱلْوُثْقَىٰ لَا ٱنفِصَامَ لَهَا ۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌ',
		number_in_surah: '256',
		page: '42',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '264',
		number: '264',
		text: 'ٱللَّهُ وَلِىُّ ٱلَّذِينَ ءَامَنُوا۟ يُخْرِجُهُم مِّنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ ۖ وَٱلَّذِينَ كَفَرُوٓا۟ أَوْلِيَآؤُهُمُ ٱلطَّٰغُوتُ يُخْرِجُونَهُم مِّنَ ٱلنُّورِ إِلَى ٱلظُّلُمَٰتِ ۗ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '257',
		page: '43',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '265',
		number: '265',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِى حَآجَّ إِبْرَٰهِۦمَ فِى رَبِّهِۦٓ أَنْ ءَاتَىٰهُ ٱللَّهُ ٱلْمُلْكَ إِذْ قَالَ إِبْرَٰهِۦمُ رَبِّىَ ٱلَّذِى يُحْىِۦ وَيُمِيتُ قَالَ أَنَا۠ أُحْىِۦ وَأُمِيتُ ۖ قَالَ إِبْرَٰهِۦمُ فَإِنَّ ٱللَّهَ يَأْتِى بِٱلشَّمْسِ مِنَ ٱلْمَشْرِقِ فَأْتِ بِهَا مِنَ ٱلْمَغْرِبِ فَبُهِتَ ٱلَّذِى كَفَرَ ۗ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '258',
		page: '43',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '266',
		number: '266',
		text: 'أَوْ كَٱلَّذِى مَرَّ عَلَىٰ قَرْيَةٍۢ وَهِىَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا قَالَ أَنَّىٰ يُحْىِۦ هَٰذِهِ ٱللَّهُ بَعْدَ مَوْتِهَا ۖ فَأَمَاتَهُ ٱللَّهُ مِا۟ئَةَ عَامٍۢ ثُمَّ بَعَثَهُۥ ۖ قَالَ كَمْ لَبِثْتَ ۖ قَالَ لَبِثْتُ يَوْمًا أَوْ بَعْضَ يَوْمٍۢ ۖ قَالَ بَل لَّبِثْتَ مِا۟ئَةَ عَامٍۢ فَٱنظُرْ إِلَىٰ طَعَامِكَ وَشَرَابِكَ لَمْ يَتَسَنَّهْ ۖ وَٱنظُرْ إِلَىٰ حِمَارِكَ وَلِنَجْعَلَكَ ءَايَةًۭ لِّلنَّاسِ ۖ وَٱنظُرْ إِلَى ٱلْعِظَامِ كَيْفَ نُنشِزُهَا ثُمَّ نَكْسُوهَا لَحْمًۭا ۚ فَلَمَّا تَبَيَّنَ لَهُۥ قَالَ أَعْلَمُ أَنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '259',
		page: '43',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '267',
		number: '267',
		text: 'وَإِذْ قَالَ إِبْرَٰهِۦمُ رَبِّ أَرِنِى كَيْفَ تُحْىِ ٱلْمَوْتَىٰ ۖ قَالَ أَوَلَمْ تُؤْمِن ۖ قَالَ بَلَىٰ وَلَٰكِن لِّيَطْمَئِنَّ قَلْبِى ۖ قَالَ فَخُذْ أَرْبَعَةًۭ مِّنَ ٱلطَّيْرِ فَصُرْهُنَّ إِلَيْكَ ثُمَّ ٱجْعَلْ عَلَىٰ كُلِّ جَبَلٍۢ مِّنْهُنَّ جُزْءًۭا ثُمَّ ٱدْعُهُنَّ يَأْتِينَكَ سَعْيًۭا ۚ وَٱعْلَمْ أَنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '260',
		page: '44',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '268',
		number: '268',
		text: 'مَّثَلُ ٱلَّذِينَ يُنفِقُونَ أَمْوَٰلَهُمْ فِى سَبِيلِ ٱللَّهِ كَمَثَلِ حَبَّةٍ أَنۢبَتَتْ سَبْعَ سَنَابِلَ فِى كُلِّ سُنۢبُلَةٍۢ مِّا۟ئَةُ حَبَّةٍۢ ۗ وَٱللَّهُ يُضَٰعِفُ لِمَن يَشَآءُ ۗ وَٱللَّهُ وَٰسِعٌ عَلِيمٌ',
		number_in_surah: '261',
		page: '44',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '269',
		number: '269',
		text: 'ٱلَّذِينَ يُنفِقُونَ أَمْوَٰلَهُمْ فِى سَبِيلِ ٱللَّهِ ثُمَّ لَا يُتْبِعُونَ مَآ أَنفَقُوا۟ مَنًّۭا وَلَآ أَذًۭى ۙ لَّهُمْ أَجْرُهُمْ عِندَ رَبِّهِمْ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '262',
		page: '44',
		surah_id: '2',
		hizb_id: '17',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '270',
		number: '270',
		text: '۞ قَوْلٌۭ مَّعْرُوفٌۭ وَمَغْفِرَةٌ خَيْرٌۭ مِّن صَدَقَةٍۢ يَتْبَعُهَآ أَذًۭى ۗ وَٱللَّهُ غَنِىٌّ حَلِيمٌۭ',
		number_in_surah: '263',
		page: '44',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '271',
		number: '271',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تُبْطِلُوا۟ صَدَقَٰتِكُم بِٱلْمَنِّ وَٱلْأَذَىٰ كَٱلَّذِى يُنفِقُ مَالَهُۥ رِئَآءَ ٱلنَّاسِ وَلَا يُؤْمِنُ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ ۖ فَمَثَلُهُۥ كَمَثَلِ صَفْوَانٍ عَلَيْهِ تُرَابٌۭ فَأَصَابَهُۥ وَابِلٌۭ فَتَرَكَهُۥ صَلْدًۭا ۖ لَّا يَقْدِرُونَ عَلَىٰ شَىْءٍۢ مِّمَّا كَسَبُوا۟ ۗ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلْكَٰفِرِينَ',
		number_in_surah: '264',
		page: '44',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '272',
		number: '272',
		text: 'وَمَثَلُ ٱلَّذِينَ يُنفِقُونَ أَمْوَٰلَهُمُ ٱبْتِغَآءَ مَرْضَاتِ ٱللَّهِ وَتَثْبِيتًۭا مِّنْ أَنفُسِهِمْ كَمَثَلِ جَنَّةٍۭ بِرَبْوَةٍ أَصَابَهَا وَابِلٌۭ فَـَٔاتَتْ أُكُلَهَا ضِعْفَيْنِ فَإِن لَّمْ يُصِبْهَا وَابِلٌۭ فَطَلٌّۭ ۗ وَٱللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ',
		number_in_surah: '265',
		page: '45',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '273',
		number: '273',
		text: 'أَيَوَدُّ أَحَدُكُمْ أَن تَكُونَ لَهُۥ جَنَّةٌۭ مِّن نَّخِيلٍۢ وَأَعْنَابٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ لَهُۥ فِيهَا مِن كُلِّ ٱلثَّمَرَٰتِ وَأَصَابَهُ ٱلْكِبَرُ وَلَهُۥ ذُرِّيَّةٌۭ ضُعَفَآءُ فَأَصَابَهَآ إِعْصَارٌۭ فِيهِ نَارٌۭ فَٱحْتَرَقَتْ ۗ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمُ ٱلْءَايَٰتِ لَعَلَّكُمْ تَتَفَكَّرُونَ',
		number_in_surah: '266',
		page: '45',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '274',
		number: '274',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ أَنفِقُوا۟ مِن طَيِّبَٰتِ مَا كَسَبْتُمْ وَمِمَّآ أَخْرَجْنَا لَكُم مِّنَ ٱلْأَرْضِ ۖ وَلَا تَيَمَّمُوا۟ ٱلْخَبِيثَ مِنْهُ تُنفِقُونَ وَلَسْتُم بِـَٔاخِذِيهِ إِلَّآ أَن تُغْمِضُوا۟ فِيهِ ۚ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ غَنِىٌّ حَمِيدٌ',
		number_in_surah: '267',
		page: '45',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '275',
		number: '275',
		text: 'ٱلشَّيْطَٰنُ يَعِدُكُمُ ٱلْفَقْرَ وَيَأْمُرُكُم بِٱلْفَحْشَآءِ ۖ وَٱللَّهُ يَعِدُكُم مَّغْفِرَةًۭ مِّنْهُ وَفَضْلًۭا ۗ وَٱللَّهُ وَٰسِعٌ عَلِيمٌۭ',
		number_in_surah: '268',
		page: '45',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '276',
		number: '276',
		text: 'يُؤْتِى ٱلْحِكْمَةَ مَن يَشَآءُ ۚ وَمَن يُؤْتَ ٱلْحِكْمَةَ فَقَدْ أُوتِىَ خَيْرًۭا كَثِيرًۭا ۗ وَمَا يَذَّكَّرُ إِلَّآ أُو۟لُوا۟ ٱلْأَلْبَٰبِ',
		number_in_surah: '269',
		page: '45',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '277',
		number: '277',
		text: 'وَمَآ أَنفَقْتُم مِّن نَّفَقَةٍ أَوْ نَذَرْتُم مِّن نَّذْرٍۢ فَإِنَّ ٱللَّهَ يَعْلَمُهُۥ ۗ وَمَا لِلظَّٰلِمِينَ مِنْ أَنصَارٍ',
		number_in_surah: '270',
		page: '46',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '278',
		number: '278',
		text: 'إِن تُبْدُوا۟ ٱلصَّدَقَٰتِ فَنِعِمَّا هِىَ ۖ وَإِن تُخْفُوهَا وَتُؤْتُوهَا ٱلْفُقَرَآءَ فَهُوَ خَيْرٌۭ لَّكُمْ ۚ وَيُكَفِّرُ عَنكُم مِّن سَيِّـَٔاتِكُمْ ۗ وَٱللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '271',
		page: '46',
		surah_id: '2',
		hizb_id: '18',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '279',
		number: '279',
		text: '۞ لَّيْسَ عَلَيْكَ هُدَىٰهُمْ وَلَٰكِنَّ ٱللَّهَ يَهْدِى مَن يَشَآءُ ۗ وَمَا تُنفِقُوا۟ مِنْ خَيْرٍۢ فَلِأَنفُسِكُمْ ۚ وَمَا تُنفِقُونَ إِلَّا ٱبْتِغَآءَ وَجْهِ ٱللَّهِ ۚ وَمَا تُنفِقُوا۟ مِنْ خَيْرٍۢ يُوَفَّ إِلَيْكُمْ وَأَنتُمْ لَا تُظْلَمُونَ',
		number_in_surah: '272',
		page: '46',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '280',
		number: '280',
		text: 'لِلْفُقَرَآءِ ٱلَّذِينَ أُحْصِرُوا۟ فِى سَبِيلِ ٱللَّهِ لَا يَسْتَطِيعُونَ ضَرْبًۭا فِى ٱلْأَرْضِ يَحْسَبُهُمُ ٱلْجَاهِلُ أَغْنِيَآءَ مِنَ ٱلتَّعَفُّفِ تَعْرِفُهُم بِسِيمَٰهُمْ لَا يَسْـَٔلُونَ ٱلنَّاسَ إِلْحَافًۭا ۗ وَمَا تُنفِقُوا۟ مِنْ خَيْرٍۢ فَإِنَّ ٱللَّهَ بِهِۦ عَلِيمٌ',
		number_in_surah: '273',
		page: '46',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '281',
		number: '281',
		text: 'ٱلَّذِينَ يُنفِقُونَ أَمْوَٰلَهُم بِٱلَّيْلِ وَٱلنَّهَارِ سِرًّۭا وَعَلَانِيَةًۭ فَلَهُمْ أَجْرُهُمْ عِندَ رَبِّهِمْ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '274',
		page: '46',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '282',
		number: '282',
		text: 'ٱلَّذِينَ يَأْكُلُونَ ٱلرِّبَوٰا۟ لَا يَقُومُونَ إِلَّا كَمَا يَقُومُ ٱلَّذِى يَتَخَبَّطُهُ ٱلشَّيْطَٰنُ مِنَ ٱلْمَسِّ ۚ ذَٰلِكَ بِأَنَّهُمْ قَالُوٓا۟ إِنَّمَا ٱلْبَيْعُ مِثْلُ ٱلرِّبَوٰا۟ ۗ وَأَحَلَّ ٱللَّهُ ٱلْبَيْعَ وَحَرَّمَ ٱلرِّبَوٰا۟ ۚ فَمَن جَآءَهُۥ مَوْعِظَةٌۭ مِّن رَّبِّهِۦ فَٱنتَهَىٰ فَلَهُۥ مَا سَلَفَ وَأَمْرُهُۥٓ إِلَى ٱللَّهِ ۖ وَمَنْ عَادَ فَأُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '275',
		page: '47',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '283',
		number: '283',
		text: 'يَمْحَقُ ٱللَّهُ ٱلرِّبَوٰا۟ وَيُرْبِى ٱلصَّدَقَٰتِ ۗ وَٱللَّهُ لَا يُحِبُّ كُلَّ كَفَّارٍ أَثِيمٍ',
		number_in_surah: '276',
		page: '47',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '284',
		number: '284',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ وَأَقَامُوا۟ ٱلصَّلَوٰةَ وَءَاتَوُا۟ ٱلزَّكَوٰةَ لَهُمْ أَجْرُهُمْ عِندَ رَبِّهِمْ وَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '277',
		page: '47',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '285',
		number: '285',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱتَّقُوا۟ ٱللَّهَ وَذَرُوا۟ مَا بَقِىَ مِنَ ٱلرِّبَوٰٓا۟ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '278',
		page: '47',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '286',
		number: '286',
		text: 'فَإِن لَّمْ تَفْعَلُوا۟ فَأْذَنُوا۟ بِحَرْبٍۢ مِّنَ ٱللَّهِ وَرَسُولِهِۦ ۖ وَإِن تُبْتُمْ فَلَكُمْ رُءُوسُ أَمْوَٰلِكُمْ لَا تَظْلِمُونَ وَلَا تُظْلَمُونَ',
		number_in_surah: '279',
		page: '47',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '287',
		number: '287',
		text: 'وَإِن كَانَ ذُو عُسْرَةٍۢ فَنَظِرَةٌ إِلَىٰ مَيْسَرَةٍۢ ۚ وَأَن تَصَدَّقُوا۟ خَيْرٌۭ لَّكُمْ ۖ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '280',
		page: '47',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '288',
		number: '288',
		text: 'وَٱتَّقُوا۟ يَوْمًۭا تُرْجَعُونَ فِيهِ إِلَى ٱللَّهِ ۖ ثُمَّ تُوَفَّىٰ كُلُّ نَفْسٍۢ مَّا كَسَبَتْ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '281',
		page: '47',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '289',
		number: '289',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا تَدَايَنتُم بِدَيْنٍ إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى فَٱكْتُبُوهُ ۚ وَلْيَكْتُب بَّيْنَكُمْ كَاتِبٌۢ بِٱلْعَدْلِ ۚ وَلَا يَأْبَ كَاتِبٌ أَن يَكْتُبَ كَمَا عَلَّمَهُ ٱللَّهُ ۚ فَلْيَكْتُبْ وَلْيُمْلِلِ ٱلَّذِى عَلَيْهِ ٱلْحَقُّ وَلْيَتَّقِ ٱللَّهَ رَبَّهُۥ وَلَا يَبْخَسْ مِنْهُ شَيْـًۭٔا ۚ فَإِن كَانَ ٱلَّذِى عَلَيْهِ ٱلْحَقُّ سَفِيهًا أَوْ ضَعِيفًا أَوْ لَا يَسْتَطِيعُ أَن يُمِلَّ هُوَ فَلْيُمْلِلْ وَلِيُّهُۥ بِٱلْعَدْلِ ۚ وَٱسْتَشْهِدُوا۟ شَهِيدَيْنِ مِن رِّجَالِكُمْ ۖ فَإِن لَّمْ يَكُونَا رَجُلَيْنِ فَرَجُلٌۭ وَٱمْرَأَتَانِ مِمَّن تَرْضَوْنَ مِنَ ٱلشُّهَدَآءِ أَن تَضِلَّ إِحْدَىٰهُمَا فَتُذَكِّرَ إِحْدَىٰهُمَا ٱلْأُخْرَىٰ ۚ وَلَا يَأْبَ ٱلشُّهَدَآءُ إِذَا مَا دُعُوا۟ ۚ وَلَا تَسْـَٔمُوٓا۟ أَن تَكْتُبُوهُ صَغِيرًا أَوْ كَبِيرًا إِلَىٰٓ أَجَلِهِۦ ۚ ذَٰلِكُمْ أَقْسَطُ عِندَ ٱللَّهِ وَأَقْوَمُ لِلشَّهَٰدَةِ وَأَدْنَىٰٓ أَلَّا تَرْتَابُوٓا۟ ۖ إِلَّآ أَن تَكُونَ تِجَٰرَةً حَاضِرَةًۭ تُدِيرُونَهَا بَيْنَكُمْ فَلَيْسَ عَلَيْكُمْ جُنَاحٌ أَلَّا تَكْتُبُوهَا ۗ وَأَشْهِدُوٓا۟ إِذَا تَبَايَعْتُمْ ۚ وَلَا يُضَآرَّ كَاتِبٌۭ وَلَا شَهِيدٌۭ ۚ وَإِن تَفْعَلُوا۟ فَإِنَّهُۥ فُسُوقٌۢ بِكُمْ ۗ وَٱتَّقُوا۟ ٱللَّهَ ۖ وَيُعَلِّمُكُمُ ٱللَّهُ ۗ وَٱللَّهُ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '282',
		page: '48',
		surah_id: '2',
		hizb_id: '19',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '290',
		number: '290',
		text: '۞ وَإِن كُنتُمْ عَلَىٰ سَفَرٍۢ وَلَمْ تَجِدُوا۟ كَاتِبًۭا فَرِهَٰنٌۭ مَّقْبُوضَةٌۭ ۖ فَإِنْ أَمِنَ بَعْضُكُم بَعْضًۭا فَلْيُؤَدِّ ٱلَّذِى ٱؤْتُمِنَ أَمَٰنَتَهُۥ وَلْيَتَّقِ ٱللَّهَ رَبَّهُۥ ۗ وَلَا تَكْتُمُوا۟ ٱلشَّهَٰدَةَ ۚ وَمَن يَكْتُمْهَا فَإِنَّهُۥٓ ءَاثِمٌۭ قَلْبُهُۥ ۗ وَٱللَّهُ بِمَا تَعْمَلُونَ عَلِيمٌۭ',
		number_in_surah: '283',
		page: '49',
		surah_id: '2',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '291',
		number: '291',
		text: 'لِّلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۗ وَإِن تُبْدُوا۟ مَا فِىٓ أَنفُسِكُمْ أَوْ تُخْفُوهُ يُحَاسِبْكُم بِهِ ٱللَّهُ ۖ فَيَغْفِرُ لِمَن يَشَآءُ وَيُعَذِّبُ مَن يَشَآءُ ۗ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '284',
		page: '49',
		surah_id: '2',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '292',
		number: '292',
		text: 'ءَامَنَ ٱلرَّسُولُ بِمَآ أُنزِلَ إِلَيْهِ مِن رَّبِّهِۦ وَٱلْمُؤْمِنُونَ ۚ كُلٌّ ءَامَنَ بِٱللَّهِ وَمَلَٰٓئِكَتِهِۦ وَكُتُبِهِۦ وَرُسُلِهِۦ لَا نُفَرِّقُ بَيْنَ أَحَدٍۢ مِّن رُّسُلِهِۦ ۚ وَقَالُوا۟ سَمِعْنَا وَأَطَعْنَا ۖ غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ ٱلْمَصِيرُ',
		number_in_surah: '285',
		page: '49',
		surah_id: '2',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '293',
		number: '293',
		text: 'لَا يُكَلِّفُ ٱللَّهُ نَفْسًا إِلَّا وُسْعَهَا ۚ لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا ٱكْتَسَبَتْ ۗ رَبَّنَا لَا تُؤَاخِذْنَآ إِن نَّسِينَآ أَوْ أَخْطَأْنَا ۚ رَبَّنَا وَلَا تَحْمِلْ عَلَيْنَآ إِصْرًۭا كَمَا حَمَلْتَهُۥ عَلَى ٱلَّذِينَ مِن قَبْلِنَا ۚ رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهِۦ ۖ وَٱعْفُ عَنَّا وَٱغْفِرْ لَنَا وَٱرْحَمْنَآ ۚ أَنتَ مَوْلَىٰنَا فَٱنصُرْنَا عَلَى ٱلْقَوْمِ ٱلْكَٰفِرِينَ',
		number_in_surah: '286',
		page: '49',
		surah_id: '2',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '294',
		number: '294',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓمٓ',
		number_in_surah: '1',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '295',
		number: '295',
		text: 'ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ٱلْحَىُّ ٱلْقَيُّومُ',
		number_in_surah: '2',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '296',
		number: '296',
		text: 'نَزَّلَ عَلَيْكَ ٱلْكِتَٰبَ بِٱلْحَقِّ مُصَدِّقًۭا لِّمَا بَيْنَ يَدَيْهِ وَأَنزَلَ ٱلتَّوْرَىٰةَ وَٱلْإِنجِيلَ',
		number_in_surah: '3',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '297',
		number: '297',
		text: 'مِن قَبْلُ هُدًۭى لِّلنَّاسِ وَأَنزَلَ ٱلْفُرْقَانَ ۗ إِنَّ ٱلَّذِينَ كَفَرُوا۟ بِـَٔايَٰتِ ٱللَّهِ لَهُمْ عَذَابٌۭ شَدِيدٌۭ ۗ وَٱللَّهُ عَزِيزٌۭ ذُو ٱنتِقَامٍ',
		number_in_surah: '4',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '298',
		number: '298',
		text: 'إِنَّ ٱللَّهَ لَا يَخْفَىٰ عَلَيْهِ شَىْءٌۭ فِى ٱلْأَرْضِ وَلَا فِى ٱلسَّمَآءِ',
		number_in_surah: '5',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '299',
		number: '299',
		text: 'هُوَ ٱلَّذِى يُصَوِّرُكُمْ فِى ٱلْأَرْحَامِ كَيْفَ يَشَآءُ ۚ لَآ إِلَٰهَ إِلَّا هُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '6',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '300',
		number: '300',
		text: 'هُوَ ٱلَّذِىٓ أَنزَلَ عَلَيْكَ ٱلْكِتَٰبَ مِنْهُ ءَايَٰتٌۭ مُّحْكَمَٰتٌ هُنَّ أُمُّ ٱلْكِتَٰبِ وَأُخَرُ مُتَشَٰبِهَٰتٌۭ ۖ فَأَمَّا ٱلَّذِينَ فِى قُلُوبِهِمْ زَيْغٌۭ فَيَتَّبِعُونَ مَا تَشَٰبَهَ مِنْهُ ٱبْتِغَآءَ ٱلْفِتْنَةِ وَٱبْتِغَآءَ تَأْوِيلِهِۦ ۗ وَمَا يَعْلَمُ تَأْوِيلَهُۥٓ إِلَّا ٱللَّهُ ۗ وَٱلرَّٰسِخُونَ فِى ٱلْعِلْمِ يَقُولُونَ ءَامَنَّا بِهِۦ كُلٌّۭ مِّنْ عِندِ رَبِّنَا ۗ وَمَا يَذَّكَّرُ إِلَّآ أُو۟لُوا۟ ٱلْأَلْبَٰبِ',
		number_in_surah: '7',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '301',
		number: '301',
		text: 'رَبَّنَا لَا تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِن لَّدُنكَ رَحْمَةً ۚ إِنَّكَ أَنتَ ٱلْوَهَّابُ',
		number_in_surah: '8',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '302',
		number: '302',
		text: 'رَبَّنَآ إِنَّكَ جَامِعُ ٱلنَّاسِ لِيَوْمٍۢ لَّا رَيْبَ فِيهِ ۚ إِنَّ ٱللَّهَ لَا يُخْلِفُ ٱلْمِيعَادَ',
		number_in_surah: '9',
		page: '50',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '303',
		number: '303',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ لَن تُغْنِىَ عَنْهُمْ أَمْوَٰلُهُمْ وَلَآ أَوْلَٰدُهُم مِّنَ ٱللَّهِ شَيْـًۭٔا ۖ وَأُو۟لَٰٓئِكَ هُمْ وَقُودُ ٱلنَّارِ',
		number_in_surah: '10',
		page: '51',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '304',
		number: '304',
		text: 'كَدَأْبِ ءَالِ فِرْعَوْنَ وَٱلَّذِينَ مِن قَبْلِهِمْ ۚ كَذَّبُوا۟ بِـَٔايَٰتِنَا فَأَخَذَهُمُ ٱللَّهُ بِذُنُوبِهِمْ ۗ وَٱللَّهُ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '11',
		page: '51',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '305',
		number: '305',
		text: 'قُل لِّلَّذِينَ كَفَرُوا۟ سَتُغْلَبُونَ وَتُحْشَرُونَ إِلَىٰ جَهَنَّمَ ۚ وَبِئْسَ ٱلْمِهَادُ',
		number_in_surah: '12',
		page: '51',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '306',
		number: '306',
		text: 'قَدْ كَانَ لَكُمْ ءَايَةٌۭ فِى فِئَتَيْنِ ٱلْتَقَتَا ۖ فِئَةٌۭ تُقَٰتِلُ فِى سَبِيلِ ٱللَّهِ وَأُخْرَىٰ كَافِرَةٌۭ يَرَوْنَهُم مِّثْلَيْهِمْ رَأْىَ ٱلْعَيْنِ ۚ وَٱللَّهُ يُؤَيِّدُ بِنَصْرِهِۦ مَن يَشَآءُ ۗ إِنَّ فِى ذَٰلِكَ لَعِبْرَةًۭ لِّأُو۟لِى ٱلْأَبْصَٰرِ',
		number_in_surah: '13',
		page: '51',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '307',
		number: '307',
		text: 'زُيِّنَ لِلنَّاسِ حُبُّ ٱلشَّهَوَٰتِ مِنَ ٱلنِّسَآءِ وَٱلْبَنِينَ وَٱلْقَنَٰطِيرِ ٱلْمُقَنطَرَةِ مِنَ ٱلذَّهَبِ وَٱلْفِضَّةِ وَٱلْخَيْلِ ٱلْمُسَوَّمَةِ وَٱلْأَنْعَٰمِ وَٱلْحَرْثِ ۗ ذَٰلِكَ مَتَٰعُ ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ وَٱللَّهُ عِندَهُۥ حُسْنُ ٱلْمَـَٔابِ',
		number_in_surah: '14',
		page: '51',
		surah_id: '3',
		hizb_id: '20',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '308',
		number: '308',
		text: '۞ قُلْ أَؤُنَبِّئُكُم بِخَيْرٍۢ مِّن ذَٰلِكُمْ ۚ لِلَّذِينَ ٱتَّقَوْا۟ عِندَ رَبِّهِمْ جَنَّٰتٌۭ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا وَأَزْوَٰجٌۭ مُّطَهَّرَةٌۭ وَرِضْوَٰنٌۭ مِّنَ ٱللَّهِ ۗ وَٱللَّهُ بَصِيرٌۢ بِٱلْعِبَادِ',
		number_in_surah: '15',
		page: '51',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '309',
		number: '309',
		text: 'ٱلَّذِينَ يَقُولُونَ رَبَّنَآ إِنَّنَآ ءَامَنَّا فَٱغْفِرْ لَنَا ذُنُوبَنَا وَقِنَا عَذَابَ ٱلنَّارِ',
		number_in_surah: '16',
		page: '52',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '310',
		number: '310',
		text: 'ٱلصَّٰبِرِينَ وَٱلصَّٰدِقِينَ وَٱلْقَٰنِتِينَ وَٱلْمُنفِقِينَ وَٱلْمُسْتَغْفِرِينَ بِٱلْأَسْحَارِ',
		number_in_surah: '17',
		page: '52',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '311',
		number: '311',
		text: 'شَهِدَ ٱللَّهُ أَنَّهُۥ لَآ إِلَٰهَ إِلَّا هُوَ وَٱلْمَلَٰٓئِكَةُ وَأُو۟لُوا۟ ٱلْعِلْمِ قَآئِمًۢا بِٱلْقِسْطِ ۚ لَآ إِلَٰهَ إِلَّا هُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '18',
		page: '52',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '312',
		number: '312',
		text: 'إِنَّ ٱلدِّينَ عِندَ ٱللَّهِ ٱلْإِسْلَٰمُ ۗ وَمَا ٱخْتَلَفَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ إِلَّا مِنۢ بَعْدِ مَا جَآءَهُمُ ٱلْعِلْمُ بَغْيًۢا بَيْنَهُمْ ۗ وَمَن يَكْفُرْ بِـَٔايَٰتِ ٱللَّهِ فَإِنَّ ٱللَّهَ سَرِيعُ ٱلْحِسَابِ',
		number_in_surah: '19',
		page: '52',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '313',
		number: '313',
		text: 'فَإِنْ حَآجُّوكَ فَقُلْ أَسْلَمْتُ وَجْهِىَ لِلَّهِ وَمَنِ ٱتَّبَعَنِ ۗ وَقُل لِّلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ وَٱلْأُمِّيِّۦنَ ءَأَسْلَمْتُمْ ۚ فَإِنْ أَسْلَمُوا۟ فَقَدِ ٱهْتَدَوا۟ ۖ وَّإِن تَوَلَّوْا۟ فَإِنَّمَا عَلَيْكَ ٱلْبَلَٰغُ ۗ وَٱللَّهُ بَصِيرٌۢ بِٱلْعِبَادِ',
		number_in_surah: '20',
		page: '52',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '314',
		number: '314',
		text: 'إِنَّ ٱلَّذِينَ يَكْفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَيَقْتُلُونَ ٱلنَّبِيِّۦنَ بِغَيْرِ حَقٍّۢ وَيَقْتُلُونَ ٱلَّذِينَ يَأْمُرُونَ بِٱلْقِسْطِ مِنَ ٱلنَّاسِ فَبَشِّرْهُم بِعَذَابٍ أَلِيمٍ',
		number_in_surah: '21',
		page: '52',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '315',
		number: '315',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ حَبِطَتْ أَعْمَٰلُهُمْ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ وَمَا لَهُم مِّن نَّٰصِرِينَ',
		number_in_surah: '22',
		page: '52',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '316',
		number: '316',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِينَ أُوتُوا۟ نَصِيبًۭا مِّنَ ٱلْكِتَٰبِ يُدْعَوْنَ إِلَىٰ كِتَٰبِ ٱللَّهِ لِيَحْكُمَ بَيْنَهُمْ ثُمَّ يَتَوَلَّىٰ فَرِيقٌۭ مِّنْهُمْ وَهُم مُّعْرِضُونَ',
		number_in_surah: '23',
		page: '53',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '317',
		number: '317',
		text: 'ذَٰلِكَ بِأَنَّهُمْ قَالُوا۟ لَن تَمَسَّنَا ٱلنَّارُ إِلَّآ أَيَّامًۭا مَّعْدُودَٰتٍۢ ۖ وَغَرَّهُمْ فِى دِينِهِم مَّا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '24',
		page: '53',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '318',
		number: '318',
		text: 'فَكَيْفَ إِذَا جَمَعْنَٰهُمْ لِيَوْمٍۢ لَّا رَيْبَ فِيهِ وَوُفِّيَتْ كُلُّ نَفْسٍۢ مَّا كَسَبَتْ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '25',
		page: '53',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '319',
		number: '319',
		text: 'قُلِ ٱللَّهُمَّ مَٰلِكَ ٱلْمُلْكِ تُؤْتِى ٱلْمُلْكَ مَن تَشَآءُ وَتَنزِعُ ٱلْمُلْكَ مِمَّن تَشَآءُ وَتُعِزُّ مَن تَشَآءُ وَتُذِلُّ مَن تَشَآءُ ۖ بِيَدِكَ ٱلْخَيْرُ ۖ إِنَّكَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '26',
		page: '53',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '320',
		number: '320',
		text: 'تُولِجُ ٱلَّيْلَ فِى ٱلنَّهَارِ وَتُولِجُ ٱلنَّهَارَ فِى ٱلَّيْلِ ۖ وَتُخْرِجُ ٱلْحَىَّ مِنَ ٱلْمَيِّتِ وَتُخْرِجُ ٱلْمَيِّتَ مِنَ ٱلْحَىِّ ۖ وَتَرْزُقُ مَن تَشَآءُ بِغَيْرِ حِسَابٍۢ',
		number_in_surah: '27',
		page: '53',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '321',
		number: '321',
		text: 'لَّا يَتَّخِذِ ٱلْمُؤْمِنُونَ ٱلْكَٰفِرِينَ أَوْلِيَآءَ مِن دُونِ ٱلْمُؤْمِنِينَ ۖ وَمَن يَفْعَلْ ذَٰلِكَ فَلَيْسَ مِنَ ٱللَّهِ فِى شَىْءٍ إِلَّآ أَن تَتَّقُوا۟ مِنْهُمْ تُقَىٰةًۭ ۗ وَيُحَذِّرُكُمُ ٱللَّهُ نَفْسَهُۥ ۗ وَإِلَى ٱللَّهِ ٱلْمَصِيرُ',
		number_in_surah: '28',
		page: '53',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '322',
		number: '322',
		text: 'قُلْ إِن تُخْفُوا۟ مَا فِى صُدُورِكُمْ أَوْ تُبْدُوهُ يَعْلَمْهُ ٱللَّهُ ۗ وَيَعْلَمُ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۗ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '29',
		page: '53',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '323',
		number: '323',
		text: 'يَوْمَ تَجِدُ كُلُّ نَفْسٍۢ مَّا عَمِلَتْ مِنْ خَيْرٍۢ مُّحْضَرًۭا وَمَا عَمِلَتْ مِن سُوٓءٍۢ تَوَدُّ لَوْ أَنَّ بَيْنَهَا وَبَيْنَهُۥٓ أَمَدًۢا بَعِيدًۭا ۗ وَيُحَذِّرُكُمُ ٱللَّهُ نَفْسَهُۥ ۗ وَٱللَّهُ رَءُوفٌۢ بِٱلْعِبَادِ',
		number_in_surah: '30',
		page: '54',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '324',
		number: '324',
		text: 'قُلْ إِن كُنتُمْ تُحِبُّونَ ٱللَّهَ فَٱتَّبِعُونِى يُحْبِبْكُمُ ٱللَّهُ وَيَغْفِرْ لَكُمْ ذُنُوبَكُمْ ۗ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '31',
		page: '54',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '325',
		number: '325',
		text: 'قُلْ أَطِيعُوا۟ ٱللَّهَ وَٱلرَّسُولَ ۖ فَإِن تَوَلَّوْا۟ فَإِنَّ ٱللَّهَ لَا يُحِبُّ ٱلْكَٰفِرِينَ',
		number_in_surah: '32',
		page: '54',
		surah_id: '3',
		hizb_id: '21',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '326',
		number: '326',
		text: '۞ إِنَّ ٱللَّهَ ٱصْطَفَىٰٓ ءَادَمَ وَنُوحًۭا وَءَالَ إِبْرَٰهِيمَ وَءَالَ عِمْرَٰنَ عَلَى ٱلْعَٰلَمِينَ',
		number_in_surah: '33',
		page: '54',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '327',
		number: '327',
		text: 'ذُرِّيَّةًۢ بَعْضُهَا مِنۢ بَعْضٍۢ ۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌ',
		number_in_surah: '34',
		page: '54',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '328',
		number: '328',
		text: 'إِذْ قَالَتِ ٱمْرَأَتُ عِمْرَٰنَ رَبِّ إِنِّى نَذَرْتُ لَكَ مَا فِى بَطْنِى مُحَرَّرًۭا فَتَقَبَّلْ مِنِّىٓ ۖ إِنَّكَ أَنتَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '35',
		page: '54',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '329',
		number: '329',
		text: 'فَلَمَّا وَضَعَتْهَا قَالَتْ رَبِّ إِنِّى وَضَعْتُهَآ أُنثَىٰ وَٱللَّهُ أَعْلَمُ بِمَا وَضَعَتْ وَلَيْسَ ٱلذَّكَرُ كَٱلْأُنثَىٰ ۖ وَإِنِّى سَمَّيْتُهَا مَرْيَمَ وَإِنِّىٓ أُعِيذُهَا بِكَ وَذُرِّيَّتَهَا مِنَ ٱلشَّيْطَٰنِ ٱلرَّجِيمِ',
		number_in_surah: '36',
		page: '54',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '330',
		number: '330',
		text: 'فَتَقَبَّلَهَا رَبُّهَا بِقَبُولٍ حَسَنٍۢ وَأَنۢبَتَهَا نَبَاتًا حَسَنًۭا وَكَفَّلَهَا زَكَرِيَّا ۖ كُلَّمَا دَخَلَ عَلَيْهَا زَكَرِيَّا ٱلْمِحْرَابَ وَجَدَ عِندَهَا رِزْقًۭا ۖ قَالَ يَٰمَرْيَمُ أَنَّىٰ لَكِ هَٰذَا ۖ قَالَتْ هُوَ مِنْ عِندِ ٱللَّهِ ۖ إِنَّ ٱللَّهَ يَرْزُقُ مَن يَشَآءُ بِغَيْرِ حِسَابٍ',
		number_in_surah: '37',
		page: '54',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '331',
		number: '331',
		text: 'هُنَالِكَ دَعَا زَكَرِيَّا رَبَّهُۥ ۖ قَالَ رَبِّ هَبْ لِى مِن لَّدُنكَ ذُرِّيَّةًۭ طَيِّبَةً ۖ إِنَّكَ سَمِيعُ ٱلدُّعَآءِ',
		number_in_surah: '38',
		page: '55',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '332',
		number: '332',
		text: 'فَنَادَتْهُ ٱلْمَلَٰٓئِكَةُ وَهُوَ قَآئِمٌۭ يُصَلِّى فِى ٱلْمِحْرَابِ أَنَّ ٱللَّهَ يُبَشِّرُكَ بِيَحْيَىٰ مُصَدِّقًۢا بِكَلِمَةٍۢ مِّنَ ٱللَّهِ وَسَيِّدًۭا وَحَصُورًۭا وَنَبِيًّۭا مِّنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '39',
		page: '55',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '333',
		number: '333',
		text: 'قَالَ رَبِّ أَنَّىٰ يَكُونُ لِى غُلَٰمٌۭ وَقَدْ بَلَغَنِىَ ٱلْكِبَرُ وَٱمْرَأَتِى عَاقِرٌۭ ۖ قَالَ كَذَٰلِكَ ٱللَّهُ يَفْعَلُ مَا يَشَآءُ',
		number_in_surah: '40',
		page: '55',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '334',
		number: '334',
		text: 'قَالَ رَبِّ ٱجْعَل لِّىٓ ءَايَةًۭ ۖ قَالَ ءَايَتُكَ أَلَّا تُكَلِّمَ ٱلنَّاسَ ثَلَٰثَةَ أَيَّامٍ إِلَّا رَمْزًۭا ۗ وَٱذْكُر رَّبَّكَ كَثِيرًۭا وَسَبِّحْ بِٱلْعَشِىِّ وَٱلْإِبْكَٰرِ',
		number_in_surah: '41',
		page: '55',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '335',
		number: '335',
		text: 'وَإِذْ قَالَتِ ٱلْمَلَٰٓئِكَةُ يَٰمَرْيَمُ إِنَّ ٱللَّهَ ٱصْطَفَىٰكِ وَطَهَّرَكِ وَٱصْطَفَىٰكِ عَلَىٰ نِسَآءِ ٱلْعَٰلَمِينَ',
		number_in_surah: '42',
		page: '55',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '336',
		number: '336',
		text: 'يَٰمَرْيَمُ ٱقْنُتِى لِرَبِّكِ وَٱسْجُدِى وَٱرْكَعِى مَعَ ٱلرَّٰكِعِينَ',
		number_in_surah: '43',
		page: '55',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '337',
		number: '337',
		text: 'ذَٰلِكَ مِنْ أَنۢبَآءِ ٱلْغَيْبِ نُوحِيهِ إِلَيْكَ ۚ وَمَا كُنتَ لَدَيْهِمْ إِذْ يُلْقُونَ أَقْلَٰمَهُمْ أَيُّهُمْ يَكْفُلُ مَرْيَمَ وَمَا كُنتَ لَدَيْهِمْ إِذْ يَخْتَصِمُونَ',
		number_in_surah: '44',
		page: '55',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '338',
		number: '338',
		text: 'إِذْ قَالَتِ ٱلْمَلَٰٓئِكَةُ يَٰمَرْيَمُ إِنَّ ٱللَّهَ يُبَشِّرُكِ بِكَلِمَةٍۢ مِّنْهُ ٱسْمُهُ ٱلْمَسِيحُ عِيسَى ٱبْنُ مَرْيَمَ وَجِيهًۭا فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ وَمِنَ ٱلْمُقَرَّبِينَ',
		number_in_surah: '45',
		page: '55',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '339',
		number: '339',
		text: 'وَيُكَلِّمُ ٱلنَّاسَ فِى ٱلْمَهْدِ وَكَهْلًۭا وَمِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '46',
		page: '56',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '340',
		number: '340',
		text: 'قَالَتْ رَبِّ أَنَّىٰ يَكُونُ لِى وَلَدٌۭ وَلَمْ يَمْسَسْنِى بَشَرٌۭ ۖ قَالَ كَذَٰلِكِ ٱللَّهُ يَخْلُقُ مَا يَشَآءُ ۚ إِذَا قَضَىٰٓ أَمْرًۭا فَإِنَّمَا يَقُولُ لَهُۥ كُن فَيَكُونُ',
		number_in_surah: '47',
		page: '56',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '341',
		number: '341',
		text: 'وَيُعَلِّمُهُ ٱلْكِتَٰبَ وَٱلْحِكْمَةَ وَٱلتَّوْرَىٰةَ وَٱلْإِنجِيلَ',
		number_in_surah: '48',
		page: '56',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '342',
		number: '342',
		text: 'وَرَسُولًا إِلَىٰ بَنِىٓ إِسْرَٰٓءِيلَ أَنِّى قَدْ جِئْتُكُم بِـَٔايَةٍۢ مِّن رَّبِّكُمْ ۖ أَنِّىٓ أَخْلُقُ لَكُم مِّنَ ٱلطِّينِ كَهَيْـَٔةِ ٱلطَّيْرِ فَأَنفُخُ فِيهِ فَيَكُونُ طَيْرًۢا بِإِذْنِ ٱللَّهِ ۖ وَأُبْرِئُ ٱلْأَكْمَهَ وَٱلْأَبْرَصَ وَأُحْىِ ٱلْمَوْتَىٰ بِإِذْنِ ٱللَّهِ ۖ وَأُنَبِّئُكُم بِمَا تَأْكُلُونَ وَمَا تَدَّخِرُونَ فِى بُيُوتِكُمْ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لَّكُمْ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '49',
		page: '56',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '343',
		number: '343',
		text: 'وَمُصَدِّقًۭا لِّمَا بَيْنَ يَدَىَّ مِنَ ٱلتَّوْرَىٰةِ وَلِأُحِلَّ لَكُم بَعْضَ ٱلَّذِى حُرِّمَ عَلَيْكُمْ ۚ وَجِئْتُكُم بِـَٔايَةٍۢ مِّن رَّبِّكُمْ فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '50',
		page: '56',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '344',
		number: '344',
		text: 'إِنَّ ٱللَّهَ رَبِّى وَرَبُّكُمْ فَٱعْبُدُوهُ ۗ هَٰذَا صِرَٰطٌۭ مُّسْتَقِيمٌۭ',
		number_in_surah: '51',
		page: '56',
		surah_id: '3',
		hizb_id: '22',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '345',
		number: '345',
		text: '۞ فَلَمَّآ أَحَسَّ عِيسَىٰ مِنْهُمُ ٱلْكُفْرَ قَالَ مَنْ أَنصَارِىٓ إِلَى ٱللَّهِ ۖ قَالَ ٱلْحَوَارِيُّونَ نَحْنُ أَنصَارُ ٱللَّهِ ءَامَنَّا بِٱللَّهِ وَٱشْهَدْ بِأَنَّا مُسْلِمُونَ',
		number_in_surah: '52',
		page: '56',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '346',
		number: '346',
		text: 'رَبَّنَآ ءَامَنَّا بِمَآ أَنزَلْتَ وَٱتَّبَعْنَا ٱلرَّسُولَ فَٱكْتُبْنَا مَعَ ٱلشَّٰهِدِينَ',
		number_in_surah: '53',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '347',
		number: '347',
		text: 'وَمَكَرُوا۟ وَمَكَرَ ٱللَّهُ ۖ وَٱللَّهُ خَيْرُ ٱلْمَٰكِرِينَ',
		number_in_surah: '54',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '348',
		number: '348',
		text: 'إِذْ قَالَ ٱللَّهُ يَٰعِيسَىٰٓ إِنِّى مُتَوَفِّيكَ وَرَافِعُكَ إِلَىَّ وَمُطَهِّرُكَ مِنَ ٱلَّذِينَ كَفَرُوا۟ وَجَاعِلُ ٱلَّذِينَ ٱتَّبَعُوكَ فَوْقَ ٱلَّذِينَ كَفَرُوٓا۟ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ ۖ ثُمَّ إِلَىَّ مَرْجِعُكُمْ فَأَحْكُمُ بَيْنَكُمْ فِيمَا كُنتُمْ فِيهِ تَخْتَلِفُونَ',
		number_in_surah: '55',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '349',
		number: '349',
		text: 'فَأَمَّا ٱلَّذِينَ كَفَرُوا۟ فَأُعَذِّبُهُمْ عَذَابًۭا شَدِيدًۭا فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ وَمَا لَهُم مِّن نَّٰصِرِينَ',
		number_in_surah: '56',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '350',
		number: '350',
		text: 'وَأَمَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ فَيُوَفِّيهِمْ أُجُورَهُمْ ۗ وَٱللَّهُ لَا يُحِبُّ ٱلظَّٰلِمِينَ',
		number_in_surah: '57',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '351',
		number: '351',
		text: 'ذَٰلِكَ نَتْلُوهُ عَلَيْكَ مِنَ ٱلْءَايَٰتِ وَٱلذِّكْرِ ٱلْحَكِيمِ',
		number_in_surah: '58',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '352',
		number: '352',
		text: 'إِنَّ مَثَلَ عِيسَىٰ عِندَ ٱللَّهِ كَمَثَلِ ءَادَمَ ۖ خَلَقَهُۥ مِن تُرَابٍۢ ثُمَّ قَالَ لَهُۥ كُن فَيَكُونُ',
		number_in_surah: '59',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '353',
		number: '353',
		text: 'ٱلْحَقُّ مِن رَّبِّكَ فَلَا تَكُن مِّنَ ٱلْمُمْتَرِينَ',
		number_in_surah: '60',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '354',
		number: '354',
		text: 'فَمَنْ حَآجَّكَ فِيهِ مِنۢ بَعْدِ مَا جَآءَكَ مِنَ ٱلْعِلْمِ فَقُلْ تَعَالَوْا۟ نَدْعُ أَبْنَآءَنَا وَأَبْنَآءَكُمْ وَنِسَآءَنَا وَنِسَآءَكُمْ وَأَنفُسَنَا وَأَنفُسَكُمْ ثُمَّ نَبْتَهِلْ فَنَجْعَل لَّعْنَتَ ٱللَّهِ عَلَى ٱلْكَٰذِبِينَ',
		number_in_surah: '61',
		page: '57',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '355',
		number: '355',
		text: 'إِنَّ هَٰذَا لَهُوَ ٱلْقَصَصُ ٱلْحَقُّ ۚ وَمَا مِنْ إِلَٰهٍ إِلَّا ٱللَّهُ ۚ وَإِنَّ ٱللَّهَ لَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '62',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '356',
		number: '356',
		text: 'فَإِن تَوَلَّوْا۟ فَإِنَّ ٱللَّهَ عَلِيمٌۢ بِٱلْمُفْسِدِينَ',
		number_in_surah: '63',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '357',
		number: '357',
		text: 'قُلْ يَٰٓأَهْلَ ٱلْكِتَٰبِ تَعَالَوْا۟ إِلَىٰ كَلِمَةٍۢ سَوَآءٍۭ بَيْنَنَا وَبَيْنَكُمْ أَلَّا نَعْبُدَ إِلَّا ٱللَّهَ وَلَا نُشْرِكَ بِهِۦ شَيْـًۭٔا وَلَا يَتَّخِذَ بَعْضُنَا بَعْضًا أَرْبَابًۭا مِّن دُونِ ٱللَّهِ ۚ فَإِن تَوَلَّوْا۟ فَقُولُوا۟ ٱشْهَدُوا۟ بِأَنَّا مُسْلِمُونَ',
		number_in_surah: '64',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '358',
		number: '358',
		text: 'يَٰٓأَهْلَ ٱلْكِتَٰبِ لِمَ تُحَآجُّونَ فِىٓ إِبْرَٰهِيمَ وَمَآ أُنزِلَتِ ٱلتَّوْرَىٰةُ وَٱلْإِنجِيلُ إِلَّا مِنۢ بَعْدِهِۦٓ ۚ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '65',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '359',
		number: '359',
		text: 'هَٰٓأَنتُمْ هَٰٓؤُلَآءِ حَٰجَجْتُمْ فِيمَا لَكُم بِهِۦ عِلْمٌۭ فَلِمَ تُحَآجُّونَ فِيمَا لَيْسَ لَكُم بِهِۦ عِلْمٌۭ ۚ وَٱللَّهُ يَعْلَمُ وَأَنتُمْ لَا تَعْلَمُونَ',
		number_in_surah: '66',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '360',
		number: '360',
		text: 'مَا كَانَ إِبْرَٰهِيمُ يَهُودِيًّۭا وَلَا نَصْرَانِيًّۭا وَلَٰكِن كَانَ حَنِيفًۭا مُّسْلِمًۭا وَمَا كَانَ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '67',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '361',
		number: '361',
		text: 'إِنَّ أَوْلَى ٱلنَّاسِ بِإِبْرَٰهِيمَ لَلَّذِينَ ٱتَّبَعُوهُ وَهَٰذَا ٱلنَّبِىُّ وَٱلَّذِينَ ءَامَنُوا۟ ۗ وَٱللَّهُ وَلِىُّ ٱلْمُؤْمِنِينَ',
		number_in_surah: '68',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '362',
		number: '362',
		text: 'وَدَّت طَّآئِفَةٌۭ مِّنْ أَهْلِ ٱلْكِتَٰبِ لَوْ يُضِلُّونَكُمْ وَمَا يُضِلُّونَ إِلَّآ أَنفُسَهُمْ وَمَا يَشْعُرُونَ',
		number_in_surah: '69',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '363',
		number: '363',
		text: 'يَٰٓأَهْلَ ٱلْكِتَٰبِ لِمَ تَكْفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَأَنتُمْ تَشْهَدُونَ',
		number_in_surah: '70',
		page: '58',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '364',
		number: '364',
		text: 'يَٰٓأَهْلَ ٱلْكِتَٰبِ لِمَ تَلْبِسُونَ ٱلْحَقَّ بِٱلْبَٰطِلِ وَتَكْتُمُونَ ٱلْحَقَّ وَأَنتُمْ تَعْلَمُونَ',
		number_in_surah: '71',
		page: '59',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '365',
		number: '365',
		text: 'وَقَالَت طَّآئِفَةٌۭ مِّنْ أَهْلِ ٱلْكِتَٰبِ ءَامِنُوا۟ بِٱلَّذِىٓ أُنزِلَ عَلَى ٱلَّذِينَ ءَامَنُوا۟ وَجْهَ ٱلنَّهَارِ وَٱكْفُرُوٓا۟ ءَاخِرَهُۥ لَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '72',
		page: '59',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '366',
		number: '366',
		text: 'وَلَا تُؤْمِنُوٓا۟ إِلَّا لِمَن تَبِعَ دِينَكُمْ قُلْ إِنَّ ٱلْهُدَىٰ هُدَى ٱللَّهِ أَن يُؤْتَىٰٓ أَحَدٌۭ مِّثْلَ مَآ أُوتِيتُمْ أَوْ يُحَآجُّوكُمْ عِندَ رَبِّكُمْ ۗ قُلْ إِنَّ ٱلْفَضْلَ بِيَدِ ٱللَّهِ يُؤْتِيهِ مَن يَشَآءُ ۗ وَٱللَّهُ وَٰسِعٌ عَلِيمٌۭ',
		number_in_surah: '73',
		page: '59',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '367',
		number: '367',
		text: 'يَخْتَصُّ بِرَحْمَتِهِۦ مَن يَشَآءُ ۗ وَٱللَّهُ ذُو ٱلْفَضْلِ ٱلْعَظِيمِ',
		number_in_surah: '74',
		page: '59',
		surah_id: '3',
		hizb_id: '23',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '368',
		number: '368',
		text: '۞ وَمِنْ أَهْلِ ٱلْكِتَٰبِ مَنْ إِن تَأْمَنْهُ بِقِنطَارٍۢ يُؤَدِّهِۦٓ إِلَيْكَ وَمِنْهُم مَّنْ إِن تَأْمَنْهُ بِدِينَارٍۢ لَّا يُؤَدِّهِۦٓ إِلَيْكَ إِلَّا مَا دُمْتَ عَلَيْهِ قَآئِمًۭا ۗ ذَٰلِكَ بِأَنَّهُمْ قَالُوا۟ لَيْسَ عَلَيْنَا فِى ٱلْأُمِّيِّۦنَ سَبِيلٌۭ وَيَقُولُونَ عَلَى ٱللَّهِ ٱلْكَذِبَ وَهُمْ يَعْلَمُونَ',
		number_in_surah: '75',
		page: '59',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '369',
		number: '369',
		text: 'بَلَىٰ مَنْ أَوْفَىٰ بِعَهْدِهِۦ وَٱتَّقَىٰ فَإِنَّ ٱللَّهَ يُحِبُّ ٱلْمُتَّقِينَ',
		number_in_surah: '76',
		page: '59',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '370',
		number: '370',
		text: 'إِنَّ ٱلَّذِينَ يَشْتَرُونَ بِعَهْدِ ٱللَّهِ وَأَيْمَٰنِهِمْ ثَمَنًۭا قَلِيلًا أُو۟لَٰٓئِكَ لَا خَلَٰقَ لَهُمْ فِى ٱلْءَاخِرَةِ وَلَا يُكَلِّمُهُمُ ٱللَّهُ وَلَا يَنظُرُ إِلَيْهِمْ يَوْمَ ٱلْقِيَٰمَةِ وَلَا يُزَكِّيهِمْ وَلَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '77',
		page: '59',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '371',
		number: '371',
		text: 'وَإِنَّ مِنْهُمْ لَفَرِيقًۭا يَلْوُۥنَ أَلْسِنَتَهُم بِٱلْكِتَٰبِ لِتَحْسَبُوهُ مِنَ ٱلْكِتَٰبِ وَمَا هُوَ مِنَ ٱلْكِتَٰبِ وَيَقُولُونَ هُوَ مِنْ عِندِ ٱللَّهِ وَمَا هُوَ مِنْ عِندِ ٱللَّهِ وَيَقُولُونَ عَلَى ٱللَّهِ ٱلْكَذِبَ وَهُمْ يَعْلَمُونَ',
		number_in_surah: '78',
		page: '60',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '372',
		number: '372',
		text: 'مَا كَانَ لِبَشَرٍ أَن يُؤْتِيَهُ ٱللَّهُ ٱلْكِتَٰبَ وَٱلْحُكْمَ وَٱلنُّبُوَّةَ ثُمَّ يَقُولَ لِلنَّاسِ كُونُوا۟ عِبَادًۭا لِّى مِن دُونِ ٱللَّهِ وَلَٰكِن كُونُوا۟ رَبَّٰنِيِّۦنَ بِمَا كُنتُمْ تُعَلِّمُونَ ٱلْكِتَٰبَ وَبِمَا كُنتُمْ تَدْرُسُونَ',
		number_in_surah: '79',
		page: '60',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '373',
		number: '373',
		text: 'وَلَا يَأْمُرَكُمْ أَن تَتَّخِذُوا۟ ٱلْمَلَٰٓئِكَةَ وَٱلنَّبِيِّۦنَ أَرْبَابًا ۗ أَيَأْمُرُكُم بِٱلْكُفْرِ بَعْدَ إِذْ أَنتُم مُّسْلِمُونَ',
		number_in_surah: '80',
		page: '60',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '374',
		number: '374',
		text: 'وَإِذْ أَخَذَ ٱللَّهُ مِيثَٰقَ ٱلنَّبِيِّۦنَ لَمَآ ءَاتَيْتُكُم مِّن كِتَٰبٍۢ وَحِكْمَةٍۢ ثُمَّ جَآءَكُمْ رَسُولٌۭ مُّصَدِّقٌۭ لِّمَا مَعَكُمْ لَتُؤْمِنُنَّ بِهِۦ وَلَتَنصُرُنَّهُۥ ۚ قَالَ ءَأَقْرَرْتُمْ وَأَخَذْتُمْ عَلَىٰ ذَٰلِكُمْ إِصْرِى ۖ قَالُوٓا۟ أَقْرَرْنَا ۚ قَالَ فَٱشْهَدُوا۟ وَأَنَا۠ مَعَكُم مِّنَ ٱلشَّٰهِدِينَ',
		number_in_surah: '81',
		page: '60',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '375',
		number: '375',
		text: 'فَمَن تَوَلَّىٰ بَعْدَ ذَٰلِكَ فَأُو۟لَٰٓئِكَ هُمُ ٱلْفَٰسِقُونَ',
		number_in_surah: '82',
		page: '60',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '376',
		number: '376',
		text: 'أَفَغَيْرَ دِينِ ٱللَّهِ يَبْغُونَ وَلَهُۥٓ أَسْلَمَ مَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ طَوْعًۭا وَكَرْهًۭا وَإِلَيْهِ يُرْجَعُونَ',
		number_in_surah: '83',
		page: '60',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '377',
		number: '377',
		text: 'قُلْ ءَامَنَّا بِٱللَّهِ وَمَآ أُنزِلَ عَلَيْنَا وَمَآ أُنزِلَ عَلَىٰٓ إِبْرَٰهِيمَ وَإِسْمَٰعِيلَ وَإِسْحَٰقَ وَيَعْقُوبَ وَٱلْأَسْبَاطِ وَمَآ أُوتِىَ مُوسَىٰ وَعِيسَىٰ وَٱلنَّبِيُّونَ مِن رَّبِّهِمْ لَا نُفَرِّقُ بَيْنَ أَحَدٍۢ مِّنْهُمْ وَنَحْنُ لَهُۥ مُسْلِمُونَ',
		number_in_surah: '84',
		page: '61',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '378',
		number: '378',
		text: 'وَمَن يَبْتَغِ غَيْرَ ٱلْإِسْلَٰمِ دِينًۭا فَلَن يُقْبَلَ مِنْهُ وَهُوَ فِى ٱلْءَاخِرَةِ مِنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '85',
		page: '61',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '379',
		number: '379',
		text: 'كَيْفَ يَهْدِى ٱللَّهُ قَوْمًۭا كَفَرُوا۟ بَعْدَ إِيمَٰنِهِمْ وَشَهِدُوٓا۟ أَنَّ ٱلرَّسُولَ حَقٌّۭ وَجَآءَهُمُ ٱلْبَيِّنَٰتُ ۚ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '86',
		page: '61',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '380',
		number: '380',
		text: 'أُو۟لَٰٓئِكَ جَزَآؤُهُمْ أَنَّ عَلَيْهِمْ لَعْنَةَ ٱللَّهِ وَٱلْمَلَٰٓئِكَةِ وَٱلنَّاسِ أَجْمَعِينَ',
		number_in_surah: '87',
		page: '61',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '381',
		number: '381',
		text: 'خَٰلِدِينَ فِيهَا لَا يُخَفَّفُ عَنْهُمُ ٱلْعَذَابُ وَلَا هُمْ يُنظَرُونَ',
		number_in_surah: '88',
		page: '61',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '382',
		number: '382',
		text: 'إِلَّا ٱلَّذِينَ تَابُوا۟ مِنۢ بَعْدِ ذَٰلِكَ وَأَصْلَحُوا۟ فَإِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '89',
		page: '61',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '383',
		number: '383',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ بَعْدَ إِيمَٰنِهِمْ ثُمَّ ٱزْدَادُوا۟ كُفْرًۭا لَّن تُقْبَلَ تَوْبَتُهُمْ وَأُو۟لَٰٓئِكَ هُمُ ٱلضَّآلُّونَ',
		number_in_surah: '90',
		page: '61',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '384',
		number: '384',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ وَمَاتُوا۟ وَهُمْ كُفَّارٌۭ فَلَن يُقْبَلَ مِنْ أَحَدِهِم مِّلْءُ ٱلْأَرْضِ ذَهَبًۭا وَلَوِ ٱفْتَدَىٰ بِهِۦٓ ۗ أُو۟لَٰٓئِكَ لَهُمْ عَذَابٌ أَلِيمٌۭ وَمَا لَهُم مِّن نَّٰصِرِينَ',
		number_in_surah: '91',
		page: '61',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '385',
		number: '385',
		text: 'لَن تَنَالُوا۟ ٱلْبِرَّ حَتَّىٰ تُنفِقُوا۟ مِمَّا تُحِبُّونَ ۚ وَمَا تُنفِقُوا۟ مِن شَىْءٍۢ فَإِنَّ ٱللَّهَ بِهِۦ عَلِيمٌۭ',
		number_in_surah: '92',
		page: '62',
		surah_id: '3',
		hizb_id: '24',
		juz_id: '3',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '386',
		number: '386',
		text: '۞ كُلُّ ٱلطَّعَامِ كَانَ حِلًّۭا لِّبَنِىٓ إِسْرَٰٓءِيلَ إِلَّا مَا حَرَّمَ إِسْرَٰٓءِيلُ عَلَىٰ نَفْسِهِۦ مِن قَبْلِ أَن تُنَزَّلَ ٱلتَّوْرَىٰةُ ۗ قُلْ فَأْتُوا۟ بِٱلتَّوْرَىٰةِ فَٱتْلُوهَآ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '93',
		page: '62',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '387',
		number: '387',
		text: 'فَمَنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ ٱلْكَذِبَ مِنۢ بَعْدِ ذَٰلِكَ فَأُو۟لَٰٓئِكَ هُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '94',
		page: '62',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '388',
		number: '388',
		text: 'قُلْ صَدَقَ ٱللَّهُ ۗ فَٱتَّبِعُوا۟ مِلَّةَ إِبْرَٰهِيمَ حَنِيفًۭا وَمَا كَانَ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '95',
		page: '62',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '389',
		number: '389',
		text: 'إِنَّ أَوَّلَ بَيْتٍۢ وُضِعَ لِلنَّاسِ لَلَّذِى بِبَكَّةَ مُبَارَكًۭا وَهُدًۭى لِّلْعَٰلَمِينَ',
		number_in_surah: '96',
		page: '62',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '390',
		number: '390',
		text: 'فِيهِ ءَايَٰتٌۢ بَيِّنَٰتٌۭ مَّقَامُ إِبْرَٰهِيمَ ۖ وَمَن دَخَلَهُۥ كَانَ ءَامِنًۭا ۗ وَلِلَّهِ عَلَى ٱلنَّاسِ حِجُّ ٱلْبَيْتِ مَنِ ٱسْتَطَاعَ إِلَيْهِ سَبِيلًۭا ۚ وَمَن كَفَرَ فَإِنَّ ٱللَّهَ غَنِىٌّ عَنِ ٱلْعَٰلَمِينَ',
		number_in_surah: '97',
		page: '62',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '391',
		number: '391',
		text: 'قُلْ يَٰٓأَهْلَ ٱلْكِتَٰبِ لِمَ تَكْفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَٱللَّهُ شَهِيدٌ عَلَىٰ مَا تَعْمَلُونَ',
		number_in_surah: '98',
		page: '62',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '392',
		number: '392',
		text: 'قُلْ يَٰٓأَهْلَ ٱلْكِتَٰبِ لِمَ تَصُدُّونَ عَن سَبِيلِ ٱللَّهِ مَنْ ءَامَنَ تَبْغُونَهَا عِوَجًۭا وَأَنتُمْ شُهَدَآءُ ۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعْمَلُونَ',
		number_in_surah: '99',
		page: '62',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '393',
		number: '393',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِن تُطِيعُوا۟ فَرِيقًۭا مِّنَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ يَرُدُّوكُم بَعْدَ إِيمَٰنِكُمْ كَٰفِرِينَ',
		number_in_surah: '100',
		page: '62',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '394',
		number: '394',
		text: 'وَكَيْفَ تَكْفُرُونَ وَأَنتُمْ تُتْلَىٰ عَلَيْكُمْ ءَايَٰتُ ٱللَّهِ وَفِيكُمْ رَسُولُهُۥ ۗ وَمَن يَعْتَصِم بِٱللَّهِ فَقَدْ هُدِىَ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '101',
		page: '63',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '395',
		number: '395',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱتَّقُوا۟ ٱللَّهَ حَقَّ تُقَاتِهِۦ وَلَا تَمُوتُنَّ إِلَّا وَأَنتُم مُّسْلِمُونَ',
		number_in_surah: '102',
		page: '63',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '396',
		number: '396',
		text: 'وَٱعْتَصِمُوا۟ بِحَبْلِ ٱللَّهِ جَمِيعًۭا وَلَا تَفَرَّقُوا۟ ۚ وَٱذْكُرُوا۟ نِعْمَتَ ٱللَّهِ عَلَيْكُمْ إِذْ كُنتُمْ أَعْدَآءًۭ فَأَلَّفَ بَيْنَ قُلُوبِكُمْ فَأَصْبَحْتُم بِنِعْمَتِهِۦٓ إِخْوَٰنًۭا وَكُنتُمْ عَلَىٰ شَفَا حُفْرَةٍۢ مِّنَ ٱلنَّارِ فَأَنقَذَكُم مِّنْهَا ۗ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمْ ءَايَٰتِهِۦ لَعَلَّكُمْ تَهْتَدُونَ',
		number_in_surah: '103',
		page: '63',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '397',
		number: '397',
		text: 'وَلْتَكُن مِّنكُمْ أُمَّةٌۭ يَدْعُونَ إِلَى ٱلْخَيْرِ وَيَأْمُرُونَ بِٱلْمَعْرُوفِ وَيَنْهَوْنَ عَنِ ٱلْمُنكَرِ ۚ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '104',
		page: '63',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '398',
		number: '398',
		text: 'وَلَا تَكُونُوا۟ كَٱلَّذِينَ تَفَرَّقُوا۟ وَٱخْتَلَفُوا۟ مِنۢ بَعْدِ مَا جَآءَهُمُ ٱلْبَيِّنَٰتُ ۚ وَأُو۟لَٰٓئِكَ لَهُمْ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '105',
		page: '63',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '399',
		number: '399',
		text: 'يَوْمَ تَبْيَضُّ وُجُوهٌۭ وَتَسْوَدُّ وُجُوهٌۭ ۚ فَأَمَّا ٱلَّذِينَ ٱسْوَدَّتْ وُجُوهُهُمْ أَكَفَرْتُم بَعْدَ إِيمَٰنِكُمْ فَذُوقُوا۟ ٱلْعَذَابَ بِمَا كُنتُمْ تَكْفُرُونَ',
		number_in_surah: '106',
		page: '63',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '400',
		number: '400',
		text: 'وَأَمَّا ٱلَّذِينَ ٱبْيَضَّتْ وُجُوهُهُمْ فَفِى رَحْمَةِ ٱللَّهِ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '107',
		page: '63',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '401',
		number: '401',
		text: 'تِلْكَ ءَايَٰتُ ٱللَّهِ نَتْلُوهَا عَلَيْكَ بِٱلْحَقِّ ۗ وَمَا ٱللَّهُ يُرِيدُ ظُلْمًۭا لِّلْعَٰلَمِينَ',
		number_in_surah: '108',
		page: '63',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '402',
		number: '402',
		text: 'وَلِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۚ وَإِلَى ٱللَّهِ تُرْجَعُ ٱلْأُمُورُ',
		number_in_surah: '109',
		page: '64',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '403',
		number: '403',
		text: 'كُنتُمْ خَيْرَ أُمَّةٍ أُخْرِجَتْ لِلنَّاسِ تَأْمُرُونَ بِٱلْمَعْرُوفِ وَتَنْهَوْنَ عَنِ ٱلْمُنكَرِ وَتُؤْمِنُونَ بِٱللَّهِ ۗ وَلَوْ ءَامَنَ أَهْلُ ٱلْكِتَٰبِ لَكَانَ خَيْرًۭا لَّهُم ۚ مِّنْهُمُ ٱلْمُؤْمِنُونَ وَأَكْثَرُهُمُ ٱلْفَٰسِقُونَ',
		number_in_surah: '110',
		page: '64',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '404',
		number: '404',
		text: 'لَن يَضُرُّوكُمْ إِلَّآ أَذًۭى ۖ وَإِن يُقَٰتِلُوكُمْ يُوَلُّوكُمُ ٱلْأَدْبَارَ ثُمَّ لَا يُنصَرُونَ',
		number_in_surah: '111',
		page: '64',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '405',
		number: '405',
		text: 'ضُرِبَتْ عَلَيْهِمُ ٱلذِّلَّةُ أَيْنَ مَا ثُقِفُوٓا۟ إِلَّا بِحَبْلٍۢ مِّنَ ٱللَّهِ وَحَبْلٍۢ مِّنَ ٱلنَّاسِ وَبَآءُو بِغَضَبٍۢ مِّنَ ٱللَّهِ وَضُرِبَتْ عَلَيْهِمُ ٱلْمَسْكَنَةُ ۚ ذَٰلِكَ بِأَنَّهُمْ كَانُوا۟ يَكْفُرُونَ بِـَٔايَٰتِ ٱللَّهِ وَيَقْتُلُونَ ٱلْأَنۢبِيَآءَ بِغَيْرِ حَقٍّۢ ۚ ذَٰلِكَ بِمَا عَصَوا۟ وَّكَانُوا۟ يَعْتَدُونَ',
		number_in_surah: '112',
		page: '64',
		surah_id: '3',
		hizb_id: '25',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '406',
		number: '406',
		text: '۞ لَيْسُوا۟ سَوَآءًۭ ۗ مِّنْ أَهْلِ ٱلْكِتَٰبِ أُمَّةٌۭ قَآئِمَةٌۭ يَتْلُونَ ءَايَٰتِ ٱللَّهِ ءَانَآءَ ٱلَّيْلِ وَهُمْ يَسْجُدُونَ',
		number_in_surah: '113',
		page: '64',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '407',
		number: '407',
		text: 'يُؤْمِنُونَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَيَأْمُرُونَ بِٱلْمَعْرُوفِ وَيَنْهَوْنَ عَنِ ٱلْمُنكَرِ وَيُسَٰرِعُونَ فِى ٱلْخَيْرَٰتِ وَأُو۟لَٰٓئِكَ مِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '114',
		page: '64',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '408',
		number: '408',
		text: 'وَمَا يَفْعَلُوا۟ مِنْ خَيْرٍۢ فَلَن يُكْفَرُوهُ ۗ وَٱللَّهُ عَلِيمٌۢ بِٱلْمُتَّقِينَ',
		number_in_surah: '115',
		page: '64',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '409',
		number: '409',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ لَن تُغْنِىَ عَنْهُمْ أَمْوَٰلُهُمْ وَلَآ أَوْلَٰدُهُم مِّنَ ٱللَّهِ شَيْـًۭٔا ۖ وَأُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۚ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '116',
		page: '65',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '410',
		number: '410',
		text: 'مَثَلُ مَا يُنفِقُونَ فِى هَٰذِهِ ٱلْحَيَوٰةِ ٱلدُّنْيَا كَمَثَلِ رِيحٍۢ فِيهَا صِرٌّ أَصَابَتْ حَرْثَ قَوْمٍۢ ظَلَمُوٓا۟ أَنفُسَهُمْ فَأَهْلَكَتْهُ ۚ وَمَا ظَلَمَهُمُ ٱللَّهُ وَلَٰكِنْ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '117',
		page: '65',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '411',
		number: '411',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَتَّخِذُوا۟ بِطَانَةًۭ مِّن دُونِكُمْ لَا يَأْلُونَكُمْ خَبَالًۭا وَدُّوا۟ مَا عَنِتُّمْ قَدْ بَدَتِ ٱلْبَغْضَآءُ مِنْ أَفْوَٰهِهِمْ وَمَا تُخْفِى صُدُورُهُمْ أَكْبَرُ ۚ قَدْ بَيَّنَّا لَكُمُ ٱلْءَايَٰتِ ۖ إِن كُنتُمْ تَعْقِلُونَ',
		number_in_surah: '118',
		page: '65',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '412',
		number: '412',
		text: 'هَٰٓأَنتُمْ أُو۟لَآءِ تُحِبُّونَهُمْ وَلَا يُحِبُّونَكُمْ وَتُؤْمِنُونَ بِٱلْكِتَٰبِ كُلِّهِۦ وَإِذَا لَقُوكُمْ قَالُوٓا۟ ءَامَنَّا وَإِذَا خَلَوْا۟ عَضُّوا۟ عَلَيْكُمُ ٱلْأَنَامِلَ مِنَ ٱلْغَيْظِ ۚ قُلْ مُوتُوا۟ بِغَيْظِكُمْ ۗ إِنَّ ٱللَّهَ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '119',
		page: '65',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '413',
		number: '413',
		text: 'إِن تَمْسَسْكُمْ حَسَنَةٌۭ تَسُؤْهُمْ وَإِن تُصِبْكُمْ سَيِّئَةٌۭ يَفْرَحُوا۟ بِهَا ۖ وَإِن تَصْبِرُوا۟ وَتَتَّقُوا۟ لَا يَضُرُّكُمْ كَيْدُهُمْ شَيْـًٔا ۗ إِنَّ ٱللَّهَ بِمَا يَعْمَلُونَ مُحِيطٌۭ',
		number_in_surah: '120',
		page: '65',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '414',
		number: '414',
		text: 'وَإِذْ غَدَوْتَ مِنْ أَهْلِكَ تُبَوِّئُ ٱلْمُؤْمِنِينَ مَقَٰعِدَ لِلْقِتَالِ ۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌ',
		number_in_surah: '121',
		page: '65',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '415',
		number: '415',
		text: 'إِذْ هَمَّت طَّآئِفَتَانِ مِنكُمْ أَن تَفْشَلَا وَٱللَّهُ وَلِيُّهُمَا ۗ وَعَلَى ٱللَّهِ فَلْيَتَوَكَّلِ ٱلْمُؤْمِنُونَ',
		number_in_surah: '122',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '416',
		number: '416',
		text: 'وَلَقَدْ نَصَرَكُمُ ٱللَّهُ بِبَدْرٍۢ وَأَنتُمْ أَذِلَّةٌۭ ۖ فَٱتَّقُوا۟ ٱللَّهَ لَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '123',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '417',
		number: '417',
		text: 'إِذْ تَقُولُ لِلْمُؤْمِنِينَ أَلَن يَكْفِيَكُمْ أَن يُمِدَّكُمْ رَبُّكُم بِثَلَٰثَةِ ءَالَٰفٍۢ مِّنَ ٱلْمَلَٰٓئِكَةِ مُنزَلِينَ',
		number_in_surah: '124',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '418',
		number: '418',
		text: 'بَلَىٰٓ ۚ إِن تَصْبِرُوا۟ وَتَتَّقُوا۟ وَيَأْتُوكُم مِّن فَوْرِهِمْ هَٰذَا يُمْدِدْكُمْ رَبُّكُم بِخَمْسَةِ ءَالَٰفٍۢ مِّنَ ٱلْمَلَٰٓئِكَةِ مُسَوِّمِينَ',
		number_in_surah: '125',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '419',
		number: '419',
		text: 'وَمَا جَعَلَهُ ٱللَّهُ إِلَّا بُشْرَىٰ لَكُمْ وَلِتَطْمَئِنَّ قُلُوبُكُم بِهِۦ ۗ وَمَا ٱلنَّصْرُ إِلَّا مِنْ عِندِ ٱللَّهِ ٱلْعَزِيزِ ٱلْحَكِيمِ',
		number_in_surah: '126',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '420',
		number: '420',
		text: 'لِيَقْطَعَ طَرَفًۭا مِّنَ ٱلَّذِينَ كَفَرُوٓا۟ أَوْ يَكْبِتَهُمْ فَيَنقَلِبُوا۟ خَآئِبِينَ',
		number_in_surah: '127',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '421',
		number: '421',
		text: 'لَيْسَ لَكَ مِنَ ٱلْأَمْرِ شَىْءٌ أَوْ يَتُوبَ عَلَيْهِمْ أَوْ يُعَذِّبَهُمْ فَإِنَّهُمْ ظَٰلِمُونَ',
		number_in_surah: '128',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '422',
		number: '422',
		text: 'وَلِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۚ يَغْفِرُ لِمَن يَشَآءُ وَيُعَذِّبُ مَن يَشَآءُ ۚ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '129',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '423',
		number: '423',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَأْكُلُوا۟ ٱلرِّبَوٰٓا۟ أَضْعَٰفًۭا مُّضَٰعَفَةًۭ ۖ وَٱتَّقُوا۟ ٱللَّهَ لَعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '130',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '424',
		number: '424',
		text: 'وَٱتَّقُوا۟ ٱلنَّارَ ٱلَّتِىٓ أُعِدَّتْ لِلْكَٰفِرِينَ',
		number_in_surah: '131',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '425',
		number: '425',
		text: 'وَأَطِيعُوا۟ ٱللَّهَ وَٱلرَّسُولَ لَعَلَّكُمْ تُرْحَمُونَ',
		number_in_surah: '132',
		page: '66',
		surah_id: '3',
		hizb_id: '26',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '426',
		number: '426',
		text: '۞ وَسَارِعُوٓا۟ إِلَىٰ مَغْفِرَةٍۢ مِّن رَّبِّكُمْ وَجَنَّةٍ عَرْضُهَا ٱلسَّمَٰوَٰتُ وَٱلْأَرْضُ أُعِدَّتْ لِلْمُتَّقِينَ',
		number_in_surah: '133',
		page: '67',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '427',
		number: '427',
		text: 'ٱلَّذِينَ يُنفِقُونَ فِى ٱلسَّرَّآءِ وَٱلضَّرَّآءِ وَٱلْكَٰظِمِينَ ٱلْغَيْظَ وَٱلْعَافِينَ عَنِ ٱلنَّاسِ ۗ وَٱللَّهُ يُحِبُّ ٱلْمُحْسِنِينَ',
		number_in_surah: '134',
		page: '67',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '428',
		number: '428',
		text: 'وَٱلَّذِينَ إِذَا فَعَلُوا۟ فَٰحِشَةً أَوْ ظَلَمُوٓا۟ أَنفُسَهُمْ ذَكَرُوا۟ ٱللَّهَ فَٱسْتَغْفَرُوا۟ لِذُنُوبِهِمْ وَمَن يَغْفِرُ ٱلذُّنُوبَ إِلَّا ٱللَّهُ وَلَمْ يُصِرُّوا۟ عَلَىٰ مَا فَعَلُوا۟ وَهُمْ يَعْلَمُونَ',
		number_in_surah: '135',
		page: '67',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '429',
		number: '429',
		text: 'أُو۟لَٰٓئِكَ جَزَآؤُهُم مَّغْفِرَةٌۭ مِّن رَّبِّهِمْ وَجَنَّٰتٌۭ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا ۚ وَنِعْمَ أَجْرُ ٱلْعَٰمِلِينَ',
		number_in_surah: '136',
		page: '67',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '430',
		number: '430',
		text: 'قَدْ خَلَتْ مِن قَبْلِكُمْ سُنَنٌۭ فَسِيرُوا۟ فِى ٱلْأَرْضِ فَٱنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُكَذِّبِينَ',
		number_in_surah: '137',
		page: '67',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '431',
		number: '431',
		text: 'هَٰذَا بَيَانٌۭ لِّلنَّاسِ وَهُدًۭى وَمَوْعِظَةٌۭ لِّلْمُتَّقِينَ',
		number_in_surah: '138',
		page: '67',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '432',
		number: '432',
		text: 'وَلَا تَهِنُوا۟ وَلَا تَحْزَنُوا۟ وَأَنتُمُ ٱلْأَعْلَوْنَ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '139',
		page: '67',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '433',
		number: '433',
		text: 'إِن يَمْسَسْكُمْ قَرْحٌۭ فَقَدْ مَسَّ ٱلْقَوْمَ قَرْحٌۭ مِّثْلُهُۥ ۚ وَتِلْكَ ٱلْأَيَّامُ نُدَاوِلُهَا بَيْنَ ٱلنَّاسِ وَلِيَعْلَمَ ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ وَيَتَّخِذَ مِنكُمْ شُهَدَآءَ ۗ وَٱللَّهُ لَا يُحِبُّ ٱلظَّٰلِمِينَ',
		number_in_surah: '140',
		page: '67',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '434',
		number: '434',
		text: 'وَلِيُمَحِّصَ ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ وَيَمْحَقَ ٱلْكَٰفِرِينَ',
		number_in_surah: '141',
		page: '68',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '435',
		number: '435',
		text: 'أَمْ حَسِبْتُمْ أَن تَدْخُلُوا۟ ٱلْجَنَّةَ وَلَمَّا يَعْلَمِ ٱللَّهُ ٱلَّذِينَ جَٰهَدُوا۟ مِنكُمْ وَيَعْلَمَ ٱلصَّٰبِرِينَ',
		number_in_surah: '142',
		page: '68',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '436',
		number: '436',
		text: 'وَلَقَدْ كُنتُمْ تَمَنَّوْنَ ٱلْمَوْتَ مِن قَبْلِ أَن تَلْقَوْهُ فَقَدْ رَأَيْتُمُوهُ وَأَنتُمْ تَنظُرُونَ',
		number_in_surah: '143',
		page: '68',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '437',
		number: '437',
		text: 'وَمَا مُحَمَّدٌ إِلَّا رَسُولٌۭ قَدْ خَلَتْ مِن قَبْلِهِ ٱلرُّسُلُ ۚ أَفَإِي۟ن مَّاتَ أَوْ قُتِلَ ٱنقَلَبْتُمْ عَلَىٰٓ أَعْقَٰبِكُمْ ۚ وَمَن يَنقَلِبْ عَلَىٰ عَقِبَيْهِ فَلَن يَضُرَّ ٱللَّهَ شَيْـًۭٔا ۗ وَسَيَجْزِى ٱللَّهُ ٱلشَّٰكِرِينَ',
		number_in_surah: '144',
		page: '68',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '438',
		number: '438',
		text: 'وَمَا كَانَ لِنَفْسٍ أَن تَمُوتَ إِلَّا بِإِذْنِ ٱللَّهِ كِتَٰبًۭا مُّؤَجَّلًۭا ۗ وَمَن يُرِدْ ثَوَابَ ٱلدُّنْيَا نُؤْتِهِۦ مِنْهَا وَمَن يُرِدْ ثَوَابَ ٱلْءَاخِرَةِ نُؤْتِهِۦ مِنْهَا ۚ وَسَنَجْزِى ٱلشَّٰكِرِينَ',
		number_in_surah: '145',
		page: '68',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '439',
		number: '439',
		text: 'وَكَأَيِّن مِّن نَّبِىٍّۢ قَٰتَلَ مَعَهُۥ رِبِّيُّونَ كَثِيرٌۭ فَمَا وَهَنُوا۟ لِمَآ أَصَابَهُمْ فِى سَبِيلِ ٱللَّهِ وَمَا ضَعُفُوا۟ وَمَا ٱسْتَكَانُوا۟ ۗ وَٱللَّهُ يُحِبُّ ٱلصَّٰبِرِينَ',
		number_in_surah: '146',
		page: '68',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '440',
		number: '440',
		text: 'وَمَا كَانَ قَوْلَهُمْ إِلَّآ أَن قَالُوا۟ رَبَّنَا ٱغْفِرْ لَنَا ذُنُوبَنَا وَإِسْرَافَنَا فِىٓ أَمْرِنَا وَثَبِّتْ أَقْدَامَنَا وَٱنصُرْنَا عَلَى ٱلْقَوْمِ ٱلْكَٰفِرِينَ',
		number_in_surah: '147',
		page: '68',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '441',
		number: '441',
		text: 'فَـَٔاتَىٰهُمُ ٱللَّهُ ثَوَابَ ٱلدُّنْيَا وَحُسْنَ ثَوَابِ ٱلْءَاخِرَةِ ۗ وَٱللَّهُ يُحِبُّ ٱلْمُحْسِنِينَ',
		number_in_surah: '148',
		page: '68',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '442',
		number: '442',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِن تُطِيعُوا۟ ٱلَّذِينَ كَفَرُوا۟ يَرُدُّوكُمْ عَلَىٰٓ أَعْقَٰبِكُمْ فَتَنقَلِبُوا۟ خَٰسِرِينَ',
		number_in_surah: '149',
		page: '69',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '443',
		number: '443',
		text: 'بَلِ ٱللَّهُ مَوْلَىٰكُمْ ۖ وَهُوَ خَيْرُ ٱلنَّٰصِرِينَ',
		number_in_surah: '150',
		page: '69',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '444',
		number: '444',
		text: 'سَنُلْقِى فِى قُلُوبِ ٱلَّذِينَ كَفَرُوا۟ ٱلرُّعْبَ بِمَآ أَشْرَكُوا۟ بِٱللَّهِ مَا لَمْ يُنَزِّلْ بِهِۦ سُلْطَٰنًۭا ۖ وَمَأْوَىٰهُمُ ٱلنَّارُ ۚ وَبِئْسَ مَثْوَى ٱلظَّٰلِمِينَ',
		number_in_surah: '151',
		page: '69',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '445',
		number: '445',
		text: 'وَلَقَدْ صَدَقَكُمُ ٱللَّهُ وَعْدَهُۥٓ إِذْ تَحُسُّونَهُم بِإِذْنِهِۦ ۖ حَتَّىٰٓ إِذَا فَشِلْتُمْ وَتَنَٰزَعْتُمْ فِى ٱلْأَمْرِ وَعَصَيْتُم مِّنۢ بَعْدِ مَآ أَرَىٰكُم مَّا تُحِبُّونَ ۚ مِنكُم مَّن يُرِيدُ ٱلدُّنْيَا وَمِنكُم مَّن يُرِيدُ ٱلْءَاخِرَةَ ۚ ثُمَّ صَرَفَكُمْ عَنْهُمْ لِيَبْتَلِيَكُمْ ۖ وَلَقَدْ عَفَا عَنكُمْ ۗ وَٱللَّهُ ذُو فَضْلٍ عَلَى ٱلْمُؤْمِنِينَ',
		number_in_surah: '152',
		page: '69',
		surah_id: '3',
		hizb_id: '27',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '446',
		number: '446',
		text: '۞ إِذْ تُصْعِدُونَ وَلَا تَلْوُۥنَ عَلَىٰٓ أَحَدٍۢ وَٱلرَّسُولُ يَدْعُوكُمْ فِىٓ أُخْرَىٰكُمْ فَأَثَٰبَكُمْ غَمًّۢا بِغَمٍّۢ لِّكَيْلَا تَحْزَنُوا۟ عَلَىٰ مَا فَاتَكُمْ وَلَا مَآ أَصَٰبَكُمْ ۗ وَٱللَّهُ خَبِيرٌۢ بِمَا تَعْمَلُونَ',
		number_in_surah: '153',
		page: '69',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '447',
		number: '447',
		text: 'ثُمَّ أَنزَلَ عَلَيْكُم مِّنۢ بَعْدِ ٱلْغَمِّ أَمَنَةًۭ نُّعَاسًۭا يَغْشَىٰ طَآئِفَةًۭ مِّنكُمْ ۖ وَطَآئِفَةٌۭ قَدْ أَهَمَّتْهُمْ أَنفُسُهُمْ يَظُنُّونَ بِٱللَّهِ غَيْرَ ٱلْحَقِّ ظَنَّ ٱلْجَٰهِلِيَّةِ ۖ يَقُولُونَ هَل لَّنَا مِنَ ٱلْأَمْرِ مِن شَىْءٍۢ ۗ قُلْ إِنَّ ٱلْأَمْرَ كُلَّهُۥ لِلَّهِ ۗ يُخْفُونَ فِىٓ أَنفُسِهِم مَّا لَا يُبْدُونَ لَكَ ۖ يَقُولُونَ لَوْ كَانَ لَنَا مِنَ ٱلْأَمْرِ شَىْءٌۭ مَّا قُتِلْنَا هَٰهُنَا ۗ قُل لَّوْ كُنتُمْ فِى بُيُوتِكُمْ لَبَرَزَ ٱلَّذِينَ كُتِبَ عَلَيْهِمُ ٱلْقَتْلُ إِلَىٰ مَضَاجِعِهِمْ ۖ وَلِيَبْتَلِىَ ٱللَّهُ مَا فِى صُدُورِكُمْ وَلِيُمَحِّصَ مَا فِى قُلُوبِكُمْ ۗ وَٱللَّهُ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '154',
		page: '70',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '448',
		number: '448',
		text: 'إِنَّ ٱلَّذِينَ تَوَلَّوْا۟ مِنكُمْ يَوْمَ ٱلْتَقَى ٱلْجَمْعَانِ إِنَّمَا ٱسْتَزَلَّهُمُ ٱلشَّيْطَٰنُ بِبَعْضِ مَا كَسَبُوا۟ ۖ وَلَقَدْ عَفَا ٱللَّهُ عَنْهُمْ ۗ إِنَّ ٱللَّهَ غَفُورٌ حَلِيمٌۭ',
		number_in_surah: '155',
		page: '70',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '449',
		number: '449',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَكُونُوا۟ كَٱلَّذِينَ كَفَرُوا۟ وَقَالُوا۟ لِإِخْوَٰنِهِمْ إِذَا ضَرَبُوا۟ فِى ٱلْأَرْضِ أَوْ كَانُوا۟ غُزًّۭى لَّوْ كَانُوا۟ عِندَنَا مَا مَاتُوا۟ وَمَا قُتِلُوا۟ لِيَجْعَلَ ٱللَّهُ ذَٰلِكَ حَسْرَةًۭ فِى قُلُوبِهِمْ ۗ وَٱللَّهُ يُحْىِۦ وَيُمِيتُ ۗ وَٱللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '156',
		page: '70',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '450',
		number: '450',
		text: 'وَلَئِن قُتِلْتُمْ فِى سَبِيلِ ٱللَّهِ أَوْ مُتُّمْ لَمَغْفِرَةٌۭ مِّنَ ٱللَّهِ وَرَحْمَةٌ خَيْرٌۭ مِّمَّا يَجْمَعُونَ',
		number_in_surah: '157',
		page: '70',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '451',
		number: '451',
		text: 'وَلَئِن مُّتُّمْ أَوْ قُتِلْتُمْ لَإِلَى ٱللَّهِ تُحْشَرُونَ',
		number_in_surah: '158',
		page: '71',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '452',
		number: '452',
		text: 'فَبِمَا رَحْمَةٍۢ مِّنَ ٱللَّهِ لِنتَ لَهُمْ ۖ وَلَوْ كُنتَ فَظًّا غَلِيظَ ٱلْقَلْبِ لَٱنفَضُّوا۟ مِنْ حَوْلِكَ ۖ فَٱعْفُ عَنْهُمْ وَٱسْتَغْفِرْ لَهُمْ وَشَاوِرْهُمْ فِى ٱلْأَمْرِ ۖ فَإِذَا عَزَمْتَ فَتَوَكَّلْ عَلَى ٱللَّهِ ۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلْمُتَوَكِّلِينَ',
		number_in_surah: '159',
		page: '71',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '453',
		number: '453',
		text: 'إِن يَنصُرْكُمُ ٱللَّهُ فَلَا غَالِبَ لَكُمْ ۖ وَإِن يَخْذُلْكُمْ فَمَن ذَا ٱلَّذِى يَنصُرُكُم مِّنۢ بَعْدِهِۦ ۗ وَعَلَى ٱللَّهِ فَلْيَتَوَكَّلِ ٱلْمُؤْمِنُونَ',
		number_in_surah: '160',
		page: '71',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '454',
		number: '454',
		text: 'وَمَا كَانَ لِنَبِىٍّ أَن يَغُلَّ ۚ وَمَن يَغْلُلْ يَأْتِ بِمَا غَلَّ يَوْمَ ٱلْقِيَٰمَةِ ۚ ثُمَّ تُوَفَّىٰ كُلُّ نَفْسٍۢ مَّا كَسَبَتْ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '161',
		page: '71',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '455',
		number: '455',
		text: 'أَفَمَنِ ٱتَّبَعَ رِضْوَٰنَ ٱللَّهِ كَمَنۢ بَآءَ بِسَخَطٍۢ مِّنَ ٱللَّهِ وَمَأْوَىٰهُ جَهَنَّمُ ۚ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '162',
		page: '71',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '456',
		number: '456',
		text: 'هُمْ دَرَجَٰتٌ عِندَ ٱللَّهِ ۗ وَٱللَّهُ بَصِيرٌۢ بِمَا يَعْمَلُونَ',
		number_in_surah: '163',
		page: '71',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '457',
		number: '457',
		text: 'لَقَدْ مَنَّ ٱللَّهُ عَلَى ٱلْمُؤْمِنِينَ إِذْ بَعَثَ فِيهِمْ رَسُولًۭا مِّنْ أَنفُسِهِمْ يَتْلُوا۟ عَلَيْهِمْ ءَايَٰتِهِۦ وَيُزَكِّيهِمْ وَيُعَلِّمُهُمُ ٱلْكِتَٰبَ وَٱلْحِكْمَةَ وَإِن كَانُوا۟ مِن قَبْلُ لَفِى ضَلَٰلٍۢ مُّبِينٍ',
		number_in_surah: '164',
		page: '71',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '458',
		number: '458',
		text: 'أَوَلَمَّآ أَصَٰبَتْكُم مُّصِيبَةٌۭ قَدْ أَصَبْتُم مِّثْلَيْهَا قُلْتُمْ أَنَّىٰ هَٰذَا ۖ قُلْ هُوَ مِنْ عِندِ أَنفُسِكُمْ ۗ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '165',
		page: '71',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '459',
		number: '459',
		text: 'وَمَآ أَصَٰبَكُمْ يَوْمَ ٱلْتَقَى ٱلْجَمْعَانِ فَبِإِذْنِ ٱللَّهِ وَلِيَعْلَمَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '166',
		page: '72',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '460',
		number: '460',
		text: 'وَلِيَعْلَمَ ٱلَّذِينَ نَافَقُوا۟ ۚ وَقِيلَ لَهُمْ تَعَالَوْا۟ قَٰتِلُوا۟ فِى سَبِيلِ ٱللَّهِ أَوِ ٱدْفَعُوا۟ ۖ قَالُوا۟ لَوْ نَعْلَمُ قِتَالًۭا لَّٱتَّبَعْنَٰكُمْ ۗ هُمْ لِلْكُفْرِ يَوْمَئِذٍ أَقْرَبُ مِنْهُمْ لِلْإِيمَٰنِ ۚ يَقُولُونَ بِأَفْوَٰهِهِم مَّا لَيْسَ فِى قُلُوبِهِمْ ۗ وَٱللَّهُ أَعْلَمُ بِمَا يَكْتُمُونَ',
		number_in_surah: '167',
		page: '72',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '461',
		number: '461',
		text: 'ٱلَّذِينَ قَالُوا۟ لِإِخْوَٰنِهِمْ وَقَعَدُوا۟ لَوْ أَطَاعُونَا مَا قُتِلُوا۟ ۗ قُلْ فَٱدْرَءُوا۟ عَنْ أَنفُسِكُمُ ٱلْمَوْتَ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '168',
		page: '72',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '462',
		number: '462',
		text: 'وَلَا تَحْسَبَنَّ ٱلَّذِينَ قُتِلُوا۟ فِى سَبِيلِ ٱللَّهِ أَمْوَٰتًۢا ۚ بَلْ أَحْيَآءٌ عِندَ رَبِّهِمْ يُرْزَقُونَ',
		number_in_surah: '169',
		page: '72',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '463',
		number: '463',
		text: 'فَرِحِينَ بِمَآ ءَاتَىٰهُمُ ٱللَّهُ مِن فَضْلِهِۦ وَيَسْتَبْشِرُونَ بِٱلَّذِينَ لَمْ يَلْحَقُوا۟ بِهِم مِّنْ خَلْفِهِمْ أَلَّا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '170',
		page: '72',
		surah_id: '3',
		hizb_id: '28',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '464',
		number: '464',
		text: '۞ يَسْتَبْشِرُونَ بِنِعْمَةٍۢ مِّنَ ٱللَّهِ وَفَضْلٍۢ وَأَنَّ ٱللَّهَ لَا يُضِيعُ أَجْرَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '171',
		page: '72',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '465',
		number: '465',
		text: 'ٱلَّذِينَ ٱسْتَجَابُوا۟ لِلَّهِ وَٱلرَّسُولِ مِنۢ بَعْدِ مَآ أَصَابَهُمُ ٱلْقَرْحُ ۚ لِلَّذِينَ أَحْسَنُوا۟ مِنْهُمْ وَٱتَّقَوْا۟ أَجْرٌ عَظِيمٌ',
		number_in_surah: '172',
		page: '72',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '466',
		number: '466',
		text: 'ٱلَّذِينَ قَالَ لَهُمُ ٱلنَّاسُ إِنَّ ٱلنَّاسَ قَدْ جَمَعُوا۟ لَكُمْ فَٱخْشَوْهُمْ فَزَادَهُمْ إِيمَٰنًۭا وَقَالُوا۟ حَسْبُنَا ٱللَّهُ وَنِعْمَ ٱلْوَكِيلُ',
		number_in_surah: '173',
		page: '72',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '467',
		number: '467',
		text: 'فَٱنقَلَبُوا۟ بِنِعْمَةٍۢ مِّنَ ٱللَّهِ وَفَضْلٍۢ لَّمْ يَمْسَسْهُمْ سُوٓءٌۭ وَٱتَّبَعُوا۟ رِضْوَٰنَ ٱللَّهِ ۗ وَٱللَّهُ ذُو فَضْلٍ عَظِيمٍ',
		number_in_surah: '174',
		page: '73',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '468',
		number: '468',
		text: 'إِنَّمَا ذَٰلِكُمُ ٱلشَّيْطَٰنُ يُخَوِّفُ أَوْلِيَآءَهُۥ فَلَا تَخَافُوهُمْ وَخَافُونِ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '175',
		page: '73',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '469',
		number: '469',
		text: 'وَلَا يَحْزُنكَ ٱلَّذِينَ يُسَٰرِعُونَ فِى ٱلْكُفْرِ ۚ إِنَّهُمْ لَن يَضُرُّوا۟ ٱللَّهَ شَيْـًۭٔا ۗ يُرِيدُ ٱللَّهُ أَلَّا يَجْعَلَ لَهُمْ حَظًّۭا فِى ٱلْءَاخِرَةِ ۖ وَلَهُمْ عَذَابٌ عَظِيمٌ',
		number_in_surah: '176',
		page: '73',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '470',
		number: '470',
		text: 'إِنَّ ٱلَّذِينَ ٱشْتَرَوُا۟ ٱلْكُفْرَ بِٱلْإِيمَٰنِ لَن يَضُرُّوا۟ ٱللَّهَ شَيْـًۭٔا وَلَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '177',
		page: '73',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '471',
		number: '471',
		text: 'وَلَا يَحْسَبَنَّ ٱلَّذِينَ كَفَرُوٓا۟ أَنَّمَا نُمْلِى لَهُمْ خَيْرٌۭ لِّأَنفُسِهِمْ ۚ إِنَّمَا نُمْلِى لَهُمْ لِيَزْدَادُوٓا۟ إِثْمًۭا ۚ وَلَهُمْ عَذَابٌۭ مُّهِينٌۭ',
		number_in_surah: '178',
		page: '73',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '472',
		number: '472',
		text: 'مَّا كَانَ ٱللَّهُ لِيَذَرَ ٱلْمُؤْمِنِينَ عَلَىٰ مَآ أَنتُمْ عَلَيْهِ حَتَّىٰ يَمِيزَ ٱلْخَبِيثَ مِنَ ٱلطَّيِّبِ ۗ وَمَا كَانَ ٱللَّهُ لِيُطْلِعَكُمْ عَلَى ٱلْغَيْبِ وَلَٰكِنَّ ٱللَّهَ يَجْتَبِى مِن رُّسُلِهِۦ مَن يَشَآءُ ۖ فَـَٔامِنُوا۟ بِٱللَّهِ وَرُسُلِهِۦ ۚ وَإِن تُؤْمِنُوا۟ وَتَتَّقُوا۟ فَلَكُمْ أَجْرٌ عَظِيمٌۭ',
		number_in_surah: '179',
		page: '73',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '473',
		number: '473',
		text: 'وَلَا يَحْسَبَنَّ ٱلَّذِينَ يَبْخَلُونَ بِمَآ ءَاتَىٰهُمُ ٱللَّهُ مِن فَضْلِهِۦ هُوَ خَيْرًۭا لَّهُم ۖ بَلْ هُوَ شَرٌّۭ لَّهُمْ ۖ سَيُطَوَّقُونَ مَا بَخِلُوا۟ بِهِۦ يَوْمَ ٱلْقِيَٰمَةِ ۗ وَلِلَّهِ مِيرَٰثُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۗ وَٱللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '180',
		page: '73',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '474',
		number: '474',
		text: 'لَّقَدْ سَمِعَ ٱللَّهُ قَوْلَ ٱلَّذِينَ قَالُوٓا۟ إِنَّ ٱللَّهَ فَقِيرٌۭ وَنَحْنُ أَغْنِيَآءُ ۘ سَنَكْتُبُ مَا قَالُوا۟ وَقَتْلَهُمُ ٱلْأَنۢبِيَآءَ بِغَيْرِ حَقٍّۢ وَنَقُولُ ذُوقُوا۟ عَذَابَ ٱلْحَرِيقِ',
		number_in_surah: '181',
		page: '74',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '475',
		number: '475',
		text: 'ذَٰلِكَ بِمَا قَدَّمَتْ أَيْدِيكُمْ وَأَنَّ ٱللَّهَ لَيْسَ بِظَلَّامٍۢ لِّلْعَبِيدِ',
		number_in_surah: '182',
		page: '74',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '476',
		number: '476',
		text: 'ٱلَّذِينَ قَالُوٓا۟ إِنَّ ٱللَّهَ عَهِدَ إِلَيْنَآ أَلَّا نُؤْمِنَ لِرَسُولٍ حَتَّىٰ يَأْتِيَنَا بِقُرْبَانٍۢ تَأْكُلُهُ ٱلنَّارُ ۗ قُلْ قَدْ جَآءَكُمْ رُسُلٌۭ مِّن قَبْلِى بِٱلْبَيِّنَٰتِ وَبِٱلَّذِى قُلْتُمْ فَلِمَ قَتَلْتُمُوهُمْ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '183',
		page: '74',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '477',
		number: '477',
		text: 'فَإِن كَذَّبُوكَ فَقَدْ كُذِّبَ رُسُلٌۭ مِّن قَبْلِكَ جَآءُو بِٱلْبَيِّنَٰتِ وَٱلزُّبُرِ وَٱلْكِتَٰبِ ٱلْمُنِيرِ',
		number_in_surah: '184',
		page: '74',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '478',
		number: '478',
		text: 'كُلُّ نَفْسٍۢ ذَآئِقَةُ ٱلْمَوْتِ ۗ وَإِنَّمَا تُوَفَّوْنَ أُجُورَكُمْ يَوْمَ ٱلْقِيَٰمَةِ ۖ فَمَن زُحْزِحَ عَنِ ٱلنَّارِ وَأُدْخِلَ ٱلْجَنَّةَ فَقَدْ فَازَ ۗ وَمَا ٱلْحَيَوٰةُ ٱلدُّنْيَآ إِلَّا مَتَٰعُ ٱلْغُرُورِ',
		number_in_surah: '185',
		page: '74',
		surah_id: '3',
		hizb_id: '29',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '479',
		number: '479',
		text: '۞ لَتُبْلَوُنَّ فِىٓ أَمْوَٰلِكُمْ وَأَنفُسِكُمْ وَلَتَسْمَعُنَّ مِنَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ مِن قَبْلِكُمْ وَمِنَ ٱلَّذِينَ أَشْرَكُوٓا۟ أَذًۭى كَثِيرًۭا ۚ وَإِن تَصْبِرُوا۟ وَتَتَّقُوا۟ فَإِنَّ ذَٰلِكَ مِنْ عَزْمِ ٱلْأُمُورِ',
		number_in_surah: '186',
		page: '74',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '480',
		number: '480',
		text: 'وَإِذْ أَخَذَ ٱللَّهُ مِيثَٰقَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ لَتُبَيِّنُنَّهُۥ لِلنَّاسِ وَلَا تَكْتُمُونَهُۥ فَنَبَذُوهُ وَرَآءَ ظُهُورِهِمْ وَٱشْتَرَوْا۟ بِهِۦ ثَمَنًۭا قَلِيلًۭا ۖ فَبِئْسَ مَا يَشْتَرُونَ',
		number_in_surah: '187',
		page: '75',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '481',
		number: '481',
		text: 'لَا تَحْسَبَنَّ ٱلَّذِينَ يَفْرَحُونَ بِمَآ أَتَوا۟ وَّيُحِبُّونَ أَن يُحْمَدُوا۟ بِمَا لَمْ يَفْعَلُوا۟ فَلَا تَحْسَبَنَّهُم بِمَفَازَةٍۢ مِّنَ ٱلْعَذَابِ ۖ وَلَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '188',
		page: '75',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '482',
		number: '482',
		text: 'وَلِلَّهِ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۗ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '189',
		page: '75',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '483',
		number: '483',
		text: 'إِنَّ فِى خَلْقِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَٱخْتِلَٰفِ ٱلَّيْلِ وَٱلنَّهَارِ لَءَايَٰتٍۢ لِّأُو۟لِى ٱلْأَلْبَٰبِ',
		number_in_surah: '190',
		page: '75',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '484',
		number: '484',
		text: 'ٱلَّذِينَ يَذْكُرُونَ ٱللَّهَ قِيَٰمًۭا وَقُعُودًۭا وَعَلَىٰ جُنُوبِهِمْ وَيَتَفَكَّرُونَ فِى خَلْقِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ رَبَّنَا مَا خَلَقْتَ هَٰذَا بَٰطِلًۭا سُبْحَٰنَكَ فَقِنَا عَذَابَ ٱلنَّارِ',
		number_in_surah: '191',
		page: '75',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '485',
		number: '485',
		text: 'رَبَّنَآ إِنَّكَ مَن تُدْخِلِ ٱلنَّارَ فَقَدْ أَخْزَيْتَهُۥ ۖ وَمَا لِلظَّٰلِمِينَ مِنْ أَنصَارٍۢ',
		number_in_surah: '192',
		page: '75',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '486',
		number: '486',
		text: 'رَّبَّنَآ إِنَّنَا سَمِعْنَا مُنَادِيًۭا يُنَادِى لِلْإِيمَٰنِ أَنْ ءَامِنُوا۟ بِرَبِّكُمْ فَـَٔامَنَّا ۚ رَبَّنَا فَٱغْفِرْ لَنَا ذُنُوبَنَا وَكَفِّرْ عَنَّا سَيِّـَٔاتِنَا وَتَوَفَّنَا مَعَ ٱلْأَبْرَارِ',
		number_in_surah: '193',
		page: '75',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '487',
		number: '487',
		text: 'رَبَّنَا وَءَاتِنَا مَا وَعَدتَّنَا عَلَىٰ رُسُلِكَ وَلَا تُخْزِنَا يَوْمَ ٱلْقِيَٰمَةِ ۗ إِنَّكَ لَا تُخْلِفُ ٱلْمِيعَادَ',
		number_in_surah: '194',
		page: '75',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '488',
		number: '488',
		text: 'فَٱسْتَجَابَ لَهُمْ رَبُّهُمْ أَنِّى لَآ أُضِيعُ عَمَلَ عَٰمِلٍۢ مِّنكُم مِّن ذَكَرٍ أَوْ أُنثَىٰ ۖ بَعْضُكُم مِّنۢ بَعْضٍۢ ۖ فَٱلَّذِينَ هَاجَرُوا۟ وَأُخْرِجُوا۟ مِن دِيَٰرِهِمْ وَأُوذُوا۟ فِى سَبِيلِى وَقَٰتَلُوا۟ وَقُتِلُوا۟ لَأُكَفِّرَنَّ عَنْهُمْ سَيِّـَٔاتِهِمْ وَلَأُدْخِلَنَّهُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ثَوَابًۭا مِّنْ عِندِ ٱللَّهِ ۗ وَٱللَّهُ عِندَهُۥ حُسْنُ ٱلثَّوَابِ',
		number_in_surah: '195',
		page: '76',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '489',
		number: '489',
		text: 'لَا يَغُرَّنَّكَ تَقَلُّبُ ٱلَّذِينَ كَفَرُوا۟ فِى ٱلْبِلَٰدِ',
		number_in_surah: '196',
		page: '76',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '490',
		number: '490',
		text: 'مَتَٰعٌۭ قَلِيلٌۭ ثُمَّ مَأْوَىٰهُمْ جَهَنَّمُ ۚ وَبِئْسَ ٱلْمِهَادُ',
		number_in_surah: '197',
		page: '76',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '491',
		number: '491',
		text: 'لَٰكِنِ ٱلَّذِينَ ٱتَّقَوْا۟ رَبَّهُمْ لَهُمْ جَنَّٰتٌۭ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا نُزُلًۭا مِّنْ عِندِ ٱللَّهِ ۗ وَمَا عِندَ ٱللَّهِ خَيْرٌۭ لِّلْأَبْرَارِ',
		number_in_surah: '198',
		page: '76',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '492',
		number: '492',
		text: 'وَإِنَّ مِنْ أَهْلِ ٱلْكِتَٰبِ لَمَن يُؤْمِنُ بِٱللَّهِ وَمَآ أُنزِلَ إِلَيْكُمْ وَمَآ أُنزِلَ إِلَيْهِمْ خَٰشِعِينَ لِلَّهِ لَا يَشْتَرُونَ بِـَٔايَٰتِ ٱللَّهِ ثَمَنًۭا قَلِيلًا ۗ أُو۟لَٰٓئِكَ لَهُمْ أَجْرُهُمْ عِندَ رَبِّهِمْ ۗ إِنَّ ٱللَّهَ سَرِيعُ ٱلْحِسَابِ',
		number_in_surah: '199',
		page: '76',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '493',
		number: '493',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱصْبِرُوا۟ وَصَابِرُوا۟ وَرَابِطُوا۟ وَٱتَّقُوا۟ ٱللَّهَ لَعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '200',
		page: '76',
		surah_id: '3',
		hizb_id: '30',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '494',
		number: '494',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلنَّاسُ ٱتَّقُوا۟ رَبَّكُمُ ٱلَّذِى خَلَقَكُم مِّن نَّفْسٍۢ وَٰحِدَةٍۢ وَخَلَقَ مِنْهَا زَوْجَهَا وَبَثَّ مِنْهُمَا رِجَالًۭا كَثِيرًۭا وَنِسَآءًۭ ۚ وَٱتَّقُوا۟ ٱللَّهَ ٱلَّذِى تَسَآءَلُونَ بِهِۦ وَٱلْأَرْحَامَ ۚ إِنَّ ٱللَّهَ كَانَ عَلَيْكُمْ رَقِيبًۭا',
		number_in_surah: '1',
		page: '77',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '495',
		number: '495',
		text: 'وَءَاتُوا۟ ٱلْيَتَٰمَىٰٓ أَمْوَٰلَهُمْ ۖ وَلَا تَتَبَدَّلُوا۟ ٱلْخَبِيثَ بِٱلطَّيِّبِ ۖ وَلَا تَأْكُلُوٓا۟ أَمْوَٰلَهُمْ إِلَىٰٓ أَمْوَٰلِكُمْ ۚ إِنَّهُۥ كَانَ حُوبًۭا كَبِيرًۭا',
		number_in_surah: '2',
		page: '77',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '496',
		number: '496',
		text: 'وَإِنْ خِفْتُمْ أَلَّا تُقْسِطُوا۟ فِى ٱلْيَتَٰمَىٰ فَٱنكِحُوا۟ مَا طَابَ لَكُم مِّنَ ٱلنِّسَآءِ مَثْنَىٰ وَثُلَٰثَ وَرُبَٰعَ ۖ فَإِنْ خِفْتُمْ أَلَّا تَعْدِلُوا۟ فَوَٰحِدَةً أَوْ مَا مَلَكَتْ أَيْمَٰنُكُمْ ۚ ذَٰلِكَ أَدْنَىٰٓ أَلَّا تَعُولُوا۟',
		number_in_surah: '3',
		page: '77',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '497',
		number: '497',
		text: 'وَءَاتُوا۟ ٱلنِّسَآءَ صَدُقَٰتِهِنَّ نِحْلَةًۭ ۚ فَإِن طِبْنَ لَكُمْ عَن شَىْءٍۢ مِّنْهُ نَفْسًۭا فَكُلُوهُ هَنِيٓـًۭٔا مَّرِيٓـًۭٔا',
		number_in_surah: '4',
		page: '77',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '498',
		number: '498',
		text: 'وَلَا تُؤْتُوا۟ ٱلسُّفَهَآءَ أَمْوَٰلَكُمُ ٱلَّتِى جَعَلَ ٱللَّهُ لَكُمْ قِيَٰمًۭا وَٱرْزُقُوهُمْ فِيهَا وَٱكْسُوهُمْ وَقُولُوا۟ لَهُمْ قَوْلًۭا مَّعْرُوفًۭا',
		number_in_surah: '5',
		page: '77',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '499',
		number: '499',
		text: 'وَٱبْتَلُوا۟ ٱلْيَتَٰمَىٰ حَتَّىٰٓ إِذَا بَلَغُوا۟ ٱلنِّكَاحَ فَإِنْ ءَانَسْتُم مِّنْهُمْ رُشْدًۭا فَٱدْفَعُوٓا۟ إِلَيْهِمْ أَمْوَٰلَهُمْ ۖ وَلَا تَأْكُلُوهَآ إِسْرَافًۭا وَبِدَارًا أَن يَكْبَرُوا۟ ۚ وَمَن كَانَ غَنِيًّۭا فَلْيَسْتَعْفِفْ ۖ وَمَن كَانَ فَقِيرًۭا فَلْيَأْكُلْ بِٱلْمَعْرُوفِ ۚ فَإِذَا دَفَعْتُمْ إِلَيْهِمْ أَمْوَٰلَهُمْ فَأَشْهِدُوا۟ عَلَيْهِمْ ۚ وَكَفَىٰ بِٱللَّهِ حَسِيبًۭا',
		number_in_surah: '6',
		page: '77',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '500',
		number: '500',
		text: 'لِّلرِّجَالِ نَصِيبٌۭ مِّمَّا تَرَكَ ٱلْوَٰلِدَانِ وَٱلْأَقْرَبُونَ وَلِلنِّسَآءِ نَصِيبٌۭ مِّمَّا تَرَكَ ٱلْوَٰلِدَانِ وَٱلْأَقْرَبُونَ مِمَّا قَلَّ مِنْهُ أَوْ كَثُرَ ۚ نَصِيبًۭا مَّفْرُوضًۭا',
		number_in_surah: '7',
		page: '78',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '501',
		number: '501',
		text: 'وَإِذَا حَضَرَ ٱلْقِسْمَةَ أُو۟لُوا۟ ٱلْقُرْبَىٰ وَٱلْيَتَٰمَىٰ وَٱلْمَسَٰكِينُ فَٱرْزُقُوهُم مِّنْهُ وَقُولُوا۟ لَهُمْ قَوْلًۭا مَّعْرُوفًۭا',
		number_in_surah: '8',
		page: '78',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '502',
		number: '502',
		text: 'وَلْيَخْشَ ٱلَّذِينَ لَوْ تَرَكُوا۟ مِنْ خَلْفِهِمْ ذُرِّيَّةًۭ ضِعَٰفًا خَافُوا۟ عَلَيْهِمْ فَلْيَتَّقُوا۟ ٱللَّهَ وَلْيَقُولُوا۟ قَوْلًۭا سَدِيدًا',
		number_in_surah: '9',
		page: '78',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '503',
		number: '503',
		text: 'إِنَّ ٱلَّذِينَ يَأْكُلُونَ أَمْوَٰلَ ٱلْيَتَٰمَىٰ ظُلْمًا إِنَّمَا يَأْكُلُونَ فِى بُطُونِهِمْ نَارًۭا ۖ وَسَيَصْلَوْنَ سَعِيرًۭا',
		number_in_surah: '10',
		page: '78',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '504',
		number: '504',
		text: 'يُوصِيكُمُ ٱللَّهُ فِىٓ أَوْلَٰدِكُمْ ۖ لِلذَّكَرِ مِثْلُ حَظِّ ٱلْأُنثَيَيْنِ ۚ فَإِن كُنَّ نِسَآءًۭ فَوْقَ ٱثْنَتَيْنِ فَلَهُنَّ ثُلُثَا مَا تَرَكَ ۖ وَإِن كَانَتْ وَٰحِدَةًۭ فَلَهَا ٱلنِّصْفُ ۚ وَلِأَبَوَيْهِ لِكُلِّ وَٰحِدٍۢ مِّنْهُمَا ٱلسُّدُسُ مِمَّا تَرَكَ إِن كَانَ لَهُۥ وَلَدٌۭ ۚ فَإِن لَّمْ يَكُن لَّهُۥ وَلَدٌۭ وَوَرِثَهُۥٓ أَبَوَاهُ فَلِأُمِّهِ ٱلثُّلُثُ ۚ فَإِن كَانَ لَهُۥٓ إِخْوَةٌۭ فَلِأُمِّهِ ٱلسُّدُسُ ۚ مِنۢ بَعْدِ وَصِيَّةٍۢ يُوصِى بِهَآ أَوْ دَيْنٍ ۗ ءَابَآؤُكُمْ وَأَبْنَآؤُكُمْ لَا تَدْرُونَ أَيُّهُمْ أَقْرَبُ لَكُمْ نَفْعًۭا ۚ فَرِيضَةًۭ مِّنَ ٱللَّهِ ۗ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '11',
		page: '78',
		surah_id: '4',
		hizb_id: '31',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '505',
		number: '505',
		text: '۞ وَلَكُمْ نِصْفُ مَا تَرَكَ أَزْوَٰجُكُمْ إِن لَّمْ يَكُن لَّهُنَّ وَلَدٌۭ ۚ فَإِن كَانَ لَهُنَّ وَلَدٌۭ فَلَكُمُ ٱلرُّبُعُ مِمَّا تَرَكْنَ ۚ مِنۢ بَعْدِ وَصِيَّةٍۢ يُوصِينَ بِهَآ أَوْ دَيْنٍۢ ۚ وَلَهُنَّ ٱلرُّبُعُ مِمَّا تَرَكْتُمْ إِن لَّمْ يَكُن لَّكُمْ وَلَدٌۭ ۚ فَإِن كَانَ لَكُمْ وَلَدٌۭ فَلَهُنَّ ٱلثُّمُنُ مِمَّا تَرَكْتُم ۚ مِّنۢ بَعْدِ وَصِيَّةٍۢ تُوصُونَ بِهَآ أَوْ دَيْنٍۢ ۗ وَإِن كَانَ رَجُلٌۭ يُورَثُ كَلَٰلَةً أَوِ ٱمْرَأَةٌۭ وَلَهُۥٓ أَخٌ أَوْ أُخْتٌۭ فَلِكُلِّ وَٰحِدٍۢ مِّنْهُمَا ٱلسُّدُسُ ۚ فَإِن كَانُوٓا۟ أَكْثَرَ مِن ذَٰلِكَ فَهُمْ شُرَكَآءُ فِى ٱلثُّلُثِ ۚ مِنۢ بَعْدِ وَصِيَّةٍۢ يُوصَىٰ بِهَآ أَوْ دَيْنٍ غَيْرَ مُضَآرٍّۢ ۚ وَصِيَّةًۭ مِّنَ ٱللَّهِ ۗ وَٱللَّهُ عَلِيمٌ حَلِيمٌۭ',
		number_in_surah: '12',
		page: '79',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '506',
		number: '506',
		text: 'تِلْكَ حُدُودُ ٱللَّهِ ۚ وَمَن يُطِعِ ٱللَّهَ وَرَسُولَهُۥ يُدْخِلْهُ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا ۚ وَذَٰلِكَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '13',
		page: '79',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '507',
		number: '507',
		text: 'وَمَن يَعْصِ ٱللَّهَ وَرَسُولَهُۥ وَيَتَعَدَّ حُدُودَهُۥ يُدْخِلْهُ نَارًا خَٰلِدًۭا فِيهَا وَلَهُۥ عَذَابٌۭ مُّهِينٌۭ',
		number_in_surah: '14',
		page: '79',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '508',
		number: '508',
		text: 'وَٱلَّٰتِى يَأْتِينَ ٱلْفَٰحِشَةَ مِن نِّسَآئِكُمْ فَٱسْتَشْهِدُوا۟ عَلَيْهِنَّ أَرْبَعَةًۭ مِّنكُمْ ۖ فَإِن شَهِدُوا۟ فَأَمْسِكُوهُنَّ فِى ٱلْبُيُوتِ حَتَّىٰ يَتَوَفَّىٰهُنَّ ٱلْمَوْتُ أَوْ يَجْعَلَ ٱللَّهُ لَهُنَّ سَبِيلًۭا',
		number_in_surah: '15',
		page: '80',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '509',
		number: '509',
		text: 'وَٱلَّذَانِ يَأْتِيَٰنِهَا مِنكُمْ فَـَٔاذُوهُمَا ۖ فَإِن تَابَا وَأَصْلَحَا فَأَعْرِضُوا۟ عَنْهُمَآ ۗ إِنَّ ٱللَّهَ كَانَ تَوَّابًۭا رَّحِيمًا',
		number_in_surah: '16',
		page: '80',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '510',
		number: '510',
		text: 'إِنَّمَا ٱلتَّوْبَةُ عَلَى ٱللَّهِ لِلَّذِينَ يَعْمَلُونَ ٱلسُّوٓءَ بِجَهَٰلَةٍۢ ثُمَّ يَتُوبُونَ مِن قَرِيبٍۢ فَأُو۟لَٰٓئِكَ يَتُوبُ ٱللَّهُ عَلَيْهِمْ ۗ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '17',
		page: '80',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '511',
		number: '511',
		text: 'وَلَيْسَتِ ٱلتَّوْبَةُ لِلَّذِينَ يَعْمَلُونَ ٱلسَّيِّـَٔاتِ حَتَّىٰٓ إِذَا حَضَرَ أَحَدَهُمُ ٱلْمَوْتُ قَالَ إِنِّى تُبْتُ ٱلْـَٰٔنَ وَلَا ٱلَّذِينَ يَمُوتُونَ وَهُمْ كُفَّارٌ ۚ أُو۟لَٰٓئِكَ أَعْتَدْنَا لَهُمْ عَذَابًا أَلِيمًۭا',
		number_in_surah: '18',
		page: '80',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '512',
		number: '512',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا يَحِلُّ لَكُمْ أَن تَرِثُوا۟ ٱلنِّسَآءَ كَرْهًۭا ۖ وَلَا تَعْضُلُوهُنَّ لِتَذْهَبُوا۟ بِبَعْضِ مَآ ءَاتَيْتُمُوهُنَّ إِلَّآ أَن يَأْتِينَ بِفَٰحِشَةٍۢ مُّبَيِّنَةٍۢ ۚ وَعَاشِرُوهُنَّ بِٱلْمَعْرُوفِ ۚ فَإِن كَرِهْتُمُوهُنَّ فَعَسَىٰٓ أَن تَكْرَهُوا۟ شَيْـًۭٔا وَيَجْعَلَ ٱللَّهُ فِيهِ خَيْرًۭا كَثِيرًۭا',
		number_in_surah: '19',
		page: '80',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '513',
		number: '513',
		text: 'وَإِنْ أَرَدتُّمُ ٱسْتِبْدَالَ زَوْجٍۢ مَّكَانَ زَوْجٍۢ وَءَاتَيْتُمْ إِحْدَىٰهُنَّ قِنطَارًۭا فَلَا تَأْخُذُوا۟ مِنْهُ شَيْـًٔا ۚ أَتَأْخُذُونَهُۥ بُهْتَٰنًۭا وَإِثْمًۭا مُّبِينًۭا',
		number_in_surah: '20',
		page: '81',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '514',
		number: '514',
		text: 'وَكَيْفَ تَأْخُذُونَهُۥ وَقَدْ أَفْضَىٰ بَعْضُكُمْ إِلَىٰ بَعْضٍۢ وَأَخَذْنَ مِنكُم مِّيثَٰقًا غَلِيظًۭا',
		number_in_surah: '21',
		page: '81',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '515',
		number: '515',
		text: 'وَلَا تَنكِحُوا۟ مَا نَكَحَ ءَابَآؤُكُم مِّنَ ٱلنِّسَآءِ إِلَّا مَا قَدْ سَلَفَ ۚ إِنَّهُۥ كَانَ فَٰحِشَةًۭ وَمَقْتًۭا وَسَآءَ سَبِيلًا',
		number_in_surah: '22',
		page: '81',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '516',
		number: '516',
		text: 'حُرِّمَتْ عَلَيْكُمْ أُمَّهَٰتُكُمْ وَبَنَاتُكُمْ وَأَخَوَٰتُكُمْ وَعَمَّٰتُكُمْ وَخَٰلَٰتُكُمْ وَبَنَاتُ ٱلْأَخِ وَبَنَاتُ ٱلْأُخْتِ وَأُمَّهَٰتُكُمُ ٱلَّٰتِىٓ أَرْضَعْنَكُمْ وَأَخَوَٰتُكُم مِّنَ ٱلرَّضَٰعَةِ وَأُمَّهَٰتُ نِسَآئِكُمْ وَرَبَٰٓئِبُكُمُ ٱلَّٰتِى فِى حُجُورِكُم مِّن نِّسَآئِكُمُ ٱلَّٰتِى دَخَلْتُم بِهِنَّ فَإِن لَّمْ تَكُونُوا۟ دَخَلْتُم بِهِنَّ فَلَا جُنَاحَ عَلَيْكُمْ وَحَلَٰٓئِلُ أَبْنَآئِكُمُ ٱلَّذِينَ مِنْ أَصْلَٰبِكُمْ وَأَن تَجْمَعُوا۟ بَيْنَ ٱلْأُخْتَيْنِ إِلَّا مَا قَدْ سَلَفَ ۗ إِنَّ ٱللَّهَ كَانَ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '23',
		page: '81',
		surah_id: '4',
		hizb_id: '32',
		juz_id: '4',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '517',
		number: '517',
		text: '۞ وَٱلْمُحْصَنَٰتُ مِنَ ٱلنِّسَآءِ إِلَّا مَا مَلَكَتْ أَيْمَٰنُكُمْ ۖ كِتَٰبَ ٱللَّهِ عَلَيْكُمْ ۚ وَأُحِلَّ لَكُم مَّا وَرَآءَ ذَٰلِكُمْ أَن تَبْتَغُوا۟ بِأَمْوَٰلِكُم مُّحْصِنِينَ غَيْرَ مُسَٰفِحِينَ ۚ فَمَا ٱسْتَمْتَعْتُم بِهِۦ مِنْهُنَّ فَـَٔاتُوهُنَّ أُجُورَهُنَّ فَرِيضَةًۭ ۚ وَلَا جُنَاحَ عَلَيْكُمْ فِيمَا تَرَٰضَيْتُم بِهِۦ مِنۢ بَعْدِ ٱلْفَرِيضَةِ ۚ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '24',
		page: '82',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '518',
		number: '518',
		text: 'وَمَن لَّمْ يَسْتَطِعْ مِنكُمْ طَوْلًا أَن يَنكِحَ ٱلْمُحْصَنَٰتِ ٱلْمُؤْمِنَٰتِ فَمِن مَّا مَلَكَتْ أَيْمَٰنُكُم مِّن فَتَيَٰتِكُمُ ٱلْمُؤْمِنَٰتِ ۚ وَٱللَّهُ أَعْلَمُ بِإِيمَٰنِكُم ۚ بَعْضُكُم مِّنۢ بَعْضٍۢ ۚ فَٱنكِحُوهُنَّ بِإِذْنِ أَهْلِهِنَّ وَءَاتُوهُنَّ أُجُورَهُنَّ بِٱلْمَعْرُوفِ مُحْصَنَٰتٍ غَيْرَ مُسَٰفِحَٰتٍۢ وَلَا مُتَّخِذَٰتِ أَخْدَانٍۢ ۚ فَإِذَآ أُحْصِنَّ فَإِنْ أَتَيْنَ بِفَٰحِشَةٍۢ فَعَلَيْهِنَّ نِصْفُ مَا عَلَى ٱلْمُحْصَنَٰتِ مِنَ ٱلْعَذَابِ ۚ ذَٰلِكَ لِمَنْ خَشِىَ ٱلْعَنَتَ مِنكُمْ ۚ وَأَن تَصْبِرُوا۟ خَيْرٌۭ لَّكُمْ ۗ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '25',
		page: '82',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '519',
		number: '519',
		text: 'يُرِيدُ ٱللَّهُ لِيُبَيِّنَ لَكُمْ وَيَهْدِيَكُمْ سُنَنَ ٱلَّذِينَ مِن قَبْلِكُمْ وَيَتُوبَ عَلَيْكُمْ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '26',
		page: '82',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '520',
		number: '520',
		text: 'وَٱللَّهُ يُرِيدُ أَن يَتُوبَ عَلَيْكُمْ وَيُرِيدُ ٱلَّذِينَ يَتَّبِعُونَ ٱلشَّهَوَٰتِ أَن تَمِيلُوا۟ مَيْلًا عَظِيمًۭا',
		number_in_surah: '27',
		page: '83',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '521',
		number: '521',
		text: 'يُرِيدُ ٱللَّهُ أَن يُخَفِّفَ عَنكُمْ ۚ وَخُلِقَ ٱلْإِنسَٰنُ ضَعِيفًۭا',
		number_in_surah: '28',
		page: '83',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '522',
		number: '522',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَأْكُلُوٓا۟ أَمْوَٰلَكُم بَيْنَكُم بِٱلْبَٰطِلِ إِلَّآ أَن تَكُونَ تِجَٰرَةً عَن تَرَاضٍۢ مِّنكُمْ ۚ وَلَا تَقْتُلُوٓا۟ أَنفُسَكُمْ ۚ إِنَّ ٱللَّهَ كَانَ بِكُمْ رَحِيمًۭا',
		number_in_surah: '29',
		page: '83',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '523',
		number: '523',
		text: 'وَمَن يَفْعَلْ ذَٰلِكَ عُدْوَٰنًۭا وَظُلْمًۭا فَسَوْفَ نُصْلِيهِ نَارًۭا ۚ وَكَانَ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرًا',
		number_in_surah: '30',
		page: '83',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '524',
		number: '524',
		text: 'إِن تَجْتَنِبُوا۟ كَبَآئِرَ مَا تُنْهَوْنَ عَنْهُ نُكَفِّرْ عَنكُمْ سَيِّـَٔاتِكُمْ وَنُدْخِلْكُم مُّدْخَلًۭا كَرِيمًۭا',
		number_in_surah: '31',
		page: '83',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '525',
		number: '525',
		text: 'وَلَا تَتَمَنَّوْا۟ مَا فَضَّلَ ٱللَّهُ بِهِۦ بَعْضَكُمْ عَلَىٰ بَعْضٍۢ ۚ لِّلرِّجَالِ نَصِيبٌۭ مِّمَّا ٱكْتَسَبُوا۟ ۖ وَلِلنِّسَآءِ نَصِيبٌۭ مِّمَّا ٱكْتَسَبْنَ ۚ وَسْـَٔلُوا۟ ٱللَّهَ مِن فَضْلِهِۦٓ ۗ إِنَّ ٱللَّهَ كَانَ بِكُلِّ شَىْءٍ عَلِيمًۭا',
		number_in_surah: '32',
		page: '83',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '526',
		number: '526',
		text: 'وَلِكُلٍّۢ جَعَلْنَا مَوَٰلِىَ مِمَّا تَرَكَ ٱلْوَٰلِدَانِ وَٱلْأَقْرَبُونَ ۚ وَٱلَّذِينَ عَقَدَتْ أَيْمَٰنُكُمْ فَـَٔاتُوهُمْ نَصِيبَهُمْ ۚ إِنَّ ٱللَّهَ كَانَ عَلَىٰ كُلِّ شَىْءٍۢ شَهِيدًا',
		number_in_surah: '33',
		page: '83',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '527',
		number: '527',
		text: 'ٱلرِّجَالُ قَوَّٰمُونَ عَلَى ٱلنِّسَآءِ بِمَا فَضَّلَ ٱللَّهُ بَعْضَهُمْ عَلَىٰ بَعْضٍۢ وَبِمَآ أَنفَقُوا۟ مِنْ أَمْوَٰلِهِمْ ۚ فَٱلصَّٰلِحَٰتُ قَٰنِتَٰتٌ حَٰفِظَٰتٌۭ لِّلْغَيْبِ بِمَا حَفِظَ ٱللَّهُ ۚ وَٱلَّٰتِى تَخَافُونَ نُشُوزَهُنَّ فَعِظُوهُنَّ وَٱهْجُرُوهُنَّ فِى ٱلْمَضَاجِعِ وَٱضْرِبُوهُنَّ ۖ فَإِنْ أَطَعْنَكُمْ فَلَا تَبْغُوا۟ عَلَيْهِنَّ سَبِيلًا ۗ إِنَّ ٱللَّهَ كَانَ عَلِيًّۭا كَبِيرًۭا',
		number_in_surah: '34',
		page: '84',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '528',
		number: '528',
		text: 'وَإِنْ خِفْتُمْ شِقَاقَ بَيْنِهِمَا فَٱبْعَثُوا۟ حَكَمًۭا مِّنْ أَهْلِهِۦ وَحَكَمًۭا مِّنْ أَهْلِهَآ إِن يُرِيدَآ إِصْلَٰحًۭا يُوَفِّقِ ٱللَّهُ بَيْنَهُمَآ ۗ إِنَّ ٱللَّهَ كَانَ عَلِيمًا خَبِيرًۭا',
		number_in_surah: '35',
		page: '84',
		surah_id: '4',
		hizb_id: '33',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '529',
		number: '529',
		text: '۞ وَٱعْبُدُوا۟ ٱللَّهَ وَلَا تُشْرِكُوا۟ بِهِۦ شَيْـًۭٔا ۖ وَبِٱلْوَٰلِدَيْنِ إِحْسَٰنًۭا وَبِذِى ٱلْقُرْبَىٰ وَٱلْيَتَٰمَىٰ وَٱلْمَسَٰكِينِ وَٱلْجَارِ ذِى ٱلْقُرْبَىٰ وَٱلْجَارِ ٱلْجُنُبِ وَٱلصَّاحِبِ بِٱلْجَنۢبِ وَٱبْنِ ٱلسَّبِيلِ وَمَا مَلَكَتْ أَيْمَٰنُكُمْ ۗ إِنَّ ٱللَّهَ لَا يُحِبُّ مَن كَانَ مُخْتَالًۭا فَخُورًا',
		number_in_surah: '36',
		page: '84',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '530',
		number: '530',
		text: 'ٱلَّذِينَ يَبْخَلُونَ وَيَأْمُرُونَ ٱلنَّاسَ بِٱلْبُخْلِ وَيَكْتُمُونَ مَآ ءَاتَىٰهُمُ ٱللَّهُ مِن فَضْلِهِۦ ۗ وَأَعْتَدْنَا لِلْكَٰفِرِينَ عَذَابًۭا مُّهِينًۭا',
		number_in_surah: '37',
		page: '84',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '531',
		number: '531',
		text: 'وَٱلَّذِينَ يُنفِقُونَ أَمْوَٰلَهُمْ رِئَآءَ ٱلنَّاسِ وَلَا يُؤْمِنُونَ بِٱللَّهِ وَلَا بِٱلْيَوْمِ ٱلْءَاخِرِ ۗ وَمَن يَكُنِ ٱلشَّيْطَٰنُ لَهُۥ قَرِينًۭا فَسَآءَ قَرِينًۭا',
		number_in_surah: '38',
		page: '85',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '532',
		number: '532',
		text: 'وَمَاذَا عَلَيْهِمْ لَوْ ءَامَنُوا۟ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَأَنفَقُوا۟ مِمَّا رَزَقَهُمُ ٱللَّهُ ۚ وَكَانَ ٱللَّهُ بِهِمْ عَلِيمًا',
		number_in_surah: '39',
		page: '85',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '533',
		number: '533',
		text: 'إِنَّ ٱللَّهَ لَا يَظْلِمُ مِثْقَالَ ذَرَّةٍۢ ۖ وَإِن تَكُ حَسَنَةًۭ يُضَٰعِفْهَا وَيُؤْتِ مِن لَّدُنْهُ أَجْرًا عَظِيمًۭا',
		number_in_surah: '40',
		page: '85',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '534',
		number: '534',
		text: 'فَكَيْفَ إِذَا جِئْنَا مِن كُلِّ أُمَّةٍۭ بِشَهِيدٍۢ وَجِئْنَا بِكَ عَلَىٰ هَٰٓؤُلَآءِ شَهِيدًۭا',
		number_in_surah: '41',
		page: '85',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '535',
		number: '535',
		text: 'يَوْمَئِذٍۢ يَوَدُّ ٱلَّذِينَ كَفَرُوا۟ وَعَصَوُا۟ ٱلرَّسُولَ لَوْ تُسَوَّىٰ بِهِمُ ٱلْأَرْضُ وَلَا يَكْتُمُونَ ٱللَّهَ حَدِيثًۭا',
		number_in_surah: '42',
		page: '85',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '536',
		number: '536',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَقْرَبُوا۟ ٱلصَّلَوٰةَ وَأَنتُمْ سُكَٰرَىٰ حَتَّىٰ تَعْلَمُوا۟ مَا تَقُولُونَ وَلَا جُنُبًا إِلَّا عَابِرِى سَبِيلٍ حَتَّىٰ تَغْتَسِلُوا۟ ۚ وَإِن كُنتُم مَّرْضَىٰٓ أَوْ عَلَىٰ سَفَرٍ أَوْ جَآءَ أَحَدٌۭ مِّنكُم مِّنَ ٱلْغَآئِطِ أَوْ لَٰمَسْتُمُ ٱلنِّسَآءَ فَلَمْ تَجِدُوا۟ مَآءًۭ فَتَيَمَّمُوا۟ صَعِيدًۭا طَيِّبًۭا فَٱمْسَحُوا۟ بِوُجُوهِكُمْ وَأَيْدِيكُمْ ۗ إِنَّ ٱللَّهَ كَانَ عَفُوًّا غَفُورًا',
		number_in_surah: '43',
		page: '85',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '537',
		number: '537',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِينَ أُوتُوا۟ نَصِيبًۭا مِّنَ ٱلْكِتَٰبِ يَشْتَرُونَ ٱلضَّلَٰلَةَ وَيُرِيدُونَ أَن تَضِلُّوا۟ ٱلسَّبِيلَ',
		number_in_surah: '44',
		page: '85',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '538',
		number: '538',
		text: 'وَٱللَّهُ أَعْلَمُ بِأَعْدَآئِكُمْ ۚ وَكَفَىٰ بِٱللَّهِ وَلِيًّۭا وَكَفَىٰ بِٱللَّهِ نَصِيرًۭا',
		number_in_surah: '45',
		page: '86',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '539',
		number: '539',
		text: 'مِّنَ ٱلَّذِينَ هَادُوا۟ يُحَرِّفُونَ ٱلْكَلِمَ عَن مَّوَاضِعِهِۦ وَيَقُولُونَ سَمِعْنَا وَعَصَيْنَا وَٱسْمَعْ غَيْرَ مُسْمَعٍۢ وَرَٰعِنَا لَيًّۢا بِأَلْسِنَتِهِمْ وَطَعْنًۭا فِى ٱلدِّينِ ۚ وَلَوْ أَنَّهُمْ قَالُوا۟ سَمِعْنَا وَأَطَعْنَا وَٱسْمَعْ وَٱنظُرْنَا لَكَانَ خَيْرًۭا لَّهُمْ وَأَقْوَمَ وَلَٰكِن لَّعَنَهُمُ ٱللَّهُ بِكُفْرِهِمْ فَلَا يُؤْمِنُونَ إِلَّا قَلِيلًۭا',
		number_in_surah: '46',
		page: '86',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '540',
		number: '540',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ ءَامِنُوا۟ بِمَا نَزَّلْنَا مُصَدِّقًۭا لِّمَا مَعَكُم مِّن قَبْلِ أَن نَّطْمِسَ وُجُوهًۭا فَنَرُدَّهَا عَلَىٰٓ أَدْبَارِهَآ أَوْ نَلْعَنَهُمْ كَمَا لَعَنَّآ أَصْحَٰبَ ٱلسَّبْتِ ۚ وَكَانَ أَمْرُ ٱللَّهِ مَفْعُولًا',
		number_in_surah: '47',
		page: '86',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '541',
		number: '541',
		text: 'إِنَّ ٱللَّهَ لَا يَغْفِرُ أَن يُشْرَكَ بِهِۦ وَيَغْفِرُ مَا دُونَ ذَٰلِكَ لِمَن يَشَآءُ ۚ وَمَن يُشْرِكْ بِٱللَّهِ فَقَدِ ٱفْتَرَىٰٓ إِثْمًا عَظِيمًا',
		number_in_surah: '48',
		page: '86',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '542',
		number: '542',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِينَ يُزَكُّونَ أَنفُسَهُم ۚ بَلِ ٱللَّهُ يُزَكِّى مَن يَشَآءُ وَلَا يُظْلَمُونَ فَتِيلًا',
		number_in_surah: '49',
		page: '86',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '543',
		number: '543',
		text: 'ٱنظُرْ كَيْفَ يَفْتَرُونَ عَلَى ٱللَّهِ ٱلْكَذِبَ ۖ وَكَفَىٰ بِهِۦٓ إِثْمًۭا مُّبِينًا',
		number_in_surah: '50',
		page: '86',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '544',
		number: '544',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِينَ أُوتُوا۟ نَصِيبًۭا مِّنَ ٱلْكِتَٰبِ يُؤْمِنُونَ بِٱلْجِبْتِ وَٱلطَّٰغُوتِ وَيَقُولُونَ لِلَّذِينَ كَفَرُوا۟ هَٰٓؤُلَآءِ أَهْدَىٰ مِنَ ٱلَّذِينَ ءَامَنُوا۟ سَبِيلًا',
		number_in_surah: '51',
		page: '86',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '545',
		number: '545',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ لَعَنَهُمُ ٱللَّهُ ۖ وَمَن يَلْعَنِ ٱللَّهُ فَلَن تَجِدَ لَهُۥ نَصِيرًا',
		number_in_surah: '52',
		page: '87',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '546',
		number: '546',
		text: 'أَمْ لَهُمْ نَصِيبٌۭ مِّنَ ٱلْمُلْكِ فَإِذًۭا لَّا يُؤْتُونَ ٱلنَّاسَ نَقِيرًا',
		number_in_surah: '53',
		page: '87',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '547',
		number: '547',
		text: 'أَمْ يَحْسُدُونَ ٱلنَّاسَ عَلَىٰ مَآ ءَاتَىٰهُمُ ٱللَّهُ مِن فَضْلِهِۦ ۖ فَقَدْ ءَاتَيْنَآ ءَالَ إِبْرَٰهِيمَ ٱلْكِتَٰبَ وَٱلْحِكْمَةَ وَءَاتَيْنَٰهُم مُّلْكًا عَظِيمًۭا',
		number_in_surah: '54',
		page: '87',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '548',
		number: '548',
		text: 'فَمِنْهُم مَّنْ ءَامَنَ بِهِۦ وَمِنْهُم مَّن صَدَّ عَنْهُ ۚ وَكَفَىٰ بِجَهَنَّمَ سَعِيرًا',
		number_in_surah: '55',
		page: '87',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '549',
		number: '549',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ بِـَٔايَٰتِنَا سَوْفَ نُصْلِيهِمْ نَارًۭا كُلَّمَا نَضِجَتْ جُلُودُهُم بَدَّلْنَٰهُمْ جُلُودًا غَيْرَهَا لِيَذُوقُوا۟ ٱلْعَذَابَ ۗ إِنَّ ٱللَّهَ كَانَ عَزِيزًا حَكِيمًۭا',
		number_in_surah: '56',
		page: '87',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '550',
		number: '550',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ سَنُدْخِلُهُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدًۭا ۖ لَّهُمْ فِيهَآ أَزْوَٰجٌۭ مُّطَهَّرَةٌۭ ۖ وَنُدْخِلُهُمْ ظِلًّۭا ظَلِيلًا',
		number_in_surah: '57',
		page: '87',
		surah_id: '4',
		hizb_id: '34',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '551',
		number: '551',
		text: '۞ إِنَّ ٱللَّهَ يَأْمُرُكُمْ أَن تُؤَدُّوا۟ ٱلْأَمَٰنَٰتِ إِلَىٰٓ أَهْلِهَا وَإِذَا حَكَمْتُم بَيْنَ ٱلنَّاسِ أَن تَحْكُمُوا۟ بِٱلْعَدْلِ ۚ إِنَّ ٱللَّهَ نِعِمَّا يَعِظُكُم بِهِۦٓ ۗ إِنَّ ٱللَّهَ كَانَ سَمِيعًۢا بَصِيرًۭا',
		number_in_surah: '58',
		page: '87',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '552',
		number: '552',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ أَطِيعُوا۟ ٱللَّهَ وَأَطِيعُوا۟ ٱلرَّسُولَ وَأُو۟لِى ٱلْأَمْرِ مِنكُمْ ۖ فَإِن تَنَٰزَعْتُمْ فِى شَىْءٍۢ فَرُدُّوهُ إِلَى ٱللَّهِ وَٱلرَّسُولِ إِن كُنتُمْ تُؤْمِنُونَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ ۚ ذَٰلِكَ خَيْرٌۭ وَأَحْسَنُ تَأْوِيلًا',
		number_in_surah: '59',
		page: '87',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '553',
		number: '553',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِينَ يَزْعُمُونَ أَنَّهُمْ ءَامَنُوا۟ بِمَآ أُنزِلَ إِلَيْكَ وَمَآ أُنزِلَ مِن قَبْلِكَ يُرِيدُونَ أَن يَتَحَاكَمُوٓا۟ إِلَى ٱلطَّٰغُوتِ وَقَدْ أُمِرُوٓا۟ أَن يَكْفُرُوا۟ بِهِۦ وَيُرِيدُ ٱلشَّيْطَٰنُ أَن يُضِلَّهُمْ ضَلَٰلًۢا بَعِيدًۭا',
		number_in_surah: '60',
		page: '88',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '554',
		number: '554',
		text: 'وَإِذَا قِيلَ لَهُمْ تَعَالَوْا۟ إِلَىٰ مَآ أَنزَلَ ٱللَّهُ وَإِلَى ٱلرَّسُولِ رَأَيْتَ ٱلْمُنَٰفِقِينَ يَصُدُّونَ عَنكَ صُدُودًۭا',
		number_in_surah: '61',
		page: '88',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '555',
		number: '555',
		text: 'فَكَيْفَ إِذَآ أَصَٰبَتْهُم مُّصِيبَةٌۢ بِمَا قَدَّمَتْ أَيْدِيهِمْ ثُمَّ جَآءُوكَ يَحْلِفُونَ بِٱللَّهِ إِنْ أَرَدْنَآ إِلَّآ إِحْسَٰنًۭا وَتَوْفِيقًا',
		number_in_surah: '62',
		page: '88',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '556',
		number: '556',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ يَعْلَمُ ٱللَّهُ مَا فِى قُلُوبِهِمْ فَأَعْرِضْ عَنْهُمْ وَعِظْهُمْ وَقُل لَّهُمْ فِىٓ أَنفُسِهِمْ قَوْلًۢا بَلِيغًۭا',
		number_in_surah: '63',
		page: '88',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '557',
		number: '557',
		text: 'وَمَآ أَرْسَلْنَا مِن رَّسُولٍ إِلَّا لِيُطَاعَ بِإِذْنِ ٱللَّهِ ۚ وَلَوْ أَنَّهُمْ إِذ ظَّلَمُوٓا۟ أَنفُسَهُمْ جَآءُوكَ فَٱسْتَغْفَرُوا۟ ٱللَّهَ وَٱسْتَغْفَرَ لَهُمُ ٱلرَّسُولُ لَوَجَدُوا۟ ٱللَّهَ تَوَّابًۭا رَّحِيمًۭا',
		number_in_surah: '64',
		page: '88',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '558',
		number: '558',
		text: 'فَلَا وَرَبِّكَ لَا يُؤْمِنُونَ حَتَّىٰ يُحَكِّمُوكَ فِيمَا شَجَرَ بَيْنَهُمْ ثُمَّ لَا يَجِدُوا۟ فِىٓ أَنفُسِهِمْ حَرَجًۭا مِّمَّا قَضَيْتَ وَيُسَلِّمُوا۟ تَسْلِيمًۭا',
		number_in_surah: '65',
		page: '88',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '559',
		number: '559',
		text: 'وَلَوْ أَنَّا كَتَبْنَا عَلَيْهِمْ أَنِ ٱقْتُلُوٓا۟ أَنفُسَكُمْ أَوِ ٱخْرُجُوا۟ مِن دِيَٰرِكُم مَّا فَعَلُوهُ إِلَّا قَلِيلٌۭ مِّنْهُمْ ۖ وَلَوْ أَنَّهُمْ فَعَلُوا۟ مَا يُوعَظُونَ بِهِۦ لَكَانَ خَيْرًۭا لَّهُمْ وَأَشَدَّ تَثْبِيتًۭا',
		number_in_surah: '66',
		page: '89',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '560',
		number: '560',
		text: 'وَإِذًۭا لَّءَاتَيْنَٰهُم مِّن لَّدُنَّآ أَجْرًا عَظِيمًۭا',
		number_in_surah: '67',
		page: '89',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '561',
		number: '561',
		text: 'وَلَهَدَيْنَٰهُمْ صِرَٰطًۭا مُّسْتَقِيمًۭا',
		number_in_surah: '68',
		page: '89',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '562',
		number: '562',
		text: 'وَمَن يُطِعِ ٱللَّهَ وَٱلرَّسُولَ فَأُو۟لَٰٓئِكَ مَعَ ٱلَّذِينَ أَنْعَمَ ٱللَّهُ عَلَيْهِم مِّنَ ٱلنَّبِيِّۦنَ وَٱلصِّدِّيقِينَ وَٱلشُّهَدَآءِ وَٱلصَّٰلِحِينَ ۚ وَحَسُنَ أُو۟لَٰٓئِكَ رَفِيقًۭا',
		number_in_surah: '69',
		page: '89',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '563',
		number: '563',
		text: 'ذَٰلِكَ ٱلْفَضْلُ مِنَ ٱللَّهِ ۚ وَكَفَىٰ بِٱللَّهِ عَلِيمًۭا',
		number_in_surah: '70',
		page: '89',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '564',
		number: '564',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ خُذُوا۟ حِذْرَكُمْ فَٱنفِرُوا۟ ثُبَاتٍ أَوِ ٱنفِرُوا۟ جَمِيعًۭا',
		number_in_surah: '71',
		page: '89',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '565',
		number: '565',
		text: 'وَإِنَّ مِنكُمْ لَمَن لَّيُبَطِّئَنَّ فَإِنْ أَصَٰبَتْكُم مُّصِيبَةٌۭ قَالَ قَدْ أَنْعَمَ ٱللَّهُ عَلَىَّ إِذْ لَمْ أَكُن مَّعَهُمْ شَهِيدًۭا',
		number_in_surah: '72',
		page: '89',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '566',
		number: '566',
		text: 'وَلَئِنْ أَصَٰبَكُمْ فَضْلٌۭ مِّنَ ٱللَّهِ لَيَقُولَنَّ كَأَن لَّمْ تَكُنۢ بَيْنَكُمْ وَبَيْنَهُۥ مَوَدَّةٌۭ يَٰلَيْتَنِى كُنتُ مَعَهُمْ فَأَفُوزَ فَوْزًا عَظِيمًۭا',
		number_in_surah: '73',
		page: '89',
		surah_id: '4',
		hizb_id: '35',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '567',
		number: '567',
		text: '۞ فَلْيُقَٰتِلْ فِى سَبِيلِ ٱللَّهِ ٱلَّذِينَ يَشْرُونَ ٱلْحَيَوٰةَ ٱلدُّنْيَا بِٱلْءَاخِرَةِ ۚ وَمَن يُقَٰتِلْ فِى سَبِيلِ ٱللَّهِ فَيُقْتَلْ أَوْ يَغْلِبْ فَسَوْفَ نُؤْتِيهِ أَجْرًا عَظِيمًۭا',
		number_in_surah: '74',
		page: '89',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '568',
		number: '568',
		text: 'وَمَا لَكُمْ لَا تُقَٰتِلُونَ فِى سَبِيلِ ٱللَّهِ وَٱلْمُسْتَضْعَفِينَ مِنَ ٱلرِّجَالِ وَٱلنِّسَآءِ وَٱلْوِلْدَٰنِ ٱلَّذِينَ يَقُولُونَ رَبَّنَآ أَخْرِجْنَا مِنْ هَٰذِهِ ٱلْقَرْيَةِ ٱلظَّالِمِ أَهْلُهَا وَٱجْعَل لَّنَا مِن لَّدُنكَ وَلِيًّۭا وَٱجْعَل لَّنَا مِن لَّدُنكَ نَصِيرًا',
		number_in_surah: '75',
		page: '90',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '569',
		number: '569',
		text: 'ٱلَّذِينَ ءَامَنُوا۟ يُقَٰتِلُونَ فِى سَبِيلِ ٱللَّهِ ۖ وَٱلَّذِينَ كَفَرُوا۟ يُقَٰتِلُونَ فِى سَبِيلِ ٱلطَّٰغُوتِ فَقَٰتِلُوٓا۟ أَوْلِيَآءَ ٱلشَّيْطَٰنِ ۖ إِنَّ كَيْدَ ٱلشَّيْطَٰنِ كَانَ ضَعِيفًا',
		number_in_surah: '76',
		page: '90',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '570',
		number: '570',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِينَ قِيلَ لَهُمْ كُفُّوٓا۟ أَيْدِيَكُمْ وَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَءَاتُوا۟ ٱلزَّكَوٰةَ فَلَمَّا كُتِبَ عَلَيْهِمُ ٱلْقِتَالُ إِذَا فَرِيقٌۭ مِّنْهُمْ يَخْشَوْنَ ٱلنَّاسَ كَخَشْيَةِ ٱللَّهِ أَوْ أَشَدَّ خَشْيَةًۭ ۚ وَقَالُوا۟ رَبَّنَا لِمَ كَتَبْتَ عَلَيْنَا ٱلْقِتَالَ لَوْلَآ أَخَّرْتَنَآ إِلَىٰٓ أَجَلٍۢ قَرِيبٍۢ ۗ قُلْ مَتَٰعُ ٱلدُّنْيَا قَلِيلٌۭ وَٱلْءَاخِرَةُ خَيْرٌۭ لِّمَنِ ٱتَّقَىٰ وَلَا تُظْلَمُونَ فَتِيلًا',
		number_in_surah: '77',
		page: '90',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '571',
		number: '571',
		text: 'أَيْنَمَا تَكُونُوا۟ يُدْرِككُّمُ ٱلْمَوْتُ وَلَوْ كُنتُمْ فِى بُرُوجٍۢ مُّشَيَّدَةٍۢ ۗ وَإِن تُصِبْهُمْ حَسَنَةٌۭ يَقُولُوا۟ هَٰذِهِۦ مِنْ عِندِ ٱللَّهِ ۖ وَإِن تُصِبْهُمْ سَيِّئَةٌۭ يَقُولُوا۟ هَٰذِهِۦ مِنْ عِندِكَ ۚ قُلْ كُلٌّۭ مِّنْ عِندِ ٱللَّهِ ۖ فَمَالِ هَٰٓؤُلَآءِ ٱلْقَوْمِ لَا يَكَادُونَ يَفْقَهُونَ حَدِيثًۭا',
		number_in_surah: '78',
		page: '90',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '572',
		number: '572',
		text: 'مَّآ أَصَابَكَ مِنْ حَسَنَةٍۢ فَمِنَ ٱللَّهِ ۖ وَمَآ أَصَابَكَ مِن سَيِّئَةٍۢ فَمِن نَّفْسِكَ ۚ وَأَرْسَلْنَٰكَ لِلنَّاسِ رَسُولًۭا ۚ وَكَفَىٰ بِٱللَّهِ شَهِيدًۭا',
		number_in_surah: '79',
		page: '90',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '573',
		number: '573',
		text: 'مَّن يُطِعِ ٱلرَّسُولَ فَقَدْ أَطَاعَ ٱللَّهَ ۖ وَمَن تَوَلَّىٰ فَمَآ أَرْسَلْنَٰكَ عَلَيْهِمْ حَفِيظًۭا',
		number_in_surah: '80',
		page: '91',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '574',
		number: '574',
		text: 'وَيَقُولُونَ طَاعَةٌۭ فَإِذَا بَرَزُوا۟ مِنْ عِندِكَ بَيَّتَ طَآئِفَةٌۭ مِّنْهُمْ غَيْرَ ٱلَّذِى تَقُولُ ۖ وَٱللَّهُ يَكْتُبُ مَا يُبَيِّتُونَ ۖ فَأَعْرِضْ عَنْهُمْ وَتَوَكَّلْ عَلَى ٱللَّهِ ۚ وَكَفَىٰ بِٱللَّهِ وَكِيلًا',
		number_in_surah: '81',
		page: '91',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '575',
		number: '575',
		text: 'أَفَلَا يَتَدَبَّرُونَ ٱلْقُرْءَانَ ۚ وَلَوْ كَانَ مِنْ عِندِ غَيْرِ ٱللَّهِ لَوَجَدُوا۟ فِيهِ ٱخْتِلَٰفًۭا كَثِيرًۭا',
		number_in_surah: '82',
		page: '91',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '576',
		number: '576',
		text: 'وَإِذَا جَآءَهُمْ أَمْرٌۭ مِّنَ ٱلْأَمْنِ أَوِ ٱلْخَوْفِ أَذَاعُوا۟ بِهِۦ ۖ وَلَوْ رَدُّوهُ إِلَى ٱلرَّسُولِ وَإِلَىٰٓ أُو۟لِى ٱلْأَمْرِ مِنْهُمْ لَعَلِمَهُ ٱلَّذِينَ يَسْتَنۢبِطُونَهُۥ مِنْهُمْ ۗ وَلَوْلَا فَضْلُ ٱللَّهِ عَلَيْكُمْ وَرَحْمَتُهُۥ لَٱتَّبَعْتُمُ ٱلشَّيْطَٰنَ إِلَّا قَلِيلًۭا',
		number_in_surah: '83',
		page: '91',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '577',
		number: '577',
		text: 'فَقَٰتِلْ فِى سَبِيلِ ٱللَّهِ لَا تُكَلَّفُ إِلَّا نَفْسَكَ ۚ وَحَرِّضِ ٱلْمُؤْمِنِينَ ۖ عَسَى ٱللَّهُ أَن يَكُفَّ بَأْسَ ٱلَّذِينَ كَفَرُوا۟ ۚ وَٱللَّهُ أَشَدُّ بَأْسًۭا وَأَشَدُّ تَنكِيلًۭا',
		number_in_surah: '84',
		page: '91',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '578',
		number: '578',
		text: 'مَّن يَشْفَعْ شَفَٰعَةً حَسَنَةًۭ يَكُن لَّهُۥ نَصِيبٌۭ مِّنْهَا ۖ وَمَن يَشْفَعْ شَفَٰعَةًۭ سَيِّئَةًۭ يَكُن لَّهُۥ كِفْلٌۭ مِّنْهَا ۗ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ مُّقِيتًۭا',
		number_in_surah: '85',
		page: '91',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '579',
		number: '579',
		text: 'وَإِذَا حُيِّيتُم بِتَحِيَّةٍۢ فَحَيُّوا۟ بِأَحْسَنَ مِنْهَآ أَوْ رُدُّوهَآ ۗ إِنَّ ٱللَّهَ كَانَ عَلَىٰ كُلِّ شَىْءٍ حَسِيبًا',
		number_in_surah: '86',
		page: '91',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '580',
		number: '580',
		text: 'ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ۚ لَيَجْمَعَنَّكُمْ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ لَا رَيْبَ فِيهِ ۗ وَمَنْ أَصْدَقُ مِنَ ٱللَّهِ حَدِيثًۭا',
		number_in_surah: '87',
		page: '92',
		surah_id: '4',
		hizb_id: '36',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '581',
		number: '581',
		text: '۞ فَمَا لَكُمْ فِى ٱلْمُنَٰفِقِينَ فِئَتَيْنِ وَٱللَّهُ أَرْكَسَهُم بِمَا كَسَبُوٓا۟ ۚ أَتُرِيدُونَ أَن تَهْدُوا۟ مَنْ أَضَلَّ ٱللَّهُ ۖ وَمَن يُضْلِلِ ٱللَّهُ فَلَن تَجِدَ لَهُۥ سَبِيلًۭا',
		number_in_surah: '88',
		page: '92',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '582',
		number: '582',
		text: 'وَدُّوا۟ لَوْ تَكْفُرُونَ كَمَا كَفَرُوا۟ فَتَكُونُونَ سَوَآءًۭ ۖ فَلَا تَتَّخِذُوا۟ مِنْهُمْ أَوْلِيَآءَ حَتَّىٰ يُهَاجِرُوا۟ فِى سَبِيلِ ٱللَّهِ ۚ فَإِن تَوَلَّوْا۟ فَخُذُوهُمْ وَٱقْتُلُوهُمْ حَيْثُ وَجَدتُّمُوهُمْ ۖ وَلَا تَتَّخِذُوا۟ مِنْهُمْ وَلِيًّۭا وَلَا نَصِيرًا',
		number_in_surah: '89',
		page: '92',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '583',
		number: '583',
		text: 'إِلَّا ٱلَّذِينَ يَصِلُونَ إِلَىٰ قَوْمٍۭ بَيْنَكُمْ وَبَيْنَهُم مِّيثَٰقٌ أَوْ جَآءُوكُمْ حَصِرَتْ صُدُورُهُمْ أَن يُقَٰتِلُوكُمْ أَوْ يُقَٰتِلُوا۟ قَوْمَهُمْ ۚ وَلَوْ شَآءَ ٱللَّهُ لَسَلَّطَهُمْ عَلَيْكُمْ فَلَقَٰتَلُوكُمْ ۚ فَإِنِ ٱعْتَزَلُوكُمْ فَلَمْ يُقَٰتِلُوكُمْ وَأَلْقَوْا۟ إِلَيْكُمُ ٱلسَّلَمَ فَمَا جَعَلَ ٱللَّهُ لَكُمْ عَلَيْهِمْ سَبِيلًۭا',
		number_in_surah: '90',
		page: '92',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '584',
		number: '584',
		text: 'سَتَجِدُونَ ءَاخَرِينَ يُرِيدُونَ أَن يَأْمَنُوكُمْ وَيَأْمَنُوا۟ قَوْمَهُمْ كُلَّ مَا رُدُّوٓا۟ إِلَى ٱلْفِتْنَةِ أُرْكِسُوا۟ فِيهَا ۚ فَإِن لَّمْ يَعْتَزِلُوكُمْ وَيُلْقُوٓا۟ إِلَيْكُمُ ٱلسَّلَمَ وَيَكُفُّوٓا۟ أَيْدِيَهُمْ فَخُذُوهُمْ وَٱقْتُلُوهُمْ حَيْثُ ثَقِفْتُمُوهُمْ ۚ وَأُو۟لَٰٓئِكُمْ جَعَلْنَا لَكُمْ عَلَيْهِمْ سُلْطَٰنًۭا مُّبِينًۭا',
		number_in_surah: '91',
		page: '92',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '585',
		number: '585',
		text: 'وَمَا كَانَ لِمُؤْمِنٍ أَن يَقْتُلَ مُؤْمِنًا إِلَّا خَطَـًۭٔا ۚ وَمَن قَتَلَ مُؤْمِنًا خَطَـًۭٔا فَتَحْرِيرُ رَقَبَةٍۢ مُّؤْمِنَةٍۢ وَدِيَةٌۭ مُّسَلَّمَةٌ إِلَىٰٓ أَهْلِهِۦٓ إِلَّآ أَن يَصَّدَّقُوا۟ ۚ فَإِن كَانَ مِن قَوْمٍ عَدُوٍّۢ لَّكُمْ وَهُوَ مُؤْمِنٌۭ فَتَحْرِيرُ رَقَبَةٍۢ مُّؤْمِنَةٍۢ ۖ وَإِن كَانَ مِن قَوْمٍۭ بَيْنَكُمْ وَبَيْنَهُم مِّيثَٰقٌۭ فَدِيَةٌۭ مُّسَلَّمَةٌ إِلَىٰٓ أَهْلِهِۦ وَتَحْرِيرُ رَقَبَةٍۢ مُّؤْمِنَةٍۢ ۖ فَمَن لَّمْ يَجِدْ فَصِيَامُ شَهْرَيْنِ مُتَتَابِعَيْنِ تَوْبَةًۭ مِّنَ ٱللَّهِ ۗ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '92',
		page: '93',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '586',
		number: '586',
		text: 'وَمَن يَقْتُلْ مُؤْمِنًۭا مُّتَعَمِّدًۭا فَجَزَآؤُهُۥ جَهَنَّمُ خَٰلِدًۭا فِيهَا وَغَضِبَ ٱللَّهُ عَلَيْهِ وَلَعَنَهُۥ وَأَعَدَّ لَهُۥ عَذَابًا عَظِيمًۭا',
		number_in_surah: '93',
		page: '93',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '587',
		number: '587',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا ضَرَبْتُمْ فِى سَبِيلِ ٱللَّهِ فَتَبَيَّنُوا۟ وَلَا تَقُولُوا۟ لِمَنْ أَلْقَىٰٓ إِلَيْكُمُ ٱلسَّلَٰمَ لَسْتَ مُؤْمِنًۭا تَبْتَغُونَ عَرَضَ ٱلْحَيَوٰةِ ٱلدُّنْيَا فَعِندَ ٱللَّهِ مَغَانِمُ كَثِيرَةٌۭ ۚ كَذَٰلِكَ كُنتُم مِّن قَبْلُ فَمَنَّ ٱللَّهُ عَلَيْكُمْ فَتَبَيَّنُوٓا۟ ۚ إِنَّ ٱللَّهَ كَانَ بِمَا تَعْمَلُونَ خَبِيرًۭا',
		number_in_surah: '94',
		page: '93',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '588',
		number: '588',
		text: 'لَّا يَسْتَوِى ٱلْقَٰعِدُونَ مِنَ ٱلْمُؤْمِنِينَ غَيْرُ أُو۟لِى ٱلضَّرَرِ وَٱلْمُجَٰهِدُونَ فِى سَبِيلِ ٱللَّهِ بِأَمْوَٰلِهِمْ وَأَنفُسِهِمْ ۚ فَضَّلَ ٱللَّهُ ٱلْمُجَٰهِدِينَ بِأَمْوَٰلِهِمْ وَأَنفُسِهِمْ عَلَى ٱلْقَٰعِدِينَ دَرَجَةًۭ ۚ وَكُلًّۭا وَعَدَ ٱللَّهُ ٱلْحُسْنَىٰ ۚ وَفَضَّلَ ٱللَّهُ ٱلْمُجَٰهِدِينَ عَلَى ٱلْقَٰعِدِينَ أَجْرًا عَظِيمًۭا',
		number_in_surah: '95',
		page: '94',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '589',
		number: '589',
		text: 'دَرَجَٰتٍۢ مِّنْهُ وَمَغْفِرَةًۭ وَرَحْمَةًۭ ۚ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًا',
		number_in_surah: '96',
		page: '94',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '590',
		number: '590',
		text: 'إِنَّ ٱلَّذِينَ تَوَفَّىٰهُمُ ٱلْمَلَٰٓئِكَةُ ظَالِمِىٓ أَنفُسِهِمْ قَالُوا۟ فِيمَ كُنتُمْ ۖ قَالُوا۟ كُنَّا مُسْتَضْعَفِينَ فِى ٱلْأَرْضِ ۚ قَالُوٓا۟ أَلَمْ تَكُنْ أَرْضُ ٱللَّهِ وَٰسِعَةًۭ فَتُهَاجِرُوا۟ فِيهَا ۚ فَأُو۟لَٰٓئِكَ مَأْوَىٰهُمْ جَهَنَّمُ ۖ وَسَآءَتْ مَصِيرًا',
		number_in_surah: '97',
		page: '94',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '591',
		number: '591',
		text: 'إِلَّا ٱلْمُسْتَضْعَفِينَ مِنَ ٱلرِّجَالِ وَٱلنِّسَآءِ وَٱلْوِلْدَٰنِ لَا يَسْتَطِيعُونَ حِيلَةًۭ وَلَا يَهْتَدُونَ سَبِيلًۭا',
		number_in_surah: '98',
		page: '94',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '592',
		number: '592',
		text: 'فَأُو۟لَٰٓئِكَ عَسَى ٱللَّهُ أَن يَعْفُوَ عَنْهُمْ ۚ وَكَانَ ٱللَّهُ عَفُوًّا غَفُورًۭا',
		number_in_surah: '99',
		page: '94',
		surah_id: '4',
		hizb_id: '37',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '593',
		number: '593',
		text: '۞ وَمَن يُهَاجِرْ فِى سَبِيلِ ٱللَّهِ يَجِدْ فِى ٱلْأَرْضِ مُرَٰغَمًۭا كَثِيرًۭا وَسَعَةًۭ ۚ وَمَن يَخْرُجْ مِنۢ بَيْتِهِۦ مُهَاجِرًا إِلَى ٱللَّهِ وَرَسُولِهِۦ ثُمَّ يُدْرِكْهُ ٱلْمَوْتُ فَقَدْ وَقَعَ أَجْرُهُۥ عَلَى ٱللَّهِ ۗ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '100',
		page: '94',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '594',
		number: '594',
		text: 'وَإِذَا ضَرَبْتُمْ فِى ٱلْأَرْضِ فَلَيْسَ عَلَيْكُمْ جُنَاحٌ أَن تَقْصُرُوا۟ مِنَ ٱلصَّلَوٰةِ إِنْ خِفْتُمْ أَن يَفْتِنَكُمُ ٱلَّذِينَ كَفَرُوٓا۟ ۚ إِنَّ ٱلْكَٰفِرِينَ كَانُوا۟ لَكُمْ عَدُوًّۭا مُّبِينًۭا',
		number_in_surah: '101',
		page: '94',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '595',
		number: '595',
		text: 'وَإِذَا كُنتَ فِيهِمْ فَأَقَمْتَ لَهُمُ ٱلصَّلَوٰةَ فَلْتَقُمْ طَآئِفَةٌۭ مِّنْهُم مَّعَكَ وَلْيَأْخُذُوٓا۟ أَسْلِحَتَهُمْ فَإِذَا سَجَدُوا۟ فَلْيَكُونُوا۟ مِن وَرَآئِكُمْ وَلْتَأْتِ طَآئِفَةٌ أُخْرَىٰ لَمْ يُصَلُّوا۟ فَلْيُصَلُّوا۟ مَعَكَ وَلْيَأْخُذُوا۟ حِذْرَهُمْ وَأَسْلِحَتَهُمْ ۗ وَدَّ ٱلَّذِينَ كَفَرُوا۟ لَوْ تَغْفُلُونَ عَنْ أَسْلِحَتِكُمْ وَأَمْتِعَتِكُمْ فَيَمِيلُونَ عَلَيْكُم مَّيْلَةًۭ وَٰحِدَةًۭ ۚ وَلَا جُنَاحَ عَلَيْكُمْ إِن كَانَ بِكُمْ أَذًۭى مِّن مَّطَرٍ أَوْ كُنتُم مَّرْضَىٰٓ أَن تَضَعُوٓا۟ أَسْلِحَتَكُمْ ۖ وَخُذُوا۟ حِذْرَكُمْ ۗ إِنَّ ٱللَّهَ أَعَدَّ لِلْكَٰفِرِينَ عَذَابًۭا مُّهِينًۭا',
		number_in_surah: '102',
		page: '95',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '596',
		number: '596',
		text: 'فَإِذَا قَضَيْتُمُ ٱلصَّلَوٰةَ فَٱذْكُرُوا۟ ٱللَّهَ قِيَٰمًۭا وَقُعُودًۭا وَعَلَىٰ جُنُوبِكُمْ ۚ فَإِذَا ٱطْمَأْنَنتُمْ فَأَقِيمُوا۟ ٱلصَّلَوٰةَ ۚ إِنَّ ٱلصَّلَوٰةَ كَانَتْ عَلَى ٱلْمُؤْمِنِينَ كِتَٰبًۭا مَّوْقُوتًۭا',
		number_in_surah: '103',
		page: '95',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '597',
		number: '597',
		text: 'وَلَا تَهِنُوا۟ فِى ٱبْتِغَآءِ ٱلْقَوْمِ ۖ إِن تَكُونُوا۟ تَأْلَمُونَ فَإِنَّهُمْ يَأْلَمُونَ كَمَا تَأْلَمُونَ ۖ وَتَرْجُونَ مِنَ ٱللَّهِ مَا لَا يَرْجُونَ ۗ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمًا',
		number_in_surah: '104',
		page: '95',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '598',
		number: '598',
		text: 'إِنَّآ أَنزَلْنَآ إِلَيْكَ ٱلْكِتَٰبَ بِٱلْحَقِّ لِتَحْكُمَ بَيْنَ ٱلنَّاسِ بِمَآ أَرَىٰكَ ٱللَّهُ ۚ وَلَا تَكُن لِّلْخَآئِنِينَ خَصِيمًۭا',
		number_in_surah: '105',
		page: '95',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '599',
		number: '599',
		text: 'وَٱسْتَغْفِرِ ٱللَّهَ ۖ إِنَّ ٱللَّهَ كَانَ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '106',
		page: '96',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '600',
		number: '600',
		text: 'وَلَا تُجَٰدِلْ عَنِ ٱلَّذِينَ يَخْتَانُونَ أَنفُسَهُمْ ۚ إِنَّ ٱللَّهَ لَا يُحِبُّ مَن كَانَ خَوَّانًا أَثِيمًۭا',
		number_in_surah: '107',
		page: '96',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '601',
		number: '601',
		text: 'يَسْتَخْفُونَ مِنَ ٱلنَّاسِ وَلَا يَسْتَخْفُونَ مِنَ ٱللَّهِ وَهُوَ مَعَهُمْ إِذْ يُبَيِّتُونَ مَا لَا يَرْضَىٰ مِنَ ٱلْقَوْلِ ۚ وَكَانَ ٱللَّهُ بِمَا يَعْمَلُونَ مُحِيطًا',
		number_in_surah: '108',
		page: '96',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '602',
		number: '602',
		text: 'هَٰٓأَنتُمْ هَٰٓؤُلَآءِ جَٰدَلْتُمْ عَنْهُمْ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا فَمَن يُجَٰدِلُ ٱللَّهَ عَنْهُمْ يَوْمَ ٱلْقِيَٰمَةِ أَم مَّن يَكُونُ عَلَيْهِمْ وَكِيلًۭا',
		number_in_surah: '109',
		page: '96',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '603',
		number: '603',
		text: 'وَمَن يَعْمَلْ سُوٓءًا أَوْ يَظْلِمْ نَفْسَهُۥ ثُمَّ يَسْتَغْفِرِ ٱللَّهَ يَجِدِ ٱللَّهَ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '110',
		page: '96',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '604',
		number: '604',
		text: 'وَمَن يَكْسِبْ إِثْمًۭا فَإِنَّمَا يَكْسِبُهُۥ عَلَىٰ نَفْسِهِۦ ۚ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '111',
		page: '96',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '605',
		number: '605',
		text: 'وَمَن يَكْسِبْ خَطِيٓـَٔةً أَوْ إِثْمًۭا ثُمَّ يَرْمِ بِهِۦ بَرِيٓـًۭٔا فَقَدِ ٱحْتَمَلَ بُهْتَٰنًۭا وَإِثْمًۭا مُّبِينًۭا',
		number_in_surah: '112',
		page: '96',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '606',
		number: '606',
		text: 'وَلَوْلَا فَضْلُ ٱللَّهِ عَلَيْكَ وَرَحْمَتُهُۥ لَهَمَّت طَّآئِفَةٌۭ مِّنْهُمْ أَن يُضِلُّوكَ وَمَا يُضِلُّونَ إِلَّآ أَنفُسَهُمْ ۖ وَمَا يَضُرُّونَكَ مِن شَىْءٍۢ ۚ وَأَنزَلَ ٱللَّهُ عَلَيْكَ ٱلْكِتَٰبَ وَٱلْحِكْمَةَ وَعَلَّمَكَ مَا لَمْ تَكُن تَعْلَمُ ۚ وَكَانَ فَضْلُ ٱللَّهِ عَلَيْكَ عَظِيمًۭا',
		number_in_surah: '113',
		page: '96',
		surah_id: '4',
		hizb_id: '38',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '607',
		number: '607',
		text: '۞ لَّا خَيْرَ فِى كَثِيرٍۢ مِّن نَّجْوَىٰهُمْ إِلَّا مَنْ أَمَرَ بِصَدَقَةٍ أَوْ مَعْرُوفٍ أَوْ إِصْلَٰحٍۭ بَيْنَ ٱلنَّاسِ ۚ وَمَن يَفْعَلْ ذَٰلِكَ ٱبْتِغَآءَ مَرْضَاتِ ٱللَّهِ فَسَوْفَ نُؤْتِيهِ أَجْرًا عَظِيمًۭا',
		number_in_surah: '114',
		page: '97',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '608',
		number: '608',
		text: 'وَمَن يُشَاقِقِ ٱلرَّسُولَ مِنۢ بَعْدِ مَا تَبَيَّنَ لَهُ ٱلْهُدَىٰ وَيَتَّبِعْ غَيْرَ سَبِيلِ ٱلْمُؤْمِنِينَ نُوَلِّهِۦ مَا تَوَلَّىٰ وَنُصْلِهِۦ جَهَنَّمَ ۖ وَسَآءَتْ مَصِيرًا',
		number_in_surah: '115',
		page: '97',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '609',
		number: '609',
		text: 'إِنَّ ٱللَّهَ لَا يَغْفِرُ أَن يُشْرَكَ بِهِۦ وَيَغْفِرُ مَا دُونَ ذَٰلِكَ لِمَن يَشَآءُ ۚ وَمَن يُشْرِكْ بِٱللَّهِ فَقَدْ ضَلَّ ضَلَٰلًۢا بَعِيدًا',
		number_in_surah: '116',
		page: '97',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '610',
		number: '610',
		text: 'إِن يَدْعُونَ مِن دُونِهِۦٓ إِلَّآ إِنَٰثًۭا وَإِن يَدْعُونَ إِلَّا شَيْطَٰنًۭا مَّرِيدًۭا',
		number_in_surah: '117',
		page: '97',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '611',
		number: '611',
		text: 'لَّعَنَهُ ٱللَّهُ ۘ وَقَالَ لَأَتَّخِذَنَّ مِنْ عِبَادِكَ نَصِيبًۭا مَّفْرُوضًۭا',
		number_in_surah: '118',
		page: '97',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '612',
		number: '612',
		text: 'وَلَأُضِلَّنَّهُمْ وَلَأُمَنِّيَنَّهُمْ وَلَءَامُرَنَّهُمْ فَلَيُبَتِّكُنَّ ءَاذَانَ ٱلْأَنْعَٰمِ وَلَءَامُرَنَّهُمْ فَلَيُغَيِّرُنَّ خَلْقَ ٱللَّهِ ۚ وَمَن يَتَّخِذِ ٱلشَّيْطَٰنَ وَلِيًّۭا مِّن دُونِ ٱللَّهِ فَقَدْ خَسِرَ خُسْرَانًۭا مُّبِينًۭا',
		number_in_surah: '119',
		page: '97',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '613',
		number: '613',
		text: 'يَعِدُهُمْ وَيُمَنِّيهِمْ ۖ وَمَا يَعِدُهُمُ ٱلشَّيْطَٰنُ إِلَّا غُرُورًا',
		number_in_surah: '120',
		page: '97',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '614',
		number: '614',
		text: 'أُو۟لَٰٓئِكَ مَأْوَىٰهُمْ جَهَنَّمُ وَلَا يَجِدُونَ عَنْهَا مَحِيصًۭا',
		number_in_surah: '121',
		page: '97',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '615',
		number: '615',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ سَنُدْخِلُهُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدًۭا ۖ وَعْدَ ٱللَّهِ حَقًّۭا ۚ وَمَنْ أَصْدَقُ مِنَ ٱللَّهِ قِيلًۭا',
		number_in_surah: '122',
		page: '98',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '616',
		number: '616',
		text: 'لَّيْسَ بِأَمَانِيِّكُمْ وَلَآ أَمَانِىِّ أَهْلِ ٱلْكِتَٰبِ ۗ مَن يَعْمَلْ سُوٓءًۭا يُجْزَ بِهِۦ وَلَا يَجِدْ لَهُۥ مِن دُونِ ٱللَّهِ وَلِيًّۭا وَلَا نَصِيرًۭا',
		number_in_surah: '123',
		page: '98',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '617',
		number: '617',
		text: 'وَمَن يَعْمَلْ مِنَ ٱلصَّٰلِحَٰتِ مِن ذَكَرٍ أَوْ أُنثَىٰ وَهُوَ مُؤْمِنٌۭ فَأُو۟لَٰٓئِكَ يَدْخُلُونَ ٱلْجَنَّةَ وَلَا يُظْلَمُونَ نَقِيرًۭا',
		number_in_surah: '124',
		page: '98',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '618',
		number: '618',
		text: 'وَمَنْ أَحْسَنُ دِينًۭا مِّمَّنْ أَسْلَمَ وَجْهَهُۥ لِلَّهِ وَهُوَ مُحْسِنٌۭ وَٱتَّبَعَ مِلَّةَ إِبْرَٰهِيمَ حَنِيفًۭا ۗ وَٱتَّخَذَ ٱللَّهُ إِبْرَٰهِيمَ خَلِيلًۭا',
		number_in_surah: '125',
		page: '98',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '619',
		number: '619',
		text: 'وَلِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۚ وَكَانَ ٱللَّهُ بِكُلِّ شَىْءٍۢ مُّحِيطًۭا',
		number_in_surah: '126',
		page: '98',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '620',
		number: '620',
		text: 'وَيَسْتَفْتُونَكَ فِى ٱلنِّسَآءِ ۖ قُلِ ٱللَّهُ يُفْتِيكُمْ فِيهِنَّ وَمَا يُتْلَىٰ عَلَيْكُمْ فِى ٱلْكِتَٰبِ فِى يَتَٰمَى ٱلنِّسَآءِ ٱلَّٰتِى لَا تُؤْتُونَهُنَّ مَا كُتِبَ لَهُنَّ وَتَرْغَبُونَ أَن تَنكِحُوهُنَّ وَٱلْمُسْتَضْعَفِينَ مِنَ ٱلْوِلْدَٰنِ وَأَن تَقُومُوا۟ لِلْيَتَٰمَىٰ بِٱلْقِسْطِ ۚ وَمَا تَفْعَلُوا۟ مِنْ خَيْرٍۢ فَإِنَّ ٱللَّهَ كَانَ بِهِۦ عَلِيمًۭا',
		number_in_surah: '127',
		page: '98',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '621',
		number: '621',
		text: 'وَإِنِ ٱمْرَأَةٌ خَافَتْ مِنۢ بَعْلِهَا نُشُوزًا أَوْ إِعْرَاضًۭا فَلَا جُنَاحَ عَلَيْهِمَآ أَن يُصْلِحَا بَيْنَهُمَا صُلْحًۭا ۚ وَٱلصُّلْحُ خَيْرٌۭ ۗ وَأُحْضِرَتِ ٱلْأَنفُسُ ٱلشُّحَّ ۚ وَإِن تُحْسِنُوا۟ وَتَتَّقُوا۟ فَإِنَّ ٱللَّهَ كَانَ بِمَا تَعْمَلُونَ خَبِيرًۭا',
		number_in_surah: '128',
		page: '99',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '622',
		number: '622',
		text: 'وَلَن تَسْتَطِيعُوٓا۟ أَن تَعْدِلُوا۟ بَيْنَ ٱلنِّسَآءِ وَلَوْ حَرَصْتُمْ ۖ فَلَا تَمِيلُوا۟ كُلَّ ٱلْمَيْلِ فَتَذَرُوهَا كَٱلْمُعَلَّقَةِ ۚ وَإِن تُصْلِحُوا۟ وَتَتَّقُوا۟ فَإِنَّ ٱللَّهَ كَانَ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '129',
		page: '99',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '623',
		number: '623',
		text: 'وَإِن يَتَفَرَّقَا يُغْنِ ٱللَّهُ كُلًّۭا مِّن سَعَتِهِۦ ۚ وَكَانَ ٱللَّهُ وَٰسِعًا حَكِيمًۭا',
		number_in_surah: '130',
		page: '99',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '624',
		number: '624',
		text: 'وَلِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۗ وَلَقَدْ وَصَّيْنَا ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ مِن قَبْلِكُمْ وَإِيَّاكُمْ أَنِ ٱتَّقُوا۟ ٱللَّهَ ۚ وَإِن تَكْفُرُوا۟ فَإِنَّ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۚ وَكَانَ ٱللَّهُ غَنِيًّا حَمِيدًۭا',
		number_in_surah: '131',
		page: '99',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '625',
		number: '625',
		text: 'وَلِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۚ وَكَفَىٰ بِٱللَّهِ وَكِيلًا',
		number_in_surah: '132',
		page: '99',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '626',
		number: '626',
		text: 'إِن يَشَأْ يُذْهِبْكُمْ أَيُّهَا ٱلنَّاسُ وَيَأْتِ بِـَٔاخَرِينَ ۚ وَكَانَ ٱللَّهُ عَلَىٰ ذَٰلِكَ قَدِيرًۭا',
		number_in_surah: '133',
		page: '99',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '627',
		number: '627',
		text: 'مَّن كَانَ يُرِيدُ ثَوَابَ ٱلدُّنْيَا فَعِندَ ٱللَّهِ ثَوَابُ ٱلدُّنْيَا وَٱلْءَاخِرَةِ ۚ وَكَانَ ٱللَّهُ سَمِيعًۢا بَصِيرًۭا',
		number_in_surah: '134',
		page: '99',
		surah_id: '4',
		hizb_id: '39',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '628',
		number: '628',
		text: '۞ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ كُونُوا۟ قَوَّٰمِينَ بِٱلْقِسْطِ شُهَدَآءَ لِلَّهِ وَلَوْ عَلَىٰٓ أَنفُسِكُمْ أَوِ ٱلْوَٰلِدَيْنِ وَٱلْأَقْرَبِينَ ۚ إِن يَكُنْ غَنِيًّا أَوْ فَقِيرًۭا فَٱللَّهُ أَوْلَىٰ بِهِمَا ۖ فَلَا تَتَّبِعُوا۟ ٱلْهَوَىٰٓ أَن تَعْدِلُوا۟ ۚ وَإِن تَلْوُۥٓا۟ أَوْ تُعْرِضُوا۟ فَإِنَّ ٱللَّهَ كَانَ بِمَا تَعْمَلُونَ خَبِيرًۭا',
		number_in_surah: '135',
		page: '100',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '629',
		number: '629',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ ءَامِنُوا۟ بِٱللَّهِ وَرَسُولِهِۦ وَٱلْكِتَٰبِ ٱلَّذِى نَزَّلَ عَلَىٰ رَسُولِهِۦ وَٱلْكِتَٰبِ ٱلَّذِىٓ أَنزَلَ مِن قَبْلُ ۚ وَمَن يَكْفُرْ بِٱللَّهِ وَمَلَٰٓئِكَتِهِۦ وَكُتُبِهِۦ وَرُسُلِهِۦ وَٱلْيَوْمِ ٱلْءَاخِرِ فَقَدْ ضَلَّ ضَلَٰلًۢا بَعِيدًا',
		number_in_surah: '136',
		page: '100',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '630',
		number: '630',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ ثُمَّ كَفَرُوا۟ ثُمَّ ءَامَنُوا۟ ثُمَّ كَفَرُوا۟ ثُمَّ ٱزْدَادُوا۟ كُفْرًۭا لَّمْ يَكُنِ ٱللَّهُ لِيَغْفِرَ لَهُمْ وَلَا لِيَهْدِيَهُمْ سَبِيلًۢا',
		number_in_surah: '137',
		page: '100',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '631',
		number: '631',
		text: 'بَشِّرِ ٱلْمُنَٰفِقِينَ بِأَنَّ لَهُمْ عَذَابًا أَلِيمًا',
		number_in_surah: '138',
		page: '100',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '632',
		number: '632',
		text: 'ٱلَّذِينَ يَتَّخِذُونَ ٱلْكَٰفِرِينَ أَوْلِيَآءَ مِن دُونِ ٱلْمُؤْمِنِينَ ۚ أَيَبْتَغُونَ عِندَهُمُ ٱلْعِزَّةَ فَإِنَّ ٱلْعِزَّةَ لِلَّهِ جَمِيعًۭا',
		number_in_surah: '139',
		page: '100',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '633',
		number: '633',
		text: 'وَقَدْ نَزَّلَ عَلَيْكُمْ فِى ٱلْكِتَٰبِ أَنْ إِذَا سَمِعْتُمْ ءَايَٰتِ ٱللَّهِ يُكْفَرُ بِهَا وَيُسْتَهْزَأُ بِهَا فَلَا تَقْعُدُوا۟ مَعَهُمْ حَتَّىٰ يَخُوضُوا۟ فِى حَدِيثٍ غَيْرِهِۦٓ ۚ إِنَّكُمْ إِذًۭا مِّثْلُهُمْ ۗ إِنَّ ٱللَّهَ جَامِعُ ٱلْمُنَٰفِقِينَ وَٱلْكَٰفِرِينَ فِى جَهَنَّمَ جَمِيعًا',
		number_in_surah: '140',
		page: '100',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '634',
		number: '634',
		text: 'ٱلَّذِينَ يَتَرَبَّصُونَ بِكُمْ فَإِن كَانَ لَكُمْ فَتْحٌۭ مِّنَ ٱللَّهِ قَالُوٓا۟ أَلَمْ نَكُن مَّعَكُمْ وَإِن كَانَ لِلْكَٰفِرِينَ نَصِيبٌۭ قَالُوٓا۟ أَلَمْ نَسْتَحْوِذْ عَلَيْكُمْ وَنَمْنَعْكُم مِّنَ ٱلْمُؤْمِنِينَ ۚ فَٱللَّهُ يَحْكُمُ بَيْنَكُمْ يَوْمَ ٱلْقِيَٰمَةِ ۗ وَلَن يَجْعَلَ ٱللَّهُ لِلْكَٰفِرِينَ عَلَى ٱلْمُؤْمِنِينَ سَبِيلًا',
		number_in_surah: '141',
		page: '101',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '635',
		number: '635',
		text: 'إِنَّ ٱلْمُنَٰفِقِينَ يُخَٰدِعُونَ ٱللَّهَ وَهُوَ خَٰدِعُهُمْ وَإِذَا قَامُوٓا۟ إِلَى ٱلصَّلَوٰةِ قَامُوا۟ كُسَالَىٰ يُرَآءُونَ ٱلنَّاسَ وَلَا يَذْكُرُونَ ٱللَّهَ إِلَّا قَلِيلًۭا',
		number_in_surah: '142',
		page: '101',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '636',
		number: '636',
		text: 'مُّذَبْذَبِينَ بَيْنَ ذَٰلِكَ لَآ إِلَىٰ هَٰٓؤُلَآءِ وَلَآ إِلَىٰ هَٰٓؤُلَآءِ ۚ وَمَن يُضْلِلِ ٱللَّهُ فَلَن تَجِدَ لَهُۥ سَبِيلًۭا',
		number_in_surah: '143',
		page: '101',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '637',
		number: '637',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَتَّخِذُوا۟ ٱلْكَٰفِرِينَ أَوْلِيَآءَ مِن دُونِ ٱلْمُؤْمِنِينَ ۚ أَتُرِيدُونَ أَن تَجْعَلُوا۟ لِلَّهِ عَلَيْكُمْ سُلْطَٰنًۭا مُّبِينًا',
		number_in_surah: '144',
		page: '101',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '638',
		number: '638',
		text: 'إِنَّ ٱلْمُنَٰفِقِينَ فِى ٱلدَّرْكِ ٱلْأَسْفَلِ مِنَ ٱلنَّارِ وَلَن تَجِدَ لَهُمْ نَصِيرًا',
		number_in_surah: '145',
		page: '101',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '639',
		number: '639',
		text: 'إِلَّا ٱلَّذِينَ تَابُوا۟ وَأَصْلَحُوا۟ وَٱعْتَصَمُوا۟ بِٱللَّهِ وَأَخْلَصُوا۟ دِينَهُمْ لِلَّهِ فَأُو۟لَٰٓئِكَ مَعَ ٱلْمُؤْمِنِينَ ۖ وَسَوْفَ يُؤْتِ ٱللَّهُ ٱلْمُؤْمِنِينَ أَجْرًا عَظِيمًۭا',
		number_in_surah: '146',
		page: '101',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '640',
		number: '640',
		text: 'مَّا يَفْعَلُ ٱللَّهُ بِعَذَابِكُمْ إِن شَكَرْتُمْ وَءَامَنتُمْ ۚ وَكَانَ ٱللَّهُ شَاكِرًا عَلِيمًۭا',
		number_in_surah: '147',
		page: '101',
		surah_id: '4',
		hizb_id: '40',
		juz_id: '5',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '641',
		number: '641',
		text: '۞ لَّا يُحِبُّ ٱللَّهُ ٱلْجَهْرَ بِٱلسُّوٓءِ مِنَ ٱلْقَوْلِ إِلَّا مَن ظُلِمَ ۚ وَكَانَ ٱللَّهُ سَمِيعًا عَلِيمًا',
		number_in_surah: '148',
		page: '102',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '642',
		number: '642',
		text: 'إِن تُبْدُوا۟ خَيْرًا أَوْ تُخْفُوهُ أَوْ تَعْفُوا۟ عَن سُوٓءٍۢ فَإِنَّ ٱللَّهَ كَانَ عَفُوًّۭا قَدِيرًا',
		number_in_surah: '149',
		page: '102',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '643',
		number: '643',
		text: 'إِنَّ ٱلَّذِينَ يَكْفُرُونَ بِٱللَّهِ وَرُسُلِهِۦ وَيُرِيدُونَ أَن يُفَرِّقُوا۟ بَيْنَ ٱللَّهِ وَرُسُلِهِۦ وَيَقُولُونَ نُؤْمِنُ بِبَعْضٍۢ وَنَكْفُرُ بِبَعْضٍۢ وَيُرِيدُونَ أَن يَتَّخِذُوا۟ بَيْنَ ذَٰلِكَ سَبِيلًا',
		number_in_surah: '150',
		page: '102',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '644',
		number: '644',
		text: 'أُو۟لَٰٓئِكَ هُمُ ٱلْكَٰفِرُونَ حَقًّۭا ۚ وَأَعْتَدْنَا لِلْكَٰفِرِينَ عَذَابًۭا مُّهِينًۭا',
		number_in_surah: '151',
		page: '102',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '645',
		number: '645',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ بِٱللَّهِ وَرُسُلِهِۦ وَلَمْ يُفَرِّقُوا۟ بَيْنَ أَحَدٍۢ مِّنْهُمْ أُو۟لَٰٓئِكَ سَوْفَ يُؤْتِيهِمْ أُجُورَهُمْ ۗ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '152',
		page: '102',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '646',
		number: '646',
		text: 'يَسْـَٔلُكَ أَهْلُ ٱلْكِتَٰبِ أَن تُنَزِّلَ عَلَيْهِمْ كِتَٰبًۭا مِّنَ ٱلسَّمَآءِ ۚ فَقَدْ سَأَلُوا۟ مُوسَىٰٓ أَكْبَرَ مِن ذَٰلِكَ فَقَالُوٓا۟ أَرِنَا ٱللَّهَ جَهْرَةًۭ فَأَخَذَتْهُمُ ٱلصَّٰعِقَةُ بِظُلْمِهِمْ ۚ ثُمَّ ٱتَّخَذُوا۟ ٱلْعِجْلَ مِنۢ بَعْدِ مَا جَآءَتْهُمُ ٱلْبَيِّنَٰتُ فَعَفَوْنَا عَن ذَٰلِكَ ۚ وَءَاتَيْنَا مُوسَىٰ سُلْطَٰنًۭا مُّبِينًۭا',
		number_in_surah: '153',
		page: '102',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '647',
		number: '647',
		text: 'وَرَفَعْنَا فَوْقَهُمُ ٱلطُّورَ بِمِيثَٰقِهِمْ وَقُلْنَا لَهُمُ ٱدْخُلُوا۟ ٱلْبَابَ سُجَّدًۭا وَقُلْنَا لَهُمْ لَا تَعْدُوا۟ فِى ٱلسَّبْتِ وَأَخَذْنَا مِنْهُم مِّيثَٰقًا غَلِيظًۭا',
		number_in_surah: '154',
		page: '102',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '648',
		number: '648',
		text: 'فَبِمَا نَقْضِهِم مِّيثَٰقَهُمْ وَكُفْرِهِم بِـَٔايَٰتِ ٱللَّهِ وَقَتْلِهِمُ ٱلْأَنۢبِيَآءَ بِغَيْرِ حَقٍّۢ وَقَوْلِهِمْ قُلُوبُنَا غُلْفٌۢ ۚ بَلْ طَبَعَ ٱللَّهُ عَلَيْهَا بِكُفْرِهِمْ فَلَا يُؤْمِنُونَ إِلَّا قَلِيلًۭا',
		number_in_surah: '155',
		page: '103',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '649',
		number: '649',
		text: 'وَبِكُفْرِهِمْ وَقَوْلِهِمْ عَلَىٰ مَرْيَمَ بُهْتَٰنًا عَظِيمًۭا',
		number_in_surah: '156',
		page: '103',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '650',
		number: '650',
		text: 'وَقَوْلِهِمْ إِنَّا قَتَلْنَا ٱلْمَسِيحَ عِيسَى ٱبْنَ مَرْيَمَ رَسُولَ ٱللَّهِ وَمَا قَتَلُوهُ وَمَا صَلَبُوهُ وَلَٰكِن شُبِّهَ لَهُمْ ۚ وَإِنَّ ٱلَّذِينَ ٱخْتَلَفُوا۟ فِيهِ لَفِى شَكٍّۢ مِّنْهُ ۚ مَا لَهُم بِهِۦ مِنْ عِلْمٍ إِلَّا ٱتِّبَاعَ ٱلظَّنِّ ۚ وَمَا قَتَلُوهُ يَقِينًۢا',
		number_in_surah: '157',
		page: '103',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '651',
		number: '651',
		text: 'بَل رَّفَعَهُ ٱللَّهُ إِلَيْهِ ۚ وَكَانَ ٱللَّهُ عَزِيزًا حَكِيمًۭا',
		number_in_surah: '158',
		page: '103',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '652',
		number: '652',
		text: 'وَإِن مِّنْ أَهْلِ ٱلْكِتَٰبِ إِلَّا لَيُؤْمِنَنَّ بِهِۦ قَبْلَ مَوْتِهِۦ ۖ وَيَوْمَ ٱلْقِيَٰمَةِ يَكُونُ عَلَيْهِمْ شَهِيدًۭا',
		number_in_surah: '159',
		page: '103',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '653',
		number: '653',
		text: 'فَبِظُلْمٍۢ مِّنَ ٱلَّذِينَ هَادُوا۟ حَرَّمْنَا عَلَيْهِمْ طَيِّبَٰتٍ أُحِلَّتْ لَهُمْ وَبِصَدِّهِمْ عَن سَبِيلِ ٱللَّهِ كَثِيرًۭا',
		number_in_surah: '160',
		page: '103',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '654',
		number: '654',
		text: 'وَأَخْذِهِمُ ٱلرِّبَوٰا۟ وَقَدْ نُهُوا۟ عَنْهُ وَأَكْلِهِمْ أَمْوَٰلَ ٱلنَّاسِ بِٱلْبَٰطِلِ ۚ وَأَعْتَدْنَا لِلْكَٰفِرِينَ مِنْهُمْ عَذَابًا أَلِيمًۭا',
		number_in_surah: '161',
		page: '103',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '655',
		number: '655',
		text: 'لَّٰكِنِ ٱلرَّٰسِخُونَ فِى ٱلْعِلْمِ مِنْهُمْ وَٱلْمُؤْمِنُونَ يُؤْمِنُونَ بِمَآ أُنزِلَ إِلَيْكَ وَمَآ أُنزِلَ مِن قَبْلِكَ ۚ وَٱلْمُقِيمِينَ ٱلصَّلَوٰةَ ۚ وَٱلْمُؤْتُونَ ٱلزَّكَوٰةَ وَٱلْمُؤْمِنُونَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ أُو۟لَٰٓئِكَ سَنُؤْتِيهِمْ أَجْرًا عَظِيمًا',
		number_in_surah: '162',
		page: '103',
		surah_id: '4',
		hizb_id: '41',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '656',
		number: '656',
		text: '۞ إِنَّآ أَوْحَيْنَآ إِلَيْكَ كَمَآ أَوْحَيْنَآ إِلَىٰ نُوحٍۢ وَٱلنَّبِيِّۦنَ مِنۢ بَعْدِهِۦ ۚ وَأَوْحَيْنَآ إِلَىٰٓ إِبْرَٰهِيمَ وَإِسْمَٰعِيلَ وَإِسْحَٰقَ وَيَعْقُوبَ وَٱلْأَسْبَاطِ وَعِيسَىٰ وَأَيُّوبَ وَيُونُسَ وَهَٰرُونَ وَسُلَيْمَٰنَ ۚ وَءَاتَيْنَا دَاوُۥدَ زَبُورًۭا',
		number_in_surah: '163',
		page: '104',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '657',
		number: '657',
		text: 'وَرُسُلًۭا قَدْ قَصَصْنَٰهُمْ عَلَيْكَ مِن قَبْلُ وَرُسُلًۭا لَّمْ نَقْصُصْهُمْ عَلَيْكَ ۚ وَكَلَّمَ ٱللَّهُ مُوسَىٰ تَكْلِيمًۭا',
		number_in_surah: '164',
		page: '104',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '658',
		number: '658',
		text: 'رُّسُلًۭا مُّبَشِّرِينَ وَمُنذِرِينَ لِئَلَّا يَكُونَ لِلنَّاسِ عَلَى ٱللَّهِ حُجَّةٌۢ بَعْدَ ٱلرُّسُلِ ۚ وَكَانَ ٱللَّهُ عَزِيزًا حَكِيمًۭا',
		number_in_surah: '165',
		page: '104',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '659',
		number: '659',
		text: 'لَّٰكِنِ ٱللَّهُ يَشْهَدُ بِمَآ أَنزَلَ إِلَيْكَ ۖ أَنزَلَهُۥ بِعِلْمِهِۦ ۖ وَٱلْمَلَٰٓئِكَةُ يَشْهَدُونَ ۚ وَكَفَىٰ بِٱللَّهِ شَهِيدًا',
		number_in_surah: '166',
		page: '104',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '660',
		number: '660',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ وَصَدُّوا۟ عَن سَبِيلِ ٱللَّهِ قَدْ ضَلُّوا۟ ضَلَٰلًۢا بَعِيدًا',
		number_in_surah: '167',
		page: '104',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '661',
		number: '661',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ وَظَلَمُوا۟ لَمْ يَكُنِ ٱللَّهُ لِيَغْفِرَ لَهُمْ وَلَا لِيَهْدِيَهُمْ طَرِيقًا',
		number_in_surah: '168',
		page: '104',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '662',
		number: '662',
		text: 'إِلَّا طَرِيقَ جَهَنَّمَ خَٰلِدِينَ فِيهَآ أَبَدًۭا ۚ وَكَانَ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرًۭا',
		number_in_surah: '169',
		page: '104',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '663',
		number: '663',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ قَدْ جَآءَكُمُ ٱلرَّسُولُ بِٱلْحَقِّ مِن رَّبِّكُمْ فَـَٔامِنُوا۟ خَيْرًۭا لَّكُمْ ۚ وَإِن تَكْفُرُوا۟ فَإِنَّ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '170',
		page: '104',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '664',
		number: '664',
		text: 'يَٰٓأَهْلَ ٱلْكِتَٰبِ لَا تَغْلُوا۟ فِى دِينِكُمْ وَلَا تَقُولُوا۟ عَلَى ٱللَّهِ إِلَّا ٱلْحَقَّ ۚ إِنَّمَا ٱلْمَسِيحُ عِيسَى ٱبْنُ مَرْيَمَ رَسُولُ ٱللَّهِ وَكَلِمَتُهُۥٓ أَلْقَىٰهَآ إِلَىٰ مَرْيَمَ وَرُوحٌۭ مِّنْهُ ۖ فَـَٔامِنُوا۟ بِٱللَّهِ وَرُسُلِهِۦ ۖ وَلَا تَقُولُوا۟ ثَلَٰثَةٌ ۚ ٱنتَهُوا۟ خَيْرًۭا لَّكُمْ ۚ إِنَّمَا ٱللَّهُ إِلَٰهٌۭ وَٰحِدٌۭ ۖ سُبْحَٰنَهُۥٓ أَن يَكُونَ لَهُۥ وَلَدٌۭ ۘ لَّهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۗ وَكَفَىٰ بِٱللَّهِ وَكِيلًۭا',
		number_in_surah: '171',
		page: '105',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '665',
		number: '665',
		text: 'لَّن يَسْتَنكِفَ ٱلْمَسِيحُ أَن يَكُونَ عَبْدًۭا لِّلَّهِ وَلَا ٱلْمَلَٰٓئِكَةُ ٱلْمُقَرَّبُونَ ۚ وَمَن يَسْتَنكِفْ عَنْ عِبَادَتِهِۦ وَيَسْتَكْبِرْ فَسَيَحْشُرُهُمْ إِلَيْهِ جَمِيعًۭا',
		number_in_surah: '172',
		page: '105',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '666',
		number: '666',
		text: 'فَأَمَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ فَيُوَفِّيهِمْ أُجُورَهُمْ وَيَزِيدُهُم مِّن فَضْلِهِۦ ۖ وَأَمَّا ٱلَّذِينَ ٱسْتَنكَفُوا۟ وَٱسْتَكْبَرُوا۟ فَيُعَذِّبُهُمْ عَذَابًا أَلِيمًۭا وَلَا يَجِدُونَ لَهُم مِّن دُونِ ٱللَّهِ وَلِيًّۭا وَلَا نَصِيرًۭا',
		number_in_surah: '173',
		page: '105',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '667',
		number: '667',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ قَدْ جَآءَكُم بُرْهَٰنٌۭ مِّن رَّبِّكُمْ وَأَنزَلْنَآ إِلَيْكُمْ نُورًۭا مُّبِينًۭا',
		number_in_surah: '174',
		page: '105',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '668',
		number: '668',
		text: 'فَأَمَّا ٱلَّذِينَ ءَامَنُوا۟ بِٱللَّهِ وَٱعْتَصَمُوا۟ بِهِۦ فَسَيُدْخِلُهُمْ فِى رَحْمَةٍۢ مِّنْهُ وَفَضْلٍۢ وَيَهْدِيهِمْ إِلَيْهِ صِرَٰطًۭا مُّسْتَقِيمًۭا',
		number_in_surah: '175',
		page: '105',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '669',
		number: '669',
		text: 'يَسْتَفْتُونَكَ قُلِ ٱللَّهُ يُفْتِيكُمْ فِى ٱلْكَلَٰلَةِ ۚ إِنِ ٱمْرُؤٌا۟ هَلَكَ لَيْسَ لَهُۥ وَلَدٌۭ وَلَهُۥٓ أُخْتٌۭ فَلَهَا نِصْفُ مَا تَرَكَ ۚ وَهُوَ يَرِثُهَآ إِن لَّمْ يَكُن لَّهَا وَلَدٌۭ ۚ فَإِن كَانَتَا ٱثْنَتَيْنِ فَلَهُمَا ٱلثُّلُثَانِ مِمَّا تَرَكَ ۚ وَإِن كَانُوٓا۟ إِخْوَةًۭ رِّجَالًۭا وَنِسَآءًۭ فَلِلذَّكَرِ مِثْلُ حَظِّ ٱلْأُنثَيَيْنِ ۗ يُبَيِّنُ ٱللَّهُ لَكُمْ أَن تَضِلُّوا۟ ۗ وَٱللَّهُ بِكُلِّ شَىْءٍ عَلِيمٌۢ',
		number_in_surah: '176',
		page: '106',
		surah_id: '4',
		hizb_id: '42',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '670',
		number: '670',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ أَوْفُوا۟ بِٱلْعُقُودِ ۚ أُحِلَّتْ لَكُم بَهِيمَةُ ٱلْأَنْعَٰمِ إِلَّا مَا يُتْلَىٰ عَلَيْكُمْ غَيْرَ مُحِلِّى ٱلصَّيْدِ وَأَنتُمْ حُرُمٌ ۗ إِنَّ ٱللَّهَ يَحْكُمُ مَا يُرِيدُ',
		number_in_surah: '1',
		page: '106',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '671',
		number: '671',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تُحِلُّوا۟ شَعَٰٓئِرَ ٱللَّهِ وَلَا ٱلشَّهْرَ ٱلْحَرَامَ وَلَا ٱلْهَدْىَ وَلَا ٱلْقَلَٰٓئِدَ وَلَآ ءَآمِّينَ ٱلْبَيْتَ ٱلْحَرَامَ يَبْتَغُونَ فَضْلًۭا مِّن رَّبِّهِمْ وَرِضْوَٰنًۭا ۚ وَإِذَا حَلَلْتُمْ فَٱصْطَادُوا۟ ۚ وَلَا يَجْرِمَنَّكُمْ شَنَـَٔانُ قَوْمٍ أَن صَدُّوكُمْ عَنِ ٱلْمَسْجِدِ ٱلْحَرَامِ أَن تَعْتَدُوا۟ ۘ وَتَعَاوَنُوا۟ عَلَى ٱلْبِرِّ وَٱلتَّقْوَىٰ ۖ وَلَا تَعَاوَنُوا۟ عَلَى ٱلْإِثْمِ وَٱلْعُدْوَٰنِ ۚ وَٱتَّقُوا۟ ٱللَّهَ ۖ إِنَّ ٱللَّهَ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '2',
		page: '106',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '672',
		number: '672',
		text: 'حُرِّمَتْ عَلَيْكُمُ ٱلْمَيْتَةُ وَٱلدَّمُ وَلَحْمُ ٱلْخِنزِيرِ وَمَآ أُهِلَّ لِغَيْرِ ٱللَّهِ بِهِۦ وَٱلْمُنْخَنِقَةُ وَٱلْمَوْقُوذَةُ وَٱلْمُتَرَدِّيَةُ وَٱلنَّطِيحَةُ وَمَآ أَكَلَ ٱلسَّبُعُ إِلَّا مَا ذَكَّيْتُمْ وَمَا ذُبِحَ عَلَى ٱلنُّصُبِ وَأَن تَسْتَقْسِمُوا۟ بِٱلْأَزْلَٰمِ ۚ ذَٰلِكُمْ فِسْقٌ ۗ ٱلْيَوْمَ يَئِسَ ٱلَّذِينَ كَفَرُوا۟ مِن دِينِكُمْ فَلَا تَخْشَوْهُمْ وَٱخْشَوْنِ ۚ ٱلْيَوْمَ أَكْمَلْتُ لَكُمْ دِينَكُمْ وَأَتْمَمْتُ عَلَيْكُمْ نِعْمَتِى وَرَضِيتُ لَكُمُ ٱلْإِسْلَٰمَ دِينًۭا ۚ فَمَنِ ٱضْطُرَّ فِى مَخْمَصَةٍ غَيْرَ مُتَجَانِفٍۢ لِّإِثْمٍۢ ۙ فَإِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '3',
		page: '107',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '673',
		number: '673',
		text: 'يَسْـَٔلُونَكَ مَاذَآ أُحِلَّ لَهُمْ ۖ قُلْ أُحِلَّ لَكُمُ ٱلطَّيِّبَٰتُ ۙ وَمَا عَلَّمْتُم مِّنَ ٱلْجَوَارِحِ مُكَلِّبِينَ تُعَلِّمُونَهُنَّ مِمَّا عَلَّمَكُمُ ٱللَّهُ ۖ فَكُلُوا۟ مِمَّآ أَمْسَكْنَ عَلَيْكُمْ وَٱذْكُرُوا۟ ٱسْمَ ٱللَّهِ عَلَيْهِ ۖ وَٱتَّقُوا۟ ٱللَّهَ ۚ إِنَّ ٱللَّهَ سَرِيعُ ٱلْحِسَابِ',
		number_in_surah: '4',
		page: '107',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '674',
		number: '674',
		text: 'ٱلْيَوْمَ أُحِلَّ لَكُمُ ٱلطَّيِّبَٰتُ ۖ وَطَعَامُ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ حِلٌّۭ لَّكُمْ وَطَعَامُكُمْ حِلٌّۭ لَّهُمْ ۖ وَٱلْمُحْصَنَٰتُ مِنَ ٱلْمُؤْمِنَٰتِ وَٱلْمُحْصَنَٰتُ مِنَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ مِن قَبْلِكُمْ إِذَآ ءَاتَيْتُمُوهُنَّ أُجُورَهُنَّ مُحْصِنِينَ غَيْرَ مُسَٰفِحِينَ وَلَا مُتَّخِذِىٓ أَخْدَانٍۢ ۗ وَمَن يَكْفُرْ بِٱلْإِيمَٰنِ فَقَدْ حَبِطَ عَمَلُهُۥ وَهُوَ فِى ٱلْءَاخِرَةِ مِنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '5',
		page: '107',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '675',
		number: '675',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا قُمْتُمْ إِلَى ٱلصَّلَوٰةِ فَٱغْسِلُوا۟ وُجُوهَكُمْ وَأَيْدِيَكُمْ إِلَى ٱلْمَرَافِقِ وَٱمْسَحُوا۟ بِرُءُوسِكُمْ وَأَرْجُلَكُمْ إِلَى ٱلْكَعْبَيْنِ ۚ وَإِن كُنتُمْ جُنُبًۭا فَٱطَّهَّرُوا۟ ۚ وَإِن كُنتُم مَّرْضَىٰٓ أَوْ عَلَىٰ سَفَرٍ أَوْ جَآءَ أَحَدٌۭ مِّنكُم مِّنَ ٱلْغَآئِطِ أَوْ لَٰمَسْتُمُ ٱلنِّسَآءَ فَلَمْ تَجِدُوا۟ مَآءًۭ فَتَيَمَّمُوا۟ صَعِيدًۭا طَيِّبًۭا فَٱمْسَحُوا۟ بِوُجُوهِكُمْ وَأَيْدِيكُم مِّنْهُ ۚ مَا يُرِيدُ ٱللَّهُ لِيَجْعَلَ عَلَيْكُم مِّنْ حَرَجٍۢ وَلَٰكِن يُرِيدُ لِيُطَهِّرَكُمْ وَلِيُتِمَّ نِعْمَتَهُۥ عَلَيْكُمْ لَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '6',
		page: '108',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '676',
		number: '676',
		text: 'وَٱذْكُرُوا۟ نِعْمَةَ ٱللَّهِ عَلَيْكُمْ وَمِيثَٰقَهُ ٱلَّذِى وَاثَقَكُم بِهِۦٓ إِذْ قُلْتُمْ سَمِعْنَا وَأَطَعْنَا ۖ وَٱتَّقُوا۟ ٱللَّهَ ۚ إِنَّ ٱللَّهَ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '7',
		page: '108',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '677',
		number: '677',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ كُونُوا۟ قَوَّٰمِينَ لِلَّهِ شُهَدَآءَ بِٱلْقِسْطِ ۖ وَلَا يَجْرِمَنَّكُمْ شَنَـَٔانُ قَوْمٍ عَلَىٰٓ أَلَّا تَعْدِلُوا۟ ۚ ٱعْدِلُوا۟ هُوَ أَقْرَبُ لِلتَّقْوَىٰ ۖ وَٱتَّقُوا۟ ٱللَّهَ ۚ إِنَّ ٱللَّهَ خَبِيرٌۢ بِمَا تَعْمَلُونَ',
		number_in_surah: '8',
		page: '108',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '678',
		number: '678',
		text: 'وَعَدَ ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ ۙ لَهُم مَّغْفِرَةٌۭ وَأَجْرٌ عَظِيمٌۭ',
		number_in_surah: '9',
		page: '108',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '679',
		number: '679',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ وَكَذَّبُوا۟ بِـَٔايَٰتِنَآ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَحِيمِ',
		number_in_surah: '10',
		page: '109',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '680',
		number: '680',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱذْكُرُوا۟ نِعْمَتَ ٱللَّهِ عَلَيْكُمْ إِذْ هَمَّ قَوْمٌ أَن يَبْسُطُوٓا۟ إِلَيْكُمْ أَيْدِيَهُمْ فَكَفَّ أَيْدِيَهُمْ عَنكُمْ ۖ وَٱتَّقُوا۟ ٱللَّهَ ۚ وَعَلَى ٱللَّهِ فَلْيَتَوَكَّلِ ٱلْمُؤْمِنُونَ',
		number_in_surah: '11',
		page: '109',
		surah_id: '5',
		hizb_id: '43',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '681',
		number: '681',
		text: '۞ وَلَقَدْ أَخَذَ ٱللَّهُ مِيثَٰقَ بَنِىٓ إِسْرَٰٓءِيلَ وَبَعَثْنَا مِنْهُمُ ٱثْنَىْ عَشَرَ نَقِيبًۭا ۖ وَقَالَ ٱللَّهُ إِنِّى مَعَكُمْ ۖ لَئِنْ أَقَمْتُمُ ٱلصَّلَوٰةَ وَءَاتَيْتُمُ ٱلزَّكَوٰةَ وَءَامَنتُم بِرُسُلِى وَعَزَّرْتُمُوهُمْ وَأَقْرَضْتُمُ ٱللَّهَ قَرْضًا حَسَنًۭا لَّأُكَفِّرَنَّ عَنكُمْ سَيِّـَٔاتِكُمْ وَلَأُدْخِلَنَّكُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۚ فَمَن كَفَرَ بَعْدَ ذَٰلِكَ مِنكُمْ فَقَدْ ضَلَّ سَوَآءَ ٱلسَّبِيلِ',
		number_in_surah: '12',
		page: '109',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '682',
		number: '682',
		text: 'فَبِمَا نَقْضِهِم مِّيثَٰقَهُمْ لَعَنَّٰهُمْ وَجَعَلْنَا قُلُوبَهُمْ قَٰسِيَةًۭ ۖ يُحَرِّفُونَ ٱلْكَلِمَ عَن مَّوَاضِعِهِۦ ۙ وَنَسُوا۟ حَظًّۭا مِّمَّا ذُكِّرُوا۟ بِهِۦ ۚ وَلَا تَزَالُ تَطَّلِعُ عَلَىٰ خَآئِنَةٍۢ مِّنْهُمْ إِلَّا قَلِيلًۭا مِّنْهُمْ ۖ فَٱعْفُ عَنْهُمْ وَٱصْفَحْ ۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلْمُحْسِنِينَ',
		number_in_surah: '13',
		page: '109',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '683',
		number: '683',
		text: 'وَمِنَ ٱلَّذِينَ قَالُوٓا۟ إِنَّا نَصَٰرَىٰٓ أَخَذْنَا مِيثَٰقَهُمْ فَنَسُوا۟ حَظًّۭا مِّمَّا ذُكِّرُوا۟ بِهِۦ فَأَغْرَيْنَا بَيْنَهُمُ ٱلْعَدَاوَةَ وَٱلْبَغْضَآءَ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ ۚ وَسَوْفَ يُنَبِّئُهُمُ ٱللَّهُ بِمَا كَانُوا۟ يَصْنَعُونَ',
		number_in_surah: '14',
		page: '110',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '684',
		number: '684',
		text: 'يَٰٓأَهْلَ ٱلْكِتَٰبِ قَدْ جَآءَكُمْ رَسُولُنَا يُبَيِّنُ لَكُمْ كَثِيرًۭا مِّمَّا كُنتُمْ تُخْفُونَ مِنَ ٱلْكِتَٰبِ وَيَعْفُوا۟ عَن كَثِيرٍۢ ۚ قَدْ جَآءَكُم مِّنَ ٱللَّهِ نُورٌۭ وَكِتَٰبٌۭ مُّبِينٌۭ',
		number_in_surah: '15',
		page: '110',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '685',
		number: '685',
		text: 'يَهْدِى بِهِ ٱللَّهُ مَنِ ٱتَّبَعَ رِضْوَٰنَهُۥ سُبُلَ ٱلسَّلَٰمِ وَيُخْرِجُهُم مِّنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ بِإِذْنِهِۦ وَيَهْدِيهِمْ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '16',
		page: '110',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '686',
		number: '686',
		text: 'لَّقَدْ كَفَرَ ٱلَّذِينَ قَالُوٓا۟ إِنَّ ٱللَّهَ هُوَ ٱلْمَسِيحُ ٱبْنُ مَرْيَمَ ۚ قُلْ فَمَن يَمْلِكُ مِنَ ٱللَّهِ شَيْـًٔا إِنْ أَرَادَ أَن يُهْلِكَ ٱلْمَسِيحَ ٱبْنَ مَرْيَمَ وَأُمَّهُۥ وَمَن فِى ٱلْأَرْضِ جَمِيعًۭا ۗ وَلِلَّهِ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَا ۚ يَخْلُقُ مَا يَشَآءُ ۚ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '17',
		page: '110',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '687',
		number: '687',
		text: 'وَقَالَتِ ٱلْيَهُودُ وَٱلنَّصَٰرَىٰ نَحْنُ أَبْنَٰٓؤُا۟ ٱللَّهِ وَأَحِبَّٰٓؤُهُۥ ۚ قُلْ فَلِمَ يُعَذِّبُكُم بِذُنُوبِكُم ۖ بَلْ أَنتُم بَشَرٌۭ مِّمَّنْ خَلَقَ ۚ يَغْفِرُ لِمَن يَشَآءُ وَيُعَذِّبُ مَن يَشَآءُ ۚ وَلِلَّهِ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَا ۖ وَإِلَيْهِ ٱلْمَصِيرُ',
		number_in_surah: '18',
		page: '111',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '688',
		number: '688',
		text: 'يَٰٓأَهْلَ ٱلْكِتَٰبِ قَدْ جَآءَكُمْ رَسُولُنَا يُبَيِّنُ لَكُمْ عَلَىٰ فَتْرَةٍۢ مِّنَ ٱلرُّسُلِ أَن تَقُولُوا۟ مَا جَآءَنَا مِنۢ بَشِيرٍۢ وَلَا نَذِيرٍۢ ۖ فَقَدْ جَآءَكُم بَشِيرٌۭ وَنَذِيرٌۭ ۗ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '19',
		page: '111',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '689',
		number: '689',
		text: 'وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِۦ يَٰقَوْمِ ٱذْكُرُوا۟ نِعْمَةَ ٱللَّهِ عَلَيْكُمْ إِذْ جَعَلَ فِيكُمْ أَنۢبِيَآءَ وَجَعَلَكُم مُّلُوكًۭا وَءَاتَىٰكُم مَّا لَمْ يُؤْتِ أَحَدًۭا مِّنَ ٱلْعَٰلَمِينَ',
		number_in_surah: '20',
		page: '111',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '690',
		number: '690',
		text: 'يَٰقَوْمِ ٱدْخُلُوا۟ ٱلْأَرْضَ ٱلْمُقَدَّسَةَ ٱلَّتِى كَتَبَ ٱللَّهُ لَكُمْ وَلَا تَرْتَدُّوا۟ عَلَىٰٓ أَدْبَارِكُمْ فَتَنقَلِبُوا۟ خَٰسِرِينَ',
		number_in_surah: '21',
		page: '111',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '691',
		number: '691',
		text: 'قَالُوا۟ يَٰمُوسَىٰٓ إِنَّ فِيهَا قَوْمًۭا جَبَّارِينَ وَإِنَّا لَن نَّدْخُلَهَا حَتَّىٰ يَخْرُجُوا۟ مِنْهَا فَإِن يَخْرُجُوا۟ مِنْهَا فَإِنَّا دَٰخِلُونَ',
		number_in_surah: '22',
		page: '111',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '692',
		number: '692',
		text: 'قَالَ رَجُلَانِ مِنَ ٱلَّذِينَ يَخَافُونَ أَنْعَمَ ٱللَّهُ عَلَيْهِمَا ٱدْخُلُوا۟ عَلَيْهِمُ ٱلْبَابَ فَإِذَا دَخَلْتُمُوهُ فَإِنَّكُمْ غَٰلِبُونَ ۚ وَعَلَى ٱللَّهِ فَتَوَكَّلُوٓا۟ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '23',
		page: '111',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '693',
		number: '693',
		text: 'قَالُوا۟ يَٰمُوسَىٰٓ إِنَّا لَن نَّدْخُلَهَآ أَبَدًۭا مَّا دَامُوا۟ فِيهَا ۖ فَٱذْهَبْ أَنتَ وَرَبُّكَ فَقَٰتِلَآ إِنَّا هَٰهُنَا قَٰعِدُونَ',
		number_in_surah: '24',
		page: '112',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '694',
		number: '694',
		text: 'قَالَ رَبِّ إِنِّى لَآ أَمْلِكُ إِلَّا نَفْسِى وَأَخِى ۖ فَٱفْرُقْ بَيْنَنَا وَبَيْنَ ٱلْقَوْمِ ٱلْفَٰسِقِينَ',
		number_in_surah: '25',
		page: '112',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '695',
		number: '695',
		text: 'قَالَ فَإِنَّهَا مُحَرَّمَةٌ عَلَيْهِمْ ۛ أَرْبَعِينَ سَنَةًۭ ۛ يَتِيهُونَ فِى ٱلْأَرْضِ ۚ فَلَا تَأْسَ عَلَى ٱلْقَوْمِ ٱلْفَٰسِقِينَ',
		number_in_surah: '26',
		page: '112',
		surah_id: '5',
		hizb_id: '44',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '696',
		number: '696',
		text: '۞ وَٱتْلُ عَلَيْهِمْ نَبَأَ ٱبْنَىْ ءَادَمَ بِٱلْحَقِّ إِذْ قَرَّبَا قُرْبَانًۭا فَتُقُبِّلَ مِنْ أَحَدِهِمَا وَلَمْ يُتَقَبَّلْ مِنَ ٱلْءَاخَرِ قَالَ لَأَقْتُلَنَّكَ ۖ قَالَ إِنَّمَا يَتَقَبَّلُ ٱللَّهُ مِنَ ٱلْمُتَّقِينَ',
		number_in_surah: '27',
		page: '112',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '697',
		number: '697',
		text: 'لَئِنۢ بَسَطتَ إِلَىَّ يَدَكَ لِتَقْتُلَنِى مَآ أَنَا۠ بِبَاسِطٍۢ يَدِىَ إِلَيْكَ لِأَقْتُلَكَ ۖ إِنِّىٓ أَخَافُ ٱللَّهَ رَبَّ ٱلْعَٰلَمِينَ',
		number_in_surah: '28',
		page: '112',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '698',
		number: '698',
		text: 'إِنِّىٓ أُرِيدُ أَن تَبُوٓأَ بِإِثْمِى وَإِثْمِكَ فَتَكُونَ مِنْ أَصْحَٰبِ ٱلنَّارِ ۚ وَذَٰلِكَ جَزَٰٓؤُا۟ ٱلظَّٰلِمِينَ',
		number_in_surah: '29',
		page: '112',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '699',
		number: '699',
		text: 'فَطَوَّعَتْ لَهُۥ نَفْسُهُۥ قَتْلَ أَخِيهِ فَقَتَلَهُۥ فَأَصْبَحَ مِنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '30',
		page: '112',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '700',
		number: '700',
		text: 'فَبَعَثَ ٱللَّهُ غُرَابًۭا يَبْحَثُ فِى ٱلْأَرْضِ لِيُرِيَهُۥ كَيْفَ يُوَٰرِى سَوْءَةَ أَخِيهِ ۚ قَالَ يَٰوَيْلَتَىٰٓ أَعَجَزْتُ أَنْ أَكُونَ مِثْلَ هَٰذَا ٱلْغُرَابِ فَأُوَٰرِىَ سَوْءَةَ أَخِى ۖ فَأَصْبَحَ مِنَ ٱلنَّٰدِمِينَ',
		number_in_surah: '31',
		page: '112',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '701',
		number: '701',
		text: 'مِنْ أَجْلِ ذَٰلِكَ كَتَبْنَا عَلَىٰ بَنِىٓ إِسْرَٰٓءِيلَ أَنَّهُۥ مَن قَتَلَ نَفْسًۢا بِغَيْرِ نَفْسٍ أَوْ فَسَادٍۢ فِى ٱلْأَرْضِ فَكَأَنَّمَا قَتَلَ ٱلنَّاسَ جَمِيعًۭا وَمَنْ أَحْيَاهَا فَكَأَنَّمَآ أَحْيَا ٱلنَّاسَ جَمِيعًۭا ۚ وَلَقَدْ جَآءَتْهُمْ رُسُلُنَا بِٱلْبَيِّنَٰتِ ثُمَّ إِنَّ كَثِيرًۭا مِّنْهُم بَعْدَ ذَٰلِكَ فِى ٱلْأَرْضِ لَمُسْرِفُونَ',
		number_in_surah: '32',
		page: '113',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '702',
		number: '702',
		text: 'إِنَّمَا جَزَٰٓؤُا۟ ٱلَّذِينَ يُحَارِبُونَ ٱللَّهَ وَرَسُولَهُۥ وَيَسْعَوْنَ فِى ٱلْأَرْضِ فَسَادًا أَن يُقَتَّلُوٓا۟ أَوْ يُصَلَّبُوٓا۟ أَوْ تُقَطَّعَ أَيْدِيهِمْ وَأَرْجُلُهُم مِّنْ خِلَٰفٍ أَوْ يُنفَوْا۟ مِنَ ٱلْأَرْضِ ۚ ذَٰلِكَ لَهُمْ خِزْىٌۭ فِى ٱلدُّنْيَا ۖ وَلَهُمْ فِى ٱلْءَاخِرَةِ عَذَابٌ عَظِيمٌ',
		number_in_surah: '33',
		page: '113',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '703',
		number: '703',
		text: 'إِلَّا ٱلَّذِينَ تَابُوا۟ مِن قَبْلِ أَن تَقْدِرُوا۟ عَلَيْهِمْ ۖ فَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '34',
		page: '113',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '704',
		number: '704',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱتَّقُوا۟ ٱللَّهَ وَٱبْتَغُوٓا۟ إِلَيْهِ ٱلْوَسِيلَةَ وَجَٰهِدُوا۟ فِى سَبِيلِهِۦ لَعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '35',
		page: '113',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '705',
		number: '705',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ لَوْ أَنَّ لَهُم مَّا فِى ٱلْأَرْضِ جَمِيعًۭا وَمِثْلَهُۥ مَعَهُۥ لِيَفْتَدُوا۟ بِهِۦ مِنْ عَذَابِ يَوْمِ ٱلْقِيَٰمَةِ مَا تُقُبِّلَ مِنْهُمْ ۖ وَلَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '36',
		page: '113',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '706',
		number: '706',
		text: 'يُرِيدُونَ أَن يَخْرُجُوا۟ مِنَ ٱلنَّارِ وَمَا هُم بِخَٰرِجِينَ مِنْهَا ۖ وَلَهُمْ عَذَابٌۭ مُّقِيمٌۭ',
		number_in_surah: '37',
		page: '114',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '707',
		number: '707',
		text: 'وَٱلسَّارِقُ وَٱلسَّارِقَةُ فَٱقْطَعُوٓا۟ أَيْدِيَهُمَا جَزَآءًۢ بِمَا كَسَبَا نَكَٰلًۭا مِّنَ ٱللَّهِ ۗ وَٱللَّهُ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '38',
		page: '114',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '708',
		number: '708',
		text: 'فَمَن تَابَ مِنۢ بَعْدِ ظُلْمِهِۦ وَأَصْلَحَ فَإِنَّ ٱللَّهَ يَتُوبُ عَلَيْهِ ۗ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '39',
		page: '114',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '709',
		number: '709',
		text: 'أَلَمْ تَعْلَمْ أَنَّ ٱللَّهَ لَهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ يُعَذِّبُ مَن يَشَآءُ وَيَغْفِرُ لِمَن يَشَآءُ ۗ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '40',
		page: '114',
		surah_id: '5',
		hizb_id: '45',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '710',
		number: '710',
		text: '۞ يَٰٓأَيُّهَا ٱلرَّسُولُ لَا يَحْزُنكَ ٱلَّذِينَ يُسَٰرِعُونَ فِى ٱلْكُفْرِ مِنَ ٱلَّذِينَ قَالُوٓا۟ ءَامَنَّا بِأَفْوَٰهِهِمْ وَلَمْ تُؤْمِن قُلُوبُهُمْ ۛ وَمِنَ ٱلَّذِينَ هَادُوا۟ ۛ سَمَّٰعُونَ لِلْكَذِبِ سَمَّٰعُونَ لِقَوْمٍ ءَاخَرِينَ لَمْ يَأْتُوكَ ۖ يُحَرِّفُونَ ٱلْكَلِمَ مِنۢ بَعْدِ مَوَاضِعِهِۦ ۖ يَقُولُونَ إِنْ أُوتِيتُمْ هَٰذَا فَخُذُوهُ وَإِن لَّمْ تُؤْتَوْهُ فَٱحْذَرُوا۟ ۚ وَمَن يُرِدِ ٱللَّهُ فِتْنَتَهُۥ فَلَن تَمْلِكَ لَهُۥ مِنَ ٱللَّهِ شَيْـًٔا ۚ أُو۟لَٰٓئِكَ ٱلَّذِينَ لَمْ يُرِدِ ٱللَّهُ أَن يُطَهِّرَ قُلُوبَهُمْ ۚ لَهُمْ فِى ٱلدُّنْيَا خِزْىٌۭ ۖ وَلَهُمْ فِى ٱلْءَاخِرَةِ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '41',
		page: '114',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '711',
		number: '711',
		text: 'سَمَّٰعُونَ لِلْكَذِبِ أَكَّٰلُونَ لِلسُّحْتِ ۚ فَإِن جَآءُوكَ فَٱحْكُم بَيْنَهُمْ أَوْ أَعْرِضْ عَنْهُمْ ۖ وَإِن تُعْرِضْ عَنْهُمْ فَلَن يَضُرُّوكَ شَيْـًۭٔا ۖ وَإِنْ حَكَمْتَ فَٱحْكُم بَيْنَهُم بِٱلْقِسْطِ ۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلْمُقْسِطِينَ',
		number_in_surah: '42',
		page: '115',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '712',
		number: '712',
		text: 'وَكَيْفَ يُحَكِّمُونَكَ وَعِندَهُمُ ٱلتَّوْرَىٰةُ فِيهَا حُكْمُ ٱللَّهِ ثُمَّ يَتَوَلَّوْنَ مِنۢ بَعْدِ ذَٰلِكَ ۚ وَمَآ أُو۟لَٰٓئِكَ بِٱلْمُؤْمِنِينَ',
		number_in_surah: '43',
		page: '115',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:55',
		updated_at: '2018-06-07 08:06:55',
	},
	{
		id: '713',
		number: '713',
		text: 'إِنَّآ أَنزَلْنَا ٱلتَّوْرَىٰةَ فِيهَا هُدًۭى وَنُورٌۭ ۚ يَحْكُمُ بِهَا ٱلنَّبِيُّونَ ٱلَّذِينَ أَسْلَمُوا۟ لِلَّذِينَ هَادُوا۟ وَٱلرَّبَّٰنِيُّونَ وَٱلْأَحْبَارُ بِمَا ٱسْتُحْفِظُوا۟ مِن كِتَٰبِ ٱللَّهِ وَكَانُوا۟ عَلَيْهِ شُهَدَآءَ ۚ فَلَا تَخْشَوُا۟ ٱلنَّاسَ وَٱخْشَوْنِ وَلَا تَشْتَرُوا۟ بِـَٔايَٰتِى ثَمَنًۭا قَلِيلًۭا ۚ وَمَن لَّمْ يَحْكُم بِمَآ أَنزَلَ ٱللَّهُ فَأُو۟لَٰٓئِكَ هُمُ ٱلْكَٰفِرُونَ',
		number_in_surah: '44',
		page: '115',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '714',
		number: '714',
		text: 'وَكَتَبْنَا عَلَيْهِمْ فِيهَآ أَنَّ ٱلنَّفْسَ بِٱلنَّفْسِ وَٱلْعَيْنَ بِٱلْعَيْنِ وَٱلْأَنفَ بِٱلْأَنفِ وَٱلْأُذُنَ بِٱلْأُذُنِ وَٱلسِّنَّ بِٱلسِّنِّ وَٱلْجُرُوحَ قِصَاصٌۭ ۚ فَمَن تَصَدَّقَ بِهِۦ فَهُوَ كَفَّارَةٌۭ لَّهُۥ ۚ وَمَن لَّمْ يَحْكُم بِمَآ أَنزَلَ ٱللَّهُ فَأُو۟لَٰٓئِكَ هُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '45',
		page: '115',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '715',
		number: '715',
		text: 'وَقَفَّيْنَا عَلَىٰٓ ءَاثَٰرِهِم بِعِيسَى ٱبْنِ مَرْيَمَ مُصَدِّقًۭا لِّمَا بَيْنَ يَدَيْهِ مِنَ ٱلتَّوْرَىٰةِ ۖ وَءَاتَيْنَٰهُ ٱلْإِنجِيلَ فِيهِ هُدًۭى وَنُورٌۭ وَمُصَدِّقًۭا لِّمَا بَيْنَ يَدَيْهِ مِنَ ٱلتَّوْرَىٰةِ وَهُدًۭى وَمَوْعِظَةًۭ لِّلْمُتَّقِينَ',
		number_in_surah: '46',
		page: '116',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '716',
		number: '716',
		text: 'وَلْيَحْكُمْ أَهْلُ ٱلْإِنجِيلِ بِمَآ أَنزَلَ ٱللَّهُ فِيهِ ۚ وَمَن لَّمْ يَحْكُم بِمَآ أَنزَلَ ٱللَّهُ فَأُو۟لَٰٓئِكَ هُمُ ٱلْفَٰسِقُونَ',
		number_in_surah: '47',
		page: '116',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '717',
		number: '717',
		text: 'وَأَنزَلْنَآ إِلَيْكَ ٱلْكِتَٰبَ بِٱلْحَقِّ مُصَدِّقًۭا لِّمَا بَيْنَ يَدَيْهِ مِنَ ٱلْكِتَٰبِ وَمُهَيْمِنًا عَلَيْهِ ۖ فَٱحْكُم بَيْنَهُم بِمَآ أَنزَلَ ٱللَّهُ ۖ وَلَا تَتَّبِعْ أَهْوَآءَهُمْ عَمَّا جَآءَكَ مِنَ ٱلْحَقِّ ۚ لِكُلٍّۢ جَعَلْنَا مِنكُمْ شِرْعَةًۭ وَمِنْهَاجًۭا ۚ وَلَوْ شَآءَ ٱللَّهُ لَجَعَلَكُمْ أُمَّةًۭ وَٰحِدَةًۭ وَلَٰكِن لِّيَبْلُوَكُمْ فِى مَآ ءَاتَىٰكُمْ ۖ فَٱسْتَبِقُوا۟ ٱلْخَيْرَٰتِ ۚ إِلَى ٱللَّهِ مَرْجِعُكُمْ جَمِيعًۭا فَيُنَبِّئُكُم بِمَا كُنتُمْ فِيهِ تَخْتَلِفُونَ',
		number_in_surah: '48',
		page: '116',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '718',
		number: '718',
		text: 'وَأَنِ ٱحْكُم بَيْنَهُم بِمَآ أَنزَلَ ٱللَّهُ وَلَا تَتَّبِعْ أَهْوَآءَهُمْ وَٱحْذَرْهُمْ أَن يَفْتِنُوكَ عَنۢ بَعْضِ مَآ أَنزَلَ ٱللَّهُ إِلَيْكَ ۖ فَإِن تَوَلَّوْا۟ فَٱعْلَمْ أَنَّمَا يُرِيدُ ٱللَّهُ أَن يُصِيبَهُم بِبَعْضِ ذُنُوبِهِمْ ۗ وَإِنَّ كَثِيرًۭا مِّنَ ٱلنَّاسِ لَفَٰسِقُونَ',
		number_in_surah: '49',
		page: '116',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '719',
		number: '719',
		text: 'أَفَحُكْمَ ٱلْجَٰهِلِيَّةِ يَبْغُونَ ۚ وَمَنْ أَحْسَنُ مِنَ ٱللَّهِ حُكْمًۭا لِّقَوْمٍۢ يُوقِنُونَ',
		number_in_surah: '50',
		page: '116',
		surah_id: '5',
		hizb_id: '46',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '720',
		number: '720',
		text: '۞ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَتَّخِذُوا۟ ٱلْيَهُودَ وَٱلنَّصَٰرَىٰٓ أَوْلِيَآءَ ۘ بَعْضُهُمْ أَوْلِيَآءُ بَعْضٍۢ ۚ وَمَن يَتَوَلَّهُم مِّنكُمْ فَإِنَّهُۥ مِنْهُمْ ۗ إِنَّ ٱللَّهَ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '51',
		page: '117',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '721',
		number: '721',
		text: 'فَتَرَى ٱلَّذِينَ فِى قُلُوبِهِم مَّرَضٌۭ يُسَٰرِعُونَ فِيهِمْ يَقُولُونَ نَخْشَىٰٓ أَن تُصِيبَنَا دَآئِرَةٌۭ ۚ فَعَسَى ٱللَّهُ أَن يَأْتِىَ بِٱلْفَتْحِ أَوْ أَمْرٍۢ مِّنْ عِندِهِۦ فَيُصْبِحُوا۟ عَلَىٰ مَآ أَسَرُّوا۟ فِىٓ أَنفُسِهِمْ نَٰدِمِينَ',
		number_in_surah: '52',
		page: '117',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '722',
		number: '722',
		text: 'وَيَقُولُ ٱلَّذِينَ ءَامَنُوٓا۟ أَهَٰٓؤُلَآءِ ٱلَّذِينَ أَقْسَمُوا۟ بِٱللَّهِ جَهْدَ أَيْمَٰنِهِمْ ۙ إِنَّهُمْ لَمَعَكُمْ ۚ حَبِطَتْ أَعْمَٰلُهُمْ فَأَصْبَحُوا۟ خَٰسِرِينَ',
		number_in_surah: '53',
		page: '117',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '723',
		number: '723',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ مَن يَرْتَدَّ مِنكُمْ عَن دِينِهِۦ فَسَوْفَ يَأْتِى ٱللَّهُ بِقَوْمٍۢ يُحِبُّهُمْ وَيُحِبُّونَهُۥٓ أَذِلَّةٍ عَلَى ٱلْمُؤْمِنِينَ أَعِزَّةٍ عَلَى ٱلْكَٰفِرِينَ يُجَٰهِدُونَ فِى سَبِيلِ ٱللَّهِ وَلَا يَخَافُونَ لَوْمَةَ لَآئِمٍۢ ۚ ذَٰلِكَ فَضْلُ ٱللَّهِ يُؤْتِيهِ مَن يَشَآءُ ۚ وَٱللَّهُ وَٰسِعٌ عَلِيمٌ',
		number_in_surah: '54',
		page: '117',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '724',
		number: '724',
		text: 'إِنَّمَا وَلِيُّكُمُ ٱللَّهُ وَرَسُولُهُۥ وَٱلَّذِينَ ءَامَنُوا۟ ٱلَّذِينَ يُقِيمُونَ ٱلصَّلَوٰةَ وَيُؤْتُونَ ٱلزَّكَوٰةَ وَهُمْ رَٰكِعُونَ',
		number_in_surah: '55',
		page: '117',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '725',
		number: '725',
		text: 'وَمَن يَتَوَلَّ ٱللَّهَ وَرَسُولَهُۥ وَٱلَّذِينَ ءَامَنُوا۟ فَإِنَّ حِزْبَ ٱللَّهِ هُمُ ٱلْغَٰلِبُونَ',
		number_in_surah: '56',
		page: '117',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '726',
		number: '726',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَتَّخِذُوا۟ ٱلَّذِينَ ٱتَّخَذُوا۟ دِينَكُمْ هُزُوًۭا وَلَعِبًۭا مِّنَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ مِن قَبْلِكُمْ وَٱلْكُفَّارَ أَوْلِيَآءَ ۚ وَٱتَّقُوا۟ ٱللَّهَ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '57',
		page: '117',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '727',
		number: '727',
		text: 'وَإِذَا نَادَيْتُمْ إِلَى ٱلصَّلَوٰةِ ٱتَّخَذُوهَا هُزُوًۭا وَلَعِبًۭا ۚ ذَٰلِكَ بِأَنَّهُمْ قَوْمٌۭ لَّا يَعْقِلُونَ',
		number_in_surah: '58',
		page: '118',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '728',
		number: '728',
		text: 'قُلْ يَٰٓأَهْلَ ٱلْكِتَٰبِ هَلْ تَنقِمُونَ مِنَّآ إِلَّآ أَنْ ءَامَنَّا بِٱللَّهِ وَمَآ أُنزِلَ إِلَيْنَا وَمَآ أُنزِلَ مِن قَبْلُ وَأَنَّ أَكْثَرَكُمْ فَٰسِقُونَ',
		number_in_surah: '59',
		page: '118',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '729',
		number: '729',
		text: 'قُلْ هَلْ أُنَبِّئُكُم بِشَرٍّۢ مِّن ذَٰلِكَ مَثُوبَةً عِندَ ٱللَّهِ ۚ مَن لَّعَنَهُ ٱللَّهُ وَغَضِبَ عَلَيْهِ وَجَعَلَ مِنْهُمُ ٱلْقِرَدَةَ وَٱلْخَنَازِيرَ وَعَبَدَ ٱلطَّٰغُوتَ ۚ أُو۟لَٰٓئِكَ شَرٌّۭ مَّكَانًۭا وَأَضَلُّ عَن سَوَآءِ ٱلسَّبِيلِ',
		number_in_surah: '60',
		page: '118',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '730',
		number: '730',
		text: 'وَإِذَا جَآءُوكُمْ قَالُوٓا۟ ءَامَنَّا وَقَد دَّخَلُوا۟ بِٱلْكُفْرِ وَهُمْ قَدْ خَرَجُوا۟ بِهِۦ ۚ وَٱللَّهُ أَعْلَمُ بِمَا كَانُوا۟ يَكْتُمُونَ',
		number_in_surah: '61',
		page: '118',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '731',
		number: '731',
		text: 'وَتَرَىٰ كَثِيرًۭا مِّنْهُمْ يُسَٰرِعُونَ فِى ٱلْإِثْمِ وَٱلْعُدْوَٰنِ وَأَكْلِهِمُ ٱلسُّحْتَ ۚ لَبِئْسَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '62',
		page: '118',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '732',
		number: '732',
		text: 'لَوْلَا يَنْهَىٰهُمُ ٱلرَّبَّٰنِيُّونَ وَٱلْأَحْبَارُ عَن قَوْلِهِمُ ٱلْإِثْمَ وَأَكْلِهِمُ ٱلسُّحْتَ ۚ لَبِئْسَ مَا كَانُوا۟ يَصْنَعُونَ',
		number_in_surah: '63',
		page: '118',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '733',
		number: '733',
		text: 'وَقَالَتِ ٱلْيَهُودُ يَدُ ٱللَّهِ مَغْلُولَةٌ ۚ غُلَّتْ أَيْدِيهِمْ وَلُعِنُوا۟ بِمَا قَالُوا۟ ۘ بَلْ يَدَاهُ مَبْسُوطَتَانِ يُنفِقُ كَيْفَ يَشَآءُ ۚ وَلَيَزِيدَنَّ كَثِيرًۭا مِّنْهُم مَّآ أُنزِلَ إِلَيْكَ مِن رَّبِّكَ طُغْيَٰنًۭا وَكُفْرًۭا ۚ وَأَلْقَيْنَا بَيْنَهُمُ ٱلْعَدَٰوَةَ وَٱلْبَغْضَآءَ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ ۚ كُلَّمَآ أَوْقَدُوا۟ نَارًۭا لِّلْحَرْبِ أَطْفَأَهَا ٱللَّهُ ۚ وَيَسْعَوْنَ فِى ٱلْأَرْضِ فَسَادًۭا ۚ وَٱللَّهُ لَا يُحِبُّ ٱلْمُفْسِدِينَ',
		number_in_surah: '64',
		page: '118',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '734',
		number: '734',
		text: 'وَلَوْ أَنَّ أَهْلَ ٱلْكِتَٰبِ ءَامَنُوا۟ وَٱتَّقَوْا۟ لَكَفَّرْنَا عَنْهُمْ سَيِّـَٔاتِهِمْ وَلَأَدْخَلْنَٰهُمْ جَنَّٰتِ ٱلنَّعِيمِ',
		number_in_surah: '65',
		page: '119',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '735',
		number: '735',
		text: 'وَلَوْ أَنَّهُمْ أَقَامُوا۟ ٱلتَّوْرَىٰةَ وَٱلْإِنجِيلَ وَمَآ أُنزِلَ إِلَيْهِم مِّن رَّبِّهِمْ لَأَكَلُوا۟ مِن فَوْقِهِمْ وَمِن تَحْتِ أَرْجُلِهِم ۚ مِّنْهُمْ أُمَّةٌۭ مُّقْتَصِدَةٌۭ ۖ وَكَثِيرٌۭ مِّنْهُمْ سَآءَ مَا يَعْمَلُونَ',
		number_in_surah: '66',
		page: '119',
		surah_id: '5',
		hizb_id: '47',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '736',
		number: '736',
		text: '۞ يَٰٓأَيُّهَا ٱلرَّسُولُ بَلِّغْ مَآ أُنزِلَ إِلَيْكَ مِن رَّبِّكَ ۖ وَإِن لَّمْ تَفْعَلْ فَمَا بَلَّغْتَ رِسَالَتَهُۥ ۚ وَٱللَّهُ يَعْصِمُكَ مِنَ ٱلنَّاسِ ۗ إِنَّ ٱللَّهَ لَا يَهْدِى ٱلْقَوْمَ ٱلْكَٰفِرِينَ',
		number_in_surah: '67',
		page: '119',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '737',
		number: '737',
		text: 'قُلْ يَٰٓأَهْلَ ٱلْكِتَٰبِ لَسْتُمْ عَلَىٰ شَىْءٍ حَتَّىٰ تُقِيمُوا۟ ٱلتَّوْرَىٰةَ وَٱلْإِنجِيلَ وَمَآ أُنزِلَ إِلَيْكُم مِّن رَّبِّكُمْ ۗ وَلَيَزِيدَنَّ كَثِيرًۭا مِّنْهُم مَّآ أُنزِلَ إِلَيْكَ مِن رَّبِّكَ طُغْيَٰنًۭا وَكُفْرًۭا ۖ فَلَا تَأْسَ عَلَى ٱلْقَوْمِ ٱلْكَٰفِرِينَ',
		number_in_surah: '68',
		page: '119',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '738',
		number: '738',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَٱلَّذِينَ هَادُوا۟ وَٱلصَّٰبِـُٔونَ وَٱلنَّصَٰرَىٰ مَنْ ءَامَنَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَعَمِلَ صَٰلِحًۭا فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '69',
		page: '119',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '739',
		number: '739',
		text: 'لَقَدْ أَخَذْنَا مِيثَٰقَ بَنِىٓ إِسْرَٰٓءِيلَ وَأَرْسَلْنَآ إِلَيْهِمْ رُسُلًۭا ۖ كُلَّمَا جَآءَهُمْ رَسُولٌۢ بِمَا لَا تَهْوَىٰٓ أَنفُسُهُمْ فَرِيقًۭا كَذَّبُوا۟ وَفَرِيقًۭا يَقْتُلُونَ',
		number_in_surah: '70',
		page: '119',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '740',
		number: '740',
		text: 'وَحَسِبُوٓا۟ أَلَّا تَكُونَ فِتْنَةٌۭ فَعَمُوا۟ وَصَمُّوا۟ ثُمَّ تَابَ ٱللَّهُ عَلَيْهِمْ ثُمَّ عَمُوا۟ وَصَمُّوا۟ كَثِيرٌۭ مِّنْهُمْ ۚ وَٱللَّهُ بَصِيرٌۢ بِمَا يَعْمَلُونَ',
		number_in_surah: '71',
		page: '120',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '741',
		number: '741',
		text: 'لَقَدْ كَفَرَ ٱلَّذِينَ قَالُوٓا۟ إِنَّ ٱللَّهَ هُوَ ٱلْمَسِيحُ ٱبْنُ مَرْيَمَ ۖ وَقَالَ ٱلْمَسِيحُ يَٰبَنِىٓ إِسْرَٰٓءِيلَ ٱعْبُدُوا۟ ٱللَّهَ رَبِّى وَرَبَّكُمْ ۖ إِنَّهُۥ مَن يُشْرِكْ بِٱللَّهِ فَقَدْ حَرَّمَ ٱللَّهُ عَلَيْهِ ٱلْجَنَّةَ وَمَأْوَىٰهُ ٱلنَّارُ ۖ وَمَا لِلظَّٰلِمِينَ مِنْ أَنصَارٍۢ',
		number_in_surah: '72',
		page: '120',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '742',
		number: '742',
		text: 'لَّقَدْ كَفَرَ ٱلَّذِينَ قَالُوٓا۟ إِنَّ ٱللَّهَ ثَالِثُ ثَلَٰثَةٍۢ ۘ وَمَا مِنْ إِلَٰهٍ إِلَّآ إِلَٰهٌۭ وَٰحِدٌۭ ۚ وَإِن لَّمْ يَنتَهُوا۟ عَمَّا يَقُولُونَ لَيَمَسَّنَّ ٱلَّذِينَ كَفَرُوا۟ مِنْهُمْ عَذَابٌ أَلِيمٌ',
		number_in_surah: '73',
		page: '120',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '743',
		number: '743',
		text: 'أَفَلَا يَتُوبُونَ إِلَى ٱللَّهِ وَيَسْتَغْفِرُونَهُۥ ۚ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '74',
		page: '120',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '744',
		number: '744',
		text: 'مَّا ٱلْمَسِيحُ ٱبْنُ مَرْيَمَ إِلَّا رَسُولٌۭ قَدْ خَلَتْ مِن قَبْلِهِ ٱلرُّسُلُ وَأُمُّهُۥ صِدِّيقَةٌۭ ۖ كَانَا يَأْكُلَانِ ٱلطَّعَامَ ۗ ٱنظُرْ كَيْفَ نُبَيِّنُ لَهُمُ ٱلْءَايَٰتِ ثُمَّ ٱنظُرْ أَنَّىٰ يُؤْفَكُونَ',
		number_in_surah: '75',
		page: '120',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '745',
		number: '745',
		text: 'قُلْ أَتَعْبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَمْلِكُ لَكُمْ ضَرًّۭا وَلَا نَفْعًۭا ۚ وَٱللَّهُ هُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '76',
		page: '120',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '746',
		number: '746',
		text: 'قُلْ يَٰٓأَهْلَ ٱلْكِتَٰبِ لَا تَغْلُوا۟ فِى دِينِكُمْ غَيْرَ ٱلْحَقِّ وَلَا تَتَّبِعُوٓا۟ أَهْوَآءَ قَوْمٍۢ قَدْ ضَلُّوا۟ مِن قَبْلُ وَأَضَلُّوا۟ كَثِيرًۭا وَضَلُّوا۟ عَن سَوَآءِ ٱلسَّبِيلِ',
		number_in_surah: '77',
		page: '121',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '747',
		number: '747',
		text: 'لُعِنَ ٱلَّذِينَ كَفَرُوا۟ مِنۢ بَنِىٓ إِسْرَٰٓءِيلَ عَلَىٰ لِسَانِ دَاوُۥدَ وَعِيسَى ٱبْنِ مَرْيَمَ ۚ ذَٰلِكَ بِمَا عَصَوا۟ وَّكَانُوا۟ يَعْتَدُونَ',
		number_in_surah: '78',
		page: '121',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '748',
		number: '748',
		text: 'كَانُوا۟ لَا يَتَنَاهَوْنَ عَن مُّنكَرٍۢ فَعَلُوهُ ۚ لَبِئْسَ مَا كَانُوا۟ يَفْعَلُونَ',
		number_in_surah: '79',
		page: '121',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '749',
		number: '749',
		text: 'تَرَىٰ كَثِيرًۭا مِّنْهُمْ يَتَوَلَّوْنَ ٱلَّذِينَ كَفَرُوا۟ ۚ لَبِئْسَ مَا قَدَّمَتْ لَهُمْ أَنفُسُهُمْ أَن سَخِطَ ٱللَّهُ عَلَيْهِمْ وَفِى ٱلْعَذَابِ هُمْ خَٰلِدُونَ',
		number_in_surah: '80',
		page: '121',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '750',
		number: '750',
		text: 'وَلَوْ كَانُوا۟ يُؤْمِنُونَ بِٱللَّهِ وَٱلنَّبِىِّ وَمَآ أُنزِلَ إِلَيْهِ مَا ٱتَّخَذُوهُمْ أَوْلِيَآءَ وَلَٰكِنَّ كَثِيرًۭا مِّنْهُمْ فَٰسِقُونَ',
		number_in_surah: '81',
		page: '121',
		surah_id: '5',
		hizb_id: '48',
		juz_id: '6',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '751',
		number: '751',
		text: '۞ لَتَجِدَنَّ أَشَدَّ ٱلنَّاسِ عَدَٰوَةًۭ لِّلَّذِينَ ءَامَنُوا۟ ٱلْيَهُودَ وَٱلَّذِينَ أَشْرَكُوا۟ ۖ وَلَتَجِدَنَّ أَقْرَبَهُم مَّوَدَّةًۭ لِّلَّذِينَ ءَامَنُوا۟ ٱلَّذِينَ قَالُوٓا۟ إِنَّا نَصَٰرَىٰ ۚ ذَٰلِكَ بِأَنَّ مِنْهُمْ قِسِّيسِينَ وَرُهْبَانًۭا وَأَنَّهُمْ لَا يَسْتَكْبِرُونَ',
		number_in_surah: '82',
		page: '121',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '752',
		number: '752',
		text: 'وَإِذَا سَمِعُوا۟ مَآ أُنزِلَ إِلَى ٱلرَّسُولِ تَرَىٰٓ أَعْيُنَهُمْ تَفِيضُ مِنَ ٱلدَّمْعِ مِمَّا عَرَفُوا۟ مِنَ ٱلْحَقِّ ۖ يَقُولُونَ رَبَّنَآ ءَامَنَّا فَٱكْتُبْنَا مَعَ ٱلشَّٰهِدِينَ',
		number_in_surah: '83',
		page: '122',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '753',
		number: '753',
		text: 'وَمَا لَنَا لَا نُؤْمِنُ بِٱللَّهِ وَمَا جَآءَنَا مِنَ ٱلْحَقِّ وَنَطْمَعُ أَن يُدْخِلَنَا رَبُّنَا مَعَ ٱلْقَوْمِ ٱلصَّٰلِحِينَ',
		number_in_surah: '84',
		page: '122',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '754',
		number: '754',
		text: 'فَأَثَٰبَهُمُ ٱللَّهُ بِمَا قَالُوا۟ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا ۚ وَذَٰلِكَ جَزَآءُ ٱلْمُحْسِنِينَ',
		number_in_surah: '85',
		page: '122',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '755',
		number: '755',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ وَكَذَّبُوا۟ بِـَٔايَٰتِنَآ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَحِيمِ',
		number_in_surah: '86',
		page: '122',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '756',
		number: '756',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تُحَرِّمُوا۟ طَيِّبَٰتِ مَآ أَحَلَّ ٱللَّهُ لَكُمْ وَلَا تَعْتَدُوٓا۟ ۚ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلْمُعْتَدِينَ',
		number_in_surah: '87',
		page: '122',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '757',
		number: '757',
		text: 'وَكُلُوا۟ مِمَّا رَزَقَكُمُ ٱللَّهُ حَلَٰلًۭا طَيِّبًۭا ۚ وَٱتَّقُوا۟ ٱللَّهَ ٱلَّذِىٓ أَنتُم بِهِۦ مُؤْمِنُونَ',
		number_in_surah: '88',
		page: '122',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '758',
		number: '758',
		text: 'لَا يُؤَاخِذُكُمُ ٱللَّهُ بِٱللَّغْوِ فِىٓ أَيْمَٰنِكُمْ وَلَٰكِن يُؤَاخِذُكُم بِمَا عَقَّدتُّمُ ٱلْأَيْمَٰنَ ۖ فَكَفَّٰرَتُهُۥٓ إِطْعَامُ عَشَرَةِ مَسَٰكِينَ مِنْ أَوْسَطِ مَا تُطْعِمُونَ أَهْلِيكُمْ أَوْ كِسْوَتُهُمْ أَوْ تَحْرِيرُ رَقَبَةٍۢ ۖ فَمَن لَّمْ يَجِدْ فَصِيَامُ ثَلَٰثَةِ أَيَّامٍۢ ۚ ذَٰلِكَ كَفَّٰرَةُ أَيْمَٰنِكُمْ إِذَا حَلَفْتُمْ ۚ وَٱحْفَظُوٓا۟ أَيْمَٰنَكُمْ ۚ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمْ ءَايَٰتِهِۦ لَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '89',
		page: '122',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '759',
		number: '759',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِنَّمَا ٱلْخَمْرُ وَٱلْمَيْسِرُ وَٱلْأَنصَابُ وَٱلْأَزْلَٰمُ رِجْسٌۭ مِّنْ عَمَلِ ٱلشَّيْطَٰنِ فَٱجْتَنِبُوهُ لَعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '90',
		page: '123',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '760',
		number: '760',
		text: 'إِنَّمَا يُرِيدُ ٱلشَّيْطَٰنُ أَن يُوقِعَ بَيْنَكُمُ ٱلْعَدَٰوَةَ وَٱلْبَغْضَآءَ فِى ٱلْخَمْرِ وَٱلْمَيْسِرِ وَيَصُدَّكُمْ عَن ذِكْرِ ٱللَّهِ وَعَنِ ٱلصَّلَوٰةِ ۖ فَهَلْ أَنتُم مُّنتَهُونَ',
		number_in_surah: '91',
		page: '123',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '761',
		number: '761',
		text: 'وَأَطِيعُوا۟ ٱللَّهَ وَأَطِيعُوا۟ ٱلرَّسُولَ وَٱحْذَرُوا۟ ۚ فَإِن تَوَلَّيْتُمْ فَٱعْلَمُوٓا۟ أَنَّمَا عَلَىٰ رَسُولِنَا ٱلْبَلَٰغُ ٱلْمُبِينُ',
		number_in_surah: '92',
		page: '123',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '762',
		number: '762',
		text: 'لَيْسَ عَلَى ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ جُنَاحٌۭ فِيمَا طَعِمُوٓا۟ إِذَا مَا ٱتَّقَوا۟ وَّءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ ثُمَّ ٱتَّقَوا۟ وَّءَامَنُوا۟ ثُمَّ ٱتَّقَوا۟ وَّأَحْسَنُوا۟ ۗ وَٱللَّهُ يُحِبُّ ٱلْمُحْسِنِينَ',
		number_in_surah: '93',
		page: '123',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '763',
		number: '763',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَيَبْلُوَنَّكُمُ ٱللَّهُ بِشَىْءٍۢ مِّنَ ٱلصَّيْدِ تَنَالُهُۥٓ أَيْدِيكُمْ وَرِمَاحُكُمْ لِيَعْلَمَ ٱللَّهُ مَن يَخَافُهُۥ بِٱلْغَيْبِ ۚ فَمَنِ ٱعْتَدَىٰ بَعْدَ ذَٰلِكَ فَلَهُۥ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '94',
		page: '123',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '764',
		number: '764',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَقْتُلُوا۟ ٱلصَّيْدَ وَأَنتُمْ حُرُمٌۭ ۚ وَمَن قَتَلَهُۥ مِنكُم مُّتَعَمِّدًۭا فَجَزَآءٌۭ مِّثْلُ مَا قَتَلَ مِنَ ٱلنَّعَمِ يَحْكُمُ بِهِۦ ذَوَا عَدْلٍۢ مِّنكُمْ هَدْيًۢا بَٰلِغَ ٱلْكَعْبَةِ أَوْ كَفَّٰرَةٌۭ طَعَامُ مَسَٰكِينَ أَوْ عَدْلُ ذَٰلِكَ صِيَامًۭا لِّيَذُوقَ وَبَالَ أَمْرِهِۦ ۗ عَفَا ٱللَّهُ عَمَّا سَلَفَ ۚ وَمَنْ عَادَ فَيَنتَقِمُ ٱللَّهُ مِنْهُ ۗ وَٱللَّهُ عَزِيزٌۭ ذُو ٱنتِقَامٍ',
		number_in_surah: '95',
		page: '123',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '765',
		number: '765',
		text: 'أُحِلَّ لَكُمْ صَيْدُ ٱلْبَحْرِ وَطَعَامُهُۥ مَتَٰعًۭا لَّكُمْ وَلِلسَّيَّارَةِ ۖ وَحُرِّمَ عَلَيْكُمْ صَيْدُ ٱلْبَرِّ مَا دُمْتُمْ حُرُمًۭا ۗ وَٱتَّقُوا۟ ٱللَّهَ ٱلَّذِىٓ إِلَيْهِ تُحْشَرُونَ',
		number_in_surah: '96',
		page: '124',
		surah_id: '5',
		hizb_id: '49',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '766',
		number: '766',
		text: '۞ جَعَلَ ٱللَّهُ ٱلْكَعْبَةَ ٱلْبَيْتَ ٱلْحَرَامَ قِيَٰمًۭا لِّلنَّاسِ وَٱلشَّهْرَ ٱلْحَرَامَ وَٱلْهَدْىَ وَٱلْقَلَٰٓئِدَ ۚ ذَٰلِكَ لِتَعْلَمُوٓا۟ أَنَّ ٱللَّهَ يَعْلَمُ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ وَأَنَّ ٱللَّهَ بِكُلِّ شَىْءٍ عَلِيمٌ',
		number_in_surah: '97',
		page: '124',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '767',
		number: '767',
		text: 'ٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ شَدِيدُ ٱلْعِقَابِ وَأَنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '98',
		page: '124',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '768',
		number: '768',
		text: 'مَّا عَلَى ٱلرَّسُولِ إِلَّا ٱلْبَلَٰغُ ۗ وَٱللَّهُ يَعْلَمُ مَا تُبْدُونَ وَمَا تَكْتُمُونَ',
		number_in_surah: '99',
		page: '124',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '769',
		number: '769',
		text: 'قُل لَّا يَسْتَوِى ٱلْخَبِيثُ وَٱلطَّيِّبُ وَلَوْ أَعْجَبَكَ كَثْرَةُ ٱلْخَبِيثِ ۚ فَٱتَّقُوا۟ ٱللَّهَ يَٰٓأُو۟لِى ٱلْأَلْبَٰبِ لَعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '100',
		page: '124',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '770',
		number: '770',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَسْـَٔلُوا۟ عَنْ أَشْيَآءَ إِن تُبْدَ لَكُمْ تَسُؤْكُمْ وَإِن تَسْـَٔلُوا۟ عَنْهَا حِينَ يُنَزَّلُ ٱلْقُرْءَانُ تُبْدَ لَكُمْ عَفَا ٱللَّهُ عَنْهَا ۗ وَٱللَّهُ غَفُورٌ حَلِيمٌۭ',
		number_in_surah: '101',
		page: '124',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '771',
		number: '771',
		text: 'قَدْ سَأَلَهَا قَوْمٌۭ مِّن قَبْلِكُمْ ثُمَّ أَصْبَحُوا۟ بِهَا كَٰفِرِينَ',
		number_in_surah: '102',
		page: '124',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '772',
		number: '772',
		text: 'مَا جَعَلَ ٱللَّهُ مِنۢ بَحِيرَةٍۢ وَلَا سَآئِبَةٍۢ وَلَا وَصِيلَةٍۢ وَلَا حَامٍۢ ۙ وَلَٰكِنَّ ٱلَّذِينَ كَفَرُوا۟ يَفْتَرُونَ عَلَى ٱللَّهِ ٱلْكَذِبَ ۖ وَأَكْثَرُهُمْ لَا يَعْقِلُونَ',
		number_in_surah: '103',
		page: '124',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '773',
		number: '773',
		text: 'وَإِذَا قِيلَ لَهُمْ تَعَالَوْا۟ إِلَىٰ مَآ أَنزَلَ ٱللَّهُ وَإِلَى ٱلرَّسُولِ قَالُوا۟ حَسْبُنَا مَا وَجَدْنَا عَلَيْهِ ءَابَآءَنَآ ۚ أَوَلَوْ كَانَ ءَابَآؤُهُمْ لَا يَعْلَمُونَ شَيْـًۭٔا وَلَا يَهْتَدُونَ',
		number_in_surah: '104',
		page: '125',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '774',
		number: '774',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ عَلَيْكُمْ أَنفُسَكُمْ ۖ لَا يَضُرُّكُم مَّن ضَلَّ إِذَا ٱهْتَدَيْتُمْ ۚ إِلَى ٱللَّهِ مَرْجِعُكُمْ جَمِيعًۭا فَيُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '105',
		page: '125',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '775',
		number: '775',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ شَهَٰدَةُ بَيْنِكُمْ إِذَا حَضَرَ أَحَدَكُمُ ٱلْمَوْتُ حِينَ ٱلْوَصِيَّةِ ٱثْنَانِ ذَوَا عَدْلٍۢ مِّنكُمْ أَوْ ءَاخَرَانِ مِنْ غَيْرِكُمْ إِنْ أَنتُمْ ضَرَبْتُمْ فِى ٱلْأَرْضِ فَأَصَٰبَتْكُم مُّصِيبَةُ ٱلْمَوْتِ ۚ تَحْبِسُونَهُمَا مِنۢ بَعْدِ ٱلصَّلَوٰةِ فَيُقْسِمَانِ بِٱللَّهِ إِنِ ٱرْتَبْتُمْ لَا نَشْتَرِى بِهِۦ ثَمَنًۭا وَلَوْ كَانَ ذَا قُرْبَىٰ ۙ وَلَا نَكْتُمُ شَهَٰدَةَ ٱللَّهِ إِنَّآ إِذًۭا لَّمِنَ ٱلْءَاثِمِينَ',
		number_in_surah: '106',
		page: '125',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '776',
		number: '776',
		text: 'فَإِنْ عُثِرَ عَلَىٰٓ أَنَّهُمَا ٱسْتَحَقَّآ إِثْمًۭا فَـَٔاخَرَانِ يَقُومَانِ مَقَامَهُمَا مِنَ ٱلَّذِينَ ٱسْتَحَقَّ عَلَيْهِمُ ٱلْأَوْلَيَٰنِ فَيُقْسِمَانِ بِٱللَّهِ لَشَهَٰدَتُنَآ أَحَقُّ مِن شَهَٰدَتِهِمَا وَمَا ٱعْتَدَيْنَآ إِنَّآ إِذًۭا لَّمِنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '107',
		page: '125',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '777',
		number: '777',
		text: 'ذَٰلِكَ أَدْنَىٰٓ أَن يَأْتُوا۟ بِٱلشَّهَٰدَةِ عَلَىٰ وَجْهِهَآ أَوْ يَخَافُوٓا۟ أَن تُرَدَّ أَيْمَٰنٌۢ بَعْدَ أَيْمَٰنِهِمْ ۗ وَٱتَّقُوا۟ ٱللَّهَ وَٱسْمَعُوا۟ ۗ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلْفَٰسِقِينَ',
		number_in_surah: '108',
		page: '125',
		surah_id: '5',
		hizb_id: '50',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '778',
		number: '778',
		text: '۞ يَوْمَ يَجْمَعُ ٱللَّهُ ٱلرُّسُلَ فَيَقُولُ مَاذَآ أُجِبْتُمْ ۖ قَالُوا۟ لَا عِلْمَ لَنَآ ۖ إِنَّكَ أَنتَ عَلَّٰمُ ٱلْغُيُوبِ',
		number_in_surah: '109',
		page: '126',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '779',
		number: '779',
		text: 'إِذْ قَالَ ٱللَّهُ يَٰعِيسَى ٱبْنَ مَرْيَمَ ٱذْكُرْ نِعْمَتِى عَلَيْكَ وَعَلَىٰ وَٰلِدَتِكَ إِذْ أَيَّدتُّكَ بِرُوحِ ٱلْقُدُسِ تُكَلِّمُ ٱلنَّاسَ فِى ٱلْمَهْدِ وَكَهْلًۭا ۖ وَإِذْ عَلَّمْتُكَ ٱلْكِتَٰبَ وَٱلْحِكْمَةَ وَٱلتَّوْرَىٰةَ وَٱلْإِنجِيلَ ۖ وَإِذْ تَخْلُقُ مِنَ ٱلطِّينِ كَهَيْـَٔةِ ٱلطَّيْرِ بِإِذْنِى فَتَنفُخُ فِيهَا فَتَكُونُ طَيْرًۢا بِإِذْنِى ۖ وَتُبْرِئُ ٱلْأَكْمَهَ وَٱلْأَبْرَصَ بِإِذْنِى ۖ وَإِذْ تُخْرِجُ ٱلْمَوْتَىٰ بِإِذْنِى ۖ وَإِذْ كَفَفْتُ بَنِىٓ إِسْرَٰٓءِيلَ عَنكَ إِذْ جِئْتَهُم بِٱلْبَيِّنَٰتِ فَقَالَ ٱلَّذِينَ كَفَرُوا۟ مِنْهُمْ إِنْ هَٰذَآ إِلَّا سِحْرٌۭ مُّبِينٌۭ',
		number_in_surah: '110',
		page: '126',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '780',
		number: '780',
		text: 'وَإِذْ أَوْحَيْتُ إِلَى ٱلْحَوَارِيِّۦنَ أَنْ ءَامِنُوا۟ بِى وَبِرَسُولِى قَالُوٓا۟ ءَامَنَّا وَٱشْهَدْ بِأَنَّنَا مُسْلِمُونَ',
		number_in_surah: '111',
		page: '126',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '781',
		number: '781',
		text: 'إِذْ قَالَ ٱلْحَوَارِيُّونَ يَٰعِيسَى ٱبْنَ مَرْيَمَ هَلْ يَسْتَطِيعُ رَبُّكَ أَن يُنَزِّلَ عَلَيْنَا مَآئِدَةًۭ مِّنَ ٱلسَّمَآءِ ۖ قَالَ ٱتَّقُوا۟ ٱللَّهَ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '112',
		page: '126',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '782',
		number: '782',
		text: 'قَالُوا۟ نُرِيدُ أَن نَّأْكُلَ مِنْهَا وَتَطْمَئِنَّ قُلُوبُنَا وَنَعْلَمَ أَن قَدْ صَدَقْتَنَا وَنَكُونَ عَلَيْهَا مِنَ ٱلشَّٰهِدِينَ',
		number_in_surah: '113',
		page: '126',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '783',
		number: '783',
		text: 'قَالَ عِيسَى ٱبْنُ مَرْيَمَ ٱللَّهُمَّ رَبَّنَآ أَنزِلْ عَلَيْنَا مَآئِدَةًۭ مِّنَ ٱلسَّمَآءِ تَكُونُ لَنَا عِيدًۭا لِّأَوَّلِنَا وَءَاخِرِنَا وَءَايَةًۭ مِّنكَ ۖ وَٱرْزُقْنَا وَأَنتَ خَيْرُ ٱلرَّٰزِقِينَ',
		number_in_surah: '114',
		page: '127',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '784',
		number: '784',
		text: 'قَالَ ٱللَّهُ إِنِّى مُنَزِّلُهَا عَلَيْكُمْ ۖ فَمَن يَكْفُرْ بَعْدُ مِنكُمْ فَإِنِّىٓ أُعَذِّبُهُۥ عَذَابًۭا لَّآ أُعَذِّبُهُۥٓ أَحَدًۭا مِّنَ ٱلْعَٰلَمِينَ',
		number_in_surah: '115',
		page: '127',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '785',
		number: '785',
		text: 'وَإِذْ قَالَ ٱللَّهُ يَٰعِيسَى ٱبْنَ مَرْيَمَ ءَأَنتَ قُلْتَ لِلنَّاسِ ٱتَّخِذُونِى وَأُمِّىَ إِلَٰهَيْنِ مِن دُونِ ٱللَّهِ ۖ قَالَ سُبْحَٰنَكَ مَا يَكُونُ لِىٓ أَنْ أَقُولَ مَا لَيْسَ لِى بِحَقٍّ ۚ إِن كُنتُ قُلْتُهُۥ فَقَدْ عَلِمْتَهُۥ ۚ تَعْلَمُ مَا فِى نَفْسِى وَلَآ أَعْلَمُ مَا فِى نَفْسِكَ ۚ إِنَّكَ أَنتَ عَلَّٰمُ ٱلْغُيُوبِ',
		number_in_surah: '116',
		page: '127',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '786',
		number: '786',
		text: 'مَا قُلْتُ لَهُمْ إِلَّا مَآ أَمَرْتَنِى بِهِۦٓ أَنِ ٱعْبُدُوا۟ ٱللَّهَ رَبِّى وَرَبَّكُمْ ۚ وَكُنتُ عَلَيْهِمْ شَهِيدًۭا مَّا دُمْتُ فِيهِمْ ۖ فَلَمَّا تَوَفَّيْتَنِى كُنتَ أَنتَ ٱلرَّقِيبَ عَلَيْهِمْ ۚ وَأَنتَ عَلَىٰ كُلِّ شَىْءٍۢ شَهِيدٌ',
		number_in_surah: '117',
		page: '127',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '787',
		number: '787',
		text: 'إِن تُعَذِّبْهُمْ فَإِنَّهُمْ عِبَادُكَ ۖ وَإِن تَغْفِرْ لَهُمْ فَإِنَّكَ أَنتَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '118',
		page: '127',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '788',
		number: '788',
		text: 'قَالَ ٱللَّهُ هَٰذَا يَوْمُ يَنفَعُ ٱلصَّٰدِقِينَ صِدْقُهُمْ ۚ لَهُمْ جَنَّٰتٌۭ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدًۭا ۚ رَّضِىَ ٱللَّهُ عَنْهُمْ وَرَضُوا۟ عَنْهُ ۚ ذَٰلِكَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '119',
		page: '127',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '789',
		number: '789',
		text: 'لِلَّهِ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا فِيهِنَّ ۚ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۢ',
		number_in_surah: '120',
		page: '127',
		surah_id: '5',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '790',
		number: '790',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱلْحَمْدُ لِلَّهِ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَجَعَلَ ٱلظُّلُمَٰتِ وَٱلنُّورَ ۖ ثُمَّ ٱلَّذِينَ كَفَرُوا۟ بِرَبِّهِمْ يَعْدِلُونَ',
		number_in_surah: '1',
		page: '128',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '791',
		number: '791',
		text: 'هُوَ ٱلَّذِى خَلَقَكُم مِّن طِينٍۢ ثُمَّ قَضَىٰٓ أَجَلًۭا ۖ وَأَجَلٌۭ مُّسَمًّى عِندَهُۥ ۖ ثُمَّ أَنتُمْ تَمْتَرُونَ',
		number_in_surah: '2',
		page: '128',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '792',
		number: '792',
		text: 'وَهُوَ ٱللَّهُ فِى ٱلسَّمَٰوَٰتِ وَفِى ٱلْأَرْضِ ۖ يَعْلَمُ سِرَّكُمْ وَجَهْرَكُمْ وَيَعْلَمُ مَا تَكْسِبُونَ',
		number_in_surah: '3',
		page: '128',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '793',
		number: '793',
		text: 'وَمَا تَأْتِيهِم مِّنْ ءَايَةٍۢ مِّنْ ءَايَٰتِ رَبِّهِمْ إِلَّا كَانُوا۟ عَنْهَا مُعْرِضِينَ',
		number_in_surah: '4',
		page: '128',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '794',
		number: '794',
		text: 'فَقَدْ كَذَّبُوا۟ بِٱلْحَقِّ لَمَّا جَآءَهُمْ ۖ فَسَوْفَ يَأْتِيهِمْ أَنۢبَٰٓؤُا۟ مَا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '5',
		page: '128',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '795',
		number: '795',
		text: 'أَلَمْ يَرَوْا۟ كَمْ أَهْلَكْنَا مِن قَبْلِهِم مِّن قَرْنٍۢ مَّكَّنَّٰهُمْ فِى ٱلْأَرْضِ مَا لَمْ نُمَكِّن لَّكُمْ وَأَرْسَلْنَا ٱلسَّمَآءَ عَلَيْهِم مِّدْرَارًۭا وَجَعَلْنَا ٱلْأَنْهَٰرَ تَجْرِى مِن تَحْتِهِمْ فَأَهْلَكْنَٰهُم بِذُنُوبِهِمْ وَأَنشَأْنَا مِنۢ بَعْدِهِمْ قَرْنًا ءَاخَرِينَ',
		number_in_surah: '6',
		page: '128',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '796',
		number: '796',
		text: 'وَلَوْ نَزَّلْنَا عَلَيْكَ كِتَٰبًۭا فِى قِرْطَاسٍۢ فَلَمَسُوهُ بِأَيْدِيهِمْ لَقَالَ ٱلَّذِينَ كَفَرُوٓا۟ إِنْ هَٰذَآ إِلَّا سِحْرٌۭ مُّبِينٌۭ',
		number_in_surah: '7',
		page: '128',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '797',
		number: '797',
		text: 'وَقَالُوا۟ لَوْلَآ أُنزِلَ عَلَيْهِ مَلَكٌۭ ۖ وَلَوْ أَنزَلْنَا مَلَكًۭا لَّقُضِىَ ٱلْأَمْرُ ثُمَّ لَا يُنظَرُونَ',
		number_in_surah: '8',
		page: '128',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '798',
		number: '798',
		text: 'وَلَوْ جَعَلْنَٰهُ مَلَكًۭا لَّجَعَلْنَٰهُ رَجُلًۭا وَلَلَبَسْنَا عَلَيْهِم مَّا يَلْبِسُونَ',
		number_in_surah: '9',
		page: '129',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '799',
		number: '799',
		text: 'وَلَقَدِ ٱسْتُهْزِئَ بِرُسُلٍۢ مِّن قَبْلِكَ فَحَاقَ بِٱلَّذِينَ سَخِرُوا۟ مِنْهُم مَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '10',
		page: '129',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '800',
		number: '800',
		text: 'قُلْ سِيرُوا۟ فِى ٱلْأَرْضِ ثُمَّ ٱنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُكَذِّبِينَ',
		number_in_surah: '11',
		page: '129',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '801',
		number: '801',
		text: 'قُل لِّمَن مَّا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ قُل لِّلَّهِ ۚ كَتَبَ عَلَىٰ نَفْسِهِ ٱلرَّحْمَةَ ۚ لَيَجْمَعَنَّكُمْ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ لَا رَيْبَ فِيهِ ۚ ٱلَّذِينَ خَسِرُوٓا۟ أَنفُسَهُمْ فَهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '12',
		page: '129',
		surah_id: '6',
		hizb_id: '51',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '802',
		number: '802',
		text: '۞ وَلَهُۥ مَا سَكَنَ فِى ٱلَّيْلِ وَٱلنَّهَارِ ۚ وَهُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '13',
		page: '129',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '803',
		number: '803',
		text: 'قُلْ أَغَيْرَ ٱللَّهِ أَتَّخِذُ وَلِيًّۭا فَاطِرِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَهُوَ يُطْعِمُ وَلَا يُطْعَمُ ۗ قُلْ إِنِّىٓ أُمِرْتُ أَنْ أَكُونَ أَوَّلَ مَنْ أَسْلَمَ ۖ وَلَا تَكُونَنَّ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '14',
		page: '129',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '804',
		number: '804',
		text: 'قُلْ إِنِّىٓ أَخَافُ إِنْ عَصَيْتُ رَبِّى عَذَابَ يَوْمٍ عَظِيمٍۢ',
		number_in_surah: '15',
		page: '129',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '805',
		number: '805',
		text: 'مَّن يُصْرَفْ عَنْهُ يَوْمَئِذٍۢ فَقَدْ رَحِمَهُۥ ۚ وَذَٰلِكَ ٱلْفَوْزُ ٱلْمُبِينُ',
		number_in_surah: '16',
		page: '129',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '806',
		number: '806',
		text: 'وَإِن يَمْسَسْكَ ٱللَّهُ بِضُرٍّۢ فَلَا كَاشِفَ لَهُۥٓ إِلَّا هُوَ ۖ وَإِن يَمْسَسْكَ بِخَيْرٍۢ فَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '17',
		page: '129',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '807',
		number: '807',
		text: 'وَهُوَ ٱلْقَاهِرُ فَوْقَ عِبَادِهِۦ ۚ وَهُوَ ٱلْحَكِيمُ ٱلْخَبِيرُ',
		number_in_surah: '18',
		page: '129',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '808',
		number: '808',
		text: 'قُلْ أَىُّ شَىْءٍ أَكْبَرُ شَهَٰدَةًۭ ۖ قُلِ ٱللَّهُ ۖ شَهِيدٌۢ بَيْنِى وَبَيْنَكُمْ ۚ وَأُوحِىَ إِلَىَّ هَٰذَا ٱلْقُرْءَانُ لِأُنذِرَكُم بِهِۦ وَمَنۢ بَلَغَ ۚ أَئِنَّكُمْ لَتَشْهَدُونَ أَنَّ مَعَ ٱللَّهِ ءَالِهَةً أُخْرَىٰ ۚ قُل لَّآ أَشْهَدُ ۚ قُلْ إِنَّمَا هُوَ إِلَٰهٌۭ وَٰحِدٌۭ وَإِنَّنِى بَرِىٓءٌۭ مِّمَّا تُشْرِكُونَ',
		number_in_surah: '19',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '809',
		number: '809',
		text: 'ٱلَّذِينَ ءَاتَيْنَٰهُمُ ٱلْكِتَٰبَ يَعْرِفُونَهُۥ كَمَا يَعْرِفُونَ أَبْنَآءَهُمُ ۘ ٱلَّذِينَ خَسِرُوٓا۟ أَنفُسَهُمْ فَهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '20',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '810',
		number: '810',
		text: 'وَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوْ كَذَّبَ بِـَٔايَٰتِهِۦٓ ۗ إِنَّهُۥ لَا يُفْلِحُ ٱلظَّٰلِمُونَ',
		number_in_surah: '21',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '811',
		number: '811',
		text: 'وَيَوْمَ نَحْشُرُهُمْ جَمِيعًۭا ثُمَّ نَقُولُ لِلَّذِينَ أَشْرَكُوٓا۟ أَيْنَ شُرَكَآؤُكُمُ ٱلَّذِينَ كُنتُمْ تَزْعُمُونَ',
		number_in_surah: '22',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '812',
		number: '812',
		text: 'ثُمَّ لَمْ تَكُن فِتْنَتُهُمْ إِلَّآ أَن قَالُوا۟ وَٱللَّهِ رَبِّنَا مَا كُنَّا مُشْرِكِينَ',
		number_in_surah: '23',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '813',
		number: '813',
		text: 'ٱنظُرْ كَيْفَ كَذَبُوا۟ عَلَىٰٓ أَنفُسِهِمْ ۚ وَضَلَّ عَنْهُم مَّا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '24',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '814',
		number: '814',
		text: 'وَمِنْهُم مَّن يَسْتَمِعُ إِلَيْكَ ۖ وَجَعَلْنَا عَلَىٰ قُلُوبِهِمْ أَكِنَّةً أَن يَفْقَهُوهُ وَفِىٓ ءَاذَانِهِمْ وَقْرًۭا ۚ وَإِن يَرَوْا۟ كُلَّ ءَايَةٍۢ لَّا يُؤْمِنُوا۟ بِهَا ۚ حَتَّىٰٓ إِذَا جَآءُوكَ يُجَٰدِلُونَكَ يَقُولُ ٱلَّذِينَ كَفَرُوٓا۟ إِنْ هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلْأَوَّلِينَ',
		number_in_surah: '25',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '815',
		number: '815',
		text: 'وَهُمْ يَنْهَوْنَ عَنْهُ وَيَنْـَٔوْنَ عَنْهُ ۖ وَإِن يُهْلِكُونَ إِلَّآ أَنفُسَهُمْ وَمَا يَشْعُرُونَ',
		number_in_surah: '26',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '816',
		number: '816',
		text: 'وَلَوْ تَرَىٰٓ إِذْ وُقِفُوا۟ عَلَى ٱلنَّارِ فَقَالُوا۟ يَٰلَيْتَنَا نُرَدُّ وَلَا نُكَذِّبَ بِـَٔايَٰتِ رَبِّنَا وَنَكُونَ مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '27',
		page: '130',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '817',
		number: '817',
		text: 'بَلْ بَدَا لَهُم مَّا كَانُوا۟ يُخْفُونَ مِن قَبْلُ ۖ وَلَوْ رُدُّوا۟ لَعَادُوا۟ لِمَا نُهُوا۟ عَنْهُ وَإِنَّهُمْ لَكَٰذِبُونَ',
		number_in_surah: '28',
		page: '131',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '818',
		number: '818',
		text: 'وَقَالُوٓا۟ إِنْ هِىَ إِلَّا حَيَاتُنَا ٱلدُّنْيَا وَمَا نَحْنُ بِمَبْعُوثِينَ',
		number_in_surah: '29',
		page: '131',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '819',
		number: '819',
		text: 'وَلَوْ تَرَىٰٓ إِذْ وُقِفُوا۟ عَلَىٰ رَبِّهِمْ ۚ قَالَ أَلَيْسَ هَٰذَا بِٱلْحَقِّ ۚ قَالُوا۟ بَلَىٰ وَرَبِّنَا ۚ قَالَ فَذُوقُوا۟ ٱلْعَذَابَ بِمَا كُنتُمْ تَكْفُرُونَ',
		number_in_surah: '30',
		page: '131',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '820',
		number: '820',
		text: 'قَدْ خَسِرَ ٱلَّذِينَ كَذَّبُوا۟ بِلِقَآءِ ٱللَّهِ ۖ حَتَّىٰٓ إِذَا جَآءَتْهُمُ ٱلسَّاعَةُ بَغْتَةًۭ قَالُوا۟ يَٰحَسْرَتَنَا عَلَىٰ مَا فَرَّطْنَا فِيهَا وَهُمْ يَحْمِلُونَ أَوْزَارَهُمْ عَلَىٰ ظُهُورِهِمْ ۚ أَلَا سَآءَ مَا يَزِرُونَ',
		number_in_surah: '31',
		page: '131',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '821',
		number: '821',
		text: 'وَمَا ٱلْحَيَوٰةُ ٱلدُّنْيَآ إِلَّا لَعِبٌۭ وَلَهْوٌۭ ۖ وَلَلدَّارُ ٱلْءَاخِرَةُ خَيْرٌۭ لِّلَّذِينَ يَتَّقُونَ ۗ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '32',
		page: '131',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '822',
		number: '822',
		text: 'قَدْ نَعْلَمُ إِنَّهُۥ لَيَحْزُنُكَ ٱلَّذِى يَقُولُونَ ۖ فَإِنَّهُمْ لَا يُكَذِّبُونَكَ وَلَٰكِنَّ ٱلظَّٰلِمِينَ بِـَٔايَٰتِ ٱللَّهِ يَجْحَدُونَ',
		number_in_surah: '33',
		page: '131',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '823',
		number: '823',
		text: 'وَلَقَدْ كُذِّبَتْ رُسُلٌۭ مِّن قَبْلِكَ فَصَبَرُوا۟ عَلَىٰ مَا كُذِّبُوا۟ وَأُوذُوا۟ حَتَّىٰٓ أَتَىٰهُمْ نَصْرُنَا ۚ وَلَا مُبَدِّلَ لِكَلِمَٰتِ ٱللَّهِ ۚ وَلَقَدْ جَآءَكَ مِن نَّبَإِى۟ ٱلْمُرْسَلِينَ',
		number_in_surah: '34',
		page: '131',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '824',
		number: '824',
		text: 'وَإِن كَانَ كَبُرَ عَلَيْكَ إِعْرَاضُهُمْ فَإِنِ ٱسْتَطَعْتَ أَن تَبْتَغِىَ نَفَقًۭا فِى ٱلْأَرْضِ أَوْ سُلَّمًۭا فِى ٱلسَّمَآءِ فَتَأْتِيَهُم بِـَٔايَةٍۢ ۚ وَلَوْ شَآءَ ٱللَّهُ لَجَمَعَهُمْ عَلَى ٱلْهُدَىٰ ۚ فَلَا تَكُونَنَّ مِنَ ٱلْجَٰهِلِينَ',
		number_in_surah: '35',
		page: '131',
		surah_id: '6',
		hizb_id: '52',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '825',
		number: '825',
		text: '۞ إِنَّمَا يَسْتَجِيبُ ٱلَّذِينَ يَسْمَعُونَ ۘ وَٱلْمَوْتَىٰ يَبْعَثُهُمُ ٱللَّهُ ثُمَّ إِلَيْهِ يُرْجَعُونَ',
		number_in_surah: '36',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '826',
		number: '826',
		text: 'وَقَالُوا۟ لَوْلَا نُزِّلَ عَلَيْهِ ءَايَةٌۭ مِّن رَّبِّهِۦ ۚ قُلْ إِنَّ ٱللَّهَ قَادِرٌ عَلَىٰٓ أَن يُنَزِّلَ ءَايَةًۭ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '37',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '827',
		number: '827',
		text: 'وَمَا مِن دَآبَّةٍۢ فِى ٱلْأَرْضِ وَلَا طَٰٓئِرٍۢ يَطِيرُ بِجَنَاحَيْهِ إِلَّآ أُمَمٌ أَمْثَالُكُم ۚ مَّا فَرَّطْنَا فِى ٱلْكِتَٰبِ مِن شَىْءٍۢ ۚ ثُمَّ إِلَىٰ رَبِّهِمْ يُحْشَرُونَ',
		number_in_surah: '38',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '828',
		number: '828',
		text: 'وَٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا صُمٌّۭ وَبُكْمٌۭ فِى ٱلظُّلُمَٰتِ ۗ مَن يَشَإِ ٱللَّهُ يُضْلِلْهُ وَمَن يَشَأْ يَجْعَلْهُ عَلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '39',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '829',
		number: '829',
		text: 'قُلْ أَرَءَيْتَكُمْ إِنْ أَتَىٰكُمْ عَذَابُ ٱللَّهِ أَوْ أَتَتْكُمُ ٱلسَّاعَةُ أَغَيْرَ ٱللَّهِ تَدْعُونَ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '40',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '830',
		number: '830',
		text: 'بَلْ إِيَّاهُ تَدْعُونَ فَيَكْشِفُ مَا تَدْعُونَ إِلَيْهِ إِن شَآءَ وَتَنسَوْنَ مَا تُشْرِكُونَ',
		number_in_surah: '41',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '831',
		number: '831',
		text: 'وَلَقَدْ أَرْسَلْنَآ إِلَىٰٓ أُمَمٍۢ مِّن قَبْلِكَ فَأَخَذْنَٰهُم بِٱلْبَأْسَآءِ وَٱلضَّرَّآءِ لَعَلَّهُمْ يَتَضَرَّعُونَ',
		number_in_surah: '42',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '832',
		number: '832',
		text: 'فَلَوْلَآ إِذْ جَآءَهُم بَأْسُنَا تَضَرَّعُوا۟ وَلَٰكِن قَسَتْ قُلُوبُهُمْ وَزَيَّنَ لَهُمُ ٱلشَّيْطَٰنُ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '43',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '833',
		number: '833',
		text: 'فَلَمَّا نَسُوا۟ مَا ذُكِّرُوا۟ بِهِۦ فَتَحْنَا عَلَيْهِمْ أَبْوَٰبَ كُلِّ شَىْءٍ حَتَّىٰٓ إِذَا فَرِحُوا۟ بِمَآ أُوتُوٓا۟ أَخَذْنَٰهُم بَغْتَةًۭ فَإِذَا هُم مُّبْلِسُونَ',
		number_in_surah: '44',
		page: '132',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '834',
		number: '834',
		text: 'فَقُطِعَ دَابِرُ ٱلْقَوْمِ ٱلَّذِينَ ظَلَمُوا۟ ۚ وَٱلْحَمْدُ لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '45',
		page: '133',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '835',
		number: '835',
		text: 'قُلْ أَرَءَيْتُمْ إِنْ أَخَذَ ٱللَّهُ سَمْعَكُمْ وَأَبْصَٰرَكُمْ وَخَتَمَ عَلَىٰ قُلُوبِكُم مَّنْ إِلَٰهٌ غَيْرُ ٱللَّهِ يَأْتِيكُم بِهِ ۗ ٱنظُرْ كَيْفَ نُصَرِّفُ ٱلْءَايَٰتِ ثُمَّ هُمْ يَصْدِفُونَ',
		number_in_surah: '46',
		page: '133',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '836',
		number: '836',
		text: 'قُلْ أَرَءَيْتَكُمْ إِنْ أَتَىٰكُمْ عَذَابُ ٱللَّهِ بَغْتَةً أَوْ جَهْرَةً هَلْ يُهْلَكُ إِلَّا ٱلْقَوْمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '47',
		page: '133',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '837',
		number: '837',
		text: 'وَمَا نُرْسِلُ ٱلْمُرْسَلِينَ إِلَّا مُبَشِّرِينَ وَمُنذِرِينَ ۖ فَمَنْ ءَامَنَ وَأَصْلَحَ فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '48',
		page: '133',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '838',
		number: '838',
		text: 'وَٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا يَمَسُّهُمُ ٱلْعَذَابُ بِمَا كَانُوا۟ يَفْسُقُونَ',
		number_in_surah: '49',
		page: '133',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '839',
		number: '839',
		text: 'قُل لَّآ أَقُولُ لَكُمْ عِندِى خَزَآئِنُ ٱللَّهِ وَلَآ أَعْلَمُ ٱلْغَيْبَ وَلَآ أَقُولُ لَكُمْ إِنِّى مَلَكٌ ۖ إِنْ أَتَّبِعُ إِلَّا مَا يُوحَىٰٓ إِلَىَّ ۚ قُلْ هَلْ يَسْتَوِى ٱلْأَعْمَىٰ وَٱلْبَصِيرُ ۚ أَفَلَا تَتَفَكَّرُونَ',
		number_in_surah: '50',
		page: '133',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '840',
		number: '840',
		text: 'وَأَنذِرْ بِهِ ٱلَّذِينَ يَخَافُونَ أَن يُحْشَرُوٓا۟ إِلَىٰ رَبِّهِمْ ۙ لَيْسَ لَهُم مِّن دُونِهِۦ وَلِىٌّۭ وَلَا شَفِيعٌۭ لَّعَلَّهُمْ يَتَّقُونَ',
		number_in_surah: '51',
		page: '133',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '841',
		number: '841',
		text: 'وَلَا تَطْرُدِ ٱلَّذِينَ يَدْعُونَ رَبَّهُم بِٱلْغَدَوٰةِ وَٱلْعَشِىِّ يُرِيدُونَ وَجْهَهُۥ ۖ مَا عَلَيْكَ مِنْ حِسَابِهِم مِّن شَىْءٍۢ وَمَا مِنْ حِسَابِكَ عَلَيْهِم مِّن شَىْءٍۢ فَتَطْرُدَهُمْ فَتَكُونَ مِنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '52',
		page: '133',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '842',
		number: '842',
		text: 'وَكَذَٰلِكَ فَتَنَّا بَعْضَهُم بِبَعْضٍۢ لِّيَقُولُوٓا۟ أَهَٰٓؤُلَآءِ مَنَّ ٱللَّهُ عَلَيْهِم مِّنۢ بَيْنِنَآ ۗ أَلَيْسَ ٱللَّهُ بِأَعْلَمَ بِٱلشَّٰكِرِينَ',
		number_in_surah: '53',
		page: '134',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '843',
		number: '843',
		text: 'وَإِذَا جَآءَكَ ٱلَّذِينَ يُؤْمِنُونَ بِـَٔايَٰتِنَا فَقُلْ سَلَٰمٌ عَلَيْكُمْ ۖ كَتَبَ رَبُّكُمْ عَلَىٰ نَفْسِهِ ٱلرَّحْمَةَ ۖ أَنَّهُۥ مَنْ عَمِلَ مِنكُمْ سُوٓءًۢا بِجَهَٰلَةٍۢ ثُمَّ تَابَ مِنۢ بَعْدِهِۦ وَأَصْلَحَ فَأَنَّهُۥ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '54',
		page: '134',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '844',
		number: '844',
		text: 'وَكَذَٰلِكَ نُفَصِّلُ ٱلْءَايَٰتِ وَلِتَسْتَبِينَ سَبِيلُ ٱلْمُجْرِمِينَ',
		number_in_surah: '55',
		page: '134',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '845',
		number: '845',
		text: 'قُلْ إِنِّى نُهِيتُ أَنْ أَعْبُدَ ٱلَّذِينَ تَدْعُونَ مِن دُونِ ٱللَّهِ ۚ قُل لَّآ أَتَّبِعُ أَهْوَآءَكُمْ ۙ قَدْ ضَلَلْتُ إِذًۭا وَمَآ أَنَا۠ مِنَ ٱلْمُهْتَدِينَ',
		number_in_surah: '56',
		page: '134',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '846',
		number: '846',
		text: 'قُلْ إِنِّى عَلَىٰ بَيِّنَةٍۢ مِّن رَّبِّى وَكَذَّبْتُم بِهِۦ ۚ مَا عِندِى مَا تَسْتَعْجِلُونَ بِهِۦٓ ۚ إِنِ ٱلْحُكْمُ إِلَّا لِلَّهِ ۖ يَقُصُّ ٱلْحَقَّ ۖ وَهُوَ خَيْرُ ٱلْفَٰصِلِينَ',
		number_in_surah: '57',
		page: '134',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '847',
		number: '847',
		text: 'قُل لَّوْ أَنَّ عِندِى مَا تَسْتَعْجِلُونَ بِهِۦ لَقُضِىَ ٱلْأَمْرُ بَيْنِى وَبَيْنَكُمْ ۗ وَٱللَّهُ أَعْلَمُ بِٱلظَّٰلِمِينَ',
		number_in_surah: '58',
		page: '134',
		surah_id: '6',
		hizb_id: '53',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '848',
		number: '848',
		text: '۞ وَعِندَهُۥ مَفَاتِحُ ٱلْغَيْبِ لَا يَعْلَمُهَآ إِلَّا هُوَ ۚ وَيَعْلَمُ مَا فِى ٱلْبَرِّ وَٱلْبَحْرِ ۚ وَمَا تَسْقُطُ مِن وَرَقَةٍ إِلَّا يَعْلَمُهَا وَلَا حَبَّةٍۢ فِى ظُلُمَٰتِ ٱلْأَرْضِ وَلَا رَطْبٍۢ وَلَا يَابِسٍ إِلَّا فِى كِتَٰبٍۢ مُّبِينٍۢ',
		number_in_surah: '59',
		page: '134',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '849',
		number: '849',
		text: 'وَهُوَ ٱلَّذِى يَتَوَفَّىٰكُم بِٱلَّيْلِ وَيَعْلَمُ مَا جَرَحْتُم بِٱلنَّهَارِ ثُمَّ يَبْعَثُكُمْ فِيهِ لِيُقْضَىٰٓ أَجَلٌۭ مُّسَمًّۭى ۖ ثُمَّ إِلَيْهِ مَرْجِعُكُمْ ثُمَّ يُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '60',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '850',
		number: '850',
		text: 'وَهُوَ ٱلْقَاهِرُ فَوْقَ عِبَادِهِۦ ۖ وَيُرْسِلُ عَلَيْكُمْ حَفَظَةً حَتَّىٰٓ إِذَا جَآءَ أَحَدَكُمُ ٱلْمَوْتُ تَوَفَّتْهُ رُسُلُنَا وَهُمْ لَا يُفَرِّطُونَ',
		number_in_surah: '61',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '851',
		number: '851',
		text: 'ثُمَّ رُدُّوٓا۟ إِلَى ٱللَّهِ مَوْلَىٰهُمُ ٱلْحَقِّ ۚ أَلَا لَهُ ٱلْحُكْمُ وَهُوَ أَسْرَعُ ٱلْحَٰسِبِينَ',
		number_in_surah: '62',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '852',
		number: '852',
		text: 'قُلْ مَن يُنَجِّيكُم مِّن ظُلُمَٰتِ ٱلْبَرِّ وَٱلْبَحْرِ تَدْعُونَهُۥ تَضَرُّعًۭا وَخُفْيَةًۭ لَّئِنْ أَنجَىٰنَا مِنْ هَٰذِهِۦ لَنَكُونَنَّ مِنَ ٱلشَّٰكِرِينَ',
		number_in_surah: '63',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '853',
		number: '853',
		text: 'قُلِ ٱللَّهُ يُنَجِّيكُم مِّنْهَا وَمِن كُلِّ كَرْبٍۢ ثُمَّ أَنتُمْ تُشْرِكُونَ',
		number_in_surah: '64',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '854',
		number: '854',
		text: 'قُلْ هُوَ ٱلْقَادِرُ عَلَىٰٓ أَن يَبْعَثَ عَلَيْكُمْ عَذَابًۭا مِّن فَوْقِكُمْ أَوْ مِن تَحْتِ أَرْجُلِكُمْ أَوْ يَلْبِسَكُمْ شِيَعًۭا وَيُذِيقَ بَعْضَكُم بَأْسَ بَعْضٍ ۗ ٱنظُرْ كَيْفَ نُصَرِّفُ ٱلْءَايَٰتِ لَعَلَّهُمْ يَفْقَهُونَ',
		number_in_surah: '65',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '855',
		number: '855',
		text: 'وَكَذَّبَ بِهِۦ قَوْمُكَ وَهُوَ ٱلْحَقُّ ۚ قُل لَّسْتُ عَلَيْكُم بِوَكِيلٍۢ',
		number_in_surah: '66',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '856',
		number: '856',
		text: 'لِّكُلِّ نَبَإٍۢ مُّسْتَقَرٌّۭ ۚ وَسَوْفَ تَعْلَمُونَ',
		number_in_surah: '67',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '857',
		number: '857',
		text: 'وَإِذَا رَأَيْتَ ٱلَّذِينَ يَخُوضُونَ فِىٓ ءَايَٰتِنَا فَأَعْرِضْ عَنْهُمْ حَتَّىٰ يَخُوضُوا۟ فِى حَدِيثٍ غَيْرِهِۦ ۚ وَإِمَّا يُنسِيَنَّكَ ٱلشَّيْطَٰنُ فَلَا تَقْعُدْ بَعْدَ ٱلذِّكْرَىٰ مَعَ ٱلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '68',
		page: '135',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '858',
		number: '858',
		text: 'وَمَا عَلَى ٱلَّذِينَ يَتَّقُونَ مِنْ حِسَابِهِم مِّن شَىْءٍۢ وَلَٰكِن ذِكْرَىٰ لَعَلَّهُمْ يَتَّقُونَ',
		number_in_surah: '69',
		page: '136',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '859',
		number: '859',
		text: 'وَذَرِ ٱلَّذِينَ ٱتَّخَذُوا۟ دِينَهُمْ لَعِبًۭا وَلَهْوًۭا وَغَرَّتْهُمُ ٱلْحَيَوٰةُ ٱلدُّنْيَا ۚ وَذَكِّرْ بِهِۦٓ أَن تُبْسَلَ نَفْسٌۢ بِمَا كَسَبَتْ لَيْسَ لَهَا مِن دُونِ ٱللَّهِ وَلِىٌّۭ وَلَا شَفِيعٌۭ وَإِن تَعْدِلْ كُلَّ عَدْلٍۢ لَّا يُؤْخَذْ مِنْهَآ ۗ أُو۟لَٰٓئِكَ ٱلَّذِينَ أُبْسِلُوا۟ بِمَا كَسَبُوا۟ ۖ لَهُمْ شَرَابٌۭ مِّنْ حَمِيمٍۢ وَعَذَابٌ أَلِيمٌۢ بِمَا كَانُوا۟ يَكْفُرُونَ',
		number_in_surah: '70',
		page: '136',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '860',
		number: '860',
		text: 'قُلْ أَنَدْعُوا۟ مِن دُونِ ٱللَّهِ مَا لَا يَنفَعُنَا وَلَا يَضُرُّنَا وَنُرَدُّ عَلَىٰٓ أَعْقَابِنَا بَعْدَ إِذْ هَدَىٰنَا ٱللَّهُ كَٱلَّذِى ٱسْتَهْوَتْهُ ٱلشَّيَٰطِينُ فِى ٱلْأَرْضِ حَيْرَانَ لَهُۥٓ أَصْحَٰبٌۭ يَدْعُونَهُۥٓ إِلَى ٱلْهُدَى ٱئْتِنَا ۗ قُلْ إِنَّ هُدَى ٱللَّهِ هُوَ ٱلْهُدَىٰ ۖ وَأُمِرْنَا لِنُسْلِمَ لِرَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '71',
		page: '136',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '861',
		number: '861',
		text: 'وَأَنْ أَقِيمُوا۟ ٱلصَّلَوٰةَ وَٱتَّقُوهُ ۚ وَهُوَ ٱلَّذِىٓ إِلَيْهِ تُحْشَرُونَ',
		number_in_surah: '72',
		page: '136',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '862',
		number: '862',
		text: 'وَهُوَ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ بِٱلْحَقِّ ۖ وَيَوْمَ يَقُولُ كُن فَيَكُونُ ۚ قَوْلُهُ ٱلْحَقُّ ۚ وَلَهُ ٱلْمُلْكُ يَوْمَ يُنفَخُ فِى ٱلصُّورِ ۚ عَٰلِمُ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ ۚ وَهُوَ ٱلْحَكِيمُ ٱلْخَبِيرُ',
		number_in_surah: '73',
		page: '136',
		surah_id: '6',
		hizb_id: '54',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '863',
		number: '863',
		text: '۞ وَإِذْ قَالَ إِبْرَٰهِيمُ لِأَبِيهِ ءَازَرَ أَتَتَّخِذُ أَصْنَامًا ءَالِهَةً ۖ إِنِّىٓ أَرَىٰكَ وَقَوْمَكَ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '74',
		page: '137',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '864',
		number: '864',
		text: 'وَكَذَٰلِكَ نُرِىٓ إِبْرَٰهِيمَ مَلَكُوتَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَلِيَكُونَ مِنَ ٱلْمُوقِنِينَ',
		number_in_surah: '75',
		page: '137',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '865',
		number: '865',
		text: 'فَلَمَّا جَنَّ عَلَيْهِ ٱلَّيْلُ رَءَا كَوْكَبًۭا ۖ قَالَ هَٰذَا رَبِّى ۖ فَلَمَّآ أَفَلَ قَالَ لَآ أُحِبُّ ٱلْءَافِلِينَ',
		number_in_surah: '76',
		page: '137',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '866',
		number: '866',
		text: 'فَلَمَّا رَءَا ٱلْقَمَرَ بَازِغًۭا قَالَ هَٰذَا رَبِّى ۖ فَلَمَّآ أَفَلَ قَالَ لَئِن لَّمْ يَهْدِنِى رَبِّى لَأَكُونَنَّ مِنَ ٱلْقَوْمِ ٱلضَّآلِّينَ',
		number_in_surah: '77',
		page: '137',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '867',
		number: '867',
		text: 'فَلَمَّا رَءَا ٱلشَّمْسَ بَازِغَةًۭ قَالَ هَٰذَا رَبِّى هَٰذَآ أَكْبَرُ ۖ فَلَمَّآ أَفَلَتْ قَالَ يَٰقَوْمِ إِنِّى بَرِىٓءٌۭ مِّمَّا تُشْرِكُونَ',
		number_in_surah: '78',
		page: '137',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '868',
		number: '868',
		text: 'إِنِّى وَجَّهْتُ وَجْهِىَ لِلَّذِى فَطَرَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ حَنِيفًۭا ۖ وَمَآ أَنَا۠ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '79',
		page: '137',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '869',
		number: '869',
		text: 'وَحَآجَّهُۥ قَوْمُهُۥ ۚ قَالَ أَتُحَٰٓجُّوٓنِّى فِى ٱللَّهِ وَقَدْ هَدَىٰنِ ۚ وَلَآ أَخَافُ مَا تُشْرِكُونَ بِهِۦٓ إِلَّآ أَن يَشَآءَ رَبِّى شَيْـًۭٔا ۗ وَسِعَ رَبِّى كُلَّ شَىْءٍ عِلْمًا ۗ أَفَلَا تَتَذَكَّرُونَ',
		number_in_surah: '80',
		page: '137',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '870',
		number: '870',
		text: 'وَكَيْفَ أَخَافُ مَآ أَشْرَكْتُمْ وَلَا تَخَافُونَ أَنَّكُمْ أَشْرَكْتُم بِٱللَّهِ مَا لَمْ يُنَزِّلْ بِهِۦ عَلَيْكُمْ سُلْطَٰنًۭا ۚ فَأَىُّ ٱلْفَرِيقَيْنِ أَحَقُّ بِٱلْأَمْنِ ۖ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '81',
		page: '137',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '871',
		number: '871',
		text: 'ٱلَّذِينَ ءَامَنُوا۟ وَلَمْ يَلْبِسُوٓا۟ إِيمَٰنَهُم بِظُلْمٍ أُو۟لَٰٓئِكَ لَهُمُ ٱلْأَمْنُ وَهُم مُّهْتَدُونَ',
		number_in_surah: '82',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '872',
		number: '872',
		text: 'وَتِلْكَ حُجَّتُنَآ ءَاتَيْنَٰهَآ إِبْرَٰهِيمَ عَلَىٰ قَوْمِهِۦ ۚ نَرْفَعُ دَرَجَٰتٍۢ مَّن نَّشَآءُ ۗ إِنَّ رَبَّكَ حَكِيمٌ عَلِيمٌۭ',
		number_in_surah: '83',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '873',
		number: '873',
		text: 'وَوَهَبْنَا لَهُۥٓ إِسْحَٰقَ وَيَعْقُوبَ ۚ كُلًّا هَدَيْنَا ۚ وَنُوحًا هَدَيْنَا مِن قَبْلُ ۖ وَمِن ذُرِّيَّتِهِۦ دَاوُۥدَ وَسُلَيْمَٰنَ وَأَيُّوبَ وَيُوسُفَ وَمُوسَىٰ وَهَٰرُونَ ۚ وَكَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '84',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '874',
		number: '874',
		text: 'وَزَكَرِيَّا وَيَحْيَىٰ وَعِيسَىٰ وَإِلْيَاسَ ۖ كُلٌّۭ مِّنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '85',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '875',
		number: '875',
		text: 'وَإِسْمَٰعِيلَ وَٱلْيَسَعَ وَيُونُسَ وَلُوطًۭا ۚ وَكُلًّۭا فَضَّلْنَا عَلَى ٱلْعَٰلَمِينَ',
		number_in_surah: '86',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '876',
		number: '876',
		text: 'وَمِنْ ءَابَآئِهِمْ وَذُرِّيَّٰتِهِمْ وَإِخْوَٰنِهِمْ ۖ وَٱجْتَبَيْنَٰهُمْ وَهَدَيْنَٰهُمْ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '87',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '877',
		number: '877',
		text: 'ذَٰلِكَ هُدَى ٱللَّهِ يَهْدِى بِهِۦ مَن يَشَآءُ مِنْ عِبَادِهِۦ ۚ وَلَوْ أَشْرَكُوا۟ لَحَبِطَ عَنْهُم مَّا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '88',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '878',
		number: '878',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ ءَاتَيْنَٰهُمُ ٱلْكِتَٰبَ وَٱلْحُكْمَ وَٱلنُّبُوَّةَ ۚ فَإِن يَكْفُرْ بِهَا هَٰٓؤُلَآءِ فَقَدْ وَكَّلْنَا بِهَا قَوْمًۭا لَّيْسُوا۟ بِهَا بِكَٰفِرِينَ',
		number_in_surah: '89',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '879',
		number: '879',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ هَدَى ٱللَّهُ ۖ فَبِهُدَىٰهُمُ ٱقْتَدِهْ ۗ قُل لَّآ أَسْـَٔلُكُمْ عَلَيْهِ أَجْرًا ۖ إِنْ هُوَ إِلَّا ذِكْرَىٰ لِلْعَٰلَمِينَ',
		number_in_surah: '90',
		page: '138',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '880',
		number: '880',
		text: 'وَمَا قَدَرُوا۟ ٱللَّهَ حَقَّ قَدْرِهِۦٓ إِذْ قَالُوا۟ مَآ أَنزَلَ ٱللَّهُ عَلَىٰ بَشَرٍۢ مِّن شَىْءٍۢ ۗ قُلْ مَنْ أَنزَلَ ٱلْكِتَٰبَ ٱلَّذِى جَآءَ بِهِۦ مُوسَىٰ نُورًۭا وَهُدًۭى لِّلنَّاسِ ۖ تَجْعَلُونَهُۥ قَرَاطِيسَ تُبْدُونَهَا وَتُخْفُونَ كَثِيرًۭا ۖ وَعُلِّمْتُم مَّا لَمْ تَعْلَمُوٓا۟ أَنتُمْ وَلَآ ءَابَآؤُكُمْ ۖ قُلِ ٱللَّهُ ۖ ثُمَّ ذَرْهُمْ فِى خَوْضِهِمْ يَلْعَبُونَ',
		number_in_surah: '91',
		page: '139',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '881',
		number: '881',
		text: 'وَهَٰذَا كِتَٰبٌ أَنزَلْنَٰهُ مُبَارَكٌۭ مُّصَدِّقُ ٱلَّذِى بَيْنَ يَدَيْهِ وَلِتُنذِرَ أُمَّ ٱلْقُرَىٰ وَمَنْ حَوْلَهَا ۚ وَٱلَّذِينَ يُؤْمِنُونَ بِٱلْءَاخِرَةِ يُؤْمِنُونَ بِهِۦ ۖ وَهُمْ عَلَىٰ صَلَاتِهِمْ يُحَافِظُونَ',
		number_in_surah: '92',
		page: '139',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '882',
		number: '882',
		text: 'وَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوْ قَالَ أُوحِىَ إِلَىَّ وَلَمْ يُوحَ إِلَيْهِ شَىْءٌۭ وَمَن قَالَ سَأُنزِلُ مِثْلَ مَآ أَنزَلَ ٱللَّهُ ۗ وَلَوْ تَرَىٰٓ إِذِ ٱلظَّٰلِمُونَ فِى غَمَرَٰتِ ٱلْمَوْتِ وَٱلْمَلَٰٓئِكَةُ بَاسِطُوٓا۟ أَيْدِيهِمْ أَخْرِجُوٓا۟ أَنفُسَكُمُ ۖ ٱلْيَوْمَ تُجْزَوْنَ عَذَابَ ٱلْهُونِ بِمَا كُنتُمْ تَقُولُونَ عَلَى ٱللَّهِ غَيْرَ ٱلْحَقِّ وَكُنتُمْ عَنْ ءَايَٰتِهِۦ تَسْتَكْبِرُونَ',
		number_in_surah: '93',
		page: '139',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '883',
		number: '883',
		text: 'وَلَقَدْ جِئْتُمُونَا فُرَٰدَىٰ كَمَا خَلَقْنَٰكُمْ أَوَّلَ مَرَّةٍۢ وَتَرَكْتُم مَّا خَوَّلْنَٰكُمْ وَرَآءَ ظُهُورِكُمْ ۖ وَمَا نَرَىٰ مَعَكُمْ شُفَعَآءَكُمُ ٱلَّذِينَ زَعَمْتُمْ أَنَّهُمْ فِيكُمْ شُرَكَٰٓؤُا۟ ۚ لَقَد تَّقَطَّعَ بَيْنَكُمْ وَضَلَّ عَنكُم مَّا كُنتُمْ تَزْعُمُونَ',
		number_in_surah: '94',
		page: '139',
		surah_id: '6',
		hizb_id: '55',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '884',
		number: '884',
		text: '۞ إِنَّ ٱللَّهَ فَالِقُ ٱلْحَبِّ وَٱلنَّوَىٰ ۖ يُخْرِجُ ٱلْحَىَّ مِنَ ٱلْمَيِّتِ وَمُخْرِجُ ٱلْمَيِّتِ مِنَ ٱلْحَىِّ ۚ ذَٰلِكُمُ ٱللَّهُ ۖ فَأَنَّىٰ تُؤْفَكُونَ',
		number_in_surah: '95',
		page: '140',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '885',
		number: '885',
		text: 'فَالِقُ ٱلْإِصْبَاحِ وَجَعَلَ ٱلَّيْلَ سَكَنًۭا وَٱلشَّمْسَ وَٱلْقَمَرَ حُسْبَانًۭا ۚ ذَٰلِكَ تَقْدِيرُ ٱلْعَزِيزِ ٱلْعَلِيمِ',
		number_in_surah: '96',
		page: '140',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '886',
		number: '886',
		text: 'وَهُوَ ٱلَّذِى جَعَلَ لَكُمُ ٱلنُّجُومَ لِتَهْتَدُوا۟ بِهَا فِى ظُلُمَٰتِ ٱلْبَرِّ وَٱلْبَحْرِ ۗ قَدْ فَصَّلْنَا ٱلْءَايَٰتِ لِقَوْمٍۢ يَعْلَمُونَ',
		number_in_surah: '97',
		page: '140',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '887',
		number: '887',
		text: 'وَهُوَ ٱلَّذِىٓ أَنشَأَكُم مِّن نَّفْسٍۢ وَٰحِدَةٍۢ فَمُسْتَقَرٌّۭ وَمُسْتَوْدَعٌۭ ۗ قَدْ فَصَّلْنَا ٱلْءَايَٰتِ لِقَوْمٍۢ يَفْقَهُونَ',
		number_in_surah: '98',
		page: '140',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '888',
		number: '888',
		text: 'وَهُوَ ٱلَّذِىٓ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَخْرَجْنَا بِهِۦ نَبَاتَ كُلِّ شَىْءٍۢ فَأَخْرَجْنَا مِنْهُ خَضِرًۭا نُّخْرِجُ مِنْهُ حَبًّۭا مُّتَرَاكِبًۭا وَمِنَ ٱلنَّخْلِ مِن طَلْعِهَا قِنْوَانٌۭ دَانِيَةٌۭ وَجَنَّٰتٍۢ مِّنْ أَعْنَابٍۢ وَٱلزَّيْتُونَ وَٱلرُّمَّانَ مُشْتَبِهًۭا وَغَيْرَ مُتَشَٰبِهٍ ۗ ٱنظُرُوٓا۟ إِلَىٰ ثَمَرِهِۦٓ إِذَآ أَثْمَرَ وَيَنْعِهِۦٓ ۚ إِنَّ فِى ذَٰلِكُمْ لَءَايَٰتٍۢ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '99',
		page: '140',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '889',
		number: '889',
		text: 'وَجَعَلُوا۟ لِلَّهِ شُرَكَآءَ ٱلْجِنَّ وَخَلَقَهُمْ ۖ وَخَرَقُوا۟ لَهُۥ بَنِينَ وَبَنَٰتٍۭ بِغَيْرِ عِلْمٍۢ ۚ سُبْحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يَصِفُونَ',
		number_in_surah: '100',
		page: '140',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '890',
		number: '890',
		text: 'بَدِيعُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ أَنَّىٰ يَكُونُ لَهُۥ وَلَدٌۭ وَلَمْ تَكُن لَّهُۥ صَٰحِبَةٌۭ ۖ وَخَلَقَ كُلَّ شَىْءٍۢ ۖ وَهُوَ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '101',
		page: '140',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '891',
		number: '891',
		text: 'ذَٰلِكُمُ ٱللَّهُ رَبُّكُمْ ۖ لَآ إِلَٰهَ إِلَّا هُوَ ۖ خَٰلِقُ كُلِّ شَىْءٍۢ فَٱعْبُدُوهُ ۚ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ وَكِيلٌۭ',
		number_in_surah: '102',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '892',
		number: '892',
		text: 'لَّا تُدْرِكُهُ ٱلْأَبْصَٰرُ وَهُوَ يُدْرِكُ ٱلْأَبْصَٰرَ ۖ وَهُوَ ٱللَّطِيفُ ٱلْخَبِيرُ',
		number_in_surah: '103',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '893',
		number: '893',
		text: 'قَدْ جَآءَكُم بَصَآئِرُ مِن رَّبِّكُمْ ۖ فَمَنْ أَبْصَرَ فَلِنَفْسِهِۦ ۖ وَمَنْ عَمِىَ فَعَلَيْهَا ۚ وَمَآ أَنَا۠ عَلَيْكُم بِحَفِيظٍۢ',
		number_in_surah: '104',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '894',
		number: '894',
		text: 'وَكَذَٰلِكَ نُصَرِّفُ ٱلْءَايَٰتِ وَلِيَقُولُوا۟ دَرَسْتَ وَلِنُبَيِّنَهُۥ لِقَوْمٍۢ يَعْلَمُونَ',
		number_in_surah: '105',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '895',
		number: '895',
		text: 'ٱتَّبِعْ مَآ أُوحِىَ إِلَيْكَ مِن رَّبِّكَ ۖ لَآ إِلَٰهَ إِلَّا هُوَ ۖ وَأَعْرِضْ عَنِ ٱلْمُشْرِكِينَ',
		number_in_surah: '106',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '896',
		number: '896',
		text: 'وَلَوْ شَآءَ ٱللَّهُ مَآ أَشْرَكُوا۟ ۗ وَمَا جَعَلْنَٰكَ عَلَيْهِمْ حَفِيظًۭا ۖ وَمَآ أَنتَ عَلَيْهِم بِوَكِيلٍۢ',
		number_in_surah: '107',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '897',
		number: '897',
		text: 'وَلَا تَسُبُّوا۟ ٱلَّذِينَ يَدْعُونَ مِن دُونِ ٱللَّهِ فَيَسُبُّوا۟ ٱللَّهَ عَدْوًۢا بِغَيْرِ عِلْمٍۢ ۗ كَذَٰلِكَ زَيَّنَّا لِكُلِّ أُمَّةٍ عَمَلَهُمْ ثُمَّ إِلَىٰ رَبِّهِم مَّرْجِعُهُمْ فَيُنَبِّئُهُم بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '108',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '898',
		number: '898',
		text: 'وَأَقْسَمُوا۟ بِٱللَّهِ جَهْدَ أَيْمَٰنِهِمْ لَئِن جَآءَتْهُمْ ءَايَةٌۭ لَّيُؤْمِنُنَّ بِهَا ۚ قُلْ إِنَّمَا ٱلْءَايَٰتُ عِندَ ٱللَّهِ ۖ وَمَا يُشْعِرُكُمْ أَنَّهَآ إِذَا جَآءَتْ لَا يُؤْمِنُونَ',
		number_in_surah: '109',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '899',
		number: '899',
		text: 'وَنُقَلِّبُ أَفْـِٔدَتَهُمْ وَأَبْصَٰرَهُمْ كَمَا لَمْ يُؤْمِنُوا۟ بِهِۦٓ أَوَّلَ مَرَّةٍۢ وَنَذَرُهُمْ فِى طُغْيَٰنِهِمْ يَعْمَهُونَ',
		number_in_surah: '110',
		page: '141',
		surah_id: '6',
		hizb_id: '56',
		juz_id: '7',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '900',
		number: '900',
		text: '۞ وَلَوْ أَنَّنَا نَزَّلْنَآ إِلَيْهِمُ ٱلْمَلَٰٓئِكَةَ وَكَلَّمَهُمُ ٱلْمَوْتَىٰ وَحَشَرْنَا عَلَيْهِمْ كُلَّ شَىْءٍۢ قُبُلًۭا مَّا كَانُوا۟ لِيُؤْمِنُوٓا۟ إِلَّآ أَن يَشَآءَ ٱللَّهُ وَلَٰكِنَّ أَكْثَرَهُمْ يَجْهَلُونَ',
		number_in_surah: '111',
		page: '142',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '901',
		number: '901',
		text: 'وَكَذَٰلِكَ جَعَلْنَا لِكُلِّ نَبِىٍّ عَدُوًّۭا شَيَٰطِينَ ٱلْإِنسِ وَٱلْجِنِّ يُوحِى بَعْضُهُمْ إِلَىٰ بَعْضٍۢ زُخْرُفَ ٱلْقَوْلِ غُرُورًۭا ۚ وَلَوْ شَآءَ رَبُّكَ مَا فَعَلُوهُ ۖ فَذَرْهُمْ وَمَا يَفْتَرُونَ',
		number_in_surah: '112',
		page: '142',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '902',
		number: '902',
		text: 'وَلِتَصْغَىٰٓ إِلَيْهِ أَفْـِٔدَةُ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ وَلِيَرْضَوْهُ وَلِيَقْتَرِفُوا۟ مَا هُم مُّقْتَرِفُونَ',
		number_in_surah: '113',
		page: '142',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '903',
		number: '903',
		text: 'أَفَغَيْرَ ٱللَّهِ أَبْتَغِى حَكَمًۭا وَهُوَ ٱلَّذِىٓ أَنزَلَ إِلَيْكُمُ ٱلْكِتَٰبَ مُفَصَّلًۭا ۚ وَٱلَّذِينَ ءَاتَيْنَٰهُمُ ٱلْكِتَٰبَ يَعْلَمُونَ أَنَّهُۥ مُنَزَّلٌۭ مِّن رَّبِّكَ بِٱلْحَقِّ ۖ فَلَا تَكُونَنَّ مِنَ ٱلْمُمْتَرِينَ',
		number_in_surah: '114',
		page: '142',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '904',
		number: '904',
		text: 'وَتَمَّتْ كَلِمَتُ رَبِّكَ صِدْقًۭا وَعَدْلًۭا ۚ لَّا مُبَدِّلَ لِكَلِمَٰتِهِۦ ۚ وَهُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '115',
		page: '142',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '905',
		number: '905',
		text: 'وَإِن تُطِعْ أَكْثَرَ مَن فِى ٱلْأَرْضِ يُضِلُّوكَ عَن سَبِيلِ ٱللَّهِ ۚ إِن يَتَّبِعُونَ إِلَّا ٱلظَّنَّ وَإِنْ هُمْ إِلَّا يَخْرُصُونَ',
		number_in_surah: '116',
		page: '142',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '906',
		number: '906',
		text: 'إِنَّ رَبَّكَ هُوَ أَعْلَمُ مَن يَضِلُّ عَن سَبِيلِهِۦ ۖ وَهُوَ أَعْلَمُ بِٱلْمُهْتَدِينَ',
		number_in_surah: '117',
		page: '142',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '907',
		number: '907',
		text: 'فَكُلُوا۟ مِمَّا ذُكِرَ ٱسْمُ ٱللَّهِ عَلَيْهِ إِن كُنتُم بِـَٔايَٰتِهِۦ مُؤْمِنِينَ',
		number_in_surah: '118',
		page: '142',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '908',
		number: '908',
		text: 'وَمَا لَكُمْ أَلَّا تَأْكُلُوا۟ مِمَّا ذُكِرَ ٱسْمُ ٱللَّهِ عَلَيْهِ وَقَدْ فَصَّلَ لَكُم مَّا حَرَّمَ عَلَيْكُمْ إِلَّا مَا ٱضْطُرِرْتُمْ إِلَيْهِ ۗ وَإِنَّ كَثِيرًۭا لَّيُضِلُّونَ بِأَهْوَآئِهِم بِغَيْرِ عِلْمٍ ۗ إِنَّ رَبَّكَ هُوَ أَعْلَمُ بِٱلْمُعْتَدِينَ',
		number_in_surah: '119',
		page: '143',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '909',
		number: '909',
		text: 'وَذَرُوا۟ ظَٰهِرَ ٱلْإِثْمِ وَبَاطِنَهُۥٓ ۚ إِنَّ ٱلَّذِينَ يَكْسِبُونَ ٱلْإِثْمَ سَيُجْزَوْنَ بِمَا كَانُوا۟ يَقْتَرِفُونَ',
		number_in_surah: '120',
		page: '143',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '910',
		number: '910',
		text: 'وَلَا تَأْكُلُوا۟ مِمَّا لَمْ يُذْكَرِ ٱسْمُ ٱللَّهِ عَلَيْهِ وَإِنَّهُۥ لَفِسْقٌۭ ۗ وَإِنَّ ٱلشَّيَٰطِينَ لَيُوحُونَ إِلَىٰٓ أَوْلِيَآئِهِمْ لِيُجَٰدِلُوكُمْ ۖ وَإِنْ أَطَعْتُمُوهُمْ إِنَّكُمْ لَمُشْرِكُونَ',
		number_in_surah: '121',
		page: '143',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '911',
		number: '911',
		text: 'أَوَمَن كَانَ مَيْتًۭا فَأَحْيَيْنَٰهُ وَجَعَلْنَا لَهُۥ نُورًۭا يَمْشِى بِهِۦ فِى ٱلنَّاسِ كَمَن مَّثَلُهُۥ فِى ٱلظُّلُمَٰتِ لَيْسَ بِخَارِجٍۢ مِّنْهَا ۚ كَذَٰلِكَ زُيِّنَ لِلْكَٰفِرِينَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '122',
		page: '143',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '912',
		number: '912',
		text: 'وَكَذَٰلِكَ جَعَلْنَا فِى كُلِّ قَرْيَةٍ أَكَٰبِرَ مُجْرِمِيهَا لِيَمْكُرُوا۟ فِيهَا ۖ وَمَا يَمْكُرُونَ إِلَّا بِأَنفُسِهِمْ وَمَا يَشْعُرُونَ',
		number_in_surah: '123',
		page: '143',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '913',
		number: '913',
		text: 'وَإِذَا جَآءَتْهُمْ ءَايَةٌۭ قَالُوا۟ لَن نُّؤْمِنَ حَتَّىٰ نُؤْتَىٰ مِثْلَ مَآ أُوتِىَ رُسُلُ ٱللَّهِ ۘ ٱللَّهُ أَعْلَمُ حَيْثُ يَجْعَلُ رِسَالَتَهُۥ ۗ سَيُصِيبُ ٱلَّذِينَ أَجْرَمُوا۟ صَغَارٌ عِندَ ٱللَّهِ وَعَذَابٌۭ شَدِيدٌۢ بِمَا كَانُوا۟ يَمْكُرُونَ',
		number_in_surah: '124',
		page: '143',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '914',
		number: '914',
		text: 'فَمَن يُرِدِ ٱللَّهُ أَن يَهْدِيَهُۥ يَشْرَحْ صَدْرَهُۥ لِلْإِسْلَٰمِ ۖ وَمَن يُرِدْ أَن يُضِلَّهُۥ يَجْعَلْ صَدْرَهُۥ ضَيِّقًا حَرَجًۭا كَأَنَّمَا يَصَّعَّدُ فِى ٱلسَّمَآءِ ۚ كَذَٰلِكَ يَجْعَلُ ٱللَّهُ ٱلرِّجْسَ عَلَى ٱلَّذِينَ لَا يُؤْمِنُونَ',
		number_in_surah: '125',
		page: '144',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '915',
		number: '915',
		text: 'وَهَٰذَا صِرَٰطُ رَبِّكَ مُسْتَقِيمًۭا ۗ قَدْ فَصَّلْنَا ٱلْءَايَٰتِ لِقَوْمٍۢ يَذَّكَّرُونَ',
		number_in_surah: '126',
		page: '144',
		surah_id: '6',
		hizb_id: '57',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '916',
		number: '916',
		text: '۞ لَهُمْ دَارُ ٱلسَّلَٰمِ عِندَ رَبِّهِمْ ۖ وَهُوَ وَلِيُّهُم بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '127',
		page: '144',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '917',
		number: '917',
		text: 'وَيَوْمَ يَحْشُرُهُمْ جَمِيعًۭا يَٰمَعْشَرَ ٱلْجِنِّ قَدِ ٱسْتَكْثَرْتُم مِّنَ ٱلْإِنسِ ۖ وَقَالَ أَوْلِيَآؤُهُم مِّنَ ٱلْإِنسِ رَبَّنَا ٱسْتَمْتَعَ بَعْضُنَا بِبَعْضٍۢ وَبَلَغْنَآ أَجَلَنَا ٱلَّذِىٓ أَجَّلْتَ لَنَا ۚ قَالَ ٱلنَّارُ مَثْوَىٰكُمْ خَٰلِدِينَ فِيهَآ إِلَّا مَا شَآءَ ٱللَّهُ ۗ إِنَّ رَبَّكَ حَكِيمٌ عَلِيمٌۭ',
		number_in_surah: '128',
		page: '144',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '918',
		number: '918',
		text: 'وَكَذَٰلِكَ نُوَلِّى بَعْضَ ٱلظَّٰلِمِينَ بَعْضًۢا بِمَا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '129',
		page: '144',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '919',
		number: '919',
		text: 'يَٰمَعْشَرَ ٱلْجِنِّ وَٱلْإِنسِ أَلَمْ يَأْتِكُمْ رُسُلٌۭ مِّنكُمْ يَقُصُّونَ عَلَيْكُمْ ءَايَٰتِى وَيُنذِرُونَكُمْ لِقَآءَ يَوْمِكُمْ هَٰذَا ۚ قَالُوا۟ شَهِدْنَا عَلَىٰٓ أَنفُسِنَا ۖ وَغَرَّتْهُمُ ٱلْحَيَوٰةُ ٱلدُّنْيَا وَشَهِدُوا۟ عَلَىٰٓ أَنفُسِهِمْ أَنَّهُمْ كَانُوا۟ كَٰفِرِينَ',
		number_in_surah: '130',
		page: '144',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '920',
		number: '920',
		text: 'ذَٰلِكَ أَن لَّمْ يَكُن رَّبُّكَ مُهْلِكَ ٱلْقُرَىٰ بِظُلْمٍۢ وَأَهْلُهَا غَٰفِلُونَ',
		number_in_surah: '131',
		page: '144',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '921',
		number: '921',
		text: 'وَلِكُلٍّۢ دَرَجَٰتٌۭ مِّمَّا عَمِلُوا۟ ۚ وَمَا رَبُّكَ بِغَٰفِلٍ عَمَّا يَعْمَلُونَ',
		number_in_surah: '132',
		page: '145',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '922',
		number: '922',
		text: 'وَرَبُّكَ ٱلْغَنِىُّ ذُو ٱلرَّحْمَةِ ۚ إِن يَشَأْ يُذْهِبْكُمْ وَيَسْتَخْلِفْ مِنۢ بَعْدِكُم مَّا يَشَآءُ كَمَآ أَنشَأَكُم مِّن ذُرِّيَّةِ قَوْمٍ ءَاخَرِينَ',
		number_in_surah: '133',
		page: '145',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '923',
		number: '923',
		text: 'إِنَّ مَا تُوعَدُونَ لَءَاتٍۢ ۖ وَمَآ أَنتُم بِمُعْجِزِينَ',
		number_in_surah: '134',
		page: '145',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '924',
		number: '924',
		text: 'قُلْ يَٰقَوْمِ ٱعْمَلُوا۟ عَلَىٰ مَكَانَتِكُمْ إِنِّى عَامِلٌۭ ۖ فَسَوْفَ تَعْلَمُونَ مَن تَكُونُ لَهُۥ عَٰقِبَةُ ٱلدَّارِ ۗ إِنَّهُۥ لَا يُفْلِحُ ٱلظَّٰلِمُونَ',
		number_in_surah: '135',
		page: '145',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '925',
		number: '925',
		text: 'وَجَعَلُوا۟ لِلَّهِ مِمَّا ذَرَأَ مِنَ ٱلْحَرْثِ وَٱلْأَنْعَٰمِ نَصِيبًۭا فَقَالُوا۟ هَٰذَا لِلَّهِ بِزَعْمِهِمْ وَهَٰذَا لِشُرَكَآئِنَا ۖ فَمَا كَانَ لِشُرَكَآئِهِمْ فَلَا يَصِلُ إِلَى ٱللَّهِ ۖ وَمَا كَانَ لِلَّهِ فَهُوَ يَصِلُ إِلَىٰ شُرَكَآئِهِمْ ۗ سَآءَ مَا يَحْكُمُونَ',
		number_in_surah: '136',
		page: '145',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '926',
		number: '926',
		text: 'وَكَذَٰلِكَ زَيَّنَ لِكَثِيرٍۢ مِّنَ ٱلْمُشْرِكِينَ قَتْلَ أَوْلَٰدِهِمْ شُرَكَآؤُهُمْ لِيُرْدُوهُمْ وَلِيَلْبِسُوا۟ عَلَيْهِمْ دِينَهُمْ ۖ وَلَوْ شَآءَ ٱللَّهُ مَا فَعَلُوهُ ۖ فَذَرْهُمْ وَمَا يَفْتَرُونَ',
		number_in_surah: '137',
		page: '145',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '927',
		number: '927',
		text: 'وَقَالُوا۟ هَٰذِهِۦٓ أَنْعَٰمٌۭ وَحَرْثٌ حِجْرٌۭ لَّا يَطْعَمُهَآ إِلَّا مَن نَّشَآءُ بِزَعْمِهِمْ وَأَنْعَٰمٌ حُرِّمَتْ ظُهُورُهَا وَأَنْعَٰمٌۭ لَّا يَذْكُرُونَ ٱسْمَ ٱللَّهِ عَلَيْهَا ٱفْتِرَآءً عَلَيْهِ ۚ سَيَجْزِيهِم بِمَا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '138',
		page: '146',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '928',
		number: '928',
		text: 'وَقَالُوا۟ مَا فِى بُطُونِ هَٰذِهِ ٱلْأَنْعَٰمِ خَالِصَةٌۭ لِّذُكُورِنَا وَمُحَرَّمٌ عَلَىٰٓ أَزْوَٰجِنَا ۖ وَإِن يَكُن مَّيْتَةًۭ فَهُمْ فِيهِ شُرَكَآءُ ۚ سَيَجْزِيهِمْ وَصْفَهُمْ ۚ إِنَّهُۥ حَكِيمٌ عَلِيمٌۭ',
		number_in_surah: '139',
		page: '146',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '929',
		number: '929',
		text: 'قَدْ خَسِرَ ٱلَّذِينَ قَتَلُوٓا۟ أَوْلَٰدَهُمْ سَفَهًۢا بِغَيْرِ عِلْمٍۢ وَحَرَّمُوا۟ مَا رَزَقَهُمُ ٱللَّهُ ٱفْتِرَآءً عَلَى ٱللَّهِ ۚ قَدْ ضَلُّوا۟ وَمَا كَانُوا۟ مُهْتَدِينَ',
		number_in_surah: '140',
		page: '146',
		surah_id: '6',
		hizb_id: '58',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '930',
		number: '930',
		text: '۞ وَهُوَ ٱلَّذِىٓ أَنشَأَ جَنَّٰتٍۢ مَّعْرُوشَٰتٍۢ وَغَيْرَ مَعْرُوشَٰتٍۢ وَٱلنَّخْلَ وَٱلزَّرْعَ مُخْتَلِفًا أُكُلُهُۥ وَٱلزَّيْتُونَ وَٱلرُّمَّانَ مُتَشَٰبِهًۭا وَغَيْرَ مُتَشَٰبِهٍۢ ۚ كُلُوا۟ مِن ثَمَرِهِۦٓ إِذَآ أَثْمَرَ وَءَاتُوا۟ حَقَّهُۥ يَوْمَ حَصَادِهِۦ ۖ وَلَا تُسْرِفُوٓا۟ ۚ إِنَّهُۥ لَا يُحِبُّ ٱلْمُسْرِفِينَ',
		number_in_surah: '141',
		page: '146',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '931',
		number: '931',
		text: 'وَمِنَ ٱلْأَنْعَٰمِ حَمُولَةًۭ وَفَرْشًۭا ۚ كُلُوا۟ مِمَّا رَزَقَكُمُ ٱللَّهُ وَلَا تَتَّبِعُوا۟ خُطُوَٰتِ ٱلشَّيْطَٰنِ ۚ إِنَّهُۥ لَكُمْ عَدُوٌّۭ مُّبِينٌۭ',
		number_in_surah: '142',
		page: '146',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '932',
		number: '932',
		text: 'ثَمَٰنِيَةَ أَزْوَٰجٍۢ ۖ مِّنَ ٱلضَّأْنِ ٱثْنَيْنِ وَمِنَ ٱلْمَعْزِ ٱثْنَيْنِ ۗ قُلْ ءَآلذَّكَرَيْنِ حَرَّمَ أَمِ ٱلْأُنثَيَيْنِ أَمَّا ٱشْتَمَلَتْ عَلَيْهِ أَرْحَامُ ٱلْأُنثَيَيْنِ ۖ نَبِّـُٔونِى بِعِلْمٍ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '143',
		page: '147',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '933',
		number: '933',
		text: 'وَمِنَ ٱلْإِبِلِ ٱثْنَيْنِ وَمِنَ ٱلْبَقَرِ ٱثْنَيْنِ ۗ قُلْ ءَآلذَّكَرَيْنِ حَرَّمَ أَمِ ٱلْأُنثَيَيْنِ أَمَّا ٱشْتَمَلَتْ عَلَيْهِ أَرْحَامُ ٱلْأُنثَيَيْنِ ۖ أَمْ كُنتُمْ شُهَدَآءَ إِذْ وَصَّىٰكُمُ ٱللَّهُ بِهَٰذَا ۚ فَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًۭا لِّيُضِلَّ ٱلنَّاسَ بِغَيْرِ عِلْمٍ ۗ إِنَّ ٱللَّهَ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '144',
		page: '147',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '934',
		number: '934',
		text: 'قُل لَّآ أَجِدُ فِى مَآ أُوحِىَ إِلَىَّ مُحَرَّمًا عَلَىٰ طَاعِمٍۢ يَطْعَمُهُۥٓ إِلَّآ أَن يَكُونَ مَيْتَةً أَوْ دَمًۭا مَّسْفُوحًا أَوْ لَحْمَ خِنزِيرٍۢ فَإِنَّهُۥ رِجْسٌ أَوْ فِسْقًا أُهِلَّ لِغَيْرِ ٱللَّهِ بِهِۦ ۚ فَمَنِ ٱضْطُرَّ غَيْرَ بَاغٍۢ وَلَا عَادٍۢ فَإِنَّ رَبَّكَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '145',
		page: '147',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '935',
		number: '935',
		text: 'وَعَلَى ٱلَّذِينَ هَادُوا۟ حَرَّمْنَا كُلَّ ذِى ظُفُرٍۢ ۖ وَمِنَ ٱلْبَقَرِ وَٱلْغَنَمِ حَرَّمْنَا عَلَيْهِمْ شُحُومَهُمَآ إِلَّا مَا حَمَلَتْ ظُهُورُهُمَآ أَوِ ٱلْحَوَايَآ أَوْ مَا ٱخْتَلَطَ بِعَظْمٍۢ ۚ ذَٰلِكَ جَزَيْنَٰهُم بِبَغْيِهِمْ ۖ وَإِنَّا لَصَٰدِقُونَ',
		number_in_surah: '146',
		page: '147',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '936',
		number: '936',
		text: 'فَإِن كَذَّبُوكَ فَقُل رَّبُّكُمْ ذُو رَحْمَةٍۢ وَٰسِعَةٍۢ وَلَا يُرَدُّ بَأْسُهُۥ عَنِ ٱلْقَوْمِ ٱلْمُجْرِمِينَ',
		number_in_surah: '147',
		page: '148',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '937',
		number: '937',
		text: 'سَيَقُولُ ٱلَّذِينَ أَشْرَكُوا۟ لَوْ شَآءَ ٱللَّهُ مَآ أَشْرَكْنَا وَلَآ ءَابَآؤُنَا وَلَا حَرَّمْنَا مِن شَىْءٍۢ ۚ كَذَٰلِكَ كَذَّبَ ٱلَّذِينَ مِن قَبْلِهِمْ حَتَّىٰ ذَاقُوا۟ بَأْسَنَا ۗ قُلْ هَلْ عِندَكُم مِّنْ عِلْمٍۢ فَتُخْرِجُوهُ لَنَآ ۖ إِن تَتَّبِعُونَ إِلَّا ٱلظَّنَّ وَإِنْ أَنتُمْ إِلَّا تَخْرُصُونَ',
		number_in_surah: '148',
		page: '148',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '938',
		number: '938',
		text: 'قُلْ فَلِلَّهِ ٱلْحُجَّةُ ٱلْبَٰلِغَةُ ۖ فَلَوْ شَآءَ لَهَدَىٰكُمْ أَجْمَعِينَ',
		number_in_surah: '149',
		page: '148',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '939',
		number: '939',
		text: 'قُلْ هَلُمَّ شُهَدَآءَكُمُ ٱلَّذِينَ يَشْهَدُونَ أَنَّ ٱللَّهَ حَرَّمَ هَٰذَا ۖ فَإِن شَهِدُوا۟ فَلَا تَشْهَدْ مَعَهُمْ ۚ وَلَا تَتَّبِعْ أَهْوَآءَ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا وَٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ وَهُم بِرَبِّهِمْ يَعْدِلُونَ',
		number_in_surah: '150',
		page: '148',
		surah_id: '6',
		hizb_id: '59',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '940',
		number: '940',
		text: '۞ قُلْ تَعَالَوْا۟ أَتْلُ مَا حَرَّمَ رَبُّكُمْ عَلَيْكُمْ ۖ أَلَّا تُشْرِكُوا۟ بِهِۦ شَيْـًۭٔا ۖ وَبِٱلْوَٰلِدَيْنِ إِحْسَٰنًۭا ۖ وَلَا تَقْتُلُوٓا۟ أَوْلَٰدَكُم مِّنْ إِمْلَٰقٍۢ ۖ نَّحْنُ نَرْزُقُكُمْ وَإِيَّاهُمْ ۖ وَلَا تَقْرَبُوا۟ ٱلْفَوَٰحِشَ مَا ظَهَرَ مِنْهَا وَمَا بَطَنَ ۖ وَلَا تَقْتُلُوا۟ ٱلنَّفْسَ ٱلَّتِى حَرَّمَ ٱللَّهُ إِلَّا بِٱلْحَقِّ ۚ ذَٰلِكُمْ وَصَّىٰكُم بِهِۦ لَعَلَّكُمْ تَعْقِلُونَ',
		number_in_surah: '151',
		page: '148',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '941',
		number: '941',
		text: 'وَلَا تَقْرَبُوا۟ مَالَ ٱلْيَتِيمِ إِلَّا بِٱلَّتِى هِىَ أَحْسَنُ حَتَّىٰ يَبْلُغَ أَشُدَّهُۥ ۖ وَأَوْفُوا۟ ٱلْكَيْلَ وَٱلْمِيزَانَ بِٱلْقِسْطِ ۖ لَا نُكَلِّفُ نَفْسًا إِلَّا وُسْعَهَا ۖ وَإِذَا قُلْتُمْ فَٱعْدِلُوا۟ وَلَوْ كَانَ ذَا قُرْبَىٰ ۖ وَبِعَهْدِ ٱللَّهِ أَوْفُوا۟ ۚ ذَٰلِكُمْ وَصَّىٰكُم بِهِۦ لَعَلَّكُمْ تَذَكَّرُونَ',
		number_in_surah: '152',
		page: '149',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '942',
		number: '942',
		text: 'وَأَنَّ هَٰذَا صِرَٰطِى مُسْتَقِيمًۭا فَٱتَّبِعُوهُ ۖ وَلَا تَتَّبِعُوا۟ ٱلسُّبُلَ فَتَفَرَّقَ بِكُمْ عَن سَبِيلِهِۦ ۚ ذَٰلِكُمْ وَصَّىٰكُم بِهِۦ لَعَلَّكُمْ تَتَّقُونَ',
		number_in_surah: '153',
		page: '149',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '943',
		number: '943',
		text: 'ثُمَّ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ تَمَامًا عَلَى ٱلَّذِىٓ أَحْسَنَ وَتَفْصِيلًۭا لِّكُلِّ شَىْءٍۢ وَهُدًۭى وَرَحْمَةًۭ لَّعَلَّهُم بِلِقَآءِ رَبِّهِمْ يُؤْمِنُونَ',
		number_in_surah: '154',
		page: '149',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '944',
		number: '944',
		text: 'وَهَٰذَا كِتَٰبٌ أَنزَلْنَٰهُ مُبَارَكٌۭ فَٱتَّبِعُوهُ وَٱتَّقُوا۟ لَعَلَّكُمْ تُرْحَمُونَ',
		number_in_surah: '155',
		page: '149',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '945',
		number: '945',
		text: 'أَن تَقُولُوٓا۟ إِنَّمَآ أُنزِلَ ٱلْكِتَٰبُ عَلَىٰ طَآئِفَتَيْنِ مِن قَبْلِنَا وَإِن كُنَّا عَن دِرَاسَتِهِمْ لَغَٰفِلِينَ',
		number_in_surah: '156',
		page: '149',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '946',
		number: '946',
		text: 'أَوْ تَقُولُوا۟ لَوْ أَنَّآ أُنزِلَ عَلَيْنَا ٱلْكِتَٰبُ لَكُنَّآ أَهْدَىٰ مِنْهُمْ ۚ فَقَدْ جَآءَكُم بَيِّنَةٌۭ مِّن رَّبِّكُمْ وَهُدًۭى وَرَحْمَةٌۭ ۚ فَمَنْ أَظْلَمُ مِمَّن كَذَّبَ بِـَٔايَٰتِ ٱللَّهِ وَصَدَفَ عَنْهَا ۗ سَنَجْزِى ٱلَّذِينَ يَصْدِفُونَ عَنْ ءَايَٰتِنَا سُوٓءَ ٱلْعَذَابِ بِمَا كَانُوا۟ يَصْدِفُونَ',
		number_in_surah: '157',
		page: '149',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '947',
		number: '947',
		text: 'هَلْ يَنظُرُونَ إِلَّآ أَن تَأْتِيَهُمُ ٱلْمَلَٰٓئِكَةُ أَوْ يَأْتِىَ رَبُّكَ أَوْ يَأْتِىَ بَعْضُ ءَايَٰتِ رَبِّكَ ۗ يَوْمَ يَأْتِى بَعْضُ ءَايَٰتِ رَبِّكَ لَا يَنفَعُ نَفْسًا إِيمَٰنُهَا لَمْ تَكُنْ ءَامَنَتْ مِن قَبْلُ أَوْ كَسَبَتْ فِىٓ إِيمَٰنِهَا خَيْرًۭا ۗ قُلِ ٱنتَظِرُوٓا۟ إِنَّا مُنتَظِرُونَ',
		number_in_surah: '158',
		page: '150',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '948',
		number: '948',
		text: 'إِنَّ ٱلَّذِينَ فَرَّقُوا۟ دِينَهُمْ وَكَانُوا۟ شِيَعًۭا لَّسْتَ مِنْهُمْ فِى شَىْءٍ ۚ إِنَّمَآ أَمْرُهُمْ إِلَى ٱللَّهِ ثُمَّ يُنَبِّئُهُم بِمَا كَانُوا۟ يَفْعَلُونَ',
		number_in_surah: '159',
		page: '150',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '949',
		number: '949',
		text: 'مَن جَآءَ بِٱلْحَسَنَةِ فَلَهُۥ عَشْرُ أَمْثَالِهَا ۖ وَمَن جَآءَ بِٱلسَّيِّئَةِ فَلَا يُجْزَىٰٓ إِلَّا مِثْلَهَا وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '160',
		page: '150',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '950',
		number: '950',
		text: 'قُلْ إِنَّنِى هَدَىٰنِى رَبِّىٓ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ دِينًۭا قِيَمًۭا مِّلَّةَ إِبْرَٰهِيمَ حَنِيفًۭا ۚ وَمَا كَانَ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '161',
		page: '150',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '951',
		number: '951',
		text: 'قُلْ إِنَّ صَلَاتِى وَنُسُكِى وَمَحْيَاىَ وَمَمَاتِى لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '162',
		page: '150',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '952',
		number: '952',
		text: 'لَا شَرِيكَ لَهُۥ ۖ وَبِذَٰلِكَ أُمِرْتُ وَأَنَا۠ أَوَّلُ ٱلْمُسْلِمِينَ',
		number_in_surah: '163',
		page: '150',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '953',
		number: '953',
		text: 'قُلْ أَغَيْرَ ٱللَّهِ أَبْغِى رَبًّۭا وَهُوَ رَبُّ كُلِّ شَىْءٍۢ ۚ وَلَا تَكْسِبُ كُلُّ نَفْسٍ إِلَّا عَلَيْهَا ۚ وَلَا تَزِرُ وَازِرَةٌۭ وِزْرَ أُخْرَىٰ ۚ ثُمَّ إِلَىٰ رَبِّكُم مَّرْجِعُكُمْ فَيُنَبِّئُكُم بِمَا كُنتُمْ فِيهِ تَخْتَلِفُونَ',
		number_in_surah: '164',
		page: '150',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '954',
		number: '954',
		text: 'وَهُوَ ٱلَّذِى جَعَلَكُمْ خَلَٰٓئِفَ ٱلْأَرْضِ وَرَفَعَ بَعْضَكُمْ فَوْقَ بَعْضٍۢ دَرَجَٰتٍۢ لِّيَبْلُوَكُمْ فِى مَآ ءَاتَىٰكُمْ ۗ إِنَّ رَبَّكَ سَرِيعُ ٱلْعِقَابِ وَإِنَّهُۥ لَغَفُورٌۭ رَّحِيمٌۢ',
		number_in_surah: '165',
		page: '150',
		surah_id: '6',
		hizb_id: '60',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '955',
		number: '955',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓمٓصٓ',
		number_in_surah: '1',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '956',
		number: '956',
		text: 'كِتَٰبٌ أُنزِلَ إِلَيْكَ فَلَا يَكُن فِى صَدْرِكَ حَرَجٌۭ مِّنْهُ لِتُنذِرَ بِهِۦ وَذِكْرَىٰ لِلْمُؤْمِنِينَ',
		number_in_surah: '2',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '957',
		number: '957',
		text: 'ٱتَّبِعُوا۟ مَآ أُنزِلَ إِلَيْكُم مِّن رَّبِّكُمْ وَلَا تَتَّبِعُوا۟ مِن دُونِهِۦٓ أَوْلِيَآءَ ۗ قَلِيلًۭا مَّا تَذَكَّرُونَ',
		number_in_surah: '3',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '958',
		number: '958',
		text: 'وَكَم مِّن قَرْيَةٍ أَهْلَكْنَٰهَا فَجَآءَهَا بَأْسُنَا بَيَٰتًا أَوْ هُمْ قَآئِلُونَ',
		number_in_surah: '4',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '959',
		number: '959',
		text: 'فَمَا كَانَ دَعْوَىٰهُمْ إِذْ جَآءَهُم بَأْسُنَآ إِلَّآ أَن قَالُوٓا۟ إِنَّا كُنَّا ظَٰلِمِينَ',
		number_in_surah: '5',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '960',
		number: '960',
		text: 'فَلَنَسْـَٔلَنَّ ٱلَّذِينَ أُرْسِلَ إِلَيْهِمْ وَلَنَسْـَٔلَنَّ ٱلْمُرْسَلِينَ',
		number_in_surah: '6',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '961',
		number: '961',
		text: 'فَلَنَقُصَّنَّ عَلَيْهِم بِعِلْمٍۢ ۖ وَمَا كُنَّا غَآئِبِينَ',
		number_in_surah: '7',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '962',
		number: '962',
		text: 'وَٱلْوَزْنُ يَوْمَئِذٍ ٱلْحَقُّ ۚ فَمَن ثَقُلَتْ مَوَٰزِينُهُۥ فَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '8',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '963',
		number: '963',
		text: 'وَمَنْ خَفَّتْ مَوَٰزِينُهُۥ فَأُو۟لَٰٓئِكَ ٱلَّذِينَ خَسِرُوٓا۟ أَنفُسَهُم بِمَا كَانُوا۟ بِـَٔايَٰتِنَا يَظْلِمُونَ',
		number_in_surah: '9',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '964',
		number: '964',
		text: 'وَلَقَدْ مَكَّنَّٰكُمْ فِى ٱلْأَرْضِ وَجَعَلْنَا لَكُمْ فِيهَا مَعَٰيِشَ ۗ قَلِيلًۭا مَّا تَشْكُرُونَ',
		number_in_surah: '10',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '965',
		number: '965',
		text: 'وَلَقَدْ خَلَقْنَٰكُمْ ثُمَّ صَوَّرْنَٰكُمْ ثُمَّ قُلْنَا لِلْمَلَٰٓئِكَةِ ٱسْجُدُوا۟ لِءَادَمَ فَسَجَدُوٓا۟ إِلَّآ إِبْلِيسَ لَمْ يَكُن مِّنَ ٱلسَّٰجِدِينَ',
		number_in_surah: '11',
		page: '151',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '966',
		number: '966',
		text: 'قَالَ مَا مَنَعَكَ أَلَّا تَسْجُدَ إِذْ أَمَرْتُكَ ۖ قَالَ أَنَا۠ خَيْرٌۭ مِّنْهُ خَلَقْتَنِى مِن نَّارٍۢ وَخَلَقْتَهُۥ مِن طِينٍۢ',
		number_in_surah: '12',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '967',
		number: '967',
		text: 'قَالَ فَٱهْبِطْ مِنْهَا فَمَا يَكُونُ لَكَ أَن تَتَكَبَّرَ فِيهَا فَٱخْرُجْ إِنَّكَ مِنَ ٱلصَّٰغِرِينَ',
		number_in_surah: '13',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '968',
		number: '968',
		text: 'قَالَ أَنظِرْنِىٓ إِلَىٰ يَوْمِ يُبْعَثُونَ',
		number_in_surah: '14',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '969',
		number: '969',
		text: 'قَالَ إِنَّكَ مِنَ ٱلْمُنظَرِينَ',
		number_in_surah: '15',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '970',
		number: '970',
		text: 'قَالَ فَبِمَآ أَغْوَيْتَنِى لَأَقْعُدَنَّ لَهُمْ صِرَٰطَكَ ٱلْمُسْتَقِيمَ',
		number_in_surah: '16',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '971',
		number: '971',
		text: 'ثُمَّ لَءَاتِيَنَّهُم مِّنۢ بَيْنِ أَيْدِيهِمْ وَمِنْ خَلْفِهِمْ وَعَنْ أَيْمَٰنِهِمْ وَعَن شَمَآئِلِهِمْ ۖ وَلَا تَجِدُ أَكْثَرَهُمْ شَٰكِرِينَ',
		number_in_surah: '17',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '972',
		number: '972',
		text: 'قَالَ ٱخْرُجْ مِنْهَا مَذْءُومًۭا مَّدْحُورًۭا ۖ لَّمَن تَبِعَكَ مِنْهُمْ لَأَمْلَأَنَّ جَهَنَّمَ مِنكُمْ أَجْمَعِينَ',
		number_in_surah: '18',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '973',
		number: '973',
		text: 'وَيَٰٓـَٔادَمُ ٱسْكُنْ أَنتَ وَزَوْجُكَ ٱلْجَنَّةَ فَكُلَا مِنْ حَيْثُ شِئْتُمَا وَلَا تَقْرَبَا هَٰذِهِ ٱلشَّجَرَةَ فَتَكُونَا مِنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '19',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '974',
		number: '974',
		text: 'فَوَسْوَسَ لَهُمَا ٱلشَّيْطَٰنُ لِيُبْدِىَ لَهُمَا مَا وُۥرِىَ عَنْهُمَا مِن سَوْءَٰتِهِمَا وَقَالَ مَا نَهَىٰكُمَا رَبُّكُمَا عَنْ هَٰذِهِ ٱلشَّجَرَةِ إِلَّآ أَن تَكُونَا مَلَكَيْنِ أَوْ تَكُونَا مِنَ ٱلْخَٰلِدِينَ',
		number_in_surah: '20',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '975',
		number: '975',
		text: 'وَقَاسَمَهُمَآ إِنِّى لَكُمَا لَمِنَ ٱلنَّٰصِحِينَ',
		number_in_surah: '21',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '976',
		number: '976',
		text: 'فَدَلَّىٰهُمَا بِغُرُورٍۢ ۚ فَلَمَّا ذَاقَا ٱلشَّجَرَةَ بَدَتْ لَهُمَا سَوْءَٰتُهُمَا وَطَفِقَا يَخْصِفَانِ عَلَيْهِمَا مِن وَرَقِ ٱلْجَنَّةِ ۖ وَنَادَىٰهُمَا رَبُّهُمَآ أَلَمْ أَنْهَكُمَا عَن تِلْكُمَا ٱلشَّجَرَةِ وَأَقُل لَّكُمَآ إِنَّ ٱلشَّيْطَٰنَ لَكُمَا عَدُوٌّۭ مُّبِينٌۭ',
		number_in_surah: '22',
		page: '152',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '977',
		number: '977',
		text: 'قَالَا رَبَّنَا ظَلَمْنَآ أَنفُسَنَا وَإِن لَّمْ تَغْفِرْ لَنَا وَتَرْحَمْنَا لَنَكُونَنَّ مِنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '23',
		page: '153',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '978',
		number: '978',
		text: 'قَالَ ٱهْبِطُوا۟ بَعْضُكُمْ لِبَعْضٍ عَدُوٌّۭ ۖ وَلَكُمْ فِى ٱلْأَرْضِ مُسْتَقَرٌّۭ وَمَتَٰعٌ إِلَىٰ حِينٍۢ',
		number_in_surah: '24',
		page: '153',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '979',
		number: '979',
		text: 'قَالَ فِيهَا تَحْيَوْنَ وَفِيهَا تَمُوتُونَ وَمِنْهَا تُخْرَجُونَ',
		number_in_surah: '25',
		page: '153',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '980',
		number: '980',
		text: 'يَٰبَنِىٓ ءَادَمَ قَدْ أَنزَلْنَا عَلَيْكُمْ لِبَاسًۭا يُوَٰرِى سَوْءَٰتِكُمْ وَرِيشًۭا ۖ وَلِبَاسُ ٱلتَّقْوَىٰ ذَٰلِكَ خَيْرٌۭ ۚ ذَٰلِكَ مِنْ ءَايَٰتِ ٱللَّهِ لَعَلَّهُمْ يَذَّكَّرُونَ',
		number_in_surah: '26',
		page: '153',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '981',
		number: '981',
		text: 'يَٰبَنِىٓ ءَادَمَ لَا يَفْتِنَنَّكُمُ ٱلشَّيْطَٰنُ كَمَآ أَخْرَجَ أَبَوَيْكُم مِّنَ ٱلْجَنَّةِ يَنزِعُ عَنْهُمَا لِبَاسَهُمَا لِيُرِيَهُمَا سَوْءَٰتِهِمَآ ۗ إِنَّهُۥ يَرَىٰكُمْ هُوَ وَقَبِيلُهُۥ مِنْ حَيْثُ لَا تَرَوْنَهُمْ ۗ إِنَّا جَعَلْنَا ٱلشَّيَٰطِينَ أَوْلِيَآءَ لِلَّذِينَ لَا يُؤْمِنُونَ',
		number_in_surah: '27',
		page: '153',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '982',
		number: '982',
		text: 'وَإِذَا فَعَلُوا۟ فَٰحِشَةًۭ قَالُوا۟ وَجَدْنَا عَلَيْهَآ ءَابَآءَنَا وَٱللَّهُ أَمَرَنَا بِهَا ۗ قُلْ إِنَّ ٱللَّهَ لَا يَأْمُرُ بِٱلْفَحْشَآءِ ۖ أَتَقُولُونَ عَلَى ٱللَّهِ مَا لَا تَعْلَمُونَ',
		number_in_surah: '28',
		page: '153',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '983',
		number: '983',
		text: 'قُلْ أَمَرَ رَبِّى بِٱلْقِسْطِ ۖ وَأَقِيمُوا۟ وُجُوهَكُمْ عِندَ كُلِّ مَسْجِدٍۢ وَٱدْعُوهُ مُخْلِصِينَ لَهُ ٱلدِّينَ ۚ كَمَا بَدَأَكُمْ تَعُودُونَ',
		number_in_surah: '29',
		page: '153',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '984',
		number: '984',
		text: 'فَرِيقًا هَدَىٰ وَفَرِيقًا حَقَّ عَلَيْهِمُ ٱلضَّلَٰلَةُ ۗ إِنَّهُمُ ٱتَّخَذُوا۟ ٱلشَّيَٰطِينَ أَوْلِيَآءَ مِن دُونِ ٱللَّهِ وَيَحْسَبُونَ أَنَّهُم مُّهْتَدُونَ',
		number_in_surah: '30',
		page: '153',
		surah_id: '7',
		hizb_id: '61',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '985',
		number: '985',
		text: '۞ يَٰبَنِىٓ ءَادَمَ خُذُوا۟ زِينَتَكُمْ عِندَ كُلِّ مَسْجِدٍۢ وَكُلُوا۟ وَٱشْرَبُوا۟ وَلَا تُسْرِفُوٓا۟ ۚ إِنَّهُۥ لَا يُحِبُّ ٱلْمُسْرِفِينَ',
		number_in_surah: '31',
		page: '154',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '986',
		number: '986',
		text: 'قُلْ مَنْ حَرَّمَ زِينَةَ ٱللَّهِ ٱلَّتِىٓ أَخْرَجَ لِعِبَادِهِۦ وَٱلطَّيِّبَٰتِ مِنَ ٱلرِّزْقِ ۚ قُلْ هِىَ لِلَّذِينَ ءَامَنُوا۟ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا خَالِصَةًۭ يَوْمَ ٱلْقِيَٰمَةِ ۗ كَذَٰلِكَ نُفَصِّلُ ٱلْءَايَٰتِ لِقَوْمٍۢ يَعْلَمُونَ',
		number_in_surah: '32',
		page: '154',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '987',
		number: '987',
		text: 'قُلْ إِنَّمَا حَرَّمَ رَبِّىَ ٱلْفَوَٰحِشَ مَا ظَهَرَ مِنْهَا وَمَا بَطَنَ وَٱلْإِثْمَ وَٱلْبَغْىَ بِغَيْرِ ٱلْحَقِّ وَأَن تُشْرِكُوا۟ بِٱللَّهِ مَا لَمْ يُنَزِّلْ بِهِۦ سُلْطَٰنًۭا وَأَن تَقُولُوا۟ عَلَى ٱللَّهِ مَا لَا تَعْلَمُونَ',
		number_in_surah: '33',
		page: '154',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '988',
		number: '988',
		text: 'وَلِكُلِّ أُمَّةٍ أَجَلٌۭ ۖ فَإِذَا جَآءَ أَجَلُهُمْ لَا يَسْتَأْخِرُونَ سَاعَةًۭ ۖ وَلَا يَسْتَقْدِمُونَ',
		number_in_surah: '34',
		page: '154',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '989',
		number: '989',
		text: 'يَٰبَنِىٓ ءَادَمَ إِمَّا يَأْتِيَنَّكُمْ رُسُلٌۭ مِّنكُمْ يَقُصُّونَ عَلَيْكُمْ ءَايَٰتِى ۙ فَمَنِ ٱتَّقَىٰ وَأَصْلَحَ فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '35',
		page: '154',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '990',
		number: '990',
		text: 'وَٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا وَٱسْتَكْبَرُوا۟ عَنْهَآ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '36',
		page: '154',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '991',
		number: '991',
		text: 'فَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوْ كَذَّبَ بِـَٔايَٰتِهِۦٓ ۚ أُو۟لَٰٓئِكَ يَنَالُهُمْ نَصِيبُهُم مِّنَ ٱلْكِتَٰبِ ۖ حَتَّىٰٓ إِذَا جَآءَتْهُمْ رُسُلُنَا يَتَوَفَّوْنَهُمْ قَالُوٓا۟ أَيْنَ مَا كُنتُمْ تَدْعُونَ مِن دُونِ ٱللَّهِ ۖ قَالُوا۟ ضَلُّوا۟ عَنَّا وَشَهِدُوا۟ عَلَىٰٓ أَنفُسِهِمْ أَنَّهُمْ كَانُوا۟ كَٰفِرِينَ',
		number_in_surah: '37',
		page: '154',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '992',
		number: '992',
		text: 'قَالَ ٱدْخُلُوا۟ فِىٓ أُمَمٍۢ قَدْ خَلَتْ مِن قَبْلِكُم مِّنَ ٱلْجِنِّ وَٱلْإِنسِ فِى ٱلنَّارِ ۖ كُلَّمَا دَخَلَتْ أُمَّةٌۭ لَّعَنَتْ أُخْتَهَا ۖ حَتَّىٰٓ إِذَا ٱدَّارَكُوا۟ فِيهَا جَمِيعًۭا قَالَتْ أُخْرَىٰهُمْ لِأُولَىٰهُمْ رَبَّنَا هَٰٓؤُلَآءِ أَضَلُّونَا فَـَٔاتِهِمْ عَذَابًۭا ضِعْفًۭا مِّنَ ٱلنَّارِ ۖ قَالَ لِكُلٍّۢ ضِعْفٌۭ وَلَٰكِن لَّا تَعْلَمُونَ',
		number_in_surah: '38',
		page: '155',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '993',
		number: '993',
		text: 'وَقَالَتْ أُولَىٰهُمْ لِأُخْرَىٰهُمْ فَمَا كَانَ لَكُمْ عَلَيْنَا مِن فَضْلٍۢ فَذُوقُوا۟ ٱلْعَذَابَ بِمَا كُنتُمْ تَكْسِبُونَ',
		number_in_surah: '39',
		page: '155',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '994',
		number: '994',
		text: 'إِنَّ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا وَٱسْتَكْبَرُوا۟ عَنْهَا لَا تُفَتَّحُ لَهُمْ أَبْوَٰبُ ٱلسَّمَآءِ وَلَا يَدْخُلُونَ ٱلْجَنَّةَ حَتَّىٰ يَلِجَ ٱلْجَمَلُ فِى سَمِّ ٱلْخِيَاطِ ۚ وَكَذَٰلِكَ نَجْزِى ٱلْمُجْرِمِينَ',
		number_in_surah: '40',
		page: '155',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '995',
		number: '995',
		text: 'لَهُم مِّن جَهَنَّمَ مِهَادٌۭ وَمِن فَوْقِهِمْ غَوَاشٍۢ ۚ وَكَذَٰلِكَ نَجْزِى ٱلظَّٰلِمِينَ',
		number_in_surah: '41',
		page: '155',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '996',
		number: '996',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَا نُكَلِّفُ نَفْسًا إِلَّا وُسْعَهَآ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَنَّةِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '42',
		page: '155',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '997',
		number: '997',
		text: 'وَنَزَعْنَا مَا فِى صُدُورِهِم مِّنْ غِلٍّۢ تَجْرِى مِن تَحْتِهِمُ ٱلْأَنْهَٰرُ ۖ وَقَالُوا۟ ٱلْحَمْدُ لِلَّهِ ٱلَّذِى هَدَىٰنَا لِهَٰذَا وَمَا كُنَّا لِنَهْتَدِىَ لَوْلَآ أَنْ هَدَىٰنَا ٱللَّهُ ۖ لَقَدْ جَآءَتْ رُسُلُ رَبِّنَا بِٱلْحَقِّ ۖ وَنُودُوٓا۟ أَن تِلْكُمُ ٱلْجَنَّةُ أُورِثْتُمُوهَا بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '43',
		page: '155',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '998',
		number: '998',
		text: 'وَنَادَىٰٓ أَصْحَٰبُ ٱلْجَنَّةِ أَصْحَٰبَ ٱلنَّارِ أَن قَدْ وَجَدْنَا مَا وَعَدَنَا رَبُّنَا حَقًّۭا فَهَلْ وَجَدتُّم مَّا وَعَدَ رَبُّكُمْ حَقًّۭا ۖ قَالُوا۟ نَعَمْ ۚ فَأَذَّنَ مُؤَذِّنٌۢ بَيْنَهُمْ أَن لَّعْنَةُ ٱللَّهِ عَلَى ٱلظَّٰلِمِينَ',
		number_in_surah: '44',
		page: '156',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '999',
		number: '999',
		text: 'ٱلَّذِينَ يَصُدُّونَ عَن سَبِيلِ ٱللَّهِ وَيَبْغُونَهَا عِوَجًۭا وَهُم بِٱلْءَاخِرَةِ كَٰفِرُونَ',
		number_in_surah: '45',
		page: '156',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1000',
		number: '1000',
		text: 'وَبَيْنَهُمَا حِجَابٌۭ ۚ وَعَلَى ٱلْأَعْرَافِ رِجَالٌۭ يَعْرِفُونَ كُلًّۢا بِسِيمَىٰهُمْ ۚ وَنَادَوْا۟ أَصْحَٰبَ ٱلْجَنَّةِ أَن سَلَٰمٌ عَلَيْكُمْ ۚ لَمْ يَدْخُلُوهَا وَهُمْ يَطْمَعُونَ',
		number_in_surah: '46',
		page: '156',
		surah_id: '7',
		hizb_id: '62',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1001',
		number: '1001',
		text: '۞ وَإِذَا صُرِفَتْ أَبْصَٰرُهُمْ تِلْقَآءَ أَصْحَٰبِ ٱلنَّارِ قَالُوا۟ رَبَّنَا لَا تَجْعَلْنَا مَعَ ٱلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '47',
		page: '156',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1002',
		number: '1002',
		text: 'وَنَادَىٰٓ أَصْحَٰبُ ٱلْأَعْرَافِ رِجَالًۭا يَعْرِفُونَهُم بِسِيمَىٰهُمْ قَالُوا۟ مَآ أَغْنَىٰ عَنكُمْ جَمْعُكُمْ وَمَا كُنتُمْ تَسْتَكْبِرُونَ',
		number_in_surah: '48',
		page: '156',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1003',
		number: '1003',
		text: 'أَهَٰٓؤُلَآءِ ٱلَّذِينَ أَقْسَمْتُمْ لَا يَنَالُهُمُ ٱللَّهُ بِرَحْمَةٍ ۚ ٱدْخُلُوا۟ ٱلْجَنَّةَ لَا خَوْفٌ عَلَيْكُمْ وَلَآ أَنتُمْ تَحْزَنُونَ',
		number_in_surah: '49',
		page: '156',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1004',
		number: '1004',
		text: 'وَنَادَىٰٓ أَصْحَٰبُ ٱلنَّارِ أَصْحَٰبَ ٱلْجَنَّةِ أَنْ أَفِيضُوا۟ عَلَيْنَا مِنَ ٱلْمَآءِ أَوْ مِمَّا رَزَقَكُمُ ٱللَّهُ ۚ قَالُوٓا۟ إِنَّ ٱللَّهَ حَرَّمَهُمَا عَلَى ٱلْكَٰفِرِينَ',
		number_in_surah: '50',
		page: '156',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1005',
		number: '1005',
		text: 'ٱلَّذِينَ ٱتَّخَذُوا۟ دِينَهُمْ لَهْوًۭا وَلَعِبًۭا وَغَرَّتْهُمُ ٱلْحَيَوٰةُ ٱلدُّنْيَا ۚ فَٱلْيَوْمَ نَنسَىٰهُمْ كَمَا نَسُوا۟ لِقَآءَ يَوْمِهِمْ هَٰذَا وَمَا كَانُوا۟ بِـَٔايَٰتِنَا يَجْحَدُونَ',
		number_in_surah: '51',
		page: '156',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1006',
		number: '1006',
		text: 'وَلَقَدْ جِئْنَٰهُم بِكِتَٰبٍۢ فَصَّلْنَٰهُ عَلَىٰ عِلْمٍ هُدًۭى وَرَحْمَةًۭ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '52',
		page: '157',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1007',
		number: '1007',
		text: 'هَلْ يَنظُرُونَ إِلَّا تَأْوِيلَهُۥ ۚ يَوْمَ يَأْتِى تَأْوِيلُهُۥ يَقُولُ ٱلَّذِينَ نَسُوهُ مِن قَبْلُ قَدْ جَآءَتْ رُسُلُ رَبِّنَا بِٱلْحَقِّ فَهَل لَّنَا مِن شُفَعَآءَ فَيَشْفَعُوا۟ لَنَآ أَوْ نُرَدُّ فَنَعْمَلَ غَيْرَ ٱلَّذِى كُنَّا نَعْمَلُ ۚ قَدْ خَسِرُوٓا۟ أَنفُسَهُمْ وَضَلَّ عَنْهُم مَّا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '53',
		page: '157',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1008',
		number: '1008',
		text: 'إِنَّ رَبَّكُمُ ٱللَّهُ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ فِى سِتَّةِ أَيَّامٍۢ ثُمَّ ٱسْتَوَىٰ عَلَى ٱلْعَرْشِ يُغْشِى ٱلَّيْلَ ٱلنَّهَارَ يَطْلُبُهُۥ حَثِيثًۭا وَٱلشَّمْسَ وَٱلْقَمَرَ وَٱلنُّجُومَ مُسَخَّرَٰتٍۭ بِأَمْرِهِۦٓ ۗ أَلَا لَهُ ٱلْخَلْقُ وَٱلْأَمْرُ ۗ تَبَارَكَ ٱللَّهُ رَبُّ ٱلْعَٰلَمِينَ',
		number_in_surah: '54',
		page: '157',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1009',
		number: '1009',
		text: 'ٱدْعُوا۟ رَبَّكُمْ تَضَرُّعًۭا وَخُفْيَةً ۚ إِنَّهُۥ لَا يُحِبُّ ٱلْمُعْتَدِينَ',
		number_in_surah: '55',
		page: '157',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1010',
		number: '1010',
		text: 'وَلَا تُفْسِدُوا۟ فِى ٱلْأَرْضِ بَعْدَ إِصْلَٰحِهَا وَٱدْعُوهُ خَوْفًۭا وَطَمَعًا ۚ إِنَّ رَحْمَتَ ٱللَّهِ قَرِيبٌۭ مِّنَ ٱلْمُحْسِنِينَ',
		number_in_surah: '56',
		page: '157',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1011',
		number: '1011',
		text: 'وَهُوَ ٱلَّذِى يُرْسِلُ ٱلرِّيَٰحَ بُشْرًۢا بَيْنَ يَدَىْ رَحْمَتِهِۦ ۖ حَتَّىٰٓ إِذَآ أَقَلَّتْ سَحَابًۭا ثِقَالًۭا سُقْنَٰهُ لِبَلَدٍۢ مَّيِّتٍۢ فَأَنزَلْنَا بِهِ ٱلْمَآءَ فَأَخْرَجْنَا بِهِۦ مِن كُلِّ ٱلثَّمَرَٰتِ ۚ كَذَٰلِكَ نُخْرِجُ ٱلْمَوْتَىٰ لَعَلَّكُمْ تَذَكَّرُونَ',
		number_in_surah: '57',
		page: '157',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1012',
		number: '1012',
		text: 'وَٱلْبَلَدُ ٱلطَّيِّبُ يَخْرُجُ نَبَاتُهُۥ بِإِذْنِ رَبِّهِۦ ۖ وَٱلَّذِى خَبُثَ لَا يَخْرُجُ إِلَّا نَكِدًۭا ۚ كَذَٰلِكَ نُصَرِّفُ ٱلْءَايَٰتِ لِقَوْمٍۢ يَشْكُرُونَ',
		number_in_surah: '58',
		page: '158',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1013',
		number: '1013',
		text: 'لَقَدْ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِۦ فَقَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥٓ إِنِّىٓ أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ عَظِيمٍۢ',
		number_in_surah: '59',
		page: '158',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1014',
		number: '1014',
		text: 'قَالَ ٱلْمَلَأُ مِن قَوْمِهِۦٓ إِنَّا لَنَرَىٰكَ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '60',
		page: '158',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1015',
		number: '1015',
		text: 'قَالَ يَٰقَوْمِ لَيْسَ بِى ضَلَٰلَةٌۭ وَلَٰكِنِّى رَسُولٌۭ مِّن رَّبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '61',
		page: '158',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1016',
		number: '1016',
		text: 'أُبَلِّغُكُمْ رِسَٰلَٰتِ رَبِّى وَأَنصَحُ لَكُمْ وَأَعْلَمُ مِنَ ٱللَّهِ مَا لَا تَعْلَمُونَ',
		number_in_surah: '62',
		page: '158',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1017',
		number: '1017',
		text: 'أَوَعَجِبْتُمْ أَن جَآءَكُمْ ذِكْرٌۭ مِّن رَّبِّكُمْ عَلَىٰ رَجُلٍۢ مِّنكُمْ لِيُنذِرَكُمْ وَلِتَتَّقُوا۟ وَلَعَلَّكُمْ تُرْحَمُونَ',
		number_in_surah: '63',
		page: '158',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1018',
		number: '1018',
		text: 'فَكَذَّبُوهُ فَأَنجَيْنَٰهُ وَٱلَّذِينَ مَعَهُۥ فِى ٱلْفُلْكِ وَأَغْرَقْنَا ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَآ ۚ إِنَّهُمْ كَانُوا۟ قَوْمًا عَمِينَ',
		number_in_surah: '64',
		page: '158',
		surah_id: '7',
		hizb_id: '63',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1019',
		number: '1019',
		text: '۞ وَإِلَىٰ عَادٍ أَخَاهُمْ هُودًۭا ۗ قَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥٓ ۚ أَفَلَا تَتَّقُونَ',
		number_in_surah: '65',
		page: '158',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1020',
		number: '1020',
		text: 'قَالَ ٱلْمَلَأُ ٱلَّذِينَ كَفَرُوا۟ مِن قَوْمِهِۦٓ إِنَّا لَنَرَىٰكَ فِى سَفَاهَةٍۢ وَإِنَّا لَنَظُنُّكَ مِنَ ٱلْكَٰذِبِينَ',
		number_in_surah: '66',
		page: '158',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1021',
		number: '1021',
		text: 'قَالَ يَٰقَوْمِ لَيْسَ بِى سَفَاهَةٌۭ وَلَٰكِنِّى رَسُولٌۭ مِّن رَّبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '67',
		page: '158',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1022',
		number: '1022',
		text: 'أُبَلِّغُكُمْ رِسَٰلَٰتِ رَبِّى وَأَنَا۠ لَكُمْ نَاصِحٌ أَمِينٌ',
		number_in_surah: '68',
		page: '159',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1023',
		number: '1023',
		text: 'أَوَعَجِبْتُمْ أَن جَآءَكُمْ ذِكْرٌۭ مِّن رَّبِّكُمْ عَلَىٰ رَجُلٍۢ مِّنكُمْ لِيُنذِرَكُمْ ۚ وَٱذْكُرُوٓا۟ إِذْ جَعَلَكُمْ خُلَفَآءَ مِنۢ بَعْدِ قَوْمِ نُوحٍۢ وَزَادَكُمْ فِى ٱلْخَلْقِ بَصْۜطَةًۭ ۖ فَٱذْكُرُوٓا۟ ءَالَآءَ ٱللَّهِ لَعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '69',
		page: '159',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1024',
		number: '1024',
		text: 'قَالُوٓا۟ أَجِئْتَنَا لِنَعْبُدَ ٱللَّهَ وَحْدَهُۥ وَنَذَرَ مَا كَانَ يَعْبُدُ ءَابَآؤُنَا ۖ فَأْتِنَا بِمَا تَعِدُنَآ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '70',
		page: '159',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1025',
		number: '1025',
		text: 'قَالَ قَدْ وَقَعَ عَلَيْكُم مِّن رَّبِّكُمْ رِجْسٌۭ وَغَضَبٌ ۖ أَتُجَٰدِلُونَنِى فِىٓ أَسْمَآءٍۢ سَمَّيْتُمُوهَآ أَنتُمْ وَءَابَآؤُكُم مَّا نَزَّلَ ٱللَّهُ بِهَا مِن سُلْطَٰنٍۢ ۚ فَٱنتَظِرُوٓا۟ إِنِّى مَعَكُم مِّنَ ٱلْمُنتَظِرِينَ',
		number_in_surah: '71',
		page: '159',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1026',
		number: '1026',
		text: 'فَأَنجَيْنَٰهُ وَٱلَّذِينَ مَعَهُۥ بِرَحْمَةٍۢ مِّنَّا وَقَطَعْنَا دَابِرَ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا ۖ وَمَا كَانُوا۟ مُؤْمِنِينَ',
		number_in_surah: '72',
		page: '159',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1027',
		number: '1027',
		text: 'وَإِلَىٰ ثَمُودَ أَخَاهُمْ صَٰلِحًۭا ۗ قَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥ ۖ قَدْ جَآءَتْكُم بَيِّنَةٌۭ مِّن رَّبِّكُمْ ۖ هَٰذِهِۦ نَاقَةُ ٱللَّهِ لَكُمْ ءَايَةًۭ ۖ فَذَرُوهَا تَأْكُلْ فِىٓ أَرْضِ ٱللَّهِ ۖ وَلَا تَمَسُّوهَا بِسُوٓءٍۢ فَيَأْخُذَكُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '73',
		page: '159',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1028',
		number: '1028',
		text: 'وَٱذْكُرُوٓا۟ إِذْ جَعَلَكُمْ خُلَفَآءَ مِنۢ بَعْدِ عَادٍۢ وَبَوَّأَكُمْ فِى ٱلْأَرْضِ تَتَّخِذُونَ مِن سُهُولِهَا قُصُورًۭا وَتَنْحِتُونَ ٱلْجِبَالَ بُيُوتًۭا ۖ فَٱذْكُرُوٓا۟ ءَالَآءَ ٱللَّهِ وَلَا تَعْثَوْا۟ فِى ٱلْأَرْضِ مُفْسِدِينَ',
		number_in_surah: '74',
		page: '160',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1029',
		number: '1029',
		text: 'قَالَ ٱلْمَلَأُ ٱلَّذِينَ ٱسْتَكْبَرُوا۟ مِن قَوْمِهِۦ لِلَّذِينَ ٱسْتُضْعِفُوا۟ لِمَنْ ءَامَنَ مِنْهُمْ أَتَعْلَمُونَ أَنَّ صَٰلِحًۭا مُّرْسَلٌۭ مِّن رَّبِّهِۦ ۚ قَالُوٓا۟ إِنَّا بِمَآ أُرْسِلَ بِهِۦ مُؤْمِنُونَ',
		number_in_surah: '75',
		page: '160',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1030',
		number: '1030',
		text: 'قَالَ ٱلَّذِينَ ٱسْتَكْبَرُوٓا۟ إِنَّا بِٱلَّذِىٓ ءَامَنتُم بِهِۦ كَٰفِرُونَ',
		number_in_surah: '76',
		page: '160',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1031',
		number: '1031',
		text: 'فَعَقَرُوا۟ ٱلنَّاقَةَ وَعَتَوْا۟ عَنْ أَمْرِ رَبِّهِمْ وَقَالُوا۟ يَٰصَٰلِحُ ٱئْتِنَا بِمَا تَعِدُنَآ إِن كُنتَ مِنَ ٱلْمُرْسَلِينَ',
		number_in_surah: '77',
		page: '160',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1032',
		number: '1032',
		text: 'فَأَخَذَتْهُمُ ٱلرَّجْفَةُ فَأَصْبَحُوا۟ فِى دَارِهِمْ جَٰثِمِينَ',
		number_in_surah: '78',
		page: '160',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1033',
		number: '1033',
		text: 'فَتَوَلَّىٰ عَنْهُمْ وَقَالَ يَٰقَوْمِ لَقَدْ أَبْلَغْتُكُمْ رِسَالَةَ رَبِّى وَنَصَحْتُ لَكُمْ وَلَٰكِن لَّا تُحِبُّونَ ٱلنَّٰصِحِينَ',
		number_in_surah: '79',
		page: '160',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1034',
		number: '1034',
		text: 'وَلُوطًا إِذْ قَالَ لِقَوْمِهِۦٓ أَتَأْتُونَ ٱلْفَٰحِشَةَ مَا سَبَقَكُم بِهَا مِنْ أَحَدٍۢ مِّنَ ٱلْعَٰلَمِينَ',
		number_in_surah: '80',
		page: '160',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1035',
		number: '1035',
		text: 'إِنَّكُمْ لَتَأْتُونَ ٱلرِّجَالَ شَهْوَةًۭ مِّن دُونِ ٱلنِّسَآءِ ۚ بَلْ أَنتُمْ قَوْمٌۭ مُّسْرِفُونَ',
		number_in_surah: '81',
		page: '160',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1036',
		number: '1036',
		text: 'وَمَا كَانَ جَوَابَ قَوْمِهِۦٓ إِلَّآ أَن قَالُوٓا۟ أَخْرِجُوهُم مِّن قَرْيَتِكُمْ ۖ إِنَّهُمْ أُنَاسٌۭ يَتَطَهَّرُونَ',
		number_in_surah: '82',
		page: '161',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1037',
		number: '1037',
		text: 'فَأَنجَيْنَٰهُ وَأَهْلَهُۥٓ إِلَّا ٱمْرَأَتَهُۥ كَانَتْ مِنَ ٱلْغَٰبِرِينَ',
		number_in_surah: '83',
		page: '161',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1038',
		number: '1038',
		text: 'وَأَمْطَرْنَا عَلَيْهِم مَّطَرًۭا ۖ فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُجْرِمِينَ',
		number_in_surah: '84',
		page: '161',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1039',
		number: '1039',
		text: 'وَإِلَىٰ مَدْيَنَ أَخَاهُمْ شُعَيْبًۭا ۗ قَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥ ۖ قَدْ جَآءَتْكُم بَيِّنَةٌۭ مِّن رَّبِّكُمْ ۖ فَأَوْفُوا۟ ٱلْكَيْلَ وَٱلْمِيزَانَ وَلَا تَبْخَسُوا۟ ٱلنَّاسَ أَشْيَآءَهُمْ وَلَا تُفْسِدُوا۟ فِى ٱلْأَرْضِ بَعْدَ إِصْلَٰحِهَا ۚ ذَٰلِكُمْ خَيْرٌۭ لَّكُمْ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '85',
		page: '161',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1040',
		number: '1040',
		text: 'وَلَا تَقْعُدُوا۟ بِكُلِّ صِرَٰطٍۢ تُوعِدُونَ وَتَصُدُّونَ عَن سَبِيلِ ٱللَّهِ مَنْ ءَامَنَ بِهِۦ وَتَبْغُونَهَا عِوَجًۭا ۚ وَٱذْكُرُوٓا۟ إِذْ كُنتُمْ قَلِيلًۭا فَكَثَّرَكُمْ ۖ وَٱنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُفْسِدِينَ',
		number_in_surah: '86',
		page: '161',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1041',
		number: '1041',
		text: 'وَإِن كَانَ طَآئِفَةٌۭ مِّنكُمْ ءَامَنُوا۟ بِٱلَّذِىٓ أُرْسِلْتُ بِهِۦ وَطَآئِفَةٌۭ لَّمْ يُؤْمِنُوا۟ فَٱصْبِرُوا۟ حَتَّىٰ يَحْكُمَ ٱللَّهُ بَيْنَنَا ۚ وَهُوَ خَيْرُ ٱلْحَٰكِمِينَ',
		number_in_surah: '87',
		page: '161',
		surah_id: '7',
		hizb_id: '64',
		juz_id: '8',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1042',
		number: '1042',
		text: '۞ قَالَ ٱلْمَلَأُ ٱلَّذِينَ ٱسْتَكْبَرُوا۟ مِن قَوْمِهِۦ لَنُخْرِجَنَّكَ يَٰشُعَيْبُ وَٱلَّذِينَ ءَامَنُوا۟ مَعَكَ مِن قَرْيَتِنَآ أَوْ لَتَعُودُنَّ فِى مِلَّتِنَا ۚ قَالَ أَوَلَوْ كُنَّا كَٰرِهِينَ',
		number_in_surah: '88',
		page: '162',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1043',
		number: '1043',
		text: 'قَدِ ٱفْتَرَيْنَا عَلَى ٱللَّهِ كَذِبًا إِنْ عُدْنَا فِى مِلَّتِكُم بَعْدَ إِذْ نَجَّىٰنَا ٱللَّهُ مِنْهَا ۚ وَمَا يَكُونُ لَنَآ أَن نَّعُودَ فِيهَآ إِلَّآ أَن يَشَآءَ ٱللَّهُ رَبُّنَا ۚ وَسِعَ رَبُّنَا كُلَّ شَىْءٍ عِلْمًا ۚ عَلَى ٱللَّهِ تَوَكَّلْنَا ۚ رَبَّنَا ٱفْتَحْ بَيْنَنَا وَبَيْنَ قَوْمِنَا بِٱلْحَقِّ وَأَنتَ خَيْرُ ٱلْفَٰتِحِينَ',
		number_in_surah: '89',
		page: '162',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1044',
		number: '1044',
		text: 'وَقَالَ ٱلْمَلَأُ ٱلَّذِينَ كَفَرُوا۟ مِن قَوْمِهِۦ لَئِنِ ٱتَّبَعْتُمْ شُعَيْبًا إِنَّكُمْ إِذًۭا لَّخَٰسِرُونَ',
		number_in_surah: '90',
		page: '162',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1045',
		number: '1045',
		text: 'فَأَخَذَتْهُمُ ٱلرَّجْفَةُ فَأَصْبَحُوا۟ فِى دَارِهِمْ جَٰثِمِينَ',
		number_in_surah: '91',
		page: '162',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1046',
		number: '1046',
		text: 'ٱلَّذِينَ كَذَّبُوا۟ شُعَيْبًۭا كَأَن لَّمْ يَغْنَوْا۟ فِيهَا ۚ ٱلَّذِينَ كَذَّبُوا۟ شُعَيْبًۭا كَانُوا۟ هُمُ ٱلْخَٰسِرِينَ',
		number_in_surah: '92',
		page: '162',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1047',
		number: '1047',
		text: 'فَتَوَلَّىٰ عَنْهُمْ وَقَالَ يَٰقَوْمِ لَقَدْ أَبْلَغْتُكُمْ رِسَٰلَٰتِ رَبِّى وَنَصَحْتُ لَكُمْ ۖ فَكَيْفَ ءَاسَىٰ عَلَىٰ قَوْمٍۢ كَٰفِرِينَ',
		number_in_surah: '93',
		page: '162',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1048',
		number: '1048',
		text: 'وَمَآ أَرْسَلْنَا فِى قَرْيَةٍۢ مِّن نَّبِىٍّ إِلَّآ أَخَذْنَآ أَهْلَهَا بِٱلْبَأْسَآءِ وَٱلضَّرَّآءِ لَعَلَّهُمْ يَضَّرَّعُونَ',
		number_in_surah: '94',
		page: '162',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1049',
		number: '1049',
		text: 'ثُمَّ بَدَّلْنَا مَكَانَ ٱلسَّيِّئَةِ ٱلْحَسَنَةَ حَتَّىٰ عَفَوا۟ وَّقَالُوا۟ قَدْ مَسَّ ءَابَآءَنَا ٱلضَّرَّآءُ وَٱلسَّرَّآءُ فَأَخَذْنَٰهُم بَغْتَةًۭ وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '95',
		page: '162',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1050',
		number: '1050',
		text: 'وَلَوْ أَنَّ أَهْلَ ٱلْقُرَىٰٓ ءَامَنُوا۟ وَٱتَّقَوْا۟ لَفَتَحْنَا عَلَيْهِم بَرَكَٰتٍۢ مِّنَ ٱلسَّمَآءِ وَٱلْأَرْضِ وَلَٰكِن كَذَّبُوا۟ فَأَخَذْنَٰهُم بِمَا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '96',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1051',
		number: '1051',
		text: 'أَفَأَمِنَ أَهْلُ ٱلْقُرَىٰٓ أَن يَأْتِيَهُم بَأْسُنَا بَيَٰتًۭا وَهُمْ نَآئِمُونَ',
		number_in_surah: '97',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1052',
		number: '1052',
		text: 'أَوَأَمِنَ أَهْلُ ٱلْقُرَىٰٓ أَن يَأْتِيَهُم بَأْسُنَا ضُحًۭى وَهُمْ يَلْعَبُونَ',
		number_in_surah: '98',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1053',
		number: '1053',
		text: 'أَفَأَمِنُوا۟ مَكْرَ ٱللَّهِ ۚ فَلَا يَأْمَنُ مَكْرَ ٱللَّهِ إِلَّا ٱلْقَوْمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '99',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1054',
		number: '1054',
		text: 'أَوَلَمْ يَهْدِ لِلَّذِينَ يَرِثُونَ ٱلْأَرْضَ مِنۢ بَعْدِ أَهْلِهَآ أَن لَّوْ نَشَآءُ أَصَبْنَٰهُم بِذُنُوبِهِمْ ۚ وَنَطْبَعُ عَلَىٰ قُلُوبِهِمْ فَهُمْ لَا يَسْمَعُونَ',
		number_in_surah: '100',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1055',
		number: '1055',
		text: 'تِلْكَ ٱلْقُرَىٰ نَقُصُّ عَلَيْكَ مِنْ أَنۢبَآئِهَا ۚ وَلَقَدْ جَآءَتْهُمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ فَمَا كَانُوا۟ لِيُؤْمِنُوا۟ بِمَا كَذَّبُوا۟ مِن قَبْلُ ۚ كَذَٰلِكَ يَطْبَعُ ٱللَّهُ عَلَىٰ قُلُوبِ ٱلْكَٰفِرِينَ',
		number_in_surah: '101',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1056',
		number: '1056',
		text: 'وَمَا وَجَدْنَا لِأَكْثَرِهِم مِّنْ عَهْدٍۢ ۖ وَإِن وَجَدْنَآ أَكْثَرَهُمْ لَفَٰسِقِينَ',
		number_in_surah: '102',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1057',
		number: '1057',
		text: 'ثُمَّ بَعَثْنَا مِنۢ بَعْدِهِم مُّوسَىٰ بِـَٔايَٰتِنَآ إِلَىٰ فِرْعَوْنَ وَمَلَإِي۟هِۦ فَظَلَمُوا۟ بِهَا ۖ فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُفْسِدِينَ',
		number_in_surah: '103',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1058',
		number: '1058',
		text: 'وَقَالَ مُوسَىٰ يَٰفِرْعَوْنُ إِنِّى رَسُولٌۭ مِّن رَّبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '104',
		page: '163',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1059',
		number: '1059',
		text: 'حَقِيقٌ عَلَىٰٓ أَن لَّآ أَقُولَ عَلَى ٱللَّهِ إِلَّا ٱلْحَقَّ ۚ قَدْ جِئْتُكُم بِبَيِّنَةٍۢ مِّن رَّبِّكُمْ فَأَرْسِلْ مَعِىَ بَنِىٓ إِسْرَٰٓءِيلَ',
		number_in_surah: '105',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1060',
		number: '1060',
		text: 'قَالَ إِن كُنتَ جِئْتَ بِـَٔايَةٍۢ فَأْتِ بِهَآ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '106',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1061',
		number: '1061',
		text: 'فَأَلْقَىٰ عَصَاهُ فَإِذَا هِىَ ثُعْبَانٌۭ مُّبِينٌۭ',
		number_in_surah: '107',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1062',
		number: '1062',
		text: 'وَنَزَعَ يَدَهُۥ فَإِذَا هِىَ بَيْضَآءُ لِلنَّٰظِرِينَ',
		number_in_surah: '108',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1063',
		number: '1063',
		text: 'قَالَ ٱلْمَلَأُ مِن قَوْمِ فِرْعَوْنَ إِنَّ هَٰذَا لَسَٰحِرٌ عَلِيمٌۭ',
		number_in_surah: '109',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1064',
		number: '1064',
		text: 'يُرِيدُ أَن يُخْرِجَكُم مِّنْ أَرْضِكُمْ ۖ فَمَاذَا تَأْمُرُونَ',
		number_in_surah: '110',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1065',
		number: '1065',
		text: 'قَالُوٓا۟ أَرْجِهْ وَأَخَاهُ وَأَرْسِلْ فِى ٱلْمَدَآئِنِ حَٰشِرِينَ',
		number_in_surah: '111',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1066',
		number: '1066',
		text: 'يَأْتُوكَ بِكُلِّ سَٰحِرٍ عَلِيمٍۢ',
		number_in_surah: '112',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1067',
		number: '1067',
		text: 'وَجَآءَ ٱلسَّحَرَةُ فِرْعَوْنَ قَالُوٓا۟ إِنَّ لَنَا لَأَجْرًا إِن كُنَّا نَحْنُ ٱلْغَٰلِبِينَ',
		number_in_surah: '113',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1068',
		number: '1068',
		text: 'قَالَ نَعَمْ وَإِنَّكُمْ لَمِنَ ٱلْمُقَرَّبِينَ',
		number_in_surah: '114',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1069',
		number: '1069',
		text: 'قَالُوا۟ يَٰمُوسَىٰٓ إِمَّآ أَن تُلْقِىَ وَإِمَّآ أَن نَّكُونَ نَحْنُ ٱلْمُلْقِينَ',
		number_in_surah: '115',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1070',
		number: '1070',
		text: 'قَالَ أَلْقُوا۟ ۖ فَلَمَّآ أَلْقَوْا۟ سَحَرُوٓا۟ أَعْيُنَ ٱلنَّاسِ وَٱسْتَرْهَبُوهُمْ وَجَآءُو بِسِحْرٍ عَظِيمٍۢ',
		number_in_surah: '116',
		page: '164',
		surah_id: '7',
		hizb_id: '65',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1071',
		number: '1071',
		text: '۞ وَأَوْحَيْنَآ إِلَىٰ مُوسَىٰٓ أَنْ أَلْقِ عَصَاكَ ۖ فَإِذَا هِىَ تَلْقَفُ مَا يَأْفِكُونَ',
		number_in_surah: '117',
		page: '164',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1072',
		number: '1072',
		text: 'فَوَقَعَ ٱلْحَقُّ وَبَطَلَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '118',
		page: '164',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1073',
		number: '1073',
		text: 'فَغُلِبُوا۟ هُنَالِكَ وَٱنقَلَبُوا۟ صَٰغِرِينَ',
		number_in_surah: '119',
		page: '164',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1074',
		number: '1074',
		text: 'وَأُلْقِىَ ٱلسَّحَرَةُ سَٰجِدِينَ',
		number_in_surah: '120',
		page: '164',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1075',
		number: '1075',
		text: 'قَالُوٓا۟ ءَامَنَّا بِرَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '121',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:56',
		updated_at: '2018-06-07 08:06:56',
	},
	{
		id: '1076',
		number: '1076',
		text: 'رَبِّ مُوسَىٰ وَهَٰرُونَ',
		number_in_surah: '122',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1077',
		number: '1077',
		text: 'قَالَ فِرْعَوْنُ ءَامَنتُم بِهِۦ قَبْلَ أَنْ ءَاذَنَ لَكُمْ ۖ إِنَّ هَٰذَا لَمَكْرٌۭ مَّكَرْتُمُوهُ فِى ٱلْمَدِينَةِ لِتُخْرِجُوا۟ مِنْهَآ أَهْلَهَا ۖ فَسَوْفَ تَعْلَمُونَ',
		number_in_surah: '123',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1078',
		number: '1078',
		text: 'لَأُقَطِّعَنَّ أَيْدِيَكُمْ وَأَرْجُلَكُم مِّنْ خِلَٰفٍۢ ثُمَّ لَأُصَلِّبَنَّكُمْ أَجْمَعِينَ',
		number_in_surah: '124',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1079',
		number: '1079',
		text: 'قَالُوٓا۟ إِنَّآ إِلَىٰ رَبِّنَا مُنقَلِبُونَ',
		number_in_surah: '125',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1080',
		number: '1080',
		text: 'وَمَا تَنقِمُ مِنَّآ إِلَّآ أَنْ ءَامَنَّا بِـَٔايَٰتِ رَبِّنَا لَمَّا جَآءَتْنَا ۚ رَبَّنَآ أَفْرِغْ عَلَيْنَا صَبْرًۭا وَتَوَفَّنَا مُسْلِمِينَ',
		number_in_surah: '126',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1081',
		number: '1081',
		text: 'وَقَالَ ٱلْمَلَأُ مِن قَوْمِ فِرْعَوْنَ أَتَذَرُ مُوسَىٰ وَقَوْمَهُۥ لِيُفْسِدُوا۟ فِى ٱلْأَرْضِ وَيَذَرَكَ وَءَالِهَتَكَ ۚ قَالَ سَنُقَتِّلُ أَبْنَآءَهُمْ وَنَسْتَحْىِۦ نِسَآءَهُمْ وَإِنَّا فَوْقَهُمْ قَٰهِرُونَ',
		number_in_surah: '127',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1082',
		number: '1082',
		text: 'قَالَ مُوسَىٰ لِقَوْمِهِ ٱسْتَعِينُوا۟ بِٱللَّهِ وَٱصْبِرُوٓا۟ ۖ إِنَّ ٱلْأَرْضَ لِلَّهِ يُورِثُهَا مَن يَشَآءُ مِنْ عِبَادِهِۦ ۖ وَٱلْعَٰقِبَةُ لِلْمُتَّقِينَ',
		number_in_surah: '128',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1083',
		number: '1083',
		text: 'قَالُوٓا۟ أُوذِينَا مِن قَبْلِ أَن تَأْتِيَنَا وَمِنۢ بَعْدِ مَا جِئْتَنَا ۚ قَالَ عَسَىٰ رَبُّكُمْ أَن يُهْلِكَ عَدُوَّكُمْ وَيَسْتَخْلِفَكُمْ فِى ٱلْأَرْضِ فَيَنظُرَ كَيْفَ تَعْمَلُونَ',
		number_in_surah: '129',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1084',
		number: '1084',
		text: 'وَلَقَدْ أَخَذْنَآ ءَالَ فِرْعَوْنَ بِٱلسِّنِينَ وَنَقْصٍۢ مِّنَ ٱلثَّمَرَٰتِ لَعَلَّهُمْ يَذَّكَّرُونَ',
		number_in_surah: '130',
		page: '165',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1085',
		number: '1085',
		text: 'فَإِذَا جَآءَتْهُمُ ٱلْحَسَنَةُ قَالُوا۟ لَنَا هَٰذِهِۦ ۖ وَإِن تُصِبْهُمْ سَيِّئَةٌۭ يَطَّيَّرُوا۟ بِمُوسَىٰ وَمَن مَّعَهُۥٓ ۗ أَلَآ إِنَّمَا طَٰٓئِرُهُمْ عِندَ ٱللَّهِ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '131',
		page: '166',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1086',
		number: '1086',
		text: 'وَقَالُوا۟ مَهْمَا تَأْتِنَا بِهِۦ مِنْ ءَايَةٍۢ لِّتَسْحَرَنَا بِهَا فَمَا نَحْنُ لَكَ بِمُؤْمِنِينَ',
		number_in_surah: '132',
		page: '166',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1087',
		number: '1087',
		text: 'فَأَرْسَلْنَا عَلَيْهِمُ ٱلطُّوفَانَ وَٱلْجَرَادَ وَٱلْقُمَّلَ وَٱلضَّفَادِعَ وَٱلدَّمَ ءَايَٰتٍۢ مُّفَصَّلَٰتٍۢ فَٱسْتَكْبَرُوا۟ وَكَانُوا۟ قَوْمًۭا مُّجْرِمِينَ',
		number_in_surah: '133',
		page: '166',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1088',
		number: '1088',
		text: 'وَلَمَّا وَقَعَ عَلَيْهِمُ ٱلرِّجْزُ قَالُوا۟ يَٰمُوسَى ٱدْعُ لَنَا رَبَّكَ بِمَا عَهِدَ عِندَكَ ۖ لَئِن كَشَفْتَ عَنَّا ٱلرِّجْزَ لَنُؤْمِنَنَّ لَكَ وَلَنُرْسِلَنَّ مَعَكَ بَنِىٓ إِسْرَٰٓءِيلَ',
		number_in_surah: '134',
		page: '166',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1089',
		number: '1089',
		text: 'فَلَمَّا كَشَفْنَا عَنْهُمُ ٱلرِّجْزَ إِلَىٰٓ أَجَلٍ هُم بَٰلِغُوهُ إِذَا هُمْ يَنكُثُونَ',
		number_in_surah: '135',
		page: '166',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1090',
		number: '1090',
		text: 'فَٱنتَقَمْنَا مِنْهُمْ فَأَغْرَقْنَٰهُمْ فِى ٱلْيَمِّ بِأَنَّهُمْ كَذَّبُوا۟ بِـَٔايَٰتِنَا وَكَانُوا۟ عَنْهَا غَٰفِلِينَ',
		number_in_surah: '136',
		page: '166',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1091',
		number: '1091',
		text: 'وَأَوْرَثْنَا ٱلْقَوْمَ ٱلَّذِينَ كَانُوا۟ يُسْتَضْعَفُونَ مَشَٰرِقَ ٱلْأَرْضِ وَمَغَٰرِبَهَا ٱلَّتِى بَٰرَكْنَا فِيهَا ۖ وَتَمَّتْ كَلِمَتُ رَبِّكَ ٱلْحُسْنَىٰ عَلَىٰ بَنِىٓ إِسْرَٰٓءِيلَ بِمَا صَبَرُوا۟ ۖ وَدَمَّرْنَا مَا كَانَ يَصْنَعُ فِرْعَوْنُ وَقَوْمُهُۥ وَمَا كَانُوا۟ يَعْرِشُونَ',
		number_in_surah: '137',
		page: '166',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1092',
		number: '1092',
		text: 'وَجَٰوَزْنَا بِبَنِىٓ إِسْرَٰٓءِيلَ ٱلْبَحْرَ فَأَتَوْا۟ عَلَىٰ قَوْمٍۢ يَعْكُفُونَ عَلَىٰٓ أَصْنَامٍۢ لَّهُمْ ۚ قَالُوا۟ يَٰمُوسَى ٱجْعَل لَّنَآ إِلَٰهًۭا كَمَا لَهُمْ ءَالِهَةٌۭ ۚ قَالَ إِنَّكُمْ قَوْمٌۭ تَجْهَلُونَ',
		number_in_surah: '138',
		page: '167',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1093',
		number: '1093',
		text: 'إِنَّ هَٰٓؤُلَآءِ مُتَبَّرٌۭ مَّا هُمْ فِيهِ وَبَٰطِلٌۭ مَّا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '139',
		page: '167',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1094',
		number: '1094',
		text: 'قَالَ أَغَيْرَ ٱللَّهِ أَبْغِيكُمْ إِلَٰهًۭا وَهُوَ فَضَّلَكُمْ عَلَى ٱلْعَٰلَمِينَ',
		number_in_surah: '140',
		page: '167',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1095',
		number: '1095',
		text: 'وَإِذْ أَنجَيْنَٰكُم مِّنْ ءَالِ فِرْعَوْنَ يَسُومُونَكُمْ سُوٓءَ ٱلْعَذَابِ ۖ يُقَتِّلُونَ أَبْنَآءَكُمْ وَيَسْتَحْيُونَ نِسَآءَكُمْ ۚ وَفِى ذَٰلِكُم بَلَآءٌۭ مِّن رَّبِّكُمْ عَظِيمٌۭ',
		number_in_surah: '141',
		page: '167',
		surah_id: '7',
		hizb_id: '66',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1096',
		number: '1096',
		text: '۞ وَوَٰعَدْنَا مُوسَىٰ ثَلَٰثِينَ لَيْلَةًۭ وَأَتْمَمْنَٰهَا بِعَشْرٍۢ فَتَمَّ مِيقَٰتُ رَبِّهِۦٓ أَرْبَعِينَ لَيْلَةًۭ ۚ وَقَالَ مُوسَىٰ لِأَخِيهِ هَٰرُونَ ٱخْلُفْنِى فِى قَوْمِى وَأَصْلِحْ وَلَا تَتَّبِعْ سَبِيلَ ٱلْمُفْسِدِينَ',
		number_in_surah: '142',
		page: '167',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1097',
		number: '1097',
		text: 'وَلَمَّا جَآءَ مُوسَىٰ لِمِيقَٰتِنَا وَكَلَّمَهُۥ رَبُّهُۥ قَالَ رَبِّ أَرِنِىٓ أَنظُرْ إِلَيْكَ ۚ قَالَ لَن تَرَىٰنِى وَلَٰكِنِ ٱنظُرْ إِلَى ٱلْجَبَلِ فَإِنِ ٱسْتَقَرَّ مَكَانَهُۥ فَسَوْفَ تَرَىٰنِى ۚ فَلَمَّا تَجَلَّىٰ رَبُّهُۥ لِلْجَبَلِ جَعَلَهُۥ دَكًّۭا وَخَرَّ مُوسَىٰ صَعِقًۭا ۚ فَلَمَّآ أَفَاقَ قَالَ سُبْحَٰنَكَ تُبْتُ إِلَيْكَ وَأَنَا۠ أَوَّلُ ٱلْمُؤْمِنِينَ',
		number_in_surah: '143',
		page: '167',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1098',
		number: '1098',
		text: 'قَالَ يَٰمُوسَىٰٓ إِنِّى ٱصْطَفَيْتُكَ عَلَى ٱلنَّاسِ بِرِسَٰلَٰتِى وَبِكَلَٰمِى فَخُذْ مَآ ءَاتَيْتُكَ وَكُن مِّنَ ٱلشَّٰكِرِينَ',
		number_in_surah: '144',
		page: '168',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1099',
		number: '1099',
		text: 'وَكَتَبْنَا لَهُۥ فِى ٱلْأَلْوَاحِ مِن كُلِّ شَىْءٍۢ مَّوْعِظَةًۭ وَتَفْصِيلًۭا لِّكُلِّ شَىْءٍۢ فَخُذْهَا بِقُوَّةٍۢ وَأْمُرْ قَوْمَكَ يَأْخُذُوا۟ بِأَحْسَنِهَا ۚ سَأُو۟رِيكُمْ دَارَ ٱلْفَٰسِقِينَ',
		number_in_surah: '145',
		page: '168',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1100',
		number: '1100',
		text: 'سَأَصْرِفُ عَنْ ءَايَٰتِىَ ٱلَّذِينَ يَتَكَبَّرُونَ فِى ٱلْأَرْضِ بِغَيْرِ ٱلْحَقِّ وَإِن يَرَوْا۟ كُلَّ ءَايَةٍۢ لَّا يُؤْمِنُوا۟ بِهَا وَإِن يَرَوْا۟ سَبِيلَ ٱلرُّشْدِ لَا يَتَّخِذُوهُ سَبِيلًۭا وَإِن يَرَوْا۟ سَبِيلَ ٱلْغَىِّ يَتَّخِذُوهُ سَبِيلًۭا ۚ ذَٰلِكَ بِأَنَّهُمْ كَذَّبُوا۟ بِـَٔايَٰتِنَا وَكَانُوا۟ عَنْهَا غَٰفِلِينَ',
		number_in_surah: '146',
		page: '168',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1101',
		number: '1101',
		text: 'وَٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا وَلِقَآءِ ٱلْءَاخِرَةِ حَبِطَتْ أَعْمَٰلُهُمْ ۚ هَلْ يُجْزَوْنَ إِلَّا مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '147',
		page: '168',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1102',
		number: '1102',
		text: 'وَٱتَّخَذَ قَوْمُ مُوسَىٰ مِنۢ بَعْدِهِۦ مِنْ حُلِيِّهِمْ عِجْلًۭا جَسَدًۭا لَّهُۥ خُوَارٌ ۚ أَلَمْ يَرَوْا۟ أَنَّهُۥ لَا يُكَلِّمُهُمْ وَلَا يَهْدِيهِمْ سَبِيلًا ۘ ٱتَّخَذُوهُ وَكَانُوا۟ ظَٰلِمِينَ',
		number_in_surah: '148',
		page: '168',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1103',
		number: '1103',
		text: 'وَلَمَّا سُقِطَ فِىٓ أَيْدِيهِمْ وَرَأَوْا۟ أَنَّهُمْ قَدْ ضَلُّوا۟ قَالُوا۟ لَئِن لَّمْ يَرْحَمْنَا رَبُّنَا وَيَغْفِرْ لَنَا لَنَكُونَنَّ مِنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '149',
		page: '168',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1104',
		number: '1104',
		text: 'وَلَمَّا رَجَعَ مُوسَىٰٓ إِلَىٰ قَوْمِهِۦ غَضْبَٰنَ أَسِفًۭا قَالَ بِئْسَمَا خَلَفْتُمُونِى مِنۢ بَعْدِىٓ ۖ أَعَجِلْتُمْ أَمْرَ رَبِّكُمْ ۖ وَأَلْقَى ٱلْأَلْوَاحَ وَأَخَذَ بِرَأْسِ أَخِيهِ يَجُرُّهُۥٓ إِلَيْهِ ۚ قَالَ ٱبْنَ أُمَّ إِنَّ ٱلْقَوْمَ ٱسْتَضْعَفُونِى وَكَادُوا۟ يَقْتُلُونَنِى فَلَا تُشْمِتْ بِىَ ٱلْأَعْدَآءَ وَلَا تَجْعَلْنِى مَعَ ٱلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '150',
		page: '169',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1105',
		number: '1105',
		text: 'قَالَ رَبِّ ٱغْفِرْ لِى وَلِأَخِى وَأَدْخِلْنَا فِى رَحْمَتِكَ ۖ وَأَنتَ أَرْحَمُ ٱلرَّٰحِمِينَ',
		number_in_surah: '151',
		page: '169',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1106',
		number: '1106',
		text: 'إِنَّ ٱلَّذِينَ ٱتَّخَذُوا۟ ٱلْعِجْلَ سَيَنَالُهُمْ غَضَبٌۭ مِّن رَّبِّهِمْ وَذِلَّةٌۭ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا ۚ وَكَذَٰلِكَ نَجْزِى ٱلْمُفْتَرِينَ',
		number_in_surah: '152',
		page: '169',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1107',
		number: '1107',
		text: 'وَٱلَّذِينَ عَمِلُوا۟ ٱلسَّيِّـَٔاتِ ثُمَّ تَابُوا۟ مِنۢ بَعْدِهَا وَءَامَنُوٓا۟ إِنَّ رَبَّكَ مِنۢ بَعْدِهَا لَغَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '153',
		page: '169',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1108',
		number: '1108',
		text: 'وَلَمَّا سَكَتَ عَن مُّوسَى ٱلْغَضَبُ أَخَذَ ٱلْأَلْوَاحَ ۖ وَفِى نُسْخَتِهَا هُدًۭى وَرَحْمَةٌۭ لِّلَّذِينَ هُمْ لِرَبِّهِمْ يَرْهَبُونَ',
		number_in_surah: '154',
		page: '169',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1109',
		number: '1109',
		text: 'وَٱخْتَارَ مُوسَىٰ قَوْمَهُۥ سَبْعِينَ رَجُلًۭا لِّمِيقَٰتِنَا ۖ فَلَمَّآ أَخَذَتْهُمُ ٱلرَّجْفَةُ قَالَ رَبِّ لَوْ شِئْتَ أَهْلَكْتَهُم مِّن قَبْلُ وَإِيَّٰىَ ۖ أَتُهْلِكُنَا بِمَا فَعَلَ ٱلسُّفَهَآءُ مِنَّآ ۖ إِنْ هِىَ إِلَّا فِتْنَتُكَ تُضِلُّ بِهَا مَن تَشَآءُ وَتَهْدِى مَن تَشَآءُ ۖ أَنتَ وَلِيُّنَا فَٱغْفِرْ لَنَا وَٱرْحَمْنَا ۖ وَأَنتَ خَيْرُ ٱلْغَٰفِرِينَ',
		number_in_surah: '155',
		page: '169',
		surah_id: '7',
		hizb_id: '67',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1110',
		number: '1110',
		text: '۞ وَٱكْتُبْ لَنَا فِى هَٰذِهِ ٱلدُّنْيَا حَسَنَةًۭ وَفِى ٱلْءَاخِرَةِ إِنَّا هُدْنَآ إِلَيْكَ ۚ قَالَ عَذَابِىٓ أُصِيبُ بِهِۦ مَنْ أَشَآءُ ۖ وَرَحْمَتِى وَسِعَتْ كُلَّ شَىْءٍۢ ۚ فَسَأَكْتُبُهَا لِلَّذِينَ يَتَّقُونَ وَيُؤْتُونَ ٱلزَّكَوٰةَ وَٱلَّذِينَ هُم بِـَٔايَٰتِنَا يُؤْمِنُونَ',
		number_in_surah: '156',
		page: '170',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1111',
		number: '1111',
		text: 'ٱلَّذِينَ يَتَّبِعُونَ ٱلرَّسُولَ ٱلنَّبِىَّ ٱلْأُمِّىَّ ٱلَّذِى يَجِدُونَهُۥ مَكْتُوبًا عِندَهُمْ فِى ٱلتَّوْرَىٰةِ وَٱلْإِنجِيلِ يَأْمُرُهُم بِٱلْمَعْرُوفِ وَيَنْهَىٰهُمْ عَنِ ٱلْمُنكَرِ وَيُحِلُّ لَهُمُ ٱلطَّيِّبَٰتِ وَيُحَرِّمُ عَلَيْهِمُ ٱلْخَبَٰٓئِثَ وَيَضَعُ عَنْهُمْ إِصْرَهُمْ وَٱلْأَغْلَٰلَ ٱلَّتِى كَانَتْ عَلَيْهِمْ ۚ فَٱلَّذِينَ ءَامَنُوا۟ بِهِۦ وَعَزَّرُوهُ وَنَصَرُوهُ وَٱتَّبَعُوا۟ ٱلنُّورَ ٱلَّذِىٓ أُنزِلَ مَعَهُۥٓ ۙ أُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '157',
		page: '170',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1112',
		number: '1112',
		text: 'قُلْ يَٰٓأَيُّهَا ٱلنَّاسُ إِنِّى رَسُولُ ٱللَّهِ إِلَيْكُمْ جَمِيعًا ٱلَّذِى لَهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ لَآ إِلَٰهَ إِلَّا هُوَ يُحْىِۦ وَيُمِيتُ ۖ فَـَٔامِنُوا۟ بِٱللَّهِ وَرَسُولِهِ ٱلنَّبِىِّ ٱلْأُمِّىِّ ٱلَّذِى يُؤْمِنُ بِٱللَّهِ وَكَلِمَٰتِهِۦ وَٱتَّبِعُوهُ لَعَلَّكُمْ تَهْتَدُونَ',
		number_in_surah: '158',
		page: '170',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1113',
		number: '1113',
		text: 'وَمِن قَوْمِ مُوسَىٰٓ أُمَّةٌۭ يَهْدُونَ بِٱلْحَقِّ وَبِهِۦ يَعْدِلُونَ',
		number_in_surah: '159',
		page: '170',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1114',
		number: '1114',
		text: 'وَقَطَّعْنَٰهُمُ ٱثْنَتَىْ عَشْرَةَ أَسْبَاطًا أُمَمًۭا ۚ وَأَوْحَيْنَآ إِلَىٰ مُوسَىٰٓ إِذِ ٱسْتَسْقَىٰهُ قَوْمُهُۥٓ أَنِ ٱضْرِب بِّعَصَاكَ ٱلْحَجَرَ ۖ فَٱنۢبَجَسَتْ مِنْهُ ٱثْنَتَا عَشْرَةَ عَيْنًۭا ۖ قَدْ عَلِمَ كُلُّ أُنَاسٍۢ مَّشْرَبَهُمْ ۚ وَظَلَّلْنَا عَلَيْهِمُ ٱلْغَمَٰمَ وَأَنزَلْنَا عَلَيْهِمُ ٱلْمَنَّ وَٱلسَّلْوَىٰ ۖ كُلُوا۟ مِن طَيِّبَٰتِ مَا رَزَقْنَٰكُمْ ۚ وَمَا ظَلَمُونَا وَلَٰكِن كَانُوٓا۟ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '160',
		page: '171',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1115',
		number: '1115',
		text: 'وَإِذْ قِيلَ لَهُمُ ٱسْكُنُوا۟ هَٰذِهِ ٱلْقَرْيَةَ وَكُلُوا۟ مِنْهَا حَيْثُ شِئْتُمْ وَقُولُوا۟ حِطَّةٌۭ وَٱدْخُلُوا۟ ٱلْبَابَ سُجَّدًۭا نَّغْفِرْ لَكُمْ خَطِيٓـَٰٔتِكُمْ ۚ سَنَزِيدُ ٱلْمُحْسِنِينَ',
		number_in_surah: '161',
		page: '171',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1116',
		number: '1116',
		text: 'فَبَدَّلَ ٱلَّذِينَ ظَلَمُوا۟ مِنْهُمْ قَوْلًا غَيْرَ ٱلَّذِى قِيلَ لَهُمْ فَأَرْسَلْنَا عَلَيْهِمْ رِجْزًۭا مِّنَ ٱلسَّمَآءِ بِمَا كَانُوا۟ يَظْلِمُونَ',
		number_in_surah: '162',
		page: '171',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1117',
		number: '1117',
		text: 'وَسْـَٔلْهُمْ عَنِ ٱلْقَرْيَةِ ٱلَّتِى كَانَتْ حَاضِرَةَ ٱلْبَحْرِ إِذْ يَعْدُونَ فِى ٱلسَّبْتِ إِذْ تَأْتِيهِمْ حِيتَانُهُمْ يَوْمَ سَبْتِهِمْ شُرَّعًۭا وَيَوْمَ لَا يَسْبِتُونَ ۙ لَا تَأْتِيهِمْ ۚ كَذَٰلِكَ نَبْلُوهُم بِمَا كَانُوا۟ يَفْسُقُونَ',
		number_in_surah: '163',
		page: '171',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1118',
		number: '1118',
		text: 'وَإِذْ قَالَتْ أُمَّةٌۭ مِّنْهُمْ لِمَ تَعِظُونَ قَوْمًا ۙ ٱللَّهُ مُهْلِكُهُمْ أَوْ مُعَذِّبُهُمْ عَذَابًۭا شَدِيدًۭا ۖ قَالُوا۟ مَعْذِرَةً إِلَىٰ رَبِّكُمْ وَلَعَلَّهُمْ يَتَّقُونَ',
		number_in_surah: '164',
		page: '172',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1119',
		number: '1119',
		text: 'فَلَمَّا نَسُوا۟ مَا ذُكِّرُوا۟ بِهِۦٓ أَنجَيْنَا ٱلَّذِينَ يَنْهَوْنَ عَنِ ٱلسُّوٓءِ وَأَخَذْنَا ٱلَّذِينَ ظَلَمُوا۟ بِعَذَابٍۭ بَـِٔيسٍۭ بِمَا كَانُوا۟ يَفْسُقُونَ',
		number_in_surah: '165',
		page: '172',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1120',
		number: '1120',
		text: 'فَلَمَّا عَتَوْا۟ عَن مَّا نُهُوا۟ عَنْهُ قُلْنَا لَهُمْ كُونُوا۟ قِرَدَةً خَٰسِـِٔينَ',
		number_in_surah: '166',
		page: '172',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1121',
		number: '1121',
		text: 'وَإِذْ تَأَذَّنَ رَبُّكَ لَيَبْعَثَنَّ عَلَيْهِمْ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ مَن يَسُومُهُمْ سُوٓءَ ٱلْعَذَابِ ۗ إِنَّ رَبَّكَ لَسَرِيعُ ٱلْعِقَابِ ۖ وَإِنَّهُۥ لَغَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '167',
		page: '172',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1122',
		number: '1122',
		text: 'وَقَطَّعْنَٰهُمْ فِى ٱلْأَرْضِ أُمَمًۭا ۖ مِّنْهُمُ ٱلصَّٰلِحُونَ وَمِنْهُمْ دُونَ ذَٰلِكَ ۖ وَبَلَوْنَٰهُم بِٱلْحَسَنَٰتِ وَٱلسَّيِّـَٔاتِ لَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '168',
		page: '172',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1123',
		number: '1123',
		text: 'فَخَلَفَ مِنۢ بَعْدِهِمْ خَلْفٌۭ وَرِثُوا۟ ٱلْكِتَٰبَ يَأْخُذُونَ عَرَضَ هَٰذَا ٱلْأَدْنَىٰ وَيَقُولُونَ سَيُغْفَرُ لَنَا وَإِن يَأْتِهِمْ عَرَضٌۭ مِّثْلُهُۥ يَأْخُذُوهُ ۚ أَلَمْ يُؤْخَذْ عَلَيْهِم مِّيثَٰقُ ٱلْكِتَٰبِ أَن لَّا يَقُولُوا۟ عَلَى ٱللَّهِ إِلَّا ٱلْحَقَّ وَدَرَسُوا۟ مَا فِيهِ ۗ وَٱلدَّارُ ٱلْءَاخِرَةُ خَيْرٌۭ لِّلَّذِينَ يَتَّقُونَ ۗ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '169',
		page: '172',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1124',
		number: '1124',
		text: 'وَٱلَّذِينَ يُمَسِّكُونَ بِٱلْكِتَٰبِ وَأَقَامُوا۟ ٱلصَّلَوٰةَ إِنَّا لَا نُضِيعُ أَجْرَ ٱلْمُصْلِحِينَ',
		number_in_surah: '170',
		page: '172',
		surah_id: '7',
		hizb_id: '68',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1125',
		number: '1125',
		text: '۞ وَإِذْ نَتَقْنَا ٱلْجَبَلَ فَوْقَهُمْ كَأَنَّهُۥ ظُلَّةٌۭ وَظَنُّوٓا۟ أَنَّهُۥ وَاقِعٌۢ بِهِمْ خُذُوا۟ مَآ ءَاتَيْنَٰكُم بِقُوَّةٍۢ وَٱذْكُرُوا۟ مَا فِيهِ لَعَلَّكُمْ تَتَّقُونَ',
		number_in_surah: '171',
		page: '173',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1126',
		number: '1126',
		text: 'وَإِذْ أَخَذَ رَبُّكَ مِنۢ بَنِىٓ ءَادَمَ مِن ظُهُورِهِمْ ذُرِّيَّتَهُمْ وَأَشْهَدَهُمْ عَلَىٰٓ أَنفُسِهِمْ أَلَسْتُ بِرَبِّكُمْ ۖ قَالُوا۟ بَلَىٰ ۛ شَهِدْنَآ ۛ أَن تَقُولُوا۟ يَوْمَ ٱلْقِيَٰمَةِ إِنَّا كُنَّا عَنْ هَٰذَا غَٰفِلِينَ',
		number_in_surah: '172',
		page: '173',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1127',
		number: '1127',
		text: 'أَوْ تَقُولُوٓا۟ إِنَّمَآ أَشْرَكَ ءَابَآؤُنَا مِن قَبْلُ وَكُنَّا ذُرِّيَّةًۭ مِّنۢ بَعْدِهِمْ ۖ أَفَتُهْلِكُنَا بِمَا فَعَلَ ٱلْمُبْطِلُونَ',
		number_in_surah: '173',
		page: '173',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1128',
		number: '1128',
		text: 'وَكَذَٰلِكَ نُفَصِّلُ ٱلْءَايَٰتِ وَلَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '174',
		page: '173',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1129',
		number: '1129',
		text: 'وَٱتْلُ عَلَيْهِمْ نَبَأَ ٱلَّذِىٓ ءَاتَيْنَٰهُ ءَايَٰتِنَا فَٱنسَلَخَ مِنْهَا فَأَتْبَعَهُ ٱلشَّيْطَٰنُ فَكَانَ مِنَ ٱلْغَاوِينَ',
		number_in_surah: '175',
		page: '173',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1130',
		number: '1130',
		text: 'وَلَوْ شِئْنَا لَرَفَعْنَٰهُ بِهَا وَلَٰكِنَّهُۥٓ أَخْلَدَ إِلَى ٱلْأَرْضِ وَٱتَّبَعَ هَوَىٰهُ ۚ فَمَثَلُهُۥ كَمَثَلِ ٱلْكَلْبِ إِن تَحْمِلْ عَلَيْهِ يَلْهَثْ أَوْ تَتْرُكْهُ يَلْهَث ۚ ذَّٰلِكَ مَثَلُ ٱلْقَوْمِ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا ۚ فَٱقْصُصِ ٱلْقَصَصَ لَعَلَّهُمْ يَتَفَكَّرُونَ',
		number_in_surah: '176',
		page: '173',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1131',
		number: '1131',
		text: 'سَآءَ مَثَلًا ٱلْقَوْمُ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا وَأَنفُسَهُمْ كَانُوا۟ يَظْلِمُونَ',
		number_in_surah: '177',
		page: '173',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1132',
		number: '1132',
		text: 'مَن يَهْدِ ٱللَّهُ فَهُوَ ٱلْمُهْتَدِى ۖ وَمَن يُضْلِلْ فَأُو۟لَٰٓئِكَ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '178',
		page: '173',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1133',
		number: '1133',
		text: 'وَلَقَدْ ذَرَأْنَا لِجَهَنَّمَ كَثِيرًۭا مِّنَ ٱلْجِنِّ وَٱلْإِنسِ ۖ لَهُمْ قُلُوبٌۭ لَّا يَفْقَهُونَ بِهَا وَلَهُمْ أَعْيُنٌۭ لَّا يُبْصِرُونَ بِهَا وَلَهُمْ ءَاذَانٌۭ لَّا يَسْمَعُونَ بِهَآ ۚ أُو۟لَٰٓئِكَ كَٱلْأَنْعَٰمِ بَلْ هُمْ أَضَلُّ ۚ أُو۟لَٰٓئِكَ هُمُ ٱلْغَٰفِلُونَ',
		number_in_surah: '179',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1134',
		number: '1134',
		text: 'وَلِلَّهِ ٱلْأَسْمَآءُ ٱلْحُسْنَىٰ فَٱدْعُوهُ بِهَا ۖ وَذَرُوا۟ ٱلَّذِينَ يُلْحِدُونَ فِىٓ أَسْمَٰٓئِهِۦ ۚ سَيُجْزَوْنَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '180',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1135',
		number: '1135',
		text: 'وَمِمَّنْ خَلَقْنَآ أُمَّةٌۭ يَهْدُونَ بِٱلْحَقِّ وَبِهِۦ يَعْدِلُونَ',
		number_in_surah: '181',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1136',
		number: '1136',
		text: 'وَٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا سَنَسْتَدْرِجُهُم مِّنْ حَيْثُ لَا يَعْلَمُونَ',
		number_in_surah: '182',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1137',
		number: '1137',
		text: 'وَأُمْلِى لَهُمْ ۚ إِنَّ كَيْدِى مَتِينٌ',
		number_in_surah: '183',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1138',
		number: '1138',
		text: 'أَوَلَمْ يَتَفَكَّرُوا۟ ۗ مَا بِصَاحِبِهِم مِّن جِنَّةٍ ۚ إِنْ هُوَ إِلَّا نَذِيرٌۭ مُّبِينٌ',
		number_in_surah: '184',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1139',
		number: '1139',
		text: 'أَوَلَمْ يَنظُرُوا۟ فِى مَلَكُوتِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا خَلَقَ ٱللَّهُ مِن شَىْءٍۢ وَأَنْ عَسَىٰٓ أَن يَكُونَ قَدِ ٱقْتَرَبَ أَجَلُهُمْ ۖ فَبِأَىِّ حَدِيثٍۭ بَعْدَهُۥ يُؤْمِنُونَ',
		number_in_surah: '185',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1140',
		number: '1140',
		text: 'مَن يُضْلِلِ ٱللَّهُ فَلَا هَادِىَ لَهُۥ ۚ وَيَذَرُهُمْ فِى طُغْيَٰنِهِمْ يَعْمَهُونَ',
		number_in_surah: '186',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1141',
		number: '1141',
		text: 'يَسْـَٔلُونَكَ عَنِ ٱلسَّاعَةِ أَيَّانَ مُرْسَىٰهَا ۖ قُلْ إِنَّمَا عِلْمُهَا عِندَ رَبِّى ۖ لَا يُجَلِّيهَا لِوَقْتِهَآ إِلَّا هُوَ ۚ ثَقُلَتْ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ لَا تَأْتِيكُمْ إِلَّا بَغْتَةًۭ ۗ يَسْـَٔلُونَكَ كَأَنَّكَ حَفِىٌّ عَنْهَا ۖ قُلْ إِنَّمَا عِلْمُهَا عِندَ ٱللَّهِ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '187',
		page: '174',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1142',
		number: '1142',
		text: 'قُل لَّآ أَمْلِكُ لِنَفْسِى نَفْعًۭا وَلَا ضَرًّا إِلَّا مَا شَآءَ ٱللَّهُ ۚ وَلَوْ كُنتُ أَعْلَمُ ٱلْغَيْبَ لَٱسْتَكْثَرْتُ مِنَ ٱلْخَيْرِ وَمَا مَسَّنِىَ ٱلسُّوٓءُ ۚ إِنْ أَنَا۠ إِلَّا نَذِيرٌۭ وَبَشِيرٌۭ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '188',
		page: '175',
		surah_id: '7',
		hizb_id: '69',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1143',
		number: '1143',
		text: '۞ هُوَ ٱلَّذِى خَلَقَكُم مِّن نَّفْسٍۢ وَٰحِدَةٍۢ وَجَعَلَ مِنْهَا زَوْجَهَا لِيَسْكُنَ إِلَيْهَا ۖ فَلَمَّا تَغَشَّىٰهَا حَمَلَتْ حَمْلًا خَفِيفًۭا فَمَرَّتْ بِهِۦ ۖ فَلَمَّآ أَثْقَلَت دَّعَوَا ٱللَّهَ رَبَّهُمَا لَئِنْ ءَاتَيْتَنَا صَٰلِحًۭا لَّنَكُونَنَّ مِنَ ٱلشَّٰكِرِينَ',
		number_in_surah: '189',
		page: '175',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1144',
		number: '1144',
		text: 'فَلَمَّآ ءَاتَىٰهُمَا صَٰلِحًۭا جَعَلَا لَهُۥ شُرَكَآءَ فِيمَآ ءَاتَىٰهُمَا ۚ فَتَعَٰلَى ٱللَّهُ عَمَّا يُشْرِكُونَ',
		number_in_surah: '190',
		page: '175',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1145',
		number: '1145',
		text: 'أَيُشْرِكُونَ مَا لَا يَخْلُقُ شَيْـًۭٔا وَهُمْ يُخْلَقُونَ',
		number_in_surah: '191',
		page: '175',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1146',
		number: '1146',
		text: 'وَلَا يَسْتَطِيعُونَ لَهُمْ نَصْرًۭا وَلَآ أَنفُسَهُمْ يَنصُرُونَ',
		number_in_surah: '192',
		page: '175',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1147',
		number: '1147',
		text: 'وَإِن تَدْعُوهُمْ إِلَى ٱلْهُدَىٰ لَا يَتَّبِعُوكُمْ ۚ سَوَآءٌ عَلَيْكُمْ أَدَعَوْتُمُوهُمْ أَمْ أَنتُمْ صَٰمِتُونَ',
		number_in_surah: '193',
		page: '175',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1148',
		number: '1148',
		text: 'إِنَّ ٱلَّذِينَ تَدْعُونَ مِن دُونِ ٱللَّهِ عِبَادٌ أَمْثَالُكُمْ ۖ فَٱدْعُوهُمْ فَلْيَسْتَجِيبُوا۟ لَكُمْ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '194',
		page: '175',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1149',
		number: '1149',
		text: 'أَلَهُمْ أَرْجُلٌۭ يَمْشُونَ بِهَآ ۖ أَمْ لَهُمْ أَيْدٍۢ يَبْطِشُونَ بِهَآ ۖ أَمْ لَهُمْ أَعْيُنٌۭ يُبْصِرُونَ بِهَآ ۖ أَمْ لَهُمْ ءَاذَانٌۭ يَسْمَعُونَ بِهَا ۗ قُلِ ٱدْعُوا۟ شُرَكَآءَكُمْ ثُمَّ كِيدُونِ فَلَا تُنظِرُونِ',
		number_in_surah: '195',
		page: '175',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1150',
		number: '1150',
		text: 'إِنَّ وَلِۦِّىَ ٱللَّهُ ٱلَّذِى نَزَّلَ ٱلْكِتَٰبَ ۖ وَهُوَ يَتَوَلَّى ٱلصَّٰلِحِينَ',
		number_in_surah: '196',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1151',
		number: '1151',
		text: 'وَٱلَّذِينَ تَدْعُونَ مِن دُونِهِۦ لَا يَسْتَطِيعُونَ نَصْرَكُمْ وَلَآ أَنفُسَهُمْ يَنصُرُونَ',
		number_in_surah: '197',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1152',
		number: '1152',
		text: 'وَإِن تَدْعُوهُمْ إِلَى ٱلْهُدَىٰ لَا يَسْمَعُوا۟ ۖ وَتَرَىٰهُمْ يَنظُرُونَ إِلَيْكَ وَهُمْ لَا يُبْصِرُونَ',
		number_in_surah: '198',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1153',
		number: '1153',
		text: 'خُذِ ٱلْعَفْوَ وَأْمُرْ بِٱلْعُرْفِ وَأَعْرِضْ عَنِ ٱلْجَٰهِلِينَ',
		number_in_surah: '199',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1154',
		number: '1154',
		text: 'وَإِمَّا يَنزَغَنَّكَ مِنَ ٱلشَّيْطَٰنِ نَزْغٌۭ فَٱسْتَعِذْ بِٱللَّهِ ۚ إِنَّهُۥ سَمِيعٌ عَلِيمٌ',
		number_in_surah: '200',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1155',
		number: '1155',
		text: 'إِنَّ ٱلَّذِينَ ٱتَّقَوْا۟ إِذَا مَسَّهُمْ طَٰٓئِفٌۭ مِّنَ ٱلشَّيْطَٰنِ تَذَكَّرُوا۟ فَإِذَا هُم مُّبْصِرُونَ',
		number_in_surah: '201',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1156',
		number: '1156',
		text: 'وَإِخْوَٰنُهُمْ يَمُدُّونَهُمْ فِى ٱلْغَىِّ ثُمَّ لَا يُقْصِرُونَ',
		number_in_surah: '202',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1157',
		number: '1157',
		text: 'وَإِذَا لَمْ تَأْتِهِم بِـَٔايَةٍۢ قَالُوا۟ لَوْلَا ٱجْتَبَيْتَهَا ۚ قُلْ إِنَّمَآ أَتَّبِعُ مَا يُوحَىٰٓ إِلَىَّ مِن رَّبِّى ۚ هَٰذَا بَصَآئِرُ مِن رَّبِّكُمْ وَهُدًۭى وَرَحْمَةٌۭ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '203',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1158',
		number: '1158',
		text: 'وَإِذَا قُرِئَ ٱلْقُرْءَانُ فَٱسْتَمِعُوا۟ لَهُۥ وَأَنصِتُوا۟ لَعَلَّكُمْ تُرْحَمُونَ',
		number_in_surah: '204',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1159',
		number: '1159',
		text: 'وَٱذْكُر رَّبَّكَ فِى نَفْسِكَ تَضَرُّعًۭا وَخِيفَةًۭ وَدُونَ ٱلْجَهْرِ مِنَ ٱلْقَوْلِ بِٱلْغُدُوِّ وَٱلْءَاصَالِ وَلَا تَكُن مِّنَ ٱلْغَٰفِلِينَ',
		number_in_surah: '205',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1160',
		number: '1160',
		text: 'إِنَّ ٱلَّذِينَ عِندَ رَبِّكَ لَا يَسْتَكْبِرُونَ عَنْ عِبَادَتِهِۦ وَيُسَبِّحُونَهُۥ وَلَهُۥ يَسْجُدُونَ ۩',
		number_in_surah: '206',
		page: '176',
		surah_id: '7',
		hizb_id: '70',
		juz_id: '9',
		sajda: '1',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1161',
		number: '1161',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَسْـَٔلُونَكَ عَنِ ٱلْأَنفَالِ ۖ قُلِ ٱلْأَنفَالُ لِلَّهِ وَٱلرَّسُولِ ۖ فَٱتَّقُوا۟ ٱللَّهَ وَأَصْلِحُوا۟ ذَاتَ بَيْنِكُمْ ۖ وَأَطِيعُوا۟ ٱللَّهَ وَرَسُولَهُۥٓ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '1',
		page: '177',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1162',
		number: '1162',
		text: 'إِنَّمَا ٱلْمُؤْمِنُونَ ٱلَّذِينَ إِذَا ذُكِرَ ٱللَّهُ وَجِلَتْ قُلُوبُهُمْ وَإِذَا تُلِيَتْ عَلَيْهِمْ ءَايَٰتُهُۥ زَادَتْهُمْ إِيمَٰنًۭا وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ',
		number_in_surah: '2',
		page: '177',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1163',
		number: '1163',
		text: 'ٱلَّذِينَ يُقِيمُونَ ٱلصَّلَوٰةَ وَمِمَّا رَزَقْنَٰهُمْ يُنفِقُونَ',
		number_in_surah: '3',
		page: '177',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1164',
		number: '1164',
		text: 'أُو۟لَٰٓئِكَ هُمُ ٱلْمُؤْمِنُونَ حَقًّۭا ۚ لَّهُمْ دَرَجَٰتٌ عِندَ رَبِّهِمْ وَمَغْفِرَةٌۭ وَرِزْقٌۭ كَرِيمٌۭ',
		number_in_surah: '4',
		page: '177',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1165',
		number: '1165',
		text: 'كَمَآ أَخْرَجَكَ رَبُّكَ مِنۢ بَيْتِكَ بِٱلْحَقِّ وَإِنَّ فَرِيقًۭا مِّنَ ٱلْمُؤْمِنِينَ لَكَٰرِهُونَ',
		number_in_surah: '5',
		page: '177',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1166',
		number: '1166',
		text: 'يُجَٰدِلُونَكَ فِى ٱلْحَقِّ بَعْدَمَا تَبَيَّنَ كَأَنَّمَا يُسَاقُونَ إِلَى ٱلْمَوْتِ وَهُمْ يَنظُرُونَ',
		number_in_surah: '6',
		page: '177',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1167',
		number: '1167',
		text: 'وَإِذْ يَعِدُكُمُ ٱللَّهُ إِحْدَى ٱلطَّآئِفَتَيْنِ أَنَّهَا لَكُمْ وَتَوَدُّونَ أَنَّ غَيْرَ ذَاتِ ٱلشَّوْكَةِ تَكُونُ لَكُمْ وَيُرِيدُ ٱللَّهُ أَن يُحِقَّ ٱلْحَقَّ بِكَلِمَٰتِهِۦ وَيَقْطَعَ دَابِرَ ٱلْكَٰفِرِينَ',
		number_in_surah: '7',
		page: '177',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1168',
		number: '1168',
		text: 'لِيُحِقَّ ٱلْحَقَّ وَيُبْطِلَ ٱلْبَٰطِلَ وَلَوْ كَرِهَ ٱلْمُجْرِمُونَ',
		number_in_surah: '8',
		page: '177',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1169',
		number: '1169',
		text: 'إِذْ تَسْتَغِيثُونَ رَبَّكُمْ فَٱسْتَجَابَ لَكُمْ أَنِّى مُمِدُّكُم بِأَلْفٍۢ مِّنَ ٱلْمَلَٰٓئِكَةِ مُرْدِفِينَ',
		number_in_surah: '9',
		page: '178',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1170',
		number: '1170',
		text: 'وَمَا جَعَلَهُ ٱللَّهُ إِلَّا بُشْرَىٰ وَلِتَطْمَئِنَّ بِهِۦ قُلُوبُكُمْ ۚ وَمَا ٱلنَّصْرُ إِلَّا مِنْ عِندِ ٱللَّهِ ۚ إِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌ',
		number_in_surah: '10',
		page: '178',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1171',
		number: '1171',
		text: 'إِذْ يُغَشِّيكُمُ ٱلنُّعَاسَ أَمَنَةًۭ مِّنْهُ وَيُنَزِّلُ عَلَيْكُم مِّنَ ٱلسَّمَآءِ مَآءًۭ لِّيُطَهِّرَكُم بِهِۦ وَيُذْهِبَ عَنكُمْ رِجْزَ ٱلشَّيْطَٰنِ وَلِيَرْبِطَ عَلَىٰ قُلُوبِكُمْ وَيُثَبِّتَ بِهِ ٱلْأَقْدَامَ',
		number_in_surah: '11',
		page: '178',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1172',
		number: '1172',
		text: 'إِذْ يُوحِى رَبُّكَ إِلَى ٱلْمَلَٰٓئِكَةِ أَنِّى مَعَكُمْ فَثَبِّتُوا۟ ٱلَّذِينَ ءَامَنُوا۟ ۚ سَأُلْقِى فِى قُلُوبِ ٱلَّذِينَ كَفَرُوا۟ ٱلرُّعْبَ فَٱضْرِبُوا۟ فَوْقَ ٱلْأَعْنَاقِ وَٱضْرِبُوا۟ مِنْهُمْ كُلَّ بَنَانٍۢ',
		number_in_surah: '12',
		page: '178',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1173',
		number: '1173',
		text: 'ذَٰلِكَ بِأَنَّهُمْ شَآقُّوا۟ ٱللَّهَ وَرَسُولَهُۥ ۚ وَمَن يُشَاقِقِ ٱللَّهَ وَرَسُولَهُۥ فَإِنَّ ٱللَّهَ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '13',
		page: '178',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1174',
		number: '1174',
		text: 'ذَٰلِكُمْ فَذُوقُوهُ وَأَنَّ لِلْكَٰفِرِينَ عَذَابَ ٱلنَّارِ',
		number_in_surah: '14',
		page: '178',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1175',
		number: '1175',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا لَقِيتُمُ ٱلَّذِينَ كَفَرُوا۟ زَحْفًۭا فَلَا تُوَلُّوهُمُ ٱلْأَدْبَارَ',
		number_in_surah: '15',
		page: '178',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1176',
		number: '1176',
		text: 'وَمَن يُوَلِّهِمْ يَوْمَئِذٍۢ دُبُرَهُۥٓ إِلَّا مُتَحَرِّفًۭا لِّقِتَالٍ أَوْ مُتَحَيِّزًا إِلَىٰ فِئَةٍۢ فَقَدْ بَآءَ بِغَضَبٍۢ مِّنَ ٱللَّهِ وَمَأْوَىٰهُ جَهَنَّمُ ۖ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '16',
		page: '178',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1177',
		number: '1177',
		text: 'فَلَمْ تَقْتُلُوهُمْ وَلَٰكِنَّ ٱللَّهَ قَتَلَهُمْ ۚ وَمَا رَمَيْتَ إِذْ رَمَيْتَ وَلَٰكِنَّ ٱللَّهَ رَمَىٰ ۚ وَلِيُبْلِىَ ٱلْمُؤْمِنِينَ مِنْهُ بَلَآءً حَسَنًا ۚ إِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '17',
		page: '179',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1178',
		number: '1178',
		text: 'ذَٰلِكُمْ وَأَنَّ ٱللَّهَ مُوهِنُ كَيْدِ ٱلْكَٰفِرِينَ',
		number_in_surah: '18',
		page: '179',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1179',
		number: '1179',
		text: 'إِن تَسْتَفْتِحُوا۟ فَقَدْ جَآءَكُمُ ٱلْفَتْحُ ۖ وَإِن تَنتَهُوا۟ فَهُوَ خَيْرٌۭ لَّكُمْ ۖ وَإِن تَعُودُوا۟ نَعُدْ وَلَن تُغْنِىَ عَنكُمْ فِئَتُكُمْ شَيْـًۭٔا وَلَوْ كَثُرَتْ وَأَنَّ ٱللَّهَ مَعَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '19',
		page: '179',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1180',
		number: '1180',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ أَطِيعُوا۟ ٱللَّهَ وَرَسُولَهُۥ وَلَا تَوَلَّوْا۟ عَنْهُ وَأَنتُمْ تَسْمَعُونَ',
		number_in_surah: '20',
		page: '179',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1181',
		number: '1181',
		text: 'وَلَا تَكُونُوا۟ كَٱلَّذِينَ قَالُوا۟ سَمِعْنَا وَهُمْ لَا يَسْمَعُونَ',
		number_in_surah: '21',
		page: '179',
		surah_id: '8',
		hizb_id: '71',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1182',
		number: '1182',
		text: '۞ إِنَّ شَرَّ ٱلدَّوَآبِّ عِندَ ٱللَّهِ ٱلصُّمُّ ٱلْبُكْمُ ٱلَّذِينَ لَا يَعْقِلُونَ',
		number_in_surah: '22',
		page: '179',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1183',
		number: '1183',
		text: 'وَلَوْ عَلِمَ ٱللَّهُ فِيهِمْ خَيْرًۭا لَّأَسْمَعَهُمْ ۖ وَلَوْ أَسْمَعَهُمْ لَتَوَلَّوا۟ وَّهُم مُّعْرِضُونَ',
		number_in_surah: '23',
		page: '179',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1184',
		number: '1184',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱسْتَجِيبُوا۟ لِلَّهِ وَلِلرَّسُولِ إِذَا دَعَاكُمْ لِمَا يُحْيِيكُمْ ۖ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ يَحُولُ بَيْنَ ٱلْمَرْءِ وَقَلْبِهِۦ وَأَنَّهُۥٓ إِلَيْهِ تُحْشَرُونَ',
		number_in_surah: '24',
		page: '179',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1185',
		number: '1185',
		text: 'وَٱتَّقُوا۟ فِتْنَةًۭ لَّا تُصِيبَنَّ ٱلَّذِينَ ظَلَمُوا۟ مِنكُمْ خَآصَّةًۭ ۖ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '25',
		page: '179',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1186',
		number: '1186',
		text: 'وَٱذْكُرُوٓا۟ إِذْ أَنتُمْ قَلِيلٌۭ مُّسْتَضْعَفُونَ فِى ٱلْأَرْضِ تَخَافُونَ أَن يَتَخَطَّفَكُمُ ٱلنَّاسُ فَـَٔاوَىٰكُمْ وَأَيَّدَكُم بِنَصْرِهِۦ وَرَزَقَكُم مِّنَ ٱلطَّيِّبَٰتِ لَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '26',
		page: '180',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1187',
		number: '1187',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَخُونُوا۟ ٱللَّهَ وَٱلرَّسُولَ وَتَخُونُوٓا۟ أَمَٰنَٰتِكُمْ وَأَنتُمْ تَعْلَمُونَ',
		number_in_surah: '27',
		page: '180',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1188',
		number: '1188',
		text: 'وَٱعْلَمُوٓا۟ أَنَّمَآ أَمْوَٰلُكُمْ وَأَوْلَٰدُكُمْ فِتْنَةٌۭ وَأَنَّ ٱللَّهَ عِندَهُۥٓ أَجْرٌ عَظِيمٌۭ',
		number_in_surah: '28',
		page: '180',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1189',
		number: '1189',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِن تَتَّقُوا۟ ٱللَّهَ يَجْعَل لَّكُمْ فُرْقَانًۭا وَيُكَفِّرْ عَنكُمْ سَيِّـَٔاتِكُمْ وَيَغْفِرْ لَكُمْ ۗ وَٱللَّهُ ذُو ٱلْفَضْلِ ٱلْعَظِيمِ',
		number_in_surah: '29',
		page: '180',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1190',
		number: '1190',
		text: 'وَإِذْ يَمْكُرُ بِكَ ٱلَّذِينَ كَفَرُوا۟ لِيُثْبِتُوكَ أَوْ يَقْتُلُوكَ أَوْ يُخْرِجُوكَ ۚ وَيَمْكُرُونَ وَيَمْكُرُ ٱللَّهُ ۖ وَٱللَّهُ خَيْرُ ٱلْمَٰكِرِينَ',
		number_in_surah: '30',
		page: '180',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1191',
		number: '1191',
		text: 'وَإِذَا تُتْلَىٰ عَلَيْهِمْ ءَايَٰتُنَا قَالُوا۟ قَدْ سَمِعْنَا لَوْ نَشَآءُ لَقُلْنَا مِثْلَ هَٰذَآ ۙ إِنْ هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلْأَوَّلِينَ',
		number_in_surah: '31',
		page: '180',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1192',
		number: '1192',
		text: 'وَإِذْ قَالُوا۟ ٱللَّهُمَّ إِن كَانَ هَٰذَا هُوَ ٱلْحَقَّ مِنْ عِندِكَ فَأَمْطِرْ عَلَيْنَا حِجَارَةًۭ مِّنَ ٱلسَّمَآءِ أَوِ ٱئْتِنَا بِعَذَابٍ أَلِيمٍۢ',
		number_in_surah: '32',
		page: '180',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1193',
		number: '1193',
		text: 'وَمَا كَانَ ٱللَّهُ لِيُعَذِّبَهُمْ وَأَنتَ فِيهِمْ ۚ وَمَا كَانَ ٱللَّهُ مُعَذِّبَهُمْ وَهُمْ يَسْتَغْفِرُونَ',
		number_in_surah: '33',
		page: '180',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1194',
		number: '1194',
		text: 'وَمَا لَهُمْ أَلَّا يُعَذِّبَهُمُ ٱللَّهُ وَهُمْ يَصُدُّونَ عَنِ ٱلْمَسْجِدِ ٱلْحَرَامِ وَمَا كَانُوٓا۟ أَوْلِيَآءَهُۥٓ ۚ إِنْ أَوْلِيَآؤُهُۥٓ إِلَّا ٱلْمُتَّقُونَ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '34',
		page: '181',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1195',
		number: '1195',
		text: 'وَمَا كَانَ صَلَاتُهُمْ عِندَ ٱلْبَيْتِ إِلَّا مُكَآءًۭ وَتَصْدِيَةًۭ ۚ فَذُوقُوا۟ ٱلْعَذَابَ بِمَا كُنتُمْ تَكْفُرُونَ',
		number_in_surah: '35',
		page: '181',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1196',
		number: '1196',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ يُنفِقُونَ أَمْوَٰلَهُمْ لِيَصُدُّوا۟ عَن سَبِيلِ ٱللَّهِ ۚ فَسَيُنفِقُونَهَا ثُمَّ تَكُونُ عَلَيْهِمْ حَسْرَةًۭ ثُمَّ يُغْلَبُونَ ۗ وَٱلَّذِينَ كَفَرُوٓا۟ إِلَىٰ جَهَنَّمَ يُحْشَرُونَ',
		number_in_surah: '36',
		page: '181',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1197',
		number: '1197',
		text: 'لِيَمِيزَ ٱللَّهُ ٱلْخَبِيثَ مِنَ ٱلطَّيِّبِ وَيَجْعَلَ ٱلْخَبِيثَ بَعْضَهُۥ عَلَىٰ بَعْضٍۢ فَيَرْكُمَهُۥ جَمِيعًۭا فَيَجْعَلَهُۥ فِى جَهَنَّمَ ۚ أُو۟لَٰٓئِكَ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '37',
		page: '181',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1198',
		number: '1198',
		text: 'قُل لِّلَّذِينَ كَفَرُوٓا۟ إِن يَنتَهُوا۟ يُغْفَرْ لَهُم مَّا قَدْ سَلَفَ وَإِن يَعُودُوا۟ فَقَدْ مَضَتْ سُنَّتُ ٱلْأَوَّلِينَ',
		number_in_surah: '38',
		page: '181',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1199',
		number: '1199',
		text: 'وَقَٰتِلُوهُمْ حَتَّىٰ لَا تَكُونَ فِتْنَةٌۭ وَيَكُونَ ٱلدِّينُ كُلُّهُۥ لِلَّهِ ۚ فَإِنِ ٱنتَهَوْا۟ فَإِنَّ ٱللَّهَ بِمَا يَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '39',
		page: '181',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1200',
		number: '1200',
		text: 'وَإِن تَوَلَّوْا۟ فَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ مَوْلَىٰكُمْ ۚ نِعْمَ ٱلْمَوْلَىٰ وَنِعْمَ ٱلنَّصِيرُ',
		number_in_surah: '40',
		page: '181',
		surah_id: '8',
		hizb_id: '72',
		juz_id: '9',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1201',
		number: '1201',
		text: '۞ وَٱعْلَمُوٓا۟ أَنَّمَا غَنِمْتُم مِّن شَىْءٍۢ فَأَنَّ لِلَّهِ خُمُسَهُۥ وَلِلرَّسُولِ وَلِذِى ٱلْقُرْبَىٰ وَٱلْيَتَٰمَىٰ وَٱلْمَسَٰكِينِ وَٱبْنِ ٱلسَّبِيلِ إِن كُنتُمْ ءَامَنتُم بِٱللَّهِ وَمَآ أَنزَلْنَا عَلَىٰ عَبْدِنَا يَوْمَ ٱلْفُرْقَانِ يَوْمَ ٱلْتَقَى ٱلْجَمْعَانِ ۗ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '41',
		page: '182',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1202',
		number: '1202',
		text: 'إِذْ أَنتُم بِٱلْعُدْوَةِ ٱلدُّنْيَا وَهُم بِٱلْعُدْوَةِ ٱلْقُصْوَىٰ وَٱلرَّكْبُ أَسْفَلَ مِنكُمْ ۚ وَلَوْ تَوَاعَدتُّمْ لَٱخْتَلَفْتُمْ فِى ٱلْمِيعَٰدِ ۙ وَلَٰكِن لِّيَقْضِىَ ٱللَّهُ أَمْرًۭا كَانَ مَفْعُولًۭا لِّيَهْلِكَ مَنْ هَلَكَ عَنۢ بَيِّنَةٍۢ وَيَحْيَىٰ مَنْ حَىَّ عَنۢ بَيِّنَةٍۢ ۗ وَإِنَّ ٱللَّهَ لَسَمِيعٌ عَلِيمٌ',
		number_in_surah: '42',
		page: '182',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1203',
		number: '1203',
		text: 'إِذْ يُرِيكَهُمُ ٱللَّهُ فِى مَنَامِكَ قَلِيلًۭا ۖ وَلَوْ أَرَىٰكَهُمْ كَثِيرًۭا لَّفَشِلْتُمْ وَلَتَنَٰزَعْتُمْ فِى ٱلْأَمْرِ وَلَٰكِنَّ ٱللَّهَ سَلَّمَ ۗ إِنَّهُۥ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '43',
		page: '182',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1204',
		number: '1204',
		text: 'وَإِذْ يُرِيكُمُوهُمْ إِذِ ٱلْتَقَيْتُمْ فِىٓ أَعْيُنِكُمْ قَلِيلًۭا وَيُقَلِّلُكُمْ فِىٓ أَعْيُنِهِمْ لِيَقْضِىَ ٱللَّهُ أَمْرًۭا كَانَ مَفْعُولًۭا ۗ وَإِلَى ٱللَّهِ تُرْجَعُ ٱلْأُمُورُ',
		number_in_surah: '44',
		page: '182',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1205',
		number: '1205',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا لَقِيتُمْ فِئَةًۭ فَٱثْبُتُوا۟ وَٱذْكُرُوا۟ ٱللَّهَ كَثِيرًۭا لَّعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '45',
		page: '182',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1206',
		number: '1206',
		text: 'وَأَطِيعُوا۟ ٱللَّهَ وَرَسُولَهُۥ وَلَا تَنَٰزَعُوا۟ فَتَفْشَلُوا۟ وَتَذْهَبَ رِيحُكُمْ ۖ وَٱصْبِرُوٓا۟ ۚ إِنَّ ٱللَّهَ مَعَ ٱلصَّٰبِرِينَ',
		number_in_surah: '46',
		page: '183',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1207',
		number: '1207',
		text: 'وَلَا تَكُونُوا۟ كَٱلَّذِينَ خَرَجُوا۟ مِن دِيَٰرِهِم بَطَرًۭا وَرِئَآءَ ٱلنَّاسِ وَيَصُدُّونَ عَن سَبِيلِ ٱللَّهِ ۚ وَٱللَّهُ بِمَا يَعْمَلُونَ مُحِيطٌۭ',
		number_in_surah: '47',
		page: '183',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1208',
		number: '1208',
		text: 'وَإِذْ زَيَّنَ لَهُمُ ٱلشَّيْطَٰنُ أَعْمَٰلَهُمْ وَقَالَ لَا غَالِبَ لَكُمُ ٱلْيَوْمَ مِنَ ٱلنَّاسِ وَإِنِّى جَارٌۭ لَّكُمْ ۖ فَلَمَّا تَرَآءَتِ ٱلْفِئَتَانِ نَكَصَ عَلَىٰ عَقِبَيْهِ وَقَالَ إِنِّى بَرِىٓءٌۭ مِّنكُمْ إِنِّىٓ أَرَىٰ مَا لَا تَرَوْنَ إِنِّىٓ أَخَافُ ٱللَّهَ ۚ وَٱللَّهُ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '48',
		page: '183',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1209',
		number: '1209',
		text: 'إِذْ يَقُولُ ٱلْمُنَٰفِقُونَ وَٱلَّذِينَ فِى قُلُوبِهِم مَّرَضٌ غَرَّ هَٰٓؤُلَآءِ دِينُهُمْ ۗ وَمَن يَتَوَكَّلْ عَلَى ٱللَّهِ فَإِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '49',
		page: '183',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1210',
		number: '1210',
		text: 'وَلَوْ تَرَىٰٓ إِذْ يَتَوَفَّى ٱلَّذِينَ كَفَرُوا۟ ۙ ٱلْمَلَٰٓئِكَةُ يَضْرِبُونَ وُجُوهَهُمْ وَأَدْبَٰرَهُمْ وَذُوقُوا۟ عَذَابَ ٱلْحَرِيقِ',
		number_in_surah: '50',
		page: '183',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1211',
		number: '1211',
		text: 'ذَٰلِكَ بِمَا قَدَّمَتْ أَيْدِيكُمْ وَأَنَّ ٱللَّهَ لَيْسَ بِظَلَّٰمٍۢ لِّلْعَبِيدِ',
		number_in_surah: '51',
		page: '183',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1212',
		number: '1212',
		text: 'كَدَأْبِ ءَالِ فِرْعَوْنَ ۙ وَٱلَّذِينَ مِن قَبْلِهِمْ ۚ كَفَرُوا۟ بِـَٔايَٰتِ ٱللَّهِ فَأَخَذَهُمُ ٱللَّهُ بِذُنُوبِهِمْ ۗ إِنَّ ٱللَّهَ قَوِىٌّۭ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '52',
		page: '183',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1213',
		number: '1213',
		text: 'ذَٰلِكَ بِأَنَّ ٱللَّهَ لَمْ يَكُ مُغَيِّرًۭا نِّعْمَةً أَنْعَمَهَا عَلَىٰ قَوْمٍ حَتَّىٰ يُغَيِّرُوا۟ مَا بِأَنفُسِهِمْ ۙ وَأَنَّ ٱللَّهَ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '53',
		page: '184',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1214',
		number: '1214',
		text: 'كَدَأْبِ ءَالِ فِرْعَوْنَ ۙ وَٱلَّذِينَ مِن قَبْلِهِمْ ۚ كَذَّبُوا۟ بِـَٔايَٰتِ رَبِّهِمْ فَأَهْلَكْنَٰهُم بِذُنُوبِهِمْ وَأَغْرَقْنَآ ءَالَ فِرْعَوْنَ ۚ وَكُلٌّۭ كَانُوا۟ ظَٰلِمِينَ',
		number_in_surah: '54',
		page: '184',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1215',
		number: '1215',
		text: 'إِنَّ شَرَّ ٱلدَّوَآبِّ عِندَ ٱللَّهِ ٱلَّذِينَ كَفَرُوا۟ فَهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '55',
		page: '184',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1216',
		number: '1216',
		text: 'ٱلَّذِينَ عَٰهَدتَّ مِنْهُمْ ثُمَّ يَنقُضُونَ عَهْدَهُمْ فِى كُلِّ مَرَّةٍۢ وَهُمْ لَا يَتَّقُونَ',
		number_in_surah: '56',
		page: '184',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1217',
		number: '1217',
		text: 'فَإِمَّا تَثْقَفَنَّهُمْ فِى ٱلْحَرْبِ فَشَرِّدْ بِهِم مَّنْ خَلْفَهُمْ لَعَلَّهُمْ يَذَّكَّرُونَ',
		number_in_surah: '57',
		page: '184',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1218',
		number: '1218',
		text: 'وَإِمَّا تَخَافَنَّ مِن قَوْمٍ خِيَانَةًۭ فَٱنۢبِذْ إِلَيْهِمْ عَلَىٰ سَوَآءٍ ۚ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلْخَآئِنِينَ',
		number_in_surah: '58',
		page: '184',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1219',
		number: '1219',
		text: 'وَلَا يَحْسَبَنَّ ٱلَّذِينَ كَفَرُوا۟ سَبَقُوٓا۟ ۚ إِنَّهُمْ لَا يُعْجِزُونَ',
		number_in_surah: '59',
		page: '184',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1220',
		number: '1220',
		text: 'وَأَعِدُّوا۟ لَهُم مَّا ٱسْتَطَعْتُم مِّن قُوَّةٍۢ وَمِن رِّبَاطِ ٱلْخَيْلِ تُرْهِبُونَ بِهِۦ عَدُوَّ ٱللَّهِ وَعَدُوَّكُمْ وَءَاخَرِينَ مِن دُونِهِمْ لَا تَعْلَمُونَهُمُ ٱللَّهُ يَعْلَمُهُمْ ۚ وَمَا تُنفِقُوا۟ مِن شَىْءٍۢ فِى سَبِيلِ ٱللَّهِ يُوَفَّ إِلَيْكُمْ وَأَنتُمْ لَا تُظْلَمُونَ',
		number_in_surah: '60',
		page: '184',
		surah_id: '8',
		hizb_id: '73',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1221',
		number: '1221',
		text: '۞ وَإِن جَنَحُوا۟ لِلسَّلْمِ فَٱجْنَحْ لَهَا وَتَوَكَّلْ عَلَى ٱللَّهِ ۚ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '61',
		page: '184',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1222',
		number: '1222',
		text: 'وَإِن يُرِيدُوٓا۟ أَن يَخْدَعُوكَ فَإِنَّ حَسْبَكَ ٱللَّهُ ۚ هُوَ ٱلَّذِىٓ أَيَّدَكَ بِنَصْرِهِۦ وَبِٱلْمُؤْمِنِينَ',
		number_in_surah: '62',
		page: '185',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1223',
		number: '1223',
		text: 'وَأَلَّفَ بَيْنَ قُلُوبِهِمْ ۚ لَوْ أَنفَقْتَ مَا فِى ٱلْأَرْضِ جَمِيعًۭا مَّآ أَلَّفْتَ بَيْنَ قُلُوبِهِمْ وَلَٰكِنَّ ٱللَّهَ أَلَّفَ بَيْنَهُمْ ۚ إِنَّهُۥ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '63',
		page: '185',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1224',
		number: '1224',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ حَسْبُكَ ٱللَّهُ وَمَنِ ٱتَّبَعَكَ مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '64',
		page: '185',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1225',
		number: '1225',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ حَرِّضِ ٱلْمُؤْمِنِينَ عَلَى ٱلْقِتَالِ ۚ إِن يَكُن مِّنكُمْ عِشْرُونَ صَٰبِرُونَ يَغْلِبُوا۟ مِا۟ئَتَيْنِ ۚ وَإِن يَكُن مِّنكُم مِّا۟ئَةٌۭ يَغْلِبُوٓا۟ أَلْفًۭا مِّنَ ٱلَّذِينَ كَفَرُوا۟ بِأَنَّهُمْ قَوْمٌۭ لَّا يَفْقَهُونَ',
		number_in_surah: '65',
		page: '185',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1226',
		number: '1226',
		text: 'ٱلْـَٰٔنَ خَفَّفَ ٱللَّهُ عَنكُمْ وَعَلِمَ أَنَّ فِيكُمْ ضَعْفًۭا ۚ فَإِن يَكُن مِّنكُم مِّا۟ئَةٌۭ صَابِرَةٌۭ يَغْلِبُوا۟ مِا۟ئَتَيْنِ ۚ وَإِن يَكُن مِّنكُمْ أَلْفٌۭ يَغْلِبُوٓا۟ أَلْفَيْنِ بِإِذْنِ ٱللَّهِ ۗ وَٱللَّهُ مَعَ ٱلصَّٰبِرِينَ',
		number_in_surah: '66',
		page: '185',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1227',
		number: '1227',
		text: 'مَا كَانَ لِنَبِىٍّ أَن يَكُونَ لَهُۥٓ أَسْرَىٰ حَتَّىٰ يُثْخِنَ فِى ٱلْأَرْضِ ۚ تُرِيدُونَ عَرَضَ ٱلدُّنْيَا وَٱللَّهُ يُرِيدُ ٱلْءَاخِرَةَ ۗ وَٱللَّهُ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '67',
		page: '185',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1228',
		number: '1228',
		text: 'لَّوْلَا كِتَٰبٌۭ مِّنَ ٱللَّهِ سَبَقَ لَمَسَّكُمْ فِيمَآ أَخَذْتُمْ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '68',
		page: '185',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1229',
		number: '1229',
		text: 'فَكُلُوا۟ مِمَّا غَنِمْتُمْ حَلَٰلًۭا طَيِّبًۭا ۚ وَٱتَّقُوا۟ ٱللَّهَ ۚ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '69',
		page: '185',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1230',
		number: '1230',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ قُل لِّمَن فِىٓ أَيْدِيكُم مِّنَ ٱلْأَسْرَىٰٓ إِن يَعْلَمِ ٱللَّهُ فِى قُلُوبِكُمْ خَيْرًۭا يُؤْتِكُمْ خَيْرًۭا مِّمَّآ أُخِذَ مِنكُمْ وَيَغْفِرْ لَكُمْ ۗ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '70',
		page: '186',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1231',
		number: '1231',
		text: 'وَإِن يُرِيدُوا۟ خِيَانَتَكَ فَقَدْ خَانُوا۟ ٱللَّهَ مِن قَبْلُ فَأَمْكَنَ مِنْهُمْ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌ',
		number_in_surah: '71',
		page: '186',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1232',
		number: '1232',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَهَاجَرُوا۟ وَجَٰهَدُوا۟ بِأَمْوَٰلِهِمْ وَأَنفُسِهِمْ فِى سَبِيلِ ٱللَّهِ وَٱلَّذِينَ ءَاوَوا۟ وَّنَصَرُوٓا۟ أُو۟لَٰٓئِكَ بَعْضُهُمْ أَوْلِيَآءُ بَعْضٍۢ ۚ وَٱلَّذِينَ ءَامَنُوا۟ وَلَمْ يُهَاجِرُوا۟ مَا لَكُم مِّن وَلَٰيَتِهِم مِّن شَىْءٍ حَتَّىٰ يُهَاجِرُوا۟ ۚ وَإِنِ ٱسْتَنصَرُوكُمْ فِى ٱلدِّينِ فَعَلَيْكُمُ ٱلنَّصْرُ إِلَّا عَلَىٰ قَوْمٍۭ بَيْنَكُمْ وَبَيْنَهُم مِّيثَٰقٌۭ ۗ وَٱللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '72',
		page: '186',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1233',
		number: '1233',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ بَعْضُهُمْ أَوْلِيَآءُ بَعْضٍ ۚ إِلَّا تَفْعَلُوهُ تَكُن فِتْنَةٌۭ فِى ٱلْأَرْضِ وَفَسَادٌۭ كَبِيرٌۭ',
		number_in_surah: '73',
		page: '186',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1234',
		number: '1234',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَهَاجَرُوا۟ وَجَٰهَدُوا۟ فِى سَبِيلِ ٱللَّهِ وَٱلَّذِينَ ءَاوَوا۟ وَّنَصَرُوٓا۟ أُو۟لَٰٓئِكَ هُمُ ٱلْمُؤْمِنُونَ حَقًّۭا ۚ لَّهُم مَّغْفِرَةٌۭ وَرِزْقٌۭ كَرِيمٌۭ',
		number_in_surah: '74',
		page: '186',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1235',
		number: '1235',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ مِنۢ بَعْدُ وَهَاجَرُوا۟ وَجَٰهَدُوا۟ مَعَكُمْ فَأُو۟لَٰٓئِكَ مِنكُمْ ۚ وَأُو۟لُوا۟ ٱلْأَرْحَامِ بَعْضُهُمْ أَوْلَىٰ بِبَعْضٍۢ فِى كِتَٰبِ ٱللَّهِ ۗ إِنَّ ٱللَّهَ بِكُلِّ شَىْءٍ عَلِيمٌۢ',
		number_in_surah: '75',
		page: '186',
		surah_id: '8',
		hizb_id: '74',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1236',
		number: '1236',
		text: 'بَرَآءَةٌۭ مِّنَ ٱللَّهِ وَرَسُولِهِۦٓ إِلَى ٱلَّذِينَ عَٰهَدتُّم مِّنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '1',
		page: '187',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1237',
		number: '1237',
		text: 'فَسِيحُوا۟ فِى ٱلْأَرْضِ أَرْبَعَةَ أَشْهُرٍۢ وَٱعْلَمُوٓا۟ أَنَّكُمْ غَيْرُ مُعْجِزِى ٱللَّهِ ۙ وَأَنَّ ٱللَّهَ مُخْزِى ٱلْكَٰفِرِينَ',
		number_in_surah: '2',
		page: '187',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1238',
		number: '1238',
		text: 'وَأَذَٰنٌۭ مِّنَ ٱللَّهِ وَرَسُولِهِۦٓ إِلَى ٱلنَّاسِ يَوْمَ ٱلْحَجِّ ٱلْأَكْبَرِ أَنَّ ٱللَّهَ بَرِىٓءٌۭ مِّنَ ٱلْمُشْرِكِينَ ۙ وَرَسُولُهُۥ ۚ فَإِن تُبْتُمْ فَهُوَ خَيْرٌۭ لَّكُمْ ۖ وَإِن تَوَلَّيْتُمْ فَٱعْلَمُوٓا۟ أَنَّكُمْ غَيْرُ مُعْجِزِى ٱللَّهِ ۗ وَبَشِّرِ ٱلَّذِينَ كَفَرُوا۟ بِعَذَابٍ أَلِيمٍ',
		number_in_surah: '3',
		page: '187',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1239',
		number: '1239',
		text: 'إِلَّا ٱلَّذِينَ عَٰهَدتُّم مِّنَ ٱلْمُشْرِكِينَ ثُمَّ لَمْ يَنقُصُوكُمْ شَيْـًۭٔا وَلَمْ يُظَٰهِرُوا۟ عَلَيْكُمْ أَحَدًۭا فَأَتِمُّوٓا۟ إِلَيْهِمْ عَهْدَهُمْ إِلَىٰ مُدَّتِهِمْ ۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلْمُتَّقِينَ',
		number_in_surah: '4',
		page: '187',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1240',
		number: '1240',
		text: 'فَإِذَا ٱنسَلَخَ ٱلْأَشْهُرُ ٱلْحُرُمُ فَٱقْتُلُوا۟ ٱلْمُشْرِكِينَ حَيْثُ وَجَدتُّمُوهُمْ وَخُذُوهُمْ وَٱحْصُرُوهُمْ وَٱقْعُدُوا۟ لَهُمْ كُلَّ مَرْصَدٍۢ ۚ فَإِن تَابُوا۟ وَأَقَامُوا۟ ٱلصَّلَوٰةَ وَءَاتَوُا۟ ٱلزَّكَوٰةَ فَخَلُّوا۟ سَبِيلَهُمْ ۚ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '5',
		page: '187',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1241',
		number: '1241',
		text: 'وَإِنْ أَحَدٌۭ مِّنَ ٱلْمُشْرِكِينَ ٱسْتَجَارَكَ فَأَجِرْهُ حَتَّىٰ يَسْمَعَ كَلَٰمَ ٱللَّهِ ثُمَّ أَبْلِغْهُ مَأْمَنَهُۥ ۚ ذَٰلِكَ بِأَنَّهُمْ قَوْمٌۭ لَّا يَعْلَمُونَ',
		number_in_surah: '6',
		page: '187',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1242',
		number: '1242',
		text: 'كَيْفَ يَكُونُ لِلْمُشْرِكِينَ عَهْدٌ عِندَ ٱللَّهِ وَعِندَ رَسُولِهِۦٓ إِلَّا ٱلَّذِينَ عَٰهَدتُّمْ عِندَ ٱلْمَسْجِدِ ٱلْحَرَامِ ۖ فَمَا ٱسْتَقَٰمُوا۟ لَكُمْ فَٱسْتَقِيمُوا۟ لَهُمْ ۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلْمُتَّقِينَ',
		number_in_surah: '7',
		page: '188',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1243',
		number: '1243',
		text: 'كَيْفَ وَإِن يَظْهَرُوا۟ عَلَيْكُمْ لَا يَرْقُبُوا۟ فِيكُمْ إِلًّۭا وَلَا ذِمَّةًۭ ۚ يُرْضُونَكُم بِأَفْوَٰهِهِمْ وَتَأْبَىٰ قُلُوبُهُمْ وَأَكْثَرُهُمْ فَٰسِقُونَ',
		number_in_surah: '8',
		page: '188',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1244',
		number: '1244',
		text: 'ٱشْتَرَوْا۟ بِـَٔايَٰتِ ٱللَّهِ ثَمَنًۭا قَلِيلًۭا فَصَدُّوا۟ عَن سَبِيلِهِۦٓ ۚ إِنَّهُمْ سَآءَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '9',
		page: '188',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1245',
		number: '1245',
		text: 'لَا يَرْقُبُونَ فِى مُؤْمِنٍ إِلًّۭا وَلَا ذِمَّةًۭ ۚ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُعْتَدُونَ',
		number_in_surah: '10',
		page: '188',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1246',
		number: '1246',
		text: 'فَإِن تَابُوا۟ وَأَقَامُوا۟ ٱلصَّلَوٰةَ وَءَاتَوُا۟ ٱلزَّكَوٰةَ فَإِخْوَٰنُكُمْ فِى ٱلدِّينِ ۗ وَنُفَصِّلُ ٱلْءَايَٰتِ لِقَوْمٍۢ يَعْلَمُونَ',
		number_in_surah: '11',
		page: '188',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1247',
		number: '1247',
		text: 'وَإِن نَّكَثُوٓا۟ أَيْمَٰنَهُم مِّنۢ بَعْدِ عَهْدِهِمْ وَطَعَنُوا۟ فِى دِينِكُمْ فَقَٰتِلُوٓا۟ أَئِمَّةَ ٱلْكُفْرِ ۙ إِنَّهُمْ لَآ أَيْمَٰنَ لَهُمْ لَعَلَّهُمْ يَنتَهُونَ',
		number_in_surah: '12',
		page: '188',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1248',
		number: '1248',
		text: 'أَلَا تُقَٰتِلُونَ قَوْمًۭا نَّكَثُوٓا۟ أَيْمَٰنَهُمْ وَهَمُّوا۟ بِإِخْرَاجِ ٱلرَّسُولِ وَهُم بَدَءُوكُمْ أَوَّلَ مَرَّةٍ ۚ أَتَخْشَوْنَهُمْ ۚ فَٱللَّهُ أَحَقُّ أَن تَخْشَوْهُ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '13',
		page: '188',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1249',
		number: '1249',
		text: 'قَٰتِلُوهُمْ يُعَذِّبْهُمُ ٱللَّهُ بِأَيْدِيكُمْ وَيُخْزِهِمْ وَيَنصُرْكُمْ عَلَيْهِمْ وَيَشْفِ صُدُورَ قَوْمٍۢ مُّؤْمِنِينَ',
		number_in_surah: '14',
		page: '189',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1250',
		number: '1250',
		text: 'وَيُذْهِبْ غَيْظَ قُلُوبِهِمْ ۗ وَيَتُوبُ ٱللَّهُ عَلَىٰ مَن يَشَآءُ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌ',
		number_in_surah: '15',
		page: '189',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1251',
		number: '1251',
		text: 'أَمْ حَسِبْتُمْ أَن تُتْرَكُوا۟ وَلَمَّا يَعْلَمِ ٱللَّهُ ٱلَّذِينَ جَٰهَدُوا۟ مِنكُمْ وَلَمْ يَتَّخِذُوا۟ مِن دُونِ ٱللَّهِ وَلَا رَسُولِهِۦ وَلَا ٱلْمُؤْمِنِينَ وَلِيجَةًۭ ۚ وَٱللَّهُ خَبِيرٌۢ بِمَا تَعْمَلُونَ',
		number_in_surah: '16',
		page: '189',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1252',
		number: '1252',
		text: 'مَا كَانَ لِلْمُشْرِكِينَ أَن يَعْمُرُوا۟ مَسَٰجِدَ ٱللَّهِ شَٰهِدِينَ عَلَىٰٓ أَنفُسِهِم بِٱلْكُفْرِ ۚ أُو۟لَٰٓئِكَ حَبِطَتْ أَعْمَٰلُهُمْ وَفِى ٱلنَّارِ هُمْ خَٰلِدُونَ',
		number_in_surah: '17',
		page: '189',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1253',
		number: '1253',
		text: 'إِنَّمَا يَعْمُرُ مَسَٰجِدَ ٱللَّهِ مَنْ ءَامَنَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَأَقَامَ ٱلصَّلَوٰةَ وَءَاتَى ٱلزَّكَوٰةَ وَلَمْ يَخْشَ إِلَّا ٱللَّهَ ۖ فَعَسَىٰٓ أُو۟لَٰٓئِكَ أَن يَكُونُوا۟ مِنَ ٱلْمُهْتَدِينَ',
		number_in_surah: '18',
		page: '189',
		surah_id: '9',
		hizb_id: '75',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1254',
		number: '1254',
		text: '۞ أَجَعَلْتُمْ سِقَايَةَ ٱلْحَآجِّ وَعِمَارَةَ ٱلْمَسْجِدِ ٱلْحَرَامِ كَمَنْ ءَامَنَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَجَٰهَدَ فِى سَبِيلِ ٱللَّهِ ۚ لَا يَسْتَوُۥنَ عِندَ ٱللَّهِ ۗ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '19',
		page: '189',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1255',
		number: '1255',
		text: 'ٱلَّذِينَ ءَامَنُوا۟ وَهَاجَرُوا۟ وَجَٰهَدُوا۟ فِى سَبِيلِ ٱللَّهِ بِأَمْوَٰلِهِمْ وَأَنفُسِهِمْ أَعْظَمُ دَرَجَةً عِندَ ٱللَّهِ ۚ وَأُو۟لَٰٓئِكَ هُمُ ٱلْفَآئِزُونَ',
		number_in_surah: '20',
		page: '189',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1256',
		number: '1256',
		text: 'يُبَشِّرُهُمْ رَبُّهُم بِرَحْمَةٍۢ مِّنْهُ وَرِضْوَٰنٍۢ وَجَنَّٰتٍۢ لَّهُمْ فِيهَا نَعِيمٌۭ مُّقِيمٌ',
		number_in_surah: '21',
		page: '190',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1257',
		number: '1257',
		text: 'خَٰلِدِينَ فِيهَآ أَبَدًا ۚ إِنَّ ٱللَّهَ عِندَهُۥٓ أَجْرٌ عَظِيمٌۭ',
		number_in_surah: '22',
		page: '190',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1258',
		number: '1258',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَتَّخِذُوٓا۟ ءَابَآءَكُمْ وَإِخْوَٰنَكُمْ أَوْلِيَآءَ إِنِ ٱسْتَحَبُّوا۟ ٱلْكُفْرَ عَلَى ٱلْإِيمَٰنِ ۚ وَمَن يَتَوَلَّهُم مِّنكُمْ فَأُو۟لَٰٓئِكَ هُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '23',
		page: '190',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1259',
		number: '1259',
		text: 'قُلْ إِن كَانَ ءَابَآؤُكُمْ وَأَبْنَآؤُكُمْ وَإِخْوَٰنُكُمْ وَأَزْوَٰجُكُمْ وَعَشِيرَتُكُمْ وَأَمْوَٰلٌ ٱقْتَرَفْتُمُوهَا وَتِجَٰرَةٌۭ تَخْشَوْنَ كَسَادَهَا وَمَسَٰكِنُ تَرْضَوْنَهَآ أَحَبَّ إِلَيْكُم مِّنَ ٱللَّهِ وَرَسُولِهِۦ وَجِهَادٍۢ فِى سَبِيلِهِۦ فَتَرَبَّصُوا۟ حَتَّىٰ يَأْتِىَ ٱللَّهُ بِأَمْرِهِۦ ۗ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلْفَٰسِقِينَ',
		number_in_surah: '24',
		page: '190',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1260',
		number: '1260',
		text: 'لَقَدْ نَصَرَكُمُ ٱللَّهُ فِى مَوَاطِنَ كَثِيرَةٍۢ ۙ وَيَوْمَ حُنَيْنٍ ۙ إِذْ أَعْجَبَتْكُمْ كَثْرَتُكُمْ فَلَمْ تُغْنِ عَنكُمْ شَيْـًۭٔا وَضَاقَتْ عَلَيْكُمُ ٱلْأَرْضُ بِمَا رَحُبَتْ ثُمَّ وَلَّيْتُم مُّدْبِرِينَ',
		number_in_surah: '25',
		page: '190',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1261',
		number: '1261',
		text: 'ثُمَّ أَنزَلَ ٱللَّهُ سَكِينَتَهُۥ عَلَىٰ رَسُولِهِۦ وَعَلَى ٱلْمُؤْمِنِينَ وَأَنزَلَ جُنُودًۭا لَّمْ تَرَوْهَا وَعَذَّبَ ٱلَّذِينَ كَفَرُوا۟ ۚ وَذَٰلِكَ جَزَآءُ ٱلْكَٰفِرِينَ',
		number_in_surah: '26',
		page: '190',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1262',
		number: '1262',
		text: 'ثُمَّ يَتُوبُ ٱللَّهُ مِنۢ بَعْدِ ذَٰلِكَ عَلَىٰ مَن يَشَآءُ ۗ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '27',
		page: '191',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1263',
		number: '1263',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِنَّمَا ٱلْمُشْرِكُونَ نَجَسٌۭ فَلَا يَقْرَبُوا۟ ٱلْمَسْجِدَ ٱلْحَرَامَ بَعْدَ عَامِهِمْ هَٰذَا ۚ وَإِنْ خِفْتُمْ عَيْلَةًۭ فَسَوْفَ يُغْنِيكُمُ ٱللَّهُ مِن فَضْلِهِۦٓ إِن شَآءَ ۚ إِنَّ ٱللَّهَ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '28',
		page: '191',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1264',
		number: '1264',
		text: 'قَٰتِلُوا۟ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱللَّهِ وَلَا بِٱلْيَوْمِ ٱلْءَاخِرِ وَلَا يُحَرِّمُونَ مَا حَرَّمَ ٱللَّهُ وَرَسُولُهُۥ وَلَا يَدِينُونَ دِينَ ٱلْحَقِّ مِنَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ حَتَّىٰ يُعْطُوا۟ ٱلْجِزْيَةَ عَن يَدٍۢ وَهُمْ صَٰغِرُونَ',
		number_in_surah: '29',
		page: '191',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1265',
		number: '1265',
		text: 'وَقَالَتِ ٱلْيَهُودُ عُزَيْرٌ ٱبْنُ ٱللَّهِ وَقَالَتِ ٱلنَّصَٰرَى ٱلْمَسِيحُ ٱبْنُ ٱللَّهِ ۖ ذَٰلِكَ قَوْلُهُم بِأَفْوَٰهِهِمْ ۖ يُضَٰهِـُٔونَ قَوْلَ ٱلَّذِينَ كَفَرُوا۟ مِن قَبْلُ ۚ قَٰتَلَهُمُ ٱللَّهُ ۚ أَنَّىٰ يُؤْفَكُونَ',
		number_in_surah: '30',
		page: '191',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1266',
		number: '1266',
		text: 'ٱتَّخَذُوٓا۟ أَحْبَارَهُمْ وَرُهْبَٰنَهُمْ أَرْبَابًۭا مِّن دُونِ ٱللَّهِ وَٱلْمَسِيحَ ٱبْنَ مَرْيَمَ وَمَآ أُمِرُوٓا۟ إِلَّا لِيَعْبُدُوٓا۟ إِلَٰهًۭا وَٰحِدًۭا ۖ لَّآ إِلَٰهَ إِلَّا هُوَ ۚ سُبْحَٰنَهُۥ عَمَّا يُشْرِكُونَ',
		number_in_surah: '31',
		page: '191',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1267',
		number: '1267',
		text: 'يُرِيدُونَ أَن يُطْفِـُٔوا۟ نُورَ ٱللَّهِ بِأَفْوَٰهِهِمْ وَيَأْبَى ٱللَّهُ إِلَّآ أَن يُتِمَّ نُورَهُۥ وَلَوْ كَرِهَ ٱلْكَٰفِرُونَ',
		number_in_surah: '32',
		page: '192',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1268',
		number: '1268',
		text: 'هُوَ ٱلَّذِىٓ أَرْسَلَ رَسُولَهُۥ بِٱلْهُدَىٰ وَدِينِ ٱلْحَقِّ لِيُظْهِرَهُۥ عَلَى ٱلدِّينِ كُلِّهِۦ وَلَوْ كَرِهَ ٱلْمُشْرِكُونَ',
		number_in_surah: '33',
		page: '192',
		surah_id: '9',
		hizb_id: '76',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1269',
		number: '1269',
		text: '۞ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِنَّ كَثِيرًۭا مِّنَ ٱلْأَحْبَارِ وَٱلرُّهْبَانِ لَيَأْكُلُونَ أَمْوَٰلَ ٱلنَّاسِ بِٱلْبَٰطِلِ وَيَصُدُّونَ عَن سَبِيلِ ٱللَّهِ ۗ وَٱلَّذِينَ يَكْنِزُونَ ٱلذَّهَبَ وَٱلْفِضَّةَ وَلَا يُنفِقُونَهَا فِى سَبِيلِ ٱللَّهِ فَبَشِّرْهُم بِعَذَابٍ أَلِيمٍۢ',
		number_in_surah: '34',
		page: '192',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1270',
		number: '1270',
		text: 'يَوْمَ يُحْمَىٰ عَلَيْهَا فِى نَارِ جَهَنَّمَ فَتُكْوَىٰ بِهَا جِبَاهُهُمْ وَجُنُوبُهُمْ وَظُهُورُهُمْ ۖ هَٰذَا مَا كَنَزْتُمْ لِأَنفُسِكُمْ فَذُوقُوا۟ مَا كُنتُمْ تَكْنِزُونَ',
		number_in_surah: '35',
		page: '192',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1271',
		number: '1271',
		text: 'إِنَّ عِدَّةَ ٱلشُّهُورِ عِندَ ٱللَّهِ ٱثْنَا عَشَرَ شَهْرًۭا فِى كِتَٰبِ ٱللَّهِ يَوْمَ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ مِنْهَآ أَرْبَعَةٌ حُرُمٌۭ ۚ ذَٰلِكَ ٱلدِّينُ ٱلْقَيِّمُ ۚ فَلَا تَظْلِمُوا۟ فِيهِنَّ أَنفُسَكُمْ ۚ وَقَٰتِلُوا۟ ٱلْمُشْرِكِينَ كَآفَّةًۭ كَمَا يُقَٰتِلُونَكُمْ كَآفَّةًۭ ۚ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ مَعَ ٱلْمُتَّقِينَ',
		number_in_surah: '36',
		page: '192',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1272',
		number: '1272',
		text: 'إِنَّمَا ٱلنَّسِىٓءُ زِيَادَةٌۭ فِى ٱلْكُفْرِ ۖ يُضَلُّ بِهِ ٱلَّذِينَ كَفَرُوا۟ يُحِلُّونَهُۥ عَامًۭا وَيُحَرِّمُونَهُۥ عَامًۭا لِّيُوَاطِـُٔوا۟ عِدَّةَ مَا حَرَّمَ ٱللَّهُ فَيُحِلُّوا۟ مَا حَرَّمَ ٱللَّهُ ۚ زُيِّنَ لَهُمْ سُوٓءُ أَعْمَٰلِهِمْ ۗ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلْكَٰفِرِينَ',
		number_in_surah: '37',
		page: '193',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1273',
		number: '1273',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ مَا لَكُمْ إِذَا قِيلَ لَكُمُ ٱنفِرُوا۟ فِى سَبِيلِ ٱللَّهِ ٱثَّاقَلْتُمْ إِلَى ٱلْأَرْضِ ۚ أَرَضِيتُم بِٱلْحَيَوٰةِ ٱلدُّنْيَا مِنَ ٱلْءَاخِرَةِ ۚ فَمَا مَتَٰعُ ٱلْحَيَوٰةِ ٱلدُّنْيَا فِى ٱلْءَاخِرَةِ إِلَّا قَلِيلٌ',
		number_in_surah: '38',
		page: '193',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1274',
		number: '1274',
		text: 'إِلَّا تَنفِرُوا۟ يُعَذِّبْكُمْ عَذَابًا أَلِيمًۭا وَيَسْتَبْدِلْ قَوْمًا غَيْرَكُمْ وَلَا تَضُرُّوهُ شَيْـًۭٔا ۗ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '39',
		page: '193',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1275',
		number: '1275',
		text: 'إِلَّا تَنصُرُوهُ فَقَدْ نَصَرَهُ ٱللَّهُ إِذْ أَخْرَجَهُ ٱلَّذِينَ كَفَرُوا۟ ثَانِىَ ٱثْنَيْنِ إِذْ هُمَا فِى ٱلْغَارِ إِذْ يَقُولُ لِصَٰحِبِهِۦ لَا تَحْزَنْ إِنَّ ٱللَّهَ مَعَنَا ۖ فَأَنزَلَ ٱللَّهُ سَكِينَتَهُۥ عَلَيْهِ وَأَيَّدَهُۥ بِجُنُودٍۢ لَّمْ تَرَوْهَا وَجَعَلَ كَلِمَةَ ٱلَّذِينَ كَفَرُوا۟ ٱلسُّفْلَىٰ ۗ وَكَلِمَةُ ٱللَّهِ هِىَ ٱلْعُلْيَا ۗ وَٱللَّهُ عَزِيزٌ حَكِيمٌ',
		number_in_surah: '40',
		page: '193',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1276',
		number: '1276',
		text: 'ٱنفِرُوا۟ خِفَافًۭا وَثِقَالًۭا وَجَٰهِدُوا۟ بِأَمْوَٰلِكُمْ وَأَنفُسِكُمْ فِى سَبِيلِ ٱللَّهِ ۚ ذَٰلِكُمْ خَيْرٌۭ لَّكُمْ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '41',
		page: '194',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1277',
		number: '1277',
		text: 'لَوْ كَانَ عَرَضًۭا قَرِيبًۭا وَسَفَرًۭا قَاصِدًۭا لَّٱتَّبَعُوكَ وَلَٰكِنۢ بَعُدَتْ عَلَيْهِمُ ٱلشُّقَّةُ ۚ وَسَيَحْلِفُونَ بِٱللَّهِ لَوِ ٱسْتَطَعْنَا لَخَرَجْنَا مَعَكُمْ يُهْلِكُونَ أَنفُسَهُمْ وَٱللَّهُ يَعْلَمُ إِنَّهُمْ لَكَٰذِبُونَ',
		number_in_surah: '42',
		page: '194',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1278',
		number: '1278',
		text: 'عَفَا ٱللَّهُ عَنكَ لِمَ أَذِنتَ لَهُمْ حَتَّىٰ يَتَبَيَّنَ لَكَ ٱلَّذِينَ صَدَقُوا۟ وَتَعْلَمَ ٱلْكَٰذِبِينَ',
		number_in_surah: '43',
		page: '194',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1279',
		number: '1279',
		text: 'لَا يَسْتَـْٔذِنُكَ ٱلَّذِينَ يُؤْمِنُونَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ أَن يُجَٰهِدُوا۟ بِأَمْوَٰلِهِمْ وَأَنفُسِهِمْ ۗ وَٱللَّهُ عَلِيمٌۢ بِٱلْمُتَّقِينَ',
		number_in_surah: '44',
		page: '194',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1280',
		number: '1280',
		text: 'إِنَّمَا يَسْتَـْٔذِنُكَ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَٱرْتَابَتْ قُلُوبُهُمْ فَهُمْ فِى رَيْبِهِمْ يَتَرَدَّدُونَ',
		number_in_surah: '45',
		page: '194',
		surah_id: '9',
		hizb_id: '77',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1281',
		number: '1281',
		text: '۞ وَلَوْ أَرَادُوا۟ ٱلْخُرُوجَ لَأَعَدُّوا۟ لَهُۥ عُدَّةًۭ وَلَٰكِن كَرِهَ ٱللَّهُ ٱنۢبِعَاثَهُمْ فَثَبَّطَهُمْ وَقِيلَ ٱقْعُدُوا۟ مَعَ ٱلْقَٰعِدِينَ',
		number_in_surah: '46',
		page: '194',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1282',
		number: '1282',
		text: 'لَوْ خَرَجُوا۟ فِيكُم مَّا زَادُوكُمْ إِلَّا خَبَالًۭا وَلَأَوْضَعُوا۟ خِلَٰلَكُمْ يَبْغُونَكُمُ ٱلْفِتْنَةَ وَفِيكُمْ سَمَّٰعُونَ لَهُمْ ۗ وَٱللَّهُ عَلِيمٌۢ بِٱلظَّٰلِمِينَ',
		number_in_surah: '47',
		page: '194',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1283',
		number: '1283',
		text: 'لَقَدِ ٱبْتَغَوُا۟ ٱلْفِتْنَةَ مِن قَبْلُ وَقَلَّبُوا۟ لَكَ ٱلْأُمُورَ حَتَّىٰ جَآءَ ٱلْحَقُّ وَظَهَرَ أَمْرُ ٱللَّهِ وَهُمْ كَٰرِهُونَ',
		number_in_surah: '48',
		page: '195',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1284',
		number: '1284',
		text: 'وَمِنْهُم مَّن يَقُولُ ٱئْذَن لِّى وَلَا تَفْتِنِّىٓ ۚ أَلَا فِى ٱلْفِتْنَةِ سَقَطُوا۟ ۗ وَإِنَّ جَهَنَّمَ لَمُحِيطَةٌۢ بِٱلْكَٰفِرِينَ',
		number_in_surah: '49',
		page: '195',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1285',
		number: '1285',
		text: 'إِن تُصِبْكَ حَسَنَةٌۭ تَسُؤْهُمْ ۖ وَإِن تُصِبْكَ مُصِيبَةٌۭ يَقُولُوا۟ قَدْ أَخَذْنَآ أَمْرَنَا مِن قَبْلُ وَيَتَوَلَّوا۟ وَّهُمْ فَرِحُونَ',
		number_in_surah: '50',
		page: '195',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1286',
		number: '1286',
		text: 'قُل لَّن يُصِيبَنَآ إِلَّا مَا كَتَبَ ٱللَّهُ لَنَا هُوَ مَوْلَىٰنَا ۚ وَعَلَى ٱللَّهِ فَلْيَتَوَكَّلِ ٱلْمُؤْمِنُونَ',
		number_in_surah: '51',
		page: '195',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1287',
		number: '1287',
		text: 'قُلْ هَلْ تَرَبَّصُونَ بِنَآ إِلَّآ إِحْدَى ٱلْحُسْنَيَيْنِ ۖ وَنَحْنُ نَتَرَبَّصُ بِكُمْ أَن يُصِيبَكُمُ ٱللَّهُ بِعَذَابٍۢ مِّنْ عِندِهِۦٓ أَوْ بِأَيْدِينَا ۖ فَتَرَبَّصُوٓا۟ إِنَّا مَعَكُم مُّتَرَبِّصُونَ',
		number_in_surah: '52',
		page: '195',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1288',
		number: '1288',
		text: 'قُلْ أَنفِقُوا۟ طَوْعًا أَوْ كَرْهًۭا لَّن يُتَقَبَّلَ مِنكُمْ ۖ إِنَّكُمْ كُنتُمْ قَوْمًۭا فَٰسِقِينَ',
		number_in_surah: '53',
		page: '195',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1289',
		number: '1289',
		text: 'وَمَا مَنَعَهُمْ أَن تُقْبَلَ مِنْهُمْ نَفَقَٰتُهُمْ إِلَّآ أَنَّهُمْ كَفَرُوا۟ بِٱللَّهِ وَبِرَسُولِهِۦ وَلَا يَأْتُونَ ٱلصَّلَوٰةَ إِلَّا وَهُمْ كُسَالَىٰ وَلَا يُنفِقُونَ إِلَّا وَهُمْ كَٰرِهُونَ',
		number_in_surah: '54',
		page: '195',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1290',
		number: '1290',
		text: 'فَلَا تُعْجِبْكَ أَمْوَٰلُهُمْ وَلَآ أَوْلَٰدُهُمْ ۚ إِنَّمَا يُرِيدُ ٱللَّهُ لِيُعَذِّبَهُم بِهَا فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا وَتَزْهَقَ أَنفُسُهُمْ وَهُمْ كَٰفِرُونَ',
		number_in_surah: '55',
		page: '196',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1291',
		number: '1291',
		text: 'وَيَحْلِفُونَ بِٱللَّهِ إِنَّهُمْ لَمِنكُمْ وَمَا هُم مِّنكُمْ وَلَٰكِنَّهُمْ قَوْمٌۭ يَفْرَقُونَ',
		number_in_surah: '56',
		page: '196',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1292',
		number: '1292',
		text: 'لَوْ يَجِدُونَ مَلْجَـًٔا أَوْ مَغَٰرَٰتٍ أَوْ مُدَّخَلًۭا لَّوَلَّوْا۟ إِلَيْهِ وَهُمْ يَجْمَحُونَ',
		number_in_surah: '57',
		page: '196',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1293',
		number: '1293',
		text: 'وَمِنْهُم مَّن يَلْمِزُكَ فِى ٱلصَّدَقَٰتِ فَإِنْ أُعْطُوا۟ مِنْهَا رَضُوا۟ وَإِن لَّمْ يُعْطَوْا۟ مِنْهَآ إِذَا هُمْ يَسْخَطُونَ',
		number_in_surah: '58',
		page: '196',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1294',
		number: '1294',
		text: 'وَلَوْ أَنَّهُمْ رَضُوا۟ مَآ ءَاتَىٰهُمُ ٱللَّهُ وَرَسُولُهُۥ وَقَالُوا۟ حَسْبُنَا ٱللَّهُ سَيُؤْتِينَا ٱللَّهُ مِن فَضْلِهِۦ وَرَسُولُهُۥٓ إِنَّآ إِلَى ٱللَّهِ رَٰغِبُونَ',
		number_in_surah: '59',
		page: '196',
		surah_id: '9',
		hizb_id: '78',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1295',
		number: '1295',
		text: '۞ إِنَّمَا ٱلصَّدَقَٰتُ لِلْفُقَرَآءِ وَٱلْمَسَٰكِينِ وَٱلْعَٰمِلِينَ عَلَيْهَا وَٱلْمُؤَلَّفَةِ قُلُوبُهُمْ وَفِى ٱلرِّقَابِ وَٱلْغَٰرِمِينَ وَفِى سَبِيلِ ٱللَّهِ وَٱبْنِ ٱلسَّبِيلِ ۖ فَرِيضَةًۭ مِّنَ ٱللَّهِ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '60',
		page: '196',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1296',
		number: '1296',
		text: 'وَمِنْهُمُ ٱلَّذِينَ يُؤْذُونَ ٱلنَّبِىَّ وَيَقُولُونَ هُوَ أُذُنٌۭ ۚ قُلْ أُذُنُ خَيْرٍۢ لَّكُمْ يُؤْمِنُ بِٱللَّهِ وَيُؤْمِنُ لِلْمُؤْمِنِينَ وَرَحْمَةٌۭ لِّلَّذِينَ ءَامَنُوا۟ مِنكُمْ ۚ وَٱلَّذِينَ يُؤْذُونَ رَسُولَ ٱللَّهِ لَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '61',
		page: '196',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1297',
		number: '1297',
		text: 'يَحْلِفُونَ بِٱللَّهِ لَكُمْ لِيُرْضُوكُمْ وَٱللَّهُ وَرَسُولُهُۥٓ أَحَقُّ أَن يُرْضُوهُ إِن كَانُوا۟ مُؤْمِنِينَ',
		number_in_surah: '62',
		page: '197',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1298',
		number: '1298',
		text: 'أَلَمْ يَعْلَمُوٓا۟ أَنَّهُۥ مَن يُحَادِدِ ٱللَّهَ وَرَسُولَهُۥ فَأَنَّ لَهُۥ نَارَ جَهَنَّمَ خَٰلِدًۭا فِيهَا ۚ ذَٰلِكَ ٱلْخِزْىُ ٱلْعَظِيمُ',
		number_in_surah: '63',
		page: '197',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1299',
		number: '1299',
		text: 'يَحْذَرُ ٱلْمُنَٰفِقُونَ أَن تُنَزَّلَ عَلَيْهِمْ سُورَةٌۭ تُنَبِّئُهُم بِمَا فِى قُلُوبِهِمْ ۚ قُلِ ٱسْتَهْزِءُوٓا۟ إِنَّ ٱللَّهَ مُخْرِجٌۭ مَّا تَحْذَرُونَ',
		number_in_surah: '64',
		page: '197',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1300',
		number: '1300',
		text: 'وَلَئِن سَأَلْتَهُمْ لَيَقُولُنَّ إِنَّمَا كُنَّا نَخُوضُ وَنَلْعَبُ ۚ قُلْ أَبِٱللَّهِ وَءَايَٰتِهِۦ وَرَسُولِهِۦ كُنتُمْ تَسْتَهْزِءُونَ',
		number_in_surah: '65',
		page: '197',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1301',
		number: '1301',
		text: 'لَا تَعْتَذِرُوا۟ قَدْ كَفَرْتُم بَعْدَ إِيمَٰنِكُمْ ۚ إِن نَّعْفُ عَن طَآئِفَةٍۢ مِّنكُمْ نُعَذِّبْ طَآئِفَةًۢ بِأَنَّهُمْ كَانُوا۟ مُجْرِمِينَ',
		number_in_surah: '66',
		page: '197',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1302',
		number: '1302',
		text: 'ٱلْمُنَٰفِقُونَ وَٱلْمُنَٰفِقَٰتُ بَعْضُهُم مِّنۢ بَعْضٍۢ ۚ يَأْمُرُونَ بِٱلْمُنكَرِ وَيَنْهَوْنَ عَنِ ٱلْمَعْرُوفِ وَيَقْبِضُونَ أَيْدِيَهُمْ ۚ نَسُوا۟ ٱللَّهَ فَنَسِيَهُمْ ۗ إِنَّ ٱلْمُنَٰفِقِينَ هُمُ ٱلْفَٰسِقُونَ',
		number_in_surah: '67',
		page: '197',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1303',
		number: '1303',
		text: 'وَعَدَ ٱللَّهُ ٱلْمُنَٰفِقِينَ وَٱلْمُنَٰفِقَٰتِ وَٱلْكُفَّارَ نَارَ جَهَنَّمَ خَٰلِدِينَ فِيهَا ۚ هِىَ حَسْبُهُمْ ۚ وَلَعَنَهُمُ ٱللَّهُ ۖ وَلَهُمْ عَذَابٌۭ مُّقِيمٌۭ',
		number_in_surah: '68',
		page: '197',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1304',
		number: '1304',
		text: 'كَٱلَّذِينَ مِن قَبْلِكُمْ كَانُوٓا۟ أَشَدَّ مِنكُمْ قُوَّةًۭ وَأَكْثَرَ أَمْوَٰلًۭا وَأَوْلَٰدًۭا فَٱسْتَمْتَعُوا۟ بِخَلَٰقِهِمْ فَٱسْتَمْتَعْتُم بِخَلَٰقِكُمْ كَمَا ٱسْتَمْتَعَ ٱلَّذِينَ مِن قَبْلِكُم بِخَلَٰقِهِمْ وَخُضْتُمْ كَٱلَّذِى خَاضُوٓا۟ ۚ أُو۟لَٰٓئِكَ حَبِطَتْ أَعْمَٰلُهُمْ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '69',
		page: '198',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1305',
		number: '1305',
		text: 'أَلَمْ يَأْتِهِمْ نَبَأُ ٱلَّذِينَ مِن قَبْلِهِمْ قَوْمِ نُوحٍۢ وَعَادٍۢ وَثَمُودَ وَقَوْمِ إِبْرَٰهِيمَ وَأَصْحَٰبِ مَدْيَنَ وَٱلْمُؤْتَفِكَٰتِ ۚ أَتَتْهُمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ ۖ فَمَا كَانَ ٱللَّهُ لِيَظْلِمَهُمْ وَلَٰكِن كَانُوٓا۟ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '70',
		page: '198',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1306',
		number: '1306',
		text: 'وَٱلْمُؤْمِنُونَ وَٱلْمُؤْمِنَٰتُ بَعْضُهُمْ أَوْلِيَآءُ بَعْضٍۢ ۚ يَأْمُرُونَ بِٱلْمَعْرُوفِ وَيَنْهَوْنَ عَنِ ٱلْمُنكَرِ وَيُقِيمُونَ ٱلصَّلَوٰةَ وَيُؤْتُونَ ٱلزَّكَوٰةَ وَيُطِيعُونَ ٱللَّهَ وَرَسُولَهُۥٓ ۚ أُو۟لَٰٓئِكَ سَيَرْحَمُهُمُ ٱللَّهُ ۗ إِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '71',
		page: '198',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1307',
		number: '1307',
		text: 'وَعَدَ ٱللَّهُ ٱلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا وَمَسَٰكِنَ طَيِّبَةًۭ فِى جَنَّٰتِ عَدْنٍۢ ۚ وَرِضْوَٰنٌۭ مِّنَ ٱللَّهِ أَكْبَرُ ۚ ذَٰلِكَ هُوَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '72',
		page: '198',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1308',
		number: '1308',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ جَٰهِدِ ٱلْكُفَّارَ وَٱلْمُنَٰفِقِينَ وَٱغْلُظْ عَلَيْهِمْ ۚ وَمَأْوَىٰهُمْ جَهَنَّمُ ۖ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '73',
		page: '199',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1309',
		number: '1309',
		text: 'يَحْلِفُونَ بِٱللَّهِ مَا قَالُوا۟ وَلَقَدْ قَالُوا۟ كَلِمَةَ ٱلْكُفْرِ وَكَفَرُوا۟ بَعْدَ إِسْلَٰمِهِمْ وَهَمُّوا۟ بِمَا لَمْ يَنَالُوا۟ ۚ وَمَا نَقَمُوٓا۟ إِلَّآ أَنْ أَغْنَىٰهُمُ ٱللَّهُ وَرَسُولُهُۥ مِن فَضْلِهِۦ ۚ فَإِن يَتُوبُوا۟ يَكُ خَيْرًۭا لَّهُمْ ۖ وَإِن يَتَوَلَّوْا۟ يُعَذِّبْهُمُ ٱللَّهُ عَذَابًا أَلِيمًۭا فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ ۚ وَمَا لَهُمْ فِى ٱلْأَرْضِ مِن وَلِىٍّۢ وَلَا نَصِيرٍۢ',
		number_in_surah: '74',
		page: '199',
		surah_id: '9',
		hizb_id: '79',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1310',
		number: '1310',
		text: '۞ وَمِنْهُم مَّنْ عَٰهَدَ ٱللَّهَ لَئِنْ ءَاتَىٰنَا مِن فَضْلِهِۦ لَنَصَّدَّقَنَّ وَلَنَكُونَنَّ مِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '75',
		page: '199',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1311',
		number: '1311',
		text: 'فَلَمَّآ ءَاتَىٰهُم مِّن فَضْلِهِۦ بَخِلُوا۟ بِهِۦ وَتَوَلَّوا۟ وَّهُم مُّعْرِضُونَ',
		number_in_surah: '76',
		page: '199',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1312',
		number: '1312',
		text: 'فَأَعْقَبَهُمْ نِفَاقًۭا فِى قُلُوبِهِمْ إِلَىٰ يَوْمِ يَلْقَوْنَهُۥ بِمَآ أَخْلَفُوا۟ ٱللَّهَ مَا وَعَدُوهُ وَبِمَا كَانُوا۟ يَكْذِبُونَ',
		number_in_surah: '77',
		page: '199',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1313',
		number: '1313',
		text: 'أَلَمْ يَعْلَمُوٓا۟ أَنَّ ٱللَّهَ يَعْلَمُ سِرَّهُمْ وَنَجْوَىٰهُمْ وَأَنَّ ٱللَّهَ عَلَّٰمُ ٱلْغُيُوبِ',
		number_in_surah: '78',
		page: '199',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1314',
		number: '1314',
		text: 'ٱلَّذِينَ يَلْمِزُونَ ٱلْمُطَّوِّعِينَ مِنَ ٱلْمُؤْمِنِينَ فِى ٱلصَّدَقَٰتِ وَٱلَّذِينَ لَا يَجِدُونَ إِلَّا جُهْدَهُمْ فَيَسْخَرُونَ مِنْهُمْ ۙ سَخِرَ ٱللَّهُ مِنْهُمْ وَلَهُمْ عَذَابٌ أَلِيمٌ',
		number_in_surah: '79',
		page: '199',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1315',
		number: '1315',
		text: 'ٱسْتَغْفِرْ لَهُمْ أَوْ لَا تَسْتَغْفِرْ لَهُمْ إِن تَسْتَغْفِرْ لَهُمْ سَبْعِينَ مَرَّةًۭ فَلَن يَغْفِرَ ٱللَّهُ لَهُمْ ۚ ذَٰلِكَ بِأَنَّهُمْ كَفَرُوا۟ بِٱللَّهِ وَرَسُولِهِۦ ۗ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلْفَٰسِقِينَ',
		number_in_surah: '80',
		page: '200',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1316',
		number: '1316',
		text: 'فَرِحَ ٱلْمُخَلَّفُونَ بِمَقْعَدِهِمْ خِلَٰفَ رَسُولِ ٱللَّهِ وَكَرِهُوٓا۟ أَن يُجَٰهِدُوا۟ بِأَمْوَٰلِهِمْ وَأَنفُسِهِمْ فِى سَبِيلِ ٱللَّهِ وَقَالُوا۟ لَا تَنفِرُوا۟ فِى ٱلْحَرِّ ۗ قُلْ نَارُ جَهَنَّمَ أَشَدُّ حَرًّۭا ۚ لَّوْ كَانُوا۟ يَفْقَهُونَ',
		number_in_surah: '81',
		page: '200',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1317',
		number: '1317',
		text: 'فَلْيَضْحَكُوا۟ قَلِيلًۭا وَلْيَبْكُوا۟ كَثِيرًۭا جَزَآءًۢ بِمَا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '82',
		page: '200',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1318',
		number: '1318',
		text: 'فَإِن رَّجَعَكَ ٱللَّهُ إِلَىٰ طَآئِفَةٍۢ مِّنْهُمْ فَٱسْتَـْٔذَنُوكَ لِلْخُرُوجِ فَقُل لَّن تَخْرُجُوا۟ مَعِىَ أَبَدًۭا وَلَن تُقَٰتِلُوا۟ مَعِىَ عَدُوًّا ۖ إِنَّكُمْ رَضِيتُم بِٱلْقُعُودِ أَوَّلَ مَرَّةٍۢ فَٱقْعُدُوا۟ مَعَ ٱلْخَٰلِفِينَ',
		number_in_surah: '83',
		page: '200',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1319',
		number: '1319',
		text: 'وَلَا تُصَلِّ عَلَىٰٓ أَحَدٍۢ مِّنْهُم مَّاتَ أَبَدًۭا وَلَا تَقُمْ عَلَىٰ قَبْرِهِۦٓ ۖ إِنَّهُمْ كَفَرُوا۟ بِٱللَّهِ وَرَسُولِهِۦ وَمَاتُوا۟ وَهُمْ فَٰسِقُونَ',
		number_in_surah: '84',
		page: '200',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1320',
		number: '1320',
		text: 'وَلَا تُعْجِبْكَ أَمْوَٰلُهُمْ وَأَوْلَٰدُهُمْ ۚ إِنَّمَا يُرِيدُ ٱللَّهُ أَن يُعَذِّبَهُم بِهَا فِى ٱلدُّنْيَا وَتَزْهَقَ أَنفُسُهُمْ وَهُمْ كَٰفِرُونَ',
		number_in_surah: '85',
		page: '200',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1321',
		number: '1321',
		text: 'وَإِذَآ أُنزِلَتْ سُورَةٌ أَنْ ءَامِنُوا۟ بِٱللَّهِ وَجَٰهِدُوا۟ مَعَ رَسُولِهِ ٱسْتَـْٔذَنَكَ أُو۟لُوا۟ ٱلطَّوْلِ مِنْهُمْ وَقَالُوا۟ ذَرْنَا نَكُن مَّعَ ٱلْقَٰعِدِينَ',
		number_in_surah: '86',
		page: '200',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1322',
		number: '1322',
		text: 'رَضُوا۟ بِأَن يَكُونُوا۟ مَعَ ٱلْخَوَالِفِ وَطُبِعَ عَلَىٰ قُلُوبِهِمْ فَهُمْ لَا يَفْقَهُونَ',
		number_in_surah: '87',
		page: '201',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1323',
		number: '1323',
		text: 'لَٰكِنِ ٱلرَّسُولُ وَٱلَّذِينَ ءَامَنُوا۟ مَعَهُۥ جَٰهَدُوا۟ بِأَمْوَٰلِهِمْ وَأَنفُسِهِمْ ۚ وَأُو۟لَٰٓئِكَ لَهُمُ ٱلْخَيْرَٰتُ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '88',
		page: '201',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1324',
		number: '1324',
		text: 'أَعَدَّ ٱللَّهُ لَهُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا ۚ ذَٰلِكَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '89',
		page: '201',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1325',
		number: '1325',
		text: 'وَجَآءَ ٱلْمُعَذِّرُونَ مِنَ ٱلْأَعْرَابِ لِيُؤْذَنَ لَهُمْ وَقَعَدَ ٱلَّذِينَ كَذَبُوا۟ ٱللَّهَ وَرَسُولَهُۥ ۚ سَيُصِيبُ ٱلَّذِينَ كَفَرُوا۟ مِنْهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '90',
		page: '201',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1326',
		number: '1326',
		text: 'لَّيْسَ عَلَى ٱلضُّعَفَآءِ وَلَا عَلَى ٱلْمَرْضَىٰ وَلَا عَلَى ٱلَّذِينَ لَا يَجِدُونَ مَا يُنفِقُونَ حَرَجٌ إِذَا نَصَحُوا۟ لِلَّهِ وَرَسُولِهِۦ ۚ مَا عَلَى ٱلْمُحْسِنِينَ مِن سَبِيلٍۢ ۚ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '91',
		page: '201',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1327',
		number: '1327',
		text: 'وَلَا عَلَى ٱلَّذِينَ إِذَا مَآ أَتَوْكَ لِتَحْمِلَهُمْ قُلْتَ لَآ أَجِدُ مَآ أَحْمِلُكُمْ عَلَيْهِ تَوَلَّوا۟ وَّأَعْيُنُهُمْ تَفِيضُ مِنَ ٱلدَّمْعِ حَزَنًا أَلَّا يَجِدُوا۟ مَا يُنفِقُونَ',
		number_in_surah: '92',
		page: '201',
		surah_id: '9',
		hizb_id: '80',
		juz_id: '10',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1328',
		number: '1328',
		text: '۞ إِنَّمَا ٱلسَّبِيلُ عَلَى ٱلَّذِينَ يَسْتَـْٔذِنُونَكَ وَهُمْ أَغْنِيَآءُ ۚ رَضُوا۟ بِأَن يَكُونُوا۟ مَعَ ٱلْخَوَالِفِ وَطَبَعَ ٱللَّهُ عَلَىٰ قُلُوبِهِمْ فَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '93',
		page: '201',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1329',
		number: '1329',
		text: 'يَعْتَذِرُونَ إِلَيْكُمْ إِذَا رَجَعْتُمْ إِلَيْهِمْ ۚ قُل لَّا تَعْتَذِرُوا۟ لَن نُّؤْمِنَ لَكُمْ قَدْ نَبَّأَنَا ٱللَّهُ مِنْ أَخْبَارِكُمْ ۚ وَسَيَرَى ٱللَّهُ عَمَلَكُمْ وَرَسُولُهُۥ ثُمَّ تُرَدُّونَ إِلَىٰ عَٰلِمِ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ فَيُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '94',
		page: '202',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1330',
		number: '1330',
		text: 'سَيَحْلِفُونَ بِٱللَّهِ لَكُمْ إِذَا ٱنقَلَبْتُمْ إِلَيْهِمْ لِتُعْرِضُوا۟ عَنْهُمْ ۖ فَأَعْرِضُوا۟ عَنْهُمْ ۖ إِنَّهُمْ رِجْسٌۭ ۖ وَمَأْوَىٰهُمْ جَهَنَّمُ جَزَآءًۢ بِمَا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '95',
		page: '202',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1331',
		number: '1331',
		text: 'يَحْلِفُونَ لَكُمْ لِتَرْضَوْا۟ عَنْهُمْ ۖ فَإِن تَرْضَوْا۟ عَنْهُمْ فَإِنَّ ٱللَّهَ لَا يَرْضَىٰ عَنِ ٱلْقَوْمِ ٱلْفَٰسِقِينَ',
		number_in_surah: '96',
		page: '202',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1332',
		number: '1332',
		text: 'ٱلْأَعْرَابُ أَشَدُّ كُفْرًۭا وَنِفَاقًۭا وَأَجْدَرُ أَلَّا يَعْلَمُوا۟ حُدُودَ مَآ أَنزَلَ ٱللَّهُ عَلَىٰ رَسُولِهِۦ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '97',
		page: '202',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1333',
		number: '1333',
		text: 'وَمِنَ ٱلْأَعْرَابِ مَن يَتَّخِذُ مَا يُنفِقُ مَغْرَمًۭا وَيَتَرَبَّصُ بِكُمُ ٱلدَّوَآئِرَ ۚ عَلَيْهِمْ دَآئِرَةُ ٱلسَّوْءِ ۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '98',
		page: '202',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1334',
		number: '1334',
		text: 'وَمِنَ ٱلْأَعْرَابِ مَن يُؤْمِنُ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ وَيَتَّخِذُ مَا يُنفِقُ قُرُبَٰتٍ عِندَ ٱللَّهِ وَصَلَوَٰتِ ٱلرَّسُولِ ۚ أَلَآ إِنَّهَا قُرْبَةٌۭ لَّهُمْ ۚ سَيُدْخِلُهُمُ ٱللَّهُ فِى رَحْمَتِهِۦٓ ۗ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '99',
		page: '202',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1335',
		number: '1335',
		text: 'وَٱلسَّٰبِقُونَ ٱلْأَوَّلُونَ مِنَ ٱلْمُهَٰجِرِينَ وَٱلْأَنصَارِ وَٱلَّذِينَ ٱتَّبَعُوهُم بِإِحْسَٰنٍۢ رَّضِىَ ٱللَّهُ عَنْهُمْ وَرَضُوا۟ عَنْهُ وَأَعَدَّ لَهُمْ جَنَّٰتٍۢ تَجْرِى تَحْتَهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدًۭا ۚ ذَٰلِكَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '100',
		page: '203',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1336',
		number: '1336',
		text: 'وَمِمَّنْ حَوْلَكُم مِّنَ ٱلْأَعْرَابِ مُنَٰفِقُونَ ۖ وَمِنْ أَهْلِ ٱلْمَدِينَةِ ۖ مَرَدُوا۟ عَلَى ٱلنِّفَاقِ لَا تَعْلَمُهُمْ ۖ نَحْنُ نَعْلَمُهُمْ ۚ سَنُعَذِّبُهُم مَّرَّتَيْنِ ثُمَّ يُرَدُّونَ إِلَىٰ عَذَابٍ عَظِيمٍۢ',
		number_in_surah: '101',
		page: '203',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1337',
		number: '1337',
		text: 'وَءَاخَرُونَ ٱعْتَرَفُوا۟ بِذُنُوبِهِمْ خَلَطُوا۟ عَمَلًۭا صَٰلِحًۭا وَءَاخَرَ سَيِّئًا عَسَى ٱللَّهُ أَن يَتُوبَ عَلَيْهِمْ ۚ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '102',
		page: '203',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1338',
		number: '1338',
		text: 'خُذْ مِنْ أَمْوَٰلِهِمْ صَدَقَةًۭ تُطَهِّرُهُمْ وَتُزَكِّيهِم بِهَا وَصَلِّ عَلَيْهِمْ ۖ إِنَّ صَلَوٰتَكَ سَكَنٌۭ لَّهُمْ ۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌ',
		number_in_surah: '103',
		page: '203',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1339',
		number: '1339',
		text: 'أَلَمْ يَعْلَمُوٓا۟ أَنَّ ٱللَّهَ هُوَ يَقْبَلُ ٱلتَّوْبَةَ عَنْ عِبَادِهِۦ وَيَأْخُذُ ٱلصَّدَقَٰتِ وَأَنَّ ٱللَّهَ هُوَ ٱلتَّوَّابُ ٱلرَّحِيمُ',
		number_in_surah: '104',
		page: '203',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1340',
		number: '1340',
		text: 'وَقُلِ ٱعْمَلُوا۟ فَسَيَرَى ٱللَّهُ عَمَلَكُمْ وَرَسُولُهُۥ وَٱلْمُؤْمِنُونَ ۖ وَسَتُرَدُّونَ إِلَىٰ عَٰلِمِ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ فَيُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '105',
		page: '203',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1341',
		number: '1341',
		text: 'وَءَاخَرُونَ مُرْجَوْنَ لِأَمْرِ ٱللَّهِ إِمَّا يُعَذِّبُهُمْ وَإِمَّا يَتُوبُ عَلَيْهِمْ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '106',
		page: '203',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1342',
		number: '1342',
		text: 'وَٱلَّذِينَ ٱتَّخَذُوا۟ مَسْجِدًۭا ضِرَارًۭا وَكُفْرًۭا وَتَفْرِيقًۢا بَيْنَ ٱلْمُؤْمِنِينَ وَإِرْصَادًۭا لِّمَنْ حَارَبَ ٱللَّهَ وَرَسُولَهُۥ مِن قَبْلُ ۚ وَلَيَحْلِفُنَّ إِنْ أَرَدْنَآ إِلَّا ٱلْحُسْنَىٰ ۖ وَٱللَّهُ يَشْهَدُ إِنَّهُمْ لَكَٰذِبُونَ',
		number_in_surah: '107',
		page: '204',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1343',
		number: '1343',
		text: 'لَا تَقُمْ فِيهِ أَبَدًۭا ۚ لَّمَسْجِدٌ أُسِّسَ عَلَى ٱلتَّقْوَىٰ مِنْ أَوَّلِ يَوْمٍ أَحَقُّ أَن تَقُومَ فِيهِ ۚ فِيهِ رِجَالٌۭ يُحِبُّونَ أَن يَتَطَهَّرُوا۟ ۚ وَٱللَّهُ يُحِبُّ ٱلْمُطَّهِّرِينَ',
		number_in_surah: '108',
		page: '204',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1344',
		number: '1344',
		text: 'أَفَمَنْ أَسَّسَ بُنْيَٰنَهُۥ عَلَىٰ تَقْوَىٰ مِنَ ٱللَّهِ وَرِضْوَٰنٍ خَيْرٌ أَم مَّنْ أَسَّسَ بُنْيَٰنَهُۥ عَلَىٰ شَفَا جُرُفٍ هَارٍۢ فَٱنْهَارَ بِهِۦ فِى نَارِ جَهَنَّمَ ۗ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '109',
		page: '204',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1345',
		number: '1345',
		text: 'لَا يَزَالُ بُنْيَٰنُهُمُ ٱلَّذِى بَنَوْا۟ رِيبَةًۭ فِى قُلُوبِهِمْ إِلَّآ أَن تَقَطَّعَ قُلُوبُهُمْ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌ',
		number_in_surah: '110',
		page: '204',
		surah_id: '9',
		hizb_id: '81',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1346',
		number: '1346',
		text: '۞ إِنَّ ٱللَّهَ ٱشْتَرَىٰ مِنَ ٱلْمُؤْمِنِينَ أَنفُسَهُمْ وَأَمْوَٰلَهُم بِأَنَّ لَهُمُ ٱلْجَنَّةَ ۚ يُقَٰتِلُونَ فِى سَبِيلِ ٱللَّهِ فَيَقْتُلُونَ وَيُقْتَلُونَ ۖ وَعْدًا عَلَيْهِ حَقًّۭا فِى ٱلتَّوْرَىٰةِ وَٱلْإِنجِيلِ وَٱلْقُرْءَانِ ۚ وَمَنْ أَوْفَىٰ بِعَهْدِهِۦ مِنَ ٱللَّهِ ۚ فَٱسْتَبْشِرُوا۟ بِبَيْعِكُمُ ٱلَّذِى بَايَعْتُم بِهِۦ ۚ وَذَٰلِكَ هُوَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '111',
		page: '204',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1347',
		number: '1347',
		text: 'ٱلتَّٰٓئِبُونَ ٱلْعَٰبِدُونَ ٱلْحَٰمِدُونَ ٱلسَّٰٓئِحُونَ ٱلرَّٰكِعُونَ ٱلسَّٰجِدُونَ ٱلْءَامِرُونَ بِٱلْمَعْرُوفِ وَٱلنَّاهُونَ عَنِ ٱلْمُنكَرِ وَٱلْحَٰفِظُونَ لِحُدُودِ ٱللَّهِ ۗ وَبَشِّرِ ٱلْمُؤْمِنِينَ',
		number_in_surah: '112',
		page: '205',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1348',
		number: '1348',
		text: 'مَا كَانَ لِلنَّبِىِّ وَٱلَّذِينَ ءَامَنُوٓا۟ أَن يَسْتَغْفِرُوا۟ لِلْمُشْرِكِينَ وَلَوْ كَانُوٓا۟ أُو۟لِى قُرْبَىٰ مِنۢ بَعْدِ مَا تَبَيَّنَ لَهُمْ أَنَّهُمْ أَصْحَٰبُ ٱلْجَحِيمِ',
		number_in_surah: '113',
		page: '205',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1349',
		number: '1349',
		text: 'وَمَا كَانَ ٱسْتِغْفَارُ إِبْرَٰهِيمَ لِأَبِيهِ إِلَّا عَن مَّوْعِدَةٍۢ وَعَدَهَآ إِيَّاهُ فَلَمَّا تَبَيَّنَ لَهُۥٓ أَنَّهُۥ عَدُوٌّۭ لِّلَّهِ تَبَرَّأَ مِنْهُ ۚ إِنَّ إِبْرَٰهِيمَ لَأَوَّٰهٌ حَلِيمٌۭ',
		number_in_surah: '114',
		page: '205',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1350',
		number: '1350',
		text: 'وَمَا كَانَ ٱللَّهُ لِيُضِلَّ قَوْمًۢا بَعْدَ إِذْ هَدَىٰهُمْ حَتَّىٰ يُبَيِّنَ لَهُم مَّا يَتَّقُونَ ۚ إِنَّ ٱللَّهَ بِكُلِّ شَىْءٍ عَلِيمٌ',
		number_in_surah: '115',
		page: '205',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1351',
		number: '1351',
		text: 'إِنَّ ٱللَّهَ لَهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ يُحْىِۦ وَيُمِيتُ ۚ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِن وَلِىٍّۢ وَلَا نَصِيرٍۢ',
		number_in_surah: '116',
		page: '205',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1352',
		number: '1352',
		text: 'لَّقَد تَّابَ ٱللَّهُ عَلَى ٱلنَّبِىِّ وَٱلْمُهَٰجِرِينَ وَٱلْأَنصَارِ ٱلَّذِينَ ٱتَّبَعُوهُ فِى سَاعَةِ ٱلْعُسْرَةِ مِنۢ بَعْدِ مَا كَادَ يَزِيغُ قُلُوبُ فَرِيقٍۢ مِّنْهُمْ ثُمَّ تَابَ عَلَيْهِمْ ۚ إِنَّهُۥ بِهِمْ رَءُوفٌۭ رَّحِيمٌۭ',
		number_in_surah: '117',
		page: '205',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1353',
		number: '1353',
		text: 'وَعَلَى ٱلثَّلَٰثَةِ ٱلَّذِينَ خُلِّفُوا۟ حَتَّىٰٓ إِذَا ضَاقَتْ عَلَيْهِمُ ٱلْأَرْضُ بِمَا رَحُبَتْ وَضَاقَتْ عَلَيْهِمْ أَنفُسُهُمْ وَظَنُّوٓا۟ أَن لَّا مَلْجَأَ مِنَ ٱللَّهِ إِلَّآ إِلَيْهِ ثُمَّ تَابَ عَلَيْهِمْ لِيَتُوبُوٓا۟ ۚ إِنَّ ٱللَّهَ هُوَ ٱلتَّوَّابُ ٱلرَّحِيمُ',
		number_in_surah: '118',
		page: '206',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1354',
		number: '1354',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱتَّقُوا۟ ٱللَّهَ وَكُونُوا۟ مَعَ ٱلصَّٰدِقِينَ',
		number_in_surah: '119',
		page: '206',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1355',
		number: '1355',
		text: 'مَا كَانَ لِأَهْلِ ٱلْمَدِينَةِ وَمَنْ حَوْلَهُم مِّنَ ٱلْأَعْرَابِ أَن يَتَخَلَّفُوا۟ عَن رَّسُولِ ٱللَّهِ وَلَا يَرْغَبُوا۟ بِأَنفُسِهِمْ عَن نَّفْسِهِۦ ۚ ذَٰلِكَ بِأَنَّهُمْ لَا يُصِيبُهُمْ ظَمَأٌۭ وَلَا نَصَبٌۭ وَلَا مَخْمَصَةٌۭ فِى سَبِيلِ ٱللَّهِ وَلَا يَطَـُٔونَ مَوْطِئًۭا يَغِيظُ ٱلْكُفَّارَ وَلَا يَنَالُونَ مِنْ عَدُوٍّۢ نَّيْلًا إِلَّا كُتِبَ لَهُم بِهِۦ عَمَلٌۭ صَٰلِحٌ ۚ إِنَّ ٱللَّهَ لَا يُضِيعُ أَجْرَ ٱلْمُحْسِنِينَ',
		number_in_surah: '120',
		page: '206',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1356',
		number: '1356',
		text: 'وَلَا يُنفِقُونَ نَفَقَةًۭ صَغِيرَةًۭ وَلَا كَبِيرَةًۭ وَلَا يَقْطَعُونَ وَادِيًا إِلَّا كُتِبَ لَهُمْ لِيَجْزِيَهُمُ ٱللَّهُ أَحْسَنَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '121',
		page: '206',
		surah_id: '9',
		hizb_id: '82',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1357',
		number: '1357',
		text: '۞ وَمَا كَانَ ٱلْمُؤْمِنُونَ لِيَنفِرُوا۟ كَآفَّةًۭ ۚ فَلَوْلَا نَفَرَ مِن كُلِّ فِرْقَةٍۢ مِّنْهُمْ طَآئِفَةٌۭ لِّيَتَفَقَّهُوا۟ فِى ٱلدِّينِ وَلِيُنذِرُوا۟ قَوْمَهُمْ إِذَا رَجَعُوٓا۟ إِلَيْهِمْ لَعَلَّهُمْ يَحْذَرُونَ',
		number_in_surah: '122',
		page: '206',
		surah_id: '9',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1358',
		number: '1358',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ قَٰتِلُوا۟ ٱلَّذِينَ يَلُونَكُم مِّنَ ٱلْكُفَّارِ وَلْيَجِدُوا۟ فِيكُمْ غِلْظَةًۭ ۚ وَٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ مَعَ ٱلْمُتَّقِينَ',
		number_in_surah: '123',
		page: '207',
		surah_id: '9',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1359',
		number: '1359',
		text: 'وَإِذَا مَآ أُنزِلَتْ سُورَةٌۭ فَمِنْهُم مَّن يَقُولُ أَيُّكُمْ زَادَتْهُ هَٰذِهِۦٓ إِيمَٰنًۭا ۚ فَأَمَّا ٱلَّذِينَ ءَامَنُوا۟ فَزَادَتْهُمْ إِيمَٰنًۭا وَهُمْ يَسْتَبْشِرُونَ',
		number_in_surah: '124',
		page: '207',
		surah_id: '9',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1360',
		number: '1360',
		text: 'وَأَمَّا ٱلَّذِينَ فِى قُلُوبِهِم مَّرَضٌۭ فَزَادَتْهُمْ رِجْسًا إِلَىٰ رِجْسِهِمْ وَمَاتُوا۟ وَهُمْ كَٰفِرُونَ',
		number_in_surah: '125',
		page: '207',
		surah_id: '9',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1361',
		number: '1361',
		text: 'أَوَلَا يَرَوْنَ أَنَّهُمْ يُفْتَنُونَ فِى كُلِّ عَامٍۢ مَّرَّةً أَوْ مَرَّتَيْنِ ثُمَّ لَا يَتُوبُونَ وَلَا هُمْ يَذَّكَّرُونَ',
		number_in_surah: '126',
		page: '207',
		surah_id: '9',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1362',
		number: '1362',
		text: 'وَإِذَا مَآ أُنزِلَتْ سُورَةٌۭ نَّظَرَ بَعْضُهُمْ إِلَىٰ بَعْضٍ هَلْ يَرَىٰكُم مِّنْ أَحَدٍۢ ثُمَّ ٱنصَرَفُوا۟ ۚ صَرَفَ ٱللَّهُ قُلُوبَهُم بِأَنَّهُمْ قَوْمٌۭ لَّا يَفْقَهُونَ',
		number_in_surah: '127',
		page: '207',
		surah_id: '9',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1363',
		number: '1363',
		text: 'لَقَدْ جَآءَكُمْ رَسُولٌۭ مِّنْ أَنفُسِكُمْ عَزِيزٌ عَلَيْهِ مَا عَنِتُّمْ حَرِيصٌ عَلَيْكُم بِٱلْمُؤْمِنِينَ رَءُوفٌۭ رَّحِيمٌۭ',
		number_in_surah: '128',
		page: '207',
		surah_id: '9',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1364',
		number: '1364',
		text: 'فَإِن تَوَلَّوْا۟ فَقُلْ حَسْبِىَ ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ۖ عَلَيْهِ تَوَكَّلْتُ ۖ وَهُوَ رَبُّ ٱلْعَرْشِ ٱلْعَظِيمِ',
		number_in_surah: '129',
		page: '207',
		surah_id: '9',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1365',
		number: '1365',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓر ۚ تِلْكَ ءَايَٰتُ ٱلْكِتَٰبِ ٱلْحَكِيمِ',
		number_in_surah: '1',
		page: '208',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1366',
		number: '1366',
		text: 'أَكَانَ لِلنَّاسِ عَجَبًا أَنْ أَوْحَيْنَآ إِلَىٰ رَجُلٍۢ مِّنْهُمْ أَنْ أَنذِرِ ٱلنَّاسَ وَبَشِّرِ ٱلَّذِينَ ءَامَنُوٓا۟ أَنَّ لَهُمْ قَدَمَ صِدْقٍ عِندَ رَبِّهِمْ ۗ قَالَ ٱلْكَٰفِرُونَ إِنَّ هَٰذَا لَسَٰحِرٌۭ مُّبِينٌ',
		number_in_surah: '2',
		page: '208',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1367',
		number: '1367',
		text: 'إِنَّ رَبَّكُمُ ٱللَّهُ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ فِى سِتَّةِ أَيَّامٍۢ ثُمَّ ٱسْتَوَىٰ عَلَى ٱلْعَرْشِ ۖ يُدَبِّرُ ٱلْأَمْرَ ۖ مَا مِن شَفِيعٍ إِلَّا مِنۢ بَعْدِ إِذْنِهِۦ ۚ ذَٰلِكُمُ ٱللَّهُ رَبُّكُمْ فَٱعْبُدُوهُ ۚ أَفَلَا تَذَكَّرُونَ',
		number_in_surah: '3',
		page: '208',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1368',
		number: '1368',
		text: 'إِلَيْهِ مَرْجِعُكُمْ جَمِيعًۭا ۖ وَعْدَ ٱللَّهِ حَقًّا ۚ إِنَّهُۥ يَبْدَؤُا۟ ٱلْخَلْقَ ثُمَّ يُعِيدُهُۥ لِيَجْزِىَ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ بِٱلْقِسْطِ ۚ وَٱلَّذِينَ كَفَرُوا۟ لَهُمْ شَرَابٌۭ مِّنْ حَمِيمٍۢ وَعَذَابٌ أَلِيمٌۢ بِمَا كَانُوا۟ يَكْفُرُونَ',
		number_in_surah: '4',
		page: '208',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1369',
		number: '1369',
		text: 'هُوَ ٱلَّذِى جَعَلَ ٱلشَّمْسَ ضِيَآءًۭ وَٱلْقَمَرَ نُورًۭا وَقَدَّرَهُۥ مَنَازِلَ لِتَعْلَمُوا۟ عَدَدَ ٱلسِّنِينَ وَٱلْحِسَابَ ۚ مَا خَلَقَ ٱللَّهُ ذَٰلِكَ إِلَّا بِٱلْحَقِّ ۚ يُفَصِّلُ ٱلْءَايَٰتِ لِقَوْمٍۢ يَعْلَمُونَ',
		number_in_surah: '5',
		page: '208',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1370',
		number: '1370',
		text: 'إِنَّ فِى ٱخْتِلَٰفِ ٱلَّيْلِ وَٱلنَّهَارِ وَمَا خَلَقَ ٱللَّهُ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَتَّقُونَ',
		number_in_surah: '6',
		page: '208',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1371',
		number: '1371',
		text: 'إِنَّ ٱلَّذِينَ لَا يَرْجُونَ لِقَآءَنَا وَرَضُوا۟ بِٱلْحَيَوٰةِ ٱلدُّنْيَا وَٱطْمَأَنُّوا۟ بِهَا وَٱلَّذِينَ هُمْ عَنْ ءَايَٰتِنَا غَٰفِلُونَ',
		number_in_surah: '7',
		page: '209',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1372',
		number: '1372',
		text: 'أُو۟لَٰٓئِكَ مَأْوَىٰهُمُ ٱلنَّارُ بِمَا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '8',
		page: '209',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1373',
		number: '1373',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ يَهْدِيهِمْ رَبُّهُم بِإِيمَٰنِهِمْ ۖ تَجْرِى مِن تَحْتِهِمُ ٱلْأَنْهَٰرُ فِى جَنَّٰتِ ٱلنَّعِيمِ',
		number_in_surah: '9',
		page: '209',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1374',
		number: '1374',
		text: 'دَعْوَىٰهُمْ فِيهَا سُبْحَٰنَكَ ٱللَّهُمَّ وَتَحِيَّتُهُمْ فِيهَا سَلَٰمٌۭ ۚ وَءَاخِرُ دَعْوَىٰهُمْ أَنِ ٱلْحَمْدُ لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '10',
		page: '209',
		surah_id: '10',
		hizb_id: '83',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1375',
		number: '1375',
		text: '۞ وَلَوْ يُعَجِّلُ ٱللَّهُ لِلنَّاسِ ٱلشَّرَّ ٱسْتِعْجَالَهُم بِٱلْخَيْرِ لَقُضِىَ إِلَيْهِمْ أَجَلُهُمْ ۖ فَنَذَرُ ٱلَّذِينَ لَا يَرْجُونَ لِقَآءَنَا فِى طُغْيَٰنِهِمْ يَعْمَهُونَ',
		number_in_surah: '11',
		page: '209',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1376',
		number: '1376',
		text: 'وَإِذَا مَسَّ ٱلْإِنسَٰنَ ٱلضُّرُّ دَعَانَا لِجَنۢبِهِۦٓ أَوْ قَاعِدًا أَوْ قَآئِمًۭا فَلَمَّا كَشَفْنَا عَنْهُ ضُرَّهُۥ مَرَّ كَأَن لَّمْ يَدْعُنَآ إِلَىٰ ضُرٍّۢ مَّسَّهُۥ ۚ كَذَٰلِكَ زُيِّنَ لِلْمُسْرِفِينَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '12',
		page: '209',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1377',
		number: '1377',
		text: 'وَلَقَدْ أَهْلَكْنَا ٱلْقُرُونَ مِن قَبْلِكُمْ لَمَّا ظَلَمُوا۟ ۙ وَجَآءَتْهُمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ وَمَا كَانُوا۟ لِيُؤْمِنُوا۟ ۚ كَذَٰلِكَ نَجْزِى ٱلْقَوْمَ ٱلْمُجْرِمِينَ',
		number_in_surah: '13',
		page: '209',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1378',
		number: '1378',
		text: 'ثُمَّ جَعَلْنَٰكُمْ خَلَٰٓئِفَ فِى ٱلْأَرْضِ مِنۢ بَعْدِهِمْ لِنَنظُرَ كَيْفَ تَعْمَلُونَ',
		number_in_surah: '14',
		page: '209',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1379',
		number: '1379',
		text: 'وَإِذَا تُتْلَىٰ عَلَيْهِمْ ءَايَاتُنَا بَيِّنَٰتٍۢ ۙ قَالَ ٱلَّذِينَ لَا يَرْجُونَ لِقَآءَنَا ٱئْتِ بِقُرْءَانٍ غَيْرِ هَٰذَآ أَوْ بَدِّلْهُ ۚ قُلْ مَا يَكُونُ لِىٓ أَنْ أُبَدِّلَهُۥ مِن تِلْقَآئِ نَفْسِىٓ ۖ إِنْ أَتَّبِعُ إِلَّا مَا يُوحَىٰٓ إِلَىَّ ۖ إِنِّىٓ أَخَافُ إِنْ عَصَيْتُ رَبِّى عَذَابَ يَوْمٍ عَظِيمٍۢ',
		number_in_surah: '15',
		page: '210',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1380',
		number: '1380',
		text: 'قُل لَّوْ شَآءَ ٱللَّهُ مَا تَلَوْتُهُۥ عَلَيْكُمْ وَلَآ أَدْرَىٰكُم بِهِۦ ۖ فَقَدْ لَبِثْتُ فِيكُمْ عُمُرًۭا مِّن قَبْلِهِۦٓ ۚ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '16',
		page: '210',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1381',
		number: '1381',
		text: 'فَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوْ كَذَّبَ بِـَٔايَٰتِهِۦٓ ۚ إِنَّهُۥ لَا يُفْلِحُ ٱلْمُجْرِمُونَ',
		number_in_surah: '17',
		page: '210',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1382',
		number: '1382',
		text: 'وَيَعْبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَضُرُّهُمْ وَلَا يَنفَعُهُمْ وَيَقُولُونَ هَٰٓؤُلَآءِ شُفَعَٰٓؤُنَا عِندَ ٱللَّهِ ۚ قُلْ أَتُنَبِّـُٔونَ ٱللَّهَ بِمَا لَا يَعْلَمُ فِى ٱلسَّمَٰوَٰتِ وَلَا فِى ٱلْأَرْضِ ۚ سُبْحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشْرِكُونَ',
		number_in_surah: '18',
		page: '210',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1383',
		number: '1383',
		text: 'وَمَا كَانَ ٱلنَّاسُ إِلَّآ أُمَّةًۭ وَٰحِدَةًۭ فَٱخْتَلَفُوا۟ ۚ وَلَوْلَا كَلِمَةٌۭ سَبَقَتْ مِن رَّبِّكَ لَقُضِىَ بَيْنَهُمْ فِيمَا فِيهِ يَخْتَلِفُونَ',
		number_in_surah: '19',
		page: '210',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1384',
		number: '1384',
		text: 'وَيَقُولُونَ لَوْلَآ أُنزِلَ عَلَيْهِ ءَايَةٌۭ مِّن رَّبِّهِۦ ۖ فَقُلْ إِنَّمَا ٱلْغَيْبُ لِلَّهِ فَٱنتَظِرُوٓا۟ إِنِّى مَعَكُم مِّنَ ٱلْمُنتَظِرِينَ',
		number_in_surah: '20',
		page: '210',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1385',
		number: '1385',
		text: 'وَإِذَآ أَذَقْنَا ٱلنَّاسَ رَحْمَةًۭ مِّنۢ بَعْدِ ضَرَّآءَ مَسَّتْهُمْ إِذَا لَهُم مَّكْرٌۭ فِىٓ ءَايَاتِنَا ۚ قُلِ ٱللَّهُ أَسْرَعُ مَكْرًا ۚ إِنَّ رُسُلَنَا يَكْتُبُونَ مَا تَمْكُرُونَ',
		number_in_surah: '21',
		page: '211',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1386',
		number: '1386',
		text: 'هُوَ ٱلَّذِى يُسَيِّرُكُمْ فِى ٱلْبَرِّ وَٱلْبَحْرِ ۖ حَتَّىٰٓ إِذَا كُنتُمْ فِى ٱلْفُلْكِ وَجَرَيْنَ بِهِم بِرِيحٍۢ طَيِّبَةٍۢ وَفَرِحُوا۟ بِهَا جَآءَتْهَا رِيحٌ عَاصِفٌۭ وَجَآءَهُمُ ٱلْمَوْجُ مِن كُلِّ مَكَانٍۢ وَظَنُّوٓا۟ أَنَّهُمْ أُحِيطَ بِهِمْ ۙ دَعَوُا۟ ٱللَّهَ مُخْلِصِينَ لَهُ ٱلدِّينَ لَئِنْ أَنجَيْتَنَا مِنْ هَٰذِهِۦ لَنَكُونَنَّ مِنَ ٱلشَّٰكِرِينَ',
		number_in_surah: '22',
		page: '211',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1387',
		number: '1387',
		text: 'فَلَمَّآ أَنجَىٰهُمْ إِذَا هُمْ يَبْغُونَ فِى ٱلْأَرْضِ بِغَيْرِ ٱلْحَقِّ ۗ يَٰٓأَيُّهَا ٱلنَّاسُ إِنَّمَا بَغْيُكُمْ عَلَىٰٓ أَنفُسِكُم ۖ مَّتَٰعَ ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ ثُمَّ إِلَيْنَا مَرْجِعُكُمْ فَنُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '23',
		page: '211',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1388',
		number: '1388',
		text: 'إِنَّمَا مَثَلُ ٱلْحَيَوٰةِ ٱلدُّنْيَا كَمَآءٍ أَنزَلْنَٰهُ مِنَ ٱلسَّمَآءِ فَٱخْتَلَطَ بِهِۦ نَبَاتُ ٱلْأَرْضِ مِمَّا يَأْكُلُ ٱلنَّاسُ وَٱلْأَنْعَٰمُ حَتَّىٰٓ إِذَآ أَخَذَتِ ٱلْأَرْضُ زُخْرُفَهَا وَٱزَّيَّنَتْ وَظَنَّ أَهْلُهَآ أَنَّهُمْ قَٰدِرُونَ عَلَيْهَآ أَتَىٰهَآ أَمْرُنَا لَيْلًا أَوْ نَهَارًۭا فَجَعَلْنَٰهَا حَصِيدًۭا كَأَن لَّمْ تَغْنَ بِٱلْأَمْسِ ۚ كَذَٰلِكَ نُفَصِّلُ ٱلْءَايَٰتِ لِقَوْمٍۢ يَتَفَكَّرُونَ',
		number_in_surah: '24',
		page: '211',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1389',
		number: '1389',
		text: 'وَٱللَّهُ يَدْعُوٓا۟ إِلَىٰ دَارِ ٱلسَّلَٰمِ وَيَهْدِى مَن يَشَآءُ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '25',
		page: '211',
		surah_id: '10',
		hizb_id: '84',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1390',
		number: '1390',
		text: '۞ لِّلَّذِينَ أَحْسَنُوا۟ ٱلْحُسْنَىٰ وَزِيَادَةٌۭ ۖ وَلَا يَرْهَقُ وُجُوهَهُمْ قَتَرٌۭ وَلَا ذِلَّةٌ ۚ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَنَّةِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '26',
		page: '212',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1391',
		number: '1391',
		text: 'وَٱلَّذِينَ كَسَبُوا۟ ٱلسَّيِّـَٔاتِ جَزَآءُ سَيِّئَةٍۭ بِمِثْلِهَا وَتَرْهَقُهُمْ ذِلَّةٌۭ ۖ مَّا لَهُم مِّنَ ٱللَّهِ مِنْ عَاصِمٍۢ ۖ كَأَنَّمَآ أُغْشِيَتْ وُجُوهُهُمْ قِطَعًۭا مِّنَ ٱلَّيْلِ مُظْلِمًا ۚ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '27',
		page: '212',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1392',
		number: '1392',
		text: 'وَيَوْمَ نَحْشُرُهُمْ جَمِيعًۭا ثُمَّ نَقُولُ لِلَّذِينَ أَشْرَكُوا۟ مَكَانَكُمْ أَنتُمْ وَشُرَكَآؤُكُمْ ۚ فَزَيَّلْنَا بَيْنَهُمْ ۖ وَقَالَ شُرَكَآؤُهُم مَّا كُنتُمْ إِيَّانَا تَعْبُدُونَ',
		number_in_surah: '28',
		page: '212',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1393',
		number: '1393',
		text: 'فَكَفَىٰ بِٱللَّهِ شَهِيدًۢا بَيْنَنَا وَبَيْنَكُمْ إِن كُنَّا عَنْ عِبَادَتِكُمْ لَغَٰفِلِينَ',
		number_in_surah: '29',
		page: '212',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1394',
		number: '1394',
		text: 'هُنَالِكَ تَبْلُوا۟ كُلُّ نَفْسٍۢ مَّآ أَسْلَفَتْ ۚ وَرُدُّوٓا۟ إِلَى ٱللَّهِ مَوْلَىٰهُمُ ٱلْحَقِّ ۖ وَضَلَّ عَنْهُم مَّا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '30',
		page: '212',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1395',
		number: '1395',
		text: 'قُلْ مَن يَرْزُقُكُم مِّنَ ٱلسَّمَآءِ وَٱلْأَرْضِ أَمَّن يَمْلِكُ ٱلسَّمْعَ وَٱلْأَبْصَٰرَ وَمَن يُخْرِجُ ٱلْحَىَّ مِنَ ٱلْمَيِّتِ وَيُخْرِجُ ٱلْمَيِّتَ مِنَ ٱلْحَىِّ وَمَن يُدَبِّرُ ٱلْأَمْرَ ۚ فَسَيَقُولُونَ ٱللَّهُ ۚ فَقُلْ أَفَلَا تَتَّقُونَ',
		number_in_surah: '31',
		page: '212',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1396',
		number: '1396',
		text: 'فَذَٰلِكُمُ ٱللَّهُ رَبُّكُمُ ٱلْحَقُّ ۖ فَمَاذَا بَعْدَ ٱلْحَقِّ إِلَّا ٱلضَّلَٰلُ ۖ فَأَنَّىٰ تُصْرَفُونَ',
		number_in_surah: '32',
		page: '212',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1397',
		number: '1397',
		text: 'كَذَٰلِكَ حَقَّتْ كَلِمَتُ رَبِّكَ عَلَى ٱلَّذِينَ فَسَقُوٓا۟ أَنَّهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '33',
		page: '212',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1398',
		number: '1398',
		text: 'قُلْ هَلْ مِن شُرَكَآئِكُم مَّن يَبْدَؤُا۟ ٱلْخَلْقَ ثُمَّ يُعِيدُهُۥ ۚ قُلِ ٱللَّهُ يَبْدَؤُا۟ ٱلْخَلْقَ ثُمَّ يُعِيدُهُۥ ۖ فَأَنَّىٰ تُؤْفَكُونَ',
		number_in_surah: '34',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1399',
		number: '1399',
		text: 'قُلْ هَلْ مِن شُرَكَآئِكُم مَّن يَهْدِىٓ إِلَى ٱلْحَقِّ ۚ قُلِ ٱللَّهُ يَهْدِى لِلْحَقِّ ۗ أَفَمَن يَهْدِىٓ إِلَى ٱلْحَقِّ أَحَقُّ أَن يُتَّبَعَ أَمَّن لَّا يَهِدِّىٓ إِلَّآ أَن يُهْدَىٰ ۖ فَمَا لَكُمْ كَيْفَ تَحْكُمُونَ',
		number_in_surah: '35',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1400',
		number: '1400',
		text: 'وَمَا يَتَّبِعُ أَكْثَرُهُمْ إِلَّا ظَنًّا ۚ إِنَّ ٱلظَّنَّ لَا يُغْنِى مِنَ ٱلْحَقِّ شَيْـًٔا ۚ إِنَّ ٱللَّهَ عَلِيمٌۢ بِمَا يَفْعَلُونَ',
		number_in_surah: '36',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1401',
		number: '1401',
		text: 'وَمَا كَانَ هَٰذَا ٱلْقُرْءَانُ أَن يُفْتَرَىٰ مِن دُونِ ٱللَّهِ وَلَٰكِن تَصْدِيقَ ٱلَّذِى بَيْنَ يَدَيْهِ وَتَفْصِيلَ ٱلْكِتَٰبِ لَا رَيْبَ فِيهِ مِن رَّبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '37',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:57',
		updated_at: '2018-06-07 08:06:57',
	},
	{
		id: '1402',
		number: '1402',
		text: 'أَمْ يَقُولُونَ ٱفْتَرَىٰهُ ۖ قُلْ فَأْتُوا۟ بِسُورَةٍۢ مِّثْلِهِۦ وَٱدْعُوا۟ مَنِ ٱسْتَطَعْتُم مِّن دُونِ ٱللَّهِ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '38',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1403',
		number: '1403',
		text: 'بَلْ كَذَّبُوا۟ بِمَا لَمْ يُحِيطُوا۟ بِعِلْمِهِۦ وَلَمَّا يَأْتِهِمْ تَأْوِيلُهُۥ ۚ كَذَٰلِكَ كَذَّبَ ٱلَّذِينَ مِن قَبْلِهِمْ ۖ فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ ٱلظَّٰلِمِينَ',
		number_in_surah: '39',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1404',
		number: '1404',
		text: 'وَمِنْهُم مَّن يُؤْمِنُ بِهِۦ وَمِنْهُم مَّن لَّا يُؤْمِنُ بِهِۦ ۚ وَرَبُّكَ أَعْلَمُ بِٱلْمُفْسِدِينَ',
		number_in_surah: '40',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1405',
		number: '1405',
		text: 'وَإِن كَذَّبُوكَ فَقُل لِّى عَمَلِى وَلَكُمْ عَمَلُكُمْ ۖ أَنتُم بَرِيٓـُٔونَ مِمَّآ أَعْمَلُ وَأَنَا۠ بَرِىٓءٌۭ مِّمَّا تَعْمَلُونَ',
		number_in_surah: '41',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1406',
		number: '1406',
		text: 'وَمِنْهُم مَّن يَسْتَمِعُونَ إِلَيْكَ ۚ أَفَأَنتَ تُسْمِعُ ٱلصُّمَّ وَلَوْ كَانُوا۟ لَا يَعْقِلُونَ',
		number_in_surah: '42',
		page: '213',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1407',
		number: '1407',
		text: 'وَمِنْهُم مَّن يَنظُرُ إِلَيْكَ ۚ أَفَأَنتَ تَهْدِى ٱلْعُمْىَ وَلَوْ كَانُوا۟ لَا يُبْصِرُونَ',
		number_in_surah: '43',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1408',
		number: '1408',
		text: 'إِنَّ ٱللَّهَ لَا يَظْلِمُ ٱلنَّاسَ شَيْـًۭٔا وَلَٰكِنَّ ٱلنَّاسَ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '44',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1409',
		number: '1409',
		text: 'وَيَوْمَ يَحْشُرُهُمْ كَأَن لَّمْ يَلْبَثُوٓا۟ إِلَّا سَاعَةًۭ مِّنَ ٱلنَّهَارِ يَتَعَارَفُونَ بَيْنَهُمْ ۚ قَدْ خَسِرَ ٱلَّذِينَ كَذَّبُوا۟ بِلِقَآءِ ٱللَّهِ وَمَا كَانُوا۟ مُهْتَدِينَ',
		number_in_surah: '45',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1410',
		number: '1410',
		text: 'وَإِمَّا نُرِيَنَّكَ بَعْضَ ٱلَّذِى نَعِدُهُمْ أَوْ نَتَوَفَّيَنَّكَ فَإِلَيْنَا مَرْجِعُهُمْ ثُمَّ ٱللَّهُ شَهِيدٌ عَلَىٰ مَا يَفْعَلُونَ',
		number_in_surah: '46',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1411',
		number: '1411',
		text: 'وَلِكُلِّ أُمَّةٍۢ رَّسُولٌۭ ۖ فَإِذَا جَآءَ رَسُولُهُمْ قُضِىَ بَيْنَهُم بِٱلْقِسْطِ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '47',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1412',
		number: '1412',
		text: 'وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلْوَعْدُ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '48',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1413',
		number: '1413',
		text: 'قُل لَّآ أَمْلِكُ لِنَفْسِى ضَرًّۭا وَلَا نَفْعًا إِلَّا مَا شَآءَ ٱللَّهُ ۗ لِكُلِّ أُمَّةٍ أَجَلٌ ۚ إِذَا جَآءَ أَجَلُهُمْ فَلَا يَسْتَـْٔخِرُونَ سَاعَةًۭ ۖ وَلَا يَسْتَقْدِمُونَ',
		number_in_surah: '49',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1414',
		number: '1414',
		text: 'قُلْ أَرَءَيْتُمْ إِنْ أَتَىٰكُمْ عَذَابُهُۥ بَيَٰتًا أَوْ نَهَارًۭا مَّاذَا يَسْتَعْجِلُ مِنْهُ ٱلْمُجْرِمُونَ',
		number_in_surah: '50',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1415',
		number: '1415',
		text: 'أَثُمَّ إِذَا مَا وَقَعَ ءَامَنتُم بِهِۦٓ ۚ ءَآلْـَٰٔنَ وَقَدْ كُنتُم بِهِۦ تَسْتَعْجِلُونَ',
		number_in_surah: '51',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1416',
		number: '1416',
		text: 'ثُمَّ قِيلَ لِلَّذِينَ ظَلَمُوا۟ ذُوقُوا۟ عَذَابَ ٱلْخُلْدِ هَلْ تُجْزَوْنَ إِلَّا بِمَا كُنتُمْ تَكْسِبُونَ',
		number_in_surah: '52',
		page: '214',
		surah_id: '10',
		hizb_id: '85',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1417',
		number: '1417',
		text: '۞ وَيَسْتَنۢبِـُٔونَكَ أَحَقٌّ هُوَ ۖ قُلْ إِى وَرَبِّىٓ إِنَّهُۥ لَحَقٌّۭ ۖ وَمَآ أَنتُم بِمُعْجِزِينَ',
		number_in_surah: '53',
		page: '214',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1418',
		number: '1418',
		text: 'وَلَوْ أَنَّ لِكُلِّ نَفْسٍۢ ظَلَمَتْ مَا فِى ٱلْأَرْضِ لَٱفْتَدَتْ بِهِۦ ۗ وَأَسَرُّوا۟ ٱلنَّدَامَةَ لَمَّا رَأَوُا۟ ٱلْعَذَابَ ۖ وَقُضِىَ بَيْنَهُم بِٱلْقِسْطِ ۚ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '54',
		page: '215',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1419',
		number: '1419',
		text: 'أَلَآ إِنَّ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۗ أَلَآ إِنَّ وَعْدَ ٱللَّهِ حَقٌّۭ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '55',
		page: '215',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1420',
		number: '1420',
		text: 'هُوَ يُحْىِۦ وَيُمِيتُ وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '56',
		page: '215',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1421',
		number: '1421',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ قَدْ جَآءَتْكُم مَّوْعِظَةٌۭ مِّن رَّبِّكُمْ وَشِفَآءٌۭ لِّمَا فِى ٱلصُّدُورِ وَهُدًۭى وَرَحْمَةٌۭ لِّلْمُؤْمِنِينَ',
		number_in_surah: '57',
		page: '215',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1422',
		number: '1422',
		text: 'قُلْ بِفَضْلِ ٱللَّهِ وَبِرَحْمَتِهِۦ فَبِذَٰلِكَ فَلْيَفْرَحُوا۟ هُوَ خَيْرٌۭ مِّمَّا يَجْمَعُونَ',
		number_in_surah: '58',
		page: '215',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1423',
		number: '1423',
		text: 'قُلْ أَرَءَيْتُم مَّآ أَنزَلَ ٱللَّهُ لَكُم مِّن رِّزْقٍۢ فَجَعَلْتُم مِّنْهُ حَرَامًۭا وَحَلَٰلًۭا قُلْ ءَآللَّهُ أَذِنَ لَكُمْ ۖ أَمْ عَلَى ٱللَّهِ تَفْتَرُونَ',
		number_in_surah: '59',
		page: '215',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1424',
		number: '1424',
		text: 'وَمَا ظَنُّ ٱلَّذِينَ يَفْتَرُونَ عَلَى ٱللَّهِ ٱلْكَذِبَ يَوْمَ ٱلْقِيَٰمَةِ ۗ إِنَّ ٱللَّهَ لَذُو فَضْلٍ عَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَشْكُرُونَ',
		number_in_surah: '60',
		page: '215',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1425',
		number: '1425',
		text: 'وَمَا تَكُونُ فِى شَأْنٍۢ وَمَا تَتْلُوا۟ مِنْهُ مِن قُرْءَانٍۢ وَلَا تَعْمَلُونَ مِنْ عَمَلٍ إِلَّا كُنَّا عَلَيْكُمْ شُهُودًا إِذْ تُفِيضُونَ فِيهِ ۚ وَمَا يَعْزُبُ عَن رَّبِّكَ مِن مِّثْقَالِ ذَرَّةٍۢ فِى ٱلْأَرْضِ وَلَا فِى ٱلسَّمَآءِ وَلَآ أَصْغَرَ مِن ذَٰلِكَ وَلَآ أَكْبَرَ إِلَّا فِى كِتَٰبٍۢ مُّبِينٍ',
		number_in_surah: '61',
		page: '215',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1426',
		number: '1426',
		text: 'أَلَآ إِنَّ أَوْلِيَآءَ ٱللَّهِ لَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '62',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1427',
		number: '1427',
		text: 'ٱلَّذِينَ ءَامَنُوا۟ وَكَانُوا۟ يَتَّقُونَ',
		number_in_surah: '63',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1428',
		number: '1428',
		text: 'لَهُمُ ٱلْبُشْرَىٰ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا وَفِى ٱلْءَاخِرَةِ ۚ لَا تَبْدِيلَ لِكَلِمَٰتِ ٱللَّهِ ۚ ذَٰلِكَ هُوَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '64',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1429',
		number: '1429',
		text: 'وَلَا يَحْزُنكَ قَوْلُهُمْ ۘ إِنَّ ٱلْعِزَّةَ لِلَّهِ جَمِيعًا ۚ هُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '65',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1430',
		number: '1430',
		text: 'أَلَآ إِنَّ لِلَّهِ مَن فِى ٱلسَّمَٰوَٰتِ وَمَن فِى ٱلْأَرْضِ ۗ وَمَا يَتَّبِعُ ٱلَّذِينَ يَدْعُونَ مِن دُونِ ٱللَّهِ شُرَكَآءَ ۚ إِن يَتَّبِعُونَ إِلَّا ٱلظَّنَّ وَإِنْ هُمْ إِلَّا يَخْرُصُونَ',
		number_in_surah: '66',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1431',
		number: '1431',
		text: 'هُوَ ٱلَّذِى جَعَلَ لَكُمُ ٱلَّيْلَ لِتَسْكُنُوا۟ فِيهِ وَٱلنَّهَارَ مُبْصِرًا ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَسْمَعُونَ',
		number_in_surah: '67',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1432',
		number: '1432',
		text: 'قَالُوا۟ ٱتَّخَذَ ٱللَّهُ وَلَدًۭا ۗ سُبْحَٰنَهُۥ ۖ هُوَ ٱلْغَنِىُّ ۖ لَهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۚ إِنْ عِندَكُم مِّن سُلْطَٰنٍۭ بِهَٰذَآ ۚ أَتَقُولُونَ عَلَى ٱللَّهِ مَا لَا تَعْلَمُونَ',
		number_in_surah: '68',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1433',
		number: '1433',
		text: 'قُلْ إِنَّ ٱلَّذِينَ يَفْتَرُونَ عَلَى ٱللَّهِ ٱلْكَذِبَ لَا يُفْلِحُونَ',
		number_in_surah: '69',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1434',
		number: '1434',
		text: 'مَتَٰعٌۭ فِى ٱلدُّنْيَا ثُمَّ إِلَيْنَا مَرْجِعُهُمْ ثُمَّ نُذِيقُهُمُ ٱلْعَذَابَ ٱلشَّدِيدَ بِمَا كَانُوا۟ يَكْفُرُونَ',
		number_in_surah: '70',
		page: '216',
		surah_id: '10',
		hizb_id: '86',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1435',
		number: '1435',
		text: '۞ وَٱتْلُ عَلَيْهِمْ نَبَأَ نُوحٍ إِذْ قَالَ لِقَوْمِهِۦ يَٰقَوْمِ إِن كَانَ كَبُرَ عَلَيْكُم مَّقَامِى وَتَذْكِيرِى بِـَٔايَٰتِ ٱللَّهِ فَعَلَى ٱللَّهِ تَوَكَّلْتُ فَأَجْمِعُوٓا۟ أَمْرَكُمْ وَشُرَكَآءَكُمْ ثُمَّ لَا يَكُنْ أَمْرُكُمْ عَلَيْكُمْ غُمَّةًۭ ثُمَّ ٱقْضُوٓا۟ إِلَىَّ وَلَا تُنظِرُونِ',
		number_in_surah: '71',
		page: '217',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1436',
		number: '1436',
		text: 'فَإِن تَوَلَّيْتُمْ فَمَا سَأَلْتُكُم مِّنْ أَجْرٍ ۖ إِنْ أَجْرِىَ إِلَّا عَلَى ٱللَّهِ ۖ وَأُمِرْتُ أَنْ أَكُونَ مِنَ ٱلْمُسْلِمِينَ',
		number_in_surah: '72',
		page: '217',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1437',
		number: '1437',
		text: 'فَكَذَّبُوهُ فَنَجَّيْنَٰهُ وَمَن مَّعَهُۥ فِى ٱلْفُلْكِ وَجَعَلْنَٰهُمْ خَلَٰٓئِفَ وَأَغْرَقْنَا ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا ۖ فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُنذَرِينَ',
		number_in_surah: '73',
		page: '217',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1438',
		number: '1438',
		text: 'ثُمَّ بَعَثْنَا مِنۢ بَعْدِهِۦ رُسُلًا إِلَىٰ قَوْمِهِمْ فَجَآءُوهُم بِٱلْبَيِّنَٰتِ فَمَا كَانُوا۟ لِيُؤْمِنُوا۟ بِمَا كَذَّبُوا۟ بِهِۦ مِن قَبْلُ ۚ كَذَٰلِكَ نَطْبَعُ عَلَىٰ قُلُوبِ ٱلْمُعْتَدِينَ',
		number_in_surah: '74',
		page: '217',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1439',
		number: '1439',
		text: 'ثُمَّ بَعَثْنَا مِنۢ بَعْدِهِم مُّوسَىٰ وَهَٰرُونَ إِلَىٰ فِرْعَوْنَ وَمَلَإِي۟هِۦ بِـَٔايَٰتِنَا فَٱسْتَكْبَرُوا۟ وَكَانُوا۟ قَوْمًۭا مُّجْرِمِينَ',
		number_in_surah: '75',
		page: '217',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1440',
		number: '1440',
		text: 'فَلَمَّا جَآءَهُمُ ٱلْحَقُّ مِنْ عِندِنَا قَالُوٓا۟ إِنَّ هَٰذَا لَسِحْرٌۭ مُّبِينٌۭ',
		number_in_surah: '76',
		page: '217',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1441',
		number: '1441',
		text: 'قَالَ مُوسَىٰٓ أَتَقُولُونَ لِلْحَقِّ لَمَّا جَآءَكُمْ ۖ أَسِحْرٌ هَٰذَا وَلَا يُفْلِحُ ٱلسَّٰحِرُونَ',
		number_in_surah: '77',
		page: '217',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1442',
		number: '1442',
		text: 'قَالُوٓا۟ أَجِئْتَنَا لِتَلْفِتَنَا عَمَّا وَجَدْنَا عَلَيْهِ ءَابَآءَنَا وَتَكُونَ لَكُمَا ٱلْكِبْرِيَآءُ فِى ٱلْأَرْضِ وَمَا نَحْنُ لَكُمَا بِمُؤْمِنِينَ',
		number_in_surah: '78',
		page: '217',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1443',
		number: '1443',
		text: 'وَقَالَ فِرْعَوْنُ ٱئْتُونِى بِكُلِّ سَٰحِرٍ عَلِيمٍۢ',
		number_in_surah: '79',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1444',
		number: '1444',
		text: 'فَلَمَّا جَآءَ ٱلسَّحَرَةُ قَالَ لَهُم مُّوسَىٰٓ أَلْقُوا۟ مَآ أَنتُم مُّلْقُونَ',
		number_in_surah: '80',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1445',
		number: '1445',
		text: 'فَلَمَّآ أَلْقَوْا۟ قَالَ مُوسَىٰ مَا جِئْتُم بِهِ ٱلسِّحْرُ ۖ إِنَّ ٱللَّهَ سَيُبْطِلُهُۥٓ ۖ إِنَّ ٱللَّهَ لَا يُصْلِحُ عَمَلَ ٱلْمُفْسِدِينَ',
		number_in_surah: '81',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1446',
		number: '1446',
		text: 'وَيُحِقُّ ٱللَّهُ ٱلْحَقَّ بِكَلِمَٰتِهِۦ وَلَوْ كَرِهَ ٱلْمُجْرِمُونَ',
		number_in_surah: '82',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1447',
		number: '1447',
		text: 'فَمَآ ءَامَنَ لِمُوسَىٰٓ إِلَّا ذُرِّيَّةٌۭ مِّن قَوْمِهِۦ عَلَىٰ خَوْفٍۢ مِّن فِرْعَوْنَ وَمَلَإِي۟هِمْ أَن يَفْتِنَهُمْ ۚ وَإِنَّ فِرْعَوْنَ لَعَالٍۢ فِى ٱلْأَرْضِ وَإِنَّهُۥ لَمِنَ ٱلْمُسْرِفِينَ',
		number_in_surah: '83',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1448',
		number: '1448',
		text: 'وَقَالَ مُوسَىٰ يَٰقَوْمِ إِن كُنتُمْ ءَامَنتُم بِٱللَّهِ فَعَلَيْهِ تَوَكَّلُوٓا۟ إِن كُنتُم مُّسْلِمِينَ',
		number_in_surah: '84',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1449',
		number: '1449',
		text: 'فَقَالُوا۟ عَلَى ٱللَّهِ تَوَكَّلْنَا رَبَّنَا لَا تَجْعَلْنَا فِتْنَةًۭ لِّلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '85',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1450',
		number: '1450',
		text: 'وَنَجِّنَا بِرَحْمَتِكَ مِنَ ٱلْقَوْمِ ٱلْكَٰفِرِينَ',
		number_in_surah: '86',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1451',
		number: '1451',
		text: 'وَأَوْحَيْنَآ إِلَىٰ مُوسَىٰ وَأَخِيهِ أَن تَبَوَّءَا لِقَوْمِكُمَا بِمِصْرَ بُيُوتًۭا وَٱجْعَلُوا۟ بُيُوتَكُمْ قِبْلَةًۭ وَأَقِيمُوا۟ ٱلصَّلَوٰةَ ۗ وَبَشِّرِ ٱلْمُؤْمِنِينَ',
		number_in_surah: '87',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1452',
		number: '1452',
		text: 'وَقَالَ مُوسَىٰ رَبَّنَآ إِنَّكَ ءَاتَيْتَ فِرْعَوْنَ وَمَلَأَهُۥ زِينَةًۭ وَأَمْوَٰلًۭا فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا رَبَّنَا لِيُضِلُّوا۟ عَن سَبِيلِكَ ۖ رَبَّنَا ٱطْمِسْ عَلَىٰٓ أَمْوَٰلِهِمْ وَٱشْدُدْ عَلَىٰ قُلُوبِهِمْ فَلَا يُؤْمِنُوا۟ حَتَّىٰ يَرَوُا۟ ٱلْعَذَابَ ٱلْأَلِيمَ',
		number_in_surah: '88',
		page: '218',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1453',
		number: '1453',
		text: 'قَالَ قَدْ أُجِيبَت دَّعْوَتُكُمَا فَٱسْتَقِيمَا وَلَا تَتَّبِعَآنِّ سَبِيلَ ٱلَّذِينَ لَا يَعْلَمُونَ',
		number_in_surah: '89',
		page: '219',
		surah_id: '10',
		hizb_id: '87',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1454',
		number: '1454',
		text: '۞ وَجَٰوَزْنَا بِبَنِىٓ إِسْرَٰٓءِيلَ ٱلْبَحْرَ فَأَتْبَعَهُمْ فِرْعَوْنُ وَجُنُودُهُۥ بَغْيًۭا وَعَدْوًا ۖ حَتَّىٰٓ إِذَآ أَدْرَكَهُ ٱلْغَرَقُ قَالَ ءَامَنتُ أَنَّهُۥ لَآ إِلَٰهَ إِلَّا ٱلَّذِىٓ ءَامَنَتْ بِهِۦ بَنُوٓا۟ إِسْرَٰٓءِيلَ وَأَنَا۠ مِنَ ٱلْمُسْلِمِينَ',
		number_in_surah: '90',
		page: '219',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1455',
		number: '1455',
		text: 'ءَآلْـَٰٔنَ وَقَدْ عَصَيْتَ قَبْلُ وَكُنتَ مِنَ ٱلْمُفْسِدِينَ',
		number_in_surah: '91',
		page: '219',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1456',
		number: '1456',
		text: 'فَٱلْيَوْمَ نُنَجِّيكَ بِبَدَنِكَ لِتَكُونَ لِمَنْ خَلْفَكَ ءَايَةًۭ ۚ وَإِنَّ كَثِيرًۭا مِّنَ ٱلنَّاسِ عَنْ ءَايَٰتِنَا لَغَٰفِلُونَ',
		number_in_surah: '92',
		page: '219',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1457',
		number: '1457',
		text: 'وَلَقَدْ بَوَّأْنَا بَنِىٓ إِسْرَٰٓءِيلَ مُبَوَّأَ صِدْقٍۢ وَرَزَقْنَٰهُم مِّنَ ٱلطَّيِّبَٰتِ فَمَا ٱخْتَلَفُوا۟ حَتَّىٰ جَآءَهُمُ ٱلْعِلْمُ ۚ إِنَّ رَبَّكَ يَقْضِى بَيْنَهُمْ يَوْمَ ٱلْقِيَٰمَةِ فِيمَا كَانُوا۟ فِيهِ يَخْتَلِفُونَ',
		number_in_surah: '93',
		page: '219',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1458',
		number: '1458',
		text: 'فَإِن كُنتَ فِى شَكٍّۢ مِّمَّآ أَنزَلْنَآ إِلَيْكَ فَسْـَٔلِ ٱلَّذِينَ يَقْرَءُونَ ٱلْكِتَٰبَ مِن قَبْلِكَ ۚ لَقَدْ جَآءَكَ ٱلْحَقُّ مِن رَّبِّكَ فَلَا تَكُونَنَّ مِنَ ٱلْمُمْتَرِينَ',
		number_in_surah: '94',
		page: '219',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1459',
		number: '1459',
		text: 'وَلَا تَكُونَنَّ مِنَ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِ ٱللَّهِ فَتَكُونَ مِنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '95',
		page: '219',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1460',
		number: '1460',
		text: 'إِنَّ ٱلَّذِينَ حَقَّتْ عَلَيْهِمْ كَلِمَتُ رَبِّكَ لَا يُؤْمِنُونَ',
		number_in_surah: '96',
		page: '219',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1461',
		number: '1461',
		text: 'وَلَوْ جَآءَتْهُمْ كُلُّ ءَايَةٍ حَتَّىٰ يَرَوُا۟ ٱلْعَذَابَ ٱلْأَلِيمَ',
		number_in_surah: '97',
		page: '219',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1462',
		number: '1462',
		text: 'فَلَوْلَا كَانَتْ قَرْيَةٌ ءَامَنَتْ فَنَفَعَهَآ إِيمَٰنُهَآ إِلَّا قَوْمَ يُونُسَ لَمَّآ ءَامَنُوا۟ كَشَفْنَا عَنْهُمْ عَذَابَ ٱلْخِزْىِ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا وَمَتَّعْنَٰهُمْ إِلَىٰ حِينٍۢ',
		number_in_surah: '98',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1463',
		number: '1463',
		text: 'وَلَوْ شَآءَ رَبُّكَ لَءَامَنَ مَن فِى ٱلْأَرْضِ كُلُّهُمْ جَمِيعًا ۚ أَفَأَنتَ تُكْرِهُ ٱلنَّاسَ حَتَّىٰ يَكُونُوا۟ مُؤْمِنِينَ',
		number_in_surah: '99',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1464',
		number: '1464',
		text: 'وَمَا كَانَ لِنَفْسٍ أَن تُؤْمِنَ إِلَّا بِإِذْنِ ٱللَّهِ ۚ وَيَجْعَلُ ٱلرِّجْسَ عَلَى ٱلَّذِينَ لَا يَعْقِلُونَ',
		number_in_surah: '100',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1465',
		number: '1465',
		text: 'قُلِ ٱنظُرُوا۟ مَاذَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَمَا تُغْنِى ٱلْءَايَٰتُ وَٱلنُّذُرُ عَن قَوْمٍۢ لَّا يُؤْمِنُونَ',
		number_in_surah: '101',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1466',
		number: '1466',
		text: 'فَهَلْ يَنتَظِرُونَ إِلَّا مِثْلَ أَيَّامِ ٱلَّذِينَ خَلَوْا۟ مِن قَبْلِهِمْ ۚ قُلْ فَٱنتَظِرُوٓا۟ إِنِّى مَعَكُم مِّنَ ٱلْمُنتَظِرِينَ',
		number_in_surah: '102',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1467',
		number: '1467',
		text: 'ثُمَّ نُنَجِّى رُسُلَنَا وَٱلَّذِينَ ءَامَنُوا۟ ۚ كَذَٰلِكَ حَقًّا عَلَيْنَا نُنجِ ٱلْمُؤْمِنِينَ',
		number_in_surah: '103',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1468',
		number: '1468',
		text: 'قُلْ يَٰٓأَيُّهَا ٱلنَّاسُ إِن كُنتُمْ فِى شَكٍّۢ مِّن دِينِى فَلَآ أَعْبُدُ ٱلَّذِينَ تَعْبُدُونَ مِن دُونِ ٱللَّهِ وَلَٰكِنْ أَعْبُدُ ٱللَّهَ ٱلَّذِى يَتَوَفَّىٰكُمْ ۖ وَأُمِرْتُ أَنْ أَكُونَ مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '104',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1469',
		number: '1469',
		text: 'وَأَنْ أَقِمْ وَجْهَكَ لِلدِّينِ حَنِيفًۭا وَلَا تَكُونَنَّ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '105',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1470',
		number: '1470',
		text: 'وَلَا تَدْعُ مِن دُونِ ٱللَّهِ مَا لَا يَنفَعُكَ وَلَا يَضُرُّكَ ۖ فَإِن فَعَلْتَ فَإِنَّكَ إِذًۭا مِّنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '106',
		page: '220',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1471',
		number: '1471',
		text: 'وَإِن يَمْسَسْكَ ٱللَّهُ بِضُرٍّۢ فَلَا كَاشِفَ لَهُۥٓ إِلَّا هُوَ ۖ وَإِن يُرِدْكَ بِخَيْرٍۢ فَلَا رَآدَّ لِفَضْلِهِۦ ۚ يُصِيبُ بِهِۦ مَن يَشَآءُ مِنْ عِبَادِهِۦ ۚ وَهُوَ ٱلْغَفُورُ ٱلرَّحِيمُ',
		number_in_surah: '107',
		page: '221',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1472',
		number: '1472',
		text: 'قُلْ يَٰٓأَيُّهَا ٱلنَّاسُ قَدْ جَآءَكُمُ ٱلْحَقُّ مِن رَّبِّكُمْ ۖ فَمَنِ ٱهْتَدَىٰ فَإِنَّمَا يَهْتَدِى لِنَفْسِهِۦ ۖ وَمَن ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيْهَا ۖ وَمَآ أَنَا۠ عَلَيْكُم بِوَكِيلٍۢ',
		number_in_surah: '108',
		page: '221',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1473',
		number: '1473',
		text: 'وَٱتَّبِعْ مَا يُوحَىٰٓ إِلَيْكَ وَٱصْبِرْ حَتَّىٰ يَحْكُمَ ٱللَّهُ ۚ وَهُوَ خَيْرُ ٱلْحَٰكِمِينَ',
		number_in_surah: '109',
		page: '221',
		surah_id: '10',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1474',
		number: '1474',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓر ۚ كِتَٰبٌ أُحْكِمَتْ ءَايَٰتُهُۥ ثُمَّ فُصِّلَتْ مِن لَّدُنْ حَكِيمٍ خَبِيرٍ',
		number_in_surah: '1',
		page: '221',
		surah_id: '11',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1475',
		number: '1475',
		text: 'أَلَّا تَعْبُدُوٓا۟ إِلَّا ٱللَّهَ ۚ إِنَّنِى لَكُم مِّنْهُ نَذِيرٌۭ وَبَشِيرٌۭ',
		number_in_surah: '2',
		page: '221',
		surah_id: '11',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1476',
		number: '1476',
		text: 'وَأَنِ ٱسْتَغْفِرُوا۟ رَبَّكُمْ ثُمَّ تُوبُوٓا۟ إِلَيْهِ يُمَتِّعْكُم مَّتَٰعًا حَسَنًا إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى وَيُؤْتِ كُلَّ ذِى فَضْلٍۢ فَضْلَهُۥ ۖ وَإِن تَوَلَّوْا۟ فَإِنِّىٓ أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍۢ كَبِيرٍ',
		number_in_surah: '3',
		page: '221',
		surah_id: '11',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1477',
		number: '1477',
		text: 'إِلَى ٱللَّهِ مَرْجِعُكُمْ ۖ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '4',
		page: '221',
		surah_id: '11',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1478',
		number: '1478',
		text: 'أَلَآ إِنَّهُمْ يَثْنُونَ صُدُورَهُمْ لِيَسْتَخْفُوا۟ مِنْهُ ۚ أَلَا حِينَ يَسْتَغْشُونَ ثِيَابَهُمْ يَعْلَمُ مَا يُسِرُّونَ وَمَا يُعْلِنُونَ ۚ إِنَّهُۥ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '5',
		page: '221',
		surah_id: '11',
		hizb_id: '88',
		juz_id: '11',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1479',
		number: '1479',
		text: '۞ وَمَا مِن دَآبَّةٍۢ فِى ٱلْأَرْضِ إِلَّا عَلَى ٱللَّهِ رِزْقُهَا وَيَعْلَمُ مُسْتَقَرَّهَا وَمُسْتَوْدَعَهَا ۚ كُلٌّۭ فِى كِتَٰبٍۢ مُّبِينٍۢ',
		number_in_surah: '6',
		page: '222',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1480',
		number: '1480',
		text: 'وَهُوَ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ فِى سِتَّةِ أَيَّامٍۢ وَكَانَ عَرْشُهُۥ عَلَى ٱلْمَآءِ لِيَبْلُوَكُمْ أَيُّكُمْ أَحْسَنُ عَمَلًۭا ۗ وَلَئِن قُلْتَ إِنَّكُم مَّبْعُوثُونَ مِنۢ بَعْدِ ٱلْمَوْتِ لَيَقُولَنَّ ٱلَّذِينَ كَفَرُوٓا۟ إِنْ هَٰذَآ إِلَّا سِحْرٌۭ مُّبِينٌۭ',
		number_in_surah: '7',
		page: '222',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1481',
		number: '1481',
		text: 'وَلَئِنْ أَخَّرْنَا عَنْهُمُ ٱلْعَذَابَ إِلَىٰٓ أُمَّةٍۢ مَّعْدُودَةٍۢ لَّيَقُولُنَّ مَا يَحْبِسُهُۥٓ ۗ أَلَا يَوْمَ يَأْتِيهِمْ لَيْسَ مَصْرُوفًا عَنْهُمْ وَحَاقَ بِهِم مَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '8',
		page: '222',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1482',
		number: '1482',
		text: 'وَلَئِنْ أَذَقْنَا ٱلْإِنسَٰنَ مِنَّا رَحْمَةًۭ ثُمَّ نَزَعْنَٰهَا مِنْهُ إِنَّهُۥ لَيَـُٔوسٌۭ كَفُورٌۭ',
		number_in_surah: '9',
		page: '222',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1483',
		number: '1483',
		text: 'وَلَئِنْ أَذَقْنَٰهُ نَعْمَآءَ بَعْدَ ضَرَّآءَ مَسَّتْهُ لَيَقُولَنَّ ذَهَبَ ٱلسَّيِّـَٔاتُ عَنِّىٓ ۚ إِنَّهُۥ لَفَرِحٌۭ فَخُورٌ',
		number_in_surah: '10',
		page: '222',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1484',
		number: '1484',
		text: 'إِلَّا ٱلَّذِينَ صَبَرُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ أُو۟لَٰٓئِكَ لَهُم مَّغْفِرَةٌۭ وَأَجْرٌۭ كَبِيرٌۭ',
		number_in_surah: '11',
		page: '222',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1485',
		number: '1485',
		text: 'فَلَعَلَّكَ تَارِكٌۢ بَعْضَ مَا يُوحَىٰٓ إِلَيْكَ وَضَآئِقٌۢ بِهِۦ صَدْرُكَ أَن يَقُولُوا۟ لَوْلَآ أُنزِلَ عَلَيْهِ كَنزٌ أَوْ جَآءَ مَعَهُۥ مَلَكٌ ۚ إِنَّمَآ أَنتَ نَذِيرٌۭ ۚ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ وَكِيلٌ',
		number_in_surah: '12',
		page: '222',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1486',
		number: '1486',
		text: 'أَمْ يَقُولُونَ ٱفْتَرَىٰهُ ۖ قُلْ فَأْتُوا۟ بِعَشْرِ سُوَرٍۢ مِّثْلِهِۦ مُفْتَرَيَٰتٍۢ وَٱدْعُوا۟ مَنِ ٱسْتَطَعْتُم مِّن دُونِ ٱللَّهِ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '13',
		page: '223',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1487',
		number: '1487',
		text: 'فَإِلَّمْ يَسْتَجِيبُوا۟ لَكُمْ فَٱعْلَمُوٓا۟ أَنَّمَآ أُنزِلَ بِعِلْمِ ٱللَّهِ وَأَن لَّآ إِلَٰهَ إِلَّا هُوَ ۖ فَهَلْ أَنتُم مُّسْلِمُونَ',
		number_in_surah: '14',
		page: '223',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1488',
		number: '1488',
		text: 'مَن كَانَ يُرِيدُ ٱلْحَيَوٰةَ ٱلدُّنْيَا وَزِينَتَهَا نُوَفِّ إِلَيْهِمْ أَعْمَٰلَهُمْ فِيهَا وَهُمْ فِيهَا لَا يُبْخَسُونَ',
		number_in_surah: '15',
		page: '223',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1489',
		number: '1489',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ لَيْسَ لَهُمْ فِى ٱلْءَاخِرَةِ إِلَّا ٱلنَّارُ ۖ وَحَبِطَ مَا صَنَعُوا۟ فِيهَا وَبَٰطِلٌۭ مَّا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '16',
		page: '223',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1490',
		number: '1490',
		text: 'أَفَمَن كَانَ عَلَىٰ بَيِّنَةٍۢ مِّن رَّبِّهِۦ وَيَتْلُوهُ شَاهِدٌۭ مِّنْهُ وَمِن قَبْلِهِۦ كِتَٰبُ مُوسَىٰٓ إِمَامًۭا وَرَحْمَةً ۚ أُو۟لَٰٓئِكَ يُؤْمِنُونَ بِهِۦ ۚ وَمَن يَكْفُرْ بِهِۦ مِنَ ٱلْأَحْزَابِ فَٱلنَّارُ مَوْعِدُهُۥ ۚ فَلَا تَكُ فِى مِرْيَةٍۢ مِّنْهُ ۚ إِنَّهُ ٱلْحَقُّ مِن رَّبِّكَ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يُؤْمِنُونَ',
		number_in_surah: '17',
		page: '223',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1491',
		number: '1491',
		text: 'وَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًا ۚ أُو۟لَٰٓئِكَ يُعْرَضُونَ عَلَىٰ رَبِّهِمْ وَيَقُولُ ٱلْأَشْهَٰدُ هَٰٓؤُلَآءِ ٱلَّذِينَ كَذَبُوا۟ عَلَىٰ رَبِّهِمْ ۚ أَلَا لَعْنَةُ ٱللَّهِ عَلَى ٱلظَّٰلِمِينَ',
		number_in_surah: '18',
		page: '223',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1492',
		number: '1492',
		text: 'ٱلَّذِينَ يَصُدُّونَ عَن سَبِيلِ ٱللَّهِ وَيَبْغُونَهَا عِوَجًۭا وَهُم بِٱلْءَاخِرَةِ هُمْ كَٰفِرُونَ',
		number_in_surah: '19',
		page: '223',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1493',
		number: '1493',
		text: 'أُو۟لَٰٓئِكَ لَمْ يَكُونُوا۟ مُعْجِزِينَ فِى ٱلْأَرْضِ وَمَا كَانَ لَهُم مِّن دُونِ ٱللَّهِ مِنْ أَوْلِيَآءَ ۘ يُضَٰعَفُ لَهُمُ ٱلْعَذَابُ ۚ مَا كَانُوا۟ يَسْتَطِيعُونَ ٱلسَّمْعَ وَمَا كَانُوا۟ يُبْصِرُونَ',
		number_in_surah: '20',
		page: '224',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1494',
		number: '1494',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ خَسِرُوٓا۟ أَنفُسَهُمْ وَضَلَّ عَنْهُم مَّا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '21',
		page: '224',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1495',
		number: '1495',
		text: 'لَا جَرَمَ أَنَّهُمْ فِى ٱلْءَاخِرَةِ هُمُ ٱلْأَخْسَرُونَ',
		number_in_surah: '22',
		page: '224',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1496',
		number: '1496',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ وَأَخْبَتُوٓا۟ إِلَىٰ رَبِّهِمْ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَنَّةِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '23',
		page: '224',
		surah_id: '11',
		hizb_id: '89',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1497',
		number: '1497',
		text: '۞ مَثَلُ ٱلْفَرِيقَيْنِ كَٱلْأَعْمَىٰ وَٱلْأَصَمِّ وَٱلْبَصِيرِ وَٱلسَّمِيعِ ۚ هَلْ يَسْتَوِيَانِ مَثَلًا ۚ أَفَلَا تَذَكَّرُونَ',
		number_in_surah: '24',
		page: '224',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1498',
		number: '1498',
		text: 'وَلَقَدْ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِۦٓ إِنِّى لَكُمْ نَذِيرٌۭ مُّبِينٌ',
		number_in_surah: '25',
		page: '224',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1499',
		number: '1499',
		text: 'أَن لَّا تَعْبُدُوٓا۟ إِلَّا ٱللَّهَ ۖ إِنِّىٓ أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ أَلِيمٍۢ',
		number_in_surah: '26',
		page: '224',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1500',
		number: '1500',
		text: 'فَقَالَ ٱلْمَلَأُ ٱلَّذِينَ كَفَرُوا۟ مِن قَوْمِهِۦ مَا نَرَىٰكَ إِلَّا بَشَرًۭا مِّثْلَنَا وَمَا نَرَىٰكَ ٱتَّبَعَكَ إِلَّا ٱلَّذِينَ هُمْ أَرَاذِلُنَا بَادِىَ ٱلرَّأْىِ وَمَا نَرَىٰ لَكُمْ عَلَيْنَا مِن فَضْلٍۭ بَلْ نَظُنُّكُمْ كَٰذِبِينَ',
		number_in_surah: '27',
		page: '224',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1501',
		number: '1501',
		text: 'قَالَ يَٰقَوْمِ أَرَءَيْتُمْ إِن كُنتُ عَلَىٰ بَيِّنَةٍۢ مِّن رَّبِّى وَءَاتَىٰنِى رَحْمَةًۭ مِّنْ عِندِهِۦ فَعُمِّيَتْ عَلَيْكُمْ أَنُلْزِمُكُمُوهَا وَأَنتُمْ لَهَا كَٰرِهُونَ',
		number_in_surah: '28',
		page: '224',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1502',
		number: '1502',
		text: 'وَيَٰقَوْمِ لَآ أَسْـَٔلُكُمْ عَلَيْهِ مَالًا ۖ إِنْ أَجْرِىَ إِلَّا عَلَى ٱللَّهِ ۚ وَمَآ أَنَا۠ بِطَارِدِ ٱلَّذِينَ ءَامَنُوٓا۟ ۚ إِنَّهُم مُّلَٰقُوا۟ رَبِّهِمْ وَلَٰكِنِّىٓ أَرَىٰكُمْ قَوْمًۭا تَجْهَلُونَ',
		number_in_surah: '29',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1503',
		number: '1503',
		text: 'وَيَٰقَوْمِ مَن يَنصُرُنِى مِنَ ٱللَّهِ إِن طَرَدتُّهُمْ ۚ أَفَلَا تَذَكَّرُونَ',
		number_in_surah: '30',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1504',
		number: '1504',
		text: 'وَلَآ أَقُولُ لَكُمْ عِندِى خَزَآئِنُ ٱللَّهِ وَلَآ أَعْلَمُ ٱلْغَيْبَ وَلَآ أَقُولُ إِنِّى مَلَكٌۭ وَلَآ أَقُولُ لِلَّذِينَ تَزْدَرِىٓ أَعْيُنُكُمْ لَن يُؤْتِيَهُمُ ٱللَّهُ خَيْرًا ۖ ٱللَّهُ أَعْلَمُ بِمَا فِىٓ أَنفُسِهِمْ ۖ إِنِّىٓ إِذًۭا لَّمِنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '31',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1505',
		number: '1505',
		text: 'قَالُوا۟ يَٰنُوحُ قَدْ جَٰدَلْتَنَا فَأَكْثَرْتَ جِدَٰلَنَا فَأْتِنَا بِمَا تَعِدُنَآ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '32',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1506',
		number: '1506',
		text: 'قَالَ إِنَّمَا يَأْتِيكُم بِهِ ٱللَّهُ إِن شَآءَ وَمَآ أَنتُم بِمُعْجِزِينَ',
		number_in_surah: '33',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1507',
		number: '1507',
		text: 'وَلَا يَنفَعُكُمْ نُصْحِىٓ إِنْ أَرَدتُّ أَنْ أَنصَحَ لَكُمْ إِن كَانَ ٱللَّهُ يُرِيدُ أَن يُغْوِيَكُمْ ۚ هُوَ رَبُّكُمْ وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '34',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1508',
		number: '1508',
		text: 'أَمْ يَقُولُونَ ٱفْتَرَىٰهُ ۖ قُلْ إِنِ ٱفْتَرَيْتُهُۥ فَعَلَىَّ إِجْرَامِى وَأَنَا۠ بَرِىٓءٌۭ مِّمَّا تُجْرِمُونَ',
		number_in_surah: '35',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1509',
		number: '1509',
		text: 'وَأُوحِىَ إِلَىٰ نُوحٍ أَنَّهُۥ لَن يُؤْمِنَ مِن قَوْمِكَ إِلَّا مَن قَدْ ءَامَنَ فَلَا تَبْتَئِسْ بِمَا كَانُوا۟ يَفْعَلُونَ',
		number_in_surah: '36',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1510',
		number: '1510',
		text: 'وَٱصْنَعِ ٱلْفُلْكَ بِأَعْيُنِنَا وَوَحْيِنَا وَلَا تُخَٰطِبْنِى فِى ٱلَّذِينَ ظَلَمُوٓا۟ ۚ إِنَّهُم مُّغْرَقُونَ',
		number_in_surah: '37',
		page: '225',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1511',
		number: '1511',
		text: 'وَيَصْنَعُ ٱلْفُلْكَ وَكُلَّمَا مَرَّ عَلَيْهِ مَلَأٌۭ مِّن قَوْمِهِۦ سَخِرُوا۟ مِنْهُ ۚ قَالَ إِن تَسْخَرُوا۟ مِنَّا فَإِنَّا نَسْخَرُ مِنكُمْ كَمَا تَسْخَرُونَ',
		number_in_surah: '38',
		page: '226',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1512',
		number: '1512',
		text: 'فَسَوْفَ تَعْلَمُونَ مَن يَأْتِيهِ عَذَابٌۭ يُخْزِيهِ وَيَحِلُّ عَلَيْهِ عَذَابٌۭ مُّقِيمٌ',
		number_in_surah: '39',
		page: '226',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1513',
		number: '1513',
		text: 'حَتَّىٰٓ إِذَا جَآءَ أَمْرُنَا وَفَارَ ٱلتَّنُّورُ قُلْنَا ٱحْمِلْ فِيهَا مِن كُلٍّۢ زَوْجَيْنِ ٱثْنَيْنِ وَأَهْلَكَ إِلَّا مَن سَبَقَ عَلَيْهِ ٱلْقَوْلُ وَمَنْ ءَامَنَ ۚ وَمَآ ءَامَنَ مَعَهُۥٓ إِلَّا قَلِيلٌۭ',
		number_in_surah: '40',
		page: '226',
		surah_id: '11',
		hizb_id: '90',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1514',
		number: '1514',
		text: '۞ وَقَالَ ٱرْكَبُوا۟ فِيهَا بِسْمِ ٱللَّهِ مَجْر۪ىٰهَا وَمُرْسَىٰهَآ ۚ إِنَّ رَبِّى لَغَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '41',
		page: '226',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1515',
		number: '1515',
		text: 'وَهِىَ تَجْرِى بِهِمْ فِى مَوْجٍۢ كَٱلْجِبَالِ وَنَادَىٰ نُوحٌ ٱبْنَهُۥ وَكَانَ فِى مَعْزِلٍۢ يَٰبُنَىَّ ٱرْكَب مَّعَنَا وَلَا تَكُن مَّعَ ٱلْكَٰفِرِينَ',
		number_in_surah: '42',
		page: '226',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1516',
		number: '1516',
		text: 'قَالَ سَـَٔاوِىٓ إِلَىٰ جَبَلٍۢ يَعْصِمُنِى مِنَ ٱلْمَآءِ ۚ قَالَ لَا عَاصِمَ ٱلْيَوْمَ مِنْ أَمْرِ ٱللَّهِ إِلَّا مَن رَّحِمَ ۚ وَحَالَ بَيْنَهُمَا ٱلْمَوْجُ فَكَانَ مِنَ ٱلْمُغْرَقِينَ',
		number_in_surah: '43',
		page: '226',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1517',
		number: '1517',
		text: 'وَقِيلَ يَٰٓأَرْضُ ٱبْلَعِى مَآءَكِ وَيَٰسَمَآءُ أَقْلِعِى وَغِيضَ ٱلْمَآءُ وَقُضِىَ ٱلْأَمْرُ وَٱسْتَوَتْ عَلَى ٱلْجُودِىِّ ۖ وَقِيلَ بُعْدًۭا لِّلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '44',
		page: '226',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1518',
		number: '1518',
		text: 'وَنَادَىٰ نُوحٌۭ رَّبَّهُۥ فَقَالَ رَبِّ إِنَّ ٱبْنِى مِنْ أَهْلِى وَإِنَّ وَعْدَكَ ٱلْحَقُّ وَأَنتَ أَحْكَمُ ٱلْحَٰكِمِينَ',
		number_in_surah: '45',
		page: '226',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1519',
		number: '1519',
		text: 'قَالَ يَٰنُوحُ إِنَّهُۥ لَيْسَ مِنْ أَهْلِكَ ۖ إِنَّهُۥ عَمَلٌ غَيْرُ صَٰلِحٍۢ ۖ فَلَا تَسْـَٔلْنِ مَا لَيْسَ لَكَ بِهِۦ عِلْمٌ ۖ إِنِّىٓ أَعِظُكَ أَن تَكُونَ مِنَ ٱلْجَٰهِلِينَ',
		number_in_surah: '46',
		page: '227',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1520',
		number: '1520',
		text: 'قَالَ رَبِّ إِنِّىٓ أَعُوذُ بِكَ أَنْ أَسْـَٔلَكَ مَا لَيْسَ لِى بِهِۦ عِلْمٌۭ ۖ وَإِلَّا تَغْفِرْ لِى وَتَرْحَمْنِىٓ أَكُن مِّنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '47',
		page: '227',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1521',
		number: '1521',
		text: 'قِيلَ يَٰنُوحُ ٱهْبِطْ بِسَلَٰمٍۢ مِّنَّا وَبَرَكَٰتٍ عَلَيْكَ وَعَلَىٰٓ أُمَمٍۢ مِّمَّن مَّعَكَ ۚ وَأُمَمٌۭ سَنُمَتِّعُهُمْ ثُمَّ يَمَسُّهُم مِّنَّا عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '48',
		page: '227',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1522',
		number: '1522',
		text: 'تِلْكَ مِنْ أَنۢبَآءِ ٱلْغَيْبِ نُوحِيهَآ إِلَيْكَ ۖ مَا كُنتَ تَعْلَمُهَآ أَنتَ وَلَا قَوْمُكَ مِن قَبْلِ هَٰذَا ۖ فَٱصْبِرْ ۖ إِنَّ ٱلْعَٰقِبَةَ لِلْمُتَّقِينَ',
		number_in_surah: '49',
		page: '227',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1523',
		number: '1523',
		text: 'وَإِلَىٰ عَادٍ أَخَاهُمْ هُودًۭا ۚ قَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥٓ ۖ إِنْ أَنتُمْ إِلَّا مُفْتَرُونَ',
		number_in_surah: '50',
		page: '227',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1524',
		number: '1524',
		text: 'يَٰقَوْمِ لَآ أَسْـَٔلُكُمْ عَلَيْهِ أَجْرًا ۖ إِنْ أَجْرِىَ إِلَّا عَلَى ٱلَّذِى فَطَرَنِىٓ ۚ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '51',
		page: '227',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1525',
		number: '1525',
		text: 'وَيَٰقَوْمِ ٱسْتَغْفِرُوا۟ رَبَّكُمْ ثُمَّ تُوبُوٓا۟ إِلَيْهِ يُرْسِلِ ٱلسَّمَآءَ عَلَيْكُم مِّدْرَارًۭا وَيَزِدْكُمْ قُوَّةً إِلَىٰ قُوَّتِكُمْ وَلَا تَتَوَلَّوْا۟ مُجْرِمِينَ',
		number_in_surah: '52',
		page: '227',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1526',
		number: '1526',
		text: 'قَالُوا۟ يَٰهُودُ مَا جِئْتَنَا بِبَيِّنَةٍۢ وَمَا نَحْنُ بِتَارِكِىٓ ءَالِهَتِنَا عَن قَوْلِكَ وَمَا نَحْنُ لَكَ بِمُؤْمِنِينَ',
		number_in_surah: '53',
		page: '227',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1527',
		number: '1527',
		text: 'إِن نَّقُولُ إِلَّا ٱعْتَرَىٰكَ بَعْضُ ءَالِهَتِنَا بِسُوٓءٍۢ ۗ قَالَ إِنِّىٓ أُشْهِدُ ٱللَّهَ وَٱشْهَدُوٓا۟ أَنِّى بَرِىٓءٌۭ مِّمَّا تُشْرِكُونَ',
		number_in_surah: '54',
		page: '228',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1528',
		number: '1528',
		text: 'مِن دُونِهِۦ ۖ فَكِيدُونِى جَمِيعًۭا ثُمَّ لَا تُنظِرُونِ',
		number_in_surah: '55',
		page: '228',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1529',
		number: '1529',
		text: 'إِنِّى تَوَكَّلْتُ عَلَى ٱللَّهِ رَبِّى وَرَبِّكُم ۚ مَّا مِن دَآبَّةٍ إِلَّا هُوَ ءَاخِذٌۢ بِنَاصِيَتِهَآ ۚ إِنَّ رَبِّى عَلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '56',
		page: '228',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1530',
		number: '1530',
		text: 'فَإِن تَوَلَّوْا۟ فَقَدْ أَبْلَغْتُكُم مَّآ أُرْسِلْتُ بِهِۦٓ إِلَيْكُمْ ۚ وَيَسْتَخْلِفُ رَبِّى قَوْمًا غَيْرَكُمْ وَلَا تَضُرُّونَهُۥ شَيْـًٔا ۚ إِنَّ رَبِّى عَلَىٰ كُلِّ شَىْءٍ حَفِيظٌۭ',
		number_in_surah: '57',
		page: '228',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1531',
		number: '1531',
		text: 'وَلَمَّا جَآءَ أَمْرُنَا نَجَّيْنَا هُودًۭا وَٱلَّذِينَ ءَامَنُوا۟ مَعَهُۥ بِرَحْمَةٍۢ مِّنَّا وَنَجَّيْنَٰهُم مِّنْ عَذَابٍ غَلِيظٍۢ',
		number_in_surah: '58',
		page: '228',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1532',
		number: '1532',
		text: 'وَتِلْكَ عَادٌۭ ۖ جَحَدُوا۟ بِـَٔايَٰتِ رَبِّهِمْ وَعَصَوْا۟ رُسُلَهُۥ وَٱتَّبَعُوٓا۟ أَمْرَ كُلِّ جَبَّارٍ عَنِيدٍۢ',
		number_in_surah: '59',
		page: '228',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1533',
		number: '1533',
		text: 'وَأُتْبِعُوا۟ فِى هَٰذِهِ ٱلدُّنْيَا لَعْنَةًۭ وَيَوْمَ ٱلْقِيَٰمَةِ ۗ أَلَآ إِنَّ عَادًۭا كَفَرُوا۟ رَبَّهُمْ ۗ أَلَا بُعْدًۭا لِّعَادٍۢ قَوْمِ هُودٍۢ',
		number_in_surah: '60',
		page: '228',
		surah_id: '11',
		hizb_id: '91',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1534',
		number: '1534',
		text: '۞ وَإِلَىٰ ثَمُودَ أَخَاهُمْ صَٰلِحًۭا ۚ قَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥ ۖ هُوَ أَنشَأَكُم مِّنَ ٱلْأَرْضِ وَٱسْتَعْمَرَكُمْ فِيهَا فَٱسْتَغْفِرُوهُ ثُمَّ تُوبُوٓا۟ إِلَيْهِ ۚ إِنَّ رَبِّى قَرِيبٌۭ مُّجِيبٌۭ',
		number_in_surah: '61',
		page: '228',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1535',
		number: '1535',
		text: 'قَالُوا۟ يَٰصَٰلِحُ قَدْ كُنتَ فِينَا مَرْجُوًّۭا قَبْلَ هَٰذَآ ۖ أَتَنْهَىٰنَآ أَن نَّعْبُدَ مَا يَعْبُدُ ءَابَآؤُنَا وَإِنَّنَا لَفِى شَكٍّۢ مِّمَّا تَدْعُونَآ إِلَيْهِ مُرِيبٍۢ',
		number_in_surah: '62',
		page: '228',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1536',
		number: '1536',
		text: 'قَالَ يَٰقَوْمِ أَرَءَيْتُمْ إِن كُنتُ عَلَىٰ بَيِّنَةٍۢ مِّن رَّبِّى وَءَاتَىٰنِى مِنْهُ رَحْمَةًۭ فَمَن يَنصُرُنِى مِنَ ٱللَّهِ إِنْ عَصَيْتُهُۥ ۖ فَمَا تَزِيدُونَنِى غَيْرَ تَخْسِيرٍۢ',
		number_in_surah: '63',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1537',
		number: '1537',
		text: 'وَيَٰقَوْمِ هَٰذِهِۦ نَاقَةُ ٱللَّهِ لَكُمْ ءَايَةًۭ فَذَرُوهَا تَأْكُلْ فِىٓ أَرْضِ ٱللَّهِ وَلَا تَمَسُّوهَا بِسُوٓءٍۢ فَيَأْخُذَكُمْ عَذَابٌۭ قَرِيبٌۭ',
		number_in_surah: '64',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1538',
		number: '1538',
		text: 'فَعَقَرُوهَا فَقَالَ تَمَتَّعُوا۟ فِى دَارِكُمْ ثَلَٰثَةَ أَيَّامٍۢ ۖ ذَٰلِكَ وَعْدٌ غَيْرُ مَكْذُوبٍۢ',
		number_in_surah: '65',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1539',
		number: '1539',
		text: 'فَلَمَّا جَآءَ أَمْرُنَا نَجَّيْنَا صَٰلِحًۭا وَٱلَّذِينَ ءَامَنُوا۟ مَعَهُۥ بِرَحْمَةٍۢ مِّنَّا وَمِنْ خِزْىِ يَوْمِئِذٍ ۗ إِنَّ رَبَّكَ هُوَ ٱلْقَوِىُّ ٱلْعَزِيزُ',
		number_in_surah: '66',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1540',
		number: '1540',
		text: 'وَأَخَذَ ٱلَّذِينَ ظَلَمُوا۟ ٱلصَّيْحَةُ فَأَصْبَحُوا۟ فِى دِيَٰرِهِمْ جَٰثِمِينَ',
		number_in_surah: '67',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1541',
		number: '1541',
		text: 'كَأَن لَّمْ يَغْنَوْا۟ فِيهَآ ۗ أَلَآ إِنَّ ثَمُودَا۟ كَفَرُوا۟ رَبَّهُمْ ۗ أَلَا بُعْدًۭا لِّثَمُودَ',
		number_in_surah: '68',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1542',
		number: '1542',
		text: 'وَلَقَدْ جَآءَتْ رُسُلُنَآ إِبْرَٰهِيمَ بِٱلْبُشْرَىٰ قَالُوا۟ سَلَٰمًۭا ۖ قَالَ سَلَٰمٌۭ ۖ فَمَا لَبِثَ أَن جَآءَ بِعِجْلٍ حَنِيذٍۢ',
		number_in_surah: '69',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1543',
		number: '1543',
		text: 'فَلَمَّا رَءَآ أَيْدِيَهُمْ لَا تَصِلُ إِلَيْهِ نَكِرَهُمْ وَأَوْجَسَ مِنْهُمْ خِيفَةًۭ ۚ قَالُوا۟ لَا تَخَفْ إِنَّآ أُرْسِلْنَآ إِلَىٰ قَوْمِ لُوطٍۢ',
		number_in_surah: '70',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1544',
		number: '1544',
		text: 'وَٱمْرَأَتُهُۥ قَآئِمَةٌۭ فَضَحِكَتْ فَبَشَّرْنَٰهَا بِإِسْحَٰقَ وَمِن وَرَآءِ إِسْحَٰقَ يَعْقُوبَ',
		number_in_surah: '71',
		page: '229',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1545',
		number: '1545',
		text: 'قَالَتْ يَٰوَيْلَتَىٰٓ ءَأَلِدُ وَأَنَا۠ عَجُوزٌۭ وَهَٰذَا بَعْلِى شَيْخًا ۖ إِنَّ هَٰذَا لَشَىْءٌ عَجِيبٌۭ',
		number_in_surah: '72',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1546',
		number: '1546',
		text: 'قَالُوٓا۟ أَتَعْجَبِينَ مِنْ أَمْرِ ٱللَّهِ ۖ رَحْمَتُ ٱللَّهِ وَبَرَكَٰتُهُۥ عَلَيْكُمْ أَهْلَ ٱلْبَيْتِ ۚ إِنَّهُۥ حَمِيدٌۭ مَّجِيدٌۭ',
		number_in_surah: '73',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1547',
		number: '1547',
		text: 'فَلَمَّا ذَهَبَ عَنْ إِبْرَٰهِيمَ ٱلرَّوْعُ وَجَآءَتْهُ ٱلْبُشْرَىٰ يُجَٰدِلُنَا فِى قَوْمِ لُوطٍ',
		number_in_surah: '74',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1548',
		number: '1548',
		text: 'إِنَّ إِبْرَٰهِيمَ لَحَلِيمٌ أَوَّٰهٌۭ مُّنِيبٌۭ',
		number_in_surah: '75',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1549',
		number: '1549',
		text: 'يَٰٓإِبْرَٰهِيمُ أَعْرِضْ عَنْ هَٰذَآ ۖ إِنَّهُۥ قَدْ جَآءَ أَمْرُ رَبِّكَ ۖ وَإِنَّهُمْ ءَاتِيهِمْ عَذَابٌ غَيْرُ مَرْدُودٍۢ',
		number_in_surah: '76',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1550',
		number: '1550',
		text: 'وَلَمَّا جَآءَتْ رُسُلُنَا لُوطًۭا سِىٓءَ بِهِمْ وَضَاقَ بِهِمْ ذَرْعًۭا وَقَالَ هَٰذَا يَوْمٌ عَصِيبٌۭ',
		number_in_surah: '77',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1551',
		number: '1551',
		text: 'وَجَآءَهُۥ قَوْمُهُۥ يُهْرَعُونَ إِلَيْهِ وَمِن قَبْلُ كَانُوا۟ يَعْمَلُونَ ٱلسَّيِّـَٔاتِ ۚ قَالَ يَٰقَوْمِ هَٰٓؤُلَآءِ بَنَاتِى هُنَّ أَطْهَرُ لَكُمْ ۖ فَٱتَّقُوا۟ ٱللَّهَ وَلَا تُخْزُونِ فِى ضَيْفِىٓ ۖ أَلَيْسَ مِنكُمْ رَجُلٌۭ رَّشِيدٌۭ',
		number_in_surah: '78',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1552',
		number: '1552',
		text: 'قَالُوا۟ لَقَدْ عَلِمْتَ مَا لَنَا فِى بَنَاتِكَ مِنْ حَقٍّۢ وَإِنَّكَ لَتَعْلَمُ مَا نُرِيدُ',
		number_in_surah: '79',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1553',
		number: '1553',
		text: 'قَالَ لَوْ أَنَّ لِى بِكُمْ قُوَّةً أَوْ ءَاوِىٓ إِلَىٰ رُكْنٍۢ شَدِيدٍۢ',
		number_in_surah: '80',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1554',
		number: '1554',
		text: 'قَالُوا۟ يَٰلُوطُ إِنَّا رُسُلُ رَبِّكَ لَن يَصِلُوٓا۟ إِلَيْكَ ۖ فَأَسْرِ بِأَهْلِكَ بِقِطْعٍۢ مِّنَ ٱلَّيْلِ وَلَا يَلْتَفِتْ مِنكُمْ أَحَدٌ إِلَّا ٱمْرَأَتَكَ ۖ إِنَّهُۥ مُصِيبُهَا مَآ أَصَابَهُمْ ۚ إِنَّ مَوْعِدَهُمُ ٱلصُّبْحُ ۚ أَلَيْسَ ٱلصُّبْحُ بِقَرِيبٍۢ',
		number_in_surah: '81',
		page: '230',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1555',
		number: '1555',
		text: 'فَلَمَّا جَآءَ أَمْرُنَا جَعَلْنَا عَٰلِيَهَا سَافِلَهَا وَأَمْطَرْنَا عَلَيْهَا حِجَارَةًۭ مِّن سِجِّيلٍۢ مَّنضُودٍۢ',
		number_in_surah: '82',
		page: '231',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1556',
		number: '1556',
		text: 'مُّسَوَّمَةً عِندَ رَبِّكَ ۖ وَمَا هِىَ مِنَ ٱلظَّٰلِمِينَ بِبَعِيدٍۢ',
		number_in_surah: '83',
		page: '231',
		surah_id: '11',
		hizb_id: '92',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1557',
		number: '1557',
		text: '۞ وَإِلَىٰ مَدْيَنَ أَخَاهُمْ شُعَيْبًۭا ۚ قَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥ ۖ وَلَا تَنقُصُوا۟ ٱلْمِكْيَالَ وَٱلْمِيزَانَ ۚ إِنِّىٓ أَرَىٰكُم بِخَيْرٍۢ وَإِنِّىٓ أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍۢ مُّحِيطٍۢ',
		number_in_surah: '84',
		page: '231',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1558',
		number: '1558',
		text: 'وَيَٰقَوْمِ أَوْفُوا۟ ٱلْمِكْيَالَ وَٱلْمِيزَانَ بِٱلْقِسْطِ ۖ وَلَا تَبْخَسُوا۟ ٱلنَّاسَ أَشْيَآءَهُمْ وَلَا تَعْثَوْا۟ فِى ٱلْأَرْضِ مُفْسِدِينَ',
		number_in_surah: '85',
		page: '231',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1559',
		number: '1559',
		text: 'بَقِيَّتُ ٱللَّهِ خَيْرٌۭ لَّكُمْ إِن كُنتُم مُّؤْمِنِينَ ۚ وَمَآ أَنَا۠ عَلَيْكُم بِحَفِيظٍۢ',
		number_in_surah: '86',
		page: '231',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1560',
		number: '1560',
		text: 'قَالُوا۟ يَٰشُعَيْبُ أَصَلَوٰتُكَ تَأْمُرُكَ أَن نَّتْرُكَ مَا يَعْبُدُ ءَابَآؤُنَآ أَوْ أَن نَّفْعَلَ فِىٓ أَمْوَٰلِنَا مَا نَشَٰٓؤُا۟ ۖ إِنَّكَ لَأَنتَ ٱلْحَلِيمُ ٱلرَّشِيدُ',
		number_in_surah: '87',
		page: '231',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1561',
		number: '1561',
		text: 'قَالَ يَٰقَوْمِ أَرَءَيْتُمْ إِن كُنتُ عَلَىٰ بَيِّنَةٍۢ مِّن رَّبِّى وَرَزَقَنِى مِنْهُ رِزْقًا حَسَنًۭا ۚ وَمَآ أُرِيدُ أَنْ أُخَالِفَكُمْ إِلَىٰ مَآ أَنْهَىٰكُمْ عَنْهُ ۚ إِنْ أُرِيدُ إِلَّا ٱلْإِصْلَٰحَ مَا ٱسْتَطَعْتُ ۚ وَمَا تَوْفِيقِىٓ إِلَّا بِٱللَّهِ ۚ عَلَيْهِ تَوَكَّلْتُ وَإِلَيْهِ أُنِيبُ',
		number_in_surah: '88',
		page: '231',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1562',
		number: '1562',
		text: 'وَيَٰقَوْمِ لَا يَجْرِمَنَّكُمْ شِقَاقِىٓ أَن يُصِيبَكُم مِّثْلُ مَآ أَصَابَ قَوْمَ نُوحٍ أَوْ قَوْمَ هُودٍ أَوْ قَوْمَ صَٰلِحٍۢ ۚ وَمَا قَوْمُ لُوطٍۢ مِّنكُم بِبَعِيدٍۢ',
		number_in_surah: '89',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1563',
		number: '1563',
		text: 'وَٱسْتَغْفِرُوا۟ رَبَّكُمْ ثُمَّ تُوبُوٓا۟ إِلَيْهِ ۚ إِنَّ رَبِّى رَحِيمٌۭ وَدُودٌۭ',
		number_in_surah: '90',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1564',
		number: '1564',
		text: 'قَالُوا۟ يَٰشُعَيْبُ مَا نَفْقَهُ كَثِيرًۭا مِّمَّا تَقُولُ وَإِنَّا لَنَرَىٰكَ فِينَا ضَعِيفًۭا ۖ وَلَوْلَا رَهْطُكَ لَرَجَمْنَٰكَ ۖ وَمَآ أَنتَ عَلَيْنَا بِعَزِيزٍۢ',
		number_in_surah: '91',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1565',
		number: '1565',
		text: 'قَالَ يَٰقَوْمِ أَرَهْطِىٓ أَعَزُّ عَلَيْكُم مِّنَ ٱللَّهِ وَٱتَّخَذْتُمُوهُ وَرَآءَكُمْ ظِهْرِيًّا ۖ إِنَّ رَبِّى بِمَا تَعْمَلُونَ مُحِيطٌۭ',
		number_in_surah: '92',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1566',
		number: '1566',
		text: 'وَيَٰقَوْمِ ٱعْمَلُوا۟ عَلَىٰ مَكَانَتِكُمْ إِنِّى عَٰمِلٌۭ ۖ سَوْفَ تَعْلَمُونَ مَن يَأْتِيهِ عَذَابٌۭ يُخْزِيهِ وَمَنْ هُوَ كَٰذِبٌۭ ۖ وَٱرْتَقِبُوٓا۟ إِنِّى مَعَكُمْ رَقِيبٌۭ',
		number_in_surah: '93',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1567',
		number: '1567',
		text: 'وَلَمَّا جَآءَ أَمْرُنَا نَجَّيْنَا شُعَيْبًۭا وَٱلَّذِينَ ءَامَنُوا۟ مَعَهُۥ بِرَحْمَةٍۢ مِّنَّا وَأَخَذَتِ ٱلَّذِينَ ظَلَمُوا۟ ٱلصَّيْحَةُ فَأَصْبَحُوا۟ فِى دِيَٰرِهِمْ جَٰثِمِينَ',
		number_in_surah: '94',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1568',
		number: '1568',
		text: 'كَأَن لَّمْ يَغْنَوْا۟ فِيهَآ ۗ أَلَا بُعْدًۭا لِّمَدْيَنَ كَمَا بَعِدَتْ ثَمُودُ',
		number_in_surah: '95',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1569',
		number: '1569',
		text: 'وَلَقَدْ أَرْسَلْنَا مُوسَىٰ بِـَٔايَٰتِنَا وَسُلْطَٰنٍۢ مُّبِينٍ',
		number_in_surah: '96',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1570',
		number: '1570',
		text: 'إِلَىٰ فِرْعَوْنَ وَمَلَإِي۟هِۦ فَٱتَّبَعُوٓا۟ أَمْرَ فِرْعَوْنَ ۖ وَمَآ أَمْرُ فِرْعَوْنَ بِرَشِيدٍۢ',
		number_in_surah: '97',
		page: '232',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1571',
		number: '1571',
		text: 'يَقْدُمُ قَوْمَهُۥ يَوْمَ ٱلْقِيَٰمَةِ فَأَوْرَدَهُمُ ٱلنَّارَ ۖ وَبِئْسَ ٱلْوِرْدُ ٱلْمَوْرُودُ',
		number_in_surah: '98',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1572',
		number: '1572',
		text: 'وَأُتْبِعُوا۟ فِى هَٰذِهِۦ لَعْنَةًۭ وَيَوْمَ ٱلْقِيَٰمَةِ ۚ بِئْسَ ٱلرِّفْدُ ٱلْمَرْفُودُ',
		number_in_surah: '99',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1573',
		number: '1573',
		text: 'ذَٰلِكَ مِنْ أَنۢبَآءِ ٱلْقُرَىٰ نَقُصُّهُۥ عَلَيْكَ ۖ مِنْهَا قَآئِمٌۭ وَحَصِيدٌۭ',
		number_in_surah: '100',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1574',
		number: '1574',
		text: 'وَمَا ظَلَمْنَٰهُمْ وَلَٰكِن ظَلَمُوٓا۟ أَنفُسَهُمْ ۖ فَمَآ أَغْنَتْ عَنْهُمْ ءَالِهَتُهُمُ ٱلَّتِى يَدْعُونَ مِن دُونِ ٱللَّهِ مِن شَىْءٍۢ لَّمَّا جَآءَ أَمْرُ رَبِّكَ ۖ وَمَا زَادُوهُمْ غَيْرَ تَتْبِيبٍۢ',
		number_in_surah: '101',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1575',
		number: '1575',
		text: 'وَكَذَٰلِكَ أَخْذُ رَبِّكَ إِذَآ أَخَذَ ٱلْقُرَىٰ وَهِىَ ظَٰلِمَةٌ ۚ إِنَّ أَخْذَهُۥٓ أَلِيمٌۭ شَدِيدٌ',
		number_in_surah: '102',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1576',
		number: '1576',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّمَنْ خَافَ عَذَابَ ٱلْءَاخِرَةِ ۚ ذَٰلِكَ يَوْمٌۭ مَّجْمُوعٌۭ لَّهُ ٱلنَّاسُ وَذَٰلِكَ يَوْمٌۭ مَّشْهُودٌۭ',
		number_in_surah: '103',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1577',
		number: '1577',
		text: 'وَمَا نُؤَخِّرُهُۥٓ إِلَّا لِأَجَلٍۢ مَّعْدُودٍۢ',
		number_in_surah: '104',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1578',
		number: '1578',
		text: 'يَوْمَ يَأْتِ لَا تَكَلَّمُ نَفْسٌ إِلَّا بِإِذْنِهِۦ ۚ فَمِنْهُمْ شَقِىٌّۭ وَسَعِيدٌۭ',
		number_in_surah: '105',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1579',
		number: '1579',
		text: 'فَأَمَّا ٱلَّذِينَ شَقُوا۟ فَفِى ٱلنَّارِ لَهُمْ فِيهَا زَفِيرٌۭ وَشَهِيقٌ',
		number_in_surah: '106',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1580',
		number: '1580',
		text: 'خَٰلِدِينَ فِيهَا مَا دَامَتِ ٱلسَّمَٰوَٰتُ وَٱلْأَرْضُ إِلَّا مَا شَآءَ رَبُّكَ ۚ إِنَّ رَبَّكَ فَعَّالٌۭ لِّمَا يُرِيدُ',
		number_in_surah: '107',
		page: '233',
		surah_id: '11',
		hizb_id: '93',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1581',
		number: '1581',
		text: '۞ وَأَمَّا ٱلَّذِينَ سُعِدُوا۟ فَفِى ٱلْجَنَّةِ خَٰلِدِينَ فِيهَا مَا دَامَتِ ٱلسَّمَٰوَٰتُ وَٱلْأَرْضُ إِلَّا مَا شَآءَ رَبُّكَ ۖ عَطَآءً غَيْرَ مَجْذُوذٍۢ',
		number_in_surah: '108',
		page: '233',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1582',
		number: '1582',
		text: 'فَلَا تَكُ فِى مِرْيَةٍۢ مِّمَّا يَعْبُدُ هَٰٓؤُلَآءِ ۚ مَا يَعْبُدُونَ إِلَّا كَمَا يَعْبُدُ ءَابَآؤُهُم مِّن قَبْلُ ۚ وَإِنَّا لَمُوَفُّوهُمْ نَصِيبَهُمْ غَيْرَ مَنقُوصٍۢ',
		number_in_surah: '109',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1583',
		number: '1583',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ فَٱخْتُلِفَ فِيهِ ۚ وَلَوْلَا كَلِمَةٌۭ سَبَقَتْ مِن رَّبِّكَ لَقُضِىَ بَيْنَهُمْ ۚ وَإِنَّهُمْ لَفِى شَكٍّۢ مِّنْهُ مُرِيبٍۢ',
		number_in_surah: '110',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1584',
		number: '1584',
		text: 'وَإِنَّ كُلًّۭا لَّمَّا لَيُوَفِّيَنَّهُمْ رَبُّكَ أَعْمَٰلَهُمْ ۚ إِنَّهُۥ بِمَا يَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '111',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1585',
		number: '1585',
		text: 'فَٱسْتَقِمْ كَمَآ أُمِرْتَ وَمَن تَابَ مَعَكَ وَلَا تَطْغَوْا۟ ۚ إِنَّهُۥ بِمَا تَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '112',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1586',
		number: '1586',
		text: 'وَلَا تَرْكَنُوٓا۟ إِلَى ٱلَّذِينَ ظَلَمُوا۟ فَتَمَسَّكُمُ ٱلنَّارُ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِنْ أَوْلِيَآءَ ثُمَّ لَا تُنصَرُونَ',
		number_in_surah: '113',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1587',
		number: '1587',
		text: 'وَأَقِمِ ٱلصَّلَوٰةَ طَرَفَىِ ٱلنَّهَارِ وَزُلَفًۭا مِّنَ ٱلَّيْلِ ۚ إِنَّ ٱلْحَسَنَٰتِ يُذْهِبْنَ ٱلسَّيِّـَٔاتِ ۚ ذَٰلِكَ ذِكْرَىٰ لِلذَّٰكِرِينَ',
		number_in_surah: '114',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1588',
		number: '1588',
		text: 'وَٱصْبِرْ فَإِنَّ ٱللَّهَ لَا يُضِيعُ أَجْرَ ٱلْمُحْسِنِينَ',
		number_in_surah: '115',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1589',
		number: '1589',
		text: 'فَلَوْلَا كَانَ مِنَ ٱلْقُرُونِ مِن قَبْلِكُمْ أُو۟لُوا۟ بَقِيَّةٍۢ يَنْهَوْنَ عَنِ ٱلْفَسَادِ فِى ٱلْأَرْضِ إِلَّا قَلِيلًۭا مِّمَّنْ أَنجَيْنَا مِنْهُمْ ۗ وَٱتَّبَعَ ٱلَّذِينَ ظَلَمُوا۟ مَآ أُتْرِفُوا۟ فِيهِ وَكَانُوا۟ مُجْرِمِينَ',
		number_in_surah: '116',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1590',
		number: '1590',
		text: 'وَمَا كَانَ رَبُّكَ لِيُهْلِكَ ٱلْقُرَىٰ بِظُلْمٍۢ وَأَهْلُهَا مُصْلِحُونَ',
		number_in_surah: '117',
		page: '234',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1591',
		number: '1591',
		text: 'وَلَوْ شَآءَ رَبُّكَ لَجَعَلَ ٱلنَّاسَ أُمَّةًۭ وَٰحِدَةًۭ ۖ وَلَا يَزَالُونَ مُخْتَلِفِينَ',
		number_in_surah: '118',
		page: '235',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1592',
		number: '1592',
		text: 'إِلَّا مَن رَّحِمَ رَبُّكَ ۚ وَلِذَٰلِكَ خَلَقَهُمْ ۗ وَتَمَّتْ كَلِمَةُ رَبِّكَ لَأَمْلَأَنَّ جَهَنَّمَ مِنَ ٱلْجِنَّةِ وَٱلنَّاسِ أَجْمَعِينَ',
		number_in_surah: '119',
		page: '235',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1593',
		number: '1593',
		text: 'وَكُلًّۭا نَّقُصُّ عَلَيْكَ مِنْ أَنۢبَآءِ ٱلرُّسُلِ مَا نُثَبِّتُ بِهِۦ فُؤَادَكَ ۚ وَجَآءَكَ فِى هَٰذِهِ ٱلْحَقُّ وَمَوْعِظَةٌۭ وَذِكْرَىٰ لِلْمُؤْمِنِينَ',
		number_in_surah: '120',
		page: '235',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1594',
		number: '1594',
		text: 'وَقُل لِّلَّذِينَ لَا يُؤْمِنُونَ ٱعْمَلُوا۟ عَلَىٰ مَكَانَتِكُمْ إِنَّا عَٰمِلُونَ',
		number_in_surah: '121',
		page: '235',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1595',
		number: '1595',
		text: 'وَٱنتَظِرُوٓا۟ إِنَّا مُنتَظِرُونَ',
		number_in_surah: '122',
		page: '235',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1596',
		number: '1596',
		text: 'وَلِلَّهِ غَيْبُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَإِلَيْهِ يُرْجَعُ ٱلْأَمْرُ كُلُّهُۥ فَٱعْبُدْهُ وَتَوَكَّلْ عَلَيْهِ ۚ وَمَا رَبُّكَ بِغَٰفِلٍ عَمَّا تَعْمَلُونَ',
		number_in_surah: '123',
		page: '235',
		surah_id: '11',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1597',
		number: '1597',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓر ۚ تِلْكَ ءَايَٰتُ ٱلْكِتَٰبِ ٱلْمُبِينِ',
		number_in_surah: '1',
		page: '235',
		surah_id: '12',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1598',
		number: '1598',
		text: 'إِنَّآ أَنزَلْنَٰهُ قُرْءَٰنًا عَرَبِيًّۭا لَّعَلَّكُمْ تَعْقِلُونَ',
		number_in_surah: '2',
		page: '235',
		surah_id: '12',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1599',
		number: '1599',
		text: 'نَحْنُ نَقُصُّ عَلَيْكَ أَحْسَنَ ٱلْقَصَصِ بِمَآ أَوْحَيْنَآ إِلَيْكَ هَٰذَا ٱلْقُرْءَانَ وَإِن كُنتَ مِن قَبْلِهِۦ لَمِنَ ٱلْغَٰفِلِينَ',
		number_in_surah: '3',
		page: '235',
		surah_id: '12',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1600',
		number: '1600',
		text: 'إِذْ قَالَ يُوسُفُ لِأَبِيهِ يَٰٓأَبَتِ إِنِّى رَأَيْتُ أَحَدَ عَشَرَ كَوْكَبًۭا وَٱلشَّمْسَ وَٱلْقَمَرَ رَأَيْتُهُمْ لِى سَٰجِدِينَ',
		number_in_surah: '4',
		page: '235',
		surah_id: '12',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1601',
		number: '1601',
		text: 'قَالَ يَٰبُنَىَّ لَا تَقْصُصْ رُءْيَاكَ عَلَىٰٓ إِخْوَتِكَ فَيَكِيدُوا۟ لَكَ كَيْدًا ۖ إِنَّ ٱلشَّيْطَٰنَ لِلْإِنسَٰنِ عَدُوٌّۭ مُّبِينٌۭ',
		number_in_surah: '5',
		page: '236',
		surah_id: '12',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1602',
		number: '1602',
		text: 'وَكَذَٰلِكَ يَجْتَبِيكَ رَبُّكَ وَيُعَلِّمُكَ مِن تَأْوِيلِ ٱلْأَحَادِيثِ وَيُتِمُّ نِعْمَتَهُۥ عَلَيْكَ وَعَلَىٰٓ ءَالِ يَعْقُوبَ كَمَآ أَتَمَّهَا عَلَىٰٓ أَبَوَيْكَ مِن قَبْلُ إِبْرَٰهِيمَ وَإِسْحَٰقَ ۚ إِنَّ رَبَّكَ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '6',
		page: '236',
		surah_id: '12',
		hizb_id: '94',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1603',
		number: '1603',
		text: '۞ لَّقَدْ كَانَ فِى يُوسُفَ وَإِخْوَتِهِۦٓ ءَايَٰتٌۭ لِّلسَّآئِلِينَ',
		number_in_surah: '7',
		page: '236',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1604',
		number: '1604',
		text: 'إِذْ قَالُوا۟ لَيُوسُفُ وَأَخُوهُ أَحَبُّ إِلَىٰٓ أَبِينَا مِنَّا وَنَحْنُ عُصْبَةٌ إِنَّ أَبَانَا لَفِى ضَلَٰلٍۢ مُّبِينٍ',
		number_in_surah: '8',
		page: '236',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1605',
		number: '1605',
		text: 'ٱقْتُلُوا۟ يُوسُفَ أَوِ ٱطْرَحُوهُ أَرْضًۭا يَخْلُ لَكُمْ وَجْهُ أَبِيكُمْ وَتَكُونُوا۟ مِنۢ بَعْدِهِۦ قَوْمًۭا صَٰلِحِينَ',
		number_in_surah: '9',
		page: '236',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1606',
		number: '1606',
		text: 'قَالَ قَآئِلٌۭ مِّنْهُمْ لَا تَقْتُلُوا۟ يُوسُفَ وَأَلْقُوهُ فِى غَيَٰبَتِ ٱلْجُبِّ يَلْتَقِطْهُ بَعْضُ ٱلسَّيَّارَةِ إِن كُنتُمْ فَٰعِلِينَ',
		number_in_surah: '10',
		page: '236',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1607',
		number: '1607',
		text: 'قَالُوا۟ يَٰٓأَبَانَا مَا لَكَ لَا تَأْمَ۫نَّا عَلَىٰ يُوسُفَ وَإِنَّا لَهُۥ لَنَٰصِحُونَ',
		number_in_surah: '11',
		page: '236',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1608',
		number: '1608',
		text: 'أَرْسِلْهُ مَعَنَا غَدًۭا يَرْتَعْ وَيَلْعَبْ وَإِنَّا لَهُۥ لَحَٰفِظُونَ',
		number_in_surah: '12',
		page: '236',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1609',
		number: '1609',
		text: 'قَالَ إِنِّى لَيَحْزُنُنِىٓ أَن تَذْهَبُوا۟ بِهِۦ وَأَخَافُ أَن يَأْكُلَهُ ٱلذِّئْبُ وَأَنتُمْ عَنْهُ غَٰفِلُونَ',
		number_in_surah: '13',
		page: '236',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1610',
		number: '1610',
		text: 'قَالُوا۟ لَئِنْ أَكَلَهُ ٱلذِّئْبُ وَنَحْنُ عُصْبَةٌ إِنَّآ إِذًۭا لَّخَٰسِرُونَ',
		number_in_surah: '14',
		page: '236',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1611',
		number: '1611',
		text: 'فَلَمَّا ذَهَبُوا۟ بِهِۦ وَأَجْمَعُوٓا۟ أَن يَجْعَلُوهُ فِى غَيَٰبَتِ ٱلْجُبِّ ۚ وَأَوْحَيْنَآ إِلَيْهِ لَتُنَبِّئَنَّهُم بِأَمْرِهِمْ هَٰذَا وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '15',
		page: '237',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1612',
		number: '1612',
		text: 'وَجَآءُوٓ أَبَاهُمْ عِشَآءًۭ يَبْكُونَ',
		number_in_surah: '16',
		page: '237',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1613',
		number: '1613',
		text: 'قَالُوا۟ يَٰٓأَبَانَآ إِنَّا ذَهَبْنَا نَسْتَبِقُ وَتَرَكْنَا يُوسُفَ عِندَ مَتَٰعِنَا فَأَكَلَهُ ٱلذِّئْبُ ۖ وَمَآ أَنتَ بِمُؤْمِنٍۢ لَّنَا وَلَوْ كُنَّا صَٰدِقِينَ',
		number_in_surah: '17',
		page: '237',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1614',
		number: '1614',
		text: 'وَجَآءُو عَلَىٰ قَمِيصِهِۦ بِدَمٍۢ كَذِبٍۢ ۚ قَالَ بَلْ سَوَّلَتْ لَكُمْ أَنفُسُكُمْ أَمْرًۭا ۖ فَصَبْرٌۭ جَمِيلٌۭ ۖ وَٱللَّهُ ٱلْمُسْتَعَانُ عَلَىٰ مَا تَصِفُونَ',
		number_in_surah: '18',
		page: '237',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1615',
		number: '1615',
		text: 'وَجَآءَتْ سَيَّارَةٌۭ فَأَرْسَلُوا۟ وَارِدَهُمْ فَأَدْلَىٰ دَلْوَهُۥ ۖ قَالَ يَٰبُشْرَىٰ هَٰذَا غُلَٰمٌۭ ۚ وَأَسَرُّوهُ بِضَٰعَةًۭ ۚ وَٱللَّهُ عَلِيمٌۢ بِمَا يَعْمَلُونَ',
		number_in_surah: '19',
		page: '237',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1616',
		number: '1616',
		text: 'وَشَرَوْهُ بِثَمَنٍۭ بَخْسٍۢ دَرَٰهِمَ مَعْدُودَةٍۢ وَكَانُوا۟ فِيهِ مِنَ ٱلزَّٰهِدِينَ',
		number_in_surah: '20',
		page: '237',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1617',
		number: '1617',
		text: 'وَقَالَ ٱلَّذِى ٱشْتَرَىٰهُ مِن مِّصْرَ لِٱمْرَأَتِهِۦٓ أَكْرِمِى مَثْوَىٰهُ عَسَىٰٓ أَن يَنفَعَنَآ أَوْ نَتَّخِذَهُۥ وَلَدًۭا ۚ وَكَذَٰلِكَ مَكَّنَّا لِيُوسُفَ فِى ٱلْأَرْضِ وَلِنُعَلِّمَهُۥ مِن تَأْوِيلِ ٱلْأَحَادِيثِ ۚ وَٱللَّهُ غَالِبٌ عَلَىٰٓ أَمْرِهِۦ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '21',
		page: '237',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1618',
		number: '1618',
		text: 'وَلَمَّا بَلَغَ أَشُدَّهُۥٓ ءَاتَيْنَٰهُ حُكْمًۭا وَعِلْمًۭا ۚ وَكَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '22',
		page: '237',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1619',
		number: '1619',
		text: 'وَرَٰوَدَتْهُ ٱلَّتِى هُوَ فِى بَيْتِهَا عَن نَّفْسِهِۦ وَغَلَّقَتِ ٱلْأَبْوَٰبَ وَقَالَتْ هَيْتَ لَكَ ۚ قَالَ مَعَاذَ ٱللَّهِ ۖ إِنَّهُۥ رَبِّىٓ أَحْسَنَ مَثْوَاىَ ۖ إِنَّهُۥ لَا يُفْلِحُ ٱلظَّٰلِمُونَ',
		number_in_surah: '23',
		page: '238',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1620',
		number: '1620',
		text: 'وَلَقَدْ هَمَّتْ بِهِۦ ۖ وَهَمَّ بِهَا لَوْلَآ أَن رَّءَا بُرْهَٰنَ رَبِّهِۦ ۚ كَذَٰلِكَ لِنَصْرِفَ عَنْهُ ٱلسُّوٓءَ وَٱلْفَحْشَآءَ ۚ إِنَّهُۥ مِنْ عِبَادِنَا ٱلْمُخْلَصِينَ',
		number_in_surah: '24',
		page: '238',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1621',
		number: '1621',
		text: 'وَٱسْتَبَقَا ٱلْبَابَ وَقَدَّتْ قَمِيصَهُۥ مِن دُبُرٍۢ وَأَلْفَيَا سَيِّدَهَا لَدَا ٱلْبَابِ ۚ قَالَتْ مَا جَزَآءُ مَنْ أَرَادَ بِأَهْلِكَ سُوٓءًا إِلَّآ أَن يُسْجَنَ أَوْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '25',
		page: '238',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1622',
		number: '1622',
		text: 'قَالَ هِىَ رَٰوَدَتْنِى عَن نَّفْسِى ۚ وَشَهِدَ شَاهِدٌۭ مِّنْ أَهْلِهَآ إِن كَانَ قَمِيصُهُۥ قُدَّ مِن قُبُلٍۢ فَصَدَقَتْ وَهُوَ مِنَ ٱلْكَٰذِبِينَ',
		number_in_surah: '26',
		page: '238',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1623',
		number: '1623',
		text: 'وَإِن كَانَ قَمِيصُهُۥ قُدَّ مِن دُبُرٍۢ فَكَذَبَتْ وَهُوَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '27',
		page: '238',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1624',
		number: '1624',
		text: 'فَلَمَّا رَءَا قَمِيصَهُۥ قُدَّ مِن دُبُرٍۢ قَالَ إِنَّهُۥ مِن كَيْدِكُنَّ ۖ إِنَّ كَيْدَكُنَّ عَظِيمٌۭ',
		number_in_surah: '28',
		page: '238',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1625',
		number: '1625',
		text: 'يُوسُفُ أَعْرِضْ عَنْ هَٰذَا ۚ وَٱسْتَغْفِرِى لِذَنۢبِكِ ۖ إِنَّكِ كُنتِ مِنَ ٱلْخَاطِـِٔينَ',
		number_in_surah: '29',
		page: '238',
		surah_id: '12',
		hizb_id: '95',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1626',
		number: '1626',
		text: '۞ وَقَالَ نِسْوَةٌۭ فِى ٱلْمَدِينَةِ ٱمْرَأَتُ ٱلْعَزِيزِ تُرَٰوِدُ فَتَىٰهَا عَن نَّفْسِهِۦ ۖ قَدْ شَغَفَهَا حُبًّا ۖ إِنَّا لَنَرَىٰهَا فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '30',
		page: '238',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1627',
		number: '1627',
		text: 'فَلَمَّا سَمِعَتْ بِمَكْرِهِنَّ أَرْسَلَتْ إِلَيْهِنَّ وَأَعْتَدَتْ لَهُنَّ مُتَّكَـًۭٔا وَءَاتَتْ كُلَّ وَٰحِدَةٍۢ مِّنْهُنَّ سِكِّينًۭا وَقَالَتِ ٱخْرُجْ عَلَيْهِنَّ ۖ فَلَمَّا رَأَيْنَهُۥٓ أَكْبَرْنَهُۥ وَقَطَّعْنَ أَيْدِيَهُنَّ وَقُلْنَ حَٰشَ لِلَّهِ مَا هَٰذَا بَشَرًا إِنْ هَٰذَآ إِلَّا مَلَكٌۭ كَرِيمٌۭ',
		number_in_surah: '31',
		page: '239',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1628',
		number: '1628',
		text: 'قَالَتْ فَذَٰلِكُنَّ ٱلَّذِى لُمْتُنَّنِى فِيهِ ۖ وَلَقَدْ رَٰوَدتُّهُۥ عَن نَّفْسِهِۦ فَٱسْتَعْصَمَ ۖ وَلَئِن لَّمْ يَفْعَلْ مَآ ءَامُرُهُۥ لَيُسْجَنَنَّ وَلَيَكُونًۭا مِّنَ ٱلصَّٰغِرِينَ',
		number_in_surah: '32',
		page: '239',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1629',
		number: '1629',
		text: 'قَالَ رَبِّ ٱلسِّجْنُ أَحَبُّ إِلَىَّ مِمَّا يَدْعُونَنِىٓ إِلَيْهِ ۖ وَإِلَّا تَصْرِفْ عَنِّى كَيْدَهُنَّ أَصْبُ إِلَيْهِنَّ وَأَكُن مِّنَ ٱلْجَٰهِلِينَ',
		number_in_surah: '33',
		page: '239',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1630',
		number: '1630',
		text: 'فَٱسْتَجَابَ لَهُۥ رَبُّهُۥ فَصَرَفَ عَنْهُ كَيْدَهُنَّ ۚ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '34',
		page: '239',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1631',
		number: '1631',
		text: 'ثُمَّ بَدَا لَهُم مِّنۢ بَعْدِ مَا رَأَوُا۟ ٱلْءَايَٰتِ لَيَسْجُنُنَّهُۥ حَتَّىٰ حِينٍۢ',
		number_in_surah: '35',
		page: '239',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1632',
		number: '1632',
		text: 'وَدَخَلَ مَعَهُ ٱلسِّجْنَ فَتَيَانِ ۖ قَالَ أَحَدُهُمَآ إِنِّىٓ أَرَىٰنِىٓ أَعْصِرُ خَمْرًۭا ۖ وَقَالَ ٱلْءَاخَرُ إِنِّىٓ أَرَىٰنِىٓ أَحْمِلُ فَوْقَ رَأْسِى خُبْزًۭا تَأْكُلُ ٱلطَّيْرُ مِنْهُ ۖ نَبِّئْنَا بِتَأْوِيلِهِۦٓ ۖ إِنَّا نَرَىٰكَ مِنَ ٱلْمُحْسِنِينَ',
		number_in_surah: '36',
		page: '239',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1633',
		number: '1633',
		text: 'قَالَ لَا يَأْتِيكُمَا طَعَامٌۭ تُرْزَقَانِهِۦٓ إِلَّا نَبَّأْتُكُمَا بِتَأْوِيلِهِۦ قَبْلَ أَن يَأْتِيَكُمَا ۚ ذَٰلِكُمَا مِمَّا عَلَّمَنِى رَبِّىٓ ۚ إِنِّى تَرَكْتُ مِلَّةَ قَوْمٍۢ لَّا يُؤْمِنُونَ بِٱللَّهِ وَهُم بِٱلْءَاخِرَةِ هُمْ كَٰفِرُونَ',
		number_in_surah: '37',
		page: '239',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1634',
		number: '1634',
		text: 'وَٱتَّبَعْتُ مِلَّةَ ءَابَآءِىٓ إِبْرَٰهِيمَ وَإِسْحَٰقَ وَيَعْقُوبَ ۚ مَا كَانَ لَنَآ أَن نُّشْرِكَ بِٱللَّهِ مِن شَىْءٍۢ ۚ ذَٰلِكَ مِن فَضْلِ ٱللَّهِ عَلَيْنَا وَعَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَشْكُرُونَ',
		number_in_surah: '38',
		page: '240',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1635',
		number: '1635',
		text: 'يَٰصَىٰحِبَىِ ٱلسِّجْنِ ءَأَرْبَابٌۭ مُّتَفَرِّقُونَ خَيْرٌ أَمِ ٱللَّهُ ٱلْوَٰحِدُ ٱلْقَهَّارُ',
		number_in_surah: '39',
		page: '240',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1636',
		number: '1636',
		text: 'مَا تَعْبُدُونَ مِن دُونِهِۦٓ إِلَّآ أَسْمَآءًۭ سَمَّيْتُمُوهَآ أَنتُمْ وَءَابَآؤُكُم مَّآ أَنزَلَ ٱللَّهُ بِهَا مِن سُلْطَٰنٍ ۚ إِنِ ٱلْحُكْمُ إِلَّا لِلَّهِ ۚ أَمَرَ أَلَّا تَعْبُدُوٓا۟ إِلَّآ إِيَّاهُ ۚ ذَٰلِكَ ٱلدِّينُ ٱلْقَيِّمُ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '40',
		page: '240',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1637',
		number: '1637',
		text: 'يَٰصَىٰحِبَىِ ٱلسِّجْنِ أَمَّآ أَحَدُكُمَا فَيَسْقِى رَبَّهُۥ خَمْرًۭا ۖ وَأَمَّا ٱلْءَاخَرُ فَيُصْلَبُ فَتَأْكُلُ ٱلطَّيْرُ مِن رَّأْسِهِۦ ۚ قُضِىَ ٱلْأَمْرُ ٱلَّذِى فِيهِ تَسْتَفْتِيَانِ',
		number_in_surah: '41',
		page: '240',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1638',
		number: '1638',
		text: 'وَقَالَ لِلَّذِى ظَنَّ أَنَّهُۥ نَاجٍۢ مِّنْهُمَا ٱذْكُرْنِى عِندَ رَبِّكَ فَأَنسَىٰهُ ٱلشَّيْطَٰنُ ذِكْرَ رَبِّهِۦ فَلَبِثَ فِى ٱلسِّجْنِ بِضْعَ سِنِينَ',
		number_in_surah: '42',
		page: '240',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1639',
		number: '1639',
		text: 'وَقَالَ ٱلْمَلِكُ إِنِّىٓ أَرَىٰ سَبْعَ بَقَرَٰتٍۢ سِمَانٍۢ يَأْكُلُهُنَّ سَبْعٌ عِجَافٌۭ وَسَبْعَ سُنۢبُلَٰتٍ خُضْرٍۢ وَأُخَرَ يَابِسَٰتٍۢ ۖ يَٰٓأَيُّهَا ٱلْمَلَأُ أَفْتُونِى فِى رُءْيَٰىَ إِن كُنتُمْ لِلرُّءْيَا تَعْبُرُونَ',
		number_in_surah: '43',
		page: '240',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1640',
		number: '1640',
		text: 'قَالُوٓا۟ أَضْغَٰثُ أَحْلَٰمٍۢ ۖ وَمَا نَحْنُ بِتَأْوِيلِ ٱلْأَحْلَٰمِ بِعَٰلِمِينَ',
		number_in_surah: '44',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1641',
		number: '1641',
		text: 'وَقَالَ ٱلَّذِى نَجَا مِنْهُمَا وَٱدَّكَرَ بَعْدَ أُمَّةٍ أَنَا۠ أُنَبِّئُكُم بِتَأْوِيلِهِۦ فَأَرْسِلُونِ',
		number_in_surah: '45',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1642',
		number: '1642',
		text: 'يُوسُفُ أَيُّهَا ٱلصِّدِّيقُ أَفْتِنَا فِى سَبْعِ بَقَرَٰتٍۢ سِمَانٍۢ يَأْكُلُهُنَّ سَبْعٌ عِجَافٌۭ وَسَبْعِ سُنۢبُلَٰتٍ خُضْرٍۢ وَأُخَرَ يَابِسَٰتٍۢ لَّعَلِّىٓ أَرْجِعُ إِلَى ٱلنَّاسِ لَعَلَّهُمْ يَعْلَمُونَ',
		number_in_surah: '46',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1643',
		number: '1643',
		text: 'قَالَ تَزْرَعُونَ سَبْعَ سِنِينَ دَأَبًۭا فَمَا حَصَدتُّمْ فَذَرُوهُ فِى سُنۢبُلِهِۦٓ إِلَّا قَلِيلًۭا مِّمَّا تَأْكُلُونَ',
		number_in_surah: '47',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1644',
		number: '1644',
		text: 'ثُمَّ يَأْتِى مِنۢ بَعْدِ ذَٰلِكَ سَبْعٌۭ شِدَادٌۭ يَأْكُلْنَ مَا قَدَّمْتُمْ لَهُنَّ إِلَّا قَلِيلًۭا مِّمَّا تُحْصِنُونَ',
		number_in_surah: '48',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1645',
		number: '1645',
		text: 'ثُمَّ يَأْتِى مِنۢ بَعْدِ ذَٰلِكَ عَامٌۭ فِيهِ يُغَاثُ ٱلنَّاسُ وَفِيهِ يَعْصِرُونَ',
		number_in_surah: '49',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1646',
		number: '1646',
		text: 'وَقَالَ ٱلْمَلِكُ ٱئْتُونِى بِهِۦ ۖ فَلَمَّا جَآءَهُ ٱلرَّسُولُ قَالَ ٱرْجِعْ إِلَىٰ رَبِّكَ فَسْـَٔلْهُ مَا بَالُ ٱلنِّسْوَةِ ٱلَّٰتِى قَطَّعْنَ أَيْدِيَهُنَّ ۚ إِنَّ رَبِّى بِكَيْدِهِنَّ عَلِيمٌۭ',
		number_in_surah: '50',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1647',
		number: '1647',
		text: 'قَالَ مَا خَطْبُكُنَّ إِذْ رَٰوَدتُّنَّ يُوسُفَ عَن نَّفْسِهِۦ ۚ قُلْنَ حَٰشَ لِلَّهِ مَا عَلِمْنَا عَلَيْهِ مِن سُوٓءٍۢ ۚ قَالَتِ ٱمْرَأَتُ ٱلْعَزِيزِ ٱلْـَٰٔنَ حَصْحَصَ ٱلْحَقُّ أَنَا۠ رَٰوَدتُّهُۥ عَن نَّفْسِهِۦ وَإِنَّهُۥ لَمِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '51',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1648',
		number: '1648',
		text: 'ذَٰلِكَ لِيَعْلَمَ أَنِّى لَمْ أَخُنْهُ بِٱلْغَيْبِ وَأَنَّ ٱللَّهَ لَا يَهْدِى كَيْدَ ٱلْخَآئِنِينَ',
		number_in_surah: '52',
		page: '241',
		surah_id: '12',
		hizb_id: '96',
		juz_id: '12',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1649',
		number: '1649',
		text: '۞ وَمَآ أُبَرِّئُ نَفْسِىٓ ۚ إِنَّ ٱلنَّفْسَ لَأَمَّارَةٌۢ بِٱلسُّوٓءِ إِلَّا مَا رَحِمَ رَبِّىٓ ۚ إِنَّ رَبِّى غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '53',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1650',
		number: '1650',
		text: 'وَقَالَ ٱلْمَلِكُ ٱئْتُونِى بِهِۦٓ أَسْتَخْلِصْهُ لِنَفْسِى ۖ فَلَمَّا كَلَّمَهُۥ قَالَ إِنَّكَ ٱلْيَوْمَ لَدَيْنَا مَكِينٌ أَمِينٌۭ',
		number_in_surah: '54',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1651',
		number: '1651',
		text: 'قَالَ ٱجْعَلْنِى عَلَىٰ خَزَآئِنِ ٱلْأَرْضِ ۖ إِنِّى حَفِيظٌ عَلِيمٌۭ',
		number_in_surah: '55',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1652',
		number: '1652',
		text: 'وَكَذَٰلِكَ مَكَّنَّا لِيُوسُفَ فِى ٱلْأَرْضِ يَتَبَوَّأُ مِنْهَا حَيْثُ يَشَآءُ ۚ نُصِيبُ بِرَحْمَتِنَا مَن نَّشَآءُ ۖ وَلَا نُضِيعُ أَجْرَ ٱلْمُحْسِنِينَ',
		number_in_surah: '56',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1653',
		number: '1653',
		text: 'وَلَأَجْرُ ٱلْءَاخِرَةِ خَيْرٌۭ لِّلَّذِينَ ءَامَنُوا۟ وَكَانُوا۟ يَتَّقُونَ',
		number_in_surah: '57',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1654',
		number: '1654',
		text: 'وَجَآءَ إِخْوَةُ يُوسُفَ فَدَخَلُوا۟ عَلَيْهِ فَعَرَفَهُمْ وَهُمْ لَهُۥ مُنكِرُونَ',
		number_in_surah: '58',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1655',
		number: '1655',
		text: 'وَلَمَّا جَهَّزَهُم بِجَهَازِهِمْ قَالَ ٱئْتُونِى بِأَخٍۢ لَّكُم مِّنْ أَبِيكُمْ ۚ أَلَا تَرَوْنَ أَنِّىٓ أُوفِى ٱلْكَيْلَ وَأَنَا۠ خَيْرُ ٱلْمُنزِلِينَ',
		number_in_surah: '59',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1656',
		number: '1656',
		text: 'فَإِن لَّمْ تَأْتُونِى بِهِۦ فَلَا كَيْلَ لَكُمْ عِندِى وَلَا تَقْرَبُونِ',
		number_in_surah: '60',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1657',
		number: '1657',
		text: 'قَالُوا۟ سَنُرَٰوِدُ عَنْهُ أَبَاهُ وَإِنَّا لَفَٰعِلُونَ',
		number_in_surah: '61',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1658',
		number: '1658',
		text: 'وَقَالَ لِفِتْيَٰنِهِ ٱجْعَلُوا۟ بِضَٰعَتَهُمْ فِى رِحَالِهِمْ لَعَلَّهُمْ يَعْرِفُونَهَآ إِذَا ٱنقَلَبُوٓا۟ إِلَىٰٓ أَهْلِهِمْ لَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '62',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1659',
		number: '1659',
		text: 'فَلَمَّا رَجَعُوٓا۟ إِلَىٰٓ أَبِيهِمْ قَالُوا۟ يَٰٓأَبَانَا مُنِعَ مِنَّا ٱلْكَيْلُ فَأَرْسِلْ مَعَنَآ أَخَانَا نَكْتَلْ وَإِنَّا لَهُۥ لَحَٰفِظُونَ',
		number_in_surah: '63',
		page: '242',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1660',
		number: '1660',
		text: 'قَالَ هَلْ ءَامَنُكُمْ عَلَيْهِ إِلَّا كَمَآ أَمِنتُكُمْ عَلَىٰٓ أَخِيهِ مِن قَبْلُ ۖ فَٱللَّهُ خَيْرٌ حَٰفِظًۭا ۖ وَهُوَ أَرْحَمُ ٱلرَّٰحِمِينَ',
		number_in_surah: '64',
		page: '243',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1661',
		number: '1661',
		text: 'وَلَمَّا فَتَحُوا۟ مَتَٰعَهُمْ وَجَدُوا۟ بِضَٰعَتَهُمْ رُدَّتْ إِلَيْهِمْ ۖ قَالُوا۟ يَٰٓأَبَانَا مَا نَبْغِى ۖ هَٰذِهِۦ بِضَٰعَتُنَا رُدَّتْ إِلَيْنَا ۖ وَنَمِيرُ أَهْلَنَا وَنَحْفَظُ أَخَانَا وَنَزْدَادُ كَيْلَ بَعِيرٍۢ ۖ ذَٰلِكَ كَيْلٌۭ يَسِيرٌۭ',
		number_in_surah: '65',
		page: '243',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1662',
		number: '1662',
		text: 'قَالَ لَنْ أُرْسِلَهُۥ مَعَكُمْ حَتَّىٰ تُؤْتُونِ مَوْثِقًۭا مِّنَ ٱللَّهِ لَتَأْتُنَّنِى بِهِۦٓ إِلَّآ أَن يُحَاطَ بِكُمْ ۖ فَلَمَّآ ءَاتَوْهُ مَوْثِقَهُمْ قَالَ ٱللَّهُ عَلَىٰ مَا نَقُولُ وَكِيلٌۭ',
		number_in_surah: '66',
		page: '243',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1663',
		number: '1663',
		text: 'وَقَالَ يَٰبَنِىَّ لَا تَدْخُلُوا۟ مِنۢ بَابٍۢ وَٰحِدٍۢ وَٱدْخُلُوا۟ مِنْ أَبْوَٰبٍۢ مُّتَفَرِّقَةٍۢ ۖ وَمَآ أُغْنِى عَنكُم مِّنَ ٱللَّهِ مِن شَىْءٍ ۖ إِنِ ٱلْحُكْمُ إِلَّا لِلَّهِ ۖ عَلَيْهِ تَوَكَّلْتُ ۖ وَعَلَيْهِ فَلْيَتَوَكَّلِ ٱلْمُتَوَكِّلُونَ',
		number_in_surah: '67',
		page: '243',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1664',
		number: '1664',
		text: 'وَلَمَّا دَخَلُوا۟ مِنْ حَيْثُ أَمَرَهُمْ أَبُوهُم مَّا كَانَ يُغْنِى عَنْهُم مِّنَ ٱللَّهِ مِن شَىْءٍ إِلَّا حَاجَةًۭ فِى نَفْسِ يَعْقُوبَ قَضَىٰهَا ۚ وَإِنَّهُۥ لَذُو عِلْمٍۢ لِّمَا عَلَّمْنَٰهُ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '68',
		page: '243',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1665',
		number: '1665',
		text: 'وَلَمَّا دَخَلُوا۟ عَلَىٰ يُوسُفَ ءَاوَىٰٓ إِلَيْهِ أَخَاهُ ۖ قَالَ إِنِّىٓ أَنَا۠ أَخُوكَ فَلَا تَبْتَئِسْ بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '69',
		page: '243',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1666',
		number: '1666',
		text: 'فَلَمَّا جَهَّزَهُم بِجَهَازِهِمْ جَعَلَ ٱلسِّقَايَةَ فِى رَحْلِ أَخِيهِ ثُمَّ أَذَّنَ مُؤَذِّنٌ أَيَّتُهَا ٱلْعِيرُ إِنَّكُمْ لَسَٰرِقُونَ',
		number_in_surah: '70',
		page: '244',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1667',
		number: '1667',
		text: 'قَالُوا۟ وَأَقْبَلُوا۟ عَلَيْهِم مَّاذَا تَفْقِدُونَ',
		number_in_surah: '71',
		page: '244',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1668',
		number: '1668',
		text: 'قَالُوا۟ نَفْقِدُ صُوَاعَ ٱلْمَلِكِ وَلِمَن جَآءَ بِهِۦ حِمْلُ بَعِيرٍۢ وَأَنَا۠ بِهِۦ زَعِيمٌۭ',
		number_in_surah: '72',
		page: '244',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1669',
		number: '1669',
		text: 'قَالُوا۟ تَٱللَّهِ لَقَدْ عَلِمْتُم مَّا جِئْنَا لِنُفْسِدَ فِى ٱلْأَرْضِ وَمَا كُنَّا سَٰرِقِينَ',
		number_in_surah: '73',
		page: '244',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1670',
		number: '1670',
		text: 'قَالُوا۟ فَمَا جَزَٰٓؤُهُۥٓ إِن كُنتُمْ كَٰذِبِينَ',
		number_in_surah: '74',
		page: '244',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1671',
		number: '1671',
		text: 'قَالُوا۟ جَزَٰٓؤُهُۥ مَن وُجِدَ فِى رَحْلِهِۦ فَهُوَ جَزَٰٓؤُهُۥ ۚ كَذَٰلِكَ نَجْزِى ٱلظَّٰلِمِينَ',
		number_in_surah: '75',
		page: '244',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1672',
		number: '1672',
		text: 'فَبَدَأَ بِأَوْعِيَتِهِمْ قَبْلَ وِعَآءِ أَخِيهِ ثُمَّ ٱسْتَخْرَجَهَا مِن وِعَآءِ أَخِيهِ ۚ كَذَٰلِكَ كِدْنَا لِيُوسُفَ ۖ مَا كَانَ لِيَأْخُذَ أَخَاهُ فِى دِينِ ٱلْمَلِكِ إِلَّآ أَن يَشَآءَ ٱللَّهُ ۚ نَرْفَعُ دَرَجَٰتٍۢ مَّن نَّشَآءُ ۗ وَفَوْقَ كُلِّ ذِى عِلْمٍ عَلِيمٌۭ',
		number_in_surah: '76',
		page: '244',
		surah_id: '12',
		hizb_id: '97',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1673',
		number: '1673',
		text: '۞ قَالُوٓا۟ إِن يَسْرِقْ فَقَدْ سَرَقَ أَخٌۭ لَّهُۥ مِن قَبْلُ ۚ فَأَسَرَّهَا يُوسُفُ فِى نَفْسِهِۦ وَلَمْ يُبْدِهَا لَهُمْ ۚ قَالَ أَنتُمْ شَرٌّۭ مَّكَانًۭا ۖ وَٱللَّهُ أَعْلَمُ بِمَا تَصِفُونَ',
		number_in_surah: '77',
		page: '244',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1674',
		number: '1674',
		text: 'قَالُوا۟ يَٰٓأَيُّهَا ٱلْعَزِيزُ إِنَّ لَهُۥٓ أَبًۭا شَيْخًۭا كَبِيرًۭا فَخُذْ أَحَدَنَا مَكَانَهُۥٓ ۖ إِنَّا نَرَىٰكَ مِنَ ٱلْمُحْسِنِينَ',
		number_in_surah: '78',
		page: '244',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1675',
		number: '1675',
		text: 'قَالَ مَعَاذَ ٱللَّهِ أَن نَّأْخُذَ إِلَّا مَن وَجَدْنَا مَتَٰعَنَا عِندَهُۥٓ إِنَّآ إِذًۭا لَّظَٰلِمُونَ',
		number_in_surah: '79',
		page: '245',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1676',
		number: '1676',
		text: 'فَلَمَّا ٱسْتَيْـَٔسُوا۟ مِنْهُ خَلَصُوا۟ نَجِيًّۭا ۖ قَالَ كَبِيرُهُمْ أَلَمْ تَعْلَمُوٓا۟ أَنَّ أَبَاكُمْ قَدْ أَخَذَ عَلَيْكُم مَّوْثِقًۭا مِّنَ ٱللَّهِ وَمِن قَبْلُ مَا فَرَّطتُمْ فِى يُوسُفَ ۖ فَلَنْ أَبْرَحَ ٱلْأَرْضَ حَتَّىٰ يَأْذَنَ لِىٓ أَبِىٓ أَوْ يَحْكُمَ ٱللَّهُ لِى ۖ وَهُوَ خَيْرُ ٱلْحَٰكِمِينَ',
		number_in_surah: '80',
		page: '245',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1677',
		number: '1677',
		text: 'ٱرْجِعُوٓا۟ إِلَىٰٓ أَبِيكُمْ فَقُولُوا۟ يَٰٓأَبَانَآ إِنَّ ٱبْنَكَ سَرَقَ وَمَا شَهِدْنَآ إِلَّا بِمَا عَلِمْنَا وَمَا كُنَّا لِلْغَيْبِ حَٰفِظِينَ',
		number_in_surah: '81',
		page: '245',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1678',
		number: '1678',
		text: 'وَسْـَٔلِ ٱلْقَرْيَةَ ٱلَّتِى كُنَّا فِيهَا وَٱلْعِيرَ ٱلَّتِىٓ أَقْبَلْنَا فِيهَا ۖ وَإِنَّا لَصَٰدِقُونَ',
		number_in_surah: '82',
		page: '245',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1679',
		number: '1679',
		text: 'قَالَ بَلْ سَوَّلَتْ لَكُمْ أَنفُسُكُمْ أَمْرًۭا ۖ فَصَبْرٌۭ جَمِيلٌ ۖ عَسَى ٱللَّهُ أَن يَأْتِيَنِى بِهِمْ جَمِيعًا ۚ إِنَّهُۥ هُوَ ٱلْعَلِيمُ ٱلْحَكِيمُ',
		number_in_surah: '83',
		page: '245',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1680',
		number: '1680',
		text: 'وَتَوَلَّىٰ عَنْهُمْ وَقَالَ يَٰٓأَسَفَىٰ عَلَىٰ يُوسُفَ وَٱبْيَضَّتْ عَيْنَاهُ مِنَ ٱلْحُزْنِ فَهُوَ كَظِيمٌۭ',
		number_in_surah: '84',
		page: '245',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1681',
		number: '1681',
		text: 'قَالُوا۟ تَٱللَّهِ تَفْتَؤُا۟ تَذْكُرُ يُوسُفَ حَتَّىٰ تَكُونَ حَرَضًا أَوْ تَكُونَ مِنَ ٱلْهَٰلِكِينَ',
		number_in_surah: '85',
		page: '245',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1682',
		number: '1682',
		text: 'قَالَ إِنَّمَآ أَشْكُوا۟ بَثِّى وَحُزْنِىٓ إِلَى ٱللَّهِ وَأَعْلَمُ مِنَ ٱللَّهِ مَا لَا تَعْلَمُونَ',
		number_in_surah: '86',
		page: '245',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1683',
		number: '1683',
		text: 'يَٰبَنِىَّ ٱذْهَبُوا۟ فَتَحَسَّسُوا۟ مِن يُوسُفَ وَأَخِيهِ وَلَا تَا۟يْـَٔسُوا۟ مِن رَّوْحِ ٱللَّهِ ۖ إِنَّهُۥ لَا يَا۟يْـَٔسُ مِن رَّوْحِ ٱللَّهِ إِلَّا ٱلْقَوْمُ ٱلْكَٰفِرُونَ',
		number_in_surah: '87',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1684',
		number: '1684',
		text: 'فَلَمَّا دَخَلُوا۟ عَلَيْهِ قَالُوا۟ يَٰٓأَيُّهَا ٱلْعَزِيزُ مَسَّنَا وَأَهْلَنَا ٱلضُّرُّ وَجِئْنَا بِبِضَٰعَةٍۢ مُّزْجَىٰةٍۢ فَأَوْفِ لَنَا ٱلْكَيْلَ وَتَصَدَّقْ عَلَيْنَآ ۖ إِنَّ ٱللَّهَ يَجْزِى ٱلْمُتَصَدِّقِينَ',
		number_in_surah: '88',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1685',
		number: '1685',
		text: 'قَالَ هَلْ عَلِمْتُم مَّا فَعَلْتُم بِيُوسُفَ وَأَخِيهِ إِذْ أَنتُمْ جَٰهِلُونَ',
		number_in_surah: '89',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1686',
		number: '1686',
		text: 'قَالُوٓا۟ أَءِنَّكَ لَأَنتَ يُوسُفُ ۖ قَالَ أَنَا۠ يُوسُفُ وَهَٰذَآ أَخِى ۖ قَدْ مَنَّ ٱللَّهُ عَلَيْنَآ ۖ إِنَّهُۥ مَن يَتَّقِ وَيَصْبِرْ فَإِنَّ ٱللَّهَ لَا يُضِيعُ أَجْرَ ٱلْمُحْسِنِينَ',
		number_in_surah: '90',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1687',
		number: '1687',
		text: 'قَالُوا۟ تَٱللَّهِ لَقَدْ ءَاثَرَكَ ٱللَّهُ عَلَيْنَا وَإِن كُنَّا لَخَٰطِـِٔينَ',
		number_in_surah: '91',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1688',
		number: '1688',
		text: 'قَالَ لَا تَثْرِيبَ عَلَيْكُمُ ٱلْيَوْمَ ۖ يَغْفِرُ ٱللَّهُ لَكُمْ ۖ وَهُوَ أَرْحَمُ ٱلرَّٰحِمِينَ',
		number_in_surah: '92',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1689',
		number: '1689',
		text: 'ٱذْهَبُوا۟ بِقَمِيصِى هَٰذَا فَأَلْقُوهُ عَلَىٰ وَجْهِ أَبِى يَأْتِ بَصِيرًۭا وَأْتُونِى بِأَهْلِكُمْ أَجْمَعِينَ',
		number_in_surah: '93',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1690',
		number: '1690',
		text: 'وَلَمَّا فَصَلَتِ ٱلْعِيرُ قَالَ أَبُوهُمْ إِنِّى لَأَجِدُ رِيحَ يُوسُفَ ۖ لَوْلَآ أَن تُفَنِّدُونِ',
		number_in_surah: '94',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1691',
		number: '1691',
		text: 'قَالُوا۟ تَٱللَّهِ إِنَّكَ لَفِى ضَلَٰلِكَ ٱلْقَدِيمِ',
		number_in_surah: '95',
		page: '246',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1692',
		number: '1692',
		text: 'فَلَمَّآ أَن جَآءَ ٱلْبَشِيرُ أَلْقَىٰهُ عَلَىٰ وَجْهِهِۦ فَٱرْتَدَّ بَصِيرًۭا ۖ قَالَ أَلَمْ أَقُل لَّكُمْ إِنِّىٓ أَعْلَمُ مِنَ ٱللَّهِ مَا لَا تَعْلَمُونَ',
		number_in_surah: '96',
		page: '247',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1693',
		number: '1693',
		text: 'قَالُوا۟ يَٰٓأَبَانَا ٱسْتَغْفِرْ لَنَا ذُنُوبَنَآ إِنَّا كُنَّا خَٰطِـِٔينَ',
		number_in_surah: '97',
		page: '247',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1694',
		number: '1694',
		text: 'قَالَ سَوْفَ أَسْتَغْفِرُ لَكُمْ رَبِّىٓ ۖ إِنَّهُۥ هُوَ ٱلْغَفُورُ ٱلرَّحِيمُ',
		number_in_surah: '98',
		page: '247',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1695',
		number: '1695',
		text: 'فَلَمَّا دَخَلُوا۟ عَلَىٰ يُوسُفَ ءَاوَىٰٓ إِلَيْهِ أَبَوَيْهِ وَقَالَ ٱدْخُلُوا۟ مِصْرَ إِن شَآءَ ٱللَّهُ ءَامِنِينَ',
		number_in_surah: '99',
		page: '247',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1696',
		number: '1696',
		text: 'وَرَفَعَ أَبَوَيْهِ عَلَى ٱلْعَرْشِ وَخَرُّوا۟ لَهُۥ سُجَّدًۭا ۖ وَقَالَ يَٰٓأَبَتِ هَٰذَا تَأْوِيلُ رُءْيَٰىَ مِن قَبْلُ قَدْ جَعَلَهَا رَبِّى حَقًّۭا ۖ وَقَدْ أَحْسَنَ بِىٓ إِذْ أَخْرَجَنِى مِنَ ٱلسِّجْنِ وَجَآءَ بِكُم مِّنَ ٱلْبَدْوِ مِنۢ بَعْدِ أَن نَّزَغَ ٱلشَّيْطَٰنُ بَيْنِى وَبَيْنَ إِخْوَتِىٓ ۚ إِنَّ رَبِّى لَطِيفٌۭ لِّمَا يَشَآءُ ۚ إِنَّهُۥ هُوَ ٱلْعَلِيمُ ٱلْحَكِيمُ',
		number_in_surah: '100',
		page: '247',
		surah_id: '12',
		hizb_id: '98',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1697',
		number: '1697',
		text: '۞ رَبِّ قَدْ ءَاتَيْتَنِى مِنَ ٱلْمُلْكِ وَعَلَّمْتَنِى مِن تَأْوِيلِ ٱلْأَحَادِيثِ ۚ فَاطِرَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ أَنتَ وَلِىِّۦ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ ۖ تَوَفَّنِى مُسْلِمًۭا وَأَلْحِقْنِى بِٱلصَّٰلِحِينَ',
		number_in_surah: '101',
		page: '247',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1698',
		number: '1698',
		text: 'ذَٰلِكَ مِنْ أَنۢبَآءِ ٱلْغَيْبِ نُوحِيهِ إِلَيْكَ ۖ وَمَا كُنتَ لَدَيْهِمْ إِذْ أَجْمَعُوٓا۟ أَمْرَهُمْ وَهُمْ يَمْكُرُونَ',
		number_in_surah: '102',
		page: '247',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1699',
		number: '1699',
		text: 'وَمَآ أَكْثَرُ ٱلنَّاسِ وَلَوْ حَرَصْتَ بِمُؤْمِنِينَ',
		number_in_surah: '103',
		page: '247',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1700',
		number: '1700',
		text: 'وَمَا تَسْـَٔلُهُمْ عَلَيْهِ مِنْ أَجْرٍ ۚ إِنْ هُوَ إِلَّا ذِكْرٌۭ لِّلْعَٰلَمِينَ',
		number_in_surah: '104',
		page: '248',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1701',
		number: '1701',
		text: 'وَكَأَيِّن مِّنْ ءَايَةٍۢ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ يَمُرُّونَ عَلَيْهَا وَهُمْ عَنْهَا مُعْرِضُونَ',
		number_in_surah: '105',
		page: '248',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:58',
		updated_at: '2018-06-07 08:06:58',
	},
	{
		id: '1702',
		number: '1702',
		text: 'وَمَا يُؤْمِنُ أَكْثَرُهُم بِٱللَّهِ إِلَّا وَهُم مُّشْرِكُونَ',
		number_in_surah: '106',
		page: '248',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1703',
		number: '1703',
		text: 'أَفَأَمِنُوٓا۟ أَن تَأْتِيَهُمْ غَٰشِيَةٌۭ مِّنْ عَذَابِ ٱللَّهِ أَوْ تَأْتِيَهُمُ ٱلسَّاعَةُ بَغْتَةًۭ وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '107',
		page: '248',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1704',
		number: '1704',
		text: 'قُلْ هَٰذِهِۦ سَبِيلِىٓ أَدْعُوٓا۟ إِلَى ٱللَّهِ ۚ عَلَىٰ بَصِيرَةٍ أَنَا۠ وَمَنِ ٱتَّبَعَنِى ۖ وَسُبْحَٰنَ ٱللَّهِ وَمَآ أَنَا۠ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '108',
		page: '248',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1705',
		number: '1705',
		text: 'وَمَآ أَرْسَلْنَا مِن قَبْلِكَ إِلَّا رِجَالًۭا نُّوحِىٓ إِلَيْهِم مِّنْ أَهْلِ ٱلْقُرَىٰٓ ۗ أَفَلَمْ يَسِيرُوا۟ فِى ٱلْأَرْضِ فَيَنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبْلِهِمْ ۗ وَلَدَارُ ٱلْءَاخِرَةِ خَيْرٌۭ لِّلَّذِينَ ٱتَّقَوْا۟ ۗ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '109',
		page: '248',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1706',
		number: '1706',
		text: 'حَتَّىٰٓ إِذَا ٱسْتَيْـَٔسَ ٱلرُّسُلُ وَظَنُّوٓا۟ أَنَّهُمْ قَدْ كُذِبُوا۟ جَآءَهُمْ نَصْرُنَا فَنُجِّىَ مَن نَّشَآءُ ۖ وَلَا يُرَدُّ بَأْسُنَا عَنِ ٱلْقَوْمِ ٱلْمُجْرِمِينَ',
		number_in_surah: '110',
		page: '248',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1707',
		number: '1707',
		text: 'لَقَدْ كَانَ فِى قَصَصِهِمْ عِبْرَةٌۭ لِّأُو۟لِى ٱلْأَلْبَٰبِ ۗ مَا كَانَ حَدِيثًۭا يُفْتَرَىٰ وَلَٰكِن تَصْدِيقَ ٱلَّذِى بَيْنَ يَدَيْهِ وَتَفْصِيلَ كُلِّ شَىْءٍۢ وَهُدًۭى وَرَحْمَةًۭ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '111',
		page: '248',
		surah_id: '12',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1708',
		number: '1708',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓمٓر ۚ تِلْكَ ءَايَٰتُ ٱلْكِتَٰبِ ۗ وَٱلَّذِىٓ أُنزِلَ إِلَيْكَ مِن رَّبِّكَ ٱلْحَقُّ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يُؤْمِنُونَ',
		number_in_surah: '1',
		page: '249',
		surah_id: '13',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1709',
		number: '1709',
		text: 'ٱللَّهُ ٱلَّذِى رَفَعَ ٱلسَّمَٰوَٰتِ بِغَيْرِ عَمَدٍۢ تَرَوْنَهَا ۖ ثُمَّ ٱسْتَوَىٰ عَلَى ٱلْعَرْشِ ۖ وَسَخَّرَ ٱلشَّمْسَ وَٱلْقَمَرَ ۖ كُلٌّۭ يَجْرِى لِأَجَلٍۢ مُّسَمًّۭى ۚ يُدَبِّرُ ٱلْأَمْرَ يُفَصِّلُ ٱلْءَايَٰتِ لَعَلَّكُم بِلِقَآءِ رَبِّكُمْ تُوقِنُونَ',
		number_in_surah: '2',
		page: '249',
		surah_id: '13',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1710',
		number: '1710',
		text: 'وَهُوَ ٱلَّذِى مَدَّ ٱلْأَرْضَ وَجَعَلَ فِيهَا رَوَٰسِىَ وَأَنْهَٰرًۭا ۖ وَمِن كُلِّ ٱلثَّمَرَٰتِ جَعَلَ فِيهَا زَوْجَيْنِ ٱثْنَيْنِ ۖ يُغْشِى ٱلَّيْلَ ٱلنَّهَارَ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَتَفَكَّرُونَ',
		number_in_surah: '3',
		page: '249',
		surah_id: '13',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1711',
		number: '1711',
		text: 'وَفِى ٱلْأَرْضِ قِطَعٌۭ مُّتَجَٰوِرَٰتٌۭ وَجَنَّٰتٌۭ مِّنْ أَعْنَٰبٍۢ وَزَرْعٌۭ وَنَخِيلٌۭ صِنْوَانٌۭ وَغَيْرُ صِنْوَانٍۢ يُسْقَىٰ بِمَآءٍۢ وَٰحِدٍۢ وَنُفَضِّلُ بَعْضَهَا عَلَىٰ بَعْضٍۢ فِى ٱلْأُكُلِ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَعْقِلُونَ',
		number_in_surah: '4',
		page: '249',
		surah_id: '13',
		hizb_id: '99',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1712',
		number: '1712',
		text: '۞ وَإِن تَعْجَبْ فَعَجَبٌۭ قَوْلُهُمْ أَءِذَا كُنَّا تُرَٰبًا أَءِنَّا لَفِى خَلْقٍۢ جَدِيدٍ ۗ أُو۟لَٰٓئِكَ ٱلَّذِينَ كَفَرُوا۟ بِرَبِّهِمْ ۖ وَأُو۟لَٰٓئِكَ ٱلْأَغْلَٰلُ فِىٓ أَعْنَاقِهِمْ ۖ وَأُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '5',
		page: '249',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1713',
		number: '1713',
		text: 'وَيَسْتَعْجِلُونَكَ بِٱلسَّيِّئَةِ قَبْلَ ٱلْحَسَنَةِ وَقَدْ خَلَتْ مِن قَبْلِهِمُ ٱلْمَثُلَٰتُ ۗ وَإِنَّ رَبَّكَ لَذُو مَغْفِرَةٍۢ لِّلنَّاسِ عَلَىٰ ظُلْمِهِمْ ۖ وَإِنَّ رَبَّكَ لَشَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '6',
		page: '250',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1714',
		number: '1714',
		text: 'وَيَقُولُ ٱلَّذِينَ كَفَرُوا۟ لَوْلَآ أُنزِلَ عَلَيْهِ ءَايَةٌۭ مِّن رَّبِّهِۦٓ ۗ إِنَّمَآ أَنتَ مُنذِرٌۭ ۖ وَلِكُلِّ قَوْمٍ هَادٍ',
		number_in_surah: '7',
		page: '250',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1715',
		number: '1715',
		text: 'ٱللَّهُ يَعْلَمُ مَا تَحْمِلُ كُلُّ أُنثَىٰ وَمَا تَغِيضُ ٱلْأَرْحَامُ وَمَا تَزْدَادُ ۖ وَكُلُّ شَىْءٍ عِندَهُۥ بِمِقْدَارٍ',
		number_in_surah: '8',
		page: '250',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1716',
		number: '1716',
		text: 'عَٰلِمُ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ ٱلْكَبِيرُ ٱلْمُتَعَالِ',
		number_in_surah: '9',
		page: '250',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1717',
		number: '1717',
		text: 'سَوَآءٌۭ مِّنكُم مَّنْ أَسَرَّ ٱلْقَوْلَ وَمَن جَهَرَ بِهِۦ وَمَنْ هُوَ مُسْتَخْفٍۭ بِٱلَّيْلِ وَسَارِبٌۢ بِٱلنَّهَارِ',
		number_in_surah: '10',
		page: '250',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1718',
		number: '1718',
		text: 'لَهُۥ مُعَقِّبَٰتٌۭ مِّنۢ بَيْنِ يَدَيْهِ وَمِنْ خَلْفِهِۦ يَحْفَظُونَهُۥ مِنْ أَمْرِ ٱللَّهِ ۗ إِنَّ ٱللَّهَ لَا يُغَيِّرُ مَا بِقَوْمٍ حَتَّىٰ يُغَيِّرُوا۟ مَا بِأَنفُسِهِمْ ۗ وَإِذَآ أَرَادَ ٱللَّهُ بِقَوْمٍۢ سُوٓءًۭا فَلَا مَرَدَّ لَهُۥ ۚ وَمَا لَهُم مِّن دُونِهِۦ مِن وَالٍ',
		number_in_surah: '11',
		page: '250',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1719',
		number: '1719',
		text: 'هُوَ ٱلَّذِى يُرِيكُمُ ٱلْبَرْقَ خَوْفًۭا وَطَمَعًۭا وَيُنشِئُ ٱلسَّحَابَ ٱلثِّقَالَ',
		number_in_surah: '12',
		page: '250',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1720',
		number: '1720',
		text: 'وَيُسَبِّحُ ٱلرَّعْدُ بِحَمْدِهِۦ وَٱلْمَلَٰٓئِكَةُ مِنْ خِيفَتِهِۦ وَيُرْسِلُ ٱلصَّوَٰعِقَ فَيُصِيبُ بِهَا مَن يَشَآءُ وَهُمْ يُجَٰدِلُونَ فِى ٱللَّهِ وَهُوَ شَدِيدُ ٱلْمِحَالِ',
		number_in_surah: '13',
		page: '250',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1721',
		number: '1721',
		text: 'لَهُۥ دَعْوَةُ ٱلْحَقِّ ۖ وَٱلَّذِينَ يَدْعُونَ مِن دُونِهِۦ لَا يَسْتَجِيبُونَ لَهُم بِشَىْءٍ إِلَّا كَبَٰسِطِ كَفَّيْهِ إِلَى ٱلْمَآءِ لِيَبْلُغَ فَاهُ وَمَا هُوَ بِبَٰلِغِهِۦ ۚ وَمَا دُعَآءُ ٱلْكَٰفِرِينَ إِلَّا فِى ضَلَٰلٍۢ',
		number_in_surah: '14',
		page: '251',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1722',
		number: '1722',
		text: 'وَلِلَّهِ يَسْجُدُ مَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ طَوْعًۭا وَكَرْهًۭا وَظِلَٰلُهُم بِٱلْغُدُوِّ وَٱلْءَاصَالِ ۩',
		number_in_surah: '15',
		page: '251',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '1',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1723',
		number: '1723',
		text: 'قُلْ مَن رَّبُّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ قُلِ ٱللَّهُ ۚ قُلْ أَفَٱتَّخَذْتُم مِّن دُونِهِۦٓ أَوْلِيَآءَ لَا يَمْلِكُونَ لِأَنفُسِهِمْ نَفْعًۭا وَلَا ضَرًّۭا ۚ قُلْ هَلْ يَسْتَوِى ٱلْأَعْمَىٰ وَٱلْبَصِيرُ أَمْ هَلْ تَسْتَوِى ٱلظُّلُمَٰتُ وَٱلنُّورُ ۗ أَمْ جَعَلُوا۟ لِلَّهِ شُرَكَآءَ خَلَقُوا۟ كَخَلْقِهِۦ فَتَشَٰبَهَ ٱلْخَلْقُ عَلَيْهِمْ ۚ قُلِ ٱللَّهُ خَٰلِقُ كُلِّ شَىْءٍۢ وَهُوَ ٱلْوَٰحِدُ ٱلْقَهَّٰرُ',
		number_in_surah: '16',
		page: '251',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1724',
		number: '1724',
		text: 'أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَسَالَتْ أَوْدِيَةٌۢ بِقَدَرِهَا فَٱحْتَمَلَ ٱلسَّيْلُ زَبَدًۭا رَّابِيًۭا ۚ وَمِمَّا يُوقِدُونَ عَلَيْهِ فِى ٱلنَّارِ ٱبْتِغَآءَ حِلْيَةٍ أَوْ مَتَٰعٍۢ زَبَدٌۭ مِّثْلُهُۥ ۚ كَذَٰلِكَ يَضْرِبُ ٱللَّهُ ٱلْحَقَّ وَٱلْبَٰطِلَ ۚ فَأَمَّا ٱلزَّبَدُ فَيَذْهَبُ جُفَآءًۭ ۖ وَأَمَّا مَا يَنفَعُ ٱلنَّاسَ فَيَمْكُثُ فِى ٱلْأَرْضِ ۚ كَذَٰلِكَ يَضْرِبُ ٱللَّهُ ٱلْأَمْثَالَ',
		number_in_surah: '17',
		page: '251',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1725',
		number: '1725',
		text: 'لِلَّذِينَ ٱسْتَجَابُوا۟ لِرَبِّهِمُ ٱلْحُسْنَىٰ ۚ وَٱلَّذِينَ لَمْ يَسْتَجِيبُوا۟ لَهُۥ لَوْ أَنَّ لَهُم مَّا فِى ٱلْأَرْضِ جَمِيعًۭا وَمِثْلَهُۥ مَعَهُۥ لَٱفْتَدَوْا۟ بِهِۦٓ ۚ أُو۟لَٰٓئِكَ لَهُمْ سُوٓءُ ٱلْحِسَابِ وَمَأْوَىٰهُمْ جَهَنَّمُ ۖ وَبِئْسَ ٱلْمِهَادُ',
		number_in_surah: '18',
		page: '251',
		surah_id: '13',
		hizb_id: '100',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1726',
		number: '1726',
		text: '۞ أَفَمَن يَعْلَمُ أَنَّمَآ أُنزِلَ إِلَيْكَ مِن رَّبِّكَ ٱلْحَقُّ كَمَنْ هُوَ أَعْمَىٰٓ ۚ إِنَّمَا يَتَذَكَّرُ أُو۟لُوا۟ ٱلْأَلْبَٰبِ',
		number_in_surah: '19',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1727',
		number: '1727',
		text: 'ٱلَّذِينَ يُوفُونَ بِعَهْدِ ٱللَّهِ وَلَا يَنقُضُونَ ٱلْمِيثَٰقَ',
		number_in_surah: '20',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1728',
		number: '1728',
		text: 'وَٱلَّذِينَ يَصِلُونَ مَآ أَمَرَ ٱللَّهُ بِهِۦٓ أَن يُوصَلَ وَيَخْشَوْنَ رَبَّهُمْ وَيَخَافُونَ سُوٓءَ ٱلْحِسَابِ',
		number_in_surah: '21',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1729',
		number: '1729',
		text: 'وَٱلَّذِينَ صَبَرُوا۟ ٱبْتِغَآءَ وَجْهِ رَبِّهِمْ وَأَقَامُوا۟ ٱلصَّلَوٰةَ وَأَنفَقُوا۟ مِمَّا رَزَقْنَٰهُمْ سِرًّۭا وَعَلَانِيَةًۭ وَيَدْرَءُونَ بِٱلْحَسَنَةِ ٱلسَّيِّئَةَ أُو۟لَٰٓئِكَ لَهُمْ عُقْبَى ٱلدَّارِ',
		number_in_surah: '22',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1730',
		number: '1730',
		text: 'جَنَّٰتُ عَدْنٍۢ يَدْخُلُونَهَا وَمَن صَلَحَ مِنْ ءَابَآئِهِمْ وَأَزْوَٰجِهِمْ وَذُرِّيَّٰتِهِمْ ۖ وَٱلْمَلَٰٓئِكَةُ يَدْخُلُونَ عَلَيْهِم مِّن كُلِّ بَابٍۢ',
		number_in_surah: '23',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1731',
		number: '1731',
		text: 'سَلَٰمٌ عَلَيْكُم بِمَا صَبَرْتُمْ ۚ فَنِعْمَ عُقْبَى ٱلدَّارِ',
		number_in_surah: '24',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1732',
		number: '1732',
		text: 'وَٱلَّذِينَ يَنقُضُونَ عَهْدَ ٱللَّهِ مِنۢ بَعْدِ مِيثَٰقِهِۦ وَيَقْطَعُونَ مَآ أَمَرَ ٱللَّهُ بِهِۦٓ أَن يُوصَلَ وَيُفْسِدُونَ فِى ٱلْأَرْضِ ۙ أُو۟لَٰٓئِكَ لَهُمُ ٱللَّعْنَةُ وَلَهُمْ سُوٓءُ ٱلدَّارِ',
		number_in_surah: '25',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1733',
		number: '1733',
		text: 'ٱللَّهُ يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ وَيَقْدِرُ ۚ وَفَرِحُوا۟ بِٱلْحَيَوٰةِ ٱلدُّنْيَا وَمَا ٱلْحَيَوٰةُ ٱلدُّنْيَا فِى ٱلْءَاخِرَةِ إِلَّا مَتَٰعٌۭ',
		number_in_surah: '26',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1734',
		number: '1734',
		text: 'وَيَقُولُ ٱلَّذِينَ كَفَرُوا۟ لَوْلَآ أُنزِلَ عَلَيْهِ ءَايَةٌۭ مِّن رَّبِّهِۦ ۗ قُلْ إِنَّ ٱللَّهَ يُضِلُّ مَن يَشَآءُ وَيَهْدِىٓ إِلَيْهِ مَنْ أَنَابَ',
		number_in_surah: '27',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1735',
		number: '1735',
		text: 'ٱلَّذِينَ ءَامَنُوا۟ وَتَطْمَئِنُّ قُلُوبُهُم بِذِكْرِ ٱللَّهِ ۗ أَلَا بِذِكْرِ ٱللَّهِ تَطْمَئِنُّ ٱلْقُلُوبُ',
		number_in_surah: '28',
		page: '252',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1736',
		number: '1736',
		text: 'ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ طُوبَىٰ لَهُمْ وَحُسْنُ مَـَٔابٍۢ',
		number_in_surah: '29',
		page: '253',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1737',
		number: '1737',
		text: 'كَذَٰلِكَ أَرْسَلْنَٰكَ فِىٓ أُمَّةٍۢ قَدْ خَلَتْ مِن قَبْلِهَآ أُمَمٌۭ لِّتَتْلُوَا۟ عَلَيْهِمُ ٱلَّذِىٓ أَوْحَيْنَآ إِلَيْكَ وَهُمْ يَكْفُرُونَ بِٱلرَّحْمَٰنِ ۚ قُلْ هُوَ رَبِّى لَآ إِلَٰهَ إِلَّا هُوَ عَلَيْهِ تَوَكَّلْتُ وَإِلَيْهِ مَتَابِ',
		number_in_surah: '30',
		page: '253',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1738',
		number: '1738',
		text: 'وَلَوْ أَنَّ قُرْءَانًۭا سُيِّرَتْ بِهِ ٱلْجِبَالُ أَوْ قُطِّعَتْ بِهِ ٱلْأَرْضُ أَوْ كُلِّمَ بِهِ ٱلْمَوْتَىٰ ۗ بَل لِّلَّهِ ٱلْأَمْرُ جَمِيعًا ۗ أَفَلَمْ يَا۟يْـَٔسِ ٱلَّذِينَ ءَامَنُوٓا۟ أَن لَّوْ يَشَآءُ ٱللَّهُ لَهَدَى ٱلنَّاسَ جَمِيعًۭا ۗ وَلَا يَزَالُ ٱلَّذِينَ كَفَرُوا۟ تُصِيبُهُم بِمَا صَنَعُوا۟ قَارِعَةٌ أَوْ تَحُلُّ قَرِيبًۭا مِّن دَارِهِمْ حَتَّىٰ يَأْتِىَ وَعْدُ ٱللَّهِ ۚ إِنَّ ٱللَّهَ لَا يُخْلِفُ ٱلْمِيعَادَ',
		number_in_surah: '31',
		page: '253',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1739',
		number: '1739',
		text: 'وَلَقَدِ ٱسْتُهْزِئَ بِرُسُلٍۢ مِّن قَبْلِكَ فَأَمْلَيْتُ لِلَّذِينَ كَفَرُوا۟ ثُمَّ أَخَذْتُهُمْ ۖ فَكَيْفَ كَانَ عِقَابِ',
		number_in_surah: '32',
		page: '253',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1740',
		number: '1740',
		text: 'أَفَمَنْ هُوَ قَآئِمٌ عَلَىٰ كُلِّ نَفْسٍۭ بِمَا كَسَبَتْ ۗ وَجَعَلُوا۟ لِلَّهِ شُرَكَآءَ قُلْ سَمُّوهُمْ ۚ أَمْ تُنَبِّـُٔونَهُۥ بِمَا لَا يَعْلَمُ فِى ٱلْأَرْضِ أَم بِظَٰهِرٍۢ مِّنَ ٱلْقَوْلِ ۗ بَلْ زُيِّنَ لِلَّذِينَ كَفَرُوا۟ مَكْرُهُمْ وَصُدُّوا۟ عَنِ ٱلسَّبِيلِ ۗ وَمَن يُضْلِلِ ٱللَّهُ فَمَا لَهُۥ مِنْ هَادٍۢ',
		number_in_surah: '33',
		page: '253',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1741',
		number: '1741',
		text: 'لَّهُمْ عَذَابٌۭ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ وَلَعَذَابُ ٱلْءَاخِرَةِ أَشَقُّ ۖ وَمَا لَهُم مِّنَ ٱللَّهِ مِن وَاقٍۢ',
		number_in_surah: '34',
		page: '253',
		surah_id: '13',
		hizb_id: '101',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1742',
		number: '1742',
		text: '۞ مَّثَلُ ٱلْجَنَّةِ ٱلَّتِى وُعِدَ ٱلْمُتَّقُونَ ۖ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۖ أُكُلُهَا دَآئِمٌۭ وَظِلُّهَا ۚ تِلْكَ عُقْبَى ٱلَّذِينَ ٱتَّقَوا۟ ۖ وَّعُقْبَى ٱلْكَٰفِرِينَ ٱلنَّارُ',
		number_in_surah: '35',
		page: '254',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1743',
		number: '1743',
		text: 'وَٱلَّذِينَ ءَاتَيْنَٰهُمُ ٱلْكِتَٰبَ يَفْرَحُونَ بِمَآ أُنزِلَ إِلَيْكَ ۖ وَمِنَ ٱلْأَحْزَابِ مَن يُنكِرُ بَعْضَهُۥ ۚ قُلْ إِنَّمَآ أُمِرْتُ أَنْ أَعْبُدَ ٱللَّهَ وَلَآ أُشْرِكَ بِهِۦٓ ۚ إِلَيْهِ أَدْعُوا۟ وَإِلَيْهِ مَـَٔابِ',
		number_in_surah: '36',
		page: '254',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1744',
		number: '1744',
		text: 'وَكَذَٰلِكَ أَنزَلْنَٰهُ حُكْمًا عَرَبِيًّۭا ۚ وَلَئِنِ ٱتَّبَعْتَ أَهْوَآءَهُم بَعْدَمَا جَآءَكَ مِنَ ٱلْعِلْمِ مَا لَكَ مِنَ ٱللَّهِ مِن وَلِىٍّۢ وَلَا وَاقٍۢ',
		number_in_surah: '37',
		page: '254',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1745',
		number: '1745',
		text: 'وَلَقَدْ أَرْسَلْنَا رُسُلًۭا مِّن قَبْلِكَ وَجَعَلْنَا لَهُمْ أَزْوَٰجًۭا وَذُرِّيَّةًۭ ۚ وَمَا كَانَ لِرَسُولٍ أَن يَأْتِىَ بِـَٔايَةٍ إِلَّا بِإِذْنِ ٱللَّهِ ۗ لِكُلِّ أَجَلٍۢ كِتَابٌۭ',
		number_in_surah: '38',
		page: '254',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1746',
		number: '1746',
		text: 'يَمْحُوا۟ ٱللَّهُ مَا يَشَآءُ وَيُثْبِتُ ۖ وَعِندَهُۥٓ أُمُّ ٱلْكِتَٰبِ',
		number_in_surah: '39',
		page: '254',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1747',
		number: '1747',
		text: 'وَإِن مَّا نُرِيَنَّكَ بَعْضَ ٱلَّذِى نَعِدُهُمْ أَوْ نَتَوَفَّيَنَّكَ فَإِنَّمَا عَلَيْكَ ٱلْبَلَٰغُ وَعَلَيْنَا ٱلْحِسَابُ',
		number_in_surah: '40',
		page: '254',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1748',
		number: '1748',
		text: 'أَوَلَمْ يَرَوْا۟ أَنَّا نَأْتِى ٱلْأَرْضَ نَنقُصُهَا مِنْ أَطْرَافِهَا ۚ وَٱللَّهُ يَحْكُمُ لَا مُعَقِّبَ لِحُكْمِهِۦ ۚ وَهُوَ سَرِيعُ ٱلْحِسَابِ',
		number_in_surah: '41',
		page: '254',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1749',
		number: '1749',
		text: 'وَقَدْ مَكَرَ ٱلَّذِينَ مِن قَبْلِهِمْ فَلِلَّهِ ٱلْمَكْرُ جَمِيعًۭا ۖ يَعْلَمُ مَا تَكْسِبُ كُلُّ نَفْسٍۢ ۗ وَسَيَعْلَمُ ٱلْكُفَّٰرُ لِمَنْ عُقْبَى ٱلدَّارِ',
		number_in_surah: '42',
		page: '254',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1750',
		number: '1750',
		text: 'وَيَقُولُ ٱلَّذِينَ كَفَرُوا۟ لَسْتَ مُرْسَلًۭا ۚ قُلْ كَفَىٰ بِٱللَّهِ شَهِيدًۢا بَيْنِى وَبَيْنَكُمْ وَمَنْ عِندَهُۥ عِلْمُ ٱلْكِتَٰبِ',
		number_in_surah: '43',
		page: '255',
		surah_id: '13',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1751',
		number: '1751',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓر ۚ كِتَٰبٌ أَنزَلْنَٰهُ إِلَيْكَ لِتُخْرِجَ ٱلنَّاسَ مِنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ بِإِذْنِ رَبِّهِمْ إِلَىٰ صِرَٰطِ ٱلْعَزِيزِ ٱلْحَمِيدِ',
		number_in_surah: '1',
		page: '255',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1752',
		number: '1752',
		text: 'ٱللَّهِ ٱلَّذِى لَهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۗ وَوَيْلٌۭ لِّلْكَٰفِرِينَ مِنْ عَذَابٍۢ شَدِيدٍ',
		number_in_surah: '2',
		page: '255',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1753',
		number: '1753',
		text: 'ٱلَّذِينَ يَسْتَحِبُّونَ ٱلْحَيَوٰةَ ٱلدُّنْيَا عَلَى ٱلْءَاخِرَةِ وَيَصُدُّونَ عَن سَبِيلِ ٱللَّهِ وَيَبْغُونَهَا عِوَجًا ۚ أُو۟لَٰٓئِكَ فِى ضَلَٰلٍۭ بَعِيدٍۢ',
		number_in_surah: '3',
		page: '255',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1754',
		number: '1754',
		text: 'وَمَآ أَرْسَلْنَا مِن رَّسُولٍ إِلَّا بِلِسَانِ قَوْمِهِۦ لِيُبَيِّنَ لَهُمْ ۖ فَيُضِلُّ ٱللَّهُ مَن يَشَآءُ وَيَهْدِى مَن يَشَآءُ ۚ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '4',
		page: '255',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1755',
		number: '1755',
		text: 'وَلَقَدْ أَرْسَلْنَا مُوسَىٰ بِـَٔايَٰتِنَآ أَنْ أَخْرِجْ قَوْمَكَ مِنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ وَذَكِّرْهُم بِأَيَّىٰمِ ٱللَّهِ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّكُلِّ صَبَّارٍۢ شَكُورٍۢ',
		number_in_surah: '5',
		page: '255',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1756',
		number: '1756',
		text: 'وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِ ٱذْكُرُوا۟ نِعْمَةَ ٱللَّهِ عَلَيْكُمْ إِذْ أَنجَىٰكُم مِّنْ ءَالِ فِرْعَوْنَ يَسُومُونَكُمْ سُوٓءَ ٱلْعَذَابِ وَيُذَبِّحُونَ أَبْنَآءَكُمْ وَيَسْتَحْيُونَ نِسَآءَكُمْ ۚ وَفِى ذَٰلِكُم بَلَآءٌۭ مِّن رَّبِّكُمْ عَظِيمٌۭ',
		number_in_surah: '6',
		page: '256',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1757',
		number: '1757',
		text: 'وَإِذْ تَأَذَّنَ رَبُّكُمْ لَئِن شَكَرْتُمْ لَأَزِيدَنَّكُمْ ۖ وَلَئِن كَفَرْتُمْ إِنَّ عَذَابِى لَشَدِيدٌۭ',
		number_in_surah: '7',
		page: '256',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1758',
		number: '1758',
		text: 'وَقَالَ مُوسَىٰٓ إِن تَكْفُرُوٓا۟ أَنتُمْ وَمَن فِى ٱلْأَرْضِ جَمِيعًۭا فَإِنَّ ٱللَّهَ لَغَنِىٌّ حَمِيدٌ',
		number_in_surah: '8',
		page: '256',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1759',
		number: '1759',
		text: 'أَلَمْ يَأْتِكُمْ نَبَؤُا۟ ٱلَّذِينَ مِن قَبْلِكُمْ قَوْمِ نُوحٍۢ وَعَادٍۢ وَثَمُودَ ۛ وَٱلَّذِينَ مِنۢ بَعْدِهِمْ ۛ لَا يَعْلَمُهُمْ إِلَّا ٱللَّهُ ۚ جَآءَتْهُمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ فَرَدُّوٓا۟ أَيْدِيَهُمْ فِىٓ أَفْوَٰهِهِمْ وَقَالُوٓا۟ إِنَّا كَفَرْنَا بِمَآ أُرْسِلْتُم بِهِۦ وَإِنَّا لَفِى شَكٍّۢ مِّمَّا تَدْعُونَنَآ إِلَيْهِ مُرِيبٍۢ',
		number_in_surah: '9',
		page: '256',
		surah_id: '14',
		hizb_id: '102',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1760',
		number: '1760',
		text: '۞ قَالَتْ رُسُلُهُمْ أَفِى ٱللَّهِ شَكٌّۭ فَاطِرِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ يَدْعُوكُمْ لِيَغْفِرَ لَكُم مِّن ذُنُوبِكُمْ وَيُؤَخِّرَكُمْ إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى ۚ قَالُوٓا۟ إِنْ أَنتُمْ إِلَّا بَشَرٌۭ مِّثْلُنَا تُرِيدُونَ أَن تَصُدُّونَا عَمَّا كَانَ يَعْبُدُ ءَابَآؤُنَا فَأْتُونَا بِسُلْطَٰنٍۢ مُّبِينٍۢ',
		number_in_surah: '10',
		page: '256',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1761',
		number: '1761',
		text: 'قَالَتْ لَهُمْ رُسُلُهُمْ إِن نَّحْنُ إِلَّا بَشَرٌۭ مِّثْلُكُمْ وَلَٰكِنَّ ٱللَّهَ يَمُنُّ عَلَىٰ مَن يَشَآءُ مِنْ عِبَادِهِۦ ۖ وَمَا كَانَ لَنَآ أَن نَّأْتِيَكُم بِسُلْطَٰنٍ إِلَّا بِإِذْنِ ٱللَّهِ ۚ وَعَلَى ٱللَّهِ فَلْيَتَوَكَّلِ ٱلْمُؤْمِنُونَ',
		number_in_surah: '11',
		page: '257',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1762',
		number: '1762',
		text: 'وَمَا لَنَآ أَلَّا نَتَوَكَّلَ عَلَى ٱللَّهِ وَقَدْ هَدَىٰنَا سُبُلَنَا ۚ وَلَنَصْبِرَنَّ عَلَىٰ مَآ ءَاذَيْتُمُونَا ۚ وَعَلَى ٱللَّهِ فَلْيَتَوَكَّلِ ٱلْمُتَوَكِّلُونَ',
		number_in_surah: '12',
		page: '257',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1763',
		number: '1763',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ لِرُسُلِهِمْ لَنُخْرِجَنَّكُم مِّنْ أَرْضِنَآ أَوْ لَتَعُودُنَّ فِى مِلَّتِنَا ۖ فَأَوْحَىٰٓ إِلَيْهِمْ رَبُّهُمْ لَنُهْلِكَنَّ ٱلظَّٰلِمِينَ',
		number_in_surah: '13',
		page: '257',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1764',
		number: '1764',
		text: 'وَلَنُسْكِنَنَّكُمُ ٱلْأَرْضَ مِنۢ بَعْدِهِمْ ۚ ذَٰلِكَ لِمَنْ خَافَ مَقَامِى وَخَافَ وَعِيدِ',
		number_in_surah: '14',
		page: '257',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1765',
		number: '1765',
		text: 'وَٱسْتَفْتَحُوا۟ وَخَابَ كُلُّ جَبَّارٍ عَنِيدٍۢ',
		number_in_surah: '15',
		page: '257',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1766',
		number: '1766',
		text: 'مِّن وَرَآئِهِۦ جَهَنَّمُ وَيُسْقَىٰ مِن مَّآءٍۢ صَدِيدٍۢ',
		number_in_surah: '16',
		page: '257',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1767',
		number: '1767',
		text: 'يَتَجَرَّعُهُۥ وَلَا يَكَادُ يُسِيغُهُۥ وَيَأْتِيهِ ٱلْمَوْتُ مِن كُلِّ مَكَانٍۢ وَمَا هُوَ بِمَيِّتٍۢ ۖ وَمِن وَرَآئِهِۦ عَذَابٌ غَلِيظٌۭ',
		number_in_surah: '17',
		page: '257',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1768',
		number: '1768',
		text: 'مَّثَلُ ٱلَّذِينَ كَفَرُوا۟ بِرَبِّهِمْ ۖ أَعْمَٰلُهُمْ كَرَمَادٍ ٱشْتَدَّتْ بِهِ ٱلرِّيحُ فِى يَوْمٍ عَاصِفٍۢ ۖ لَّا يَقْدِرُونَ مِمَّا كَسَبُوا۟ عَلَىٰ شَىْءٍۢ ۚ ذَٰلِكَ هُوَ ٱلضَّلَٰلُ ٱلْبَعِيدُ',
		number_in_surah: '18',
		page: '257',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1769',
		number: '1769',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ بِٱلْحَقِّ ۚ إِن يَشَأْ يُذْهِبْكُمْ وَيَأْتِ بِخَلْقٍۢ جَدِيدٍۢ',
		number_in_surah: '19',
		page: '258',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1770',
		number: '1770',
		text: 'وَمَا ذَٰلِكَ عَلَى ٱللَّهِ بِعَزِيزٍۢ',
		number_in_surah: '20',
		page: '258',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1771',
		number: '1771',
		text: 'وَبَرَزُوا۟ لِلَّهِ جَمِيعًۭا فَقَالَ ٱلضُّعَفَٰٓؤُا۟ لِلَّذِينَ ٱسْتَكْبَرُوٓا۟ إِنَّا كُنَّا لَكُمْ تَبَعًۭا فَهَلْ أَنتُم مُّغْنُونَ عَنَّا مِنْ عَذَابِ ٱللَّهِ مِن شَىْءٍۢ ۚ قَالُوا۟ لَوْ هَدَىٰنَا ٱللَّهُ لَهَدَيْنَٰكُمْ ۖ سَوَآءٌ عَلَيْنَآ أَجَزِعْنَآ أَمْ صَبَرْنَا مَا لَنَا مِن مَّحِيصٍۢ',
		number_in_surah: '21',
		page: '258',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1772',
		number: '1772',
		text: 'وَقَالَ ٱلشَّيْطَٰنُ لَمَّا قُضِىَ ٱلْأَمْرُ إِنَّ ٱللَّهَ وَعَدَكُمْ وَعْدَ ٱلْحَقِّ وَوَعَدتُّكُمْ فَأَخْلَفْتُكُمْ ۖ وَمَا كَانَ لِىَ عَلَيْكُم مِّن سُلْطَٰنٍ إِلَّآ أَن دَعَوْتُكُمْ فَٱسْتَجَبْتُمْ لِى ۖ فَلَا تَلُومُونِى وَلُومُوٓا۟ أَنفُسَكُم ۖ مَّآ أَنَا۠ بِمُصْرِخِكُمْ وَمَآ أَنتُم بِمُصْرِخِىَّ ۖ إِنِّى كَفَرْتُ بِمَآ أَشْرَكْتُمُونِ مِن قَبْلُ ۗ إِنَّ ٱلظَّٰلِمِينَ لَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '22',
		page: '258',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1773',
		number: '1773',
		text: 'وَأُدْخِلَ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا بِإِذْنِ رَبِّهِمْ ۖ تَحِيَّتُهُمْ فِيهَا سَلَٰمٌ',
		number_in_surah: '23',
		page: '258',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1774',
		number: '1774',
		text: 'أَلَمْ تَرَ كَيْفَ ضَرَبَ ٱللَّهُ مَثَلًۭا كَلِمَةًۭ طَيِّبَةًۭ كَشَجَرَةٍۢ طَيِّبَةٍ أَصْلُهَا ثَابِتٌۭ وَفَرْعُهَا فِى ٱلسَّمَآءِ',
		number_in_surah: '24',
		page: '258',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1775',
		number: '1775',
		text: 'تُؤْتِىٓ أُكُلَهَا كُلَّ حِينٍۭ بِإِذْنِ رَبِّهَا ۗ وَيَضْرِبُ ٱللَّهُ ٱلْأَمْثَالَ لِلنَّاسِ لَعَلَّهُمْ يَتَذَكَّرُونَ',
		number_in_surah: '25',
		page: '259',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1776',
		number: '1776',
		text: 'وَمَثَلُ كَلِمَةٍ خَبِيثَةٍۢ كَشَجَرَةٍ خَبِيثَةٍ ٱجْتُثَّتْ مِن فَوْقِ ٱلْأَرْضِ مَا لَهَا مِن قَرَارٍۢ',
		number_in_surah: '26',
		page: '259',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1777',
		number: '1777',
		text: 'يُثَبِّتُ ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ بِٱلْقَوْلِ ٱلثَّابِتِ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا وَفِى ٱلْءَاخِرَةِ ۖ وَيُضِلُّ ٱللَّهُ ٱلظَّٰلِمِينَ ۚ وَيَفْعَلُ ٱللَّهُ مَا يَشَآءُ',
		number_in_surah: '27',
		page: '259',
		surah_id: '14',
		hizb_id: '103',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1778',
		number: '1778',
		text: '۞ أَلَمْ تَرَ إِلَى ٱلَّذِينَ بَدَّلُوا۟ نِعْمَتَ ٱللَّهِ كُفْرًۭا وَأَحَلُّوا۟ قَوْمَهُمْ دَارَ ٱلْبَوَارِ',
		number_in_surah: '28',
		page: '259',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1779',
		number: '1779',
		text: 'جَهَنَّمَ يَصْلَوْنَهَا ۖ وَبِئْسَ ٱلْقَرَارُ',
		number_in_surah: '29',
		page: '259',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1780',
		number: '1780',
		text: 'وَجَعَلُوا۟ لِلَّهِ أَندَادًۭا لِّيُضِلُّوا۟ عَن سَبِيلِهِۦ ۗ قُلْ تَمَتَّعُوا۟ فَإِنَّ مَصِيرَكُمْ إِلَى ٱلنَّارِ',
		number_in_surah: '30',
		page: '259',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1781',
		number: '1781',
		text: 'قُل لِّعِبَادِىَ ٱلَّذِينَ ءَامَنُوا۟ يُقِيمُوا۟ ٱلصَّلَوٰةَ وَيُنفِقُوا۟ مِمَّا رَزَقْنَٰهُمْ سِرًّۭا وَعَلَانِيَةًۭ مِّن قَبْلِ أَن يَأْتِىَ يَوْمٌۭ لَّا بَيْعٌۭ فِيهِ وَلَا خِلَٰلٌ',
		number_in_surah: '31',
		page: '259',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1782',
		number: '1782',
		text: 'ٱللَّهُ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَأَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَخْرَجَ بِهِۦ مِنَ ٱلثَّمَرَٰتِ رِزْقًۭا لَّكُمْ ۖ وَسَخَّرَ لَكُمُ ٱلْفُلْكَ لِتَجْرِىَ فِى ٱلْبَحْرِ بِأَمْرِهِۦ ۖ وَسَخَّرَ لَكُمُ ٱلْأَنْهَٰرَ',
		number_in_surah: '32',
		page: '259',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1783',
		number: '1783',
		text: 'وَسَخَّرَ لَكُمُ ٱلشَّمْسَ وَٱلْقَمَرَ دَآئِبَيْنِ ۖ وَسَخَّرَ لَكُمُ ٱلَّيْلَ وَٱلنَّهَارَ',
		number_in_surah: '33',
		page: '259',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1784',
		number: '1784',
		text: 'وَءَاتَىٰكُم مِّن كُلِّ مَا سَأَلْتُمُوهُ ۚ وَإِن تَعُدُّوا۟ نِعْمَتَ ٱللَّهِ لَا تُحْصُوهَآ ۗ إِنَّ ٱلْإِنسَٰنَ لَظَلُومٌۭ كَفَّارٌۭ',
		number_in_surah: '34',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1785',
		number: '1785',
		text: 'وَإِذْ قَالَ إِبْرَٰهِيمُ رَبِّ ٱجْعَلْ هَٰذَا ٱلْبَلَدَ ءَامِنًۭا وَٱجْنُبْنِى وَبَنِىَّ أَن نَّعْبُدَ ٱلْأَصْنَامَ',
		number_in_surah: '35',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1786',
		number: '1786',
		text: 'رَبِّ إِنَّهُنَّ أَضْلَلْنَ كَثِيرًۭا مِّنَ ٱلنَّاسِ ۖ فَمَن تَبِعَنِى فَإِنَّهُۥ مِنِّى ۖ وَمَنْ عَصَانِى فَإِنَّكَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '36',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1787',
		number: '1787',
		text: 'رَّبَّنَآ إِنِّىٓ أَسْكَنتُ مِن ذُرِّيَّتِى بِوَادٍ غَيْرِ ذِى زَرْعٍ عِندَ بَيْتِكَ ٱلْمُحَرَّمِ رَبَّنَا لِيُقِيمُوا۟ ٱلصَّلَوٰةَ فَٱجْعَلْ أَفْـِٔدَةًۭ مِّنَ ٱلنَّاسِ تَهْوِىٓ إِلَيْهِمْ وَٱرْزُقْهُم مِّنَ ٱلثَّمَرَٰتِ لَعَلَّهُمْ يَشْكُرُونَ',
		number_in_surah: '37',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1788',
		number: '1788',
		text: 'رَبَّنَآ إِنَّكَ تَعْلَمُ مَا نُخْفِى وَمَا نُعْلِنُ ۗ وَمَا يَخْفَىٰ عَلَى ٱللَّهِ مِن شَىْءٍۢ فِى ٱلْأَرْضِ وَلَا فِى ٱلسَّمَآءِ',
		number_in_surah: '38',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1789',
		number: '1789',
		text: 'ٱلْحَمْدُ لِلَّهِ ٱلَّذِى وَهَبَ لِى عَلَى ٱلْكِبَرِ إِسْمَٰعِيلَ وَإِسْحَٰقَ ۚ إِنَّ رَبِّى لَسَمِيعُ ٱلدُّعَآءِ',
		number_in_surah: '39',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1790',
		number: '1790',
		text: 'رَبِّ ٱجْعَلْنِى مُقِيمَ ٱلصَّلَوٰةِ وَمِن ذُرِّيَّتِى ۚ رَبَّنَا وَتَقَبَّلْ دُعَآءِ',
		number_in_surah: '40',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1791',
		number: '1791',
		text: 'رَبَّنَا ٱغْفِرْ لِى وَلِوَٰلِدَىَّ وَلِلْمُؤْمِنِينَ يَوْمَ يَقُومُ ٱلْحِسَابُ',
		number_in_surah: '41',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1792',
		number: '1792',
		text: 'وَلَا تَحْسَبَنَّ ٱللَّهَ غَٰفِلًا عَمَّا يَعْمَلُ ٱلظَّٰلِمُونَ ۚ إِنَّمَا يُؤَخِّرُهُمْ لِيَوْمٍۢ تَشْخَصُ فِيهِ ٱلْأَبْصَٰرُ',
		number_in_surah: '42',
		page: '260',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1793',
		number: '1793',
		text: 'مُهْطِعِينَ مُقْنِعِى رُءُوسِهِمْ لَا يَرْتَدُّ إِلَيْهِمْ طَرْفُهُمْ ۖ وَأَفْـِٔدَتُهُمْ هَوَآءٌۭ',
		number_in_surah: '43',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1794',
		number: '1794',
		text: 'وَأَنذِرِ ٱلنَّاسَ يَوْمَ يَأْتِيهِمُ ٱلْعَذَابُ فَيَقُولُ ٱلَّذِينَ ظَلَمُوا۟ رَبَّنَآ أَخِّرْنَآ إِلَىٰٓ أَجَلٍۢ قَرِيبٍۢ نُّجِبْ دَعْوَتَكَ وَنَتَّبِعِ ٱلرُّسُلَ ۗ أَوَلَمْ تَكُونُوٓا۟ أَقْسَمْتُم مِّن قَبْلُ مَا لَكُم مِّن زَوَالٍۢ',
		number_in_surah: '44',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1795',
		number: '1795',
		text: 'وَسَكَنتُمْ فِى مَسَٰكِنِ ٱلَّذِينَ ظَلَمُوٓا۟ أَنفُسَهُمْ وَتَبَيَّنَ لَكُمْ كَيْفَ فَعَلْنَا بِهِمْ وَضَرَبْنَا لَكُمُ ٱلْأَمْثَالَ',
		number_in_surah: '45',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1796',
		number: '1796',
		text: 'وَقَدْ مَكَرُوا۟ مَكْرَهُمْ وَعِندَ ٱللَّهِ مَكْرُهُمْ وَإِن كَانَ مَكْرُهُمْ لِتَزُولَ مِنْهُ ٱلْجِبَالُ',
		number_in_surah: '46',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1797',
		number: '1797',
		text: 'فَلَا تَحْسَبَنَّ ٱللَّهَ مُخْلِفَ وَعْدِهِۦ رُسُلَهُۥٓ ۗ إِنَّ ٱللَّهَ عَزِيزٌۭ ذُو ٱنتِقَامٍۢ',
		number_in_surah: '47',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1798',
		number: '1798',
		text: 'يَوْمَ تُبَدَّلُ ٱلْأَرْضُ غَيْرَ ٱلْأَرْضِ وَٱلسَّمَٰوَٰتُ ۖ وَبَرَزُوا۟ لِلَّهِ ٱلْوَٰحِدِ ٱلْقَهَّارِ',
		number_in_surah: '48',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1799',
		number: '1799',
		text: 'وَتَرَى ٱلْمُجْرِمِينَ يَوْمَئِذٍۢ مُّقَرَّنِينَ فِى ٱلْأَصْفَادِ',
		number_in_surah: '49',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1800',
		number: '1800',
		text: 'سَرَابِيلُهُم مِّن قَطِرَانٍۢ وَتَغْشَىٰ وُجُوهَهُمُ ٱلنَّارُ',
		number_in_surah: '50',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1801',
		number: '1801',
		text: 'لِيَجْزِىَ ٱللَّهُ كُلَّ نَفْسٍۢ مَّا كَسَبَتْ ۚ إِنَّ ٱللَّهَ سَرِيعُ ٱلْحِسَابِ',
		number_in_surah: '51',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1802',
		number: '1802',
		text: 'هَٰذَا بَلَٰغٌۭ لِّلنَّاسِ وَلِيُنذَرُوا۟ بِهِۦ وَلِيَعْلَمُوٓا۟ أَنَّمَا هُوَ إِلَٰهٌۭ وَٰحِدٌۭ وَلِيَذَّكَّرَ أُو۟لُوا۟ ٱلْأَلْبَٰبِ',
		number_in_surah: '52',
		page: '261',
		surah_id: '14',
		hizb_id: '104',
		juz_id: '13',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1803',
		number: '1803',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓر ۚ تِلْكَ ءَايَٰتُ ٱلْكِتَٰبِ وَقُرْءَانٍۢ مُّبِينٍۢ',
		number_in_surah: '1',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1804',
		number: '1804',
		text: 'رُّبَمَا يَوَدُّ ٱلَّذِينَ كَفَرُوا۟ لَوْ كَانُوا۟ مُسْلِمِينَ',
		number_in_surah: '2',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1805',
		number: '1805',
		text: 'ذَرْهُمْ يَأْكُلُوا۟ وَيَتَمَتَّعُوا۟ وَيُلْهِهِمُ ٱلْأَمَلُ ۖ فَسَوْفَ يَعْلَمُونَ',
		number_in_surah: '3',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1806',
		number: '1806',
		text: 'وَمَآ أَهْلَكْنَا مِن قَرْيَةٍ إِلَّا وَلَهَا كِتَابٌۭ مَّعْلُومٌۭ',
		number_in_surah: '4',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1807',
		number: '1807',
		text: 'مَّا تَسْبِقُ مِنْ أُمَّةٍ أَجَلَهَا وَمَا يَسْتَـْٔخِرُونَ',
		number_in_surah: '5',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1808',
		number: '1808',
		text: 'وَقَالُوا۟ يَٰٓأَيُّهَا ٱلَّذِى نُزِّلَ عَلَيْهِ ٱلذِّكْرُ إِنَّكَ لَمَجْنُونٌۭ',
		number_in_surah: '6',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1809',
		number: '1809',
		text: 'لَّوْ مَا تَأْتِينَا بِٱلْمَلَٰٓئِكَةِ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '7',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1810',
		number: '1810',
		text: 'مَا نُنَزِّلُ ٱلْمَلَٰٓئِكَةَ إِلَّا بِٱلْحَقِّ وَمَا كَانُوٓا۟ إِذًۭا مُّنظَرِينَ',
		number_in_surah: '8',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1811',
		number: '1811',
		text: 'إِنَّا نَحْنُ نَزَّلْنَا ٱلذِّكْرَ وَإِنَّا لَهُۥ لَحَٰفِظُونَ',
		number_in_surah: '9',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1812',
		number: '1812',
		text: 'وَلَقَدْ أَرْسَلْنَا مِن قَبْلِكَ فِى شِيَعِ ٱلْأَوَّلِينَ',
		number_in_surah: '10',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1813',
		number: '1813',
		text: 'وَمَا يَأْتِيهِم مِّن رَّسُولٍ إِلَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '11',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1814',
		number: '1814',
		text: 'كَذَٰلِكَ نَسْلُكُهُۥ فِى قُلُوبِ ٱلْمُجْرِمِينَ',
		number_in_surah: '12',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1815',
		number: '1815',
		text: 'لَا يُؤْمِنُونَ بِهِۦ ۖ وَقَدْ خَلَتْ سُنَّةُ ٱلْأَوَّلِينَ',
		number_in_surah: '13',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1816',
		number: '1816',
		text: 'وَلَوْ فَتَحْنَا عَلَيْهِم بَابًۭا مِّنَ ٱلسَّمَآءِ فَظَلُّوا۟ فِيهِ يَعْرُجُونَ',
		number_in_surah: '14',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1817',
		number: '1817',
		text: 'لَقَالُوٓا۟ إِنَّمَا سُكِّرَتْ أَبْصَٰرُنَا بَلْ نَحْنُ قَوْمٌۭ مَّسْحُورُونَ',
		number_in_surah: '15',
		page: '262',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1818',
		number: '1818',
		text: 'وَلَقَدْ جَعَلْنَا فِى ٱلسَّمَآءِ بُرُوجًۭا وَزَيَّنَّٰهَا لِلنَّٰظِرِينَ',
		number_in_surah: '16',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1819',
		number: '1819',
		text: 'وَحَفِظْنَٰهَا مِن كُلِّ شَيْطَٰنٍۢ رَّجِيمٍ',
		number_in_surah: '17',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1820',
		number: '1820',
		text: 'إِلَّا مَنِ ٱسْتَرَقَ ٱلسَّمْعَ فَأَتْبَعَهُۥ شِهَابٌۭ مُّبِينٌۭ',
		number_in_surah: '18',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1821',
		number: '1821',
		text: 'وَٱلْأَرْضَ مَدَدْنَٰهَا وَأَلْقَيْنَا فِيهَا رَوَٰسِىَ وَأَنۢبَتْنَا فِيهَا مِن كُلِّ شَىْءٍۢ مَّوْزُونٍۢ',
		number_in_surah: '19',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1822',
		number: '1822',
		text: 'وَجَعَلْنَا لَكُمْ فِيهَا مَعَٰيِشَ وَمَن لَّسْتُمْ لَهُۥ بِرَٰزِقِينَ',
		number_in_surah: '20',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1823',
		number: '1823',
		text: 'وَإِن مِّن شَىْءٍ إِلَّا عِندَنَا خَزَآئِنُهُۥ وَمَا نُنَزِّلُهُۥٓ إِلَّا بِقَدَرٍۢ مَّعْلُومٍۢ',
		number_in_surah: '21',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1824',
		number: '1824',
		text: 'وَأَرْسَلْنَا ٱلرِّيَٰحَ لَوَٰقِحَ فَأَنزَلْنَا مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَسْقَيْنَٰكُمُوهُ وَمَآ أَنتُمْ لَهُۥ بِخَٰزِنِينَ',
		number_in_surah: '22',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1825',
		number: '1825',
		text: 'وَإِنَّا لَنَحْنُ نُحْىِۦ وَنُمِيتُ وَنَحْنُ ٱلْوَٰرِثُونَ',
		number_in_surah: '23',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1826',
		number: '1826',
		text: 'وَلَقَدْ عَلِمْنَا ٱلْمُسْتَقْدِمِينَ مِنكُمْ وَلَقَدْ عَلِمْنَا ٱلْمُسْتَـْٔخِرِينَ',
		number_in_surah: '24',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1827',
		number: '1827',
		text: 'وَإِنَّ رَبَّكَ هُوَ يَحْشُرُهُمْ ۚ إِنَّهُۥ حَكِيمٌ عَلِيمٌۭ',
		number_in_surah: '25',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1828',
		number: '1828',
		text: 'وَلَقَدْ خَلَقْنَا ٱلْإِنسَٰنَ مِن صَلْصَٰلٍۢ مِّنْ حَمَإٍۢ مَّسْنُونٍۢ',
		number_in_surah: '26',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1829',
		number: '1829',
		text: 'وَٱلْجَآنَّ خَلَقْنَٰهُ مِن قَبْلُ مِن نَّارِ ٱلسَّمُومِ',
		number_in_surah: '27',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1830',
		number: '1830',
		text: 'وَإِذْ قَالَ رَبُّكَ لِلْمَلَٰٓئِكَةِ إِنِّى خَٰلِقٌۢ بَشَرًۭا مِّن صَلْصَٰلٍۢ مِّنْ حَمَإٍۢ مَّسْنُونٍۢ',
		number_in_surah: '28',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1831',
		number: '1831',
		text: 'فَإِذَا سَوَّيْتُهُۥ وَنَفَخْتُ فِيهِ مِن رُّوحِى فَقَعُوا۟ لَهُۥ سَٰجِدِينَ',
		number_in_surah: '29',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1832',
		number: '1832',
		text: 'فَسَجَدَ ٱلْمَلَٰٓئِكَةُ كُلُّهُمْ أَجْمَعُونَ',
		number_in_surah: '30',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1833',
		number: '1833',
		text: 'إِلَّآ إِبْلِيسَ أَبَىٰٓ أَن يَكُونَ مَعَ ٱلسَّٰجِدِينَ',
		number_in_surah: '31',
		page: '263',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1834',
		number: '1834',
		text: 'قَالَ يَٰٓإِبْلِيسُ مَا لَكَ أَلَّا تَكُونَ مَعَ ٱلسَّٰجِدِينَ',
		number_in_surah: '32',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1835',
		number: '1835',
		text: 'قَالَ لَمْ أَكُن لِّأَسْجُدَ لِبَشَرٍ خَلَقْتَهُۥ مِن صَلْصَٰلٍۢ مِّنْ حَمَإٍۢ مَّسْنُونٍۢ',
		number_in_surah: '33',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1836',
		number: '1836',
		text: 'قَالَ فَٱخْرُجْ مِنْهَا فَإِنَّكَ رَجِيمٌۭ',
		number_in_surah: '34',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1837',
		number: '1837',
		text: 'وَإِنَّ عَلَيْكَ ٱللَّعْنَةَ إِلَىٰ يَوْمِ ٱلدِّينِ',
		number_in_surah: '35',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1838',
		number: '1838',
		text: 'قَالَ رَبِّ فَأَنظِرْنِىٓ إِلَىٰ يَوْمِ يُبْعَثُونَ',
		number_in_surah: '36',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1839',
		number: '1839',
		text: 'قَالَ فَإِنَّكَ مِنَ ٱلْمُنظَرِينَ',
		number_in_surah: '37',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1840',
		number: '1840',
		text: 'إِلَىٰ يَوْمِ ٱلْوَقْتِ ٱلْمَعْلُومِ',
		number_in_surah: '38',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1841',
		number: '1841',
		text: 'قَالَ رَبِّ بِمَآ أَغْوَيْتَنِى لَأُزَيِّنَنَّ لَهُمْ فِى ٱلْأَرْضِ وَلَأُغْوِيَنَّهُمْ أَجْمَعِينَ',
		number_in_surah: '39',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1842',
		number: '1842',
		text: 'إِلَّا عِبَادَكَ مِنْهُمُ ٱلْمُخْلَصِينَ',
		number_in_surah: '40',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1843',
		number: '1843',
		text: 'قَالَ هَٰذَا صِرَٰطٌ عَلَىَّ مُسْتَقِيمٌ',
		number_in_surah: '41',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1844',
		number: '1844',
		text: 'إِنَّ عِبَادِى لَيْسَ لَكَ عَلَيْهِمْ سُلْطَٰنٌ إِلَّا مَنِ ٱتَّبَعَكَ مِنَ ٱلْغَاوِينَ',
		number_in_surah: '42',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1845',
		number: '1845',
		text: 'وَإِنَّ جَهَنَّمَ لَمَوْعِدُهُمْ أَجْمَعِينَ',
		number_in_surah: '43',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1846',
		number: '1846',
		text: 'لَهَا سَبْعَةُ أَبْوَٰبٍۢ لِّكُلِّ بَابٍۢ مِّنْهُمْ جُزْءٌۭ مَّقْسُومٌ',
		number_in_surah: '44',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1847',
		number: '1847',
		text: 'إِنَّ ٱلْمُتَّقِينَ فِى جَنَّٰتٍۢ وَعُيُونٍ',
		number_in_surah: '45',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1848',
		number: '1848',
		text: 'ٱدْخُلُوهَا بِسَلَٰمٍ ءَامِنِينَ',
		number_in_surah: '46',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1849',
		number: '1849',
		text: 'وَنَزَعْنَا مَا فِى صُدُورِهِم مِّنْ غِلٍّ إِخْوَٰنًا عَلَىٰ سُرُرٍۢ مُّتَقَٰبِلِينَ',
		number_in_surah: '47',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1850',
		number: '1850',
		text: 'لَا يَمَسُّهُمْ فِيهَا نَصَبٌۭ وَمَا هُم مِّنْهَا بِمُخْرَجِينَ',
		number_in_surah: '48',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1851',
		number: '1851',
		text: '۞ نَبِّئْ عِبَادِىٓ أَنِّىٓ أَنَا ٱلْغَفُورُ ٱلرَّحِيمُ',
		number_in_surah: '49',
		page: '264',
		surah_id: '15',
		hizb_id: '105',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1852',
		number: '1852',
		text: 'وَأَنَّ عَذَابِى هُوَ ٱلْعَذَابُ ٱلْأَلِيمُ',
		number_in_surah: '50',
		page: '264',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1853',
		number: '1853',
		text: 'وَنَبِّئْهُمْ عَن ضَيْفِ إِبْرَٰهِيمَ',
		number_in_surah: '51',
		page: '264',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1854',
		number: '1854',
		text: 'إِذْ دَخَلُوا۟ عَلَيْهِ فَقَالُوا۟ سَلَٰمًۭا قَالَ إِنَّا مِنكُمْ وَجِلُونَ',
		number_in_surah: '52',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1855',
		number: '1855',
		text: 'قَالُوا۟ لَا تَوْجَلْ إِنَّا نُبَشِّرُكَ بِغُلَٰمٍ عَلِيمٍۢ',
		number_in_surah: '53',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1856',
		number: '1856',
		text: 'قَالَ أَبَشَّرْتُمُونِى عَلَىٰٓ أَن مَّسَّنِىَ ٱلْكِبَرُ فَبِمَ تُبَشِّرُونَ',
		number_in_surah: '54',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1857',
		number: '1857',
		text: 'قَالُوا۟ بَشَّرْنَٰكَ بِٱلْحَقِّ فَلَا تَكُن مِّنَ ٱلْقَٰنِطِينَ',
		number_in_surah: '55',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1858',
		number: '1858',
		text: 'قَالَ وَمَن يَقْنَطُ مِن رَّحْمَةِ رَبِّهِۦٓ إِلَّا ٱلضَّآلُّونَ',
		number_in_surah: '56',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1859',
		number: '1859',
		text: 'قَالَ فَمَا خَطْبُكُمْ أَيُّهَا ٱلْمُرْسَلُونَ',
		number_in_surah: '57',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1860',
		number: '1860',
		text: 'قَالُوٓا۟ إِنَّآ أُرْسِلْنَآ إِلَىٰ قَوْمٍۢ مُّجْرِمِينَ',
		number_in_surah: '58',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1861',
		number: '1861',
		text: 'إِلَّآ ءَالَ لُوطٍ إِنَّا لَمُنَجُّوهُمْ أَجْمَعِينَ',
		number_in_surah: '59',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1862',
		number: '1862',
		text: 'إِلَّا ٱمْرَأَتَهُۥ قَدَّرْنَآ ۙ إِنَّهَا لَمِنَ ٱلْغَٰبِرِينَ',
		number_in_surah: '60',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1863',
		number: '1863',
		text: 'فَلَمَّا جَآءَ ءَالَ لُوطٍ ٱلْمُرْسَلُونَ',
		number_in_surah: '61',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1864',
		number: '1864',
		text: 'قَالَ إِنَّكُمْ قَوْمٌۭ مُّنكَرُونَ',
		number_in_surah: '62',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1865',
		number: '1865',
		text: 'قَالُوا۟ بَلْ جِئْنَٰكَ بِمَا كَانُوا۟ فِيهِ يَمْتَرُونَ',
		number_in_surah: '63',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1866',
		number: '1866',
		text: 'وَأَتَيْنَٰكَ بِٱلْحَقِّ وَإِنَّا لَصَٰدِقُونَ',
		number_in_surah: '64',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1867',
		number: '1867',
		text: 'فَأَسْرِ بِأَهْلِكَ بِقِطْعٍۢ مِّنَ ٱلَّيْلِ وَٱتَّبِعْ أَدْبَٰرَهُمْ وَلَا يَلْتَفِتْ مِنكُمْ أَحَدٌۭ وَٱمْضُوا۟ حَيْثُ تُؤْمَرُونَ',
		number_in_surah: '65',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1868',
		number: '1868',
		text: 'وَقَضَيْنَآ إِلَيْهِ ذَٰلِكَ ٱلْأَمْرَ أَنَّ دَابِرَ هَٰٓؤُلَآءِ مَقْطُوعٌۭ مُّصْبِحِينَ',
		number_in_surah: '66',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1869',
		number: '1869',
		text: 'وَجَآءَ أَهْلُ ٱلْمَدِينَةِ يَسْتَبْشِرُونَ',
		number_in_surah: '67',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1870',
		number: '1870',
		text: 'قَالَ إِنَّ هَٰٓؤُلَآءِ ضَيْفِى فَلَا تَفْضَحُونِ',
		number_in_surah: '68',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1871',
		number: '1871',
		text: 'وَٱتَّقُوا۟ ٱللَّهَ وَلَا تُخْزُونِ',
		number_in_surah: '69',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1872',
		number: '1872',
		text: 'قَالُوٓا۟ أَوَلَمْ نَنْهَكَ عَنِ ٱلْعَٰلَمِينَ',
		number_in_surah: '70',
		page: '265',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1873',
		number: '1873',
		text: 'قَالَ هَٰٓؤُلَآءِ بَنَاتِىٓ إِن كُنتُمْ فَٰعِلِينَ',
		number_in_surah: '71',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1874',
		number: '1874',
		text: 'لَعَمْرُكَ إِنَّهُمْ لَفِى سَكْرَتِهِمْ يَعْمَهُونَ',
		number_in_surah: '72',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1875',
		number: '1875',
		text: 'فَأَخَذَتْهُمُ ٱلصَّيْحَةُ مُشْرِقِينَ',
		number_in_surah: '73',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1876',
		number: '1876',
		text: 'فَجَعَلْنَا عَٰلِيَهَا سَافِلَهَا وَأَمْطَرْنَا عَلَيْهِمْ حِجَارَةًۭ مِّن سِجِّيلٍ',
		number_in_surah: '74',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1877',
		number: '1877',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّلْمُتَوَسِّمِينَ',
		number_in_surah: '75',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1878',
		number: '1878',
		text: 'وَإِنَّهَا لَبِسَبِيلٍۢ مُّقِيمٍ',
		number_in_surah: '76',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1879',
		number: '1879',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّلْمُؤْمِنِينَ',
		number_in_surah: '77',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1880',
		number: '1880',
		text: 'وَإِن كَانَ أَصْحَٰبُ ٱلْأَيْكَةِ لَظَٰلِمِينَ',
		number_in_surah: '78',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1881',
		number: '1881',
		text: 'فَٱنتَقَمْنَا مِنْهُمْ وَإِنَّهُمَا لَبِإِمَامٍۢ مُّبِينٍۢ',
		number_in_surah: '79',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1882',
		number: '1882',
		text: 'وَلَقَدْ كَذَّبَ أَصْحَٰبُ ٱلْحِجْرِ ٱلْمُرْسَلِينَ',
		number_in_surah: '80',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1883',
		number: '1883',
		text: 'وَءَاتَيْنَٰهُمْ ءَايَٰتِنَا فَكَانُوا۟ عَنْهَا مُعْرِضِينَ',
		number_in_surah: '81',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1884',
		number: '1884',
		text: 'وَكَانُوا۟ يَنْحِتُونَ مِنَ ٱلْجِبَالِ بُيُوتًا ءَامِنِينَ',
		number_in_surah: '82',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1885',
		number: '1885',
		text: 'فَأَخَذَتْهُمُ ٱلصَّيْحَةُ مُصْبِحِينَ',
		number_in_surah: '83',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1886',
		number: '1886',
		text: 'فَمَآ أَغْنَىٰ عَنْهُم مَّا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '84',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1887',
		number: '1887',
		text: 'وَمَا خَلَقْنَا ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَمَا بَيْنَهُمَآ إِلَّا بِٱلْحَقِّ ۗ وَإِنَّ ٱلسَّاعَةَ لَءَاتِيَةٌۭ ۖ فَٱصْفَحِ ٱلصَّفْحَ ٱلْجَمِيلَ',
		number_in_surah: '85',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1888',
		number: '1888',
		text: 'إِنَّ رَبَّكَ هُوَ ٱلْخَلَّٰقُ ٱلْعَلِيمُ',
		number_in_surah: '86',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1889',
		number: '1889',
		text: 'وَلَقَدْ ءَاتَيْنَٰكَ سَبْعًۭا مِّنَ ٱلْمَثَانِى وَٱلْقُرْءَانَ ٱلْعَظِيمَ',
		number_in_surah: '87',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1890',
		number: '1890',
		text: 'لَا تَمُدَّنَّ عَيْنَيْكَ إِلَىٰ مَا مَتَّعْنَا بِهِۦٓ أَزْوَٰجًۭا مِّنْهُمْ وَلَا تَحْزَنْ عَلَيْهِمْ وَٱخْفِضْ جَنَاحَكَ لِلْمُؤْمِنِينَ',
		number_in_surah: '88',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1891',
		number: '1891',
		text: 'وَقُلْ إِنِّىٓ أَنَا ٱلنَّذِيرُ ٱلْمُبِينُ',
		number_in_surah: '89',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1892',
		number: '1892',
		text: 'كَمَآ أَنزَلْنَا عَلَى ٱلْمُقْتَسِمِينَ',
		number_in_surah: '90',
		page: '266',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1893',
		number: '1893',
		text: 'ٱلَّذِينَ جَعَلُوا۟ ٱلْقُرْءَانَ عِضِينَ',
		number_in_surah: '91',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1894',
		number: '1894',
		text: 'فَوَرَبِّكَ لَنَسْـَٔلَنَّهُمْ أَجْمَعِينَ',
		number_in_surah: '92',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1895',
		number: '1895',
		text: 'عَمَّا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '93',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1896',
		number: '1896',
		text: 'فَٱصْدَعْ بِمَا تُؤْمَرُ وَأَعْرِضْ عَنِ ٱلْمُشْرِكِينَ',
		number_in_surah: '94',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1897',
		number: '1897',
		text: 'إِنَّا كَفَيْنَٰكَ ٱلْمُسْتَهْزِءِينَ',
		number_in_surah: '95',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1898',
		number: '1898',
		text: 'ٱلَّذِينَ يَجْعَلُونَ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ ۚ فَسَوْفَ يَعْلَمُونَ',
		number_in_surah: '96',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1899',
		number: '1899',
		text: 'وَلَقَدْ نَعْلَمُ أَنَّكَ يَضِيقُ صَدْرُكَ بِمَا يَقُولُونَ',
		number_in_surah: '97',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1900',
		number: '1900',
		text: 'فَسَبِّحْ بِحَمْدِ رَبِّكَ وَكُن مِّنَ ٱلسَّٰجِدِينَ',
		number_in_surah: '98',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1901',
		number: '1901',
		text: 'وَٱعْبُدْ رَبَّكَ حَتَّىٰ يَأْتِيَكَ ٱلْيَقِينُ',
		number_in_surah: '99',
		page: '267',
		surah_id: '15',
		hizb_id: '106',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1902',
		number: '1902',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ أَتَىٰٓ أَمْرُ ٱللَّهِ فَلَا تَسْتَعْجِلُوهُ ۚ سُبْحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشْرِكُونَ',
		number_in_surah: '1',
		page: '267',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1903',
		number: '1903',
		text: 'يُنَزِّلُ ٱلْمَلَٰٓئِكَةَ بِٱلرُّوحِ مِنْ أَمْرِهِۦ عَلَىٰ مَن يَشَآءُ مِنْ عِبَادِهِۦٓ أَنْ أَنذِرُوٓا۟ أَنَّهُۥ لَآ إِلَٰهَ إِلَّآ أَنَا۠ فَٱتَّقُونِ',
		number_in_surah: '2',
		page: '267',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1904',
		number: '1904',
		text: 'خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ بِٱلْحَقِّ ۚ تَعَٰلَىٰ عَمَّا يُشْرِكُونَ',
		number_in_surah: '3',
		page: '267',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1905',
		number: '1905',
		text: 'خَلَقَ ٱلْإِنسَٰنَ مِن نُّطْفَةٍۢ فَإِذَا هُوَ خَصِيمٌۭ مُّبِينٌۭ',
		number_in_surah: '4',
		page: '267',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1906',
		number: '1906',
		text: 'وَٱلْأَنْعَٰمَ خَلَقَهَا ۗ لَكُمْ فِيهَا دِفْءٌۭ وَمَنَٰفِعُ وَمِنْهَا تَأْكُلُونَ',
		number_in_surah: '5',
		page: '267',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1907',
		number: '1907',
		text: 'وَلَكُمْ فِيهَا جَمَالٌ حِينَ تُرِيحُونَ وَحِينَ تَسْرَحُونَ',
		number_in_surah: '6',
		page: '267',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1908',
		number: '1908',
		text: 'وَتَحْمِلُ أَثْقَالَكُمْ إِلَىٰ بَلَدٍۢ لَّمْ تَكُونُوا۟ بَٰلِغِيهِ إِلَّا بِشِقِّ ٱلْأَنفُسِ ۚ إِنَّ رَبَّكُمْ لَرَءُوفٌۭ رَّحِيمٌۭ',
		number_in_surah: '7',
		page: '268',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1909',
		number: '1909',
		text: 'وَٱلْخَيْلَ وَٱلْبِغَالَ وَٱلْحَمِيرَ لِتَرْكَبُوهَا وَزِينَةًۭ ۚ وَيَخْلُقُ مَا لَا تَعْلَمُونَ',
		number_in_surah: '8',
		page: '268',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1910',
		number: '1910',
		text: 'وَعَلَى ٱللَّهِ قَصْدُ ٱلسَّبِيلِ وَمِنْهَا جَآئِرٌۭ ۚ وَلَوْ شَآءَ لَهَدَىٰكُمْ أَجْمَعِينَ',
		number_in_surah: '9',
		page: '268',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1911',
		number: '1911',
		text: 'هُوَ ٱلَّذِىٓ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ ۖ لَّكُم مِّنْهُ شَرَابٌۭ وَمِنْهُ شَجَرٌۭ فِيهِ تُسِيمُونَ',
		number_in_surah: '10',
		page: '268',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1912',
		number: '1912',
		text: 'يُنۢبِتُ لَكُم بِهِ ٱلزَّرْعَ وَٱلزَّيْتُونَ وَٱلنَّخِيلَ وَٱلْأَعْنَٰبَ وَمِن كُلِّ ٱلثَّمَرَٰتِ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّقَوْمٍۢ يَتَفَكَّرُونَ',
		number_in_surah: '11',
		page: '268',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1913',
		number: '1913',
		text: 'وَسَخَّرَ لَكُمُ ٱلَّيْلَ وَٱلنَّهَارَ وَٱلشَّمْسَ وَٱلْقَمَرَ ۖ وَٱلنُّجُومُ مُسَخَّرَٰتٌۢ بِأَمْرِهِۦٓ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَعْقِلُونَ',
		number_in_surah: '12',
		page: '268',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1914',
		number: '1914',
		text: 'وَمَا ذَرَأَ لَكُمْ فِى ٱلْأَرْضِ مُخْتَلِفًا أَلْوَٰنُهُۥٓ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّقَوْمٍۢ يَذَّكَّرُونَ',
		number_in_surah: '13',
		page: '268',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1915',
		number: '1915',
		text: 'وَهُوَ ٱلَّذِى سَخَّرَ ٱلْبَحْرَ لِتَأْكُلُوا۟ مِنْهُ لَحْمًۭا طَرِيًّۭا وَتَسْتَخْرِجُوا۟ مِنْهُ حِلْيَةًۭ تَلْبَسُونَهَا وَتَرَى ٱلْفُلْكَ مَوَاخِرَ فِيهِ وَلِتَبْتَغُوا۟ مِن فَضْلِهِۦ وَلَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '14',
		page: '268',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1916',
		number: '1916',
		text: 'وَأَلْقَىٰ فِى ٱلْأَرْضِ رَوَٰسِىَ أَن تَمِيدَ بِكُمْ وَأَنْهَٰرًۭا وَسُبُلًۭا لَّعَلَّكُمْ تَهْتَدُونَ',
		number_in_surah: '15',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1917',
		number: '1917',
		text: 'وَعَلَٰمَٰتٍۢ ۚ وَبِٱلنَّجْمِ هُمْ يَهْتَدُونَ',
		number_in_surah: '16',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1918',
		number: '1918',
		text: 'أَفَمَن يَخْلُقُ كَمَن لَّا يَخْلُقُ ۗ أَفَلَا تَذَكَّرُونَ',
		number_in_surah: '17',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1919',
		number: '1919',
		text: 'وَإِن تَعُدُّوا۟ نِعْمَةَ ٱللَّهِ لَا تُحْصُوهَآ ۗ إِنَّ ٱللَّهَ لَغَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '18',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1920',
		number: '1920',
		text: 'وَٱللَّهُ يَعْلَمُ مَا تُسِرُّونَ وَمَا تُعْلِنُونَ',
		number_in_surah: '19',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1921',
		number: '1921',
		text: 'وَٱلَّذِينَ يَدْعُونَ مِن دُونِ ٱللَّهِ لَا يَخْلُقُونَ شَيْـًۭٔا وَهُمْ يُخْلَقُونَ',
		number_in_surah: '20',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1922',
		number: '1922',
		text: 'أَمْوَٰتٌ غَيْرُ أَحْيَآءٍۢ ۖ وَمَا يَشْعُرُونَ أَيَّانَ يُبْعَثُونَ',
		number_in_surah: '21',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1923',
		number: '1923',
		text: 'إِلَٰهُكُمْ إِلَٰهٌۭ وَٰحِدٌۭ ۚ فَٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ قُلُوبُهُم مُّنكِرَةٌۭ وَهُم مُّسْتَكْبِرُونَ',
		number_in_surah: '22',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1924',
		number: '1924',
		text: 'لَا جَرَمَ أَنَّ ٱللَّهَ يَعْلَمُ مَا يُسِرُّونَ وَمَا يُعْلِنُونَ ۚ إِنَّهُۥ لَا يُحِبُّ ٱلْمُسْتَكْبِرِينَ',
		number_in_surah: '23',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1925',
		number: '1925',
		text: 'وَإِذَا قِيلَ لَهُم مَّاذَآ أَنزَلَ رَبُّكُمْ ۙ قَالُوٓا۟ أَسَٰطِيرُ ٱلْأَوَّلِينَ',
		number_in_surah: '24',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1926',
		number: '1926',
		text: 'لِيَحْمِلُوٓا۟ أَوْزَارَهُمْ كَامِلَةًۭ يَوْمَ ٱلْقِيَٰمَةِ ۙ وَمِنْ أَوْزَارِ ٱلَّذِينَ يُضِلُّونَهُم بِغَيْرِ عِلْمٍ ۗ أَلَا سَآءَ مَا يَزِرُونَ',
		number_in_surah: '25',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1927',
		number: '1927',
		text: 'قَدْ مَكَرَ ٱلَّذِينَ مِن قَبْلِهِمْ فَأَتَى ٱللَّهُ بُنْيَٰنَهُم مِّنَ ٱلْقَوَاعِدِ فَخَرَّ عَلَيْهِمُ ٱلسَّقْفُ مِن فَوْقِهِمْ وَأَتَىٰهُمُ ٱلْعَذَابُ مِنْ حَيْثُ لَا يَشْعُرُونَ',
		number_in_surah: '26',
		page: '269',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1928',
		number: '1928',
		text: 'ثُمَّ يَوْمَ ٱلْقِيَٰمَةِ يُخْزِيهِمْ وَيَقُولُ أَيْنَ شُرَكَآءِىَ ٱلَّذِينَ كُنتُمْ تُشَٰٓقُّونَ فِيهِمْ ۚ قَالَ ٱلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ إِنَّ ٱلْخِزْىَ ٱلْيَوْمَ وَٱلسُّوٓءَ عَلَى ٱلْكَٰفِرِينَ',
		number_in_surah: '27',
		page: '270',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1929',
		number: '1929',
		text: 'ٱلَّذِينَ تَتَوَفَّىٰهُمُ ٱلْمَلَٰٓئِكَةُ ظَالِمِىٓ أَنفُسِهِمْ ۖ فَأَلْقَوُا۟ ٱلسَّلَمَ مَا كُنَّا نَعْمَلُ مِن سُوٓءٍۭ ۚ بَلَىٰٓ إِنَّ ٱللَّهَ عَلِيمٌۢ بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '28',
		page: '270',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1930',
		number: '1930',
		text: 'فَٱدْخُلُوٓا۟ أَبْوَٰبَ جَهَنَّمَ خَٰلِدِينَ فِيهَا ۖ فَلَبِئْسَ مَثْوَى ٱلْمُتَكَبِّرِينَ',
		number_in_surah: '29',
		page: '270',
		surah_id: '16',
		hizb_id: '107',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1931',
		number: '1931',
		text: '۞ وَقِيلَ لِلَّذِينَ ٱتَّقَوْا۟ مَاذَآ أَنزَلَ رَبُّكُمْ ۚ قَالُوا۟ خَيْرًۭا ۗ لِّلَّذِينَ أَحْسَنُوا۟ فِى هَٰذِهِ ٱلدُّنْيَا حَسَنَةٌۭ ۚ وَلَدَارُ ٱلْءَاخِرَةِ خَيْرٌۭ ۚ وَلَنِعْمَ دَارُ ٱلْمُتَّقِينَ',
		number_in_surah: '30',
		page: '270',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1932',
		number: '1932',
		text: 'جَنَّٰتُ عَدْنٍۢ يَدْخُلُونَهَا تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۖ لَهُمْ فِيهَا مَا يَشَآءُونَ ۚ كَذَٰلِكَ يَجْزِى ٱللَّهُ ٱلْمُتَّقِينَ',
		number_in_surah: '31',
		page: '270',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1933',
		number: '1933',
		text: 'ٱلَّذِينَ تَتَوَفَّىٰهُمُ ٱلْمَلَٰٓئِكَةُ طَيِّبِينَ ۙ يَقُولُونَ سَلَٰمٌ عَلَيْكُمُ ٱدْخُلُوا۟ ٱلْجَنَّةَ بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '32',
		page: '270',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1934',
		number: '1934',
		text: 'هَلْ يَنظُرُونَ إِلَّآ أَن تَأْتِيَهُمُ ٱلْمَلَٰٓئِكَةُ أَوْ يَأْتِىَ أَمْرُ رَبِّكَ ۚ كَذَٰلِكَ فَعَلَ ٱلَّذِينَ مِن قَبْلِهِمْ ۚ وَمَا ظَلَمَهُمُ ٱللَّهُ وَلَٰكِن كَانُوٓا۟ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '33',
		page: '270',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1935',
		number: '1935',
		text: 'فَأَصَابَهُمْ سَيِّـَٔاتُ مَا عَمِلُوا۟ وَحَاقَ بِهِم مَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '34',
		page: '270',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1936',
		number: '1936',
		text: 'وَقَالَ ٱلَّذِينَ أَشْرَكُوا۟ لَوْ شَآءَ ٱللَّهُ مَا عَبَدْنَا مِن دُونِهِۦ مِن شَىْءٍۢ نَّحْنُ وَلَآ ءَابَآؤُنَا وَلَا حَرَّمْنَا مِن دُونِهِۦ مِن شَىْءٍۢ ۚ كَذَٰلِكَ فَعَلَ ٱلَّذِينَ مِن قَبْلِهِمْ ۚ فَهَلْ عَلَى ٱلرُّسُلِ إِلَّا ٱلْبَلَٰغُ ٱلْمُبِينُ',
		number_in_surah: '35',
		page: '271',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1937',
		number: '1937',
		text: 'وَلَقَدْ بَعَثْنَا فِى كُلِّ أُمَّةٍۢ رَّسُولًا أَنِ ٱعْبُدُوا۟ ٱللَّهَ وَٱجْتَنِبُوا۟ ٱلطَّٰغُوتَ ۖ فَمِنْهُم مَّنْ هَدَى ٱللَّهُ وَمِنْهُم مَّنْ حَقَّتْ عَلَيْهِ ٱلضَّلَٰلَةُ ۚ فَسِيرُوا۟ فِى ٱلْأَرْضِ فَٱنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُكَذِّبِينَ',
		number_in_surah: '36',
		page: '271',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1938',
		number: '1938',
		text: 'إِن تَحْرِصْ عَلَىٰ هُدَىٰهُمْ فَإِنَّ ٱللَّهَ لَا يَهْدِى مَن يُضِلُّ ۖ وَمَا لَهُم مِّن نَّٰصِرِينَ',
		number_in_surah: '37',
		page: '271',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1939',
		number: '1939',
		text: 'وَأَقْسَمُوا۟ بِٱللَّهِ جَهْدَ أَيْمَٰنِهِمْ ۙ لَا يَبْعَثُ ٱللَّهُ مَن يَمُوتُ ۚ بَلَىٰ وَعْدًا عَلَيْهِ حَقًّۭا وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '38',
		page: '271',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1940',
		number: '1940',
		text: 'لِيُبَيِّنَ لَهُمُ ٱلَّذِى يَخْتَلِفُونَ فِيهِ وَلِيَعْلَمَ ٱلَّذِينَ كَفَرُوٓا۟ أَنَّهُمْ كَانُوا۟ كَٰذِبِينَ',
		number_in_surah: '39',
		page: '271',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1941',
		number: '1941',
		text: 'إِنَّمَا قَوْلُنَا لِشَىْءٍ إِذَآ أَرَدْنَٰهُ أَن نَّقُولَ لَهُۥ كُن فَيَكُونُ',
		number_in_surah: '40',
		page: '271',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1942',
		number: '1942',
		text: 'وَٱلَّذِينَ هَاجَرُوا۟ فِى ٱللَّهِ مِنۢ بَعْدِ مَا ظُلِمُوا۟ لَنُبَوِّئَنَّهُمْ فِى ٱلدُّنْيَا حَسَنَةًۭ ۖ وَلَأَجْرُ ٱلْءَاخِرَةِ أَكْبَرُ ۚ لَوْ كَانُوا۟ يَعْلَمُونَ',
		number_in_surah: '41',
		page: '271',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1943',
		number: '1943',
		text: 'ٱلَّذِينَ صَبَرُوا۟ وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ',
		number_in_surah: '42',
		page: '271',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1944',
		number: '1944',
		text: 'وَمَآ أَرْسَلْنَا مِن قَبْلِكَ إِلَّا رِجَالًۭا نُّوحِىٓ إِلَيْهِمْ ۚ فَسْـَٔلُوٓا۟ أَهْلَ ٱلذِّكْرِ إِن كُنتُمْ لَا تَعْلَمُونَ',
		number_in_surah: '43',
		page: '272',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1945',
		number: '1945',
		text: 'بِٱلْبَيِّنَٰتِ وَٱلزُّبُرِ ۗ وَأَنزَلْنَآ إِلَيْكَ ٱلذِّكْرَ لِتُبَيِّنَ لِلنَّاسِ مَا نُزِّلَ إِلَيْهِمْ وَلَعَلَّهُمْ يَتَفَكَّرُونَ',
		number_in_surah: '44',
		page: '272',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1946',
		number: '1946',
		text: 'أَفَأَمِنَ ٱلَّذِينَ مَكَرُوا۟ ٱلسَّيِّـَٔاتِ أَن يَخْسِفَ ٱللَّهُ بِهِمُ ٱلْأَرْضَ أَوْ يَأْتِيَهُمُ ٱلْعَذَابُ مِنْ حَيْثُ لَا يَشْعُرُونَ',
		number_in_surah: '45',
		page: '272',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1947',
		number: '1947',
		text: 'أَوْ يَأْخُذَهُمْ فِى تَقَلُّبِهِمْ فَمَا هُم بِمُعْجِزِينَ',
		number_in_surah: '46',
		page: '272',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1948',
		number: '1948',
		text: 'أَوْ يَأْخُذَهُمْ عَلَىٰ تَخَوُّفٍۢ فَإِنَّ رَبَّكُمْ لَرَءُوفٌۭ رَّحِيمٌ',
		number_in_surah: '47',
		page: '272',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1949',
		number: '1949',
		text: 'أَوَلَمْ يَرَوْا۟ إِلَىٰ مَا خَلَقَ ٱللَّهُ مِن شَىْءٍۢ يَتَفَيَّؤُا۟ ظِلَٰلُهُۥ عَنِ ٱلْيَمِينِ وَٱلشَّمَآئِلِ سُجَّدًۭا لِّلَّهِ وَهُمْ دَٰخِرُونَ',
		number_in_surah: '48',
		page: '272',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1950',
		number: '1950',
		text: 'وَلِلَّهِ يَسْجُدُ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ مِن دَآبَّةٍۢ وَٱلْمَلَٰٓئِكَةُ وَهُمْ لَا يَسْتَكْبِرُونَ',
		number_in_surah: '49',
		page: '272',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1951',
		number: '1951',
		text: 'يَخَافُونَ رَبَّهُم مِّن فَوْقِهِمْ وَيَفْعَلُونَ مَا يُؤْمَرُونَ ۩',
		number_in_surah: '50',
		page: '272',
		surah_id: '16',
		hizb_id: '108',
		juz_id: '14',
		sajda: '1',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1952',
		number: '1952',
		text: '۞ وَقَالَ ٱللَّهُ لَا تَتَّخِذُوٓا۟ إِلَٰهَيْنِ ٱثْنَيْنِ ۖ إِنَّمَا هُوَ إِلَٰهٌۭ وَٰحِدٌۭ ۖ فَإِيَّٰىَ فَٱرْهَبُونِ',
		number_in_surah: '51',
		page: '272',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1953',
		number: '1953',
		text: 'وَلَهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَلَهُ ٱلدِّينُ وَاصِبًا ۚ أَفَغَيْرَ ٱللَّهِ تَتَّقُونَ',
		number_in_surah: '52',
		page: '272',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1954',
		number: '1954',
		text: 'وَمَا بِكُم مِّن نِّعْمَةٍۢ فَمِنَ ٱللَّهِ ۖ ثُمَّ إِذَا مَسَّكُمُ ٱلضُّرُّ فَإِلَيْهِ تَجْـَٔرُونَ',
		number_in_surah: '53',
		page: '272',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1955',
		number: '1955',
		text: 'ثُمَّ إِذَا كَشَفَ ٱلضُّرَّ عَنكُمْ إِذَا فَرِيقٌۭ مِّنكُم بِرَبِّهِمْ يُشْرِكُونَ',
		number_in_surah: '54',
		page: '272',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1956',
		number: '1956',
		text: 'لِيَكْفُرُوا۟ بِمَآ ءَاتَيْنَٰهُمْ ۚ فَتَمَتَّعُوا۟ ۖ فَسَوْفَ تَعْلَمُونَ',
		number_in_surah: '55',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1957',
		number: '1957',
		text: 'وَيَجْعَلُونَ لِمَا لَا يَعْلَمُونَ نَصِيبًۭا مِّمَّا رَزَقْنَٰهُمْ ۗ تَٱللَّهِ لَتُسْـَٔلُنَّ عَمَّا كُنتُمْ تَفْتَرُونَ',
		number_in_surah: '56',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1958',
		number: '1958',
		text: 'وَيَجْعَلُونَ لِلَّهِ ٱلْبَنَٰتِ سُبْحَٰنَهُۥ ۙ وَلَهُم مَّا يَشْتَهُونَ',
		number_in_surah: '57',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1959',
		number: '1959',
		text: 'وَإِذَا بُشِّرَ أَحَدُهُم بِٱلْأُنثَىٰ ظَلَّ وَجْهُهُۥ مُسْوَدًّۭا وَهُوَ كَظِيمٌۭ',
		number_in_surah: '58',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1960',
		number: '1960',
		text: 'يَتَوَٰرَىٰ مِنَ ٱلْقَوْمِ مِن سُوٓءِ مَا بُشِّرَ بِهِۦٓ ۚ أَيُمْسِكُهُۥ عَلَىٰ هُونٍ أَمْ يَدُسُّهُۥ فِى ٱلتُّرَابِ ۗ أَلَا سَآءَ مَا يَحْكُمُونَ',
		number_in_surah: '59',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1961',
		number: '1961',
		text: 'لِلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ مَثَلُ ٱلسَّوْءِ ۖ وَلِلَّهِ ٱلْمَثَلُ ٱلْأَعْلَىٰ ۚ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '60',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1962',
		number: '1962',
		text: 'وَلَوْ يُؤَاخِذُ ٱللَّهُ ٱلنَّاسَ بِظُلْمِهِم مَّا تَرَكَ عَلَيْهَا مِن دَآبَّةٍۢ وَلَٰكِن يُؤَخِّرُهُمْ إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى ۖ فَإِذَا جَآءَ أَجَلُهُمْ لَا يَسْتَـْٔخِرُونَ سَاعَةًۭ ۖ وَلَا يَسْتَقْدِمُونَ',
		number_in_surah: '61',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1963',
		number: '1963',
		text: 'وَيَجْعَلُونَ لِلَّهِ مَا يَكْرَهُونَ وَتَصِفُ أَلْسِنَتُهُمُ ٱلْكَذِبَ أَنَّ لَهُمُ ٱلْحُسْنَىٰ ۖ لَا جَرَمَ أَنَّ لَهُمُ ٱلنَّارَ وَأَنَّهُم مُّفْرَطُونَ',
		number_in_surah: '62',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1964',
		number: '1964',
		text: 'تَٱللَّهِ لَقَدْ أَرْسَلْنَآ إِلَىٰٓ أُمَمٍۢ مِّن قَبْلِكَ فَزَيَّنَ لَهُمُ ٱلشَّيْطَٰنُ أَعْمَٰلَهُمْ فَهُوَ وَلِيُّهُمُ ٱلْيَوْمَ وَلَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '63',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1965',
		number: '1965',
		text: 'وَمَآ أَنزَلْنَا عَلَيْكَ ٱلْكِتَٰبَ إِلَّا لِتُبَيِّنَ لَهُمُ ٱلَّذِى ٱخْتَلَفُوا۟ فِيهِ ۙ وَهُدًۭى وَرَحْمَةًۭ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '64',
		page: '273',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1966',
		number: '1966',
		text: 'وَٱللَّهُ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَحْيَا بِهِ ٱلْأَرْضَ بَعْدَ مَوْتِهَآ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّقَوْمٍۢ يَسْمَعُونَ',
		number_in_surah: '65',
		page: '274',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1967',
		number: '1967',
		text: 'وَإِنَّ لَكُمْ فِى ٱلْأَنْعَٰمِ لَعِبْرَةًۭ ۖ نُّسْقِيكُم مِّمَّا فِى بُطُونِهِۦ مِنۢ بَيْنِ فَرْثٍۢ وَدَمٍۢ لَّبَنًا خَالِصًۭا سَآئِغًۭا لِّلشَّٰرِبِينَ',
		number_in_surah: '66',
		page: '274',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1968',
		number: '1968',
		text: 'وَمِن ثَمَرَٰتِ ٱلنَّخِيلِ وَٱلْأَعْنَٰبِ تَتَّخِذُونَ مِنْهُ سَكَرًۭا وَرِزْقًا حَسَنًا ۗ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّقَوْمٍۢ يَعْقِلُونَ',
		number_in_surah: '67',
		page: '274',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1969',
		number: '1969',
		text: 'وَأَوْحَىٰ رَبُّكَ إِلَى ٱلنَّحْلِ أَنِ ٱتَّخِذِى مِنَ ٱلْجِبَالِ بُيُوتًۭا وَمِنَ ٱلشَّجَرِ وَمِمَّا يَعْرِشُونَ',
		number_in_surah: '68',
		page: '274',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:06:59',
		updated_at: '2018-06-07 08:06:59',
	},
	{
		id: '1970',
		number: '1970',
		text: 'ثُمَّ كُلِى مِن كُلِّ ٱلثَّمَرَٰتِ فَٱسْلُكِى سُبُلَ رَبِّكِ ذُلُلًۭا ۚ يَخْرُجُ مِنۢ بُطُونِهَا شَرَابٌۭ مُّخْتَلِفٌ أَلْوَٰنُهُۥ فِيهِ شِفَآءٌۭ لِّلنَّاسِ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّقَوْمٍۢ يَتَفَكَّرُونَ',
		number_in_surah: '69',
		page: '274',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1971',
		number: '1971',
		text: 'وَٱللَّهُ خَلَقَكُمْ ثُمَّ يَتَوَفَّىٰكُمْ ۚ وَمِنكُم مَّن يُرَدُّ إِلَىٰٓ أَرْذَلِ ٱلْعُمُرِ لِكَىْ لَا يَعْلَمَ بَعْدَ عِلْمٍۢ شَيْـًٔا ۚ إِنَّ ٱللَّهَ عَلِيمٌۭ قَدِيرٌۭ',
		number_in_surah: '70',
		page: '274',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1972',
		number: '1972',
		text: 'وَٱللَّهُ فَضَّلَ بَعْضَكُمْ عَلَىٰ بَعْضٍۢ فِى ٱلرِّزْقِ ۚ فَمَا ٱلَّذِينَ فُضِّلُوا۟ بِرَآدِّى رِزْقِهِمْ عَلَىٰ مَا مَلَكَتْ أَيْمَٰنُهُمْ فَهُمْ فِيهِ سَوَآءٌ ۚ أَفَبِنِعْمَةِ ٱللَّهِ يَجْحَدُونَ',
		number_in_surah: '71',
		page: '274',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1973',
		number: '1973',
		text: 'وَٱللَّهُ جَعَلَ لَكُم مِّنْ أَنفُسِكُمْ أَزْوَٰجًۭا وَجَعَلَ لَكُم مِّنْ أَزْوَٰجِكُم بَنِينَ وَحَفَدَةًۭ وَرَزَقَكُم مِّنَ ٱلطَّيِّبَٰتِ ۚ أَفَبِٱلْبَٰطِلِ يُؤْمِنُونَ وَبِنِعْمَتِ ٱللَّهِ هُمْ يَكْفُرُونَ',
		number_in_surah: '72',
		page: '274',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1974',
		number: '1974',
		text: 'وَيَعْبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَمْلِكُ لَهُمْ رِزْقًۭا مِّنَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ شَيْـًۭٔا وَلَا يَسْتَطِيعُونَ',
		number_in_surah: '73',
		page: '275',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1975',
		number: '1975',
		text: 'فَلَا تَضْرِبُوا۟ لِلَّهِ ٱلْأَمْثَالَ ۚ إِنَّ ٱللَّهَ يَعْلَمُ وَأَنتُمْ لَا تَعْلَمُونَ',
		number_in_surah: '74',
		page: '275',
		surah_id: '16',
		hizb_id: '109',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1976',
		number: '1976',
		text: '۞ ضَرَبَ ٱللَّهُ مَثَلًا عَبْدًۭا مَّمْلُوكًۭا لَّا يَقْدِرُ عَلَىٰ شَىْءٍۢ وَمَن رَّزَقْنَٰهُ مِنَّا رِزْقًا حَسَنًۭا فَهُوَ يُنفِقُ مِنْهُ سِرًّۭا وَجَهْرًا ۖ هَلْ يَسْتَوُۥنَ ۚ ٱلْحَمْدُ لِلَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '75',
		page: '275',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1977',
		number: '1977',
		text: 'وَضَرَبَ ٱللَّهُ مَثَلًۭا رَّجُلَيْنِ أَحَدُهُمَآ أَبْكَمُ لَا يَقْدِرُ عَلَىٰ شَىْءٍۢ وَهُوَ كَلٌّ عَلَىٰ مَوْلَىٰهُ أَيْنَمَا يُوَجِّههُّ لَا يَأْتِ بِخَيْرٍ ۖ هَلْ يَسْتَوِى هُوَ وَمَن يَأْمُرُ بِٱلْعَدْلِ ۙ وَهُوَ عَلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '76',
		page: '275',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1978',
		number: '1978',
		text: 'وَلِلَّهِ غَيْبُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَمَآ أَمْرُ ٱلسَّاعَةِ إِلَّا كَلَمْحِ ٱلْبَصَرِ أَوْ هُوَ أَقْرَبُ ۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '77',
		page: '275',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1979',
		number: '1979',
		text: 'وَٱللَّهُ أَخْرَجَكُم مِّنۢ بُطُونِ أُمَّهَٰتِكُمْ لَا تَعْلَمُونَ شَيْـًۭٔا وَجَعَلَ لَكُمُ ٱلسَّمْعَ وَٱلْأَبْصَٰرَ وَٱلْأَفْـِٔدَةَ ۙ لَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '78',
		page: '275',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1980',
		number: '1980',
		text: 'أَلَمْ يَرَوْا۟ إِلَى ٱلطَّيْرِ مُسَخَّرَٰتٍۢ فِى جَوِّ ٱلسَّمَآءِ مَا يُمْسِكُهُنَّ إِلَّا ٱللَّهُ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '79',
		page: '275',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1981',
		number: '1981',
		text: 'وَٱللَّهُ جَعَلَ لَكُم مِّنۢ بُيُوتِكُمْ سَكَنًۭا وَجَعَلَ لَكُم مِّن جُلُودِ ٱلْأَنْعَٰمِ بُيُوتًۭا تَسْتَخِفُّونَهَا يَوْمَ ظَعْنِكُمْ وَيَوْمَ إِقَامَتِكُمْ ۙ وَمِنْ أَصْوَافِهَا وَأَوْبَارِهَا وَأَشْعَارِهَآ أَثَٰثًۭا وَمَتَٰعًا إِلَىٰ حِينٍۢ',
		number_in_surah: '80',
		page: '276',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1982',
		number: '1982',
		text: 'وَٱللَّهُ جَعَلَ لَكُم مِّمَّا خَلَقَ ظِلَٰلًۭا وَجَعَلَ لَكُم مِّنَ ٱلْجِبَالِ أَكْنَٰنًۭا وَجَعَلَ لَكُمْ سَرَٰبِيلَ تَقِيكُمُ ٱلْحَرَّ وَسَرَٰبِيلَ تَقِيكُم بَأْسَكُمْ ۚ كَذَٰلِكَ يُتِمُّ نِعْمَتَهُۥ عَلَيْكُمْ لَعَلَّكُمْ تُسْلِمُونَ',
		number_in_surah: '81',
		page: '276',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1983',
		number: '1983',
		text: 'فَإِن تَوَلَّوْا۟ فَإِنَّمَا عَلَيْكَ ٱلْبَلَٰغُ ٱلْمُبِينُ',
		number_in_surah: '82',
		page: '276',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1984',
		number: '1984',
		text: 'يَعْرِفُونَ نِعْمَتَ ٱللَّهِ ثُمَّ يُنكِرُونَهَا وَأَكْثَرُهُمُ ٱلْكَٰفِرُونَ',
		number_in_surah: '83',
		page: '276',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1985',
		number: '1985',
		text: 'وَيَوْمَ نَبْعَثُ مِن كُلِّ أُمَّةٍۢ شَهِيدًۭا ثُمَّ لَا يُؤْذَنُ لِلَّذِينَ كَفَرُوا۟ وَلَا هُمْ يُسْتَعْتَبُونَ',
		number_in_surah: '84',
		page: '276',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1986',
		number: '1986',
		text: 'وَإِذَا رَءَا ٱلَّذِينَ ظَلَمُوا۟ ٱلْعَذَابَ فَلَا يُخَفَّفُ عَنْهُمْ وَلَا هُمْ يُنظَرُونَ',
		number_in_surah: '85',
		page: '276',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1987',
		number: '1987',
		text: 'وَإِذَا رَءَا ٱلَّذِينَ أَشْرَكُوا۟ شُرَكَآءَهُمْ قَالُوا۟ رَبَّنَا هَٰٓؤُلَآءِ شُرَكَآؤُنَا ٱلَّذِينَ كُنَّا نَدْعُوا۟ مِن دُونِكَ ۖ فَأَلْقَوْا۟ إِلَيْهِمُ ٱلْقَوْلَ إِنَّكُمْ لَكَٰذِبُونَ',
		number_in_surah: '86',
		page: '276',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1988',
		number: '1988',
		text: 'وَأَلْقَوْا۟ إِلَى ٱللَّهِ يَوْمَئِذٍ ٱلسَّلَمَ ۖ وَضَلَّ عَنْهُم مَّا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '87',
		page: '276',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1989',
		number: '1989',
		text: 'ٱلَّذِينَ كَفَرُوا۟ وَصَدُّوا۟ عَن سَبِيلِ ٱللَّهِ زِدْنَٰهُمْ عَذَابًۭا فَوْقَ ٱلْعَذَابِ بِمَا كَانُوا۟ يُفْسِدُونَ',
		number_in_surah: '88',
		page: '277',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1990',
		number: '1990',
		text: 'وَيَوْمَ نَبْعَثُ فِى كُلِّ أُمَّةٍۢ شَهِيدًا عَلَيْهِم مِّنْ أَنفُسِهِمْ ۖ وَجِئْنَا بِكَ شَهِيدًا عَلَىٰ هَٰٓؤُلَآءِ ۚ وَنَزَّلْنَا عَلَيْكَ ٱلْكِتَٰبَ تِبْيَٰنًۭا لِّكُلِّ شَىْءٍۢ وَهُدًۭى وَرَحْمَةًۭ وَبُشْرَىٰ لِلْمُسْلِمِينَ',
		number_in_surah: '89',
		page: '277',
		surah_id: '16',
		hizb_id: '110',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1991',
		number: '1991',
		text: '۞ إِنَّ ٱللَّهَ يَأْمُرُ بِٱلْعَدْلِ وَٱلْإِحْسَٰنِ وَإِيتَآئِ ذِى ٱلْقُرْبَىٰ وَيَنْهَىٰ عَنِ ٱلْفَحْشَآءِ وَٱلْمُنكَرِ وَٱلْبَغْىِ ۚ يَعِظُكُمْ لَعَلَّكُمْ تَذَكَّرُونَ',
		number_in_surah: '90',
		page: '277',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1992',
		number: '1992',
		text: 'وَأَوْفُوا۟ بِعَهْدِ ٱللَّهِ إِذَا عَٰهَدتُّمْ وَلَا تَنقُضُوا۟ ٱلْأَيْمَٰنَ بَعْدَ تَوْكِيدِهَا وَقَدْ جَعَلْتُمُ ٱللَّهَ عَلَيْكُمْ كَفِيلًا ۚ إِنَّ ٱللَّهَ يَعْلَمُ مَا تَفْعَلُونَ',
		number_in_surah: '91',
		page: '277',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1993',
		number: '1993',
		text: 'وَلَا تَكُونُوا۟ كَٱلَّتِى نَقَضَتْ غَزْلَهَا مِنۢ بَعْدِ قُوَّةٍ أَنكَٰثًۭا تَتَّخِذُونَ أَيْمَٰنَكُمْ دَخَلًۢا بَيْنَكُمْ أَن تَكُونَ أُمَّةٌ هِىَ أَرْبَىٰ مِنْ أُمَّةٍ ۚ إِنَّمَا يَبْلُوكُمُ ٱللَّهُ بِهِۦ ۚ وَلَيُبَيِّنَنَّ لَكُمْ يَوْمَ ٱلْقِيَٰمَةِ مَا كُنتُمْ فِيهِ تَخْتَلِفُونَ',
		number_in_surah: '92',
		page: '277',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1994',
		number: '1994',
		text: 'وَلَوْ شَآءَ ٱللَّهُ لَجَعَلَكُمْ أُمَّةًۭ وَٰحِدَةًۭ وَلَٰكِن يُضِلُّ مَن يَشَآءُ وَيَهْدِى مَن يَشَآءُ ۚ وَلَتُسْـَٔلُنَّ عَمَّا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '93',
		page: '277',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1995',
		number: '1995',
		text: 'وَلَا تَتَّخِذُوٓا۟ أَيْمَٰنَكُمْ دَخَلًۢا بَيْنَكُمْ فَتَزِلَّ قَدَمٌۢ بَعْدَ ثُبُوتِهَا وَتَذُوقُوا۟ ٱلسُّوٓءَ بِمَا صَدَدتُّمْ عَن سَبِيلِ ٱللَّهِ ۖ وَلَكُمْ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '94',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1996',
		number: '1996',
		text: 'وَلَا تَشْتَرُوا۟ بِعَهْدِ ٱللَّهِ ثَمَنًۭا قَلِيلًا ۚ إِنَّمَا عِندَ ٱللَّهِ هُوَ خَيْرٌۭ لَّكُمْ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '95',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1997',
		number: '1997',
		text: 'مَا عِندَكُمْ يَنفَدُ ۖ وَمَا عِندَ ٱللَّهِ بَاقٍۢ ۗ وَلَنَجْزِيَنَّ ٱلَّذِينَ صَبَرُوٓا۟ أَجْرَهُم بِأَحْسَنِ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '96',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1998',
		number: '1998',
		text: 'مَنْ عَمِلَ صَٰلِحًۭا مِّن ذَكَرٍ أَوْ أُنثَىٰ وَهُوَ مُؤْمِنٌۭ فَلَنُحْيِيَنَّهُۥ حَيَوٰةًۭ طَيِّبَةًۭ ۖ وَلَنَجْزِيَنَّهُمْ أَجْرَهُم بِأَحْسَنِ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '97',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '1999',
		number: '1999',
		text: 'فَإِذَا قَرَأْتَ ٱلْقُرْءَانَ فَٱسْتَعِذْ بِٱللَّهِ مِنَ ٱلشَّيْطَٰنِ ٱلرَّجِيمِ',
		number_in_surah: '98',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2000',
		number: '2000',
		text: 'إِنَّهُۥ لَيْسَ لَهُۥ سُلْطَٰنٌ عَلَى ٱلَّذِينَ ءَامَنُوا۟ وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ',
		number_in_surah: '99',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2001',
		number: '2001',
		text: 'إِنَّمَا سُلْطَٰنُهُۥ عَلَى ٱلَّذِينَ يَتَوَلَّوْنَهُۥ وَٱلَّذِينَ هُم بِهِۦ مُشْرِكُونَ',
		number_in_surah: '100',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2002',
		number: '2002',
		text: 'وَإِذَا بَدَّلْنَآ ءَايَةًۭ مَّكَانَ ءَايَةٍۢ ۙ وَٱللَّهُ أَعْلَمُ بِمَا يُنَزِّلُ قَالُوٓا۟ إِنَّمَآ أَنتَ مُفْتَرٍۭ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '101',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2003',
		number: '2003',
		text: 'قُلْ نَزَّلَهُۥ رُوحُ ٱلْقُدُسِ مِن رَّبِّكَ بِٱلْحَقِّ لِيُثَبِّتَ ٱلَّذِينَ ءَامَنُوا۟ وَهُدًۭى وَبُشْرَىٰ لِلْمُسْلِمِينَ',
		number_in_surah: '102',
		page: '278',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2004',
		number: '2004',
		text: 'وَلَقَدْ نَعْلَمُ أَنَّهُمْ يَقُولُونَ إِنَّمَا يُعَلِّمُهُۥ بَشَرٌۭ ۗ لِّسَانُ ٱلَّذِى يُلْحِدُونَ إِلَيْهِ أَعْجَمِىٌّۭ وَهَٰذَا لِسَانٌ عَرَبِىٌّۭ مُّبِينٌ',
		number_in_surah: '103',
		page: '279',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2005',
		number: '2005',
		text: 'إِنَّ ٱلَّذِينَ لَا يُؤْمِنُونَ بِـَٔايَٰتِ ٱللَّهِ لَا يَهْدِيهِمُ ٱللَّهُ وَلَهُمْ عَذَابٌ أَلِيمٌ',
		number_in_surah: '104',
		page: '279',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2006',
		number: '2006',
		text: 'إِنَّمَا يَفْتَرِى ٱلْكَذِبَ ٱلَّذِينَ لَا يُؤْمِنُونَ بِـَٔايَٰتِ ٱللَّهِ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْكَٰذِبُونَ',
		number_in_surah: '105',
		page: '279',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2007',
		number: '2007',
		text: 'مَن كَفَرَ بِٱللَّهِ مِنۢ بَعْدِ إِيمَٰنِهِۦٓ إِلَّا مَنْ أُكْرِهَ وَقَلْبُهُۥ مُطْمَئِنٌّۢ بِٱلْإِيمَٰنِ وَلَٰكِن مَّن شَرَحَ بِٱلْكُفْرِ صَدْرًۭا فَعَلَيْهِمْ غَضَبٌۭ مِّنَ ٱللَّهِ وَلَهُمْ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '106',
		page: '279',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2008',
		number: '2008',
		text: 'ذَٰلِكَ بِأَنَّهُمُ ٱسْتَحَبُّوا۟ ٱلْحَيَوٰةَ ٱلدُّنْيَا عَلَى ٱلْءَاخِرَةِ وَأَنَّ ٱللَّهَ لَا يَهْدِى ٱلْقَوْمَ ٱلْكَٰفِرِينَ',
		number_in_surah: '107',
		page: '279',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2009',
		number: '2009',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ طَبَعَ ٱللَّهُ عَلَىٰ قُلُوبِهِمْ وَسَمْعِهِمْ وَأَبْصَٰرِهِمْ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْغَٰفِلُونَ',
		number_in_surah: '108',
		page: '279',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2010',
		number: '2010',
		text: 'لَا جَرَمَ أَنَّهُمْ فِى ٱلْءَاخِرَةِ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '109',
		page: '279',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2011',
		number: '2011',
		text: 'ثُمَّ إِنَّ رَبَّكَ لِلَّذِينَ هَاجَرُوا۟ مِنۢ بَعْدِ مَا فُتِنُوا۟ ثُمَّ جَٰهَدُوا۟ وَصَبَرُوٓا۟ إِنَّ رَبَّكَ مِنۢ بَعْدِهَا لَغَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '110',
		page: '279',
		surah_id: '16',
		hizb_id: '111',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2012',
		number: '2012',
		text: '۞ يَوْمَ تَأْتِى كُلُّ نَفْسٍۢ تُجَٰدِلُ عَن نَّفْسِهَا وَتُوَفَّىٰ كُلُّ نَفْسٍۢ مَّا عَمِلَتْ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '111',
		page: '280',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2013',
		number: '2013',
		text: 'وَضَرَبَ ٱللَّهُ مَثَلًۭا قَرْيَةًۭ كَانَتْ ءَامِنَةًۭ مُّطْمَئِنَّةًۭ يَأْتِيهَا رِزْقُهَا رَغَدًۭا مِّن كُلِّ مَكَانٍۢ فَكَفَرَتْ بِأَنْعُمِ ٱللَّهِ فَأَذَٰقَهَا ٱللَّهُ لِبَاسَ ٱلْجُوعِ وَٱلْخَوْفِ بِمَا كَانُوا۟ يَصْنَعُونَ',
		number_in_surah: '112',
		page: '280',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2014',
		number: '2014',
		text: 'وَلَقَدْ جَآءَهُمْ رَسُولٌۭ مِّنْهُمْ فَكَذَّبُوهُ فَأَخَذَهُمُ ٱلْعَذَابُ وَهُمْ ظَٰلِمُونَ',
		number_in_surah: '113',
		page: '280',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2015',
		number: '2015',
		text: 'فَكُلُوا۟ مِمَّا رَزَقَكُمُ ٱللَّهُ حَلَٰلًۭا طَيِّبًۭا وَٱشْكُرُوا۟ نِعْمَتَ ٱللَّهِ إِن كُنتُمْ إِيَّاهُ تَعْبُدُونَ',
		number_in_surah: '114',
		page: '280',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2016',
		number: '2016',
		text: 'إِنَّمَا حَرَّمَ عَلَيْكُمُ ٱلْمَيْتَةَ وَٱلدَّمَ وَلَحْمَ ٱلْخِنزِيرِ وَمَآ أُهِلَّ لِغَيْرِ ٱللَّهِ بِهِۦ ۖ فَمَنِ ٱضْطُرَّ غَيْرَ بَاغٍۢ وَلَا عَادٍۢ فَإِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '115',
		page: '280',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2017',
		number: '2017',
		text: 'وَلَا تَقُولُوا۟ لِمَا تَصِفُ أَلْسِنَتُكُمُ ٱلْكَذِبَ هَٰذَا حَلَٰلٌۭ وَهَٰذَا حَرَامٌۭ لِّتَفْتَرُوا۟ عَلَى ٱللَّهِ ٱلْكَذِبَ ۚ إِنَّ ٱلَّذِينَ يَفْتَرُونَ عَلَى ٱللَّهِ ٱلْكَذِبَ لَا يُفْلِحُونَ',
		number_in_surah: '116',
		page: '280',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2018',
		number: '2018',
		text: 'مَتَٰعٌۭ قَلِيلٌۭ وَلَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '117',
		page: '280',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2019',
		number: '2019',
		text: 'وَعَلَى ٱلَّذِينَ هَادُوا۟ حَرَّمْنَا مَا قَصَصْنَا عَلَيْكَ مِن قَبْلُ ۖ وَمَا ظَلَمْنَٰهُمْ وَلَٰكِن كَانُوٓا۟ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '118',
		page: '280',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2020',
		number: '2020',
		text: 'ثُمَّ إِنَّ رَبَّكَ لِلَّذِينَ عَمِلُوا۟ ٱلسُّوٓءَ بِجَهَٰلَةٍۢ ثُمَّ تَابُوا۟ مِنۢ بَعْدِ ذَٰلِكَ وَأَصْلَحُوٓا۟ إِنَّ رَبَّكَ مِنۢ بَعْدِهَا لَغَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '119',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2021',
		number: '2021',
		text: 'إِنَّ إِبْرَٰهِيمَ كَانَ أُمَّةًۭ قَانِتًۭا لِّلَّهِ حَنِيفًۭا وَلَمْ يَكُ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '120',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2022',
		number: '2022',
		text: 'شَاكِرًۭا لِّأَنْعُمِهِ ۚ ٱجْتَبَىٰهُ وَهَدَىٰهُ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '121',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2023',
		number: '2023',
		text: 'وَءَاتَيْنَٰهُ فِى ٱلدُّنْيَا حَسَنَةًۭ ۖ وَإِنَّهُۥ فِى ٱلْءَاخِرَةِ لَمِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '122',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2024',
		number: '2024',
		text: 'ثُمَّ أَوْحَيْنَآ إِلَيْكَ أَنِ ٱتَّبِعْ مِلَّةَ إِبْرَٰهِيمَ حَنِيفًۭا ۖ وَمَا كَانَ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '123',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2025',
		number: '2025',
		text: 'إِنَّمَا جُعِلَ ٱلسَّبْتُ عَلَى ٱلَّذِينَ ٱخْتَلَفُوا۟ فِيهِ ۚ وَإِنَّ رَبَّكَ لَيَحْكُمُ بَيْنَهُمْ يَوْمَ ٱلْقِيَٰمَةِ فِيمَا كَانُوا۟ فِيهِ يَخْتَلِفُونَ',
		number_in_surah: '124',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2026',
		number: '2026',
		text: 'ٱدْعُ إِلَىٰ سَبِيلِ رَبِّكَ بِٱلْحِكْمَةِ وَٱلْمَوْعِظَةِ ٱلْحَسَنَةِ ۖ وَجَٰدِلْهُم بِٱلَّتِى هِىَ أَحْسَنُ ۚ إِنَّ رَبَّكَ هُوَ أَعْلَمُ بِمَن ضَلَّ عَن سَبِيلِهِۦ ۖ وَهُوَ أَعْلَمُ بِٱلْمُهْتَدِينَ',
		number_in_surah: '125',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2027',
		number: '2027',
		text: 'وَإِنْ عَاقَبْتُمْ فَعَاقِبُوا۟ بِمِثْلِ مَا عُوقِبْتُم بِهِۦ ۖ وَلَئِن صَبَرْتُمْ لَهُوَ خَيْرٌۭ لِّلصَّٰبِرِينَ',
		number_in_surah: '126',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2028',
		number: '2028',
		text: 'وَٱصْبِرْ وَمَا صَبْرُكَ إِلَّا بِٱللَّهِ ۚ وَلَا تَحْزَنْ عَلَيْهِمْ وَلَا تَكُ فِى ضَيْقٍۢ مِّمَّا يَمْكُرُونَ',
		number_in_surah: '127',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2029',
		number: '2029',
		text: 'إِنَّ ٱللَّهَ مَعَ ٱلَّذِينَ ٱتَّقَوا۟ وَّٱلَّذِينَ هُم مُّحْسِنُونَ',
		number_in_surah: '128',
		page: '281',
		surah_id: '16',
		hizb_id: '112',
		juz_id: '14',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2030',
		number: '2030',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ سُبْحَٰنَ ٱلَّذِىٓ أَسْرَىٰ بِعَبْدِهِۦ لَيْلًۭا مِّنَ ٱلْمَسْجِدِ ٱلْحَرَامِ إِلَى ٱلْمَسْجِدِ ٱلْأَقْصَا ٱلَّذِى بَٰرَكْنَا حَوْلَهُۥ لِنُرِيَهُۥ مِنْ ءَايَٰتِنَآ ۚ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلْبَصِيرُ',
		number_in_surah: '1',
		page: '282',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2031',
		number: '2031',
		text: 'وَءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ وَجَعَلْنَٰهُ هُدًۭى لِّبَنِىٓ إِسْرَٰٓءِيلَ أَلَّا تَتَّخِذُوا۟ مِن دُونِى وَكِيلًۭا',
		number_in_surah: '2',
		page: '282',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2032',
		number: '2032',
		text: 'ذُرِّيَّةَ مَنْ حَمَلْنَا مَعَ نُوحٍ ۚ إِنَّهُۥ كَانَ عَبْدًۭا شَكُورًۭا',
		number_in_surah: '3',
		page: '282',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2033',
		number: '2033',
		text: 'وَقَضَيْنَآ إِلَىٰ بَنِىٓ إِسْرَٰٓءِيلَ فِى ٱلْكِتَٰبِ لَتُفْسِدُنَّ فِى ٱلْأَرْضِ مَرَّتَيْنِ وَلَتَعْلُنَّ عُلُوًّۭا كَبِيرًۭا',
		number_in_surah: '4',
		page: '282',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2034',
		number: '2034',
		text: 'فَإِذَا جَآءَ وَعْدُ أُولَىٰهُمَا بَعَثْنَا عَلَيْكُمْ عِبَادًۭا لَّنَآ أُو۟لِى بَأْسٍۢ شَدِيدٍۢ فَجَاسُوا۟ خِلَٰلَ ٱلدِّيَارِ ۚ وَكَانَ وَعْدًۭا مَّفْعُولًۭا',
		number_in_surah: '5',
		page: '282',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2035',
		number: '2035',
		text: 'ثُمَّ رَدَدْنَا لَكُمُ ٱلْكَرَّةَ عَلَيْهِمْ وَأَمْدَدْنَٰكُم بِأَمْوَٰلٍۢ وَبَنِينَ وَجَعَلْنَٰكُمْ أَكْثَرَ نَفِيرًا',
		number_in_surah: '6',
		page: '282',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2036',
		number: '2036',
		text: 'إِنْ أَحْسَنتُمْ أَحْسَنتُمْ لِأَنفُسِكُمْ ۖ وَإِنْ أَسَأْتُمْ فَلَهَا ۚ فَإِذَا جَآءَ وَعْدُ ٱلْءَاخِرَةِ لِيَسُۥٓـُٔوا۟ وُجُوهَكُمْ وَلِيَدْخُلُوا۟ ٱلْمَسْجِدَ كَمَا دَخَلُوهُ أَوَّلَ مَرَّةٍۢ وَلِيُتَبِّرُوا۟ مَا عَلَوْا۟ تَتْبِيرًا',
		number_in_surah: '7',
		page: '282',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2037',
		number: '2037',
		text: 'عَسَىٰ رَبُّكُمْ أَن يَرْحَمَكُمْ ۚ وَإِنْ عُدتُّمْ عُدْنَا ۘ وَجَعَلْنَا جَهَنَّمَ لِلْكَٰفِرِينَ حَصِيرًا',
		number_in_surah: '8',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2038',
		number: '2038',
		text: 'إِنَّ هَٰذَا ٱلْقُرْءَانَ يَهْدِى لِلَّتِى هِىَ أَقْوَمُ وَيُبَشِّرُ ٱلْمُؤْمِنِينَ ٱلَّذِينَ يَعْمَلُونَ ٱلصَّٰلِحَٰتِ أَنَّ لَهُمْ أَجْرًۭا كَبِيرًۭا',
		number_in_surah: '9',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2039',
		number: '2039',
		text: 'وَأَنَّ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ أَعْتَدْنَا لَهُمْ عَذَابًا أَلِيمًۭا',
		number_in_surah: '10',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2040',
		number: '2040',
		text: 'وَيَدْعُ ٱلْإِنسَٰنُ بِٱلشَّرِّ دُعَآءَهُۥ بِٱلْخَيْرِ ۖ وَكَانَ ٱلْإِنسَٰنُ عَجُولًۭا',
		number_in_surah: '11',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2041',
		number: '2041',
		text: 'وَجَعَلْنَا ٱلَّيْلَ وَٱلنَّهَارَ ءَايَتَيْنِ ۖ فَمَحَوْنَآ ءَايَةَ ٱلَّيْلِ وَجَعَلْنَآ ءَايَةَ ٱلنَّهَارِ مُبْصِرَةًۭ لِّتَبْتَغُوا۟ فَضْلًۭا مِّن رَّبِّكُمْ وَلِتَعْلَمُوا۟ عَدَدَ ٱلسِّنِينَ وَٱلْحِسَابَ ۚ وَكُلَّ شَىْءٍۢ فَصَّلْنَٰهُ تَفْصِيلًۭا',
		number_in_surah: '12',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2042',
		number: '2042',
		text: 'وَكُلَّ إِنسَٰنٍ أَلْزَمْنَٰهُ طَٰٓئِرَهُۥ فِى عُنُقِهِۦ ۖ وَنُخْرِجُ لَهُۥ يَوْمَ ٱلْقِيَٰمَةِ كِتَٰبًۭا يَلْقَىٰهُ مَنشُورًا',
		number_in_surah: '13',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2043',
		number: '2043',
		text: 'ٱقْرَأْ كِتَٰبَكَ كَفَىٰ بِنَفْسِكَ ٱلْيَوْمَ عَلَيْكَ حَسِيبًۭا',
		number_in_surah: '14',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2044',
		number: '2044',
		text: 'مَّنِ ٱهْتَدَىٰ فَإِنَّمَا يَهْتَدِى لِنَفْسِهِۦ ۖ وَمَن ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيْهَا ۚ وَلَا تَزِرُ وَازِرَةٌۭ وِزْرَ أُخْرَىٰ ۗ وَمَا كُنَّا مُعَذِّبِينَ حَتَّىٰ نَبْعَثَ رَسُولًۭا',
		number_in_surah: '15',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2045',
		number: '2045',
		text: 'وَإِذَآ أَرَدْنَآ أَن نُّهْلِكَ قَرْيَةً أَمَرْنَا مُتْرَفِيهَا فَفَسَقُوا۟ فِيهَا فَحَقَّ عَلَيْهَا ٱلْقَوْلُ فَدَمَّرْنَٰهَا تَدْمِيرًۭا',
		number_in_surah: '16',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2046',
		number: '2046',
		text: 'وَكَمْ أَهْلَكْنَا مِنَ ٱلْقُرُونِ مِنۢ بَعْدِ نُوحٍۢ ۗ وَكَفَىٰ بِرَبِّكَ بِذُنُوبِ عِبَادِهِۦ خَبِيرًۢا بَصِيرًۭا',
		number_in_surah: '17',
		page: '283',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2047',
		number: '2047',
		text: 'مَّن كَانَ يُرِيدُ ٱلْعَاجِلَةَ عَجَّلْنَا لَهُۥ فِيهَا مَا نَشَآءُ لِمَن نُّرِيدُ ثُمَّ جَعَلْنَا لَهُۥ جَهَنَّمَ يَصْلَىٰهَا مَذْمُومًۭا مَّدْحُورًۭا',
		number_in_surah: '18',
		page: '284',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2048',
		number: '2048',
		text: 'وَمَنْ أَرَادَ ٱلْءَاخِرَةَ وَسَعَىٰ لَهَا سَعْيَهَا وَهُوَ مُؤْمِنٌۭ فَأُو۟لَٰٓئِكَ كَانَ سَعْيُهُم مَّشْكُورًۭا',
		number_in_surah: '19',
		page: '284',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2049',
		number: '2049',
		text: 'كُلًّۭا نُّمِدُّ هَٰٓؤُلَآءِ وَهَٰٓؤُلَآءِ مِنْ عَطَآءِ رَبِّكَ ۚ وَمَا كَانَ عَطَآءُ رَبِّكَ مَحْظُورًا',
		number_in_surah: '20',
		page: '284',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2050',
		number: '2050',
		text: 'ٱنظُرْ كَيْفَ فَضَّلْنَا بَعْضَهُمْ عَلَىٰ بَعْضٍۢ ۚ وَلَلْءَاخِرَةُ أَكْبَرُ دَرَجَٰتٍۢ وَأَكْبَرُ تَفْضِيلًۭا',
		number_in_surah: '21',
		page: '284',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2051',
		number: '2051',
		text: 'لَّا تَجْعَلْ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ فَتَقْعُدَ مَذْمُومًۭا مَّخْذُولًۭا',
		number_in_surah: '22',
		page: '284',
		surah_id: '17',
		hizb_id: '113',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2052',
		number: '2052',
		text: '۞ وَقَضَىٰ رَبُّكَ أَلَّا تَعْبُدُوٓا۟ إِلَّآ إِيَّاهُ وَبِٱلْوَٰلِدَيْنِ إِحْسَٰنًا ۚ إِمَّا يَبْلُغَنَّ عِندَكَ ٱلْكِبَرَ أَحَدُهُمَآ أَوْ كِلَاهُمَا فَلَا تَقُل لَّهُمَآ أُفٍّۢ وَلَا تَنْهَرْهُمَا وَقُل لَّهُمَا قَوْلًۭا كَرِيمًۭا',
		number_in_surah: '23',
		page: '284',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2053',
		number: '2053',
		text: 'وَٱخْفِضْ لَهُمَا جَنَاحَ ٱلذُّلِّ مِنَ ٱلرَّحْمَةِ وَقُل رَّبِّ ٱرْحَمْهُمَا كَمَا رَبَّيَانِى صَغِيرًۭا',
		number_in_surah: '24',
		page: '284',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2054',
		number: '2054',
		text: 'رَّبُّكُمْ أَعْلَمُ بِمَا فِى نُفُوسِكُمْ ۚ إِن تَكُونُوا۟ صَٰلِحِينَ فَإِنَّهُۥ كَانَ لِلْأَوَّٰبِينَ غَفُورًۭا',
		number_in_surah: '25',
		page: '284',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2055',
		number: '2055',
		text: 'وَءَاتِ ذَا ٱلْقُرْبَىٰ حَقَّهُۥ وَٱلْمِسْكِينَ وَٱبْنَ ٱلسَّبِيلِ وَلَا تُبَذِّرْ تَبْذِيرًا',
		number_in_surah: '26',
		page: '284',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2056',
		number: '2056',
		text: 'إِنَّ ٱلْمُبَذِّرِينَ كَانُوٓا۟ إِخْوَٰنَ ٱلشَّيَٰطِينِ ۖ وَكَانَ ٱلشَّيْطَٰنُ لِرَبِّهِۦ كَفُورًۭا',
		number_in_surah: '27',
		page: '284',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2057',
		number: '2057',
		text: 'وَإِمَّا تُعْرِضَنَّ عَنْهُمُ ٱبْتِغَآءَ رَحْمَةٍۢ مِّن رَّبِّكَ تَرْجُوهَا فَقُل لَّهُمْ قَوْلًۭا مَّيْسُورًۭا',
		number_in_surah: '28',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2058',
		number: '2058',
		text: 'وَلَا تَجْعَلْ يَدَكَ مَغْلُولَةً إِلَىٰ عُنُقِكَ وَلَا تَبْسُطْهَا كُلَّ ٱلْبَسْطِ فَتَقْعُدَ مَلُومًۭا مَّحْسُورًا',
		number_in_surah: '29',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2059',
		number: '2059',
		text: 'إِنَّ رَبَّكَ يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ وَيَقْدِرُ ۚ إِنَّهُۥ كَانَ بِعِبَادِهِۦ خَبِيرًۢا بَصِيرًۭا',
		number_in_surah: '30',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2060',
		number: '2060',
		text: 'وَلَا تَقْتُلُوٓا۟ أَوْلَٰدَكُمْ خَشْيَةَ إِمْلَٰقٍۢ ۖ نَّحْنُ نَرْزُقُهُمْ وَإِيَّاكُمْ ۚ إِنَّ قَتْلَهُمْ كَانَ خِطْـًۭٔا كَبِيرًۭا',
		number_in_surah: '31',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2061',
		number: '2061',
		text: 'وَلَا تَقْرَبُوا۟ ٱلزِّنَىٰٓ ۖ إِنَّهُۥ كَانَ فَٰحِشَةًۭ وَسَآءَ سَبِيلًۭا',
		number_in_surah: '32',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2062',
		number: '2062',
		text: 'وَلَا تَقْتُلُوا۟ ٱلنَّفْسَ ٱلَّتِى حَرَّمَ ٱللَّهُ إِلَّا بِٱلْحَقِّ ۗ وَمَن قُتِلَ مَظْلُومًۭا فَقَدْ جَعَلْنَا لِوَلِيِّهِۦ سُلْطَٰنًۭا فَلَا يُسْرِف فِّى ٱلْقَتْلِ ۖ إِنَّهُۥ كَانَ مَنصُورًۭا',
		number_in_surah: '33',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2063',
		number: '2063',
		text: 'وَلَا تَقْرَبُوا۟ مَالَ ٱلْيَتِيمِ إِلَّا بِٱلَّتِى هِىَ أَحْسَنُ حَتَّىٰ يَبْلُغَ أَشُدَّهُۥ ۚ وَأَوْفُوا۟ بِٱلْعَهْدِ ۖ إِنَّ ٱلْعَهْدَ كَانَ مَسْـُٔولًۭا',
		number_in_surah: '34',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2064',
		number: '2064',
		text: 'وَأَوْفُوا۟ ٱلْكَيْلَ إِذَا كِلْتُمْ وَزِنُوا۟ بِٱلْقِسْطَاسِ ٱلْمُسْتَقِيمِ ۚ ذَٰلِكَ خَيْرٌۭ وَأَحْسَنُ تَأْوِيلًۭا',
		number_in_surah: '35',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2065',
		number: '2065',
		text: 'وَلَا تَقْفُ مَا لَيْسَ لَكَ بِهِۦ عِلْمٌ ۚ إِنَّ ٱلسَّمْعَ وَٱلْبَصَرَ وَٱلْفُؤَادَ كُلُّ أُو۟لَٰٓئِكَ كَانَ عَنْهُ مَسْـُٔولًۭا',
		number_in_surah: '36',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2066',
		number: '2066',
		text: 'وَلَا تَمْشِ فِى ٱلْأَرْضِ مَرَحًا ۖ إِنَّكَ لَن تَخْرِقَ ٱلْأَرْضَ وَلَن تَبْلُغَ ٱلْجِبَالَ طُولًۭا',
		number_in_surah: '37',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2067',
		number: '2067',
		text: 'كُلُّ ذَٰلِكَ كَانَ سَيِّئُهُۥ عِندَ رَبِّكَ مَكْرُوهًۭا',
		number_in_surah: '38',
		page: '285',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2068',
		number: '2068',
		text: 'ذَٰلِكَ مِمَّآ أَوْحَىٰٓ إِلَيْكَ رَبُّكَ مِنَ ٱلْحِكْمَةِ ۗ وَلَا تَجْعَلْ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ فَتُلْقَىٰ فِى جَهَنَّمَ مَلُومًۭا مَّدْحُورًا',
		number_in_surah: '39',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2069',
		number: '2069',
		text: 'أَفَأَصْفَىٰكُمْ رَبُّكُم بِٱلْبَنِينَ وَٱتَّخَذَ مِنَ ٱلْمَلَٰٓئِكَةِ إِنَٰثًا ۚ إِنَّكُمْ لَتَقُولُونَ قَوْلًا عَظِيمًۭا',
		number_in_surah: '40',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2070',
		number: '2070',
		text: 'وَلَقَدْ صَرَّفْنَا فِى هَٰذَا ٱلْقُرْءَانِ لِيَذَّكَّرُوا۟ وَمَا يَزِيدُهُمْ إِلَّا نُفُورًۭا',
		number_in_surah: '41',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2071',
		number: '2071',
		text: 'قُل لَّوْ كَانَ مَعَهُۥٓ ءَالِهَةٌۭ كَمَا يَقُولُونَ إِذًۭا لَّٱبْتَغَوْا۟ إِلَىٰ ذِى ٱلْعَرْشِ سَبِيلًۭا',
		number_in_surah: '42',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2072',
		number: '2072',
		text: 'سُبْحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يَقُولُونَ عُلُوًّۭا كَبِيرًۭا',
		number_in_surah: '43',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2073',
		number: '2073',
		text: 'تُسَبِّحُ لَهُ ٱلسَّمَٰوَٰتُ ٱلسَّبْعُ وَٱلْأَرْضُ وَمَن فِيهِنَّ ۚ وَإِن مِّن شَىْءٍ إِلَّا يُسَبِّحُ بِحَمْدِهِۦ وَلَٰكِن لَّا تَفْقَهُونَ تَسْبِيحَهُمْ ۗ إِنَّهُۥ كَانَ حَلِيمًا غَفُورًۭا',
		number_in_surah: '44',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2074',
		number: '2074',
		text: 'وَإِذَا قَرَأْتَ ٱلْقُرْءَانَ جَعَلْنَا بَيْنَكَ وَبَيْنَ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ حِجَابًۭا مَّسْتُورًۭا',
		number_in_surah: '45',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2075',
		number: '2075',
		text: 'وَجَعَلْنَا عَلَىٰ قُلُوبِهِمْ أَكِنَّةً أَن يَفْقَهُوهُ وَفِىٓ ءَاذَانِهِمْ وَقْرًۭا ۚ وَإِذَا ذَكَرْتَ رَبَّكَ فِى ٱلْقُرْءَانِ وَحْدَهُۥ وَلَّوْا۟ عَلَىٰٓ أَدْبَٰرِهِمْ نُفُورًۭا',
		number_in_surah: '46',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2076',
		number: '2076',
		text: 'نَّحْنُ أَعْلَمُ بِمَا يَسْتَمِعُونَ بِهِۦٓ إِذْ يَسْتَمِعُونَ إِلَيْكَ وَإِذْ هُمْ نَجْوَىٰٓ إِذْ يَقُولُ ٱلظَّٰلِمُونَ إِن تَتَّبِعُونَ إِلَّا رَجُلًۭا مَّسْحُورًا',
		number_in_surah: '47',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2077',
		number: '2077',
		text: 'ٱنظُرْ كَيْفَ ضَرَبُوا۟ لَكَ ٱلْأَمْثَالَ فَضَلُّوا۟ فَلَا يَسْتَطِيعُونَ سَبِيلًۭا',
		number_in_surah: '48',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2078',
		number: '2078',
		text: 'وَقَالُوٓا۟ أَءِذَا كُنَّا عِظَٰمًۭا وَرُفَٰتًا أَءِنَّا لَمَبْعُوثُونَ خَلْقًۭا جَدِيدًۭا',
		number_in_surah: '49',
		page: '286',
		surah_id: '17',
		hizb_id: '114',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2079',
		number: '2079',
		text: '۞ قُلْ كُونُوا۟ حِجَارَةً أَوْ حَدِيدًا',
		number_in_surah: '50',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2080',
		number: '2080',
		text: 'أَوْ خَلْقًۭا مِّمَّا يَكْبُرُ فِى صُدُورِكُمْ ۚ فَسَيَقُولُونَ مَن يُعِيدُنَا ۖ قُلِ ٱلَّذِى فَطَرَكُمْ أَوَّلَ مَرَّةٍۢ ۚ فَسَيُنْغِضُونَ إِلَيْكَ رُءُوسَهُمْ وَيَقُولُونَ مَتَىٰ هُوَ ۖ قُلْ عَسَىٰٓ أَن يَكُونَ قَرِيبًۭا',
		number_in_surah: '51',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2081',
		number: '2081',
		text: 'يَوْمَ يَدْعُوكُمْ فَتَسْتَجِيبُونَ بِحَمْدِهِۦ وَتَظُنُّونَ إِن لَّبِثْتُمْ إِلَّا قَلِيلًۭا',
		number_in_surah: '52',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2082',
		number: '2082',
		text: 'وَقُل لِّعِبَادِى يَقُولُوا۟ ٱلَّتِى هِىَ أَحْسَنُ ۚ إِنَّ ٱلشَّيْطَٰنَ يَنزَغُ بَيْنَهُمْ ۚ إِنَّ ٱلشَّيْطَٰنَ كَانَ لِلْإِنسَٰنِ عَدُوًّۭا مُّبِينًۭا',
		number_in_surah: '53',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2083',
		number: '2083',
		text: 'رَّبُّكُمْ أَعْلَمُ بِكُمْ ۖ إِن يَشَأْ يَرْحَمْكُمْ أَوْ إِن يَشَأْ يُعَذِّبْكُمْ ۚ وَمَآ أَرْسَلْنَٰكَ عَلَيْهِمْ وَكِيلًۭا',
		number_in_surah: '54',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2084',
		number: '2084',
		text: 'وَرَبُّكَ أَعْلَمُ بِمَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۗ وَلَقَدْ فَضَّلْنَا بَعْضَ ٱلنَّبِيِّۦنَ عَلَىٰ بَعْضٍۢ ۖ وَءَاتَيْنَا دَاوُۥدَ زَبُورًۭا',
		number_in_surah: '55',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2085',
		number: '2085',
		text: 'قُلِ ٱدْعُوا۟ ٱلَّذِينَ زَعَمْتُم مِّن دُونِهِۦ فَلَا يَمْلِكُونَ كَشْفَ ٱلضُّرِّ عَنكُمْ وَلَا تَحْوِيلًا',
		number_in_surah: '56',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2086',
		number: '2086',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ يَدْعُونَ يَبْتَغُونَ إِلَىٰ رَبِّهِمُ ٱلْوَسِيلَةَ أَيُّهُمْ أَقْرَبُ وَيَرْجُونَ رَحْمَتَهُۥ وَيَخَافُونَ عَذَابَهُۥٓ ۚ إِنَّ عَذَابَ رَبِّكَ كَانَ مَحْذُورًۭا',
		number_in_surah: '57',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2087',
		number: '2087',
		text: 'وَإِن مِّن قَرْيَةٍ إِلَّا نَحْنُ مُهْلِكُوهَا قَبْلَ يَوْمِ ٱلْقِيَٰمَةِ أَوْ مُعَذِّبُوهَا عَذَابًۭا شَدِيدًۭا ۚ كَانَ ذَٰلِكَ فِى ٱلْكِتَٰبِ مَسْطُورًۭا',
		number_in_surah: '58',
		page: '287',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2088',
		number: '2088',
		text: 'وَمَا مَنَعَنَآ أَن نُّرْسِلَ بِٱلْءَايَٰتِ إِلَّآ أَن كَذَّبَ بِهَا ٱلْأَوَّلُونَ ۚ وَءَاتَيْنَا ثَمُودَ ٱلنَّاقَةَ مُبْصِرَةًۭ فَظَلَمُوا۟ بِهَا ۚ وَمَا نُرْسِلُ بِٱلْءَايَٰتِ إِلَّا تَخْوِيفًۭا',
		number_in_surah: '59',
		page: '288',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2089',
		number: '2089',
		text: 'وَإِذْ قُلْنَا لَكَ إِنَّ رَبَّكَ أَحَاطَ بِٱلنَّاسِ ۚ وَمَا جَعَلْنَا ٱلرُّءْيَا ٱلَّتِىٓ أَرَيْنَٰكَ إِلَّا فِتْنَةًۭ لِّلنَّاسِ وَٱلشَّجَرَةَ ٱلْمَلْعُونَةَ فِى ٱلْقُرْءَانِ ۚ وَنُخَوِّفُهُمْ فَمَا يَزِيدُهُمْ إِلَّا طُغْيَٰنًۭا كَبِيرًۭا',
		number_in_surah: '60',
		page: '288',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2090',
		number: '2090',
		text: 'وَإِذْ قُلْنَا لِلْمَلَٰٓئِكَةِ ٱسْجُدُوا۟ لِءَادَمَ فَسَجَدُوٓا۟ إِلَّآ إِبْلِيسَ قَالَ ءَأَسْجُدُ لِمَنْ خَلَقْتَ طِينًۭا',
		number_in_surah: '61',
		page: '288',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2091',
		number: '2091',
		text: 'قَالَ أَرَءَيْتَكَ هَٰذَا ٱلَّذِى كَرَّمْتَ عَلَىَّ لَئِنْ أَخَّرْتَنِ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ لَأَحْتَنِكَنَّ ذُرِّيَّتَهُۥٓ إِلَّا قَلِيلًۭا',
		number_in_surah: '62',
		page: '288',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2092',
		number: '2092',
		text: 'قَالَ ٱذْهَبْ فَمَن تَبِعَكَ مِنْهُمْ فَإِنَّ جَهَنَّمَ جَزَآؤُكُمْ جَزَآءًۭ مَّوْفُورًۭا',
		number_in_surah: '63',
		page: '288',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2093',
		number: '2093',
		text: 'وَٱسْتَفْزِزْ مَنِ ٱسْتَطَعْتَ مِنْهُم بِصَوْتِكَ وَأَجْلِبْ عَلَيْهِم بِخَيْلِكَ وَرَجِلِكَ وَشَارِكْهُمْ فِى ٱلْأَمْوَٰلِ وَٱلْأَوْلَٰدِ وَعِدْهُمْ ۚ وَمَا يَعِدُهُمُ ٱلشَّيْطَٰنُ إِلَّا غُرُورًا',
		number_in_surah: '64',
		page: '288',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2094',
		number: '2094',
		text: 'إِنَّ عِبَادِى لَيْسَ لَكَ عَلَيْهِمْ سُلْطَٰنٌۭ ۚ وَكَفَىٰ بِرَبِّكَ وَكِيلًۭا',
		number_in_surah: '65',
		page: '288',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2095',
		number: '2095',
		text: 'رَّبُّكُمُ ٱلَّذِى يُزْجِى لَكُمُ ٱلْفُلْكَ فِى ٱلْبَحْرِ لِتَبْتَغُوا۟ مِن فَضْلِهِۦٓ ۚ إِنَّهُۥ كَانَ بِكُمْ رَحِيمًۭا',
		number_in_surah: '66',
		page: '288',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2096',
		number: '2096',
		text: 'وَإِذَا مَسَّكُمُ ٱلضُّرُّ فِى ٱلْبَحْرِ ضَلَّ مَن تَدْعُونَ إِلَّآ إِيَّاهُ ۖ فَلَمَّا نَجَّىٰكُمْ إِلَى ٱلْبَرِّ أَعْرَضْتُمْ ۚ وَكَانَ ٱلْإِنسَٰنُ كَفُورًا',
		number_in_surah: '67',
		page: '289',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2097',
		number: '2097',
		text: 'أَفَأَمِنتُمْ أَن يَخْسِفَ بِكُمْ جَانِبَ ٱلْبَرِّ أَوْ يُرْسِلَ عَلَيْكُمْ حَاصِبًۭا ثُمَّ لَا تَجِدُوا۟ لَكُمْ وَكِيلًا',
		number_in_surah: '68',
		page: '289',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2098',
		number: '2098',
		text: 'أَمْ أَمِنتُمْ أَن يُعِيدَكُمْ فِيهِ تَارَةً أُخْرَىٰ فَيُرْسِلَ عَلَيْكُمْ قَاصِفًۭا مِّنَ ٱلرِّيحِ فَيُغْرِقَكُم بِمَا كَفَرْتُمْ ۙ ثُمَّ لَا تَجِدُوا۟ لَكُمْ عَلَيْنَا بِهِۦ تَبِيعًۭا',
		number_in_surah: '69',
		page: '289',
		surah_id: '17',
		hizb_id: '115',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2099',
		number: '2099',
		text: '۞ وَلَقَدْ كَرَّمْنَا بَنِىٓ ءَادَمَ وَحَمَلْنَٰهُمْ فِى ٱلْبَرِّ وَٱلْبَحْرِ وَرَزَقْنَٰهُم مِّنَ ٱلطَّيِّبَٰتِ وَفَضَّلْنَٰهُمْ عَلَىٰ كَثِيرٍۢ مِّمَّنْ خَلَقْنَا تَفْضِيلًۭا',
		number_in_surah: '70',
		page: '289',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2100',
		number: '2100',
		text: 'يَوْمَ نَدْعُوا۟ كُلَّ أُنَاسٍۭ بِإِمَٰمِهِمْ ۖ فَمَنْ أُوتِىَ كِتَٰبَهُۥ بِيَمِينِهِۦ فَأُو۟لَٰٓئِكَ يَقْرَءُونَ كِتَٰبَهُمْ وَلَا يُظْلَمُونَ فَتِيلًۭا',
		number_in_surah: '71',
		page: '289',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2101',
		number: '2101',
		text: 'وَمَن كَانَ فِى هَٰذِهِۦٓ أَعْمَىٰ فَهُوَ فِى ٱلْءَاخِرَةِ أَعْمَىٰ وَأَضَلُّ سَبِيلًۭا',
		number_in_surah: '72',
		page: '289',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2102',
		number: '2102',
		text: 'وَإِن كَادُوا۟ لَيَفْتِنُونَكَ عَنِ ٱلَّذِىٓ أَوْحَيْنَآ إِلَيْكَ لِتَفْتَرِىَ عَلَيْنَا غَيْرَهُۥ ۖ وَإِذًۭا لَّٱتَّخَذُوكَ خَلِيلًۭا',
		number_in_surah: '73',
		page: '289',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2103',
		number: '2103',
		text: 'وَلَوْلَآ أَن ثَبَّتْنَٰكَ لَقَدْ كِدتَّ تَرْكَنُ إِلَيْهِمْ شَيْـًۭٔا قَلِيلًا',
		number_in_surah: '74',
		page: '289',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2104',
		number: '2104',
		text: 'إِذًۭا لَّأَذَقْنَٰكَ ضِعْفَ ٱلْحَيَوٰةِ وَضِعْفَ ٱلْمَمَاتِ ثُمَّ لَا تَجِدُ لَكَ عَلَيْنَا نَصِيرًۭا',
		number_in_surah: '75',
		page: '289',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2105',
		number: '2105',
		text: 'وَإِن كَادُوا۟ لَيَسْتَفِزُّونَكَ مِنَ ٱلْأَرْضِ لِيُخْرِجُوكَ مِنْهَا ۖ وَإِذًۭا لَّا يَلْبَثُونَ خِلَٰفَكَ إِلَّا قَلِيلًۭا',
		number_in_surah: '76',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2106',
		number: '2106',
		text: 'سُنَّةَ مَن قَدْ أَرْسَلْنَا قَبْلَكَ مِن رُّسُلِنَا ۖ وَلَا تَجِدُ لِسُنَّتِنَا تَحْوِيلًا',
		number_in_surah: '77',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2107',
		number: '2107',
		text: 'أَقِمِ ٱلصَّلَوٰةَ لِدُلُوكِ ٱلشَّمْسِ إِلَىٰ غَسَقِ ٱلَّيْلِ وَقُرْءَانَ ٱلْفَجْرِ ۖ إِنَّ قُرْءَانَ ٱلْفَجْرِ كَانَ مَشْهُودًۭا',
		number_in_surah: '78',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2108',
		number: '2108',
		text: 'وَمِنَ ٱلَّيْلِ فَتَهَجَّدْ بِهِۦ نَافِلَةًۭ لَّكَ عَسَىٰٓ أَن يَبْعَثَكَ رَبُّكَ مَقَامًۭا مَّحْمُودًۭا',
		number_in_surah: '79',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2109',
		number: '2109',
		text: 'وَقُل رَّبِّ أَدْخِلْنِى مُدْخَلَ صِدْقٍۢ وَأَخْرِجْنِى مُخْرَجَ صِدْقٍۢ وَٱجْعَل لِّى مِن لَّدُنكَ سُلْطَٰنًۭا نَّصِيرًۭا',
		number_in_surah: '80',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2110',
		number: '2110',
		text: 'وَقُلْ جَآءَ ٱلْحَقُّ وَزَهَقَ ٱلْبَٰطِلُ ۚ إِنَّ ٱلْبَٰطِلَ كَانَ زَهُوقًۭا',
		number_in_surah: '81',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2111',
		number: '2111',
		text: 'وَنُنَزِّلُ مِنَ ٱلْقُرْءَانِ مَا هُوَ شِفَآءٌۭ وَرَحْمَةٌۭ لِّلْمُؤْمِنِينَ ۙ وَلَا يَزِيدُ ٱلظَّٰلِمِينَ إِلَّا خَسَارًۭا',
		number_in_surah: '82',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2112',
		number: '2112',
		text: 'وَإِذَآ أَنْعَمْنَا عَلَى ٱلْإِنسَٰنِ أَعْرَضَ وَنَـَٔا بِجَانِبِهِۦ ۖ وَإِذَا مَسَّهُ ٱلشَّرُّ كَانَ يَـُٔوسًۭا',
		number_in_surah: '83',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2113',
		number: '2113',
		text: 'قُلْ كُلٌّۭ يَعْمَلُ عَلَىٰ شَاكِلَتِهِۦ فَرَبُّكُمْ أَعْلَمُ بِمَنْ هُوَ أَهْدَىٰ سَبِيلًۭا',
		number_in_surah: '84',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2114',
		number: '2114',
		text: 'وَيَسْـَٔلُونَكَ عَنِ ٱلرُّوحِ ۖ قُلِ ٱلرُّوحُ مِنْ أَمْرِ رَبِّى وَمَآ أُوتِيتُم مِّنَ ٱلْعِلْمِ إِلَّا قَلِيلًۭا',
		number_in_surah: '85',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2115',
		number: '2115',
		text: 'وَلَئِن شِئْنَا لَنَذْهَبَنَّ بِٱلَّذِىٓ أَوْحَيْنَآ إِلَيْكَ ثُمَّ لَا تَجِدُ لَكَ بِهِۦ عَلَيْنَا وَكِيلًا',
		number_in_surah: '86',
		page: '290',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2116',
		number: '2116',
		text: 'إِلَّا رَحْمَةًۭ مِّن رَّبِّكَ ۚ إِنَّ فَضْلَهُۥ كَانَ عَلَيْكَ كَبِيرًۭا',
		number_in_surah: '87',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2117',
		number: '2117',
		text: 'قُل لَّئِنِ ٱجْتَمَعَتِ ٱلْإِنسُ وَٱلْجِنُّ عَلَىٰٓ أَن يَأْتُوا۟ بِمِثْلِ هَٰذَا ٱلْقُرْءَانِ لَا يَأْتُونَ بِمِثْلِهِۦ وَلَوْ كَانَ بَعْضُهُمْ لِبَعْضٍۢ ظَهِيرًۭا',
		number_in_surah: '88',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2118',
		number: '2118',
		text: 'وَلَقَدْ صَرَّفْنَا لِلنَّاسِ فِى هَٰذَا ٱلْقُرْءَانِ مِن كُلِّ مَثَلٍۢ فَأَبَىٰٓ أَكْثَرُ ٱلنَّاسِ إِلَّا كُفُورًۭا',
		number_in_surah: '89',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2119',
		number: '2119',
		text: 'وَقَالُوا۟ لَن نُّؤْمِنَ لَكَ حَتَّىٰ تَفْجُرَ لَنَا مِنَ ٱلْأَرْضِ يَنۢبُوعًا',
		number_in_surah: '90',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2120',
		number: '2120',
		text: 'أَوْ تَكُونَ لَكَ جَنَّةٌۭ مِّن نَّخِيلٍۢ وَعِنَبٍۢ فَتُفَجِّرَ ٱلْأَنْهَٰرَ خِلَٰلَهَا تَفْجِيرًا',
		number_in_surah: '91',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2121',
		number: '2121',
		text: 'أَوْ تُسْقِطَ ٱلسَّمَآءَ كَمَا زَعَمْتَ عَلَيْنَا كِسَفًا أَوْ تَأْتِىَ بِٱللَّهِ وَٱلْمَلَٰٓئِكَةِ قَبِيلًا',
		number_in_surah: '92',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2122',
		number: '2122',
		text: 'أَوْ يَكُونَ لَكَ بَيْتٌۭ مِّن زُخْرُفٍ أَوْ تَرْقَىٰ فِى ٱلسَّمَآءِ وَلَن نُّؤْمِنَ لِرُقِيِّكَ حَتَّىٰ تُنَزِّلَ عَلَيْنَا كِتَٰبًۭا نَّقْرَؤُهُۥ ۗ قُلْ سُبْحَانَ رَبِّى هَلْ كُنتُ إِلَّا بَشَرًۭا رَّسُولًۭا',
		number_in_surah: '93',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2123',
		number: '2123',
		text: 'وَمَا مَنَعَ ٱلنَّاسَ أَن يُؤْمِنُوٓا۟ إِذْ جَآءَهُمُ ٱلْهُدَىٰٓ إِلَّآ أَن قَالُوٓا۟ أَبَعَثَ ٱللَّهُ بَشَرًۭا رَّسُولًۭا',
		number_in_surah: '94',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2124',
		number: '2124',
		text: 'قُل لَّوْ كَانَ فِى ٱلْأَرْضِ مَلَٰٓئِكَةٌۭ يَمْشُونَ مُطْمَئِنِّينَ لَنَزَّلْنَا عَلَيْهِم مِّنَ ٱلسَّمَآءِ مَلَكًۭا رَّسُولًۭا',
		number_in_surah: '95',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2125',
		number: '2125',
		text: 'قُلْ كَفَىٰ بِٱللَّهِ شَهِيدًۢا بَيْنِى وَبَيْنَكُمْ ۚ إِنَّهُۥ كَانَ بِعِبَادِهِۦ خَبِيرًۢا بَصِيرًۭا',
		number_in_surah: '96',
		page: '291',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2126',
		number: '2126',
		text: 'وَمَن يَهْدِ ٱللَّهُ فَهُوَ ٱلْمُهْتَدِ ۖ وَمَن يُضْلِلْ فَلَن تَجِدَ لَهُمْ أَوْلِيَآءَ مِن دُونِهِۦ ۖ وَنَحْشُرُهُمْ يَوْمَ ٱلْقِيَٰمَةِ عَلَىٰ وُجُوهِهِمْ عُمْيًۭا وَبُكْمًۭا وَصُمًّۭا ۖ مَّأْوَىٰهُمْ جَهَنَّمُ ۖ كُلَّمَا خَبَتْ زِدْنَٰهُمْ سَعِيرًۭا',
		number_in_surah: '97',
		page: '292',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2127',
		number: '2127',
		text: 'ذَٰلِكَ جَزَآؤُهُم بِأَنَّهُمْ كَفَرُوا۟ بِـَٔايَٰتِنَا وَقَالُوٓا۟ أَءِذَا كُنَّا عِظَٰمًۭا وَرُفَٰتًا أَءِنَّا لَمَبْعُوثُونَ خَلْقًۭا جَدِيدًا',
		number_in_surah: '98',
		page: '292',
		surah_id: '17',
		hizb_id: '116',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2128',
		number: '2128',
		text: '۞ أَوَلَمْ يَرَوْا۟ أَنَّ ٱللَّهَ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ قَادِرٌ عَلَىٰٓ أَن يَخْلُقَ مِثْلَهُمْ وَجَعَلَ لَهُمْ أَجَلًۭا لَّا رَيْبَ فِيهِ فَأَبَى ٱلظَّٰلِمُونَ إِلَّا كُفُورًۭا',
		number_in_surah: '99',
		page: '292',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2129',
		number: '2129',
		text: 'قُل لَّوْ أَنتُمْ تَمْلِكُونَ خَزَآئِنَ رَحْمَةِ رَبِّىٓ إِذًۭا لَّأَمْسَكْتُمْ خَشْيَةَ ٱلْإِنفَاقِ ۚ وَكَانَ ٱلْإِنسَٰنُ قَتُورًۭا',
		number_in_surah: '100',
		page: '292',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2130',
		number: '2130',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَىٰ تِسْعَ ءَايَٰتٍۭ بَيِّنَٰتٍۢ ۖ فَسْـَٔلْ بَنِىٓ إِسْرَٰٓءِيلَ إِذْ جَآءَهُمْ فَقَالَ لَهُۥ فِرْعَوْنُ إِنِّى لَأَظُنُّكَ يَٰمُوسَىٰ مَسْحُورًۭا',
		number_in_surah: '101',
		page: '292',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2131',
		number: '2131',
		text: 'قَالَ لَقَدْ عَلِمْتَ مَآ أَنزَلَ هَٰٓؤُلَآءِ إِلَّا رَبُّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ بَصَآئِرَ وَإِنِّى لَأَظُنُّكَ يَٰفِرْعَوْنُ مَثْبُورًۭا',
		number_in_surah: '102',
		page: '292',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2132',
		number: '2132',
		text: 'فَأَرَادَ أَن يَسْتَفِزَّهُم مِّنَ ٱلْأَرْضِ فَأَغْرَقْنَٰهُ وَمَن مَّعَهُۥ جَمِيعًۭا',
		number_in_surah: '103',
		page: '292',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2133',
		number: '2133',
		text: 'وَقُلْنَا مِنۢ بَعْدِهِۦ لِبَنِىٓ إِسْرَٰٓءِيلَ ٱسْكُنُوا۟ ٱلْأَرْضَ فَإِذَا جَآءَ وَعْدُ ٱلْءَاخِرَةِ جِئْنَا بِكُمْ لَفِيفًۭا',
		number_in_surah: '104',
		page: '292',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2134',
		number: '2134',
		text: 'وَبِٱلْحَقِّ أَنزَلْنَٰهُ وَبِٱلْحَقِّ نَزَلَ ۗ وَمَآ أَرْسَلْنَٰكَ إِلَّا مُبَشِّرًۭا وَنَذِيرًۭا',
		number_in_surah: '105',
		page: '293',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2135',
		number: '2135',
		text: 'وَقُرْءَانًۭا فَرَقْنَٰهُ لِتَقْرَأَهُۥ عَلَى ٱلنَّاسِ عَلَىٰ مُكْثٍۢ وَنَزَّلْنَٰهُ تَنزِيلًۭا',
		number_in_surah: '106',
		page: '293',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2136',
		number: '2136',
		text: 'قُلْ ءَامِنُوا۟ بِهِۦٓ أَوْ لَا تُؤْمِنُوٓا۟ ۚ إِنَّ ٱلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ مِن قَبْلِهِۦٓ إِذَا يُتْلَىٰ عَلَيْهِمْ يَخِرُّونَ لِلْأَذْقَانِ سُجَّدًۭا',
		number_in_surah: '107',
		page: '293',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2137',
		number: '2137',
		text: 'وَيَقُولُونَ سُبْحَٰنَ رَبِّنَآ إِن كَانَ وَعْدُ رَبِّنَا لَمَفْعُولًۭا',
		number_in_surah: '108',
		page: '293',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2138',
		number: '2138',
		text: 'وَيَخِرُّونَ لِلْأَذْقَانِ يَبْكُونَ وَيَزِيدُهُمْ خُشُوعًۭا ۩',
		number_in_surah: '109',
		page: '293',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '1',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2139',
		number: '2139',
		text: 'قُلِ ٱدْعُوا۟ ٱللَّهَ أَوِ ٱدْعُوا۟ ٱلرَّحْمَٰنَ ۖ أَيًّۭا مَّا تَدْعُوا۟ فَلَهُ ٱلْأَسْمَآءُ ٱلْحُسْنَىٰ ۚ وَلَا تَجْهَرْ بِصَلَاتِكَ وَلَا تُخَافِتْ بِهَا وَٱبْتَغِ بَيْنَ ذَٰلِكَ سَبِيلًۭا',
		number_in_surah: '110',
		page: '293',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2140',
		number: '2140',
		text: 'وَقُلِ ٱلْحَمْدُ لِلَّهِ ٱلَّذِى لَمْ يَتَّخِذْ وَلَدًۭا وَلَمْ يَكُن لَّهُۥ شَرِيكٌۭ فِى ٱلْمُلْكِ وَلَمْ يَكُن لَّهُۥ وَلِىٌّۭ مِّنَ ٱلذُّلِّ ۖ وَكَبِّرْهُ تَكْبِيرًۢا',
		number_in_surah: '111',
		page: '293',
		surah_id: '17',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2141',
		number: '2141',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱلْحَمْدُ لِلَّهِ ٱلَّذِىٓ أَنزَلَ عَلَىٰ عَبْدِهِ ٱلْكِتَٰبَ وَلَمْ يَجْعَل لَّهُۥ عِوَجَا ۜ',
		number_in_surah: '1',
		page: '293',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2142',
		number: '2142',
		text: 'قَيِّمًۭا لِّيُنذِرَ بَأْسًۭا شَدِيدًۭا مِّن لَّدُنْهُ وَيُبَشِّرَ ٱلْمُؤْمِنِينَ ٱلَّذِينَ يَعْمَلُونَ ٱلصَّٰلِحَٰتِ أَنَّ لَهُمْ أَجْرًا حَسَنًۭا',
		number_in_surah: '2',
		page: '293',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2143',
		number: '2143',
		text: 'مَّٰكِثِينَ فِيهِ أَبَدًۭا',
		number_in_surah: '3',
		page: '293',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2144',
		number: '2144',
		text: 'وَيُنذِرَ ٱلَّذِينَ قَالُوا۟ ٱتَّخَذَ ٱللَّهُ وَلَدًۭا',
		number_in_surah: '4',
		page: '293',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2145',
		number: '2145',
		text: 'مَّا لَهُم بِهِۦ مِنْ عِلْمٍۢ وَلَا لِءَابَآئِهِمْ ۚ كَبُرَتْ كَلِمَةًۭ تَخْرُجُ مِنْ أَفْوَٰهِهِمْ ۚ إِن يَقُولُونَ إِلَّا كَذِبًۭا',
		number_in_surah: '5',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2146',
		number: '2146',
		text: 'فَلَعَلَّكَ بَٰخِعٌۭ نَّفْسَكَ عَلَىٰٓ ءَاثَٰرِهِمْ إِن لَّمْ يُؤْمِنُوا۟ بِهَٰذَا ٱلْحَدِيثِ أَسَفًا',
		number_in_surah: '6',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2147',
		number: '2147',
		text: 'إِنَّا جَعَلْنَا مَا عَلَى ٱلْأَرْضِ زِينَةًۭ لَّهَا لِنَبْلُوَهُمْ أَيُّهُمْ أَحْسَنُ عَمَلًۭا',
		number_in_surah: '7',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2148',
		number: '2148',
		text: 'وَإِنَّا لَجَٰعِلُونَ مَا عَلَيْهَا صَعِيدًۭا جُرُزًا',
		number_in_surah: '8',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2149',
		number: '2149',
		text: 'أَمْ حَسِبْتَ أَنَّ أَصْحَٰبَ ٱلْكَهْفِ وَٱلرَّقِيمِ كَانُوا۟ مِنْ ءَايَٰتِنَا عَجَبًا',
		number_in_surah: '9',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2150',
		number: '2150',
		text: 'إِذْ أَوَى ٱلْفِتْيَةُ إِلَى ٱلْكَهْفِ فَقَالُوا۟ رَبَّنَآ ءَاتِنَا مِن لَّدُنكَ رَحْمَةًۭ وَهَيِّئْ لَنَا مِنْ أَمْرِنَا رَشَدًۭا',
		number_in_surah: '10',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2151',
		number: '2151',
		text: 'فَضَرَبْنَا عَلَىٰٓ ءَاذَانِهِمْ فِى ٱلْكَهْفِ سِنِينَ عَدَدًۭا',
		number_in_surah: '11',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2152',
		number: '2152',
		text: 'ثُمَّ بَعَثْنَٰهُمْ لِنَعْلَمَ أَىُّ ٱلْحِزْبَيْنِ أَحْصَىٰ لِمَا لَبِثُوٓا۟ أَمَدًۭا',
		number_in_surah: '12',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2153',
		number: '2153',
		text: 'نَّحْنُ نَقُصُّ عَلَيْكَ نَبَأَهُم بِٱلْحَقِّ ۚ إِنَّهُمْ فِتْيَةٌ ءَامَنُوا۟ بِرَبِّهِمْ وَزِدْنَٰهُمْ هُدًۭى',
		number_in_surah: '13',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2154',
		number: '2154',
		text: 'وَرَبَطْنَا عَلَىٰ قُلُوبِهِمْ إِذْ قَامُوا۟ فَقَالُوا۟ رَبُّنَا رَبُّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ لَن نَّدْعُوَا۟ مِن دُونِهِۦٓ إِلَٰهًۭا ۖ لَّقَدْ قُلْنَآ إِذًۭا شَطَطًا',
		number_in_surah: '14',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2155',
		number: '2155',
		text: 'هَٰٓؤُلَآءِ قَوْمُنَا ٱتَّخَذُوا۟ مِن دُونِهِۦٓ ءَالِهَةًۭ ۖ لَّوْلَا يَأْتُونَ عَلَيْهِم بِسُلْطَٰنٍۭ بَيِّنٍۢ ۖ فَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًۭا',
		number_in_surah: '15',
		page: '294',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2156',
		number: '2156',
		text: 'وَإِذِ ٱعْتَزَلْتُمُوهُمْ وَمَا يَعْبُدُونَ إِلَّا ٱللَّهَ فَأْوُۥٓا۟ إِلَى ٱلْكَهْفِ يَنشُرْ لَكُمْ رَبُّكُم مِّن رَّحْمَتِهِۦ وَيُهَيِّئْ لَكُم مِّنْ أَمْرِكُم مِّرْفَقًۭا',
		number_in_surah: '16',
		page: '295',
		surah_id: '18',
		hizb_id: '117',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2157',
		number: '2157',
		text: '۞ وَتَرَى ٱلشَّمْسَ إِذَا طَلَعَت تَّزَٰوَرُ عَن كَهْفِهِمْ ذَاتَ ٱلْيَمِينِ وَإِذَا غَرَبَت تَّقْرِضُهُمْ ذَاتَ ٱلشِّمَالِ وَهُمْ فِى فَجْوَةٍۢ مِّنْهُ ۚ ذَٰلِكَ مِنْ ءَايَٰتِ ٱللَّهِ ۗ مَن يَهْدِ ٱللَّهُ فَهُوَ ٱلْمُهْتَدِ ۖ وَمَن يُضْلِلْ فَلَن تَجِدَ لَهُۥ وَلِيًّۭا مُّرْشِدًۭا',
		number_in_surah: '17',
		page: '295',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2158',
		number: '2158',
		text: 'وَتَحْسَبُهُمْ أَيْقَاظًۭا وَهُمْ رُقُودٌۭ ۚ وَنُقَلِّبُهُمْ ذَاتَ ٱلْيَمِينِ وَذَاتَ ٱلشِّمَالِ ۖ وَكَلْبُهُم بَٰسِطٌۭ ذِرَاعَيْهِ بِٱلْوَصِيدِ ۚ لَوِ ٱطَّلَعْتَ عَلَيْهِمْ لَوَلَّيْتَ مِنْهُمْ فِرَارًۭا وَلَمُلِئْتَ مِنْهُمْ رُعْبًۭا',
		number_in_surah: '18',
		page: '295',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2159',
		number: '2159',
		text: 'وَكَذَٰلِكَ بَعَثْنَٰهُمْ لِيَتَسَآءَلُوا۟ بَيْنَهُمْ ۚ قَالَ قَآئِلٌۭ مِّنْهُمْ كَمْ لَبِثْتُمْ ۖ قَالُوا۟ لَبِثْنَا يَوْمًا أَوْ بَعْضَ يَوْمٍۢ ۚ قَالُوا۟ رَبُّكُمْ أَعْلَمُ بِمَا لَبِثْتُمْ فَٱبْعَثُوٓا۟ أَحَدَكُم بِوَرِقِكُمْ هَٰذِهِۦٓ إِلَى ٱلْمَدِينَةِ فَلْيَنظُرْ أَيُّهَآ أَزْكَىٰ طَعَامًۭا فَلْيَأْتِكُم بِرِزْقٍۢ مِّنْهُ وَلْيَتَلَطَّفْ وَلَا يُشْعِرَنَّ بِكُمْ أَحَدًا',
		number_in_surah: '19',
		page: '295',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2160',
		number: '2160',
		text: 'إِنَّهُمْ إِن يَظْهَرُوا۟ عَلَيْكُمْ يَرْجُمُوكُمْ أَوْ يُعِيدُوكُمْ فِى مِلَّتِهِمْ وَلَن تُفْلِحُوٓا۟ إِذًا أَبَدًۭا',
		number_in_surah: '20',
		page: '295',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2161',
		number: '2161',
		text: 'وَكَذَٰلِكَ أَعْثَرْنَا عَلَيْهِمْ لِيَعْلَمُوٓا۟ أَنَّ وَعْدَ ٱللَّهِ حَقٌّۭ وَأَنَّ ٱلسَّاعَةَ لَا رَيْبَ فِيهَآ إِذْ يَتَنَٰزَعُونَ بَيْنَهُمْ أَمْرَهُمْ ۖ فَقَالُوا۟ ٱبْنُوا۟ عَلَيْهِم بُنْيَٰنًۭا ۖ رَّبُّهُمْ أَعْلَمُ بِهِمْ ۚ قَالَ ٱلَّذِينَ غَلَبُوا۟ عَلَىٰٓ أَمْرِهِمْ لَنَتَّخِذَنَّ عَلَيْهِم مَّسْجِدًۭا',
		number_in_surah: '21',
		page: '296',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2162',
		number: '2162',
		text: 'سَيَقُولُونَ ثَلَٰثَةٌۭ رَّابِعُهُمْ كَلْبُهُمْ وَيَقُولُونَ خَمْسَةٌۭ سَادِسُهُمْ كَلْبُهُمْ رَجْمًۢا بِٱلْغَيْبِ ۖ وَيَقُولُونَ سَبْعَةٌۭ وَثَامِنُهُمْ كَلْبُهُمْ ۚ قُل رَّبِّىٓ أَعْلَمُ بِعِدَّتِهِم مَّا يَعْلَمُهُمْ إِلَّا قَلِيلٌۭ ۗ فَلَا تُمَارِ فِيهِمْ إِلَّا مِرَآءًۭ ظَٰهِرًۭا وَلَا تَسْتَفْتِ فِيهِم مِّنْهُمْ أَحَدًۭا',
		number_in_surah: '22',
		page: '296',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2163',
		number: '2163',
		text: 'وَلَا تَقُولَنَّ لِشَا۟ىْءٍ إِنِّى فَاعِلٌۭ ذَٰلِكَ غَدًا',
		number_in_surah: '23',
		page: '296',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2164',
		number: '2164',
		text: 'إِلَّآ أَن يَشَآءَ ٱللَّهُ ۚ وَٱذْكُر رَّبَّكَ إِذَا نَسِيتَ وَقُلْ عَسَىٰٓ أَن يَهْدِيَنِ رَبِّى لِأَقْرَبَ مِنْ هَٰذَا رَشَدًۭا',
		number_in_surah: '24',
		page: '296',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2165',
		number: '2165',
		text: 'وَلَبِثُوا۟ فِى كَهْفِهِمْ ثَلَٰثَ مِا۟ئَةٍۢ سِنِينَ وَٱزْدَادُوا۟ تِسْعًۭا',
		number_in_surah: '25',
		page: '296',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2166',
		number: '2166',
		text: 'قُلِ ٱللَّهُ أَعْلَمُ بِمَا لَبِثُوا۟ ۖ لَهُۥ غَيْبُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ أَبْصِرْ بِهِۦ وَأَسْمِعْ ۚ مَا لَهُم مِّن دُونِهِۦ مِن وَلِىٍّۢ وَلَا يُشْرِكُ فِى حُكْمِهِۦٓ أَحَدًۭا',
		number_in_surah: '26',
		page: '296',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2167',
		number: '2167',
		text: 'وَٱتْلُ مَآ أُوحِىَ إِلَيْكَ مِن كِتَابِ رَبِّكَ ۖ لَا مُبَدِّلَ لِكَلِمَٰتِهِۦ وَلَن تَجِدَ مِن دُونِهِۦ مُلْتَحَدًۭا',
		number_in_surah: '27',
		page: '296',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2168',
		number: '2168',
		text: 'وَٱصْبِرْ نَفْسَكَ مَعَ ٱلَّذِينَ يَدْعُونَ رَبَّهُم بِٱلْغَدَوٰةِ وَٱلْعَشِىِّ يُرِيدُونَ وَجْهَهُۥ ۖ وَلَا تَعْدُ عَيْنَاكَ عَنْهُمْ تُرِيدُ زِينَةَ ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ وَلَا تُطِعْ مَنْ أَغْفَلْنَا قَلْبَهُۥ عَن ذِكْرِنَا وَٱتَّبَعَ هَوَىٰهُ وَكَانَ أَمْرُهُۥ فُرُطًۭا',
		number_in_surah: '28',
		page: '297',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2169',
		number: '2169',
		text: 'وَقُلِ ٱلْحَقُّ مِن رَّبِّكُمْ ۖ فَمَن شَآءَ فَلْيُؤْمِن وَمَن شَآءَ فَلْيَكْفُرْ ۚ إِنَّآ أَعْتَدْنَا لِلظَّٰلِمِينَ نَارًا أَحَاطَ بِهِمْ سُرَادِقُهَا ۚ وَإِن يَسْتَغِيثُوا۟ يُغَاثُوا۟ بِمَآءٍۢ كَٱلْمُهْلِ يَشْوِى ٱلْوُجُوهَ ۚ بِئْسَ ٱلشَّرَابُ وَسَآءَتْ مُرْتَفَقًا',
		number_in_surah: '29',
		page: '297',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2170',
		number: '2170',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ إِنَّا لَا نُضِيعُ أَجْرَ مَنْ أَحْسَنَ عَمَلًا',
		number_in_surah: '30',
		page: '297',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2171',
		number: '2171',
		text: 'أُو۟لَٰٓئِكَ لَهُمْ جَنَّٰتُ عَدْنٍۢ تَجْرِى مِن تَحْتِهِمُ ٱلْأَنْهَٰرُ يُحَلَّوْنَ فِيهَا مِنْ أَسَاوِرَ مِن ذَهَبٍۢ وَيَلْبَسُونَ ثِيَابًا خُضْرًۭا مِّن سُندُسٍۢ وَإِسْتَبْرَقٍۢ مُّتَّكِـِٔينَ فِيهَا عَلَى ٱلْأَرَآئِكِ ۚ نِعْمَ ٱلثَّوَابُ وَحَسُنَتْ مُرْتَفَقًۭا',
		number_in_surah: '31',
		page: '297',
		surah_id: '18',
		hizb_id: '118',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2172',
		number: '2172',
		text: '۞ وَٱضْرِبْ لَهُم مَّثَلًۭا رَّجُلَيْنِ جَعَلْنَا لِأَحَدِهِمَا جَنَّتَيْنِ مِنْ أَعْنَٰبٍۢ وَحَفَفْنَٰهُمَا بِنَخْلٍۢ وَجَعَلْنَا بَيْنَهُمَا زَرْعًۭا',
		number_in_surah: '32',
		page: '297',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2173',
		number: '2173',
		text: 'كِلْتَا ٱلْجَنَّتَيْنِ ءَاتَتْ أُكُلَهَا وَلَمْ تَظْلِم مِّنْهُ شَيْـًۭٔا ۚ وَفَجَّرْنَا خِلَٰلَهُمَا نَهَرًۭا',
		number_in_surah: '33',
		page: '297',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2174',
		number: '2174',
		text: 'وَكَانَ لَهُۥ ثَمَرٌۭ فَقَالَ لِصَٰحِبِهِۦ وَهُوَ يُحَاوِرُهُۥٓ أَنَا۠ أَكْثَرُ مِنكَ مَالًۭا وَأَعَزُّ نَفَرًۭا',
		number_in_surah: '34',
		page: '297',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2175',
		number: '2175',
		text: 'وَدَخَلَ جَنَّتَهُۥ وَهُوَ ظَالِمٌۭ لِّنَفْسِهِۦ قَالَ مَآ أَظُنُّ أَن تَبِيدَ هَٰذِهِۦٓ أَبَدًۭا',
		number_in_surah: '35',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2176',
		number: '2176',
		text: 'وَمَآ أَظُنُّ ٱلسَّاعَةَ قَآئِمَةًۭ وَلَئِن رُّدِدتُّ إِلَىٰ رَبِّى لَأَجِدَنَّ خَيْرًۭا مِّنْهَا مُنقَلَبًۭا',
		number_in_surah: '36',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2177',
		number: '2177',
		text: 'قَالَ لَهُۥ صَاحِبُهُۥ وَهُوَ يُحَاوِرُهُۥٓ أَكَفَرْتَ بِٱلَّذِى خَلَقَكَ مِن تُرَابٍۢ ثُمَّ مِن نُّطْفَةٍۢ ثُمَّ سَوَّىٰكَ رَجُلًۭا',
		number_in_surah: '37',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2178',
		number: '2178',
		text: 'لَّٰكِنَّا۠ هُوَ ٱللَّهُ رَبِّى وَلَآ أُشْرِكُ بِرَبِّىٓ أَحَدًۭا',
		number_in_surah: '38',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2179',
		number: '2179',
		text: 'وَلَوْلَآ إِذْ دَخَلْتَ جَنَّتَكَ قُلْتَ مَا شَآءَ ٱللَّهُ لَا قُوَّةَ إِلَّا بِٱللَّهِ ۚ إِن تَرَنِ أَنَا۠ أَقَلَّ مِنكَ مَالًۭا وَوَلَدًۭا',
		number_in_surah: '39',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2180',
		number: '2180',
		text: 'فَعَسَىٰ رَبِّىٓ أَن يُؤْتِيَنِ خَيْرًۭا مِّن جَنَّتِكَ وَيُرْسِلَ عَلَيْهَا حُسْبَانًۭا مِّنَ ٱلسَّمَآءِ فَتُصْبِحَ صَعِيدًۭا زَلَقًا',
		number_in_surah: '40',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2181',
		number: '2181',
		text: 'أَوْ يُصْبِحَ مَآؤُهَا غَوْرًۭا فَلَن تَسْتَطِيعَ لَهُۥ طَلَبًۭا',
		number_in_surah: '41',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2182',
		number: '2182',
		text: 'وَأُحِيطَ بِثَمَرِهِۦ فَأَصْبَحَ يُقَلِّبُ كَفَّيْهِ عَلَىٰ مَآ أَنفَقَ فِيهَا وَهِىَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا وَيَقُولُ يَٰلَيْتَنِى لَمْ أُشْرِكْ بِرَبِّىٓ أَحَدًۭا',
		number_in_surah: '42',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2183',
		number: '2183',
		text: 'وَلَمْ تَكُن لَّهُۥ فِئَةٌۭ يَنصُرُونَهُۥ مِن دُونِ ٱللَّهِ وَمَا كَانَ مُنتَصِرًا',
		number_in_surah: '43',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2184',
		number: '2184',
		text: 'هُنَالِكَ ٱلْوَلَٰيَةُ لِلَّهِ ٱلْحَقِّ ۚ هُوَ خَيْرٌۭ ثَوَابًۭا وَخَيْرٌ عُقْبًۭا',
		number_in_surah: '44',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2185',
		number: '2185',
		text: 'وَٱضْرِبْ لَهُم مَّثَلَ ٱلْحَيَوٰةِ ٱلدُّنْيَا كَمَآءٍ أَنزَلْنَٰهُ مِنَ ٱلسَّمَآءِ فَٱخْتَلَطَ بِهِۦ نَبَاتُ ٱلْأَرْضِ فَأَصْبَحَ هَشِيمًۭا تَذْرُوهُ ٱلرِّيَٰحُ ۗ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ مُّقْتَدِرًا',
		number_in_surah: '45',
		page: '298',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2186',
		number: '2186',
		text: 'ٱلْمَالُ وَٱلْبَنُونَ زِينَةُ ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ وَٱلْبَٰقِيَٰتُ ٱلصَّٰلِحَٰتُ خَيْرٌ عِندَ رَبِّكَ ثَوَابًۭا وَخَيْرٌ أَمَلًۭا',
		number_in_surah: '46',
		page: '299',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2187',
		number: '2187',
		text: 'وَيَوْمَ نُسَيِّرُ ٱلْجِبَالَ وَتَرَى ٱلْأَرْضَ بَارِزَةًۭ وَحَشَرْنَٰهُمْ فَلَمْ نُغَادِرْ مِنْهُمْ أَحَدًۭا',
		number_in_surah: '47',
		page: '299',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2188',
		number: '2188',
		text: 'وَعُرِضُوا۟ عَلَىٰ رَبِّكَ صَفًّۭا لَّقَدْ جِئْتُمُونَا كَمَا خَلَقْنَٰكُمْ أَوَّلَ مَرَّةٍۭ ۚ بَلْ زَعَمْتُمْ أَلَّن نَّجْعَلَ لَكُم مَّوْعِدًۭا',
		number_in_surah: '48',
		page: '299',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2189',
		number: '2189',
		text: 'وَوُضِعَ ٱلْكِتَٰبُ فَتَرَى ٱلْمُجْرِمِينَ مُشْفِقِينَ مِمَّا فِيهِ وَيَقُولُونَ يَٰوَيْلَتَنَا مَالِ هَٰذَا ٱلْكِتَٰبِ لَا يُغَادِرُ صَغِيرَةًۭ وَلَا كَبِيرَةً إِلَّآ أَحْصَىٰهَا ۚ وَوَجَدُوا۟ مَا عَمِلُوا۟ حَاضِرًۭا ۗ وَلَا يَظْلِمُ رَبُّكَ أَحَدًۭا',
		number_in_surah: '49',
		page: '299',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2190',
		number: '2190',
		text: 'وَإِذْ قُلْنَا لِلْمَلَٰٓئِكَةِ ٱسْجُدُوا۟ لِءَادَمَ فَسَجَدُوٓا۟ إِلَّآ إِبْلِيسَ كَانَ مِنَ ٱلْجِنِّ فَفَسَقَ عَنْ أَمْرِ رَبِّهِۦٓ ۗ أَفَتَتَّخِذُونَهُۥ وَذُرِّيَّتَهُۥٓ أَوْلِيَآءَ مِن دُونِى وَهُمْ لَكُمْ عَدُوٌّۢ ۚ بِئْسَ لِلظَّٰلِمِينَ بَدَلًۭا',
		number_in_surah: '50',
		page: '299',
		surah_id: '18',
		hizb_id: '119',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2191',
		number: '2191',
		text: '۞ مَّآ أَشْهَدتُّهُمْ خَلْقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَلَا خَلْقَ أَنفُسِهِمْ وَمَا كُنتُ مُتَّخِذَ ٱلْمُضِلِّينَ عَضُدًۭا',
		number_in_surah: '51',
		page: '299',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2192',
		number: '2192',
		text: 'وَيَوْمَ يَقُولُ نَادُوا۟ شُرَكَآءِىَ ٱلَّذِينَ زَعَمْتُمْ فَدَعَوْهُمْ فَلَمْ يَسْتَجِيبُوا۟ لَهُمْ وَجَعَلْنَا بَيْنَهُم مَّوْبِقًۭا',
		number_in_surah: '52',
		page: '299',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2193',
		number: '2193',
		text: 'وَرَءَا ٱلْمُجْرِمُونَ ٱلنَّارَ فَظَنُّوٓا۟ أَنَّهُم مُّوَاقِعُوهَا وَلَمْ يَجِدُوا۟ عَنْهَا مَصْرِفًۭا',
		number_in_surah: '53',
		page: '299',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2194',
		number: '2194',
		text: 'وَلَقَدْ صَرَّفْنَا فِى هَٰذَا ٱلْقُرْءَانِ لِلنَّاسِ مِن كُلِّ مَثَلٍۢ ۚ وَكَانَ ٱلْإِنسَٰنُ أَكْثَرَ شَىْءٍۢ جَدَلًۭا',
		number_in_surah: '54',
		page: '300',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2195',
		number: '2195',
		text: 'وَمَا مَنَعَ ٱلنَّاسَ أَن يُؤْمِنُوٓا۟ إِذْ جَآءَهُمُ ٱلْهُدَىٰ وَيَسْتَغْفِرُوا۟ رَبَّهُمْ إِلَّآ أَن تَأْتِيَهُمْ سُنَّةُ ٱلْأَوَّلِينَ أَوْ يَأْتِيَهُمُ ٱلْعَذَابُ قُبُلًۭا',
		number_in_surah: '55',
		page: '300',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2196',
		number: '2196',
		text: 'وَمَا نُرْسِلُ ٱلْمُرْسَلِينَ إِلَّا مُبَشِّرِينَ وَمُنذِرِينَ ۚ وَيُجَٰدِلُ ٱلَّذِينَ كَفَرُوا۟ بِٱلْبَٰطِلِ لِيُدْحِضُوا۟ بِهِ ٱلْحَقَّ ۖ وَٱتَّخَذُوٓا۟ ءَايَٰتِى وَمَآ أُنذِرُوا۟ هُزُوًۭا',
		number_in_surah: '56',
		page: '300',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2197',
		number: '2197',
		text: 'وَمَنْ أَظْلَمُ مِمَّن ذُكِّرَ بِـَٔايَٰتِ رَبِّهِۦ فَأَعْرَضَ عَنْهَا وَنَسِىَ مَا قَدَّمَتْ يَدَاهُ ۚ إِنَّا جَعَلْنَا عَلَىٰ قُلُوبِهِمْ أَكِنَّةً أَن يَفْقَهُوهُ وَفِىٓ ءَاذَانِهِمْ وَقْرًۭا ۖ وَإِن تَدْعُهُمْ إِلَى ٱلْهُدَىٰ فَلَن يَهْتَدُوٓا۟ إِذًا أَبَدًۭا',
		number_in_surah: '57',
		page: '300',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2198',
		number: '2198',
		text: 'وَرَبُّكَ ٱلْغَفُورُ ذُو ٱلرَّحْمَةِ ۖ لَوْ يُؤَاخِذُهُم بِمَا كَسَبُوا۟ لَعَجَّلَ لَهُمُ ٱلْعَذَابَ ۚ بَل لَّهُم مَّوْعِدٌۭ لَّن يَجِدُوا۟ مِن دُونِهِۦ مَوْئِلًۭا',
		number_in_surah: '58',
		page: '300',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2199',
		number: '2199',
		text: 'وَتِلْكَ ٱلْقُرَىٰٓ أَهْلَكْنَٰهُمْ لَمَّا ظَلَمُوا۟ وَجَعَلْنَا لِمَهْلِكِهِم مَّوْعِدًۭا',
		number_in_surah: '59',
		page: '300',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2200',
		number: '2200',
		text: 'وَإِذْ قَالَ مُوسَىٰ لِفَتَىٰهُ لَآ أَبْرَحُ حَتَّىٰٓ أَبْلُغَ مَجْمَعَ ٱلْبَحْرَيْنِ أَوْ أَمْضِىَ حُقُبًۭا',
		number_in_surah: '60',
		page: '300',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2201',
		number: '2201',
		text: 'فَلَمَّا بَلَغَا مَجْمَعَ بَيْنِهِمَا نَسِيَا حُوتَهُمَا فَٱتَّخَذَ سَبِيلَهُۥ فِى ٱلْبَحْرِ سَرَبًۭا',
		number_in_surah: '61',
		page: '300',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2202',
		number: '2202',
		text: 'فَلَمَّا جَاوَزَا قَالَ لِفَتَىٰهُ ءَاتِنَا غَدَآءَنَا لَقَدْ لَقِينَا مِن سَفَرِنَا هَٰذَا نَصَبًۭا',
		number_in_surah: '62',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2203',
		number: '2203',
		text: 'قَالَ أَرَءَيْتَ إِذْ أَوَيْنَآ إِلَى ٱلصَّخْرَةِ فَإِنِّى نَسِيتُ ٱلْحُوتَ وَمَآ أَنسَىٰنِيهُ إِلَّا ٱلشَّيْطَٰنُ أَنْ أَذْكُرَهُۥ ۚ وَٱتَّخَذَ سَبِيلَهُۥ فِى ٱلْبَحْرِ عَجَبًۭا',
		number_in_surah: '63',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2204',
		number: '2204',
		text: 'قَالَ ذَٰلِكَ مَا كُنَّا نَبْغِ ۚ فَٱرْتَدَّا عَلَىٰٓ ءَاثَارِهِمَا قَصَصًۭا',
		number_in_surah: '64',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2205',
		number: '2205',
		text: 'فَوَجَدَا عَبْدًۭا مِّنْ عِبَادِنَآ ءَاتَيْنَٰهُ رَحْمَةًۭ مِّنْ عِندِنَا وَعَلَّمْنَٰهُ مِن لَّدُنَّا عِلْمًۭا',
		number_in_surah: '65',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2206',
		number: '2206',
		text: 'قَالَ لَهُۥ مُوسَىٰ هَلْ أَتَّبِعُكَ عَلَىٰٓ أَن تُعَلِّمَنِ مِمَّا عُلِّمْتَ رُشْدًۭا',
		number_in_surah: '66',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2207',
		number: '2207',
		text: 'قَالَ إِنَّكَ لَن تَسْتَطِيعَ مَعِىَ صَبْرًۭا',
		number_in_surah: '67',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2208',
		number: '2208',
		text: 'وَكَيْفَ تَصْبِرُ عَلَىٰ مَا لَمْ تُحِطْ بِهِۦ خُبْرًۭا',
		number_in_surah: '68',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2209',
		number: '2209',
		text: 'قَالَ سَتَجِدُنِىٓ إِن شَآءَ ٱللَّهُ صَابِرًۭا وَلَآ أَعْصِى لَكَ أَمْرًۭا',
		number_in_surah: '69',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2210',
		number: '2210',
		text: 'قَالَ فَإِنِ ٱتَّبَعْتَنِى فَلَا تَسْـَٔلْنِى عَن شَىْءٍ حَتَّىٰٓ أُحْدِثَ لَكَ مِنْهُ ذِكْرًۭا',
		number_in_surah: '70',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2211',
		number: '2211',
		text: 'فَٱنطَلَقَا حَتَّىٰٓ إِذَا رَكِبَا فِى ٱلسَّفِينَةِ خَرَقَهَا ۖ قَالَ أَخَرَقْتَهَا لِتُغْرِقَ أَهْلَهَا لَقَدْ جِئْتَ شَيْـًٔا إِمْرًۭا',
		number_in_surah: '71',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2212',
		number: '2212',
		text: 'قَالَ أَلَمْ أَقُلْ إِنَّكَ لَن تَسْتَطِيعَ مَعِىَ صَبْرًۭا',
		number_in_surah: '72',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2213',
		number: '2213',
		text: 'قَالَ لَا تُؤَاخِذْنِى بِمَا نَسِيتُ وَلَا تُرْهِقْنِى مِنْ أَمْرِى عُسْرًۭا',
		number_in_surah: '73',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2214',
		number: '2214',
		text: 'فَٱنطَلَقَا حَتَّىٰٓ إِذَا لَقِيَا غُلَٰمًۭا فَقَتَلَهُۥ قَالَ أَقَتَلْتَ نَفْسًۭا زَكِيَّةًۢ بِغَيْرِ نَفْسٍۢ لَّقَدْ جِئْتَ شَيْـًۭٔا نُّكْرًۭا',
		number_in_surah: '74',
		page: '301',
		surah_id: '18',
		hizb_id: '120',
		juz_id: '15',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2215',
		number: '2215',
		text: '۞ قَالَ أَلَمْ أَقُل لَّكَ إِنَّكَ لَن تَسْتَطِيعَ مَعِىَ صَبْرًۭا',
		number_in_surah: '75',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2216',
		number: '2216',
		text: 'قَالَ إِن سَأَلْتُكَ عَن شَىْءٍۭ بَعْدَهَا فَلَا تُصَٰحِبْنِى ۖ قَدْ بَلَغْتَ مِن لَّدُنِّى عُذْرًۭا',
		number_in_surah: '76',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2217',
		number: '2217',
		text: 'فَٱنطَلَقَا حَتَّىٰٓ إِذَآ أَتَيَآ أَهْلَ قَرْيَةٍ ٱسْتَطْعَمَآ أَهْلَهَا فَأَبَوْا۟ أَن يُضَيِّفُوهُمَا فَوَجَدَا فِيهَا جِدَارًۭا يُرِيدُ أَن يَنقَضَّ فَأَقَامَهُۥ ۖ قَالَ لَوْ شِئْتَ لَتَّخَذْتَ عَلَيْهِ أَجْرًۭا',
		number_in_surah: '77',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2218',
		number: '2218',
		text: 'قَالَ هَٰذَا فِرَاقُ بَيْنِى وَبَيْنِكَ ۚ سَأُنَبِّئُكَ بِتَأْوِيلِ مَا لَمْ تَسْتَطِع عَّلَيْهِ صَبْرًا',
		number_in_surah: '78',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2219',
		number: '2219',
		text: 'أَمَّا ٱلسَّفِينَةُ فَكَانَتْ لِمَسَٰكِينَ يَعْمَلُونَ فِى ٱلْبَحْرِ فَأَرَدتُّ أَنْ أَعِيبَهَا وَكَانَ وَرَآءَهُم مَّلِكٌۭ يَأْخُذُ كُلَّ سَفِينَةٍ غَصْبًۭا',
		number_in_surah: '79',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2220',
		number: '2220',
		text: 'وَأَمَّا ٱلْغُلَٰمُ فَكَانَ أَبَوَاهُ مُؤْمِنَيْنِ فَخَشِينَآ أَن يُرْهِقَهُمَا طُغْيَٰنًۭا وَكُفْرًۭا',
		number_in_surah: '80',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2221',
		number: '2221',
		text: 'فَأَرَدْنَآ أَن يُبْدِلَهُمَا رَبُّهُمَا خَيْرًۭا مِّنْهُ زَكَوٰةًۭ وَأَقْرَبَ رُحْمًۭا',
		number_in_surah: '81',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2222',
		number: '2222',
		text: 'وَأَمَّا ٱلْجِدَارُ فَكَانَ لِغُلَٰمَيْنِ يَتِيمَيْنِ فِى ٱلْمَدِينَةِ وَكَانَ تَحْتَهُۥ كَنزٌۭ لَّهُمَا وَكَانَ أَبُوهُمَا صَٰلِحًۭا فَأَرَادَ رَبُّكَ أَن يَبْلُغَآ أَشُدَّهُمَا وَيَسْتَخْرِجَا كَنزَهُمَا رَحْمَةًۭ مِّن رَّبِّكَ ۚ وَمَا فَعَلْتُهُۥ عَنْ أَمْرِى ۚ ذَٰلِكَ تَأْوِيلُ مَا لَمْ تَسْطِع عَّلَيْهِ صَبْرًۭا',
		number_in_surah: '82',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2223',
		number: '2223',
		text: 'وَيَسْـَٔلُونَكَ عَن ذِى ٱلْقَرْنَيْنِ ۖ قُلْ سَأَتْلُوا۟ عَلَيْكُم مِّنْهُ ذِكْرًا',
		number_in_surah: '83',
		page: '302',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:00',
		updated_at: '2018-06-07 08:07:00',
	},
	{
		id: '2224',
		number: '2224',
		text: 'إِنَّا مَكَّنَّا لَهُۥ فِى ٱلْأَرْضِ وَءَاتَيْنَٰهُ مِن كُلِّ شَىْءٍۢ سَبَبًۭا',
		number_in_surah: '84',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2225',
		number: '2225',
		text: 'فَأَتْبَعَ سَبَبًا',
		number_in_surah: '85',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2226',
		number: '2226',
		text: 'حَتَّىٰٓ إِذَا بَلَغَ مَغْرِبَ ٱلشَّمْسِ وَجَدَهَا تَغْرُبُ فِى عَيْنٍ حَمِئَةٍۢ وَوَجَدَ عِندَهَا قَوْمًۭا ۗ قُلْنَا يَٰذَا ٱلْقَرْنَيْنِ إِمَّآ أَن تُعَذِّبَ وَإِمَّآ أَن تَتَّخِذَ فِيهِمْ حُسْنًۭا',
		number_in_surah: '86',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2227',
		number: '2227',
		text: 'قَالَ أَمَّا مَن ظَلَمَ فَسَوْفَ نُعَذِّبُهُۥ ثُمَّ يُرَدُّ إِلَىٰ رَبِّهِۦ فَيُعَذِّبُهُۥ عَذَابًۭا نُّكْرًۭا',
		number_in_surah: '87',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2228',
		number: '2228',
		text: 'وَأَمَّا مَنْ ءَامَنَ وَعَمِلَ صَٰلِحًۭا فَلَهُۥ جَزَآءً ٱلْحُسْنَىٰ ۖ وَسَنَقُولُ لَهُۥ مِنْ أَمْرِنَا يُسْرًۭا',
		number_in_surah: '88',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2229',
		number: '2229',
		text: 'ثُمَّ أَتْبَعَ سَبَبًا',
		number_in_surah: '89',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2230',
		number: '2230',
		text: 'حَتَّىٰٓ إِذَا بَلَغَ مَطْلِعَ ٱلشَّمْسِ وَجَدَهَا تَطْلُعُ عَلَىٰ قَوْمٍۢ لَّمْ نَجْعَل لَّهُم مِّن دُونِهَا سِتْرًۭا',
		number_in_surah: '90',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2231',
		number: '2231',
		text: 'كَذَٰلِكَ وَقَدْ أَحَطْنَا بِمَا لَدَيْهِ خُبْرًۭا',
		number_in_surah: '91',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2232',
		number: '2232',
		text: 'ثُمَّ أَتْبَعَ سَبَبًا',
		number_in_surah: '92',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2233',
		number: '2233',
		text: 'حَتَّىٰٓ إِذَا بَلَغَ بَيْنَ ٱلسَّدَّيْنِ وَجَدَ مِن دُونِهِمَا قَوْمًۭا لَّا يَكَادُونَ يَفْقَهُونَ قَوْلًۭا',
		number_in_surah: '93',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2234',
		number: '2234',
		text: 'قَالُوا۟ يَٰذَا ٱلْقَرْنَيْنِ إِنَّ يَأْجُوجَ وَمَأْجُوجَ مُفْسِدُونَ فِى ٱلْأَرْضِ فَهَلْ نَجْعَلُ لَكَ خَرْجًا عَلَىٰٓ أَن تَجْعَلَ بَيْنَنَا وَبَيْنَهُمْ سَدًّۭا',
		number_in_surah: '94',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2235',
		number: '2235',
		text: 'قَالَ مَا مَكَّنِّى فِيهِ رَبِّى خَيْرٌۭ فَأَعِينُونِى بِقُوَّةٍ أَجْعَلْ بَيْنَكُمْ وَبَيْنَهُمْ رَدْمًا',
		number_in_surah: '95',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2236',
		number: '2236',
		text: 'ءَاتُونِى زُبَرَ ٱلْحَدِيدِ ۖ حَتَّىٰٓ إِذَا سَاوَىٰ بَيْنَ ٱلصَّدَفَيْنِ قَالَ ٱنفُخُوا۟ ۖ حَتَّىٰٓ إِذَا جَعَلَهُۥ نَارًۭا قَالَ ءَاتُونِىٓ أُفْرِغْ عَلَيْهِ قِطْرًۭا',
		number_in_surah: '96',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2237',
		number: '2237',
		text: 'فَمَا ٱسْطَٰعُوٓا۟ أَن يَظْهَرُوهُ وَمَا ٱسْتَطَٰعُوا۟ لَهُۥ نَقْبًۭا',
		number_in_surah: '97',
		page: '303',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2238',
		number: '2238',
		text: 'قَالَ هَٰذَا رَحْمَةٌۭ مِّن رَّبِّى ۖ فَإِذَا جَآءَ وَعْدُ رَبِّى جَعَلَهُۥ دَكَّآءَ ۖ وَكَانَ وَعْدُ رَبِّى حَقًّۭا',
		number_in_surah: '98',
		page: '304',
		surah_id: '18',
		hizb_id: '121',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2239',
		number: '2239',
		text: '۞ وَتَرَكْنَا بَعْضَهُمْ يَوْمَئِذٍۢ يَمُوجُ فِى بَعْضٍۢ ۖ وَنُفِخَ فِى ٱلصُّورِ فَجَمَعْنَٰهُمْ جَمْعًۭا',
		number_in_surah: '99',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2240',
		number: '2240',
		text: 'وَعَرَضْنَا جَهَنَّمَ يَوْمَئِذٍۢ لِّلْكَٰفِرِينَ عَرْضًا',
		number_in_surah: '100',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2241',
		number: '2241',
		text: 'ٱلَّذِينَ كَانَتْ أَعْيُنُهُمْ فِى غِطَآءٍ عَن ذِكْرِى وَكَانُوا۟ لَا يَسْتَطِيعُونَ سَمْعًا',
		number_in_surah: '101',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2242',
		number: '2242',
		text: 'أَفَحَسِبَ ٱلَّذِينَ كَفَرُوٓا۟ أَن يَتَّخِذُوا۟ عِبَادِى مِن دُونِىٓ أَوْلِيَآءَ ۚ إِنَّآ أَعْتَدْنَا جَهَنَّمَ لِلْكَٰفِرِينَ نُزُلًۭا',
		number_in_surah: '102',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2243',
		number: '2243',
		text: 'قُلْ هَلْ نُنَبِّئُكُم بِٱلْأَخْسَرِينَ أَعْمَٰلًا',
		number_in_surah: '103',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2244',
		number: '2244',
		text: 'ٱلَّذِينَ ضَلَّ سَعْيُهُمْ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا وَهُمْ يَحْسَبُونَ أَنَّهُمْ يُحْسِنُونَ صُنْعًا',
		number_in_surah: '104',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2245',
		number: '2245',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ كَفَرُوا۟ بِـَٔايَٰتِ رَبِّهِمْ وَلِقَآئِهِۦ فَحَبِطَتْ أَعْمَٰلُهُمْ فَلَا نُقِيمُ لَهُمْ يَوْمَ ٱلْقِيَٰمَةِ وَزْنًۭا',
		number_in_surah: '105',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2246',
		number: '2246',
		text: 'ذَٰلِكَ جَزَآؤُهُمْ جَهَنَّمُ بِمَا كَفَرُوا۟ وَٱتَّخَذُوٓا۟ ءَايَٰتِى وَرُسُلِى هُزُوًا',
		number_in_surah: '106',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2247',
		number: '2247',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ كَانَتْ لَهُمْ جَنَّٰتُ ٱلْفِرْدَوْسِ نُزُلًا',
		number_in_surah: '107',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2248',
		number: '2248',
		text: 'خَٰلِدِينَ فِيهَا لَا يَبْغُونَ عَنْهَا حِوَلًۭا',
		number_in_surah: '108',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2249',
		number: '2249',
		text: 'قُل لَّوْ كَانَ ٱلْبَحْرُ مِدَادًۭا لِّكَلِمَٰتِ رَبِّى لَنَفِدَ ٱلْبَحْرُ قَبْلَ أَن تَنفَدَ كَلِمَٰتُ رَبِّى وَلَوْ جِئْنَا بِمِثْلِهِۦ مَدَدًۭا',
		number_in_surah: '109',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2250',
		number: '2250',
		text: 'قُلْ إِنَّمَآ أَنَا۠ بَشَرٌۭ مِّثْلُكُمْ يُوحَىٰٓ إِلَىَّ أَنَّمَآ إِلَٰهُكُمْ إِلَٰهٌۭ وَٰحِدٌۭ ۖ فَمَن كَانَ يَرْجُوا۟ لِقَآءَ رَبِّهِۦ فَلْيَعْمَلْ عَمَلًۭا صَٰلِحًۭا وَلَا يُشْرِكْ بِعِبَادَةِ رَبِّهِۦٓ أَحَدًۢا',
		number_in_surah: '110',
		page: '304',
		surah_id: '18',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2251',
		number: '2251',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ كٓهيعٓصٓ',
		number_in_surah: '1',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2252',
		number: '2252',
		text: 'ذِكْرُ رَحْمَتِ رَبِّكَ عَبْدَهُۥ زَكَرِيَّآ',
		number_in_surah: '2',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2253',
		number: '2253',
		text: 'إِذْ نَادَىٰ رَبَّهُۥ نِدَآءً خَفِيًّۭا',
		number_in_surah: '3',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2254',
		number: '2254',
		text: 'قَالَ رَبِّ إِنِّى وَهَنَ ٱلْعَظْمُ مِنِّى وَٱشْتَعَلَ ٱلرَّأْسُ شَيْبًۭا وَلَمْ أَكُنۢ بِدُعَآئِكَ رَبِّ شَقِيًّۭا',
		number_in_surah: '4',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2255',
		number: '2255',
		text: 'وَإِنِّى خِفْتُ ٱلْمَوَٰلِىَ مِن وَرَآءِى وَكَانَتِ ٱمْرَأَتِى عَاقِرًۭا فَهَبْ لِى مِن لَّدُنكَ وَلِيًّۭا',
		number_in_surah: '5',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2256',
		number: '2256',
		text: 'يَرِثُنِى وَيَرِثُ مِنْ ءَالِ يَعْقُوبَ ۖ وَٱجْعَلْهُ رَبِّ رَضِيًّۭا',
		number_in_surah: '6',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2257',
		number: '2257',
		text: 'يَٰزَكَرِيَّآ إِنَّا نُبَشِّرُكَ بِغُلَٰمٍ ٱسْمُهُۥ يَحْيَىٰ لَمْ نَجْعَل لَّهُۥ مِن قَبْلُ سَمِيًّۭا',
		number_in_surah: '7',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2258',
		number: '2258',
		text: 'قَالَ رَبِّ أَنَّىٰ يَكُونُ لِى غُلَٰمٌۭ وَكَانَتِ ٱمْرَأَتِى عَاقِرًۭا وَقَدْ بَلَغْتُ مِنَ ٱلْكِبَرِ عِتِيًّۭا',
		number_in_surah: '8',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2259',
		number: '2259',
		text: 'قَالَ كَذَٰلِكَ قَالَ رَبُّكَ هُوَ عَلَىَّ هَيِّنٌۭ وَقَدْ خَلَقْتُكَ مِن قَبْلُ وَلَمْ تَكُ شَيْـًۭٔا',
		number_in_surah: '9',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2260',
		number: '2260',
		text: 'قَالَ رَبِّ ٱجْعَل لِّىٓ ءَايَةًۭ ۚ قَالَ ءَايَتُكَ أَلَّا تُكَلِّمَ ٱلنَّاسَ ثَلَٰثَ لَيَالٍۢ سَوِيًّۭا',
		number_in_surah: '10',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2261',
		number: '2261',
		text: 'فَخَرَجَ عَلَىٰ قَوْمِهِۦ مِنَ ٱلْمِحْرَابِ فَأَوْحَىٰٓ إِلَيْهِمْ أَن سَبِّحُوا۟ بُكْرَةًۭ وَعَشِيًّۭا',
		number_in_surah: '11',
		page: '305',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2262',
		number: '2262',
		text: 'يَٰيَحْيَىٰ خُذِ ٱلْكِتَٰبَ بِقُوَّةٍۢ ۖ وَءَاتَيْنَٰهُ ٱلْحُكْمَ صَبِيًّۭا',
		number_in_surah: '12',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2263',
		number: '2263',
		text: 'وَحَنَانًۭا مِّن لَّدُنَّا وَزَكَوٰةًۭ ۖ وَكَانَ تَقِيًّۭا',
		number_in_surah: '13',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2264',
		number: '2264',
		text: 'وَبَرًّۢا بِوَٰلِدَيْهِ وَلَمْ يَكُن جَبَّارًا عَصِيًّۭا',
		number_in_surah: '14',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2265',
		number: '2265',
		text: 'وَسَلَٰمٌ عَلَيْهِ يَوْمَ وُلِدَ وَيَوْمَ يَمُوتُ وَيَوْمَ يُبْعَثُ حَيًّۭا',
		number_in_surah: '15',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2266',
		number: '2266',
		text: 'وَٱذْكُرْ فِى ٱلْكِتَٰبِ مَرْيَمَ إِذِ ٱنتَبَذَتْ مِنْ أَهْلِهَا مَكَانًۭا شَرْقِيًّۭا',
		number_in_surah: '16',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2267',
		number: '2267',
		text: 'فَٱتَّخَذَتْ مِن دُونِهِمْ حِجَابًۭا فَأَرْسَلْنَآ إِلَيْهَا رُوحَنَا فَتَمَثَّلَ لَهَا بَشَرًۭا سَوِيًّۭا',
		number_in_surah: '17',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2268',
		number: '2268',
		text: 'قَالَتْ إِنِّىٓ أَعُوذُ بِٱلرَّحْمَٰنِ مِنكَ إِن كُنتَ تَقِيًّۭا',
		number_in_surah: '18',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2269',
		number: '2269',
		text: 'قَالَ إِنَّمَآ أَنَا۠ رَسُولُ رَبِّكِ لِأَهَبَ لَكِ غُلَٰمًۭا زَكِيًّۭا',
		number_in_surah: '19',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2270',
		number: '2270',
		text: 'قَالَتْ أَنَّىٰ يَكُونُ لِى غُلَٰمٌۭ وَلَمْ يَمْسَسْنِى بَشَرٌۭ وَلَمْ أَكُ بَغِيًّۭا',
		number_in_surah: '20',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2271',
		number: '2271',
		text: 'قَالَ كَذَٰلِكِ قَالَ رَبُّكِ هُوَ عَلَىَّ هَيِّنٌۭ ۖ وَلِنَجْعَلَهُۥٓ ءَايَةًۭ لِّلنَّاسِ وَرَحْمَةًۭ مِّنَّا ۚ وَكَانَ أَمْرًۭا مَّقْضِيًّۭا',
		number_in_surah: '21',
		page: '306',
		surah_id: '19',
		hizb_id: '122',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2272',
		number: '2272',
		text: '۞ فَحَمَلَتْهُ فَٱنتَبَذَتْ بِهِۦ مَكَانًۭا قَصِيًّۭا',
		number_in_surah: '22',
		page: '306',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2273',
		number: '2273',
		text: 'فَأَجَآءَهَا ٱلْمَخَاضُ إِلَىٰ جِذْعِ ٱلنَّخْلَةِ قَالَتْ يَٰلَيْتَنِى مِتُّ قَبْلَ هَٰذَا وَكُنتُ نَسْيًۭا مَّنسِيًّۭا',
		number_in_surah: '23',
		page: '306',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2274',
		number: '2274',
		text: 'فَنَادَىٰهَا مِن تَحْتِهَآ أَلَّا تَحْزَنِى قَدْ جَعَلَ رَبُّكِ تَحْتَكِ سَرِيًّۭا',
		number_in_surah: '24',
		page: '306',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2275',
		number: '2275',
		text: 'وَهُزِّىٓ إِلَيْكِ بِجِذْعِ ٱلنَّخْلَةِ تُسَٰقِطْ عَلَيْكِ رُطَبًۭا جَنِيًّۭا',
		number_in_surah: '25',
		page: '306',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2276',
		number: '2276',
		text: 'فَكُلِى وَٱشْرَبِى وَقَرِّى عَيْنًۭا ۖ فَإِمَّا تَرَيِنَّ مِنَ ٱلْبَشَرِ أَحَدًۭا فَقُولِىٓ إِنِّى نَذَرْتُ لِلرَّحْمَٰنِ صَوْمًۭا فَلَنْ أُكَلِّمَ ٱلْيَوْمَ إِنسِيًّۭا',
		number_in_surah: '26',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2277',
		number: '2277',
		text: 'فَأَتَتْ بِهِۦ قَوْمَهَا تَحْمِلُهُۥ ۖ قَالُوا۟ يَٰمَرْيَمُ لَقَدْ جِئْتِ شَيْـًۭٔا فَرِيًّۭا',
		number_in_surah: '27',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2278',
		number: '2278',
		text: 'يَٰٓأُخْتَ هَٰرُونَ مَا كَانَ أَبُوكِ ٱمْرَأَ سَوْءٍۢ وَمَا كَانَتْ أُمُّكِ بَغِيًّۭا',
		number_in_surah: '28',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2279',
		number: '2279',
		text: 'فَأَشَارَتْ إِلَيْهِ ۖ قَالُوا۟ كَيْفَ نُكَلِّمُ مَن كَانَ فِى ٱلْمَهْدِ صَبِيًّۭا',
		number_in_surah: '29',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2280',
		number: '2280',
		text: 'قَالَ إِنِّى عَبْدُ ٱللَّهِ ءَاتَىٰنِىَ ٱلْكِتَٰبَ وَجَعَلَنِى نَبِيًّۭا',
		number_in_surah: '30',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2281',
		number: '2281',
		text: 'وَجَعَلَنِى مُبَارَكًا أَيْنَ مَا كُنتُ وَأَوْصَٰنِى بِٱلصَّلَوٰةِ وَٱلزَّكَوٰةِ مَا دُمْتُ حَيًّۭا',
		number_in_surah: '31',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2282',
		number: '2282',
		text: 'وَبَرًّۢا بِوَٰلِدَتِى وَلَمْ يَجْعَلْنِى جَبَّارًۭا شَقِيًّۭا',
		number_in_surah: '32',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2283',
		number: '2283',
		text: 'وَٱلسَّلَٰمُ عَلَىَّ يَوْمَ وُلِدتُّ وَيَوْمَ أَمُوتُ وَيَوْمَ أُبْعَثُ حَيًّۭا',
		number_in_surah: '33',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2284',
		number: '2284',
		text: 'ذَٰلِكَ عِيسَى ٱبْنُ مَرْيَمَ ۚ قَوْلَ ٱلْحَقِّ ٱلَّذِى فِيهِ يَمْتَرُونَ',
		number_in_surah: '34',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2285',
		number: '2285',
		text: 'مَا كَانَ لِلَّهِ أَن يَتَّخِذَ مِن وَلَدٍۢ ۖ سُبْحَٰنَهُۥٓ ۚ إِذَا قَضَىٰٓ أَمْرًۭا فَإِنَّمَا يَقُولُ لَهُۥ كُن فَيَكُونُ',
		number_in_surah: '35',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2286',
		number: '2286',
		text: 'وَإِنَّ ٱللَّهَ رَبِّى وَرَبُّكُمْ فَٱعْبُدُوهُ ۚ هَٰذَا صِرَٰطٌۭ مُّسْتَقِيمٌۭ',
		number_in_surah: '36',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2287',
		number: '2287',
		text: 'فَٱخْتَلَفَ ٱلْأَحْزَابُ مِنۢ بَيْنِهِمْ ۖ فَوَيْلٌۭ لِّلَّذِينَ كَفَرُوا۟ مِن مَّشْهَدِ يَوْمٍ عَظِيمٍ',
		number_in_surah: '37',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2288',
		number: '2288',
		text: 'أَسْمِعْ بِهِمْ وَأَبْصِرْ يَوْمَ يَأْتُونَنَا ۖ لَٰكِنِ ٱلظَّٰلِمُونَ ٱلْيَوْمَ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '38',
		page: '307',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2289',
		number: '2289',
		text: 'وَأَنذِرْهُمْ يَوْمَ ٱلْحَسْرَةِ إِذْ قُضِىَ ٱلْأَمْرُ وَهُمْ فِى غَفْلَةٍۢ وَهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '39',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2290',
		number: '2290',
		text: 'إِنَّا نَحْنُ نَرِثُ ٱلْأَرْضَ وَمَنْ عَلَيْهَا وَإِلَيْنَا يُرْجَعُونَ',
		number_in_surah: '40',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2291',
		number: '2291',
		text: 'وَٱذْكُرْ فِى ٱلْكِتَٰبِ إِبْرَٰهِيمَ ۚ إِنَّهُۥ كَانَ صِدِّيقًۭا نَّبِيًّا',
		number_in_surah: '41',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2292',
		number: '2292',
		text: 'إِذْ قَالَ لِأَبِيهِ يَٰٓأَبَتِ لِمَ تَعْبُدُ مَا لَا يَسْمَعُ وَلَا يُبْصِرُ وَلَا يُغْنِى عَنكَ شَيْـًۭٔا',
		number_in_surah: '42',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2293',
		number: '2293',
		text: 'يَٰٓأَبَتِ إِنِّى قَدْ جَآءَنِى مِنَ ٱلْعِلْمِ مَا لَمْ يَأْتِكَ فَٱتَّبِعْنِىٓ أَهْدِكَ صِرَٰطًۭا سَوِيًّۭا',
		number_in_surah: '43',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2294',
		number: '2294',
		text: 'يَٰٓأَبَتِ لَا تَعْبُدِ ٱلشَّيْطَٰنَ ۖ إِنَّ ٱلشَّيْطَٰنَ كَانَ لِلرَّحْمَٰنِ عَصِيًّۭا',
		number_in_surah: '44',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2295',
		number: '2295',
		text: 'يَٰٓأَبَتِ إِنِّىٓ أَخَافُ أَن يَمَسَّكَ عَذَابٌۭ مِّنَ ٱلرَّحْمَٰنِ فَتَكُونَ لِلشَّيْطَٰنِ وَلِيًّۭا',
		number_in_surah: '45',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2296',
		number: '2296',
		text: 'قَالَ أَرَاغِبٌ أَنتَ عَنْ ءَالِهَتِى يَٰٓإِبْرَٰهِيمُ ۖ لَئِن لَّمْ تَنتَهِ لَأَرْجُمَنَّكَ ۖ وَٱهْجُرْنِى مَلِيًّۭا',
		number_in_surah: '46',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2297',
		number: '2297',
		text: 'قَالَ سَلَٰمٌ عَلَيْكَ ۖ سَأَسْتَغْفِرُ لَكَ رَبِّىٓ ۖ إِنَّهُۥ كَانَ بِى حَفِيًّۭا',
		number_in_surah: '47',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2298',
		number: '2298',
		text: 'وَأَعْتَزِلُكُمْ وَمَا تَدْعُونَ مِن دُونِ ٱللَّهِ وَأَدْعُوا۟ رَبِّى عَسَىٰٓ أَلَّآ أَكُونَ بِدُعَآءِ رَبِّى شَقِيًّۭا',
		number_in_surah: '48',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2299',
		number: '2299',
		text: 'فَلَمَّا ٱعْتَزَلَهُمْ وَمَا يَعْبُدُونَ مِن دُونِ ٱللَّهِ وَهَبْنَا لَهُۥٓ إِسْحَٰقَ وَيَعْقُوبَ ۖ وَكُلًّۭا جَعَلْنَا نَبِيًّۭا',
		number_in_surah: '49',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2300',
		number: '2300',
		text: 'وَوَهَبْنَا لَهُم مِّن رَّحْمَتِنَا وَجَعَلْنَا لَهُمْ لِسَانَ صِدْقٍ عَلِيًّۭا',
		number_in_surah: '50',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2301',
		number: '2301',
		text: 'وَٱذْكُرْ فِى ٱلْكِتَٰبِ مُوسَىٰٓ ۚ إِنَّهُۥ كَانَ مُخْلَصًۭا وَكَانَ رَسُولًۭا نَّبِيًّۭا',
		number_in_surah: '51',
		page: '308',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2302',
		number: '2302',
		text: 'وَنَٰدَيْنَٰهُ مِن جَانِبِ ٱلطُّورِ ٱلْأَيْمَنِ وَقَرَّبْنَٰهُ نَجِيًّۭا',
		number_in_surah: '52',
		page: '309',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2303',
		number: '2303',
		text: 'وَوَهَبْنَا لَهُۥ مِن رَّحْمَتِنَآ أَخَاهُ هَٰرُونَ نَبِيًّۭا',
		number_in_surah: '53',
		page: '309',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2304',
		number: '2304',
		text: 'وَٱذْكُرْ فِى ٱلْكِتَٰبِ إِسْمَٰعِيلَ ۚ إِنَّهُۥ كَانَ صَادِقَ ٱلْوَعْدِ وَكَانَ رَسُولًۭا نَّبِيًّۭا',
		number_in_surah: '54',
		page: '309',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2305',
		number: '2305',
		text: 'وَكَانَ يَأْمُرُ أَهْلَهُۥ بِٱلصَّلَوٰةِ وَٱلزَّكَوٰةِ وَكَانَ عِندَ رَبِّهِۦ مَرْضِيًّۭا',
		number_in_surah: '55',
		page: '309',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2306',
		number: '2306',
		text: 'وَٱذْكُرْ فِى ٱلْكِتَٰبِ إِدْرِيسَ ۚ إِنَّهُۥ كَانَ صِدِّيقًۭا نَّبِيًّۭا',
		number_in_surah: '56',
		page: '309',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2307',
		number: '2307',
		text: 'وَرَفَعْنَٰهُ مَكَانًا عَلِيًّا',
		number_in_surah: '57',
		page: '309',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2308',
		number: '2308',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ أَنْعَمَ ٱللَّهُ عَلَيْهِم مِّنَ ٱلنَّبِيِّۦنَ مِن ذُرِّيَّةِ ءَادَمَ وَمِمَّنْ حَمَلْنَا مَعَ نُوحٍۢ وَمِن ذُرِّيَّةِ إِبْرَٰهِيمَ وَإِسْرَٰٓءِيلَ وَمِمَّنْ هَدَيْنَا وَٱجْتَبَيْنَآ ۚ إِذَا تُتْلَىٰ عَلَيْهِمْ ءَايَٰتُ ٱلرَّحْمَٰنِ خَرُّوا۟ سُجَّدًۭا وَبُكِيًّۭا ۩',
		number_in_surah: '58',
		page: '309',
		surah_id: '19',
		hizb_id: '123',
		juz_id: '16',
		sajda: '1',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2309',
		number: '2309',
		text: '۞ فَخَلَفَ مِنۢ بَعْدِهِمْ خَلْفٌ أَضَاعُوا۟ ٱلصَّلَوٰةَ وَٱتَّبَعُوا۟ ٱلشَّهَوَٰتِ ۖ فَسَوْفَ يَلْقَوْنَ غَيًّا',
		number_in_surah: '59',
		page: '309',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2310',
		number: '2310',
		text: 'إِلَّا مَن تَابَ وَءَامَنَ وَعَمِلَ صَٰلِحًۭا فَأُو۟لَٰٓئِكَ يَدْخُلُونَ ٱلْجَنَّةَ وَلَا يُظْلَمُونَ شَيْـًۭٔا',
		number_in_surah: '60',
		page: '309',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2311',
		number: '2311',
		text: 'جَنَّٰتِ عَدْنٍ ٱلَّتِى وَعَدَ ٱلرَّحْمَٰنُ عِبَادَهُۥ بِٱلْغَيْبِ ۚ إِنَّهُۥ كَانَ وَعْدُهُۥ مَأْتِيًّۭا',
		number_in_surah: '61',
		page: '309',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2312',
		number: '2312',
		text: 'لَّا يَسْمَعُونَ فِيهَا لَغْوًا إِلَّا سَلَٰمًۭا ۖ وَلَهُمْ رِزْقُهُمْ فِيهَا بُكْرَةًۭ وَعَشِيًّۭا',
		number_in_surah: '62',
		page: '309',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2313',
		number: '2313',
		text: 'تِلْكَ ٱلْجَنَّةُ ٱلَّتِى نُورِثُ مِنْ عِبَادِنَا مَن كَانَ تَقِيًّۭا',
		number_in_surah: '63',
		page: '309',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2314',
		number: '2314',
		text: 'وَمَا نَتَنَزَّلُ إِلَّا بِأَمْرِ رَبِّكَ ۖ لَهُۥ مَا بَيْنَ أَيْدِينَا وَمَا خَلْفَنَا وَمَا بَيْنَ ذَٰلِكَ ۚ وَمَا كَانَ رَبُّكَ نَسِيًّۭا',
		number_in_surah: '64',
		page: '309',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2315',
		number: '2315',
		text: 'رَّبُّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَا فَٱعْبُدْهُ وَٱصْطَبِرْ لِعِبَٰدَتِهِۦ ۚ هَلْ تَعْلَمُ لَهُۥ سَمِيًّۭا',
		number_in_surah: '65',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2316',
		number: '2316',
		text: 'وَيَقُولُ ٱلْإِنسَٰنُ أَءِذَا مَا مِتُّ لَسَوْفَ أُخْرَجُ حَيًّا',
		number_in_surah: '66',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2317',
		number: '2317',
		text: 'أَوَلَا يَذْكُرُ ٱلْإِنسَٰنُ أَنَّا خَلَقْنَٰهُ مِن قَبْلُ وَلَمْ يَكُ شَيْـًۭٔا',
		number_in_surah: '67',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2318',
		number: '2318',
		text: 'فَوَرَبِّكَ لَنَحْشُرَنَّهُمْ وَٱلشَّيَٰطِينَ ثُمَّ لَنُحْضِرَنَّهُمْ حَوْلَ جَهَنَّمَ جِثِيًّۭا',
		number_in_surah: '68',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2319',
		number: '2319',
		text: 'ثُمَّ لَنَنزِعَنَّ مِن كُلِّ شِيعَةٍ أَيُّهُمْ أَشَدُّ عَلَى ٱلرَّحْمَٰنِ عِتِيًّۭا',
		number_in_surah: '69',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2320',
		number: '2320',
		text: 'ثُمَّ لَنَحْنُ أَعْلَمُ بِٱلَّذِينَ هُمْ أَوْلَىٰ بِهَا صِلِيًّۭا',
		number_in_surah: '70',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2321',
		number: '2321',
		text: 'وَإِن مِّنكُمْ إِلَّا وَارِدُهَا ۚ كَانَ عَلَىٰ رَبِّكَ حَتْمًۭا مَّقْضِيًّۭا',
		number_in_surah: '71',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2322',
		number: '2322',
		text: 'ثُمَّ نُنَجِّى ٱلَّذِينَ ٱتَّقَوا۟ وَّنَذَرُ ٱلظَّٰلِمِينَ فِيهَا جِثِيًّۭا',
		number_in_surah: '72',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2323',
		number: '2323',
		text: 'وَإِذَا تُتْلَىٰ عَلَيْهِمْ ءَايَٰتُنَا بَيِّنَٰتٍۢ قَالَ ٱلَّذِينَ كَفَرُوا۟ لِلَّذِينَ ءَامَنُوٓا۟ أَىُّ ٱلْفَرِيقَيْنِ خَيْرٌۭ مَّقَامًۭا وَأَحْسَنُ نَدِيًّۭا',
		number_in_surah: '73',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2324',
		number: '2324',
		text: 'وَكَمْ أَهْلَكْنَا قَبْلَهُم مِّن قَرْنٍ هُمْ أَحْسَنُ أَثَٰثًۭا وَرِءْيًۭا',
		number_in_surah: '74',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2325',
		number: '2325',
		text: 'قُلْ مَن كَانَ فِى ٱلضَّلَٰلَةِ فَلْيَمْدُدْ لَهُ ٱلرَّحْمَٰنُ مَدًّا ۚ حَتَّىٰٓ إِذَا رَأَوْا۟ مَا يُوعَدُونَ إِمَّا ٱلْعَذَابَ وَإِمَّا ٱلسَّاعَةَ فَسَيَعْلَمُونَ مَنْ هُوَ شَرٌّۭ مَّكَانًۭا وَأَضْعَفُ جُندًۭا',
		number_in_surah: '75',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2326',
		number: '2326',
		text: 'وَيَزِيدُ ٱللَّهُ ٱلَّذِينَ ٱهْتَدَوْا۟ هُدًۭى ۗ وَٱلْبَٰقِيَٰتُ ٱلصَّٰلِحَٰتُ خَيْرٌ عِندَ رَبِّكَ ثَوَابًۭا وَخَيْرٌۭ مَّرَدًّا',
		number_in_surah: '76',
		page: '310',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2327',
		number: '2327',
		text: 'أَفَرَءَيْتَ ٱلَّذِى كَفَرَ بِـَٔايَٰتِنَا وَقَالَ لَأُوتَيَنَّ مَالًۭا وَوَلَدًا',
		number_in_surah: '77',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2328',
		number: '2328',
		text: 'أَطَّلَعَ ٱلْغَيْبَ أَمِ ٱتَّخَذَ عِندَ ٱلرَّحْمَٰنِ عَهْدًۭا',
		number_in_surah: '78',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2329',
		number: '2329',
		text: 'كَلَّا ۚ سَنَكْتُبُ مَا يَقُولُ وَنَمُدُّ لَهُۥ مِنَ ٱلْعَذَابِ مَدًّۭا',
		number_in_surah: '79',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2330',
		number: '2330',
		text: 'وَنَرِثُهُۥ مَا يَقُولُ وَيَأْتِينَا فَرْدًۭا',
		number_in_surah: '80',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2331',
		number: '2331',
		text: 'وَٱتَّخَذُوا۟ مِن دُونِ ٱللَّهِ ءَالِهَةًۭ لِّيَكُونُوا۟ لَهُمْ عِزًّۭا',
		number_in_surah: '81',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2332',
		number: '2332',
		text: 'كَلَّا ۚ سَيَكْفُرُونَ بِعِبَادَتِهِمْ وَيَكُونُونَ عَلَيْهِمْ ضِدًّا',
		number_in_surah: '82',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2333',
		number: '2333',
		text: 'أَلَمْ تَرَ أَنَّآ أَرْسَلْنَا ٱلشَّيَٰطِينَ عَلَى ٱلْكَٰفِرِينَ تَؤُزُّهُمْ أَزًّۭا',
		number_in_surah: '83',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2334',
		number: '2334',
		text: 'فَلَا تَعْجَلْ عَلَيْهِمْ ۖ إِنَّمَا نَعُدُّ لَهُمْ عَدًّۭا',
		number_in_surah: '84',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2335',
		number: '2335',
		text: 'يَوْمَ نَحْشُرُ ٱلْمُتَّقِينَ إِلَى ٱلرَّحْمَٰنِ وَفْدًۭا',
		number_in_surah: '85',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2336',
		number: '2336',
		text: 'وَنَسُوقُ ٱلْمُجْرِمِينَ إِلَىٰ جَهَنَّمَ وِرْدًۭا',
		number_in_surah: '86',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2337',
		number: '2337',
		text: 'لَّا يَمْلِكُونَ ٱلشَّفَٰعَةَ إِلَّا مَنِ ٱتَّخَذَ عِندَ ٱلرَّحْمَٰنِ عَهْدًۭا',
		number_in_surah: '87',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2338',
		number: '2338',
		text: 'وَقَالُوا۟ ٱتَّخَذَ ٱلرَّحْمَٰنُ وَلَدًۭا',
		number_in_surah: '88',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2339',
		number: '2339',
		text: 'لَّقَدْ جِئْتُمْ شَيْـًٔا إِدًّۭا',
		number_in_surah: '89',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2340',
		number: '2340',
		text: 'تَكَادُ ٱلسَّمَٰوَٰتُ يَتَفَطَّرْنَ مِنْهُ وَتَنشَقُّ ٱلْأَرْضُ وَتَخِرُّ ٱلْجِبَالُ هَدًّا',
		number_in_surah: '90',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2341',
		number: '2341',
		text: 'أَن دَعَوْا۟ لِلرَّحْمَٰنِ وَلَدًۭا',
		number_in_surah: '91',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2342',
		number: '2342',
		text: 'وَمَا يَنۢبَغِى لِلرَّحْمَٰنِ أَن يَتَّخِذَ وَلَدًا',
		number_in_surah: '92',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2343',
		number: '2343',
		text: 'إِن كُلُّ مَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ إِلَّآ ءَاتِى ٱلرَّحْمَٰنِ عَبْدًۭا',
		number_in_surah: '93',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2344',
		number: '2344',
		text: 'لَّقَدْ أَحْصَىٰهُمْ وَعَدَّهُمْ عَدًّۭا',
		number_in_surah: '94',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2345',
		number: '2345',
		text: 'وَكُلُّهُمْ ءَاتِيهِ يَوْمَ ٱلْقِيَٰمَةِ فَرْدًا',
		number_in_surah: '95',
		page: '311',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2346',
		number: '2346',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ سَيَجْعَلُ لَهُمُ ٱلرَّحْمَٰنُ وُدًّۭا',
		number_in_surah: '96',
		page: '312',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2347',
		number: '2347',
		text: 'فَإِنَّمَا يَسَّرْنَٰهُ بِلِسَانِكَ لِتُبَشِّرَ بِهِ ٱلْمُتَّقِينَ وَتُنذِرَ بِهِۦ قَوْمًۭا لُّدًّۭا',
		number_in_surah: '97',
		page: '312',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2348',
		number: '2348',
		text: 'وَكَمْ أَهْلَكْنَا قَبْلَهُم مِّن قَرْنٍ هَلْ تُحِسُّ مِنْهُم مِّنْ أَحَدٍ أَوْ تَسْمَعُ لَهُمْ رِكْزًۢا',
		number_in_surah: '98',
		page: '312',
		surah_id: '19',
		hizb_id: '124',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2349',
		number: '2349',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ طه',
		number_in_surah: '1',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2350',
		number: '2350',
		text: 'مَآ أَنزَلْنَا عَلَيْكَ ٱلْقُرْءَانَ لِتَشْقَىٰٓ',
		number_in_surah: '2',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2351',
		number: '2351',
		text: 'إِلَّا تَذْكِرَةًۭ لِّمَن يَخْشَىٰ',
		number_in_surah: '3',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2352',
		number: '2352',
		text: 'تَنزِيلًۭا مِّمَّنْ خَلَقَ ٱلْأَرْضَ وَٱلسَّمَٰوَٰتِ ٱلْعُلَى',
		number_in_surah: '4',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2353',
		number: '2353',
		text: 'ٱلرَّحْمَٰنُ عَلَى ٱلْعَرْشِ ٱسْتَوَىٰ',
		number_in_surah: '5',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2354',
		number: '2354',
		text: 'لَهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ وَمَا بَيْنَهُمَا وَمَا تَحْتَ ٱلثَّرَىٰ',
		number_in_surah: '6',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2355',
		number: '2355',
		text: 'وَإِن تَجْهَرْ بِٱلْقَوْلِ فَإِنَّهُۥ يَعْلَمُ ٱلسِّرَّ وَأَخْفَى',
		number_in_surah: '7',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2356',
		number: '2356',
		text: 'ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ۖ لَهُ ٱلْأَسْمَآءُ ٱلْحُسْنَىٰ',
		number_in_surah: '8',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2357',
		number: '2357',
		text: 'وَهَلْ أَتَىٰكَ حَدِيثُ مُوسَىٰٓ',
		number_in_surah: '9',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2358',
		number: '2358',
		text: 'إِذْ رَءَا نَارًۭا فَقَالَ لِأَهْلِهِ ٱمْكُثُوٓا۟ إِنِّىٓ ءَانَسْتُ نَارًۭا لَّعَلِّىٓ ءَاتِيكُم مِّنْهَا بِقَبَسٍ أَوْ أَجِدُ عَلَى ٱلنَّارِ هُدًۭى',
		number_in_surah: '10',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2359',
		number: '2359',
		text: 'فَلَمَّآ أَتَىٰهَا نُودِىَ يَٰمُوسَىٰٓ',
		number_in_surah: '11',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2360',
		number: '2360',
		text: 'إِنِّىٓ أَنَا۠ رَبُّكَ فَٱخْلَعْ نَعْلَيْكَ ۖ إِنَّكَ بِٱلْوَادِ ٱلْمُقَدَّسِ طُوًۭى',
		number_in_surah: '12',
		page: '312',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2361',
		number: '2361',
		text: 'وَأَنَا ٱخْتَرْتُكَ فَٱسْتَمِعْ لِمَا يُوحَىٰٓ',
		number_in_surah: '13',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2362',
		number: '2362',
		text: 'إِنَّنِىٓ أَنَا ٱللَّهُ لَآ إِلَٰهَ إِلَّآ أَنَا۠ فَٱعْبُدْنِى وَأَقِمِ ٱلصَّلَوٰةَ لِذِكْرِىٓ',
		number_in_surah: '14',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2363',
		number: '2363',
		text: 'إِنَّ ٱلسَّاعَةَ ءَاتِيَةٌ أَكَادُ أُخْفِيهَا لِتُجْزَىٰ كُلُّ نَفْسٍۭ بِمَا تَسْعَىٰ',
		number_in_surah: '15',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2364',
		number: '2364',
		text: 'فَلَا يَصُدَّنَّكَ عَنْهَا مَن لَّا يُؤْمِنُ بِهَا وَٱتَّبَعَ هَوَىٰهُ فَتَرْدَىٰ',
		number_in_surah: '16',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2365',
		number: '2365',
		text: 'وَمَا تِلْكَ بِيَمِينِكَ يَٰمُوسَىٰ',
		number_in_surah: '17',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2366',
		number: '2366',
		text: 'قَالَ هِىَ عَصَاىَ أَتَوَكَّؤُا۟ عَلَيْهَا وَأَهُشُّ بِهَا عَلَىٰ غَنَمِى وَلِىَ فِيهَا مَـَٔارِبُ أُخْرَىٰ',
		number_in_surah: '18',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2367',
		number: '2367',
		text: 'قَالَ أَلْقِهَا يَٰمُوسَىٰ',
		number_in_surah: '19',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2368',
		number: '2368',
		text: 'فَأَلْقَىٰهَا فَإِذَا هِىَ حَيَّةٌۭ تَسْعَىٰ',
		number_in_surah: '20',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2369',
		number: '2369',
		text: 'قَالَ خُذْهَا وَلَا تَخَفْ ۖ سَنُعِيدُهَا سِيرَتَهَا ٱلْأُولَىٰ',
		number_in_surah: '21',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2370',
		number: '2370',
		text: 'وَٱضْمُمْ يَدَكَ إِلَىٰ جَنَاحِكَ تَخْرُجْ بَيْضَآءَ مِنْ غَيْرِ سُوٓءٍ ءَايَةً أُخْرَىٰ',
		number_in_surah: '22',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2371',
		number: '2371',
		text: 'لِنُرِيَكَ مِنْ ءَايَٰتِنَا ٱلْكُبْرَى',
		number_in_surah: '23',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2372',
		number: '2372',
		text: 'ٱذْهَبْ إِلَىٰ فِرْعَوْنَ إِنَّهُۥ طَغَىٰ',
		number_in_surah: '24',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2373',
		number: '2373',
		text: 'قَالَ رَبِّ ٱشْرَحْ لِى صَدْرِى',
		number_in_surah: '25',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2374',
		number: '2374',
		text: 'وَيَسِّرْ لِىٓ أَمْرِى',
		number_in_surah: '26',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2375',
		number: '2375',
		text: 'وَٱحْلُلْ عُقْدَةًۭ مِّن لِّسَانِى',
		number_in_surah: '27',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2376',
		number: '2376',
		text: 'يَفْقَهُوا۟ قَوْلِى',
		number_in_surah: '28',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2377',
		number: '2377',
		text: 'وَٱجْعَل لِّى وَزِيرًۭا مِّنْ أَهْلِى',
		number_in_surah: '29',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2378',
		number: '2378',
		text: 'هَٰرُونَ أَخِى',
		number_in_surah: '30',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2379',
		number: '2379',
		text: 'ٱشْدُدْ بِهِۦٓ أَزْرِى',
		number_in_surah: '31',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2380',
		number: '2380',
		text: 'وَأَشْرِكْهُ فِىٓ أَمْرِى',
		number_in_surah: '32',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2381',
		number: '2381',
		text: 'كَىْ نُسَبِّحَكَ كَثِيرًۭا',
		number_in_surah: '33',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2382',
		number: '2382',
		text: 'وَنَذْكُرَكَ كَثِيرًا',
		number_in_surah: '34',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2383',
		number: '2383',
		text: 'إِنَّكَ كُنتَ بِنَا بَصِيرًۭا',
		number_in_surah: '35',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2384',
		number: '2384',
		text: 'قَالَ قَدْ أُوتِيتَ سُؤْلَكَ يَٰمُوسَىٰ',
		number_in_surah: '36',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2385',
		number: '2385',
		text: 'وَلَقَدْ مَنَنَّا عَلَيْكَ مَرَّةً أُخْرَىٰٓ',
		number_in_surah: '37',
		page: '313',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2386',
		number: '2386',
		text: 'إِذْ أَوْحَيْنَآ إِلَىٰٓ أُمِّكَ مَا يُوحَىٰٓ',
		number_in_surah: '38',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2387',
		number: '2387',
		text: 'أَنِ ٱقْذِفِيهِ فِى ٱلتَّابُوتِ فَٱقْذِفِيهِ فِى ٱلْيَمِّ فَلْيُلْقِهِ ٱلْيَمُّ بِٱلسَّاحِلِ يَأْخُذْهُ عَدُوٌّۭ لِّى وَعَدُوٌّۭ لَّهُۥ ۚ وَأَلْقَيْتُ عَلَيْكَ مَحَبَّةًۭ مِّنِّى وَلِتُصْنَعَ عَلَىٰ عَيْنِىٓ',
		number_in_surah: '39',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2388',
		number: '2388',
		text: 'إِذْ تَمْشِىٓ أُخْتُكَ فَتَقُولُ هَلْ أَدُلُّكُمْ عَلَىٰ مَن يَكْفُلُهُۥ ۖ فَرَجَعْنَٰكَ إِلَىٰٓ أُمِّكَ كَىْ تَقَرَّ عَيْنُهَا وَلَا تَحْزَنَ ۚ وَقَتَلْتَ نَفْسًۭا فَنَجَّيْنَٰكَ مِنَ ٱلْغَمِّ وَفَتَنَّٰكَ فُتُونًۭا ۚ فَلَبِثْتَ سِنِينَ فِىٓ أَهْلِ مَدْيَنَ ثُمَّ جِئْتَ عَلَىٰ قَدَرٍۢ يَٰمُوسَىٰ',
		number_in_surah: '40',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2389',
		number: '2389',
		text: 'وَٱصْطَنَعْتُكَ لِنَفْسِى',
		number_in_surah: '41',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2390',
		number: '2390',
		text: 'ٱذْهَبْ أَنتَ وَأَخُوكَ بِـَٔايَٰتِى وَلَا تَنِيَا فِى ذِكْرِى',
		number_in_surah: '42',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2391',
		number: '2391',
		text: 'ٱذْهَبَآ إِلَىٰ فِرْعَوْنَ إِنَّهُۥ طَغَىٰ',
		number_in_surah: '43',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2392',
		number: '2392',
		text: 'فَقُولَا لَهُۥ قَوْلًۭا لَّيِّنًۭا لَّعَلَّهُۥ يَتَذَكَّرُ أَوْ يَخْشَىٰ',
		number_in_surah: '44',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2393',
		number: '2393',
		text: 'قَالَا رَبَّنَآ إِنَّنَا نَخَافُ أَن يَفْرُطَ عَلَيْنَآ أَوْ أَن يَطْغَىٰ',
		number_in_surah: '45',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2394',
		number: '2394',
		text: 'قَالَ لَا تَخَافَآ ۖ إِنَّنِى مَعَكُمَآ أَسْمَعُ وَأَرَىٰ',
		number_in_surah: '46',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2395',
		number: '2395',
		text: 'فَأْتِيَاهُ فَقُولَآ إِنَّا رَسُولَا رَبِّكَ فَأَرْسِلْ مَعَنَا بَنِىٓ إِسْرَٰٓءِيلَ وَلَا تُعَذِّبْهُمْ ۖ قَدْ جِئْنَٰكَ بِـَٔايَةٍۢ مِّن رَّبِّكَ ۖ وَٱلسَّلَٰمُ عَلَىٰ مَنِ ٱتَّبَعَ ٱلْهُدَىٰٓ',
		number_in_surah: '47',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2396',
		number: '2396',
		text: 'إِنَّا قَدْ أُوحِىَ إِلَيْنَآ أَنَّ ٱلْعَذَابَ عَلَىٰ مَن كَذَّبَ وَتَوَلَّىٰ',
		number_in_surah: '48',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2397',
		number: '2397',
		text: 'قَالَ فَمَن رَّبُّكُمَا يَٰمُوسَىٰ',
		number_in_surah: '49',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2398',
		number: '2398',
		text: 'قَالَ رَبُّنَا ٱلَّذِىٓ أَعْطَىٰ كُلَّ شَىْءٍ خَلْقَهُۥ ثُمَّ هَدَىٰ',
		number_in_surah: '50',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2399',
		number: '2399',
		text: 'قَالَ فَمَا بَالُ ٱلْقُرُونِ ٱلْأُولَىٰ',
		number_in_surah: '51',
		page: '314',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2400',
		number: '2400',
		text: 'قَالَ عِلْمُهَا عِندَ رَبِّى فِى كِتَٰبٍۢ ۖ لَّا يَضِلُّ رَبِّى وَلَا يَنسَى',
		number_in_surah: '52',
		page: '315',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2401',
		number: '2401',
		text: 'ٱلَّذِى جَعَلَ لَكُمُ ٱلْأَرْضَ مَهْدًۭا وَسَلَكَ لَكُمْ فِيهَا سُبُلًۭا وَأَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَخْرَجْنَا بِهِۦٓ أَزْوَٰجًۭا مِّن نَّبَاتٍۢ شَتَّىٰ',
		number_in_surah: '53',
		page: '315',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2402',
		number: '2402',
		text: 'كُلُوا۟ وَٱرْعَوْا۟ أَنْعَٰمَكُمْ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّأُو۟لِى ٱلنُّهَىٰ',
		number_in_surah: '54',
		page: '315',
		surah_id: '20',
		hizb_id: '125',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2403',
		number: '2403',
		text: '۞ مِنْهَا خَلَقْنَٰكُمْ وَفِيهَا نُعِيدُكُمْ وَمِنْهَا نُخْرِجُكُمْ تَارَةً أُخْرَىٰ',
		number_in_surah: '55',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2404',
		number: '2404',
		text: 'وَلَقَدْ أَرَيْنَٰهُ ءَايَٰتِنَا كُلَّهَا فَكَذَّبَ وَأَبَىٰ',
		number_in_surah: '56',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2405',
		number: '2405',
		text: 'قَالَ أَجِئْتَنَا لِتُخْرِجَنَا مِنْ أَرْضِنَا بِسِحْرِكَ يَٰمُوسَىٰ',
		number_in_surah: '57',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2406',
		number: '2406',
		text: 'فَلَنَأْتِيَنَّكَ بِسِحْرٍۢ مِّثْلِهِۦ فَٱجْعَلْ بَيْنَنَا وَبَيْنَكَ مَوْعِدًۭا لَّا نُخْلِفُهُۥ نَحْنُ وَلَآ أَنتَ مَكَانًۭا سُوًۭى',
		number_in_surah: '58',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2407',
		number: '2407',
		text: 'قَالَ مَوْعِدُكُمْ يَوْمُ ٱلزِّينَةِ وَأَن يُحْشَرَ ٱلنَّاسُ ضُحًۭى',
		number_in_surah: '59',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2408',
		number: '2408',
		text: 'فَتَوَلَّىٰ فِرْعَوْنُ فَجَمَعَ كَيْدَهُۥ ثُمَّ أَتَىٰ',
		number_in_surah: '60',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2409',
		number: '2409',
		text: 'قَالَ لَهُم مُّوسَىٰ وَيْلَكُمْ لَا تَفْتَرُوا۟ عَلَى ٱللَّهِ كَذِبًۭا فَيُسْحِتَكُم بِعَذَابٍۢ ۖ وَقَدْ خَابَ مَنِ ٱفْتَرَىٰ',
		number_in_surah: '61',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2410',
		number: '2410',
		text: 'فَتَنَٰزَعُوٓا۟ أَمْرَهُم بَيْنَهُمْ وَأَسَرُّوا۟ ٱلنَّجْوَىٰ',
		number_in_surah: '62',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2411',
		number: '2411',
		text: 'قَالُوٓا۟ إِنْ هَٰذَٰنِ لَسَٰحِرَٰنِ يُرِيدَانِ أَن يُخْرِجَاكُم مِّنْ أَرْضِكُم بِسِحْرِهِمَا وَيَذْهَبَا بِطَرِيقَتِكُمُ ٱلْمُثْلَىٰ',
		number_in_surah: '63',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2412',
		number: '2412',
		text: 'فَأَجْمِعُوا۟ كَيْدَكُمْ ثُمَّ ٱئْتُوا۟ صَفًّۭا ۚ وَقَدْ أَفْلَحَ ٱلْيَوْمَ مَنِ ٱسْتَعْلَىٰ',
		number_in_surah: '64',
		page: '315',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2413',
		number: '2413',
		text: 'قَالُوا۟ يَٰمُوسَىٰٓ إِمَّآ أَن تُلْقِىَ وَإِمَّآ أَن نَّكُونَ أَوَّلَ مَنْ أَلْقَىٰ',
		number_in_surah: '65',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2414',
		number: '2414',
		text: 'قَالَ بَلْ أَلْقُوا۟ ۖ فَإِذَا حِبَالُهُمْ وَعِصِيُّهُمْ يُخَيَّلُ إِلَيْهِ مِن سِحْرِهِمْ أَنَّهَا تَسْعَىٰ',
		number_in_surah: '66',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2415',
		number: '2415',
		text: 'فَأَوْجَسَ فِى نَفْسِهِۦ خِيفَةًۭ مُّوسَىٰ',
		number_in_surah: '67',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2416',
		number: '2416',
		text: 'قُلْنَا لَا تَخَفْ إِنَّكَ أَنتَ ٱلْأَعْلَىٰ',
		number_in_surah: '68',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2417',
		number: '2417',
		text: 'وَأَلْقِ مَا فِى يَمِينِكَ تَلْقَفْ مَا صَنَعُوٓا۟ ۖ إِنَّمَا صَنَعُوا۟ كَيْدُ سَٰحِرٍۢ ۖ وَلَا يُفْلِحُ ٱلسَّاحِرُ حَيْثُ أَتَىٰ',
		number_in_surah: '69',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2418',
		number: '2418',
		text: 'فَأُلْقِىَ ٱلسَّحَرَةُ سُجَّدًۭا قَالُوٓا۟ ءَامَنَّا بِرَبِّ هَٰرُونَ وَمُوسَىٰ',
		number_in_surah: '70',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2419',
		number: '2419',
		text: 'قَالَ ءَامَنتُمْ لَهُۥ قَبْلَ أَنْ ءَاذَنَ لَكُمْ ۖ إِنَّهُۥ لَكَبِيرُكُمُ ٱلَّذِى عَلَّمَكُمُ ٱلسِّحْرَ ۖ فَلَأُقَطِّعَنَّ أَيْدِيَكُمْ وَأَرْجُلَكُم مِّنْ خِلَٰفٍۢ وَلَأُصَلِّبَنَّكُمْ فِى جُذُوعِ ٱلنَّخْلِ وَلَتَعْلَمُنَّ أَيُّنَآ أَشَدُّ عَذَابًۭا وَأَبْقَىٰ',
		number_in_surah: '71',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2420',
		number: '2420',
		text: 'قَالُوا۟ لَن نُّؤْثِرَكَ عَلَىٰ مَا جَآءَنَا مِنَ ٱلْبَيِّنَٰتِ وَٱلَّذِى فَطَرَنَا ۖ فَٱقْضِ مَآ أَنتَ قَاضٍ ۖ إِنَّمَا تَقْضِى هَٰذِهِ ٱلْحَيَوٰةَ ٱلدُّنْيَآ',
		number_in_surah: '72',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2421',
		number: '2421',
		text: 'إِنَّآ ءَامَنَّا بِرَبِّنَا لِيَغْفِرَ لَنَا خَطَٰيَٰنَا وَمَآ أَكْرَهْتَنَا عَلَيْهِ مِنَ ٱلسِّحْرِ ۗ وَٱللَّهُ خَيْرٌۭ وَأَبْقَىٰٓ',
		number_in_surah: '73',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2422',
		number: '2422',
		text: 'إِنَّهُۥ مَن يَأْتِ رَبَّهُۥ مُجْرِمًۭا فَإِنَّ لَهُۥ جَهَنَّمَ لَا يَمُوتُ فِيهَا وَلَا يَحْيَىٰ',
		number_in_surah: '74',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2423',
		number: '2423',
		text: 'وَمَن يَأْتِهِۦ مُؤْمِنًۭا قَدْ عَمِلَ ٱلصَّٰلِحَٰتِ فَأُو۟لَٰٓئِكَ لَهُمُ ٱلدَّرَجَٰتُ ٱلْعُلَىٰ',
		number_in_surah: '75',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2424',
		number: '2424',
		text: 'جَنَّٰتُ عَدْنٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا ۚ وَذَٰلِكَ جَزَآءُ مَن تَزَكَّىٰ',
		number_in_surah: '76',
		page: '316',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2425',
		number: '2425',
		text: 'وَلَقَدْ أَوْحَيْنَآ إِلَىٰ مُوسَىٰٓ أَنْ أَسْرِ بِعِبَادِى فَٱضْرِبْ لَهُمْ طَرِيقًۭا فِى ٱلْبَحْرِ يَبَسًۭا لَّا تَخَٰفُ دَرَكًۭا وَلَا تَخْشَىٰ',
		number_in_surah: '77',
		page: '317',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2426',
		number: '2426',
		text: 'فَأَتْبَعَهُمْ فِرْعَوْنُ بِجُنُودِهِۦ فَغَشِيَهُم مِّنَ ٱلْيَمِّ مَا غَشِيَهُمْ',
		number_in_surah: '78',
		page: '317',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2427',
		number: '2427',
		text: 'وَأَضَلَّ فِرْعَوْنُ قَوْمَهُۥ وَمَا هَدَىٰ',
		number_in_surah: '79',
		page: '317',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2428',
		number: '2428',
		text: 'يَٰبَنِىٓ إِسْرَٰٓءِيلَ قَدْ أَنجَيْنَٰكُم مِّنْ عَدُوِّكُمْ وَوَٰعَدْنَٰكُمْ جَانِبَ ٱلطُّورِ ٱلْأَيْمَنَ وَنَزَّلْنَا عَلَيْكُمُ ٱلْمَنَّ وَٱلسَّلْوَىٰ',
		number_in_surah: '80',
		page: '317',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2429',
		number: '2429',
		text: 'كُلُوا۟ مِن طَيِّبَٰتِ مَا رَزَقْنَٰكُمْ وَلَا تَطْغَوْا۟ فِيهِ فَيَحِلَّ عَلَيْكُمْ غَضَبِى ۖ وَمَن يَحْلِلْ عَلَيْهِ غَضَبِى فَقَدْ هَوَىٰ',
		number_in_surah: '81',
		page: '317',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2430',
		number: '2430',
		text: 'وَإِنِّى لَغَفَّارٌۭ لِّمَن تَابَ وَءَامَنَ وَعَمِلَ صَٰلِحًۭا ثُمَّ ٱهْتَدَىٰ',
		number_in_surah: '82',
		page: '317',
		surah_id: '20',
		hizb_id: '126',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2431',
		number: '2431',
		text: '۞ وَمَآ أَعْجَلَكَ عَن قَوْمِكَ يَٰمُوسَىٰ',
		number_in_surah: '83',
		page: '317',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2432',
		number: '2432',
		text: 'قَالَ هُمْ أُو۟لَآءِ عَلَىٰٓ أَثَرِى وَعَجِلْتُ إِلَيْكَ رَبِّ لِتَرْضَىٰ',
		number_in_surah: '84',
		page: '317',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2433',
		number: '2433',
		text: 'قَالَ فَإِنَّا قَدْ فَتَنَّا قَوْمَكَ مِنۢ بَعْدِكَ وَأَضَلَّهُمُ ٱلسَّامِرِىُّ',
		number_in_surah: '85',
		page: '317',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2434',
		number: '2434',
		text: 'فَرَجَعَ مُوسَىٰٓ إِلَىٰ قَوْمِهِۦ غَضْبَٰنَ أَسِفًۭا ۚ قَالَ يَٰقَوْمِ أَلَمْ يَعِدْكُمْ رَبُّكُمْ وَعْدًا حَسَنًا ۚ أَفَطَالَ عَلَيْكُمُ ٱلْعَهْدُ أَمْ أَرَدتُّمْ أَن يَحِلَّ عَلَيْكُمْ غَضَبٌۭ مِّن رَّبِّكُمْ فَأَخْلَفْتُم مَّوْعِدِى',
		number_in_surah: '86',
		page: '317',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2435',
		number: '2435',
		text: 'قَالُوا۟ مَآ أَخْلَفْنَا مَوْعِدَكَ بِمَلْكِنَا وَلَٰكِنَّا حُمِّلْنَآ أَوْزَارًۭا مِّن زِينَةِ ٱلْقَوْمِ فَقَذَفْنَٰهَا فَكَذَٰلِكَ أَلْقَى ٱلسَّامِرِىُّ',
		number_in_surah: '87',
		page: '317',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2436',
		number: '2436',
		text: 'فَأَخْرَجَ لَهُمْ عِجْلًۭا جَسَدًۭا لَّهُۥ خُوَارٌۭ فَقَالُوا۟ هَٰذَآ إِلَٰهُكُمْ وَإِلَٰهُ مُوسَىٰ فَنَسِىَ',
		number_in_surah: '88',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2437',
		number: '2437',
		text: 'أَفَلَا يَرَوْنَ أَلَّا يَرْجِعُ إِلَيْهِمْ قَوْلًۭا وَلَا يَمْلِكُ لَهُمْ ضَرًّۭا وَلَا نَفْعًۭا',
		number_in_surah: '89',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2438',
		number: '2438',
		text: 'وَلَقَدْ قَالَ لَهُمْ هَٰرُونُ مِن قَبْلُ يَٰقَوْمِ إِنَّمَا فُتِنتُم بِهِۦ ۖ وَإِنَّ رَبَّكُمُ ٱلرَّحْمَٰنُ فَٱتَّبِعُونِى وَأَطِيعُوٓا۟ أَمْرِى',
		number_in_surah: '90',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2439',
		number: '2439',
		text: 'قَالُوا۟ لَن نَّبْرَحَ عَلَيْهِ عَٰكِفِينَ حَتَّىٰ يَرْجِعَ إِلَيْنَا مُوسَىٰ',
		number_in_surah: '91',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2440',
		number: '2440',
		text: 'قَالَ يَٰهَٰرُونُ مَا مَنَعَكَ إِذْ رَأَيْتَهُمْ ضَلُّوٓا۟',
		number_in_surah: '92',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2441',
		number: '2441',
		text: 'أَلَّا تَتَّبِعَنِ ۖ أَفَعَصَيْتَ أَمْرِى',
		number_in_surah: '93',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2442',
		number: '2442',
		text: 'قَالَ يَبْنَؤُمَّ لَا تَأْخُذْ بِلِحْيَتِى وَلَا بِرَأْسِىٓ ۖ إِنِّى خَشِيتُ أَن تَقُولَ فَرَّقْتَ بَيْنَ بَنِىٓ إِسْرَٰٓءِيلَ وَلَمْ تَرْقُبْ قَوْلِى',
		number_in_surah: '94',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2443',
		number: '2443',
		text: 'قَالَ فَمَا خَطْبُكَ يَٰسَٰمِرِىُّ',
		number_in_surah: '95',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2444',
		number: '2444',
		text: 'قَالَ بَصُرْتُ بِمَا لَمْ يَبْصُرُوا۟ بِهِۦ فَقَبَضْتُ قَبْضَةًۭ مِّنْ أَثَرِ ٱلرَّسُولِ فَنَبَذْتُهَا وَكَذَٰلِكَ سَوَّلَتْ لِى نَفْسِى',
		number_in_surah: '96',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2445',
		number: '2445',
		text: 'قَالَ فَٱذْهَبْ فَإِنَّ لَكَ فِى ٱلْحَيَوٰةِ أَن تَقُولَ لَا مِسَاسَ ۖ وَإِنَّ لَكَ مَوْعِدًۭا لَّن تُخْلَفَهُۥ ۖ وَٱنظُرْ إِلَىٰٓ إِلَٰهِكَ ٱلَّذِى ظَلْتَ عَلَيْهِ عَاكِفًۭا ۖ لَّنُحَرِّقَنَّهُۥ ثُمَّ لَنَنسِفَنَّهُۥ فِى ٱلْيَمِّ نَسْفًا',
		number_in_surah: '97',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2446',
		number: '2446',
		text: 'إِنَّمَآ إِلَٰهُكُمُ ٱللَّهُ ٱلَّذِى لَآ إِلَٰهَ إِلَّا هُوَ ۚ وَسِعَ كُلَّ شَىْءٍ عِلْمًۭا',
		number_in_surah: '98',
		page: '318',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2447',
		number: '2447',
		text: 'كَذَٰلِكَ نَقُصُّ عَلَيْكَ مِنْ أَنۢبَآءِ مَا قَدْ سَبَقَ ۚ وَقَدْ ءَاتَيْنَٰكَ مِن لَّدُنَّا ذِكْرًۭا',
		number_in_surah: '99',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2448',
		number: '2448',
		text: 'مَّنْ أَعْرَضَ عَنْهُ فَإِنَّهُۥ يَحْمِلُ يَوْمَ ٱلْقِيَٰمَةِ وِزْرًا',
		number_in_surah: '100',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2449',
		number: '2449',
		text: 'خَٰلِدِينَ فِيهِ ۖ وَسَآءَ لَهُمْ يَوْمَ ٱلْقِيَٰمَةِ حِمْلًۭا',
		number_in_surah: '101',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2450',
		number: '2450',
		text: 'يَوْمَ يُنفَخُ فِى ٱلصُّورِ ۚ وَنَحْشُرُ ٱلْمُجْرِمِينَ يَوْمَئِذٍۢ زُرْقًۭا',
		number_in_surah: '102',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2451',
		number: '2451',
		text: 'يَتَخَٰفَتُونَ بَيْنَهُمْ إِن لَّبِثْتُمْ إِلَّا عَشْرًۭا',
		number_in_surah: '103',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2452',
		number: '2452',
		text: 'نَّحْنُ أَعْلَمُ بِمَا يَقُولُونَ إِذْ يَقُولُ أَمْثَلُهُمْ طَرِيقَةً إِن لَّبِثْتُمْ إِلَّا يَوْمًۭا',
		number_in_surah: '104',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2453',
		number: '2453',
		text: 'وَيَسْـَٔلُونَكَ عَنِ ٱلْجِبَالِ فَقُلْ يَنسِفُهَا رَبِّى نَسْفًۭا',
		number_in_surah: '105',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2454',
		number: '2454',
		text: 'فَيَذَرُهَا قَاعًۭا صَفْصَفًۭا',
		number_in_surah: '106',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2455',
		number: '2455',
		text: 'لَّا تَرَىٰ فِيهَا عِوَجًۭا وَلَآ أَمْتًۭا',
		number_in_surah: '107',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2456',
		number: '2456',
		text: 'يَوْمَئِذٍۢ يَتَّبِعُونَ ٱلدَّاعِىَ لَا عِوَجَ لَهُۥ ۖ وَخَشَعَتِ ٱلْأَصْوَاتُ لِلرَّحْمَٰنِ فَلَا تَسْمَعُ إِلَّا هَمْسًۭا',
		number_in_surah: '108',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2457',
		number: '2457',
		text: 'يَوْمَئِذٍۢ لَّا تَنفَعُ ٱلشَّفَٰعَةُ إِلَّا مَنْ أَذِنَ لَهُ ٱلرَّحْمَٰنُ وَرَضِىَ لَهُۥ قَوْلًۭا',
		number_in_surah: '109',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2458',
		number: '2458',
		text: 'يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلَا يُحِيطُونَ بِهِۦ عِلْمًۭا',
		number_in_surah: '110',
		page: '319',
		surah_id: '20',
		hizb_id: '127',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2459',
		number: '2459',
		text: '۞ وَعَنَتِ ٱلْوُجُوهُ لِلْحَىِّ ٱلْقَيُّومِ ۖ وَقَدْ خَابَ مَنْ حَمَلَ ظُلْمًۭا',
		number_in_surah: '111',
		page: '319',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2460',
		number: '2460',
		text: 'وَمَن يَعْمَلْ مِنَ ٱلصَّٰلِحَٰتِ وَهُوَ مُؤْمِنٌۭ فَلَا يَخَافُ ظُلْمًۭا وَلَا هَضْمًۭا',
		number_in_surah: '112',
		page: '319',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2461',
		number: '2461',
		text: 'وَكَذَٰلِكَ أَنزَلْنَٰهُ قُرْءَانًا عَرَبِيًّۭا وَصَرَّفْنَا فِيهِ مِنَ ٱلْوَعِيدِ لَعَلَّهُمْ يَتَّقُونَ أَوْ يُحْدِثُ لَهُمْ ذِكْرًۭا',
		number_in_surah: '113',
		page: '319',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2462',
		number: '2462',
		text: 'فَتَعَٰلَى ٱللَّهُ ٱلْمَلِكُ ٱلْحَقُّ ۗ وَلَا تَعْجَلْ بِٱلْقُرْءَانِ مِن قَبْلِ أَن يُقْضَىٰٓ إِلَيْكَ وَحْيُهُۥ ۖ وَقُل رَّبِّ زِدْنِى عِلْمًۭا',
		number_in_surah: '114',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2463',
		number: '2463',
		text: 'وَلَقَدْ عَهِدْنَآ إِلَىٰٓ ءَادَمَ مِن قَبْلُ فَنَسِىَ وَلَمْ نَجِدْ لَهُۥ عَزْمًۭا',
		number_in_surah: '115',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2464',
		number: '2464',
		text: 'وَإِذْ قُلْنَا لِلْمَلَٰٓئِكَةِ ٱسْجُدُوا۟ لِءَادَمَ فَسَجَدُوٓا۟ إِلَّآ إِبْلِيسَ أَبَىٰ',
		number_in_surah: '116',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2465',
		number: '2465',
		text: 'فَقُلْنَا يَٰٓـَٔادَمُ إِنَّ هَٰذَا عَدُوٌّۭ لَّكَ وَلِزَوْجِكَ فَلَا يُخْرِجَنَّكُمَا مِنَ ٱلْجَنَّةِ فَتَشْقَىٰٓ',
		number_in_surah: '117',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2466',
		number: '2466',
		text: 'إِنَّ لَكَ أَلَّا تَجُوعَ فِيهَا وَلَا تَعْرَىٰ',
		number_in_surah: '118',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:01',
		updated_at: '2018-06-07 08:07:01',
	},
	{
		id: '2467',
		number: '2467',
		text: 'وَأَنَّكَ لَا تَظْمَؤُا۟ فِيهَا وَلَا تَضْحَىٰ',
		number_in_surah: '119',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2468',
		number: '2468',
		text: 'فَوَسْوَسَ إِلَيْهِ ٱلشَّيْطَٰنُ قَالَ يَٰٓـَٔادَمُ هَلْ أَدُلُّكَ عَلَىٰ شَجَرَةِ ٱلْخُلْدِ وَمُلْكٍۢ لَّا يَبْلَىٰ',
		number_in_surah: '120',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2469',
		number: '2469',
		text: 'فَأَكَلَا مِنْهَا فَبَدَتْ لَهُمَا سَوْءَٰتُهُمَا وَطَفِقَا يَخْصِفَانِ عَلَيْهِمَا مِن وَرَقِ ٱلْجَنَّةِ ۚ وَعَصَىٰٓ ءَادَمُ رَبَّهُۥ فَغَوَىٰ',
		number_in_surah: '121',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2470',
		number: '2470',
		text: 'ثُمَّ ٱجْتَبَٰهُ رَبُّهُۥ فَتَابَ عَلَيْهِ وَهَدَىٰ',
		number_in_surah: '122',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2471',
		number: '2471',
		text: 'قَالَ ٱهْبِطَا مِنْهَا جَمِيعًۢا ۖ بَعْضُكُمْ لِبَعْضٍ عَدُوٌّۭ ۖ فَإِمَّا يَأْتِيَنَّكُم مِّنِّى هُدًۭى فَمَنِ ٱتَّبَعَ هُدَاىَ فَلَا يَضِلُّ وَلَا يَشْقَىٰ',
		number_in_surah: '123',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2472',
		number: '2472',
		text: 'وَمَنْ أَعْرَضَ عَن ذِكْرِى فَإِنَّ لَهُۥ مَعِيشَةًۭ ضَنكًۭا وَنَحْشُرُهُۥ يَوْمَ ٱلْقِيَٰمَةِ أَعْمَىٰ',
		number_in_surah: '124',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2473',
		number: '2473',
		text: 'قَالَ رَبِّ لِمَ حَشَرْتَنِىٓ أَعْمَىٰ وَقَدْ كُنتُ بَصِيرًۭا',
		number_in_surah: '125',
		page: '320',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2474',
		number: '2474',
		text: 'قَالَ كَذَٰلِكَ أَتَتْكَ ءَايَٰتُنَا فَنَسِيتَهَا ۖ وَكَذَٰلِكَ ٱلْيَوْمَ تُنسَىٰ',
		number_in_surah: '126',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2475',
		number: '2475',
		text: 'وَكَذَٰلِكَ نَجْزِى مَنْ أَسْرَفَ وَلَمْ يُؤْمِنۢ بِـَٔايَٰتِ رَبِّهِۦ ۚ وَلَعَذَابُ ٱلْءَاخِرَةِ أَشَدُّ وَأَبْقَىٰٓ',
		number_in_surah: '127',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2476',
		number: '2476',
		text: 'أَفَلَمْ يَهْدِ لَهُمْ كَمْ أَهْلَكْنَا قَبْلَهُم مِّنَ ٱلْقُرُونِ يَمْشُونَ فِى مَسَٰكِنِهِمْ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّأُو۟لِى ٱلنُّهَىٰ',
		number_in_surah: '128',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2477',
		number: '2477',
		text: 'وَلَوْلَا كَلِمَةٌۭ سَبَقَتْ مِن رَّبِّكَ لَكَانَ لِزَامًۭا وَأَجَلٌۭ مُّسَمًّۭى',
		number_in_surah: '129',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2478',
		number: '2478',
		text: 'فَٱصْبِرْ عَلَىٰ مَا يَقُولُونَ وَسَبِّحْ بِحَمْدِ رَبِّكَ قَبْلَ طُلُوعِ ٱلشَّمْسِ وَقَبْلَ غُرُوبِهَا ۖ وَمِنْ ءَانَآئِ ٱلَّيْلِ فَسَبِّحْ وَأَطْرَافَ ٱلنَّهَارِ لَعَلَّكَ تَرْضَىٰ',
		number_in_surah: '130',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2479',
		number: '2479',
		text: 'وَلَا تَمُدَّنَّ عَيْنَيْكَ إِلَىٰ مَا مَتَّعْنَا بِهِۦٓ أَزْوَٰجًۭا مِّنْهُمْ زَهْرَةَ ٱلْحَيَوٰةِ ٱلدُّنْيَا لِنَفْتِنَهُمْ فِيهِ ۚ وَرِزْقُ رَبِّكَ خَيْرٌۭ وَأَبْقَىٰ',
		number_in_surah: '131',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2480',
		number: '2480',
		text: 'وَأْمُرْ أَهْلَكَ بِٱلصَّلَوٰةِ وَٱصْطَبِرْ عَلَيْهَا ۖ لَا نَسْـَٔلُكَ رِزْقًۭا ۖ نَّحْنُ نَرْزُقُكَ ۗ وَٱلْعَٰقِبَةُ لِلتَّقْوَىٰ',
		number_in_surah: '132',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2481',
		number: '2481',
		text: 'وَقَالُوا۟ لَوْلَا يَأْتِينَا بِـَٔايَةٍۢ مِّن رَّبِّهِۦٓ ۚ أَوَلَمْ تَأْتِهِم بَيِّنَةُ مَا فِى ٱلصُّحُفِ ٱلْأُولَىٰ',
		number_in_surah: '133',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2482',
		number: '2482',
		text: 'وَلَوْ أَنَّآ أَهْلَكْنَٰهُم بِعَذَابٍۢ مِّن قَبْلِهِۦ لَقَالُوا۟ رَبَّنَا لَوْلَآ أَرْسَلْتَ إِلَيْنَا رَسُولًۭا فَنَتَّبِعَ ءَايَٰتِكَ مِن قَبْلِ أَن نَّذِلَّ وَنَخْزَىٰ',
		number_in_surah: '134',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2483',
		number: '2483',
		text: 'قُلْ كُلٌّۭ مُّتَرَبِّصٌۭ فَتَرَبَّصُوا۟ ۖ فَسَتَعْلَمُونَ مَنْ أَصْحَٰبُ ٱلصِّرَٰطِ ٱلسَّوِىِّ وَمَنِ ٱهْتَدَىٰ',
		number_in_surah: '135',
		page: '321',
		surah_id: '20',
		hizb_id: '128',
		juz_id: '16',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2484',
		number: '2484',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱقْتَرَبَ لِلنَّاسِ حِسَابُهُمْ وَهُمْ فِى غَفْلَةٍۢ مُّعْرِضُونَ',
		number_in_surah: '1',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2485',
		number: '2485',
		text: 'مَا يَأْتِيهِم مِّن ذِكْرٍۢ مِّن رَّبِّهِم مُّحْدَثٍ إِلَّا ٱسْتَمَعُوهُ وَهُمْ يَلْعَبُونَ',
		number_in_surah: '2',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2486',
		number: '2486',
		text: 'لَاهِيَةًۭ قُلُوبُهُمْ ۗ وَأَسَرُّوا۟ ٱلنَّجْوَى ٱلَّذِينَ ظَلَمُوا۟ هَلْ هَٰذَآ إِلَّا بَشَرٌۭ مِّثْلُكُمْ ۖ أَفَتَأْتُونَ ٱلسِّحْرَ وَأَنتُمْ تُبْصِرُونَ',
		number_in_surah: '3',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2487',
		number: '2487',
		text: 'قَالَ رَبِّى يَعْلَمُ ٱلْقَوْلَ فِى ٱلسَّمَآءِ وَٱلْأَرْضِ ۖ وَهُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '4',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2488',
		number: '2488',
		text: 'بَلْ قَالُوٓا۟ أَضْغَٰثُ أَحْلَٰمٍۭ بَلِ ٱفْتَرَىٰهُ بَلْ هُوَ شَاعِرٌۭ فَلْيَأْتِنَا بِـَٔايَةٍۢ كَمَآ أُرْسِلَ ٱلْأَوَّلُونَ',
		number_in_surah: '5',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2489',
		number: '2489',
		text: 'مَآ ءَامَنَتْ قَبْلَهُم مِّن قَرْيَةٍ أَهْلَكْنَٰهَآ ۖ أَفَهُمْ يُؤْمِنُونَ',
		number_in_surah: '6',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2490',
		number: '2490',
		text: 'وَمَآ أَرْسَلْنَا قَبْلَكَ إِلَّا رِجَالًۭا نُّوحِىٓ إِلَيْهِمْ ۖ فَسْـَٔلُوٓا۟ أَهْلَ ٱلذِّكْرِ إِن كُنتُمْ لَا تَعْلَمُونَ',
		number_in_surah: '7',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2491',
		number: '2491',
		text: 'وَمَا جَعَلْنَٰهُمْ جَسَدًۭا لَّا يَأْكُلُونَ ٱلطَّعَامَ وَمَا كَانُوا۟ خَٰلِدِينَ',
		number_in_surah: '8',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2492',
		number: '2492',
		text: 'ثُمَّ صَدَقْنَٰهُمُ ٱلْوَعْدَ فَأَنجَيْنَٰهُمْ وَمَن نَّشَآءُ وَأَهْلَكْنَا ٱلْمُسْرِفِينَ',
		number_in_surah: '9',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2493',
		number: '2493',
		text: 'لَقَدْ أَنزَلْنَآ إِلَيْكُمْ كِتَٰبًۭا فِيهِ ذِكْرُكُمْ ۖ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '10',
		page: '322',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2494',
		number: '2494',
		text: 'وَكَمْ قَصَمْنَا مِن قَرْيَةٍۢ كَانَتْ ظَالِمَةًۭ وَأَنشَأْنَا بَعْدَهَا قَوْمًا ءَاخَرِينَ',
		number_in_surah: '11',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2495',
		number: '2495',
		text: 'فَلَمَّآ أَحَسُّوا۟ بَأْسَنَآ إِذَا هُم مِّنْهَا يَرْكُضُونَ',
		number_in_surah: '12',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2496',
		number: '2496',
		text: 'لَا تَرْكُضُوا۟ وَٱرْجِعُوٓا۟ إِلَىٰ مَآ أُتْرِفْتُمْ فِيهِ وَمَسَٰكِنِكُمْ لَعَلَّكُمْ تُسْـَٔلُونَ',
		number_in_surah: '13',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2497',
		number: '2497',
		text: 'قَالُوا۟ يَٰوَيْلَنَآ إِنَّا كُنَّا ظَٰلِمِينَ',
		number_in_surah: '14',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2498',
		number: '2498',
		text: 'فَمَا زَالَت تِّلْكَ دَعْوَىٰهُمْ حَتَّىٰ جَعَلْنَٰهُمْ حَصِيدًا خَٰمِدِينَ',
		number_in_surah: '15',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2499',
		number: '2499',
		text: 'وَمَا خَلَقْنَا ٱلسَّمَآءَ وَٱلْأَرْضَ وَمَا بَيْنَهُمَا لَٰعِبِينَ',
		number_in_surah: '16',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2500',
		number: '2500',
		text: 'لَوْ أَرَدْنَآ أَن نَّتَّخِذَ لَهْوًۭا لَّٱتَّخَذْنَٰهُ مِن لَّدُنَّآ إِن كُنَّا فَٰعِلِينَ',
		number_in_surah: '17',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2501',
		number: '2501',
		text: 'بَلْ نَقْذِفُ بِٱلْحَقِّ عَلَى ٱلْبَٰطِلِ فَيَدْمَغُهُۥ فَإِذَا هُوَ زَاهِقٌۭ ۚ وَلَكُمُ ٱلْوَيْلُ مِمَّا تَصِفُونَ',
		number_in_surah: '18',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2502',
		number: '2502',
		text: 'وَلَهُۥ مَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَمَنْ عِندَهُۥ لَا يَسْتَكْبِرُونَ عَنْ عِبَادَتِهِۦ وَلَا يَسْتَحْسِرُونَ',
		number_in_surah: '19',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2503',
		number: '2503',
		text: 'يُسَبِّحُونَ ٱلَّيْلَ وَٱلنَّهَارَ لَا يَفْتُرُونَ',
		number_in_surah: '20',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2504',
		number: '2504',
		text: 'أَمِ ٱتَّخَذُوٓا۟ ءَالِهَةًۭ مِّنَ ٱلْأَرْضِ هُمْ يُنشِرُونَ',
		number_in_surah: '21',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2505',
		number: '2505',
		text: 'لَوْ كَانَ فِيهِمَآ ءَالِهَةٌ إِلَّا ٱللَّهُ لَفَسَدَتَا ۚ فَسُبْحَٰنَ ٱللَّهِ رَبِّ ٱلْعَرْشِ عَمَّا يَصِفُونَ',
		number_in_surah: '22',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2506',
		number: '2506',
		text: 'لَا يُسْـَٔلُ عَمَّا يَفْعَلُ وَهُمْ يُسْـَٔلُونَ',
		number_in_surah: '23',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2507',
		number: '2507',
		text: 'أَمِ ٱتَّخَذُوا۟ مِن دُونِهِۦٓ ءَالِهَةًۭ ۖ قُلْ هَاتُوا۟ بُرْهَٰنَكُمْ ۖ هَٰذَا ذِكْرُ مَن مَّعِىَ وَذِكْرُ مَن قَبْلِى ۗ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ ٱلْحَقَّ ۖ فَهُم مُّعْرِضُونَ',
		number_in_surah: '24',
		page: '323',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2508',
		number: '2508',
		text: 'وَمَآ أَرْسَلْنَا مِن قَبْلِكَ مِن رَّسُولٍ إِلَّا نُوحِىٓ إِلَيْهِ أَنَّهُۥ لَآ إِلَٰهَ إِلَّآ أَنَا۠ فَٱعْبُدُونِ',
		number_in_surah: '25',
		page: '324',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2509',
		number: '2509',
		text: 'وَقَالُوا۟ ٱتَّخَذَ ٱلرَّحْمَٰنُ وَلَدًۭا ۗ سُبْحَٰنَهُۥ ۚ بَلْ عِبَادٌۭ مُّكْرَمُونَ',
		number_in_surah: '26',
		page: '324',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2510',
		number: '2510',
		text: 'لَا يَسْبِقُونَهُۥ بِٱلْقَوْلِ وَهُم بِأَمْرِهِۦ يَعْمَلُونَ',
		number_in_surah: '27',
		page: '324',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2511',
		number: '2511',
		text: 'يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلَا يَشْفَعُونَ إِلَّا لِمَنِ ٱرْتَضَىٰ وَهُم مِّنْ خَشْيَتِهِۦ مُشْفِقُونَ',
		number_in_surah: '28',
		page: '324',
		surah_id: '21',
		hizb_id: '129',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2512',
		number: '2512',
		text: '۞ وَمَن يَقُلْ مِنْهُمْ إِنِّىٓ إِلَٰهٌۭ مِّن دُونِهِۦ فَذَٰلِكَ نَجْزِيهِ جَهَنَّمَ ۚ كَذَٰلِكَ نَجْزِى ٱلظَّٰلِمِينَ',
		number_in_surah: '29',
		page: '324',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2513',
		number: '2513',
		text: 'أَوَلَمْ يَرَ ٱلَّذِينَ كَفَرُوٓا۟ أَنَّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ كَانَتَا رَتْقًۭا فَفَتَقْنَٰهُمَا ۖ وَجَعَلْنَا مِنَ ٱلْمَآءِ كُلَّ شَىْءٍ حَىٍّ ۖ أَفَلَا يُؤْمِنُونَ',
		number_in_surah: '30',
		page: '324',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2514',
		number: '2514',
		text: 'وَجَعَلْنَا فِى ٱلْأَرْضِ رَوَٰسِىَ أَن تَمِيدَ بِهِمْ وَجَعَلْنَا فِيهَا فِجَاجًۭا سُبُلًۭا لَّعَلَّهُمْ يَهْتَدُونَ',
		number_in_surah: '31',
		page: '324',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2515',
		number: '2515',
		text: 'وَجَعَلْنَا ٱلسَّمَآءَ سَقْفًۭا مَّحْفُوظًۭا ۖ وَهُمْ عَنْ ءَايَٰتِهَا مُعْرِضُونَ',
		number_in_surah: '32',
		page: '324',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2516',
		number: '2516',
		text: 'وَهُوَ ٱلَّذِى خَلَقَ ٱلَّيْلَ وَٱلنَّهَارَ وَٱلشَّمْسَ وَٱلْقَمَرَ ۖ كُلٌّۭ فِى فَلَكٍۢ يَسْبَحُونَ',
		number_in_surah: '33',
		page: '324',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2517',
		number: '2517',
		text: 'وَمَا جَعَلْنَا لِبَشَرٍۢ مِّن قَبْلِكَ ٱلْخُلْدَ ۖ أَفَإِي۟ن مِّتَّ فَهُمُ ٱلْخَٰلِدُونَ',
		number_in_surah: '34',
		page: '324',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2518',
		number: '2518',
		text: 'كُلُّ نَفْسٍۢ ذَآئِقَةُ ٱلْمَوْتِ ۗ وَنَبْلُوكُم بِٱلشَّرِّ وَٱلْخَيْرِ فِتْنَةًۭ ۖ وَإِلَيْنَا تُرْجَعُونَ',
		number_in_surah: '35',
		page: '324',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2519',
		number: '2519',
		text: 'وَإِذَا رَءَاكَ ٱلَّذِينَ كَفَرُوٓا۟ إِن يَتَّخِذُونَكَ إِلَّا هُزُوًا أَهَٰذَا ٱلَّذِى يَذْكُرُ ءَالِهَتَكُمْ وَهُم بِذِكْرِ ٱلرَّحْمَٰنِ هُمْ كَٰفِرُونَ',
		number_in_surah: '36',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2520',
		number: '2520',
		text: 'خُلِقَ ٱلْإِنسَٰنُ مِنْ عَجَلٍۢ ۚ سَأُو۟رِيكُمْ ءَايَٰتِى فَلَا تَسْتَعْجِلُونِ',
		number_in_surah: '37',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2521',
		number: '2521',
		text: 'وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلْوَعْدُ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '38',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2522',
		number: '2522',
		text: 'لَوْ يَعْلَمُ ٱلَّذِينَ كَفَرُوا۟ حِينَ لَا يَكُفُّونَ عَن وُجُوهِهِمُ ٱلنَّارَ وَلَا عَن ظُهُورِهِمْ وَلَا هُمْ يُنصَرُونَ',
		number_in_surah: '39',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2523',
		number: '2523',
		text: 'بَلْ تَأْتِيهِم بَغْتَةًۭ فَتَبْهَتُهُمْ فَلَا يَسْتَطِيعُونَ رَدَّهَا وَلَا هُمْ يُنظَرُونَ',
		number_in_surah: '40',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2524',
		number: '2524',
		text: 'وَلَقَدِ ٱسْتُهْزِئَ بِرُسُلٍۢ مِّن قَبْلِكَ فَحَاقَ بِٱلَّذِينَ سَخِرُوا۟ مِنْهُم مَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '41',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2525',
		number: '2525',
		text: 'قُلْ مَن يَكْلَؤُكُم بِٱلَّيْلِ وَٱلنَّهَارِ مِنَ ٱلرَّحْمَٰنِ ۗ بَلْ هُمْ عَن ذِكْرِ رَبِّهِم مُّعْرِضُونَ',
		number_in_surah: '42',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2526',
		number: '2526',
		text: 'أَمْ لَهُمْ ءَالِهَةٌۭ تَمْنَعُهُم مِّن دُونِنَا ۚ لَا يَسْتَطِيعُونَ نَصْرَ أَنفُسِهِمْ وَلَا هُم مِّنَّا يُصْحَبُونَ',
		number_in_surah: '43',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2527',
		number: '2527',
		text: 'بَلْ مَتَّعْنَا هَٰٓؤُلَآءِ وَءَابَآءَهُمْ حَتَّىٰ طَالَ عَلَيْهِمُ ٱلْعُمُرُ ۗ أَفَلَا يَرَوْنَ أَنَّا نَأْتِى ٱلْأَرْضَ نَنقُصُهَا مِنْ أَطْرَافِهَآ ۚ أَفَهُمُ ٱلْغَٰلِبُونَ',
		number_in_surah: '44',
		page: '325',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2528',
		number: '2528',
		text: 'قُلْ إِنَّمَآ أُنذِرُكُم بِٱلْوَحْىِ ۚ وَلَا يَسْمَعُ ٱلصُّمُّ ٱلدُّعَآءَ إِذَا مَا يُنذَرُونَ',
		number_in_surah: '45',
		page: '326',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2529',
		number: '2529',
		text: 'وَلَئِن مَّسَّتْهُمْ نَفْحَةٌۭ مِّنْ عَذَابِ رَبِّكَ لَيَقُولُنَّ يَٰوَيْلَنَآ إِنَّا كُنَّا ظَٰلِمِينَ',
		number_in_surah: '46',
		page: '326',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2530',
		number: '2530',
		text: 'وَنَضَعُ ٱلْمَوَٰزِينَ ٱلْقِسْطَ لِيَوْمِ ٱلْقِيَٰمَةِ فَلَا تُظْلَمُ نَفْسٌۭ شَيْـًۭٔا ۖ وَإِن كَانَ مِثْقَالَ حَبَّةٍۢ مِّنْ خَرْدَلٍ أَتَيْنَا بِهَا ۗ وَكَفَىٰ بِنَا حَٰسِبِينَ',
		number_in_surah: '47',
		page: '326',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2531',
		number: '2531',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَىٰ وَهَٰرُونَ ٱلْفُرْقَانَ وَضِيَآءًۭ وَذِكْرًۭا لِّلْمُتَّقِينَ',
		number_in_surah: '48',
		page: '326',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2532',
		number: '2532',
		text: 'ٱلَّذِينَ يَخْشَوْنَ رَبَّهُم بِٱلْغَيْبِ وَهُم مِّنَ ٱلسَّاعَةِ مُشْفِقُونَ',
		number_in_surah: '49',
		page: '326',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2533',
		number: '2533',
		text: 'وَهَٰذَا ذِكْرٌۭ مُّبَارَكٌ أَنزَلْنَٰهُ ۚ أَفَأَنتُمْ لَهُۥ مُنكِرُونَ',
		number_in_surah: '50',
		page: '326',
		surah_id: '21',
		hizb_id: '130',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2534',
		number: '2534',
		text: '۞ وَلَقَدْ ءَاتَيْنَآ إِبْرَٰهِيمَ رُشْدَهُۥ مِن قَبْلُ وَكُنَّا بِهِۦ عَٰلِمِينَ',
		number_in_surah: '51',
		page: '326',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2535',
		number: '2535',
		text: 'إِذْ قَالَ لِأَبِيهِ وَقَوْمِهِۦ مَا هَٰذِهِ ٱلتَّمَاثِيلُ ٱلَّتِىٓ أَنتُمْ لَهَا عَٰكِفُونَ',
		number_in_surah: '52',
		page: '326',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2536',
		number: '2536',
		text: 'قَالُوا۟ وَجَدْنَآ ءَابَآءَنَا لَهَا عَٰبِدِينَ',
		number_in_surah: '53',
		page: '326',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2537',
		number: '2537',
		text: 'قَالَ لَقَدْ كُنتُمْ أَنتُمْ وَءَابَآؤُكُمْ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '54',
		page: '326',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2538',
		number: '2538',
		text: 'قَالُوٓا۟ أَجِئْتَنَا بِٱلْحَقِّ أَمْ أَنتَ مِنَ ٱللَّٰعِبِينَ',
		number_in_surah: '55',
		page: '326',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2539',
		number: '2539',
		text: 'قَالَ بَل رَّبُّكُمْ رَبُّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ٱلَّذِى فَطَرَهُنَّ وَأَنَا۠ عَلَىٰ ذَٰلِكُم مِّنَ ٱلشَّٰهِدِينَ',
		number_in_surah: '56',
		page: '326',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2540',
		number: '2540',
		text: 'وَتَٱللَّهِ لَأَكِيدَنَّ أَصْنَٰمَكُم بَعْدَ أَن تُوَلُّوا۟ مُدْبِرِينَ',
		number_in_surah: '57',
		page: '326',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2541',
		number: '2541',
		text: 'فَجَعَلَهُمْ جُذَٰذًا إِلَّا كَبِيرًۭا لَّهُمْ لَعَلَّهُمْ إِلَيْهِ يَرْجِعُونَ',
		number_in_surah: '58',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2542',
		number: '2542',
		text: 'قَالُوا۟ مَن فَعَلَ هَٰذَا بِـَٔالِهَتِنَآ إِنَّهُۥ لَمِنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '59',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2543',
		number: '2543',
		text: 'قَالُوا۟ سَمِعْنَا فَتًۭى يَذْكُرُهُمْ يُقَالُ لَهُۥٓ إِبْرَٰهِيمُ',
		number_in_surah: '60',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2544',
		number: '2544',
		text: 'قَالُوا۟ فَأْتُوا۟ بِهِۦ عَلَىٰٓ أَعْيُنِ ٱلنَّاسِ لَعَلَّهُمْ يَشْهَدُونَ',
		number_in_surah: '61',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2545',
		number: '2545',
		text: 'قَالُوٓا۟ ءَأَنتَ فَعَلْتَ هَٰذَا بِـَٔالِهَتِنَا يَٰٓإِبْرَٰهِيمُ',
		number_in_surah: '62',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2546',
		number: '2546',
		text: 'قَالَ بَلْ فَعَلَهُۥ كَبِيرُهُمْ هَٰذَا فَسْـَٔلُوهُمْ إِن كَانُوا۟ يَنطِقُونَ',
		number_in_surah: '63',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2547',
		number: '2547',
		text: 'فَرَجَعُوٓا۟ إِلَىٰٓ أَنفُسِهِمْ فَقَالُوٓا۟ إِنَّكُمْ أَنتُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '64',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2548',
		number: '2548',
		text: 'ثُمَّ نُكِسُوا۟ عَلَىٰ رُءُوسِهِمْ لَقَدْ عَلِمْتَ مَا هَٰٓؤُلَآءِ يَنطِقُونَ',
		number_in_surah: '65',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2549',
		number: '2549',
		text: 'قَالَ أَفَتَعْبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَنفَعُكُمْ شَيْـًۭٔا وَلَا يَضُرُّكُمْ',
		number_in_surah: '66',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2550',
		number: '2550',
		text: 'أُفٍّۢ لَّكُمْ وَلِمَا تَعْبُدُونَ مِن دُونِ ٱللَّهِ ۖ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '67',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2551',
		number: '2551',
		text: 'قَالُوا۟ حَرِّقُوهُ وَٱنصُرُوٓا۟ ءَالِهَتَكُمْ إِن كُنتُمْ فَٰعِلِينَ',
		number_in_surah: '68',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2552',
		number: '2552',
		text: 'قُلْنَا يَٰنَارُ كُونِى بَرْدًۭا وَسَلَٰمًا عَلَىٰٓ إِبْرَٰهِيمَ',
		number_in_surah: '69',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2553',
		number: '2553',
		text: 'وَأَرَادُوا۟ بِهِۦ كَيْدًۭا فَجَعَلْنَٰهُمُ ٱلْأَخْسَرِينَ',
		number_in_surah: '70',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2554',
		number: '2554',
		text: 'وَنَجَّيْنَٰهُ وَلُوطًا إِلَى ٱلْأَرْضِ ٱلَّتِى بَٰرَكْنَا فِيهَا لِلْعَٰلَمِينَ',
		number_in_surah: '71',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2555',
		number: '2555',
		text: 'وَوَهَبْنَا لَهُۥٓ إِسْحَٰقَ وَيَعْقُوبَ نَافِلَةًۭ ۖ وَكُلًّۭا جَعَلْنَا صَٰلِحِينَ',
		number_in_surah: '72',
		page: '327',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2556',
		number: '2556',
		text: 'وَجَعَلْنَٰهُمْ أَئِمَّةًۭ يَهْدُونَ بِأَمْرِنَا وَأَوْحَيْنَآ إِلَيْهِمْ فِعْلَ ٱلْخَيْرَٰتِ وَإِقَامَ ٱلصَّلَوٰةِ وَإِيتَآءَ ٱلزَّكَوٰةِ ۖ وَكَانُوا۟ لَنَا عَٰبِدِينَ',
		number_in_surah: '73',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2557',
		number: '2557',
		text: 'وَلُوطًا ءَاتَيْنَٰهُ حُكْمًۭا وَعِلْمًۭا وَنَجَّيْنَٰهُ مِنَ ٱلْقَرْيَةِ ٱلَّتِى كَانَت تَّعْمَلُ ٱلْخَبَٰٓئِثَ ۗ إِنَّهُمْ كَانُوا۟ قَوْمَ سَوْءٍۢ فَٰسِقِينَ',
		number_in_surah: '74',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2558',
		number: '2558',
		text: 'وَأَدْخَلْنَٰهُ فِى رَحْمَتِنَآ ۖ إِنَّهُۥ مِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '75',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2559',
		number: '2559',
		text: 'وَنُوحًا إِذْ نَادَىٰ مِن قَبْلُ فَٱسْتَجَبْنَا لَهُۥ فَنَجَّيْنَٰهُ وَأَهْلَهُۥ مِنَ ٱلْكَرْبِ ٱلْعَظِيمِ',
		number_in_surah: '76',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2560',
		number: '2560',
		text: 'وَنَصَرْنَٰهُ مِنَ ٱلْقَوْمِ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَآ ۚ إِنَّهُمْ كَانُوا۟ قَوْمَ سَوْءٍۢ فَأَغْرَقْنَٰهُمْ أَجْمَعِينَ',
		number_in_surah: '77',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2561',
		number: '2561',
		text: 'وَدَاوُۥدَ وَسُلَيْمَٰنَ إِذْ يَحْكُمَانِ فِى ٱلْحَرْثِ إِذْ نَفَشَتْ فِيهِ غَنَمُ ٱلْقَوْمِ وَكُنَّا لِحُكْمِهِمْ شَٰهِدِينَ',
		number_in_surah: '78',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2562',
		number: '2562',
		text: 'فَفَهَّمْنَٰهَا سُلَيْمَٰنَ ۚ وَكُلًّا ءَاتَيْنَا حُكْمًۭا وَعِلْمًۭا ۚ وَسَخَّرْنَا مَعَ دَاوُۥدَ ٱلْجِبَالَ يُسَبِّحْنَ وَٱلطَّيْرَ ۚ وَكُنَّا فَٰعِلِينَ',
		number_in_surah: '79',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2563',
		number: '2563',
		text: 'وَعَلَّمْنَٰهُ صَنْعَةَ لَبُوسٍۢ لَّكُمْ لِتُحْصِنَكُم مِّنۢ بَأْسِكُمْ ۖ فَهَلْ أَنتُمْ شَٰكِرُونَ',
		number_in_surah: '80',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2564',
		number: '2564',
		text: 'وَلِسُلَيْمَٰنَ ٱلرِّيحَ عَاصِفَةًۭ تَجْرِى بِأَمْرِهِۦٓ إِلَى ٱلْأَرْضِ ٱلَّتِى بَٰرَكْنَا فِيهَا ۚ وَكُنَّا بِكُلِّ شَىْءٍ عَٰلِمِينَ',
		number_in_surah: '81',
		page: '328',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2565',
		number: '2565',
		text: 'وَمِنَ ٱلشَّيَٰطِينِ مَن يَغُوصُونَ لَهُۥ وَيَعْمَلُونَ عَمَلًۭا دُونَ ذَٰلِكَ ۖ وَكُنَّا لَهُمْ حَٰفِظِينَ',
		number_in_surah: '82',
		page: '329',
		surah_id: '21',
		hizb_id: '131',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2566',
		number: '2566',
		text: '۞ وَأَيُّوبَ إِذْ نَادَىٰ رَبَّهُۥٓ أَنِّى مَسَّنِىَ ٱلضُّرُّ وَأَنتَ أَرْحَمُ ٱلرَّٰحِمِينَ',
		number_in_surah: '83',
		page: '329',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2567',
		number: '2567',
		text: 'فَٱسْتَجَبْنَا لَهُۥ فَكَشَفْنَا مَا بِهِۦ مِن ضُرٍّۢ ۖ وَءَاتَيْنَٰهُ أَهْلَهُۥ وَمِثْلَهُم مَّعَهُمْ رَحْمَةًۭ مِّنْ عِندِنَا وَذِكْرَىٰ لِلْعَٰبِدِينَ',
		number_in_surah: '84',
		page: '329',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2568',
		number: '2568',
		text: 'وَإِسْمَٰعِيلَ وَإِدْرِيسَ وَذَا ٱلْكِفْلِ ۖ كُلٌّۭ مِّنَ ٱلصَّٰبِرِينَ',
		number_in_surah: '85',
		page: '329',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2569',
		number: '2569',
		text: 'وَأَدْخَلْنَٰهُمْ فِى رَحْمَتِنَآ ۖ إِنَّهُم مِّنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '86',
		page: '329',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2570',
		number: '2570',
		text: 'وَذَا ٱلنُّونِ إِذ ذَّهَبَ مُغَٰضِبًۭا فَظَنَّ أَن لَّن نَّقْدِرَ عَلَيْهِ فَنَادَىٰ فِى ٱلظُّلُمَٰتِ أَن لَّآ إِلَٰهَ إِلَّآ أَنتَ سُبْحَٰنَكَ إِنِّى كُنتُ مِنَ ٱلظَّٰلِمِينَ',
		number_in_surah: '87',
		page: '329',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2571',
		number: '2571',
		text: 'فَٱسْتَجَبْنَا لَهُۥ وَنَجَّيْنَٰهُ مِنَ ٱلْغَمِّ ۚ وَكَذَٰلِكَ نُۨجِى ٱلْمُؤْمِنِينَ',
		number_in_surah: '88',
		page: '329',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2572',
		number: '2572',
		text: 'وَزَكَرِيَّآ إِذْ نَادَىٰ رَبَّهُۥ رَبِّ لَا تَذَرْنِى فَرْدًۭا وَأَنتَ خَيْرُ ٱلْوَٰرِثِينَ',
		number_in_surah: '89',
		page: '329',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2573',
		number: '2573',
		text: 'فَٱسْتَجَبْنَا لَهُۥ وَوَهَبْنَا لَهُۥ يَحْيَىٰ وَأَصْلَحْنَا لَهُۥ زَوْجَهُۥٓ ۚ إِنَّهُمْ كَانُوا۟ يُسَٰرِعُونَ فِى ٱلْخَيْرَٰتِ وَيَدْعُونَنَا رَغَبًۭا وَرَهَبًۭا ۖ وَكَانُوا۟ لَنَا خَٰشِعِينَ',
		number_in_surah: '90',
		page: '329',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2574',
		number: '2574',
		text: 'وَٱلَّتِىٓ أَحْصَنَتْ فَرْجَهَا فَنَفَخْنَا فِيهَا مِن رُّوحِنَا وَجَعَلْنَٰهَا وَٱبْنَهَآ ءَايَةًۭ لِّلْعَٰلَمِينَ',
		number_in_surah: '91',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2575',
		number: '2575',
		text: 'إِنَّ هَٰذِهِۦٓ أُمَّتُكُمْ أُمَّةًۭ وَٰحِدَةًۭ وَأَنَا۠ رَبُّكُمْ فَٱعْبُدُونِ',
		number_in_surah: '92',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2576',
		number: '2576',
		text: 'وَتَقَطَّعُوٓا۟ أَمْرَهُم بَيْنَهُمْ ۖ كُلٌّ إِلَيْنَا رَٰجِعُونَ',
		number_in_surah: '93',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2577',
		number: '2577',
		text: 'فَمَن يَعْمَلْ مِنَ ٱلصَّٰلِحَٰتِ وَهُوَ مُؤْمِنٌۭ فَلَا كُفْرَانَ لِسَعْيِهِۦ وَإِنَّا لَهُۥ كَٰتِبُونَ',
		number_in_surah: '94',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2578',
		number: '2578',
		text: 'وَحَرَٰمٌ عَلَىٰ قَرْيَةٍ أَهْلَكْنَٰهَآ أَنَّهُمْ لَا يَرْجِعُونَ',
		number_in_surah: '95',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2579',
		number: '2579',
		text: 'حَتَّىٰٓ إِذَا فُتِحَتْ يَأْجُوجُ وَمَأْجُوجُ وَهُم مِّن كُلِّ حَدَبٍۢ يَنسِلُونَ',
		number_in_surah: '96',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2580',
		number: '2580',
		text: 'وَٱقْتَرَبَ ٱلْوَعْدُ ٱلْحَقُّ فَإِذَا هِىَ شَٰخِصَةٌ أَبْصَٰرُ ٱلَّذِينَ كَفَرُوا۟ يَٰوَيْلَنَا قَدْ كُنَّا فِى غَفْلَةٍۢ مِّنْ هَٰذَا بَلْ كُنَّا ظَٰلِمِينَ',
		number_in_surah: '97',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2581',
		number: '2581',
		text: 'إِنَّكُمْ وَمَا تَعْبُدُونَ مِن دُونِ ٱللَّهِ حَصَبُ جَهَنَّمَ أَنتُمْ لَهَا وَٰرِدُونَ',
		number_in_surah: '98',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2582',
		number: '2582',
		text: 'لَوْ كَانَ هَٰٓؤُلَآءِ ءَالِهَةًۭ مَّا وَرَدُوهَا ۖ وَكُلٌّۭ فِيهَا خَٰلِدُونَ',
		number_in_surah: '99',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2583',
		number: '2583',
		text: 'لَهُمْ فِيهَا زَفِيرٌۭ وَهُمْ فِيهَا لَا يَسْمَعُونَ',
		number_in_surah: '100',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2584',
		number: '2584',
		text: 'إِنَّ ٱلَّذِينَ سَبَقَتْ لَهُم مِّنَّا ٱلْحُسْنَىٰٓ أُو۟لَٰٓئِكَ عَنْهَا مُبْعَدُونَ',
		number_in_surah: '101',
		page: '330',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2585',
		number: '2585',
		text: 'لَا يَسْمَعُونَ حَسِيسَهَا ۖ وَهُمْ فِى مَا ٱشْتَهَتْ أَنفُسُهُمْ خَٰلِدُونَ',
		number_in_surah: '102',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2586',
		number: '2586',
		text: 'لَا يَحْزُنُهُمُ ٱلْفَزَعُ ٱلْأَكْبَرُ وَتَتَلَقَّىٰهُمُ ٱلْمَلَٰٓئِكَةُ هَٰذَا يَوْمُكُمُ ٱلَّذِى كُنتُمْ تُوعَدُونَ',
		number_in_surah: '103',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2587',
		number: '2587',
		text: 'يَوْمَ نَطْوِى ٱلسَّمَآءَ كَطَىِّ ٱلسِّجِلِّ لِلْكُتُبِ ۚ كَمَا بَدَأْنَآ أَوَّلَ خَلْقٍۢ نُّعِيدُهُۥ ۚ وَعْدًا عَلَيْنَآ ۚ إِنَّا كُنَّا فَٰعِلِينَ',
		number_in_surah: '104',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2588',
		number: '2588',
		text: 'وَلَقَدْ كَتَبْنَا فِى ٱلزَّبُورِ مِنۢ بَعْدِ ٱلذِّكْرِ أَنَّ ٱلْأَرْضَ يَرِثُهَا عِبَادِىَ ٱلصَّٰلِحُونَ',
		number_in_surah: '105',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2589',
		number: '2589',
		text: 'إِنَّ فِى هَٰذَا لَبَلَٰغًۭا لِّقَوْمٍ عَٰبِدِينَ',
		number_in_surah: '106',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2590',
		number: '2590',
		text: 'وَمَآ أَرْسَلْنَٰكَ إِلَّا رَحْمَةًۭ لِّلْعَٰلَمِينَ',
		number_in_surah: '107',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2591',
		number: '2591',
		text: 'قُلْ إِنَّمَا يُوحَىٰٓ إِلَىَّ أَنَّمَآ إِلَٰهُكُمْ إِلَٰهٌۭ وَٰحِدٌۭ ۖ فَهَلْ أَنتُم مُّسْلِمُونَ',
		number_in_surah: '108',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2592',
		number: '2592',
		text: 'فَإِن تَوَلَّوْا۟ فَقُلْ ءَاذَنتُكُمْ عَلَىٰ سَوَآءٍۢ ۖ وَإِنْ أَدْرِىٓ أَقَرِيبٌ أَم بَعِيدٌۭ مَّا تُوعَدُونَ',
		number_in_surah: '109',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2593',
		number: '2593',
		text: 'إِنَّهُۥ يَعْلَمُ ٱلْجَهْرَ مِنَ ٱلْقَوْلِ وَيَعْلَمُ مَا تَكْتُمُونَ',
		number_in_surah: '110',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2594',
		number: '2594',
		text: 'وَإِنْ أَدْرِى لَعَلَّهُۥ فِتْنَةٌۭ لَّكُمْ وَمَتَٰعٌ إِلَىٰ حِينٍۢ',
		number_in_surah: '111',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2595',
		number: '2595',
		text: 'قَٰلَ رَبِّ ٱحْكُم بِٱلْحَقِّ ۗ وَرَبُّنَا ٱلرَّحْمَٰنُ ٱلْمُسْتَعَانُ عَلَىٰ مَا تَصِفُونَ',
		number_in_surah: '112',
		page: '331',
		surah_id: '21',
		hizb_id: '132',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2596',
		number: '2596',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلنَّاسُ ٱتَّقُوا۟ رَبَّكُمْ ۚ إِنَّ زَلْزَلَةَ ٱلسَّاعَةِ شَىْءٌ عَظِيمٌۭ',
		number_in_surah: '1',
		page: '332',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2597',
		number: '2597',
		text: 'يَوْمَ تَرَوْنَهَا تَذْهَلُ كُلُّ مُرْضِعَةٍ عَمَّآ أَرْضَعَتْ وَتَضَعُ كُلُّ ذَاتِ حَمْلٍ حَمْلَهَا وَتَرَى ٱلنَّاسَ سُكَٰرَىٰ وَمَا هُم بِسُكَٰرَىٰ وَلَٰكِنَّ عَذَابَ ٱللَّهِ شَدِيدٌۭ',
		number_in_surah: '2',
		page: '332',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2598',
		number: '2598',
		text: 'وَمِنَ ٱلنَّاسِ مَن يُجَٰدِلُ فِى ٱللَّهِ بِغَيْرِ عِلْمٍۢ وَيَتَّبِعُ كُلَّ شَيْطَٰنٍۢ مَّرِيدٍۢ',
		number_in_surah: '3',
		page: '332',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2599',
		number: '2599',
		text: 'كُتِبَ عَلَيْهِ أَنَّهُۥ مَن تَوَلَّاهُ فَأَنَّهُۥ يُضِلُّهُۥ وَيَهْدِيهِ إِلَىٰ عَذَابِ ٱلسَّعِيرِ',
		number_in_surah: '4',
		page: '332',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2600',
		number: '2600',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ إِن كُنتُمْ فِى رَيْبٍۢ مِّنَ ٱلْبَعْثِ فَإِنَّا خَلَقْنَٰكُم مِّن تُرَابٍۢ ثُمَّ مِن نُّطْفَةٍۢ ثُمَّ مِنْ عَلَقَةٍۢ ثُمَّ مِن مُّضْغَةٍۢ مُّخَلَّقَةٍۢ وَغَيْرِ مُخَلَّقَةٍۢ لِّنُبَيِّنَ لَكُمْ ۚ وَنُقِرُّ فِى ٱلْأَرْحَامِ مَا نَشَآءُ إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى ثُمَّ نُخْرِجُكُمْ طِفْلًۭا ثُمَّ لِتَبْلُغُوٓا۟ أَشُدَّكُمْ ۖ وَمِنكُم مَّن يُتَوَفَّىٰ وَمِنكُم مَّن يُرَدُّ إِلَىٰٓ أَرْذَلِ ٱلْعُمُرِ لِكَيْلَا يَعْلَمَ مِنۢ بَعْدِ عِلْمٍۢ شَيْـًۭٔا ۚ وَتَرَى ٱلْأَرْضَ هَامِدَةًۭ فَإِذَآ أَنزَلْنَا عَلَيْهَا ٱلْمَآءَ ٱهْتَزَّتْ وَرَبَتْ وَأَنۢبَتَتْ مِن كُلِّ زَوْجٍۭ بَهِيجٍۢ',
		number_in_surah: '5',
		page: '332',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2601',
		number: '2601',
		text: 'ذَٰلِكَ بِأَنَّ ٱللَّهَ هُوَ ٱلْحَقُّ وَأَنَّهُۥ يُحْىِ ٱلْمَوْتَىٰ وَأَنَّهُۥ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '6',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2602',
		number: '2602',
		text: 'وَأَنَّ ٱلسَّاعَةَ ءَاتِيَةٌۭ لَّا رَيْبَ فِيهَا وَأَنَّ ٱللَّهَ يَبْعَثُ مَن فِى ٱلْقُبُورِ',
		number_in_surah: '7',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2603',
		number: '2603',
		text: 'وَمِنَ ٱلنَّاسِ مَن يُجَٰدِلُ فِى ٱللَّهِ بِغَيْرِ عِلْمٍۢ وَلَا هُدًۭى وَلَا كِتَٰبٍۢ مُّنِيرٍۢ',
		number_in_surah: '8',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2604',
		number: '2604',
		text: 'ثَانِىَ عِطْفِهِۦ لِيُضِلَّ عَن سَبِيلِ ٱللَّهِ ۖ لَهُۥ فِى ٱلدُّنْيَا خِزْىٌۭ ۖ وَنُذِيقُهُۥ يَوْمَ ٱلْقِيَٰمَةِ عَذَابَ ٱلْحَرِيقِ',
		number_in_surah: '9',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2605',
		number: '2605',
		text: 'ذَٰلِكَ بِمَا قَدَّمَتْ يَدَاكَ وَأَنَّ ٱللَّهَ لَيْسَ بِظَلَّٰمٍۢ لِّلْعَبِيدِ',
		number_in_surah: '10',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2606',
		number: '2606',
		text: 'وَمِنَ ٱلنَّاسِ مَن يَعْبُدُ ٱللَّهَ عَلَىٰ حَرْفٍۢ ۖ فَإِنْ أَصَابَهُۥ خَيْرٌ ٱطْمَأَنَّ بِهِۦ ۖ وَإِنْ أَصَابَتْهُ فِتْنَةٌ ٱنقَلَبَ عَلَىٰ وَجْهِهِۦ خَسِرَ ٱلدُّنْيَا وَٱلْءَاخِرَةَ ۚ ذَٰلِكَ هُوَ ٱلْخُسْرَانُ ٱلْمُبِينُ',
		number_in_surah: '11',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2607',
		number: '2607',
		text: 'يَدْعُوا۟ مِن دُونِ ٱللَّهِ مَا لَا يَضُرُّهُۥ وَمَا لَا يَنفَعُهُۥ ۚ ذَٰلِكَ هُوَ ٱلضَّلَٰلُ ٱلْبَعِيدُ',
		number_in_surah: '12',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2608',
		number: '2608',
		text: 'يَدْعُوا۟ لَمَن ضَرُّهُۥٓ أَقْرَبُ مِن نَّفْعِهِۦ ۚ لَبِئْسَ ٱلْمَوْلَىٰ وَلَبِئْسَ ٱلْعَشِيرُ',
		number_in_surah: '13',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2609',
		number: '2609',
		text: 'إِنَّ ٱللَّهَ يُدْخِلُ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۚ إِنَّ ٱللَّهَ يَفْعَلُ مَا يُرِيدُ',
		number_in_surah: '14',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2610',
		number: '2610',
		text: 'مَن كَانَ يَظُنُّ أَن لَّن يَنصُرَهُ ٱللَّهُ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ فَلْيَمْدُدْ بِسَبَبٍ إِلَى ٱلسَّمَآءِ ثُمَّ لْيَقْطَعْ فَلْيَنظُرْ هَلْ يُذْهِبَنَّ كَيْدُهُۥ مَا يَغِيظُ',
		number_in_surah: '15',
		page: '333',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2611',
		number: '2611',
		text: 'وَكَذَٰلِكَ أَنزَلْنَٰهُ ءَايَٰتٍۭ بَيِّنَٰتٍۢ وَأَنَّ ٱللَّهَ يَهْدِى مَن يُرِيدُ',
		number_in_surah: '16',
		page: '334',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2612',
		number: '2612',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَٱلَّذِينَ هَادُوا۟ وَٱلصَّٰبِـِٔينَ وَٱلنَّصَٰرَىٰ وَٱلْمَجُوسَ وَٱلَّذِينَ أَشْرَكُوٓا۟ إِنَّ ٱللَّهَ يَفْصِلُ بَيْنَهُمْ يَوْمَ ٱلْقِيَٰمَةِ ۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ شَهِيدٌ',
		number_in_surah: '17',
		page: '334',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2613',
		number: '2613',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ يَسْجُدُ لَهُۥ مَن فِى ٱلسَّمَٰوَٰتِ وَمَن فِى ٱلْأَرْضِ وَٱلشَّمْسُ وَٱلْقَمَرُ وَٱلنُّجُومُ وَٱلْجِبَالُ وَٱلشَّجَرُ وَٱلدَّوَآبُّ وَكَثِيرٌۭ مِّنَ ٱلنَّاسِ ۖ وَكَثِيرٌ حَقَّ عَلَيْهِ ٱلْعَذَابُ ۗ وَمَن يُهِنِ ٱللَّهُ فَمَا لَهُۥ مِن مُّكْرِمٍ ۚ إِنَّ ٱللَّهَ يَفْعَلُ مَا يَشَآءُ ۩',
		number_in_surah: '18',
		page: '334',
		surah_id: '22',
		hizb_id: '133',
		juz_id: '17',
		sajda: '1',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2614',
		number: '2614',
		text: '۞ هَٰذَانِ خَصْمَانِ ٱخْتَصَمُوا۟ فِى رَبِّهِمْ ۖ فَٱلَّذِينَ كَفَرُوا۟ قُطِّعَتْ لَهُمْ ثِيَابٌۭ مِّن نَّارٍۢ يُصَبُّ مِن فَوْقِ رُءُوسِهِمُ ٱلْحَمِيمُ',
		number_in_surah: '19',
		page: '334',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2615',
		number: '2615',
		text: 'يُصْهَرُ بِهِۦ مَا فِى بُطُونِهِمْ وَٱلْجُلُودُ',
		number_in_surah: '20',
		page: '334',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2616',
		number: '2616',
		text: 'وَلَهُم مَّقَٰمِعُ مِنْ حَدِيدٍۢ',
		number_in_surah: '21',
		page: '334',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2617',
		number: '2617',
		text: 'كُلَّمَآ أَرَادُوٓا۟ أَن يَخْرُجُوا۟ مِنْهَا مِنْ غَمٍّ أُعِيدُوا۟ فِيهَا وَذُوقُوا۟ عَذَابَ ٱلْحَرِيقِ',
		number_in_surah: '22',
		page: '334',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2618',
		number: '2618',
		text: 'إِنَّ ٱللَّهَ يُدْخِلُ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ يُحَلَّوْنَ فِيهَا مِنْ أَسَاوِرَ مِن ذَهَبٍۢ وَلُؤْلُؤًۭا ۖ وَلِبَاسُهُمْ فِيهَا حَرِيرٌۭ',
		number_in_surah: '23',
		page: '334',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2619',
		number: '2619',
		text: 'وَهُدُوٓا۟ إِلَى ٱلطَّيِّبِ مِنَ ٱلْقَوْلِ وَهُدُوٓا۟ إِلَىٰ صِرَٰطِ ٱلْحَمِيدِ',
		number_in_surah: '24',
		page: '335',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2620',
		number: '2620',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ وَيَصُدُّونَ عَن سَبِيلِ ٱللَّهِ وَٱلْمَسْجِدِ ٱلْحَرَامِ ٱلَّذِى جَعَلْنَٰهُ لِلنَّاسِ سَوَآءً ٱلْعَٰكِفُ فِيهِ وَٱلْبَادِ ۚ وَمَن يُرِدْ فِيهِ بِإِلْحَادٍۭ بِظُلْمٍۢ نُّذِقْهُ مِنْ عَذَابٍ أَلِيمٍۢ',
		number_in_surah: '25',
		page: '335',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2621',
		number: '2621',
		text: 'وَإِذْ بَوَّأْنَا لِإِبْرَٰهِيمَ مَكَانَ ٱلْبَيْتِ أَن لَّا تُشْرِكْ بِى شَيْـًۭٔا وَطَهِّرْ بَيْتِىَ لِلطَّآئِفِينَ وَٱلْقَآئِمِينَ وَٱلرُّكَّعِ ٱلسُّجُودِ',
		number_in_surah: '26',
		page: '335',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2622',
		number: '2622',
		text: 'وَأَذِّن فِى ٱلنَّاسِ بِٱلْحَجِّ يَأْتُوكَ رِجَالًۭا وَعَلَىٰ كُلِّ ضَامِرٍۢ يَأْتِينَ مِن كُلِّ فَجٍّ عَمِيقٍۢ',
		number_in_surah: '27',
		page: '335',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2623',
		number: '2623',
		text: 'لِّيَشْهَدُوا۟ مَنَٰفِعَ لَهُمْ وَيَذْكُرُوا۟ ٱسْمَ ٱللَّهِ فِىٓ أَيَّامٍۢ مَّعْلُومَٰتٍ عَلَىٰ مَا رَزَقَهُم مِّنۢ بَهِيمَةِ ٱلْأَنْعَٰمِ ۖ فَكُلُوا۟ مِنْهَا وَأَطْعِمُوا۟ ٱلْبَآئِسَ ٱلْفَقِيرَ',
		number_in_surah: '28',
		page: '335',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2624',
		number: '2624',
		text: 'ثُمَّ لْيَقْضُوا۟ تَفَثَهُمْ وَلْيُوفُوا۟ نُذُورَهُمْ وَلْيَطَّوَّفُوا۟ بِٱلْبَيْتِ ٱلْعَتِيقِ',
		number_in_surah: '29',
		page: '335',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2625',
		number: '2625',
		text: 'ذَٰلِكَ وَمَن يُعَظِّمْ حُرُمَٰتِ ٱللَّهِ فَهُوَ خَيْرٌۭ لَّهُۥ عِندَ رَبِّهِۦ ۗ وَأُحِلَّتْ لَكُمُ ٱلْأَنْعَٰمُ إِلَّا مَا يُتْلَىٰ عَلَيْكُمْ ۖ فَٱجْتَنِبُوا۟ ٱلرِّجْسَ مِنَ ٱلْأَوْثَٰنِ وَٱجْتَنِبُوا۟ قَوْلَ ٱلزُّورِ',
		number_in_surah: '30',
		page: '335',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2626',
		number: '2626',
		text: 'حُنَفَآءَ لِلَّهِ غَيْرَ مُشْرِكِينَ بِهِۦ ۚ وَمَن يُشْرِكْ بِٱللَّهِ فَكَأَنَّمَا خَرَّ مِنَ ٱلسَّمَآءِ فَتَخْطَفُهُ ٱلطَّيْرُ أَوْ تَهْوِى بِهِ ٱلرِّيحُ فِى مَكَانٍۢ سَحِيقٍۢ',
		number_in_surah: '31',
		page: '336',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2627',
		number: '2627',
		text: 'ذَٰلِكَ وَمَن يُعَظِّمْ شَعَٰٓئِرَ ٱللَّهِ فَإِنَّهَا مِن تَقْوَى ٱلْقُلُوبِ',
		number_in_surah: '32',
		page: '336',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2628',
		number: '2628',
		text: 'لَكُمْ فِيهَا مَنَٰفِعُ إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى ثُمَّ مَحِلُّهَآ إِلَى ٱلْبَيْتِ ٱلْعَتِيقِ',
		number_in_surah: '33',
		page: '336',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2629',
		number: '2629',
		text: 'وَلِكُلِّ أُمَّةٍۢ جَعَلْنَا مَنسَكًۭا لِّيَذْكُرُوا۟ ٱسْمَ ٱللَّهِ عَلَىٰ مَا رَزَقَهُم مِّنۢ بَهِيمَةِ ٱلْأَنْعَٰمِ ۗ فَإِلَٰهُكُمْ إِلَٰهٌۭ وَٰحِدٌۭ فَلَهُۥٓ أَسْلِمُوا۟ ۗ وَبَشِّرِ ٱلْمُخْبِتِينَ',
		number_in_surah: '34',
		page: '336',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2630',
		number: '2630',
		text: 'ٱلَّذِينَ إِذَا ذُكِرَ ٱللَّهُ وَجِلَتْ قُلُوبُهُمْ وَٱلصَّٰبِرِينَ عَلَىٰ مَآ أَصَابَهُمْ وَٱلْمُقِيمِى ٱلصَّلَوٰةِ وَمِمَّا رَزَقْنَٰهُمْ يُنفِقُونَ',
		number_in_surah: '35',
		page: '336',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2631',
		number: '2631',
		text: 'وَٱلْبُدْنَ جَعَلْنَٰهَا لَكُم مِّن شَعَٰٓئِرِ ٱللَّهِ لَكُمْ فِيهَا خَيْرٌۭ ۖ فَٱذْكُرُوا۟ ٱسْمَ ٱللَّهِ عَلَيْهَا صَوَآفَّ ۖ فَإِذَا وَجَبَتْ جُنُوبُهَا فَكُلُوا۟ مِنْهَا وَأَطْعِمُوا۟ ٱلْقَانِعَ وَٱلْمُعْتَرَّ ۚ كَذَٰلِكَ سَخَّرْنَٰهَا لَكُمْ لَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '36',
		page: '336',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2632',
		number: '2632',
		text: 'لَن يَنَالَ ٱللَّهَ لُحُومُهَا وَلَا دِمَآؤُهَا وَلَٰكِن يَنَالُهُ ٱلتَّقْوَىٰ مِنكُمْ ۚ كَذَٰلِكَ سَخَّرَهَا لَكُمْ لِتُكَبِّرُوا۟ ٱللَّهَ عَلَىٰ مَا هَدَىٰكُمْ ۗ وَبَشِّرِ ٱلْمُحْسِنِينَ',
		number_in_surah: '37',
		page: '336',
		surah_id: '22',
		hizb_id: '134',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2633',
		number: '2633',
		text: '۞ إِنَّ ٱللَّهَ يُدَٰفِعُ عَنِ ٱلَّذِينَ ءَامَنُوٓا۟ ۗ إِنَّ ٱللَّهَ لَا يُحِبُّ كُلَّ خَوَّانٍۢ كَفُورٍ',
		number_in_surah: '38',
		page: '336',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2634',
		number: '2634',
		text: 'أُذِنَ لِلَّذِينَ يُقَٰتَلُونَ بِأَنَّهُمْ ظُلِمُوا۟ ۚ وَإِنَّ ٱللَّهَ عَلَىٰ نَصْرِهِمْ لَقَدِيرٌ',
		number_in_surah: '39',
		page: '337',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2635',
		number: '2635',
		text: 'ٱلَّذِينَ أُخْرِجُوا۟ مِن دِيَٰرِهِم بِغَيْرِ حَقٍّ إِلَّآ أَن يَقُولُوا۟ رَبُّنَا ٱللَّهُ ۗ وَلَوْلَا دَفْعُ ٱللَّهِ ٱلنَّاسَ بَعْضَهُم بِبَعْضٍۢ لَّهُدِّمَتْ صَوَٰمِعُ وَبِيَعٌۭ وَصَلَوَٰتٌۭ وَمَسَٰجِدُ يُذْكَرُ فِيهَا ٱسْمُ ٱللَّهِ كَثِيرًۭا ۗ وَلَيَنصُرَنَّ ٱللَّهُ مَن يَنصُرُهُۥٓ ۗ إِنَّ ٱللَّهَ لَقَوِىٌّ عَزِيزٌ',
		number_in_surah: '40',
		page: '337',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2636',
		number: '2636',
		text: 'ٱلَّذِينَ إِن مَّكَّنَّٰهُمْ فِى ٱلْأَرْضِ أَقَامُوا۟ ٱلصَّلَوٰةَ وَءَاتَوُا۟ ٱلزَّكَوٰةَ وَأَمَرُوا۟ بِٱلْمَعْرُوفِ وَنَهَوْا۟ عَنِ ٱلْمُنكَرِ ۗ وَلِلَّهِ عَٰقِبَةُ ٱلْأُمُورِ',
		number_in_surah: '41',
		page: '337',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2637',
		number: '2637',
		text: 'وَإِن يُكَذِّبُوكَ فَقَدْ كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍۢ وَعَادٌۭ وَثَمُودُ',
		number_in_surah: '42',
		page: '337',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2638',
		number: '2638',
		text: 'وَقَوْمُ إِبْرَٰهِيمَ وَقَوْمُ لُوطٍۢ',
		number_in_surah: '43',
		page: '337',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2639',
		number: '2639',
		text: 'وَأَصْحَٰبُ مَدْيَنَ ۖ وَكُذِّبَ مُوسَىٰ فَأَمْلَيْتُ لِلْكَٰفِرِينَ ثُمَّ أَخَذْتُهُمْ ۖ فَكَيْفَ كَانَ نَكِيرِ',
		number_in_surah: '44',
		page: '337',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2640',
		number: '2640',
		text: 'فَكَأَيِّن مِّن قَرْيَةٍ أَهْلَكْنَٰهَا وَهِىَ ظَالِمَةٌۭ فَهِىَ خَاوِيَةٌ عَلَىٰ عُرُوشِهَا وَبِئْرٍۢ مُّعَطَّلَةٍۢ وَقَصْرٍۢ مَّشِيدٍ',
		number_in_surah: '45',
		page: '337',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2641',
		number: '2641',
		text: 'أَفَلَمْ يَسِيرُوا۟ فِى ٱلْأَرْضِ فَتَكُونَ لَهُمْ قُلُوبٌۭ يَعْقِلُونَ بِهَآ أَوْ ءَاذَانٌۭ يَسْمَعُونَ بِهَا ۖ فَإِنَّهَا لَا تَعْمَى ٱلْأَبْصَٰرُ وَلَٰكِن تَعْمَى ٱلْقُلُوبُ ٱلَّتِى فِى ٱلصُّدُورِ',
		number_in_surah: '46',
		page: '337',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2642',
		number: '2642',
		text: 'وَيَسْتَعْجِلُونَكَ بِٱلْعَذَابِ وَلَن يُخْلِفَ ٱللَّهُ وَعْدَهُۥ ۚ وَإِنَّ يَوْمًا عِندَ رَبِّكَ كَأَلْفِ سَنَةٍۢ مِّمَّا تَعُدُّونَ',
		number_in_surah: '47',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2643',
		number: '2643',
		text: 'وَكَأَيِّن مِّن قَرْيَةٍ أَمْلَيْتُ لَهَا وَهِىَ ظَالِمَةٌۭ ثُمَّ أَخَذْتُهَا وَإِلَىَّ ٱلْمَصِيرُ',
		number_in_surah: '48',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2644',
		number: '2644',
		text: 'قُلْ يَٰٓأَيُّهَا ٱلنَّاسُ إِنَّمَآ أَنَا۠ لَكُمْ نَذِيرٌۭ مُّبِينٌۭ',
		number_in_surah: '49',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2645',
		number: '2645',
		text: 'فَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَهُم مَّغْفِرَةٌۭ وَرِزْقٌۭ كَرِيمٌۭ',
		number_in_surah: '50',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2646',
		number: '2646',
		text: 'وَٱلَّذِينَ سَعَوْا۟ فِىٓ ءَايَٰتِنَا مُعَٰجِزِينَ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَحِيمِ',
		number_in_surah: '51',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2647',
		number: '2647',
		text: 'وَمَآ أَرْسَلْنَا مِن قَبْلِكَ مِن رَّسُولٍۢ وَلَا نَبِىٍّ إِلَّآ إِذَا تَمَنَّىٰٓ أَلْقَى ٱلشَّيْطَٰنُ فِىٓ أُمْنِيَّتِهِۦ فَيَنسَخُ ٱللَّهُ مَا يُلْقِى ٱلشَّيْطَٰنُ ثُمَّ يُحْكِمُ ٱللَّهُ ءَايَٰتِهِۦ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '52',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2648',
		number: '2648',
		text: 'لِّيَجْعَلَ مَا يُلْقِى ٱلشَّيْطَٰنُ فِتْنَةًۭ لِّلَّذِينَ فِى قُلُوبِهِم مَّرَضٌۭ وَٱلْقَاسِيَةِ قُلُوبُهُمْ ۗ وَإِنَّ ٱلظَّٰلِمِينَ لَفِى شِقَاقٍۭ بَعِيدٍۢ',
		number_in_surah: '53',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2649',
		number: '2649',
		text: 'وَلِيَعْلَمَ ٱلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ أَنَّهُ ٱلْحَقُّ مِن رَّبِّكَ فَيُؤْمِنُوا۟ بِهِۦ فَتُخْبِتَ لَهُۥ قُلُوبُهُمْ ۗ وَإِنَّ ٱللَّهَ لَهَادِ ٱلَّذِينَ ءَامَنُوٓا۟ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '54',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2650',
		number: '2650',
		text: 'وَلَا يَزَالُ ٱلَّذِينَ كَفَرُوا۟ فِى مِرْيَةٍۢ مِّنْهُ حَتَّىٰ تَأْتِيَهُمُ ٱلسَّاعَةُ بَغْتَةً أَوْ يَأْتِيَهُمْ عَذَابُ يَوْمٍ عَقِيمٍ',
		number_in_surah: '55',
		page: '338',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2651',
		number: '2651',
		text: 'ٱلْمُلْكُ يَوْمَئِذٍۢ لِّلَّهِ يَحْكُمُ بَيْنَهُمْ ۚ فَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ فِى جَنَّٰتِ ٱلنَّعِيمِ',
		number_in_surah: '56',
		page: '339',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2652',
		number: '2652',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ وَكَذَّبُوا۟ بِـَٔايَٰتِنَا فَأُو۟لَٰٓئِكَ لَهُمْ عَذَابٌۭ مُّهِينٌۭ',
		number_in_surah: '57',
		page: '339',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2653',
		number: '2653',
		text: 'وَٱلَّذِينَ هَاجَرُوا۟ فِى سَبِيلِ ٱللَّهِ ثُمَّ قُتِلُوٓا۟ أَوْ مَاتُوا۟ لَيَرْزُقَنَّهُمُ ٱللَّهُ رِزْقًا حَسَنًۭا ۚ وَإِنَّ ٱللَّهَ لَهُوَ خَيْرُ ٱلرَّٰزِقِينَ',
		number_in_surah: '58',
		page: '339',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2654',
		number: '2654',
		text: 'لَيُدْخِلَنَّهُم مُّدْخَلًۭا يَرْضَوْنَهُۥ ۗ وَإِنَّ ٱللَّهَ لَعَلِيمٌ حَلِيمٌۭ',
		number_in_surah: '59',
		page: '339',
		surah_id: '22',
		hizb_id: '135',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2655',
		number: '2655',
		text: '۞ ذَٰلِكَ وَمَنْ عَاقَبَ بِمِثْلِ مَا عُوقِبَ بِهِۦ ثُمَّ بُغِىَ عَلَيْهِ لَيَنصُرَنَّهُ ٱللَّهُ ۗ إِنَّ ٱللَّهَ لَعَفُوٌّ غَفُورٌۭ',
		number_in_surah: '60',
		page: '339',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2656',
		number: '2656',
		text: 'ذَٰلِكَ بِأَنَّ ٱللَّهَ يُولِجُ ٱلَّيْلَ فِى ٱلنَّهَارِ وَيُولِجُ ٱلنَّهَارَ فِى ٱلَّيْلِ وَأَنَّ ٱللَّهَ سَمِيعٌۢ بَصِيرٌۭ',
		number_in_surah: '61',
		page: '339',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2657',
		number: '2657',
		text: 'ذَٰلِكَ بِأَنَّ ٱللَّهَ هُوَ ٱلْحَقُّ وَأَنَّ مَا يَدْعُونَ مِن دُونِهِۦ هُوَ ٱلْبَٰطِلُ وَأَنَّ ٱللَّهَ هُوَ ٱلْعَلِىُّ ٱلْكَبِيرُ',
		number_in_surah: '62',
		page: '339',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2658',
		number: '2658',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَتُصْبِحُ ٱلْأَرْضُ مُخْضَرَّةً ۗ إِنَّ ٱللَّهَ لَطِيفٌ خَبِيرٌۭ',
		number_in_surah: '63',
		page: '339',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2659',
		number: '2659',
		text: 'لَّهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۗ وَإِنَّ ٱللَّهَ لَهُوَ ٱلْغَنِىُّ ٱلْحَمِيدُ',
		number_in_surah: '64',
		page: '339',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2660',
		number: '2660',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ سَخَّرَ لَكُم مَّا فِى ٱلْأَرْضِ وَٱلْفُلْكَ تَجْرِى فِى ٱلْبَحْرِ بِأَمْرِهِۦ وَيُمْسِكُ ٱلسَّمَآءَ أَن تَقَعَ عَلَى ٱلْأَرْضِ إِلَّا بِإِذْنِهِۦٓ ۗ إِنَّ ٱللَّهَ بِٱلنَّاسِ لَرَءُوفٌۭ رَّحِيمٌۭ',
		number_in_surah: '65',
		page: '340',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2661',
		number: '2661',
		text: 'وَهُوَ ٱلَّذِىٓ أَحْيَاكُمْ ثُمَّ يُمِيتُكُمْ ثُمَّ يُحْيِيكُمْ ۗ إِنَّ ٱلْإِنسَٰنَ لَكَفُورٌۭ',
		number_in_surah: '66',
		page: '340',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2662',
		number: '2662',
		text: 'لِّكُلِّ أُمَّةٍۢ جَعَلْنَا مَنسَكًا هُمْ نَاسِكُوهُ ۖ فَلَا يُنَٰزِعُنَّكَ فِى ٱلْأَمْرِ ۚ وَٱدْعُ إِلَىٰ رَبِّكَ ۖ إِنَّكَ لَعَلَىٰ هُدًۭى مُّسْتَقِيمٍۢ',
		number_in_surah: '67',
		page: '340',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2663',
		number: '2663',
		text: 'وَإِن جَٰدَلُوكَ فَقُلِ ٱللَّهُ أَعْلَمُ بِمَا تَعْمَلُونَ',
		number_in_surah: '68',
		page: '340',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2664',
		number: '2664',
		text: 'ٱللَّهُ يَحْكُمُ بَيْنَكُمْ يَوْمَ ٱلْقِيَٰمَةِ فِيمَا كُنتُمْ فِيهِ تَخْتَلِفُونَ',
		number_in_surah: '69',
		page: '340',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2665',
		number: '2665',
		text: 'أَلَمْ تَعْلَمْ أَنَّ ٱللَّهَ يَعْلَمُ مَا فِى ٱلسَّمَآءِ وَٱلْأَرْضِ ۗ إِنَّ ذَٰلِكَ فِى كِتَٰبٍ ۚ إِنَّ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٌۭ',
		number_in_surah: '70',
		page: '340',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2666',
		number: '2666',
		text: 'وَيَعْبُدُونَ مِن دُونِ ٱللَّهِ مَا لَمْ يُنَزِّلْ بِهِۦ سُلْطَٰنًۭا وَمَا لَيْسَ لَهُم بِهِۦ عِلْمٌۭ ۗ وَمَا لِلظَّٰلِمِينَ مِن نَّصِيرٍۢ',
		number_in_surah: '71',
		page: '340',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2667',
		number: '2667',
		text: 'وَإِذَا تُتْلَىٰ عَلَيْهِمْ ءَايَٰتُنَا بَيِّنَٰتٍۢ تَعْرِفُ فِى وُجُوهِ ٱلَّذِينَ كَفَرُوا۟ ٱلْمُنكَرَ ۖ يَكَادُونَ يَسْطُونَ بِٱلَّذِينَ يَتْلُونَ عَلَيْهِمْ ءَايَٰتِنَا ۗ قُلْ أَفَأُنَبِّئُكُم بِشَرٍّۢ مِّن ذَٰلِكُمُ ۗ ٱلنَّارُ وَعَدَهَا ٱللَّهُ ٱلَّذِينَ كَفَرُوا۟ ۖ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '72',
		page: '340',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2668',
		number: '2668',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ ضُرِبَ مَثَلٌۭ فَٱسْتَمِعُوا۟ لَهُۥٓ ۚ إِنَّ ٱلَّذِينَ تَدْعُونَ مِن دُونِ ٱللَّهِ لَن يَخْلُقُوا۟ ذُبَابًۭا وَلَوِ ٱجْتَمَعُوا۟ لَهُۥ ۖ وَإِن يَسْلُبْهُمُ ٱلذُّبَابُ شَيْـًۭٔا لَّا يَسْتَنقِذُوهُ مِنْهُ ۚ ضَعُفَ ٱلطَّالِبُ وَٱلْمَطْلُوبُ',
		number_in_surah: '73',
		page: '341',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2669',
		number: '2669',
		text: 'مَا قَدَرُوا۟ ٱللَّهَ حَقَّ قَدْرِهِۦٓ ۗ إِنَّ ٱللَّهَ لَقَوِىٌّ عَزِيزٌ',
		number_in_surah: '74',
		page: '341',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2670',
		number: '2670',
		text: 'ٱللَّهُ يَصْطَفِى مِنَ ٱلْمَلَٰٓئِكَةِ رُسُلًۭا وَمِنَ ٱلنَّاسِ ۚ إِنَّ ٱللَّهَ سَمِيعٌۢ بَصِيرٌۭ',
		number_in_surah: '75',
		page: '341',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2671',
		number: '2671',
		text: 'يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۗ وَإِلَى ٱللَّهِ تُرْجَعُ ٱلْأُمُورُ',
		number_in_surah: '76',
		page: '341',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2672',
		number: '2672',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱرْكَعُوا۟ وَٱسْجُدُوا۟ وَٱعْبُدُوا۟ رَبَّكُمْ وَٱفْعَلُوا۟ ٱلْخَيْرَ لَعَلَّكُمْ تُفْلِحُونَ ۩',
		number_in_surah: '77',
		page: '341',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '1',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2673',
		number: '2673',
		text: 'وَجَٰهِدُوا۟ فِى ٱللَّهِ حَقَّ جِهَادِهِۦ ۚ هُوَ ٱجْتَبَىٰكُمْ وَمَا جَعَلَ عَلَيْكُمْ فِى ٱلدِّينِ مِنْ حَرَجٍۢ ۚ مِّلَّةَ أَبِيكُمْ إِبْرَٰهِيمَ ۚ هُوَ سَمَّىٰكُمُ ٱلْمُسْلِمِينَ مِن قَبْلُ وَفِى هَٰذَا لِيَكُونَ ٱلرَّسُولُ شَهِيدًا عَلَيْكُمْ وَتَكُونُوا۟ شُهَدَآءَ عَلَى ٱلنَّاسِ ۚ فَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَءَاتُوا۟ ٱلزَّكَوٰةَ وَٱعْتَصِمُوا۟ بِٱللَّهِ هُوَ مَوْلَىٰكُمْ ۖ فَنِعْمَ ٱلْمَوْلَىٰ وَنِعْمَ ٱلنَّصِيرُ',
		number_in_surah: '78',
		page: '341',
		surah_id: '22',
		hizb_id: '136',
		juz_id: '17',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2674',
		number: '2674',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ قَدْ أَفْلَحَ ٱلْمُؤْمِنُونَ',
		number_in_surah: '1',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2675',
		number: '2675',
		text: 'ٱلَّذِينَ هُمْ فِى صَلَاتِهِمْ خَٰشِعُونَ',
		number_in_surah: '2',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2676',
		number: '2676',
		text: 'وَٱلَّذِينَ هُمْ عَنِ ٱللَّغْوِ مُعْرِضُونَ',
		number_in_surah: '3',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2677',
		number: '2677',
		text: 'وَٱلَّذِينَ هُمْ لِلزَّكَوٰةِ فَٰعِلُونَ',
		number_in_surah: '4',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2678',
		number: '2678',
		text: 'وَٱلَّذِينَ هُمْ لِفُرُوجِهِمْ حَٰفِظُونَ',
		number_in_surah: '5',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2679',
		number: '2679',
		text: 'إِلَّا عَلَىٰٓ أَزْوَٰجِهِمْ أَوْ مَا مَلَكَتْ أَيْمَٰنُهُمْ فَإِنَّهُمْ غَيْرُ مَلُومِينَ',
		number_in_surah: '6',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2680',
		number: '2680',
		text: 'فَمَنِ ٱبْتَغَىٰ وَرَآءَ ذَٰلِكَ فَأُو۟لَٰٓئِكَ هُمُ ٱلْعَادُونَ',
		number_in_surah: '7',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2681',
		number: '2681',
		text: 'وَٱلَّذِينَ هُمْ لِأَمَٰنَٰتِهِمْ وَعَهْدِهِمْ رَٰعُونَ',
		number_in_surah: '8',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2682',
		number: '2682',
		text: 'وَٱلَّذِينَ هُمْ عَلَىٰ صَلَوَٰتِهِمْ يُحَافِظُونَ',
		number_in_surah: '9',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2683',
		number: '2683',
		text: 'أُو۟لَٰٓئِكَ هُمُ ٱلْوَٰرِثُونَ',
		number_in_surah: '10',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2684',
		number: '2684',
		text: 'ٱلَّذِينَ يَرِثُونَ ٱلْفِرْدَوْسَ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '11',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2685',
		number: '2685',
		text: 'وَلَقَدْ خَلَقْنَا ٱلْإِنسَٰنَ مِن سُلَٰلَةٍۢ مِّن طِينٍۢ',
		number_in_surah: '12',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2686',
		number: '2686',
		text: 'ثُمَّ جَعَلْنَٰهُ نُطْفَةًۭ فِى قَرَارٍۢ مَّكِينٍۢ',
		number_in_surah: '13',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2687',
		number: '2687',
		text: 'ثُمَّ خَلَقْنَا ٱلنُّطْفَةَ عَلَقَةًۭ فَخَلَقْنَا ٱلْعَلَقَةَ مُضْغَةًۭ فَخَلَقْنَا ٱلْمُضْغَةَ عِظَٰمًۭا فَكَسَوْنَا ٱلْعِظَٰمَ لَحْمًۭا ثُمَّ أَنشَأْنَٰهُ خَلْقًا ءَاخَرَ ۚ فَتَبَارَكَ ٱللَّهُ أَحْسَنُ ٱلْخَٰلِقِينَ',
		number_in_surah: '14',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2688',
		number: '2688',
		text: 'ثُمَّ إِنَّكُم بَعْدَ ذَٰلِكَ لَمَيِّتُونَ',
		number_in_surah: '15',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2689',
		number: '2689',
		text: 'ثُمَّ إِنَّكُمْ يَوْمَ ٱلْقِيَٰمَةِ تُبْعَثُونَ',
		number_in_surah: '16',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2690',
		number: '2690',
		text: 'وَلَقَدْ خَلَقْنَا فَوْقَكُمْ سَبْعَ طَرَآئِقَ وَمَا كُنَّا عَنِ ٱلْخَلْقِ غَٰفِلِينَ',
		number_in_surah: '17',
		page: '342',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2691',
		number: '2691',
		text: 'وَأَنزَلْنَا مِنَ ٱلسَّمَآءِ مَآءًۢ بِقَدَرٍۢ فَأَسْكَنَّٰهُ فِى ٱلْأَرْضِ ۖ وَإِنَّا عَلَىٰ ذَهَابٍۭ بِهِۦ لَقَٰدِرُونَ',
		number_in_surah: '18',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2692',
		number: '2692',
		text: 'فَأَنشَأْنَا لَكُم بِهِۦ جَنَّٰتٍۢ مِّن نَّخِيلٍۢ وَأَعْنَٰبٍۢ لَّكُمْ فِيهَا فَوَٰكِهُ كَثِيرَةٌۭ وَمِنْهَا تَأْكُلُونَ',
		number_in_surah: '19',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2693',
		number: '2693',
		text: 'وَشَجَرَةًۭ تَخْرُجُ مِن طُورِ سَيْنَآءَ تَنۢبُتُ بِٱلدُّهْنِ وَصِبْغٍۢ لِّلْءَاكِلِينَ',
		number_in_surah: '20',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2694',
		number: '2694',
		text: 'وَإِنَّ لَكُمْ فِى ٱلْأَنْعَٰمِ لَعِبْرَةًۭ ۖ نُّسْقِيكُم مِّمَّا فِى بُطُونِهَا وَلَكُمْ فِيهَا مَنَٰفِعُ كَثِيرَةٌۭ وَمِنْهَا تَأْكُلُونَ',
		number_in_surah: '21',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2695',
		number: '2695',
		text: 'وَعَلَيْهَا وَعَلَى ٱلْفُلْكِ تُحْمَلُونَ',
		number_in_surah: '22',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2696',
		number: '2696',
		text: 'وَلَقَدْ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِۦ فَقَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥٓ ۖ أَفَلَا تَتَّقُونَ',
		number_in_surah: '23',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2697',
		number: '2697',
		text: 'فَقَالَ ٱلْمَلَؤُا۟ ٱلَّذِينَ كَفَرُوا۟ مِن قَوْمِهِۦ مَا هَٰذَآ إِلَّا بَشَرٌۭ مِّثْلُكُمْ يُرِيدُ أَن يَتَفَضَّلَ عَلَيْكُمْ وَلَوْ شَآءَ ٱللَّهُ لَأَنزَلَ مَلَٰٓئِكَةًۭ مَّا سَمِعْنَا بِهَٰذَا فِىٓ ءَابَآئِنَا ٱلْأَوَّلِينَ',
		number_in_surah: '24',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2698',
		number: '2698',
		text: 'إِنْ هُوَ إِلَّا رَجُلٌۢ بِهِۦ جِنَّةٌۭ فَتَرَبَّصُوا۟ بِهِۦ حَتَّىٰ حِينٍۢ',
		number_in_surah: '25',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2699',
		number: '2699',
		text: 'قَالَ رَبِّ ٱنصُرْنِى بِمَا كَذَّبُونِ',
		number_in_surah: '26',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:02',
		updated_at: '2018-06-07 08:07:02',
	},
	{
		id: '2700',
		number: '2700',
		text: 'فَأَوْحَيْنَآ إِلَيْهِ أَنِ ٱصْنَعِ ٱلْفُلْكَ بِأَعْيُنِنَا وَوَحْيِنَا فَإِذَا جَآءَ أَمْرُنَا وَفَارَ ٱلتَّنُّورُ ۙ فَٱسْلُكْ فِيهَا مِن كُلٍّۢ زَوْجَيْنِ ٱثْنَيْنِ وَأَهْلَكَ إِلَّا مَن سَبَقَ عَلَيْهِ ٱلْقَوْلُ مِنْهُمْ ۖ وَلَا تُخَٰطِبْنِى فِى ٱلَّذِينَ ظَلَمُوٓا۟ ۖ إِنَّهُم مُّغْرَقُونَ',
		number_in_surah: '27',
		page: '343',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2701',
		number: '2701',
		text: 'فَإِذَا ٱسْتَوَيْتَ أَنتَ وَمَن مَّعَكَ عَلَى ٱلْفُلْكِ فَقُلِ ٱلْحَمْدُ لِلَّهِ ٱلَّذِى نَجَّىٰنَا مِنَ ٱلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '28',
		page: '344',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2702',
		number: '2702',
		text: 'وَقُل رَّبِّ أَنزِلْنِى مُنزَلًۭا مُّبَارَكًۭا وَأَنتَ خَيْرُ ٱلْمُنزِلِينَ',
		number_in_surah: '29',
		page: '344',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2703',
		number: '2703',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ وَإِن كُنَّا لَمُبْتَلِينَ',
		number_in_surah: '30',
		page: '344',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2704',
		number: '2704',
		text: 'ثُمَّ أَنشَأْنَا مِنۢ بَعْدِهِمْ قَرْنًا ءَاخَرِينَ',
		number_in_surah: '31',
		page: '344',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2705',
		number: '2705',
		text: 'فَأَرْسَلْنَا فِيهِمْ رَسُولًۭا مِّنْهُمْ أَنِ ٱعْبُدُوا۟ ٱللَّهَ مَا لَكُم مِّنْ إِلَٰهٍ غَيْرُهُۥٓ ۖ أَفَلَا تَتَّقُونَ',
		number_in_surah: '32',
		page: '344',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2706',
		number: '2706',
		text: 'وَقَالَ ٱلْمَلَأُ مِن قَوْمِهِ ٱلَّذِينَ كَفَرُوا۟ وَكَذَّبُوا۟ بِلِقَآءِ ٱلْءَاخِرَةِ وَأَتْرَفْنَٰهُمْ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا مَا هَٰذَآ إِلَّا بَشَرٌۭ مِّثْلُكُمْ يَأْكُلُ مِمَّا تَأْكُلُونَ مِنْهُ وَيَشْرَبُ مِمَّا تَشْرَبُونَ',
		number_in_surah: '33',
		page: '344',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2707',
		number: '2707',
		text: 'وَلَئِنْ أَطَعْتُم بَشَرًۭا مِّثْلَكُمْ إِنَّكُمْ إِذًۭا لَّخَٰسِرُونَ',
		number_in_surah: '34',
		page: '344',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2708',
		number: '2708',
		text: 'أَيَعِدُكُمْ أَنَّكُمْ إِذَا مِتُّمْ وَكُنتُمْ تُرَابًۭا وَعِظَٰمًا أَنَّكُم مُّخْرَجُونَ',
		number_in_surah: '35',
		page: '344',
		surah_id: '23',
		hizb_id: '137',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2709',
		number: '2709',
		text: '۞ هَيْهَاتَ هَيْهَاتَ لِمَا تُوعَدُونَ',
		number_in_surah: '36',
		page: '344',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2710',
		number: '2710',
		text: 'إِنْ هِىَ إِلَّا حَيَاتُنَا ٱلدُّنْيَا نَمُوتُ وَنَحْيَا وَمَا نَحْنُ بِمَبْعُوثِينَ',
		number_in_surah: '37',
		page: '344',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2711',
		number: '2711',
		text: 'إِنْ هُوَ إِلَّا رَجُلٌ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًۭا وَمَا نَحْنُ لَهُۥ بِمُؤْمِنِينَ',
		number_in_surah: '38',
		page: '344',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2712',
		number: '2712',
		text: 'قَالَ رَبِّ ٱنصُرْنِى بِمَا كَذَّبُونِ',
		number_in_surah: '39',
		page: '344',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2713',
		number: '2713',
		text: 'قَالَ عَمَّا قَلِيلٍۢ لَّيُصْبِحُنَّ نَٰدِمِينَ',
		number_in_surah: '40',
		page: '344',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2714',
		number: '2714',
		text: 'فَأَخَذَتْهُمُ ٱلصَّيْحَةُ بِٱلْحَقِّ فَجَعَلْنَٰهُمْ غُثَآءًۭ ۚ فَبُعْدًۭا لِّلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '41',
		page: '344',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2715',
		number: '2715',
		text: 'ثُمَّ أَنشَأْنَا مِنۢ بَعْدِهِمْ قُرُونًا ءَاخَرِينَ',
		number_in_surah: '42',
		page: '344',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2716',
		number: '2716',
		text: 'مَا تَسْبِقُ مِنْ أُمَّةٍ أَجَلَهَا وَمَا يَسْتَـْٔخِرُونَ',
		number_in_surah: '43',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2717',
		number: '2717',
		text: 'ثُمَّ أَرْسَلْنَا رُسُلَنَا تَتْرَا ۖ كُلَّ مَا جَآءَ أُمَّةًۭ رَّسُولُهَا كَذَّبُوهُ ۚ فَأَتْبَعْنَا بَعْضَهُم بَعْضًۭا وَجَعَلْنَٰهُمْ أَحَادِيثَ ۚ فَبُعْدًۭا لِّقَوْمٍۢ لَّا يُؤْمِنُونَ',
		number_in_surah: '44',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2718',
		number: '2718',
		text: 'ثُمَّ أَرْسَلْنَا مُوسَىٰ وَأَخَاهُ هَٰرُونَ بِـَٔايَٰتِنَا وَسُلْطَٰنٍۢ مُّبِينٍ',
		number_in_surah: '45',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2719',
		number: '2719',
		text: 'إِلَىٰ فِرْعَوْنَ وَمَلَإِي۟هِۦ فَٱسْتَكْبَرُوا۟ وَكَانُوا۟ قَوْمًا عَالِينَ',
		number_in_surah: '46',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2720',
		number: '2720',
		text: 'فَقَالُوٓا۟ أَنُؤْمِنُ لِبَشَرَيْنِ مِثْلِنَا وَقَوْمُهُمَا لَنَا عَٰبِدُونَ',
		number_in_surah: '47',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2721',
		number: '2721',
		text: 'فَكَذَّبُوهُمَا فَكَانُوا۟ مِنَ ٱلْمُهْلَكِينَ',
		number_in_surah: '48',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2722',
		number: '2722',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ لَعَلَّهُمْ يَهْتَدُونَ',
		number_in_surah: '49',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2723',
		number: '2723',
		text: 'وَجَعَلْنَا ٱبْنَ مَرْيَمَ وَأُمَّهُۥٓ ءَايَةًۭ وَءَاوَيْنَٰهُمَآ إِلَىٰ رَبْوَةٍۢ ذَاتِ قَرَارٍۢ وَمَعِينٍۢ',
		number_in_surah: '50',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2724',
		number: '2724',
		text: 'يَٰٓأَيُّهَا ٱلرُّسُلُ كُلُوا۟ مِنَ ٱلطَّيِّبَٰتِ وَٱعْمَلُوا۟ صَٰلِحًا ۖ إِنِّى بِمَا تَعْمَلُونَ عَلِيمٌۭ',
		number_in_surah: '51',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2725',
		number: '2725',
		text: 'وَإِنَّ هَٰذِهِۦٓ أُمَّتُكُمْ أُمَّةًۭ وَٰحِدَةًۭ وَأَنَا۠ رَبُّكُمْ فَٱتَّقُونِ',
		number_in_surah: '52',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2726',
		number: '2726',
		text: 'فَتَقَطَّعُوٓا۟ أَمْرَهُم بَيْنَهُمْ زُبُرًۭا ۖ كُلُّ حِزْبٍۭ بِمَا لَدَيْهِمْ فَرِحُونَ',
		number_in_surah: '53',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2727',
		number: '2727',
		text: 'فَذَرْهُمْ فِى غَمْرَتِهِمْ حَتَّىٰ حِينٍ',
		number_in_surah: '54',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2728',
		number: '2728',
		text: 'أَيَحْسَبُونَ أَنَّمَا نُمِدُّهُم بِهِۦ مِن مَّالٍۢ وَبَنِينَ',
		number_in_surah: '55',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2729',
		number: '2729',
		text: 'نُسَارِعُ لَهُمْ فِى ٱلْخَيْرَٰتِ ۚ بَل لَّا يَشْعُرُونَ',
		number_in_surah: '56',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2730',
		number: '2730',
		text: 'إِنَّ ٱلَّذِينَ هُم مِّنْ خَشْيَةِ رَبِّهِم مُّشْفِقُونَ',
		number_in_surah: '57',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2731',
		number: '2731',
		text: 'وَٱلَّذِينَ هُم بِـَٔايَٰتِ رَبِّهِمْ يُؤْمِنُونَ',
		number_in_surah: '58',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2732',
		number: '2732',
		text: 'وَٱلَّذِينَ هُم بِرَبِّهِمْ لَا يُشْرِكُونَ',
		number_in_surah: '59',
		page: '345',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2733',
		number: '2733',
		text: 'وَٱلَّذِينَ يُؤْتُونَ مَآ ءَاتَوا۟ وَّقُلُوبُهُمْ وَجِلَةٌ أَنَّهُمْ إِلَىٰ رَبِّهِمْ رَٰجِعُونَ',
		number_in_surah: '60',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2734',
		number: '2734',
		text: 'أُو۟لَٰٓئِكَ يُسَٰرِعُونَ فِى ٱلْخَيْرَٰتِ وَهُمْ لَهَا سَٰبِقُونَ',
		number_in_surah: '61',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2735',
		number: '2735',
		text: 'وَلَا نُكَلِّفُ نَفْسًا إِلَّا وُسْعَهَا ۖ وَلَدَيْنَا كِتَٰبٌۭ يَنطِقُ بِٱلْحَقِّ ۚ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '62',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2736',
		number: '2736',
		text: 'بَلْ قُلُوبُهُمْ فِى غَمْرَةٍۢ مِّنْ هَٰذَا وَلَهُمْ أَعْمَٰلٌۭ مِّن دُونِ ذَٰلِكَ هُمْ لَهَا عَٰمِلُونَ',
		number_in_surah: '63',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2737',
		number: '2737',
		text: 'حَتَّىٰٓ إِذَآ أَخَذْنَا مُتْرَفِيهِم بِٱلْعَذَابِ إِذَا هُمْ يَجْـَٔرُونَ',
		number_in_surah: '64',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2738',
		number: '2738',
		text: 'لَا تَجْـَٔرُوا۟ ٱلْيَوْمَ ۖ إِنَّكُم مِّنَّا لَا تُنصَرُونَ',
		number_in_surah: '65',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2739',
		number: '2739',
		text: 'قَدْ كَانَتْ ءَايَٰتِى تُتْلَىٰ عَلَيْكُمْ فَكُنتُمْ عَلَىٰٓ أَعْقَٰبِكُمْ تَنكِصُونَ',
		number_in_surah: '66',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2740',
		number: '2740',
		text: 'مُسْتَكْبِرِينَ بِهِۦ سَٰمِرًۭا تَهْجُرُونَ',
		number_in_surah: '67',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2741',
		number: '2741',
		text: 'أَفَلَمْ يَدَّبَّرُوا۟ ٱلْقَوْلَ أَمْ جَآءَهُم مَّا لَمْ يَأْتِ ءَابَآءَهُمُ ٱلْأَوَّلِينَ',
		number_in_surah: '68',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2742',
		number: '2742',
		text: 'أَمْ لَمْ يَعْرِفُوا۟ رَسُولَهُمْ فَهُمْ لَهُۥ مُنكِرُونَ',
		number_in_surah: '69',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2743',
		number: '2743',
		text: 'أَمْ يَقُولُونَ بِهِۦ جِنَّةٌۢ ۚ بَلْ جَآءَهُم بِٱلْحَقِّ وَأَكْثَرُهُمْ لِلْحَقِّ كَٰرِهُونَ',
		number_in_surah: '70',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2744',
		number: '2744',
		text: 'وَلَوِ ٱتَّبَعَ ٱلْحَقُّ أَهْوَآءَهُمْ لَفَسَدَتِ ٱلسَّمَٰوَٰتُ وَٱلْأَرْضُ وَمَن فِيهِنَّ ۚ بَلْ أَتَيْنَٰهُم بِذِكْرِهِمْ فَهُمْ عَن ذِكْرِهِم مُّعْرِضُونَ',
		number_in_surah: '71',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2745',
		number: '2745',
		text: 'أَمْ تَسْـَٔلُهُمْ خَرْجًۭا فَخَرَاجُ رَبِّكَ خَيْرٌۭ ۖ وَهُوَ خَيْرُ ٱلرَّٰزِقِينَ',
		number_in_surah: '72',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2746',
		number: '2746',
		text: 'وَإِنَّكَ لَتَدْعُوهُمْ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '73',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2747',
		number: '2747',
		text: 'وَإِنَّ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ عَنِ ٱلصِّرَٰطِ لَنَٰكِبُونَ',
		number_in_surah: '74',
		page: '346',
		surah_id: '23',
		hizb_id: '138',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2748',
		number: '2748',
		text: '۞ وَلَوْ رَحِمْنَٰهُمْ وَكَشَفْنَا مَا بِهِم مِّن ضُرٍّۢ لَّلَجُّوا۟ فِى طُغْيَٰنِهِمْ يَعْمَهُونَ',
		number_in_surah: '75',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2749',
		number: '2749',
		text: 'وَلَقَدْ أَخَذْنَٰهُم بِٱلْعَذَابِ فَمَا ٱسْتَكَانُوا۟ لِرَبِّهِمْ وَمَا يَتَضَرَّعُونَ',
		number_in_surah: '76',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2750',
		number: '2750',
		text: 'حَتَّىٰٓ إِذَا فَتَحْنَا عَلَيْهِم بَابًۭا ذَا عَذَابٍۢ شَدِيدٍ إِذَا هُمْ فِيهِ مُبْلِسُونَ',
		number_in_surah: '77',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2751',
		number: '2751',
		text: 'وَهُوَ ٱلَّذِىٓ أَنشَأَ لَكُمُ ٱلسَّمْعَ وَٱلْأَبْصَٰرَ وَٱلْأَفْـِٔدَةَ ۚ قَلِيلًۭا مَّا تَشْكُرُونَ',
		number_in_surah: '78',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2752',
		number: '2752',
		text: 'وَهُوَ ٱلَّذِى ذَرَأَكُمْ فِى ٱلْأَرْضِ وَإِلَيْهِ تُحْشَرُونَ',
		number_in_surah: '79',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2753',
		number: '2753',
		text: 'وَهُوَ ٱلَّذِى يُحْىِۦ وَيُمِيتُ وَلَهُ ٱخْتِلَٰفُ ٱلَّيْلِ وَٱلنَّهَارِ ۚ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '80',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2754',
		number: '2754',
		text: 'بَلْ قَالُوا۟ مِثْلَ مَا قَالَ ٱلْأَوَّلُونَ',
		number_in_surah: '81',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2755',
		number: '2755',
		text: 'قَالُوٓا۟ أَءِذَا مِتْنَا وَكُنَّا تُرَابًۭا وَعِظَٰمًا أَءِنَّا لَمَبْعُوثُونَ',
		number_in_surah: '82',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2756',
		number: '2756',
		text: 'لَقَدْ وُعِدْنَا نَحْنُ وَءَابَآؤُنَا هَٰذَا مِن قَبْلُ إِنْ هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلْأَوَّلِينَ',
		number_in_surah: '83',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2757',
		number: '2757',
		text: 'قُل لِّمَنِ ٱلْأَرْضُ وَمَن فِيهَآ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '84',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2758',
		number: '2758',
		text: 'سَيَقُولُونَ لِلَّهِ ۚ قُلْ أَفَلَا تَذَكَّرُونَ',
		number_in_surah: '85',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2759',
		number: '2759',
		text: 'قُلْ مَن رَّبُّ ٱلسَّمَٰوَٰتِ ٱلسَّبْعِ وَرَبُّ ٱلْعَرْشِ ٱلْعَظِيمِ',
		number_in_surah: '86',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2760',
		number: '2760',
		text: 'سَيَقُولُونَ لِلَّهِ ۚ قُلْ أَفَلَا تَتَّقُونَ',
		number_in_surah: '87',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2761',
		number: '2761',
		text: 'قُلْ مَنۢ بِيَدِهِۦ مَلَكُوتُ كُلِّ شَىْءٍۢ وَهُوَ يُجِيرُ وَلَا يُجَارُ عَلَيْهِ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '88',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2762',
		number: '2762',
		text: 'سَيَقُولُونَ لِلَّهِ ۚ قُلْ فَأَنَّىٰ تُسْحَرُونَ',
		number_in_surah: '89',
		page: '347',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2763',
		number: '2763',
		text: 'بَلْ أَتَيْنَٰهُم بِٱلْحَقِّ وَإِنَّهُمْ لَكَٰذِبُونَ',
		number_in_surah: '90',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2764',
		number: '2764',
		text: 'مَا ٱتَّخَذَ ٱللَّهُ مِن وَلَدٍۢ وَمَا كَانَ مَعَهُۥ مِنْ إِلَٰهٍ ۚ إِذًۭا لَّذَهَبَ كُلُّ إِلَٰهٍۭ بِمَا خَلَقَ وَلَعَلَا بَعْضُهُمْ عَلَىٰ بَعْضٍۢ ۚ سُبْحَٰنَ ٱللَّهِ عَمَّا يَصِفُونَ',
		number_in_surah: '91',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2765',
		number: '2765',
		text: 'عَٰلِمِ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ فَتَعَٰلَىٰ عَمَّا يُشْرِكُونَ',
		number_in_surah: '92',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2766',
		number: '2766',
		text: 'قُل رَّبِّ إِمَّا تُرِيَنِّى مَا يُوعَدُونَ',
		number_in_surah: '93',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2767',
		number: '2767',
		text: 'رَبِّ فَلَا تَجْعَلْنِى فِى ٱلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '94',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2768',
		number: '2768',
		text: 'وَإِنَّا عَلَىٰٓ أَن نُّرِيَكَ مَا نَعِدُهُمْ لَقَٰدِرُونَ',
		number_in_surah: '95',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2769',
		number: '2769',
		text: 'ٱدْفَعْ بِٱلَّتِى هِىَ أَحْسَنُ ٱلسَّيِّئَةَ ۚ نَحْنُ أَعْلَمُ بِمَا يَصِفُونَ',
		number_in_surah: '96',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2770',
		number: '2770',
		text: 'وَقُل رَّبِّ أَعُوذُ بِكَ مِنْ هَمَزَٰتِ ٱلشَّيَٰطِينِ',
		number_in_surah: '97',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2771',
		number: '2771',
		text: 'وَأَعُوذُ بِكَ رَبِّ أَن يَحْضُرُونِ',
		number_in_surah: '98',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2772',
		number: '2772',
		text: 'حَتَّىٰٓ إِذَا جَآءَ أَحَدَهُمُ ٱلْمَوْتُ قَالَ رَبِّ ٱرْجِعُونِ',
		number_in_surah: '99',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2773',
		number: '2773',
		text: 'لَعَلِّىٓ أَعْمَلُ صَٰلِحًۭا فِيمَا تَرَكْتُ ۚ كَلَّآ ۚ إِنَّهَا كَلِمَةٌ هُوَ قَآئِلُهَا ۖ وَمِن وَرَآئِهِم بَرْزَخٌ إِلَىٰ يَوْمِ يُبْعَثُونَ',
		number_in_surah: '100',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2774',
		number: '2774',
		text: 'فَإِذَا نُفِخَ فِى ٱلصُّورِ فَلَآ أَنسَابَ بَيْنَهُمْ يَوْمَئِذٍۢ وَلَا يَتَسَآءَلُونَ',
		number_in_surah: '101',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2775',
		number: '2775',
		text: 'فَمَن ثَقُلَتْ مَوَٰزِينُهُۥ فَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '102',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2776',
		number: '2776',
		text: 'وَمَنْ خَفَّتْ مَوَٰزِينُهُۥ فَأُو۟لَٰٓئِكَ ٱلَّذِينَ خَسِرُوٓا۟ أَنفُسَهُمْ فِى جَهَنَّمَ خَٰلِدُونَ',
		number_in_surah: '103',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2777',
		number: '2777',
		text: 'تَلْفَحُ وُجُوهَهُمُ ٱلنَّارُ وَهُمْ فِيهَا كَٰلِحُونَ',
		number_in_surah: '104',
		page: '348',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2778',
		number: '2778',
		text: 'أَلَمْ تَكُنْ ءَايَٰتِى تُتْلَىٰ عَلَيْكُمْ فَكُنتُم بِهَا تُكَذِّبُونَ',
		number_in_surah: '105',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2779',
		number: '2779',
		text: 'قَالُوا۟ رَبَّنَا غَلَبَتْ عَلَيْنَا شِقْوَتُنَا وَكُنَّا قَوْمًۭا ضَآلِّينَ',
		number_in_surah: '106',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2780',
		number: '2780',
		text: 'رَبَّنَآ أَخْرِجْنَا مِنْهَا فَإِنْ عُدْنَا فَإِنَّا ظَٰلِمُونَ',
		number_in_surah: '107',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2781',
		number: '2781',
		text: 'قَالَ ٱخْسَـُٔوا۟ فِيهَا وَلَا تُكَلِّمُونِ',
		number_in_surah: '108',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2782',
		number: '2782',
		text: 'إِنَّهُۥ كَانَ فَرِيقٌۭ مِّنْ عِبَادِى يَقُولُونَ رَبَّنَآ ءَامَنَّا فَٱغْفِرْ لَنَا وَٱرْحَمْنَا وَأَنتَ خَيْرُ ٱلرَّٰحِمِينَ',
		number_in_surah: '109',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2783',
		number: '2783',
		text: 'فَٱتَّخَذْتُمُوهُمْ سِخْرِيًّا حَتَّىٰٓ أَنسَوْكُمْ ذِكْرِى وَكُنتُم مِّنْهُمْ تَضْحَكُونَ',
		number_in_surah: '110',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2784',
		number: '2784',
		text: 'إِنِّى جَزَيْتُهُمُ ٱلْيَوْمَ بِمَا صَبَرُوٓا۟ أَنَّهُمْ هُمُ ٱلْفَآئِزُونَ',
		number_in_surah: '111',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2785',
		number: '2785',
		text: 'قَٰلَ كَمْ لَبِثْتُمْ فِى ٱلْأَرْضِ عَدَدَ سِنِينَ',
		number_in_surah: '112',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2786',
		number: '2786',
		text: 'قَالُوا۟ لَبِثْنَا يَوْمًا أَوْ بَعْضَ يَوْمٍۢ فَسْـَٔلِ ٱلْعَآدِّينَ',
		number_in_surah: '113',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2787',
		number: '2787',
		text: 'قَٰلَ إِن لَّبِثْتُمْ إِلَّا قَلِيلًۭا ۖ لَّوْ أَنَّكُمْ كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '114',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2788',
		number: '2788',
		text: 'أَفَحَسِبْتُمْ أَنَّمَا خَلَقْنَٰكُمْ عَبَثًۭا وَأَنَّكُمْ إِلَيْنَا لَا تُرْجَعُونَ',
		number_in_surah: '115',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2789',
		number: '2789',
		text: 'فَتَعَٰلَى ٱللَّهُ ٱلْمَلِكُ ٱلْحَقُّ ۖ لَآ إِلَٰهَ إِلَّا هُوَ رَبُّ ٱلْعَرْشِ ٱلْكَرِيمِ',
		number_in_surah: '116',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2790',
		number: '2790',
		text: 'وَمَن يَدْعُ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ لَا بُرْهَٰنَ لَهُۥ بِهِۦ فَإِنَّمَا حِسَابُهُۥ عِندَ رَبِّهِۦٓ ۚ إِنَّهُۥ لَا يُفْلِحُ ٱلْكَٰفِرُونَ',
		number_in_surah: '117',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2791',
		number: '2791',
		text: 'وَقُل رَّبِّ ٱغْفِرْ وَٱرْحَمْ وَأَنتَ خَيْرُ ٱلرَّٰحِمِينَ',
		number_in_surah: '118',
		page: '349',
		surah_id: '23',
		hizb_id: '139',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2792',
		number: '2792',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ سُورَةٌ أَنزَلْنَٰهَا وَفَرَضْنَٰهَا وَأَنزَلْنَا فِيهَآ ءَايَٰتٍۭ بَيِّنَٰتٍۢ لَّعَلَّكُمْ تَذَكَّرُونَ',
		number_in_surah: '1',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2793',
		number: '2793',
		text: 'ٱلزَّانِيَةُ وَٱلزَّانِى فَٱجْلِدُوا۟ كُلَّ وَٰحِدٍۢ مِّنْهُمَا مِا۟ئَةَ جَلْدَةٍۢ ۖ وَلَا تَأْخُذْكُم بِهِمَا رَأْفَةٌۭ فِى دِينِ ٱللَّهِ إِن كُنتُمْ تُؤْمِنُونَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ ۖ وَلْيَشْهَدْ عَذَابَهُمَا طَآئِفَةٌۭ مِّنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '2',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2794',
		number: '2794',
		text: 'ٱلزَّانِى لَا يَنكِحُ إِلَّا زَانِيَةً أَوْ مُشْرِكَةًۭ وَٱلزَّانِيَةُ لَا يَنكِحُهَآ إِلَّا زَانٍ أَوْ مُشْرِكٌۭ ۚ وَحُرِّمَ ذَٰلِكَ عَلَى ٱلْمُؤْمِنِينَ',
		number_in_surah: '3',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2795',
		number: '2795',
		text: 'وَٱلَّذِينَ يَرْمُونَ ٱلْمُحْصَنَٰتِ ثُمَّ لَمْ يَأْتُوا۟ بِأَرْبَعَةِ شُهَدَآءَ فَٱجْلِدُوهُمْ ثَمَٰنِينَ جَلْدَةًۭ وَلَا تَقْبَلُوا۟ لَهُمْ شَهَٰدَةً أَبَدًۭا ۚ وَأُو۟لَٰٓئِكَ هُمُ ٱلْفَٰسِقُونَ',
		number_in_surah: '4',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2796',
		number: '2796',
		text: 'إِلَّا ٱلَّذِينَ تَابُوا۟ مِنۢ بَعْدِ ذَٰلِكَ وَأَصْلَحُوا۟ فَإِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '5',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2797',
		number: '2797',
		text: 'وَٱلَّذِينَ يَرْمُونَ أَزْوَٰجَهُمْ وَلَمْ يَكُن لَّهُمْ شُهَدَآءُ إِلَّآ أَنفُسُهُمْ فَشَهَٰدَةُ أَحَدِهِمْ أَرْبَعُ شَهَٰدَٰتٍۭ بِٱللَّهِ ۙ إِنَّهُۥ لَمِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '6',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2798',
		number: '2798',
		text: 'وَٱلْخَٰمِسَةُ أَنَّ لَعْنَتَ ٱللَّهِ عَلَيْهِ إِن كَانَ مِنَ ٱلْكَٰذِبِينَ',
		number_in_surah: '7',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2799',
		number: '2799',
		text: 'وَيَدْرَؤُا۟ عَنْهَا ٱلْعَذَابَ أَن تَشْهَدَ أَرْبَعَ شَهَٰدَٰتٍۭ بِٱللَّهِ ۙ إِنَّهُۥ لَمِنَ ٱلْكَٰذِبِينَ',
		number_in_surah: '8',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2800',
		number: '2800',
		text: 'وَٱلْخَٰمِسَةَ أَنَّ غَضَبَ ٱللَّهِ عَلَيْهَآ إِن كَانَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '9',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2801',
		number: '2801',
		text: 'وَلَوْلَا فَضْلُ ٱللَّهِ عَلَيْكُمْ وَرَحْمَتُهُۥ وَأَنَّ ٱللَّهَ تَوَّابٌ حَكِيمٌ',
		number_in_surah: '10',
		page: '350',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2802',
		number: '2802',
		text: 'إِنَّ ٱلَّذِينَ جَآءُو بِٱلْإِفْكِ عُصْبَةٌۭ مِّنكُمْ ۚ لَا تَحْسَبُوهُ شَرًّۭا لَّكُم ۖ بَلْ هُوَ خَيْرٌۭ لَّكُمْ ۚ لِكُلِّ ٱمْرِئٍۢ مِّنْهُم مَّا ٱكْتَسَبَ مِنَ ٱلْإِثْمِ ۚ وَٱلَّذِى تَوَلَّىٰ كِبْرَهُۥ مِنْهُمْ لَهُۥ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '11',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2803',
		number: '2803',
		text: 'لَّوْلَآ إِذْ سَمِعْتُمُوهُ ظَنَّ ٱلْمُؤْمِنُونَ وَٱلْمُؤْمِنَٰتُ بِأَنفُسِهِمْ خَيْرًۭا وَقَالُوا۟ هَٰذَآ إِفْكٌۭ مُّبِينٌۭ',
		number_in_surah: '12',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2804',
		number: '2804',
		text: 'لَّوْلَا جَآءُو عَلَيْهِ بِأَرْبَعَةِ شُهَدَآءَ ۚ فَإِذْ لَمْ يَأْتُوا۟ بِٱلشُّهَدَآءِ فَأُو۟لَٰٓئِكَ عِندَ ٱللَّهِ هُمُ ٱلْكَٰذِبُونَ',
		number_in_surah: '13',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2805',
		number: '2805',
		text: 'وَلَوْلَا فَضْلُ ٱللَّهِ عَلَيْكُمْ وَرَحْمَتُهُۥ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ لَمَسَّكُمْ فِى مَآ أَفَضْتُمْ فِيهِ عَذَابٌ عَظِيمٌ',
		number_in_surah: '14',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2806',
		number: '2806',
		text: 'إِذْ تَلَقَّوْنَهُۥ بِأَلْسِنَتِكُمْ وَتَقُولُونَ بِأَفْوَاهِكُم مَّا لَيْسَ لَكُم بِهِۦ عِلْمٌۭ وَتَحْسَبُونَهُۥ هَيِّنًۭا وَهُوَ عِندَ ٱللَّهِ عَظِيمٌۭ',
		number_in_surah: '15',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2807',
		number: '2807',
		text: 'وَلَوْلَآ إِذْ سَمِعْتُمُوهُ قُلْتُم مَّا يَكُونُ لَنَآ أَن نَّتَكَلَّمَ بِهَٰذَا سُبْحَٰنَكَ هَٰذَا بُهْتَٰنٌ عَظِيمٌۭ',
		number_in_surah: '16',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2808',
		number: '2808',
		text: 'يَعِظُكُمُ ٱللَّهُ أَن تَعُودُوا۟ لِمِثْلِهِۦٓ أَبَدًا إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '17',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2809',
		number: '2809',
		text: 'وَيُبَيِّنُ ٱللَّهُ لَكُمُ ٱلْءَايَٰتِ ۚ وَٱللَّهُ عَلِيمٌ حَكِيمٌ',
		number_in_surah: '18',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2810',
		number: '2810',
		text: 'إِنَّ ٱلَّذِينَ يُحِبُّونَ أَن تَشِيعَ ٱلْفَٰحِشَةُ فِى ٱلَّذِينَ ءَامَنُوا۟ لَهُمْ عَذَابٌ أَلِيمٌۭ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ ۚ وَٱللَّهُ يَعْلَمُ وَأَنتُمْ لَا تَعْلَمُونَ',
		number_in_surah: '19',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2811',
		number: '2811',
		text: 'وَلَوْلَا فَضْلُ ٱللَّهِ عَلَيْكُمْ وَرَحْمَتُهُۥ وَأَنَّ ٱللَّهَ رَءُوفٌۭ رَّحِيمٌۭ',
		number_in_surah: '20',
		page: '351',
		surah_id: '24',
		hizb_id: '140',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2812',
		number: '2812',
		text: '۞ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَتَّبِعُوا۟ خُطُوَٰتِ ٱلشَّيْطَٰنِ ۚ وَمَن يَتَّبِعْ خُطُوَٰتِ ٱلشَّيْطَٰنِ فَإِنَّهُۥ يَأْمُرُ بِٱلْفَحْشَآءِ وَٱلْمُنكَرِ ۚ وَلَوْلَا فَضْلُ ٱللَّهِ عَلَيْكُمْ وَرَحْمَتُهُۥ مَا زَكَىٰ مِنكُم مِّنْ أَحَدٍ أَبَدًۭا وَلَٰكِنَّ ٱللَّهَ يُزَكِّى مَن يَشَآءُ ۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '21',
		page: '352',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2813',
		number: '2813',
		text: 'وَلَا يَأْتَلِ أُو۟لُوا۟ ٱلْفَضْلِ مِنكُمْ وَٱلسَّعَةِ أَن يُؤْتُوٓا۟ أُو۟لِى ٱلْقُرْبَىٰ وَٱلْمَسَٰكِينَ وَٱلْمُهَٰجِرِينَ فِى سَبِيلِ ٱللَّهِ ۖ وَلْيَعْفُوا۟ وَلْيَصْفَحُوٓا۟ ۗ أَلَا تُحِبُّونَ أَن يَغْفِرَ ٱللَّهُ لَكُمْ ۗ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '22',
		page: '352',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2814',
		number: '2814',
		text: 'إِنَّ ٱلَّذِينَ يَرْمُونَ ٱلْمُحْصَنَٰتِ ٱلْغَٰفِلَٰتِ ٱلْمُؤْمِنَٰتِ لُعِنُوا۟ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ وَلَهُمْ عَذَابٌ عَظِيمٌۭ',
		number_in_surah: '23',
		page: '352',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2815',
		number: '2815',
		text: 'يَوْمَ تَشْهَدُ عَلَيْهِمْ أَلْسِنَتُهُمْ وَأَيْدِيهِمْ وَأَرْجُلُهُم بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '24',
		page: '352',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2816',
		number: '2816',
		text: 'يَوْمَئِذٍۢ يُوَفِّيهِمُ ٱللَّهُ دِينَهُمُ ٱلْحَقَّ وَيَعْلَمُونَ أَنَّ ٱللَّهَ هُوَ ٱلْحَقُّ ٱلْمُبِينُ',
		number_in_surah: '25',
		page: '352',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2817',
		number: '2817',
		text: 'ٱلْخَبِيثَٰتُ لِلْخَبِيثِينَ وَٱلْخَبِيثُونَ لِلْخَبِيثَٰتِ ۖ وَٱلطَّيِّبَٰتُ لِلطَّيِّبِينَ وَٱلطَّيِّبُونَ لِلطَّيِّبَٰتِ ۚ أُو۟لَٰٓئِكَ مُبَرَّءُونَ مِمَّا يَقُولُونَ ۖ لَهُم مَّغْفِرَةٌۭ وَرِزْقٌۭ كَرِيمٌۭ',
		number_in_surah: '26',
		page: '352',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2818',
		number: '2818',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَدْخُلُوا۟ بُيُوتًا غَيْرَ بُيُوتِكُمْ حَتَّىٰ تَسْتَأْنِسُوا۟ وَتُسَلِّمُوا۟ عَلَىٰٓ أَهْلِهَا ۚ ذَٰلِكُمْ خَيْرٌۭ لَّكُمْ لَعَلَّكُمْ تَذَكَّرُونَ',
		number_in_surah: '27',
		page: '352',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2819',
		number: '2819',
		text: 'فَإِن لَّمْ تَجِدُوا۟ فِيهَآ أَحَدًۭا فَلَا تَدْخُلُوهَا حَتَّىٰ يُؤْذَنَ لَكُمْ ۖ وَإِن قِيلَ لَكُمُ ٱرْجِعُوا۟ فَٱرْجِعُوا۟ ۖ هُوَ أَزْكَىٰ لَكُمْ ۚ وَٱللَّهُ بِمَا تَعْمَلُونَ عَلِيمٌۭ',
		number_in_surah: '28',
		page: '353',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2820',
		number: '2820',
		text: 'لَّيْسَ عَلَيْكُمْ جُنَاحٌ أَن تَدْخُلُوا۟ بُيُوتًا غَيْرَ مَسْكُونَةٍۢ فِيهَا مَتَٰعٌۭ لَّكُمْ ۚ وَٱللَّهُ يَعْلَمُ مَا تُبْدُونَ وَمَا تَكْتُمُونَ',
		number_in_surah: '29',
		page: '353',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2821',
		number: '2821',
		text: 'قُل لِّلْمُؤْمِنِينَ يَغُضُّوا۟ مِنْ أَبْصَٰرِهِمْ وَيَحْفَظُوا۟ فُرُوجَهُمْ ۚ ذَٰلِكَ أَزْكَىٰ لَهُمْ ۗ إِنَّ ٱللَّهَ خَبِيرٌۢ بِمَا يَصْنَعُونَ',
		number_in_surah: '30',
		page: '353',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2822',
		number: '2822',
		text: 'وَقُل لِّلْمُؤْمِنَٰتِ يَغْضُضْنَ مِنْ أَبْصَٰرِهِنَّ وَيَحْفَظْنَ فُرُوجَهُنَّ وَلَا يُبْدِينَ زِينَتَهُنَّ إِلَّا مَا ظَهَرَ مِنْهَا ۖ وَلْيَضْرِبْنَ بِخُمُرِهِنَّ عَلَىٰ جُيُوبِهِنَّ ۖ وَلَا يُبْدِينَ زِينَتَهُنَّ إِلَّا لِبُعُولَتِهِنَّ أَوْ ءَابَآئِهِنَّ أَوْ ءَابَآءِ بُعُولَتِهِنَّ أَوْ أَبْنَآئِهِنَّ أَوْ أَبْنَآءِ بُعُولَتِهِنَّ أَوْ إِخْوَٰنِهِنَّ أَوْ بَنِىٓ إِخْوَٰنِهِنَّ أَوْ بَنِىٓ أَخَوَٰتِهِنَّ أَوْ نِسَآئِهِنَّ أَوْ مَا مَلَكَتْ أَيْمَٰنُهُنَّ أَوِ ٱلتَّٰبِعِينَ غَيْرِ أُو۟لِى ٱلْإِرْبَةِ مِنَ ٱلرِّجَالِ أَوِ ٱلطِّفْلِ ٱلَّذِينَ لَمْ يَظْهَرُوا۟ عَلَىٰ عَوْرَٰتِ ٱلنِّسَآءِ ۖ وَلَا يَضْرِبْنَ بِأَرْجُلِهِنَّ لِيُعْلَمَ مَا يُخْفِينَ مِن زِينَتِهِنَّ ۚ وَتُوبُوٓا۟ إِلَى ٱللَّهِ جَمِيعًا أَيُّهَ ٱلْمُؤْمِنُونَ لَعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '31',
		page: '353',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2823',
		number: '2823',
		text: 'وَأَنكِحُوا۟ ٱلْأَيَٰمَىٰ مِنكُمْ وَٱلصَّٰلِحِينَ مِنْ عِبَادِكُمْ وَإِمَآئِكُمْ ۚ إِن يَكُونُوا۟ فُقَرَآءَ يُغْنِهِمُ ٱللَّهُ مِن فَضْلِهِۦ ۗ وَٱللَّهُ وَٰسِعٌ عَلِيمٌۭ',
		number_in_surah: '32',
		page: '354',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2824',
		number: '2824',
		text: 'وَلْيَسْتَعْفِفِ ٱلَّذِينَ لَا يَجِدُونَ نِكَاحًا حَتَّىٰ يُغْنِيَهُمُ ٱللَّهُ مِن فَضْلِهِۦ ۗ وَٱلَّذِينَ يَبْتَغُونَ ٱلْكِتَٰبَ مِمَّا مَلَكَتْ أَيْمَٰنُكُمْ فَكَاتِبُوهُمْ إِنْ عَلِمْتُمْ فِيهِمْ خَيْرًۭا ۖ وَءَاتُوهُم مِّن مَّالِ ٱللَّهِ ٱلَّذِىٓ ءَاتَىٰكُمْ ۚ وَلَا تُكْرِهُوا۟ فَتَيَٰتِكُمْ عَلَى ٱلْبِغَآءِ إِنْ أَرَدْنَ تَحَصُّنًۭا لِّتَبْتَغُوا۟ عَرَضَ ٱلْحَيَوٰةِ ٱلدُّنْيَا ۚ وَمَن يُكْرِههُّنَّ فَإِنَّ ٱللَّهَ مِنۢ بَعْدِ إِكْرَٰهِهِنَّ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '33',
		page: '354',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2825',
		number: '2825',
		text: 'وَلَقَدْ أَنزَلْنَآ إِلَيْكُمْ ءَايَٰتٍۢ مُّبَيِّنَٰتٍۢ وَمَثَلًۭا مِّنَ ٱلَّذِينَ خَلَوْا۟ مِن قَبْلِكُمْ وَمَوْعِظَةًۭ لِّلْمُتَّقِينَ',
		number_in_surah: '34',
		page: '354',
		surah_id: '24',
		hizb_id: '141',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2826',
		number: '2826',
		text: '۞ ٱللَّهُ نُورُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ مَثَلُ نُورِهِۦ كَمِشْكَوٰةٍۢ فِيهَا مِصْبَاحٌ ۖ ٱلْمِصْبَاحُ فِى زُجَاجَةٍ ۖ ٱلزُّجَاجَةُ كَأَنَّهَا كَوْكَبٌۭ دُرِّىٌّۭ يُوقَدُ مِن شَجَرَةٍۢ مُّبَٰرَكَةٍۢ زَيْتُونَةٍۢ لَّا شَرْقِيَّةٍۢ وَلَا غَرْبِيَّةٍۢ يَكَادُ زَيْتُهَا يُضِىٓءُ وَلَوْ لَمْ تَمْسَسْهُ نَارٌۭ ۚ نُّورٌ عَلَىٰ نُورٍۢ ۗ يَهْدِى ٱللَّهُ لِنُورِهِۦ مَن يَشَآءُ ۚ وَيَضْرِبُ ٱللَّهُ ٱلْأَمْثَٰلَ لِلنَّاسِ ۗ وَٱللَّهُ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '35',
		page: '354',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2827',
		number: '2827',
		text: 'فِى بُيُوتٍ أَذِنَ ٱللَّهُ أَن تُرْفَعَ وَيُذْكَرَ فِيهَا ٱسْمُهُۥ يُسَبِّحُ لَهُۥ فِيهَا بِٱلْغُدُوِّ وَٱلْءَاصَالِ',
		number_in_surah: '36',
		page: '354',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2828',
		number: '2828',
		text: 'رِجَالٌۭ لَّا تُلْهِيهِمْ تِجَٰرَةٌۭ وَلَا بَيْعٌ عَن ذِكْرِ ٱللَّهِ وَإِقَامِ ٱلصَّلَوٰةِ وَإِيتَآءِ ٱلزَّكَوٰةِ ۙ يَخَافُونَ يَوْمًۭا تَتَقَلَّبُ فِيهِ ٱلْقُلُوبُ وَٱلْأَبْصَٰرُ',
		number_in_surah: '37',
		page: '355',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2829',
		number: '2829',
		text: 'لِيَجْزِيَهُمُ ٱللَّهُ أَحْسَنَ مَا عَمِلُوا۟ وَيَزِيدَهُم مِّن فَضْلِهِۦ ۗ وَٱللَّهُ يَرْزُقُ مَن يَشَآءُ بِغَيْرِ حِسَابٍۢ',
		number_in_surah: '38',
		page: '355',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2830',
		number: '2830',
		text: 'وَٱلَّذِينَ كَفَرُوٓا۟ أَعْمَٰلُهُمْ كَسَرَابٍۭ بِقِيعَةٍۢ يَحْسَبُهُ ٱلظَّمْـَٔانُ مَآءً حَتَّىٰٓ إِذَا جَآءَهُۥ لَمْ يَجِدْهُ شَيْـًۭٔا وَوَجَدَ ٱللَّهَ عِندَهُۥ فَوَفَّىٰهُ حِسَابَهُۥ ۗ وَٱللَّهُ سَرِيعُ ٱلْحِسَابِ',
		number_in_surah: '39',
		page: '355',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2831',
		number: '2831',
		text: 'أَوْ كَظُلُمَٰتٍۢ فِى بَحْرٍۢ لُّجِّىٍّۢ يَغْشَىٰهُ مَوْجٌۭ مِّن فَوْقِهِۦ مَوْجٌۭ مِّن فَوْقِهِۦ سَحَابٌۭ ۚ ظُلُمَٰتٌۢ بَعْضُهَا فَوْقَ بَعْضٍ إِذَآ أَخْرَجَ يَدَهُۥ لَمْ يَكَدْ يَرَىٰهَا ۗ وَمَن لَّمْ يَجْعَلِ ٱللَّهُ لَهُۥ نُورًۭا فَمَا لَهُۥ مِن نُّورٍ',
		number_in_surah: '40',
		page: '355',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2832',
		number: '2832',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ يُسَبِّحُ لَهُۥ مَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَٱلطَّيْرُ صَٰٓفَّٰتٍۢ ۖ كُلٌّۭ قَدْ عَلِمَ صَلَاتَهُۥ وَتَسْبِيحَهُۥ ۗ وَٱللَّهُ عَلِيمٌۢ بِمَا يَفْعَلُونَ',
		number_in_surah: '41',
		page: '355',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2833',
		number: '2833',
		text: 'وَلِلَّهِ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ وَإِلَى ٱللَّهِ ٱلْمَصِيرُ',
		number_in_surah: '42',
		page: '355',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2834',
		number: '2834',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ يُزْجِى سَحَابًۭا ثُمَّ يُؤَلِّفُ بَيْنَهُۥ ثُمَّ يَجْعَلُهُۥ رُكَامًۭا فَتَرَى ٱلْوَدْقَ يَخْرُجُ مِنْ خِلَٰلِهِۦ وَيُنَزِّلُ مِنَ ٱلسَّمَآءِ مِن جِبَالٍۢ فِيهَا مِنۢ بَرَدٍۢ فَيُصِيبُ بِهِۦ مَن يَشَآءُ وَيَصْرِفُهُۥ عَن مَّن يَشَآءُ ۖ يَكَادُ سَنَا بَرْقِهِۦ يَذْهَبُ بِٱلْأَبْصَٰرِ',
		number_in_surah: '43',
		page: '355',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2835',
		number: '2835',
		text: 'يُقَلِّبُ ٱللَّهُ ٱلَّيْلَ وَٱلنَّهَارَ ۚ إِنَّ فِى ذَٰلِكَ لَعِبْرَةًۭ لِّأُو۟لِى ٱلْأَبْصَٰرِ',
		number_in_surah: '44',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2836',
		number: '2836',
		text: 'وَٱللَّهُ خَلَقَ كُلَّ دَآبَّةٍۢ مِّن مَّآءٍۢ ۖ فَمِنْهُم مَّن يَمْشِى عَلَىٰ بَطْنِهِۦ وَمِنْهُم مَّن يَمْشِى عَلَىٰ رِجْلَيْنِ وَمِنْهُم مَّن يَمْشِى عَلَىٰٓ أَرْبَعٍۢ ۚ يَخْلُقُ ٱللَّهُ مَا يَشَآءُ ۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '45',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2837',
		number: '2837',
		text: 'لَّقَدْ أَنزَلْنَآ ءَايَٰتٍۢ مُّبَيِّنَٰتٍۢ ۚ وَٱللَّهُ يَهْدِى مَن يَشَآءُ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '46',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2838',
		number: '2838',
		text: 'وَيَقُولُونَ ءَامَنَّا بِٱللَّهِ وَبِٱلرَّسُولِ وَأَطَعْنَا ثُمَّ يَتَوَلَّىٰ فَرِيقٌۭ مِّنْهُم مِّنۢ بَعْدِ ذَٰلِكَ ۚ وَمَآ أُو۟لَٰٓئِكَ بِٱلْمُؤْمِنِينَ',
		number_in_surah: '47',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2839',
		number: '2839',
		text: 'وَإِذَا دُعُوٓا۟ إِلَى ٱللَّهِ وَرَسُولِهِۦ لِيَحْكُمَ بَيْنَهُمْ إِذَا فَرِيقٌۭ مِّنْهُم مُّعْرِضُونَ',
		number_in_surah: '48',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2840',
		number: '2840',
		text: 'وَإِن يَكُن لَّهُمُ ٱلْحَقُّ يَأْتُوٓا۟ إِلَيْهِ مُذْعِنِينَ',
		number_in_surah: '49',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2841',
		number: '2841',
		text: 'أَفِى قُلُوبِهِم مَّرَضٌ أَمِ ٱرْتَابُوٓا۟ أَمْ يَخَافُونَ أَن يَحِيفَ ٱللَّهُ عَلَيْهِمْ وَرَسُولُهُۥ ۚ بَلْ أُو۟لَٰٓئِكَ هُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '50',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2842',
		number: '2842',
		text: 'إِنَّمَا كَانَ قَوْلَ ٱلْمُؤْمِنِينَ إِذَا دُعُوٓا۟ إِلَى ٱللَّهِ وَرَسُولِهِۦ لِيَحْكُمَ بَيْنَهُمْ أَن يَقُولُوا۟ سَمِعْنَا وَأَطَعْنَا ۚ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '51',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2843',
		number: '2843',
		text: 'وَمَن يُطِعِ ٱللَّهَ وَرَسُولَهُۥ وَيَخْشَ ٱللَّهَ وَيَتَّقْهِ فَأُو۟لَٰٓئِكَ هُمُ ٱلْفَآئِزُونَ',
		number_in_surah: '52',
		page: '356',
		surah_id: '24',
		hizb_id: '142',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2844',
		number: '2844',
		text: '۞ وَأَقْسَمُوا۟ بِٱللَّهِ جَهْدَ أَيْمَٰنِهِمْ لَئِنْ أَمَرْتَهُمْ لَيَخْرُجُنَّ ۖ قُل لَّا تُقْسِمُوا۟ ۖ طَاعَةٌۭ مَّعْرُوفَةٌ ۚ إِنَّ ٱللَّهَ خَبِيرٌۢ بِمَا تَعْمَلُونَ',
		number_in_surah: '53',
		page: '356',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2845',
		number: '2845',
		text: 'قُلْ أَطِيعُوا۟ ٱللَّهَ وَأَطِيعُوا۟ ٱلرَّسُولَ ۖ فَإِن تَوَلَّوْا۟ فَإِنَّمَا عَلَيْهِ مَا حُمِّلَ وَعَلَيْكُم مَّا حُمِّلْتُمْ ۖ وَإِن تُطِيعُوهُ تَهْتَدُوا۟ ۚ وَمَا عَلَى ٱلرَّسُولِ إِلَّا ٱلْبَلَٰغُ ٱلْمُبِينُ',
		number_in_surah: '54',
		page: '357',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2846',
		number: '2846',
		text: 'وَعَدَ ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ مِنكُمْ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَيَسْتَخْلِفَنَّهُمْ فِى ٱلْأَرْضِ كَمَا ٱسْتَخْلَفَ ٱلَّذِينَ مِن قَبْلِهِمْ وَلَيُمَكِّنَنَّ لَهُمْ دِينَهُمُ ٱلَّذِى ٱرْتَضَىٰ لَهُمْ وَلَيُبَدِّلَنَّهُم مِّنۢ بَعْدِ خَوْفِهِمْ أَمْنًۭا ۚ يَعْبُدُونَنِى لَا يُشْرِكُونَ بِى شَيْـًۭٔا ۚ وَمَن كَفَرَ بَعْدَ ذَٰلِكَ فَأُو۟لَٰٓئِكَ هُمُ ٱلْفَٰسِقُونَ',
		number_in_surah: '55',
		page: '357',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2847',
		number: '2847',
		text: 'وَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَءَاتُوا۟ ٱلزَّكَوٰةَ وَأَطِيعُوا۟ ٱلرَّسُولَ لَعَلَّكُمْ تُرْحَمُونَ',
		number_in_surah: '56',
		page: '357',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2848',
		number: '2848',
		text: 'لَا تَحْسَبَنَّ ٱلَّذِينَ كَفَرُوا۟ مُعْجِزِينَ فِى ٱلْأَرْضِ ۚ وَمَأْوَىٰهُمُ ٱلنَّارُ ۖ وَلَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '57',
		page: '357',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2849',
		number: '2849',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لِيَسْتَـْٔذِنكُمُ ٱلَّذِينَ مَلَكَتْ أَيْمَٰنُكُمْ وَٱلَّذِينَ لَمْ يَبْلُغُوا۟ ٱلْحُلُمَ مِنكُمْ ثَلَٰثَ مَرَّٰتٍۢ ۚ مِّن قَبْلِ صَلَوٰةِ ٱلْفَجْرِ وَحِينَ تَضَعُونَ ثِيَابَكُم مِّنَ ٱلظَّهِيرَةِ وَمِنۢ بَعْدِ صَلَوٰةِ ٱلْعِشَآءِ ۚ ثَلَٰثُ عَوْرَٰتٍۢ لَّكُمْ ۚ لَيْسَ عَلَيْكُمْ وَلَا عَلَيْهِمْ جُنَاحٌۢ بَعْدَهُنَّ ۚ طَوَّٰفُونَ عَلَيْكُم بَعْضُكُمْ عَلَىٰ بَعْضٍۢ ۚ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمُ ٱلْءَايَٰتِ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '58',
		page: '357',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2850',
		number: '2850',
		text: 'وَإِذَا بَلَغَ ٱلْأَطْفَٰلُ مِنكُمُ ٱلْحُلُمَ فَلْيَسْتَـْٔذِنُوا۟ كَمَا ٱسْتَـْٔذَنَ ٱلَّذِينَ مِن قَبْلِهِمْ ۚ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمْ ءَايَٰتِهِۦ ۗ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '59',
		page: '358',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2851',
		number: '2851',
		text: 'وَٱلْقَوَٰعِدُ مِنَ ٱلنِّسَآءِ ٱلَّٰتِى لَا يَرْجُونَ نِكَاحًۭا فَلَيْسَ عَلَيْهِنَّ جُنَاحٌ أَن يَضَعْنَ ثِيَابَهُنَّ غَيْرَ مُتَبَرِّجَٰتٍۭ بِزِينَةٍۢ ۖ وَأَن يَسْتَعْفِفْنَ خَيْرٌۭ لَّهُنَّ ۗ وَٱللَّهُ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '60',
		page: '358',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2852',
		number: '2852',
		text: 'لَّيْسَ عَلَى ٱلْأَعْمَىٰ حَرَجٌۭ وَلَا عَلَى ٱلْأَعْرَجِ حَرَجٌۭ وَلَا عَلَى ٱلْمَرِيضِ حَرَجٌۭ وَلَا عَلَىٰٓ أَنفُسِكُمْ أَن تَأْكُلُوا۟ مِنۢ بُيُوتِكُمْ أَوْ بُيُوتِ ءَابَآئِكُمْ أَوْ بُيُوتِ أُمَّهَٰتِكُمْ أَوْ بُيُوتِ إِخْوَٰنِكُمْ أَوْ بُيُوتِ أَخَوَٰتِكُمْ أَوْ بُيُوتِ أَعْمَٰمِكُمْ أَوْ بُيُوتِ عَمَّٰتِكُمْ أَوْ بُيُوتِ أَخْوَٰلِكُمْ أَوْ بُيُوتِ خَٰلَٰتِكُمْ أَوْ مَا مَلَكْتُم مَّفَاتِحَهُۥٓ أَوْ صَدِيقِكُمْ ۚ لَيْسَ عَلَيْكُمْ جُنَاحٌ أَن تَأْكُلُوا۟ جَمِيعًا أَوْ أَشْتَاتًۭا ۚ فَإِذَا دَخَلْتُم بُيُوتًۭا فَسَلِّمُوا۟ عَلَىٰٓ أَنفُسِكُمْ تَحِيَّةًۭ مِّنْ عِندِ ٱللَّهِ مُبَٰرَكَةًۭ طَيِّبَةًۭ ۚ كَذَٰلِكَ يُبَيِّنُ ٱللَّهُ لَكُمُ ٱلْءَايَٰتِ لَعَلَّكُمْ تَعْقِلُونَ',
		number_in_surah: '61',
		page: '358',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2853',
		number: '2853',
		text: 'إِنَّمَا ٱلْمُؤْمِنُونَ ٱلَّذِينَ ءَامَنُوا۟ بِٱللَّهِ وَرَسُولِهِۦ وَإِذَا كَانُوا۟ مَعَهُۥ عَلَىٰٓ أَمْرٍۢ جَامِعٍۢ لَّمْ يَذْهَبُوا۟ حَتَّىٰ يَسْتَـْٔذِنُوهُ ۚ إِنَّ ٱلَّذِينَ يَسْتَـْٔذِنُونَكَ أُو۟لَٰٓئِكَ ٱلَّذِينَ يُؤْمِنُونَ بِٱللَّهِ وَرَسُولِهِۦ ۚ فَإِذَا ٱسْتَـْٔذَنُوكَ لِبَعْضِ شَأْنِهِمْ فَأْذَن لِّمَن شِئْتَ مِنْهُمْ وَٱسْتَغْفِرْ لَهُمُ ٱللَّهَ ۚ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '62',
		page: '359',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2854',
		number: '2854',
		text: 'لَّا تَجْعَلُوا۟ دُعَآءَ ٱلرَّسُولِ بَيْنَكُمْ كَدُعَآءِ بَعْضِكُم بَعْضًۭا ۚ قَدْ يَعْلَمُ ٱللَّهُ ٱلَّذِينَ يَتَسَلَّلُونَ مِنكُمْ لِوَاذًۭا ۚ فَلْيَحْذَرِ ٱلَّذِينَ يُخَالِفُونَ عَنْ أَمْرِهِۦٓ أَن تُصِيبَهُمْ فِتْنَةٌ أَوْ يُصِيبَهُمْ عَذَابٌ أَلِيمٌ',
		number_in_surah: '63',
		page: '359',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2855',
		number: '2855',
		text: 'أَلَآ إِنَّ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ قَدْ يَعْلَمُ مَآ أَنتُمْ عَلَيْهِ وَيَوْمَ يُرْجَعُونَ إِلَيْهِ فَيُنَبِّئُهُم بِمَا عَمِلُوا۟ ۗ وَٱللَّهُ بِكُلِّ شَىْءٍ عَلِيمٌۢ',
		number_in_surah: '64',
		page: '359',
		surah_id: '24',
		hizb_id: '143',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2856',
		number: '2856',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ تَبَارَكَ ٱلَّذِى نَزَّلَ ٱلْفُرْقَانَ عَلَىٰ عَبْدِهِۦ لِيَكُونَ لِلْعَٰلَمِينَ نَذِيرًا',
		number_in_surah: '1',
		page: '359',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2857',
		number: '2857',
		text: 'ٱلَّذِى لَهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَلَمْ يَتَّخِذْ وَلَدًۭا وَلَمْ يَكُن لَّهُۥ شَرِيكٌۭ فِى ٱلْمُلْكِ وَخَلَقَ كُلَّ شَىْءٍۢ فَقَدَّرَهُۥ تَقْدِيرًۭا',
		number_in_surah: '2',
		page: '359',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2858',
		number: '2858',
		text: 'وَٱتَّخَذُوا۟ مِن دُونِهِۦٓ ءَالِهَةًۭ لَّا يَخْلُقُونَ شَيْـًۭٔا وَهُمْ يُخْلَقُونَ وَلَا يَمْلِكُونَ لِأَنفُسِهِمْ ضَرًّۭا وَلَا نَفْعًۭا وَلَا يَمْلِكُونَ مَوْتًۭا وَلَا حَيَوٰةًۭ وَلَا نُشُورًۭا',
		number_in_surah: '3',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2859',
		number: '2859',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوٓا۟ إِنْ هَٰذَآ إِلَّآ إِفْكٌ ٱفْتَرَىٰهُ وَأَعَانَهُۥ عَلَيْهِ قَوْمٌ ءَاخَرُونَ ۖ فَقَدْ جَآءُو ظُلْمًۭا وَزُورًۭا',
		number_in_surah: '4',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2860',
		number: '2860',
		text: 'وَقَالُوٓا۟ أَسَٰطِيرُ ٱلْأَوَّلِينَ ٱكْتَتَبَهَا فَهِىَ تُمْلَىٰ عَلَيْهِ بُكْرَةًۭ وَأَصِيلًۭا',
		number_in_surah: '5',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2861',
		number: '2861',
		text: 'قُلْ أَنزَلَهُ ٱلَّذِى يَعْلَمُ ٱلسِّرَّ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ إِنَّهُۥ كَانَ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '6',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2862',
		number: '2862',
		text: 'وَقَالُوا۟ مَالِ هَٰذَا ٱلرَّسُولِ يَأْكُلُ ٱلطَّعَامَ وَيَمْشِى فِى ٱلْأَسْوَاقِ ۙ لَوْلَآ أُنزِلَ إِلَيْهِ مَلَكٌۭ فَيَكُونَ مَعَهُۥ نَذِيرًا',
		number_in_surah: '7',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2863',
		number: '2863',
		text: 'أَوْ يُلْقَىٰٓ إِلَيْهِ كَنزٌ أَوْ تَكُونُ لَهُۥ جَنَّةٌۭ يَأْكُلُ مِنْهَا ۚ وَقَالَ ٱلظَّٰلِمُونَ إِن تَتَّبِعُونَ إِلَّا رَجُلًۭا مَّسْحُورًا',
		number_in_surah: '8',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2864',
		number: '2864',
		text: 'ٱنظُرْ كَيْفَ ضَرَبُوا۟ لَكَ ٱلْأَمْثَٰلَ فَضَلُّوا۟ فَلَا يَسْتَطِيعُونَ سَبِيلًۭا',
		number_in_surah: '9',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2865',
		number: '2865',
		text: 'تَبَارَكَ ٱلَّذِىٓ إِن شَآءَ جَعَلَ لَكَ خَيْرًۭا مِّن ذَٰلِكَ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ وَيَجْعَل لَّكَ قُصُورًۢا',
		number_in_surah: '10',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2866',
		number: '2866',
		text: 'بَلْ كَذَّبُوا۟ بِٱلسَّاعَةِ ۖ وَأَعْتَدْنَا لِمَن كَذَّبَ بِٱلسَّاعَةِ سَعِيرًا',
		number_in_surah: '11',
		page: '360',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2867',
		number: '2867',
		text: 'إِذَا رَأَتْهُم مِّن مَّكَانٍۭ بَعِيدٍۢ سَمِعُوا۟ لَهَا تَغَيُّظًۭا وَزَفِيرًۭا',
		number_in_surah: '12',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2868',
		number: '2868',
		text: 'وَإِذَآ أُلْقُوا۟ مِنْهَا مَكَانًۭا ضَيِّقًۭا مُّقَرَّنِينَ دَعَوْا۟ هُنَالِكَ ثُبُورًۭا',
		number_in_surah: '13',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2869',
		number: '2869',
		text: 'لَّا تَدْعُوا۟ ٱلْيَوْمَ ثُبُورًۭا وَٰحِدًۭا وَٱدْعُوا۟ ثُبُورًۭا كَثِيرًۭا',
		number_in_surah: '14',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2870',
		number: '2870',
		text: 'قُلْ أَذَٰلِكَ خَيْرٌ أَمْ جَنَّةُ ٱلْخُلْدِ ٱلَّتِى وُعِدَ ٱلْمُتَّقُونَ ۚ كَانَتْ لَهُمْ جَزَآءًۭ وَمَصِيرًۭا',
		number_in_surah: '15',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2871',
		number: '2871',
		text: 'لَّهُمْ فِيهَا مَا يَشَآءُونَ خَٰلِدِينَ ۚ كَانَ عَلَىٰ رَبِّكَ وَعْدًۭا مَّسْـُٔولًۭا',
		number_in_surah: '16',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2872',
		number: '2872',
		text: 'وَيَوْمَ يَحْشُرُهُمْ وَمَا يَعْبُدُونَ مِن دُونِ ٱللَّهِ فَيَقُولُ ءَأَنتُمْ أَضْلَلْتُمْ عِبَادِى هَٰٓؤُلَآءِ أَمْ هُمْ ضَلُّوا۟ ٱلسَّبِيلَ',
		number_in_surah: '17',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2873',
		number: '2873',
		text: 'قَالُوا۟ سُبْحَٰنَكَ مَا كَانَ يَنۢبَغِى لَنَآ أَن نَّتَّخِذَ مِن دُونِكَ مِنْ أَوْلِيَآءَ وَلَٰكِن مَّتَّعْتَهُمْ وَءَابَآءَهُمْ حَتَّىٰ نَسُوا۟ ٱلذِّكْرَ وَكَانُوا۟ قَوْمًۢا بُورًۭا',
		number_in_surah: '18',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2874',
		number: '2874',
		text: 'فَقَدْ كَذَّبُوكُم بِمَا تَقُولُونَ فَمَا تَسْتَطِيعُونَ صَرْفًۭا وَلَا نَصْرًۭا ۚ وَمَن يَظْلِم مِّنكُمْ نُذِقْهُ عَذَابًۭا كَبِيرًۭا',
		number_in_surah: '19',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2875',
		number: '2875',
		text: 'وَمَآ أَرْسَلْنَا قَبْلَكَ مِنَ ٱلْمُرْسَلِينَ إِلَّآ إِنَّهُمْ لَيَأْكُلُونَ ٱلطَّعَامَ وَيَمْشُونَ فِى ٱلْأَسْوَاقِ ۗ وَجَعَلْنَا بَعْضَكُمْ لِبَعْضٍۢ فِتْنَةً أَتَصْبِرُونَ ۗ وَكَانَ رَبُّكَ بَصِيرًۭا',
		number_in_surah: '20',
		page: '361',
		surah_id: '25',
		hizb_id: '144',
		juz_id: '18',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2876',
		number: '2876',
		text: '۞ وَقَالَ ٱلَّذِينَ لَا يَرْجُونَ لِقَآءَنَا لَوْلَآ أُنزِلَ عَلَيْنَا ٱلْمَلَٰٓئِكَةُ أَوْ نَرَىٰ رَبَّنَا ۗ لَقَدِ ٱسْتَكْبَرُوا۟ فِىٓ أَنفُسِهِمْ وَعَتَوْ عُتُوًّۭا كَبِيرًۭا',
		number_in_surah: '21',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2877',
		number: '2877',
		text: 'يَوْمَ يَرَوْنَ ٱلْمَلَٰٓئِكَةَ لَا بُشْرَىٰ يَوْمَئِذٍۢ لِّلْمُجْرِمِينَ وَيَقُولُونَ حِجْرًۭا مَّحْجُورًۭا',
		number_in_surah: '22',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2878',
		number: '2878',
		text: 'وَقَدِمْنَآ إِلَىٰ مَا عَمِلُوا۟ مِنْ عَمَلٍۢ فَجَعَلْنَٰهُ هَبَآءًۭ مَّنثُورًا',
		number_in_surah: '23',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2879',
		number: '2879',
		text: 'أَصْحَٰبُ ٱلْجَنَّةِ يَوْمَئِذٍ خَيْرٌۭ مُّسْتَقَرًّۭا وَأَحْسَنُ مَقِيلًۭا',
		number_in_surah: '24',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2880',
		number: '2880',
		text: 'وَيَوْمَ تَشَقَّقُ ٱلسَّمَآءُ بِٱلْغَمَٰمِ وَنُزِّلَ ٱلْمَلَٰٓئِكَةُ تَنزِيلًا',
		number_in_surah: '25',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2881',
		number: '2881',
		text: 'ٱلْمُلْكُ يَوْمَئِذٍ ٱلْحَقُّ لِلرَّحْمَٰنِ ۚ وَكَانَ يَوْمًا عَلَى ٱلْكَٰفِرِينَ عَسِيرًۭا',
		number_in_surah: '26',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2882',
		number: '2882',
		text: 'وَيَوْمَ يَعَضُّ ٱلظَّالِمُ عَلَىٰ يَدَيْهِ يَقُولُ يَٰلَيْتَنِى ٱتَّخَذْتُ مَعَ ٱلرَّسُولِ سَبِيلًۭا',
		number_in_surah: '27',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2883',
		number: '2883',
		text: 'يَٰوَيْلَتَىٰ لَيْتَنِى لَمْ أَتَّخِذْ فُلَانًا خَلِيلًۭا',
		number_in_surah: '28',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2884',
		number: '2884',
		text: 'لَّقَدْ أَضَلَّنِى عَنِ ٱلذِّكْرِ بَعْدَ إِذْ جَآءَنِى ۗ وَكَانَ ٱلشَّيْطَٰنُ لِلْإِنسَٰنِ خَذُولًۭا',
		number_in_surah: '29',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2885',
		number: '2885',
		text: 'وَقَالَ ٱلرَّسُولُ يَٰرَبِّ إِنَّ قَوْمِى ٱتَّخَذُوا۟ هَٰذَا ٱلْقُرْءَانَ مَهْجُورًۭا',
		number_in_surah: '30',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2886',
		number: '2886',
		text: 'وَكَذَٰلِكَ جَعَلْنَا لِكُلِّ نَبِىٍّ عَدُوًّۭا مِّنَ ٱلْمُجْرِمِينَ ۗ وَكَفَىٰ بِرَبِّكَ هَادِيًۭا وَنَصِيرًۭا',
		number_in_surah: '31',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2887',
		number: '2887',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ لَوْلَا نُزِّلَ عَلَيْهِ ٱلْقُرْءَانُ جُمْلَةًۭ وَٰحِدَةًۭ ۚ كَذَٰلِكَ لِنُثَبِّتَ بِهِۦ فُؤَادَكَ ۖ وَرَتَّلْنَٰهُ تَرْتِيلًۭا',
		number_in_surah: '32',
		page: '362',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2888',
		number: '2888',
		text: 'وَلَا يَأْتُونَكَ بِمَثَلٍ إِلَّا جِئْنَٰكَ بِٱلْحَقِّ وَأَحْسَنَ تَفْسِيرًا',
		number_in_surah: '33',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2889',
		number: '2889',
		text: 'ٱلَّذِينَ يُحْشَرُونَ عَلَىٰ وُجُوهِهِمْ إِلَىٰ جَهَنَّمَ أُو۟لَٰٓئِكَ شَرٌّۭ مَّكَانًۭا وَأَضَلُّ سَبِيلًۭا',
		number_in_surah: '34',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2890',
		number: '2890',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ وَجَعَلْنَا مَعَهُۥٓ أَخَاهُ هَٰرُونَ وَزِيرًۭا',
		number_in_surah: '35',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2891',
		number: '2891',
		text: 'فَقُلْنَا ٱذْهَبَآ إِلَى ٱلْقَوْمِ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِنَا فَدَمَّرْنَٰهُمْ تَدْمِيرًۭا',
		number_in_surah: '36',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2892',
		number: '2892',
		text: 'وَقَوْمَ نُوحٍۢ لَّمَّا كَذَّبُوا۟ ٱلرُّسُلَ أَغْرَقْنَٰهُمْ وَجَعَلْنَٰهُمْ لِلنَّاسِ ءَايَةًۭ ۖ وَأَعْتَدْنَا لِلظَّٰلِمِينَ عَذَابًا أَلِيمًۭا',
		number_in_surah: '37',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2893',
		number: '2893',
		text: 'وَعَادًۭا وَثَمُودَا۟ وَأَصْحَٰبَ ٱلرَّسِّ وَقُرُونًۢا بَيْنَ ذَٰلِكَ كَثِيرًۭا',
		number_in_surah: '38',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2894',
		number: '2894',
		text: 'وَكُلًّۭا ضَرَبْنَا لَهُ ٱلْأَمْثَٰلَ ۖ وَكُلًّۭا تَبَّرْنَا تَتْبِيرًۭا',
		number_in_surah: '39',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2895',
		number: '2895',
		text: 'وَلَقَدْ أَتَوْا۟ عَلَى ٱلْقَرْيَةِ ٱلَّتِىٓ أُمْطِرَتْ مَطَرَ ٱلسَّوْءِ ۚ أَفَلَمْ يَكُونُوا۟ يَرَوْنَهَا ۚ بَلْ كَانُوا۟ لَا يَرْجُونَ نُشُورًۭا',
		number_in_surah: '40',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2896',
		number: '2896',
		text: 'وَإِذَا رَأَوْكَ إِن يَتَّخِذُونَكَ إِلَّا هُزُوًا أَهَٰذَا ٱلَّذِى بَعَثَ ٱللَّهُ رَسُولًا',
		number_in_surah: '41',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2897',
		number: '2897',
		text: 'إِن كَادَ لَيُضِلُّنَا عَنْ ءَالِهَتِنَا لَوْلَآ أَن صَبَرْنَا عَلَيْهَا ۚ وَسَوْفَ يَعْلَمُونَ حِينَ يَرَوْنَ ٱلْعَذَابَ مَنْ أَضَلُّ سَبِيلًا',
		number_in_surah: '42',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2898',
		number: '2898',
		text: 'أَرَءَيْتَ مَنِ ٱتَّخَذَ إِلَٰهَهُۥ هَوَىٰهُ أَفَأَنتَ تَكُونُ عَلَيْهِ وَكِيلًا',
		number_in_surah: '43',
		page: '363',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2899',
		number: '2899',
		text: 'أَمْ تَحْسَبُ أَنَّ أَكْثَرَهُمْ يَسْمَعُونَ أَوْ يَعْقِلُونَ ۚ إِنْ هُمْ إِلَّا كَٱلْأَنْعَٰمِ ۖ بَلْ هُمْ أَضَلُّ سَبِيلًا',
		number_in_surah: '44',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2900',
		number: '2900',
		text: 'أَلَمْ تَرَ إِلَىٰ رَبِّكَ كَيْفَ مَدَّ ٱلظِّلَّ وَلَوْ شَآءَ لَجَعَلَهُۥ سَاكِنًۭا ثُمَّ جَعَلْنَا ٱلشَّمْسَ عَلَيْهِ دَلِيلًۭا',
		number_in_surah: '45',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2901',
		number: '2901',
		text: 'ثُمَّ قَبَضْنَٰهُ إِلَيْنَا قَبْضًۭا يَسِيرًۭا',
		number_in_surah: '46',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2902',
		number: '2902',
		text: 'وَهُوَ ٱلَّذِى جَعَلَ لَكُمُ ٱلَّيْلَ لِبَاسًۭا وَٱلنَّوْمَ سُبَاتًۭا وَجَعَلَ ٱلنَّهَارَ نُشُورًۭا',
		number_in_surah: '47',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2903',
		number: '2903',
		text: 'وَهُوَ ٱلَّذِىٓ أَرْسَلَ ٱلرِّيَٰحَ بُشْرًۢا بَيْنَ يَدَىْ رَحْمَتِهِۦ ۚ وَأَنزَلْنَا مِنَ ٱلسَّمَآءِ مَآءًۭ طَهُورًۭا',
		number_in_surah: '48',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2904',
		number: '2904',
		text: 'لِّنُحْۦِىَ بِهِۦ بَلْدَةًۭ مَّيْتًۭا وَنُسْقِيَهُۥ مِمَّا خَلَقْنَآ أَنْعَٰمًۭا وَأَنَاسِىَّ كَثِيرًۭا',
		number_in_surah: '49',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2905',
		number: '2905',
		text: 'وَلَقَدْ صَرَّفْنَٰهُ بَيْنَهُمْ لِيَذَّكَّرُوا۟ فَأَبَىٰٓ أَكْثَرُ ٱلنَّاسِ إِلَّا كُفُورًۭا',
		number_in_surah: '50',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2906',
		number: '2906',
		text: 'وَلَوْ شِئْنَا لَبَعَثْنَا فِى كُلِّ قَرْيَةٍۢ نَّذِيرًۭا',
		number_in_surah: '51',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2907',
		number: '2907',
		text: 'فَلَا تُطِعِ ٱلْكَٰفِرِينَ وَجَٰهِدْهُم بِهِۦ جِهَادًۭا كَبِيرًۭا',
		number_in_surah: '52',
		page: '364',
		surah_id: '25',
		hizb_id: '145',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2908',
		number: '2908',
		text: '۞ وَهُوَ ٱلَّذِى مَرَجَ ٱلْبَحْرَيْنِ هَٰذَا عَذْبٌۭ فُرَاتٌۭ وَهَٰذَا مِلْحٌ أُجَاجٌۭ وَجَعَلَ بَيْنَهُمَا بَرْزَخًۭا وَحِجْرًۭا مَّحْجُورًۭا',
		number_in_surah: '53',
		page: '364',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2909',
		number: '2909',
		text: 'وَهُوَ ٱلَّذِى خَلَقَ مِنَ ٱلْمَآءِ بَشَرًۭا فَجَعَلَهُۥ نَسَبًۭا وَصِهْرًۭا ۗ وَكَانَ رَبُّكَ قَدِيرًۭا',
		number_in_surah: '54',
		page: '364',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2910',
		number: '2910',
		text: 'وَيَعْبُدُونَ مِن دُونِ ٱللَّهِ مَا لَا يَنفَعُهُمْ وَلَا يَضُرُّهُمْ ۗ وَكَانَ ٱلْكَافِرُ عَلَىٰ رَبِّهِۦ ظَهِيرًۭا',
		number_in_surah: '55',
		page: '364',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2911',
		number: '2911',
		text: 'وَمَآ أَرْسَلْنَٰكَ إِلَّا مُبَشِّرًۭا وَنَذِيرًۭا',
		number_in_surah: '56',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2912',
		number: '2912',
		text: 'قُلْ مَآ أَسْـَٔلُكُمْ عَلَيْهِ مِنْ أَجْرٍ إِلَّا مَن شَآءَ أَن يَتَّخِذَ إِلَىٰ رَبِّهِۦ سَبِيلًۭا',
		number_in_surah: '57',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:03',
		updated_at: '2018-06-07 08:07:03',
	},
	{
		id: '2913',
		number: '2913',
		text: 'وَتَوَكَّلْ عَلَى ٱلْحَىِّ ٱلَّذِى لَا يَمُوتُ وَسَبِّحْ بِحَمْدِهِۦ ۚ وَكَفَىٰ بِهِۦ بِذُنُوبِ عِبَادِهِۦ خَبِيرًا',
		number_in_surah: '58',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2914',
		number: '2914',
		text: 'ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَمَا بَيْنَهُمَا فِى سِتَّةِ أَيَّامٍۢ ثُمَّ ٱسْتَوَىٰ عَلَى ٱلْعَرْشِ ۚ ٱلرَّحْمَٰنُ فَسْـَٔلْ بِهِۦ خَبِيرًۭا',
		number_in_surah: '59',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2915',
		number: '2915',
		text: 'وَإِذَا قِيلَ لَهُمُ ٱسْجُدُوا۟ لِلرَّحْمَٰنِ قَالُوا۟ وَمَا ٱلرَّحْمَٰنُ أَنَسْجُدُ لِمَا تَأْمُرُنَا وَزَادَهُمْ نُفُورًۭا ۩',
		number_in_surah: '60',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '1',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2916',
		number: '2916',
		text: 'تَبَارَكَ ٱلَّذِى جَعَلَ فِى ٱلسَّمَآءِ بُرُوجًۭا وَجَعَلَ فِيهَا سِرَٰجًۭا وَقَمَرًۭا مُّنِيرًۭا',
		number_in_surah: '61',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2917',
		number: '2917',
		text: 'وَهُوَ ٱلَّذِى جَعَلَ ٱلَّيْلَ وَٱلنَّهَارَ خِلْفَةًۭ لِّمَنْ أَرَادَ أَن يَذَّكَّرَ أَوْ أَرَادَ شُكُورًۭا',
		number_in_surah: '62',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2918',
		number: '2918',
		text: 'وَعِبَادُ ٱلرَّحْمَٰنِ ٱلَّذِينَ يَمْشُونَ عَلَى ٱلْأَرْضِ هَوْنًۭا وَإِذَا خَاطَبَهُمُ ٱلْجَٰهِلُونَ قَالُوا۟ سَلَٰمًۭا',
		number_in_surah: '63',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2919',
		number: '2919',
		text: 'وَٱلَّذِينَ يَبِيتُونَ لِرَبِّهِمْ سُجَّدًۭا وَقِيَٰمًۭا',
		number_in_surah: '64',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2920',
		number: '2920',
		text: 'وَٱلَّذِينَ يَقُولُونَ رَبَّنَا ٱصْرِفْ عَنَّا عَذَابَ جَهَنَّمَ ۖ إِنَّ عَذَابَهَا كَانَ غَرَامًا',
		number_in_surah: '65',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2921',
		number: '2921',
		text: 'إِنَّهَا سَآءَتْ مُسْتَقَرًّۭا وَمُقَامًۭا',
		number_in_surah: '66',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2922',
		number: '2922',
		text: 'وَٱلَّذِينَ إِذَآ أَنفَقُوا۟ لَمْ يُسْرِفُوا۟ وَلَمْ يَقْتُرُوا۟ وَكَانَ بَيْنَ ذَٰلِكَ قَوَامًۭا',
		number_in_surah: '67',
		page: '365',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2923',
		number: '2923',
		text: 'وَٱلَّذِينَ لَا يَدْعُونَ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ وَلَا يَقْتُلُونَ ٱلنَّفْسَ ٱلَّتِى حَرَّمَ ٱللَّهُ إِلَّا بِٱلْحَقِّ وَلَا يَزْنُونَ ۚ وَمَن يَفْعَلْ ذَٰلِكَ يَلْقَ أَثَامًۭا',
		number_in_surah: '68',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2924',
		number: '2924',
		text: 'يُضَٰعَفْ لَهُ ٱلْعَذَابُ يَوْمَ ٱلْقِيَٰمَةِ وَيَخْلُدْ فِيهِۦ مُهَانًا',
		number_in_surah: '69',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2925',
		number: '2925',
		text: 'إِلَّا مَن تَابَ وَءَامَنَ وَعَمِلَ عَمَلًۭا صَٰلِحًۭا فَأُو۟لَٰٓئِكَ يُبَدِّلُ ٱللَّهُ سَيِّـَٔاتِهِمْ حَسَنَٰتٍۢ ۗ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '70',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2926',
		number: '2926',
		text: 'وَمَن تَابَ وَعَمِلَ صَٰلِحًۭا فَإِنَّهُۥ يَتُوبُ إِلَى ٱللَّهِ مَتَابًۭا',
		number_in_surah: '71',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2927',
		number: '2927',
		text: 'وَٱلَّذِينَ لَا يَشْهَدُونَ ٱلزُّورَ وَإِذَا مَرُّوا۟ بِٱللَّغْوِ مَرُّوا۟ كِرَامًۭا',
		number_in_surah: '72',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2928',
		number: '2928',
		text: 'وَٱلَّذِينَ إِذَا ذُكِّرُوا۟ بِـَٔايَٰتِ رَبِّهِمْ لَمْ يَخِرُّوا۟ عَلَيْهَا صُمًّۭا وَعُمْيَانًۭا',
		number_in_surah: '73',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2929',
		number: '2929',
		text: 'وَٱلَّذِينَ يَقُولُونَ رَبَّنَا هَبْ لَنَا مِنْ أَزْوَٰجِنَا وَذُرِّيَّٰتِنَا قُرَّةَ أَعْيُنٍۢ وَٱجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا',
		number_in_surah: '74',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2930',
		number: '2930',
		text: 'أُو۟لَٰٓئِكَ يُجْزَوْنَ ٱلْغُرْفَةَ بِمَا صَبَرُوا۟ وَيُلَقَّوْنَ فِيهَا تَحِيَّةًۭ وَسَلَٰمًا',
		number_in_surah: '75',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2931',
		number: '2931',
		text: 'خَٰلِدِينَ فِيهَا ۚ حَسُنَتْ مُسْتَقَرًّۭا وَمُقَامًۭا',
		number_in_surah: '76',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2932',
		number: '2932',
		text: 'قُلْ مَا يَعْبَؤُا۟ بِكُمْ رَبِّى لَوْلَا دُعَآؤُكُمْ ۖ فَقَدْ كَذَّبْتُمْ فَسَوْفَ يَكُونُ لِزَامًۢا',
		number_in_surah: '77',
		page: '366',
		surah_id: '25',
		hizb_id: '146',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2933',
		number: '2933',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ طسٓمٓ',
		number_in_surah: '1',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2934',
		number: '2934',
		text: 'تِلْكَ ءَايَٰتُ ٱلْكِتَٰبِ ٱلْمُبِينِ',
		number_in_surah: '2',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2935',
		number: '2935',
		text: 'لَعَلَّكَ بَٰخِعٌۭ نَّفْسَكَ أَلَّا يَكُونُوا۟ مُؤْمِنِينَ',
		number_in_surah: '3',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2936',
		number: '2936',
		text: 'إِن نَّشَأْ نُنَزِّلْ عَلَيْهِم مِّنَ ٱلسَّمَآءِ ءَايَةًۭ فَظَلَّتْ أَعْنَٰقُهُمْ لَهَا خَٰضِعِينَ',
		number_in_surah: '4',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2937',
		number: '2937',
		text: 'وَمَا يَأْتِيهِم مِّن ذِكْرٍۢ مِّنَ ٱلرَّحْمَٰنِ مُحْدَثٍ إِلَّا كَانُوا۟ عَنْهُ مُعْرِضِينَ',
		number_in_surah: '5',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2938',
		number: '2938',
		text: 'فَقَدْ كَذَّبُوا۟ فَسَيَأْتِيهِمْ أَنۢبَٰٓؤُا۟ مَا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '6',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2939',
		number: '2939',
		text: 'أَوَلَمْ يَرَوْا۟ إِلَى ٱلْأَرْضِ كَمْ أَنۢبَتْنَا فِيهَا مِن كُلِّ زَوْجٍۢ كَرِيمٍ',
		number_in_surah: '7',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2940',
		number: '2940',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ ۖ وَمَا كَانَ أَكْثَرُهُم مُّؤْمِنِينَ',
		number_in_surah: '8',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2941',
		number: '2941',
		text: 'وَإِنَّ رَبَّكَ لَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '9',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2942',
		number: '2942',
		text: 'وَإِذْ نَادَىٰ رَبُّكَ مُوسَىٰٓ أَنِ ٱئْتِ ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '10',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2943',
		number: '2943',
		text: 'قَوْمَ فِرْعَوْنَ ۚ أَلَا يَتَّقُونَ',
		number_in_surah: '11',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2944',
		number: '2944',
		text: 'قَالَ رَبِّ إِنِّىٓ أَخَافُ أَن يُكَذِّبُونِ',
		number_in_surah: '12',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2945',
		number: '2945',
		text: 'وَيَضِيقُ صَدْرِى وَلَا يَنطَلِقُ لِسَانِى فَأَرْسِلْ إِلَىٰ هَٰرُونَ',
		number_in_surah: '13',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2946',
		number: '2946',
		text: 'وَلَهُمْ عَلَىَّ ذَنۢبٌۭ فَأَخَافُ أَن يَقْتُلُونِ',
		number_in_surah: '14',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2947',
		number: '2947',
		text: 'قَالَ كَلَّا ۖ فَٱذْهَبَا بِـَٔايَٰتِنَآ ۖ إِنَّا مَعَكُم مُّسْتَمِعُونَ',
		number_in_surah: '15',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2948',
		number: '2948',
		text: 'فَأْتِيَا فِرْعَوْنَ فَقُولَآ إِنَّا رَسُولُ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '16',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2949',
		number: '2949',
		text: 'أَنْ أَرْسِلْ مَعَنَا بَنِىٓ إِسْرَٰٓءِيلَ',
		number_in_surah: '17',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2950',
		number: '2950',
		text: 'قَالَ أَلَمْ نُرَبِّكَ فِينَا وَلِيدًۭا وَلَبِثْتَ فِينَا مِنْ عُمُرِكَ سِنِينَ',
		number_in_surah: '18',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2951',
		number: '2951',
		text: 'وَفَعَلْتَ فَعْلَتَكَ ٱلَّتِى فَعَلْتَ وَأَنتَ مِنَ ٱلْكَٰفِرِينَ',
		number_in_surah: '19',
		page: '367',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2952',
		number: '2952',
		text: 'قَالَ فَعَلْتُهَآ إِذًۭا وَأَنَا۠ مِنَ ٱلضَّآلِّينَ',
		number_in_surah: '20',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2953',
		number: '2953',
		text: 'فَفَرَرْتُ مِنكُمْ لَمَّا خِفْتُكُمْ فَوَهَبَ لِى رَبِّى حُكْمًۭا وَجَعَلَنِى مِنَ ٱلْمُرْسَلِينَ',
		number_in_surah: '21',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2954',
		number: '2954',
		text: 'وَتِلْكَ نِعْمَةٌۭ تَمُنُّهَا عَلَىَّ أَنْ عَبَّدتَّ بَنِىٓ إِسْرَٰٓءِيلَ',
		number_in_surah: '22',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2955',
		number: '2955',
		text: 'قَالَ فِرْعَوْنُ وَمَا رَبُّ ٱلْعَٰلَمِينَ',
		number_in_surah: '23',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2956',
		number: '2956',
		text: 'قَالَ رَبُّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَآ ۖ إِن كُنتُم مُّوقِنِينَ',
		number_in_surah: '24',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2957',
		number: '2957',
		text: 'قَالَ لِمَنْ حَوْلَهُۥٓ أَلَا تَسْتَمِعُونَ',
		number_in_surah: '25',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2958',
		number: '2958',
		text: 'قَالَ رَبُّكُمْ وَرَبُّ ءَابَآئِكُمُ ٱلْأَوَّلِينَ',
		number_in_surah: '26',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2959',
		number: '2959',
		text: 'قَالَ إِنَّ رَسُولَكُمُ ٱلَّذِىٓ أُرْسِلَ إِلَيْكُمْ لَمَجْنُونٌۭ',
		number_in_surah: '27',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2960',
		number: '2960',
		text: 'قَالَ رَبُّ ٱلْمَشْرِقِ وَٱلْمَغْرِبِ وَمَا بَيْنَهُمَآ ۖ إِن كُنتُمْ تَعْقِلُونَ',
		number_in_surah: '28',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2961',
		number: '2961',
		text: 'قَالَ لَئِنِ ٱتَّخَذْتَ إِلَٰهًا غَيْرِى لَأَجْعَلَنَّكَ مِنَ ٱلْمَسْجُونِينَ',
		number_in_surah: '29',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2962',
		number: '2962',
		text: 'قَالَ أَوَلَوْ جِئْتُكَ بِشَىْءٍۢ مُّبِينٍۢ',
		number_in_surah: '30',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2963',
		number: '2963',
		text: 'قَالَ فَأْتِ بِهِۦٓ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '31',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2964',
		number: '2964',
		text: 'فَأَلْقَىٰ عَصَاهُ فَإِذَا هِىَ ثُعْبَانٌۭ مُّبِينٌۭ',
		number_in_surah: '32',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2965',
		number: '2965',
		text: 'وَنَزَعَ يَدَهُۥ فَإِذَا هِىَ بَيْضَآءُ لِلنَّٰظِرِينَ',
		number_in_surah: '33',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2966',
		number: '2966',
		text: 'قَالَ لِلْمَلَإِ حَوْلَهُۥٓ إِنَّ هَٰذَا لَسَٰحِرٌ عَلِيمٌۭ',
		number_in_surah: '34',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2967',
		number: '2967',
		text: 'يُرِيدُ أَن يُخْرِجَكُم مِّنْ أَرْضِكُم بِسِحْرِهِۦ فَمَاذَا تَأْمُرُونَ',
		number_in_surah: '35',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2968',
		number: '2968',
		text: 'قَالُوٓا۟ أَرْجِهْ وَأَخَاهُ وَٱبْعَثْ فِى ٱلْمَدَآئِنِ حَٰشِرِينَ',
		number_in_surah: '36',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2969',
		number: '2969',
		text: 'يَأْتُوكَ بِكُلِّ سَحَّارٍ عَلِيمٍۢ',
		number_in_surah: '37',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2970',
		number: '2970',
		text: 'فَجُمِعَ ٱلسَّحَرَةُ لِمِيقَٰتِ يَوْمٍۢ مَّعْلُومٍۢ',
		number_in_surah: '38',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2971',
		number: '2971',
		text: 'وَقِيلَ لِلنَّاسِ هَلْ أَنتُم مُّجْتَمِعُونَ',
		number_in_surah: '39',
		page: '368',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2972',
		number: '2972',
		text: 'لَعَلَّنَا نَتَّبِعُ ٱلسَّحَرَةَ إِن كَانُوا۟ هُمُ ٱلْغَٰلِبِينَ',
		number_in_surah: '40',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2973',
		number: '2973',
		text: 'فَلَمَّا جَآءَ ٱلسَّحَرَةُ قَالُوا۟ لِفِرْعَوْنَ أَئِنَّ لَنَا لَأَجْرًا إِن كُنَّا نَحْنُ ٱلْغَٰلِبِينَ',
		number_in_surah: '41',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2974',
		number: '2974',
		text: 'قَالَ نَعَمْ وَإِنَّكُمْ إِذًۭا لَّمِنَ ٱلْمُقَرَّبِينَ',
		number_in_surah: '42',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2975',
		number: '2975',
		text: 'قَالَ لَهُم مُّوسَىٰٓ أَلْقُوا۟ مَآ أَنتُم مُّلْقُونَ',
		number_in_surah: '43',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2976',
		number: '2976',
		text: 'فَأَلْقَوْا۟ حِبَالَهُمْ وَعِصِيَّهُمْ وَقَالُوا۟ بِعِزَّةِ فِرْعَوْنَ إِنَّا لَنَحْنُ ٱلْغَٰلِبُونَ',
		number_in_surah: '44',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2977',
		number: '2977',
		text: 'فَأَلْقَىٰ مُوسَىٰ عَصَاهُ فَإِذَا هِىَ تَلْقَفُ مَا يَأْفِكُونَ',
		number_in_surah: '45',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2978',
		number: '2978',
		text: 'فَأُلْقِىَ ٱلسَّحَرَةُ سَٰجِدِينَ',
		number_in_surah: '46',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2979',
		number: '2979',
		text: 'قَالُوٓا۟ ءَامَنَّا بِرَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '47',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2980',
		number: '2980',
		text: 'رَبِّ مُوسَىٰ وَهَٰرُونَ',
		number_in_surah: '48',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2981',
		number: '2981',
		text: 'قَالَ ءَامَنتُمْ لَهُۥ قَبْلَ أَنْ ءَاذَنَ لَكُمْ ۖ إِنَّهُۥ لَكَبِيرُكُمُ ٱلَّذِى عَلَّمَكُمُ ٱلسِّحْرَ فَلَسَوْفَ تَعْلَمُونَ ۚ لَأُقَطِّعَنَّ أَيْدِيَكُمْ وَأَرْجُلَكُم مِّنْ خِلَٰفٍۢ وَلَأُصَلِّبَنَّكُمْ أَجْمَعِينَ',
		number_in_surah: '49',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2982',
		number: '2982',
		text: 'قَالُوا۟ لَا ضَيْرَ ۖ إِنَّآ إِلَىٰ رَبِّنَا مُنقَلِبُونَ',
		number_in_surah: '50',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2983',
		number: '2983',
		text: 'إِنَّا نَطْمَعُ أَن يَغْفِرَ لَنَا رَبُّنَا خَطَٰيَٰنَآ أَن كُنَّآ أَوَّلَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '51',
		page: '369',
		surah_id: '26',
		hizb_id: '147',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2984',
		number: '2984',
		text: '۞ وَأَوْحَيْنَآ إِلَىٰ مُوسَىٰٓ أَنْ أَسْرِ بِعِبَادِىٓ إِنَّكُم مُّتَّبَعُونَ',
		number_in_surah: '52',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2985',
		number: '2985',
		text: 'فَأَرْسَلَ فِرْعَوْنُ فِى ٱلْمَدَآئِنِ حَٰشِرِينَ',
		number_in_surah: '53',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2986',
		number: '2986',
		text: 'إِنَّ هَٰٓؤُلَآءِ لَشِرْذِمَةٌۭ قَلِيلُونَ',
		number_in_surah: '54',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2987',
		number: '2987',
		text: 'وَإِنَّهُمْ لَنَا لَغَآئِظُونَ',
		number_in_surah: '55',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2988',
		number: '2988',
		text: 'وَإِنَّا لَجَمِيعٌ حَٰذِرُونَ',
		number_in_surah: '56',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2989',
		number: '2989',
		text: 'فَأَخْرَجْنَٰهُم مِّن جَنَّٰتٍۢ وَعُيُونٍۢ',
		number_in_surah: '57',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2990',
		number: '2990',
		text: 'وَكُنُوزٍۢ وَمَقَامٍۢ كَرِيمٍۢ',
		number_in_surah: '58',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2991',
		number: '2991',
		text: 'كَذَٰلِكَ وَأَوْرَثْنَٰهَا بَنِىٓ إِسْرَٰٓءِيلَ',
		number_in_surah: '59',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2992',
		number: '2992',
		text: 'فَأَتْبَعُوهُم مُّشْرِقِينَ',
		number_in_surah: '60',
		page: '369',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2993',
		number: '2993',
		text: 'فَلَمَّا تَرَٰٓءَا ٱلْجَمْعَانِ قَالَ أَصْحَٰبُ مُوسَىٰٓ إِنَّا لَمُدْرَكُونَ',
		number_in_surah: '61',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2994',
		number: '2994',
		text: 'قَالَ كَلَّآ ۖ إِنَّ مَعِىَ رَبِّى سَيَهْدِينِ',
		number_in_surah: '62',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2995',
		number: '2995',
		text: 'فَأَوْحَيْنَآ إِلَىٰ مُوسَىٰٓ أَنِ ٱضْرِب بِّعَصَاكَ ٱلْبَحْرَ ۖ فَٱنفَلَقَ فَكَانَ كُلُّ فِرْقٍۢ كَٱلطَّوْدِ ٱلْعَظِيمِ',
		number_in_surah: '63',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2996',
		number: '2996',
		text: 'وَأَزْلَفْنَا ثَمَّ ٱلْءَاخَرِينَ',
		number_in_surah: '64',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2997',
		number: '2997',
		text: 'وَأَنجَيْنَا مُوسَىٰ وَمَن مَّعَهُۥٓ أَجْمَعِينَ',
		number_in_surah: '65',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2998',
		number: '2998',
		text: 'ثُمَّ أَغْرَقْنَا ٱلْءَاخَرِينَ',
		number_in_surah: '66',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '2999',
		number: '2999',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ ۖ وَمَا كَانَ أَكْثَرُهُم مُّؤْمِنِينَ',
		number_in_surah: '67',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3000',
		number: '3000',
		text: 'وَإِنَّ رَبَّكَ لَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '68',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3001',
		number: '3001',
		text: 'وَٱتْلُ عَلَيْهِمْ نَبَأَ إِبْرَٰهِيمَ',
		number_in_surah: '69',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3002',
		number: '3002',
		text: 'إِذْ قَالَ لِأَبِيهِ وَقَوْمِهِۦ مَا تَعْبُدُونَ',
		number_in_surah: '70',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3003',
		number: '3003',
		text: 'قَالُوا۟ نَعْبُدُ أَصْنَامًۭا فَنَظَلُّ لَهَا عَٰكِفِينَ',
		number_in_surah: '71',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3004',
		number: '3004',
		text: 'قَالَ هَلْ يَسْمَعُونَكُمْ إِذْ تَدْعُونَ',
		number_in_surah: '72',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3005',
		number: '3005',
		text: 'أَوْ يَنفَعُونَكُمْ أَوْ يَضُرُّونَ',
		number_in_surah: '73',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3006',
		number: '3006',
		text: 'قَالُوا۟ بَلْ وَجَدْنَآ ءَابَآءَنَا كَذَٰلِكَ يَفْعَلُونَ',
		number_in_surah: '74',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3007',
		number: '3007',
		text: 'قَالَ أَفَرَءَيْتُم مَّا كُنتُمْ تَعْبُدُونَ',
		number_in_surah: '75',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3008',
		number: '3008',
		text: 'أَنتُمْ وَءَابَآؤُكُمُ ٱلْأَقْدَمُونَ',
		number_in_surah: '76',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3009',
		number: '3009',
		text: 'فَإِنَّهُمْ عَدُوٌّۭ لِّىٓ إِلَّا رَبَّ ٱلْعَٰلَمِينَ',
		number_in_surah: '77',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3010',
		number: '3010',
		text: 'ٱلَّذِى خَلَقَنِى فَهُوَ يَهْدِينِ',
		number_in_surah: '78',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3011',
		number: '3011',
		text: 'وَٱلَّذِى هُوَ يُطْعِمُنِى وَيَسْقِينِ',
		number_in_surah: '79',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3012',
		number: '3012',
		text: 'وَإِذَا مَرِضْتُ فَهُوَ يَشْفِينِ',
		number_in_surah: '80',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3013',
		number: '3013',
		text: 'وَٱلَّذِى يُمِيتُنِى ثُمَّ يُحْيِينِ',
		number_in_surah: '81',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3014',
		number: '3014',
		text: 'وَٱلَّذِىٓ أَطْمَعُ أَن يَغْفِرَ لِى خَطِيٓـَٔتِى يَوْمَ ٱلدِّينِ',
		number_in_surah: '82',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3015',
		number: '3015',
		text: 'رَبِّ هَبْ لِى حُكْمًۭا وَأَلْحِقْنِى بِٱلصَّٰلِحِينَ',
		number_in_surah: '83',
		page: '370',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3016',
		number: '3016',
		text: 'وَٱجْعَل لِّى لِسَانَ صِدْقٍۢ فِى ٱلْءَاخِرِينَ',
		number_in_surah: '84',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3017',
		number: '3017',
		text: 'وَٱجْعَلْنِى مِن وَرَثَةِ جَنَّةِ ٱلنَّعِيمِ',
		number_in_surah: '85',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3018',
		number: '3018',
		text: 'وَٱغْفِرْ لِأَبِىٓ إِنَّهُۥ كَانَ مِنَ ٱلضَّآلِّينَ',
		number_in_surah: '86',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3019',
		number: '3019',
		text: 'وَلَا تُخْزِنِى يَوْمَ يُبْعَثُونَ',
		number_in_surah: '87',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3020',
		number: '3020',
		text: 'يَوْمَ لَا يَنفَعُ مَالٌۭ وَلَا بَنُونَ',
		number_in_surah: '88',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3021',
		number: '3021',
		text: 'إِلَّا مَنْ أَتَى ٱللَّهَ بِقَلْبٍۢ سَلِيمٍۢ',
		number_in_surah: '89',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3022',
		number: '3022',
		text: 'وَأُزْلِفَتِ ٱلْجَنَّةُ لِلْمُتَّقِينَ',
		number_in_surah: '90',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3023',
		number: '3023',
		text: 'وَبُرِّزَتِ ٱلْجَحِيمُ لِلْغَاوِينَ',
		number_in_surah: '91',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3024',
		number: '3024',
		text: 'وَقِيلَ لَهُمْ أَيْنَ مَا كُنتُمْ تَعْبُدُونَ',
		number_in_surah: '92',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3025',
		number: '3025',
		text: 'مِن دُونِ ٱللَّهِ هَلْ يَنصُرُونَكُمْ أَوْ يَنتَصِرُونَ',
		number_in_surah: '93',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3026',
		number: '3026',
		text: 'فَكُبْكِبُوا۟ فِيهَا هُمْ وَٱلْغَاوُۥنَ',
		number_in_surah: '94',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3027',
		number: '3027',
		text: 'وَجُنُودُ إِبْلِيسَ أَجْمَعُونَ',
		number_in_surah: '95',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3028',
		number: '3028',
		text: 'قَالُوا۟ وَهُمْ فِيهَا يَخْتَصِمُونَ',
		number_in_surah: '96',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3029',
		number: '3029',
		text: 'تَٱللَّهِ إِن كُنَّا لَفِى ضَلَٰلٍۢ مُّبِينٍ',
		number_in_surah: '97',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3030',
		number: '3030',
		text: 'إِذْ نُسَوِّيكُم بِرَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '98',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3031',
		number: '3031',
		text: 'وَمَآ أَضَلَّنَآ إِلَّا ٱلْمُجْرِمُونَ',
		number_in_surah: '99',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3032',
		number: '3032',
		text: 'فَمَا لَنَا مِن شَٰفِعِينَ',
		number_in_surah: '100',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3033',
		number: '3033',
		text: 'وَلَا صَدِيقٍ حَمِيمٍۢ',
		number_in_surah: '101',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3034',
		number: '3034',
		text: 'فَلَوْ أَنَّ لَنَا كَرَّةًۭ فَنَكُونَ مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '102',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3035',
		number: '3035',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ ۖ وَمَا كَانَ أَكْثَرُهُم مُّؤْمِنِينَ',
		number_in_surah: '103',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3036',
		number: '3036',
		text: 'وَإِنَّ رَبَّكَ لَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '104',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3037',
		number: '3037',
		text: 'كَذَّبَتْ قَوْمُ نُوحٍ ٱلْمُرْسَلِينَ',
		number_in_surah: '105',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3038',
		number: '3038',
		text: 'إِذْ قَالَ لَهُمْ أَخُوهُمْ نُوحٌ أَلَا تَتَّقُونَ',
		number_in_surah: '106',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3039',
		number: '3039',
		text: 'إِنِّى لَكُمْ رَسُولٌ أَمِينٌۭ',
		number_in_surah: '107',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3040',
		number: '3040',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '108',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3041',
		number: '3041',
		text: 'وَمَآ أَسْـَٔلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِىَ إِلَّا عَلَىٰ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '109',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3042',
		number: '3042',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '110',
		page: '371',
		surah_id: '26',
		hizb_id: '148',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3043',
		number: '3043',
		text: '۞ قَالُوٓا۟ أَنُؤْمِنُ لَكَ وَٱتَّبَعَكَ ٱلْأَرْذَلُونَ',
		number_in_surah: '111',
		page: '371',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3044',
		number: '3044',
		text: 'قَالَ وَمَا عِلْمِى بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '112',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3045',
		number: '3045',
		text: 'إِنْ حِسَابُهُمْ إِلَّا عَلَىٰ رَبِّى ۖ لَوْ تَشْعُرُونَ',
		number_in_surah: '113',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3046',
		number: '3046',
		text: 'وَمَآ أَنَا۠ بِطَارِدِ ٱلْمُؤْمِنِينَ',
		number_in_surah: '114',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3047',
		number: '3047',
		text: 'إِنْ أَنَا۠ إِلَّا نَذِيرٌۭ مُّبِينٌۭ',
		number_in_surah: '115',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3048',
		number: '3048',
		text: 'قَالُوا۟ لَئِن لَّمْ تَنتَهِ يَٰنُوحُ لَتَكُونَنَّ مِنَ ٱلْمَرْجُومِينَ',
		number_in_surah: '116',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3049',
		number: '3049',
		text: 'قَالَ رَبِّ إِنَّ قَوْمِى كَذَّبُونِ',
		number_in_surah: '117',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3050',
		number: '3050',
		text: 'فَٱفْتَحْ بَيْنِى وَبَيْنَهُمْ فَتْحًۭا وَنَجِّنِى وَمَن مَّعِىَ مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '118',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3051',
		number: '3051',
		text: 'فَأَنجَيْنَٰهُ وَمَن مَّعَهُۥ فِى ٱلْفُلْكِ ٱلْمَشْحُونِ',
		number_in_surah: '119',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3052',
		number: '3052',
		text: 'ثُمَّ أَغْرَقْنَا بَعْدُ ٱلْبَاقِينَ',
		number_in_surah: '120',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3053',
		number: '3053',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ ۖ وَمَا كَانَ أَكْثَرُهُم مُّؤْمِنِينَ',
		number_in_surah: '121',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3054',
		number: '3054',
		text: 'وَإِنَّ رَبَّكَ لَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '122',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3055',
		number: '3055',
		text: 'كَذَّبَتْ عَادٌ ٱلْمُرْسَلِينَ',
		number_in_surah: '123',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3056',
		number: '3056',
		text: 'إِذْ قَالَ لَهُمْ أَخُوهُمْ هُودٌ أَلَا تَتَّقُونَ',
		number_in_surah: '124',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3057',
		number: '3057',
		text: 'إِنِّى لَكُمْ رَسُولٌ أَمِينٌۭ',
		number_in_surah: '125',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3058',
		number: '3058',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '126',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3059',
		number: '3059',
		text: 'وَمَآ أَسْـَٔلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِىَ إِلَّا عَلَىٰ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '127',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3060',
		number: '3060',
		text: 'أَتَبْنُونَ بِكُلِّ رِيعٍ ءَايَةًۭ تَعْبَثُونَ',
		number_in_surah: '128',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3061',
		number: '3061',
		text: 'وَتَتَّخِذُونَ مَصَانِعَ لَعَلَّكُمْ تَخْلُدُونَ',
		number_in_surah: '129',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3062',
		number: '3062',
		text: 'وَإِذَا بَطَشْتُم بَطَشْتُمْ جَبَّارِينَ',
		number_in_surah: '130',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3063',
		number: '3063',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '131',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3064',
		number: '3064',
		text: 'وَٱتَّقُوا۟ ٱلَّذِىٓ أَمَدَّكُم بِمَا تَعْلَمُونَ',
		number_in_surah: '132',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3065',
		number: '3065',
		text: 'أَمَدَّكُم بِأَنْعَٰمٍۢ وَبَنِينَ',
		number_in_surah: '133',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3066',
		number: '3066',
		text: 'وَجَنَّٰتٍۢ وَعُيُونٍ',
		number_in_surah: '134',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3067',
		number: '3067',
		text: 'إِنِّىٓ أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ عَظِيمٍۢ',
		number_in_surah: '135',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3068',
		number: '3068',
		text: 'قَالُوا۟ سَوَآءٌ عَلَيْنَآ أَوَعَظْتَ أَمْ لَمْ تَكُن مِّنَ ٱلْوَٰعِظِينَ',
		number_in_surah: '136',
		page: '372',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3069',
		number: '3069',
		text: 'إِنْ هَٰذَآ إِلَّا خُلُقُ ٱلْأَوَّلِينَ',
		number_in_surah: '137',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3070',
		number: '3070',
		text: 'وَمَا نَحْنُ بِمُعَذَّبِينَ',
		number_in_surah: '138',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3071',
		number: '3071',
		text: 'فَكَذَّبُوهُ فَأَهْلَكْنَٰهُمْ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ ۖ وَمَا كَانَ أَكْثَرُهُم مُّؤْمِنِينَ',
		number_in_surah: '139',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3072',
		number: '3072',
		text: 'وَإِنَّ رَبَّكَ لَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '140',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3073',
		number: '3073',
		text: 'كَذَّبَتْ ثَمُودُ ٱلْمُرْسَلِينَ',
		number_in_surah: '141',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3074',
		number: '3074',
		text: 'إِذْ قَالَ لَهُمْ أَخُوهُمْ صَٰلِحٌ أَلَا تَتَّقُونَ',
		number_in_surah: '142',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3075',
		number: '3075',
		text: 'إِنِّى لَكُمْ رَسُولٌ أَمِينٌۭ',
		number_in_surah: '143',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3076',
		number: '3076',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '144',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3077',
		number: '3077',
		text: 'وَمَآ أَسْـَٔلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِىَ إِلَّا عَلَىٰ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '145',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3078',
		number: '3078',
		text: 'أَتُتْرَكُونَ فِى مَا هَٰهُنَآ ءَامِنِينَ',
		number_in_surah: '146',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3079',
		number: '3079',
		text: 'فِى جَنَّٰتٍۢ وَعُيُونٍۢ',
		number_in_surah: '147',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3080',
		number: '3080',
		text: 'وَزُرُوعٍۢ وَنَخْلٍۢ طَلْعُهَا هَضِيمٌۭ',
		number_in_surah: '148',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3081',
		number: '3081',
		text: 'وَتَنْحِتُونَ مِنَ ٱلْجِبَالِ بُيُوتًۭا فَٰرِهِينَ',
		number_in_surah: '149',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3082',
		number: '3082',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '150',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3083',
		number: '3083',
		text: 'وَلَا تُطِيعُوٓا۟ أَمْرَ ٱلْمُسْرِفِينَ',
		number_in_surah: '151',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3084',
		number: '3084',
		text: 'ٱلَّذِينَ يُفْسِدُونَ فِى ٱلْأَرْضِ وَلَا يُصْلِحُونَ',
		number_in_surah: '152',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3085',
		number: '3085',
		text: 'قَالُوٓا۟ إِنَّمَآ أَنتَ مِنَ ٱلْمُسَحَّرِينَ',
		number_in_surah: '153',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3086',
		number: '3086',
		text: 'مَآ أَنتَ إِلَّا بَشَرٌۭ مِّثْلُنَا فَأْتِ بِـَٔايَةٍ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '154',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3087',
		number: '3087',
		text: 'قَالَ هَٰذِهِۦ نَاقَةٌۭ لَّهَا شِرْبٌۭ وَلَكُمْ شِرْبُ يَوْمٍۢ مَّعْلُومٍۢ',
		number_in_surah: '155',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3088',
		number: '3088',
		text: 'وَلَا تَمَسُّوهَا بِسُوٓءٍۢ فَيَأْخُذَكُمْ عَذَابُ يَوْمٍ عَظِيمٍۢ',
		number_in_surah: '156',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3089',
		number: '3089',
		text: 'فَعَقَرُوهَا فَأَصْبَحُوا۟ نَٰدِمِينَ',
		number_in_surah: '157',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3090',
		number: '3090',
		text: 'فَأَخَذَهُمُ ٱلْعَذَابُ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ ۖ وَمَا كَانَ أَكْثَرُهُم مُّؤْمِنِينَ',
		number_in_surah: '158',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3091',
		number: '3091',
		text: 'وَإِنَّ رَبَّكَ لَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '159',
		page: '373',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3092',
		number: '3092',
		text: 'كَذَّبَتْ قَوْمُ لُوطٍ ٱلْمُرْسَلِينَ',
		number_in_surah: '160',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3093',
		number: '3093',
		text: 'إِذْ قَالَ لَهُمْ أَخُوهُمْ لُوطٌ أَلَا تَتَّقُونَ',
		number_in_surah: '161',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3094',
		number: '3094',
		text: 'إِنِّى لَكُمْ رَسُولٌ أَمِينٌۭ',
		number_in_surah: '162',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3095',
		number: '3095',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '163',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3096',
		number: '3096',
		text: 'وَمَآ أَسْـَٔلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِىَ إِلَّا عَلَىٰ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '164',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3097',
		number: '3097',
		text: 'أَتَأْتُونَ ٱلذُّكْرَانَ مِنَ ٱلْعَٰلَمِينَ',
		number_in_surah: '165',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3098',
		number: '3098',
		text: 'وَتَذَرُونَ مَا خَلَقَ لَكُمْ رَبُّكُم مِّنْ أَزْوَٰجِكُم ۚ بَلْ أَنتُمْ قَوْمٌ عَادُونَ',
		number_in_surah: '166',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3099',
		number: '3099',
		text: 'قَالُوا۟ لَئِن لَّمْ تَنتَهِ يَٰلُوطُ لَتَكُونَنَّ مِنَ ٱلْمُخْرَجِينَ',
		number_in_surah: '167',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3100',
		number: '3100',
		text: 'قَالَ إِنِّى لِعَمَلِكُم مِّنَ ٱلْقَالِينَ',
		number_in_surah: '168',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3101',
		number: '3101',
		text: 'رَبِّ نَجِّنِى وَأَهْلِى مِمَّا يَعْمَلُونَ',
		number_in_surah: '169',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3102',
		number: '3102',
		text: 'فَنَجَّيْنَٰهُ وَأَهْلَهُۥٓ أَجْمَعِينَ',
		number_in_surah: '170',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3103',
		number: '3103',
		text: 'إِلَّا عَجُوزًۭا فِى ٱلْغَٰبِرِينَ',
		number_in_surah: '171',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3104',
		number: '3104',
		text: 'ثُمَّ دَمَّرْنَا ٱلْءَاخَرِينَ',
		number_in_surah: '172',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3105',
		number: '3105',
		text: 'وَأَمْطَرْنَا عَلَيْهِم مَّطَرًۭا ۖ فَسَآءَ مَطَرُ ٱلْمُنذَرِينَ',
		number_in_surah: '173',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3106',
		number: '3106',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ ۖ وَمَا كَانَ أَكْثَرُهُم مُّؤْمِنِينَ',
		number_in_surah: '174',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3107',
		number: '3107',
		text: 'وَإِنَّ رَبَّكَ لَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '175',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3108',
		number: '3108',
		text: 'كَذَّبَ أَصْحَٰبُ لْـَٔيْكَةِ ٱلْمُرْسَلِينَ',
		number_in_surah: '176',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3109',
		number: '3109',
		text: 'إِذْ قَالَ لَهُمْ شُعَيْبٌ أَلَا تَتَّقُونَ',
		number_in_surah: '177',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3110',
		number: '3110',
		text: 'إِنِّى لَكُمْ رَسُولٌ أَمِينٌۭ',
		number_in_surah: '178',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3111',
		number: '3111',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '179',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3112',
		number: '3112',
		text: 'وَمَآ أَسْـَٔلُكُمْ عَلَيْهِ مِنْ أَجْرٍ ۖ إِنْ أَجْرِىَ إِلَّا عَلَىٰ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '180',
		page: '374',
		surah_id: '26',
		hizb_id: '149',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3113',
		number: '3113',
		text: '۞ أَوْفُوا۟ ٱلْكَيْلَ وَلَا تَكُونُوا۟ مِنَ ٱلْمُخْسِرِينَ',
		number_in_surah: '181',
		page: '374',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3114',
		number: '3114',
		text: 'وَزِنُوا۟ بِٱلْقِسْطَاسِ ٱلْمُسْتَقِيمِ',
		number_in_surah: '182',
		page: '374',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3115',
		number: '3115',
		text: 'وَلَا تَبْخَسُوا۟ ٱلنَّاسَ أَشْيَآءَهُمْ وَلَا تَعْثَوْا۟ فِى ٱلْأَرْضِ مُفْسِدِينَ',
		number_in_surah: '183',
		page: '374',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3116',
		number: '3116',
		text: 'وَٱتَّقُوا۟ ٱلَّذِى خَلَقَكُمْ وَٱلْجِبِلَّةَ ٱلْأَوَّلِينَ',
		number_in_surah: '184',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3117',
		number: '3117',
		text: 'قَالُوٓا۟ إِنَّمَآ أَنتَ مِنَ ٱلْمُسَحَّرِينَ',
		number_in_surah: '185',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3118',
		number: '3118',
		text: 'وَمَآ أَنتَ إِلَّا بَشَرٌۭ مِّثْلُنَا وَإِن نَّظُنُّكَ لَمِنَ ٱلْكَٰذِبِينَ',
		number_in_surah: '186',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3119',
		number: '3119',
		text: 'فَأَسْقِطْ عَلَيْنَا كِسَفًۭا مِّنَ ٱلسَّمَآءِ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '187',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3120',
		number: '3120',
		text: 'قَالَ رَبِّىٓ أَعْلَمُ بِمَا تَعْمَلُونَ',
		number_in_surah: '188',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3121',
		number: '3121',
		text: 'فَكَذَّبُوهُ فَأَخَذَهُمْ عَذَابُ يَوْمِ ٱلظُّلَّةِ ۚ إِنَّهُۥ كَانَ عَذَابَ يَوْمٍ عَظِيمٍ',
		number_in_surah: '189',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3122',
		number: '3122',
		text: 'إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ ۖ وَمَا كَانَ أَكْثَرُهُم مُّؤْمِنِينَ',
		number_in_surah: '190',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3123',
		number: '3123',
		text: 'وَإِنَّ رَبَّكَ لَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '191',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3124',
		number: '3124',
		text: 'وَإِنَّهُۥ لَتَنزِيلُ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '192',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3125',
		number: '3125',
		text: 'نَزَلَ بِهِ ٱلرُّوحُ ٱلْأَمِينُ',
		number_in_surah: '193',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3126',
		number: '3126',
		text: 'عَلَىٰ قَلْبِكَ لِتَكُونَ مِنَ ٱلْمُنذِرِينَ',
		number_in_surah: '194',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3127',
		number: '3127',
		text: 'بِلِسَانٍ عَرَبِىٍّۢ مُّبِينٍۢ',
		number_in_surah: '195',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3128',
		number: '3128',
		text: 'وَإِنَّهُۥ لَفِى زُبُرِ ٱلْأَوَّلِينَ',
		number_in_surah: '196',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3129',
		number: '3129',
		text: 'أَوَلَمْ يَكُن لَّهُمْ ءَايَةً أَن يَعْلَمَهُۥ عُلَمَٰٓؤُا۟ بَنِىٓ إِسْرَٰٓءِيلَ',
		number_in_surah: '197',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3130',
		number: '3130',
		text: 'وَلَوْ نَزَّلْنَٰهُ عَلَىٰ بَعْضِ ٱلْأَعْجَمِينَ',
		number_in_surah: '198',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3131',
		number: '3131',
		text: 'فَقَرَأَهُۥ عَلَيْهِم مَّا كَانُوا۟ بِهِۦ مُؤْمِنِينَ',
		number_in_surah: '199',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:04',
		updated_at: '2018-06-07 08:07:04',
	},
	{
		id: '3132',
		number: '3132',
		text: 'كَذَٰلِكَ سَلَكْنَٰهُ فِى قُلُوبِ ٱلْمُجْرِمِينَ',
		number_in_surah: '200',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3133',
		number: '3133',
		text: 'لَا يُؤْمِنُونَ بِهِۦ حَتَّىٰ يَرَوُا۟ ٱلْعَذَابَ ٱلْأَلِيمَ',
		number_in_surah: '201',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3134',
		number: '3134',
		text: 'فَيَأْتِيَهُم بَغْتَةًۭ وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '202',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3135',
		number: '3135',
		text: 'فَيَقُولُوا۟ هَلْ نَحْنُ مُنظَرُونَ',
		number_in_surah: '203',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3136',
		number: '3136',
		text: 'أَفَبِعَذَابِنَا يَسْتَعْجِلُونَ',
		number_in_surah: '204',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3137',
		number: '3137',
		text: 'أَفَرَءَيْتَ إِن مَّتَّعْنَٰهُمْ سِنِينَ',
		number_in_surah: '205',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3138',
		number: '3138',
		text: 'ثُمَّ جَآءَهُم مَّا كَانُوا۟ يُوعَدُونَ',
		number_in_surah: '206',
		page: '375',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3139',
		number: '3139',
		text: 'مَآ أَغْنَىٰ عَنْهُم مَّا كَانُوا۟ يُمَتَّعُونَ',
		number_in_surah: '207',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3140',
		number: '3140',
		text: 'وَمَآ أَهْلَكْنَا مِن قَرْيَةٍ إِلَّا لَهَا مُنذِرُونَ',
		number_in_surah: '208',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3141',
		number: '3141',
		text: 'ذِكْرَىٰ وَمَا كُنَّا ظَٰلِمِينَ',
		number_in_surah: '209',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3142',
		number: '3142',
		text: 'وَمَا تَنَزَّلَتْ بِهِ ٱلشَّيَٰطِينُ',
		number_in_surah: '210',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3143',
		number: '3143',
		text: 'وَمَا يَنۢبَغِى لَهُمْ وَمَا يَسْتَطِيعُونَ',
		number_in_surah: '211',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3144',
		number: '3144',
		text: 'إِنَّهُمْ عَنِ ٱلسَّمْعِ لَمَعْزُولُونَ',
		number_in_surah: '212',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3145',
		number: '3145',
		text: 'فَلَا تَدْعُ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ فَتَكُونَ مِنَ ٱلْمُعَذَّبِينَ',
		number_in_surah: '213',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3146',
		number: '3146',
		text: 'وَأَنذِرْ عَشِيرَتَكَ ٱلْأَقْرَبِينَ',
		number_in_surah: '214',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3147',
		number: '3147',
		text: 'وَٱخْفِضْ جَنَاحَكَ لِمَنِ ٱتَّبَعَكَ مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '215',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3148',
		number: '3148',
		text: 'فَإِنْ عَصَوْكَ فَقُلْ إِنِّى بَرِىٓءٌۭ مِّمَّا تَعْمَلُونَ',
		number_in_surah: '216',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3149',
		number: '3149',
		text: 'وَتَوَكَّلْ عَلَى ٱلْعَزِيزِ ٱلرَّحِيمِ',
		number_in_surah: '217',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3150',
		number: '3150',
		text: 'ٱلَّذِى يَرَىٰكَ حِينَ تَقُومُ',
		number_in_surah: '218',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3151',
		number: '3151',
		text: 'وَتَقَلُّبَكَ فِى ٱلسَّٰجِدِينَ',
		number_in_surah: '219',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3152',
		number: '3152',
		text: 'إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '220',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3153',
		number: '3153',
		text: 'هَلْ أُنَبِّئُكُمْ عَلَىٰ مَن تَنَزَّلُ ٱلشَّيَٰطِينُ',
		number_in_surah: '221',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3154',
		number: '3154',
		text: 'تَنَزَّلُ عَلَىٰ كُلِّ أَفَّاكٍ أَثِيمٍۢ',
		number_in_surah: '222',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3155',
		number: '3155',
		text: 'يُلْقُونَ ٱلسَّمْعَ وَأَكْثَرُهُمْ كَٰذِبُونَ',
		number_in_surah: '223',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3156',
		number: '3156',
		text: 'وَٱلشُّعَرَآءُ يَتَّبِعُهُمُ ٱلْغَاوُۥنَ',
		number_in_surah: '224',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3157',
		number: '3157',
		text: 'أَلَمْ تَرَ أَنَّهُمْ فِى كُلِّ وَادٍۢ يَهِيمُونَ',
		number_in_surah: '225',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3158',
		number: '3158',
		text: 'وَأَنَّهُمْ يَقُولُونَ مَا لَا يَفْعَلُونَ',
		number_in_surah: '226',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3159',
		number: '3159',
		text: 'إِلَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ وَذَكَرُوا۟ ٱللَّهَ كَثِيرًۭا وَٱنتَصَرُوا۟ مِنۢ بَعْدِ مَا ظُلِمُوا۟ ۗ وَسَيَعْلَمُ ٱلَّذِينَ ظَلَمُوٓا۟ أَىَّ مُنقَلَبٍۢ يَنقَلِبُونَ',
		number_in_surah: '227',
		page: '376',
		surah_id: '26',
		hizb_id: '150',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3160',
		number: '3160',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ طسٓ ۚ تِلْكَ ءَايَٰتُ ٱلْقُرْءَانِ وَكِتَابٍۢ مُّبِينٍ',
		number_in_surah: '1',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3161',
		number: '3161',
		text: 'هُدًۭى وَبُشْرَىٰ لِلْمُؤْمِنِينَ',
		number_in_surah: '2',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3162',
		number: '3162',
		text: 'ٱلَّذِينَ يُقِيمُونَ ٱلصَّلَوٰةَ وَيُؤْتُونَ ٱلزَّكَوٰةَ وَهُم بِٱلْءَاخِرَةِ هُمْ يُوقِنُونَ',
		number_in_surah: '3',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3163',
		number: '3163',
		text: 'إِنَّ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ زَيَّنَّا لَهُمْ أَعْمَٰلَهُمْ فَهُمْ يَعْمَهُونَ',
		number_in_surah: '4',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3164',
		number: '3164',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ لَهُمْ سُوٓءُ ٱلْعَذَابِ وَهُمْ فِى ٱلْءَاخِرَةِ هُمُ ٱلْأَخْسَرُونَ',
		number_in_surah: '5',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3165',
		number: '3165',
		text: 'وَإِنَّكَ لَتُلَقَّى ٱلْقُرْءَانَ مِن لَّدُنْ حَكِيمٍ عَلِيمٍ',
		number_in_surah: '6',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3166',
		number: '3166',
		text: 'إِذْ قَالَ مُوسَىٰ لِأَهْلِهِۦٓ إِنِّىٓ ءَانَسْتُ نَارًۭا سَـَٔاتِيكُم مِّنْهَا بِخَبَرٍ أَوْ ءَاتِيكُم بِشِهَابٍۢ قَبَسٍۢ لَّعَلَّكُمْ تَصْطَلُونَ',
		number_in_surah: '7',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3167',
		number: '3167',
		text: 'فَلَمَّا جَآءَهَا نُودِىَ أَنۢ بُورِكَ مَن فِى ٱلنَّارِ وَمَنْ حَوْلَهَا وَسُبْحَٰنَ ٱللَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '8',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3168',
		number: '3168',
		text: 'يَٰمُوسَىٰٓ إِنَّهُۥٓ أَنَا ٱللَّهُ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '9',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3169',
		number: '3169',
		text: 'وَأَلْقِ عَصَاكَ ۚ فَلَمَّا رَءَاهَا تَهْتَزُّ كَأَنَّهَا جَآنٌّۭ وَلَّىٰ مُدْبِرًۭا وَلَمْ يُعَقِّبْ ۚ يَٰمُوسَىٰ لَا تَخَفْ إِنِّى لَا يَخَافُ لَدَىَّ ٱلْمُرْسَلُونَ',
		number_in_surah: '10',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3170',
		number: '3170',
		text: 'إِلَّا مَن ظَلَمَ ثُمَّ بَدَّلَ حُسْنًۢا بَعْدَ سُوٓءٍۢ فَإِنِّى غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '11',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3171',
		number: '3171',
		text: 'وَأَدْخِلْ يَدَكَ فِى جَيْبِكَ تَخْرُجْ بَيْضَآءَ مِنْ غَيْرِ سُوٓءٍۢ ۖ فِى تِسْعِ ءَايَٰتٍ إِلَىٰ فِرْعَوْنَ وَقَوْمِهِۦٓ ۚ إِنَّهُمْ كَانُوا۟ قَوْمًۭا فَٰسِقِينَ',
		number_in_surah: '12',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3172',
		number: '3172',
		text: 'فَلَمَّا جَآءَتْهُمْ ءَايَٰتُنَا مُبْصِرَةًۭ قَالُوا۟ هَٰذَا سِحْرٌۭ مُّبِينٌۭ',
		number_in_surah: '13',
		page: '377',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3173',
		number: '3173',
		text: 'وَجَحَدُوا۟ بِهَا وَٱسْتَيْقَنَتْهَآ أَنفُسُهُمْ ظُلْمًۭا وَعُلُوًّۭا ۚ فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُفْسِدِينَ',
		number_in_surah: '14',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3174',
		number: '3174',
		text: 'وَلَقَدْ ءَاتَيْنَا دَاوُۥدَ وَسُلَيْمَٰنَ عِلْمًۭا ۖ وَقَالَا ٱلْحَمْدُ لِلَّهِ ٱلَّذِى فَضَّلَنَا عَلَىٰ كَثِيرٍۢ مِّنْ عِبَادِهِ ٱلْمُؤْمِنِينَ',
		number_in_surah: '15',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3175',
		number: '3175',
		text: 'وَوَرِثَ سُلَيْمَٰنُ دَاوُۥدَ ۖ وَقَالَ يَٰٓأَيُّهَا ٱلنَّاسُ عُلِّمْنَا مَنطِقَ ٱلطَّيْرِ وَأُوتِينَا مِن كُلِّ شَىْءٍ ۖ إِنَّ هَٰذَا لَهُوَ ٱلْفَضْلُ ٱلْمُبِينُ',
		number_in_surah: '16',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3176',
		number: '3176',
		text: 'وَحُشِرَ لِسُلَيْمَٰنَ جُنُودُهُۥ مِنَ ٱلْجِنِّ وَٱلْإِنسِ وَٱلطَّيْرِ فَهُمْ يُوزَعُونَ',
		number_in_surah: '17',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3177',
		number: '3177',
		text: 'حَتَّىٰٓ إِذَآ أَتَوْا۟ عَلَىٰ وَادِ ٱلنَّمْلِ قَالَتْ نَمْلَةٌۭ يَٰٓأَيُّهَا ٱلنَّمْلُ ٱدْخُلُوا۟ مَسَٰكِنَكُمْ لَا يَحْطِمَنَّكُمْ سُلَيْمَٰنُ وَجُنُودُهُۥ وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '18',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3178',
		number: '3178',
		text: 'فَتَبَسَّمَ ضَاحِكًۭا مِّن قَوْلِهَا وَقَالَ رَبِّ أَوْزِعْنِىٓ أَنْ أَشْكُرَ نِعْمَتَكَ ٱلَّتِىٓ أَنْعَمْتَ عَلَىَّ وَعَلَىٰ وَٰلِدَىَّ وَأَنْ أَعْمَلَ صَٰلِحًۭا تَرْضَىٰهُ وَأَدْخِلْنِى بِرَحْمَتِكَ فِى عِبَادِكَ ٱلصَّٰلِحِينَ',
		number_in_surah: '19',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3179',
		number: '3179',
		text: 'وَتَفَقَّدَ ٱلطَّيْرَ فَقَالَ مَا لِىَ لَآ أَرَى ٱلْهُدْهُدَ أَمْ كَانَ مِنَ ٱلْغَآئِبِينَ',
		number_in_surah: '20',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3180',
		number: '3180',
		text: 'لَأُعَذِّبَنَّهُۥ عَذَابًۭا شَدِيدًا أَوْ لَأَا۟ذْبَحَنَّهُۥٓ أَوْ لَيَأْتِيَنِّى بِسُلْطَٰنٍۢ مُّبِينٍۢ',
		number_in_surah: '21',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3181',
		number: '3181',
		text: 'فَمَكَثَ غَيْرَ بَعِيدٍۢ فَقَالَ أَحَطتُ بِمَا لَمْ تُحِطْ بِهِۦ وَجِئْتُكَ مِن سَبَإٍۭ بِنَبَإٍۢ يَقِينٍ',
		number_in_surah: '22',
		page: '378',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3182',
		number: '3182',
		text: 'إِنِّى وَجَدتُّ ٱمْرَأَةًۭ تَمْلِكُهُمْ وَأُوتِيَتْ مِن كُلِّ شَىْءٍۢ وَلَهَا عَرْشٌ عَظِيمٌۭ',
		number_in_surah: '23',
		page: '379',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3183',
		number: '3183',
		text: 'وَجَدتُّهَا وَقَوْمَهَا يَسْجُدُونَ لِلشَّمْسِ مِن دُونِ ٱللَّهِ وَزَيَّنَ لَهُمُ ٱلشَّيْطَٰنُ أَعْمَٰلَهُمْ فَصَدَّهُمْ عَنِ ٱلسَّبِيلِ فَهُمْ لَا يَهْتَدُونَ',
		number_in_surah: '24',
		page: '379',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3184',
		number: '3184',
		text: 'أَلَّا يَسْجُدُوا۟ لِلَّهِ ٱلَّذِى يُخْرِجُ ٱلْخَبْءَ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَيَعْلَمُ مَا تُخْفُونَ وَمَا تُعْلِنُونَ',
		number_in_surah: '25',
		page: '379',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3185',
		number: '3185',
		text: 'ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ رَبُّ ٱلْعَرْشِ ٱلْعَظِيمِ ۩',
		number_in_surah: '26',
		page: '379',
		surah_id: '27',
		hizb_id: '151',
		juz_id: '19',
		sajda: '1',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3186',
		number: '3186',
		text: '۞ قَالَ سَنَنظُرُ أَصَدَقْتَ أَمْ كُنتَ مِنَ ٱلْكَٰذِبِينَ',
		number_in_surah: '27',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3187',
		number: '3187',
		text: 'ٱذْهَب بِّكِتَٰبِى هَٰذَا فَأَلْقِهْ إِلَيْهِمْ ثُمَّ تَوَلَّ عَنْهُمْ فَٱنظُرْ مَاذَا يَرْجِعُونَ',
		number_in_surah: '28',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3188',
		number: '3188',
		text: 'قَالَتْ يَٰٓأَيُّهَا ٱلْمَلَؤُا۟ إِنِّىٓ أُلْقِىَ إِلَىَّ كِتَٰبٌۭ كَرِيمٌ',
		number_in_surah: '29',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3189',
		number: '3189',
		text: 'إِنَّهُۥ مِن سُلَيْمَٰنَ وَإِنَّهُۥ بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ',
		number_in_surah: '30',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3190',
		number: '3190',
		text: 'أَلَّا تَعْلُوا۟ عَلَىَّ وَأْتُونِى مُسْلِمِينَ',
		number_in_surah: '31',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3191',
		number: '3191',
		text: 'قَالَتْ يَٰٓأَيُّهَا ٱلْمَلَؤُا۟ أَفْتُونِى فِىٓ أَمْرِى مَا كُنتُ قَاطِعَةً أَمْرًا حَتَّىٰ تَشْهَدُونِ',
		number_in_surah: '32',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3192',
		number: '3192',
		text: 'قَالُوا۟ نَحْنُ أُو۟لُوا۟ قُوَّةٍۢ وَأُو۟لُوا۟ بَأْسٍۢ شَدِيدٍۢ وَٱلْأَمْرُ إِلَيْكِ فَٱنظُرِى مَاذَا تَأْمُرِينَ',
		number_in_surah: '33',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3193',
		number: '3193',
		text: 'قَالَتْ إِنَّ ٱلْمُلُوكَ إِذَا دَخَلُوا۟ قَرْيَةً أَفْسَدُوهَا وَجَعَلُوٓا۟ أَعِزَّةَ أَهْلِهَآ أَذِلَّةًۭ ۖ وَكَذَٰلِكَ يَفْعَلُونَ',
		number_in_surah: '34',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3194',
		number: '3194',
		text: 'وَإِنِّى مُرْسِلَةٌ إِلَيْهِم بِهَدِيَّةٍۢ فَنَاظِرَةٌۢ بِمَ يَرْجِعُ ٱلْمُرْسَلُونَ',
		number_in_surah: '35',
		page: '379',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3195',
		number: '3195',
		text: 'فَلَمَّا جَآءَ سُلَيْمَٰنَ قَالَ أَتُمِدُّونَنِ بِمَالٍۢ فَمَآ ءَاتَىٰنِۦَ ٱللَّهُ خَيْرٌۭ مِّمَّآ ءَاتَىٰكُم بَلْ أَنتُم بِهَدِيَّتِكُمْ تَفْرَحُونَ',
		number_in_surah: '36',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3196',
		number: '3196',
		text: 'ٱرْجِعْ إِلَيْهِمْ فَلَنَأْتِيَنَّهُم بِجُنُودٍۢ لَّا قِبَلَ لَهُم بِهَا وَلَنُخْرِجَنَّهُم مِّنْهَآ أَذِلَّةًۭ وَهُمْ صَٰغِرُونَ',
		number_in_surah: '37',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3197',
		number: '3197',
		text: 'قَالَ يَٰٓأَيُّهَا ٱلْمَلَؤُا۟ أَيُّكُمْ يَأْتِينِى بِعَرْشِهَا قَبْلَ أَن يَأْتُونِى مُسْلِمِينَ',
		number_in_surah: '38',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3198',
		number: '3198',
		text: 'قَالَ عِفْرِيتٌۭ مِّنَ ٱلْجِنِّ أَنَا۠ ءَاتِيكَ بِهِۦ قَبْلَ أَن تَقُومَ مِن مَّقَامِكَ ۖ وَإِنِّى عَلَيْهِ لَقَوِىٌّ أَمِينٌۭ',
		number_in_surah: '39',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3199',
		number: '3199',
		text: 'قَالَ ٱلَّذِى عِندَهُۥ عِلْمٌۭ مِّنَ ٱلْكِتَٰبِ أَنَا۠ ءَاتِيكَ بِهِۦ قَبْلَ أَن يَرْتَدَّ إِلَيْكَ طَرْفُكَ ۚ فَلَمَّا رَءَاهُ مُسْتَقِرًّا عِندَهُۥ قَالَ هَٰذَا مِن فَضْلِ رَبِّى لِيَبْلُوَنِىٓ ءَأَشْكُرُ أَمْ أَكْفُرُ ۖ وَمَن شَكَرَ فَإِنَّمَا يَشْكُرُ لِنَفْسِهِۦ ۖ وَمَن كَفَرَ فَإِنَّ رَبِّى غَنِىٌّۭ كَرِيمٌۭ',
		number_in_surah: '40',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3200',
		number: '3200',
		text: 'قَالَ نَكِّرُوا۟ لَهَا عَرْشَهَا نَنظُرْ أَتَهْتَدِىٓ أَمْ تَكُونُ مِنَ ٱلَّذِينَ لَا يَهْتَدُونَ',
		number_in_surah: '41',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3201',
		number: '3201',
		text: 'فَلَمَّا جَآءَتْ قِيلَ أَهَٰكَذَا عَرْشُكِ ۖ قَالَتْ كَأَنَّهُۥ هُوَ ۚ وَأُوتِينَا ٱلْعِلْمَ مِن قَبْلِهَا وَكُنَّا مُسْلِمِينَ',
		number_in_surah: '42',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3202',
		number: '3202',
		text: 'وَصَدَّهَا مَا كَانَت تَّعْبُدُ مِن دُونِ ٱللَّهِ ۖ إِنَّهَا كَانَتْ مِن قَوْمٍۢ كَٰفِرِينَ',
		number_in_surah: '43',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3203',
		number: '3203',
		text: 'قِيلَ لَهَا ٱدْخُلِى ٱلصَّرْحَ ۖ فَلَمَّا رَأَتْهُ حَسِبَتْهُ لُجَّةًۭ وَكَشَفَتْ عَن سَاقَيْهَا ۚ قَالَ إِنَّهُۥ صَرْحٌۭ مُّمَرَّدٌۭ مِّن قَوَارِيرَ ۗ قَالَتْ رَبِّ إِنِّى ظَلَمْتُ نَفْسِى وَأَسْلَمْتُ مَعَ سُلَيْمَٰنَ لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '44',
		page: '380',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3204',
		number: '3204',
		text: 'وَلَقَدْ أَرْسَلْنَآ إِلَىٰ ثَمُودَ أَخَاهُمْ صَٰلِحًا أَنِ ٱعْبُدُوا۟ ٱللَّهَ فَإِذَا هُمْ فَرِيقَانِ يَخْتَصِمُونَ',
		number_in_surah: '45',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3205',
		number: '3205',
		text: 'قَالَ يَٰقَوْمِ لِمَ تَسْتَعْجِلُونَ بِٱلسَّيِّئَةِ قَبْلَ ٱلْحَسَنَةِ ۖ لَوْلَا تَسْتَغْفِرُونَ ٱللَّهَ لَعَلَّكُمْ تُرْحَمُونَ',
		number_in_surah: '46',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3206',
		number: '3206',
		text: 'قَالُوا۟ ٱطَّيَّرْنَا بِكَ وَبِمَن مَّعَكَ ۚ قَالَ طَٰٓئِرُكُمْ عِندَ ٱللَّهِ ۖ بَلْ أَنتُمْ قَوْمٌۭ تُفْتَنُونَ',
		number_in_surah: '47',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3207',
		number: '3207',
		text: 'وَكَانَ فِى ٱلْمَدِينَةِ تِسْعَةُ رَهْطٍۢ يُفْسِدُونَ فِى ٱلْأَرْضِ وَلَا يُصْلِحُونَ',
		number_in_surah: '48',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3208',
		number: '3208',
		text: 'قَالُوا۟ تَقَاسَمُوا۟ بِٱللَّهِ لَنُبَيِّتَنَّهُۥ وَأَهْلَهُۥ ثُمَّ لَنَقُولَنَّ لِوَلِيِّهِۦ مَا شَهِدْنَا مَهْلِكَ أَهْلِهِۦ وَإِنَّا لَصَٰدِقُونَ',
		number_in_surah: '49',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3209',
		number: '3209',
		text: 'وَمَكَرُوا۟ مَكْرًۭا وَمَكَرْنَا مَكْرًۭا وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '50',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3210',
		number: '3210',
		text: 'فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ مَكْرِهِمْ أَنَّا دَمَّرْنَٰهُمْ وَقَوْمَهُمْ أَجْمَعِينَ',
		number_in_surah: '51',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3211',
		number: '3211',
		text: 'فَتِلْكَ بُيُوتُهُمْ خَاوِيَةًۢ بِمَا ظَلَمُوٓا۟ ۗ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّقَوْمٍۢ يَعْلَمُونَ',
		number_in_surah: '52',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3212',
		number: '3212',
		text: 'وَأَنجَيْنَا ٱلَّذِينَ ءَامَنُوا۟ وَكَانُوا۟ يَتَّقُونَ',
		number_in_surah: '53',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3213',
		number: '3213',
		text: 'وَلُوطًا إِذْ قَالَ لِقَوْمِهِۦٓ أَتَأْتُونَ ٱلْفَٰحِشَةَ وَأَنتُمْ تُبْصِرُونَ',
		number_in_surah: '54',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3214',
		number: '3214',
		text: 'أَئِنَّكُمْ لَتَأْتُونَ ٱلرِّجَالَ شَهْوَةًۭ مِّن دُونِ ٱلنِّسَآءِ ۚ بَلْ أَنتُمْ قَوْمٌۭ تَجْهَلُونَ',
		number_in_surah: '55',
		page: '381',
		surah_id: '27',
		hizb_id: '152',
		juz_id: '19',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3215',
		number: '3215',
		text: '۞ فَمَا كَانَ جَوَابَ قَوْمِهِۦٓ إِلَّآ أَن قَالُوٓا۟ أَخْرِجُوٓا۟ ءَالَ لُوطٍۢ مِّن قَرْيَتِكُمْ ۖ إِنَّهُمْ أُنَاسٌۭ يَتَطَهَّرُونَ',
		number_in_surah: '56',
		page: '382',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3216',
		number: '3216',
		text: 'فَأَنجَيْنَٰهُ وَأَهْلَهُۥٓ إِلَّا ٱمْرَأَتَهُۥ قَدَّرْنَٰهَا مِنَ ٱلْغَٰبِرِينَ',
		number_in_surah: '57',
		page: '382',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3217',
		number: '3217',
		text: 'وَأَمْطَرْنَا عَلَيْهِم مَّطَرًۭا ۖ فَسَآءَ مَطَرُ ٱلْمُنذَرِينَ',
		number_in_surah: '58',
		page: '382',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3218',
		number: '3218',
		text: 'قُلِ ٱلْحَمْدُ لِلَّهِ وَسَلَٰمٌ عَلَىٰ عِبَادِهِ ٱلَّذِينَ ٱصْطَفَىٰٓ ۗ ءَآللَّهُ خَيْرٌ أَمَّا يُشْرِكُونَ',
		number_in_surah: '59',
		page: '382',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3219',
		number: '3219',
		text: 'أَمَّنْ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَأَنزَلَ لَكُم مِّنَ ٱلسَّمَآءِ مَآءًۭ فَأَنۢبَتْنَا بِهِۦ حَدَآئِقَ ذَاتَ بَهْجَةٍۢ مَّا كَانَ لَكُمْ أَن تُنۢبِتُوا۟ شَجَرَهَآ ۗ أَءِلَٰهٌۭ مَّعَ ٱللَّهِ ۚ بَلْ هُمْ قَوْمٌۭ يَعْدِلُونَ',
		number_in_surah: '60',
		page: '382',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3220',
		number: '3220',
		text: 'أَمَّن جَعَلَ ٱلْأَرْضَ قَرَارًۭا وَجَعَلَ خِلَٰلَهَآ أَنْهَٰرًۭا وَجَعَلَ لَهَا رَوَٰسِىَ وَجَعَلَ بَيْنَ ٱلْبَحْرَيْنِ حَاجِزًا ۗ أَءِلَٰهٌۭ مَّعَ ٱللَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '61',
		page: '382',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3221',
		number: '3221',
		text: 'أَمَّن يُجِيبُ ٱلْمُضْطَرَّ إِذَا دَعَاهُ وَيَكْشِفُ ٱلسُّوٓءَ وَيَجْعَلُكُمْ خُلَفَآءَ ٱلْأَرْضِ ۗ أَءِلَٰهٌۭ مَّعَ ٱللَّهِ ۚ قَلِيلًۭا مَّا تَذَكَّرُونَ',
		number_in_surah: '62',
		page: '382',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3222',
		number: '3222',
		text: 'أَمَّن يَهْدِيكُمْ فِى ظُلُمَٰتِ ٱلْبَرِّ وَٱلْبَحْرِ وَمَن يُرْسِلُ ٱلرِّيَٰحَ بُشْرًۢا بَيْنَ يَدَىْ رَحْمَتِهِۦٓ ۗ أَءِلَٰهٌۭ مَّعَ ٱللَّهِ ۚ تَعَٰلَى ٱللَّهُ عَمَّا يُشْرِكُونَ',
		number_in_surah: '63',
		page: '382',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3223',
		number: '3223',
		text: 'أَمَّن يَبْدَؤُا۟ ٱلْخَلْقَ ثُمَّ يُعِيدُهُۥ وَمَن يَرْزُقُكُم مِّنَ ٱلسَّمَآءِ وَٱلْأَرْضِ ۗ أَءِلَٰهٌۭ مَّعَ ٱللَّهِ ۚ قُلْ هَاتُوا۟ بُرْهَٰنَكُمْ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '64',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3224',
		number: '3224',
		text: 'قُل لَّا يَعْلَمُ مَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ٱلْغَيْبَ إِلَّا ٱللَّهُ ۚ وَمَا يَشْعُرُونَ أَيَّانَ يُبْعَثُونَ',
		number_in_surah: '65',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3225',
		number: '3225',
		text: 'بَلِ ٱدَّٰرَكَ عِلْمُهُمْ فِى ٱلْءَاخِرَةِ ۚ بَلْ هُمْ فِى شَكٍّۢ مِّنْهَا ۖ بَلْ هُم مِّنْهَا عَمُونَ',
		number_in_surah: '66',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3226',
		number: '3226',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوٓا۟ أَءِذَا كُنَّا تُرَٰبًۭا وَءَابَآؤُنَآ أَئِنَّا لَمُخْرَجُونَ',
		number_in_surah: '67',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3227',
		number: '3227',
		text: 'لَقَدْ وُعِدْنَا هَٰذَا نَحْنُ وَءَابَآؤُنَا مِن قَبْلُ إِنْ هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلْأَوَّلِينَ',
		number_in_surah: '68',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3228',
		number: '3228',
		text: 'قُلْ سِيرُوا۟ فِى ٱلْأَرْضِ فَٱنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُجْرِمِينَ',
		number_in_surah: '69',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3229',
		number: '3229',
		text: 'وَلَا تَحْزَنْ عَلَيْهِمْ وَلَا تَكُن فِى ضَيْقٍۢ مِّمَّا يَمْكُرُونَ',
		number_in_surah: '70',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3230',
		number: '3230',
		text: 'وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلْوَعْدُ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '71',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3231',
		number: '3231',
		text: 'قُلْ عَسَىٰٓ أَن يَكُونَ رَدِفَ لَكُم بَعْضُ ٱلَّذِى تَسْتَعْجِلُونَ',
		number_in_surah: '72',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3232',
		number: '3232',
		text: 'وَإِنَّ رَبَّكَ لَذُو فَضْلٍ عَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَشْكُرُونَ',
		number_in_surah: '73',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3233',
		number: '3233',
		text: 'وَإِنَّ رَبَّكَ لَيَعْلَمُ مَا تُكِنُّ صُدُورُهُمْ وَمَا يُعْلِنُونَ',
		number_in_surah: '74',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3234',
		number: '3234',
		text: 'وَمَا مِنْ غَآئِبَةٍۢ فِى ٱلسَّمَآءِ وَٱلْأَرْضِ إِلَّا فِى كِتَٰبٍۢ مُّبِينٍ',
		number_in_surah: '75',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3235',
		number: '3235',
		text: 'إِنَّ هَٰذَا ٱلْقُرْءَانَ يَقُصُّ عَلَىٰ بَنِىٓ إِسْرَٰٓءِيلَ أَكْثَرَ ٱلَّذِى هُمْ فِيهِ يَخْتَلِفُونَ',
		number_in_surah: '76',
		page: '383',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3236',
		number: '3236',
		text: 'وَإِنَّهُۥ لَهُدًۭى وَرَحْمَةٌۭ لِّلْمُؤْمِنِينَ',
		number_in_surah: '77',
		page: '384',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3237',
		number: '3237',
		text: 'إِنَّ رَبَّكَ يَقْضِى بَيْنَهُم بِحُكْمِهِۦ ۚ وَهُوَ ٱلْعَزِيزُ ٱلْعَلِيمُ',
		number_in_surah: '78',
		page: '384',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3238',
		number: '3238',
		text: 'فَتَوَكَّلْ عَلَى ٱللَّهِ ۖ إِنَّكَ عَلَى ٱلْحَقِّ ٱلْمُبِينِ',
		number_in_surah: '79',
		page: '384',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3239',
		number: '3239',
		text: 'إِنَّكَ لَا تُسْمِعُ ٱلْمَوْتَىٰ وَلَا تُسْمِعُ ٱلصُّمَّ ٱلدُّعَآءَ إِذَا وَلَّوْا۟ مُدْبِرِينَ',
		number_in_surah: '80',
		page: '384',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3240',
		number: '3240',
		text: 'وَمَآ أَنتَ بِهَٰدِى ٱلْعُمْىِ عَن ضَلَٰلَتِهِمْ ۖ إِن تُسْمِعُ إِلَّا مَن يُؤْمِنُ بِـَٔايَٰتِنَا فَهُم مُّسْلِمُونَ',
		number_in_surah: '81',
		page: '384',
		surah_id: '27',
		hizb_id: '153',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3241',
		number: '3241',
		text: '۞ وَإِذَا وَقَعَ ٱلْقَوْلُ عَلَيْهِمْ أَخْرَجْنَا لَهُمْ دَآبَّةًۭ مِّنَ ٱلْأَرْضِ تُكَلِّمُهُمْ أَنَّ ٱلنَّاسَ كَانُوا۟ بِـَٔايَٰتِنَا لَا يُوقِنُونَ',
		number_in_surah: '82',
		page: '384',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3242',
		number: '3242',
		text: 'وَيَوْمَ نَحْشُرُ مِن كُلِّ أُمَّةٍۢ فَوْجًۭا مِّمَّن يُكَذِّبُ بِـَٔايَٰتِنَا فَهُمْ يُوزَعُونَ',
		number_in_surah: '83',
		page: '384',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3243',
		number: '3243',
		text: 'حَتَّىٰٓ إِذَا جَآءُو قَالَ أَكَذَّبْتُم بِـَٔايَٰتِى وَلَمْ تُحِيطُوا۟ بِهَا عِلْمًا أَمَّاذَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '84',
		page: '384',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3244',
		number: '3244',
		text: 'وَوَقَعَ ٱلْقَوْلُ عَلَيْهِم بِمَا ظَلَمُوا۟ فَهُمْ لَا يَنطِقُونَ',
		number_in_surah: '85',
		page: '384',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3245',
		number: '3245',
		text: 'أَلَمْ يَرَوْا۟ أَنَّا جَعَلْنَا ٱلَّيْلَ لِيَسْكُنُوا۟ فِيهِ وَٱلنَّهَارَ مُبْصِرًا ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '86',
		page: '384',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3246',
		number: '3246',
		text: 'وَيَوْمَ يُنفَخُ فِى ٱلصُّورِ فَفَزِعَ مَن فِى ٱلسَّمَٰوَٰتِ وَمَن فِى ٱلْأَرْضِ إِلَّا مَن شَآءَ ٱللَّهُ ۚ وَكُلٌّ أَتَوْهُ دَٰخِرِينَ',
		number_in_surah: '87',
		page: '384',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3247',
		number: '3247',
		text: 'وَتَرَى ٱلْجِبَالَ تَحْسَبُهَا جَامِدَةًۭ وَهِىَ تَمُرُّ مَرَّ ٱلسَّحَابِ ۚ صُنْعَ ٱللَّهِ ٱلَّذِىٓ أَتْقَنَ كُلَّ شَىْءٍ ۚ إِنَّهُۥ خَبِيرٌۢ بِمَا تَفْعَلُونَ',
		number_in_surah: '88',
		page: '384',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3248',
		number: '3248',
		text: 'مَن جَآءَ بِٱلْحَسَنَةِ فَلَهُۥ خَيْرٌۭ مِّنْهَا وَهُم مِّن فَزَعٍۢ يَوْمَئِذٍ ءَامِنُونَ',
		number_in_surah: '89',
		page: '385',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3249',
		number: '3249',
		text: 'وَمَن جَآءَ بِٱلسَّيِّئَةِ فَكُبَّتْ وُجُوهُهُمْ فِى ٱلنَّارِ هَلْ تُجْزَوْنَ إِلَّا مَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '90',
		page: '385',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3250',
		number: '3250',
		text: 'إِنَّمَآ أُمِرْتُ أَنْ أَعْبُدَ رَبَّ هَٰذِهِ ٱلْبَلْدَةِ ٱلَّذِى حَرَّمَهَا وَلَهُۥ كُلُّ شَىْءٍۢ ۖ وَأُمِرْتُ أَنْ أَكُونَ مِنَ ٱلْمُسْلِمِينَ',
		number_in_surah: '91',
		page: '385',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3251',
		number: '3251',
		text: 'وَأَنْ أَتْلُوَا۟ ٱلْقُرْءَانَ ۖ فَمَنِ ٱهْتَدَىٰ فَإِنَّمَا يَهْتَدِى لِنَفْسِهِۦ ۖ وَمَن ضَلَّ فَقُلْ إِنَّمَآ أَنَا۠ مِنَ ٱلْمُنذِرِينَ',
		number_in_surah: '92',
		page: '385',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3252',
		number: '3252',
		text: 'وَقُلِ ٱلْحَمْدُ لِلَّهِ سَيُرِيكُمْ ءَايَٰتِهِۦ فَتَعْرِفُونَهَا ۚ وَمَا رَبُّكَ بِغَٰفِلٍ عَمَّا تَعْمَلُونَ',
		number_in_surah: '93',
		page: '385',
		surah_id: '27',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3253',
		number: '3253',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ طسٓمٓ',
		number_in_surah: '1',
		page: '385',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3254',
		number: '3254',
		text: 'تِلْكَ ءَايَٰتُ ٱلْكِتَٰبِ ٱلْمُبِينِ',
		number_in_surah: '2',
		page: '385',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3255',
		number: '3255',
		text: 'نَتْلُوا۟ عَلَيْكَ مِن نَّبَإِ مُوسَىٰ وَفِرْعَوْنَ بِٱلْحَقِّ لِقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '3',
		page: '385',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3256',
		number: '3256',
		text: 'إِنَّ فِرْعَوْنَ عَلَا فِى ٱلْأَرْضِ وَجَعَلَ أَهْلَهَا شِيَعًۭا يَسْتَضْعِفُ طَآئِفَةًۭ مِّنْهُمْ يُذَبِّحُ أَبْنَآءَهُمْ وَيَسْتَحْىِۦ نِسَآءَهُمْ ۚ إِنَّهُۥ كَانَ مِنَ ٱلْمُفْسِدِينَ',
		number_in_surah: '4',
		page: '385',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3257',
		number: '3257',
		text: 'وَنُرِيدُ أَن نَّمُنَّ عَلَى ٱلَّذِينَ ٱسْتُضْعِفُوا۟ فِى ٱلْأَرْضِ وَنَجْعَلَهُمْ أَئِمَّةًۭ وَنَجْعَلَهُمُ ٱلْوَٰرِثِينَ',
		number_in_surah: '5',
		page: '385',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3258',
		number: '3258',
		text: 'وَنُمَكِّنَ لَهُمْ فِى ٱلْأَرْضِ وَنُرِىَ فِرْعَوْنَ وَهَٰمَٰنَ وَجُنُودَهُمَا مِنْهُم مَّا كَانُوا۟ يَحْذَرُونَ',
		number_in_surah: '6',
		page: '386',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3259',
		number: '3259',
		text: 'وَأَوْحَيْنَآ إِلَىٰٓ أُمِّ مُوسَىٰٓ أَنْ أَرْضِعِيهِ ۖ فَإِذَا خِفْتِ عَلَيْهِ فَأَلْقِيهِ فِى ٱلْيَمِّ وَلَا تَخَافِى وَلَا تَحْزَنِىٓ ۖ إِنَّا رَآدُّوهُ إِلَيْكِ وَجَاعِلُوهُ مِنَ ٱلْمُرْسَلِينَ',
		number_in_surah: '7',
		page: '386',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3260',
		number: '3260',
		text: 'فَٱلْتَقَطَهُۥٓ ءَالُ فِرْعَوْنَ لِيَكُونَ لَهُمْ عَدُوًّۭا وَحَزَنًا ۗ إِنَّ فِرْعَوْنَ وَهَٰمَٰنَ وَجُنُودَهُمَا كَانُوا۟ خَٰطِـِٔينَ',
		number_in_surah: '8',
		page: '386',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3261',
		number: '3261',
		text: 'وَقَالَتِ ٱمْرَأَتُ فِرْعَوْنَ قُرَّتُ عَيْنٍۢ لِّى وَلَكَ ۖ لَا تَقْتُلُوهُ عَسَىٰٓ أَن يَنفَعَنَآ أَوْ نَتَّخِذَهُۥ وَلَدًۭا وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '9',
		page: '386',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3262',
		number: '3262',
		text: 'وَأَصْبَحَ فُؤَادُ أُمِّ مُوسَىٰ فَٰرِغًا ۖ إِن كَادَتْ لَتُبْدِى بِهِۦ لَوْلَآ أَن رَّبَطْنَا عَلَىٰ قَلْبِهَا لِتَكُونَ مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '10',
		page: '386',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3263',
		number: '3263',
		text: 'وَقَالَتْ لِأُخْتِهِۦ قُصِّيهِ ۖ فَبَصُرَتْ بِهِۦ عَن جُنُبٍۢ وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '11',
		page: '386',
		surah_id: '28',
		hizb_id: '154',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3264',
		number: '3264',
		text: '۞ وَحَرَّمْنَا عَلَيْهِ ٱلْمَرَاضِعَ مِن قَبْلُ فَقَالَتْ هَلْ أَدُلُّكُمْ عَلَىٰٓ أَهْلِ بَيْتٍۢ يَكْفُلُونَهُۥ لَكُمْ وَهُمْ لَهُۥ نَٰصِحُونَ',
		number_in_surah: '12',
		page: '386',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3265',
		number: '3265',
		text: 'فَرَدَدْنَٰهُ إِلَىٰٓ أُمِّهِۦ كَىْ تَقَرَّ عَيْنُهَا وَلَا تَحْزَنَ وَلِتَعْلَمَ أَنَّ وَعْدَ ٱللَّهِ حَقٌّۭ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '13',
		page: '386',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3266',
		number: '3266',
		text: 'وَلَمَّا بَلَغَ أَشُدَّهُۥ وَٱسْتَوَىٰٓ ءَاتَيْنَٰهُ حُكْمًۭا وَعِلْمًۭا ۚ وَكَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '14',
		page: '387',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3267',
		number: '3267',
		text: 'وَدَخَلَ ٱلْمَدِينَةَ عَلَىٰ حِينِ غَفْلَةٍۢ مِّنْ أَهْلِهَا فَوَجَدَ فِيهَا رَجُلَيْنِ يَقْتَتِلَانِ هَٰذَا مِن شِيعَتِهِۦ وَهَٰذَا مِنْ عَدُوِّهِۦ ۖ فَٱسْتَغَٰثَهُ ٱلَّذِى مِن شِيعَتِهِۦ عَلَى ٱلَّذِى مِنْ عَدُوِّهِۦ فَوَكَزَهُۥ مُوسَىٰ فَقَضَىٰ عَلَيْهِ ۖ قَالَ هَٰذَا مِنْ عَمَلِ ٱلشَّيْطَٰنِ ۖ إِنَّهُۥ عَدُوٌّۭ مُّضِلٌّۭ مُّبِينٌۭ',
		number_in_surah: '15',
		page: '387',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3268',
		number: '3268',
		text: 'قَالَ رَبِّ إِنِّى ظَلَمْتُ نَفْسِى فَٱغْفِرْ لِى فَغَفَرَ لَهُۥٓ ۚ إِنَّهُۥ هُوَ ٱلْغَفُورُ ٱلرَّحِيمُ',
		number_in_surah: '16',
		page: '387',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3269',
		number: '3269',
		text: 'قَالَ رَبِّ بِمَآ أَنْعَمْتَ عَلَىَّ فَلَنْ أَكُونَ ظَهِيرًۭا لِّلْمُجْرِمِينَ',
		number_in_surah: '17',
		page: '387',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3270',
		number: '3270',
		text: 'فَأَصْبَحَ فِى ٱلْمَدِينَةِ خَآئِفًۭا يَتَرَقَّبُ فَإِذَا ٱلَّذِى ٱسْتَنصَرَهُۥ بِٱلْأَمْسِ يَسْتَصْرِخُهُۥ ۚ قَالَ لَهُۥ مُوسَىٰٓ إِنَّكَ لَغَوِىٌّۭ مُّبِينٌۭ',
		number_in_surah: '18',
		page: '387',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3271',
		number: '3271',
		text: 'فَلَمَّآ أَنْ أَرَادَ أَن يَبْطِشَ بِٱلَّذِى هُوَ عَدُوٌّۭ لَّهُمَا قَالَ يَٰمُوسَىٰٓ أَتُرِيدُ أَن تَقْتُلَنِى كَمَا قَتَلْتَ نَفْسًۢا بِٱلْأَمْسِ ۖ إِن تُرِيدُ إِلَّآ أَن تَكُونَ جَبَّارًۭا فِى ٱلْأَرْضِ وَمَا تُرِيدُ أَن تَكُونَ مِنَ ٱلْمُصْلِحِينَ',
		number_in_surah: '19',
		page: '387',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3272',
		number: '3272',
		text: 'وَجَآءَ رَجُلٌۭ مِّنْ أَقْصَا ٱلْمَدِينَةِ يَسْعَىٰ قَالَ يَٰمُوسَىٰٓ إِنَّ ٱلْمَلَأَ يَأْتَمِرُونَ بِكَ لِيَقْتُلُوكَ فَٱخْرُجْ إِنِّى لَكَ مِنَ ٱلنَّٰصِحِينَ',
		number_in_surah: '20',
		page: '387',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3273',
		number: '3273',
		text: 'فَخَرَجَ مِنْهَا خَآئِفًۭا يَتَرَقَّبُ ۖ قَالَ رَبِّ نَجِّنِى مِنَ ٱلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '21',
		page: '387',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3274',
		number: '3274',
		text: 'وَلَمَّا تَوَجَّهَ تِلْقَآءَ مَدْيَنَ قَالَ عَسَىٰ رَبِّىٓ أَن يَهْدِيَنِى سَوَآءَ ٱلسَّبِيلِ',
		number_in_surah: '22',
		page: '388',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3275',
		number: '3275',
		text: 'وَلَمَّا وَرَدَ مَآءَ مَدْيَنَ وَجَدَ عَلَيْهِ أُمَّةًۭ مِّنَ ٱلنَّاسِ يَسْقُونَ وَوَجَدَ مِن دُونِهِمُ ٱمْرَأَتَيْنِ تَذُودَانِ ۖ قَالَ مَا خَطْبُكُمَا ۖ قَالَتَا لَا نَسْقِى حَتَّىٰ يُصْدِرَ ٱلرِّعَآءُ ۖ وَأَبُونَا شَيْخٌۭ كَبِيرٌۭ',
		number_in_surah: '23',
		page: '388',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3276',
		number: '3276',
		text: 'فَسَقَىٰ لَهُمَا ثُمَّ تَوَلَّىٰٓ إِلَى ٱلظِّلِّ فَقَالَ رَبِّ إِنِّى لِمَآ أَنزَلْتَ إِلَىَّ مِنْ خَيْرٍۢ فَقِيرٌۭ',
		number_in_surah: '24',
		page: '388',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3277',
		number: '3277',
		text: 'فَجَآءَتْهُ إِحْدَىٰهُمَا تَمْشِى عَلَى ٱسْتِحْيَآءٍۢ قَالَتْ إِنَّ أَبِى يَدْعُوكَ لِيَجْزِيَكَ أَجْرَ مَا سَقَيْتَ لَنَا ۚ فَلَمَّا جَآءَهُۥ وَقَصَّ عَلَيْهِ ٱلْقَصَصَ قَالَ لَا تَخَفْ ۖ نَجَوْتَ مِنَ ٱلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '25',
		page: '388',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3278',
		number: '3278',
		text: 'قَالَتْ إِحْدَىٰهُمَا يَٰٓأَبَتِ ٱسْتَـْٔجِرْهُ ۖ إِنَّ خَيْرَ مَنِ ٱسْتَـْٔجَرْتَ ٱلْقَوِىُّ ٱلْأَمِينُ',
		number_in_surah: '26',
		page: '388',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3279',
		number: '3279',
		text: 'قَالَ إِنِّىٓ أُرِيدُ أَنْ أُنكِحَكَ إِحْدَى ٱبْنَتَىَّ هَٰتَيْنِ عَلَىٰٓ أَن تَأْجُرَنِى ثَمَٰنِىَ حِجَجٍۢ ۖ فَإِنْ أَتْمَمْتَ عَشْرًۭا فَمِنْ عِندِكَ ۖ وَمَآ أُرِيدُ أَنْ أَشُقَّ عَلَيْكَ ۚ سَتَجِدُنِىٓ إِن شَآءَ ٱللَّهُ مِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '27',
		page: '388',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3280',
		number: '3280',
		text: 'قَالَ ذَٰلِكَ بَيْنِى وَبَيْنَكَ ۖ أَيَّمَا ٱلْأَجَلَيْنِ قَضَيْتُ فَلَا عُدْوَٰنَ عَلَىَّ ۖ وَٱللَّهُ عَلَىٰ مَا نَقُولُ وَكِيلٌۭ',
		number_in_surah: '28',
		page: '388',
		surah_id: '28',
		hizb_id: '155',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3281',
		number: '3281',
		text: '۞ فَلَمَّا قَضَىٰ مُوسَى ٱلْأَجَلَ وَسَارَ بِأَهْلِهِۦٓ ءَانَسَ مِن جَانِبِ ٱلطُّورِ نَارًۭا قَالَ لِأَهْلِهِ ٱمْكُثُوٓا۟ إِنِّىٓ ءَانَسْتُ نَارًۭا لَّعَلِّىٓ ءَاتِيكُم مِّنْهَا بِخَبَرٍ أَوْ جَذْوَةٍۢ مِّنَ ٱلنَّارِ لَعَلَّكُمْ تَصْطَلُونَ',
		number_in_surah: '29',
		page: '389',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3282',
		number: '3282',
		text: 'فَلَمَّآ أَتَىٰهَا نُودِىَ مِن شَٰطِئِ ٱلْوَادِ ٱلْأَيْمَنِ فِى ٱلْبُقْعَةِ ٱلْمُبَٰرَكَةِ مِنَ ٱلشَّجَرَةِ أَن يَٰمُوسَىٰٓ إِنِّىٓ أَنَا ٱللَّهُ رَبُّ ٱلْعَٰلَمِينَ',
		number_in_surah: '30',
		page: '389',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3283',
		number: '3283',
		text: 'وَأَنْ أَلْقِ عَصَاكَ ۖ فَلَمَّا رَءَاهَا تَهْتَزُّ كَأَنَّهَا جَآنٌّۭ وَلَّىٰ مُدْبِرًۭا وَلَمْ يُعَقِّبْ ۚ يَٰمُوسَىٰٓ أَقْبِلْ وَلَا تَخَفْ ۖ إِنَّكَ مِنَ ٱلْءَامِنِينَ',
		number_in_surah: '31',
		page: '389',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3284',
		number: '3284',
		text: 'ٱسْلُكْ يَدَكَ فِى جَيْبِكَ تَخْرُجْ بَيْضَآءَ مِنْ غَيْرِ سُوٓءٍۢ وَٱضْمُمْ إِلَيْكَ جَنَاحَكَ مِنَ ٱلرَّهْبِ ۖ فَذَٰنِكَ بُرْهَٰنَانِ مِن رَّبِّكَ إِلَىٰ فِرْعَوْنَ وَمَلَإِي۟هِۦٓ ۚ إِنَّهُمْ كَانُوا۟ قَوْمًۭا فَٰسِقِينَ',
		number_in_surah: '32',
		page: '389',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3285',
		number: '3285',
		text: 'قَالَ رَبِّ إِنِّى قَتَلْتُ مِنْهُمْ نَفْسًۭا فَأَخَافُ أَن يَقْتُلُونِ',
		number_in_surah: '33',
		page: '389',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3286',
		number: '3286',
		text: 'وَأَخِى هَٰرُونُ هُوَ أَفْصَحُ مِنِّى لِسَانًۭا فَأَرْسِلْهُ مَعِىَ رِدْءًۭا يُصَدِّقُنِىٓ ۖ إِنِّىٓ أَخَافُ أَن يُكَذِّبُونِ',
		number_in_surah: '34',
		page: '389',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3287',
		number: '3287',
		text: 'قَالَ سَنَشُدُّ عَضُدَكَ بِأَخِيكَ وَنَجْعَلُ لَكُمَا سُلْطَٰنًۭا فَلَا يَصِلُونَ إِلَيْكُمَا ۚ بِـَٔايَٰتِنَآ أَنتُمَا وَمَنِ ٱتَّبَعَكُمَا ٱلْغَٰلِبُونَ',
		number_in_surah: '35',
		page: '389',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3288',
		number: '3288',
		text: 'فَلَمَّا جَآءَهُم مُّوسَىٰ بِـَٔايَٰتِنَا بَيِّنَٰتٍۢ قَالُوا۟ مَا هَٰذَآ إِلَّا سِحْرٌۭ مُّفْتَرًۭى وَمَا سَمِعْنَا بِهَٰذَا فِىٓ ءَابَآئِنَا ٱلْأَوَّلِينَ',
		number_in_surah: '36',
		page: '390',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3289',
		number: '3289',
		text: 'وَقَالَ مُوسَىٰ رَبِّىٓ أَعْلَمُ بِمَن جَآءَ بِٱلْهُدَىٰ مِنْ عِندِهِۦ وَمَن تَكُونُ لَهُۥ عَٰقِبَةُ ٱلدَّارِ ۖ إِنَّهُۥ لَا يُفْلِحُ ٱلظَّٰلِمُونَ',
		number_in_surah: '37',
		page: '390',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3290',
		number: '3290',
		text: 'وَقَالَ فِرْعَوْنُ يَٰٓأَيُّهَا ٱلْمَلَأُ مَا عَلِمْتُ لَكُم مِّنْ إِلَٰهٍ غَيْرِى فَأَوْقِدْ لِى يَٰهَٰمَٰنُ عَلَى ٱلطِّينِ فَٱجْعَل لِّى صَرْحًۭا لَّعَلِّىٓ أَطَّلِعُ إِلَىٰٓ إِلَٰهِ مُوسَىٰ وَإِنِّى لَأَظُنُّهُۥ مِنَ ٱلْكَٰذِبِينَ',
		number_in_surah: '38',
		page: '390',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3291',
		number: '3291',
		text: 'وَٱسْتَكْبَرَ هُوَ وَجُنُودُهُۥ فِى ٱلْأَرْضِ بِغَيْرِ ٱلْحَقِّ وَظَنُّوٓا۟ أَنَّهُمْ إِلَيْنَا لَا يُرْجَعُونَ',
		number_in_surah: '39',
		page: '390',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3292',
		number: '3292',
		text: 'فَأَخَذْنَٰهُ وَجُنُودَهُۥ فَنَبَذْنَٰهُمْ فِى ٱلْيَمِّ ۖ فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ ٱلظَّٰلِمِينَ',
		number_in_surah: '40',
		page: '390',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3293',
		number: '3293',
		text: 'وَجَعَلْنَٰهُمْ أَئِمَّةًۭ يَدْعُونَ إِلَى ٱلنَّارِ ۖ وَيَوْمَ ٱلْقِيَٰمَةِ لَا يُنصَرُونَ',
		number_in_surah: '41',
		page: '390',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3294',
		number: '3294',
		text: 'وَأَتْبَعْنَٰهُمْ فِى هَٰذِهِ ٱلدُّنْيَا لَعْنَةًۭ ۖ وَيَوْمَ ٱلْقِيَٰمَةِ هُم مِّنَ ٱلْمَقْبُوحِينَ',
		number_in_surah: '42',
		page: '390',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3295',
		number: '3295',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ مِنۢ بَعْدِ مَآ أَهْلَكْنَا ٱلْقُرُونَ ٱلْأُولَىٰ بَصَآئِرَ لِلنَّاسِ وَهُدًۭى وَرَحْمَةًۭ لَّعَلَّهُمْ يَتَذَكَّرُونَ',
		number_in_surah: '43',
		page: '390',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3296',
		number: '3296',
		text: 'وَمَا كُنتَ بِجَانِبِ ٱلْغَرْبِىِّ إِذْ قَضَيْنَآ إِلَىٰ مُوسَى ٱلْأَمْرَ وَمَا كُنتَ مِنَ ٱلشَّٰهِدِينَ',
		number_in_surah: '44',
		page: '391',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3297',
		number: '3297',
		text: 'وَلَٰكِنَّآ أَنشَأْنَا قُرُونًۭا فَتَطَاوَلَ عَلَيْهِمُ ٱلْعُمُرُ ۚ وَمَا كُنتَ ثَاوِيًۭا فِىٓ أَهْلِ مَدْيَنَ تَتْلُوا۟ عَلَيْهِمْ ءَايَٰتِنَا وَلَٰكِنَّا كُنَّا مُرْسِلِينَ',
		number_in_surah: '45',
		page: '391',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3298',
		number: '3298',
		text: 'وَمَا كُنتَ بِجَانِبِ ٱلطُّورِ إِذْ نَادَيْنَا وَلَٰكِن رَّحْمَةًۭ مِّن رَّبِّكَ لِتُنذِرَ قَوْمًۭا مَّآ أَتَىٰهُم مِّن نَّذِيرٍۢ مِّن قَبْلِكَ لَعَلَّهُمْ يَتَذَكَّرُونَ',
		number_in_surah: '46',
		page: '391',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3299',
		number: '3299',
		text: 'وَلَوْلَآ أَن تُصِيبَهُم مُّصِيبَةٌۢ بِمَا قَدَّمَتْ أَيْدِيهِمْ فَيَقُولُوا۟ رَبَّنَا لَوْلَآ أَرْسَلْتَ إِلَيْنَا رَسُولًۭا فَنَتَّبِعَ ءَايَٰتِكَ وَنَكُونَ مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '47',
		page: '391',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3300',
		number: '3300',
		text: 'فَلَمَّا جَآءَهُمُ ٱلْحَقُّ مِنْ عِندِنَا قَالُوا۟ لَوْلَآ أُوتِىَ مِثْلَ مَآ أُوتِىَ مُوسَىٰٓ ۚ أَوَلَمْ يَكْفُرُوا۟ بِمَآ أُوتِىَ مُوسَىٰ مِن قَبْلُ ۖ قَالُوا۟ سِحْرَانِ تَظَٰهَرَا وَقَالُوٓا۟ إِنَّا بِكُلٍّۢ كَٰفِرُونَ',
		number_in_surah: '48',
		page: '391',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3301',
		number: '3301',
		text: 'قُلْ فَأْتُوا۟ بِكِتَٰبٍۢ مِّنْ عِندِ ٱللَّهِ هُوَ أَهْدَىٰ مِنْهُمَآ أَتَّبِعْهُ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '49',
		page: '391',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3302',
		number: '3302',
		text: 'فَإِن لَّمْ يَسْتَجِيبُوا۟ لَكَ فَٱعْلَمْ أَنَّمَا يَتَّبِعُونَ أَهْوَآءَهُمْ ۚ وَمَنْ أَضَلُّ مِمَّنِ ٱتَّبَعَ هَوَىٰهُ بِغَيْرِ هُدًۭى مِّنَ ٱللَّهِ ۚ إِنَّ ٱللَّهَ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '50',
		page: '391',
		surah_id: '28',
		hizb_id: '156',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3303',
		number: '3303',
		text: '۞ وَلَقَدْ وَصَّلْنَا لَهُمُ ٱلْقَوْلَ لَعَلَّهُمْ يَتَذَكَّرُونَ',
		number_in_surah: '51',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3304',
		number: '3304',
		text: 'ٱلَّذِينَ ءَاتَيْنَٰهُمُ ٱلْكِتَٰبَ مِن قَبْلِهِۦ هُم بِهِۦ يُؤْمِنُونَ',
		number_in_surah: '52',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3305',
		number: '3305',
		text: 'وَإِذَا يُتْلَىٰ عَلَيْهِمْ قَالُوٓا۟ ءَامَنَّا بِهِۦٓ إِنَّهُ ٱلْحَقُّ مِن رَّبِّنَآ إِنَّا كُنَّا مِن قَبْلِهِۦ مُسْلِمِينَ',
		number_in_surah: '53',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3306',
		number: '3306',
		text: 'أُو۟لَٰٓئِكَ يُؤْتَوْنَ أَجْرَهُم مَّرَّتَيْنِ بِمَا صَبَرُوا۟ وَيَدْرَءُونَ بِٱلْحَسَنَةِ ٱلسَّيِّئَةَ وَمِمَّا رَزَقْنَٰهُمْ يُنفِقُونَ',
		number_in_surah: '54',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3307',
		number: '3307',
		text: 'وَإِذَا سَمِعُوا۟ ٱللَّغْوَ أَعْرَضُوا۟ عَنْهُ وَقَالُوا۟ لَنَآ أَعْمَٰلُنَا وَلَكُمْ أَعْمَٰلُكُمْ سَلَٰمٌ عَلَيْكُمْ لَا نَبْتَغِى ٱلْجَٰهِلِينَ',
		number_in_surah: '55',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3308',
		number: '3308',
		text: 'إِنَّكَ لَا تَهْدِى مَنْ أَحْبَبْتَ وَلَٰكِنَّ ٱللَّهَ يَهْدِى مَن يَشَآءُ ۚ وَهُوَ أَعْلَمُ بِٱلْمُهْتَدِينَ',
		number_in_surah: '56',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3309',
		number: '3309',
		text: 'وَقَالُوٓا۟ إِن نَّتَّبِعِ ٱلْهُدَىٰ مَعَكَ نُتَخَطَّفْ مِنْ أَرْضِنَآ ۚ أَوَلَمْ نُمَكِّن لَّهُمْ حَرَمًا ءَامِنًۭا يُجْبَىٰٓ إِلَيْهِ ثَمَرَٰتُ كُلِّ شَىْءٍۢ رِّزْقًۭا مِّن لَّدُنَّا وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '57',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3310',
		number: '3310',
		text: 'وَكَمْ أَهْلَكْنَا مِن قَرْيَةٍۭ بَطِرَتْ مَعِيشَتَهَا ۖ فَتِلْكَ مَسَٰكِنُهُمْ لَمْ تُسْكَن مِّنۢ بَعْدِهِمْ إِلَّا قَلِيلًۭا ۖ وَكُنَّا نَحْنُ ٱلْوَٰرِثِينَ',
		number_in_surah: '58',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3311',
		number: '3311',
		text: 'وَمَا كَانَ رَبُّكَ مُهْلِكَ ٱلْقُرَىٰ حَتَّىٰ يَبْعَثَ فِىٓ أُمِّهَا رَسُولًۭا يَتْلُوا۟ عَلَيْهِمْ ءَايَٰتِنَا ۚ وَمَا كُنَّا مُهْلِكِى ٱلْقُرَىٰٓ إِلَّا وَأَهْلُهَا ظَٰلِمُونَ',
		number_in_surah: '59',
		page: '392',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3312',
		number: '3312',
		text: 'وَمَآ أُوتِيتُم مِّن شَىْءٍۢ فَمَتَٰعُ ٱلْحَيَوٰةِ ٱلدُّنْيَا وَزِينَتُهَا ۚ وَمَا عِندَ ٱللَّهِ خَيْرٌۭ وَأَبْقَىٰٓ ۚ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '60',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3313',
		number: '3313',
		text: 'أَفَمَن وَعَدْنَٰهُ وَعْدًا حَسَنًۭا فَهُوَ لَٰقِيهِ كَمَن مَّتَّعْنَٰهُ مَتَٰعَ ٱلْحَيَوٰةِ ٱلدُّنْيَا ثُمَّ هُوَ يَوْمَ ٱلْقِيَٰمَةِ مِنَ ٱلْمُحْضَرِينَ',
		number_in_surah: '61',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3314',
		number: '3314',
		text: 'وَيَوْمَ يُنَادِيهِمْ فَيَقُولُ أَيْنَ شُرَكَآءِىَ ٱلَّذِينَ كُنتُمْ تَزْعُمُونَ',
		number_in_surah: '62',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3315',
		number: '3315',
		text: 'قَالَ ٱلَّذِينَ حَقَّ عَلَيْهِمُ ٱلْقَوْلُ رَبَّنَا هَٰٓؤُلَآءِ ٱلَّذِينَ أَغْوَيْنَآ أَغْوَيْنَٰهُمْ كَمَا غَوَيْنَا ۖ تَبَرَّأْنَآ إِلَيْكَ ۖ مَا كَانُوٓا۟ إِيَّانَا يَعْبُدُونَ',
		number_in_surah: '63',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3316',
		number: '3316',
		text: 'وَقِيلَ ٱدْعُوا۟ شُرَكَآءَكُمْ فَدَعَوْهُمْ فَلَمْ يَسْتَجِيبُوا۟ لَهُمْ وَرَأَوُا۟ ٱلْعَذَابَ ۚ لَوْ أَنَّهُمْ كَانُوا۟ يَهْتَدُونَ',
		number_in_surah: '64',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3317',
		number: '3317',
		text: 'وَيَوْمَ يُنَادِيهِمْ فَيَقُولُ مَاذَآ أَجَبْتُمُ ٱلْمُرْسَلِينَ',
		number_in_surah: '65',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3318',
		number: '3318',
		text: 'فَعَمِيَتْ عَلَيْهِمُ ٱلْأَنۢبَآءُ يَوْمَئِذٍۢ فَهُمْ لَا يَتَسَآءَلُونَ',
		number_in_surah: '66',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3319',
		number: '3319',
		text: 'فَأَمَّا مَن تَابَ وَءَامَنَ وَعَمِلَ صَٰلِحًۭا فَعَسَىٰٓ أَن يَكُونَ مِنَ ٱلْمُفْلِحِينَ',
		number_in_surah: '67',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3320',
		number: '3320',
		text: 'وَرَبُّكَ يَخْلُقُ مَا يَشَآءُ وَيَخْتَارُ ۗ مَا كَانَ لَهُمُ ٱلْخِيَرَةُ ۚ سُبْحَٰنَ ٱللَّهِ وَتَعَٰلَىٰ عَمَّا يُشْرِكُونَ',
		number_in_surah: '68',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3321',
		number: '3321',
		text: 'وَرَبُّكَ يَعْلَمُ مَا تُكِنُّ صُدُورُهُمْ وَمَا يُعْلِنُونَ',
		number_in_surah: '69',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3322',
		number: '3322',
		text: 'وَهُوَ ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ۖ لَهُ ٱلْحَمْدُ فِى ٱلْأُولَىٰ وَٱلْءَاخِرَةِ ۖ وَلَهُ ٱلْحُكْمُ وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '70',
		page: '393',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3323',
		number: '3323',
		text: 'قُلْ أَرَءَيْتُمْ إِن جَعَلَ ٱللَّهُ عَلَيْكُمُ ٱلَّيْلَ سَرْمَدًا إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ مَنْ إِلَٰهٌ غَيْرُ ٱللَّهِ يَأْتِيكُم بِضِيَآءٍ ۖ أَفَلَا تَسْمَعُونَ',
		number_in_surah: '71',
		page: '394',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3324',
		number: '3324',
		text: 'قُلْ أَرَءَيْتُمْ إِن جَعَلَ ٱللَّهُ عَلَيْكُمُ ٱلنَّهَارَ سَرْمَدًا إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ مَنْ إِلَٰهٌ غَيْرُ ٱللَّهِ يَأْتِيكُم بِلَيْلٍۢ تَسْكُنُونَ فِيهِ ۖ أَفَلَا تُبْصِرُونَ',
		number_in_surah: '72',
		page: '394',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3325',
		number: '3325',
		text: 'وَمِن رَّحْمَتِهِۦ جَعَلَ لَكُمُ ٱلَّيْلَ وَٱلنَّهَارَ لِتَسْكُنُوا۟ فِيهِ وَلِتَبْتَغُوا۟ مِن فَضْلِهِۦ وَلَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '73',
		page: '394',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3326',
		number: '3326',
		text: 'وَيَوْمَ يُنَادِيهِمْ فَيَقُولُ أَيْنَ شُرَكَآءِىَ ٱلَّذِينَ كُنتُمْ تَزْعُمُونَ',
		number_in_surah: '74',
		page: '394',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3327',
		number: '3327',
		text: 'وَنَزَعْنَا مِن كُلِّ أُمَّةٍۢ شَهِيدًۭا فَقُلْنَا هَاتُوا۟ بُرْهَٰنَكُمْ فَعَلِمُوٓا۟ أَنَّ ٱلْحَقَّ لِلَّهِ وَضَلَّ عَنْهُم مَّا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '75',
		page: '394',
		surah_id: '28',
		hizb_id: '157',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3328',
		number: '3328',
		text: '۞ إِنَّ قَٰرُونَ كَانَ مِن قَوْمِ مُوسَىٰ فَبَغَىٰ عَلَيْهِمْ ۖ وَءَاتَيْنَٰهُ مِنَ ٱلْكُنُوزِ مَآ إِنَّ مَفَاتِحَهُۥ لَتَنُوٓأُ بِٱلْعُصْبَةِ أُو۟لِى ٱلْقُوَّةِ إِذْ قَالَ لَهُۥ قَوْمُهُۥ لَا تَفْرَحْ ۖ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلْفَرِحِينَ',
		number_in_surah: '76',
		page: '394',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3329',
		number: '3329',
		text: 'وَٱبْتَغِ فِيمَآ ءَاتَىٰكَ ٱللَّهُ ٱلدَّارَ ٱلْءَاخِرَةَ ۖ وَلَا تَنسَ نَصِيبَكَ مِنَ ٱلدُّنْيَا ۖ وَأَحْسِن كَمَآ أَحْسَنَ ٱللَّهُ إِلَيْكَ ۖ وَلَا تَبْغِ ٱلْفَسَادَ فِى ٱلْأَرْضِ ۖ إِنَّ ٱللَّهَ لَا يُحِبُّ ٱلْمُفْسِدِينَ',
		number_in_surah: '77',
		page: '394',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3330',
		number: '3330',
		text: 'قَالَ إِنَّمَآ أُوتِيتُهُۥ عَلَىٰ عِلْمٍ عِندِىٓ ۚ أَوَلَمْ يَعْلَمْ أَنَّ ٱللَّهَ قَدْ أَهْلَكَ مِن قَبْلِهِۦ مِنَ ٱلْقُرُونِ مَنْ هُوَ أَشَدُّ مِنْهُ قُوَّةًۭ وَأَكْثَرُ جَمْعًۭا ۚ وَلَا يُسْـَٔلُ عَن ذُنُوبِهِمُ ٱلْمُجْرِمُونَ',
		number_in_surah: '78',
		page: '395',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3331',
		number: '3331',
		text: 'فَخَرَجَ عَلَىٰ قَوْمِهِۦ فِى زِينَتِهِۦ ۖ قَالَ ٱلَّذِينَ يُرِيدُونَ ٱلْحَيَوٰةَ ٱلدُّنْيَا يَٰلَيْتَ لَنَا مِثْلَ مَآ أُوتِىَ قَٰرُونُ إِنَّهُۥ لَذُو حَظٍّ عَظِيمٍۢ',
		number_in_surah: '79',
		page: '395',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3332',
		number: '3332',
		text: 'وَقَالَ ٱلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ وَيْلَكُمْ ثَوَابُ ٱللَّهِ خَيْرٌۭ لِّمَنْ ءَامَنَ وَعَمِلَ صَٰلِحًۭا وَلَا يُلَقَّىٰهَآ إِلَّا ٱلصَّٰبِرُونَ',
		number_in_surah: '80',
		page: '395',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3333',
		number: '3333',
		text: 'فَخَسَفْنَا بِهِۦ وَبِدَارِهِ ٱلْأَرْضَ فَمَا كَانَ لَهُۥ مِن فِئَةٍۢ يَنصُرُونَهُۥ مِن دُونِ ٱللَّهِ وَمَا كَانَ مِنَ ٱلْمُنتَصِرِينَ',
		number_in_surah: '81',
		page: '395',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3334',
		number: '3334',
		text: 'وَأَصْبَحَ ٱلَّذِينَ تَمَنَّوْا۟ مَكَانَهُۥ بِٱلْأَمْسِ يَقُولُونَ وَيْكَأَنَّ ٱللَّهَ يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ مِنْ عِبَادِهِۦ وَيَقْدِرُ ۖ لَوْلَآ أَن مَّنَّ ٱللَّهُ عَلَيْنَا لَخَسَفَ بِنَا ۖ وَيْكَأَنَّهُۥ لَا يُفْلِحُ ٱلْكَٰفِرُونَ',
		number_in_surah: '82',
		page: '395',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:05',
		updated_at: '2018-06-07 08:07:05',
	},
	{
		id: '3335',
		number: '3335',
		text: 'تِلْكَ ٱلدَّارُ ٱلْءَاخِرَةُ نَجْعَلُهَا لِلَّذِينَ لَا يُرِيدُونَ عُلُوًّۭا فِى ٱلْأَرْضِ وَلَا فَسَادًۭا ۚ وَٱلْعَٰقِبَةُ لِلْمُتَّقِينَ',
		number_in_surah: '83',
		page: '395',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3336',
		number: '3336',
		text: 'مَن جَآءَ بِٱلْحَسَنَةِ فَلَهُۥ خَيْرٌۭ مِّنْهَا ۖ وَمَن جَآءَ بِٱلسَّيِّئَةِ فَلَا يُجْزَى ٱلَّذِينَ عَمِلُوا۟ ٱلسَّيِّـَٔاتِ إِلَّا مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '84',
		page: '395',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3337',
		number: '3337',
		text: 'إِنَّ ٱلَّذِى فَرَضَ عَلَيْكَ ٱلْقُرْءَانَ لَرَآدُّكَ إِلَىٰ مَعَادٍۢ ۚ قُل رَّبِّىٓ أَعْلَمُ مَن جَآءَ بِٱلْهُدَىٰ وَمَنْ هُوَ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '85',
		page: '396',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3338',
		number: '3338',
		text: 'وَمَا كُنتَ تَرْجُوٓا۟ أَن يُلْقَىٰٓ إِلَيْكَ ٱلْكِتَٰبُ إِلَّا رَحْمَةًۭ مِّن رَّبِّكَ ۖ فَلَا تَكُونَنَّ ظَهِيرًۭا لِّلْكَٰفِرِينَ',
		number_in_surah: '86',
		page: '396',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3339',
		number: '3339',
		text: 'وَلَا يَصُدُّنَّكَ عَنْ ءَايَٰتِ ٱللَّهِ بَعْدَ إِذْ أُنزِلَتْ إِلَيْكَ ۖ وَٱدْعُ إِلَىٰ رَبِّكَ ۖ وَلَا تَكُونَنَّ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '87',
		page: '396',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3340',
		number: '3340',
		text: 'وَلَا تَدْعُ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ ۘ لَآ إِلَٰهَ إِلَّا هُوَ ۚ كُلُّ شَىْءٍ هَالِكٌ إِلَّا وَجْهَهُۥ ۚ لَهُ ٱلْحُكْمُ وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '88',
		page: '396',
		surah_id: '28',
		hizb_id: '158',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3341',
		number: '3341',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓمٓ',
		number_in_surah: '1',
		page: '396',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3342',
		number: '3342',
		text: 'أَحَسِبَ ٱلنَّاسُ أَن يُتْرَكُوٓا۟ أَن يَقُولُوٓا۟ ءَامَنَّا وَهُمْ لَا يُفْتَنُونَ',
		number_in_surah: '2',
		page: '396',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3343',
		number: '3343',
		text: 'وَلَقَدْ فَتَنَّا ٱلَّذِينَ مِن قَبْلِهِمْ ۖ فَلَيَعْلَمَنَّ ٱللَّهُ ٱلَّذِينَ صَدَقُوا۟ وَلَيَعْلَمَنَّ ٱلْكَٰذِبِينَ',
		number_in_surah: '3',
		page: '396',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3344',
		number: '3344',
		text: 'أَمْ حَسِبَ ٱلَّذِينَ يَعْمَلُونَ ٱلسَّيِّـَٔاتِ أَن يَسْبِقُونَا ۚ سَآءَ مَا يَحْكُمُونَ',
		number_in_surah: '4',
		page: '396',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3345',
		number: '3345',
		text: 'مَن كَانَ يَرْجُوا۟ لِقَآءَ ٱللَّهِ فَإِنَّ أَجَلَ ٱللَّهِ لَءَاتٍۢ ۚ وَهُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '5',
		page: '396',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3346',
		number: '3346',
		text: 'وَمَن جَٰهَدَ فَإِنَّمَا يُجَٰهِدُ لِنَفْسِهِۦٓ ۚ إِنَّ ٱللَّهَ لَغَنِىٌّ عَنِ ٱلْعَٰلَمِينَ',
		number_in_surah: '6',
		page: '396',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3347',
		number: '3347',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَنُكَفِّرَنَّ عَنْهُمْ سَيِّـَٔاتِهِمْ وَلَنَجْزِيَنَّهُمْ أَحْسَنَ ٱلَّذِى كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '7',
		page: '397',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3348',
		number: '3348',
		text: 'وَوَصَّيْنَا ٱلْإِنسَٰنَ بِوَٰلِدَيْهِ حُسْنًۭا ۖ وَإِن جَٰهَدَاكَ لِتُشْرِكَ بِى مَا لَيْسَ لَكَ بِهِۦ عِلْمٌۭ فَلَا تُطِعْهُمَآ ۚ إِلَىَّ مَرْجِعُكُمْ فَأُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '8',
		page: '397',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3349',
		number: '3349',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَنُدْخِلَنَّهُمْ فِى ٱلصَّٰلِحِينَ',
		number_in_surah: '9',
		page: '397',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3350',
		number: '3350',
		text: 'وَمِنَ ٱلنَّاسِ مَن يَقُولُ ءَامَنَّا بِٱللَّهِ فَإِذَآ أُوذِىَ فِى ٱللَّهِ جَعَلَ فِتْنَةَ ٱلنَّاسِ كَعَذَابِ ٱللَّهِ وَلَئِن جَآءَ نَصْرٌۭ مِّن رَّبِّكَ لَيَقُولُنَّ إِنَّا كُنَّا مَعَكُمْ ۚ أَوَلَيْسَ ٱللَّهُ بِأَعْلَمَ بِمَا فِى صُدُورِ ٱلْعَٰلَمِينَ',
		number_in_surah: '10',
		page: '397',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3351',
		number: '3351',
		text: 'وَلَيَعْلَمَنَّ ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ وَلَيَعْلَمَنَّ ٱلْمُنَٰفِقِينَ',
		number_in_surah: '11',
		page: '397',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3352',
		number: '3352',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ لِلَّذِينَ ءَامَنُوا۟ ٱتَّبِعُوا۟ سَبِيلَنَا وَلْنَحْمِلْ خَطَٰيَٰكُمْ وَمَا هُم بِحَٰمِلِينَ مِنْ خَطَٰيَٰهُم مِّن شَىْءٍ ۖ إِنَّهُمْ لَكَٰذِبُونَ',
		number_in_surah: '12',
		page: '397',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3353',
		number: '3353',
		text: 'وَلَيَحْمِلُنَّ أَثْقَالَهُمْ وَأَثْقَالًۭا مَّعَ أَثْقَالِهِمْ ۖ وَلَيُسْـَٔلُنَّ يَوْمَ ٱلْقِيَٰمَةِ عَمَّا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '13',
		page: '397',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3354',
		number: '3354',
		text: 'وَلَقَدْ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِۦ فَلَبِثَ فِيهِمْ أَلْفَ سَنَةٍ إِلَّا خَمْسِينَ عَامًۭا فَأَخَذَهُمُ ٱلطُّوفَانُ وَهُمْ ظَٰلِمُونَ',
		number_in_surah: '14',
		page: '397',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3355',
		number: '3355',
		text: 'فَأَنجَيْنَٰهُ وَأَصْحَٰبَ ٱلسَّفِينَةِ وَجَعَلْنَٰهَآ ءَايَةًۭ لِّلْعَٰلَمِينَ',
		number_in_surah: '15',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3356',
		number: '3356',
		text: 'وَإِبْرَٰهِيمَ إِذْ قَالَ لِقَوْمِهِ ٱعْبُدُوا۟ ٱللَّهَ وَٱتَّقُوهُ ۖ ذَٰلِكُمْ خَيْرٌۭ لَّكُمْ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '16',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3357',
		number: '3357',
		text: 'إِنَّمَا تَعْبُدُونَ مِن دُونِ ٱللَّهِ أَوْثَٰنًۭا وَتَخْلُقُونَ إِفْكًا ۚ إِنَّ ٱلَّذِينَ تَعْبُدُونَ مِن دُونِ ٱللَّهِ لَا يَمْلِكُونَ لَكُمْ رِزْقًۭا فَٱبْتَغُوا۟ عِندَ ٱللَّهِ ٱلرِّزْقَ وَٱعْبُدُوهُ وَٱشْكُرُوا۟ لَهُۥٓ ۖ إِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '17',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3358',
		number: '3358',
		text: 'وَإِن تُكَذِّبُوا۟ فَقَدْ كَذَّبَ أُمَمٌۭ مِّن قَبْلِكُمْ ۖ وَمَا عَلَى ٱلرَّسُولِ إِلَّا ٱلْبَلَٰغُ ٱلْمُبِينُ',
		number_in_surah: '18',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3359',
		number: '3359',
		text: 'أَوَلَمْ يَرَوْا۟ كَيْفَ يُبْدِئُ ٱللَّهُ ٱلْخَلْقَ ثُمَّ يُعِيدُهُۥٓ ۚ إِنَّ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٌۭ',
		number_in_surah: '19',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3360',
		number: '3360',
		text: 'قُلْ سِيرُوا۟ فِى ٱلْأَرْضِ فَٱنظُرُوا۟ كَيْفَ بَدَأَ ٱلْخَلْقَ ۚ ثُمَّ ٱللَّهُ يُنشِئُ ٱلنَّشْأَةَ ٱلْءَاخِرَةَ ۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '20',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3361',
		number: '3361',
		text: 'يُعَذِّبُ مَن يَشَآءُ وَيَرْحَمُ مَن يَشَآءُ ۖ وَإِلَيْهِ تُقْلَبُونَ',
		number_in_surah: '21',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3362',
		number: '3362',
		text: 'وَمَآ أَنتُم بِمُعْجِزِينَ فِى ٱلْأَرْضِ وَلَا فِى ٱلسَّمَآءِ ۖ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِن وَلِىٍّۢ وَلَا نَصِيرٍۢ',
		number_in_surah: '22',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3363',
		number: '3363',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ بِـَٔايَٰتِ ٱللَّهِ وَلِقَآئِهِۦٓ أُو۟لَٰٓئِكَ يَئِسُوا۟ مِن رَّحْمَتِى وَأُو۟لَٰٓئِكَ لَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '23',
		page: '398',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3364',
		number: '3364',
		text: 'فَمَا كَانَ جَوَابَ قَوْمِهِۦٓ إِلَّآ أَن قَالُوا۟ ٱقْتُلُوهُ أَوْ حَرِّقُوهُ فَأَنجَىٰهُ ٱللَّهُ مِنَ ٱلنَّارِ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '24',
		page: '399',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3365',
		number: '3365',
		text: 'وَقَالَ إِنَّمَا ٱتَّخَذْتُم مِّن دُونِ ٱللَّهِ أَوْثَٰنًۭا مَّوَدَّةَ بَيْنِكُمْ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ ثُمَّ يَوْمَ ٱلْقِيَٰمَةِ يَكْفُرُ بَعْضُكُم بِبَعْضٍۢ وَيَلْعَنُ بَعْضُكُم بَعْضًۭا وَمَأْوَىٰكُمُ ٱلنَّارُ وَمَا لَكُم مِّن نَّٰصِرِينَ',
		number_in_surah: '25',
		page: '399',
		surah_id: '29',
		hizb_id: '159',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3366',
		number: '3366',
		text: '۞ فَـَٔامَنَ لَهُۥ لُوطٌۭ ۘ وَقَالَ إِنِّى مُهَاجِرٌ إِلَىٰ رَبِّىٓ ۖ إِنَّهُۥ هُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '26',
		page: '399',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3367',
		number: '3367',
		text: 'وَوَهَبْنَا لَهُۥٓ إِسْحَٰقَ وَيَعْقُوبَ وَجَعَلْنَا فِى ذُرِّيَّتِهِ ٱلنُّبُوَّةَ وَٱلْكِتَٰبَ وَءَاتَيْنَٰهُ أَجْرَهُۥ فِى ٱلدُّنْيَا ۖ وَإِنَّهُۥ فِى ٱلْءَاخِرَةِ لَمِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '27',
		page: '399',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3368',
		number: '3368',
		text: 'وَلُوطًا إِذْ قَالَ لِقَوْمِهِۦٓ إِنَّكُمْ لَتَأْتُونَ ٱلْفَٰحِشَةَ مَا سَبَقَكُم بِهَا مِنْ أَحَدٍۢ مِّنَ ٱلْعَٰلَمِينَ',
		number_in_surah: '28',
		page: '399',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3369',
		number: '3369',
		text: 'أَئِنَّكُمْ لَتَأْتُونَ ٱلرِّجَالَ وَتَقْطَعُونَ ٱلسَّبِيلَ وَتَأْتُونَ فِى نَادِيكُمُ ٱلْمُنكَرَ ۖ فَمَا كَانَ جَوَابَ قَوْمِهِۦٓ إِلَّآ أَن قَالُوا۟ ٱئْتِنَا بِعَذَابِ ٱللَّهِ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '29',
		page: '399',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3370',
		number: '3370',
		text: 'قَالَ رَبِّ ٱنصُرْنِى عَلَى ٱلْقَوْمِ ٱلْمُفْسِدِينَ',
		number_in_surah: '30',
		page: '399',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3371',
		number: '3371',
		text: 'وَلَمَّا جَآءَتْ رُسُلُنَآ إِبْرَٰهِيمَ بِٱلْبُشْرَىٰ قَالُوٓا۟ إِنَّا مُهْلِكُوٓا۟ أَهْلِ هَٰذِهِ ٱلْقَرْيَةِ ۖ إِنَّ أَهْلَهَا كَانُوا۟ ظَٰلِمِينَ',
		number_in_surah: '31',
		page: '400',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3372',
		number: '3372',
		text: 'قَالَ إِنَّ فِيهَا لُوطًۭا ۚ قَالُوا۟ نَحْنُ أَعْلَمُ بِمَن فِيهَا ۖ لَنُنَجِّيَنَّهُۥ وَأَهْلَهُۥٓ إِلَّا ٱمْرَأَتَهُۥ كَانَتْ مِنَ ٱلْغَٰبِرِينَ',
		number_in_surah: '32',
		page: '400',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3373',
		number: '3373',
		text: 'وَلَمَّآ أَن جَآءَتْ رُسُلُنَا لُوطًۭا سِىٓءَ بِهِمْ وَضَاقَ بِهِمْ ذَرْعًۭا وَقَالُوا۟ لَا تَخَفْ وَلَا تَحْزَنْ ۖ إِنَّا مُنَجُّوكَ وَأَهْلَكَ إِلَّا ٱمْرَأَتَكَ كَانَتْ مِنَ ٱلْغَٰبِرِينَ',
		number_in_surah: '33',
		page: '400',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3374',
		number: '3374',
		text: 'إِنَّا مُنزِلُونَ عَلَىٰٓ أَهْلِ هَٰذِهِ ٱلْقَرْيَةِ رِجْزًۭا مِّنَ ٱلسَّمَآءِ بِمَا كَانُوا۟ يَفْسُقُونَ',
		number_in_surah: '34',
		page: '400',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3375',
		number: '3375',
		text: 'وَلَقَد تَّرَكْنَا مِنْهَآ ءَايَةًۢ بَيِّنَةًۭ لِّقَوْمٍۢ يَعْقِلُونَ',
		number_in_surah: '35',
		page: '400',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3376',
		number: '3376',
		text: 'وَإِلَىٰ مَدْيَنَ أَخَاهُمْ شُعَيْبًۭا فَقَالَ يَٰقَوْمِ ٱعْبُدُوا۟ ٱللَّهَ وَٱرْجُوا۟ ٱلْيَوْمَ ٱلْءَاخِرَ وَلَا تَعْثَوْا۟ فِى ٱلْأَرْضِ مُفْسِدِينَ',
		number_in_surah: '36',
		page: '400',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3377',
		number: '3377',
		text: 'فَكَذَّبُوهُ فَأَخَذَتْهُمُ ٱلرَّجْفَةُ فَأَصْبَحُوا۟ فِى دَارِهِمْ جَٰثِمِينَ',
		number_in_surah: '37',
		page: '400',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3378',
		number: '3378',
		text: 'وَعَادًۭا وَثَمُودَا۟ وَقَد تَّبَيَّنَ لَكُم مِّن مَّسَٰكِنِهِمْ ۖ وَزَيَّنَ لَهُمُ ٱلشَّيْطَٰنُ أَعْمَٰلَهُمْ فَصَدَّهُمْ عَنِ ٱلسَّبِيلِ وَكَانُوا۟ مُسْتَبْصِرِينَ',
		number_in_surah: '38',
		page: '400',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3379',
		number: '3379',
		text: 'وَقَٰرُونَ وَفِرْعَوْنَ وَهَٰمَٰنَ ۖ وَلَقَدْ جَآءَهُم مُّوسَىٰ بِٱلْبَيِّنَٰتِ فَٱسْتَكْبَرُوا۟ فِى ٱلْأَرْضِ وَمَا كَانُوا۟ سَٰبِقِينَ',
		number_in_surah: '39',
		page: '401',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3380',
		number: '3380',
		text: 'فَكُلًّا أَخَذْنَا بِذَنۢبِهِۦ ۖ فَمِنْهُم مَّنْ أَرْسَلْنَا عَلَيْهِ حَاصِبًۭا وَمِنْهُم مَّنْ أَخَذَتْهُ ٱلصَّيْحَةُ وَمِنْهُم مَّنْ خَسَفْنَا بِهِ ٱلْأَرْضَ وَمِنْهُم مَّنْ أَغْرَقْنَا ۚ وَمَا كَانَ ٱللَّهُ لِيَظْلِمَهُمْ وَلَٰكِن كَانُوٓا۟ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '40',
		page: '401',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3381',
		number: '3381',
		text: 'مَثَلُ ٱلَّذِينَ ٱتَّخَذُوا۟ مِن دُونِ ٱللَّهِ أَوْلِيَآءَ كَمَثَلِ ٱلْعَنكَبُوتِ ٱتَّخَذَتْ بَيْتًۭا ۖ وَإِنَّ أَوْهَنَ ٱلْبُيُوتِ لَبَيْتُ ٱلْعَنكَبُوتِ ۖ لَوْ كَانُوا۟ يَعْلَمُونَ',
		number_in_surah: '41',
		page: '401',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3382',
		number: '3382',
		text: 'إِنَّ ٱللَّهَ يَعْلَمُ مَا يَدْعُونَ مِن دُونِهِۦ مِن شَىْءٍۢ ۚ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '42',
		page: '401',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3383',
		number: '3383',
		text: 'وَتِلْكَ ٱلْأَمْثَٰلُ نَضْرِبُهَا لِلنَّاسِ ۖ وَمَا يَعْقِلُهَآ إِلَّا ٱلْعَٰلِمُونَ',
		number_in_surah: '43',
		page: '401',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3384',
		number: '3384',
		text: 'خَلَقَ ٱللَّهُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ بِٱلْحَقِّ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّلْمُؤْمِنِينَ',
		number_in_surah: '44',
		page: '401',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3385',
		number: '3385',
		text: 'ٱتْلُ مَآ أُوحِىَ إِلَيْكَ مِنَ ٱلْكِتَٰبِ وَأَقِمِ ٱلصَّلَوٰةَ ۖ إِنَّ ٱلصَّلَوٰةَ تَنْهَىٰ عَنِ ٱلْفَحْشَآءِ وَٱلْمُنكَرِ ۗ وَلَذِكْرُ ٱللَّهِ أَكْبَرُ ۗ وَٱللَّهُ يَعْلَمُ مَا تَصْنَعُونَ',
		number_in_surah: '45',
		page: '401',
		surah_id: '29',
		hizb_id: '160',
		juz_id: '20',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3386',
		number: '3386',
		text: '۞ وَلَا تُجَٰدِلُوٓا۟ أَهْلَ ٱلْكِتَٰبِ إِلَّا بِٱلَّتِى هِىَ أَحْسَنُ إِلَّا ٱلَّذِينَ ظَلَمُوا۟ مِنْهُمْ ۖ وَقُولُوٓا۟ ءَامَنَّا بِٱلَّذِىٓ أُنزِلَ إِلَيْنَا وَأُنزِلَ إِلَيْكُمْ وَإِلَٰهُنَا وَإِلَٰهُكُمْ وَٰحِدٌۭ وَنَحْنُ لَهُۥ مُسْلِمُونَ',
		number_in_surah: '46',
		page: '402',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3387',
		number: '3387',
		text: 'وَكَذَٰلِكَ أَنزَلْنَآ إِلَيْكَ ٱلْكِتَٰبَ ۚ فَٱلَّذِينَ ءَاتَيْنَٰهُمُ ٱلْكِتَٰبَ يُؤْمِنُونَ بِهِۦ ۖ وَمِنْ هَٰٓؤُلَآءِ مَن يُؤْمِنُ بِهِۦ ۚ وَمَا يَجْحَدُ بِـَٔايَٰتِنَآ إِلَّا ٱلْكَٰفِرُونَ',
		number_in_surah: '47',
		page: '402',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3388',
		number: '3388',
		text: 'وَمَا كُنتَ تَتْلُوا۟ مِن قَبْلِهِۦ مِن كِتَٰبٍۢ وَلَا تَخُطُّهُۥ بِيَمِينِكَ ۖ إِذًۭا لَّٱرْتَابَ ٱلْمُبْطِلُونَ',
		number_in_surah: '48',
		page: '402',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3389',
		number: '3389',
		text: 'بَلْ هُوَ ءَايَٰتٌۢ بَيِّنَٰتٌۭ فِى صُدُورِ ٱلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ ۚ وَمَا يَجْحَدُ بِـَٔايَٰتِنَآ إِلَّا ٱلظَّٰلِمُونَ',
		number_in_surah: '49',
		page: '402',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3390',
		number: '3390',
		text: 'وَقَالُوا۟ لَوْلَآ أُنزِلَ عَلَيْهِ ءَايَٰتٌۭ مِّن رَّبِّهِۦ ۖ قُلْ إِنَّمَا ٱلْءَايَٰتُ عِندَ ٱللَّهِ وَإِنَّمَآ أَنَا۠ نَذِيرٌۭ مُّبِينٌ',
		number_in_surah: '50',
		page: '402',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3391',
		number: '3391',
		text: 'أَوَلَمْ يَكْفِهِمْ أَنَّآ أَنزَلْنَا عَلَيْكَ ٱلْكِتَٰبَ يُتْلَىٰ عَلَيْهِمْ ۚ إِنَّ فِى ذَٰلِكَ لَرَحْمَةًۭ وَذِكْرَىٰ لِقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '51',
		page: '402',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3392',
		number: '3392',
		text: 'قُلْ كَفَىٰ بِٱللَّهِ بَيْنِى وَبَيْنَكُمْ شَهِيدًۭا ۖ يَعْلَمُ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۗ وَٱلَّذِينَ ءَامَنُوا۟ بِٱلْبَٰطِلِ وَكَفَرُوا۟ بِٱللَّهِ أُو۟لَٰٓئِكَ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '52',
		page: '402',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3393',
		number: '3393',
		text: 'وَيَسْتَعْجِلُونَكَ بِٱلْعَذَابِ ۚ وَلَوْلَآ أَجَلٌۭ مُّسَمًّۭى لَّجَآءَهُمُ ٱلْعَذَابُ وَلَيَأْتِيَنَّهُم بَغْتَةًۭ وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '53',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3394',
		number: '3394',
		text: 'يَسْتَعْجِلُونَكَ بِٱلْعَذَابِ وَإِنَّ جَهَنَّمَ لَمُحِيطَةٌۢ بِٱلْكَٰفِرِينَ',
		number_in_surah: '54',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3395',
		number: '3395',
		text: 'يَوْمَ يَغْشَىٰهُمُ ٱلْعَذَابُ مِن فَوْقِهِمْ وَمِن تَحْتِ أَرْجُلِهِمْ وَيَقُولُ ذُوقُوا۟ مَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '55',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3396',
		number: '3396',
		text: 'يَٰعِبَادِىَ ٱلَّذِينَ ءَامَنُوٓا۟ إِنَّ أَرْضِى وَٰسِعَةٌۭ فَإِيَّٰىَ فَٱعْبُدُونِ',
		number_in_surah: '56',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3397',
		number: '3397',
		text: 'كُلُّ نَفْسٍۢ ذَآئِقَةُ ٱلْمَوْتِ ۖ ثُمَّ إِلَيْنَا تُرْجَعُونَ',
		number_in_surah: '57',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3398',
		number: '3398',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَنُبَوِّئَنَّهُم مِّنَ ٱلْجَنَّةِ غُرَفًۭا تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا ۚ نِعْمَ أَجْرُ ٱلْعَٰمِلِينَ',
		number_in_surah: '58',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3399',
		number: '3399',
		text: 'ٱلَّذِينَ صَبَرُوا۟ وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ',
		number_in_surah: '59',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3400',
		number: '3400',
		text: 'وَكَأَيِّن مِّن دَآبَّةٍۢ لَّا تَحْمِلُ رِزْقَهَا ٱللَّهُ يَرْزُقُهَا وَإِيَّاكُمْ ۚ وَهُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '60',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3401',
		number: '3401',
		text: 'وَلَئِن سَأَلْتَهُم مَّنْ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَسَخَّرَ ٱلشَّمْسَ وَٱلْقَمَرَ لَيَقُولُنَّ ٱللَّهُ ۖ فَأَنَّىٰ يُؤْفَكُونَ',
		number_in_surah: '61',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3402',
		number: '3402',
		text: 'ٱللَّهُ يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ مِنْ عِبَادِهِۦ وَيَقْدِرُ لَهُۥٓ ۚ إِنَّ ٱللَّهَ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '62',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3403',
		number: '3403',
		text: 'وَلَئِن سَأَلْتَهُم مَّن نَّزَّلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَحْيَا بِهِ ٱلْأَرْضَ مِنۢ بَعْدِ مَوْتِهَا لَيَقُولُنَّ ٱللَّهُ ۚ قُلِ ٱلْحَمْدُ لِلَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْقِلُونَ',
		number_in_surah: '63',
		page: '403',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3404',
		number: '3404',
		text: 'وَمَا هَٰذِهِ ٱلْحَيَوٰةُ ٱلدُّنْيَآ إِلَّا لَهْوٌۭ وَلَعِبٌۭ ۚ وَإِنَّ ٱلدَّارَ ٱلْءَاخِرَةَ لَهِىَ ٱلْحَيَوَانُ ۚ لَوْ كَانُوا۟ يَعْلَمُونَ',
		number_in_surah: '64',
		page: '404',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3405',
		number: '3405',
		text: 'فَإِذَا رَكِبُوا۟ فِى ٱلْفُلْكِ دَعَوُا۟ ٱللَّهَ مُخْلِصِينَ لَهُ ٱلدِّينَ فَلَمَّا نَجَّىٰهُمْ إِلَى ٱلْبَرِّ إِذَا هُمْ يُشْرِكُونَ',
		number_in_surah: '65',
		page: '404',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3406',
		number: '3406',
		text: 'لِيَكْفُرُوا۟ بِمَآ ءَاتَيْنَٰهُمْ وَلِيَتَمَتَّعُوا۟ ۖ فَسَوْفَ يَعْلَمُونَ',
		number_in_surah: '66',
		page: '404',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3407',
		number: '3407',
		text: 'أَوَلَمْ يَرَوْا۟ أَنَّا جَعَلْنَا حَرَمًا ءَامِنًۭا وَيُتَخَطَّفُ ٱلنَّاسُ مِنْ حَوْلِهِمْ ۚ أَفَبِٱلْبَٰطِلِ يُؤْمِنُونَ وَبِنِعْمَةِ ٱللَّهِ يَكْفُرُونَ',
		number_in_surah: '67',
		page: '404',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3408',
		number: '3408',
		text: 'وَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَوْ كَذَّبَ بِٱلْحَقِّ لَمَّا جَآءَهُۥٓ ۚ أَلَيْسَ فِى جَهَنَّمَ مَثْوًۭى لِّلْكَٰفِرِينَ',
		number_in_surah: '68',
		page: '404',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3409',
		number: '3409',
		text: 'وَٱلَّذِينَ جَٰهَدُوا۟ فِينَا لَنَهْدِيَنَّهُمْ سُبُلَنَا ۚ وَإِنَّ ٱللَّهَ لَمَعَ ٱلْمُحْسِنِينَ',
		number_in_surah: '69',
		page: '404',
		surah_id: '29',
		hizb_id: '161',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3410',
		number: '3410',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓمٓ',
		number_in_surah: '1',
		page: '404',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3411',
		number: '3411',
		text: 'غُلِبَتِ ٱلرُّومُ',
		number_in_surah: '2',
		page: '404',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3412',
		number: '3412',
		text: 'فِىٓ أَدْنَى ٱلْأَرْضِ وَهُم مِّنۢ بَعْدِ غَلَبِهِمْ سَيَغْلِبُونَ',
		number_in_surah: '3',
		page: '404',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3413',
		number: '3413',
		text: 'فِى بِضْعِ سِنِينَ ۗ لِلَّهِ ٱلْأَمْرُ مِن قَبْلُ وَمِنۢ بَعْدُ ۚ وَيَوْمَئِذٍۢ يَفْرَحُ ٱلْمُؤْمِنُونَ',
		number_in_surah: '4',
		page: '404',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3414',
		number: '3414',
		text: 'بِنَصْرِ ٱللَّهِ ۚ يَنصُرُ مَن يَشَآءُ ۖ وَهُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '5',
		page: '404',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3415',
		number: '3415',
		text: 'وَعْدَ ٱللَّهِ ۖ لَا يُخْلِفُ ٱللَّهُ وَعْدَهُۥ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '6',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3416',
		number: '3416',
		text: 'يَعْلَمُونَ ظَٰهِرًۭا مِّنَ ٱلْحَيَوٰةِ ٱلدُّنْيَا وَهُمْ عَنِ ٱلْءَاخِرَةِ هُمْ غَٰفِلُونَ',
		number_in_surah: '7',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3417',
		number: '3417',
		text: 'أَوَلَمْ يَتَفَكَّرُوا۟ فِىٓ أَنفُسِهِم ۗ مَّا خَلَقَ ٱللَّهُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَمَا بَيْنَهُمَآ إِلَّا بِٱلْحَقِّ وَأَجَلٍۢ مُّسَمًّۭى ۗ وَإِنَّ كَثِيرًۭا مِّنَ ٱلنَّاسِ بِلِقَآئِ رَبِّهِمْ لَكَٰفِرُونَ',
		number_in_surah: '8',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3418',
		number: '3418',
		text: 'أَوَلَمْ يَسِيرُوا۟ فِى ٱلْأَرْضِ فَيَنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبْلِهِمْ ۚ كَانُوٓا۟ أَشَدَّ مِنْهُمْ قُوَّةًۭ وَأَثَارُوا۟ ٱلْأَرْضَ وَعَمَرُوهَآ أَكْثَرَ مِمَّا عَمَرُوهَا وَجَآءَتْهُمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ ۖ فَمَا كَانَ ٱللَّهُ لِيَظْلِمَهُمْ وَلَٰكِن كَانُوٓا۟ أَنفُسَهُمْ يَظْلِمُونَ',
		number_in_surah: '9',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3419',
		number: '3419',
		text: 'ثُمَّ كَانَ عَٰقِبَةَ ٱلَّذِينَ أَسَٰٓـُٔوا۟ ٱلسُّوٓأَىٰٓ أَن كَذَّبُوا۟ بِـَٔايَٰتِ ٱللَّهِ وَكَانُوا۟ بِهَا يَسْتَهْزِءُونَ',
		number_in_surah: '10',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3420',
		number: '3420',
		text: 'ٱللَّهُ يَبْدَؤُا۟ ٱلْخَلْقَ ثُمَّ يُعِيدُهُۥ ثُمَّ إِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '11',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3421',
		number: '3421',
		text: 'وَيَوْمَ تَقُومُ ٱلسَّاعَةُ يُبْلِسُ ٱلْمُجْرِمُونَ',
		number_in_surah: '12',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3422',
		number: '3422',
		text: 'وَلَمْ يَكُن لَّهُم مِّن شُرَكَآئِهِمْ شُفَعَٰٓؤُا۟ وَكَانُوا۟ بِشُرَكَآئِهِمْ كَٰفِرِينَ',
		number_in_surah: '13',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3423',
		number: '3423',
		text: 'وَيَوْمَ تَقُومُ ٱلسَّاعَةُ يَوْمَئِذٍۢ يَتَفَرَّقُونَ',
		number_in_surah: '14',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3424',
		number: '3424',
		text: 'فَأَمَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ فَهُمْ فِى رَوْضَةٍۢ يُحْبَرُونَ',
		number_in_surah: '15',
		page: '405',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3425',
		number: '3425',
		text: 'وَأَمَّا ٱلَّذِينَ كَفَرُوا۟ وَكَذَّبُوا۟ بِـَٔايَٰتِنَا وَلِقَآئِ ٱلْءَاخِرَةِ فَأُو۟لَٰٓئِكَ فِى ٱلْعَذَابِ مُحْضَرُونَ',
		number_in_surah: '16',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3426',
		number: '3426',
		text: 'فَسُبْحَٰنَ ٱللَّهِ حِينَ تُمْسُونَ وَحِينَ تُصْبِحُونَ',
		number_in_surah: '17',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3427',
		number: '3427',
		text: 'وَلَهُ ٱلْحَمْدُ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَعَشِيًّۭا وَحِينَ تُظْهِرُونَ',
		number_in_surah: '18',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3428',
		number: '3428',
		text: 'يُخْرِجُ ٱلْحَىَّ مِنَ ٱلْمَيِّتِ وَيُخْرِجُ ٱلْمَيِّتَ مِنَ ٱلْحَىِّ وَيُحْىِ ٱلْأَرْضَ بَعْدَ مَوْتِهَا ۚ وَكَذَٰلِكَ تُخْرَجُونَ',
		number_in_surah: '19',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3429',
		number: '3429',
		text: 'وَمِنْ ءَايَٰتِهِۦٓ أَنْ خَلَقَكُم مِّن تُرَابٍۢ ثُمَّ إِذَآ أَنتُم بَشَرٌۭ تَنتَشِرُونَ',
		number_in_surah: '20',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3430',
		number: '3430',
		text: 'وَمِنْ ءَايَٰتِهِۦٓ أَنْ خَلَقَ لَكُم مِّنْ أَنفُسِكُمْ أَزْوَٰجًۭا لِّتَسْكُنُوٓا۟ إِلَيْهَا وَجَعَلَ بَيْنَكُم مَّوَدَّةًۭ وَرَحْمَةً ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَتَفَكَّرُونَ',
		number_in_surah: '21',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3431',
		number: '3431',
		text: 'وَمِنْ ءَايَٰتِهِۦ خَلْقُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَٱخْتِلَٰفُ أَلْسِنَتِكُمْ وَأَلْوَٰنِكُمْ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّلْعَٰلِمِينَ',
		number_in_surah: '22',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3432',
		number: '3432',
		text: 'وَمِنْ ءَايَٰتِهِۦ مَنَامُكُم بِٱلَّيْلِ وَٱلنَّهَارِ وَٱبْتِغَآؤُكُم مِّن فَضْلِهِۦٓ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَسْمَعُونَ',
		number_in_surah: '23',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3433',
		number: '3433',
		text: 'وَمِنْ ءَايَٰتِهِۦ يُرِيكُمُ ٱلْبَرْقَ خَوْفًۭا وَطَمَعًۭا وَيُنَزِّلُ مِنَ ٱلسَّمَآءِ مَآءًۭ فَيُحْىِۦ بِهِ ٱلْأَرْضَ بَعْدَ مَوْتِهَآ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَعْقِلُونَ',
		number_in_surah: '24',
		page: '406',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3434',
		number: '3434',
		text: 'وَمِنْ ءَايَٰتِهِۦٓ أَن تَقُومَ ٱلسَّمَآءُ وَٱلْأَرْضُ بِأَمْرِهِۦ ۚ ثُمَّ إِذَا دَعَاكُمْ دَعْوَةًۭ مِّنَ ٱلْأَرْضِ إِذَآ أَنتُمْ تَخْرُجُونَ',
		number_in_surah: '25',
		page: '407',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3435',
		number: '3435',
		text: 'وَلَهُۥ مَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ كُلٌّۭ لَّهُۥ قَٰنِتُونَ',
		number_in_surah: '26',
		page: '407',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3436',
		number: '3436',
		text: 'وَهُوَ ٱلَّذِى يَبْدَؤُا۟ ٱلْخَلْقَ ثُمَّ يُعِيدُهُۥ وَهُوَ أَهْوَنُ عَلَيْهِ ۚ وَلَهُ ٱلْمَثَلُ ٱلْأَعْلَىٰ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '27',
		page: '407',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3437',
		number: '3437',
		text: 'ضَرَبَ لَكُم مَّثَلًۭا مِّنْ أَنفُسِكُمْ ۖ هَل لَّكُم مِّن مَّا مَلَكَتْ أَيْمَٰنُكُم مِّن شُرَكَآءَ فِى مَا رَزَقْنَٰكُمْ فَأَنتُمْ فِيهِ سَوَآءٌۭ تَخَافُونَهُمْ كَخِيفَتِكُمْ أَنفُسَكُمْ ۚ كَذَٰلِكَ نُفَصِّلُ ٱلْءَايَٰتِ لِقَوْمٍۢ يَعْقِلُونَ',
		number_in_surah: '28',
		page: '407',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3438',
		number: '3438',
		text: 'بَلِ ٱتَّبَعَ ٱلَّذِينَ ظَلَمُوٓا۟ أَهْوَآءَهُم بِغَيْرِ عِلْمٍۢ ۖ فَمَن يَهْدِى مَنْ أَضَلَّ ٱللَّهُ ۖ وَمَا لَهُم مِّن نَّٰصِرِينَ',
		number_in_surah: '29',
		page: '407',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3439',
		number: '3439',
		text: 'فَأَقِمْ وَجْهَكَ لِلدِّينِ حَنِيفًۭا ۚ فِطْرَتَ ٱللَّهِ ٱلَّتِى فَطَرَ ٱلنَّاسَ عَلَيْهَا ۚ لَا تَبْدِيلَ لِخَلْقِ ٱللَّهِ ۚ ذَٰلِكَ ٱلدِّينُ ٱلْقَيِّمُ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '30',
		page: '407',
		surah_id: '30',
		hizb_id: '162',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3440',
		number: '3440',
		text: '۞ مُنِيبِينَ إِلَيْهِ وَٱتَّقُوهُ وَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَلَا تَكُونُوا۟ مِنَ ٱلْمُشْرِكِينَ',
		number_in_surah: '31',
		page: '407',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3441',
		number: '3441',
		text: 'مِنَ ٱلَّذِينَ فَرَّقُوا۟ دِينَهُمْ وَكَانُوا۟ شِيَعًۭا ۖ كُلُّ حِزْبٍۭ بِمَا لَدَيْهِمْ فَرِحُونَ',
		number_in_surah: '32',
		page: '407',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3442',
		number: '3442',
		text: 'وَإِذَا مَسَّ ٱلنَّاسَ ضُرٌّۭ دَعَوْا۟ رَبَّهُم مُّنِيبِينَ إِلَيْهِ ثُمَّ إِذَآ أَذَاقَهُم مِّنْهُ رَحْمَةً إِذَا فَرِيقٌۭ مِّنْهُم بِرَبِّهِمْ يُشْرِكُونَ',
		number_in_surah: '33',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3443',
		number: '3443',
		text: 'لِيَكْفُرُوا۟ بِمَآ ءَاتَيْنَٰهُمْ ۚ فَتَمَتَّعُوا۟ فَسَوْفَ تَعْلَمُونَ',
		number_in_surah: '34',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3444',
		number: '3444',
		text: 'أَمْ أَنزَلْنَا عَلَيْهِمْ سُلْطَٰنًۭا فَهُوَ يَتَكَلَّمُ بِمَا كَانُوا۟ بِهِۦ يُشْرِكُونَ',
		number_in_surah: '35',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3445',
		number: '3445',
		text: 'وَإِذَآ أَذَقْنَا ٱلنَّاسَ رَحْمَةًۭ فَرِحُوا۟ بِهَا ۖ وَإِن تُصِبْهُمْ سَيِّئَةٌۢ بِمَا قَدَّمَتْ أَيْدِيهِمْ إِذَا هُمْ يَقْنَطُونَ',
		number_in_surah: '36',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3446',
		number: '3446',
		text: 'أَوَلَمْ يَرَوْا۟ أَنَّ ٱللَّهَ يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ وَيَقْدِرُ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '37',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3447',
		number: '3447',
		text: 'فَـَٔاتِ ذَا ٱلْقُرْبَىٰ حَقَّهُۥ وَٱلْمِسْكِينَ وَٱبْنَ ٱلسَّبِيلِ ۚ ذَٰلِكَ خَيْرٌۭ لِّلَّذِينَ يُرِيدُونَ وَجْهَ ٱللَّهِ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '38',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3448',
		number: '3448',
		text: 'وَمَآ ءَاتَيْتُم مِّن رِّبًۭا لِّيَرْبُوَا۟ فِىٓ أَمْوَٰلِ ٱلنَّاسِ فَلَا يَرْبُوا۟ عِندَ ٱللَّهِ ۖ وَمَآ ءَاتَيْتُم مِّن زَكَوٰةٍۢ تُرِيدُونَ وَجْهَ ٱللَّهِ فَأُو۟لَٰٓئِكَ هُمُ ٱلْمُضْعِفُونَ',
		number_in_surah: '39',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3449',
		number: '3449',
		text: 'ٱللَّهُ ٱلَّذِى خَلَقَكُمْ ثُمَّ رَزَقَكُمْ ثُمَّ يُمِيتُكُمْ ثُمَّ يُحْيِيكُمْ ۖ هَلْ مِن شُرَكَآئِكُم مَّن يَفْعَلُ مِن ذَٰلِكُم مِّن شَىْءٍۢ ۚ سُبْحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشْرِكُونَ',
		number_in_surah: '40',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3450',
		number: '3450',
		text: 'ظَهَرَ ٱلْفَسَادُ فِى ٱلْبَرِّ وَٱلْبَحْرِ بِمَا كَسَبَتْ أَيْدِى ٱلنَّاسِ لِيُذِيقَهُم بَعْضَ ٱلَّذِى عَمِلُوا۟ لَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '41',
		page: '408',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3451',
		number: '3451',
		text: 'قُلْ سِيرُوا۟ فِى ٱلْأَرْضِ فَٱنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبْلُ ۚ كَانَ أَكْثَرُهُم مُّشْرِكِينَ',
		number_in_surah: '42',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3452',
		number: '3452',
		text: 'فَأَقِمْ وَجْهَكَ لِلدِّينِ ٱلْقَيِّمِ مِن قَبْلِ أَن يَأْتِىَ يَوْمٌۭ لَّا مَرَدَّ لَهُۥ مِنَ ٱللَّهِ ۖ يَوْمَئِذٍۢ يَصَّدَّعُونَ',
		number_in_surah: '43',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3453',
		number: '3453',
		text: 'مَن كَفَرَ فَعَلَيْهِ كُفْرُهُۥ ۖ وَمَنْ عَمِلَ صَٰلِحًۭا فَلِأَنفُسِهِمْ يَمْهَدُونَ',
		number_in_surah: '44',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3454',
		number: '3454',
		text: 'لِيَجْزِىَ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ مِن فَضْلِهِۦٓ ۚ إِنَّهُۥ لَا يُحِبُّ ٱلْكَٰفِرِينَ',
		number_in_surah: '45',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3455',
		number: '3455',
		text: 'وَمِنْ ءَايَٰتِهِۦٓ أَن يُرْسِلَ ٱلرِّيَاحَ مُبَشِّرَٰتٍۢ وَلِيُذِيقَكُم مِّن رَّحْمَتِهِۦ وَلِتَجْرِىَ ٱلْفُلْكُ بِأَمْرِهِۦ وَلِتَبْتَغُوا۟ مِن فَضْلِهِۦ وَلَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '46',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3456',
		number: '3456',
		text: 'وَلَقَدْ أَرْسَلْنَا مِن قَبْلِكَ رُسُلًا إِلَىٰ قَوْمِهِمْ فَجَآءُوهُم بِٱلْبَيِّنَٰتِ فَٱنتَقَمْنَا مِنَ ٱلَّذِينَ أَجْرَمُوا۟ ۖ وَكَانَ حَقًّا عَلَيْنَا نَصْرُ ٱلْمُؤْمِنِينَ',
		number_in_surah: '47',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3457',
		number: '3457',
		text: 'ٱللَّهُ ٱلَّذِى يُرْسِلُ ٱلرِّيَٰحَ فَتُثِيرُ سَحَابًۭا فَيَبْسُطُهُۥ فِى ٱلسَّمَآءِ كَيْفَ يَشَآءُ وَيَجْعَلُهُۥ كِسَفًۭا فَتَرَى ٱلْوَدْقَ يَخْرُجُ مِنْ خِلَٰلِهِۦ ۖ فَإِذَآ أَصَابَ بِهِۦ مَن يَشَآءُ مِنْ عِبَادِهِۦٓ إِذَا هُمْ يَسْتَبْشِرُونَ',
		number_in_surah: '48',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3458',
		number: '3458',
		text: 'وَإِن كَانُوا۟ مِن قَبْلِ أَن يُنَزَّلَ عَلَيْهِم مِّن قَبْلِهِۦ لَمُبْلِسِينَ',
		number_in_surah: '49',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3459',
		number: '3459',
		text: 'فَٱنظُرْ إِلَىٰٓ ءَاثَٰرِ رَحْمَتِ ٱللَّهِ كَيْفَ يُحْىِ ٱلْأَرْضَ بَعْدَ مَوْتِهَآ ۚ إِنَّ ذَٰلِكَ لَمُحْىِ ٱلْمَوْتَىٰ ۖ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '50',
		page: '409',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3460',
		number: '3460',
		text: 'وَلَئِنْ أَرْسَلْنَا رِيحًۭا فَرَأَوْهُ مُصْفَرًّۭا لَّظَلُّوا۟ مِنۢ بَعْدِهِۦ يَكْفُرُونَ',
		number_in_surah: '51',
		page: '410',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3461',
		number: '3461',
		text: 'فَإِنَّكَ لَا تُسْمِعُ ٱلْمَوْتَىٰ وَلَا تُسْمِعُ ٱلصُّمَّ ٱلدُّعَآءَ إِذَا وَلَّوْا۟ مُدْبِرِينَ',
		number_in_surah: '52',
		page: '410',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3462',
		number: '3462',
		text: 'وَمَآ أَنتَ بِهَٰدِ ٱلْعُمْىِ عَن ضَلَٰلَتِهِمْ ۖ إِن تُسْمِعُ إِلَّا مَن يُؤْمِنُ بِـَٔايَٰتِنَا فَهُم مُّسْلِمُونَ',
		number_in_surah: '53',
		page: '410',
		surah_id: '30',
		hizb_id: '163',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3463',
		number: '3463',
		text: '۞ ٱللَّهُ ٱلَّذِى خَلَقَكُم مِّن ضَعْفٍۢ ثُمَّ جَعَلَ مِنۢ بَعْدِ ضَعْفٍۢ قُوَّةًۭ ثُمَّ جَعَلَ مِنۢ بَعْدِ قُوَّةٍۢ ضَعْفًۭا وَشَيْبَةًۭ ۚ يَخْلُقُ مَا يَشَآءُ ۖ وَهُوَ ٱلْعَلِيمُ ٱلْقَدِيرُ',
		number_in_surah: '54',
		page: '410',
		surah_id: '30',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3464',
		number: '3464',
		text: 'وَيَوْمَ تَقُومُ ٱلسَّاعَةُ يُقْسِمُ ٱلْمُجْرِمُونَ مَا لَبِثُوا۟ غَيْرَ سَاعَةٍۢ ۚ كَذَٰلِكَ كَانُوا۟ يُؤْفَكُونَ',
		number_in_surah: '55',
		page: '410',
		surah_id: '30',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3465',
		number: '3465',
		text: 'وَقَالَ ٱلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ وَٱلْإِيمَٰنَ لَقَدْ لَبِثْتُمْ فِى كِتَٰبِ ٱللَّهِ إِلَىٰ يَوْمِ ٱلْبَعْثِ ۖ فَهَٰذَا يَوْمُ ٱلْبَعْثِ وَلَٰكِنَّكُمْ كُنتُمْ لَا تَعْلَمُونَ',
		number_in_surah: '56',
		page: '410',
		surah_id: '30',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3466',
		number: '3466',
		text: 'فَيَوْمَئِذٍۢ لَّا يَنفَعُ ٱلَّذِينَ ظَلَمُوا۟ مَعْذِرَتُهُمْ وَلَا هُمْ يُسْتَعْتَبُونَ',
		number_in_surah: '57',
		page: '410',
		surah_id: '30',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3467',
		number: '3467',
		text: 'وَلَقَدْ ضَرَبْنَا لِلنَّاسِ فِى هَٰذَا ٱلْقُرْءَانِ مِن كُلِّ مَثَلٍۢ ۚ وَلَئِن جِئْتَهُم بِـَٔايَةٍۢ لَّيَقُولَنَّ ٱلَّذِينَ كَفَرُوٓا۟ إِنْ أَنتُمْ إِلَّا مُبْطِلُونَ',
		number_in_surah: '58',
		page: '410',
		surah_id: '30',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3468',
		number: '3468',
		text: 'كَذَٰلِكَ يَطْبَعُ ٱللَّهُ عَلَىٰ قُلُوبِ ٱلَّذِينَ لَا يَعْلَمُونَ',
		number_in_surah: '59',
		page: '410',
		surah_id: '30',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3469',
		number: '3469',
		text: 'فَٱصْبِرْ إِنَّ وَعْدَ ٱللَّهِ حَقٌّۭ ۖ وَلَا يَسْتَخِفَّنَّكَ ٱلَّذِينَ لَا يُوقِنُونَ',
		number_in_surah: '60',
		page: '410',
		surah_id: '30',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3470',
		number: '3470',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓمٓ',
		number_in_surah: '1',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3471',
		number: '3471',
		text: 'تِلْكَ ءَايَٰتُ ٱلْكِتَٰبِ ٱلْحَكِيمِ',
		number_in_surah: '2',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3472',
		number: '3472',
		text: 'هُدًۭى وَرَحْمَةًۭ لِّلْمُحْسِنِينَ',
		number_in_surah: '3',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3473',
		number: '3473',
		text: 'ٱلَّذِينَ يُقِيمُونَ ٱلصَّلَوٰةَ وَيُؤْتُونَ ٱلزَّكَوٰةَ وَهُم بِٱلْءَاخِرَةِ هُمْ يُوقِنُونَ',
		number_in_surah: '4',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3474',
		number: '3474',
		text: 'أُو۟لَٰٓئِكَ عَلَىٰ هُدًۭى مِّن رَّبِّهِمْ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '5',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3475',
		number: '3475',
		text: 'وَمِنَ ٱلنَّاسِ مَن يَشْتَرِى لَهْوَ ٱلْحَدِيثِ لِيُضِلَّ عَن سَبِيلِ ٱللَّهِ بِغَيْرِ عِلْمٍۢ وَيَتَّخِذَهَا هُزُوًا ۚ أُو۟لَٰٓئِكَ لَهُمْ عَذَابٌۭ مُّهِينٌۭ',
		number_in_surah: '6',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3476',
		number: '3476',
		text: 'وَإِذَا تُتْلَىٰ عَلَيْهِ ءَايَٰتُنَا وَلَّىٰ مُسْتَكْبِرًۭا كَأَن لَّمْ يَسْمَعْهَا كَأَنَّ فِىٓ أُذُنَيْهِ وَقْرًۭا ۖ فَبَشِّرْهُ بِعَذَابٍ أَلِيمٍ',
		number_in_surah: '7',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3477',
		number: '3477',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَهُمْ جَنَّٰتُ ٱلنَّعِيمِ',
		number_in_surah: '8',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3478',
		number: '3478',
		text: 'خَٰلِدِينَ فِيهَا ۖ وَعْدَ ٱللَّهِ حَقًّۭا ۚ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '9',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3479',
		number: '3479',
		text: 'خَلَقَ ٱلسَّمَٰوَٰتِ بِغَيْرِ عَمَدٍۢ تَرَوْنَهَا ۖ وَأَلْقَىٰ فِى ٱلْأَرْضِ رَوَٰسِىَ أَن تَمِيدَ بِكُمْ وَبَثَّ فِيهَا مِن كُلِّ دَآبَّةٍۢ ۚ وَأَنزَلْنَا مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَنۢبَتْنَا فِيهَا مِن كُلِّ زَوْجٍۢ كَرِيمٍ',
		number_in_surah: '10',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3480',
		number: '3480',
		text: 'هَٰذَا خَلْقُ ٱللَّهِ فَأَرُونِى مَاذَا خَلَقَ ٱلَّذِينَ مِن دُونِهِۦ ۚ بَلِ ٱلظَّٰلِمُونَ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '11',
		page: '411',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3481',
		number: '3481',
		text: 'وَلَقَدْ ءَاتَيْنَا لُقْمَٰنَ ٱلْحِكْمَةَ أَنِ ٱشْكُرْ لِلَّهِ ۚ وَمَن يَشْكُرْ فَإِنَّمَا يَشْكُرُ لِنَفْسِهِۦ ۖ وَمَن كَفَرَ فَإِنَّ ٱللَّهَ غَنِىٌّ حَمِيدٌۭ',
		number_in_surah: '12',
		page: '412',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3482',
		number: '3482',
		text: 'وَإِذْ قَالَ لُقْمَٰنُ لِٱبْنِهِۦ وَهُوَ يَعِظُهُۥ يَٰبُنَىَّ لَا تُشْرِكْ بِٱللَّهِ ۖ إِنَّ ٱلشِّرْكَ لَظُلْمٌ عَظِيمٌۭ',
		number_in_surah: '13',
		page: '412',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3483',
		number: '3483',
		text: 'وَوَصَّيْنَا ٱلْإِنسَٰنَ بِوَٰلِدَيْهِ حَمَلَتْهُ أُمُّهُۥ وَهْنًا عَلَىٰ وَهْنٍۢ وَفِصَٰلُهُۥ فِى عَامَيْنِ أَنِ ٱشْكُرْ لِى وَلِوَٰلِدَيْكَ إِلَىَّ ٱلْمَصِيرُ',
		number_in_surah: '14',
		page: '412',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3484',
		number: '3484',
		text: 'وَإِن جَٰهَدَاكَ عَلَىٰٓ أَن تُشْرِكَ بِى مَا لَيْسَ لَكَ بِهِۦ عِلْمٌۭ فَلَا تُطِعْهُمَا ۖ وَصَاحِبْهُمَا فِى ٱلدُّنْيَا مَعْرُوفًۭا ۖ وَٱتَّبِعْ سَبِيلَ مَنْ أَنَابَ إِلَىَّ ۚ ثُمَّ إِلَىَّ مَرْجِعُكُمْ فَأُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '15',
		page: '412',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3485',
		number: '3485',
		text: 'يَٰبُنَىَّ إِنَّهَآ إِن تَكُ مِثْقَالَ حَبَّةٍۢ مِّنْ خَرْدَلٍۢ فَتَكُن فِى صَخْرَةٍ أَوْ فِى ٱلسَّمَٰوَٰتِ أَوْ فِى ٱلْأَرْضِ يَأْتِ بِهَا ٱللَّهُ ۚ إِنَّ ٱللَّهَ لَطِيفٌ خَبِيرٌۭ',
		number_in_surah: '16',
		page: '412',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3486',
		number: '3486',
		text: 'يَٰبُنَىَّ أَقِمِ ٱلصَّلَوٰةَ وَأْمُرْ بِٱلْمَعْرُوفِ وَٱنْهَ عَنِ ٱلْمُنكَرِ وَٱصْبِرْ عَلَىٰ مَآ أَصَابَكَ ۖ إِنَّ ذَٰلِكَ مِنْ عَزْمِ ٱلْأُمُورِ',
		number_in_surah: '17',
		page: '412',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3487',
		number: '3487',
		text: 'وَلَا تُصَعِّرْ خَدَّكَ لِلنَّاسِ وَلَا تَمْشِ فِى ٱلْأَرْضِ مَرَحًا ۖ إِنَّ ٱللَّهَ لَا يُحِبُّ كُلَّ مُخْتَالٍۢ فَخُورٍۢ',
		number_in_surah: '18',
		page: '412',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3488',
		number: '3488',
		text: 'وَٱقْصِدْ فِى مَشْيِكَ وَٱغْضُضْ مِن صَوْتِكَ ۚ إِنَّ أَنكَرَ ٱلْأَصْوَٰتِ لَصَوْتُ ٱلْحَمِيرِ',
		number_in_surah: '19',
		page: '412',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3489',
		number: '3489',
		text: 'أَلَمْ تَرَوْا۟ أَنَّ ٱللَّهَ سَخَّرَ لَكُم مَّا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ وَأَسْبَغَ عَلَيْكُمْ نِعَمَهُۥ ظَٰهِرَةًۭ وَبَاطِنَةًۭ ۗ وَمِنَ ٱلنَّاسِ مَن يُجَٰدِلُ فِى ٱللَّهِ بِغَيْرِ عِلْمٍۢ وَلَا هُدًۭى وَلَا كِتَٰبٍۢ مُّنِيرٍۢ',
		number_in_surah: '20',
		page: '413',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3490',
		number: '3490',
		text: 'وَإِذَا قِيلَ لَهُمُ ٱتَّبِعُوا۟ مَآ أَنزَلَ ٱللَّهُ قَالُوا۟ بَلْ نَتَّبِعُ مَا وَجَدْنَا عَلَيْهِ ءَابَآءَنَآ ۚ أَوَلَوْ كَانَ ٱلشَّيْطَٰنُ يَدْعُوهُمْ إِلَىٰ عَذَابِ ٱلسَّعِيرِ',
		number_in_surah: '21',
		page: '413',
		surah_id: '31',
		hizb_id: '164',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3491',
		number: '3491',
		text: '۞ وَمَن يُسْلِمْ وَجْهَهُۥٓ إِلَى ٱللَّهِ وَهُوَ مُحْسِنٌۭ فَقَدِ ٱسْتَمْسَكَ بِٱلْعُرْوَةِ ٱلْوُثْقَىٰ ۗ وَإِلَى ٱللَّهِ عَٰقِبَةُ ٱلْأُمُورِ',
		number_in_surah: '22',
		page: '413',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3492',
		number: '3492',
		text: 'وَمَن كَفَرَ فَلَا يَحْزُنكَ كُفْرُهُۥٓ ۚ إِلَيْنَا مَرْجِعُهُمْ فَنُنَبِّئُهُم بِمَا عَمِلُوٓا۟ ۚ إِنَّ ٱللَّهَ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '23',
		page: '413',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3493',
		number: '3493',
		text: 'نُمَتِّعُهُمْ قَلِيلًۭا ثُمَّ نَضْطَرُّهُمْ إِلَىٰ عَذَابٍ غَلِيظٍۢ',
		number_in_surah: '24',
		page: '413',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3494',
		number: '3494',
		text: 'وَلَئِن سَأَلْتَهُم مَّنْ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ لَيَقُولُنَّ ٱللَّهُ ۚ قُلِ ٱلْحَمْدُ لِلَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '25',
		page: '413',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3495',
		number: '3495',
		text: 'لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ إِنَّ ٱللَّهَ هُوَ ٱلْغَنِىُّ ٱلْحَمِيدُ',
		number_in_surah: '26',
		page: '413',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3496',
		number: '3496',
		text: 'وَلَوْ أَنَّمَا فِى ٱلْأَرْضِ مِن شَجَرَةٍ أَقْلَٰمٌۭ وَٱلْبَحْرُ يَمُدُّهُۥ مِنۢ بَعْدِهِۦ سَبْعَةُ أَبْحُرٍۢ مَّا نَفِدَتْ كَلِمَٰتُ ٱللَّهِ ۗ إِنَّ ٱللَّهَ عَزِيزٌ حَكِيمٌۭ',
		number_in_surah: '27',
		page: '413',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3497',
		number: '3497',
		text: 'مَّا خَلْقُكُمْ وَلَا بَعْثُكُمْ إِلَّا كَنَفْسٍۢ وَٰحِدَةٍ ۗ إِنَّ ٱللَّهَ سَمِيعٌۢ بَصِيرٌ',
		number_in_surah: '28',
		page: '413',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3498',
		number: '3498',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ يُولِجُ ٱلَّيْلَ فِى ٱلنَّهَارِ وَيُولِجُ ٱلنَّهَارَ فِى ٱلَّيْلِ وَسَخَّرَ ٱلشَّمْسَ وَٱلْقَمَرَ كُلٌّۭ يَجْرِىٓ إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى وَأَنَّ ٱللَّهَ بِمَا تَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '29',
		page: '414',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3499',
		number: '3499',
		text: 'ذَٰلِكَ بِأَنَّ ٱللَّهَ هُوَ ٱلْحَقُّ وَأَنَّ مَا يَدْعُونَ مِن دُونِهِ ٱلْبَٰطِلُ وَأَنَّ ٱللَّهَ هُوَ ٱلْعَلِىُّ ٱلْكَبِيرُ',
		number_in_surah: '30',
		page: '414',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3500',
		number: '3500',
		text: 'أَلَمْ تَرَ أَنَّ ٱلْفُلْكَ تَجْرِى فِى ٱلْبَحْرِ بِنِعْمَتِ ٱللَّهِ لِيُرِيَكُم مِّنْ ءَايَٰتِهِۦٓ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّكُلِّ صَبَّارٍۢ شَكُورٍۢ',
		number_in_surah: '31',
		page: '414',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3501',
		number: '3501',
		text: 'وَإِذَا غَشِيَهُم مَّوْجٌۭ كَٱلظُّلَلِ دَعَوُا۟ ٱللَّهَ مُخْلِصِينَ لَهُ ٱلدِّينَ فَلَمَّا نَجَّىٰهُمْ إِلَى ٱلْبَرِّ فَمِنْهُم مُّقْتَصِدٌۭ ۚ وَمَا يَجْحَدُ بِـَٔايَٰتِنَآ إِلَّا كُلُّ خَتَّارٍۢ كَفُورٍۢ',
		number_in_surah: '32',
		page: '414',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3502',
		number: '3502',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ ٱتَّقُوا۟ رَبَّكُمْ وَٱخْشَوْا۟ يَوْمًۭا لَّا يَجْزِى وَالِدٌ عَن وَلَدِهِۦ وَلَا مَوْلُودٌ هُوَ جَازٍ عَن وَالِدِهِۦ شَيْـًٔا ۚ إِنَّ وَعْدَ ٱللَّهِ حَقٌّۭ ۖ فَلَا تَغُرَّنَّكُمُ ٱلْحَيَوٰةُ ٱلدُّنْيَا وَلَا يَغُرَّنَّكُم بِٱللَّهِ ٱلْغَرُورُ',
		number_in_surah: '33',
		page: '414',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3503',
		number: '3503',
		text: 'إِنَّ ٱللَّهَ عِندَهُۥ عِلْمُ ٱلسَّاعَةِ وَيُنَزِّلُ ٱلْغَيْثَ وَيَعْلَمُ مَا فِى ٱلْأَرْحَامِ ۖ وَمَا تَدْرِى نَفْسٌۭ مَّاذَا تَكْسِبُ غَدًۭا ۖ وَمَا تَدْرِى نَفْسٌۢ بِأَىِّ أَرْضٍۢ تَمُوتُ ۚ إِنَّ ٱللَّهَ عَلِيمٌ خَبِيرٌۢ',
		number_in_surah: '34',
		page: '414',
		surah_id: '31',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3504',
		number: '3504',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ الٓمٓ',
		number_in_surah: '1',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3505',
		number: '3505',
		text: 'تَنزِيلُ ٱلْكِتَٰبِ لَا رَيْبَ فِيهِ مِن رَّبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '2',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3506',
		number: '3506',
		text: 'أَمْ يَقُولُونَ ٱفْتَرَىٰهُ ۚ بَلْ هُوَ ٱلْحَقُّ مِن رَّبِّكَ لِتُنذِرَ قَوْمًۭا مَّآ أَتَىٰهُم مِّن نَّذِيرٍۢ مِّن قَبْلِكَ لَعَلَّهُمْ يَهْتَدُونَ',
		number_in_surah: '3',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3507',
		number: '3507',
		text: 'ٱللَّهُ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَمَا بَيْنَهُمَا فِى سِتَّةِ أَيَّامٍۢ ثُمَّ ٱسْتَوَىٰ عَلَى ٱلْعَرْشِ ۖ مَا لَكُم مِّن دُونِهِۦ مِن وَلِىٍّۢ وَلَا شَفِيعٍ ۚ أَفَلَا تَتَذَكَّرُونَ',
		number_in_surah: '4',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3508',
		number: '3508',
		text: 'يُدَبِّرُ ٱلْأَمْرَ مِنَ ٱلسَّمَآءِ إِلَى ٱلْأَرْضِ ثُمَّ يَعْرُجُ إِلَيْهِ فِى يَوْمٍۢ كَانَ مِقْدَارُهُۥٓ أَلْفَ سَنَةٍۢ مِّمَّا تَعُدُّونَ',
		number_in_surah: '5',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3509',
		number: '3509',
		text: 'ذَٰلِكَ عَٰلِمُ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '6',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3510',
		number: '3510',
		text: 'ٱلَّذِىٓ أَحْسَنَ كُلَّ شَىْءٍ خَلَقَهُۥ ۖ وَبَدَأَ خَلْقَ ٱلْإِنسَٰنِ مِن طِينٍۢ',
		number_in_surah: '7',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3511',
		number: '3511',
		text: 'ثُمَّ جَعَلَ نَسْلَهُۥ مِن سُلَٰلَةٍۢ مِّن مَّآءٍۢ مَّهِينٍۢ',
		number_in_surah: '8',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3512',
		number: '3512',
		text: 'ثُمَّ سَوَّىٰهُ وَنَفَخَ فِيهِ مِن رُّوحِهِۦ ۖ وَجَعَلَ لَكُمُ ٱلسَّمْعَ وَٱلْأَبْصَٰرَ وَٱلْأَفْـِٔدَةَ ۚ قَلِيلًۭا مَّا تَشْكُرُونَ',
		number_in_surah: '9',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3513',
		number: '3513',
		text: 'وَقَالُوٓا۟ أَءِذَا ضَلَلْنَا فِى ٱلْأَرْضِ أَءِنَّا لَفِى خَلْقٍۢ جَدِيدٍۭ ۚ بَلْ هُم بِلِقَآءِ رَبِّهِمْ كَٰفِرُونَ',
		number_in_surah: '10',
		page: '415',
		surah_id: '32',
		hizb_id: '165',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3514',
		number: '3514',
		text: '۞ قُلْ يَتَوَفَّىٰكُم مَّلَكُ ٱلْمَوْتِ ٱلَّذِى وُكِّلَ بِكُمْ ثُمَّ إِلَىٰ رَبِّكُمْ تُرْجَعُونَ',
		number_in_surah: '11',
		page: '415',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3515',
		number: '3515',
		text: 'وَلَوْ تَرَىٰٓ إِذِ ٱلْمُجْرِمُونَ نَاكِسُوا۟ رُءُوسِهِمْ عِندَ رَبِّهِمْ رَبَّنَآ أَبْصَرْنَا وَسَمِعْنَا فَٱرْجِعْنَا نَعْمَلْ صَٰلِحًا إِنَّا مُوقِنُونَ',
		number_in_surah: '12',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3516',
		number: '3516',
		text: 'وَلَوْ شِئْنَا لَءَاتَيْنَا كُلَّ نَفْسٍ هُدَىٰهَا وَلَٰكِنْ حَقَّ ٱلْقَوْلُ مِنِّى لَأَمْلَأَنَّ جَهَنَّمَ مِنَ ٱلْجِنَّةِ وَٱلنَّاسِ أَجْمَعِينَ',
		number_in_surah: '13',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3517',
		number: '3517',
		text: 'فَذُوقُوا۟ بِمَا نَسِيتُمْ لِقَآءَ يَوْمِكُمْ هَٰذَآ إِنَّا نَسِينَٰكُمْ ۖ وَذُوقُوا۟ عَذَابَ ٱلْخُلْدِ بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '14',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3518',
		number: '3518',
		text: 'إِنَّمَا يُؤْمِنُ بِـَٔايَٰتِنَا ٱلَّذِينَ إِذَا ذُكِّرُوا۟ بِهَا خَرُّوا۟ سُجَّدًۭا وَسَبَّحُوا۟ بِحَمْدِ رَبِّهِمْ وَهُمْ لَا يَسْتَكْبِرُونَ ۩',
		number_in_surah: '15',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '1',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3519',
		number: '3519',
		text: 'تَتَجَافَىٰ جُنُوبُهُمْ عَنِ ٱلْمَضَاجِعِ يَدْعُونَ رَبَّهُمْ خَوْفًۭا وَطَمَعًۭا وَمِمَّا رَزَقْنَٰهُمْ يُنفِقُونَ',
		number_in_surah: '16',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3520',
		number: '3520',
		text: 'فَلَا تَعْلَمُ نَفْسٌۭ مَّآ أُخْفِىَ لَهُم مِّن قُرَّةِ أَعْيُنٍۢ جَزَآءًۢ بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '17',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3521',
		number: '3521',
		text: 'أَفَمَن كَانَ مُؤْمِنًۭا كَمَن كَانَ فَاسِقًۭا ۚ لَّا يَسْتَوُۥنَ',
		number_in_surah: '18',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3522',
		number: '3522',
		text: 'أَمَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ فَلَهُمْ جَنَّٰتُ ٱلْمَأْوَىٰ نُزُلًۢا بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '19',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3523',
		number: '3523',
		text: 'وَأَمَّا ٱلَّذِينَ فَسَقُوا۟ فَمَأْوَىٰهُمُ ٱلنَّارُ ۖ كُلَّمَآ أَرَادُوٓا۟ أَن يَخْرُجُوا۟ مِنْهَآ أُعِيدُوا۟ فِيهَا وَقِيلَ لَهُمْ ذُوقُوا۟ عَذَابَ ٱلنَّارِ ٱلَّذِى كُنتُم بِهِۦ تُكَذِّبُونَ',
		number_in_surah: '20',
		page: '416',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3524',
		number: '3524',
		text: 'وَلَنُذِيقَنَّهُم مِّنَ ٱلْعَذَابِ ٱلْأَدْنَىٰ دُونَ ٱلْعَذَابِ ٱلْأَكْبَرِ لَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '21',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3525',
		number: '3525',
		text: 'وَمَنْ أَظْلَمُ مِمَّن ذُكِّرَ بِـَٔايَٰتِ رَبِّهِۦ ثُمَّ أَعْرَضَ عَنْهَآ ۚ إِنَّا مِنَ ٱلْمُجْرِمِينَ مُنتَقِمُونَ',
		number_in_surah: '22',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3526',
		number: '3526',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ فَلَا تَكُن فِى مِرْيَةٍۢ مِّن لِّقَآئِهِۦ ۖ وَجَعَلْنَٰهُ هُدًۭى لِّبَنِىٓ إِسْرَٰٓءِيلَ',
		number_in_surah: '23',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3527',
		number: '3527',
		text: 'وَجَعَلْنَا مِنْهُمْ أَئِمَّةًۭ يَهْدُونَ بِأَمْرِنَا لَمَّا صَبَرُوا۟ ۖ وَكَانُوا۟ بِـَٔايَٰتِنَا يُوقِنُونَ',
		number_in_surah: '24',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3528',
		number: '3528',
		text: 'إِنَّ رَبَّكَ هُوَ يَفْصِلُ بَيْنَهُمْ يَوْمَ ٱلْقِيَٰمَةِ فِيمَا كَانُوا۟ فِيهِ يَخْتَلِفُونَ',
		number_in_surah: '25',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3529',
		number: '3529',
		text: 'أَوَلَمْ يَهْدِ لَهُمْ كَمْ أَهْلَكْنَا مِن قَبْلِهِم مِّنَ ٱلْقُرُونِ يَمْشُونَ فِى مَسَٰكِنِهِمْ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍ ۖ أَفَلَا يَسْمَعُونَ',
		number_in_surah: '26',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:06',
		updated_at: '2018-06-07 08:07:06',
	},
	{
		id: '3530',
		number: '3530',
		text: 'أَوَلَمْ يَرَوْا۟ أَنَّا نَسُوقُ ٱلْمَآءَ إِلَى ٱلْأَرْضِ ٱلْجُرُزِ فَنُخْرِجُ بِهِۦ زَرْعًۭا تَأْكُلُ مِنْهُ أَنْعَٰمُهُمْ وَأَنفُسُهُمْ ۖ أَفَلَا يُبْصِرُونَ',
		number_in_surah: '27',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3531',
		number: '3531',
		text: 'وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلْفَتْحُ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '28',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3532',
		number: '3532',
		text: 'قُلْ يَوْمَ ٱلْفَتْحِ لَا يَنفَعُ ٱلَّذِينَ كَفَرُوٓا۟ إِيمَٰنُهُمْ وَلَا هُمْ يُنظَرُونَ',
		number_in_surah: '29',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3533',
		number: '3533',
		text: 'فَأَعْرِضْ عَنْهُمْ وَٱنتَظِرْ إِنَّهُم مُّنتَظِرُونَ',
		number_in_surah: '30',
		page: '417',
		surah_id: '32',
		hizb_id: '166',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3534',
		number: '3534',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلنَّبِىُّ ٱتَّقِ ٱللَّهَ وَلَا تُطِعِ ٱلْكَٰفِرِينَ وَٱلْمُنَٰفِقِينَ ۗ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '1',
		page: '418',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3535',
		number: '3535',
		text: 'وَٱتَّبِعْ مَا يُوحَىٰٓ إِلَيْكَ مِن رَّبِّكَ ۚ إِنَّ ٱللَّهَ كَانَ بِمَا تَعْمَلُونَ خَبِيرًۭا',
		number_in_surah: '2',
		page: '418',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3536',
		number: '3536',
		text: 'وَتَوَكَّلْ عَلَى ٱللَّهِ ۚ وَكَفَىٰ بِٱللَّهِ وَكِيلًۭا',
		number_in_surah: '3',
		page: '418',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3537',
		number: '3537',
		text: 'مَّا جَعَلَ ٱللَّهُ لِرَجُلٍۢ مِّن قَلْبَيْنِ فِى جَوْفِهِۦ ۚ وَمَا جَعَلَ أَزْوَٰجَكُمُ ٱلَّٰٓـِٔى تُظَٰهِرُونَ مِنْهُنَّ أُمَّهَٰتِكُمْ ۚ وَمَا جَعَلَ أَدْعِيَآءَكُمْ أَبْنَآءَكُمْ ۚ ذَٰلِكُمْ قَوْلُكُم بِأَفْوَٰهِكُمْ ۖ وَٱللَّهُ يَقُولُ ٱلْحَقَّ وَهُوَ يَهْدِى ٱلسَّبِيلَ',
		number_in_surah: '4',
		page: '418',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3538',
		number: '3538',
		text: 'ٱدْعُوهُمْ لِءَابَآئِهِمْ هُوَ أَقْسَطُ عِندَ ٱللَّهِ ۚ فَإِن لَّمْ تَعْلَمُوٓا۟ ءَابَآءَهُمْ فَإِخْوَٰنُكُمْ فِى ٱلدِّينِ وَمَوَٰلِيكُمْ ۚ وَلَيْسَ عَلَيْكُمْ جُنَاحٌۭ فِيمَآ أَخْطَأْتُم بِهِۦ وَلَٰكِن مَّا تَعَمَّدَتْ قُلُوبُكُمْ ۚ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًا',
		number_in_surah: '5',
		page: '418',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3539',
		number: '3539',
		text: 'ٱلنَّبِىُّ أَوْلَىٰ بِٱلْمُؤْمِنِينَ مِنْ أَنفُسِهِمْ ۖ وَأَزْوَٰجُهُۥٓ أُمَّهَٰتُهُمْ ۗ وَأُو۟لُوا۟ ٱلْأَرْحَامِ بَعْضُهُمْ أَوْلَىٰ بِبَعْضٍۢ فِى كِتَٰبِ ٱللَّهِ مِنَ ٱلْمُؤْمِنِينَ وَٱلْمُهَٰجِرِينَ إِلَّآ أَن تَفْعَلُوٓا۟ إِلَىٰٓ أَوْلِيَآئِكُم مَّعْرُوفًۭا ۚ كَانَ ذَٰلِكَ فِى ٱلْكِتَٰبِ مَسْطُورًۭا',
		number_in_surah: '6',
		page: '418',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3540',
		number: '3540',
		text: 'وَإِذْ أَخَذْنَا مِنَ ٱلنَّبِيِّۦنَ مِيثَٰقَهُمْ وَمِنكَ وَمِن نُّوحٍۢ وَإِبْرَٰهِيمَ وَمُوسَىٰ وَعِيسَى ٱبْنِ مَرْيَمَ ۖ وَأَخَذْنَا مِنْهُم مِّيثَٰقًا غَلِيظًۭا',
		number_in_surah: '7',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3541',
		number: '3541',
		text: 'لِّيَسْـَٔلَ ٱلصَّٰدِقِينَ عَن صِدْقِهِمْ ۚ وَأَعَدَّ لِلْكَٰفِرِينَ عَذَابًا أَلِيمًۭا',
		number_in_surah: '8',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3542',
		number: '3542',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱذْكُرُوا۟ نِعْمَةَ ٱللَّهِ عَلَيْكُمْ إِذْ جَآءَتْكُمْ جُنُودٌۭ فَأَرْسَلْنَا عَلَيْهِمْ رِيحًۭا وَجُنُودًۭا لَّمْ تَرَوْهَا ۚ وَكَانَ ٱللَّهُ بِمَا تَعْمَلُونَ بَصِيرًا',
		number_in_surah: '9',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3543',
		number: '3543',
		text: 'إِذْ جَآءُوكُم مِّن فَوْقِكُمْ وَمِنْ أَسْفَلَ مِنكُمْ وَإِذْ زَاغَتِ ٱلْأَبْصَٰرُ وَبَلَغَتِ ٱلْقُلُوبُ ٱلْحَنَاجِرَ وَتَظُنُّونَ بِٱللَّهِ ٱلظُّنُونَا۠',
		number_in_surah: '10',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3544',
		number: '3544',
		text: 'هُنَالِكَ ٱبْتُلِىَ ٱلْمُؤْمِنُونَ وَزُلْزِلُوا۟ زِلْزَالًۭا شَدِيدًۭا',
		number_in_surah: '11',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3545',
		number: '3545',
		text: 'وَإِذْ يَقُولُ ٱلْمُنَٰفِقُونَ وَٱلَّذِينَ فِى قُلُوبِهِم مَّرَضٌۭ مَّا وَعَدَنَا ٱللَّهُ وَرَسُولُهُۥٓ إِلَّا غُرُورًۭا',
		number_in_surah: '12',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3546',
		number: '3546',
		text: 'وَإِذْ قَالَت طَّآئِفَةٌۭ مِّنْهُمْ يَٰٓأَهْلَ يَثْرِبَ لَا مُقَامَ لَكُمْ فَٱرْجِعُوا۟ ۚ وَيَسْتَـْٔذِنُ فَرِيقٌۭ مِّنْهُمُ ٱلنَّبِىَّ يَقُولُونَ إِنَّ بُيُوتَنَا عَوْرَةٌۭ وَمَا هِىَ بِعَوْرَةٍ ۖ إِن يُرِيدُونَ إِلَّا فِرَارًۭا',
		number_in_surah: '13',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3547',
		number: '3547',
		text: 'وَلَوْ دُخِلَتْ عَلَيْهِم مِّنْ أَقْطَارِهَا ثُمَّ سُئِلُوا۟ ٱلْفِتْنَةَ لَءَاتَوْهَا وَمَا تَلَبَّثُوا۟ بِهَآ إِلَّا يَسِيرًۭا',
		number_in_surah: '14',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3548',
		number: '3548',
		text: 'وَلَقَدْ كَانُوا۟ عَٰهَدُوا۟ ٱللَّهَ مِن قَبْلُ لَا يُوَلُّونَ ٱلْأَدْبَٰرَ ۚ وَكَانَ عَهْدُ ٱللَّهِ مَسْـُٔولًۭا',
		number_in_surah: '15',
		page: '419',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3549',
		number: '3549',
		text: 'قُل لَّن يَنفَعَكُمُ ٱلْفِرَارُ إِن فَرَرْتُم مِّنَ ٱلْمَوْتِ أَوِ ٱلْقَتْلِ وَإِذًۭا لَّا تُمَتَّعُونَ إِلَّا قَلِيلًۭا',
		number_in_surah: '16',
		page: '420',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3550',
		number: '3550',
		text: 'قُلْ مَن ذَا ٱلَّذِى يَعْصِمُكُم مِّنَ ٱللَّهِ إِنْ أَرَادَ بِكُمْ سُوٓءًا أَوْ أَرَادَ بِكُمْ رَحْمَةًۭ ۚ وَلَا يَجِدُونَ لَهُم مِّن دُونِ ٱللَّهِ وَلِيًّۭا وَلَا نَصِيرًۭا',
		number_in_surah: '17',
		page: '420',
		surah_id: '33',
		hizb_id: '167',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3551',
		number: '3551',
		text: '۞ قَدْ يَعْلَمُ ٱللَّهُ ٱلْمُعَوِّقِينَ مِنكُمْ وَٱلْقَآئِلِينَ لِإِخْوَٰنِهِمْ هَلُمَّ إِلَيْنَا ۖ وَلَا يَأْتُونَ ٱلْبَأْسَ إِلَّا قَلِيلًا',
		number_in_surah: '18',
		page: '420',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3552',
		number: '3552',
		text: 'أَشِحَّةً عَلَيْكُمْ ۖ فَإِذَا جَآءَ ٱلْخَوْفُ رَأَيْتَهُمْ يَنظُرُونَ إِلَيْكَ تَدُورُ أَعْيُنُهُمْ كَٱلَّذِى يُغْشَىٰ عَلَيْهِ مِنَ ٱلْمَوْتِ ۖ فَإِذَا ذَهَبَ ٱلْخَوْفُ سَلَقُوكُم بِأَلْسِنَةٍ حِدَادٍ أَشِحَّةً عَلَى ٱلْخَيْرِ ۚ أُو۟لَٰٓئِكَ لَمْ يُؤْمِنُوا۟ فَأَحْبَطَ ٱللَّهُ أَعْمَٰلَهُمْ ۚ وَكَانَ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرًۭا',
		number_in_surah: '19',
		page: '420',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3553',
		number: '3553',
		text: 'يَحْسَبُونَ ٱلْأَحْزَابَ لَمْ يَذْهَبُوا۟ ۖ وَإِن يَأْتِ ٱلْأَحْزَابُ يَوَدُّوا۟ لَوْ أَنَّهُم بَادُونَ فِى ٱلْأَعْرَابِ يَسْـَٔلُونَ عَنْ أَنۢبَآئِكُمْ ۖ وَلَوْ كَانُوا۟ فِيكُم مَّا قَٰتَلُوٓا۟ إِلَّا قَلِيلًۭا',
		number_in_surah: '20',
		page: '420',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3554',
		number: '3554',
		text: 'لَّقَدْ كَانَ لَكُمْ فِى رَسُولِ ٱللَّهِ أُسْوَةٌ حَسَنَةٌۭ لِّمَن كَانَ يَرْجُوا۟ ٱللَّهَ وَٱلْيَوْمَ ٱلْءَاخِرَ وَذَكَرَ ٱللَّهَ كَثِيرًۭا',
		number_in_surah: '21',
		page: '420',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3555',
		number: '3555',
		text: 'وَلَمَّا رَءَا ٱلْمُؤْمِنُونَ ٱلْأَحْزَابَ قَالُوا۟ هَٰذَا مَا وَعَدَنَا ٱللَّهُ وَرَسُولُهُۥ وَصَدَقَ ٱللَّهُ وَرَسُولُهُۥ ۚ وَمَا زَادَهُمْ إِلَّآ إِيمَٰنًۭا وَتَسْلِيمًۭا',
		number_in_surah: '22',
		page: '420',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3556',
		number: '3556',
		text: 'مِّنَ ٱلْمُؤْمِنِينَ رِجَالٌۭ صَدَقُوا۟ مَا عَٰهَدُوا۟ ٱللَّهَ عَلَيْهِ ۖ فَمِنْهُم مَّن قَضَىٰ نَحْبَهُۥ وَمِنْهُم مَّن يَنتَظِرُ ۖ وَمَا بَدَّلُوا۟ تَبْدِيلًۭا',
		number_in_surah: '23',
		page: '421',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3557',
		number: '3557',
		text: 'لِّيَجْزِىَ ٱللَّهُ ٱلصَّٰدِقِينَ بِصِدْقِهِمْ وَيُعَذِّبَ ٱلْمُنَٰفِقِينَ إِن شَآءَ أَوْ يَتُوبَ عَلَيْهِمْ ۚ إِنَّ ٱللَّهَ كَانَ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '24',
		page: '421',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3558',
		number: '3558',
		text: 'وَرَدَّ ٱللَّهُ ٱلَّذِينَ كَفَرُوا۟ بِغَيْظِهِمْ لَمْ يَنَالُوا۟ خَيْرًۭا ۚ وَكَفَى ٱللَّهُ ٱلْمُؤْمِنِينَ ٱلْقِتَالَ ۚ وَكَانَ ٱللَّهُ قَوِيًّا عَزِيزًۭا',
		number_in_surah: '25',
		page: '421',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3559',
		number: '3559',
		text: 'وَأَنزَلَ ٱلَّذِينَ ظَٰهَرُوهُم مِّنْ أَهْلِ ٱلْكِتَٰبِ مِن صَيَاصِيهِمْ وَقَذَفَ فِى قُلُوبِهِمُ ٱلرُّعْبَ فَرِيقًۭا تَقْتُلُونَ وَتَأْسِرُونَ فَرِيقًۭا',
		number_in_surah: '26',
		page: '421',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3560',
		number: '3560',
		text: 'وَأَوْرَثَكُمْ أَرْضَهُمْ وَدِيَٰرَهُمْ وَأَمْوَٰلَهُمْ وَأَرْضًۭا لَّمْ تَطَـُٔوهَا ۚ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرًۭا',
		number_in_surah: '27',
		page: '421',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3561',
		number: '3561',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ قُل لِّأَزْوَٰجِكَ إِن كُنتُنَّ تُرِدْنَ ٱلْحَيَوٰةَ ٱلدُّنْيَا وَزِينَتَهَا فَتَعَالَيْنَ أُمَتِّعْكُنَّ وَأُسَرِّحْكُنَّ سَرَاحًۭا جَمِيلًۭا',
		number_in_surah: '28',
		page: '421',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3562',
		number: '3562',
		text: 'وَإِن كُنتُنَّ تُرِدْنَ ٱللَّهَ وَرَسُولَهُۥ وَٱلدَّارَ ٱلْءَاخِرَةَ فَإِنَّ ٱللَّهَ أَعَدَّ لِلْمُحْسِنَٰتِ مِنكُنَّ أَجْرًا عَظِيمًۭا',
		number_in_surah: '29',
		page: '421',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3563',
		number: '3563',
		text: 'يَٰنِسَآءَ ٱلنَّبِىِّ مَن يَأْتِ مِنكُنَّ بِفَٰحِشَةٍۢ مُّبَيِّنَةٍۢ يُضَٰعَفْ لَهَا ٱلْعَذَابُ ضِعْفَيْنِ ۚ وَكَانَ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرًۭا',
		number_in_surah: '30',
		page: '421',
		surah_id: '33',
		hizb_id: '168',
		juz_id: '21',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3564',
		number: '3564',
		text: '۞ وَمَن يَقْنُتْ مِنكُنَّ لِلَّهِ وَرَسُولِهِۦ وَتَعْمَلْ صَٰلِحًۭا نُّؤْتِهَآ أَجْرَهَا مَرَّتَيْنِ وَأَعْتَدْنَا لَهَا رِزْقًۭا كَرِيمًۭا',
		number_in_surah: '31',
		page: '422',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3565',
		number: '3565',
		text: 'يَٰنِسَآءَ ٱلنَّبِىِّ لَسْتُنَّ كَأَحَدٍۢ مِّنَ ٱلنِّسَآءِ ۚ إِنِ ٱتَّقَيْتُنَّ فَلَا تَخْضَعْنَ بِٱلْقَوْلِ فَيَطْمَعَ ٱلَّذِى فِى قَلْبِهِۦ مَرَضٌۭ وَقُلْنَ قَوْلًۭا مَّعْرُوفًۭا',
		number_in_surah: '32',
		page: '422',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3566',
		number: '3566',
		text: 'وَقَرْنَ فِى بُيُوتِكُنَّ وَلَا تَبَرَّجْنَ تَبَرُّجَ ٱلْجَٰهِلِيَّةِ ٱلْأُولَىٰ ۖ وَأَقِمْنَ ٱلصَّلَوٰةَ وَءَاتِينَ ٱلزَّكَوٰةَ وَأَطِعْنَ ٱللَّهَ وَرَسُولَهُۥٓ ۚ إِنَّمَا يُرِيدُ ٱللَّهُ لِيُذْهِبَ عَنكُمُ ٱلرِّجْسَ أَهْلَ ٱلْبَيْتِ وَيُطَهِّرَكُمْ تَطْهِيرًۭا',
		number_in_surah: '33',
		page: '422',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3567',
		number: '3567',
		text: 'وَٱذْكُرْنَ مَا يُتْلَىٰ فِى بُيُوتِكُنَّ مِنْ ءَايَٰتِ ٱللَّهِ وَٱلْحِكْمَةِ ۚ إِنَّ ٱللَّهَ كَانَ لَطِيفًا خَبِيرًا',
		number_in_surah: '34',
		page: '422',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3568',
		number: '3568',
		text: 'إِنَّ ٱلْمُسْلِمِينَ وَٱلْمُسْلِمَٰتِ وَٱلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ وَٱلْقَٰنِتِينَ وَٱلْقَٰنِتَٰتِ وَٱلصَّٰدِقِينَ وَٱلصَّٰدِقَٰتِ وَٱلصَّٰبِرِينَ وَٱلصَّٰبِرَٰتِ وَٱلْخَٰشِعِينَ وَٱلْخَٰشِعَٰتِ وَٱلْمُتَصَدِّقِينَ وَٱلْمُتَصَدِّقَٰتِ وَٱلصَّٰٓئِمِينَ وَٱلصَّٰٓئِمَٰتِ وَٱلْحَٰفِظِينَ فُرُوجَهُمْ وَٱلْحَٰفِظَٰتِ وَٱلذَّٰكِرِينَ ٱللَّهَ كَثِيرًۭا وَٱلذَّٰكِرَٰتِ أَعَدَّ ٱللَّهُ لَهُم مَّغْفِرَةًۭ وَأَجْرًا عَظِيمًۭا',
		number_in_surah: '35',
		page: '422',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3569',
		number: '3569',
		text: 'وَمَا كَانَ لِمُؤْمِنٍۢ وَلَا مُؤْمِنَةٍ إِذَا قَضَى ٱللَّهُ وَرَسُولُهُۥٓ أَمْرًا أَن يَكُونَ لَهُمُ ٱلْخِيَرَةُ مِنْ أَمْرِهِمْ ۗ وَمَن يَعْصِ ٱللَّهَ وَرَسُولَهُۥ فَقَدْ ضَلَّ ضَلَٰلًۭا مُّبِينًۭا',
		number_in_surah: '36',
		page: '423',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3570',
		number: '3570',
		text: 'وَإِذْ تَقُولُ لِلَّذِىٓ أَنْعَمَ ٱللَّهُ عَلَيْهِ وَأَنْعَمْتَ عَلَيْهِ أَمْسِكْ عَلَيْكَ زَوْجَكَ وَٱتَّقِ ٱللَّهَ وَتُخْفِى فِى نَفْسِكَ مَا ٱللَّهُ مُبْدِيهِ وَتَخْشَى ٱلنَّاسَ وَٱللَّهُ أَحَقُّ أَن تَخْشَىٰهُ ۖ فَلَمَّا قَضَىٰ زَيْدٌۭ مِّنْهَا وَطَرًۭا زَوَّجْنَٰكَهَا لِكَىْ لَا يَكُونَ عَلَى ٱلْمُؤْمِنِينَ حَرَجٌۭ فِىٓ أَزْوَٰجِ أَدْعِيَآئِهِمْ إِذَا قَضَوْا۟ مِنْهُنَّ وَطَرًۭا ۚ وَكَانَ أَمْرُ ٱللَّهِ مَفْعُولًۭا',
		number_in_surah: '37',
		page: '423',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3571',
		number: '3571',
		text: 'مَّا كَانَ عَلَى ٱلنَّبِىِّ مِنْ حَرَجٍۢ فِيمَا فَرَضَ ٱللَّهُ لَهُۥ ۖ سُنَّةَ ٱللَّهِ فِى ٱلَّذِينَ خَلَوْا۟ مِن قَبْلُ ۚ وَكَانَ أَمْرُ ٱللَّهِ قَدَرًۭا مَّقْدُورًا',
		number_in_surah: '38',
		page: '423',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3572',
		number: '3572',
		text: 'ٱلَّذِينَ يُبَلِّغُونَ رِسَٰلَٰتِ ٱللَّهِ وَيَخْشَوْنَهُۥ وَلَا يَخْشَوْنَ أَحَدًا إِلَّا ٱللَّهَ ۗ وَكَفَىٰ بِٱللَّهِ حَسِيبًۭا',
		number_in_surah: '39',
		page: '423',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3573',
		number: '3573',
		text: 'مَّا كَانَ مُحَمَّدٌ أَبَآ أَحَدٍۢ مِّن رِّجَالِكُمْ وَلَٰكِن رَّسُولَ ٱللَّهِ وَخَاتَمَ ٱلنَّبِيِّۦنَ ۗ وَكَانَ ٱللَّهُ بِكُلِّ شَىْءٍ عَلِيمًۭا',
		number_in_surah: '40',
		page: '423',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3574',
		number: '3574',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱذْكُرُوا۟ ٱللَّهَ ذِكْرًۭا كَثِيرًۭا',
		number_in_surah: '41',
		page: '423',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3575',
		number: '3575',
		text: 'وَسَبِّحُوهُ بُكْرَةًۭ وَأَصِيلًا',
		number_in_surah: '42',
		page: '423',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3576',
		number: '3576',
		text: 'هُوَ ٱلَّذِى يُصَلِّى عَلَيْكُمْ وَمَلَٰٓئِكَتُهُۥ لِيُخْرِجَكُم مِّنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ ۚ وَكَانَ بِٱلْمُؤْمِنِينَ رَحِيمًۭا',
		number_in_surah: '43',
		page: '423',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3577',
		number: '3577',
		text: 'تَحِيَّتُهُمْ يَوْمَ يَلْقَوْنَهُۥ سَلَٰمٌۭ ۚ وَأَعَدَّ لَهُمْ أَجْرًۭا كَرِيمًۭا',
		number_in_surah: '44',
		page: '424',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3578',
		number: '3578',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ إِنَّآ أَرْسَلْنَٰكَ شَٰهِدًۭا وَمُبَشِّرًۭا وَنَذِيرًۭا',
		number_in_surah: '45',
		page: '424',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3579',
		number: '3579',
		text: 'وَدَاعِيًا إِلَى ٱللَّهِ بِإِذْنِهِۦ وَسِرَاجًۭا مُّنِيرًۭا',
		number_in_surah: '46',
		page: '424',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3580',
		number: '3580',
		text: 'وَبَشِّرِ ٱلْمُؤْمِنِينَ بِأَنَّ لَهُم مِّنَ ٱللَّهِ فَضْلًۭا كَبِيرًۭا',
		number_in_surah: '47',
		page: '424',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3581',
		number: '3581',
		text: 'وَلَا تُطِعِ ٱلْكَٰفِرِينَ وَٱلْمُنَٰفِقِينَ وَدَعْ أَذَىٰهُمْ وَتَوَكَّلْ عَلَى ٱللَّهِ ۚ وَكَفَىٰ بِٱللَّهِ وَكِيلًۭا',
		number_in_surah: '48',
		page: '424',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3582',
		number: '3582',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا نَكَحْتُمُ ٱلْمُؤْمِنَٰتِ ثُمَّ طَلَّقْتُمُوهُنَّ مِن قَبْلِ أَن تَمَسُّوهُنَّ فَمَا لَكُمْ عَلَيْهِنَّ مِنْ عِدَّةٍۢ تَعْتَدُّونَهَا ۖ فَمَتِّعُوهُنَّ وَسَرِّحُوهُنَّ سَرَاحًۭا جَمِيلًۭا',
		number_in_surah: '49',
		page: '424',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3583',
		number: '3583',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ إِنَّآ أَحْلَلْنَا لَكَ أَزْوَٰجَكَ ٱلَّٰتِىٓ ءَاتَيْتَ أُجُورَهُنَّ وَمَا مَلَكَتْ يَمِينُكَ مِمَّآ أَفَآءَ ٱللَّهُ عَلَيْكَ وَبَنَاتِ عَمِّكَ وَبَنَاتِ عَمَّٰتِكَ وَبَنَاتِ خَالِكَ وَبَنَاتِ خَٰلَٰتِكَ ٱلَّٰتِى هَاجَرْنَ مَعَكَ وَٱمْرَأَةًۭ مُّؤْمِنَةً إِن وَهَبَتْ نَفْسَهَا لِلنَّبِىِّ إِنْ أَرَادَ ٱلنَّبِىُّ أَن يَسْتَنكِحَهَا خَالِصَةًۭ لَّكَ مِن دُونِ ٱلْمُؤْمِنِينَ ۗ قَدْ عَلِمْنَا مَا فَرَضْنَا عَلَيْهِمْ فِىٓ أَزْوَٰجِهِمْ وَمَا مَلَكَتْ أَيْمَٰنُهُمْ لِكَيْلَا يَكُونَ عَلَيْكَ حَرَجٌۭ ۗ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '50',
		page: '424',
		surah_id: '33',
		hizb_id: '169',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3584',
		number: '3584',
		text: '۞ تُرْجِى مَن تَشَآءُ مِنْهُنَّ وَتُـْٔوِىٓ إِلَيْكَ مَن تَشَآءُ ۖ وَمَنِ ٱبْتَغَيْتَ مِمَّنْ عَزَلْتَ فَلَا جُنَاحَ عَلَيْكَ ۚ ذَٰلِكَ أَدْنَىٰٓ أَن تَقَرَّ أَعْيُنُهُنَّ وَلَا يَحْزَنَّ وَيَرْضَيْنَ بِمَآ ءَاتَيْتَهُنَّ كُلُّهُنَّ ۚ وَٱللَّهُ يَعْلَمُ مَا فِى قُلُوبِكُمْ ۚ وَكَانَ ٱللَّهُ عَلِيمًا حَلِيمًۭا',
		number_in_surah: '51',
		page: '425',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3585',
		number: '3585',
		text: 'لَّا يَحِلُّ لَكَ ٱلنِّسَآءُ مِنۢ بَعْدُ وَلَآ أَن تَبَدَّلَ بِهِنَّ مِنْ أَزْوَٰجٍۢ وَلَوْ أَعْجَبَكَ حُسْنُهُنَّ إِلَّا مَا مَلَكَتْ يَمِينُكَ ۗ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ رَّقِيبًۭا',
		number_in_surah: '52',
		page: '425',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3586',
		number: '3586',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَدْخُلُوا۟ بُيُوتَ ٱلنَّبِىِّ إِلَّآ أَن يُؤْذَنَ لَكُمْ إِلَىٰ طَعَامٍ غَيْرَ نَٰظِرِينَ إِنَىٰهُ وَلَٰكِنْ إِذَا دُعِيتُمْ فَٱدْخُلُوا۟ فَإِذَا طَعِمْتُمْ فَٱنتَشِرُوا۟ وَلَا مُسْتَـْٔنِسِينَ لِحَدِيثٍ ۚ إِنَّ ذَٰلِكُمْ كَانَ يُؤْذِى ٱلنَّبِىَّ فَيَسْتَحْىِۦ مِنكُمْ ۖ وَٱللَّهُ لَا يَسْتَحْىِۦ مِنَ ٱلْحَقِّ ۚ وَإِذَا سَأَلْتُمُوهُنَّ مَتَٰعًۭا فَسْـَٔلُوهُنَّ مِن وَرَآءِ حِجَابٍۢ ۚ ذَٰلِكُمْ أَطْهَرُ لِقُلُوبِكُمْ وَقُلُوبِهِنَّ ۚ وَمَا كَانَ لَكُمْ أَن تُؤْذُوا۟ رَسُولَ ٱللَّهِ وَلَآ أَن تَنكِحُوٓا۟ أَزْوَٰجَهُۥ مِنۢ بَعْدِهِۦٓ أَبَدًا ۚ إِنَّ ذَٰلِكُمْ كَانَ عِندَ ٱللَّهِ عَظِيمًا',
		number_in_surah: '53',
		page: '425',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3587',
		number: '3587',
		text: 'إِن تُبْدُوا۟ شَيْـًٔا أَوْ تُخْفُوهُ فَإِنَّ ٱللَّهَ كَانَ بِكُلِّ شَىْءٍ عَلِيمًۭا',
		number_in_surah: '54',
		page: '425',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3588',
		number: '3588',
		text: 'لَّا جُنَاحَ عَلَيْهِنَّ فِىٓ ءَابَآئِهِنَّ وَلَآ أَبْنَآئِهِنَّ وَلَآ إِخْوَٰنِهِنَّ وَلَآ أَبْنَآءِ إِخْوَٰنِهِنَّ وَلَآ أَبْنَآءِ أَخَوَٰتِهِنَّ وَلَا نِسَآئِهِنَّ وَلَا مَا مَلَكَتْ أَيْمَٰنُهُنَّ ۗ وَٱتَّقِينَ ٱللَّهَ ۚ إِنَّ ٱللَّهَ كَانَ عَلَىٰ كُلِّ شَىْءٍۢ شَهِيدًا',
		number_in_surah: '55',
		page: '426',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3589',
		number: '3589',
		text: 'إِنَّ ٱللَّهَ وَمَلَٰٓئِكَتَهُۥ يُصَلُّونَ عَلَى ٱلنَّبِىِّ ۚ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ صَلُّوا۟ عَلَيْهِ وَسَلِّمُوا۟ تَسْلِيمًا',
		number_in_surah: '56',
		page: '426',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3590',
		number: '3590',
		text: 'إِنَّ ٱلَّذِينَ يُؤْذُونَ ٱللَّهَ وَرَسُولَهُۥ لَعَنَهُمُ ٱللَّهُ فِى ٱلدُّنْيَا وَٱلْءَاخِرَةِ وَأَعَدَّ لَهُمْ عَذَابًۭا مُّهِينًۭا',
		number_in_surah: '57',
		page: '426',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3591',
		number: '3591',
		text: 'وَٱلَّذِينَ يُؤْذُونَ ٱلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ بِغَيْرِ مَا ٱكْتَسَبُوا۟ فَقَدِ ٱحْتَمَلُوا۟ بُهْتَٰنًۭا وَإِثْمًۭا مُّبِينًۭا',
		number_in_surah: '58',
		page: '426',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3592',
		number: '3592',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ قُل لِّأَزْوَٰجِكَ وَبَنَاتِكَ وَنِسَآءِ ٱلْمُؤْمِنِينَ يُدْنِينَ عَلَيْهِنَّ مِن جَلَٰبِيبِهِنَّ ۚ ذَٰلِكَ أَدْنَىٰٓ أَن يُعْرَفْنَ فَلَا يُؤْذَيْنَ ۗ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '59',
		page: '426',
		surah_id: '33',
		hizb_id: '170',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3593',
		number: '3593',
		text: '۞ لَّئِن لَّمْ يَنتَهِ ٱلْمُنَٰفِقُونَ وَٱلَّذِينَ فِى قُلُوبِهِم مَّرَضٌۭ وَٱلْمُرْجِفُونَ فِى ٱلْمَدِينَةِ لَنُغْرِيَنَّكَ بِهِمْ ثُمَّ لَا يُجَاوِرُونَكَ فِيهَآ إِلَّا قَلِيلًۭا',
		number_in_surah: '60',
		page: '426',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3594',
		number: '3594',
		text: 'مَّلْعُونِينَ ۖ أَيْنَمَا ثُقِفُوٓا۟ أُخِذُوا۟ وَقُتِّلُوا۟ تَقْتِيلًۭا',
		number_in_surah: '61',
		page: '426',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3595',
		number: '3595',
		text: 'سُنَّةَ ٱللَّهِ فِى ٱلَّذِينَ خَلَوْا۟ مِن قَبْلُ ۖ وَلَن تَجِدَ لِسُنَّةِ ٱللَّهِ تَبْدِيلًۭا',
		number_in_surah: '62',
		page: '426',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3596',
		number: '3596',
		text: 'يَسْـَٔلُكَ ٱلنَّاسُ عَنِ ٱلسَّاعَةِ ۖ قُلْ إِنَّمَا عِلْمُهَا عِندَ ٱللَّهِ ۚ وَمَا يُدْرِيكَ لَعَلَّ ٱلسَّاعَةَ تَكُونُ قَرِيبًا',
		number_in_surah: '63',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3597',
		number: '3597',
		text: 'إِنَّ ٱللَّهَ لَعَنَ ٱلْكَٰفِرِينَ وَأَعَدَّ لَهُمْ سَعِيرًا',
		number_in_surah: '64',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3598',
		number: '3598',
		text: 'خَٰلِدِينَ فِيهَآ أَبَدًۭا ۖ لَّا يَجِدُونَ وَلِيًّۭا وَلَا نَصِيرًۭا',
		number_in_surah: '65',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3599',
		number: '3599',
		text: 'يَوْمَ تُقَلَّبُ وُجُوهُهُمْ فِى ٱلنَّارِ يَقُولُونَ يَٰلَيْتَنَآ أَطَعْنَا ٱللَّهَ وَأَطَعْنَا ٱلرَّسُولَا۠',
		number_in_surah: '66',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3600',
		number: '3600',
		text: 'وَقَالُوا۟ رَبَّنَآ إِنَّآ أَطَعْنَا سَادَتَنَا وَكُبَرَآءَنَا فَأَضَلُّونَا ٱلسَّبِيلَا۠',
		number_in_surah: '67',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3601',
		number: '3601',
		text: 'رَبَّنَآ ءَاتِهِمْ ضِعْفَيْنِ مِنَ ٱلْعَذَابِ وَٱلْعَنْهُمْ لَعْنًۭا كَبِيرًۭا',
		number_in_surah: '68',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3602',
		number: '3602',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَكُونُوا۟ كَٱلَّذِينَ ءَاذَوْا۟ مُوسَىٰ فَبَرَّأَهُ ٱللَّهُ مِمَّا قَالُوا۟ ۚ وَكَانَ عِندَ ٱللَّهِ وَجِيهًۭا',
		number_in_surah: '69',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3603',
		number: '3603',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱتَّقُوا۟ ٱللَّهَ وَقُولُوا۟ قَوْلًۭا سَدِيدًۭا',
		number_in_surah: '70',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3604',
		number: '3604',
		text: 'يُصْلِحْ لَكُمْ أَعْمَٰلَكُمْ وَيَغْفِرْ لَكُمْ ذُنُوبَكُمْ ۗ وَمَن يُطِعِ ٱللَّهَ وَرَسُولَهُۥ فَقَدْ فَازَ فَوْزًا عَظِيمًا',
		number_in_surah: '71',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3605',
		number: '3605',
		text: 'إِنَّا عَرَضْنَا ٱلْأَمَانَةَ عَلَى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَٱلْجِبَالِ فَأَبَيْنَ أَن يَحْمِلْنَهَا وَأَشْفَقْنَ مِنْهَا وَحَمَلَهَا ٱلْإِنسَٰنُ ۖ إِنَّهُۥ كَانَ ظَلُومًۭا جَهُولًۭا',
		number_in_surah: '72',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3606',
		number: '3606',
		text: 'لِّيُعَذِّبَ ٱللَّهُ ٱلْمُنَٰفِقِينَ وَٱلْمُنَٰفِقَٰتِ وَٱلْمُشْرِكِينَ وَٱلْمُشْرِكَٰتِ وَيَتُوبَ ٱللَّهُ عَلَى ٱلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ ۗ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًۢا',
		number_in_surah: '73',
		page: '427',
		surah_id: '33',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3607',
		number: '3607',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱلْحَمْدُ لِلَّهِ ٱلَّذِى لَهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ وَلَهُ ٱلْحَمْدُ فِى ٱلْءَاخِرَةِ ۚ وَهُوَ ٱلْحَكِيمُ ٱلْخَبِيرُ',
		number_in_surah: '1',
		page: '428',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3608',
		number: '3608',
		text: 'يَعْلَمُ مَا يَلِجُ فِى ٱلْأَرْضِ وَمَا يَخْرُجُ مِنْهَا وَمَا يَنزِلُ مِنَ ٱلسَّمَآءِ وَمَا يَعْرُجُ فِيهَا ۚ وَهُوَ ٱلرَّحِيمُ ٱلْغَفُورُ',
		number_in_surah: '2',
		page: '428',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3609',
		number: '3609',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ لَا تَأْتِينَا ٱلسَّاعَةُ ۖ قُلْ بَلَىٰ وَرَبِّى لَتَأْتِيَنَّكُمْ عَٰلِمِ ٱلْغَيْبِ ۖ لَا يَعْزُبُ عَنْهُ مِثْقَالُ ذَرَّةٍۢ فِى ٱلسَّمَٰوَٰتِ وَلَا فِى ٱلْأَرْضِ وَلَآ أَصْغَرُ مِن ذَٰلِكَ وَلَآ أَكْبَرُ إِلَّا فِى كِتَٰبٍۢ مُّبِينٍۢ',
		number_in_surah: '3',
		page: '428',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3610',
		number: '3610',
		text: 'لِّيَجْزِىَ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ ۚ أُو۟لَٰٓئِكَ لَهُم مَّغْفِرَةٌۭ وَرِزْقٌۭ كَرِيمٌۭ',
		number_in_surah: '4',
		page: '428',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3611',
		number: '3611',
		text: 'وَٱلَّذِينَ سَعَوْ فِىٓ ءَايَٰتِنَا مُعَٰجِزِينَ أُو۟لَٰٓئِكَ لَهُمْ عَذَابٌۭ مِّن رِّجْزٍ أَلِيمٌۭ',
		number_in_surah: '5',
		page: '428',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3612',
		number: '3612',
		text: 'وَيَرَى ٱلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ ٱلَّذِىٓ أُنزِلَ إِلَيْكَ مِن رَّبِّكَ هُوَ ٱلْحَقَّ وَيَهْدِىٓ إِلَىٰ صِرَٰطِ ٱلْعَزِيزِ ٱلْحَمِيدِ',
		number_in_surah: '6',
		page: '428',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3613',
		number: '3613',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ هَلْ نَدُلُّكُمْ عَلَىٰ رَجُلٍۢ يُنَبِّئُكُمْ إِذَا مُزِّقْتُمْ كُلَّ مُمَزَّقٍ إِنَّكُمْ لَفِى خَلْقٍۢ جَدِيدٍ',
		number_in_surah: '7',
		page: '428',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3614',
		number: '3614',
		text: 'أَفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًا أَم بِهِۦ جِنَّةٌۢ ۗ بَلِ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ فِى ٱلْعَذَابِ وَٱلضَّلَٰلِ ٱلْبَعِيدِ',
		number_in_surah: '8',
		page: '429',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3615',
		number: '3615',
		text: 'أَفَلَمْ يَرَوْا۟ إِلَىٰ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُم مِّنَ ٱلسَّمَآءِ وَٱلْأَرْضِ ۚ إِن نَّشَأْ نَخْسِفْ بِهِمُ ٱلْأَرْضَ أَوْ نُسْقِطْ عَلَيْهِمْ كِسَفًۭا مِّنَ ٱلسَّمَآءِ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَةًۭ لِّكُلِّ عَبْدٍۢ مُّنِيبٍۢ',
		number_in_surah: '9',
		page: '429',
		surah_id: '34',
		hizb_id: '171',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3616',
		number: '3616',
		text: '۞ وَلَقَدْ ءَاتَيْنَا دَاوُۥدَ مِنَّا فَضْلًۭا ۖ يَٰجِبَالُ أَوِّبِى مَعَهُۥ وَٱلطَّيْرَ ۖ وَأَلَنَّا لَهُ ٱلْحَدِيدَ',
		number_in_surah: '10',
		page: '429',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3617',
		number: '3617',
		text: 'أَنِ ٱعْمَلْ سَٰبِغَٰتٍۢ وَقَدِّرْ فِى ٱلسَّرْدِ ۖ وَٱعْمَلُوا۟ صَٰلِحًا ۖ إِنِّى بِمَا تَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '11',
		page: '429',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3618',
		number: '3618',
		text: 'وَلِسُلَيْمَٰنَ ٱلرِّيحَ غُدُوُّهَا شَهْرٌۭ وَرَوَاحُهَا شَهْرٌۭ ۖ وَأَسَلْنَا لَهُۥ عَيْنَ ٱلْقِطْرِ ۖ وَمِنَ ٱلْجِنِّ مَن يَعْمَلُ بَيْنَ يَدَيْهِ بِإِذْنِ رَبِّهِۦ ۖ وَمَن يَزِغْ مِنْهُمْ عَنْ أَمْرِنَا نُذِقْهُ مِنْ عَذَابِ ٱلسَّعِيرِ',
		number_in_surah: '12',
		page: '429',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3619',
		number: '3619',
		text: 'يَعْمَلُونَ لَهُۥ مَا يَشَآءُ مِن مَّحَٰرِيبَ وَتَمَٰثِيلَ وَجِفَانٍۢ كَٱلْجَوَابِ وَقُدُورٍۢ رَّاسِيَٰتٍ ۚ ٱعْمَلُوٓا۟ ءَالَ دَاوُۥدَ شُكْرًۭا ۚ وَقَلِيلٌۭ مِّنْ عِبَادِىَ ٱلشَّكُورُ',
		number_in_surah: '13',
		page: '429',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3620',
		number: '3620',
		text: 'فَلَمَّا قَضَيْنَا عَلَيْهِ ٱلْمَوْتَ مَا دَلَّهُمْ عَلَىٰ مَوْتِهِۦٓ إِلَّا دَآبَّةُ ٱلْأَرْضِ تَأْكُلُ مِنسَأَتَهُۥ ۖ فَلَمَّا خَرَّ تَبَيَّنَتِ ٱلْجِنُّ أَن لَّوْ كَانُوا۟ يَعْلَمُونَ ٱلْغَيْبَ مَا لَبِثُوا۟ فِى ٱلْعَذَابِ ٱلْمُهِينِ',
		number_in_surah: '14',
		page: '429',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3621',
		number: '3621',
		text: 'لَقَدْ كَانَ لِسَبَإٍۢ فِى مَسْكَنِهِمْ ءَايَةٌۭ ۖ جَنَّتَانِ عَن يَمِينٍۢ وَشِمَالٍۢ ۖ كُلُوا۟ مِن رِّزْقِ رَبِّكُمْ وَٱشْكُرُوا۟ لَهُۥ ۚ بَلْدَةٌۭ طَيِّبَةٌۭ وَرَبٌّ غَفُورٌۭ',
		number_in_surah: '15',
		page: '430',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3622',
		number: '3622',
		text: 'فَأَعْرَضُوا۟ فَأَرْسَلْنَا عَلَيْهِمْ سَيْلَ ٱلْعَرِمِ وَبَدَّلْنَٰهُم بِجَنَّتَيْهِمْ جَنَّتَيْنِ ذَوَاتَىْ أُكُلٍ خَمْطٍۢ وَأَثْلٍۢ وَشَىْءٍۢ مِّن سِدْرٍۢ قَلِيلٍۢ',
		number_in_surah: '16',
		page: '430',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3623',
		number: '3623',
		text: 'ذَٰلِكَ جَزَيْنَٰهُم بِمَا كَفَرُوا۟ ۖ وَهَلْ نُجَٰزِىٓ إِلَّا ٱلْكَفُورَ',
		number_in_surah: '17',
		page: '430',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3624',
		number: '3624',
		text: 'وَجَعَلْنَا بَيْنَهُمْ وَبَيْنَ ٱلْقُرَى ٱلَّتِى بَٰرَكْنَا فِيهَا قُرًۭى ظَٰهِرَةًۭ وَقَدَّرْنَا فِيهَا ٱلسَّيْرَ ۖ سِيرُوا۟ فِيهَا لَيَالِىَ وَأَيَّامًا ءَامِنِينَ',
		number_in_surah: '18',
		page: '430',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3625',
		number: '3625',
		text: 'فَقَالُوا۟ رَبَّنَا بَٰعِدْ بَيْنَ أَسْفَارِنَا وَظَلَمُوٓا۟ أَنفُسَهُمْ فَجَعَلْنَٰهُمْ أَحَادِيثَ وَمَزَّقْنَٰهُمْ كُلَّ مُمَزَّقٍ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّكُلِّ صَبَّارٍۢ شَكُورٍۢ',
		number_in_surah: '19',
		page: '430',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3626',
		number: '3626',
		text: 'وَلَقَدْ صَدَّقَ عَلَيْهِمْ إِبْلِيسُ ظَنَّهُۥ فَٱتَّبَعُوهُ إِلَّا فَرِيقًۭا مِّنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '20',
		page: '430',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3627',
		number: '3627',
		text: 'وَمَا كَانَ لَهُۥ عَلَيْهِم مِّن سُلْطَٰنٍ إِلَّا لِنَعْلَمَ مَن يُؤْمِنُ بِٱلْءَاخِرَةِ مِمَّنْ هُوَ مِنْهَا فِى شَكٍّۢ ۗ وَرَبُّكَ عَلَىٰ كُلِّ شَىْءٍ حَفِيظٌۭ',
		number_in_surah: '21',
		page: '430',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3628',
		number: '3628',
		text: 'قُلِ ٱدْعُوا۟ ٱلَّذِينَ زَعَمْتُم مِّن دُونِ ٱللَّهِ ۖ لَا يَمْلِكُونَ مِثْقَالَ ذَرَّةٍۢ فِى ٱلسَّمَٰوَٰتِ وَلَا فِى ٱلْأَرْضِ وَمَا لَهُمْ فِيهِمَا مِن شِرْكٍۢ وَمَا لَهُۥ مِنْهُم مِّن ظَهِيرٍۢ',
		number_in_surah: '22',
		page: '430',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3629',
		number: '3629',
		text: 'وَلَا تَنفَعُ ٱلشَّفَٰعَةُ عِندَهُۥٓ إِلَّا لِمَنْ أَذِنَ لَهُۥ ۚ حَتَّىٰٓ إِذَا فُزِّعَ عَن قُلُوبِهِمْ قَالُوا۟ مَاذَا قَالَ رَبُّكُمْ ۖ قَالُوا۟ ٱلْحَقَّ ۖ وَهُوَ ٱلْعَلِىُّ ٱلْكَبِيرُ',
		number_in_surah: '23',
		page: '431',
		surah_id: '34',
		hizb_id: '172',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3630',
		number: '3630',
		text: '۞ قُلْ مَن يَرْزُقُكُم مِّنَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ قُلِ ٱللَّهُ ۖ وَإِنَّآ أَوْ إِيَّاكُمْ لَعَلَىٰ هُدًى أَوْ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '24',
		page: '431',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3631',
		number: '3631',
		text: 'قُل لَّا تُسْـَٔلُونَ عَمَّآ أَجْرَمْنَا وَلَا نُسْـَٔلُ عَمَّا تَعْمَلُونَ',
		number_in_surah: '25',
		page: '431',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3632',
		number: '3632',
		text: 'قُلْ يَجْمَعُ بَيْنَنَا رَبُّنَا ثُمَّ يَفْتَحُ بَيْنَنَا بِٱلْحَقِّ وَهُوَ ٱلْفَتَّاحُ ٱلْعَلِيمُ',
		number_in_surah: '26',
		page: '431',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3633',
		number: '3633',
		text: 'قُلْ أَرُونِىَ ٱلَّذِينَ أَلْحَقْتُم بِهِۦ شُرَكَآءَ ۖ كَلَّا ۚ بَلْ هُوَ ٱللَّهُ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '27',
		page: '431',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3634',
		number: '3634',
		text: 'وَمَآ أَرْسَلْنَٰكَ إِلَّا كَآفَّةًۭ لِّلنَّاسِ بَشِيرًۭا وَنَذِيرًۭا وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '28',
		page: '431',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3635',
		number: '3635',
		text: 'وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلْوَعْدُ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '29',
		page: '431',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3636',
		number: '3636',
		text: 'قُل لَّكُم مِّيعَادُ يَوْمٍۢ لَّا تَسْتَـْٔخِرُونَ عَنْهُ سَاعَةًۭ وَلَا تَسْتَقْدِمُونَ',
		number_in_surah: '30',
		page: '431',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3637',
		number: '3637',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ لَن نُّؤْمِنَ بِهَٰذَا ٱلْقُرْءَانِ وَلَا بِٱلَّذِى بَيْنَ يَدَيْهِ ۗ وَلَوْ تَرَىٰٓ إِذِ ٱلظَّٰلِمُونَ مَوْقُوفُونَ عِندَ رَبِّهِمْ يَرْجِعُ بَعْضُهُمْ إِلَىٰ بَعْضٍ ٱلْقَوْلَ يَقُولُ ٱلَّذِينَ ٱسْتُضْعِفُوا۟ لِلَّذِينَ ٱسْتَكْبَرُوا۟ لَوْلَآ أَنتُمْ لَكُنَّا مُؤْمِنِينَ',
		number_in_surah: '31',
		page: '431',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3638',
		number: '3638',
		text: 'قَالَ ٱلَّذِينَ ٱسْتَكْبَرُوا۟ لِلَّذِينَ ٱسْتُضْعِفُوٓا۟ أَنَحْنُ صَدَدْنَٰكُمْ عَنِ ٱلْهُدَىٰ بَعْدَ إِذْ جَآءَكُم ۖ بَلْ كُنتُم مُّجْرِمِينَ',
		number_in_surah: '32',
		page: '432',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3639',
		number: '3639',
		text: 'وَقَالَ ٱلَّذِينَ ٱسْتُضْعِفُوا۟ لِلَّذِينَ ٱسْتَكْبَرُوا۟ بَلْ مَكْرُ ٱلَّيْلِ وَٱلنَّهَارِ إِذْ تَأْمُرُونَنَآ أَن نَّكْفُرَ بِٱللَّهِ وَنَجْعَلَ لَهُۥٓ أَندَادًۭا ۚ وَأَسَرُّوا۟ ٱلنَّدَامَةَ لَمَّا رَأَوُا۟ ٱلْعَذَابَ وَجَعَلْنَا ٱلْأَغْلَٰلَ فِىٓ أَعْنَاقِ ٱلَّذِينَ كَفَرُوا۟ ۚ هَلْ يُجْزَوْنَ إِلَّا مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '33',
		page: '432',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3640',
		number: '3640',
		text: 'وَمَآ أَرْسَلْنَا فِى قَرْيَةٍۢ مِّن نَّذِيرٍ إِلَّا قَالَ مُتْرَفُوهَآ إِنَّا بِمَآ أُرْسِلْتُم بِهِۦ كَٰفِرُونَ',
		number_in_surah: '34',
		page: '432',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3641',
		number: '3641',
		text: 'وَقَالُوا۟ نَحْنُ أَكْثَرُ أَمْوَٰلًۭا وَأَوْلَٰدًۭا وَمَا نَحْنُ بِمُعَذَّبِينَ',
		number_in_surah: '35',
		page: '432',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3642',
		number: '3642',
		text: 'قُلْ إِنَّ رَبِّى يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ وَيَقْدِرُ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '36',
		page: '432',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3643',
		number: '3643',
		text: 'وَمَآ أَمْوَٰلُكُمْ وَلَآ أَوْلَٰدُكُم بِٱلَّتِى تُقَرِّبُكُمْ عِندَنَا زُلْفَىٰٓ إِلَّا مَنْ ءَامَنَ وَعَمِلَ صَٰلِحًۭا فَأُو۟لَٰٓئِكَ لَهُمْ جَزَآءُ ٱلضِّعْفِ بِمَا عَمِلُوا۟ وَهُمْ فِى ٱلْغُرُفَٰتِ ءَامِنُونَ',
		number_in_surah: '37',
		page: '432',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3644',
		number: '3644',
		text: 'وَٱلَّذِينَ يَسْعَوْنَ فِىٓ ءَايَٰتِنَا مُعَٰجِزِينَ أُو۟لَٰٓئِكَ فِى ٱلْعَذَابِ مُحْضَرُونَ',
		number_in_surah: '38',
		page: '432',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3645',
		number: '3645',
		text: 'قُلْ إِنَّ رَبِّى يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ مِنْ عِبَادِهِۦ وَيَقْدِرُ لَهُۥ ۚ وَمَآ أَنفَقْتُم مِّن شَىْءٍۢ فَهُوَ يُخْلِفُهُۥ ۖ وَهُوَ خَيْرُ ٱلرَّٰزِقِينَ',
		number_in_surah: '39',
		page: '432',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3646',
		number: '3646',
		text: 'وَيَوْمَ يَحْشُرُهُمْ جَمِيعًۭا ثُمَّ يَقُولُ لِلْمَلَٰٓئِكَةِ أَهَٰٓؤُلَآءِ إِيَّاكُمْ كَانُوا۟ يَعْبُدُونَ',
		number_in_surah: '40',
		page: '433',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3647',
		number: '3647',
		text: 'قَالُوا۟ سُبْحَٰنَكَ أَنتَ وَلِيُّنَا مِن دُونِهِم ۖ بَلْ كَانُوا۟ يَعْبُدُونَ ٱلْجِنَّ ۖ أَكْثَرُهُم بِهِم مُّؤْمِنُونَ',
		number_in_surah: '41',
		page: '433',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3648',
		number: '3648',
		text: 'فَٱلْيَوْمَ لَا يَمْلِكُ بَعْضُكُمْ لِبَعْضٍۢ نَّفْعًۭا وَلَا ضَرًّۭا وَنَقُولُ لِلَّذِينَ ظَلَمُوا۟ ذُوقُوا۟ عَذَابَ ٱلنَّارِ ٱلَّتِى كُنتُم بِهَا تُكَذِّبُونَ',
		number_in_surah: '42',
		page: '433',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3649',
		number: '3649',
		text: 'وَإِذَا تُتْلَىٰ عَلَيْهِمْ ءَايَٰتُنَا بَيِّنَٰتٍۢ قَالُوا۟ مَا هَٰذَآ إِلَّا رَجُلٌۭ يُرِيدُ أَن يَصُدَّكُمْ عَمَّا كَانَ يَعْبُدُ ءَابَآؤُكُمْ وَقَالُوا۟ مَا هَٰذَآ إِلَّآ إِفْكٌۭ مُّفْتَرًۭى ۚ وَقَالَ ٱلَّذِينَ كَفَرُوا۟ لِلْحَقِّ لَمَّا جَآءَهُمْ إِنْ هَٰذَآ إِلَّا سِحْرٌۭ مُّبِينٌۭ',
		number_in_surah: '43',
		page: '433',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3650',
		number: '3650',
		text: 'وَمَآ ءَاتَيْنَٰهُم مِّن كُتُبٍۢ يَدْرُسُونَهَا ۖ وَمَآ أَرْسَلْنَآ إِلَيْهِمْ قَبْلَكَ مِن نَّذِيرٍۢ',
		number_in_surah: '44',
		page: '433',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3651',
		number: '3651',
		text: 'وَكَذَّبَ ٱلَّذِينَ مِن قَبْلِهِمْ وَمَا بَلَغُوا۟ مِعْشَارَ مَآ ءَاتَيْنَٰهُمْ فَكَذَّبُوا۟ رُسُلِى ۖ فَكَيْفَ كَانَ نَكِيرِ',
		number_in_surah: '45',
		page: '433',
		surah_id: '34',
		hizb_id: '173',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3652',
		number: '3652',
		text: '۞ قُلْ إِنَّمَآ أَعِظُكُم بِوَٰحِدَةٍ ۖ أَن تَقُومُوا۟ لِلَّهِ مَثْنَىٰ وَفُرَٰدَىٰ ثُمَّ تَتَفَكَّرُوا۟ ۚ مَا بِصَاحِبِكُم مِّن جِنَّةٍ ۚ إِنْ هُوَ إِلَّا نَذِيرٌۭ لَّكُم بَيْنَ يَدَىْ عَذَابٍۢ شَدِيدٍۢ',
		number_in_surah: '46',
		page: '433',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3653',
		number: '3653',
		text: 'قُلْ مَا سَأَلْتُكُم مِّنْ أَجْرٍۢ فَهُوَ لَكُمْ ۖ إِنْ أَجْرِىَ إِلَّا عَلَى ٱللَّهِ ۖ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ شَهِيدٌۭ',
		number_in_surah: '47',
		page: '433',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3654',
		number: '3654',
		text: 'قُلْ إِنَّ رَبِّى يَقْذِفُ بِٱلْحَقِّ عَلَّٰمُ ٱلْغُيُوبِ',
		number_in_surah: '48',
		page: '433',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3655',
		number: '3655',
		text: 'قُلْ جَآءَ ٱلْحَقُّ وَمَا يُبْدِئُ ٱلْبَٰطِلُ وَمَا يُعِيدُ',
		number_in_surah: '49',
		page: '434',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3656',
		number: '3656',
		text: 'قُلْ إِن ضَلَلْتُ فَإِنَّمَآ أَضِلُّ عَلَىٰ نَفْسِى ۖ وَإِنِ ٱهْتَدَيْتُ فَبِمَا يُوحِىٓ إِلَىَّ رَبِّىٓ ۚ إِنَّهُۥ سَمِيعٌۭ قَرِيبٌۭ',
		number_in_surah: '50',
		page: '434',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3657',
		number: '3657',
		text: 'وَلَوْ تَرَىٰٓ إِذْ فَزِعُوا۟ فَلَا فَوْتَ وَأُخِذُوا۟ مِن مَّكَانٍۢ قَرِيبٍۢ',
		number_in_surah: '51',
		page: '434',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3658',
		number: '3658',
		text: 'وَقَالُوٓا۟ ءَامَنَّا بِهِۦ وَأَنَّىٰ لَهُمُ ٱلتَّنَاوُشُ مِن مَّكَانٍۭ بَعِيدٍۢ',
		number_in_surah: '52',
		page: '434',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3659',
		number: '3659',
		text: 'وَقَدْ كَفَرُوا۟ بِهِۦ مِن قَبْلُ ۖ وَيَقْذِفُونَ بِٱلْغَيْبِ مِن مَّكَانٍۭ بَعِيدٍۢ',
		number_in_surah: '53',
		page: '434',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3660',
		number: '3660',
		text: 'وَحِيلَ بَيْنَهُمْ وَبَيْنَ مَا يَشْتَهُونَ كَمَا فُعِلَ بِأَشْيَاعِهِم مِّن قَبْلُ ۚ إِنَّهُمْ كَانُوا۟ فِى شَكٍّۢ مُّرِيبٍۭ',
		number_in_surah: '54',
		page: '434',
		surah_id: '34',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3661',
		number: '3661',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱلْحَمْدُ لِلَّهِ فَاطِرِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ جَاعِلِ ٱلْمَلَٰٓئِكَةِ رُسُلًا أُو۟لِىٓ أَجْنِحَةٍۢ مَّثْنَىٰ وَثُلَٰثَ وَرُبَٰعَ ۚ يَزِيدُ فِى ٱلْخَلْقِ مَا يَشَآءُ ۚ إِنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '1',
		page: '434',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3662',
		number: '3662',
		text: 'مَّا يَفْتَحِ ٱللَّهُ لِلنَّاسِ مِن رَّحْمَةٍۢ فَلَا مُمْسِكَ لَهَا ۖ وَمَا يُمْسِكْ فَلَا مُرْسِلَ لَهُۥ مِنۢ بَعْدِهِۦ ۚ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '2',
		page: '434',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3663',
		number: '3663',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ ٱذْكُرُوا۟ نِعْمَتَ ٱللَّهِ عَلَيْكُمْ ۚ هَلْ مِنْ خَٰلِقٍ غَيْرُ ٱللَّهِ يَرْزُقُكُم مِّنَ ٱلسَّمَآءِ وَٱلْأَرْضِ ۚ لَآ إِلَٰهَ إِلَّا هُوَ ۖ فَأَنَّىٰ تُؤْفَكُونَ',
		number_in_surah: '3',
		page: '434',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3664',
		number: '3664',
		text: 'وَإِن يُكَذِّبُوكَ فَقَدْ كُذِّبَتْ رُسُلٌۭ مِّن قَبْلِكَ ۚ وَإِلَى ٱللَّهِ تُرْجَعُ ٱلْأُمُورُ',
		number_in_surah: '4',
		page: '435',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3665',
		number: '3665',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ إِنَّ وَعْدَ ٱللَّهِ حَقٌّۭ ۖ فَلَا تَغُرَّنَّكُمُ ٱلْحَيَوٰةُ ٱلدُّنْيَا ۖ وَلَا يَغُرَّنَّكُم بِٱللَّهِ ٱلْغَرُورُ',
		number_in_surah: '5',
		page: '435',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3666',
		number: '3666',
		text: 'إِنَّ ٱلشَّيْطَٰنَ لَكُمْ عَدُوٌّۭ فَٱتَّخِذُوهُ عَدُوًّا ۚ إِنَّمَا يَدْعُوا۟ حِزْبَهُۥ لِيَكُونُوا۟ مِنْ أَصْحَٰبِ ٱلسَّعِيرِ',
		number_in_surah: '6',
		page: '435',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3667',
		number: '3667',
		text: 'ٱلَّذِينَ كَفَرُوا۟ لَهُمْ عَذَابٌۭ شَدِيدٌۭ ۖ وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَهُم مَّغْفِرَةٌۭ وَأَجْرٌۭ كَبِيرٌ',
		number_in_surah: '7',
		page: '435',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3668',
		number: '3668',
		text: 'أَفَمَن زُيِّنَ لَهُۥ سُوٓءُ عَمَلِهِۦ فَرَءَاهُ حَسَنًۭا ۖ فَإِنَّ ٱللَّهَ يُضِلُّ مَن يَشَآءُ وَيَهْدِى مَن يَشَآءُ ۖ فَلَا تَذْهَبْ نَفْسُكَ عَلَيْهِمْ حَسَرَٰتٍ ۚ إِنَّ ٱللَّهَ عَلِيمٌۢ بِمَا يَصْنَعُونَ',
		number_in_surah: '8',
		page: '435',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3669',
		number: '3669',
		text: 'وَٱللَّهُ ٱلَّذِىٓ أَرْسَلَ ٱلرِّيَٰحَ فَتُثِيرُ سَحَابًۭا فَسُقْنَٰهُ إِلَىٰ بَلَدٍۢ مَّيِّتٍۢ فَأَحْيَيْنَا بِهِ ٱلْأَرْضَ بَعْدَ مَوْتِهَا ۚ كَذَٰلِكَ ٱلنُّشُورُ',
		number_in_surah: '9',
		page: '435',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3670',
		number: '3670',
		text: 'مَن كَانَ يُرِيدُ ٱلْعِزَّةَ فَلِلَّهِ ٱلْعِزَّةُ جَمِيعًا ۚ إِلَيْهِ يَصْعَدُ ٱلْكَلِمُ ٱلطَّيِّبُ وَٱلْعَمَلُ ٱلصَّٰلِحُ يَرْفَعُهُۥ ۚ وَٱلَّذِينَ يَمْكُرُونَ ٱلسَّيِّـَٔاتِ لَهُمْ عَذَابٌۭ شَدِيدٌۭ ۖ وَمَكْرُ أُو۟لَٰٓئِكَ هُوَ يَبُورُ',
		number_in_surah: '10',
		page: '435',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3671',
		number: '3671',
		text: 'وَٱللَّهُ خَلَقَكُم مِّن تُرَابٍۢ ثُمَّ مِن نُّطْفَةٍۢ ثُمَّ جَعَلَكُمْ أَزْوَٰجًۭا ۚ وَمَا تَحْمِلُ مِنْ أُنثَىٰ وَلَا تَضَعُ إِلَّا بِعِلْمِهِۦ ۚ وَمَا يُعَمَّرُ مِن مُّعَمَّرٍۢ وَلَا يُنقَصُ مِنْ عُمُرِهِۦٓ إِلَّا فِى كِتَٰبٍ ۚ إِنَّ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٌۭ',
		number_in_surah: '11',
		page: '435',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3672',
		number: '3672',
		text: 'وَمَا يَسْتَوِى ٱلْبَحْرَانِ هَٰذَا عَذْبٌۭ فُرَاتٌۭ سَآئِغٌۭ شَرَابُهُۥ وَهَٰذَا مِلْحٌ أُجَاجٌۭ ۖ وَمِن كُلٍّۢ تَأْكُلُونَ لَحْمًۭا طَرِيًّۭا وَتَسْتَخْرِجُونَ حِلْيَةًۭ تَلْبَسُونَهَا ۖ وَتَرَى ٱلْفُلْكَ فِيهِ مَوَاخِرَ لِتَبْتَغُوا۟ مِن فَضْلِهِۦ وَلَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '12',
		page: '436',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3673',
		number: '3673',
		text: 'يُولِجُ ٱلَّيْلَ فِى ٱلنَّهَارِ وَيُولِجُ ٱلنَّهَارَ فِى ٱلَّيْلِ وَسَخَّرَ ٱلشَّمْسَ وَٱلْقَمَرَ كُلٌّۭ يَجْرِى لِأَجَلٍۢ مُّسَمًّۭى ۚ ذَٰلِكُمُ ٱللَّهُ رَبُّكُمْ لَهُ ٱلْمُلْكُ ۚ وَٱلَّذِينَ تَدْعُونَ مِن دُونِهِۦ مَا يَمْلِكُونَ مِن قِطْمِيرٍ',
		number_in_surah: '13',
		page: '436',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3674',
		number: '3674',
		text: 'إِن تَدْعُوهُمْ لَا يَسْمَعُوا۟ دُعَآءَكُمْ وَلَوْ سَمِعُوا۟ مَا ٱسْتَجَابُوا۟ لَكُمْ ۖ وَيَوْمَ ٱلْقِيَٰمَةِ يَكْفُرُونَ بِشِرْكِكُمْ ۚ وَلَا يُنَبِّئُكَ مِثْلُ خَبِيرٍۢ',
		number_in_surah: '14',
		page: '436',
		surah_id: '35',
		hizb_id: '174',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3675',
		number: '3675',
		text: '۞ يَٰٓأَيُّهَا ٱلنَّاسُ أَنتُمُ ٱلْفُقَرَآءُ إِلَى ٱللَّهِ ۖ وَٱللَّهُ هُوَ ٱلْغَنِىُّ ٱلْحَمِيدُ',
		number_in_surah: '15',
		page: '436',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3676',
		number: '3676',
		text: 'إِن يَشَأْ يُذْهِبْكُمْ وَيَأْتِ بِخَلْقٍۢ جَدِيدٍۢ',
		number_in_surah: '16',
		page: '436',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3677',
		number: '3677',
		text: 'وَمَا ذَٰلِكَ عَلَى ٱللَّهِ بِعَزِيزٍۢ',
		number_in_surah: '17',
		page: '436',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3678',
		number: '3678',
		text: 'وَلَا تَزِرُ وَازِرَةٌۭ وِزْرَ أُخْرَىٰ ۚ وَإِن تَدْعُ مُثْقَلَةٌ إِلَىٰ حِمْلِهَا لَا يُحْمَلْ مِنْهُ شَىْءٌۭ وَلَوْ كَانَ ذَا قُرْبَىٰٓ ۗ إِنَّمَا تُنذِرُ ٱلَّذِينَ يَخْشَوْنَ رَبَّهُم بِٱلْغَيْبِ وَأَقَامُوا۟ ٱلصَّلَوٰةَ ۚ وَمَن تَزَكَّىٰ فَإِنَّمَا يَتَزَكَّىٰ لِنَفْسِهِۦ ۚ وَإِلَى ٱللَّهِ ٱلْمَصِيرُ',
		number_in_surah: '18',
		page: '436',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3679',
		number: '3679',
		text: 'وَمَا يَسْتَوِى ٱلْأَعْمَىٰ وَٱلْبَصِيرُ',
		number_in_surah: '19',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3680',
		number: '3680',
		text: 'وَلَا ٱلظُّلُمَٰتُ وَلَا ٱلنُّورُ',
		number_in_surah: '20',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3681',
		number: '3681',
		text: 'وَلَا ٱلظِّلُّ وَلَا ٱلْحَرُورُ',
		number_in_surah: '21',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3682',
		number: '3682',
		text: 'وَمَا يَسْتَوِى ٱلْأَحْيَآءُ وَلَا ٱلْأَمْوَٰتُ ۚ إِنَّ ٱللَّهَ يُسْمِعُ مَن يَشَآءُ ۖ وَمَآ أَنتَ بِمُسْمِعٍۢ مَّن فِى ٱلْقُبُورِ',
		number_in_surah: '22',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3683',
		number: '3683',
		text: 'إِنْ أَنتَ إِلَّا نَذِيرٌ',
		number_in_surah: '23',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3684',
		number: '3684',
		text: 'إِنَّآ أَرْسَلْنَٰكَ بِٱلْحَقِّ بَشِيرًۭا وَنَذِيرًۭا ۚ وَإِن مِّنْ أُمَّةٍ إِلَّا خَلَا فِيهَا نَذِيرٌۭ',
		number_in_surah: '24',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3685',
		number: '3685',
		text: 'وَإِن يُكَذِّبُوكَ فَقَدْ كَذَّبَ ٱلَّذِينَ مِن قَبْلِهِمْ جَآءَتْهُمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ وَبِٱلزُّبُرِ وَبِٱلْكِتَٰبِ ٱلْمُنِيرِ',
		number_in_surah: '25',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3686',
		number: '3686',
		text: 'ثُمَّ أَخَذْتُ ٱلَّذِينَ كَفَرُوا۟ ۖ فَكَيْفَ كَانَ نَكِيرِ',
		number_in_surah: '26',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3687',
		number: '3687',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَأَخْرَجْنَا بِهِۦ ثَمَرَٰتٍۢ مُّخْتَلِفًا أَلْوَٰنُهَا ۚ وَمِنَ ٱلْجِبَالِ جُدَدٌۢ بِيضٌۭ وَحُمْرٌۭ مُّخْتَلِفٌ أَلْوَٰنُهَا وَغَرَابِيبُ سُودٌۭ',
		number_in_surah: '27',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3688',
		number: '3688',
		text: 'وَمِنَ ٱلنَّاسِ وَٱلدَّوَآبِّ وَٱلْأَنْعَٰمِ مُخْتَلِفٌ أَلْوَٰنُهُۥ كَذَٰلِكَ ۗ إِنَّمَا يَخْشَى ٱللَّهَ مِنْ عِبَادِهِ ٱلْعُلَمَٰٓؤُا۟ ۗ إِنَّ ٱللَّهَ عَزِيزٌ غَفُورٌ',
		number_in_surah: '28',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3689',
		number: '3689',
		text: 'إِنَّ ٱلَّذِينَ يَتْلُونَ كِتَٰبَ ٱللَّهِ وَأَقَامُوا۟ ٱلصَّلَوٰةَ وَأَنفَقُوا۟ مِمَّا رَزَقْنَٰهُمْ سِرًّۭا وَعَلَانِيَةًۭ يَرْجُونَ تِجَٰرَةًۭ لَّن تَبُورَ',
		number_in_surah: '29',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3690',
		number: '3690',
		text: 'لِيُوَفِّيَهُمْ أُجُورَهُمْ وَيَزِيدَهُم مِّن فَضْلِهِۦٓ ۚ إِنَّهُۥ غَفُورٌۭ شَكُورٌۭ',
		number_in_surah: '30',
		page: '437',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3691',
		number: '3691',
		text: 'وَٱلَّذِىٓ أَوْحَيْنَآ إِلَيْكَ مِنَ ٱلْكِتَٰبِ هُوَ ٱلْحَقُّ مُصَدِّقًۭا لِّمَا بَيْنَ يَدَيْهِ ۗ إِنَّ ٱللَّهَ بِعِبَادِهِۦ لَخَبِيرٌۢ بَصِيرٌۭ',
		number_in_surah: '31',
		page: '438',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3692',
		number: '3692',
		text: 'ثُمَّ أَوْرَثْنَا ٱلْكِتَٰبَ ٱلَّذِينَ ٱصْطَفَيْنَا مِنْ عِبَادِنَا ۖ فَمِنْهُمْ ظَالِمٌۭ لِّنَفْسِهِۦ وَمِنْهُم مُّقْتَصِدٌۭ وَمِنْهُمْ سَابِقٌۢ بِٱلْخَيْرَٰتِ بِإِذْنِ ٱللَّهِ ۚ ذَٰلِكَ هُوَ ٱلْفَضْلُ ٱلْكَبِيرُ',
		number_in_surah: '32',
		page: '438',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3693',
		number: '3693',
		text: 'جَنَّٰتُ عَدْنٍۢ يَدْخُلُونَهَا يُحَلَّوْنَ فِيهَا مِنْ أَسَاوِرَ مِن ذَهَبٍۢ وَلُؤْلُؤًۭا ۖ وَلِبَاسُهُمْ فِيهَا حَرِيرٌۭ',
		number_in_surah: '33',
		page: '438',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3694',
		number: '3694',
		text: 'وَقَالُوا۟ ٱلْحَمْدُ لِلَّهِ ٱلَّذِىٓ أَذْهَبَ عَنَّا ٱلْحَزَنَ ۖ إِنَّ رَبَّنَا لَغَفُورٌۭ شَكُورٌ',
		number_in_surah: '34',
		page: '438',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3695',
		number: '3695',
		text: 'ٱلَّذِىٓ أَحَلَّنَا دَارَ ٱلْمُقَامَةِ مِن فَضْلِهِۦ لَا يَمَسُّنَا فِيهَا نَصَبٌۭ وَلَا يَمَسُّنَا فِيهَا لُغُوبٌۭ',
		number_in_surah: '35',
		page: '438',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3696',
		number: '3696',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ لَهُمْ نَارُ جَهَنَّمَ لَا يُقْضَىٰ عَلَيْهِمْ فَيَمُوتُوا۟ وَلَا يُخَفَّفُ عَنْهُم مِّنْ عَذَابِهَا ۚ كَذَٰلِكَ نَجْزِى كُلَّ كَفُورٍۢ',
		number_in_surah: '36',
		page: '438',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3697',
		number: '3697',
		text: 'وَهُمْ يَصْطَرِخُونَ فِيهَا رَبَّنَآ أَخْرِجْنَا نَعْمَلْ صَٰلِحًا غَيْرَ ٱلَّذِى كُنَّا نَعْمَلُ ۚ أَوَلَمْ نُعَمِّرْكُم مَّا يَتَذَكَّرُ فِيهِ مَن تَذَكَّرَ وَجَآءَكُمُ ٱلنَّذِيرُ ۖ فَذُوقُوا۟ فَمَا لِلظَّٰلِمِينَ مِن نَّصِيرٍ',
		number_in_surah: '37',
		page: '438',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3698',
		number: '3698',
		text: 'إِنَّ ٱللَّهَ عَٰلِمُ غَيْبِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ إِنَّهُۥ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '38',
		page: '438',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3699',
		number: '3699',
		text: 'هُوَ ٱلَّذِى جَعَلَكُمْ خَلَٰٓئِفَ فِى ٱلْأَرْضِ ۚ فَمَن كَفَرَ فَعَلَيْهِ كُفْرُهُۥ ۖ وَلَا يَزِيدُ ٱلْكَٰفِرِينَ كُفْرُهُمْ عِندَ رَبِّهِمْ إِلَّا مَقْتًۭا ۖ وَلَا يَزِيدُ ٱلْكَٰفِرِينَ كُفْرُهُمْ إِلَّا خَسَارًۭا',
		number_in_surah: '39',
		page: '439',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3700',
		number: '3700',
		text: 'قُلْ أَرَءَيْتُمْ شُرَكَآءَكُمُ ٱلَّذِينَ تَدْعُونَ مِن دُونِ ٱللَّهِ أَرُونِى مَاذَا خَلَقُوا۟ مِنَ ٱلْأَرْضِ أَمْ لَهُمْ شِرْكٌۭ فِى ٱلسَّمَٰوَٰتِ أَمْ ءَاتَيْنَٰهُمْ كِتَٰبًۭا فَهُمْ عَلَىٰ بَيِّنَتٍۢ مِّنْهُ ۚ بَلْ إِن يَعِدُ ٱلظَّٰلِمُونَ بَعْضُهُم بَعْضًا إِلَّا غُرُورًا',
		number_in_surah: '40',
		page: '439',
		surah_id: '35',
		hizb_id: '175',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3701',
		number: '3701',
		text: '۞ إِنَّ ٱللَّهَ يُمْسِكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ أَن تَزُولَا ۚ وَلَئِن زَالَتَآ إِنْ أَمْسَكَهُمَا مِنْ أَحَدٍۢ مِّنۢ بَعْدِهِۦٓ ۚ إِنَّهُۥ كَانَ حَلِيمًا غَفُورًۭا',
		number_in_surah: '41',
		page: '439',
		surah_id: '35',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3702',
		number: '3702',
		text: 'وَأَقْسَمُوا۟ بِٱللَّهِ جَهْدَ أَيْمَٰنِهِمْ لَئِن جَآءَهُمْ نَذِيرٌۭ لَّيَكُونُنَّ أَهْدَىٰ مِنْ إِحْدَى ٱلْأُمَمِ ۖ فَلَمَّا جَآءَهُمْ نَذِيرٌۭ مَّا زَادَهُمْ إِلَّا نُفُورًا',
		number_in_surah: '42',
		page: '439',
		surah_id: '35',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3703',
		number: '3703',
		text: 'ٱسْتِكْبَارًۭا فِى ٱلْأَرْضِ وَمَكْرَ ٱلسَّيِّئِ ۚ وَلَا يَحِيقُ ٱلْمَكْرُ ٱلسَّيِّئُ إِلَّا بِأَهْلِهِۦ ۚ فَهَلْ يَنظُرُونَ إِلَّا سُنَّتَ ٱلْأَوَّلِينَ ۚ فَلَن تَجِدَ لِسُنَّتِ ٱللَّهِ تَبْدِيلًۭا ۖ وَلَن تَجِدَ لِسُنَّتِ ٱللَّهِ تَحْوِيلًا',
		number_in_surah: '43',
		page: '439',
		surah_id: '35',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3704',
		number: '3704',
		text: 'أَوَلَمْ يَسِيرُوا۟ فِى ٱلْأَرْضِ فَيَنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبْلِهِمْ وَكَانُوٓا۟ أَشَدَّ مِنْهُمْ قُوَّةًۭ ۚ وَمَا كَانَ ٱللَّهُ لِيُعْجِزَهُۥ مِن شَىْءٍۢ فِى ٱلسَّمَٰوَٰتِ وَلَا فِى ٱلْأَرْضِ ۚ إِنَّهُۥ كَانَ عَلِيمًۭا قَدِيرًۭا',
		number_in_surah: '44',
		page: '439',
		surah_id: '35',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3705',
		number: '3705',
		text: 'وَلَوْ يُؤَاخِذُ ٱللَّهُ ٱلنَّاسَ بِمَا كَسَبُوا۟ مَا تَرَكَ عَلَىٰ ظَهْرِهَا مِن دَآبَّةٍۢ وَلَٰكِن يُؤَخِّرُهُمْ إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى ۖ فَإِذَا جَآءَ أَجَلُهُمْ فَإِنَّ ٱللَّهَ كَانَ بِعِبَادِهِۦ بَصِيرًۢا',
		number_in_surah: '45',
		page: '440',
		surah_id: '35',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3706',
		number: '3706',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يسٓ',
		number_in_surah: '1',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3707',
		number: '3707',
		text: 'وَٱلْقُرْءَانِ ٱلْحَكِيمِ',
		number_in_surah: '2',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3708',
		number: '3708',
		text: 'إِنَّكَ لَمِنَ ٱلْمُرْسَلِينَ',
		number_in_surah: '3',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3709',
		number: '3709',
		text: 'عَلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '4',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3710',
		number: '3710',
		text: 'تَنزِيلَ ٱلْعَزِيزِ ٱلرَّحِيمِ',
		number_in_surah: '5',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3711',
		number: '3711',
		text: 'لِتُنذِرَ قَوْمًۭا مَّآ أُنذِرَ ءَابَآؤُهُمْ فَهُمْ غَٰفِلُونَ',
		number_in_surah: '6',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3712',
		number: '3712',
		text: 'لَقَدْ حَقَّ ٱلْقَوْلُ عَلَىٰٓ أَكْثَرِهِمْ فَهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '7',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3713',
		number: '3713',
		text: 'إِنَّا جَعَلْنَا فِىٓ أَعْنَٰقِهِمْ أَغْلَٰلًۭا فَهِىَ إِلَى ٱلْأَذْقَانِ فَهُم مُّقْمَحُونَ',
		number_in_surah: '8',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3714',
		number: '3714',
		text: 'وَجَعَلْنَا مِنۢ بَيْنِ أَيْدِيهِمْ سَدًّۭا وَمِنْ خَلْفِهِمْ سَدًّۭا فَأَغْشَيْنَٰهُمْ فَهُمْ لَا يُبْصِرُونَ',
		number_in_surah: '9',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3715',
		number: '3715',
		text: 'وَسَوَآءٌ عَلَيْهِمْ ءَأَنذَرْتَهُمْ أَمْ لَمْ تُنذِرْهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '10',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3716',
		number: '3716',
		text: 'إِنَّمَا تُنذِرُ مَنِ ٱتَّبَعَ ٱلذِّكْرَ وَخَشِىَ ٱلرَّحْمَٰنَ بِٱلْغَيْبِ ۖ فَبَشِّرْهُ بِمَغْفِرَةٍۢ وَأَجْرٍۢ كَرِيمٍ',
		number_in_surah: '11',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3717',
		number: '3717',
		text: 'إِنَّا نَحْنُ نُحْىِ ٱلْمَوْتَىٰ وَنَكْتُبُ مَا قَدَّمُوا۟ وَءَاثَٰرَهُمْ ۚ وَكُلَّ شَىْءٍ أَحْصَيْنَٰهُ فِىٓ إِمَامٍۢ مُّبِينٍۢ',
		number_in_surah: '12',
		page: '440',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3718',
		number: '3718',
		text: 'وَٱضْرِبْ لَهُم مَّثَلًا أَصْحَٰبَ ٱلْقَرْيَةِ إِذْ جَآءَهَا ٱلْمُرْسَلُونَ',
		number_in_surah: '13',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:07',
		updated_at: '2018-06-07 08:07:07',
	},
	{
		id: '3719',
		number: '3719',
		text: 'إِذْ أَرْسَلْنَآ إِلَيْهِمُ ٱثْنَيْنِ فَكَذَّبُوهُمَا فَعَزَّزْنَا بِثَالِثٍۢ فَقَالُوٓا۟ إِنَّآ إِلَيْكُم مُّرْسَلُونَ',
		number_in_surah: '14',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3720',
		number: '3720',
		text: 'قَالُوا۟ مَآ أَنتُمْ إِلَّا بَشَرٌۭ مِّثْلُنَا وَمَآ أَنزَلَ ٱلرَّحْمَٰنُ مِن شَىْءٍ إِنْ أَنتُمْ إِلَّا تَكْذِبُونَ',
		number_in_surah: '15',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3721',
		number: '3721',
		text: 'قَالُوا۟ رَبُّنَا يَعْلَمُ إِنَّآ إِلَيْكُمْ لَمُرْسَلُونَ',
		number_in_surah: '16',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3722',
		number: '3722',
		text: 'وَمَا عَلَيْنَآ إِلَّا ٱلْبَلَٰغُ ٱلْمُبِينُ',
		number_in_surah: '17',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3723',
		number: '3723',
		text: 'قَالُوٓا۟ إِنَّا تَطَيَّرْنَا بِكُمْ ۖ لَئِن لَّمْ تَنتَهُوا۟ لَنَرْجُمَنَّكُمْ وَلَيَمَسَّنَّكُم مِّنَّا عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '18',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3724',
		number: '3724',
		text: 'قَالُوا۟ طَٰٓئِرُكُم مَّعَكُمْ ۚ أَئِن ذُكِّرْتُم ۚ بَلْ أَنتُمْ قَوْمٌۭ مُّسْرِفُونَ',
		number_in_surah: '19',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3725',
		number: '3725',
		text: 'وَجَآءَ مِنْ أَقْصَا ٱلْمَدِينَةِ رَجُلٌۭ يَسْعَىٰ قَالَ يَٰقَوْمِ ٱتَّبِعُوا۟ ٱلْمُرْسَلِينَ',
		number_in_surah: '20',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3726',
		number: '3726',
		text: 'ٱتَّبِعُوا۟ مَن لَّا يَسْـَٔلُكُمْ أَجْرًۭا وَهُم مُّهْتَدُونَ',
		number_in_surah: '21',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3727',
		number: '3727',
		text: 'وَمَا لِىَ لَآ أَعْبُدُ ٱلَّذِى فَطَرَنِى وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '22',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3728',
		number: '3728',
		text: 'ءَأَتَّخِذُ مِن دُونِهِۦٓ ءَالِهَةً إِن يُرِدْنِ ٱلرَّحْمَٰنُ بِضُرٍّۢ لَّا تُغْنِ عَنِّى شَفَٰعَتُهُمْ شَيْـًۭٔا وَلَا يُنقِذُونِ',
		number_in_surah: '23',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3729',
		number: '3729',
		text: 'إِنِّىٓ إِذًۭا لَّفِى ضَلَٰلٍۢ مُّبِينٍ',
		number_in_surah: '24',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3730',
		number: '3730',
		text: 'إِنِّىٓ ءَامَنتُ بِرَبِّكُمْ فَٱسْمَعُونِ',
		number_in_surah: '25',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3731',
		number: '3731',
		text: 'قِيلَ ٱدْخُلِ ٱلْجَنَّةَ ۖ قَالَ يَٰلَيْتَ قَوْمِى يَعْلَمُونَ',
		number_in_surah: '26',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3732',
		number: '3732',
		text: 'بِمَا غَفَرَ لِى رَبِّى وَجَعَلَنِى مِنَ ٱلْمُكْرَمِينَ',
		number_in_surah: '27',
		page: '441',
		surah_id: '36',
		hizb_id: '176',
		juz_id: '22',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3733',
		number: '3733',
		text: '۞ وَمَآ أَنزَلْنَا عَلَىٰ قَوْمِهِۦ مِنۢ بَعْدِهِۦ مِن جُندٍۢ مِّنَ ٱلسَّمَآءِ وَمَا كُنَّا مُنزِلِينَ',
		number_in_surah: '28',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3734',
		number: '3734',
		text: 'إِن كَانَتْ إِلَّا صَيْحَةًۭ وَٰحِدَةًۭ فَإِذَا هُمْ خَٰمِدُونَ',
		number_in_surah: '29',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3735',
		number: '3735',
		text: 'يَٰحَسْرَةً عَلَى ٱلْعِبَادِ ۚ مَا يَأْتِيهِم مِّن رَّسُولٍ إِلَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '30',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3736',
		number: '3736',
		text: 'أَلَمْ يَرَوْا۟ كَمْ أَهْلَكْنَا قَبْلَهُم مِّنَ ٱلْقُرُونِ أَنَّهُمْ إِلَيْهِمْ لَا يَرْجِعُونَ',
		number_in_surah: '31',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3737',
		number: '3737',
		text: 'وَإِن كُلٌّۭ لَّمَّا جَمِيعٌۭ لَّدَيْنَا مُحْضَرُونَ',
		number_in_surah: '32',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3738',
		number: '3738',
		text: 'وَءَايَةٌۭ لَّهُمُ ٱلْأَرْضُ ٱلْمَيْتَةُ أَحْيَيْنَٰهَا وَأَخْرَجْنَا مِنْهَا حَبًّۭا فَمِنْهُ يَأْكُلُونَ',
		number_in_surah: '33',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3739',
		number: '3739',
		text: 'وَجَعَلْنَا فِيهَا جَنَّٰتٍۢ مِّن نَّخِيلٍۢ وَأَعْنَٰبٍۢ وَفَجَّرْنَا فِيهَا مِنَ ٱلْعُيُونِ',
		number_in_surah: '34',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3740',
		number: '3740',
		text: 'لِيَأْكُلُوا۟ مِن ثَمَرِهِۦ وَمَا عَمِلَتْهُ أَيْدِيهِمْ ۖ أَفَلَا يَشْكُرُونَ',
		number_in_surah: '35',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3741',
		number: '3741',
		text: 'سُبْحَٰنَ ٱلَّذِى خَلَقَ ٱلْأَزْوَٰجَ كُلَّهَا مِمَّا تُنۢبِتُ ٱلْأَرْضُ وَمِنْ أَنفُسِهِمْ وَمِمَّا لَا يَعْلَمُونَ',
		number_in_surah: '36',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3742',
		number: '3742',
		text: 'وَءَايَةٌۭ لَّهُمُ ٱلَّيْلُ نَسْلَخُ مِنْهُ ٱلنَّهَارَ فَإِذَا هُم مُّظْلِمُونَ',
		number_in_surah: '37',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3743',
		number: '3743',
		text: 'وَٱلشَّمْسُ تَجْرِى لِمُسْتَقَرٍّۢ لَّهَا ۚ ذَٰلِكَ تَقْدِيرُ ٱلْعَزِيزِ ٱلْعَلِيمِ',
		number_in_surah: '38',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3744',
		number: '3744',
		text: 'وَٱلْقَمَرَ قَدَّرْنَٰهُ مَنَازِلَ حَتَّىٰ عَادَ كَٱلْعُرْجُونِ ٱلْقَدِيمِ',
		number_in_surah: '39',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3745',
		number: '3745',
		text: 'لَا ٱلشَّمْسُ يَنۢبَغِى لَهَآ أَن تُدْرِكَ ٱلْقَمَرَ وَلَا ٱلَّيْلُ سَابِقُ ٱلنَّهَارِ ۚ وَكُلٌّۭ فِى فَلَكٍۢ يَسْبَحُونَ',
		number_in_surah: '40',
		page: '442',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3746',
		number: '3746',
		text: 'وَءَايَةٌۭ لَّهُمْ أَنَّا حَمَلْنَا ذُرِّيَّتَهُمْ فِى ٱلْفُلْكِ ٱلْمَشْحُونِ',
		number_in_surah: '41',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3747',
		number: '3747',
		text: 'وَخَلَقْنَا لَهُم مِّن مِّثْلِهِۦ مَا يَرْكَبُونَ',
		number_in_surah: '42',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3748',
		number: '3748',
		text: 'وَإِن نَّشَأْ نُغْرِقْهُمْ فَلَا صَرِيخَ لَهُمْ وَلَا هُمْ يُنقَذُونَ',
		number_in_surah: '43',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3749',
		number: '3749',
		text: 'إِلَّا رَحْمَةًۭ مِّنَّا وَمَتَٰعًا إِلَىٰ حِينٍۢ',
		number_in_surah: '44',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3750',
		number: '3750',
		text: 'وَإِذَا قِيلَ لَهُمُ ٱتَّقُوا۟ مَا بَيْنَ أَيْدِيكُمْ وَمَا خَلْفَكُمْ لَعَلَّكُمْ تُرْحَمُونَ',
		number_in_surah: '45',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3751',
		number: '3751',
		text: 'وَمَا تَأْتِيهِم مِّنْ ءَايَةٍۢ مِّنْ ءَايَٰتِ رَبِّهِمْ إِلَّا كَانُوا۟ عَنْهَا مُعْرِضِينَ',
		number_in_surah: '46',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3752',
		number: '3752',
		text: 'وَإِذَا قِيلَ لَهُمْ أَنفِقُوا۟ مِمَّا رَزَقَكُمُ ٱللَّهُ قَالَ ٱلَّذِينَ كَفَرُوا۟ لِلَّذِينَ ءَامَنُوٓا۟ أَنُطْعِمُ مَن لَّوْ يَشَآءُ ٱللَّهُ أَطْعَمَهُۥٓ إِنْ أَنتُمْ إِلَّا فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '47',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3753',
		number: '3753',
		text: 'وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلْوَعْدُ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '48',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3754',
		number: '3754',
		text: 'مَا يَنظُرُونَ إِلَّا صَيْحَةًۭ وَٰحِدَةًۭ تَأْخُذُهُمْ وَهُمْ يَخِصِّمُونَ',
		number_in_surah: '49',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3755',
		number: '3755',
		text: 'فَلَا يَسْتَطِيعُونَ تَوْصِيَةًۭ وَلَآ إِلَىٰٓ أَهْلِهِمْ يَرْجِعُونَ',
		number_in_surah: '50',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3756',
		number: '3756',
		text: 'وَنُفِخَ فِى ٱلصُّورِ فَإِذَا هُم مِّنَ ٱلْأَجْدَاثِ إِلَىٰ رَبِّهِمْ يَنسِلُونَ',
		number_in_surah: '51',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3757',
		number: '3757',
		text: 'قَالُوا۟ يَٰوَيْلَنَا مَنۢ بَعَثَنَا مِن مَّرْقَدِنَا ۜ ۗ هَٰذَا مَا وَعَدَ ٱلرَّحْمَٰنُ وَصَدَقَ ٱلْمُرْسَلُونَ',
		number_in_surah: '52',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3758',
		number: '3758',
		text: 'إِن كَانَتْ إِلَّا صَيْحَةًۭ وَٰحِدَةًۭ فَإِذَا هُمْ جَمِيعٌۭ لَّدَيْنَا مُحْضَرُونَ',
		number_in_surah: '53',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3759',
		number: '3759',
		text: 'فَٱلْيَوْمَ لَا تُظْلَمُ نَفْسٌۭ شَيْـًۭٔا وَلَا تُجْزَوْنَ إِلَّا مَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '54',
		page: '443',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3760',
		number: '3760',
		text: 'إِنَّ أَصْحَٰبَ ٱلْجَنَّةِ ٱلْيَوْمَ فِى شُغُلٍۢ فَٰكِهُونَ',
		number_in_surah: '55',
		page: '444',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3761',
		number: '3761',
		text: 'هُمْ وَأَزْوَٰجُهُمْ فِى ظِلَٰلٍ عَلَى ٱلْأَرَآئِكِ مُتَّكِـُٔونَ',
		number_in_surah: '56',
		page: '444',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3762',
		number: '3762',
		text: 'لَهُمْ فِيهَا فَٰكِهَةٌۭ وَلَهُم مَّا يَدَّعُونَ',
		number_in_surah: '57',
		page: '444',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3763',
		number: '3763',
		text: 'سَلَٰمٌۭ قَوْلًۭا مِّن رَّبٍّۢ رَّحِيمٍۢ',
		number_in_surah: '58',
		page: '444',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3764',
		number: '3764',
		text: 'وَٱمْتَٰزُوا۟ ٱلْيَوْمَ أَيُّهَا ٱلْمُجْرِمُونَ',
		number_in_surah: '59',
		page: '444',
		surah_id: '36',
		hizb_id: '177',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3765',
		number: '3765',
		text: '۞ أَلَمْ أَعْهَدْ إِلَيْكُمْ يَٰبَنِىٓ ءَادَمَ أَن لَّا تَعْبُدُوا۟ ٱلشَّيْطَٰنَ ۖ إِنَّهُۥ لَكُمْ عَدُوٌّۭ مُّبِينٌۭ',
		number_in_surah: '60',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3766',
		number: '3766',
		text: 'وَأَنِ ٱعْبُدُونِى ۚ هَٰذَا صِرَٰطٌۭ مُّسْتَقِيمٌۭ',
		number_in_surah: '61',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3767',
		number: '3767',
		text: 'وَلَقَدْ أَضَلَّ مِنكُمْ جِبِلًّۭا كَثِيرًا ۖ أَفَلَمْ تَكُونُوا۟ تَعْقِلُونَ',
		number_in_surah: '62',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3768',
		number: '3768',
		text: 'هَٰذِهِۦ جَهَنَّمُ ٱلَّتِى كُنتُمْ تُوعَدُونَ',
		number_in_surah: '63',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3769',
		number: '3769',
		text: 'ٱصْلَوْهَا ٱلْيَوْمَ بِمَا كُنتُمْ تَكْفُرُونَ',
		number_in_surah: '64',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3770',
		number: '3770',
		text: 'ٱلْيَوْمَ نَخْتِمُ عَلَىٰٓ أَفْوَٰهِهِمْ وَتُكَلِّمُنَآ أَيْدِيهِمْ وَتَشْهَدُ أَرْجُلُهُم بِمَا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '65',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3771',
		number: '3771',
		text: 'وَلَوْ نَشَآءُ لَطَمَسْنَا عَلَىٰٓ أَعْيُنِهِمْ فَٱسْتَبَقُوا۟ ٱلصِّرَٰطَ فَأَنَّىٰ يُبْصِرُونَ',
		number_in_surah: '66',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3772',
		number: '3772',
		text: 'وَلَوْ نَشَآءُ لَمَسَخْنَٰهُمْ عَلَىٰ مَكَانَتِهِمْ فَمَا ٱسْتَطَٰعُوا۟ مُضِيًّۭا وَلَا يَرْجِعُونَ',
		number_in_surah: '67',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3773',
		number: '3773',
		text: 'وَمَن نُّعَمِّرْهُ نُنَكِّسْهُ فِى ٱلْخَلْقِ ۖ أَفَلَا يَعْقِلُونَ',
		number_in_surah: '68',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3774',
		number: '3774',
		text: 'وَمَا عَلَّمْنَٰهُ ٱلشِّعْرَ وَمَا يَنۢبَغِى لَهُۥٓ ۚ إِنْ هُوَ إِلَّا ذِكْرٌۭ وَقُرْءَانٌۭ مُّبِينٌۭ',
		number_in_surah: '69',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3775',
		number: '3775',
		text: 'لِّيُنذِرَ مَن كَانَ حَيًّۭا وَيَحِقَّ ٱلْقَوْلُ عَلَى ٱلْكَٰفِرِينَ',
		number_in_surah: '70',
		page: '444',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3776',
		number: '3776',
		text: 'أَوَلَمْ يَرَوْا۟ أَنَّا خَلَقْنَا لَهُم مِّمَّا عَمِلَتْ أَيْدِينَآ أَنْعَٰمًۭا فَهُمْ لَهَا مَٰلِكُونَ',
		number_in_surah: '71',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3777',
		number: '3777',
		text: 'وَذَلَّلْنَٰهَا لَهُمْ فَمِنْهَا رَكُوبُهُمْ وَمِنْهَا يَأْكُلُونَ',
		number_in_surah: '72',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3778',
		number: '3778',
		text: 'وَلَهُمْ فِيهَا مَنَٰفِعُ وَمَشَارِبُ ۖ أَفَلَا يَشْكُرُونَ',
		number_in_surah: '73',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3779',
		number: '3779',
		text: 'وَٱتَّخَذُوا۟ مِن دُونِ ٱللَّهِ ءَالِهَةًۭ لَّعَلَّهُمْ يُنصَرُونَ',
		number_in_surah: '74',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3780',
		number: '3780',
		text: 'لَا يَسْتَطِيعُونَ نَصْرَهُمْ وَهُمْ لَهُمْ جُندٌۭ مُّحْضَرُونَ',
		number_in_surah: '75',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3781',
		number: '3781',
		text: 'فَلَا يَحْزُنكَ قَوْلُهُمْ ۘ إِنَّا نَعْلَمُ مَا يُسِرُّونَ وَمَا يُعْلِنُونَ',
		number_in_surah: '76',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3782',
		number: '3782',
		text: 'أَوَلَمْ يَرَ ٱلْإِنسَٰنُ أَنَّا خَلَقْنَٰهُ مِن نُّطْفَةٍۢ فَإِذَا هُوَ خَصِيمٌۭ مُّبِينٌۭ',
		number_in_surah: '77',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3783',
		number: '3783',
		text: 'وَضَرَبَ لَنَا مَثَلًۭا وَنَسِىَ خَلْقَهُۥ ۖ قَالَ مَن يُحْىِ ٱلْعِظَٰمَ وَهِىَ رَمِيمٌۭ',
		number_in_surah: '78',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3784',
		number: '3784',
		text: 'قُلْ يُحْيِيهَا ٱلَّذِىٓ أَنشَأَهَآ أَوَّلَ مَرَّةٍۢ ۖ وَهُوَ بِكُلِّ خَلْقٍ عَلِيمٌ',
		number_in_surah: '79',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3785',
		number: '3785',
		text: 'ٱلَّذِى جَعَلَ لَكُم مِّنَ ٱلشَّجَرِ ٱلْأَخْضَرِ نَارًۭا فَإِذَآ أَنتُم مِّنْهُ تُوقِدُونَ',
		number_in_surah: '80',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3786',
		number: '3786',
		text: 'أَوَلَيْسَ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ بِقَٰدِرٍ عَلَىٰٓ أَن يَخْلُقَ مِثْلَهُم ۚ بَلَىٰ وَهُوَ ٱلْخَلَّٰقُ ٱلْعَلِيمُ',
		number_in_surah: '81',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3787',
		number: '3787',
		text: 'إِنَّمَآ أَمْرُهُۥٓ إِذَآ أَرَادَ شَيْـًٔا أَن يَقُولَ لَهُۥ كُن فَيَكُونُ',
		number_in_surah: '82',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3788',
		number: '3788',
		text: 'فَسُبْحَٰنَ ٱلَّذِى بِيَدِهِۦ مَلَكُوتُ كُلِّ شَىْءٍۢ وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '83',
		page: '445',
		surah_id: '36',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3789',
		number: '3789',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلصَّٰٓفَّٰتِ صَفًّۭا',
		number_in_surah: '1',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3790',
		number: '3790',
		text: 'فَٱلزَّٰجِرَٰتِ زَجْرًۭا',
		number_in_surah: '2',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3791',
		number: '3791',
		text: 'فَٱلتَّٰلِيَٰتِ ذِكْرًا',
		number_in_surah: '3',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3792',
		number: '3792',
		text: 'إِنَّ إِلَٰهَكُمْ لَوَٰحِدٌۭ',
		number_in_surah: '4',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3793',
		number: '3793',
		text: 'رَّبُّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَا وَرَبُّ ٱلْمَشَٰرِقِ',
		number_in_surah: '5',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3794',
		number: '3794',
		text: 'إِنَّا زَيَّنَّا ٱلسَّمَآءَ ٱلدُّنْيَا بِزِينَةٍ ٱلْكَوَاكِبِ',
		number_in_surah: '6',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3795',
		number: '3795',
		text: 'وَحِفْظًۭا مِّن كُلِّ شَيْطَٰنٍۢ مَّارِدٍۢ',
		number_in_surah: '7',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3796',
		number: '3796',
		text: 'لَّا يَسَّمَّعُونَ إِلَى ٱلْمَلَإِ ٱلْأَعْلَىٰ وَيُقْذَفُونَ مِن كُلِّ جَانِبٍۢ',
		number_in_surah: '8',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3797',
		number: '3797',
		text: 'دُحُورًۭا ۖ وَلَهُمْ عَذَابٌۭ وَاصِبٌ',
		number_in_surah: '9',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3798',
		number: '3798',
		text: 'إِلَّا مَنْ خَطِفَ ٱلْخَطْفَةَ فَأَتْبَعَهُۥ شِهَابٌۭ ثَاقِبٌۭ',
		number_in_surah: '10',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3799',
		number: '3799',
		text: 'فَٱسْتَفْتِهِمْ أَهُمْ أَشَدُّ خَلْقًا أَم مَّنْ خَلَقْنَآ ۚ إِنَّا خَلَقْنَٰهُم مِّن طِينٍۢ لَّازِبٍۭ',
		number_in_surah: '11',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3800',
		number: '3800',
		text: 'بَلْ عَجِبْتَ وَيَسْخَرُونَ',
		number_in_surah: '12',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3801',
		number: '3801',
		text: 'وَإِذَا ذُكِّرُوا۟ لَا يَذْكُرُونَ',
		number_in_surah: '13',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3802',
		number: '3802',
		text: 'وَإِذَا رَأَوْا۟ ءَايَةًۭ يَسْتَسْخِرُونَ',
		number_in_surah: '14',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3803',
		number: '3803',
		text: 'وَقَالُوٓا۟ إِنْ هَٰذَآ إِلَّا سِحْرٌۭ مُّبِينٌ',
		number_in_surah: '15',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3804',
		number: '3804',
		text: 'أَءِذَا مِتْنَا وَكُنَّا تُرَابًۭا وَعِظَٰمًا أَءِنَّا لَمَبْعُوثُونَ',
		number_in_surah: '16',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3805',
		number: '3805',
		text: 'أَوَءَابَآؤُنَا ٱلْأَوَّلُونَ',
		number_in_surah: '17',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3806',
		number: '3806',
		text: 'قُلْ نَعَمْ وَأَنتُمْ دَٰخِرُونَ',
		number_in_surah: '18',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3807',
		number: '3807',
		text: 'فَإِنَّمَا هِىَ زَجْرَةٌۭ وَٰحِدَةٌۭ فَإِذَا هُمْ يَنظُرُونَ',
		number_in_surah: '19',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3808',
		number: '3808',
		text: 'وَقَالُوا۟ يَٰوَيْلَنَا هَٰذَا يَوْمُ ٱلدِّينِ',
		number_in_surah: '20',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3809',
		number: '3809',
		text: 'هَٰذَا يَوْمُ ٱلْفَصْلِ ٱلَّذِى كُنتُم بِهِۦ تُكَذِّبُونَ',
		number_in_surah: '21',
		page: '446',
		surah_id: '37',
		hizb_id: '178',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3810',
		number: '3810',
		text: '۞ ٱحْشُرُوا۟ ٱلَّذِينَ ظَلَمُوا۟ وَأَزْوَٰجَهُمْ وَمَا كَانُوا۟ يَعْبُدُونَ',
		number_in_surah: '22',
		page: '446',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3811',
		number: '3811',
		text: 'مِن دُونِ ٱللَّهِ فَٱهْدُوهُمْ إِلَىٰ صِرَٰطِ ٱلْجَحِيمِ',
		number_in_surah: '23',
		page: '446',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3812',
		number: '3812',
		text: 'وَقِفُوهُمْ ۖ إِنَّهُم مَّسْـُٔولُونَ',
		number_in_surah: '24',
		page: '446',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3813',
		number: '3813',
		text: 'مَا لَكُمْ لَا تَنَاصَرُونَ',
		number_in_surah: '25',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3814',
		number: '3814',
		text: 'بَلْ هُمُ ٱلْيَوْمَ مُسْتَسْلِمُونَ',
		number_in_surah: '26',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3815',
		number: '3815',
		text: 'وَأَقْبَلَ بَعْضُهُمْ عَلَىٰ بَعْضٍۢ يَتَسَآءَلُونَ',
		number_in_surah: '27',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3816',
		number: '3816',
		text: 'قَالُوٓا۟ إِنَّكُمْ كُنتُمْ تَأْتُونَنَا عَنِ ٱلْيَمِينِ',
		number_in_surah: '28',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3817',
		number: '3817',
		text: 'قَالُوا۟ بَل لَّمْ تَكُونُوا۟ مُؤْمِنِينَ',
		number_in_surah: '29',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3818',
		number: '3818',
		text: 'وَمَا كَانَ لَنَا عَلَيْكُم مِّن سُلْطَٰنٍۭ ۖ بَلْ كُنتُمْ قَوْمًۭا طَٰغِينَ',
		number_in_surah: '30',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3819',
		number: '3819',
		text: 'فَحَقَّ عَلَيْنَا قَوْلُ رَبِّنَآ ۖ إِنَّا لَذَآئِقُونَ',
		number_in_surah: '31',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3820',
		number: '3820',
		text: 'فَأَغْوَيْنَٰكُمْ إِنَّا كُنَّا غَٰوِينَ',
		number_in_surah: '32',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3821',
		number: '3821',
		text: 'فَإِنَّهُمْ يَوْمَئِذٍۢ فِى ٱلْعَذَابِ مُشْتَرِكُونَ',
		number_in_surah: '33',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3822',
		number: '3822',
		text: 'إِنَّا كَذَٰلِكَ نَفْعَلُ بِٱلْمُجْرِمِينَ',
		number_in_surah: '34',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3823',
		number: '3823',
		text: 'إِنَّهُمْ كَانُوٓا۟ إِذَا قِيلَ لَهُمْ لَآ إِلَٰهَ إِلَّا ٱللَّهُ يَسْتَكْبِرُونَ',
		number_in_surah: '35',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3824',
		number: '3824',
		text: 'وَيَقُولُونَ أَئِنَّا لَتَارِكُوٓا۟ ءَالِهَتِنَا لِشَاعِرٍۢ مَّجْنُونٍۭ',
		number_in_surah: '36',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3825',
		number: '3825',
		text: 'بَلْ جَآءَ بِٱلْحَقِّ وَصَدَّقَ ٱلْمُرْسَلِينَ',
		number_in_surah: '37',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3826',
		number: '3826',
		text: 'إِنَّكُمْ لَذَآئِقُوا۟ ٱلْعَذَابِ ٱلْأَلِيمِ',
		number_in_surah: '38',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3827',
		number: '3827',
		text: 'وَمَا تُجْزَوْنَ إِلَّا مَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '39',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3828',
		number: '3828',
		text: 'إِلَّا عِبَادَ ٱللَّهِ ٱلْمُخْلَصِينَ',
		number_in_surah: '40',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3829',
		number: '3829',
		text: 'أُو۟لَٰٓئِكَ لَهُمْ رِزْقٌۭ مَّعْلُومٌۭ',
		number_in_surah: '41',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3830',
		number: '3830',
		text: 'فَوَٰكِهُ ۖ وَهُم مُّكْرَمُونَ',
		number_in_surah: '42',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3831',
		number: '3831',
		text: 'فِى جَنَّٰتِ ٱلنَّعِيمِ',
		number_in_surah: '43',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3832',
		number: '3832',
		text: 'عَلَىٰ سُرُرٍۢ مُّتَقَٰبِلِينَ',
		number_in_surah: '44',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3833',
		number: '3833',
		text: 'يُطَافُ عَلَيْهِم بِكَأْسٍۢ مِّن مَّعِينٍۭ',
		number_in_surah: '45',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3834',
		number: '3834',
		text: 'بَيْضَآءَ لَذَّةٍۢ لِّلشَّٰرِبِينَ',
		number_in_surah: '46',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3835',
		number: '3835',
		text: 'لَا فِيهَا غَوْلٌۭ وَلَا هُمْ عَنْهَا يُنزَفُونَ',
		number_in_surah: '47',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3836',
		number: '3836',
		text: 'وَعِندَهُمْ قَٰصِرَٰتُ ٱلطَّرْفِ عِينٌۭ',
		number_in_surah: '48',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3837',
		number: '3837',
		text: 'كَأَنَّهُنَّ بَيْضٌۭ مَّكْنُونٌۭ',
		number_in_surah: '49',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3838',
		number: '3838',
		text: 'فَأَقْبَلَ بَعْضُهُمْ عَلَىٰ بَعْضٍۢ يَتَسَآءَلُونَ',
		number_in_surah: '50',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3839',
		number: '3839',
		text: 'قَالَ قَآئِلٌۭ مِّنْهُمْ إِنِّى كَانَ لِى قَرِينٌۭ',
		number_in_surah: '51',
		page: '447',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3840',
		number: '3840',
		text: 'يَقُولُ أَءِنَّكَ لَمِنَ ٱلْمُصَدِّقِينَ',
		number_in_surah: '52',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3841',
		number: '3841',
		text: 'أَءِذَا مِتْنَا وَكُنَّا تُرَابًۭا وَعِظَٰمًا أَءِنَّا لَمَدِينُونَ',
		number_in_surah: '53',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3842',
		number: '3842',
		text: 'قَالَ هَلْ أَنتُم مُّطَّلِعُونَ',
		number_in_surah: '54',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3843',
		number: '3843',
		text: 'فَٱطَّلَعَ فَرَءَاهُ فِى سَوَآءِ ٱلْجَحِيمِ',
		number_in_surah: '55',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3844',
		number: '3844',
		text: 'قَالَ تَٱللَّهِ إِن كِدتَّ لَتُرْدِينِ',
		number_in_surah: '56',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3845',
		number: '3845',
		text: 'وَلَوْلَا نِعْمَةُ رَبِّى لَكُنتُ مِنَ ٱلْمُحْضَرِينَ',
		number_in_surah: '57',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3846',
		number: '3846',
		text: 'أَفَمَا نَحْنُ بِمَيِّتِينَ',
		number_in_surah: '58',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3847',
		number: '3847',
		text: 'إِلَّا مَوْتَتَنَا ٱلْأُولَىٰ وَمَا نَحْنُ بِمُعَذَّبِينَ',
		number_in_surah: '59',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3848',
		number: '3848',
		text: 'إِنَّ هَٰذَا لَهُوَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '60',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3849',
		number: '3849',
		text: 'لِمِثْلِ هَٰذَا فَلْيَعْمَلِ ٱلْعَٰمِلُونَ',
		number_in_surah: '61',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3850',
		number: '3850',
		text: 'أَذَٰلِكَ خَيْرٌۭ نُّزُلًا أَمْ شَجَرَةُ ٱلزَّقُّومِ',
		number_in_surah: '62',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3851',
		number: '3851',
		text: 'إِنَّا جَعَلْنَٰهَا فِتْنَةًۭ لِّلظَّٰلِمِينَ',
		number_in_surah: '63',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3852',
		number: '3852',
		text: 'إِنَّهَا شَجَرَةٌۭ تَخْرُجُ فِىٓ أَصْلِ ٱلْجَحِيمِ',
		number_in_surah: '64',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3853',
		number: '3853',
		text: 'طَلْعُهَا كَأَنَّهُۥ رُءُوسُ ٱلشَّيَٰطِينِ',
		number_in_surah: '65',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3854',
		number: '3854',
		text: 'فَإِنَّهُمْ لَءَاكِلُونَ مِنْهَا فَمَالِـُٔونَ مِنْهَا ٱلْبُطُونَ',
		number_in_surah: '66',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3855',
		number: '3855',
		text: 'ثُمَّ إِنَّ لَهُمْ عَلَيْهَا لَشَوْبًۭا مِّنْ حَمِيمٍۢ',
		number_in_surah: '67',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3856',
		number: '3856',
		text: 'ثُمَّ إِنَّ مَرْجِعَهُمْ لَإِلَى ٱلْجَحِيمِ',
		number_in_surah: '68',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3857',
		number: '3857',
		text: 'إِنَّهُمْ أَلْفَوْا۟ ءَابَآءَهُمْ ضَآلِّينَ',
		number_in_surah: '69',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3858',
		number: '3858',
		text: 'فَهُمْ عَلَىٰٓ ءَاثَٰرِهِمْ يُهْرَعُونَ',
		number_in_surah: '70',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3859',
		number: '3859',
		text: 'وَلَقَدْ ضَلَّ قَبْلَهُمْ أَكْثَرُ ٱلْأَوَّلِينَ',
		number_in_surah: '71',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3860',
		number: '3860',
		text: 'وَلَقَدْ أَرْسَلْنَا فِيهِم مُّنذِرِينَ',
		number_in_surah: '72',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3861',
		number: '3861',
		text: 'فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُنذَرِينَ',
		number_in_surah: '73',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3862',
		number: '3862',
		text: 'إِلَّا عِبَادَ ٱللَّهِ ٱلْمُخْلَصِينَ',
		number_in_surah: '74',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3863',
		number: '3863',
		text: 'وَلَقَدْ نَادَىٰنَا نُوحٌۭ فَلَنِعْمَ ٱلْمُجِيبُونَ',
		number_in_surah: '75',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3864',
		number: '3864',
		text: 'وَنَجَّيْنَٰهُ وَأَهْلَهُۥ مِنَ ٱلْكَرْبِ ٱلْعَظِيمِ',
		number_in_surah: '76',
		page: '448',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3865',
		number: '3865',
		text: 'وَجَعَلْنَا ذُرِّيَّتَهُۥ هُمُ ٱلْبَاقِينَ',
		number_in_surah: '77',
		page: '449',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3866',
		number: '3866',
		text: 'وَتَرَكْنَا عَلَيْهِ فِى ٱلْءَاخِرِينَ',
		number_in_surah: '78',
		page: '449',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3867',
		number: '3867',
		text: 'سَلَٰمٌ عَلَىٰ نُوحٍۢ فِى ٱلْعَٰلَمِينَ',
		number_in_surah: '79',
		page: '449',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3868',
		number: '3868',
		text: 'إِنَّا كَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '80',
		page: '449',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3869',
		number: '3869',
		text: 'إِنَّهُۥ مِنْ عِبَادِنَا ٱلْمُؤْمِنِينَ',
		number_in_surah: '81',
		page: '449',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3870',
		number: '3870',
		text: 'ثُمَّ أَغْرَقْنَا ٱلْءَاخَرِينَ',
		number_in_surah: '82',
		page: '449',
		surah_id: '37',
		hizb_id: '179',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3871',
		number: '3871',
		text: '۞ وَإِنَّ مِن شِيعَتِهِۦ لَإِبْرَٰهِيمَ',
		number_in_surah: '83',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3872',
		number: '3872',
		text: 'إِذْ جَآءَ رَبَّهُۥ بِقَلْبٍۢ سَلِيمٍ',
		number_in_surah: '84',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3873',
		number: '3873',
		text: 'إِذْ قَالَ لِأَبِيهِ وَقَوْمِهِۦ مَاذَا تَعْبُدُونَ',
		number_in_surah: '85',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3874',
		number: '3874',
		text: 'أَئِفْكًا ءَالِهَةًۭ دُونَ ٱللَّهِ تُرِيدُونَ',
		number_in_surah: '86',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3875',
		number: '3875',
		text: 'فَمَا ظَنُّكُم بِرَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '87',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3876',
		number: '3876',
		text: 'فَنَظَرَ نَظْرَةًۭ فِى ٱلنُّجُومِ',
		number_in_surah: '88',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3877',
		number: '3877',
		text: 'فَقَالَ إِنِّى سَقِيمٌۭ',
		number_in_surah: '89',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3878',
		number: '3878',
		text: 'فَتَوَلَّوْا۟ عَنْهُ مُدْبِرِينَ',
		number_in_surah: '90',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3879',
		number: '3879',
		text: 'فَرَاغَ إِلَىٰٓ ءَالِهَتِهِمْ فَقَالَ أَلَا تَأْكُلُونَ',
		number_in_surah: '91',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3880',
		number: '3880',
		text: 'مَا لَكُمْ لَا تَنطِقُونَ',
		number_in_surah: '92',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3881',
		number: '3881',
		text: 'فَرَاغَ عَلَيْهِمْ ضَرْبًۢا بِٱلْيَمِينِ',
		number_in_surah: '93',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3882',
		number: '3882',
		text: 'فَأَقْبَلُوٓا۟ إِلَيْهِ يَزِفُّونَ',
		number_in_surah: '94',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3883',
		number: '3883',
		text: 'قَالَ أَتَعْبُدُونَ مَا تَنْحِتُونَ',
		number_in_surah: '95',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3884',
		number: '3884',
		text: 'وَٱللَّهُ خَلَقَكُمْ وَمَا تَعْمَلُونَ',
		number_in_surah: '96',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3885',
		number: '3885',
		text: 'قَالُوا۟ ٱبْنُوا۟ لَهُۥ بُنْيَٰنًۭا فَأَلْقُوهُ فِى ٱلْجَحِيمِ',
		number_in_surah: '97',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3886',
		number: '3886',
		text: 'فَأَرَادُوا۟ بِهِۦ كَيْدًۭا فَجَعَلْنَٰهُمُ ٱلْأَسْفَلِينَ',
		number_in_surah: '98',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3887',
		number: '3887',
		text: 'وَقَالَ إِنِّى ذَاهِبٌ إِلَىٰ رَبِّى سَيَهْدِينِ',
		number_in_surah: '99',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3888',
		number: '3888',
		text: 'رَبِّ هَبْ لِى مِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '100',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3889',
		number: '3889',
		text: 'فَبَشَّرْنَٰهُ بِغُلَٰمٍ حَلِيمٍۢ',
		number_in_surah: '101',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3890',
		number: '3890',
		text: 'فَلَمَّا بَلَغَ مَعَهُ ٱلسَّعْىَ قَالَ يَٰبُنَىَّ إِنِّىٓ أَرَىٰ فِى ٱلْمَنَامِ أَنِّىٓ أَذْبَحُكَ فَٱنظُرْ مَاذَا تَرَىٰ ۚ قَالَ يَٰٓأَبَتِ ٱفْعَلْ مَا تُؤْمَرُ ۖ سَتَجِدُنِىٓ إِن شَآءَ ٱللَّهُ مِنَ ٱلصَّٰبِرِينَ',
		number_in_surah: '102',
		page: '449',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3891',
		number: '3891',
		text: 'فَلَمَّآ أَسْلَمَا وَتَلَّهُۥ لِلْجَبِينِ',
		number_in_surah: '103',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3892',
		number: '3892',
		text: 'وَنَٰدَيْنَٰهُ أَن يَٰٓإِبْرَٰهِيمُ',
		number_in_surah: '104',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3893',
		number: '3893',
		text: 'قَدْ صَدَّقْتَ ٱلرُّءْيَآ ۚ إِنَّا كَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '105',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3894',
		number: '3894',
		text: 'إِنَّ هَٰذَا لَهُوَ ٱلْبَلَٰٓؤُا۟ ٱلْمُبِينُ',
		number_in_surah: '106',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3895',
		number: '3895',
		text: 'وَفَدَيْنَٰهُ بِذِبْحٍ عَظِيمٍۢ',
		number_in_surah: '107',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3896',
		number: '3896',
		text: 'وَتَرَكْنَا عَلَيْهِ فِى ٱلْءَاخِرِينَ',
		number_in_surah: '108',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3897',
		number: '3897',
		text: 'سَلَٰمٌ عَلَىٰٓ إِبْرَٰهِيمَ',
		number_in_surah: '109',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3898',
		number: '3898',
		text: 'كَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '110',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3899',
		number: '3899',
		text: 'إِنَّهُۥ مِنْ عِبَادِنَا ٱلْمُؤْمِنِينَ',
		number_in_surah: '111',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3900',
		number: '3900',
		text: 'وَبَشَّرْنَٰهُ بِإِسْحَٰقَ نَبِيًّۭا مِّنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '112',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:08',
		updated_at: '2018-06-07 08:07:08',
	},
	{
		id: '3901',
		number: '3901',
		text: 'وَبَٰرَكْنَا عَلَيْهِ وَعَلَىٰٓ إِسْحَٰقَ ۚ وَمِن ذُرِّيَّتِهِمَا مُحْسِنٌۭ وَظَالِمٌۭ لِّنَفْسِهِۦ مُبِينٌۭ',
		number_in_surah: '113',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3902',
		number: '3902',
		text: 'وَلَقَدْ مَنَنَّا عَلَىٰ مُوسَىٰ وَهَٰرُونَ',
		number_in_surah: '114',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3903',
		number: '3903',
		text: 'وَنَجَّيْنَٰهُمَا وَقَوْمَهُمَا مِنَ ٱلْكَرْبِ ٱلْعَظِيمِ',
		number_in_surah: '115',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3904',
		number: '3904',
		text: 'وَنَصَرْنَٰهُمْ فَكَانُوا۟ هُمُ ٱلْغَٰلِبِينَ',
		number_in_surah: '116',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3905',
		number: '3905',
		text: 'وَءَاتَيْنَٰهُمَا ٱلْكِتَٰبَ ٱلْمُسْتَبِينَ',
		number_in_surah: '117',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3906',
		number: '3906',
		text: 'وَهَدَيْنَٰهُمَا ٱلصِّرَٰطَ ٱلْمُسْتَقِيمَ',
		number_in_surah: '118',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3907',
		number: '3907',
		text: 'وَتَرَكْنَا عَلَيْهِمَا فِى ٱلْءَاخِرِينَ',
		number_in_surah: '119',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3908',
		number: '3908',
		text: 'سَلَٰمٌ عَلَىٰ مُوسَىٰ وَهَٰرُونَ',
		number_in_surah: '120',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3909',
		number: '3909',
		text: 'إِنَّا كَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '121',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3910',
		number: '3910',
		text: 'إِنَّهُمَا مِنْ عِبَادِنَا ٱلْمُؤْمِنِينَ',
		number_in_surah: '122',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3911',
		number: '3911',
		text: 'وَإِنَّ إِلْيَاسَ لَمِنَ ٱلْمُرْسَلِينَ',
		number_in_surah: '123',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3912',
		number: '3912',
		text: 'إِذْ قَالَ لِقَوْمِهِۦٓ أَلَا تَتَّقُونَ',
		number_in_surah: '124',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3913',
		number: '3913',
		text: 'أَتَدْعُونَ بَعْلًۭا وَتَذَرُونَ أَحْسَنَ ٱلْخَٰلِقِينَ',
		number_in_surah: '125',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3914',
		number: '3914',
		text: 'ٱللَّهَ رَبَّكُمْ وَرَبَّ ءَابَآئِكُمُ ٱلْأَوَّلِينَ',
		number_in_surah: '126',
		page: '450',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3915',
		number: '3915',
		text: 'فَكَذَّبُوهُ فَإِنَّهُمْ لَمُحْضَرُونَ',
		number_in_surah: '127',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3916',
		number: '3916',
		text: 'إِلَّا عِبَادَ ٱللَّهِ ٱلْمُخْلَصِينَ',
		number_in_surah: '128',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3917',
		number: '3917',
		text: 'وَتَرَكْنَا عَلَيْهِ فِى ٱلْءَاخِرِينَ',
		number_in_surah: '129',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3918',
		number: '3918',
		text: 'سَلَٰمٌ عَلَىٰٓ إِلْ يَاسِينَ',
		number_in_surah: '130',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3919',
		number: '3919',
		text: 'إِنَّا كَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '131',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3920',
		number: '3920',
		text: 'إِنَّهُۥ مِنْ عِبَادِنَا ٱلْمُؤْمِنِينَ',
		number_in_surah: '132',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3921',
		number: '3921',
		text: 'وَإِنَّ لُوطًۭا لَّمِنَ ٱلْمُرْسَلِينَ',
		number_in_surah: '133',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3922',
		number: '3922',
		text: 'إِذْ نَجَّيْنَٰهُ وَأَهْلَهُۥٓ أَجْمَعِينَ',
		number_in_surah: '134',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3923',
		number: '3923',
		text: 'إِلَّا عَجُوزًۭا فِى ٱلْغَٰبِرِينَ',
		number_in_surah: '135',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3924',
		number: '3924',
		text: 'ثُمَّ دَمَّرْنَا ٱلْءَاخَرِينَ',
		number_in_surah: '136',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3925',
		number: '3925',
		text: 'وَإِنَّكُمْ لَتَمُرُّونَ عَلَيْهِم مُّصْبِحِينَ',
		number_in_surah: '137',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3926',
		number: '3926',
		text: 'وَبِٱلَّيْلِ ۗ أَفَلَا تَعْقِلُونَ',
		number_in_surah: '138',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3927',
		number: '3927',
		text: 'وَإِنَّ يُونُسَ لَمِنَ ٱلْمُرْسَلِينَ',
		number_in_surah: '139',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3928',
		number: '3928',
		text: 'إِذْ أَبَقَ إِلَى ٱلْفُلْكِ ٱلْمَشْحُونِ',
		number_in_surah: '140',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3929',
		number: '3929',
		text: 'فَسَاهَمَ فَكَانَ مِنَ ٱلْمُدْحَضِينَ',
		number_in_surah: '141',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3930',
		number: '3930',
		text: 'فَٱلْتَقَمَهُ ٱلْحُوتُ وَهُوَ مُلِيمٌۭ',
		number_in_surah: '142',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3931',
		number: '3931',
		text: 'فَلَوْلَآ أَنَّهُۥ كَانَ مِنَ ٱلْمُسَبِّحِينَ',
		number_in_surah: '143',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3932',
		number: '3932',
		text: 'لَلَبِثَ فِى بَطْنِهِۦٓ إِلَىٰ يَوْمِ يُبْعَثُونَ',
		number_in_surah: '144',
		page: '451',
		surah_id: '37',
		hizb_id: '180',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3933',
		number: '3933',
		text: '۞ فَنَبَذْنَٰهُ بِٱلْعَرَآءِ وَهُوَ سَقِيمٌۭ',
		number_in_surah: '145',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3934',
		number: '3934',
		text: 'وَأَنۢبَتْنَا عَلَيْهِ شَجَرَةًۭ مِّن يَقْطِينٍۢ',
		number_in_surah: '146',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3935',
		number: '3935',
		text: 'وَأَرْسَلْنَٰهُ إِلَىٰ مِا۟ئَةِ أَلْفٍ أَوْ يَزِيدُونَ',
		number_in_surah: '147',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3936',
		number: '3936',
		text: 'فَـَٔامَنُوا۟ فَمَتَّعْنَٰهُمْ إِلَىٰ حِينٍۢ',
		number_in_surah: '148',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3937',
		number: '3937',
		text: 'فَٱسْتَفْتِهِمْ أَلِرَبِّكَ ٱلْبَنَاتُ وَلَهُمُ ٱلْبَنُونَ',
		number_in_surah: '149',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3938',
		number: '3938',
		text: 'أَمْ خَلَقْنَا ٱلْمَلَٰٓئِكَةَ إِنَٰثًۭا وَهُمْ شَٰهِدُونَ',
		number_in_surah: '150',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3939',
		number: '3939',
		text: 'أَلَآ إِنَّهُم مِّنْ إِفْكِهِمْ لَيَقُولُونَ',
		number_in_surah: '151',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3940',
		number: '3940',
		text: 'وَلَدَ ٱللَّهُ وَإِنَّهُمْ لَكَٰذِبُونَ',
		number_in_surah: '152',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3941',
		number: '3941',
		text: 'أَصْطَفَى ٱلْبَنَاتِ عَلَى ٱلْبَنِينَ',
		number_in_surah: '153',
		page: '451',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3942',
		number: '3942',
		text: 'مَا لَكُمْ كَيْفَ تَحْكُمُونَ',
		number_in_surah: '154',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3943',
		number: '3943',
		text: 'أَفَلَا تَذَكَّرُونَ',
		number_in_surah: '155',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3944',
		number: '3944',
		text: 'أَمْ لَكُمْ سُلْطَٰنٌۭ مُّبِينٌۭ',
		number_in_surah: '156',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3945',
		number: '3945',
		text: 'فَأْتُوا۟ بِكِتَٰبِكُمْ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '157',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3946',
		number: '3946',
		text: 'وَجَعَلُوا۟ بَيْنَهُۥ وَبَيْنَ ٱلْجِنَّةِ نَسَبًۭا ۚ وَلَقَدْ عَلِمَتِ ٱلْجِنَّةُ إِنَّهُمْ لَمُحْضَرُونَ',
		number_in_surah: '158',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3947',
		number: '3947',
		text: 'سُبْحَٰنَ ٱللَّهِ عَمَّا يَصِفُونَ',
		number_in_surah: '159',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3948',
		number: '3948',
		text: 'إِلَّا عِبَادَ ٱللَّهِ ٱلْمُخْلَصِينَ',
		number_in_surah: '160',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3949',
		number: '3949',
		text: 'فَإِنَّكُمْ وَمَا تَعْبُدُونَ',
		number_in_surah: '161',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3950',
		number: '3950',
		text: 'مَآ أَنتُمْ عَلَيْهِ بِفَٰتِنِينَ',
		number_in_surah: '162',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3951',
		number: '3951',
		text: 'إِلَّا مَنْ هُوَ صَالِ ٱلْجَحِيمِ',
		number_in_surah: '163',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3952',
		number: '3952',
		text: 'وَمَا مِنَّآ إِلَّا لَهُۥ مَقَامٌۭ مَّعْلُومٌۭ',
		number_in_surah: '164',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3953',
		number: '3953',
		text: 'وَإِنَّا لَنَحْنُ ٱلصَّآفُّونَ',
		number_in_surah: '165',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3954',
		number: '3954',
		text: 'وَإِنَّا لَنَحْنُ ٱلْمُسَبِّحُونَ',
		number_in_surah: '166',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3955',
		number: '3955',
		text: 'وَإِن كَانُوا۟ لَيَقُولُونَ',
		number_in_surah: '167',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3956',
		number: '3956',
		text: 'لَوْ أَنَّ عِندَنَا ذِكْرًۭا مِّنَ ٱلْأَوَّلِينَ',
		number_in_surah: '168',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3957',
		number: '3957',
		text: 'لَكُنَّا عِبَادَ ٱللَّهِ ٱلْمُخْلَصِينَ',
		number_in_surah: '169',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3958',
		number: '3958',
		text: 'فَكَفَرُوا۟ بِهِۦ ۖ فَسَوْفَ يَعْلَمُونَ',
		number_in_surah: '170',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3959',
		number: '3959',
		text: 'وَلَقَدْ سَبَقَتْ كَلِمَتُنَا لِعِبَادِنَا ٱلْمُرْسَلِينَ',
		number_in_surah: '171',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3960',
		number: '3960',
		text: 'إِنَّهُمْ لَهُمُ ٱلْمَنصُورُونَ',
		number_in_surah: '172',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3961',
		number: '3961',
		text: 'وَإِنَّ جُندَنَا لَهُمُ ٱلْغَٰلِبُونَ',
		number_in_surah: '173',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3962',
		number: '3962',
		text: 'فَتَوَلَّ عَنْهُمْ حَتَّىٰ حِينٍۢ',
		number_in_surah: '174',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3963',
		number: '3963',
		text: 'وَأَبْصِرْهُمْ فَسَوْفَ يُبْصِرُونَ',
		number_in_surah: '175',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3964',
		number: '3964',
		text: 'أَفَبِعَذَابِنَا يَسْتَعْجِلُونَ',
		number_in_surah: '176',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3965',
		number: '3965',
		text: 'فَإِذَا نَزَلَ بِسَاحَتِهِمْ فَسَآءَ صَبَاحُ ٱلْمُنذَرِينَ',
		number_in_surah: '177',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3966',
		number: '3966',
		text: 'وَتَوَلَّ عَنْهُمْ حَتَّىٰ حِينٍۢ',
		number_in_surah: '178',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3967',
		number: '3967',
		text: 'وَأَبْصِرْ فَسَوْفَ يُبْصِرُونَ',
		number_in_surah: '179',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3968',
		number: '3968',
		text: 'سُبْحَٰنَ رَبِّكَ رَبِّ ٱلْعِزَّةِ عَمَّا يَصِفُونَ',
		number_in_surah: '180',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3969',
		number: '3969',
		text: 'وَسَلَٰمٌ عَلَى ٱلْمُرْسَلِينَ',
		number_in_surah: '181',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3970',
		number: '3970',
		text: 'وَٱلْحَمْدُ لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '182',
		page: '452',
		surah_id: '37',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3971',
		number: '3971',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ صٓ ۚ وَٱلْقُرْءَانِ ذِى ٱلذِّكْرِ',
		number_in_surah: '1',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3972',
		number: '3972',
		text: 'بَلِ ٱلَّذِينَ كَفَرُوا۟ فِى عِزَّةٍۢ وَشِقَاقٍۢ',
		number_in_surah: '2',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3973',
		number: '3973',
		text: 'كَمْ أَهْلَكْنَا مِن قَبْلِهِم مِّن قَرْنٍۢ فَنَادَوا۟ وَّلَاتَ حِينَ مَنَاصٍۢ',
		number_in_surah: '3',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3974',
		number: '3974',
		text: 'وَعَجِبُوٓا۟ أَن جَآءَهُم مُّنذِرٌۭ مِّنْهُمْ ۖ وَقَالَ ٱلْكَٰفِرُونَ هَٰذَا سَٰحِرٌۭ كَذَّابٌ',
		number_in_surah: '4',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3975',
		number: '3975',
		text: 'أَجَعَلَ ٱلْءَالِهَةَ إِلَٰهًۭا وَٰحِدًا ۖ إِنَّ هَٰذَا لَشَىْءٌ عُجَابٌۭ',
		number_in_surah: '5',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3976',
		number: '3976',
		text: 'وَٱنطَلَقَ ٱلْمَلَأُ مِنْهُمْ أَنِ ٱمْشُوا۟ وَٱصْبِرُوا۟ عَلَىٰٓ ءَالِهَتِكُمْ ۖ إِنَّ هَٰذَا لَشَىْءٌۭ يُرَادُ',
		number_in_surah: '6',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3977',
		number: '3977',
		text: 'مَا سَمِعْنَا بِهَٰذَا فِى ٱلْمِلَّةِ ٱلْءَاخِرَةِ إِنْ هَٰذَآ إِلَّا ٱخْتِلَٰقٌ',
		number_in_surah: '7',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3978',
		number: '3978',
		text: 'أَءُنزِلَ عَلَيْهِ ٱلذِّكْرُ مِنۢ بَيْنِنَا ۚ بَلْ هُمْ فِى شَكٍّۢ مِّن ذِكْرِى ۖ بَل لَّمَّا يَذُوقُوا۟ عَذَابِ',
		number_in_surah: '8',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3979',
		number: '3979',
		text: 'أَمْ عِندَهُمْ خَزَآئِنُ رَحْمَةِ رَبِّكَ ٱلْعَزِيزِ ٱلْوَهَّابِ',
		number_in_surah: '9',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3980',
		number: '3980',
		text: 'أَمْ لَهُم مُّلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَا ۖ فَلْيَرْتَقُوا۟ فِى ٱلْأَسْبَٰبِ',
		number_in_surah: '10',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3981',
		number: '3981',
		text: 'جُندٌۭ مَّا هُنَالِكَ مَهْزُومٌۭ مِّنَ ٱلْأَحْزَابِ',
		number_in_surah: '11',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3982',
		number: '3982',
		text: 'كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍۢ وَعَادٌۭ وَفِرْعَوْنُ ذُو ٱلْأَوْتَادِ',
		number_in_surah: '12',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3983',
		number: '3983',
		text: 'وَثَمُودُ وَقَوْمُ لُوطٍۢ وَأَصْحَٰبُ لْـَٔيْكَةِ ۚ أُو۟لَٰٓئِكَ ٱلْأَحْزَابُ',
		number_in_surah: '13',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3984',
		number: '3984',
		text: 'إِن كُلٌّ إِلَّا كَذَّبَ ٱلرُّسُلَ فَحَقَّ عِقَابِ',
		number_in_surah: '14',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3985',
		number: '3985',
		text: 'وَمَا يَنظُرُ هَٰٓؤُلَآءِ إِلَّا صَيْحَةًۭ وَٰحِدَةًۭ مَّا لَهَا مِن فَوَاقٍۢ',
		number_in_surah: '15',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3986',
		number: '3986',
		text: 'وَقَالُوا۟ رَبَّنَا عَجِّل لَّنَا قِطَّنَا قَبْلَ يَوْمِ ٱلْحِسَابِ',
		number_in_surah: '16',
		page: '453',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3987',
		number: '3987',
		text: 'ٱصْبِرْ عَلَىٰ مَا يَقُولُونَ وَٱذْكُرْ عَبْدَنَا دَاوُۥدَ ذَا ٱلْأَيْدِ ۖ إِنَّهُۥٓ أَوَّابٌ',
		number_in_surah: '17',
		page: '454',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3988',
		number: '3988',
		text: 'إِنَّا سَخَّرْنَا ٱلْجِبَالَ مَعَهُۥ يُسَبِّحْنَ بِٱلْعَشِىِّ وَٱلْإِشْرَاقِ',
		number_in_surah: '18',
		page: '454',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3989',
		number: '3989',
		text: 'وَٱلطَّيْرَ مَحْشُورَةًۭ ۖ كُلٌّۭ لَّهُۥٓ أَوَّابٌۭ',
		number_in_surah: '19',
		page: '454',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3990',
		number: '3990',
		text: 'وَشَدَدْنَا مُلْكَهُۥ وَءَاتَيْنَٰهُ ٱلْحِكْمَةَ وَفَصْلَ ٱلْخِطَابِ',
		number_in_surah: '20',
		page: '454',
		surah_id: '38',
		hizb_id: '181',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3991',
		number: '3991',
		text: '۞ وَهَلْ أَتَىٰكَ نَبَؤُا۟ ٱلْخَصْمِ إِذْ تَسَوَّرُوا۟ ٱلْمِحْرَابَ',
		number_in_surah: '21',
		page: '454',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3992',
		number: '3992',
		text: 'إِذْ دَخَلُوا۟ عَلَىٰ دَاوُۥدَ فَفَزِعَ مِنْهُمْ ۖ قَالُوا۟ لَا تَخَفْ ۖ خَصْمَانِ بَغَىٰ بَعْضُنَا عَلَىٰ بَعْضٍۢ فَٱحْكُم بَيْنَنَا بِٱلْحَقِّ وَلَا تُشْطِطْ وَٱهْدِنَآ إِلَىٰ سَوَآءِ ٱلصِّرَٰطِ',
		number_in_surah: '22',
		page: '454',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3993',
		number: '3993',
		text: 'إِنَّ هَٰذَآ أَخِى لَهُۥ تِسْعٌۭ وَتِسْعُونَ نَعْجَةًۭ وَلِىَ نَعْجَةٌۭ وَٰحِدَةٌۭ فَقَالَ أَكْفِلْنِيهَا وَعَزَّنِى فِى ٱلْخِطَابِ',
		number_in_surah: '23',
		page: '454',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3994',
		number: '3994',
		text: 'قَالَ لَقَدْ ظَلَمَكَ بِسُؤَالِ نَعْجَتِكَ إِلَىٰ نِعَاجِهِۦ ۖ وَإِنَّ كَثِيرًۭا مِّنَ ٱلْخُلَطَآءِ لَيَبْغِى بَعْضُهُمْ عَلَىٰ بَعْضٍ إِلَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ وَقَلِيلٌۭ مَّا هُمْ ۗ وَظَنَّ دَاوُۥدُ أَنَّمَا فَتَنَّٰهُ فَٱسْتَغْفَرَ رَبَّهُۥ وَخَرَّ رَاكِعًۭا وَأَنَابَ ۩',
		number_in_surah: '24',
		page: '454',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '1',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3995',
		number: '3995',
		text: 'فَغَفَرْنَا لَهُۥ ذَٰلِكَ ۖ وَإِنَّ لَهُۥ عِندَنَا لَزُلْفَىٰ وَحُسْنَ مَـَٔابٍۢ',
		number_in_surah: '25',
		page: '454',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3996',
		number: '3996',
		text: 'يَٰدَاوُۥدُ إِنَّا جَعَلْنَٰكَ خَلِيفَةًۭ فِى ٱلْأَرْضِ فَٱحْكُم بَيْنَ ٱلنَّاسِ بِٱلْحَقِّ وَلَا تَتَّبِعِ ٱلْهَوَىٰ فَيُضِلَّكَ عَن سَبِيلِ ٱللَّهِ ۚ إِنَّ ٱلَّذِينَ يَضِلُّونَ عَن سَبِيلِ ٱللَّهِ لَهُمْ عَذَابٌۭ شَدِيدٌۢ بِمَا نَسُوا۟ يَوْمَ ٱلْحِسَابِ',
		number_in_surah: '26',
		page: '454',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3997',
		number: '3997',
		text: 'وَمَا خَلَقْنَا ٱلسَّمَآءَ وَٱلْأَرْضَ وَمَا بَيْنَهُمَا بَٰطِلًۭا ۚ ذَٰلِكَ ظَنُّ ٱلَّذِينَ كَفَرُوا۟ ۚ فَوَيْلٌۭ لِّلَّذِينَ كَفَرُوا۟ مِنَ ٱلنَّارِ',
		number_in_surah: '27',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3998',
		number: '3998',
		text: 'أَمْ نَجْعَلُ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ كَٱلْمُفْسِدِينَ فِى ٱلْأَرْضِ أَمْ نَجْعَلُ ٱلْمُتَّقِينَ كَٱلْفُجَّارِ',
		number_in_surah: '28',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '3999',
		number: '3999',
		text: 'كِتَٰبٌ أَنزَلْنَٰهُ إِلَيْكَ مُبَٰرَكٌۭ لِّيَدَّبَّرُوٓا۟ ءَايَٰتِهِۦ وَلِيَتَذَكَّرَ أُو۟لُوا۟ ٱلْأَلْبَٰبِ',
		number_in_surah: '29',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4000',
		number: '4000',
		text: 'وَوَهَبْنَا لِدَاوُۥدَ سُلَيْمَٰنَ ۚ نِعْمَ ٱلْعَبْدُ ۖ إِنَّهُۥٓ أَوَّابٌ',
		number_in_surah: '30',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4001',
		number: '4001',
		text: 'إِذْ عُرِضَ عَلَيْهِ بِٱلْعَشِىِّ ٱلصَّٰفِنَٰتُ ٱلْجِيَادُ',
		number_in_surah: '31',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4002',
		number: '4002',
		text: 'فَقَالَ إِنِّىٓ أَحْبَبْتُ حُبَّ ٱلْخَيْرِ عَن ذِكْرِ رَبِّى حَتَّىٰ تَوَارَتْ بِٱلْحِجَابِ',
		number_in_surah: '32',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4003',
		number: '4003',
		text: 'رُدُّوهَا عَلَىَّ ۖ فَطَفِقَ مَسْحًۢا بِٱلسُّوقِ وَٱلْأَعْنَاقِ',
		number_in_surah: '33',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4004',
		number: '4004',
		text: 'وَلَقَدْ فَتَنَّا سُلَيْمَٰنَ وَأَلْقَيْنَا عَلَىٰ كُرْسِيِّهِۦ جَسَدًۭا ثُمَّ أَنَابَ',
		number_in_surah: '34',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4005',
		number: '4005',
		text: 'قَالَ رَبِّ ٱغْفِرْ لِى وَهَبْ لِى مُلْكًۭا لَّا يَنۢبَغِى لِأَحَدٍۢ مِّنۢ بَعْدِىٓ ۖ إِنَّكَ أَنتَ ٱلْوَهَّابُ',
		number_in_surah: '35',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4006',
		number: '4006',
		text: 'فَسَخَّرْنَا لَهُ ٱلرِّيحَ تَجْرِى بِأَمْرِهِۦ رُخَآءً حَيْثُ أَصَابَ',
		number_in_surah: '36',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4007',
		number: '4007',
		text: 'وَٱلشَّيَٰطِينَ كُلَّ بَنَّآءٍۢ وَغَوَّاصٍۢ',
		number_in_surah: '37',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4008',
		number: '4008',
		text: 'وَءَاخَرِينَ مُقَرَّنِينَ فِى ٱلْأَصْفَادِ',
		number_in_surah: '38',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4009',
		number: '4009',
		text: 'هَٰذَا عَطَآؤُنَا فَٱمْنُنْ أَوْ أَمْسِكْ بِغَيْرِ حِسَابٍۢ',
		number_in_surah: '39',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4010',
		number: '4010',
		text: 'وَإِنَّ لَهُۥ عِندَنَا لَزُلْفَىٰ وَحُسْنَ مَـَٔابٍۢ',
		number_in_surah: '40',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4011',
		number: '4011',
		text: 'وَٱذْكُرْ عَبْدَنَآ أَيُّوبَ إِذْ نَادَىٰ رَبَّهُۥٓ أَنِّى مَسَّنِىَ ٱلشَّيْطَٰنُ بِنُصْبٍۢ وَعَذَابٍ',
		number_in_surah: '41',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4012',
		number: '4012',
		text: 'ٱرْكُضْ بِرِجْلِكَ ۖ هَٰذَا مُغْتَسَلٌۢ بَارِدٌۭ وَشَرَابٌۭ',
		number_in_surah: '42',
		page: '455',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4013',
		number: '4013',
		text: 'وَوَهَبْنَا لَهُۥٓ أَهْلَهُۥ وَمِثْلَهُم مَّعَهُمْ رَحْمَةًۭ مِّنَّا وَذِكْرَىٰ لِأُو۟لِى ٱلْأَلْبَٰبِ',
		number_in_surah: '43',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4014',
		number: '4014',
		text: 'وَخُذْ بِيَدِكَ ضِغْثًۭا فَٱضْرِب بِّهِۦ وَلَا تَحْنَثْ ۗ إِنَّا وَجَدْنَٰهُ صَابِرًۭا ۚ نِّعْمَ ٱلْعَبْدُ ۖ إِنَّهُۥٓ أَوَّابٌۭ',
		number_in_surah: '44',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4015',
		number: '4015',
		text: 'وَٱذْكُرْ عِبَٰدَنَآ إِبْرَٰهِيمَ وَإِسْحَٰقَ وَيَعْقُوبَ أُو۟لِى ٱلْأَيْدِى وَٱلْأَبْصَٰرِ',
		number_in_surah: '45',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4016',
		number: '4016',
		text: 'إِنَّآ أَخْلَصْنَٰهُم بِخَالِصَةٍۢ ذِكْرَى ٱلدَّارِ',
		number_in_surah: '46',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4017',
		number: '4017',
		text: 'وَإِنَّهُمْ عِندَنَا لَمِنَ ٱلْمُصْطَفَيْنَ ٱلْأَخْيَارِ',
		number_in_surah: '47',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4018',
		number: '4018',
		text: 'وَٱذْكُرْ إِسْمَٰعِيلَ وَٱلْيَسَعَ وَذَا ٱلْكِفْلِ ۖ وَكُلٌّۭ مِّنَ ٱلْأَخْيَارِ',
		number_in_surah: '48',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4019',
		number: '4019',
		text: 'هَٰذَا ذِكْرٌۭ ۚ وَإِنَّ لِلْمُتَّقِينَ لَحُسْنَ مَـَٔابٍۢ',
		number_in_surah: '49',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4020',
		number: '4020',
		text: 'جَنَّٰتِ عَدْنٍۢ مُّفَتَّحَةًۭ لَّهُمُ ٱلْأَبْوَٰبُ',
		number_in_surah: '50',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4021',
		number: '4021',
		text: 'مُتَّكِـِٔينَ فِيهَا يَدْعُونَ فِيهَا بِفَٰكِهَةٍۢ كَثِيرَةٍۢ وَشَرَابٍۢ',
		number_in_surah: '51',
		page: '456',
		surah_id: '38',
		hizb_id: '182',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4022',
		number: '4022',
		text: '۞ وَعِندَهُمْ قَٰصِرَٰتُ ٱلطَّرْفِ أَتْرَابٌ',
		number_in_surah: '52',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4023',
		number: '4023',
		text: 'هَٰذَا مَا تُوعَدُونَ لِيَوْمِ ٱلْحِسَابِ',
		number_in_surah: '53',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4024',
		number: '4024',
		text: 'إِنَّ هَٰذَا لَرِزْقُنَا مَا لَهُۥ مِن نَّفَادٍ',
		number_in_surah: '54',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4025',
		number: '4025',
		text: 'هَٰذَا ۚ وَإِنَّ لِلطَّٰغِينَ لَشَرَّ مَـَٔابٍۢ',
		number_in_surah: '55',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4026',
		number: '4026',
		text: 'جَهَنَّمَ يَصْلَوْنَهَا فَبِئْسَ ٱلْمِهَادُ',
		number_in_surah: '56',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4027',
		number: '4027',
		text: 'هَٰذَا فَلْيَذُوقُوهُ حَمِيمٌۭ وَغَسَّاقٌۭ',
		number_in_surah: '57',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4028',
		number: '4028',
		text: 'وَءَاخَرُ مِن شَكْلِهِۦٓ أَزْوَٰجٌ',
		number_in_surah: '58',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4029',
		number: '4029',
		text: 'هَٰذَا فَوْجٌۭ مُّقْتَحِمٌۭ مَّعَكُمْ ۖ لَا مَرْحَبًۢا بِهِمْ ۚ إِنَّهُمْ صَالُوا۟ ٱلنَّارِ',
		number_in_surah: '59',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4030',
		number: '4030',
		text: 'قَالُوا۟ بَلْ أَنتُمْ لَا مَرْحَبًۢا بِكُمْ ۖ أَنتُمْ قَدَّمْتُمُوهُ لَنَا ۖ فَبِئْسَ ٱلْقَرَارُ',
		number_in_surah: '60',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4031',
		number: '4031',
		text: 'قَالُوا۟ رَبَّنَا مَن قَدَّمَ لَنَا هَٰذَا فَزِدْهُ عَذَابًۭا ضِعْفًۭا فِى ٱلنَّارِ',
		number_in_surah: '61',
		page: '456',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4032',
		number: '4032',
		text: 'وَقَالُوا۟ مَا لَنَا لَا نَرَىٰ رِجَالًۭا كُنَّا نَعُدُّهُم مِّنَ ٱلْأَشْرَارِ',
		number_in_surah: '62',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4033',
		number: '4033',
		text: 'أَتَّخَذْنَٰهُمْ سِخْرِيًّا أَمْ زَاغَتْ عَنْهُمُ ٱلْأَبْصَٰرُ',
		number_in_surah: '63',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4034',
		number: '4034',
		text: 'إِنَّ ذَٰلِكَ لَحَقٌّۭ تَخَاصُمُ أَهْلِ ٱلنَّارِ',
		number_in_surah: '64',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4035',
		number: '4035',
		text: 'قُلْ إِنَّمَآ أَنَا۠ مُنذِرٌۭ ۖ وَمَا مِنْ إِلَٰهٍ إِلَّا ٱللَّهُ ٱلْوَٰحِدُ ٱلْقَهَّارُ',
		number_in_surah: '65',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4036',
		number: '4036',
		text: 'رَبُّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَا ٱلْعَزِيزُ ٱلْغَفَّٰرُ',
		number_in_surah: '66',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4037',
		number: '4037',
		text: 'قُلْ هُوَ نَبَؤٌا۟ عَظِيمٌ',
		number_in_surah: '67',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4038',
		number: '4038',
		text: 'أَنتُمْ عَنْهُ مُعْرِضُونَ',
		number_in_surah: '68',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4039',
		number: '4039',
		text: 'مَا كَانَ لِىَ مِنْ عِلْمٍۭ بِٱلْمَلَإِ ٱلْأَعْلَىٰٓ إِذْ يَخْتَصِمُونَ',
		number_in_surah: '69',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4040',
		number: '4040',
		text: 'إِن يُوحَىٰٓ إِلَىَّ إِلَّآ أَنَّمَآ أَنَا۠ نَذِيرٌۭ مُّبِينٌ',
		number_in_surah: '70',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4041',
		number: '4041',
		text: 'إِذْ قَالَ رَبُّكَ لِلْمَلَٰٓئِكَةِ إِنِّى خَٰلِقٌۢ بَشَرًۭا مِّن طِينٍۢ',
		number_in_surah: '71',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4042',
		number: '4042',
		text: 'فَإِذَا سَوَّيْتُهُۥ وَنَفَخْتُ فِيهِ مِن رُّوحِى فَقَعُوا۟ لَهُۥ سَٰجِدِينَ',
		number_in_surah: '72',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4043',
		number: '4043',
		text: 'فَسَجَدَ ٱلْمَلَٰٓئِكَةُ كُلُّهُمْ أَجْمَعُونَ',
		number_in_surah: '73',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4044',
		number: '4044',
		text: 'إِلَّآ إِبْلِيسَ ٱسْتَكْبَرَ وَكَانَ مِنَ ٱلْكَٰفِرِينَ',
		number_in_surah: '74',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4045',
		number: '4045',
		text: 'قَالَ يَٰٓإِبْلِيسُ مَا مَنَعَكَ أَن تَسْجُدَ لِمَا خَلَقْتُ بِيَدَىَّ ۖ أَسْتَكْبَرْتَ أَمْ كُنتَ مِنَ ٱلْعَالِينَ',
		number_in_surah: '75',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4046',
		number: '4046',
		text: 'قَالَ أَنَا۠ خَيْرٌۭ مِّنْهُ ۖ خَلَقْتَنِى مِن نَّارٍۢ وَخَلَقْتَهُۥ مِن طِينٍۢ',
		number_in_surah: '76',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4047',
		number: '4047',
		text: 'قَالَ فَٱخْرُجْ مِنْهَا فَإِنَّكَ رَجِيمٌۭ',
		number_in_surah: '77',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4048',
		number: '4048',
		text: 'وَإِنَّ عَلَيْكَ لَعْنَتِىٓ إِلَىٰ يَوْمِ ٱلدِّينِ',
		number_in_surah: '78',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4049',
		number: '4049',
		text: 'قَالَ رَبِّ فَأَنظِرْنِىٓ إِلَىٰ يَوْمِ يُبْعَثُونَ',
		number_in_surah: '79',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4050',
		number: '4050',
		text: 'قَالَ فَإِنَّكَ مِنَ ٱلْمُنظَرِينَ',
		number_in_surah: '80',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4051',
		number: '4051',
		text: 'إِلَىٰ يَوْمِ ٱلْوَقْتِ ٱلْمَعْلُومِ',
		number_in_surah: '81',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4052',
		number: '4052',
		text: 'قَالَ فَبِعِزَّتِكَ لَأُغْوِيَنَّهُمْ أَجْمَعِينَ',
		number_in_surah: '82',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4053',
		number: '4053',
		text: 'إِلَّا عِبَادَكَ مِنْهُمُ ٱلْمُخْلَصِينَ',
		number_in_surah: '83',
		page: '457',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4054',
		number: '4054',
		text: 'قَالَ فَٱلْحَقُّ وَٱلْحَقَّ أَقُولُ',
		number_in_surah: '84',
		page: '458',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4055',
		number: '4055',
		text: 'لَأَمْلَأَنَّ جَهَنَّمَ مِنكَ وَمِمَّن تَبِعَكَ مِنْهُمْ أَجْمَعِينَ',
		number_in_surah: '85',
		page: '458',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4056',
		number: '4056',
		text: 'قُلْ مَآ أَسْـَٔلُكُمْ عَلَيْهِ مِنْ أَجْرٍۢ وَمَآ أَنَا۠ مِنَ ٱلْمُتَكَلِّفِينَ',
		number_in_surah: '86',
		page: '458',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4057',
		number: '4057',
		text: 'إِنْ هُوَ إِلَّا ذِكْرٌۭ لِّلْعَٰلَمِينَ',
		number_in_surah: '87',
		page: '458',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4058',
		number: '4058',
		text: 'وَلَتَعْلَمُنَّ نَبَأَهُۥ بَعْدَ حِينٍۭ',
		number_in_surah: '88',
		page: '458',
		surah_id: '38',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4059',
		number: '4059',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ تَنزِيلُ ٱلْكِتَٰبِ مِنَ ٱللَّهِ ٱلْعَزِيزِ ٱلْحَكِيمِ',
		number_in_surah: '1',
		page: '458',
		surah_id: '39',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4060',
		number: '4060',
		text: 'إِنَّآ أَنزَلْنَآ إِلَيْكَ ٱلْكِتَٰبَ بِٱلْحَقِّ فَٱعْبُدِ ٱللَّهَ مُخْلِصًۭا لَّهُ ٱلدِّينَ',
		number_in_surah: '2',
		page: '458',
		surah_id: '39',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4061',
		number: '4061',
		text: 'أَلَا لِلَّهِ ٱلدِّينُ ٱلْخَالِصُ ۚ وَٱلَّذِينَ ٱتَّخَذُوا۟ مِن دُونِهِۦٓ أَوْلِيَآءَ مَا نَعْبُدُهُمْ إِلَّا لِيُقَرِّبُونَآ إِلَى ٱللَّهِ زُلْفَىٰٓ إِنَّ ٱللَّهَ يَحْكُمُ بَيْنَهُمْ فِى مَا هُمْ فِيهِ يَخْتَلِفُونَ ۗ إِنَّ ٱللَّهَ لَا يَهْدِى مَنْ هُوَ كَٰذِبٌۭ كَفَّارٌۭ',
		number_in_surah: '3',
		page: '458',
		surah_id: '39',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4062',
		number: '4062',
		text: 'لَّوْ أَرَادَ ٱللَّهُ أَن يَتَّخِذَ وَلَدًۭا لَّٱصْطَفَىٰ مِمَّا يَخْلُقُ مَا يَشَآءُ ۚ سُبْحَٰنَهُۥ ۖ هُوَ ٱللَّهُ ٱلْوَٰحِدُ ٱلْقَهَّارُ',
		number_in_surah: '4',
		page: '458',
		surah_id: '39',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4063',
		number: '4063',
		text: 'خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ بِٱلْحَقِّ ۖ يُكَوِّرُ ٱلَّيْلَ عَلَى ٱلنَّهَارِ وَيُكَوِّرُ ٱلنَّهَارَ عَلَى ٱلَّيْلِ ۖ وَسَخَّرَ ٱلشَّمْسَ وَٱلْقَمَرَ ۖ كُلٌّۭ يَجْرِى لِأَجَلٍۢ مُّسَمًّى ۗ أَلَا هُوَ ٱلْعَزِيزُ ٱلْغَفَّٰرُ',
		number_in_surah: '5',
		page: '458',
		surah_id: '39',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4064',
		number: '4064',
		text: 'خَلَقَكُم مِّن نَّفْسٍۢ وَٰحِدَةٍۢ ثُمَّ جَعَلَ مِنْهَا زَوْجَهَا وَأَنزَلَ لَكُم مِّنَ ٱلْأَنْعَٰمِ ثَمَٰنِيَةَ أَزْوَٰجٍۢ ۚ يَخْلُقُكُمْ فِى بُطُونِ أُمَّهَٰتِكُمْ خَلْقًۭا مِّنۢ بَعْدِ خَلْقٍۢ فِى ظُلُمَٰتٍۢ ثَلَٰثٍۢ ۚ ذَٰلِكُمُ ٱللَّهُ رَبُّكُمْ لَهُ ٱلْمُلْكُ ۖ لَآ إِلَٰهَ إِلَّا هُوَ ۖ فَأَنَّىٰ تُصْرَفُونَ',
		number_in_surah: '6',
		page: '459',
		surah_id: '39',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4065',
		number: '4065',
		text: 'إِن تَكْفُرُوا۟ فَإِنَّ ٱللَّهَ غَنِىٌّ عَنكُمْ ۖ وَلَا يَرْضَىٰ لِعِبَادِهِ ٱلْكُفْرَ ۖ وَإِن تَشْكُرُوا۟ يَرْضَهُ لَكُمْ ۗ وَلَا تَزِرُ وَازِرَةٌۭ وِزْرَ أُخْرَىٰ ۗ ثُمَّ إِلَىٰ رَبِّكُم مَّرْجِعُكُمْ فَيُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ ۚ إِنَّهُۥ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '7',
		page: '459',
		surah_id: '39',
		hizb_id: '183',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4066',
		number: '4066',
		text: '۞ وَإِذَا مَسَّ ٱلْإِنسَٰنَ ضُرٌّۭ دَعَا رَبَّهُۥ مُنِيبًا إِلَيْهِ ثُمَّ إِذَا خَوَّلَهُۥ نِعْمَةًۭ مِّنْهُ نَسِىَ مَا كَانَ يَدْعُوٓا۟ إِلَيْهِ مِن قَبْلُ وَجَعَلَ لِلَّهِ أَندَادًۭا لِّيُضِلَّ عَن سَبِيلِهِۦ ۚ قُلْ تَمَتَّعْ بِكُفْرِكَ قَلِيلًا ۖ إِنَّكَ مِنْ أَصْحَٰبِ ٱلنَّارِ',
		number_in_surah: '8',
		page: '459',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4067',
		number: '4067',
		text: 'أَمَّنْ هُوَ قَٰنِتٌ ءَانَآءَ ٱلَّيْلِ سَاجِدًۭا وَقَآئِمًۭا يَحْذَرُ ٱلْءَاخِرَةَ وَيَرْجُوا۟ رَحْمَةَ رَبِّهِۦ ۗ قُلْ هَلْ يَسْتَوِى ٱلَّذِينَ يَعْلَمُونَ وَٱلَّذِينَ لَا يَعْلَمُونَ ۗ إِنَّمَا يَتَذَكَّرُ أُو۟لُوا۟ ٱلْأَلْبَٰبِ',
		number_in_surah: '9',
		page: '459',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4068',
		number: '4068',
		text: 'قُلْ يَٰعِبَادِ ٱلَّذِينَ ءَامَنُوا۟ ٱتَّقُوا۟ رَبَّكُمْ ۚ لِلَّذِينَ أَحْسَنُوا۟ فِى هَٰذِهِ ٱلدُّنْيَا حَسَنَةٌۭ ۗ وَأَرْضُ ٱللَّهِ وَٰسِعَةٌ ۗ إِنَّمَا يُوَفَّى ٱلصَّٰبِرُونَ أَجْرَهُم بِغَيْرِ حِسَابٍۢ',
		number_in_surah: '10',
		page: '459',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4069',
		number: '4069',
		text: 'قُلْ إِنِّىٓ أُمِرْتُ أَنْ أَعْبُدَ ٱللَّهَ مُخْلِصًۭا لَّهُ ٱلدِّينَ',
		number_in_surah: '11',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4070',
		number: '4070',
		text: 'وَأُمِرْتُ لِأَنْ أَكُونَ أَوَّلَ ٱلْمُسْلِمِينَ',
		number_in_surah: '12',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4071',
		number: '4071',
		text: 'قُلْ إِنِّىٓ أَخَافُ إِنْ عَصَيْتُ رَبِّى عَذَابَ يَوْمٍ عَظِيمٍۢ',
		number_in_surah: '13',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4072',
		number: '4072',
		text: 'قُلِ ٱللَّهَ أَعْبُدُ مُخْلِصًۭا لَّهُۥ دِينِى',
		number_in_surah: '14',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4073',
		number: '4073',
		text: 'فَٱعْبُدُوا۟ مَا شِئْتُم مِّن دُونِهِۦ ۗ قُلْ إِنَّ ٱلْخَٰسِرِينَ ٱلَّذِينَ خَسِرُوٓا۟ أَنفُسَهُمْ وَأَهْلِيهِمْ يَوْمَ ٱلْقِيَٰمَةِ ۗ أَلَا ذَٰلِكَ هُوَ ٱلْخُسْرَانُ ٱلْمُبِينُ',
		number_in_surah: '15',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4074',
		number: '4074',
		text: 'لَهُم مِّن فَوْقِهِمْ ظُلَلٌۭ مِّنَ ٱلنَّارِ وَمِن تَحْتِهِمْ ظُلَلٌۭ ۚ ذَٰلِكَ يُخَوِّفُ ٱللَّهُ بِهِۦ عِبَادَهُۥ ۚ يَٰعِبَادِ فَٱتَّقُونِ',
		number_in_surah: '16',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4075',
		number: '4075',
		text: 'وَٱلَّذِينَ ٱجْتَنَبُوا۟ ٱلطَّٰغُوتَ أَن يَعْبُدُوهَا وَأَنَابُوٓا۟ إِلَى ٱللَّهِ لَهُمُ ٱلْبُشْرَىٰ ۚ فَبَشِّرْ عِبَادِ',
		number_in_surah: '17',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4076',
		number: '4076',
		text: 'ٱلَّذِينَ يَسْتَمِعُونَ ٱلْقَوْلَ فَيَتَّبِعُونَ أَحْسَنَهُۥٓ ۚ أُو۟لَٰٓئِكَ ٱلَّذِينَ هَدَىٰهُمُ ٱللَّهُ ۖ وَأُو۟لَٰٓئِكَ هُمْ أُو۟لُوا۟ ٱلْأَلْبَٰبِ',
		number_in_surah: '18',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4077',
		number: '4077',
		text: 'أَفَمَنْ حَقَّ عَلَيْهِ كَلِمَةُ ٱلْعَذَابِ أَفَأَنتَ تُنقِذُ مَن فِى ٱلنَّارِ',
		number_in_surah: '19',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:09',
		updated_at: '2018-06-07 08:07:09',
	},
	{
		id: '4078',
		number: '4078',
		text: 'لَٰكِنِ ٱلَّذِينَ ٱتَّقَوْا۟ رَبَّهُمْ لَهُمْ غُرَفٌۭ مِّن فَوْقِهَا غُرَفٌۭ مَّبْنِيَّةٌۭ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۖ وَعْدَ ٱللَّهِ ۖ لَا يُخْلِفُ ٱللَّهُ ٱلْمِيعَادَ',
		number_in_surah: '20',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4079',
		number: '4079',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ أَنزَلَ مِنَ ٱلسَّمَآءِ مَآءًۭ فَسَلَكَهُۥ يَنَٰبِيعَ فِى ٱلْأَرْضِ ثُمَّ يُخْرِجُ بِهِۦ زَرْعًۭا مُّخْتَلِفًا أَلْوَٰنُهُۥ ثُمَّ يَهِيجُ فَتَرَىٰهُ مُصْفَرًّۭا ثُمَّ يَجْعَلُهُۥ حُطَٰمًا ۚ إِنَّ فِى ذَٰلِكَ لَذِكْرَىٰ لِأُو۟لِى ٱلْأَلْبَٰبِ',
		number_in_surah: '21',
		page: '460',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4080',
		number: '4080',
		text: 'أَفَمَن شَرَحَ ٱللَّهُ صَدْرَهُۥ لِلْإِسْلَٰمِ فَهُوَ عَلَىٰ نُورٍۢ مِّن رَّبِّهِۦ ۚ فَوَيْلٌۭ لِّلْقَٰسِيَةِ قُلُوبُهُم مِّن ذِكْرِ ٱللَّهِ ۚ أُو۟لَٰٓئِكَ فِى ضَلَٰلٍۢ مُّبِينٍ',
		number_in_surah: '22',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4081',
		number: '4081',
		text: 'ٱللَّهُ نَزَّلَ أَحْسَنَ ٱلْحَدِيثِ كِتَٰبًۭا مُّتَشَٰبِهًۭا مَّثَانِىَ تَقْشَعِرُّ مِنْهُ جُلُودُ ٱلَّذِينَ يَخْشَوْنَ رَبَّهُمْ ثُمَّ تَلِينُ جُلُودُهُمْ وَقُلُوبُهُمْ إِلَىٰ ذِكْرِ ٱللَّهِ ۚ ذَٰلِكَ هُدَى ٱللَّهِ يَهْدِى بِهِۦ مَن يَشَآءُ ۚ وَمَن يُضْلِلِ ٱللَّهُ فَمَا لَهُۥ مِنْ هَادٍ',
		number_in_surah: '23',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4082',
		number: '4082',
		text: 'أَفَمَن يَتَّقِى بِوَجْهِهِۦ سُوٓءَ ٱلْعَذَابِ يَوْمَ ٱلْقِيَٰمَةِ ۚ وَقِيلَ لِلظَّٰلِمِينَ ذُوقُوا۟ مَا كُنتُمْ تَكْسِبُونَ',
		number_in_surah: '24',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4083',
		number: '4083',
		text: 'كَذَّبَ ٱلَّذِينَ مِن قَبْلِهِمْ فَأَتَىٰهُمُ ٱلْعَذَابُ مِنْ حَيْثُ لَا يَشْعُرُونَ',
		number_in_surah: '25',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4084',
		number: '4084',
		text: 'فَأَذَاقَهُمُ ٱللَّهُ ٱلْخِزْىَ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ وَلَعَذَابُ ٱلْءَاخِرَةِ أَكْبَرُ ۚ لَوْ كَانُوا۟ يَعْلَمُونَ',
		number_in_surah: '26',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4085',
		number: '4085',
		text: 'وَلَقَدْ ضَرَبْنَا لِلنَّاسِ فِى هَٰذَا ٱلْقُرْءَانِ مِن كُلِّ مَثَلٍۢ لَّعَلَّهُمْ يَتَذَكَّرُونَ',
		number_in_surah: '27',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4086',
		number: '4086',
		text: 'قُرْءَانًا عَرَبِيًّا غَيْرَ ذِى عِوَجٍۢ لَّعَلَّهُمْ يَتَّقُونَ',
		number_in_surah: '28',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4087',
		number: '4087',
		text: 'ضَرَبَ ٱللَّهُ مَثَلًۭا رَّجُلًۭا فِيهِ شُرَكَآءُ مُتَشَٰكِسُونَ وَرَجُلًۭا سَلَمًۭا لِّرَجُلٍ هَلْ يَسْتَوِيَانِ مَثَلًا ۚ ٱلْحَمْدُ لِلَّهِ ۚ بَلْ أَكْثَرُهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '29',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4088',
		number: '4088',
		text: 'إِنَّكَ مَيِّتٌۭ وَإِنَّهُم مَّيِّتُونَ',
		number_in_surah: '30',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4089',
		number: '4089',
		text: 'ثُمَّ إِنَّكُمْ يَوْمَ ٱلْقِيَٰمَةِ عِندَ رَبِّكُمْ تَخْتَصِمُونَ',
		number_in_surah: '31',
		page: '461',
		surah_id: '39',
		hizb_id: '184',
		juz_id: '23',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4090',
		number: '4090',
		text: '۞ فَمَنْ أَظْلَمُ مِمَّن كَذَبَ عَلَى ٱللَّهِ وَكَذَّبَ بِٱلصِّدْقِ إِذْ جَآءَهُۥٓ ۚ أَلَيْسَ فِى جَهَنَّمَ مَثْوًۭى لِّلْكَٰفِرِينَ',
		number_in_surah: '32',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4091',
		number: '4091',
		text: 'وَٱلَّذِى جَآءَ بِٱلصِّدْقِ وَصَدَّقَ بِهِۦٓ ۙ أُو۟لَٰٓئِكَ هُمُ ٱلْمُتَّقُونَ',
		number_in_surah: '33',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4092',
		number: '4092',
		text: 'لَهُم مَّا يَشَآءُونَ عِندَ رَبِّهِمْ ۚ ذَٰلِكَ جَزَآءُ ٱلْمُحْسِنِينَ',
		number_in_surah: '34',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4093',
		number: '4093',
		text: 'لِيُكَفِّرَ ٱللَّهُ عَنْهُمْ أَسْوَأَ ٱلَّذِى عَمِلُوا۟ وَيَجْزِيَهُمْ أَجْرَهُم بِأَحْسَنِ ٱلَّذِى كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '35',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4094',
		number: '4094',
		text: 'أَلَيْسَ ٱللَّهُ بِكَافٍ عَبْدَهُۥ ۖ وَيُخَوِّفُونَكَ بِٱلَّذِينَ مِن دُونِهِۦ ۚ وَمَن يُضْلِلِ ٱللَّهُ فَمَا لَهُۥ مِنْ هَادٍۢ',
		number_in_surah: '36',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4095',
		number: '4095',
		text: 'وَمَن يَهْدِ ٱللَّهُ فَمَا لَهُۥ مِن مُّضِلٍّ ۗ أَلَيْسَ ٱللَّهُ بِعَزِيزٍۢ ذِى ٱنتِقَامٍۢ',
		number_in_surah: '37',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4096',
		number: '4096',
		text: 'وَلَئِن سَأَلْتَهُم مَّنْ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ لَيَقُولُنَّ ٱللَّهُ ۚ قُلْ أَفَرَءَيْتُم مَّا تَدْعُونَ مِن دُونِ ٱللَّهِ إِنْ أَرَادَنِىَ ٱللَّهُ بِضُرٍّ هَلْ هُنَّ كَٰشِفَٰتُ ضُرِّهِۦٓ أَوْ أَرَادَنِى بِرَحْمَةٍ هَلْ هُنَّ مُمْسِكَٰتُ رَحْمَتِهِۦ ۚ قُلْ حَسْبِىَ ٱللَّهُ ۖ عَلَيْهِ يَتَوَكَّلُ ٱلْمُتَوَكِّلُونَ',
		number_in_surah: '38',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4097',
		number: '4097',
		text: 'قُلْ يَٰقَوْمِ ٱعْمَلُوا۟ عَلَىٰ مَكَانَتِكُمْ إِنِّى عَٰمِلٌۭ ۖ فَسَوْفَ تَعْلَمُونَ',
		number_in_surah: '39',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4098',
		number: '4098',
		text: 'مَن يَأْتِيهِ عَذَابٌۭ يُخْزِيهِ وَيَحِلُّ عَلَيْهِ عَذَابٌۭ مُّقِيمٌ',
		number_in_surah: '40',
		page: '462',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4099',
		number: '4099',
		text: 'إِنَّآ أَنزَلْنَا عَلَيْكَ ٱلْكِتَٰبَ لِلنَّاسِ بِٱلْحَقِّ ۖ فَمَنِ ٱهْتَدَىٰ فَلِنَفْسِهِۦ ۖ وَمَن ضَلَّ فَإِنَّمَا يَضِلُّ عَلَيْهَا ۖ وَمَآ أَنتَ عَلَيْهِم بِوَكِيلٍ',
		number_in_surah: '41',
		page: '463',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4100',
		number: '4100',
		text: 'ٱللَّهُ يَتَوَفَّى ٱلْأَنفُسَ حِينَ مَوْتِهَا وَٱلَّتِى لَمْ تَمُتْ فِى مَنَامِهَا ۖ فَيُمْسِكُ ٱلَّتِى قَضَىٰ عَلَيْهَا ٱلْمَوْتَ وَيُرْسِلُ ٱلْأُخْرَىٰٓ إِلَىٰٓ أَجَلٍۢ مُّسَمًّى ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَتَفَكَّرُونَ',
		number_in_surah: '42',
		page: '463',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4101',
		number: '4101',
		text: 'أَمِ ٱتَّخَذُوا۟ مِن دُونِ ٱللَّهِ شُفَعَآءَ ۚ قُلْ أَوَلَوْ كَانُوا۟ لَا يَمْلِكُونَ شَيْـًۭٔا وَلَا يَعْقِلُونَ',
		number_in_surah: '43',
		page: '463',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4102',
		number: '4102',
		text: 'قُل لِّلَّهِ ٱلشَّفَٰعَةُ جَمِيعًۭا ۖ لَّهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ ثُمَّ إِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '44',
		page: '463',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4103',
		number: '4103',
		text: 'وَإِذَا ذُكِرَ ٱللَّهُ وَحْدَهُ ٱشْمَأَزَّتْ قُلُوبُ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ ۖ وَإِذَا ذُكِرَ ٱلَّذِينَ مِن دُونِهِۦٓ إِذَا هُمْ يَسْتَبْشِرُونَ',
		number_in_surah: '45',
		page: '463',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4104',
		number: '4104',
		text: 'قُلِ ٱللَّهُمَّ فَاطِرَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ عَٰلِمَ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ أَنتَ تَحْكُمُ بَيْنَ عِبَادِكَ فِى مَا كَانُوا۟ فِيهِ يَخْتَلِفُونَ',
		number_in_surah: '46',
		page: '463',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4105',
		number: '4105',
		text: 'وَلَوْ أَنَّ لِلَّذِينَ ظَلَمُوا۟ مَا فِى ٱلْأَرْضِ جَمِيعًۭا وَمِثْلَهُۥ مَعَهُۥ لَٱفْتَدَوْا۟ بِهِۦ مِن سُوٓءِ ٱلْعَذَابِ يَوْمَ ٱلْقِيَٰمَةِ ۚ وَبَدَا لَهُم مِّنَ ٱللَّهِ مَا لَمْ يَكُونُوا۟ يَحْتَسِبُونَ',
		number_in_surah: '47',
		page: '463',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4106',
		number: '4106',
		text: 'وَبَدَا لَهُمْ سَيِّـَٔاتُ مَا كَسَبُوا۟ وَحَاقَ بِهِم مَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '48',
		page: '464',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4107',
		number: '4107',
		text: 'فَإِذَا مَسَّ ٱلْإِنسَٰنَ ضُرٌّۭ دَعَانَا ثُمَّ إِذَا خَوَّلْنَٰهُ نِعْمَةًۭ مِّنَّا قَالَ إِنَّمَآ أُوتِيتُهُۥ عَلَىٰ عِلْمٍۭ ۚ بَلْ هِىَ فِتْنَةٌۭ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '49',
		page: '464',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4108',
		number: '4108',
		text: 'قَدْ قَالَهَا ٱلَّذِينَ مِن قَبْلِهِمْ فَمَآ أَغْنَىٰ عَنْهُم مَّا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '50',
		page: '464',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4109',
		number: '4109',
		text: 'فَأَصَابَهُمْ سَيِّـَٔاتُ مَا كَسَبُوا۟ ۚ وَٱلَّذِينَ ظَلَمُوا۟ مِنْ هَٰٓؤُلَآءِ سَيُصِيبُهُمْ سَيِّـَٔاتُ مَا كَسَبُوا۟ وَمَا هُم بِمُعْجِزِينَ',
		number_in_surah: '51',
		page: '464',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4110',
		number: '4110',
		text: 'أَوَلَمْ يَعْلَمُوٓا۟ أَنَّ ٱللَّهَ يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ وَيَقْدِرُ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يُؤْمِنُونَ',
		number_in_surah: '52',
		page: '464',
		surah_id: '39',
		hizb_id: '185',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4111',
		number: '4111',
		text: '۞ قُلْ يَٰعِبَادِىَ ٱلَّذِينَ أَسْرَفُوا۟ عَلَىٰٓ أَنفُسِهِمْ لَا تَقْنَطُوا۟ مِن رَّحْمَةِ ٱللَّهِ ۚ إِنَّ ٱللَّهَ يَغْفِرُ ٱلذُّنُوبَ جَمِيعًا ۚ إِنَّهُۥ هُوَ ٱلْغَفُورُ ٱلرَّحِيمُ',
		number_in_surah: '53',
		page: '464',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4112',
		number: '4112',
		text: 'وَأَنِيبُوٓا۟ إِلَىٰ رَبِّكُمْ وَأَسْلِمُوا۟ لَهُۥ مِن قَبْلِ أَن يَأْتِيَكُمُ ٱلْعَذَابُ ثُمَّ لَا تُنصَرُونَ',
		number_in_surah: '54',
		page: '464',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4113',
		number: '4113',
		text: 'وَٱتَّبِعُوٓا۟ أَحْسَنَ مَآ أُنزِلَ إِلَيْكُم مِّن رَّبِّكُم مِّن قَبْلِ أَن يَأْتِيَكُمُ ٱلْعَذَابُ بَغْتَةًۭ وَأَنتُمْ لَا تَشْعُرُونَ',
		number_in_surah: '55',
		page: '464',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4114',
		number: '4114',
		text: 'أَن تَقُولَ نَفْسٌۭ يَٰحَسْرَتَىٰ عَلَىٰ مَا فَرَّطتُ فِى جَنۢبِ ٱللَّهِ وَإِن كُنتُ لَمِنَ ٱلسَّٰخِرِينَ',
		number_in_surah: '56',
		page: '464',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4115',
		number: '4115',
		text: 'أَوْ تَقُولَ لَوْ أَنَّ ٱللَّهَ هَدَىٰنِى لَكُنتُ مِنَ ٱلْمُتَّقِينَ',
		number_in_surah: '57',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4116',
		number: '4116',
		text: 'أَوْ تَقُولَ حِينَ تَرَى ٱلْعَذَابَ لَوْ أَنَّ لِى كَرَّةًۭ فَأَكُونَ مِنَ ٱلْمُحْسِنِينَ',
		number_in_surah: '58',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4117',
		number: '4117',
		text: 'بَلَىٰ قَدْ جَآءَتْكَ ءَايَٰتِى فَكَذَّبْتَ بِهَا وَٱسْتَكْبَرْتَ وَكُنتَ مِنَ ٱلْكَٰفِرِينَ',
		number_in_surah: '59',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4118',
		number: '4118',
		text: 'وَيَوْمَ ٱلْقِيَٰمَةِ تَرَى ٱلَّذِينَ كَذَبُوا۟ عَلَى ٱللَّهِ وُجُوهُهُم مُّسْوَدَّةٌ ۚ أَلَيْسَ فِى جَهَنَّمَ مَثْوًۭى لِّلْمُتَكَبِّرِينَ',
		number_in_surah: '60',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4119',
		number: '4119',
		text: 'وَيُنَجِّى ٱللَّهُ ٱلَّذِينَ ٱتَّقَوْا۟ بِمَفَازَتِهِمْ لَا يَمَسُّهُمُ ٱلسُّوٓءُ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '61',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4120',
		number: '4120',
		text: 'ٱللَّهُ خَٰلِقُ كُلِّ شَىْءٍۢ ۖ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ وَكِيلٌۭ',
		number_in_surah: '62',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4121',
		number: '4121',
		text: 'لَّهُۥ مَقَالِيدُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۗ وَٱلَّذِينَ كَفَرُوا۟ بِـَٔايَٰتِ ٱللَّهِ أُو۟لَٰٓئِكَ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '63',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4122',
		number: '4122',
		text: 'قُلْ أَفَغَيْرَ ٱللَّهِ تَأْمُرُوٓنِّىٓ أَعْبُدُ أَيُّهَا ٱلْجَٰهِلُونَ',
		number_in_surah: '64',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4123',
		number: '4123',
		text: 'وَلَقَدْ أُوحِىَ إِلَيْكَ وَإِلَى ٱلَّذِينَ مِن قَبْلِكَ لَئِنْ أَشْرَكْتَ لَيَحْبَطَنَّ عَمَلُكَ وَلَتَكُونَنَّ مِنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '65',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4124',
		number: '4124',
		text: 'بَلِ ٱللَّهَ فَٱعْبُدْ وَكُن مِّنَ ٱلشَّٰكِرِينَ',
		number_in_surah: '66',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4125',
		number: '4125',
		text: 'وَمَا قَدَرُوا۟ ٱللَّهَ حَقَّ قَدْرِهِۦ وَٱلْأَرْضُ جَمِيعًۭا قَبْضَتُهُۥ يَوْمَ ٱلْقِيَٰمَةِ وَٱلسَّمَٰوَٰتُ مَطْوِيَّٰتٌۢ بِيَمِينِهِۦ ۚ سُبْحَٰنَهُۥ وَتَعَٰلَىٰ عَمَّا يُشْرِكُونَ',
		number_in_surah: '67',
		page: '465',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4126',
		number: '4126',
		text: 'وَنُفِخَ فِى ٱلصُّورِ فَصَعِقَ مَن فِى ٱلسَّمَٰوَٰتِ وَمَن فِى ٱلْأَرْضِ إِلَّا مَن شَآءَ ٱللَّهُ ۖ ثُمَّ نُفِخَ فِيهِ أُخْرَىٰ فَإِذَا هُمْ قِيَامٌۭ يَنظُرُونَ',
		number_in_surah: '68',
		page: '466',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4127',
		number: '4127',
		text: 'وَأَشْرَقَتِ ٱلْأَرْضُ بِنُورِ رَبِّهَا وَوُضِعَ ٱلْكِتَٰبُ وَجِا۟ىٓءَ بِٱلنَّبِيِّۦنَ وَٱلشُّهَدَآءِ وَقُضِىَ بَيْنَهُم بِٱلْحَقِّ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '69',
		page: '466',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4128',
		number: '4128',
		text: 'وَوُفِّيَتْ كُلُّ نَفْسٍۢ مَّا عَمِلَتْ وَهُوَ أَعْلَمُ بِمَا يَفْعَلُونَ',
		number_in_surah: '70',
		page: '466',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4129',
		number: '4129',
		text: 'وَسِيقَ ٱلَّذِينَ كَفَرُوٓا۟ إِلَىٰ جَهَنَّمَ زُمَرًا ۖ حَتَّىٰٓ إِذَا جَآءُوهَا فُتِحَتْ أَبْوَٰبُهَا وَقَالَ لَهُمْ خَزَنَتُهَآ أَلَمْ يَأْتِكُمْ رُسُلٌۭ مِّنكُمْ يَتْلُونَ عَلَيْكُمْ ءَايَٰتِ رَبِّكُمْ وَيُنذِرُونَكُمْ لِقَآءَ يَوْمِكُمْ هَٰذَا ۚ قَالُوا۟ بَلَىٰ وَلَٰكِنْ حَقَّتْ كَلِمَةُ ٱلْعَذَابِ عَلَى ٱلْكَٰفِرِينَ',
		number_in_surah: '71',
		page: '466',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4130',
		number: '4130',
		text: 'قِيلَ ٱدْخُلُوٓا۟ أَبْوَٰبَ جَهَنَّمَ خَٰلِدِينَ فِيهَا ۖ فَبِئْسَ مَثْوَى ٱلْمُتَكَبِّرِينَ',
		number_in_surah: '72',
		page: '466',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4131',
		number: '4131',
		text: 'وَسِيقَ ٱلَّذِينَ ٱتَّقَوْا۟ رَبَّهُمْ إِلَى ٱلْجَنَّةِ زُمَرًا ۖ حَتَّىٰٓ إِذَا جَآءُوهَا وَفُتِحَتْ أَبْوَٰبُهَا وَقَالَ لَهُمْ خَزَنَتُهَا سَلَٰمٌ عَلَيْكُمْ طِبْتُمْ فَٱدْخُلُوهَا خَٰلِدِينَ',
		number_in_surah: '73',
		page: '466',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4132',
		number: '4132',
		text: 'وَقَالُوا۟ ٱلْحَمْدُ لِلَّهِ ٱلَّذِى صَدَقَنَا وَعْدَهُۥ وَأَوْرَثَنَا ٱلْأَرْضَ نَتَبَوَّأُ مِنَ ٱلْجَنَّةِ حَيْثُ نَشَآءُ ۖ فَنِعْمَ أَجْرُ ٱلْعَٰمِلِينَ',
		number_in_surah: '74',
		page: '466',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4133',
		number: '4133',
		text: 'وَتَرَى ٱلْمَلَٰٓئِكَةَ حَآفِّينَ مِنْ حَوْلِ ٱلْعَرْشِ يُسَبِّحُونَ بِحَمْدِ رَبِّهِمْ ۖ وَقُضِىَ بَيْنَهُم بِٱلْحَقِّ وَقِيلَ ٱلْحَمْدُ لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '75',
		page: '467',
		surah_id: '39',
		hizb_id: '186',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4134',
		number: '4134',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ حمٓ',
		number_in_surah: '1',
		page: '467',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4135',
		number: '4135',
		text: 'تَنزِيلُ ٱلْكِتَٰبِ مِنَ ٱللَّهِ ٱلْعَزِيزِ ٱلْعَلِيمِ',
		number_in_surah: '2',
		page: '467',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4136',
		number: '4136',
		text: 'غَافِرِ ٱلذَّنۢبِ وَقَابِلِ ٱلتَّوْبِ شَدِيدِ ٱلْعِقَابِ ذِى ٱلطَّوْلِ ۖ لَآ إِلَٰهَ إِلَّا هُوَ ۖ إِلَيْهِ ٱلْمَصِيرُ',
		number_in_surah: '3',
		page: '467',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4137',
		number: '4137',
		text: 'مَا يُجَٰدِلُ فِىٓ ءَايَٰتِ ٱللَّهِ إِلَّا ٱلَّذِينَ كَفَرُوا۟ فَلَا يَغْرُرْكَ تَقَلُّبُهُمْ فِى ٱلْبِلَٰدِ',
		number_in_surah: '4',
		page: '467',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4138',
		number: '4138',
		text: 'كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍۢ وَٱلْأَحْزَابُ مِنۢ بَعْدِهِمْ ۖ وَهَمَّتْ كُلُّ أُمَّةٍۭ بِرَسُولِهِمْ لِيَأْخُذُوهُ ۖ وَجَٰدَلُوا۟ بِٱلْبَٰطِلِ لِيُدْحِضُوا۟ بِهِ ٱلْحَقَّ فَأَخَذْتُهُمْ ۖ فَكَيْفَ كَانَ عِقَابِ',
		number_in_surah: '5',
		page: '467',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4139',
		number: '4139',
		text: 'وَكَذَٰلِكَ حَقَّتْ كَلِمَتُ رَبِّكَ عَلَى ٱلَّذِينَ كَفَرُوٓا۟ أَنَّهُمْ أَصْحَٰبُ ٱلنَّارِ',
		number_in_surah: '6',
		page: '467',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4140',
		number: '4140',
		text: 'ٱلَّذِينَ يَحْمِلُونَ ٱلْعَرْشَ وَمَنْ حَوْلَهُۥ يُسَبِّحُونَ بِحَمْدِ رَبِّهِمْ وَيُؤْمِنُونَ بِهِۦ وَيَسْتَغْفِرُونَ لِلَّذِينَ ءَامَنُوا۟ رَبَّنَا وَسِعْتَ كُلَّ شَىْءٍۢ رَّحْمَةًۭ وَعِلْمًۭا فَٱغْفِرْ لِلَّذِينَ تَابُوا۟ وَٱتَّبَعُوا۟ سَبِيلَكَ وَقِهِمْ عَذَابَ ٱلْجَحِيمِ',
		number_in_surah: '7',
		page: '467',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4141',
		number: '4141',
		text: 'رَبَّنَا وَأَدْخِلْهُمْ جَنَّٰتِ عَدْنٍ ٱلَّتِى وَعَدتَّهُمْ وَمَن صَلَحَ مِنْ ءَابَآئِهِمْ وَأَزْوَٰجِهِمْ وَذُرِّيَّٰتِهِمْ ۚ إِنَّكَ أَنتَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '8',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4142',
		number: '4142',
		text: 'وَقِهِمُ ٱلسَّيِّـَٔاتِ ۚ وَمَن تَقِ ٱلسَّيِّـَٔاتِ يَوْمَئِذٍۢ فَقَدْ رَحِمْتَهُۥ ۚ وَذَٰلِكَ هُوَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '9',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4143',
		number: '4143',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ يُنَادَوْنَ لَمَقْتُ ٱللَّهِ أَكْبَرُ مِن مَّقْتِكُمْ أَنفُسَكُمْ إِذْ تُدْعَوْنَ إِلَى ٱلْإِيمَٰنِ فَتَكْفُرُونَ',
		number_in_surah: '10',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4144',
		number: '4144',
		text: 'قَالُوا۟ رَبَّنَآ أَمَتَّنَا ٱثْنَتَيْنِ وَأَحْيَيْتَنَا ٱثْنَتَيْنِ فَٱعْتَرَفْنَا بِذُنُوبِنَا فَهَلْ إِلَىٰ خُرُوجٍۢ مِّن سَبِيلٍۢ',
		number_in_surah: '11',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4145',
		number: '4145',
		text: 'ذَٰلِكُم بِأَنَّهُۥٓ إِذَا دُعِىَ ٱللَّهُ وَحْدَهُۥ كَفَرْتُمْ ۖ وَإِن يُشْرَكْ بِهِۦ تُؤْمِنُوا۟ ۚ فَٱلْحُكْمُ لِلَّهِ ٱلْعَلِىِّ ٱلْكَبِيرِ',
		number_in_surah: '12',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4146',
		number: '4146',
		text: 'هُوَ ٱلَّذِى يُرِيكُمْ ءَايَٰتِهِۦ وَيُنَزِّلُ لَكُم مِّنَ ٱلسَّمَآءِ رِزْقًۭا ۚ وَمَا يَتَذَكَّرُ إِلَّا مَن يُنِيبُ',
		number_in_surah: '13',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4147',
		number: '4147',
		text: 'فَٱدْعُوا۟ ٱللَّهَ مُخْلِصِينَ لَهُ ٱلدِّينَ وَلَوْ كَرِهَ ٱلْكَٰفِرُونَ',
		number_in_surah: '14',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4148',
		number: '4148',
		text: 'رَفِيعُ ٱلدَّرَجَٰتِ ذُو ٱلْعَرْشِ يُلْقِى ٱلرُّوحَ مِنْ أَمْرِهِۦ عَلَىٰ مَن يَشَآءُ مِنْ عِبَادِهِۦ لِيُنذِرَ يَوْمَ ٱلتَّلَاقِ',
		number_in_surah: '15',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4149',
		number: '4149',
		text: 'يَوْمَ هُم بَٰرِزُونَ ۖ لَا يَخْفَىٰ عَلَى ٱللَّهِ مِنْهُمْ شَىْءٌۭ ۚ لِّمَنِ ٱلْمُلْكُ ٱلْيَوْمَ ۖ لِلَّهِ ٱلْوَٰحِدِ ٱلْقَهَّارِ',
		number_in_surah: '16',
		page: '468',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4150',
		number: '4150',
		text: 'ٱلْيَوْمَ تُجْزَىٰ كُلُّ نَفْسٍۭ بِمَا كَسَبَتْ ۚ لَا ظُلْمَ ٱلْيَوْمَ ۚ إِنَّ ٱللَّهَ سَرِيعُ ٱلْحِسَابِ',
		number_in_surah: '17',
		page: '469',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4151',
		number: '4151',
		text: 'وَأَنذِرْهُمْ يَوْمَ ٱلْءَازِفَةِ إِذِ ٱلْقُلُوبُ لَدَى ٱلْحَنَاجِرِ كَٰظِمِينَ ۚ مَا لِلظَّٰلِمِينَ مِنْ حَمِيمٍۢ وَلَا شَفِيعٍۢ يُطَاعُ',
		number_in_surah: '18',
		page: '469',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4152',
		number: '4152',
		text: 'يَعْلَمُ خَآئِنَةَ ٱلْأَعْيُنِ وَمَا تُخْفِى ٱلصُّدُورُ',
		number_in_surah: '19',
		page: '469',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4153',
		number: '4153',
		text: 'وَٱللَّهُ يَقْضِى بِٱلْحَقِّ ۖ وَٱلَّذِينَ يَدْعُونَ مِن دُونِهِۦ لَا يَقْضُونَ بِشَىْءٍ ۗ إِنَّ ٱللَّهَ هُوَ ٱلسَّمِيعُ ٱلْبَصِيرُ',
		number_in_surah: '20',
		page: '469',
		surah_id: '40',
		hizb_id: '187',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4154',
		number: '4154',
		text: '۞ أَوَلَمْ يَسِيرُوا۟ فِى ٱلْأَرْضِ فَيَنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ كَانُوا۟ مِن قَبْلِهِمْ ۚ كَانُوا۟ هُمْ أَشَدَّ مِنْهُمْ قُوَّةًۭ وَءَاثَارًۭا فِى ٱلْأَرْضِ فَأَخَذَهُمُ ٱللَّهُ بِذُنُوبِهِمْ وَمَا كَانَ لَهُم مِّنَ ٱللَّهِ مِن وَاقٍۢ',
		number_in_surah: '21',
		page: '469',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4155',
		number: '4155',
		text: 'ذَٰلِكَ بِأَنَّهُمْ كَانَت تَّأْتِيهِمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ فَكَفَرُوا۟ فَأَخَذَهُمُ ٱللَّهُ ۚ إِنَّهُۥ قَوِىٌّۭ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '22',
		page: '469',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4156',
		number: '4156',
		text: 'وَلَقَدْ أَرْسَلْنَا مُوسَىٰ بِـَٔايَٰتِنَا وَسُلْطَٰنٍۢ مُّبِينٍ',
		number_in_surah: '23',
		page: '469',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4157',
		number: '4157',
		text: 'إِلَىٰ فِرْعَوْنَ وَهَٰمَٰنَ وَقَٰرُونَ فَقَالُوا۟ سَٰحِرٌۭ كَذَّابٌۭ',
		number_in_surah: '24',
		page: '469',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4158',
		number: '4158',
		text: 'فَلَمَّا جَآءَهُم بِٱلْحَقِّ مِنْ عِندِنَا قَالُوا۟ ٱقْتُلُوٓا۟ أَبْنَآءَ ٱلَّذِينَ ءَامَنُوا۟ مَعَهُۥ وَٱسْتَحْيُوا۟ نِسَآءَهُمْ ۚ وَمَا كَيْدُ ٱلْكَٰفِرِينَ إِلَّا فِى ضَلَٰلٍۢ',
		number_in_surah: '25',
		page: '469',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4159',
		number: '4159',
		text: 'وَقَالَ فِرْعَوْنُ ذَرُونِىٓ أَقْتُلْ مُوسَىٰ وَلْيَدْعُ رَبَّهُۥٓ ۖ إِنِّىٓ أَخَافُ أَن يُبَدِّلَ دِينَكُمْ أَوْ أَن يُظْهِرَ فِى ٱلْأَرْضِ ٱلْفَسَادَ',
		number_in_surah: '26',
		page: '470',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4160',
		number: '4160',
		text: 'وَقَالَ مُوسَىٰٓ إِنِّى عُذْتُ بِرَبِّى وَرَبِّكُم مِّن كُلِّ مُتَكَبِّرٍۢ لَّا يُؤْمِنُ بِيَوْمِ ٱلْحِسَابِ',
		number_in_surah: '27',
		page: '470',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4161',
		number: '4161',
		text: 'وَقَالَ رَجُلٌۭ مُّؤْمِنٌۭ مِّنْ ءَالِ فِرْعَوْنَ يَكْتُمُ إِيمَٰنَهُۥٓ أَتَقْتُلُونَ رَجُلًا أَن يَقُولَ رَبِّىَ ٱللَّهُ وَقَدْ جَآءَكُم بِٱلْبَيِّنَٰتِ مِن رَّبِّكُمْ ۖ وَإِن يَكُ كَٰذِبًۭا فَعَلَيْهِ كَذِبُهُۥ ۖ وَإِن يَكُ صَادِقًۭا يُصِبْكُم بَعْضُ ٱلَّذِى يَعِدُكُمْ ۖ إِنَّ ٱللَّهَ لَا يَهْدِى مَنْ هُوَ مُسْرِفٌۭ كَذَّابٌۭ',
		number_in_surah: '28',
		page: '470',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4162',
		number: '4162',
		text: 'يَٰقَوْمِ لَكُمُ ٱلْمُلْكُ ٱلْيَوْمَ ظَٰهِرِينَ فِى ٱلْأَرْضِ فَمَن يَنصُرُنَا مِنۢ بَأْسِ ٱللَّهِ إِن جَآءَنَا ۚ قَالَ فِرْعَوْنُ مَآ أُرِيكُمْ إِلَّا مَآ أَرَىٰ وَمَآ أَهْدِيكُمْ إِلَّا سَبِيلَ ٱلرَّشَادِ',
		number_in_surah: '29',
		page: '470',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4163',
		number: '4163',
		text: 'وَقَالَ ٱلَّذِىٓ ءَامَنَ يَٰقَوْمِ إِنِّىٓ أَخَافُ عَلَيْكُم مِّثْلَ يَوْمِ ٱلْأَحْزَابِ',
		number_in_surah: '30',
		page: '470',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4164',
		number: '4164',
		text: 'مِثْلَ دَأْبِ قَوْمِ نُوحٍۢ وَعَادٍۢ وَثَمُودَ وَٱلَّذِينَ مِنۢ بَعْدِهِمْ ۚ وَمَا ٱللَّهُ يُرِيدُ ظُلْمًۭا لِّلْعِبَادِ',
		number_in_surah: '31',
		page: '470',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4165',
		number: '4165',
		text: 'وَيَٰقَوْمِ إِنِّىٓ أَخَافُ عَلَيْكُمْ يَوْمَ ٱلتَّنَادِ',
		number_in_surah: '32',
		page: '470',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4166',
		number: '4166',
		text: 'يَوْمَ تُوَلُّونَ مُدْبِرِينَ مَا لَكُم مِّنَ ٱللَّهِ مِنْ عَاصِمٍۢ ۗ وَمَن يُضْلِلِ ٱللَّهُ فَمَا لَهُۥ مِنْ هَادٍۢ',
		number_in_surah: '33',
		page: '470',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4167',
		number: '4167',
		text: 'وَلَقَدْ جَآءَكُمْ يُوسُفُ مِن قَبْلُ بِٱلْبَيِّنَٰتِ فَمَا زِلْتُمْ فِى شَكٍّۢ مِّمَّا جَآءَكُم بِهِۦ ۖ حَتَّىٰٓ إِذَا هَلَكَ قُلْتُمْ لَن يَبْعَثَ ٱللَّهُ مِنۢ بَعْدِهِۦ رَسُولًۭا ۚ كَذَٰلِكَ يُضِلُّ ٱللَّهُ مَنْ هُوَ مُسْرِفٌۭ مُّرْتَابٌ',
		number_in_surah: '34',
		page: '471',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4168',
		number: '4168',
		text: 'ٱلَّذِينَ يُجَٰدِلُونَ فِىٓ ءَايَٰتِ ٱللَّهِ بِغَيْرِ سُلْطَٰنٍ أَتَىٰهُمْ ۖ كَبُرَ مَقْتًا عِندَ ٱللَّهِ وَعِندَ ٱلَّذِينَ ءَامَنُوا۟ ۚ كَذَٰلِكَ يَطْبَعُ ٱللَّهُ عَلَىٰ كُلِّ قَلْبِ مُتَكَبِّرٍۢ جَبَّارٍۢ',
		number_in_surah: '35',
		page: '471',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4169',
		number: '4169',
		text: 'وَقَالَ فِرْعَوْنُ يَٰهَٰمَٰنُ ٱبْنِ لِى صَرْحًۭا لَّعَلِّىٓ أَبْلُغُ ٱلْأَسْبَٰبَ',
		number_in_surah: '36',
		page: '471',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4170',
		number: '4170',
		text: 'أَسْبَٰبَ ٱلسَّمَٰوَٰتِ فَأَطَّلِعَ إِلَىٰٓ إِلَٰهِ مُوسَىٰ وَإِنِّى لَأَظُنُّهُۥ كَٰذِبًۭا ۚ وَكَذَٰلِكَ زُيِّنَ لِفِرْعَوْنَ سُوٓءُ عَمَلِهِۦ وَصُدَّ عَنِ ٱلسَّبِيلِ ۚ وَمَا كَيْدُ فِرْعَوْنَ إِلَّا فِى تَبَابٍۢ',
		number_in_surah: '37',
		page: '471',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4171',
		number: '4171',
		text: 'وَقَالَ ٱلَّذِىٓ ءَامَنَ يَٰقَوْمِ ٱتَّبِعُونِ أَهْدِكُمْ سَبِيلَ ٱلرَّشَادِ',
		number_in_surah: '38',
		page: '471',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4172',
		number: '4172',
		text: 'يَٰقَوْمِ إِنَّمَا هَٰذِهِ ٱلْحَيَوٰةُ ٱلدُّنْيَا مَتَٰعٌۭ وَإِنَّ ٱلْءَاخِرَةَ هِىَ دَارُ ٱلْقَرَارِ',
		number_in_surah: '39',
		page: '471',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4173',
		number: '4173',
		text: 'مَنْ عَمِلَ سَيِّئَةًۭ فَلَا يُجْزَىٰٓ إِلَّا مِثْلَهَا ۖ وَمَنْ عَمِلَ صَٰلِحًۭا مِّن ذَكَرٍ أَوْ أُنثَىٰ وَهُوَ مُؤْمِنٌۭ فَأُو۟لَٰٓئِكَ يَدْخُلُونَ ٱلْجَنَّةَ يُرْزَقُونَ فِيهَا بِغَيْرِ حِسَابٍۢ',
		number_in_surah: '40',
		page: '471',
		surah_id: '40',
		hizb_id: '188',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4174',
		number: '4174',
		text: '۞ وَيَٰقَوْمِ مَا لِىٓ أَدْعُوكُمْ إِلَى ٱلنَّجَوٰةِ وَتَدْعُونَنِىٓ إِلَى ٱلنَّارِ',
		number_in_surah: '41',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4175',
		number: '4175',
		text: 'تَدْعُونَنِى لِأَكْفُرَ بِٱللَّهِ وَأُشْرِكَ بِهِۦ مَا لَيْسَ لِى بِهِۦ عِلْمٌۭ وَأَنَا۠ أَدْعُوكُمْ إِلَى ٱلْعَزِيزِ ٱلْغَفَّٰرِ',
		number_in_surah: '42',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4176',
		number: '4176',
		text: 'لَا جَرَمَ أَنَّمَا تَدْعُونَنِىٓ إِلَيْهِ لَيْسَ لَهُۥ دَعْوَةٌۭ فِى ٱلدُّنْيَا وَلَا فِى ٱلْءَاخِرَةِ وَأَنَّ مَرَدَّنَآ إِلَى ٱللَّهِ وَأَنَّ ٱلْمُسْرِفِينَ هُمْ أَصْحَٰبُ ٱلنَّارِ',
		number_in_surah: '43',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4177',
		number: '4177',
		text: 'فَسَتَذْكُرُونَ مَآ أَقُولُ لَكُمْ ۚ وَأُفَوِّضُ أَمْرِىٓ إِلَى ٱللَّهِ ۚ إِنَّ ٱللَّهَ بَصِيرٌۢ بِٱلْعِبَادِ',
		number_in_surah: '44',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4178',
		number: '4178',
		text: 'فَوَقَىٰهُ ٱللَّهُ سَيِّـَٔاتِ مَا مَكَرُوا۟ ۖ وَحَاقَ بِـَٔالِ فِرْعَوْنَ سُوٓءُ ٱلْعَذَابِ',
		number_in_surah: '45',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4179',
		number: '4179',
		text: 'ٱلنَّارُ يُعْرَضُونَ عَلَيْهَا غُدُوًّۭا وَعَشِيًّۭا ۖ وَيَوْمَ تَقُومُ ٱلسَّاعَةُ أَدْخِلُوٓا۟ ءَالَ فِرْعَوْنَ أَشَدَّ ٱلْعَذَابِ',
		number_in_surah: '46',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4180',
		number: '4180',
		text: 'وَإِذْ يَتَحَآجُّونَ فِى ٱلنَّارِ فَيَقُولُ ٱلضُّعَفَٰٓؤُا۟ لِلَّذِينَ ٱسْتَكْبَرُوٓا۟ إِنَّا كُنَّا لَكُمْ تَبَعًۭا فَهَلْ أَنتُم مُّغْنُونَ عَنَّا نَصِيبًۭا مِّنَ ٱلنَّارِ',
		number_in_surah: '47',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4181',
		number: '4181',
		text: 'قَالَ ٱلَّذِينَ ٱسْتَكْبَرُوٓا۟ إِنَّا كُلٌّۭ فِيهَآ إِنَّ ٱللَّهَ قَدْ حَكَمَ بَيْنَ ٱلْعِبَادِ',
		number_in_surah: '48',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4182',
		number: '4182',
		text: 'وَقَالَ ٱلَّذِينَ فِى ٱلنَّارِ لِخَزَنَةِ جَهَنَّمَ ٱدْعُوا۟ رَبَّكُمْ يُخَفِّفْ عَنَّا يَوْمًۭا مِّنَ ٱلْعَذَابِ',
		number_in_surah: '49',
		page: '472',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4183',
		number: '4183',
		text: 'قَالُوٓا۟ أَوَلَمْ تَكُ تَأْتِيكُمْ رُسُلُكُم بِٱلْبَيِّنَٰتِ ۖ قَالُوا۟ بَلَىٰ ۚ قَالُوا۟ فَٱدْعُوا۟ ۗ وَمَا دُعَٰٓؤُا۟ ٱلْكَٰفِرِينَ إِلَّا فِى ضَلَٰلٍ',
		number_in_surah: '50',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4184',
		number: '4184',
		text: 'إِنَّا لَنَنصُرُ رُسُلَنَا وَٱلَّذِينَ ءَامَنُوا۟ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا وَيَوْمَ يَقُومُ ٱلْأَشْهَٰدُ',
		number_in_surah: '51',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4185',
		number: '4185',
		text: 'يَوْمَ لَا يَنفَعُ ٱلظَّٰلِمِينَ مَعْذِرَتُهُمْ ۖ وَلَهُمُ ٱللَّعْنَةُ وَلَهُمْ سُوٓءُ ٱلدَّارِ',
		number_in_surah: '52',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4186',
		number: '4186',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَى ٱلْهُدَىٰ وَأَوْرَثْنَا بَنِىٓ إِسْرَٰٓءِيلَ ٱلْكِتَٰبَ',
		number_in_surah: '53',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4187',
		number: '4187',
		text: 'هُدًۭى وَذِكْرَىٰ لِأُو۟لِى ٱلْأَلْبَٰبِ',
		number_in_surah: '54',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4188',
		number: '4188',
		text: 'فَٱصْبِرْ إِنَّ وَعْدَ ٱللَّهِ حَقٌّۭ وَٱسْتَغْفِرْ لِذَنۢبِكَ وَسَبِّحْ بِحَمْدِ رَبِّكَ بِٱلْعَشِىِّ وَٱلْإِبْكَٰرِ',
		number_in_surah: '55',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4189',
		number: '4189',
		text: 'إِنَّ ٱلَّذِينَ يُجَٰدِلُونَ فِىٓ ءَايَٰتِ ٱللَّهِ بِغَيْرِ سُلْطَٰنٍ أَتَىٰهُمْ ۙ إِن فِى صُدُورِهِمْ إِلَّا كِبْرٌۭ مَّا هُم بِبَٰلِغِيهِ ۚ فَٱسْتَعِذْ بِٱللَّهِ ۖ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلْبَصِيرُ',
		number_in_surah: '56',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4190',
		number: '4190',
		text: 'لَخَلْقُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ أَكْبَرُ مِنْ خَلْقِ ٱلنَّاسِ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '57',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4191',
		number: '4191',
		text: 'وَمَا يَسْتَوِى ٱلْأَعْمَىٰ وَٱلْبَصِيرُ وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ وَلَا ٱلْمُسِىٓءُ ۚ قَلِيلًۭا مَّا تَتَذَكَّرُونَ',
		number_in_surah: '58',
		page: '473',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4192',
		number: '4192',
		text: 'إِنَّ ٱلسَّاعَةَ لَءَاتِيَةٌۭ لَّا رَيْبَ فِيهَا وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يُؤْمِنُونَ',
		number_in_surah: '59',
		page: '474',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4193',
		number: '4193',
		text: 'وَقَالَ رَبُّكُمُ ٱدْعُونِىٓ أَسْتَجِبْ لَكُمْ ۚ إِنَّ ٱلَّذِينَ يَسْتَكْبِرُونَ عَنْ عِبَادَتِى سَيَدْخُلُونَ جَهَنَّمَ دَاخِرِينَ',
		number_in_surah: '60',
		page: '474',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4194',
		number: '4194',
		text: 'ٱللَّهُ ٱلَّذِى جَعَلَ لَكُمُ ٱلَّيْلَ لِتَسْكُنُوا۟ فِيهِ وَٱلنَّهَارَ مُبْصِرًا ۚ إِنَّ ٱللَّهَ لَذُو فَضْلٍ عَلَى ٱلنَّاسِ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَشْكُرُونَ',
		number_in_surah: '61',
		page: '474',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4195',
		number: '4195',
		text: 'ذَٰلِكُمُ ٱللَّهُ رَبُّكُمْ خَٰلِقُ كُلِّ شَىْءٍۢ لَّآ إِلَٰهَ إِلَّا هُوَ ۖ فَأَنَّىٰ تُؤْفَكُونَ',
		number_in_surah: '62',
		page: '474',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4196',
		number: '4196',
		text: 'كَذَٰلِكَ يُؤْفَكُ ٱلَّذِينَ كَانُوا۟ بِـَٔايَٰتِ ٱللَّهِ يَجْحَدُونَ',
		number_in_surah: '63',
		page: '474',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4197',
		number: '4197',
		text: 'ٱللَّهُ ٱلَّذِى جَعَلَ لَكُمُ ٱلْأَرْضَ قَرَارًۭا وَٱلسَّمَآءَ بِنَآءًۭ وَصَوَّرَكُمْ فَأَحْسَنَ صُوَرَكُمْ وَرَزَقَكُم مِّنَ ٱلطَّيِّبَٰتِ ۚ ذَٰلِكُمُ ٱللَّهُ رَبُّكُمْ ۖ فَتَبَارَكَ ٱللَّهُ رَبُّ ٱلْعَٰلَمِينَ',
		number_in_surah: '64',
		page: '474',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4198',
		number: '4198',
		text: 'هُوَ ٱلْحَىُّ لَآ إِلَٰهَ إِلَّا هُوَ فَٱدْعُوهُ مُخْلِصِينَ لَهُ ٱلدِّينَ ۗ ٱلْحَمْدُ لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '65',
		page: '474',
		surah_id: '40',
		hizb_id: '189',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4199',
		number: '4199',
		text: '۞ قُلْ إِنِّى نُهِيتُ أَنْ أَعْبُدَ ٱلَّذِينَ تَدْعُونَ مِن دُونِ ٱللَّهِ لَمَّا جَآءَنِىَ ٱلْبَيِّنَٰتُ مِن رَّبِّى وَأُمِرْتُ أَنْ أُسْلِمَ لِرَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '66',
		page: '474',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4200',
		number: '4200',
		text: 'هُوَ ٱلَّذِى خَلَقَكُم مِّن تُرَابٍۢ ثُمَّ مِن نُّطْفَةٍۢ ثُمَّ مِنْ عَلَقَةٍۢ ثُمَّ يُخْرِجُكُمْ طِفْلًۭا ثُمَّ لِتَبْلُغُوٓا۟ أَشُدَّكُمْ ثُمَّ لِتَكُونُوا۟ شُيُوخًۭا ۚ وَمِنكُم مَّن يُتَوَفَّىٰ مِن قَبْلُ ۖ وَلِتَبْلُغُوٓا۟ أَجَلًۭا مُّسَمًّۭى وَلَعَلَّكُمْ تَعْقِلُونَ',
		number_in_surah: '67',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4201',
		number: '4201',
		text: 'هُوَ ٱلَّذِى يُحْىِۦ وَيُمِيتُ ۖ فَإِذَا قَضَىٰٓ أَمْرًۭا فَإِنَّمَا يَقُولُ لَهُۥ كُن فَيَكُونُ',
		number_in_surah: '68',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4202',
		number: '4202',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِينَ يُجَٰدِلُونَ فِىٓ ءَايَٰتِ ٱللَّهِ أَنَّىٰ يُصْرَفُونَ',
		number_in_surah: '69',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4203',
		number: '4203',
		text: 'ٱلَّذِينَ كَذَّبُوا۟ بِٱلْكِتَٰبِ وَبِمَآ أَرْسَلْنَا بِهِۦ رُسُلَنَا ۖ فَسَوْفَ يَعْلَمُونَ',
		number_in_surah: '70',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4204',
		number: '4204',
		text: 'إِذِ ٱلْأَغْلَٰلُ فِىٓ أَعْنَٰقِهِمْ وَٱلسَّلَٰسِلُ يُسْحَبُونَ',
		number_in_surah: '71',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4205',
		number: '4205',
		text: 'فِى ٱلْحَمِيمِ ثُمَّ فِى ٱلنَّارِ يُسْجَرُونَ',
		number_in_surah: '72',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4206',
		number: '4206',
		text: 'ثُمَّ قِيلَ لَهُمْ أَيْنَ مَا كُنتُمْ تُشْرِكُونَ',
		number_in_surah: '73',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4207',
		number: '4207',
		text: 'مِن دُونِ ٱللَّهِ ۖ قَالُوا۟ ضَلُّوا۟ عَنَّا بَل لَّمْ نَكُن نَّدْعُوا۟ مِن قَبْلُ شَيْـًۭٔا ۚ كَذَٰلِكَ يُضِلُّ ٱللَّهُ ٱلْكَٰفِرِينَ',
		number_in_surah: '74',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4208',
		number: '4208',
		text: 'ذَٰلِكُم بِمَا كُنتُمْ تَفْرَحُونَ فِى ٱلْأَرْضِ بِغَيْرِ ٱلْحَقِّ وَبِمَا كُنتُمْ تَمْرَحُونَ',
		number_in_surah: '75',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4209',
		number: '4209',
		text: 'ٱدْخُلُوٓا۟ أَبْوَٰبَ جَهَنَّمَ خَٰلِدِينَ فِيهَا ۖ فَبِئْسَ مَثْوَى ٱلْمُتَكَبِّرِينَ',
		number_in_surah: '76',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4210',
		number: '4210',
		text: 'فَٱصْبِرْ إِنَّ وَعْدَ ٱللَّهِ حَقٌّۭ ۚ فَإِمَّا نُرِيَنَّكَ بَعْضَ ٱلَّذِى نَعِدُهُمْ أَوْ نَتَوَفَّيَنَّكَ فَإِلَيْنَا يُرْجَعُونَ',
		number_in_surah: '77',
		page: '475',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4211',
		number: '4211',
		text: 'وَلَقَدْ أَرْسَلْنَا رُسُلًۭا مِّن قَبْلِكَ مِنْهُم مَّن قَصَصْنَا عَلَيْكَ وَمِنْهُم مَّن لَّمْ نَقْصُصْ عَلَيْكَ ۗ وَمَا كَانَ لِرَسُولٍ أَن يَأْتِىَ بِـَٔايَةٍ إِلَّا بِإِذْنِ ٱللَّهِ ۚ فَإِذَا جَآءَ أَمْرُ ٱللَّهِ قُضِىَ بِٱلْحَقِّ وَخَسِرَ هُنَالِكَ ٱلْمُبْطِلُونَ',
		number_in_surah: '78',
		page: '476',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4212',
		number: '4212',
		text: 'ٱللَّهُ ٱلَّذِى جَعَلَ لَكُمُ ٱلْأَنْعَٰمَ لِتَرْكَبُوا۟ مِنْهَا وَمِنْهَا تَأْكُلُونَ',
		number_in_surah: '79',
		page: '476',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4213',
		number: '4213',
		text: 'وَلَكُمْ فِيهَا مَنَٰفِعُ وَلِتَبْلُغُوا۟ عَلَيْهَا حَاجَةًۭ فِى صُدُورِكُمْ وَعَلَيْهَا وَعَلَى ٱلْفُلْكِ تُحْمَلُونَ',
		number_in_surah: '80',
		page: '476',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4214',
		number: '4214',
		text: 'وَيُرِيكُمْ ءَايَٰتِهِۦ فَأَىَّ ءَايَٰتِ ٱللَّهِ تُنكِرُونَ',
		number_in_surah: '81',
		page: '476',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4215',
		number: '4215',
		text: 'أَفَلَمْ يَسِيرُوا۟ فِى ٱلْأَرْضِ فَيَنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبْلِهِمْ ۚ كَانُوٓا۟ أَكْثَرَ مِنْهُمْ وَأَشَدَّ قُوَّةًۭ وَءَاثَارًۭا فِى ٱلْأَرْضِ فَمَآ أَغْنَىٰ عَنْهُم مَّا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '82',
		page: '476',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4216',
		number: '4216',
		text: 'فَلَمَّا جَآءَتْهُمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ فَرِحُوا۟ بِمَا عِندَهُم مِّنَ ٱلْعِلْمِ وَحَاقَ بِهِم مَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '83',
		page: '476',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4217',
		number: '4217',
		text: 'فَلَمَّا رَأَوْا۟ بَأْسَنَا قَالُوٓا۟ ءَامَنَّا بِٱللَّهِ وَحْدَهُۥ وَكَفَرْنَا بِمَا كُنَّا بِهِۦ مُشْرِكِينَ',
		number_in_surah: '84',
		page: '476',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4218',
		number: '4218',
		text: 'فَلَمْ يَكُ يَنفَعُهُمْ إِيمَٰنُهُمْ لَمَّا رَأَوْا۟ بَأْسَنَا ۖ سُنَّتَ ٱللَّهِ ٱلَّتِى قَدْ خَلَتْ فِى عِبَادِهِۦ ۖ وَخَسِرَ هُنَالِكَ ٱلْكَٰفِرُونَ',
		number_in_surah: '85',
		page: '476',
		surah_id: '40',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4219',
		number: '4219',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ حمٓ',
		number_in_surah: '1',
		page: '477',
		surah_id: '41',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4220',
		number: '4220',
		text: 'تَنزِيلٌۭ مِّنَ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ',
		number_in_surah: '2',
		page: '477',
		surah_id: '41',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4221',
		number: '4221',
		text: 'كِتَٰبٌۭ فُصِّلَتْ ءَايَٰتُهُۥ قُرْءَانًا عَرَبِيًّۭا لِّقَوْمٍۢ يَعْلَمُونَ',
		number_in_surah: '3',
		page: '477',
		surah_id: '41',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4222',
		number: '4222',
		text: 'بَشِيرًۭا وَنَذِيرًۭا فَأَعْرَضَ أَكْثَرُهُمْ فَهُمْ لَا يَسْمَعُونَ',
		number_in_surah: '4',
		page: '477',
		surah_id: '41',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4223',
		number: '4223',
		text: 'وَقَالُوا۟ قُلُوبُنَا فِىٓ أَكِنَّةٍۢ مِّمَّا تَدْعُونَآ إِلَيْهِ وَفِىٓ ءَاذَانِنَا وَقْرٌۭ وَمِنۢ بَيْنِنَا وَبَيْنِكَ حِجَابٌۭ فَٱعْمَلْ إِنَّنَا عَٰمِلُونَ',
		number_in_surah: '5',
		page: '477',
		surah_id: '41',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4224',
		number: '4224',
		text: 'قُلْ إِنَّمَآ أَنَا۠ بَشَرٌۭ مِّثْلُكُمْ يُوحَىٰٓ إِلَىَّ أَنَّمَآ إِلَٰهُكُمْ إِلَٰهٌۭ وَٰحِدٌۭ فَٱسْتَقِيمُوٓا۟ إِلَيْهِ وَٱسْتَغْفِرُوهُ ۗ وَوَيْلٌۭ لِّلْمُشْرِكِينَ',
		number_in_surah: '6',
		page: '477',
		surah_id: '41',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4225',
		number: '4225',
		text: 'ٱلَّذِينَ لَا يُؤْتُونَ ٱلزَّكَوٰةَ وَهُم بِٱلْءَاخِرَةِ هُمْ كَٰفِرُونَ',
		number_in_surah: '7',
		page: '477',
		surah_id: '41',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4226',
		number: '4226',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَهُمْ أَجْرٌ غَيْرُ مَمْنُونٍۢ',
		number_in_surah: '8',
		page: '477',
		surah_id: '41',
		hizb_id: '190',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4227',
		number: '4227',
		text: '۞ قُلْ أَئِنَّكُمْ لَتَكْفُرُونَ بِٱلَّذِى خَلَقَ ٱلْأَرْضَ فِى يَوْمَيْنِ وَتَجْعَلُونَ لَهُۥٓ أَندَادًۭا ۚ ذَٰلِكَ رَبُّ ٱلْعَٰلَمِينَ',
		number_in_surah: '9',
		page: '477',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4228',
		number: '4228',
		text: 'وَجَعَلَ فِيهَا رَوَٰسِىَ مِن فَوْقِهَا وَبَٰرَكَ فِيهَا وَقَدَّرَ فِيهَآ أَقْوَٰتَهَا فِىٓ أَرْبَعَةِ أَيَّامٍۢ سَوَآءًۭ لِّلسَّآئِلِينَ',
		number_in_surah: '10',
		page: '477',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4229',
		number: '4229',
		text: 'ثُمَّ ٱسْتَوَىٰٓ إِلَى ٱلسَّمَآءِ وَهِىَ دُخَانٌۭ فَقَالَ لَهَا وَلِلْأَرْضِ ٱئْتِيَا طَوْعًا أَوْ كَرْهًۭا قَالَتَآ أَتَيْنَا طَآئِعِينَ',
		number_in_surah: '11',
		page: '477',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4230',
		number: '4230',
		text: 'فَقَضَىٰهُنَّ سَبْعَ سَمَٰوَاتٍۢ فِى يَوْمَيْنِ وَأَوْحَىٰ فِى كُلِّ سَمَآءٍ أَمْرَهَا ۚ وَزَيَّنَّا ٱلسَّمَآءَ ٱلدُّنْيَا بِمَصَٰبِيحَ وَحِفْظًۭا ۚ ذَٰلِكَ تَقْدِيرُ ٱلْعَزِيزِ ٱلْعَلِيمِ',
		number_in_surah: '12',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4231',
		number: '4231',
		text: 'فَإِنْ أَعْرَضُوا۟ فَقُلْ أَنذَرْتُكُمْ صَٰعِقَةًۭ مِّثْلَ صَٰعِقَةِ عَادٍۢ وَثَمُودَ',
		number_in_surah: '13',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4232',
		number: '4232',
		text: 'إِذْ جَآءَتْهُمُ ٱلرُّسُلُ مِنۢ بَيْنِ أَيْدِيهِمْ وَمِنْ خَلْفِهِمْ أَلَّا تَعْبُدُوٓا۟ إِلَّا ٱللَّهَ ۖ قَالُوا۟ لَوْ شَآءَ رَبُّنَا لَأَنزَلَ مَلَٰٓئِكَةًۭ فَإِنَّا بِمَآ أُرْسِلْتُم بِهِۦ كَٰفِرُونَ',
		number_in_surah: '14',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4233',
		number: '4233',
		text: 'فَأَمَّا عَادٌۭ فَٱسْتَكْبَرُوا۟ فِى ٱلْأَرْضِ بِغَيْرِ ٱلْحَقِّ وَقَالُوا۟ مَنْ أَشَدُّ مِنَّا قُوَّةً ۖ أَوَلَمْ يَرَوْا۟ أَنَّ ٱللَّهَ ٱلَّذِى خَلَقَهُمْ هُوَ أَشَدُّ مِنْهُمْ قُوَّةًۭ ۖ وَكَانُوا۟ بِـَٔايَٰتِنَا يَجْحَدُونَ',
		number_in_surah: '15',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4234',
		number: '4234',
		text: 'فَأَرْسَلْنَا عَلَيْهِمْ رِيحًۭا صَرْصَرًۭا فِىٓ أَيَّامٍۢ نَّحِسَاتٍۢ لِّنُذِيقَهُمْ عَذَابَ ٱلْخِزْىِ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ وَلَعَذَابُ ٱلْءَاخِرَةِ أَخْزَىٰ ۖ وَهُمْ لَا يُنصَرُونَ',
		number_in_surah: '16',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4235',
		number: '4235',
		text: 'وَأَمَّا ثَمُودُ فَهَدَيْنَٰهُمْ فَٱسْتَحَبُّوا۟ ٱلْعَمَىٰ عَلَى ٱلْهُدَىٰ فَأَخَذَتْهُمْ صَٰعِقَةُ ٱلْعَذَابِ ٱلْهُونِ بِمَا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '17',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4236',
		number: '4236',
		text: 'وَنَجَّيْنَا ٱلَّذِينَ ءَامَنُوا۟ وَكَانُوا۟ يَتَّقُونَ',
		number_in_surah: '18',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4237',
		number: '4237',
		text: 'وَيَوْمَ يُحْشَرُ أَعْدَآءُ ٱللَّهِ إِلَى ٱلنَّارِ فَهُمْ يُوزَعُونَ',
		number_in_surah: '19',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4238',
		number: '4238',
		text: 'حَتَّىٰٓ إِذَا مَا جَآءُوهَا شَهِدَ عَلَيْهِمْ سَمْعُهُمْ وَأَبْصَٰرُهُمْ وَجُلُودُهُم بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '20',
		page: '478',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4239',
		number: '4239',
		text: 'وَقَالُوا۟ لِجُلُودِهِمْ لِمَ شَهِدتُّمْ عَلَيْنَا ۖ قَالُوٓا۟ أَنطَقَنَا ٱللَّهُ ٱلَّذِىٓ أَنطَقَ كُلَّ شَىْءٍۢ وَهُوَ خَلَقَكُمْ أَوَّلَ مَرَّةٍۢ وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '21',
		page: '479',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:10',
		updated_at: '2018-06-07 08:07:10',
	},
	{
		id: '4240',
		number: '4240',
		text: 'وَمَا كُنتُمْ تَسْتَتِرُونَ أَن يَشْهَدَ عَلَيْكُمْ سَمْعُكُمْ وَلَآ أَبْصَٰرُكُمْ وَلَا جُلُودُكُمْ وَلَٰكِن ظَنَنتُمْ أَنَّ ٱللَّهَ لَا يَعْلَمُ كَثِيرًۭا مِّمَّا تَعْمَلُونَ',
		number_in_surah: '22',
		page: '479',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4241',
		number: '4241',
		text: 'وَذَٰلِكُمْ ظَنُّكُمُ ٱلَّذِى ظَنَنتُم بِرَبِّكُمْ أَرْدَىٰكُمْ فَأَصْبَحْتُم مِّنَ ٱلْخَٰسِرِينَ',
		number_in_surah: '23',
		page: '479',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4242',
		number: '4242',
		text: 'فَإِن يَصْبِرُوا۟ فَٱلنَّارُ مَثْوًۭى لَّهُمْ ۖ وَإِن يَسْتَعْتِبُوا۟ فَمَا هُم مِّنَ ٱلْمُعْتَبِينَ',
		number_in_surah: '24',
		page: '479',
		surah_id: '41',
		hizb_id: '191',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4243',
		number: '4243',
		text: '۞ وَقَيَّضْنَا لَهُمْ قُرَنَآءَ فَزَيَّنُوا۟ لَهُم مَّا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَحَقَّ عَلَيْهِمُ ٱلْقَوْلُ فِىٓ أُمَمٍۢ قَدْ خَلَتْ مِن قَبْلِهِم مِّنَ ٱلْجِنِّ وَٱلْإِنسِ ۖ إِنَّهُمْ كَانُوا۟ خَٰسِرِينَ',
		number_in_surah: '25',
		page: '479',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4244',
		number: '4244',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ لَا تَسْمَعُوا۟ لِهَٰذَا ٱلْقُرْءَانِ وَٱلْغَوْا۟ فِيهِ لَعَلَّكُمْ تَغْلِبُونَ',
		number_in_surah: '26',
		page: '479',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4245',
		number: '4245',
		text: 'فَلَنُذِيقَنَّ ٱلَّذِينَ كَفَرُوا۟ عَذَابًۭا شَدِيدًۭا وَلَنَجْزِيَنَّهُمْ أَسْوَأَ ٱلَّذِى كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '27',
		page: '479',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4246',
		number: '4246',
		text: 'ذَٰلِكَ جَزَآءُ أَعْدَآءِ ٱللَّهِ ٱلنَّارُ ۖ لَهُمْ فِيهَا دَارُ ٱلْخُلْدِ ۖ جَزَآءًۢ بِمَا كَانُوا۟ بِـَٔايَٰتِنَا يَجْحَدُونَ',
		number_in_surah: '28',
		page: '479',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4247',
		number: '4247',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ رَبَّنَآ أَرِنَا ٱلَّذَيْنِ أَضَلَّانَا مِنَ ٱلْجِنِّ وَٱلْإِنسِ نَجْعَلْهُمَا تَحْتَ أَقْدَامِنَا لِيَكُونَا مِنَ ٱلْأَسْفَلِينَ',
		number_in_surah: '29',
		page: '479',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4248',
		number: '4248',
		text: 'إِنَّ ٱلَّذِينَ قَالُوا۟ رَبُّنَا ٱللَّهُ ثُمَّ ٱسْتَقَٰمُوا۟ تَتَنَزَّلُ عَلَيْهِمُ ٱلْمَلَٰٓئِكَةُ أَلَّا تَخَافُوا۟ وَلَا تَحْزَنُوا۟ وَأَبْشِرُوا۟ بِٱلْجَنَّةِ ٱلَّتِى كُنتُمْ تُوعَدُونَ',
		number_in_surah: '30',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4249',
		number: '4249',
		text: 'نَحْنُ أَوْلِيَآؤُكُمْ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا وَفِى ٱلْءَاخِرَةِ ۖ وَلَكُمْ فِيهَا مَا تَشْتَهِىٓ أَنفُسُكُمْ وَلَكُمْ فِيهَا مَا تَدَّعُونَ',
		number_in_surah: '31',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4250',
		number: '4250',
		text: 'نُزُلًۭا مِّنْ غَفُورٍۢ رَّحِيمٍۢ',
		number_in_surah: '32',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4251',
		number: '4251',
		text: 'وَمَنْ أَحْسَنُ قَوْلًۭا مِّمَّن دَعَآ إِلَى ٱللَّهِ وَعَمِلَ صَٰلِحًۭا وَقَالَ إِنَّنِى مِنَ ٱلْمُسْلِمِينَ',
		number_in_surah: '33',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4252',
		number: '4252',
		text: 'وَلَا تَسْتَوِى ٱلْحَسَنَةُ وَلَا ٱلسَّيِّئَةُ ۚ ٱدْفَعْ بِٱلَّتِى هِىَ أَحْسَنُ فَإِذَا ٱلَّذِى بَيْنَكَ وَبَيْنَهُۥ عَدَٰوَةٌۭ كَأَنَّهُۥ وَلِىٌّ حَمِيمٌۭ',
		number_in_surah: '34',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4253',
		number: '4253',
		text: 'وَمَا يُلَقَّىٰهَآ إِلَّا ٱلَّذِينَ صَبَرُوا۟ وَمَا يُلَقَّىٰهَآ إِلَّا ذُو حَظٍّ عَظِيمٍۢ',
		number_in_surah: '35',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4254',
		number: '4254',
		text: 'وَإِمَّا يَنزَغَنَّكَ مِنَ ٱلشَّيْطَٰنِ نَزْغٌۭ فَٱسْتَعِذْ بِٱللَّهِ ۖ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '36',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4255',
		number: '4255',
		text: 'وَمِنْ ءَايَٰتِهِ ٱلَّيْلُ وَٱلنَّهَارُ وَٱلشَّمْسُ وَٱلْقَمَرُ ۚ لَا تَسْجُدُوا۟ لِلشَّمْسِ وَلَا لِلْقَمَرِ وَٱسْجُدُوا۟ لِلَّهِ ٱلَّذِى خَلَقَهُنَّ إِن كُنتُمْ إِيَّاهُ تَعْبُدُونَ',
		number_in_surah: '37',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4256',
		number: '4256',
		text: 'فَإِنِ ٱسْتَكْبَرُوا۟ فَٱلَّذِينَ عِندَ رَبِّكَ يُسَبِّحُونَ لَهُۥ بِٱلَّيْلِ وَٱلنَّهَارِ وَهُمْ لَا يَسْـَٔمُونَ ۩',
		number_in_surah: '38',
		page: '480',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '1',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4257',
		number: '4257',
		text: 'وَمِنْ ءَايَٰتِهِۦٓ أَنَّكَ تَرَى ٱلْأَرْضَ خَٰشِعَةًۭ فَإِذَآ أَنزَلْنَا عَلَيْهَا ٱلْمَآءَ ٱهْتَزَّتْ وَرَبَتْ ۚ إِنَّ ٱلَّذِىٓ أَحْيَاهَا لَمُحْىِ ٱلْمَوْتَىٰٓ ۚ إِنَّهُۥ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '39',
		page: '481',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4258',
		number: '4258',
		text: 'إِنَّ ٱلَّذِينَ يُلْحِدُونَ فِىٓ ءَايَٰتِنَا لَا يَخْفَوْنَ عَلَيْنَآ ۗ أَفَمَن يُلْقَىٰ فِى ٱلنَّارِ خَيْرٌ أَم مَّن يَأْتِىٓ ءَامِنًۭا يَوْمَ ٱلْقِيَٰمَةِ ۚ ٱعْمَلُوا۟ مَا شِئْتُمْ ۖ إِنَّهُۥ بِمَا تَعْمَلُونَ بَصِيرٌ',
		number_in_surah: '40',
		page: '481',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4259',
		number: '4259',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ بِٱلذِّكْرِ لَمَّا جَآءَهُمْ ۖ وَإِنَّهُۥ لَكِتَٰبٌ عَزِيزٌۭ',
		number_in_surah: '41',
		page: '481',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4260',
		number: '4260',
		text: 'لَّا يَأْتِيهِ ٱلْبَٰطِلُ مِنۢ بَيْنِ يَدَيْهِ وَلَا مِنْ خَلْفِهِۦ ۖ تَنزِيلٌۭ مِّنْ حَكِيمٍ حَمِيدٍۢ',
		number_in_surah: '42',
		page: '481',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4261',
		number: '4261',
		text: 'مَّا يُقَالُ لَكَ إِلَّا مَا قَدْ قِيلَ لِلرُّسُلِ مِن قَبْلِكَ ۚ إِنَّ رَبَّكَ لَذُو مَغْفِرَةٍۢ وَذُو عِقَابٍ أَلِيمٍۢ',
		number_in_surah: '43',
		page: '481',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4262',
		number: '4262',
		text: 'وَلَوْ جَعَلْنَٰهُ قُرْءَانًا أَعْجَمِيًّۭا لَّقَالُوا۟ لَوْلَا فُصِّلَتْ ءَايَٰتُهُۥٓ ۖ ءَا۬عْجَمِىٌّۭ وَعَرَبِىٌّۭ ۗ قُلْ هُوَ لِلَّذِينَ ءَامَنُوا۟ هُدًۭى وَشِفَآءٌۭ ۖ وَٱلَّذِينَ لَا يُؤْمِنُونَ فِىٓ ءَاذَانِهِمْ وَقْرٌۭ وَهُوَ عَلَيْهِمْ عَمًى ۚ أُو۟لَٰٓئِكَ يُنَادَوْنَ مِن مَّكَانٍۭ بَعِيدٍۢ',
		number_in_surah: '44',
		page: '481',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4263',
		number: '4263',
		text: 'وَلَقَدْ ءَاتَيْنَا مُوسَى ٱلْكِتَٰبَ فَٱخْتُلِفَ فِيهِ ۗ وَلَوْلَا كَلِمَةٌۭ سَبَقَتْ مِن رَّبِّكَ لَقُضِىَ بَيْنَهُمْ ۚ وَإِنَّهُمْ لَفِى شَكٍّۢ مِّنْهُ مُرِيبٍۢ',
		number_in_surah: '45',
		page: '481',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4264',
		number: '4264',
		text: 'مَّنْ عَمِلَ صَٰلِحًۭا فَلِنَفْسِهِۦ ۖ وَمَنْ أَسَآءَ فَعَلَيْهَا ۗ وَمَا رَبُّكَ بِظَلَّٰمٍۢ لِّلْعَبِيدِ',
		number_in_surah: '46',
		page: '481',
		surah_id: '41',
		hizb_id: '192',
		juz_id: '24',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4265',
		number: '4265',
		text: '۞ إِلَيْهِ يُرَدُّ عِلْمُ ٱلسَّاعَةِ ۚ وَمَا تَخْرُجُ مِن ثَمَرَٰتٍۢ مِّنْ أَكْمَامِهَا وَمَا تَحْمِلُ مِنْ أُنثَىٰ وَلَا تَضَعُ إِلَّا بِعِلْمِهِۦ ۚ وَيَوْمَ يُنَادِيهِمْ أَيْنَ شُرَكَآءِى قَالُوٓا۟ ءَاذَنَّٰكَ مَا مِنَّا مِن شَهِيدٍۢ',
		number_in_surah: '47',
		page: '482',
		surah_id: '41',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4266',
		number: '4266',
		text: 'وَضَلَّ عَنْهُم مَّا كَانُوا۟ يَدْعُونَ مِن قَبْلُ ۖ وَظَنُّوا۟ مَا لَهُم مِّن مَّحِيصٍۢ',
		number_in_surah: '48',
		page: '482',
		surah_id: '41',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4267',
		number: '4267',
		text: 'لَّا يَسْـَٔمُ ٱلْإِنسَٰنُ مِن دُعَآءِ ٱلْخَيْرِ وَإِن مَّسَّهُ ٱلشَّرُّ فَيَـُٔوسٌۭ قَنُوطٌۭ',
		number_in_surah: '49',
		page: '482',
		surah_id: '41',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4268',
		number: '4268',
		text: 'وَلَئِنْ أَذَقْنَٰهُ رَحْمَةًۭ مِّنَّا مِنۢ بَعْدِ ضَرَّآءَ مَسَّتْهُ لَيَقُولَنَّ هَٰذَا لِى وَمَآ أَظُنُّ ٱلسَّاعَةَ قَآئِمَةًۭ وَلَئِن رُّجِعْتُ إِلَىٰ رَبِّىٓ إِنَّ لِى عِندَهُۥ لَلْحُسْنَىٰ ۚ فَلَنُنَبِّئَنَّ ٱلَّذِينَ كَفَرُوا۟ بِمَا عَمِلُوا۟ وَلَنُذِيقَنَّهُم مِّنْ عَذَابٍ غَلِيظٍۢ',
		number_in_surah: '50',
		page: '482',
		surah_id: '41',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4269',
		number: '4269',
		text: 'وَإِذَآ أَنْعَمْنَا عَلَى ٱلْإِنسَٰنِ أَعْرَضَ وَنَـَٔا بِجَانِبِهِۦ وَإِذَا مَسَّهُ ٱلشَّرُّ فَذُو دُعَآءٍ عَرِيضٍۢ',
		number_in_surah: '51',
		page: '482',
		surah_id: '41',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4270',
		number: '4270',
		text: 'قُلْ أَرَءَيْتُمْ إِن كَانَ مِنْ عِندِ ٱللَّهِ ثُمَّ كَفَرْتُم بِهِۦ مَنْ أَضَلُّ مِمَّنْ هُوَ فِى شِقَاقٍۭ بَعِيدٍۢ',
		number_in_surah: '52',
		page: '482',
		surah_id: '41',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4271',
		number: '4271',
		text: 'سَنُرِيهِمْ ءَايَٰتِنَا فِى ٱلْءَافَاقِ وَفِىٓ أَنفُسِهِمْ حَتَّىٰ يَتَبَيَّنَ لَهُمْ أَنَّهُ ٱلْحَقُّ ۗ أَوَلَمْ يَكْفِ بِرَبِّكَ أَنَّهُۥ عَلَىٰ كُلِّ شَىْءٍۢ شَهِيدٌ',
		number_in_surah: '53',
		page: '482',
		surah_id: '41',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4272',
		number: '4272',
		text: 'أَلَآ إِنَّهُمْ فِى مِرْيَةٍۢ مِّن لِّقَآءِ رَبِّهِمْ ۗ أَلَآ إِنَّهُۥ بِكُلِّ شَىْءٍۢ مُّحِيطٌۢ',
		number_in_surah: '54',
		page: '482',
		surah_id: '41',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4273',
		number: '4273',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ حمٓ',
		number_in_surah: '1',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4274',
		number: '4274',
		text: 'عٓسٓقٓ',
		number_in_surah: '2',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4275',
		number: '4275',
		text: 'كَذَٰلِكَ يُوحِىٓ إِلَيْكَ وَإِلَى ٱلَّذِينَ مِن قَبْلِكَ ٱللَّهُ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '3',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4276',
		number: '4276',
		text: 'لَهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۖ وَهُوَ ٱلْعَلِىُّ ٱلْعَظِيمُ',
		number_in_surah: '4',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4277',
		number: '4277',
		text: 'تَكَادُ ٱلسَّمَٰوَٰتُ يَتَفَطَّرْنَ مِن فَوْقِهِنَّ ۚ وَٱلْمَلَٰٓئِكَةُ يُسَبِّحُونَ بِحَمْدِ رَبِّهِمْ وَيَسْتَغْفِرُونَ لِمَن فِى ٱلْأَرْضِ ۗ أَلَآ إِنَّ ٱللَّهَ هُوَ ٱلْغَفُورُ ٱلرَّحِيمُ',
		number_in_surah: '5',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4278',
		number: '4278',
		text: 'وَٱلَّذِينَ ٱتَّخَذُوا۟ مِن دُونِهِۦٓ أَوْلِيَآءَ ٱللَّهُ حَفِيظٌ عَلَيْهِمْ وَمَآ أَنتَ عَلَيْهِم بِوَكِيلٍۢ',
		number_in_surah: '6',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4279',
		number: '4279',
		text: 'وَكَذَٰلِكَ أَوْحَيْنَآ إِلَيْكَ قُرْءَانًا عَرَبِيًّۭا لِّتُنذِرَ أُمَّ ٱلْقُرَىٰ وَمَنْ حَوْلَهَا وَتُنذِرَ يَوْمَ ٱلْجَمْعِ لَا رَيْبَ فِيهِ ۚ فَرِيقٌۭ فِى ٱلْجَنَّةِ وَفَرِيقٌۭ فِى ٱلسَّعِيرِ',
		number_in_surah: '7',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4280',
		number: '4280',
		text: 'وَلَوْ شَآءَ ٱللَّهُ لَجَعَلَهُمْ أُمَّةًۭ وَٰحِدَةًۭ وَلَٰكِن يُدْخِلُ مَن يَشَآءُ فِى رَحْمَتِهِۦ ۚ وَٱلظَّٰلِمُونَ مَا لَهُم مِّن وَلِىٍّۢ وَلَا نَصِيرٍ',
		number_in_surah: '8',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4281',
		number: '4281',
		text: 'أَمِ ٱتَّخَذُوا۟ مِن دُونِهِۦٓ أَوْلِيَآءَ ۖ فَٱللَّهُ هُوَ ٱلْوَلِىُّ وَهُوَ يُحْىِ ٱلْمَوْتَىٰ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '9',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4282',
		number: '4282',
		text: 'وَمَا ٱخْتَلَفْتُمْ فِيهِ مِن شَىْءٍۢ فَحُكْمُهُۥٓ إِلَى ٱللَّهِ ۚ ذَٰلِكُمُ ٱللَّهُ رَبِّى عَلَيْهِ تَوَكَّلْتُ وَإِلَيْهِ أُنِيبُ',
		number_in_surah: '10',
		page: '483',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4283',
		number: '4283',
		text: 'فَاطِرُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ جَعَلَ لَكُم مِّنْ أَنفُسِكُمْ أَزْوَٰجًۭا وَمِنَ ٱلْأَنْعَٰمِ أَزْوَٰجًۭا ۖ يَذْرَؤُكُمْ فِيهِ ۚ لَيْسَ كَمِثْلِهِۦ شَىْءٌۭ ۖ وَهُوَ ٱلسَّمِيعُ ٱلْبَصِيرُ',
		number_in_surah: '11',
		page: '484',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4284',
		number: '4284',
		text: 'لَهُۥ مَقَالِيدُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ يَبْسُطُ ٱلرِّزْقَ لِمَن يَشَآءُ وَيَقْدِرُ ۚ إِنَّهُۥ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '12',
		page: '484',
		surah_id: '42',
		hizb_id: '193',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4285',
		number: '4285',
		text: '۞ شَرَعَ لَكُم مِّنَ ٱلدِّينِ مَا وَصَّىٰ بِهِۦ نُوحًۭا وَٱلَّذِىٓ أَوْحَيْنَآ إِلَيْكَ وَمَا وَصَّيْنَا بِهِۦٓ إِبْرَٰهِيمَ وَمُوسَىٰ وَعِيسَىٰٓ ۖ أَنْ أَقِيمُوا۟ ٱلدِّينَ وَلَا تَتَفَرَّقُوا۟ فِيهِ ۚ كَبُرَ عَلَى ٱلْمُشْرِكِينَ مَا تَدْعُوهُمْ إِلَيْهِ ۚ ٱللَّهُ يَجْتَبِىٓ إِلَيْهِ مَن يَشَآءُ وَيَهْدِىٓ إِلَيْهِ مَن يُنِيبُ',
		number_in_surah: '13',
		page: '484',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4286',
		number: '4286',
		text: 'وَمَا تَفَرَّقُوٓا۟ إِلَّا مِنۢ بَعْدِ مَا جَآءَهُمُ ٱلْعِلْمُ بَغْيًۢا بَيْنَهُمْ ۚ وَلَوْلَا كَلِمَةٌۭ سَبَقَتْ مِن رَّبِّكَ إِلَىٰٓ أَجَلٍۢ مُّسَمًّۭى لَّقُضِىَ بَيْنَهُمْ ۚ وَإِنَّ ٱلَّذِينَ أُورِثُوا۟ ٱلْكِتَٰبَ مِنۢ بَعْدِهِمْ لَفِى شَكٍّۢ مِّنْهُ مُرِيبٍۢ',
		number_in_surah: '14',
		page: '484',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4287',
		number: '4287',
		text: 'فَلِذَٰلِكَ فَٱدْعُ ۖ وَٱسْتَقِمْ كَمَآ أُمِرْتَ ۖ وَلَا تَتَّبِعْ أَهْوَآءَهُمْ ۖ وَقُلْ ءَامَنتُ بِمَآ أَنزَلَ ٱللَّهُ مِن كِتَٰبٍۢ ۖ وَأُمِرْتُ لِأَعْدِلَ بَيْنَكُمُ ۖ ٱللَّهُ رَبُّنَا وَرَبُّكُمْ ۖ لَنَآ أَعْمَٰلُنَا وَلَكُمْ أَعْمَٰلُكُمْ ۖ لَا حُجَّةَ بَيْنَنَا وَبَيْنَكُمُ ۖ ٱللَّهُ يَجْمَعُ بَيْنَنَا ۖ وَإِلَيْهِ ٱلْمَصِيرُ',
		number_in_surah: '15',
		page: '484',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4288',
		number: '4288',
		text: 'وَٱلَّذِينَ يُحَآجُّونَ فِى ٱللَّهِ مِنۢ بَعْدِ مَا ٱسْتُجِيبَ لَهُۥ حُجَّتُهُمْ دَاحِضَةٌ عِندَ رَبِّهِمْ وَعَلَيْهِمْ غَضَبٌۭ وَلَهُمْ عَذَابٌۭ شَدِيدٌ',
		number_in_surah: '16',
		page: '485',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4289',
		number: '4289',
		text: 'ٱللَّهُ ٱلَّذِىٓ أَنزَلَ ٱلْكِتَٰبَ بِٱلْحَقِّ وَٱلْمِيزَانَ ۗ وَمَا يُدْرِيكَ لَعَلَّ ٱلسَّاعَةَ قَرِيبٌۭ',
		number_in_surah: '17',
		page: '485',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4290',
		number: '4290',
		text: 'يَسْتَعْجِلُ بِهَا ٱلَّذِينَ لَا يُؤْمِنُونَ بِهَا ۖ وَٱلَّذِينَ ءَامَنُوا۟ مُشْفِقُونَ مِنْهَا وَيَعْلَمُونَ أَنَّهَا ٱلْحَقُّ ۗ أَلَآ إِنَّ ٱلَّذِينَ يُمَارُونَ فِى ٱلسَّاعَةِ لَفِى ضَلَٰلٍۭ بَعِيدٍ',
		number_in_surah: '18',
		page: '485',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4291',
		number: '4291',
		text: 'ٱللَّهُ لَطِيفٌۢ بِعِبَادِهِۦ يَرْزُقُ مَن يَشَآءُ ۖ وَهُوَ ٱلْقَوِىُّ ٱلْعَزِيزُ',
		number_in_surah: '19',
		page: '485',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4292',
		number: '4292',
		text: 'مَن كَانَ يُرِيدُ حَرْثَ ٱلْءَاخِرَةِ نَزِدْ لَهُۥ فِى حَرْثِهِۦ ۖ وَمَن كَانَ يُرِيدُ حَرْثَ ٱلدُّنْيَا نُؤْتِهِۦ مِنْهَا وَمَا لَهُۥ فِى ٱلْءَاخِرَةِ مِن نَّصِيبٍ',
		number_in_surah: '20',
		page: '485',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4293',
		number: '4293',
		text: 'أَمْ لَهُمْ شُرَكَٰٓؤُا۟ شَرَعُوا۟ لَهُم مِّنَ ٱلدِّينِ مَا لَمْ يَأْذَنۢ بِهِ ٱللَّهُ ۚ وَلَوْلَا كَلِمَةُ ٱلْفَصْلِ لَقُضِىَ بَيْنَهُمْ ۗ وَإِنَّ ٱلظَّٰلِمِينَ لَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '21',
		page: '485',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4294',
		number: '4294',
		text: 'تَرَى ٱلظَّٰلِمِينَ مُشْفِقِينَ مِمَّا كَسَبُوا۟ وَهُوَ وَاقِعٌۢ بِهِمْ ۗ وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ فِى رَوْضَاتِ ٱلْجَنَّاتِ ۖ لَهُم مَّا يَشَآءُونَ عِندَ رَبِّهِمْ ۚ ذَٰلِكَ هُوَ ٱلْفَضْلُ ٱلْكَبِيرُ',
		number_in_surah: '22',
		page: '485',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4295',
		number: '4295',
		text: 'ذَٰلِكَ ٱلَّذِى يُبَشِّرُ ٱللَّهُ عِبَادَهُ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ ۗ قُل لَّآ أَسْـَٔلُكُمْ عَلَيْهِ أَجْرًا إِلَّا ٱلْمَوَدَّةَ فِى ٱلْقُرْبَىٰ ۗ وَمَن يَقْتَرِفْ حَسَنَةًۭ نَّزِدْ لَهُۥ فِيهَا حُسْنًا ۚ إِنَّ ٱللَّهَ غَفُورٌۭ شَكُورٌ',
		number_in_surah: '23',
		page: '486',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4296',
		number: '4296',
		text: 'أَمْ يَقُولُونَ ٱفْتَرَىٰ عَلَى ٱللَّهِ كَذِبًۭا ۖ فَإِن يَشَإِ ٱللَّهُ يَخْتِمْ عَلَىٰ قَلْبِكَ ۗ وَيَمْحُ ٱللَّهُ ٱلْبَٰطِلَ وَيُحِقُّ ٱلْحَقَّ بِكَلِمَٰتِهِۦٓ ۚ إِنَّهُۥ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '24',
		page: '486',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4297',
		number: '4297',
		text: 'وَهُوَ ٱلَّذِى يَقْبَلُ ٱلتَّوْبَةَ عَنْ عِبَادِهِۦ وَيَعْفُوا۟ عَنِ ٱلسَّيِّـَٔاتِ وَيَعْلَمُ مَا تَفْعَلُونَ',
		number_in_surah: '25',
		page: '486',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4298',
		number: '4298',
		text: 'وَيَسْتَجِيبُ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ وَيَزِيدُهُم مِّن فَضْلِهِۦ ۚ وَٱلْكَٰفِرُونَ لَهُمْ عَذَابٌۭ شَدِيدٌۭ',
		number_in_surah: '26',
		page: '486',
		surah_id: '42',
		hizb_id: '194',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4299',
		number: '4299',
		text: '۞ وَلَوْ بَسَطَ ٱللَّهُ ٱلرِّزْقَ لِعِبَادِهِۦ لَبَغَوْا۟ فِى ٱلْأَرْضِ وَلَٰكِن يُنَزِّلُ بِقَدَرٍۢ مَّا يَشَآءُ ۚ إِنَّهُۥ بِعِبَادِهِۦ خَبِيرٌۢ بَصِيرٌۭ',
		number_in_surah: '27',
		page: '486',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4300',
		number: '4300',
		text: 'وَهُوَ ٱلَّذِى يُنَزِّلُ ٱلْغَيْثَ مِنۢ بَعْدِ مَا قَنَطُوا۟ وَيَنشُرُ رَحْمَتَهُۥ ۚ وَهُوَ ٱلْوَلِىُّ ٱلْحَمِيدُ',
		number_in_surah: '28',
		page: '486',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4301',
		number: '4301',
		text: 'وَمِنْ ءَايَٰتِهِۦ خَلْقُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَثَّ فِيهِمَا مِن دَآبَّةٍۢ ۚ وَهُوَ عَلَىٰ جَمْعِهِمْ إِذَا يَشَآءُ قَدِيرٌۭ',
		number_in_surah: '29',
		page: '486',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4302',
		number: '4302',
		text: 'وَمَآ أَصَٰبَكُم مِّن مُّصِيبَةٍۢ فَبِمَا كَسَبَتْ أَيْدِيكُمْ وَيَعْفُوا۟ عَن كَثِيرٍۢ',
		number_in_surah: '30',
		page: '486',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4303',
		number: '4303',
		text: 'وَمَآ أَنتُم بِمُعْجِزِينَ فِى ٱلْأَرْضِ ۖ وَمَا لَكُم مِّن دُونِ ٱللَّهِ مِن وَلِىٍّۢ وَلَا نَصِيرٍۢ',
		number_in_surah: '31',
		page: '486',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4304',
		number: '4304',
		text: 'وَمِنْ ءَايَٰتِهِ ٱلْجَوَارِ فِى ٱلْبَحْرِ كَٱلْأَعْلَٰمِ',
		number_in_surah: '32',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4305',
		number: '4305',
		text: 'إِن يَشَأْ يُسْكِنِ ٱلرِّيحَ فَيَظْلَلْنَ رَوَاكِدَ عَلَىٰ ظَهْرِهِۦٓ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّكُلِّ صَبَّارٍۢ شَكُورٍ',
		number_in_surah: '33',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4306',
		number: '4306',
		text: 'أَوْ يُوبِقْهُنَّ بِمَا كَسَبُوا۟ وَيَعْفُ عَن كَثِيرٍۢ',
		number_in_surah: '34',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4307',
		number: '4307',
		text: 'وَيَعْلَمَ ٱلَّذِينَ يُجَٰدِلُونَ فِىٓ ءَايَٰتِنَا مَا لَهُم مِّن مَّحِيصٍۢ',
		number_in_surah: '35',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4308',
		number: '4308',
		text: 'فَمَآ أُوتِيتُم مِّن شَىْءٍۢ فَمَتَٰعُ ٱلْحَيَوٰةِ ٱلدُّنْيَا ۖ وَمَا عِندَ ٱللَّهِ خَيْرٌۭ وَأَبْقَىٰ لِلَّذِينَ ءَامَنُوا۟ وَعَلَىٰ رَبِّهِمْ يَتَوَكَّلُونَ',
		number_in_surah: '36',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4309',
		number: '4309',
		text: 'وَٱلَّذِينَ يَجْتَنِبُونَ كَبَٰٓئِرَ ٱلْإِثْمِ وَٱلْفَوَٰحِشَ وَإِذَا مَا غَضِبُوا۟ هُمْ يَغْفِرُونَ',
		number_in_surah: '37',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4310',
		number: '4310',
		text: 'وَٱلَّذِينَ ٱسْتَجَابُوا۟ لِرَبِّهِمْ وَأَقَامُوا۟ ٱلصَّلَوٰةَ وَأَمْرُهُمْ شُورَىٰ بَيْنَهُمْ وَمِمَّا رَزَقْنَٰهُمْ يُنفِقُونَ',
		number_in_surah: '38',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4311',
		number: '4311',
		text: 'وَٱلَّذِينَ إِذَآ أَصَابَهُمُ ٱلْبَغْىُ هُمْ يَنتَصِرُونَ',
		number_in_surah: '39',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4312',
		number: '4312',
		text: 'وَجَزَٰٓؤُا۟ سَيِّئَةٍۢ سَيِّئَةٌۭ مِّثْلُهَا ۖ فَمَنْ عَفَا وَأَصْلَحَ فَأَجْرُهُۥ عَلَى ٱللَّهِ ۚ إِنَّهُۥ لَا يُحِبُّ ٱلظَّٰلِمِينَ',
		number_in_surah: '40',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4313',
		number: '4313',
		text: 'وَلَمَنِ ٱنتَصَرَ بَعْدَ ظُلْمِهِۦ فَأُو۟لَٰٓئِكَ مَا عَلَيْهِم مِّن سَبِيلٍ',
		number_in_surah: '41',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4314',
		number: '4314',
		text: 'إِنَّمَا ٱلسَّبِيلُ عَلَى ٱلَّذِينَ يَظْلِمُونَ ٱلنَّاسَ وَيَبْغُونَ فِى ٱلْأَرْضِ بِغَيْرِ ٱلْحَقِّ ۚ أُو۟لَٰٓئِكَ لَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '42',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4315',
		number: '4315',
		text: 'وَلَمَن صَبَرَ وَغَفَرَ إِنَّ ذَٰلِكَ لَمِنْ عَزْمِ ٱلْأُمُورِ',
		number_in_surah: '43',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4316',
		number: '4316',
		text: 'وَمَن يُضْلِلِ ٱللَّهُ فَمَا لَهُۥ مِن وَلِىٍّۢ مِّنۢ بَعْدِهِۦ ۗ وَتَرَى ٱلظَّٰلِمِينَ لَمَّا رَأَوُا۟ ٱلْعَذَابَ يَقُولُونَ هَلْ إِلَىٰ مَرَدٍّۢ مِّن سَبِيلٍۢ',
		number_in_surah: '44',
		page: '487',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4317',
		number: '4317',
		text: 'وَتَرَىٰهُمْ يُعْرَضُونَ عَلَيْهَا خَٰشِعِينَ مِنَ ٱلذُّلِّ يَنظُرُونَ مِن طَرْفٍ خَفِىٍّۢ ۗ وَقَالَ ٱلَّذِينَ ءَامَنُوٓا۟ إِنَّ ٱلْخَٰسِرِينَ ٱلَّذِينَ خَسِرُوٓا۟ أَنفُسَهُمْ وَأَهْلِيهِمْ يَوْمَ ٱلْقِيَٰمَةِ ۗ أَلَآ إِنَّ ٱلظَّٰلِمِينَ فِى عَذَابٍۢ مُّقِيمٍۢ',
		number_in_surah: '45',
		page: '488',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4318',
		number: '4318',
		text: 'وَمَا كَانَ لَهُم مِّنْ أَوْلِيَآءَ يَنصُرُونَهُم مِّن دُونِ ٱللَّهِ ۗ وَمَن يُضْلِلِ ٱللَّهُ فَمَا لَهُۥ مِن سَبِيلٍ',
		number_in_surah: '46',
		page: '488',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4319',
		number: '4319',
		text: 'ٱسْتَجِيبُوا۟ لِرَبِّكُم مِّن قَبْلِ أَن يَأْتِىَ يَوْمٌۭ لَّا مَرَدَّ لَهُۥ مِنَ ٱللَّهِ ۚ مَا لَكُم مِّن مَّلْجَإٍۢ يَوْمَئِذٍۢ وَمَا لَكُم مِّن نَّكِيرٍۢ',
		number_in_surah: '47',
		page: '488',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4320',
		number: '4320',
		text: 'فَإِنْ أَعْرَضُوا۟ فَمَآ أَرْسَلْنَٰكَ عَلَيْهِمْ حَفِيظًا ۖ إِنْ عَلَيْكَ إِلَّا ٱلْبَلَٰغُ ۗ وَإِنَّآ إِذَآ أَذَقْنَا ٱلْإِنسَٰنَ مِنَّا رَحْمَةًۭ فَرِحَ بِهَا ۖ وَإِن تُصِبْهُمْ سَيِّئَةٌۢ بِمَا قَدَّمَتْ أَيْدِيهِمْ فَإِنَّ ٱلْإِنسَٰنَ كَفُورٌۭ',
		number_in_surah: '48',
		page: '488',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4321',
		number: '4321',
		text: 'لِّلَّهِ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ يَخْلُقُ مَا يَشَآءُ ۚ يَهَبُ لِمَن يَشَآءُ إِنَٰثًۭا وَيَهَبُ لِمَن يَشَآءُ ٱلذُّكُورَ',
		number_in_surah: '49',
		page: '488',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4322',
		number: '4322',
		text: 'أَوْ يُزَوِّجُهُمْ ذُكْرَانًۭا وَإِنَٰثًۭا ۖ وَيَجْعَلُ مَن يَشَآءُ عَقِيمًا ۚ إِنَّهُۥ عَلِيمٌۭ قَدِيرٌۭ',
		number_in_surah: '50',
		page: '488',
		surah_id: '42',
		hizb_id: '195',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4323',
		number: '4323',
		text: '۞ وَمَا كَانَ لِبَشَرٍ أَن يُكَلِّمَهُ ٱللَّهُ إِلَّا وَحْيًا أَوْ مِن وَرَآئِ حِجَابٍ أَوْ يُرْسِلَ رَسُولًۭا فَيُوحِىَ بِإِذْنِهِۦ مَا يَشَآءُ ۚ إِنَّهُۥ عَلِىٌّ حَكِيمٌۭ',
		number_in_surah: '51',
		page: '488',
		surah_id: '42',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4324',
		number: '4324',
		text: 'وَكَذَٰلِكَ أَوْحَيْنَآ إِلَيْكَ رُوحًۭا مِّنْ أَمْرِنَا ۚ مَا كُنتَ تَدْرِى مَا ٱلْكِتَٰبُ وَلَا ٱلْإِيمَٰنُ وَلَٰكِن جَعَلْنَٰهُ نُورًۭا نَّهْدِى بِهِۦ مَن نَّشَآءُ مِنْ عِبَادِنَا ۚ وَإِنَّكَ لَتَهْدِىٓ إِلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '52',
		page: '489',
		surah_id: '42',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4325',
		number: '4325',
		text: 'صِرَٰطِ ٱللَّهِ ٱلَّذِى لَهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۗ أَلَآ إِلَى ٱللَّهِ تَصِيرُ ٱلْأُمُورُ',
		number_in_surah: '53',
		page: '489',
		surah_id: '42',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4326',
		number: '4326',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ حمٓ',
		number_in_surah: '1',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4327',
		number: '4327',
		text: 'وَٱلْكِتَٰبِ ٱلْمُبِينِ',
		number_in_surah: '2',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4328',
		number: '4328',
		text: 'إِنَّا جَعَلْنَٰهُ قُرْءَٰنًا عَرَبِيًّۭا لَّعَلَّكُمْ تَعْقِلُونَ',
		number_in_surah: '3',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4329',
		number: '4329',
		text: 'وَإِنَّهُۥ فِىٓ أُمِّ ٱلْكِتَٰبِ لَدَيْنَا لَعَلِىٌّ حَكِيمٌ',
		number_in_surah: '4',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4330',
		number: '4330',
		text: 'أَفَنَضْرِبُ عَنكُمُ ٱلذِّكْرَ صَفْحًا أَن كُنتُمْ قَوْمًۭا مُّسْرِفِينَ',
		number_in_surah: '5',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4331',
		number: '4331',
		text: 'وَكَمْ أَرْسَلْنَا مِن نَّبِىٍّۢ فِى ٱلْأَوَّلِينَ',
		number_in_surah: '6',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4332',
		number: '4332',
		text: 'وَمَا يَأْتِيهِم مِّن نَّبِىٍّ إِلَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '7',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4333',
		number: '4333',
		text: 'فَأَهْلَكْنَآ أَشَدَّ مِنْهُم بَطْشًۭا وَمَضَىٰ مَثَلُ ٱلْأَوَّلِينَ',
		number_in_surah: '8',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4334',
		number: '4334',
		text: 'وَلَئِن سَأَلْتَهُم مَّنْ خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ لَيَقُولُنَّ خَلَقَهُنَّ ٱلْعَزِيزُ ٱلْعَلِيمُ',
		number_in_surah: '9',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4335',
		number: '4335',
		text: 'ٱلَّذِى جَعَلَ لَكُمُ ٱلْأَرْضَ مَهْدًۭا وَجَعَلَ لَكُمْ فِيهَا سُبُلًۭا لَّعَلَّكُمْ تَهْتَدُونَ',
		number_in_surah: '10',
		page: '489',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4336',
		number: '4336',
		text: 'وَٱلَّذِى نَزَّلَ مِنَ ٱلسَّمَآءِ مَآءًۢ بِقَدَرٍۢ فَأَنشَرْنَا بِهِۦ بَلْدَةًۭ مَّيْتًۭا ۚ كَذَٰلِكَ تُخْرَجُونَ',
		number_in_surah: '11',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4337',
		number: '4337',
		text: 'وَٱلَّذِى خَلَقَ ٱلْأَزْوَٰجَ كُلَّهَا وَجَعَلَ لَكُم مِّنَ ٱلْفُلْكِ وَٱلْأَنْعَٰمِ مَا تَرْكَبُونَ',
		number_in_surah: '12',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4338',
		number: '4338',
		text: 'لِتَسْتَوُۥا۟ عَلَىٰ ظُهُورِهِۦ ثُمَّ تَذْكُرُوا۟ نِعْمَةَ رَبِّكُمْ إِذَا ٱسْتَوَيْتُمْ عَلَيْهِ وَتَقُولُوا۟ سُبْحَٰنَ ٱلَّذِى سَخَّرَ لَنَا هَٰذَا وَمَا كُنَّا لَهُۥ مُقْرِنِينَ',
		number_in_surah: '13',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4339',
		number: '4339',
		text: 'وَإِنَّآ إِلَىٰ رَبِّنَا لَمُنقَلِبُونَ',
		number_in_surah: '14',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4340',
		number: '4340',
		text: 'وَجَعَلُوا۟ لَهُۥ مِنْ عِبَادِهِۦ جُزْءًا ۚ إِنَّ ٱلْإِنسَٰنَ لَكَفُورٌۭ مُّبِينٌ',
		number_in_surah: '15',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4341',
		number: '4341',
		text: 'أَمِ ٱتَّخَذَ مِمَّا يَخْلُقُ بَنَاتٍۢ وَأَصْفَىٰكُم بِٱلْبَنِينَ',
		number_in_surah: '16',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4342',
		number: '4342',
		text: 'وَإِذَا بُشِّرَ أَحَدُهُم بِمَا ضَرَبَ لِلرَّحْمَٰنِ مَثَلًۭا ظَلَّ وَجْهُهُۥ مُسْوَدًّۭا وَهُوَ كَظِيمٌ',
		number_in_surah: '17',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4343',
		number: '4343',
		text: 'أَوَمَن يُنَشَّؤُا۟ فِى ٱلْحِلْيَةِ وَهُوَ فِى ٱلْخِصَامِ غَيْرُ مُبِينٍۢ',
		number_in_surah: '18',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4344',
		number: '4344',
		text: 'وَجَعَلُوا۟ ٱلْمَلَٰٓئِكَةَ ٱلَّذِينَ هُمْ عِبَٰدُ ٱلرَّحْمَٰنِ إِنَٰثًا ۚ أَشَهِدُوا۟ خَلْقَهُمْ ۚ سَتُكْتَبُ شَهَٰدَتُهُمْ وَيُسْـَٔلُونَ',
		number_in_surah: '19',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4345',
		number: '4345',
		text: 'وَقَالُوا۟ لَوْ شَآءَ ٱلرَّحْمَٰنُ مَا عَبَدْنَٰهُم ۗ مَّا لَهُم بِذَٰلِكَ مِنْ عِلْمٍ ۖ إِنْ هُمْ إِلَّا يَخْرُصُونَ',
		number_in_surah: '20',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4346',
		number: '4346',
		text: 'أَمْ ءَاتَيْنَٰهُمْ كِتَٰبًۭا مِّن قَبْلِهِۦ فَهُم بِهِۦ مُسْتَمْسِكُونَ',
		number_in_surah: '21',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4347',
		number: '4347',
		text: 'بَلْ قَالُوٓا۟ إِنَّا وَجَدْنَآ ءَابَآءَنَا عَلَىٰٓ أُمَّةٍۢ وَإِنَّا عَلَىٰٓ ءَاثَٰرِهِم مُّهْتَدُونَ',
		number_in_surah: '22',
		page: '490',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4348',
		number: '4348',
		text: 'وَكَذَٰلِكَ مَآ أَرْسَلْنَا مِن قَبْلِكَ فِى قَرْيَةٍۢ مِّن نَّذِيرٍ إِلَّا قَالَ مُتْرَفُوهَآ إِنَّا وَجَدْنَآ ءَابَآءَنَا عَلَىٰٓ أُمَّةٍۢ وَإِنَّا عَلَىٰٓ ءَاثَٰرِهِم مُّقْتَدُونَ',
		number_in_surah: '23',
		page: '491',
		surah_id: '43',
		hizb_id: '196',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4349',
		number: '4349',
		text: '۞ قَٰلَ أَوَلَوْ جِئْتُكُم بِأَهْدَىٰ مِمَّا وَجَدتُّمْ عَلَيْهِ ءَابَآءَكُمْ ۖ قَالُوٓا۟ إِنَّا بِمَآ أُرْسِلْتُم بِهِۦ كَٰفِرُونَ',
		number_in_surah: '24',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4350',
		number: '4350',
		text: 'فَٱنتَقَمْنَا مِنْهُمْ ۖ فَٱنظُرْ كَيْفَ كَانَ عَٰقِبَةُ ٱلْمُكَذِّبِينَ',
		number_in_surah: '25',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4351',
		number: '4351',
		text: 'وَإِذْ قَالَ إِبْرَٰهِيمُ لِأَبِيهِ وَقَوْمِهِۦٓ إِنَّنِى بَرَآءٌۭ مِّمَّا تَعْبُدُونَ',
		number_in_surah: '26',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4352',
		number: '4352',
		text: 'إِلَّا ٱلَّذِى فَطَرَنِى فَإِنَّهُۥ سَيَهْدِينِ',
		number_in_surah: '27',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4353',
		number: '4353',
		text: 'وَجَعَلَهَا كَلِمَةًۢ بَاقِيَةًۭ فِى عَقِبِهِۦ لَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '28',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4354',
		number: '4354',
		text: 'بَلْ مَتَّعْتُ هَٰٓؤُلَآءِ وَءَابَآءَهُمْ حَتَّىٰ جَآءَهُمُ ٱلْحَقُّ وَرَسُولٌۭ مُّبِينٌۭ',
		number_in_surah: '29',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4355',
		number: '4355',
		text: 'وَلَمَّا جَآءَهُمُ ٱلْحَقُّ قَالُوا۟ هَٰذَا سِحْرٌۭ وَإِنَّا بِهِۦ كَٰفِرُونَ',
		number_in_surah: '30',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4356',
		number: '4356',
		text: 'وَقَالُوا۟ لَوْلَا نُزِّلَ هَٰذَا ٱلْقُرْءَانُ عَلَىٰ رَجُلٍۢ مِّنَ ٱلْقَرْيَتَيْنِ عَظِيمٍ',
		number_in_surah: '31',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4357',
		number: '4357',
		text: 'أَهُمْ يَقْسِمُونَ رَحْمَتَ رَبِّكَ ۚ نَحْنُ قَسَمْنَا بَيْنَهُم مَّعِيشَتَهُمْ فِى ٱلْحَيَوٰةِ ٱلدُّنْيَا ۚ وَرَفَعْنَا بَعْضَهُمْ فَوْقَ بَعْضٍۢ دَرَجَٰتٍۢ لِّيَتَّخِذَ بَعْضُهُم بَعْضًۭا سُخْرِيًّۭا ۗ وَرَحْمَتُ رَبِّكَ خَيْرٌۭ مِّمَّا يَجْمَعُونَ',
		number_in_surah: '32',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4358',
		number: '4358',
		text: 'وَلَوْلَآ أَن يَكُونَ ٱلنَّاسُ أُمَّةًۭ وَٰحِدَةًۭ لَّجَعَلْنَا لِمَن يَكْفُرُ بِٱلرَّحْمَٰنِ لِبُيُوتِهِمْ سُقُفًۭا مِّن فِضَّةٍۢ وَمَعَارِجَ عَلَيْهَا يَظْهَرُونَ',
		number_in_surah: '33',
		page: '491',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4359',
		number: '4359',
		text: 'وَلِبُيُوتِهِمْ أَبْوَٰبًۭا وَسُرُرًا عَلَيْهَا يَتَّكِـُٔونَ',
		number_in_surah: '34',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4360',
		number: '4360',
		text: 'وَزُخْرُفًۭا ۚ وَإِن كُلُّ ذَٰلِكَ لَمَّا مَتَٰعُ ٱلْحَيَوٰةِ ٱلدُّنْيَا ۚ وَٱلْءَاخِرَةُ عِندَ رَبِّكَ لِلْمُتَّقِينَ',
		number_in_surah: '35',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4361',
		number: '4361',
		text: 'وَمَن يَعْشُ عَن ذِكْرِ ٱلرَّحْمَٰنِ نُقَيِّضْ لَهُۥ شَيْطَٰنًۭا فَهُوَ لَهُۥ قَرِينٌۭ',
		number_in_surah: '36',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4362',
		number: '4362',
		text: 'وَإِنَّهُمْ لَيَصُدُّونَهُمْ عَنِ ٱلسَّبِيلِ وَيَحْسَبُونَ أَنَّهُم مُّهْتَدُونَ',
		number_in_surah: '37',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4363',
		number: '4363',
		text: 'حَتَّىٰٓ إِذَا جَآءَنَا قَالَ يَٰلَيْتَ بَيْنِى وَبَيْنَكَ بُعْدَ ٱلْمَشْرِقَيْنِ فَبِئْسَ ٱلْقَرِينُ',
		number_in_surah: '38',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4364',
		number: '4364',
		text: 'وَلَن يَنفَعَكُمُ ٱلْيَوْمَ إِذ ظَّلَمْتُمْ أَنَّكُمْ فِى ٱلْعَذَابِ مُشْتَرِكُونَ',
		number_in_surah: '39',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4365',
		number: '4365',
		text: 'أَفَأَنتَ تُسْمِعُ ٱلصُّمَّ أَوْ تَهْدِى ٱلْعُمْىَ وَمَن كَانَ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '40',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4366',
		number: '4366',
		text: 'فَإِمَّا نَذْهَبَنَّ بِكَ فَإِنَّا مِنْهُم مُّنتَقِمُونَ',
		number_in_surah: '41',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4367',
		number: '4367',
		text: 'أَوْ نُرِيَنَّكَ ٱلَّذِى وَعَدْنَٰهُمْ فَإِنَّا عَلَيْهِم مُّقْتَدِرُونَ',
		number_in_surah: '42',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4368',
		number: '4368',
		text: 'فَٱسْتَمْسِكْ بِٱلَّذِىٓ أُوحِىَ إِلَيْكَ ۖ إِنَّكَ عَلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '43',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4369',
		number: '4369',
		text: 'وَإِنَّهُۥ لَذِكْرٌۭ لَّكَ وَلِقَوْمِكَ ۖ وَسَوْفَ تُسْـَٔلُونَ',
		number_in_surah: '44',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4370',
		number: '4370',
		text: 'وَسْـَٔلْ مَنْ أَرْسَلْنَا مِن قَبْلِكَ مِن رُّسُلِنَآ أَجَعَلْنَا مِن دُونِ ٱلرَّحْمَٰنِ ءَالِهَةًۭ يُعْبَدُونَ',
		number_in_surah: '45',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4371',
		number: '4371',
		text: 'وَلَقَدْ أَرْسَلْنَا مُوسَىٰ بِـَٔايَٰتِنَآ إِلَىٰ فِرْعَوْنَ وَمَلَإِي۟هِۦ فَقَالَ إِنِّى رَسُولُ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '46',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4372',
		number: '4372',
		text: 'فَلَمَّا جَآءَهُم بِـَٔايَٰتِنَآ إِذَا هُم مِّنْهَا يَضْحَكُونَ',
		number_in_surah: '47',
		page: '492',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4373',
		number: '4373',
		text: 'وَمَا نُرِيهِم مِّنْ ءَايَةٍ إِلَّا هِىَ أَكْبَرُ مِنْ أُخْتِهَا ۖ وَأَخَذْنَٰهُم بِٱلْعَذَابِ لَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '48',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4374',
		number: '4374',
		text: 'وَقَالُوا۟ يَٰٓأَيُّهَ ٱلسَّاحِرُ ٱدْعُ لَنَا رَبَّكَ بِمَا عَهِدَ عِندَكَ إِنَّنَا لَمُهْتَدُونَ',
		number_in_surah: '49',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4375',
		number: '4375',
		text: 'فَلَمَّا كَشَفْنَا عَنْهُمُ ٱلْعَذَابَ إِذَا هُمْ يَنكُثُونَ',
		number_in_surah: '50',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4376',
		number: '4376',
		text: 'وَنَادَىٰ فِرْعَوْنُ فِى قَوْمِهِۦ قَالَ يَٰقَوْمِ أَلَيْسَ لِى مُلْكُ مِصْرَ وَهَٰذِهِ ٱلْأَنْهَٰرُ تَجْرِى مِن تَحْتِىٓ ۖ أَفَلَا تُبْصِرُونَ',
		number_in_surah: '51',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4377',
		number: '4377',
		text: 'أَمْ أَنَا۠ خَيْرٌۭ مِّنْ هَٰذَا ٱلَّذِى هُوَ مَهِينٌۭ وَلَا يَكَادُ يُبِينُ',
		number_in_surah: '52',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4378',
		number: '4378',
		text: 'فَلَوْلَآ أُلْقِىَ عَلَيْهِ أَسْوِرَةٌۭ مِّن ذَهَبٍ أَوْ جَآءَ مَعَهُ ٱلْمَلَٰٓئِكَةُ مُقْتَرِنِينَ',
		number_in_surah: '53',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4379',
		number: '4379',
		text: 'فَٱسْتَخَفَّ قَوْمَهُۥ فَأَطَاعُوهُ ۚ إِنَّهُمْ كَانُوا۟ قَوْمًۭا فَٰسِقِينَ',
		number_in_surah: '54',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4380',
		number: '4380',
		text: 'فَلَمَّآ ءَاسَفُونَا ٱنتَقَمْنَا مِنْهُمْ فَأَغْرَقْنَٰهُمْ أَجْمَعِينَ',
		number_in_surah: '55',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4381',
		number: '4381',
		text: 'فَجَعَلْنَٰهُمْ سَلَفًۭا وَمَثَلًۭا لِّلْءَاخِرِينَ',
		number_in_surah: '56',
		page: '493',
		surah_id: '43',
		hizb_id: '197',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4382',
		number: '4382',
		text: '۞ وَلَمَّا ضُرِبَ ٱبْنُ مَرْيَمَ مَثَلًا إِذَا قَوْمُكَ مِنْهُ يَصِدُّونَ',
		number_in_surah: '57',
		page: '493',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4383',
		number: '4383',
		text: 'وَقَالُوٓا۟ ءَأَٰلِهَتُنَا خَيْرٌ أَمْ هُوَ ۚ مَا ضَرَبُوهُ لَكَ إِلَّا جَدَلًۢا ۚ بَلْ هُمْ قَوْمٌ خَصِمُونَ',
		number_in_surah: '58',
		page: '493',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4384',
		number: '4384',
		text: 'إِنْ هُوَ إِلَّا عَبْدٌ أَنْعَمْنَا عَلَيْهِ وَجَعَلْنَٰهُ مَثَلًۭا لِّبَنِىٓ إِسْرَٰٓءِيلَ',
		number_in_surah: '59',
		page: '493',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4385',
		number: '4385',
		text: 'وَلَوْ نَشَآءُ لَجَعَلْنَا مِنكُم مَّلَٰٓئِكَةًۭ فِى ٱلْأَرْضِ يَخْلُفُونَ',
		number_in_surah: '60',
		page: '493',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4386',
		number: '4386',
		text: 'وَإِنَّهُۥ لَعِلْمٌۭ لِّلسَّاعَةِ فَلَا تَمْتَرُنَّ بِهَا وَٱتَّبِعُونِ ۚ هَٰذَا صِرَٰطٌۭ مُّسْتَقِيمٌۭ',
		number_in_surah: '61',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4387',
		number: '4387',
		text: 'وَلَا يَصُدَّنَّكُمُ ٱلشَّيْطَٰنُ ۖ إِنَّهُۥ لَكُمْ عَدُوٌّۭ مُّبِينٌۭ',
		number_in_surah: '62',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4388',
		number: '4388',
		text: 'وَلَمَّا جَآءَ عِيسَىٰ بِٱلْبَيِّنَٰتِ قَالَ قَدْ جِئْتُكُم بِٱلْحِكْمَةِ وَلِأُبَيِّنَ لَكُم بَعْضَ ٱلَّذِى تَخْتَلِفُونَ فِيهِ ۖ فَٱتَّقُوا۟ ٱللَّهَ وَأَطِيعُونِ',
		number_in_surah: '63',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4389',
		number: '4389',
		text: 'إِنَّ ٱللَّهَ هُوَ رَبِّى وَرَبُّكُمْ فَٱعْبُدُوهُ ۚ هَٰذَا صِرَٰطٌۭ مُّسْتَقِيمٌۭ',
		number_in_surah: '64',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4390',
		number: '4390',
		text: 'فَٱخْتَلَفَ ٱلْأَحْزَابُ مِنۢ بَيْنِهِمْ ۖ فَوَيْلٌۭ لِّلَّذِينَ ظَلَمُوا۟ مِنْ عَذَابِ يَوْمٍ أَلِيمٍ',
		number_in_surah: '65',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4391',
		number: '4391',
		text: 'هَلْ يَنظُرُونَ إِلَّا ٱلسَّاعَةَ أَن تَأْتِيَهُم بَغْتَةًۭ وَهُمْ لَا يَشْعُرُونَ',
		number_in_surah: '66',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4392',
		number: '4392',
		text: 'ٱلْأَخِلَّآءُ يَوْمَئِذٍۭ بَعْضُهُمْ لِبَعْضٍ عَدُوٌّ إِلَّا ٱلْمُتَّقِينَ',
		number_in_surah: '67',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4393',
		number: '4393',
		text: 'يَٰعِبَادِ لَا خَوْفٌ عَلَيْكُمُ ٱلْيَوْمَ وَلَآ أَنتُمْ تَحْزَنُونَ',
		number_in_surah: '68',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4394',
		number: '4394',
		text: 'ٱلَّذِينَ ءَامَنُوا۟ بِـَٔايَٰتِنَا وَكَانُوا۟ مُسْلِمِينَ',
		number_in_surah: '69',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4395',
		number: '4395',
		text: 'ٱدْخُلُوا۟ ٱلْجَنَّةَ أَنتُمْ وَأَزْوَٰجُكُمْ تُحْبَرُونَ',
		number_in_surah: '70',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4396',
		number: '4396',
		text: 'يُطَافُ عَلَيْهِم بِصِحَافٍۢ مِّن ذَهَبٍۢ وَأَكْوَابٍۢ ۖ وَفِيهَا مَا تَشْتَهِيهِ ٱلْأَنفُسُ وَتَلَذُّ ٱلْأَعْيُنُ ۖ وَأَنتُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '71',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4397',
		number: '4397',
		text: 'وَتِلْكَ ٱلْجَنَّةُ ٱلَّتِىٓ أُورِثْتُمُوهَا بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '72',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4398',
		number: '4398',
		text: 'لَكُمْ فِيهَا فَٰكِهَةٌۭ كَثِيرَةٌۭ مِّنْهَا تَأْكُلُونَ',
		number_in_surah: '73',
		page: '494',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4399',
		number: '4399',
		text: 'إِنَّ ٱلْمُجْرِمِينَ فِى عَذَابِ جَهَنَّمَ خَٰلِدُونَ',
		number_in_surah: '74',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4400',
		number: '4400',
		text: 'لَا يُفَتَّرُ عَنْهُمْ وَهُمْ فِيهِ مُبْلِسُونَ',
		number_in_surah: '75',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4401',
		number: '4401',
		text: 'وَمَا ظَلَمْنَٰهُمْ وَلَٰكِن كَانُوا۟ هُمُ ٱلظَّٰلِمِينَ',
		number_in_surah: '76',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4402',
		number: '4402',
		text: 'وَنَادَوْا۟ يَٰمَٰلِكُ لِيَقْضِ عَلَيْنَا رَبُّكَ ۖ قَالَ إِنَّكُم مَّٰكِثُونَ',
		number_in_surah: '77',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4403',
		number: '4403',
		text: 'لَقَدْ جِئْنَٰكُم بِٱلْحَقِّ وَلَٰكِنَّ أَكْثَرَكُمْ لِلْحَقِّ كَٰرِهُونَ',
		number_in_surah: '78',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4404',
		number: '4404',
		text: 'أَمْ أَبْرَمُوٓا۟ أَمْرًۭا فَإِنَّا مُبْرِمُونَ',
		number_in_surah: '79',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4405',
		number: '4405',
		text: 'أَمْ يَحْسَبُونَ أَنَّا لَا نَسْمَعُ سِرَّهُمْ وَنَجْوَىٰهُم ۚ بَلَىٰ وَرُسُلُنَا لَدَيْهِمْ يَكْتُبُونَ',
		number_in_surah: '80',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4406',
		number: '4406',
		text: 'قُلْ إِن كَانَ لِلرَّحْمَٰنِ وَلَدٌۭ فَأَنَا۠ أَوَّلُ ٱلْعَٰبِدِينَ',
		number_in_surah: '81',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4407',
		number: '4407',
		text: 'سُبْحَٰنَ رَبِّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ رَبِّ ٱلْعَرْشِ عَمَّا يَصِفُونَ',
		number_in_surah: '82',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4408',
		number: '4408',
		text: 'فَذَرْهُمْ يَخُوضُوا۟ وَيَلْعَبُوا۟ حَتَّىٰ يُلَٰقُوا۟ يَوْمَهُمُ ٱلَّذِى يُوعَدُونَ',
		number_in_surah: '83',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4409',
		number: '4409',
		text: 'وَهُوَ ٱلَّذِى فِى ٱلسَّمَآءِ إِلَٰهٌۭ وَفِى ٱلْأَرْضِ إِلَٰهٌۭ ۚ وَهُوَ ٱلْحَكِيمُ ٱلْعَلِيمُ',
		number_in_surah: '84',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:11',
		updated_at: '2018-06-07 08:07:11',
	},
	{
		id: '4410',
		number: '4410',
		text: 'وَتَبَارَكَ ٱلَّذِى لَهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَا وَعِندَهُۥ عِلْمُ ٱلسَّاعَةِ وَإِلَيْهِ تُرْجَعُونَ',
		number_in_surah: '85',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4411',
		number: '4411',
		text: 'وَلَا يَمْلِكُ ٱلَّذِينَ يَدْعُونَ مِن دُونِهِ ٱلشَّفَٰعَةَ إِلَّا مَن شَهِدَ بِٱلْحَقِّ وَهُمْ يَعْلَمُونَ',
		number_in_surah: '86',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4412',
		number: '4412',
		text: 'وَلَئِن سَأَلْتَهُم مَّنْ خَلَقَهُمْ لَيَقُولُنَّ ٱللَّهُ ۖ فَأَنَّىٰ يُؤْفَكُونَ',
		number_in_surah: '87',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4413',
		number: '4413',
		text: 'وَقِيلِهِۦ يَٰرَبِّ إِنَّ هَٰٓؤُلَآءِ قَوْمٌۭ لَّا يُؤْمِنُونَ',
		number_in_surah: '88',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4414',
		number: '4414',
		text: 'فَٱصْفَحْ عَنْهُمْ وَقُلْ سَلَٰمٌۭ ۚ فَسَوْفَ يَعْلَمُونَ',
		number_in_surah: '89',
		page: '495',
		surah_id: '43',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4415',
		number: '4415',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ حمٓ',
		number_in_surah: '1',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4416',
		number: '4416',
		text: 'وَٱلْكِتَٰبِ ٱلْمُبِينِ',
		number_in_surah: '2',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4417',
		number: '4417',
		text: 'إِنَّآ أَنزَلْنَٰهُ فِى لَيْلَةٍۢ مُّبَٰرَكَةٍ ۚ إِنَّا كُنَّا مُنذِرِينَ',
		number_in_surah: '3',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4418',
		number: '4418',
		text: 'فِيهَا يُفْرَقُ كُلُّ أَمْرٍ حَكِيمٍ',
		number_in_surah: '4',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4419',
		number: '4419',
		text: 'أَمْرًۭا مِّنْ عِندِنَآ ۚ إِنَّا كُنَّا مُرْسِلِينَ',
		number_in_surah: '5',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4420',
		number: '4420',
		text: 'رَحْمَةًۭ مِّن رَّبِّكَ ۚ إِنَّهُۥ هُوَ ٱلسَّمِيعُ ٱلْعَلِيمُ',
		number_in_surah: '6',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4421',
		number: '4421',
		text: 'رَبِّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَآ ۖ إِن كُنتُم مُّوقِنِينَ',
		number_in_surah: '7',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4422',
		number: '4422',
		text: 'لَآ إِلَٰهَ إِلَّا هُوَ يُحْىِۦ وَيُمِيتُ ۖ رَبُّكُمْ وَرَبُّ ءَابَآئِكُمُ ٱلْأَوَّلِينَ',
		number_in_surah: '8',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4423',
		number: '4423',
		text: 'بَلْ هُمْ فِى شَكٍّۢ يَلْعَبُونَ',
		number_in_surah: '9',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4424',
		number: '4424',
		text: 'فَٱرْتَقِبْ يَوْمَ تَأْتِى ٱلسَّمَآءُ بِدُخَانٍۢ مُّبِينٍۢ',
		number_in_surah: '10',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4425',
		number: '4425',
		text: 'يَغْشَى ٱلنَّاسَ ۖ هَٰذَا عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '11',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4426',
		number: '4426',
		text: 'رَّبَّنَا ٱكْشِفْ عَنَّا ٱلْعَذَابَ إِنَّا مُؤْمِنُونَ',
		number_in_surah: '12',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4427',
		number: '4427',
		text: 'أَنَّىٰ لَهُمُ ٱلذِّكْرَىٰ وَقَدْ جَآءَهُمْ رَسُولٌۭ مُّبِينٌۭ',
		number_in_surah: '13',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4428',
		number: '4428',
		text: 'ثُمَّ تَوَلَّوْا۟ عَنْهُ وَقَالُوا۟ مُعَلَّمٌۭ مَّجْنُونٌ',
		number_in_surah: '14',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4429',
		number: '4429',
		text: 'إِنَّا كَاشِفُوا۟ ٱلْعَذَابِ قَلِيلًا ۚ إِنَّكُمْ عَآئِدُونَ',
		number_in_surah: '15',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4430',
		number: '4430',
		text: 'يَوْمَ نَبْطِشُ ٱلْبَطْشَةَ ٱلْكُبْرَىٰٓ إِنَّا مُنتَقِمُونَ',
		number_in_surah: '16',
		page: '496',
		surah_id: '44',
		hizb_id: '198',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4431',
		number: '4431',
		text: '۞ وَلَقَدْ فَتَنَّا قَبْلَهُمْ قَوْمَ فِرْعَوْنَ وَجَآءَهُمْ رَسُولٌۭ كَرِيمٌ',
		number_in_surah: '17',
		page: '496',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4432',
		number: '4432',
		text: 'أَنْ أَدُّوٓا۟ إِلَىَّ عِبَادَ ٱللَّهِ ۖ إِنِّى لَكُمْ رَسُولٌ أَمِينٌۭ',
		number_in_surah: '18',
		page: '496',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4433',
		number: '4433',
		text: 'وَأَن لَّا تَعْلُوا۟ عَلَى ٱللَّهِ ۖ إِنِّىٓ ءَاتِيكُم بِسُلْطَٰنٍۢ مُّبِينٍۢ',
		number_in_surah: '19',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4434',
		number: '4434',
		text: 'وَإِنِّى عُذْتُ بِرَبِّى وَرَبِّكُمْ أَن تَرْجُمُونِ',
		number_in_surah: '20',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4435',
		number: '4435',
		text: 'وَإِن لَّمْ تُؤْمِنُوا۟ لِى فَٱعْتَزِلُونِ',
		number_in_surah: '21',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4436',
		number: '4436',
		text: 'فَدَعَا رَبَّهُۥٓ أَنَّ هَٰٓؤُلَآءِ قَوْمٌۭ مُّجْرِمُونَ',
		number_in_surah: '22',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4437',
		number: '4437',
		text: 'فَأَسْرِ بِعِبَادِى لَيْلًا إِنَّكُم مُّتَّبَعُونَ',
		number_in_surah: '23',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4438',
		number: '4438',
		text: 'وَٱتْرُكِ ٱلْبَحْرَ رَهْوًا ۖ إِنَّهُمْ جُندٌۭ مُّغْرَقُونَ',
		number_in_surah: '24',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4439',
		number: '4439',
		text: 'كَمْ تَرَكُوا۟ مِن جَنَّٰتٍۢ وَعُيُونٍۢ',
		number_in_surah: '25',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4440',
		number: '4440',
		text: 'وَزُرُوعٍۢ وَمَقَامٍۢ كَرِيمٍۢ',
		number_in_surah: '26',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4441',
		number: '4441',
		text: 'وَنَعْمَةٍۢ كَانُوا۟ فِيهَا فَٰكِهِينَ',
		number_in_surah: '27',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4442',
		number: '4442',
		text: 'كَذَٰلِكَ ۖ وَأَوْرَثْنَٰهَا قَوْمًا ءَاخَرِينَ',
		number_in_surah: '28',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4443',
		number: '4443',
		text: 'فَمَا بَكَتْ عَلَيْهِمُ ٱلسَّمَآءُ وَٱلْأَرْضُ وَمَا كَانُوا۟ مُنظَرِينَ',
		number_in_surah: '29',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4444',
		number: '4444',
		text: 'وَلَقَدْ نَجَّيْنَا بَنِىٓ إِسْرَٰٓءِيلَ مِنَ ٱلْعَذَابِ ٱلْمُهِينِ',
		number_in_surah: '30',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4445',
		number: '4445',
		text: 'مِن فِرْعَوْنَ ۚ إِنَّهُۥ كَانَ عَالِيًۭا مِّنَ ٱلْمُسْرِفِينَ',
		number_in_surah: '31',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4446',
		number: '4446',
		text: 'وَلَقَدِ ٱخْتَرْنَٰهُمْ عَلَىٰ عِلْمٍ عَلَى ٱلْعَٰلَمِينَ',
		number_in_surah: '32',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4447',
		number: '4447',
		text: 'وَءَاتَيْنَٰهُم مِّنَ ٱلْءَايَٰتِ مَا فِيهِ بَلَٰٓؤٌۭا۟ مُّبِينٌ',
		number_in_surah: '33',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4448',
		number: '4448',
		text: 'إِنَّ هَٰٓؤُلَآءِ لَيَقُولُونَ',
		number_in_surah: '34',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4449',
		number: '4449',
		text: 'إِنْ هِىَ إِلَّا مَوْتَتُنَا ٱلْأُولَىٰ وَمَا نَحْنُ بِمُنشَرِينَ',
		number_in_surah: '35',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4450',
		number: '4450',
		text: 'فَأْتُوا۟ بِـَٔابَآئِنَآ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '36',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4451',
		number: '4451',
		text: 'أَهُمْ خَيْرٌ أَمْ قَوْمُ تُبَّعٍۢ وَٱلَّذِينَ مِن قَبْلِهِمْ ۚ أَهْلَكْنَٰهُمْ ۖ إِنَّهُمْ كَانُوا۟ مُجْرِمِينَ',
		number_in_surah: '37',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4452',
		number: '4452',
		text: 'وَمَا خَلَقْنَا ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَمَا بَيْنَهُمَا لَٰعِبِينَ',
		number_in_surah: '38',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4453',
		number: '4453',
		text: 'مَا خَلَقْنَٰهُمَآ إِلَّا بِٱلْحَقِّ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '39',
		page: '497',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4454',
		number: '4454',
		text: 'إِنَّ يَوْمَ ٱلْفَصْلِ مِيقَٰتُهُمْ أَجْمَعِينَ',
		number_in_surah: '40',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4455',
		number: '4455',
		text: 'يَوْمَ لَا يُغْنِى مَوْلًى عَن مَّوْلًۭى شَيْـًۭٔا وَلَا هُمْ يُنصَرُونَ',
		number_in_surah: '41',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4456',
		number: '4456',
		text: 'إِلَّا مَن رَّحِمَ ٱللَّهُ ۚ إِنَّهُۥ هُوَ ٱلْعَزِيزُ ٱلرَّحِيمُ',
		number_in_surah: '42',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4457',
		number: '4457',
		text: 'إِنَّ شَجَرَتَ ٱلزَّقُّومِ',
		number_in_surah: '43',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4458',
		number: '4458',
		text: 'طَعَامُ ٱلْأَثِيمِ',
		number_in_surah: '44',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4459',
		number: '4459',
		text: 'كَٱلْمُهْلِ يَغْلِى فِى ٱلْبُطُونِ',
		number_in_surah: '45',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4460',
		number: '4460',
		text: 'كَغَلْىِ ٱلْحَمِيمِ',
		number_in_surah: '46',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4461',
		number: '4461',
		text: 'خُذُوهُ فَٱعْتِلُوهُ إِلَىٰ سَوَآءِ ٱلْجَحِيمِ',
		number_in_surah: '47',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4462',
		number: '4462',
		text: 'ثُمَّ صُبُّوا۟ فَوْقَ رَأْسِهِۦ مِنْ عَذَابِ ٱلْحَمِيمِ',
		number_in_surah: '48',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4463',
		number: '4463',
		text: 'ذُقْ إِنَّكَ أَنتَ ٱلْعَزِيزُ ٱلْكَرِيمُ',
		number_in_surah: '49',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4464',
		number: '4464',
		text: 'إِنَّ هَٰذَا مَا كُنتُم بِهِۦ تَمْتَرُونَ',
		number_in_surah: '50',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4465',
		number: '4465',
		text: 'إِنَّ ٱلْمُتَّقِينَ فِى مَقَامٍ أَمِينٍۢ',
		number_in_surah: '51',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4466',
		number: '4466',
		text: 'فِى جَنَّٰتٍۢ وَعُيُونٍۢ',
		number_in_surah: '52',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4467',
		number: '4467',
		text: 'يَلْبَسُونَ مِن سُندُسٍۢ وَإِسْتَبْرَقٍۢ مُّتَقَٰبِلِينَ',
		number_in_surah: '53',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4468',
		number: '4468',
		text: 'كَذَٰلِكَ وَزَوَّجْنَٰهُم بِحُورٍ عِينٍۢ',
		number_in_surah: '54',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4469',
		number: '4469',
		text: 'يَدْعُونَ فِيهَا بِكُلِّ فَٰكِهَةٍ ءَامِنِينَ',
		number_in_surah: '55',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4470',
		number: '4470',
		text: 'لَا يَذُوقُونَ فِيهَا ٱلْمَوْتَ إِلَّا ٱلْمَوْتَةَ ٱلْأُولَىٰ ۖ وَوَقَىٰهُمْ عَذَابَ ٱلْجَحِيمِ',
		number_in_surah: '56',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4471',
		number: '4471',
		text: 'فَضْلًۭا مِّن رَّبِّكَ ۚ ذَٰلِكَ هُوَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '57',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4472',
		number: '4472',
		text: 'فَإِنَّمَا يَسَّرْنَٰهُ بِلِسَانِكَ لَعَلَّهُمْ يَتَذَكَّرُونَ',
		number_in_surah: '58',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4473',
		number: '4473',
		text: 'فَٱرْتَقِبْ إِنَّهُم مُّرْتَقِبُونَ',
		number_in_surah: '59',
		page: '498',
		surah_id: '44',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4474',
		number: '4474',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ حمٓ',
		number_in_surah: '1',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4475',
		number: '4475',
		text: 'تَنزِيلُ ٱلْكِتَٰبِ مِنَ ٱللَّهِ ٱلْعَزِيزِ ٱلْحَكِيمِ',
		number_in_surah: '2',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4476',
		number: '4476',
		text: 'إِنَّ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ لَءَايَٰتٍۢ لِّلْمُؤْمِنِينَ',
		number_in_surah: '3',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4477',
		number: '4477',
		text: 'وَفِى خَلْقِكُمْ وَمَا يَبُثُّ مِن دَآبَّةٍ ءَايَٰتٌۭ لِّقَوْمٍۢ يُوقِنُونَ',
		number_in_surah: '4',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4478',
		number: '4478',
		text: 'وَٱخْتِلَٰفِ ٱلَّيْلِ وَٱلنَّهَارِ وَمَآ أَنزَلَ ٱللَّهُ مِنَ ٱلسَّمَآءِ مِن رِّزْقٍۢ فَأَحْيَا بِهِ ٱلْأَرْضَ بَعْدَ مَوْتِهَا وَتَصْرِيفِ ٱلرِّيَٰحِ ءَايَٰتٌۭ لِّقَوْمٍۢ يَعْقِلُونَ',
		number_in_surah: '5',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4479',
		number: '4479',
		text: 'تِلْكَ ءَايَٰتُ ٱللَّهِ نَتْلُوهَا عَلَيْكَ بِٱلْحَقِّ ۖ فَبِأَىِّ حَدِيثٍۭ بَعْدَ ٱللَّهِ وَءَايَٰتِهِۦ يُؤْمِنُونَ',
		number_in_surah: '6',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4480',
		number: '4480',
		text: 'وَيْلٌۭ لِّكُلِّ أَفَّاكٍ أَثِيمٍۢ',
		number_in_surah: '7',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4481',
		number: '4481',
		text: 'يَسْمَعُ ءَايَٰتِ ٱللَّهِ تُتْلَىٰ عَلَيْهِ ثُمَّ يُصِرُّ مُسْتَكْبِرًۭا كَأَن لَّمْ يَسْمَعْهَا ۖ فَبَشِّرْهُ بِعَذَابٍ أَلِيمٍۢ',
		number_in_surah: '8',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4482',
		number: '4482',
		text: 'وَإِذَا عَلِمَ مِنْ ءَايَٰتِنَا شَيْـًٔا ٱتَّخَذَهَا هُزُوًا ۚ أُو۟لَٰٓئِكَ لَهُمْ عَذَابٌۭ مُّهِينٌۭ',
		number_in_surah: '9',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4483',
		number: '4483',
		text: 'مِّن وَرَآئِهِمْ جَهَنَّمُ ۖ وَلَا يُغْنِى عَنْهُم مَّا كَسَبُوا۟ شَيْـًۭٔا وَلَا مَا ٱتَّخَذُوا۟ مِن دُونِ ٱللَّهِ أَوْلِيَآءَ ۖ وَلَهُمْ عَذَابٌ عَظِيمٌ',
		number_in_surah: '10',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4484',
		number: '4484',
		text: 'هَٰذَا هُدًۭى ۖ وَٱلَّذِينَ كَفَرُوا۟ بِـَٔايَٰتِ رَبِّهِمْ لَهُمْ عَذَابٌۭ مِّن رِّجْزٍ أَلِيمٌ',
		number_in_surah: '11',
		page: '499',
		surah_id: '45',
		hizb_id: '199',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4485',
		number: '4485',
		text: '۞ ٱللَّهُ ٱلَّذِى سَخَّرَ لَكُمُ ٱلْبَحْرَ لِتَجْرِىَ ٱلْفُلْكُ فِيهِ بِأَمْرِهِۦ وَلِتَبْتَغُوا۟ مِن فَضْلِهِۦ وَلَعَلَّكُمْ تَشْكُرُونَ',
		number_in_surah: '12',
		page: '499',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4486',
		number: '4486',
		text: 'وَسَخَّرَ لَكُم مَّا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ جَمِيعًۭا مِّنْهُ ۚ إِنَّ فِى ذَٰلِكَ لَءَايَٰتٍۢ لِّقَوْمٍۢ يَتَفَكَّرُونَ',
		number_in_surah: '13',
		page: '499',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4487',
		number: '4487',
		text: 'قُل لِّلَّذِينَ ءَامَنُوا۟ يَغْفِرُوا۟ لِلَّذِينَ لَا يَرْجُونَ أَيَّامَ ٱللَّهِ لِيَجْزِىَ قَوْمًۢا بِمَا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '14',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4488',
		number: '4488',
		text: 'مَنْ عَمِلَ صَٰلِحًۭا فَلِنَفْسِهِۦ ۖ وَمَنْ أَسَآءَ فَعَلَيْهَا ۖ ثُمَّ إِلَىٰ رَبِّكُمْ تُرْجَعُونَ',
		number_in_surah: '15',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4489',
		number: '4489',
		text: 'وَلَقَدْ ءَاتَيْنَا بَنِىٓ إِسْرَٰٓءِيلَ ٱلْكِتَٰبَ وَٱلْحُكْمَ وَٱلنُّبُوَّةَ وَرَزَقْنَٰهُم مِّنَ ٱلطَّيِّبَٰتِ وَفَضَّلْنَٰهُمْ عَلَى ٱلْعَٰلَمِينَ',
		number_in_surah: '16',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4490',
		number: '4490',
		text: 'وَءَاتَيْنَٰهُم بَيِّنَٰتٍۢ مِّنَ ٱلْأَمْرِ ۖ فَمَا ٱخْتَلَفُوٓا۟ إِلَّا مِنۢ بَعْدِ مَا جَآءَهُمُ ٱلْعِلْمُ بَغْيًۢا بَيْنَهُمْ ۚ إِنَّ رَبَّكَ يَقْضِى بَيْنَهُمْ يَوْمَ ٱلْقِيَٰمَةِ فِيمَا كَانُوا۟ فِيهِ يَخْتَلِفُونَ',
		number_in_surah: '17',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4491',
		number: '4491',
		text: 'ثُمَّ جَعَلْنَٰكَ عَلَىٰ شَرِيعَةٍۢ مِّنَ ٱلْأَمْرِ فَٱتَّبِعْهَا وَلَا تَتَّبِعْ أَهْوَآءَ ٱلَّذِينَ لَا يَعْلَمُونَ',
		number_in_surah: '18',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4492',
		number: '4492',
		text: 'إِنَّهُمْ لَن يُغْنُوا۟ عَنكَ مِنَ ٱللَّهِ شَيْـًۭٔا ۚ وَإِنَّ ٱلظَّٰلِمِينَ بَعْضُهُمْ أَوْلِيَآءُ بَعْضٍۢ ۖ وَٱللَّهُ وَلِىُّ ٱلْمُتَّقِينَ',
		number_in_surah: '19',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4493',
		number: '4493',
		text: 'هَٰذَا بَصَٰٓئِرُ لِلنَّاسِ وَهُدًۭى وَرَحْمَةٌۭ لِّقَوْمٍۢ يُوقِنُونَ',
		number_in_surah: '20',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4494',
		number: '4494',
		text: 'أَمْ حَسِبَ ٱلَّذِينَ ٱجْتَرَحُوا۟ ٱلسَّيِّـَٔاتِ أَن نَّجْعَلَهُمْ كَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ سَوَآءًۭ مَّحْيَاهُمْ وَمَمَاتُهُمْ ۚ سَآءَ مَا يَحْكُمُونَ',
		number_in_surah: '21',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4495',
		number: '4495',
		text: 'وَخَلَقَ ٱللَّهُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ بِٱلْحَقِّ وَلِتُجْزَىٰ كُلُّ نَفْسٍۭ بِمَا كَسَبَتْ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '22',
		page: '500',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4496',
		number: '4496',
		text: 'أَفَرَءَيْتَ مَنِ ٱتَّخَذَ إِلَٰهَهُۥ هَوَىٰهُ وَأَضَلَّهُ ٱللَّهُ عَلَىٰ عِلْمٍۢ وَخَتَمَ عَلَىٰ سَمْعِهِۦ وَقَلْبِهِۦ وَجَعَلَ عَلَىٰ بَصَرِهِۦ غِشَٰوَةًۭ فَمَن يَهْدِيهِ مِنۢ بَعْدِ ٱللَّهِ ۚ أَفَلَا تَذَكَّرُونَ',
		number_in_surah: '23',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4497',
		number: '4497',
		text: 'وَقَالُوا۟ مَا هِىَ إِلَّا حَيَاتُنَا ٱلدُّنْيَا نَمُوتُ وَنَحْيَا وَمَا يُهْلِكُنَآ إِلَّا ٱلدَّهْرُ ۚ وَمَا لَهُم بِذَٰلِكَ مِنْ عِلْمٍ ۖ إِنْ هُمْ إِلَّا يَظُنُّونَ',
		number_in_surah: '24',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4498',
		number: '4498',
		text: 'وَإِذَا تُتْلَىٰ عَلَيْهِمْ ءَايَٰتُنَا بَيِّنَٰتٍۢ مَّا كَانَ حُجَّتَهُمْ إِلَّآ أَن قَالُوا۟ ٱئْتُوا۟ بِـَٔابَآئِنَآ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '25',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4499',
		number: '4499',
		text: 'قُلِ ٱللَّهُ يُحْيِيكُمْ ثُمَّ يُمِيتُكُمْ ثُمَّ يَجْمَعُكُمْ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ لَا رَيْبَ فِيهِ وَلَٰكِنَّ أَكْثَرَ ٱلنَّاسِ لَا يَعْلَمُونَ',
		number_in_surah: '26',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4500',
		number: '4500',
		text: 'وَلِلَّهِ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَيَوْمَ تَقُومُ ٱلسَّاعَةُ يَوْمَئِذٍۢ يَخْسَرُ ٱلْمُبْطِلُونَ',
		number_in_surah: '27',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4501',
		number: '4501',
		text: 'وَتَرَىٰ كُلَّ أُمَّةٍۢ جَاثِيَةًۭ ۚ كُلُّ أُمَّةٍۢ تُدْعَىٰٓ إِلَىٰ كِتَٰبِهَا ٱلْيَوْمَ تُجْزَوْنَ مَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '28',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4502',
		number: '4502',
		text: 'هَٰذَا كِتَٰبُنَا يَنطِقُ عَلَيْكُم بِٱلْحَقِّ ۚ إِنَّا كُنَّا نَسْتَنسِخُ مَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '29',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4503',
		number: '4503',
		text: 'فَأَمَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ فَيُدْخِلُهُمْ رَبُّهُمْ فِى رَحْمَتِهِۦ ۚ ذَٰلِكَ هُوَ ٱلْفَوْزُ ٱلْمُبِينُ',
		number_in_surah: '30',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4504',
		number: '4504',
		text: 'وَأَمَّا ٱلَّذِينَ كَفَرُوٓا۟ أَفَلَمْ تَكُنْ ءَايَٰتِى تُتْلَىٰ عَلَيْكُمْ فَٱسْتَكْبَرْتُمْ وَكُنتُمْ قَوْمًۭا مُّجْرِمِينَ',
		number_in_surah: '31',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4505',
		number: '4505',
		text: 'وَإِذَا قِيلَ إِنَّ وَعْدَ ٱللَّهِ حَقٌّۭ وَٱلسَّاعَةُ لَا رَيْبَ فِيهَا قُلْتُم مَّا نَدْرِى مَا ٱلسَّاعَةُ إِن نَّظُنُّ إِلَّا ظَنًّۭا وَمَا نَحْنُ بِمُسْتَيْقِنِينَ',
		number_in_surah: '32',
		page: '501',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4506',
		number: '4506',
		text: 'وَبَدَا لَهُمْ سَيِّـَٔاتُ مَا عَمِلُوا۟ وَحَاقَ بِهِم مَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '33',
		page: '502',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4507',
		number: '4507',
		text: 'وَقِيلَ ٱلْيَوْمَ نَنسَىٰكُمْ كَمَا نَسِيتُمْ لِقَآءَ يَوْمِكُمْ هَٰذَا وَمَأْوَىٰكُمُ ٱلنَّارُ وَمَا لَكُم مِّن نَّٰصِرِينَ',
		number_in_surah: '34',
		page: '502',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4508',
		number: '4508',
		text: 'ذَٰلِكُم بِأَنَّكُمُ ٱتَّخَذْتُمْ ءَايَٰتِ ٱللَّهِ هُزُوًۭا وَغَرَّتْكُمُ ٱلْحَيَوٰةُ ٱلدُّنْيَا ۚ فَٱلْيَوْمَ لَا يُخْرَجُونَ مِنْهَا وَلَا هُمْ يُسْتَعْتَبُونَ',
		number_in_surah: '35',
		page: '502',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4509',
		number: '4509',
		text: 'فَلِلَّهِ ٱلْحَمْدُ رَبِّ ٱلسَّمَٰوَٰتِ وَرَبِّ ٱلْأَرْضِ رَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '36',
		page: '502',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4510',
		number: '4510',
		text: 'وَلَهُ ٱلْكِبْرِيَآءُ فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '37',
		page: '502',
		surah_id: '45',
		hizb_id: '200',
		juz_id: '25',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4511',
		number: '4511',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ حمٓ',
		number_in_surah: '1',
		page: '502',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4512',
		number: '4512',
		text: 'تَنزِيلُ ٱلْكِتَٰبِ مِنَ ٱللَّهِ ٱلْعَزِيزِ ٱلْحَكِيمِ',
		number_in_surah: '2',
		page: '502',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4513',
		number: '4513',
		text: 'مَا خَلَقْنَا ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَمَا بَيْنَهُمَآ إِلَّا بِٱلْحَقِّ وَأَجَلٍۢ مُّسَمًّۭى ۚ وَٱلَّذِينَ كَفَرُوا۟ عَمَّآ أُنذِرُوا۟ مُعْرِضُونَ',
		number_in_surah: '3',
		page: '502',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4514',
		number: '4514',
		text: 'قُلْ أَرَءَيْتُم مَّا تَدْعُونَ مِن دُونِ ٱللَّهِ أَرُونِى مَاذَا خَلَقُوا۟ مِنَ ٱلْأَرْضِ أَمْ لَهُمْ شِرْكٌۭ فِى ٱلسَّمَٰوَٰتِ ۖ ٱئْتُونِى بِكِتَٰبٍۢ مِّن قَبْلِ هَٰذَآ أَوْ أَثَٰرَةٍۢ مِّنْ عِلْمٍ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '4',
		page: '502',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4515',
		number: '4515',
		text: 'وَمَنْ أَضَلُّ مِمَّن يَدْعُوا۟ مِن دُونِ ٱللَّهِ مَن لَّا يَسْتَجِيبُ لَهُۥٓ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ وَهُمْ عَن دُعَآئِهِمْ غَٰفِلُونَ',
		number_in_surah: '5',
		page: '502',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4516',
		number: '4516',
		text: 'وَإِذَا حُشِرَ ٱلنَّاسُ كَانُوا۟ لَهُمْ أَعْدَآءًۭ وَكَانُوا۟ بِعِبَادَتِهِمْ كَٰفِرِينَ',
		number_in_surah: '6',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4517',
		number: '4517',
		text: 'وَإِذَا تُتْلَىٰ عَلَيْهِمْ ءَايَٰتُنَا بَيِّنَٰتٍۢ قَالَ ٱلَّذِينَ كَفَرُوا۟ لِلْحَقِّ لَمَّا جَآءَهُمْ هَٰذَا سِحْرٌۭ مُّبِينٌ',
		number_in_surah: '7',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4518',
		number: '4518',
		text: 'أَمْ يَقُولُونَ ٱفْتَرَىٰهُ ۖ قُلْ إِنِ ٱفْتَرَيْتُهُۥ فَلَا تَمْلِكُونَ لِى مِنَ ٱللَّهِ شَيْـًٔا ۖ هُوَ أَعْلَمُ بِمَا تُفِيضُونَ فِيهِ ۖ كَفَىٰ بِهِۦ شَهِيدًۢا بَيْنِى وَبَيْنَكُمْ ۖ وَهُوَ ٱلْغَفُورُ ٱلرَّحِيمُ',
		number_in_surah: '8',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4519',
		number: '4519',
		text: 'قُلْ مَا كُنتُ بِدْعًۭا مِّنَ ٱلرُّسُلِ وَمَآ أَدْرِى مَا يُفْعَلُ بِى وَلَا بِكُمْ ۖ إِنْ أَتَّبِعُ إِلَّا مَا يُوحَىٰٓ إِلَىَّ وَمَآ أَنَا۠ إِلَّا نَذِيرٌۭ مُّبِينٌۭ',
		number_in_surah: '9',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4520',
		number: '4520',
		text: 'قُلْ أَرَءَيْتُمْ إِن كَانَ مِنْ عِندِ ٱللَّهِ وَكَفَرْتُم بِهِۦ وَشَهِدَ شَاهِدٌۭ مِّنۢ بَنِىٓ إِسْرَٰٓءِيلَ عَلَىٰ مِثْلِهِۦ فَـَٔامَنَ وَٱسْتَكْبَرْتُمْ ۖ إِنَّ ٱللَّهَ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '10',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4521',
		number: '4521',
		text: 'وَقَالَ ٱلَّذِينَ كَفَرُوا۟ لِلَّذِينَ ءَامَنُوا۟ لَوْ كَانَ خَيْرًۭا مَّا سَبَقُونَآ إِلَيْهِ ۚ وَإِذْ لَمْ يَهْتَدُوا۟ بِهِۦ فَسَيَقُولُونَ هَٰذَآ إِفْكٌۭ قَدِيمٌۭ',
		number_in_surah: '11',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4522',
		number: '4522',
		text: 'وَمِن قَبْلِهِۦ كِتَٰبُ مُوسَىٰٓ إِمَامًۭا وَرَحْمَةًۭ ۚ وَهَٰذَا كِتَٰبٌۭ مُّصَدِّقٌۭ لِّسَانًا عَرَبِيًّۭا لِّيُنذِرَ ٱلَّذِينَ ظَلَمُوا۟ وَبُشْرَىٰ لِلْمُحْسِنِينَ',
		number_in_surah: '12',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4523',
		number: '4523',
		text: 'إِنَّ ٱلَّذِينَ قَالُوا۟ رَبُّنَا ٱللَّهُ ثُمَّ ٱسْتَقَٰمُوا۟ فَلَا خَوْفٌ عَلَيْهِمْ وَلَا هُمْ يَحْزَنُونَ',
		number_in_surah: '13',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4524',
		number: '4524',
		text: 'أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَنَّةِ خَٰلِدِينَ فِيهَا جَزَآءًۢ بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '14',
		page: '503',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4525',
		number: '4525',
		text: 'وَوَصَّيْنَا ٱلْإِنسَٰنَ بِوَٰلِدَيْهِ إِحْسَٰنًا ۖ حَمَلَتْهُ أُمُّهُۥ كُرْهًۭا وَوَضَعَتْهُ كُرْهًۭا ۖ وَحَمْلُهُۥ وَفِصَٰلُهُۥ ثَلَٰثُونَ شَهْرًا ۚ حَتَّىٰٓ إِذَا بَلَغَ أَشُدَّهُۥ وَبَلَغَ أَرْبَعِينَ سَنَةًۭ قَالَ رَبِّ أَوْزِعْنِىٓ أَنْ أَشْكُرَ نِعْمَتَكَ ٱلَّتِىٓ أَنْعَمْتَ عَلَىَّ وَعَلَىٰ وَٰلِدَىَّ وَأَنْ أَعْمَلَ صَٰلِحًۭا تَرْضَىٰهُ وَأَصْلِحْ لِى فِى ذُرِّيَّتِىٓ ۖ إِنِّى تُبْتُ إِلَيْكَ وَإِنِّى مِنَ ٱلْمُسْلِمِينَ',
		number_in_surah: '15',
		page: '504',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4526',
		number: '4526',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ نَتَقَبَّلُ عَنْهُمْ أَحْسَنَ مَا عَمِلُوا۟ وَنَتَجَاوَزُ عَن سَيِّـَٔاتِهِمْ فِىٓ أَصْحَٰبِ ٱلْجَنَّةِ ۖ وَعْدَ ٱلصِّدْقِ ٱلَّذِى كَانُوا۟ يُوعَدُونَ',
		number_in_surah: '16',
		page: '504',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4527',
		number: '4527',
		text: 'وَٱلَّذِى قَالَ لِوَٰلِدَيْهِ أُفٍّۢ لَّكُمَآ أَتَعِدَانِنِىٓ أَنْ أُخْرَجَ وَقَدْ خَلَتِ ٱلْقُرُونُ مِن قَبْلِى وَهُمَا يَسْتَغِيثَانِ ٱللَّهَ وَيْلَكَ ءَامِنْ إِنَّ وَعْدَ ٱللَّهِ حَقٌّۭ فَيَقُولُ مَا هَٰذَآ إِلَّآ أَسَٰطِيرُ ٱلْأَوَّلِينَ',
		number_in_surah: '17',
		page: '504',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4528',
		number: '4528',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ حَقَّ عَلَيْهِمُ ٱلْقَوْلُ فِىٓ أُمَمٍۢ قَدْ خَلَتْ مِن قَبْلِهِم مِّنَ ٱلْجِنِّ وَٱلْإِنسِ ۖ إِنَّهُمْ كَانُوا۟ خَٰسِرِينَ',
		number_in_surah: '18',
		page: '504',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4529',
		number: '4529',
		text: 'وَلِكُلٍّۢ دَرَجَٰتٌۭ مِّمَّا عَمِلُوا۟ ۖ وَلِيُوَفِّيَهُمْ أَعْمَٰلَهُمْ وَهُمْ لَا يُظْلَمُونَ',
		number_in_surah: '19',
		page: '504',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4530',
		number: '4530',
		text: 'وَيَوْمَ يُعْرَضُ ٱلَّذِينَ كَفَرُوا۟ عَلَى ٱلنَّارِ أَذْهَبْتُمْ طَيِّبَٰتِكُمْ فِى حَيَاتِكُمُ ٱلدُّنْيَا وَٱسْتَمْتَعْتُم بِهَا فَٱلْيَوْمَ تُجْزَوْنَ عَذَابَ ٱلْهُونِ بِمَا كُنتُمْ تَسْتَكْبِرُونَ فِى ٱلْأَرْضِ بِغَيْرِ ٱلْحَقِّ وَبِمَا كُنتُمْ تَفْسُقُونَ',
		number_in_surah: '20',
		page: '504',
		surah_id: '46',
		hizb_id: '201',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4531',
		number: '4531',
		text: '۞ وَٱذْكُرْ أَخَا عَادٍ إِذْ أَنذَرَ قَوْمَهُۥ بِٱلْأَحْقَافِ وَقَدْ خَلَتِ ٱلنُّذُرُ مِنۢ بَيْنِ يَدَيْهِ وَمِنْ خَلْفِهِۦٓ أَلَّا تَعْبُدُوٓا۟ إِلَّا ٱللَّهَ إِنِّىٓ أَخَافُ عَلَيْكُمْ عَذَابَ يَوْمٍ عَظِيمٍۢ',
		number_in_surah: '21',
		page: '505',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4532',
		number: '4532',
		text: 'قَالُوٓا۟ أَجِئْتَنَا لِتَأْفِكَنَا عَنْ ءَالِهَتِنَا فَأْتِنَا بِمَا تَعِدُنَآ إِن كُنتَ مِنَ ٱلصَّٰدِقِينَ',
		number_in_surah: '22',
		page: '505',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4533',
		number: '4533',
		text: 'قَالَ إِنَّمَا ٱلْعِلْمُ عِندَ ٱللَّهِ وَأُبَلِّغُكُم مَّآ أُرْسِلْتُ بِهِۦ وَلَٰكِنِّىٓ أَرَىٰكُمْ قَوْمًۭا تَجْهَلُونَ',
		number_in_surah: '23',
		page: '505',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4534',
		number: '4534',
		text: 'فَلَمَّا رَأَوْهُ عَارِضًۭا مُّسْتَقْبِلَ أَوْدِيَتِهِمْ قَالُوا۟ هَٰذَا عَارِضٌۭ مُّمْطِرُنَا ۚ بَلْ هُوَ مَا ٱسْتَعْجَلْتُم بِهِۦ ۖ رِيحٌۭ فِيهَا عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '24',
		page: '505',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4535',
		number: '4535',
		text: 'تُدَمِّرُ كُلَّ شَىْءٍۭ بِأَمْرِ رَبِّهَا فَأَصْبَحُوا۟ لَا يُرَىٰٓ إِلَّا مَسَٰكِنُهُمْ ۚ كَذَٰلِكَ نَجْزِى ٱلْقَوْمَ ٱلْمُجْرِمِينَ',
		number_in_surah: '25',
		page: '505',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4536',
		number: '4536',
		text: 'وَلَقَدْ مَكَّنَّٰهُمْ فِيمَآ إِن مَّكَّنَّٰكُمْ فِيهِ وَجَعَلْنَا لَهُمْ سَمْعًۭا وَأَبْصَٰرًۭا وَأَفْـِٔدَةًۭ فَمَآ أَغْنَىٰ عَنْهُمْ سَمْعُهُمْ وَلَآ أَبْصَٰرُهُمْ وَلَآ أَفْـِٔدَتُهُم مِّن شَىْءٍ إِذْ كَانُوا۟ يَجْحَدُونَ بِـَٔايَٰتِ ٱللَّهِ وَحَاقَ بِهِم مَّا كَانُوا۟ بِهِۦ يَسْتَهْزِءُونَ',
		number_in_surah: '26',
		page: '505',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4537',
		number: '4537',
		text: 'وَلَقَدْ أَهْلَكْنَا مَا حَوْلَكُم مِّنَ ٱلْقُرَىٰ وَصَرَّفْنَا ٱلْءَايَٰتِ لَعَلَّهُمْ يَرْجِعُونَ',
		number_in_surah: '27',
		page: '505',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4538',
		number: '4538',
		text: 'فَلَوْلَا نَصَرَهُمُ ٱلَّذِينَ ٱتَّخَذُوا۟ مِن دُونِ ٱللَّهِ قُرْبَانًا ءَالِهَةًۢ ۖ بَلْ ضَلُّوا۟ عَنْهُمْ ۚ وَذَٰلِكَ إِفْكُهُمْ وَمَا كَانُوا۟ يَفْتَرُونَ',
		number_in_surah: '28',
		page: '505',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4539',
		number: '4539',
		text: 'وَإِذْ صَرَفْنَآ إِلَيْكَ نَفَرًۭا مِّنَ ٱلْجِنِّ يَسْتَمِعُونَ ٱلْقُرْءَانَ فَلَمَّا حَضَرُوهُ قَالُوٓا۟ أَنصِتُوا۟ ۖ فَلَمَّا قُضِىَ وَلَّوْا۟ إِلَىٰ قَوْمِهِم مُّنذِرِينَ',
		number_in_surah: '29',
		page: '506',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4540',
		number: '4540',
		text: 'قَالُوا۟ يَٰقَوْمَنَآ إِنَّا سَمِعْنَا كِتَٰبًا أُنزِلَ مِنۢ بَعْدِ مُوسَىٰ مُصَدِّقًۭا لِّمَا بَيْنَ يَدَيْهِ يَهْدِىٓ إِلَى ٱلْحَقِّ وَإِلَىٰ طَرِيقٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '30',
		page: '506',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4541',
		number: '4541',
		text: 'يَٰقَوْمَنَآ أَجِيبُوا۟ دَاعِىَ ٱللَّهِ وَءَامِنُوا۟ بِهِۦ يَغْفِرْ لَكُم مِّن ذُنُوبِكُمْ وَيُجِرْكُم مِّنْ عَذَابٍ أَلِيمٍۢ',
		number_in_surah: '31',
		page: '506',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4542',
		number: '4542',
		text: 'وَمَن لَّا يُجِبْ دَاعِىَ ٱللَّهِ فَلَيْسَ بِمُعْجِزٍۢ فِى ٱلْأَرْضِ وَلَيْسَ لَهُۥ مِن دُونِهِۦٓ أَوْلِيَآءُ ۚ أُو۟لَٰٓئِكَ فِى ضَلَٰلٍۢ مُّبِينٍ',
		number_in_surah: '32',
		page: '506',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4543',
		number: '4543',
		text: 'أَوَلَمْ يَرَوْا۟ أَنَّ ٱللَّهَ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَلَمْ يَعْىَ بِخَلْقِهِنَّ بِقَٰدِرٍ عَلَىٰٓ أَن يُحْۦِىَ ٱلْمَوْتَىٰ ۚ بَلَىٰٓ إِنَّهُۥ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '33',
		page: '506',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4544',
		number: '4544',
		text: 'وَيَوْمَ يُعْرَضُ ٱلَّذِينَ كَفَرُوا۟ عَلَى ٱلنَّارِ أَلَيْسَ هَٰذَا بِٱلْحَقِّ ۖ قَالُوا۟ بَلَىٰ وَرَبِّنَا ۚ قَالَ فَذُوقُوا۟ ٱلْعَذَابَ بِمَا كُنتُمْ تَكْفُرُونَ',
		number_in_surah: '34',
		page: '506',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4545',
		number: '4545',
		text: 'فَٱصْبِرْ كَمَا صَبَرَ أُو۟لُوا۟ ٱلْعَزْمِ مِنَ ٱلرُّسُلِ وَلَا تَسْتَعْجِل لَّهُمْ ۚ كَأَنَّهُمْ يَوْمَ يَرَوْنَ مَا يُوعَدُونَ لَمْ يَلْبَثُوٓا۟ إِلَّا سَاعَةًۭ مِّن نَّهَارٍۭ ۚ بَلَٰغٌۭ ۚ فَهَلْ يُهْلَكُ إِلَّا ٱلْقَوْمُ ٱلْفَٰسِقُونَ',
		number_in_surah: '35',
		page: '506',
		surah_id: '46',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4546',
		number: '4546',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱلَّذِينَ كَفَرُوا۟ وَصَدُّوا۟ عَن سَبِيلِ ٱللَّهِ أَضَلَّ أَعْمَٰلَهُمْ',
		number_in_surah: '1',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4547',
		number: '4547',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ وَءَامَنُوا۟ بِمَا نُزِّلَ عَلَىٰ مُحَمَّدٍۢ وَهُوَ ٱلْحَقُّ مِن رَّبِّهِمْ ۙ كَفَّرَ عَنْهُمْ سَيِّـَٔاتِهِمْ وَأَصْلَحَ بَالَهُمْ',
		number_in_surah: '2',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4548',
		number: '4548',
		text: 'ذَٰلِكَ بِأَنَّ ٱلَّذِينَ كَفَرُوا۟ ٱتَّبَعُوا۟ ٱلْبَٰطِلَ وَأَنَّ ٱلَّذِينَ ءَامَنُوا۟ ٱتَّبَعُوا۟ ٱلْحَقَّ مِن رَّبِّهِمْ ۚ كَذَٰلِكَ يَضْرِبُ ٱللَّهُ لِلنَّاسِ أَمْثَٰلَهُمْ',
		number_in_surah: '3',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4549',
		number: '4549',
		text: 'فَإِذَا لَقِيتُمُ ٱلَّذِينَ كَفَرُوا۟ فَضَرْبَ ٱلرِّقَابِ حَتَّىٰٓ إِذَآ أَثْخَنتُمُوهُمْ فَشُدُّوا۟ ٱلْوَثَاقَ فَإِمَّا مَنًّۢا بَعْدُ وَإِمَّا فِدَآءً حَتَّىٰ تَضَعَ ٱلْحَرْبُ أَوْزَارَهَا ۚ ذَٰلِكَ وَلَوْ يَشَآءُ ٱللَّهُ لَٱنتَصَرَ مِنْهُمْ وَلَٰكِن لِّيَبْلُوَا۟ بَعْضَكُم بِبَعْضٍۢ ۗ وَٱلَّذِينَ قُتِلُوا۟ فِى سَبِيلِ ٱللَّهِ فَلَن يُضِلَّ أَعْمَٰلَهُمْ',
		number_in_surah: '4',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4550',
		number: '4550',
		text: 'سَيَهْدِيهِمْ وَيُصْلِحُ بَالَهُمْ',
		number_in_surah: '5',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4551',
		number: '4551',
		text: 'وَيُدْخِلُهُمُ ٱلْجَنَّةَ عَرَّفَهَا لَهُمْ',
		number_in_surah: '6',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4552',
		number: '4552',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِن تَنصُرُوا۟ ٱللَّهَ يَنصُرْكُمْ وَيُثَبِّتْ أَقْدَامَكُمْ',
		number_in_surah: '7',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4553',
		number: '4553',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ فَتَعْسًۭا لَّهُمْ وَأَضَلَّ أَعْمَٰلَهُمْ',
		number_in_surah: '8',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4554',
		number: '4554',
		text: 'ذَٰلِكَ بِأَنَّهُمْ كَرِهُوا۟ مَآ أَنزَلَ ٱللَّهُ فَأَحْبَطَ أَعْمَٰلَهُمْ',
		number_in_surah: '9',
		page: '507',
		surah_id: '47',
		hizb_id: '202',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4555',
		number: '4555',
		text: '۞ أَفَلَمْ يَسِيرُوا۟ فِى ٱلْأَرْضِ فَيَنظُرُوا۟ كَيْفَ كَانَ عَٰقِبَةُ ٱلَّذِينَ مِن قَبْلِهِمْ ۚ دَمَّرَ ٱللَّهُ عَلَيْهِمْ ۖ وَلِلْكَٰفِرِينَ أَمْثَٰلُهَا',
		number_in_surah: '10',
		page: '507',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4556',
		number: '4556',
		text: 'ذَٰلِكَ بِأَنَّ ٱللَّهَ مَوْلَى ٱلَّذِينَ ءَامَنُوا۟ وَأَنَّ ٱلْكَٰفِرِينَ لَا مَوْلَىٰ لَهُمْ',
		number_in_surah: '11',
		page: '507',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4557',
		number: '4557',
		text: 'إِنَّ ٱللَّهَ يُدْخِلُ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۖ وَٱلَّذِينَ كَفَرُوا۟ يَتَمَتَّعُونَ وَيَأْكُلُونَ كَمَا تَأْكُلُ ٱلْأَنْعَٰمُ وَٱلنَّارُ مَثْوًۭى لَّهُمْ',
		number_in_surah: '12',
		page: '508',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4558',
		number: '4558',
		text: 'وَكَأَيِّن مِّن قَرْيَةٍ هِىَ أَشَدُّ قُوَّةًۭ مِّن قَرْيَتِكَ ٱلَّتِىٓ أَخْرَجَتْكَ أَهْلَكْنَٰهُمْ فَلَا نَاصِرَ لَهُمْ',
		number_in_surah: '13',
		page: '508',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4559',
		number: '4559',
		text: 'أَفَمَن كَانَ عَلَىٰ بَيِّنَةٍۢ مِّن رَّبِّهِۦ كَمَن زُيِّنَ لَهُۥ سُوٓءُ عَمَلِهِۦ وَٱتَّبَعُوٓا۟ أَهْوَآءَهُم',
		number_in_surah: '14',
		page: '508',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4560',
		number: '4560',
		text: 'مَّثَلُ ٱلْجَنَّةِ ٱلَّتِى وُعِدَ ٱلْمُتَّقُونَ ۖ فِيهَآ أَنْهَٰرٌۭ مِّن مَّآءٍ غَيْرِ ءَاسِنٍۢ وَأَنْهَٰرٌۭ مِّن لَّبَنٍۢ لَّمْ يَتَغَيَّرْ طَعْمُهُۥ وَأَنْهَٰرٌۭ مِّنْ خَمْرٍۢ لَّذَّةٍۢ لِّلشَّٰرِبِينَ وَأَنْهَٰرٌۭ مِّنْ عَسَلٍۢ مُّصَفًّۭى ۖ وَلَهُمْ فِيهَا مِن كُلِّ ٱلثَّمَرَٰتِ وَمَغْفِرَةٌۭ مِّن رَّبِّهِمْ ۖ كَمَنْ هُوَ خَٰلِدٌۭ فِى ٱلنَّارِ وَسُقُوا۟ مَآءً حَمِيمًۭا فَقَطَّعَ أَمْعَآءَهُمْ',
		number_in_surah: '15',
		page: '508',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4561',
		number: '4561',
		text: 'وَمِنْهُم مَّن يَسْتَمِعُ إِلَيْكَ حَتَّىٰٓ إِذَا خَرَجُوا۟ مِنْ عِندِكَ قَالُوا۟ لِلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ مَاذَا قَالَ ءَانِفًا ۚ أُو۟لَٰٓئِكَ ٱلَّذِينَ طَبَعَ ٱللَّهُ عَلَىٰ قُلُوبِهِمْ وَٱتَّبَعُوٓا۟ أَهْوَآءَهُمْ',
		number_in_surah: '16',
		page: '508',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4562',
		number: '4562',
		text: 'وَٱلَّذِينَ ٱهْتَدَوْا۟ زَادَهُمْ هُدًۭى وَءَاتَىٰهُمْ تَقْوَىٰهُمْ',
		number_in_surah: '17',
		page: '508',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4563',
		number: '4563',
		text: 'فَهَلْ يَنظُرُونَ إِلَّا ٱلسَّاعَةَ أَن تَأْتِيَهُم بَغْتَةًۭ ۖ فَقَدْ جَآءَ أَشْرَاطُهَا ۚ فَأَنَّىٰ لَهُمْ إِذَا جَآءَتْهُمْ ذِكْرَىٰهُمْ',
		number_in_surah: '18',
		page: '508',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4564',
		number: '4564',
		text: 'فَٱعْلَمْ أَنَّهُۥ لَآ إِلَٰهَ إِلَّا ٱللَّهُ وَٱسْتَغْفِرْ لِذَنۢبِكَ وَلِلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ ۗ وَٱللَّهُ يَعْلَمُ مُتَقَلَّبَكُمْ وَمَثْوَىٰكُمْ',
		number_in_surah: '19',
		page: '508',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4565',
		number: '4565',
		text: 'وَيَقُولُ ٱلَّذِينَ ءَامَنُوا۟ لَوْلَا نُزِّلَتْ سُورَةٌۭ ۖ فَإِذَآ أُنزِلَتْ سُورَةٌۭ مُّحْكَمَةٌۭ وَذُكِرَ فِيهَا ٱلْقِتَالُ ۙ رَأَيْتَ ٱلَّذِينَ فِى قُلُوبِهِم مَّرَضٌۭ يَنظُرُونَ إِلَيْكَ نَظَرَ ٱلْمَغْشِىِّ عَلَيْهِ مِنَ ٱلْمَوْتِ ۖ فَأَوْلَىٰ لَهُمْ',
		number_in_surah: '20',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4566',
		number: '4566',
		text: 'طَاعَةٌۭ وَقَوْلٌۭ مَّعْرُوفٌۭ ۚ فَإِذَا عَزَمَ ٱلْأَمْرُ فَلَوْ صَدَقُوا۟ ٱللَّهَ لَكَانَ خَيْرًۭا لَّهُمْ',
		number_in_surah: '21',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4567',
		number: '4567',
		text: 'فَهَلْ عَسَيْتُمْ إِن تَوَلَّيْتُمْ أَن تُفْسِدُوا۟ فِى ٱلْأَرْضِ وَتُقَطِّعُوٓا۟ أَرْحَامَكُمْ',
		number_in_surah: '22',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4568',
		number: '4568',
		text: 'أُو۟لَٰٓئِكَ ٱلَّذِينَ لَعَنَهُمُ ٱللَّهُ فَأَصَمَّهُمْ وَأَعْمَىٰٓ أَبْصَٰرَهُمْ',
		number_in_surah: '23',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4569',
		number: '4569',
		text: 'أَفَلَا يَتَدَبَّرُونَ ٱلْقُرْءَانَ أَمْ عَلَىٰ قُلُوبٍ أَقْفَالُهَآ',
		number_in_surah: '24',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4570',
		number: '4570',
		text: 'إِنَّ ٱلَّذِينَ ٱرْتَدُّوا۟ عَلَىٰٓ أَدْبَٰرِهِم مِّنۢ بَعْدِ مَا تَبَيَّنَ لَهُمُ ٱلْهُدَى ۙ ٱلشَّيْطَٰنُ سَوَّلَ لَهُمْ وَأَمْلَىٰ لَهُمْ',
		number_in_surah: '25',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4571',
		number: '4571',
		text: 'ذَٰلِكَ بِأَنَّهُمْ قَالُوا۟ لِلَّذِينَ كَرِهُوا۟ مَا نَزَّلَ ٱللَّهُ سَنُطِيعُكُمْ فِى بَعْضِ ٱلْأَمْرِ ۖ وَٱللَّهُ يَعْلَمُ إِسْرَارَهُمْ',
		number_in_surah: '26',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4572',
		number: '4572',
		text: 'فَكَيْفَ إِذَا تَوَفَّتْهُمُ ٱلْمَلَٰٓئِكَةُ يَضْرِبُونَ وُجُوهَهُمْ وَأَدْبَٰرَهُمْ',
		number_in_surah: '27',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4573',
		number: '4573',
		text: 'ذَٰلِكَ بِأَنَّهُمُ ٱتَّبَعُوا۟ مَآ أَسْخَطَ ٱللَّهَ وَكَرِهُوا۟ رِضْوَٰنَهُۥ فَأَحْبَطَ أَعْمَٰلَهُمْ',
		number_in_surah: '28',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4574',
		number: '4574',
		text: 'أَمْ حَسِبَ ٱلَّذِينَ فِى قُلُوبِهِم مَّرَضٌ أَن لَّن يُخْرِجَ ٱللَّهُ أَضْغَٰنَهُمْ',
		number_in_surah: '29',
		page: '509',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4575',
		number: '4575',
		text: 'وَلَوْ نَشَآءُ لَأَرَيْنَٰكَهُمْ فَلَعَرَفْتَهُم بِسِيمَٰهُمْ ۚ وَلَتَعْرِفَنَّهُمْ فِى لَحْنِ ٱلْقَوْلِ ۚ وَٱللَّهُ يَعْلَمُ أَعْمَٰلَكُمْ',
		number_in_surah: '30',
		page: '510',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4576',
		number: '4576',
		text: 'وَلَنَبْلُوَنَّكُمْ حَتَّىٰ نَعْلَمَ ٱلْمُجَٰهِدِينَ مِنكُمْ وَٱلصَّٰبِرِينَ وَنَبْلُوَا۟ أَخْبَارَكُمْ',
		number_in_surah: '31',
		page: '510',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4577',
		number: '4577',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ وَصَدُّوا۟ عَن سَبِيلِ ٱللَّهِ وَشَآقُّوا۟ ٱلرَّسُولَ مِنۢ بَعْدِ مَا تَبَيَّنَ لَهُمُ ٱلْهُدَىٰ لَن يَضُرُّوا۟ ٱللَّهَ شَيْـًۭٔا وَسَيُحْبِطُ أَعْمَٰلَهُمْ',
		number_in_surah: '32',
		page: '510',
		surah_id: '47',
		hizb_id: '203',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:12',
		updated_at: '2018-06-07 08:07:12',
	},
	{
		id: '4578',
		number: '4578',
		text: '۞ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ أَطِيعُوا۟ ٱللَّهَ وَأَطِيعُوا۟ ٱلرَّسُولَ وَلَا تُبْطِلُوٓا۟ أَعْمَٰلَكُمْ',
		number_in_surah: '33',
		page: '510',
		surah_id: '47',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4579',
		number: '4579',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ وَصَدُّوا۟ عَن سَبِيلِ ٱللَّهِ ثُمَّ مَاتُوا۟ وَهُمْ كُفَّارٌۭ فَلَن يَغْفِرَ ٱللَّهُ لَهُمْ',
		number_in_surah: '34',
		page: '510',
		surah_id: '47',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4580',
		number: '4580',
		text: 'فَلَا تَهِنُوا۟ وَتَدْعُوٓا۟ إِلَى ٱلسَّلْمِ وَأَنتُمُ ٱلْأَعْلَوْنَ وَٱللَّهُ مَعَكُمْ وَلَن يَتِرَكُمْ أَعْمَٰلَكُمْ',
		number_in_surah: '35',
		page: '510',
		surah_id: '47',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4581',
		number: '4581',
		text: 'إِنَّمَا ٱلْحَيَوٰةُ ٱلدُّنْيَا لَعِبٌۭ وَلَهْوٌۭ ۚ وَإِن تُؤْمِنُوا۟ وَتَتَّقُوا۟ يُؤْتِكُمْ أُجُورَكُمْ وَلَا يَسْـَٔلْكُمْ أَمْوَٰلَكُمْ',
		number_in_surah: '36',
		page: '510',
		surah_id: '47',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4582',
		number: '4582',
		text: 'إِن يَسْـَٔلْكُمُوهَا فَيُحْفِكُمْ تَبْخَلُوا۟ وَيُخْرِجْ أَضْغَٰنَكُمْ',
		number_in_surah: '37',
		page: '510',
		surah_id: '47',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4583',
		number: '4583',
		text: 'هَٰٓأَنتُمْ هَٰٓؤُلَآءِ تُدْعَوْنَ لِتُنفِقُوا۟ فِى سَبِيلِ ٱللَّهِ فَمِنكُم مَّن يَبْخَلُ ۖ وَمَن يَبْخَلْ فَإِنَّمَا يَبْخَلُ عَن نَّفْسِهِۦ ۚ وَٱللَّهُ ٱلْغَنِىُّ وَأَنتُمُ ٱلْفُقَرَآءُ ۚ وَإِن تَتَوَلَّوْا۟ يَسْتَبْدِلْ قَوْمًا غَيْرَكُمْ ثُمَّ لَا يَكُونُوٓا۟ أَمْثَٰلَكُم',
		number_in_surah: '38',
		page: '510',
		surah_id: '47',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4584',
		number: '4584',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِنَّا فَتَحْنَا لَكَ فَتْحًۭا مُّبِينًۭا',
		number_in_surah: '1',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4585',
		number: '4585',
		text: 'لِّيَغْفِرَ لَكَ ٱللَّهُ مَا تَقَدَّمَ مِن ذَنۢبِكَ وَمَا تَأَخَّرَ وَيُتِمَّ نِعْمَتَهُۥ عَلَيْكَ وَيَهْدِيَكَ صِرَٰطًۭا مُّسْتَقِيمًۭا',
		number_in_surah: '2',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4586',
		number: '4586',
		text: 'وَيَنصُرَكَ ٱللَّهُ نَصْرًا عَزِيزًا',
		number_in_surah: '3',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4587',
		number: '4587',
		text: 'هُوَ ٱلَّذِىٓ أَنزَلَ ٱلسَّكِينَةَ فِى قُلُوبِ ٱلْمُؤْمِنِينَ لِيَزْدَادُوٓا۟ إِيمَٰنًۭا مَّعَ إِيمَٰنِهِمْ ۗ وَلِلَّهِ جُنُودُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَكَانَ ٱللَّهُ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '4',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4588',
		number: '4588',
		text: 'لِّيُدْخِلَ ٱلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا وَيُكَفِّرَ عَنْهُمْ سَيِّـَٔاتِهِمْ ۚ وَكَانَ ذَٰلِكَ عِندَ ٱللَّهِ فَوْزًا عَظِيمًۭا',
		number_in_surah: '5',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4589',
		number: '4589',
		text: 'وَيُعَذِّبَ ٱلْمُنَٰفِقِينَ وَٱلْمُنَٰفِقَٰتِ وَٱلْمُشْرِكِينَ وَٱلْمُشْرِكَٰتِ ٱلظَّآنِّينَ بِٱللَّهِ ظَنَّ ٱلسَّوْءِ ۚ عَلَيْهِمْ دَآئِرَةُ ٱلسَّوْءِ ۖ وَغَضِبَ ٱللَّهُ عَلَيْهِمْ وَلَعَنَهُمْ وَأَعَدَّ لَهُمْ جَهَنَّمَ ۖ وَسَآءَتْ مَصِيرًۭا',
		number_in_surah: '6',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4590',
		number: '4590',
		text: 'وَلِلَّهِ جُنُودُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَكَانَ ٱللَّهُ عَزِيزًا حَكِيمًا',
		number_in_surah: '7',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4591',
		number: '4591',
		text: 'إِنَّآ أَرْسَلْنَٰكَ شَٰهِدًۭا وَمُبَشِّرًۭا وَنَذِيرًۭا',
		number_in_surah: '8',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4592',
		number: '4592',
		text: 'لِّتُؤْمِنُوا۟ بِٱللَّهِ وَرَسُولِهِۦ وَتُعَزِّرُوهُ وَتُوَقِّرُوهُ وَتُسَبِّحُوهُ بُكْرَةًۭ وَأَصِيلًا',
		number_in_surah: '9',
		page: '511',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4593',
		number: '4593',
		text: 'إِنَّ ٱلَّذِينَ يُبَايِعُونَكَ إِنَّمَا يُبَايِعُونَ ٱللَّهَ يَدُ ٱللَّهِ فَوْقَ أَيْدِيهِمْ ۚ فَمَن نَّكَثَ فَإِنَّمَا يَنكُثُ عَلَىٰ نَفْسِهِۦ ۖ وَمَنْ أَوْفَىٰ بِمَا عَٰهَدَ عَلَيْهُ ٱللَّهَ فَسَيُؤْتِيهِ أَجْرًا عَظِيمًۭا',
		number_in_surah: '10',
		page: '512',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4594',
		number: '4594',
		text: 'سَيَقُولُ لَكَ ٱلْمُخَلَّفُونَ مِنَ ٱلْأَعْرَابِ شَغَلَتْنَآ أَمْوَٰلُنَا وَأَهْلُونَا فَٱسْتَغْفِرْ لَنَا ۚ يَقُولُونَ بِأَلْسِنَتِهِم مَّا لَيْسَ فِى قُلُوبِهِمْ ۚ قُلْ فَمَن يَمْلِكُ لَكُم مِّنَ ٱللَّهِ شَيْـًٔا إِنْ أَرَادَ بِكُمْ ضَرًّا أَوْ أَرَادَ بِكُمْ نَفْعًۢا ۚ بَلْ كَانَ ٱللَّهُ بِمَا تَعْمَلُونَ خَبِيرًۢا',
		number_in_surah: '11',
		page: '512',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4595',
		number: '4595',
		text: 'بَلْ ظَنَنتُمْ أَن لَّن يَنقَلِبَ ٱلرَّسُولُ وَٱلْمُؤْمِنُونَ إِلَىٰٓ أَهْلِيهِمْ أَبَدًۭا وَزُيِّنَ ذَٰلِكَ فِى قُلُوبِكُمْ وَظَنَنتُمْ ظَنَّ ٱلسَّوْءِ وَكُنتُمْ قَوْمًۢا بُورًۭا',
		number_in_surah: '12',
		page: '512',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4596',
		number: '4596',
		text: 'وَمَن لَّمْ يُؤْمِنۢ بِٱللَّهِ وَرَسُولِهِۦ فَإِنَّآ أَعْتَدْنَا لِلْكَٰفِرِينَ سَعِيرًۭا',
		number_in_surah: '13',
		page: '512',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4597',
		number: '4597',
		text: 'وَلِلَّهِ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ يَغْفِرُ لِمَن يَشَآءُ وَيُعَذِّبُ مَن يَشَآءُ ۚ وَكَانَ ٱللَّهُ غَفُورًۭا رَّحِيمًۭا',
		number_in_surah: '14',
		page: '512',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4598',
		number: '4598',
		text: 'سَيَقُولُ ٱلْمُخَلَّفُونَ إِذَا ٱنطَلَقْتُمْ إِلَىٰ مَغَانِمَ لِتَأْخُذُوهَا ذَرُونَا نَتَّبِعْكُمْ ۖ يُرِيدُونَ أَن يُبَدِّلُوا۟ كَلَٰمَ ٱللَّهِ ۚ قُل لَّن تَتَّبِعُونَا كَذَٰلِكُمْ قَالَ ٱللَّهُ مِن قَبْلُ ۖ فَسَيَقُولُونَ بَلْ تَحْسُدُونَنَا ۚ بَلْ كَانُوا۟ لَا يَفْقَهُونَ إِلَّا قَلِيلًۭا',
		number_in_surah: '15',
		page: '512',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4599',
		number: '4599',
		text: 'قُل لِّلْمُخَلَّفِينَ مِنَ ٱلْأَعْرَابِ سَتُدْعَوْنَ إِلَىٰ قَوْمٍ أُو۟لِى بَأْسٍۢ شَدِيدٍۢ تُقَٰتِلُونَهُمْ أَوْ يُسْلِمُونَ ۖ فَإِن تُطِيعُوا۟ يُؤْتِكُمُ ٱللَّهُ أَجْرًا حَسَنًۭا ۖ وَإِن تَتَوَلَّوْا۟ كَمَا تَوَلَّيْتُم مِّن قَبْلُ يُعَذِّبْكُمْ عَذَابًا أَلِيمًۭا',
		number_in_surah: '16',
		page: '513',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4600',
		number: '4600',
		text: 'لَّيْسَ عَلَى ٱلْأَعْمَىٰ حَرَجٌۭ وَلَا عَلَى ٱلْأَعْرَجِ حَرَجٌۭ وَلَا عَلَى ٱلْمَرِيضِ حَرَجٌۭ ۗ وَمَن يُطِعِ ٱللَّهَ وَرَسُولَهُۥ يُدْخِلْهُ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۖ وَمَن يَتَوَلَّ يُعَذِّبْهُ عَذَابًا أَلِيمًۭا',
		number_in_surah: '17',
		page: '513',
		surah_id: '48',
		hizb_id: '204',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4601',
		number: '4601',
		text: '۞ لَّقَدْ رَضِىَ ٱللَّهُ عَنِ ٱلْمُؤْمِنِينَ إِذْ يُبَايِعُونَكَ تَحْتَ ٱلشَّجَرَةِ فَعَلِمَ مَا فِى قُلُوبِهِمْ فَأَنزَلَ ٱلسَّكِينَةَ عَلَيْهِمْ وَأَثَٰبَهُمْ فَتْحًۭا قَرِيبًۭا',
		number_in_surah: '18',
		page: '513',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4602',
		number: '4602',
		text: 'وَمَغَانِمَ كَثِيرَةًۭ يَأْخُذُونَهَا ۗ وَكَانَ ٱللَّهُ عَزِيزًا حَكِيمًۭا',
		number_in_surah: '19',
		page: '513',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4603',
		number: '4603',
		text: 'وَعَدَكُمُ ٱللَّهُ مَغَانِمَ كَثِيرَةًۭ تَأْخُذُونَهَا فَعَجَّلَ لَكُمْ هَٰذِهِۦ وَكَفَّ أَيْدِىَ ٱلنَّاسِ عَنكُمْ وَلِتَكُونَ ءَايَةًۭ لِّلْمُؤْمِنِينَ وَيَهْدِيَكُمْ صِرَٰطًۭا مُّسْتَقِيمًۭا',
		number_in_surah: '20',
		page: '513',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4604',
		number: '4604',
		text: 'وَأُخْرَىٰ لَمْ تَقْدِرُوا۟ عَلَيْهَا قَدْ أَحَاطَ ٱللَّهُ بِهَا ۚ وَكَانَ ٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرًۭا',
		number_in_surah: '21',
		page: '513',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4605',
		number: '4605',
		text: 'وَلَوْ قَٰتَلَكُمُ ٱلَّذِينَ كَفَرُوا۟ لَوَلَّوُا۟ ٱلْأَدْبَٰرَ ثُمَّ لَا يَجِدُونَ وَلِيًّۭا وَلَا نَصِيرًۭا',
		number_in_surah: '22',
		page: '513',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4606',
		number: '4606',
		text: 'سُنَّةَ ٱللَّهِ ٱلَّتِى قَدْ خَلَتْ مِن قَبْلُ ۖ وَلَن تَجِدَ لِسُنَّةِ ٱللَّهِ تَبْدِيلًۭا',
		number_in_surah: '23',
		page: '513',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4607',
		number: '4607',
		text: 'وَهُوَ ٱلَّذِى كَفَّ أَيْدِيَهُمْ عَنكُمْ وَأَيْدِيَكُمْ عَنْهُم بِبَطْنِ مَكَّةَ مِنۢ بَعْدِ أَنْ أَظْفَرَكُمْ عَلَيْهِمْ ۚ وَكَانَ ٱللَّهُ بِمَا تَعْمَلُونَ بَصِيرًا',
		number_in_surah: '24',
		page: '514',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4608',
		number: '4608',
		text: 'هُمُ ٱلَّذِينَ كَفَرُوا۟ وَصَدُّوكُمْ عَنِ ٱلْمَسْجِدِ ٱلْحَرَامِ وَٱلْهَدْىَ مَعْكُوفًا أَن يَبْلُغَ مَحِلَّهُۥ ۚ وَلَوْلَا رِجَالٌۭ مُّؤْمِنُونَ وَنِسَآءٌۭ مُّؤْمِنَٰتٌۭ لَّمْ تَعْلَمُوهُمْ أَن تَطَـُٔوهُمْ فَتُصِيبَكُم مِّنْهُم مَّعَرَّةٌۢ بِغَيْرِ عِلْمٍۢ ۖ لِّيُدْخِلَ ٱللَّهُ فِى رَحْمَتِهِۦ مَن يَشَآءُ ۚ لَوْ تَزَيَّلُوا۟ لَعَذَّبْنَا ٱلَّذِينَ كَفَرُوا۟ مِنْهُمْ عَذَابًا أَلِيمًا',
		number_in_surah: '25',
		page: '514',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4609',
		number: '4609',
		text: 'إِذْ جَعَلَ ٱلَّذِينَ كَفَرُوا۟ فِى قُلُوبِهِمُ ٱلْحَمِيَّةَ حَمِيَّةَ ٱلْجَٰهِلِيَّةِ فَأَنزَلَ ٱللَّهُ سَكِينَتَهُۥ عَلَىٰ رَسُولِهِۦ وَعَلَى ٱلْمُؤْمِنِينَ وَأَلْزَمَهُمْ كَلِمَةَ ٱلتَّقْوَىٰ وَكَانُوٓا۟ أَحَقَّ بِهَا وَأَهْلَهَا ۚ وَكَانَ ٱللَّهُ بِكُلِّ شَىْءٍ عَلِيمًۭا',
		number_in_surah: '26',
		page: '514',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4610',
		number: '4610',
		text: 'لَّقَدْ صَدَقَ ٱللَّهُ رَسُولَهُ ٱلرُّءْيَا بِٱلْحَقِّ ۖ لَتَدْخُلُنَّ ٱلْمَسْجِدَ ٱلْحَرَامَ إِن شَآءَ ٱللَّهُ ءَامِنِينَ مُحَلِّقِينَ رُءُوسَكُمْ وَمُقَصِّرِينَ لَا تَخَافُونَ ۖ فَعَلِمَ مَا لَمْ تَعْلَمُوا۟ فَجَعَلَ مِن دُونِ ذَٰلِكَ فَتْحًۭا قَرِيبًا',
		number_in_surah: '27',
		page: '514',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4611',
		number: '4611',
		text: 'هُوَ ٱلَّذِىٓ أَرْسَلَ رَسُولَهُۥ بِٱلْهُدَىٰ وَدِينِ ٱلْحَقِّ لِيُظْهِرَهُۥ عَلَى ٱلدِّينِ كُلِّهِۦ ۚ وَكَفَىٰ بِٱللَّهِ شَهِيدًۭا',
		number_in_surah: '28',
		page: '514',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4612',
		number: '4612',
		text: 'مُّحَمَّدٌۭ رَّسُولُ ٱللَّهِ ۚ وَٱلَّذِينَ مَعَهُۥٓ أَشِدَّآءُ عَلَى ٱلْكُفَّارِ رُحَمَآءُ بَيْنَهُمْ ۖ تَرَىٰهُمْ رُكَّعًۭا سُجَّدًۭا يَبْتَغُونَ فَضْلًۭا مِّنَ ٱللَّهِ وَرِضْوَٰنًۭا ۖ سِيمَاهُمْ فِى وُجُوهِهِم مِّنْ أَثَرِ ٱلسُّجُودِ ۚ ذَٰلِكَ مَثَلُهُمْ فِى ٱلتَّوْرَىٰةِ ۚ وَمَثَلُهُمْ فِى ٱلْإِنجِيلِ كَزَرْعٍ أَخْرَجَ شَطْـَٔهُۥ فَـَٔازَرَهُۥ فَٱسْتَغْلَظَ فَٱسْتَوَىٰ عَلَىٰ سُوقِهِۦ يُعْجِبُ ٱلزُّرَّاعَ لِيَغِيظَ بِهِمُ ٱلْكُفَّارَ ۗ وَعَدَ ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ مِنْهُم مَّغْفِرَةًۭ وَأَجْرًا عَظِيمًۢا',
		number_in_surah: '29',
		page: '515',
		surah_id: '48',
		hizb_id: '205',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4613',
		number: '4613',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تُقَدِّمُوا۟ بَيْنَ يَدَىِ ٱللَّهِ وَرَسُولِهِۦ ۖ وَٱتَّقُوا۟ ٱللَّهَ ۚ إِنَّ ٱللَّهَ سَمِيعٌ عَلِيمٌۭ',
		number_in_surah: '1',
		page: '515',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4614',
		number: '4614',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَرْفَعُوٓا۟ أَصْوَٰتَكُمْ فَوْقَ صَوْتِ ٱلنَّبِىِّ وَلَا تَجْهَرُوا۟ لَهُۥ بِٱلْقَوْلِ كَجَهْرِ بَعْضِكُمْ لِبَعْضٍ أَن تَحْبَطَ أَعْمَٰلُكُمْ وَأَنتُمْ لَا تَشْعُرُونَ',
		number_in_surah: '2',
		page: '515',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4615',
		number: '4615',
		text: 'إِنَّ ٱلَّذِينَ يَغُضُّونَ أَصْوَٰتَهُمْ عِندَ رَسُولِ ٱللَّهِ أُو۟لَٰٓئِكَ ٱلَّذِينَ ٱمْتَحَنَ ٱللَّهُ قُلُوبَهُمْ لِلتَّقْوَىٰ ۚ لَهُم مَّغْفِرَةٌۭ وَأَجْرٌ عَظِيمٌ',
		number_in_surah: '3',
		page: '515',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4616',
		number: '4616',
		text: 'إِنَّ ٱلَّذِينَ يُنَادُونَكَ مِن وَرَآءِ ٱلْحُجُرَٰتِ أَكْثَرُهُمْ لَا يَعْقِلُونَ',
		number_in_surah: '4',
		page: '515',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4617',
		number: '4617',
		text: 'وَلَوْ أَنَّهُمْ صَبَرُوا۟ حَتَّىٰ تَخْرُجَ إِلَيْهِمْ لَكَانَ خَيْرًۭا لَّهُمْ ۚ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '5',
		page: '516',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4618',
		number: '4618',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِن جَآءَكُمْ فَاسِقٌۢ بِنَبَإٍۢ فَتَبَيَّنُوٓا۟ أَن تُصِيبُوا۟ قَوْمًۢا بِجَهَٰلَةٍۢ فَتُصْبِحُوا۟ عَلَىٰ مَا فَعَلْتُمْ نَٰدِمِينَ',
		number_in_surah: '6',
		page: '516',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4619',
		number: '4619',
		text: 'وَٱعْلَمُوٓا۟ أَنَّ فِيكُمْ رَسُولَ ٱللَّهِ ۚ لَوْ يُطِيعُكُمْ فِى كَثِيرٍۢ مِّنَ ٱلْأَمْرِ لَعَنِتُّمْ وَلَٰكِنَّ ٱللَّهَ حَبَّبَ إِلَيْكُمُ ٱلْإِيمَٰنَ وَزَيَّنَهُۥ فِى قُلُوبِكُمْ وَكَرَّهَ إِلَيْكُمُ ٱلْكُفْرَ وَٱلْفُسُوقَ وَٱلْعِصْيَانَ ۚ أُو۟لَٰٓئِكَ هُمُ ٱلرَّٰشِدُونَ',
		number_in_surah: '7',
		page: '516',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4620',
		number: '4620',
		text: 'فَضْلًۭا مِّنَ ٱللَّهِ وَنِعْمَةًۭ ۚ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '8',
		page: '516',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4621',
		number: '4621',
		text: 'وَإِن طَآئِفَتَانِ مِنَ ٱلْمُؤْمِنِينَ ٱقْتَتَلُوا۟ فَأَصْلِحُوا۟ بَيْنَهُمَا ۖ فَإِنۢ بَغَتْ إِحْدَىٰهُمَا عَلَى ٱلْأُخْرَىٰ فَقَٰتِلُوا۟ ٱلَّتِى تَبْغِى حَتَّىٰ تَفِىٓءَ إِلَىٰٓ أَمْرِ ٱللَّهِ ۚ فَإِن فَآءَتْ فَأَصْلِحُوا۟ بَيْنَهُمَا بِٱلْعَدْلِ وَأَقْسِطُوٓا۟ ۖ إِنَّ ٱللَّهَ يُحِبُّ ٱلْمُقْسِطِينَ',
		number_in_surah: '9',
		page: '516',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4622',
		number: '4622',
		text: 'إِنَّمَا ٱلْمُؤْمِنُونَ إِخْوَةٌۭ فَأَصْلِحُوا۟ بَيْنَ أَخَوَيْكُمْ ۚ وَٱتَّقُوا۟ ٱللَّهَ لَعَلَّكُمْ تُرْحَمُونَ',
		number_in_surah: '10',
		page: '516',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4623',
		number: '4623',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا يَسْخَرْ قَوْمٌۭ مِّن قَوْمٍ عَسَىٰٓ أَن يَكُونُوا۟ خَيْرًۭا مِّنْهُمْ وَلَا نِسَآءٌۭ مِّن نِّسَآءٍ عَسَىٰٓ أَن يَكُنَّ خَيْرًۭا مِّنْهُنَّ ۖ وَلَا تَلْمِزُوٓا۟ أَنفُسَكُمْ وَلَا تَنَابَزُوا۟ بِٱلْأَلْقَٰبِ ۖ بِئْسَ ٱلِٱسْمُ ٱلْفُسُوقُ بَعْدَ ٱلْإِيمَٰنِ ۚ وَمَن لَّمْ يَتُبْ فَأُو۟لَٰٓئِكَ هُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '11',
		page: '516',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4624',
		number: '4624',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱجْتَنِبُوا۟ كَثِيرًۭا مِّنَ ٱلظَّنِّ إِنَّ بَعْضَ ٱلظَّنِّ إِثْمٌۭ ۖ وَلَا تَجَسَّسُوا۟ وَلَا يَغْتَب بَّعْضُكُم بَعْضًا ۚ أَيُحِبُّ أَحَدُكُمْ أَن يَأْكُلَ لَحْمَ أَخِيهِ مَيْتًۭا فَكَرِهْتُمُوهُ ۚ وَٱتَّقُوا۟ ٱللَّهَ ۚ إِنَّ ٱللَّهَ تَوَّابٌۭ رَّحِيمٌۭ',
		number_in_surah: '12',
		page: '517',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4625',
		number: '4625',
		text: 'يَٰٓأَيُّهَا ٱلنَّاسُ إِنَّا خَلَقْنَٰكُم مِّن ذَكَرٍۢ وَأُنثَىٰ وَجَعَلْنَٰكُمْ شُعُوبًۭا وَقَبَآئِلَ لِتَعَارَفُوٓا۟ ۚ إِنَّ أَكْرَمَكُمْ عِندَ ٱللَّهِ أَتْقَىٰكُمْ ۚ إِنَّ ٱللَّهَ عَلِيمٌ خَبِيرٌۭ',
		number_in_surah: '13',
		page: '517',
		surah_id: '49',
		hizb_id: '206',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4626',
		number: '4626',
		text: '۞ قَالَتِ ٱلْأَعْرَابُ ءَامَنَّا ۖ قُل لَّمْ تُؤْمِنُوا۟ وَلَٰكِن قُولُوٓا۟ أَسْلَمْنَا وَلَمَّا يَدْخُلِ ٱلْإِيمَٰنُ فِى قُلُوبِكُمْ ۖ وَإِن تُطِيعُوا۟ ٱللَّهَ وَرَسُولَهُۥ لَا يَلِتْكُم مِّنْ أَعْمَٰلِكُمْ شَيْـًٔا ۚ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '14',
		page: '517',
		surah_id: '49',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4627',
		number: '4627',
		text: 'إِنَّمَا ٱلْمُؤْمِنُونَ ٱلَّذِينَ ءَامَنُوا۟ بِٱللَّهِ وَرَسُولِهِۦ ثُمَّ لَمْ يَرْتَابُوا۟ وَجَٰهَدُوا۟ بِأَمْوَٰلِهِمْ وَأَنفُسِهِمْ فِى سَبِيلِ ٱللَّهِ ۚ أُو۟لَٰٓئِكَ هُمُ ٱلصَّٰدِقُونَ',
		number_in_surah: '15',
		page: '517',
		surah_id: '49',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4628',
		number: '4628',
		text: 'قُلْ أَتُعَلِّمُونَ ٱللَّهَ بِدِينِكُمْ وَٱللَّهُ يَعْلَمُ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۚ وَٱللَّهُ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '16',
		page: '517',
		surah_id: '49',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4629',
		number: '4629',
		text: 'يَمُنُّونَ عَلَيْكَ أَنْ أَسْلَمُوا۟ ۖ قُل لَّا تَمُنُّوا۟ عَلَىَّ إِسْلَٰمَكُم ۖ بَلِ ٱللَّهُ يَمُنُّ عَلَيْكُمْ أَنْ هَدَىٰكُمْ لِلْإِيمَٰنِ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '17',
		page: '517',
		surah_id: '49',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4630',
		number: '4630',
		text: 'إِنَّ ٱللَّهَ يَعْلَمُ غَيْبَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَٱللَّهُ بَصِيرٌۢ بِمَا تَعْمَلُونَ',
		number_in_surah: '18',
		page: '517',
		surah_id: '49',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4631',
		number: '4631',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ قٓ ۚ وَٱلْقُرْءَانِ ٱلْمَجِيدِ',
		number_in_surah: '1',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4632',
		number: '4632',
		text: 'بَلْ عَجِبُوٓا۟ أَن جَآءَهُم مُّنذِرٌۭ مِّنْهُمْ فَقَالَ ٱلْكَٰفِرُونَ هَٰذَا شَىْءٌ عَجِيبٌ',
		number_in_surah: '2',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4633',
		number: '4633',
		text: 'أَءِذَا مِتْنَا وَكُنَّا تُرَابًۭا ۖ ذَٰلِكَ رَجْعٌۢ بَعِيدٌۭ',
		number_in_surah: '3',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4634',
		number: '4634',
		text: 'قَدْ عَلِمْنَا مَا تَنقُصُ ٱلْأَرْضُ مِنْهُمْ ۖ وَعِندَنَا كِتَٰبٌ حَفِيظٌۢ',
		number_in_surah: '4',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4635',
		number: '4635',
		text: 'بَلْ كَذَّبُوا۟ بِٱلْحَقِّ لَمَّا جَآءَهُمْ فَهُمْ فِىٓ أَمْرٍۢ مَّرِيجٍ',
		number_in_surah: '5',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4636',
		number: '4636',
		text: 'أَفَلَمْ يَنظُرُوٓا۟ إِلَى ٱلسَّمَآءِ فَوْقَهُمْ كَيْفَ بَنَيْنَٰهَا وَزَيَّنَّٰهَا وَمَا لَهَا مِن فُرُوجٍۢ',
		number_in_surah: '6',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4637',
		number: '4637',
		text: 'وَٱلْأَرْضَ مَدَدْنَٰهَا وَأَلْقَيْنَا فِيهَا رَوَٰسِىَ وَأَنۢبَتْنَا فِيهَا مِن كُلِّ زَوْجٍۭ بَهِيجٍۢ',
		number_in_surah: '7',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4638',
		number: '4638',
		text: 'تَبْصِرَةًۭ وَذِكْرَىٰ لِكُلِّ عَبْدٍۢ مُّنِيبٍۢ',
		number_in_surah: '8',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4639',
		number: '4639',
		text: 'وَنَزَّلْنَا مِنَ ٱلسَّمَآءِ مَآءًۭ مُّبَٰرَكًۭا فَأَنۢبَتْنَا بِهِۦ جَنَّٰتٍۢ وَحَبَّ ٱلْحَصِيدِ',
		number_in_surah: '9',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4640',
		number: '4640',
		text: 'وَٱلنَّخْلَ بَاسِقَٰتٍۢ لَّهَا طَلْعٌۭ نَّضِيدٌۭ',
		number_in_surah: '10',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4641',
		number: '4641',
		text: 'رِّزْقًۭا لِّلْعِبَادِ ۖ وَأَحْيَيْنَا بِهِۦ بَلْدَةًۭ مَّيْتًۭا ۚ كَذَٰلِكَ ٱلْخُرُوجُ',
		number_in_surah: '11',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4642',
		number: '4642',
		text: 'كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍۢ وَأَصْحَٰبُ ٱلرَّسِّ وَثَمُودُ',
		number_in_surah: '12',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4643',
		number: '4643',
		text: 'وَعَادٌۭ وَفِرْعَوْنُ وَإِخْوَٰنُ لُوطٍۢ',
		number_in_surah: '13',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4644',
		number: '4644',
		text: 'وَأَصْحَٰبُ ٱلْأَيْكَةِ وَقَوْمُ تُبَّعٍۢ ۚ كُلٌّۭ كَذَّبَ ٱلرُّسُلَ فَحَقَّ وَعِيدِ',
		number_in_surah: '14',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4645',
		number: '4645',
		text: 'أَفَعَيِينَا بِٱلْخَلْقِ ٱلْأَوَّلِ ۚ بَلْ هُمْ فِى لَبْسٍۢ مِّنْ خَلْقٍۢ جَدِيدٍۢ',
		number_in_surah: '15',
		page: '518',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4646',
		number: '4646',
		text: 'وَلَقَدْ خَلَقْنَا ٱلْإِنسَٰنَ وَنَعْلَمُ مَا تُوَسْوِسُ بِهِۦ نَفْسُهُۥ ۖ وَنَحْنُ أَقْرَبُ إِلَيْهِ مِنْ حَبْلِ ٱلْوَرِيدِ',
		number_in_surah: '16',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4647',
		number: '4647',
		text: 'إِذْ يَتَلَقَّى ٱلْمُتَلَقِّيَانِ عَنِ ٱلْيَمِينِ وَعَنِ ٱلشِّمَالِ قَعِيدٌۭ',
		number_in_surah: '17',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4648',
		number: '4648',
		text: 'مَّا يَلْفِظُ مِن قَوْلٍ إِلَّا لَدَيْهِ رَقِيبٌ عَتِيدٌۭ',
		number_in_surah: '18',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4649',
		number: '4649',
		text: 'وَجَآءَتْ سَكْرَةُ ٱلْمَوْتِ بِٱلْحَقِّ ۖ ذَٰلِكَ مَا كُنتَ مِنْهُ تَحِيدُ',
		number_in_surah: '19',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4650',
		number: '4650',
		text: 'وَنُفِخَ فِى ٱلصُّورِ ۚ ذَٰلِكَ يَوْمُ ٱلْوَعِيدِ',
		number_in_surah: '20',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4651',
		number: '4651',
		text: 'وَجَآءَتْ كُلُّ نَفْسٍۢ مَّعَهَا سَآئِقٌۭ وَشَهِيدٌۭ',
		number_in_surah: '21',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4652',
		number: '4652',
		text: 'لَّقَدْ كُنتَ فِى غَفْلَةٍۢ مِّنْ هَٰذَا فَكَشَفْنَا عَنكَ غِطَآءَكَ فَبَصَرُكَ ٱلْيَوْمَ حَدِيدٌۭ',
		number_in_surah: '22',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4653',
		number: '4653',
		text: 'وَقَالَ قَرِينُهُۥ هَٰذَا مَا لَدَىَّ عَتِيدٌ',
		number_in_surah: '23',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4654',
		number: '4654',
		text: 'أَلْقِيَا فِى جَهَنَّمَ كُلَّ كَفَّارٍ عَنِيدٍۢ',
		number_in_surah: '24',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4655',
		number: '4655',
		text: 'مَّنَّاعٍۢ لِّلْخَيْرِ مُعْتَدٍۢ مُّرِيبٍ',
		number_in_surah: '25',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4656',
		number: '4656',
		text: 'ٱلَّذِى جَعَلَ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ فَأَلْقِيَاهُ فِى ٱلْعَذَابِ ٱلشَّدِيدِ',
		number_in_surah: '26',
		page: '519',
		surah_id: '50',
		hizb_id: '207',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4657',
		number: '4657',
		text: '۞ قَالَ قَرِينُهُۥ رَبَّنَا مَآ أَطْغَيْتُهُۥ وَلَٰكِن كَانَ فِى ضَلَٰلٍۭ بَعِيدٍۢ',
		number_in_surah: '27',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4658',
		number: '4658',
		text: 'قَالَ لَا تَخْتَصِمُوا۟ لَدَىَّ وَقَدْ قَدَّمْتُ إِلَيْكُم بِٱلْوَعِيدِ',
		number_in_surah: '28',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4659',
		number: '4659',
		text: 'مَا يُبَدَّلُ ٱلْقَوْلُ لَدَىَّ وَمَآ أَنَا۠ بِظَلَّٰمٍۢ لِّلْعَبِيدِ',
		number_in_surah: '29',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4660',
		number: '4660',
		text: 'يَوْمَ نَقُولُ لِجَهَنَّمَ هَلِ ٱمْتَلَأْتِ وَتَقُولُ هَلْ مِن مَّزِيدٍۢ',
		number_in_surah: '30',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4661',
		number: '4661',
		text: 'وَأُزْلِفَتِ ٱلْجَنَّةُ لِلْمُتَّقِينَ غَيْرَ بَعِيدٍ',
		number_in_surah: '31',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4662',
		number: '4662',
		text: 'هَٰذَا مَا تُوعَدُونَ لِكُلِّ أَوَّابٍ حَفِيظٍۢ',
		number_in_surah: '32',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4663',
		number: '4663',
		text: 'مَّنْ خَشِىَ ٱلرَّحْمَٰنَ بِٱلْغَيْبِ وَجَآءَ بِقَلْبٍۢ مُّنِيبٍ',
		number_in_surah: '33',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4664',
		number: '4664',
		text: 'ٱدْخُلُوهَا بِسَلَٰمٍۢ ۖ ذَٰلِكَ يَوْمُ ٱلْخُلُودِ',
		number_in_surah: '34',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4665',
		number: '4665',
		text: 'لَهُم مَّا يَشَآءُونَ فِيهَا وَلَدَيْنَا مَزِيدٌۭ',
		number_in_surah: '35',
		page: '519',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4666',
		number: '4666',
		text: 'وَكَمْ أَهْلَكْنَا قَبْلَهُم مِّن قَرْنٍ هُمْ أَشَدُّ مِنْهُم بَطْشًۭا فَنَقَّبُوا۟ فِى ٱلْبِلَٰدِ هَلْ مِن مَّحِيصٍ',
		number_in_surah: '36',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4667',
		number: '4667',
		text: 'إِنَّ فِى ذَٰلِكَ لَذِكْرَىٰ لِمَن كَانَ لَهُۥ قَلْبٌ أَوْ أَلْقَى ٱلسَّمْعَ وَهُوَ شَهِيدٌۭ',
		number_in_surah: '37',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4668',
		number: '4668',
		text: 'وَلَقَدْ خَلَقْنَا ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ وَمَا بَيْنَهُمَا فِى سِتَّةِ أَيَّامٍۢ وَمَا مَسَّنَا مِن لُّغُوبٍۢ',
		number_in_surah: '38',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4669',
		number: '4669',
		text: 'فَٱصْبِرْ عَلَىٰ مَا يَقُولُونَ وَسَبِّحْ بِحَمْدِ رَبِّكَ قَبْلَ طُلُوعِ ٱلشَّمْسِ وَقَبْلَ ٱلْغُرُوبِ',
		number_in_surah: '39',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4670',
		number: '4670',
		text: 'وَمِنَ ٱلَّيْلِ فَسَبِّحْهُ وَأَدْبَٰرَ ٱلسُّجُودِ',
		number_in_surah: '40',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4671',
		number: '4671',
		text: 'وَٱسْتَمِعْ يَوْمَ يُنَادِ ٱلْمُنَادِ مِن مَّكَانٍۢ قَرِيبٍۢ',
		number_in_surah: '41',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4672',
		number: '4672',
		text: 'يَوْمَ يَسْمَعُونَ ٱلصَّيْحَةَ بِٱلْحَقِّ ۚ ذَٰلِكَ يَوْمُ ٱلْخُرُوجِ',
		number_in_surah: '42',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4673',
		number: '4673',
		text: 'إِنَّا نَحْنُ نُحْىِۦ وَنُمِيتُ وَإِلَيْنَا ٱلْمَصِيرُ',
		number_in_surah: '43',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4674',
		number: '4674',
		text: 'يَوْمَ تَشَقَّقُ ٱلْأَرْضُ عَنْهُمْ سِرَاعًۭا ۚ ذَٰلِكَ حَشْرٌ عَلَيْنَا يَسِيرٌۭ',
		number_in_surah: '44',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4675',
		number: '4675',
		text: 'نَّحْنُ أَعْلَمُ بِمَا يَقُولُونَ ۖ وَمَآ أَنتَ عَلَيْهِم بِجَبَّارٍۢ ۖ فَذَكِّرْ بِٱلْقُرْءَانِ مَن يَخَافُ وَعِيدِ',
		number_in_surah: '45',
		page: '520',
		surah_id: '50',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4676',
		number: '4676',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلذَّٰرِيَٰتِ ذَرْوًۭا',
		number_in_surah: '1',
		page: '520',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4677',
		number: '4677',
		text: 'فَٱلْحَٰمِلَٰتِ وِقْرًۭا',
		number_in_surah: '2',
		page: '520',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4678',
		number: '4678',
		text: 'فَٱلْجَٰرِيَٰتِ يُسْرًۭا',
		number_in_surah: '3',
		page: '520',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4679',
		number: '4679',
		text: 'فَٱلْمُقَسِّمَٰتِ أَمْرًا',
		number_in_surah: '4',
		page: '520',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4680',
		number: '4680',
		text: 'إِنَّمَا تُوعَدُونَ لَصَادِقٌۭ',
		number_in_surah: '5',
		page: '520',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4681',
		number: '4681',
		text: 'وَإِنَّ ٱلدِّينَ لَوَٰقِعٌۭ',
		number_in_surah: '6',
		page: '520',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4682',
		number: '4682',
		text: 'وَٱلسَّمَآءِ ذَاتِ ٱلْحُبُكِ',
		number_in_surah: '7',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4683',
		number: '4683',
		text: 'إِنَّكُمْ لَفِى قَوْلٍۢ مُّخْتَلِفٍۢ',
		number_in_surah: '8',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4684',
		number: '4684',
		text: 'يُؤْفَكُ عَنْهُ مَنْ أُفِكَ',
		number_in_surah: '9',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4685',
		number: '4685',
		text: 'قُتِلَ ٱلْخَرَّٰصُونَ',
		number_in_surah: '10',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4686',
		number: '4686',
		text: 'ٱلَّذِينَ هُمْ فِى غَمْرَةٍۢ سَاهُونَ',
		number_in_surah: '11',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4687',
		number: '4687',
		text: 'يَسْـَٔلُونَ أَيَّانَ يَوْمُ ٱلدِّينِ',
		number_in_surah: '12',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4688',
		number: '4688',
		text: 'يَوْمَ هُمْ عَلَى ٱلنَّارِ يُفْتَنُونَ',
		number_in_surah: '13',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4689',
		number: '4689',
		text: 'ذُوقُوا۟ فِتْنَتَكُمْ هَٰذَا ٱلَّذِى كُنتُم بِهِۦ تَسْتَعْجِلُونَ',
		number_in_surah: '14',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4690',
		number: '4690',
		text: 'إِنَّ ٱلْمُتَّقِينَ فِى جَنَّٰتٍۢ وَعُيُونٍ',
		number_in_surah: '15',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4691',
		number: '4691',
		text: 'ءَاخِذِينَ مَآ ءَاتَىٰهُمْ رَبُّهُمْ ۚ إِنَّهُمْ كَانُوا۟ قَبْلَ ذَٰلِكَ مُحْسِنِينَ',
		number_in_surah: '16',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4692',
		number: '4692',
		text: 'كَانُوا۟ قَلِيلًۭا مِّنَ ٱلَّيْلِ مَا يَهْجَعُونَ',
		number_in_surah: '17',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4693',
		number: '4693',
		text: 'وَبِٱلْأَسْحَارِ هُمْ يَسْتَغْفِرُونَ',
		number_in_surah: '18',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4694',
		number: '4694',
		text: 'وَفِىٓ أَمْوَٰلِهِمْ حَقٌّۭ لِّلسَّآئِلِ وَٱلْمَحْرُومِ',
		number_in_surah: '19',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4695',
		number: '4695',
		text: 'وَفِى ٱلْأَرْضِ ءَايَٰتٌۭ لِّلْمُوقِنِينَ',
		number_in_surah: '20',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4696',
		number: '4696',
		text: 'وَفِىٓ أَنفُسِكُمْ ۚ أَفَلَا تُبْصِرُونَ',
		number_in_surah: '21',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4697',
		number: '4697',
		text: 'وَفِى ٱلسَّمَآءِ رِزْقُكُمْ وَمَا تُوعَدُونَ',
		number_in_surah: '22',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4698',
		number: '4698',
		text: 'فَوَرَبِّ ٱلسَّمَآءِ وَٱلْأَرْضِ إِنَّهُۥ لَحَقٌّۭ مِّثْلَ مَآ أَنَّكُمْ تَنطِقُونَ',
		number_in_surah: '23',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4699',
		number: '4699',
		text: 'هَلْ أَتَىٰكَ حَدِيثُ ضَيْفِ إِبْرَٰهِيمَ ٱلْمُكْرَمِينَ',
		number_in_surah: '24',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4700',
		number: '4700',
		text: 'إِذْ دَخَلُوا۟ عَلَيْهِ فَقَالُوا۟ سَلَٰمًۭا ۖ قَالَ سَلَٰمٌۭ قَوْمٌۭ مُّنكَرُونَ',
		number_in_surah: '25',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4701',
		number: '4701',
		text: 'فَرَاغَ إِلَىٰٓ أَهْلِهِۦ فَجَآءَ بِعِجْلٍۢ سَمِينٍۢ',
		number_in_surah: '26',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4702',
		number: '4702',
		text: 'فَقَرَّبَهُۥٓ إِلَيْهِمْ قَالَ أَلَا تَأْكُلُونَ',
		number_in_surah: '27',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4703',
		number: '4703',
		text: 'فَأَوْجَسَ مِنْهُمْ خِيفَةًۭ ۖ قَالُوا۟ لَا تَخَفْ ۖ وَبَشَّرُوهُ بِغُلَٰمٍ عَلِيمٍۢ',
		number_in_surah: '28',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4704',
		number: '4704',
		text: 'فَأَقْبَلَتِ ٱمْرَأَتُهُۥ فِى صَرَّةٍۢ فَصَكَّتْ وَجْهَهَا وَقَالَتْ عَجُوزٌ عَقِيمٌۭ',
		number_in_surah: '29',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4705',
		number: '4705',
		text: 'قَالُوا۟ كَذَٰلِكِ قَالَ رَبُّكِ ۖ إِنَّهُۥ هُوَ ٱلْحَكِيمُ ٱلْعَلِيمُ',
		number_in_surah: '30',
		page: '521',
		surah_id: '51',
		hizb_id: '208',
		juz_id: '26',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4706',
		number: '4706',
		text: '۞ قَالَ فَمَا خَطْبُكُمْ أَيُّهَا ٱلْمُرْسَلُونَ',
		number_in_surah: '31',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4707',
		number: '4707',
		text: 'قَالُوٓا۟ إِنَّآ أُرْسِلْنَآ إِلَىٰ قَوْمٍۢ مُّجْرِمِينَ',
		number_in_surah: '32',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4708',
		number: '4708',
		text: 'لِنُرْسِلَ عَلَيْهِمْ حِجَارَةًۭ مِّن طِينٍۢ',
		number_in_surah: '33',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4709',
		number: '4709',
		text: 'مُّسَوَّمَةً عِندَ رَبِّكَ لِلْمُسْرِفِينَ',
		number_in_surah: '34',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4710',
		number: '4710',
		text: 'فَأَخْرَجْنَا مَن كَانَ فِيهَا مِنَ ٱلْمُؤْمِنِينَ',
		number_in_surah: '35',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4711',
		number: '4711',
		text: 'فَمَا وَجَدْنَا فِيهَا غَيْرَ بَيْتٍۢ مِّنَ ٱلْمُسْلِمِينَ',
		number_in_surah: '36',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4712',
		number: '4712',
		text: 'وَتَرَكْنَا فِيهَآ ءَايَةًۭ لِّلَّذِينَ يَخَافُونَ ٱلْعَذَابَ ٱلْأَلِيمَ',
		number_in_surah: '37',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4713',
		number: '4713',
		text: 'وَفِى مُوسَىٰٓ إِذْ أَرْسَلْنَٰهُ إِلَىٰ فِرْعَوْنَ بِسُلْطَٰنٍۢ مُّبِينٍۢ',
		number_in_surah: '38',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4714',
		number: '4714',
		text: 'فَتَوَلَّىٰ بِرُكْنِهِۦ وَقَالَ سَٰحِرٌ أَوْ مَجْنُونٌۭ',
		number_in_surah: '39',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4715',
		number: '4715',
		text: 'فَأَخَذْنَٰهُ وَجُنُودَهُۥ فَنَبَذْنَٰهُمْ فِى ٱلْيَمِّ وَهُوَ مُلِيمٌۭ',
		number_in_surah: '40',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4716',
		number: '4716',
		text: 'وَفِى عَادٍ إِذْ أَرْسَلْنَا عَلَيْهِمُ ٱلرِّيحَ ٱلْعَقِيمَ',
		number_in_surah: '41',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4717',
		number: '4717',
		text: 'مَا تَذَرُ مِن شَىْءٍ أَتَتْ عَلَيْهِ إِلَّا جَعَلَتْهُ كَٱلرَّمِيمِ',
		number_in_surah: '42',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4718',
		number: '4718',
		text: 'وَفِى ثَمُودَ إِذْ قِيلَ لَهُمْ تَمَتَّعُوا۟ حَتَّىٰ حِينٍۢ',
		number_in_surah: '43',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4719',
		number: '4719',
		text: 'فَعَتَوْا۟ عَنْ أَمْرِ رَبِّهِمْ فَأَخَذَتْهُمُ ٱلصَّٰعِقَةُ وَهُمْ يَنظُرُونَ',
		number_in_surah: '44',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4720',
		number: '4720',
		text: 'فَمَا ٱسْتَطَٰعُوا۟ مِن قِيَامٍۢ وَمَا كَانُوا۟ مُنتَصِرِينَ',
		number_in_surah: '45',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4721',
		number: '4721',
		text: 'وَقَوْمَ نُوحٍۢ مِّن قَبْلُ ۖ إِنَّهُمْ كَانُوا۟ قَوْمًۭا فَٰسِقِينَ',
		number_in_surah: '46',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4722',
		number: '4722',
		text: 'وَٱلسَّمَآءَ بَنَيْنَٰهَا بِأَيْي۟دٍۢ وَإِنَّا لَمُوسِعُونَ',
		number_in_surah: '47',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4723',
		number: '4723',
		text: 'وَٱلْأَرْضَ فَرَشْنَٰهَا فَنِعْمَ ٱلْمَٰهِدُونَ',
		number_in_surah: '48',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4724',
		number: '4724',
		text: 'وَمِن كُلِّ شَىْءٍ خَلَقْنَا زَوْجَيْنِ لَعَلَّكُمْ تَذَكَّرُونَ',
		number_in_surah: '49',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4725',
		number: '4725',
		text: 'فَفِرُّوٓا۟ إِلَى ٱللَّهِ ۖ إِنِّى لَكُم مِّنْهُ نَذِيرٌۭ مُّبِينٌۭ',
		number_in_surah: '50',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4726',
		number: '4726',
		text: 'وَلَا تَجْعَلُوا۟ مَعَ ٱللَّهِ إِلَٰهًا ءَاخَرَ ۖ إِنِّى لَكُم مِّنْهُ نَذِيرٌۭ مُّبِينٌۭ',
		number_in_surah: '51',
		page: '522',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4727',
		number: '4727',
		text: 'كَذَٰلِكَ مَآ أَتَى ٱلَّذِينَ مِن قَبْلِهِم مِّن رَّسُولٍ إِلَّا قَالُوا۟ سَاحِرٌ أَوْ مَجْنُونٌ',
		number_in_surah: '52',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4728',
		number: '4728',
		text: 'أَتَوَاصَوْا۟ بِهِۦ ۚ بَلْ هُمْ قَوْمٌۭ طَاغُونَ',
		number_in_surah: '53',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4729',
		number: '4729',
		text: 'فَتَوَلَّ عَنْهُمْ فَمَآ أَنتَ بِمَلُومٍۢ',
		number_in_surah: '54',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4730',
		number: '4730',
		text: 'وَذَكِّرْ فَإِنَّ ٱلذِّكْرَىٰ تَنفَعُ ٱلْمُؤْمِنِينَ',
		number_in_surah: '55',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4731',
		number: '4731',
		text: 'وَمَا خَلَقْتُ ٱلْجِنَّ وَٱلْإِنسَ إِلَّا لِيَعْبُدُونِ',
		number_in_surah: '56',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4732',
		number: '4732',
		text: 'مَآ أُرِيدُ مِنْهُم مِّن رِّزْقٍۢ وَمَآ أُرِيدُ أَن يُطْعِمُونِ',
		number_in_surah: '57',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4733',
		number: '4733',
		text: 'إِنَّ ٱللَّهَ هُوَ ٱلرَّزَّاقُ ذُو ٱلْقُوَّةِ ٱلْمَتِينُ',
		number_in_surah: '58',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4734',
		number: '4734',
		text: 'فَإِنَّ لِلَّذِينَ ظَلَمُوا۟ ذَنُوبًۭا مِّثْلَ ذَنُوبِ أَصْحَٰبِهِمْ فَلَا يَسْتَعْجِلُونِ',
		number_in_surah: '59',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4735',
		number: '4735',
		text: 'فَوَيْلٌۭ لِّلَّذِينَ كَفَرُوا۟ مِن يَوْمِهِمُ ٱلَّذِى يُوعَدُونَ',
		number_in_surah: '60',
		page: '523',
		surah_id: '51',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4736',
		number: '4736',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلطُّورِ',
		number_in_surah: '1',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4737',
		number: '4737',
		text: 'وَكِتَٰبٍۢ مَّسْطُورٍۢ',
		number_in_surah: '2',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:13',
		updated_at: '2018-06-07 08:07:13',
	},
	{
		id: '4738',
		number: '4738',
		text: 'فِى رَقٍّۢ مَّنشُورٍۢ',
		number_in_surah: '3',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4739',
		number: '4739',
		text: 'وَٱلْبَيْتِ ٱلْمَعْمُورِ',
		number_in_surah: '4',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4740',
		number: '4740',
		text: 'وَٱلسَّقْفِ ٱلْمَرْفُوعِ',
		number_in_surah: '5',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4741',
		number: '4741',
		text: 'وَٱلْبَحْرِ ٱلْمَسْجُورِ',
		number_in_surah: '6',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4742',
		number: '4742',
		text: 'إِنَّ عَذَابَ رَبِّكَ لَوَٰقِعٌۭ',
		number_in_surah: '7',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4743',
		number: '4743',
		text: 'مَّا لَهُۥ مِن دَافِعٍۢ',
		number_in_surah: '8',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4744',
		number: '4744',
		text: 'يَوْمَ تَمُورُ ٱلسَّمَآءُ مَوْرًۭا',
		number_in_surah: '9',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4745',
		number: '4745',
		text: 'وَتَسِيرُ ٱلْجِبَالُ سَيْرًۭا',
		number_in_surah: '10',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4746',
		number: '4746',
		text: 'فَوَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '11',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4747',
		number: '4747',
		text: 'ٱلَّذِينَ هُمْ فِى خَوْضٍۢ يَلْعَبُونَ',
		number_in_surah: '12',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4748',
		number: '4748',
		text: 'يَوْمَ يُدَعُّونَ إِلَىٰ نَارِ جَهَنَّمَ دَعًّا',
		number_in_surah: '13',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4749',
		number: '4749',
		text: 'هَٰذِهِ ٱلنَّارُ ٱلَّتِى كُنتُم بِهَا تُكَذِّبُونَ',
		number_in_surah: '14',
		page: '523',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4750',
		number: '4750',
		text: 'أَفَسِحْرٌ هَٰذَآ أَمْ أَنتُمْ لَا تُبْصِرُونَ',
		number_in_surah: '15',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4751',
		number: '4751',
		text: 'ٱصْلَوْهَا فَٱصْبِرُوٓا۟ أَوْ لَا تَصْبِرُوا۟ سَوَآءٌ عَلَيْكُمْ ۖ إِنَّمَا تُجْزَوْنَ مَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '16',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4752',
		number: '4752',
		text: 'إِنَّ ٱلْمُتَّقِينَ فِى جَنَّٰتٍۢ وَنَعِيمٍۢ',
		number_in_surah: '17',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4753',
		number: '4753',
		text: 'فَٰكِهِينَ بِمَآ ءَاتَىٰهُمْ رَبُّهُمْ وَوَقَىٰهُمْ رَبُّهُمْ عَذَابَ ٱلْجَحِيمِ',
		number_in_surah: '18',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4754',
		number: '4754',
		text: 'كُلُوا۟ وَٱشْرَبُوا۟ هَنِيٓـًٔۢا بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '19',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4755',
		number: '4755',
		text: 'مُتَّكِـِٔينَ عَلَىٰ سُرُرٍۢ مَّصْفُوفَةٍۢ ۖ وَزَوَّجْنَٰهُم بِحُورٍ عِينٍۢ',
		number_in_surah: '20',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4756',
		number: '4756',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ وَٱتَّبَعَتْهُمْ ذُرِّيَّتُهُم بِإِيمَٰنٍ أَلْحَقْنَا بِهِمْ ذُرِّيَّتَهُمْ وَمَآ أَلَتْنَٰهُم مِّنْ عَمَلِهِم مِّن شَىْءٍۢ ۚ كُلُّ ٱمْرِئٍۭ بِمَا كَسَبَ رَهِينٌۭ',
		number_in_surah: '21',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4757',
		number: '4757',
		text: 'وَأَمْدَدْنَٰهُم بِفَٰكِهَةٍۢ وَلَحْمٍۢ مِّمَّا يَشْتَهُونَ',
		number_in_surah: '22',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4758',
		number: '4758',
		text: 'يَتَنَٰزَعُونَ فِيهَا كَأْسًۭا لَّا لَغْوٌۭ فِيهَا وَلَا تَأْثِيمٌۭ',
		number_in_surah: '23',
		page: '524',
		surah_id: '52',
		hizb_id: '209',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4759',
		number: '4759',
		text: '۞ وَيَطُوفُ عَلَيْهِمْ غِلْمَانٌۭ لَّهُمْ كَأَنَّهُمْ لُؤْلُؤٌۭ مَّكْنُونٌۭ',
		number_in_surah: '24',
		page: '524',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4760',
		number: '4760',
		text: 'وَأَقْبَلَ بَعْضُهُمْ عَلَىٰ بَعْضٍۢ يَتَسَآءَلُونَ',
		number_in_surah: '25',
		page: '524',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4761',
		number: '4761',
		text: 'قَالُوٓا۟ إِنَّا كُنَّا قَبْلُ فِىٓ أَهْلِنَا مُشْفِقِينَ',
		number_in_surah: '26',
		page: '524',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4762',
		number: '4762',
		text: 'فَمَنَّ ٱللَّهُ عَلَيْنَا وَوَقَىٰنَا عَذَابَ ٱلسَّمُومِ',
		number_in_surah: '27',
		page: '524',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4763',
		number: '4763',
		text: 'إِنَّا كُنَّا مِن قَبْلُ نَدْعُوهُ ۖ إِنَّهُۥ هُوَ ٱلْبَرُّ ٱلرَّحِيمُ',
		number_in_surah: '28',
		page: '524',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4764',
		number: '4764',
		text: 'فَذَكِّرْ فَمَآ أَنتَ بِنِعْمَتِ رَبِّكَ بِكَاهِنٍۢ وَلَا مَجْنُونٍ',
		number_in_surah: '29',
		page: '524',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4765',
		number: '4765',
		text: 'أَمْ يَقُولُونَ شَاعِرٌۭ نَّتَرَبَّصُ بِهِۦ رَيْبَ ٱلْمَنُونِ',
		number_in_surah: '30',
		page: '524',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4766',
		number: '4766',
		text: 'قُلْ تَرَبَّصُوا۟ فَإِنِّى مَعَكُم مِّنَ ٱلْمُتَرَبِّصِينَ',
		number_in_surah: '31',
		page: '524',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4767',
		number: '4767',
		text: 'أَمْ تَأْمُرُهُمْ أَحْلَٰمُهُم بِهَٰذَآ ۚ أَمْ هُمْ قَوْمٌۭ طَاغُونَ',
		number_in_surah: '32',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4768',
		number: '4768',
		text: 'أَمْ يَقُولُونَ تَقَوَّلَهُۥ ۚ بَل لَّا يُؤْمِنُونَ',
		number_in_surah: '33',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4769',
		number: '4769',
		text: 'فَلْيَأْتُوا۟ بِحَدِيثٍۢ مِّثْلِهِۦٓ إِن كَانُوا۟ صَٰدِقِينَ',
		number_in_surah: '34',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4770',
		number: '4770',
		text: 'أَمْ خُلِقُوا۟ مِنْ غَيْرِ شَىْءٍ أَمْ هُمُ ٱلْخَٰلِقُونَ',
		number_in_surah: '35',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4771',
		number: '4771',
		text: 'أَمْ خَلَقُوا۟ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ ۚ بَل لَّا يُوقِنُونَ',
		number_in_surah: '36',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4772',
		number: '4772',
		text: 'أَمْ عِندَهُمْ خَزَآئِنُ رَبِّكَ أَمْ هُمُ ٱلْمُصَۣيْطِرُونَ',
		number_in_surah: '37',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4773',
		number: '4773',
		text: 'أَمْ لَهُمْ سُلَّمٌۭ يَسْتَمِعُونَ فِيهِ ۖ فَلْيَأْتِ مُسْتَمِعُهُم بِسُلْطَٰنٍۢ مُّبِينٍ',
		number_in_surah: '38',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4774',
		number: '4774',
		text: 'أَمْ لَهُ ٱلْبَنَٰتُ وَلَكُمُ ٱلْبَنُونَ',
		number_in_surah: '39',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4775',
		number: '4775',
		text: 'أَمْ تَسْـَٔلُهُمْ أَجْرًۭا فَهُم مِّن مَّغْرَمٍۢ مُّثْقَلُونَ',
		number_in_surah: '40',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4776',
		number: '4776',
		text: 'أَمْ عِندَهُمُ ٱلْغَيْبُ فَهُمْ يَكْتُبُونَ',
		number_in_surah: '41',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4777',
		number: '4777',
		text: 'أَمْ يُرِيدُونَ كَيْدًۭا ۖ فَٱلَّذِينَ كَفَرُوا۟ هُمُ ٱلْمَكِيدُونَ',
		number_in_surah: '42',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4778',
		number: '4778',
		text: 'أَمْ لَهُمْ إِلَٰهٌ غَيْرُ ٱللَّهِ ۚ سُبْحَٰنَ ٱللَّهِ عَمَّا يُشْرِكُونَ',
		number_in_surah: '43',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4779',
		number: '4779',
		text: 'وَإِن يَرَوْا۟ كِسْفًۭا مِّنَ ٱلسَّمَآءِ سَاقِطًۭا يَقُولُوا۟ سَحَابٌۭ مَّرْكُومٌۭ',
		number_in_surah: '44',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4780',
		number: '4780',
		text: 'فَذَرْهُمْ حَتَّىٰ يُلَٰقُوا۟ يَوْمَهُمُ ٱلَّذِى فِيهِ يُصْعَقُونَ',
		number_in_surah: '45',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4781',
		number: '4781',
		text: 'يَوْمَ لَا يُغْنِى عَنْهُمْ كَيْدُهُمْ شَيْـًۭٔا وَلَا هُمْ يُنصَرُونَ',
		number_in_surah: '46',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4782',
		number: '4782',
		text: 'وَإِنَّ لِلَّذِينَ ظَلَمُوا۟ عَذَابًۭا دُونَ ذَٰلِكَ وَلَٰكِنَّ أَكْثَرَهُمْ لَا يَعْلَمُونَ',
		number_in_surah: '47',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4783',
		number: '4783',
		text: 'وَٱصْبِرْ لِحُكْمِ رَبِّكَ فَإِنَّكَ بِأَعْيُنِنَا ۖ وَسَبِّحْ بِحَمْدِ رَبِّكَ حِينَ تَقُومُ',
		number_in_surah: '48',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4784',
		number: '4784',
		text: 'وَمِنَ ٱلَّيْلِ فَسَبِّحْهُ وَإِدْبَٰرَ ٱلنُّجُومِ',
		number_in_surah: '49',
		page: '525',
		surah_id: '52',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4785',
		number: '4785',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلنَّجْمِ إِذَا هَوَىٰ',
		number_in_surah: '1',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4786',
		number: '4786',
		text: 'مَا ضَلَّ صَاحِبُكُمْ وَمَا غَوَىٰ',
		number_in_surah: '2',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4787',
		number: '4787',
		text: 'وَمَا يَنطِقُ عَنِ ٱلْهَوَىٰٓ',
		number_in_surah: '3',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4788',
		number: '4788',
		text: 'إِنْ هُوَ إِلَّا وَحْىٌۭ يُوحَىٰ',
		number_in_surah: '4',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4789',
		number: '4789',
		text: 'عَلَّمَهُۥ شَدِيدُ ٱلْقُوَىٰ',
		number_in_surah: '5',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4790',
		number: '4790',
		text: 'ذُو مِرَّةٍۢ فَٱسْتَوَىٰ',
		number_in_surah: '6',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4791',
		number: '4791',
		text: 'وَهُوَ بِٱلْأُفُقِ ٱلْأَعْلَىٰ',
		number_in_surah: '7',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4792',
		number: '4792',
		text: 'ثُمَّ دَنَا فَتَدَلَّىٰ',
		number_in_surah: '8',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4793',
		number: '4793',
		text: 'فَكَانَ قَابَ قَوْسَيْنِ أَوْ أَدْنَىٰ',
		number_in_surah: '9',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4794',
		number: '4794',
		text: 'فَأَوْحَىٰٓ إِلَىٰ عَبْدِهِۦ مَآ أَوْحَىٰ',
		number_in_surah: '10',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4795',
		number: '4795',
		text: 'مَا كَذَبَ ٱلْفُؤَادُ مَا رَأَىٰٓ',
		number_in_surah: '11',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4796',
		number: '4796',
		text: 'أَفَتُمَٰرُونَهُۥ عَلَىٰ مَا يَرَىٰ',
		number_in_surah: '12',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4797',
		number: '4797',
		text: 'وَلَقَدْ رَءَاهُ نَزْلَةً أُخْرَىٰ',
		number_in_surah: '13',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4798',
		number: '4798',
		text: 'عِندَ سِدْرَةِ ٱلْمُنتَهَىٰ',
		number_in_surah: '14',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4799',
		number: '4799',
		text: 'عِندَهَا جَنَّةُ ٱلْمَأْوَىٰٓ',
		number_in_surah: '15',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4800',
		number: '4800',
		text: 'إِذْ يَغْشَى ٱلسِّدْرَةَ مَا يَغْشَىٰ',
		number_in_surah: '16',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4801',
		number: '4801',
		text: 'مَا زَاغَ ٱلْبَصَرُ وَمَا طَغَىٰ',
		number_in_surah: '17',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4802',
		number: '4802',
		text: 'لَقَدْ رَأَىٰ مِنْ ءَايَٰتِ رَبِّهِ ٱلْكُبْرَىٰٓ',
		number_in_surah: '18',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4803',
		number: '4803',
		text: 'أَفَرَءَيْتُمُ ٱللَّٰتَ وَٱلْعُزَّىٰ',
		number_in_surah: '19',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4804',
		number: '4804',
		text: 'وَمَنَوٰةَ ٱلثَّالِثَةَ ٱلْأُخْرَىٰٓ',
		number_in_surah: '20',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4805',
		number: '4805',
		text: 'أَلَكُمُ ٱلذَّكَرُ وَلَهُ ٱلْأُنثَىٰ',
		number_in_surah: '21',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4806',
		number: '4806',
		text: 'تِلْكَ إِذًۭا قِسْمَةٌۭ ضِيزَىٰٓ',
		number_in_surah: '22',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4807',
		number: '4807',
		text: 'إِنْ هِىَ إِلَّآ أَسْمَآءٌۭ سَمَّيْتُمُوهَآ أَنتُمْ وَءَابَآؤُكُم مَّآ أَنزَلَ ٱللَّهُ بِهَا مِن سُلْطَٰنٍ ۚ إِن يَتَّبِعُونَ إِلَّا ٱلظَّنَّ وَمَا تَهْوَى ٱلْأَنفُسُ ۖ وَلَقَدْ جَآءَهُم مِّن رَّبِّهِمُ ٱلْهُدَىٰٓ',
		number_in_surah: '23',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4808',
		number: '4808',
		text: 'أَمْ لِلْإِنسَٰنِ مَا تَمَنَّىٰ',
		number_in_surah: '24',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4809',
		number: '4809',
		text: 'فَلِلَّهِ ٱلْءَاخِرَةُ وَٱلْأُولَىٰ',
		number_in_surah: '25',
		page: '526',
		surah_id: '53',
		hizb_id: '210',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4810',
		number: '4810',
		text: '۞ وَكَم مِّن مَّلَكٍۢ فِى ٱلسَّمَٰوَٰتِ لَا تُغْنِى شَفَٰعَتُهُمْ شَيْـًٔا إِلَّا مِنۢ بَعْدِ أَن يَأْذَنَ ٱللَّهُ لِمَن يَشَآءُ وَيَرْضَىٰٓ',
		number_in_surah: '26',
		page: '526',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4811',
		number: '4811',
		text: 'إِنَّ ٱلَّذِينَ لَا يُؤْمِنُونَ بِٱلْءَاخِرَةِ لَيُسَمُّونَ ٱلْمَلَٰٓئِكَةَ تَسْمِيَةَ ٱلْأُنثَىٰ',
		number_in_surah: '27',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4812',
		number: '4812',
		text: 'وَمَا لَهُم بِهِۦ مِنْ عِلْمٍ ۖ إِن يَتَّبِعُونَ إِلَّا ٱلظَّنَّ ۖ وَإِنَّ ٱلظَّنَّ لَا يُغْنِى مِنَ ٱلْحَقِّ شَيْـًۭٔا',
		number_in_surah: '28',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4813',
		number: '4813',
		text: 'فَأَعْرِضْ عَن مَّن تَوَلَّىٰ عَن ذِكْرِنَا وَلَمْ يُرِدْ إِلَّا ٱلْحَيَوٰةَ ٱلدُّنْيَا',
		number_in_surah: '29',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4814',
		number: '4814',
		text: 'ذَٰلِكَ مَبْلَغُهُم مِّنَ ٱلْعِلْمِ ۚ إِنَّ رَبَّكَ هُوَ أَعْلَمُ بِمَن ضَلَّ عَن سَبِيلِهِۦ وَهُوَ أَعْلَمُ بِمَنِ ٱهْتَدَىٰ',
		number_in_surah: '30',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4815',
		number: '4815',
		text: 'وَلِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ لِيَجْزِىَ ٱلَّذِينَ أَسَٰٓـُٔوا۟ بِمَا عَمِلُوا۟ وَيَجْزِىَ ٱلَّذِينَ أَحْسَنُوا۟ بِٱلْحُسْنَى',
		number_in_surah: '31',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4816',
		number: '4816',
		text: 'ٱلَّذِينَ يَجْتَنِبُونَ كَبَٰٓئِرَ ٱلْإِثْمِ وَٱلْفَوَٰحِشَ إِلَّا ٱللَّمَمَ ۚ إِنَّ رَبَّكَ وَٰسِعُ ٱلْمَغْفِرَةِ ۚ هُوَ أَعْلَمُ بِكُمْ إِذْ أَنشَأَكُم مِّنَ ٱلْأَرْضِ وَإِذْ أَنتُمْ أَجِنَّةٌۭ فِى بُطُونِ أُمَّهَٰتِكُمْ ۖ فَلَا تُزَكُّوٓا۟ أَنفُسَكُمْ ۖ هُوَ أَعْلَمُ بِمَنِ ٱتَّقَىٰٓ',
		number_in_surah: '32',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4817',
		number: '4817',
		text: 'أَفَرَءَيْتَ ٱلَّذِى تَوَلَّىٰ',
		number_in_surah: '33',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4818',
		number: '4818',
		text: 'وَأَعْطَىٰ قَلِيلًۭا وَأَكْدَىٰٓ',
		number_in_surah: '34',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4819',
		number: '4819',
		text: 'أَعِندَهُۥ عِلْمُ ٱلْغَيْبِ فَهُوَ يَرَىٰٓ',
		number_in_surah: '35',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4820',
		number: '4820',
		text: 'أَمْ لَمْ يُنَبَّأْ بِمَا فِى صُحُفِ مُوسَىٰ',
		number_in_surah: '36',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4821',
		number: '4821',
		text: 'وَإِبْرَٰهِيمَ ٱلَّذِى وَفَّىٰٓ',
		number_in_surah: '37',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4822',
		number: '4822',
		text: 'أَلَّا تَزِرُ وَازِرَةٌۭ وِزْرَ أُخْرَىٰ',
		number_in_surah: '38',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4823',
		number: '4823',
		text: 'وَأَن لَّيْسَ لِلْإِنسَٰنِ إِلَّا مَا سَعَىٰ',
		number_in_surah: '39',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4824',
		number: '4824',
		text: 'وَأَنَّ سَعْيَهُۥ سَوْفَ يُرَىٰ',
		number_in_surah: '40',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4825',
		number: '4825',
		text: 'ثُمَّ يُجْزَىٰهُ ٱلْجَزَآءَ ٱلْأَوْفَىٰ',
		number_in_surah: '41',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4826',
		number: '4826',
		text: 'وَأَنَّ إِلَىٰ رَبِّكَ ٱلْمُنتَهَىٰ',
		number_in_surah: '42',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4827',
		number: '4827',
		text: 'وَأَنَّهُۥ هُوَ أَضْحَكَ وَأَبْكَىٰ',
		number_in_surah: '43',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4828',
		number: '4828',
		text: 'وَأَنَّهُۥ هُوَ أَمَاتَ وَأَحْيَا',
		number_in_surah: '44',
		page: '527',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4829',
		number: '4829',
		text: 'وَأَنَّهُۥ خَلَقَ ٱلزَّوْجَيْنِ ٱلذَّكَرَ وَٱلْأُنثَىٰ',
		number_in_surah: '45',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4830',
		number: '4830',
		text: 'مِن نُّطْفَةٍ إِذَا تُمْنَىٰ',
		number_in_surah: '46',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4831',
		number: '4831',
		text: 'وَأَنَّ عَلَيْهِ ٱلنَّشْأَةَ ٱلْأُخْرَىٰ',
		number_in_surah: '47',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4832',
		number: '4832',
		text: 'وَأَنَّهُۥ هُوَ أَغْنَىٰ وَأَقْنَىٰ',
		number_in_surah: '48',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4833',
		number: '4833',
		text: 'وَأَنَّهُۥ هُوَ رَبُّ ٱلشِّعْرَىٰ',
		number_in_surah: '49',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4834',
		number: '4834',
		text: 'وَأَنَّهُۥٓ أَهْلَكَ عَادًا ٱلْأُولَىٰ',
		number_in_surah: '50',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4835',
		number: '4835',
		text: 'وَثَمُودَا۟ فَمَآ أَبْقَىٰ',
		number_in_surah: '51',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4836',
		number: '4836',
		text: 'وَقَوْمَ نُوحٍۢ مِّن قَبْلُ ۖ إِنَّهُمْ كَانُوا۟ هُمْ أَظْلَمَ وَأَطْغَىٰ',
		number_in_surah: '52',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4837',
		number: '4837',
		text: 'وَٱلْمُؤْتَفِكَةَ أَهْوَىٰ',
		number_in_surah: '53',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4838',
		number: '4838',
		text: 'فَغَشَّىٰهَا مَا غَشَّىٰ',
		number_in_surah: '54',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4839',
		number: '4839',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكَ تَتَمَارَىٰ',
		number_in_surah: '55',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4840',
		number: '4840',
		text: 'هَٰذَا نَذِيرٌۭ مِّنَ ٱلنُّذُرِ ٱلْأُولَىٰٓ',
		number_in_surah: '56',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4841',
		number: '4841',
		text: 'أَزِفَتِ ٱلْءَازِفَةُ',
		number_in_surah: '57',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4842',
		number: '4842',
		text: 'لَيْسَ لَهَا مِن دُونِ ٱللَّهِ كَاشِفَةٌ',
		number_in_surah: '58',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4843',
		number: '4843',
		text: 'أَفَمِنْ هَٰذَا ٱلْحَدِيثِ تَعْجَبُونَ',
		number_in_surah: '59',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4844',
		number: '4844',
		text: 'وَتَضْحَكُونَ وَلَا تَبْكُونَ',
		number_in_surah: '60',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4845',
		number: '4845',
		text: 'وَأَنتُمْ سَٰمِدُونَ',
		number_in_surah: '61',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4846',
		number: '4846',
		text: 'فَٱسْجُدُوا۟ لِلَّهِ وَٱعْبُدُوا۟ ۩',
		number_in_surah: '62',
		page: '528',
		surah_id: '53',
		hizb_id: '211',
		juz_id: '27',
		sajda: '1',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4847',
		number: '4847',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱقْتَرَبَتِ ٱلسَّاعَةُ وَٱنشَقَّ ٱلْقَمَرُ',
		number_in_surah: '1',
		page: '528',
		surah_id: '54',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4848',
		number: '4848',
		text: 'وَإِن يَرَوْا۟ ءَايَةًۭ يُعْرِضُوا۟ وَيَقُولُوا۟ سِحْرٌۭ مُّسْتَمِرٌّۭ',
		number_in_surah: '2',
		page: '528',
		surah_id: '54',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4849',
		number: '4849',
		text: 'وَكَذَّبُوا۟ وَٱتَّبَعُوٓا۟ أَهْوَآءَهُمْ ۚ وَكُلُّ أَمْرٍۢ مُّسْتَقِرٌّۭ',
		number_in_surah: '3',
		page: '528',
		surah_id: '54',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4850',
		number: '4850',
		text: 'وَلَقَدْ جَآءَهُم مِّنَ ٱلْأَنۢبَآءِ مَا فِيهِ مُزْدَجَرٌ',
		number_in_surah: '4',
		page: '528',
		surah_id: '54',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4851',
		number: '4851',
		text: 'حِكْمَةٌۢ بَٰلِغَةٌۭ ۖ فَمَا تُغْنِ ٱلنُّذُرُ',
		number_in_surah: '5',
		page: '528',
		surah_id: '54',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4852',
		number: '4852',
		text: 'فَتَوَلَّ عَنْهُمْ ۘ يَوْمَ يَدْعُ ٱلدَّاعِ إِلَىٰ شَىْءٍۢ نُّكُرٍ',
		number_in_surah: '6',
		page: '528',
		surah_id: '54',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4853',
		number: '4853',
		text: 'خُشَّعًا أَبْصَٰرُهُمْ يَخْرُجُونَ مِنَ ٱلْأَجْدَاثِ كَأَنَّهُمْ جَرَادٌۭ مُّنتَشِرٌۭ',
		number_in_surah: '7',
		page: '529',
		surah_id: '54',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4854',
		number: '4854',
		text: 'مُّهْطِعِينَ إِلَى ٱلدَّاعِ ۖ يَقُولُ ٱلْكَٰفِرُونَ هَٰذَا يَوْمٌ عَسِرٌۭ',
		number_in_surah: '8',
		page: '529',
		surah_id: '54',
		hizb_id: '211',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4855',
		number: '4855',
		text: '۞ كَذَّبَتْ قَبْلَهُمْ قَوْمُ نُوحٍۢ فَكَذَّبُوا۟ عَبْدَنَا وَقَالُوا۟ مَجْنُونٌۭ وَٱزْدُجِرَ',
		number_in_surah: '9',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4856',
		number: '4856',
		text: 'فَدَعَا رَبَّهُۥٓ أَنِّى مَغْلُوبٌۭ فَٱنتَصِرْ',
		number_in_surah: '10',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4857',
		number: '4857',
		text: 'فَفَتَحْنَآ أَبْوَٰبَ ٱلسَّمَآءِ بِمَآءٍۢ مُّنْهَمِرٍۢ',
		number_in_surah: '11',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4858',
		number: '4858',
		text: 'وَفَجَّرْنَا ٱلْأَرْضَ عُيُونًۭا فَٱلْتَقَى ٱلْمَآءُ عَلَىٰٓ أَمْرٍۢ قَدْ قُدِرَ',
		number_in_surah: '12',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4859',
		number: '4859',
		text: 'وَحَمَلْنَٰهُ عَلَىٰ ذَاتِ أَلْوَٰحٍۢ وَدُسُرٍۢ',
		number_in_surah: '13',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4860',
		number: '4860',
		text: 'تَجْرِى بِأَعْيُنِنَا جَزَآءًۭ لِّمَن كَانَ كُفِرَ',
		number_in_surah: '14',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4861',
		number: '4861',
		text: 'وَلَقَد تَّرَكْنَٰهَآ ءَايَةًۭ فَهَلْ مِن مُّدَّكِرٍۢ',
		number_in_surah: '15',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4862',
		number: '4862',
		text: 'فَكَيْفَ كَانَ عَذَابِى وَنُذُرِ',
		number_in_surah: '16',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4863',
		number: '4863',
		text: 'وَلَقَدْ يَسَّرْنَا ٱلْقُرْءَانَ لِلذِّكْرِ فَهَلْ مِن مُّدَّكِرٍۢ',
		number_in_surah: '17',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4864',
		number: '4864',
		text: 'كَذَّبَتْ عَادٌۭ فَكَيْفَ كَانَ عَذَابِى وَنُذُرِ',
		number_in_surah: '18',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4865',
		number: '4865',
		text: 'إِنَّآ أَرْسَلْنَا عَلَيْهِمْ رِيحًۭا صَرْصَرًۭا فِى يَوْمِ نَحْسٍۢ مُّسْتَمِرٍّۢ',
		number_in_surah: '19',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4866',
		number: '4866',
		text: 'تَنزِعُ ٱلنَّاسَ كَأَنَّهُمْ أَعْجَازُ نَخْلٍۢ مُّنقَعِرٍۢ',
		number_in_surah: '20',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4867',
		number: '4867',
		text: 'فَكَيْفَ كَانَ عَذَابِى وَنُذُرِ',
		number_in_surah: '21',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4868',
		number: '4868',
		text: 'وَلَقَدْ يَسَّرْنَا ٱلْقُرْءَانَ لِلذِّكْرِ فَهَلْ مِن مُّدَّكِرٍۢ',
		number_in_surah: '22',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4869',
		number: '4869',
		text: 'كَذَّبَتْ ثَمُودُ بِٱلنُّذُرِ',
		number_in_surah: '23',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4870',
		number: '4870',
		text: 'فَقَالُوٓا۟ أَبَشَرًۭا مِّنَّا وَٰحِدًۭا نَّتَّبِعُهُۥٓ إِنَّآ إِذًۭا لَّفِى ضَلَٰلٍۢ وَسُعُرٍ',
		number_in_surah: '24',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4871',
		number: '4871',
		text: 'أَءُلْقِىَ ٱلذِّكْرُ عَلَيْهِ مِنۢ بَيْنِنَا بَلْ هُوَ كَذَّابٌ أَشِرٌۭ',
		number_in_surah: '25',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4872',
		number: '4872',
		text: 'سَيَعْلَمُونَ غَدًۭا مَّنِ ٱلْكَذَّابُ ٱلْأَشِرُ',
		number_in_surah: '26',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4873',
		number: '4873',
		text: 'إِنَّا مُرْسِلُوا۟ ٱلنَّاقَةِ فِتْنَةًۭ لَّهُمْ فَٱرْتَقِبْهُمْ وَٱصْطَبِرْ',
		number_in_surah: '27',
		page: '529',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4874',
		number: '4874',
		text: 'وَنَبِّئْهُمْ أَنَّ ٱلْمَآءَ قِسْمَةٌۢ بَيْنَهُمْ ۖ كُلُّ شِرْبٍۢ مُّحْتَضَرٌۭ',
		number_in_surah: '28',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4875',
		number: '4875',
		text: 'فَنَادَوْا۟ صَاحِبَهُمْ فَتَعَاطَىٰ فَعَقَرَ',
		number_in_surah: '29',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4876',
		number: '4876',
		text: 'فَكَيْفَ كَانَ عَذَابِى وَنُذُرِ',
		number_in_surah: '30',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4877',
		number: '4877',
		text: 'إِنَّآ أَرْسَلْنَا عَلَيْهِمْ صَيْحَةًۭ وَٰحِدَةًۭ فَكَانُوا۟ كَهَشِيمِ ٱلْمُحْتَظِرِ',
		number_in_surah: '31',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4878',
		number: '4878',
		text: 'وَلَقَدْ يَسَّرْنَا ٱلْقُرْءَانَ لِلذِّكْرِ فَهَلْ مِن مُّدَّكِرٍۢ',
		number_in_surah: '32',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4879',
		number: '4879',
		text: 'كَذَّبَتْ قَوْمُ لُوطٍۭ بِٱلنُّذُرِ',
		number_in_surah: '33',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4880',
		number: '4880',
		text: 'إِنَّآ أَرْسَلْنَا عَلَيْهِمْ حَاصِبًا إِلَّآ ءَالَ لُوطٍۢ ۖ نَّجَّيْنَٰهُم بِسَحَرٍۢ',
		number_in_surah: '34',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4881',
		number: '4881',
		text: 'نِّعْمَةًۭ مِّنْ عِندِنَا ۚ كَذَٰلِكَ نَجْزِى مَن شَكَرَ',
		number_in_surah: '35',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4882',
		number: '4882',
		text: 'وَلَقَدْ أَنذَرَهُم بَطْشَتَنَا فَتَمَارَوْا۟ بِٱلنُّذُرِ',
		number_in_surah: '36',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4883',
		number: '4883',
		text: 'وَلَقَدْ رَٰوَدُوهُ عَن ضَيْفِهِۦ فَطَمَسْنَآ أَعْيُنَهُمْ فَذُوقُوا۟ عَذَابِى وَنُذُرِ',
		number_in_surah: '37',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4884',
		number: '4884',
		text: 'وَلَقَدْ صَبَّحَهُم بُكْرَةً عَذَابٌۭ مُّسْتَقِرٌّۭ',
		number_in_surah: '38',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4885',
		number: '4885',
		text: 'فَذُوقُوا۟ عَذَابِى وَنُذُرِ',
		number_in_surah: '39',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4886',
		number: '4886',
		text: 'وَلَقَدْ يَسَّرْنَا ٱلْقُرْءَانَ لِلذِّكْرِ فَهَلْ مِن مُّدَّكِرٍۢ',
		number_in_surah: '40',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4887',
		number: '4887',
		text: 'وَلَقَدْ جَآءَ ءَالَ فِرْعَوْنَ ٱلنُّذُرُ',
		number_in_surah: '41',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4888',
		number: '4888',
		text: 'كَذَّبُوا۟ بِـَٔايَٰتِنَا كُلِّهَا فَأَخَذْنَٰهُمْ أَخْذَ عَزِيزٍۢ مُّقْتَدِرٍ',
		number_in_surah: '42',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4889',
		number: '4889',
		text: 'أَكُفَّارُكُمْ خَيْرٌۭ مِّنْ أُو۟لَٰٓئِكُمْ أَمْ لَكُم بَرَآءَةٌۭ فِى ٱلزُّبُرِ',
		number_in_surah: '43',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4890',
		number: '4890',
		text: 'أَمْ يَقُولُونَ نَحْنُ جَمِيعٌۭ مُّنتَصِرٌۭ',
		number_in_surah: '44',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4891',
		number: '4891',
		text: 'سَيُهْزَمُ ٱلْجَمْعُ وَيُوَلُّونَ ٱلدُّبُرَ',
		number_in_surah: '45',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4892',
		number: '4892',
		text: 'بَلِ ٱلسَّاعَةُ مَوْعِدُهُمْ وَٱلسَّاعَةُ أَدْهَىٰ وَأَمَرُّ',
		number_in_surah: '46',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4893',
		number: '4893',
		text: 'إِنَّ ٱلْمُجْرِمِينَ فِى ضَلَٰلٍۢ وَسُعُرٍۢ',
		number_in_surah: '47',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4894',
		number: '4894',
		text: 'يَوْمَ يُسْحَبُونَ فِى ٱلنَّارِ عَلَىٰ وُجُوهِهِمْ ذُوقُوا۟ مَسَّ سَقَرَ',
		number_in_surah: '48',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4895',
		number: '4895',
		text: 'إِنَّا كُلَّ شَىْءٍ خَلَقْنَٰهُ بِقَدَرٍۢ',
		number_in_surah: '49',
		page: '530',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4896',
		number: '4896',
		text: 'وَمَآ أَمْرُنَآ إِلَّا وَٰحِدَةٌۭ كَلَمْحٍۭ بِٱلْبَصَرِ',
		number_in_surah: '50',
		page: '531',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4897',
		number: '4897',
		text: 'وَلَقَدْ أَهْلَكْنَآ أَشْيَاعَكُمْ فَهَلْ مِن مُّدَّكِرٍۢ',
		number_in_surah: '51',
		page: '531',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:14',
		updated_at: '2018-06-07 08:07:14',
	},
	{
		id: '4898',
		number: '4898',
		text: 'وَكُلُّ شَىْءٍۢ فَعَلُوهُ فِى ٱلزُّبُرِ',
		number_in_surah: '52',
		page: '531',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4899',
		number: '4899',
		text: 'وَكُلُّ صَغِيرٍۢ وَكَبِيرٍۢ مُّسْتَطَرٌ',
		number_in_surah: '53',
		page: '531',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4900',
		number: '4900',
		text: 'إِنَّ ٱلْمُتَّقِينَ فِى جَنَّٰتٍۢ وَنَهَرٍۢ',
		number_in_surah: '54',
		page: '531',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4901',
		number: '4901',
		text: 'فِى مَقْعَدِ صِدْقٍ عِندَ مَلِيكٍۢ مُّقْتَدِرٍۭ',
		number_in_surah: '55',
		page: '531',
		surah_id: '54',
		hizb_id: '212',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4902',
		number: '4902',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱلرَّحْمَٰنُ',
		number_in_surah: '1',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4903',
		number: '4903',
		text: 'عَلَّمَ ٱلْقُرْءَانَ',
		number_in_surah: '2',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4904',
		number: '4904',
		text: 'خَلَقَ ٱلْإِنسَٰنَ',
		number_in_surah: '3',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4905',
		number: '4905',
		text: 'عَلَّمَهُ ٱلْبَيَانَ',
		number_in_surah: '4',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4906',
		number: '4906',
		text: 'ٱلشَّمْسُ وَٱلْقَمَرُ بِحُسْبَانٍۢ',
		number_in_surah: '5',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4907',
		number: '4907',
		text: 'وَٱلنَّجْمُ وَٱلشَّجَرُ يَسْجُدَانِ',
		number_in_surah: '6',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4908',
		number: '4908',
		text: 'وَٱلسَّمَآءَ رَفَعَهَا وَوَضَعَ ٱلْمِيزَانَ',
		number_in_surah: '7',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4909',
		number: '4909',
		text: 'أَلَّا تَطْغَوْا۟ فِى ٱلْمِيزَانِ',
		number_in_surah: '8',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4910',
		number: '4910',
		text: 'وَأَقِيمُوا۟ ٱلْوَزْنَ بِٱلْقِسْطِ وَلَا تُخْسِرُوا۟ ٱلْمِيزَانَ',
		number_in_surah: '9',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4911',
		number: '4911',
		text: 'وَٱلْأَرْضَ وَضَعَهَا لِلْأَنَامِ',
		number_in_surah: '10',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4912',
		number: '4912',
		text: 'فِيهَا فَٰكِهَةٌۭ وَٱلنَّخْلُ ذَاتُ ٱلْأَكْمَامِ',
		number_in_surah: '11',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4913',
		number: '4913',
		text: 'وَٱلْحَبُّ ذُو ٱلْعَصْفِ وَٱلرَّيْحَانُ',
		number_in_surah: '12',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4914',
		number: '4914',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '13',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4915',
		number: '4915',
		text: 'خَلَقَ ٱلْإِنسَٰنَ مِن صَلْصَٰلٍۢ كَٱلْفَخَّارِ',
		number_in_surah: '14',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4916',
		number: '4916',
		text: 'وَخَلَقَ ٱلْجَآنَّ مِن مَّارِجٍۢ مِّن نَّارٍۢ',
		number_in_surah: '15',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4917',
		number: '4917',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '16',
		page: '531',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4918',
		number: '4918',
		text: 'رَبُّ ٱلْمَشْرِقَيْنِ وَرَبُّ ٱلْمَغْرِبَيْنِ',
		number_in_surah: '17',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4919',
		number: '4919',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '18',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4920',
		number: '4920',
		text: 'مَرَجَ ٱلْبَحْرَيْنِ يَلْتَقِيَانِ',
		number_in_surah: '19',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4921',
		number: '4921',
		text: 'بَيْنَهُمَا بَرْزَخٌۭ لَّا يَبْغِيَانِ',
		number_in_surah: '20',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4922',
		number: '4922',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '21',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4923',
		number: '4923',
		text: 'يَخْرُجُ مِنْهُمَا ٱللُّؤْلُؤُ وَٱلْمَرْجَانُ',
		number_in_surah: '22',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4924',
		number: '4924',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '23',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4925',
		number: '4925',
		text: 'وَلَهُ ٱلْجَوَارِ ٱلْمُنشَـَٔاتُ فِى ٱلْبَحْرِ كَٱلْأَعْلَٰمِ',
		number_in_surah: '24',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4926',
		number: '4926',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '25',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4927',
		number: '4927',
		text: 'كُلُّ مَنْ عَلَيْهَا فَانٍۢ',
		number_in_surah: '26',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4928',
		number: '4928',
		text: 'وَيَبْقَىٰ وَجْهُ رَبِّكَ ذُو ٱلْجَلَٰلِ وَٱلْإِكْرَامِ',
		number_in_surah: '27',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4929',
		number: '4929',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '28',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4930',
		number: '4930',
		text: 'يَسْـَٔلُهُۥ مَن فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ كُلَّ يَوْمٍ هُوَ فِى شَأْنٍۢ',
		number_in_surah: '29',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4931',
		number: '4931',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '30',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4932',
		number: '4932',
		text: 'سَنَفْرُغُ لَكُمْ أَيُّهَ ٱلثَّقَلَانِ',
		number_in_surah: '31',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4933',
		number: '4933',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '32',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4934',
		number: '4934',
		text: 'يَٰمَعْشَرَ ٱلْجِنِّ وَٱلْإِنسِ إِنِ ٱسْتَطَعْتُمْ أَن تَنفُذُوا۟ مِنْ أَقْطَارِ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ فَٱنفُذُوا۟ ۚ لَا تَنفُذُونَ إِلَّا بِسُلْطَٰنٍۢ',
		number_in_surah: '33',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4935',
		number: '4935',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '34',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4936',
		number: '4936',
		text: 'يُرْسَلُ عَلَيْكُمَا شُوَاظٌۭ مِّن نَّارٍۢ وَنُحَاسٌۭ فَلَا تَنتَصِرَانِ',
		number_in_surah: '35',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4937',
		number: '4937',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '36',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4938',
		number: '4938',
		text: 'فَإِذَا ٱنشَقَّتِ ٱلسَّمَآءُ فَكَانَتْ وَرْدَةًۭ كَٱلدِّهَانِ',
		number_in_surah: '37',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4939',
		number: '4939',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '38',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4940',
		number: '4940',
		text: 'فَيَوْمَئِذٍۢ لَّا يُسْـَٔلُ عَن ذَنۢبِهِۦٓ إِنسٌۭ وَلَا جَآنٌّۭ',
		number_in_surah: '39',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4941',
		number: '4941',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '40',
		page: '532',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4942',
		number: '4942',
		text: 'يُعْرَفُ ٱلْمُجْرِمُونَ بِسِيمَٰهُمْ فَيُؤْخَذُ بِٱلنَّوَٰصِى وَٱلْأَقْدَامِ',
		number_in_surah: '41',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4943',
		number: '4943',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '42',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4944',
		number: '4944',
		text: 'هَٰذِهِۦ جَهَنَّمُ ٱلَّتِى يُكَذِّبُ بِهَا ٱلْمُجْرِمُونَ',
		number_in_surah: '43',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4945',
		number: '4945',
		text: 'يَطُوفُونَ بَيْنَهَا وَبَيْنَ حَمِيمٍ ءَانٍۢ',
		number_in_surah: '44',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4946',
		number: '4946',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '45',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4947',
		number: '4947',
		text: 'وَلِمَنْ خَافَ مَقَامَ رَبِّهِۦ جَنَّتَانِ',
		number_in_surah: '46',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4948',
		number: '4948',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '47',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4949',
		number: '4949',
		text: 'ذَوَاتَآ أَفْنَانٍۢ',
		number_in_surah: '48',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4950',
		number: '4950',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '49',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4951',
		number: '4951',
		text: 'فِيهِمَا عَيْنَانِ تَجْرِيَانِ',
		number_in_surah: '50',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4952',
		number: '4952',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '51',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4953',
		number: '4953',
		text: 'فِيهِمَا مِن كُلِّ فَٰكِهَةٍۢ زَوْجَانِ',
		number_in_surah: '52',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4954',
		number: '4954',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '53',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4955',
		number: '4955',
		text: 'مُتَّكِـِٔينَ عَلَىٰ فُرُشٍۭ بَطَآئِنُهَا مِنْ إِسْتَبْرَقٍۢ ۚ وَجَنَى ٱلْجَنَّتَيْنِ دَانٍۢ',
		number_in_surah: '54',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4956',
		number: '4956',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '55',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4957',
		number: '4957',
		text: 'فِيهِنَّ قَٰصِرَٰتُ ٱلطَّرْفِ لَمْ يَطْمِثْهُنَّ إِنسٌۭ قَبْلَهُمْ وَلَا جَآنٌّۭ',
		number_in_surah: '56',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4958',
		number: '4958',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '57',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4959',
		number: '4959',
		text: 'كَأَنَّهُنَّ ٱلْيَاقُوتُ وَٱلْمَرْجَانُ',
		number_in_surah: '58',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4960',
		number: '4960',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '59',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4961',
		number: '4961',
		text: 'هَلْ جَزَآءُ ٱلْإِحْسَٰنِ إِلَّا ٱلْإِحْسَٰنُ',
		number_in_surah: '60',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4962',
		number: '4962',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '61',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4963',
		number: '4963',
		text: 'وَمِن دُونِهِمَا جَنَّتَانِ',
		number_in_surah: '62',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4964',
		number: '4964',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '63',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4965',
		number: '4965',
		text: 'مُدْهَآمَّتَانِ',
		number_in_surah: '64',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4966',
		number: '4966',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '65',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4967',
		number: '4967',
		text: 'فِيهِمَا عَيْنَانِ نَضَّاخَتَانِ',
		number_in_surah: '66',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4968',
		number: '4968',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '67',
		page: '533',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4969',
		number: '4969',
		text: 'فِيهِمَا فَٰكِهَةٌۭ وَنَخْلٌۭ وَرُمَّانٌۭ',
		number_in_surah: '68',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4970',
		number: '4970',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '69',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4971',
		number: '4971',
		text: 'فِيهِنَّ خَيْرَٰتٌ حِسَانٌۭ',
		number_in_surah: '70',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4972',
		number: '4972',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '71',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4973',
		number: '4973',
		text: 'حُورٌۭ مَّقْصُورَٰتٌۭ فِى ٱلْخِيَامِ',
		number_in_surah: '72',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4974',
		number: '4974',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '73',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4975',
		number: '4975',
		text: 'لَمْ يَطْمِثْهُنَّ إِنسٌۭ قَبْلَهُمْ وَلَا جَآنٌّۭ',
		number_in_surah: '74',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4976',
		number: '4976',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '75',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4977',
		number: '4977',
		text: 'مُتَّكِـِٔينَ عَلَىٰ رَفْرَفٍ خُضْرٍۢ وَعَبْقَرِىٍّ حِسَانٍۢ',
		number_in_surah: '76',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4978',
		number: '4978',
		text: 'فَبِأَىِّ ءَالَآءِ رَبِّكُمَا تُكَذِّبَانِ',
		number_in_surah: '77',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4979',
		number: '4979',
		text: 'تَبَٰرَكَ ٱسْمُ رَبِّكَ ذِى ٱلْجَلَٰلِ وَٱلْإِكْرَامِ',
		number_in_surah: '78',
		page: '534',
		surah_id: '55',
		hizb_id: '213',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4980',
		number: '4980',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِذَا وَقَعَتِ ٱلْوَاقِعَةُ',
		number_in_surah: '1',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4981',
		number: '4981',
		text: 'لَيْسَ لِوَقْعَتِهَا كَاذِبَةٌ',
		number_in_surah: '2',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4982',
		number: '4982',
		text: 'خَافِضَةٌۭ رَّافِعَةٌ',
		number_in_surah: '3',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4983',
		number: '4983',
		text: 'إِذَا رُجَّتِ ٱلْأَرْضُ رَجًّۭا',
		number_in_surah: '4',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4984',
		number: '4984',
		text: 'وَبُسَّتِ ٱلْجِبَالُ بَسًّۭا',
		number_in_surah: '5',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4985',
		number: '4985',
		text: 'فَكَانَتْ هَبَآءًۭ مُّنۢبَثًّۭا',
		number_in_surah: '6',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4986',
		number: '4986',
		text: 'وَكُنتُمْ أَزْوَٰجًۭا ثَلَٰثَةًۭ',
		number_in_surah: '7',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4987',
		number: '4987',
		text: 'فَأَصْحَٰبُ ٱلْمَيْمَنَةِ مَآ أَصْحَٰبُ ٱلْمَيْمَنَةِ',
		number_in_surah: '8',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4988',
		number: '4988',
		text: 'وَأَصْحَٰبُ ٱلْمَشْـَٔمَةِ مَآ أَصْحَٰبُ ٱلْمَشْـَٔمَةِ',
		number_in_surah: '9',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4989',
		number: '4989',
		text: 'وَٱلسَّٰبِقُونَ ٱلسَّٰبِقُونَ',
		number_in_surah: '10',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4990',
		number: '4990',
		text: 'أُو۟لَٰٓئِكَ ٱلْمُقَرَّبُونَ',
		number_in_surah: '11',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4991',
		number: '4991',
		text: 'فِى جَنَّٰتِ ٱلنَّعِيمِ',
		number_in_surah: '12',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4992',
		number: '4992',
		text: 'ثُلَّةٌۭ مِّنَ ٱلْأَوَّلِينَ',
		number_in_surah: '13',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4993',
		number: '4993',
		text: 'وَقَلِيلٌۭ مِّنَ ٱلْءَاخِرِينَ',
		number_in_surah: '14',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4994',
		number: '4994',
		text: 'عَلَىٰ سُرُرٍۢ مَّوْضُونَةٍۢ',
		number_in_surah: '15',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4995',
		number: '4995',
		text: 'مُّتَّكِـِٔينَ عَلَيْهَا مُتَقَٰبِلِينَ',
		number_in_surah: '16',
		page: '534',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4996',
		number: '4996',
		text: 'يَطُوفُ عَلَيْهِمْ وِلْدَٰنٌۭ مُّخَلَّدُونَ',
		number_in_surah: '17',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4997',
		number: '4997',
		text: 'بِأَكْوَابٍۢ وَأَبَارِيقَ وَكَأْسٍۢ مِّن مَّعِينٍۢ',
		number_in_surah: '18',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4998',
		number: '4998',
		text: 'لَّا يُصَدَّعُونَ عَنْهَا وَلَا يُنزِفُونَ',
		number_in_surah: '19',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '4999',
		number: '4999',
		text: 'وَفَٰكِهَةٍۢ مِّمَّا يَتَخَيَّرُونَ',
		number_in_surah: '20',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5000',
		number: '5000',
		text: 'وَلَحْمِ طَيْرٍۢ مِّمَّا يَشْتَهُونَ',
		number_in_surah: '21',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5001',
		number: '5001',
		text: 'وَحُورٌ عِينٌۭ',
		number_in_surah: '22',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5002',
		number: '5002',
		text: 'كَأَمْثَٰلِ ٱللُّؤْلُؤِ ٱلْمَكْنُونِ',
		number_in_surah: '23',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5003',
		number: '5003',
		text: 'جَزَآءًۢ بِمَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '24',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5004',
		number: '5004',
		text: 'لَا يَسْمَعُونَ فِيهَا لَغْوًۭا وَلَا تَأْثِيمًا',
		number_in_surah: '25',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5005',
		number: '5005',
		text: 'إِلَّا قِيلًۭا سَلَٰمًۭا سَلَٰمًۭا',
		number_in_surah: '26',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5006',
		number: '5006',
		text: 'وَأَصْحَٰبُ ٱلْيَمِينِ مَآ أَصْحَٰبُ ٱلْيَمِينِ',
		number_in_surah: '27',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5007',
		number: '5007',
		text: 'فِى سِدْرٍۢ مَّخْضُودٍۢ',
		number_in_surah: '28',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5008',
		number: '5008',
		text: 'وَطَلْحٍۢ مَّنضُودٍۢ',
		number_in_surah: '29',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5009',
		number: '5009',
		text: 'وَظِلٍّۢ مَّمْدُودٍۢ',
		number_in_surah: '30',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5010',
		number: '5010',
		text: 'وَمَآءٍۢ مَّسْكُوبٍۢ',
		number_in_surah: '31',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5011',
		number: '5011',
		text: 'وَفَٰكِهَةٍۢ كَثِيرَةٍۢ',
		number_in_surah: '32',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5012',
		number: '5012',
		text: 'لَّا مَقْطُوعَةٍۢ وَلَا مَمْنُوعَةٍۢ',
		number_in_surah: '33',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5013',
		number: '5013',
		text: 'وَفُرُشٍۢ مَّرْفُوعَةٍ',
		number_in_surah: '34',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5014',
		number: '5014',
		text: 'إِنَّآ أَنشَأْنَٰهُنَّ إِنشَآءًۭ',
		number_in_surah: '35',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5015',
		number: '5015',
		text: 'فَجَعَلْنَٰهُنَّ أَبْكَارًا',
		number_in_surah: '36',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5016',
		number: '5016',
		text: 'عُرُبًا أَتْرَابًۭا',
		number_in_surah: '37',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5017',
		number: '5017',
		text: 'لِّأَصْحَٰبِ ٱلْيَمِينِ',
		number_in_surah: '38',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5018',
		number: '5018',
		text: 'ثُلَّةٌۭ مِّنَ ٱلْأَوَّلِينَ',
		number_in_surah: '39',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5019',
		number: '5019',
		text: 'وَثُلَّةٌۭ مِّنَ ٱلْءَاخِرِينَ',
		number_in_surah: '40',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5020',
		number: '5020',
		text: 'وَأَصْحَٰبُ ٱلشِّمَالِ مَآ أَصْحَٰبُ ٱلشِّمَالِ',
		number_in_surah: '41',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5021',
		number: '5021',
		text: 'فِى سَمُومٍۢ وَحَمِيمٍۢ',
		number_in_surah: '42',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5022',
		number: '5022',
		text: 'وَظِلٍّۢ مِّن يَحْمُومٍۢ',
		number_in_surah: '43',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5023',
		number: '5023',
		text: 'لَّا بَارِدٍۢ وَلَا كَرِيمٍ',
		number_in_surah: '44',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5024',
		number: '5024',
		text: 'إِنَّهُمْ كَانُوا۟ قَبْلَ ذَٰلِكَ مُتْرَفِينَ',
		number_in_surah: '45',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5025',
		number: '5025',
		text: 'وَكَانُوا۟ يُصِرُّونَ عَلَى ٱلْحِنثِ ٱلْعَظِيمِ',
		number_in_surah: '46',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5026',
		number: '5026',
		text: 'وَكَانُوا۟ يَقُولُونَ أَئِذَا مِتْنَا وَكُنَّا تُرَابًۭا وَعِظَٰمًا أَءِنَّا لَمَبْعُوثُونَ',
		number_in_surah: '47',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5027',
		number: '5027',
		text: 'أَوَءَابَآؤُنَا ٱلْأَوَّلُونَ',
		number_in_surah: '48',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5028',
		number: '5028',
		text: 'قُلْ إِنَّ ٱلْأَوَّلِينَ وَٱلْءَاخِرِينَ',
		number_in_surah: '49',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5029',
		number: '5029',
		text: 'لَمَجْمُوعُونَ إِلَىٰ مِيقَٰتِ يَوْمٍۢ مَّعْلُومٍۢ',
		number_in_surah: '50',
		page: '535',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5030',
		number: '5030',
		text: 'ثُمَّ إِنَّكُمْ أَيُّهَا ٱلضَّآلُّونَ ٱلْمُكَذِّبُونَ',
		number_in_surah: '51',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5031',
		number: '5031',
		text: 'لَءَاكِلُونَ مِن شَجَرٍۢ مِّن زَقُّومٍۢ',
		number_in_surah: '52',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5032',
		number: '5032',
		text: 'فَمَالِـُٔونَ مِنْهَا ٱلْبُطُونَ',
		number_in_surah: '53',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5033',
		number: '5033',
		text: 'فَشَٰرِبُونَ عَلَيْهِ مِنَ ٱلْحَمِيمِ',
		number_in_surah: '54',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5034',
		number: '5034',
		text: 'فَشَٰرِبُونَ شُرْبَ ٱلْهِيمِ',
		number_in_surah: '55',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5035',
		number: '5035',
		text: 'هَٰذَا نُزُلُهُمْ يَوْمَ ٱلدِّينِ',
		number_in_surah: '56',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5036',
		number: '5036',
		text: 'نَحْنُ خَلَقْنَٰكُمْ فَلَوْلَا تُصَدِّقُونَ',
		number_in_surah: '57',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5037',
		number: '5037',
		text: 'أَفَرَءَيْتُم مَّا تُمْنُونَ',
		number_in_surah: '58',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5038',
		number: '5038',
		text: 'ءَأَنتُمْ تَخْلُقُونَهُۥٓ أَمْ نَحْنُ ٱلْخَٰلِقُونَ',
		number_in_surah: '59',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5039',
		number: '5039',
		text: 'نَحْنُ قَدَّرْنَا بَيْنَكُمُ ٱلْمَوْتَ وَمَا نَحْنُ بِمَسْبُوقِينَ',
		number_in_surah: '60',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5040',
		number: '5040',
		text: 'عَلَىٰٓ أَن نُّبَدِّلَ أَمْثَٰلَكُمْ وَنُنشِئَكُمْ فِى مَا لَا تَعْلَمُونَ',
		number_in_surah: '61',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5041',
		number: '5041',
		text: 'وَلَقَدْ عَلِمْتُمُ ٱلنَّشْأَةَ ٱلْأُولَىٰ فَلَوْلَا تَذَكَّرُونَ',
		number_in_surah: '62',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5042',
		number: '5042',
		text: 'أَفَرَءَيْتُم مَّا تَحْرُثُونَ',
		number_in_surah: '63',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5043',
		number: '5043',
		text: 'ءَأَنتُمْ تَزْرَعُونَهُۥٓ أَمْ نَحْنُ ٱلزَّٰرِعُونَ',
		number_in_surah: '64',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5044',
		number: '5044',
		text: 'لَوْ نَشَآءُ لَجَعَلْنَٰهُ حُطَٰمًۭا فَظَلْتُمْ تَفَكَّهُونَ',
		number_in_surah: '65',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5045',
		number: '5045',
		text: 'إِنَّا لَمُغْرَمُونَ',
		number_in_surah: '66',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5046',
		number: '5046',
		text: 'بَلْ نَحْنُ مَحْرُومُونَ',
		number_in_surah: '67',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5047',
		number: '5047',
		text: 'أَفَرَءَيْتُمُ ٱلْمَآءَ ٱلَّذِى تَشْرَبُونَ',
		number_in_surah: '68',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5048',
		number: '5048',
		text: 'ءَأَنتُمْ أَنزَلْتُمُوهُ مِنَ ٱلْمُزْنِ أَمْ نَحْنُ ٱلْمُنزِلُونَ',
		number_in_surah: '69',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5049',
		number: '5049',
		text: 'لَوْ نَشَآءُ جَعَلْنَٰهُ أُجَاجًۭا فَلَوْلَا تَشْكُرُونَ',
		number_in_surah: '70',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5050',
		number: '5050',
		text: 'أَفَرَءَيْتُمُ ٱلنَّارَ ٱلَّتِى تُورُونَ',
		number_in_surah: '71',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5051',
		number: '5051',
		text: 'ءَأَنتُمْ أَنشَأْتُمْ شَجَرَتَهَآ أَمْ نَحْنُ ٱلْمُنشِـُٔونَ',
		number_in_surah: '72',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5052',
		number: '5052',
		text: 'نَحْنُ جَعَلْنَٰهَا تَذْكِرَةًۭ وَمَتَٰعًۭا لِّلْمُقْوِينَ',
		number_in_surah: '73',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5053',
		number: '5053',
		text: 'فَسَبِّحْ بِٱسْمِ رَبِّكَ ٱلْعَظِيمِ',
		number_in_surah: '74',
		page: '536',
		surah_id: '56',
		hizb_id: '214',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5054',
		number: '5054',
		text: '۞ فَلَآ أُقْسِمُ بِمَوَٰقِعِ ٱلنُّجُومِ',
		number_in_surah: '75',
		page: '536',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:15',
		updated_at: '2018-06-07 08:07:15',
	},
	{
		id: '5055',
		number: '5055',
		text: 'وَإِنَّهُۥ لَقَسَمٌۭ لَّوْ تَعْلَمُونَ عَظِيمٌ',
		number_in_surah: '76',
		page: '536',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5056',
		number: '5056',
		text: 'إِنَّهُۥ لَقُرْءَانٌۭ كَرِيمٌۭ',
		number_in_surah: '77',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5057',
		number: '5057',
		text: 'فِى كِتَٰبٍۢ مَّكْنُونٍۢ',
		number_in_surah: '78',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5058',
		number: '5058',
		text: 'لَّا يَمَسُّهُۥٓ إِلَّا ٱلْمُطَهَّرُونَ',
		number_in_surah: '79',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5059',
		number: '5059',
		text: 'تَنزِيلٌۭ مِّن رَّبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '80',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5060',
		number: '5060',
		text: 'أَفَبِهَٰذَا ٱلْحَدِيثِ أَنتُم مُّدْهِنُونَ',
		number_in_surah: '81',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5061',
		number: '5061',
		text: 'وَتَجْعَلُونَ رِزْقَكُمْ أَنَّكُمْ تُكَذِّبُونَ',
		number_in_surah: '82',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5062',
		number: '5062',
		text: 'فَلَوْلَآ إِذَا بَلَغَتِ ٱلْحُلْقُومَ',
		number_in_surah: '83',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5063',
		number: '5063',
		text: 'وَأَنتُمْ حِينَئِذٍۢ تَنظُرُونَ',
		number_in_surah: '84',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5064',
		number: '5064',
		text: 'وَنَحْنُ أَقْرَبُ إِلَيْهِ مِنكُمْ وَلَٰكِن لَّا تُبْصِرُونَ',
		number_in_surah: '85',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5065',
		number: '5065',
		text: 'فَلَوْلَآ إِن كُنتُمْ غَيْرَ مَدِينِينَ',
		number_in_surah: '86',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5066',
		number: '5066',
		text: 'تَرْجِعُونَهَآ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '87',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5067',
		number: '5067',
		text: 'فَأَمَّآ إِن كَانَ مِنَ ٱلْمُقَرَّبِينَ',
		number_in_surah: '88',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5068',
		number: '5068',
		text: 'فَرَوْحٌۭ وَرَيْحَانٌۭ وَجَنَّتُ نَعِيمٍۢ',
		number_in_surah: '89',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5069',
		number: '5069',
		text: 'وَأَمَّآ إِن كَانَ مِنْ أَصْحَٰبِ ٱلْيَمِينِ',
		number_in_surah: '90',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5070',
		number: '5070',
		text: 'فَسَلَٰمٌۭ لَّكَ مِنْ أَصْحَٰبِ ٱلْيَمِينِ',
		number_in_surah: '91',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5071',
		number: '5071',
		text: 'وَأَمَّآ إِن كَانَ مِنَ ٱلْمُكَذِّبِينَ ٱلضَّآلِّينَ',
		number_in_surah: '92',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5072',
		number: '5072',
		text: 'فَنُزُلٌۭ مِّنْ حَمِيمٍۢ',
		number_in_surah: '93',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5073',
		number: '5073',
		text: 'وَتَصْلِيَةُ جَحِيمٍ',
		number_in_surah: '94',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5074',
		number: '5074',
		text: 'إِنَّ هَٰذَا لَهُوَ حَقُّ ٱلْيَقِينِ',
		number_in_surah: '95',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5075',
		number: '5075',
		text: 'فَسَبِّحْ بِٱسْمِ رَبِّكَ ٱلْعَظِيمِ',
		number_in_surah: '96',
		page: '537',
		surah_id: '56',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5076',
		number: '5076',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ سَبَّحَ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '1',
		page: '537',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5077',
		number: '5077',
		text: 'لَهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ يُحْىِۦ وَيُمِيتُ ۖ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '2',
		page: '537',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5078',
		number: '5078',
		text: 'هُوَ ٱلْأَوَّلُ وَٱلْءَاخِرُ وَٱلظَّٰهِرُ وَٱلْبَاطِنُ ۖ وَهُوَ بِكُلِّ شَىْءٍ عَلِيمٌ',
		number_in_surah: '3',
		page: '537',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5079',
		number: '5079',
		text: 'هُوَ ٱلَّذِى خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ فِى سِتَّةِ أَيَّامٍۢ ثُمَّ ٱسْتَوَىٰ عَلَى ٱلْعَرْشِ ۚ يَعْلَمُ مَا يَلِجُ فِى ٱلْأَرْضِ وَمَا يَخْرُجُ مِنْهَا وَمَا يَنزِلُ مِنَ ٱلسَّمَآءِ وَمَا يَعْرُجُ فِيهَا ۖ وَهُوَ مَعَكُمْ أَيْنَ مَا كُنتُمْ ۚ وَٱللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '4',
		page: '538',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5080',
		number: '5080',
		text: 'لَّهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَإِلَى ٱللَّهِ تُرْجَعُ ٱلْأُمُورُ',
		number_in_surah: '5',
		page: '538',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5081',
		number: '5081',
		text: 'يُولِجُ ٱلَّيْلَ فِى ٱلنَّهَارِ وَيُولِجُ ٱلنَّهَارَ فِى ٱلَّيْلِ ۚ وَهُوَ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '6',
		page: '538',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5082',
		number: '5082',
		text: 'ءَامِنُوا۟ بِٱللَّهِ وَرَسُولِهِۦ وَأَنفِقُوا۟ مِمَّا جَعَلَكُم مُّسْتَخْلَفِينَ فِيهِ ۖ فَٱلَّذِينَ ءَامَنُوا۟ مِنكُمْ وَأَنفَقُوا۟ لَهُمْ أَجْرٌۭ كَبِيرٌۭ',
		number_in_surah: '7',
		page: '538',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5083',
		number: '5083',
		text: 'وَمَا لَكُمْ لَا تُؤْمِنُونَ بِٱللَّهِ ۙ وَٱلرَّسُولُ يَدْعُوكُمْ لِتُؤْمِنُوا۟ بِرَبِّكُمْ وَقَدْ أَخَذَ مِيثَٰقَكُمْ إِن كُنتُم مُّؤْمِنِينَ',
		number_in_surah: '8',
		page: '538',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5084',
		number: '5084',
		text: 'هُوَ ٱلَّذِى يُنَزِّلُ عَلَىٰ عَبْدِهِۦٓ ءَايَٰتٍۭ بَيِّنَٰتٍۢ لِّيُخْرِجَكُم مِّنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ ۚ وَإِنَّ ٱللَّهَ بِكُمْ لَرَءُوفٌۭ رَّحِيمٌۭ',
		number_in_surah: '9',
		page: '538',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5085',
		number: '5085',
		text: 'وَمَا لَكُمْ أَلَّا تُنفِقُوا۟ فِى سَبِيلِ ٱللَّهِ وَلِلَّهِ مِيرَٰثُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ لَا يَسْتَوِى مِنكُم مَّنْ أَنفَقَ مِن قَبْلِ ٱلْفَتْحِ وَقَٰتَلَ ۚ أُو۟لَٰٓئِكَ أَعْظَمُ دَرَجَةًۭ مِّنَ ٱلَّذِينَ أَنفَقُوا۟ مِنۢ بَعْدُ وَقَٰتَلُوا۟ ۚ وَكُلًّۭا وَعَدَ ٱللَّهُ ٱلْحُسْنَىٰ ۚ وَٱللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '10',
		page: '538',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5086',
		number: '5086',
		text: 'مَّن ذَا ٱلَّذِى يُقْرِضُ ٱللَّهَ قَرْضًا حَسَنًۭا فَيُضَٰعِفَهُۥ لَهُۥ وَلَهُۥٓ أَجْرٌۭ كَرِيمٌۭ',
		number_in_surah: '11',
		page: '538',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5087',
		number: '5087',
		text: 'يَوْمَ تَرَى ٱلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ يَسْعَىٰ نُورُهُم بَيْنَ أَيْدِيهِمْ وَبِأَيْمَٰنِهِم بُشْرَىٰكُمُ ٱلْيَوْمَ جَنَّٰتٌۭ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا ۚ ذَٰلِكَ هُوَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '12',
		page: '539',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5088',
		number: '5088',
		text: 'يَوْمَ يَقُولُ ٱلْمُنَٰفِقُونَ وَٱلْمُنَٰفِقَٰتُ لِلَّذِينَ ءَامَنُوا۟ ٱنظُرُونَا نَقْتَبِسْ مِن نُّورِكُمْ قِيلَ ٱرْجِعُوا۟ وَرَآءَكُمْ فَٱلْتَمِسُوا۟ نُورًۭا فَضُرِبَ بَيْنَهُم بِسُورٍۢ لَّهُۥ بَابٌۢ بَاطِنُهُۥ فِيهِ ٱلرَّحْمَةُ وَظَٰهِرُهُۥ مِن قِبَلِهِ ٱلْعَذَابُ',
		number_in_surah: '13',
		page: '539',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5089',
		number: '5089',
		text: 'يُنَادُونَهُمْ أَلَمْ نَكُن مَّعَكُمْ ۖ قَالُوا۟ بَلَىٰ وَلَٰكِنَّكُمْ فَتَنتُمْ أَنفُسَكُمْ وَتَرَبَّصْتُمْ وَٱرْتَبْتُمْ وَغَرَّتْكُمُ ٱلْأَمَانِىُّ حَتَّىٰ جَآءَ أَمْرُ ٱللَّهِ وَغَرَّكُم بِٱللَّهِ ٱلْغَرُورُ',
		number_in_surah: '14',
		page: '539',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5090',
		number: '5090',
		text: 'فَٱلْيَوْمَ لَا يُؤْخَذُ مِنكُمْ فِدْيَةٌۭ وَلَا مِنَ ٱلَّذِينَ كَفَرُوا۟ ۚ مَأْوَىٰكُمُ ٱلنَّارُ ۖ هِىَ مَوْلَىٰكُمْ ۖ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '15',
		page: '539',
		surah_id: '57',
		hizb_id: '215',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5091',
		number: '5091',
		text: '۞ أَلَمْ يَأْنِ لِلَّذِينَ ءَامَنُوٓا۟ أَن تَخْشَعَ قُلُوبُهُمْ لِذِكْرِ ٱللَّهِ وَمَا نَزَلَ مِنَ ٱلْحَقِّ وَلَا يَكُونُوا۟ كَٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ مِن قَبْلُ فَطَالَ عَلَيْهِمُ ٱلْأَمَدُ فَقَسَتْ قُلُوبُهُمْ ۖ وَكَثِيرٌۭ مِّنْهُمْ فَٰسِقُونَ',
		number_in_surah: '16',
		page: '539',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5092',
		number: '5092',
		text: 'ٱعْلَمُوٓا۟ أَنَّ ٱللَّهَ يُحْىِ ٱلْأَرْضَ بَعْدَ مَوْتِهَا ۚ قَدْ بَيَّنَّا لَكُمُ ٱلْءَايَٰتِ لَعَلَّكُمْ تَعْقِلُونَ',
		number_in_surah: '17',
		page: '539',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5093',
		number: '5093',
		text: 'إِنَّ ٱلْمُصَّدِّقِينَ وَٱلْمُصَّدِّقَٰتِ وَأَقْرَضُوا۟ ٱللَّهَ قَرْضًا حَسَنًۭا يُضَٰعَفُ لَهُمْ وَلَهُمْ أَجْرٌۭ كَرِيمٌۭ',
		number_in_surah: '18',
		page: '539',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5094',
		number: '5094',
		text: 'وَٱلَّذِينَ ءَامَنُوا۟ بِٱللَّهِ وَرُسُلِهِۦٓ أُو۟لَٰٓئِكَ هُمُ ٱلصِّدِّيقُونَ ۖ وَٱلشُّهَدَآءُ عِندَ رَبِّهِمْ لَهُمْ أَجْرُهُمْ وَنُورُهُمْ ۖ وَٱلَّذِينَ كَفَرُوا۟ وَكَذَّبُوا۟ بِـَٔايَٰتِنَآ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْجَحِيمِ',
		number_in_surah: '19',
		page: '540',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5095',
		number: '5095',
		text: 'ٱعْلَمُوٓا۟ أَنَّمَا ٱلْحَيَوٰةُ ٱلدُّنْيَا لَعِبٌۭ وَلَهْوٌۭ وَزِينَةٌۭ وَتَفَاخُرٌۢ بَيْنَكُمْ وَتَكَاثُرٌۭ فِى ٱلْأَمْوَٰلِ وَٱلْأَوْلَٰدِ ۖ كَمَثَلِ غَيْثٍ أَعْجَبَ ٱلْكُفَّارَ نَبَاتُهُۥ ثُمَّ يَهِيجُ فَتَرَىٰهُ مُصْفَرًّۭا ثُمَّ يَكُونُ حُطَٰمًۭا ۖ وَفِى ٱلْءَاخِرَةِ عَذَابٌۭ شَدِيدٌۭ وَمَغْفِرَةٌۭ مِّنَ ٱللَّهِ وَرِضْوَٰنٌۭ ۚ وَمَا ٱلْحَيَوٰةُ ٱلدُّنْيَآ إِلَّا مَتَٰعُ ٱلْغُرُورِ',
		number_in_surah: '20',
		page: '540',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5096',
		number: '5096',
		text: 'سَابِقُوٓا۟ إِلَىٰ مَغْفِرَةٍۢ مِّن رَّبِّكُمْ وَجَنَّةٍ عَرْضُهَا كَعَرْضِ ٱلسَّمَآءِ وَٱلْأَرْضِ أُعِدَّتْ لِلَّذِينَ ءَامَنُوا۟ بِٱللَّهِ وَرُسُلِهِۦ ۚ ذَٰلِكَ فَضْلُ ٱللَّهِ يُؤْتِيهِ مَن يَشَآءُ ۚ وَٱللَّهُ ذُو ٱلْفَضْلِ ٱلْعَظِيمِ',
		number_in_surah: '21',
		page: '540',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5097',
		number: '5097',
		text: 'مَآ أَصَابَ مِن مُّصِيبَةٍۢ فِى ٱلْأَرْضِ وَلَا فِىٓ أَنفُسِكُمْ إِلَّا فِى كِتَٰبٍۢ مِّن قَبْلِ أَن نَّبْرَأَهَآ ۚ إِنَّ ذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٌۭ',
		number_in_surah: '22',
		page: '540',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5098',
		number: '5098',
		text: 'لِّكَيْلَا تَأْسَوْا۟ عَلَىٰ مَا فَاتَكُمْ وَلَا تَفْرَحُوا۟ بِمَآ ءَاتَىٰكُمْ ۗ وَٱللَّهُ لَا يُحِبُّ كُلَّ مُخْتَالٍۢ فَخُورٍ',
		number_in_surah: '23',
		page: '540',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5099',
		number: '5099',
		text: 'ٱلَّذِينَ يَبْخَلُونَ وَيَأْمُرُونَ ٱلنَّاسَ بِٱلْبُخْلِ ۗ وَمَن يَتَوَلَّ فَإِنَّ ٱللَّهَ هُوَ ٱلْغَنِىُّ ٱلْحَمِيدُ',
		number_in_surah: '24',
		page: '540',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5100',
		number: '5100',
		text: 'لَقَدْ أَرْسَلْنَا رُسُلَنَا بِٱلْبَيِّنَٰتِ وَأَنزَلْنَا مَعَهُمُ ٱلْكِتَٰبَ وَٱلْمِيزَانَ لِيَقُومَ ٱلنَّاسُ بِٱلْقِسْطِ ۖ وَأَنزَلْنَا ٱلْحَدِيدَ فِيهِ بَأْسٌۭ شَدِيدٌۭ وَمَنَٰفِعُ لِلنَّاسِ وَلِيَعْلَمَ ٱللَّهُ مَن يَنصُرُهُۥ وَرُسُلَهُۥ بِٱلْغَيْبِ ۚ إِنَّ ٱللَّهَ قَوِىٌّ عَزِيزٌۭ',
		number_in_surah: '25',
		page: '541',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5101',
		number: '5101',
		text: 'وَلَقَدْ أَرْسَلْنَا نُوحًۭا وَإِبْرَٰهِيمَ وَجَعَلْنَا فِى ذُرِّيَّتِهِمَا ٱلنُّبُوَّةَ وَٱلْكِتَٰبَ ۖ فَمِنْهُم مُّهْتَدٍۢ ۖ وَكَثِيرٌۭ مِّنْهُمْ فَٰسِقُونَ',
		number_in_surah: '26',
		page: '541',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5102',
		number: '5102',
		text: 'ثُمَّ قَفَّيْنَا عَلَىٰٓ ءَاثَٰرِهِم بِرُسُلِنَا وَقَفَّيْنَا بِعِيسَى ٱبْنِ مَرْيَمَ وَءَاتَيْنَٰهُ ٱلْإِنجِيلَ وَجَعَلْنَا فِى قُلُوبِ ٱلَّذِينَ ٱتَّبَعُوهُ رَأْفَةًۭ وَرَحْمَةًۭ وَرَهْبَانِيَّةً ٱبْتَدَعُوهَا مَا كَتَبْنَٰهَا عَلَيْهِمْ إِلَّا ٱبْتِغَآءَ رِضْوَٰنِ ٱللَّهِ فَمَا رَعَوْهَا حَقَّ رِعَايَتِهَا ۖ فَـَٔاتَيْنَا ٱلَّذِينَ ءَامَنُوا۟ مِنْهُمْ أَجْرَهُمْ ۖ وَكَثِيرٌۭ مِّنْهُمْ فَٰسِقُونَ',
		number_in_surah: '27',
		page: '541',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5103',
		number: '5103',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱتَّقُوا۟ ٱللَّهَ وَءَامِنُوا۟ بِرَسُولِهِۦ يُؤْتِكُمْ كِفْلَيْنِ مِن رَّحْمَتِهِۦ وَيَجْعَل لَّكُمْ نُورًۭا تَمْشُونَ بِهِۦ وَيَغْفِرْ لَكُمْ ۚ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '28',
		page: '541',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5104',
		number: '5104',
		text: 'لِّئَلَّا يَعْلَمَ أَهْلُ ٱلْكِتَٰبِ أَلَّا يَقْدِرُونَ عَلَىٰ شَىْءٍۢ مِّن فَضْلِ ٱللَّهِ ۙ وَأَنَّ ٱلْفَضْلَ بِيَدِ ٱللَّهِ يُؤْتِيهِ مَن يَشَآءُ ۚ وَٱللَّهُ ذُو ٱلْفَضْلِ ٱلْعَظِيمِ',
		number_in_surah: '29',
		page: '541',
		surah_id: '57',
		hizb_id: '216',
		juz_id: '27',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5105',
		number: '5105',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ قَدْ سَمِعَ ٱللَّهُ قَوْلَ ٱلَّتِى تُجَٰدِلُكَ فِى زَوْجِهَا وَتَشْتَكِىٓ إِلَى ٱللَّهِ وَٱللَّهُ يَسْمَعُ تَحَاوُرَكُمَآ ۚ إِنَّ ٱللَّهَ سَمِيعٌۢ بَصِيرٌ',
		number_in_surah: '1',
		page: '542',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5106',
		number: '5106',
		text: 'ٱلَّذِينَ يُظَٰهِرُونَ مِنكُم مِّن نِّسَآئِهِم مَّا هُنَّ أُمَّهَٰتِهِمْ ۖ إِنْ أُمَّهَٰتُهُمْ إِلَّا ٱلَّٰٓـِٔى وَلَدْنَهُمْ ۚ وَإِنَّهُمْ لَيَقُولُونَ مُنكَرًۭا مِّنَ ٱلْقَوْلِ وَزُورًۭا ۚ وَإِنَّ ٱللَّهَ لَعَفُوٌّ غَفُورٌۭ',
		number_in_surah: '2',
		page: '542',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5107',
		number: '5107',
		text: 'وَٱلَّذِينَ يُظَٰهِرُونَ مِن نِّسَآئِهِمْ ثُمَّ يَعُودُونَ لِمَا قَالُوا۟ فَتَحْرِيرُ رَقَبَةٍۢ مِّن قَبْلِ أَن يَتَمَآسَّا ۚ ذَٰلِكُمْ تُوعَظُونَ بِهِۦ ۚ وَٱللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '3',
		page: '542',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5108',
		number: '5108',
		text: 'فَمَن لَّمْ يَجِدْ فَصِيَامُ شَهْرَيْنِ مُتَتَابِعَيْنِ مِن قَبْلِ أَن يَتَمَآسَّا ۖ فَمَن لَّمْ يَسْتَطِعْ فَإِطْعَامُ سِتِّينَ مِسْكِينًۭا ۚ ذَٰلِكَ لِتُؤْمِنُوا۟ بِٱللَّهِ وَرَسُولِهِۦ ۚ وَتِلْكَ حُدُودُ ٱللَّهِ ۗ وَلِلْكَٰفِرِينَ عَذَابٌ أَلِيمٌ',
		number_in_surah: '4',
		page: '542',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5109',
		number: '5109',
		text: 'إِنَّ ٱلَّذِينَ يُحَآدُّونَ ٱللَّهَ وَرَسُولَهُۥ كُبِتُوا۟ كَمَا كُبِتَ ٱلَّذِينَ مِن قَبْلِهِمْ ۚ وَقَدْ أَنزَلْنَآ ءَايَٰتٍۭ بَيِّنَٰتٍۢ ۚ وَلِلْكَٰفِرِينَ عَذَابٌۭ مُّهِينٌۭ',
		number_in_surah: '5',
		page: '542',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5110',
		number: '5110',
		text: 'يَوْمَ يَبْعَثُهُمُ ٱللَّهُ جَمِيعًۭا فَيُنَبِّئُهُم بِمَا عَمِلُوٓا۟ ۚ أَحْصَىٰهُ ٱللَّهُ وَنَسُوهُ ۚ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ شَهِيدٌ',
		number_in_surah: '6',
		page: '542',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5111',
		number: '5111',
		text: 'أَلَمْ تَرَ أَنَّ ٱللَّهَ يَعْلَمُ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۖ مَا يَكُونُ مِن نَّجْوَىٰ ثَلَٰثَةٍ إِلَّا هُوَ رَابِعُهُمْ وَلَا خَمْسَةٍ إِلَّا هُوَ سَادِسُهُمْ وَلَآ أَدْنَىٰ مِن ذَٰلِكَ وَلَآ أَكْثَرَ إِلَّا هُوَ مَعَهُمْ أَيْنَ مَا كَانُوا۟ ۖ ثُمَّ يُنَبِّئُهُم بِمَا عَمِلُوا۟ يَوْمَ ٱلْقِيَٰمَةِ ۚ إِنَّ ٱللَّهَ بِكُلِّ شَىْءٍ عَلِيمٌ',
		number_in_surah: '7',
		page: '543',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5112',
		number: '5112',
		text: 'أَلَمْ تَرَ إِلَى ٱلَّذِينَ نُهُوا۟ عَنِ ٱلنَّجْوَىٰ ثُمَّ يَعُودُونَ لِمَا نُهُوا۟ عَنْهُ وَيَتَنَٰجَوْنَ بِٱلْإِثْمِ وَٱلْعُدْوَٰنِ وَمَعْصِيَتِ ٱلرَّسُولِ وَإِذَا جَآءُوكَ حَيَّوْكَ بِمَا لَمْ يُحَيِّكَ بِهِ ٱللَّهُ وَيَقُولُونَ فِىٓ أَنفُسِهِمْ لَوْلَا يُعَذِّبُنَا ٱللَّهُ بِمَا نَقُولُ ۚ حَسْبُهُمْ جَهَنَّمُ يَصْلَوْنَهَا ۖ فَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '8',
		page: '543',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5113',
		number: '5113',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا تَنَٰجَيْتُمْ فَلَا تَتَنَٰجَوْا۟ بِٱلْإِثْمِ وَٱلْعُدْوَٰنِ وَمَعْصِيَتِ ٱلرَّسُولِ وَتَنَٰجَوْا۟ بِٱلْبِرِّ وَٱلتَّقْوَىٰ ۖ وَٱتَّقُوا۟ ٱللَّهَ ٱلَّذِىٓ إِلَيْهِ تُحْشَرُونَ',
		number_in_surah: '9',
		page: '543',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5114',
		number: '5114',
		text: 'إِنَّمَا ٱلنَّجْوَىٰ مِنَ ٱلشَّيْطَٰنِ لِيَحْزُنَ ٱلَّذِينَ ءَامَنُوا۟ وَلَيْسَ بِضَآرِّهِمْ شَيْـًٔا إِلَّا بِإِذْنِ ٱللَّهِ ۚ وَعَلَى ٱللَّهِ فَلْيَتَوَكَّلِ ٱلْمُؤْمِنُونَ',
		number_in_surah: '10',
		page: '543',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5115',
		number: '5115',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا قِيلَ لَكُمْ تَفَسَّحُوا۟ فِى ٱلْمَجَٰلِسِ فَٱفْسَحُوا۟ يَفْسَحِ ٱللَّهُ لَكُمْ ۖ وَإِذَا قِيلَ ٱنشُزُوا۟ فَٱنشُزُوا۟ يَرْفَعِ ٱللَّهُ ٱلَّذِينَ ءَامَنُوا۟ مِنكُمْ وَٱلَّذِينَ أُوتُوا۟ ٱلْعِلْمَ دَرَجَٰتٍۢ ۚ وَٱللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '11',
		page: '543',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5116',
		number: '5116',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا نَٰجَيْتُمُ ٱلرَّسُولَ فَقَدِّمُوا۟ بَيْنَ يَدَىْ نَجْوَىٰكُمْ صَدَقَةًۭ ۚ ذَٰلِكَ خَيْرٌۭ لَّكُمْ وَأَطْهَرُ ۚ فَإِن لَّمْ تَجِدُوا۟ فَإِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '12',
		page: '544',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5117',
		number: '5117',
		text: 'ءَأَشْفَقْتُمْ أَن تُقَدِّمُوا۟ بَيْنَ يَدَىْ نَجْوَىٰكُمْ صَدَقَٰتٍۢ ۚ فَإِذْ لَمْ تَفْعَلُوا۟ وَتَابَ ٱللَّهُ عَلَيْكُمْ فَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَءَاتُوا۟ ٱلزَّكَوٰةَ وَأَطِيعُوا۟ ٱللَّهَ وَرَسُولَهُۥ ۚ وَٱللَّهُ خَبِيرٌۢ بِمَا تَعْمَلُونَ',
		number_in_surah: '13',
		page: '544',
		surah_id: '58',
		hizb_id: '217',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5118',
		number: '5118',
		text: '۞ أَلَمْ تَرَ إِلَى ٱلَّذِينَ تَوَلَّوْا۟ قَوْمًا غَضِبَ ٱللَّهُ عَلَيْهِم مَّا هُم مِّنكُمْ وَلَا مِنْهُمْ وَيَحْلِفُونَ عَلَى ٱلْكَذِبِ وَهُمْ يَعْلَمُونَ',
		number_in_surah: '14',
		page: '544',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5119',
		number: '5119',
		text: 'أَعَدَّ ٱللَّهُ لَهُمْ عَذَابًۭا شَدِيدًا ۖ إِنَّهُمْ سَآءَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '15',
		page: '544',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5120',
		number: '5120',
		text: 'ٱتَّخَذُوٓا۟ أَيْمَٰنَهُمْ جُنَّةًۭ فَصَدُّوا۟ عَن سَبِيلِ ٱللَّهِ فَلَهُمْ عَذَابٌۭ مُّهِينٌۭ',
		number_in_surah: '16',
		page: '544',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5121',
		number: '5121',
		text: 'لَّن تُغْنِىَ عَنْهُمْ أَمْوَٰلُهُمْ وَلَآ أَوْلَٰدُهُم مِّنَ ٱللَّهِ شَيْـًٔا ۚ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ ۖ هُمْ فِيهَا خَٰلِدُونَ',
		number_in_surah: '17',
		page: '544',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5122',
		number: '5122',
		text: 'يَوْمَ يَبْعَثُهُمُ ٱللَّهُ جَمِيعًۭا فَيَحْلِفُونَ لَهُۥ كَمَا يَحْلِفُونَ لَكُمْ ۖ وَيَحْسَبُونَ أَنَّهُمْ عَلَىٰ شَىْءٍ ۚ أَلَآ إِنَّهُمْ هُمُ ٱلْكَٰذِبُونَ',
		number_in_surah: '18',
		page: '544',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5123',
		number: '5123',
		text: 'ٱسْتَحْوَذَ عَلَيْهِمُ ٱلشَّيْطَٰنُ فَأَنسَىٰهُمْ ذِكْرَ ٱللَّهِ ۚ أُو۟لَٰٓئِكَ حِزْبُ ٱلشَّيْطَٰنِ ۚ أَلَآ إِنَّ حِزْبَ ٱلشَّيْطَٰنِ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '19',
		page: '544',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5124',
		number: '5124',
		text: 'إِنَّ ٱلَّذِينَ يُحَآدُّونَ ٱللَّهَ وَرَسُولَهُۥٓ أُو۟لَٰٓئِكَ فِى ٱلْأَذَلِّينَ',
		number_in_surah: '20',
		page: '544',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5125',
		number: '5125',
		text: 'كَتَبَ ٱللَّهُ لَأَغْلِبَنَّ أَنَا۠ وَرُسُلِىٓ ۚ إِنَّ ٱللَّهَ قَوِىٌّ عَزِيزٌۭ',
		number_in_surah: '21',
		page: '544',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5126',
		number: '5126',
		text: 'لَّا تَجِدُ قَوْمًۭا يُؤْمِنُونَ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ يُوَآدُّونَ مَنْ حَآدَّ ٱللَّهَ وَرَسُولَهُۥ وَلَوْ كَانُوٓا۟ ءَابَآءَهُمْ أَوْ أَبْنَآءَهُمْ أَوْ إِخْوَٰنَهُمْ أَوْ عَشِيرَتَهُمْ ۚ أُو۟لَٰٓئِكَ كَتَبَ فِى قُلُوبِهِمُ ٱلْإِيمَٰنَ وَأَيَّدَهُم بِرُوحٍۢ مِّنْهُ ۖ وَيُدْخِلُهُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَا ۚ رَضِىَ ٱللَّهُ عَنْهُمْ وَرَضُوا۟ عَنْهُ ۚ أُو۟لَٰٓئِكَ حِزْبُ ٱللَّهِ ۚ أَلَآ إِنَّ حِزْبَ ٱللَّهِ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '22',
		page: '545',
		surah_id: '58',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5127',
		number: '5127',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ سَبَّحَ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۖ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '1',
		page: '545',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5128',
		number: '5128',
		text: 'هُوَ ٱلَّذِىٓ أَخْرَجَ ٱلَّذِينَ كَفَرُوا۟ مِنْ أَهْلِ ٱلْكِتَٰبِ مِن دِيَٰرِهِمْ لِأَوَّلِ ٱلْحَشْرِ ۚ مَا ظَنَنتُمْ أَن يَخْرُجُوا۟ ۖ وَظَنُّوٓا۟ أَنَّهُم مَّانِعَتُهُمْ حُصُونُهُم مِّنَ ٱللَّهِ فَأَتَىٰهُمُ ٱللَّهُ مِنْ حَيْثُ لَمْ يَحْتَسِبُوا۟ ۖ وَقَذَفَ فِى قُلُوبِهِمُ ٱلرُّعْبَ ۚ يُخْرِبُونَ بُيُوتَهُم بِأَيْدِيهِمْ وَأَيْدِى ٱلْمُؤْمِنِينَ فَٱعْتَبِرُوا۟ يَٰٓأُو۟لِى ٱلْأَبْصَٰرِ',
		number_in_surah: '2',
		page: '545',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5129',
		number: '5129',
		text: 'وَلَوْلَآ أَن كَتَبَ ٱللَّهُ عَلَيْهِمُ ٱلْجَلَآءَ لَعَذَّبَهُمْ فِى ٱلدُّنْيَا ۖ وَلَهُمْ فِى ٱلْءَاخِرَةِ عَذَابُ ٱلنَّارِ',
		number_in_surah: '3',
		page: '545',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5130',
		number: '5130',
		text: 'ذَٰلِكَ بِأَنَّهُمْ شَآقُّوا۟ ٱللَّهَ وَرَسُولَهُۥ ۖ وَمَن يُشَآقِّ ٱللَّهَ فَإِنَّ ٱللَّهَ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '4',
		page: '546',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5131',
		number: '5131',
		text: 'مَا قَطَعْتُم مِّن لِّينَةٍ أَوْ تَرَكْتُمُوهَا قَآئِمَةً عَلَىٰٓ أُصُولِهَا فَبِإِذْنِ ٱللَّهِ وَلِيُخْزِىَ ٱلْفَٰسِقِينَ',
		number_in_surah: '5',
		page: '546',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5132',
		number: '5132',
		text: 'وَمَآ أَفَآءَ ٱللَّهُ عَلَىٰ رَسُولِهِۦ مِنْهُمْ فَمَآ أَوْجَفْتُمْ عَلَيْهِ مِنْ خَيْلٍۢ وَلَا رِكَابٍۢ وَلَٰكِنَّ ٱللَّهَ يُسَلِّطُ رُسُلَهُۥ عَلَىٰ مَن يَشَآءُ ۚ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '6',
		page: '546',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5133',
		number: '5133',
		text: 'مَّآ أَفَآءَ ٱللَّهُ عَلَىٰ رَسُولِهِۦ مِنْ أَهْلِ ٱلْقُرَىٰ فَلِلَّهِ وَلِلرَّسُولِ وَلِذِى ٱلْقُرْبَىٰ وَٱلْيَتَٰمَىٰ وَٱلْمَسَٰكِينِ وَٱبْنِ ٱلسَّبِيلِ كَىْ لَا يَكُونَ دُولَةًۢ بَيْنَ ٱلْأَغْنِيَآءِ مِنكُمْ ۚ وَمَآ ءَاتَىٰكُمُ ٱلرَّسُولُ فَخُذُوهُ وَمَا نَهَىٰكُمْ عَنْهُ فَٱنتَهُوا۟ ۚ وَٱتَّقُوا۟ ٱللَّهَ ۖ إِنَّ ٱللَّهَ شَدِيدُ ٱلْعِقَابِ',
		number_in_surah: '7',
		page: '546',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5134',
		number: '5134',
		text: 'لِلْفُقَرَآءِ ٱلْمُهَٰجِرِينَ ٱلَّذِينَ أُخْرِجُوا۟ مِن دِيَٰرِهِمْ وَأَمْوَٰلِهِمْ يَبْتَغُونَ فَضْلًۭا مِّنَ ٱللَّهِ وَرِضْوَٰنًۭا وَيَنصُرُونَ ٱللَّهَ وَرَسُولَهُۥٓ ۚ أُو۟لَٰٓئِكَ هُمُ ٱلصَّٰدِقُونَ',
		number_in_surah: '8',
		page: '546',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5135',
		number: '5135',
		text: 'وَٱلَّذِينَ تَبَوَّءُو ٱلدَّارَ وَٱلْإِيمَٰنَ مِن قَبْلِهِمْ يُحِبُّونَ مَنْ هَاجَرَ إِلَيْهِمْ وَلَا يَجِدُونَ فِى صُدُورِهِمْ حَاجَةًۭ مِّمَّآ أُوتُوا۟ وَيُؤْثِرُونَ عَلَىٰٓ أَنفُسِهِمْ وَلَوْ كَانَ بِهِمْ خَصَاصَةٌۭ ۚ وَمَن يُوقَ شُحَّ نَفْسِهِۦ فَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '9',
		page: '546',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5136',
		number: '5136',
		text: 'وَٱلَّذِينَ جَآءُو مِنۢ بَعْدِهِمْ يَقُولُونَ رَبَّنَا ٱغْفِرْ لَنَا وَلِإِخْوَٰنِنَا ٱلَّذِينَ سَبَقُونَا بِٱلْإِيمَٰنِ وَلَا تَجْعَلْ فِى قُلُوبِنَا غِلًّۭا لِّلَّذِينَ ءَامَنُوا۟ رَبَّنَآ إِنَّكَ رَءُوفٌۭ رَّحِيمٌ',
		number_in_surah: '10',
		page: '547',
		surah_id: '59',
		hizb_id: '218',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5137',
		number: '5137',
		text: '۞ أَلَمْ تَرَ إِلَى ٱلَّذِينَ نَافَقُوا۟ يَقُولُونَ لِإِخْوَٰنِهِمُ ٱلَّذِينَ كَفَرُوا۟ مِنْ أَهْلِ ٱلْكِتَٰبِ لَئِنْ أُخْرِجْتُمْ لَنَخْرُجَنَّ مَعَكُمْ وَلَا نُطِيعُ فِيكُمْ أَحَدًا أَبَدًۭا وَإِن قُوتِلْتُمْ لَنَنصُرَنَّكُمْ وَٱللَّهُ يَشْهَدُ إِنَّهُمْ لَكَٰذِبُونَ',
		number_in_surah: '11',
		page: '547',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5138',
		number: '5138',
		text: 'لَئِنْ أُخْرِجُوا۟ لَا يَخْرُجُونَ مَعَهُمْ وَلَئِن قُوتِلُوا۟ لَا يَنصُرُونَهُمْ وَلَئِن نَّصَرُوهُمْ لَيُوَلُّنَّ ٱلْأَدْبَٰرَ ثُمَّ لَا يُنصَرُونَ',
		number_in_surah: '12',
		page: '547',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5139',
		number: '5139',
		text: 'لَأَنتُمْ أَشَدُّ رَهْبَةًۭ فِى صُدُورِهِم مِّنَ ٱللَّهِ ۚ ذَٰلِكَ بِأَنَّهُمْ قَوْمٌۭ لَّا يَفْقَهُونَ',
		number_in_surah: '13',
		page: '547',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5140',
		number: '5140',
		text: 'لَا يُقَٰتِلُونَكُمْ جَمِيعًا إِلَّا فِى قُرًۭى مُّحَصَّنَةٍ أَوْ مِن وَرَآءِ جُدُرٍۭ ۚ بَأْسُهُم بَيْنَهُمْ شَدِيدٌۭ ۚ تَحْسَبُهُمْ جَمِيعًۭا وَقُلُوبُهُمْ شَتَّىٰ ۚ ذَٰلِكَ بِأَنَّهُمْ قَوْمٌۭ لَّا يَعْقِلُونَ',
		number_in_surah: '14',
		page: '547',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5141',
		number: '5141',
		text: 'كَمَثَلِ ٱلَّذِينَ مِن قَبْلِهِمْ قَرِيبًۭا ۖ ذَاقُوا۟ وَبَالَ أَمْرِهِمْ وَلَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '15',
		page: '547',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5142',
		number: '5142',
		text: 'كَمَثَلِ ٱلشَّيْطَٰنِ إِذْ قَالَ لِلْإِنسَٰنِ ٱكْفُرْ فَلَمَّا كَفَرَ قَالَ إِنِّى بَرِىٓءٌۭ مِّنكَ إِنِّىٓ أَخَافُ ٱللَّهَ رَبَّ ٱلْعَٰلَمِينَ',
		number_in_surah: '16',
		page: '547',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5143',
		number: '5143',
		text: 'فَكَانَ عَٰقِبَتَهُمَآ أَنَّهُمَا فِى ٱلنَّارِ خَٰلِدَيْنِ فِيهَا ۚ وَذَٰلِكَ جَزَٰٓؤُا۟ ٱلظَّٰلِمِينَ',
		number_in_surah: '17',
		page: '548',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5144',
		number: '5144',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ ٱتَّقُوا۟ ٱللَّهَ وَلْتَنظُرْ نَفْسٌۭ مَّا قَدَّمَتْ لِغَدٍۢ ۖ وَٱتَّقُوا۟ ٱللَّهَ ۚ إِنَّ ٱللَّهَ خَبِيرٌۢ بِمَا تَعْمَلُونَ',
		number_in_surah: '18',
		page: '548',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5145',
		number: '5145',
		text: 'وَلَا تَكُونُوا۟ كَٱلَّذِينَ نَسُوا۟ ٱللَّهَ فَأَنسَىٰهُمْ أَنفُسَهُمْ ۚ أُو۟لَٰٓئِكَ هُمُ ٱلْفَٰسِقُونَ',
		number_in_surah: '19',
		page: '548',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5146',
		number: '5146',
		text: 'لَا يَسْتَوِىٓ أَصْحَٰبُ ٱلنَّارِ وَأَصْحَٰبُ ٱلْجَنَّةِ ۚ أَصْحَٰبُ ٱلْجَنَّةِ هُمُ ٱلْفَآئِزُونَ',
		number_in_surah: '20',
		page: '548',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5147',
		number: '5147',
		text: 'لَوْ أَنزَلْنَا هَٰذَا ٱلْقُرْءَانَ عَلَىٰ جَبَلٍۢ لَّرَأَيْتَهُۥ خَٰشِعًۭا مُّتَصَدِّعًۭا مِّنْ خَشْيَةِ ٱللَّهِ ۚ وَتِلْكَ ٱلْأَمْثَٰلُ نَضْرِبُهَا لِلنَّاسِ لَعَلَّهُمْ يَتَفَكَّرُونَ',
		number_in_surah: '21',
		page: '548',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5148',
		number: '5148',
		text: 'هُوَ ٱللَّهُ ٱلَّذِى لَآ إِلَٰهَ إِلَّا هُوَ ۖ عَٰلِمُ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ ۖ هُوَ ٱلرَّحْمَٰنُ ٱلرَّحِيمُ',
		number_in_surah: '22',
		page: '548',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5149',
		number: '5149',
		text: 'هُوَ ٱللَّهُ ٱلَّذِى لَآ إِلَٰهَ إِلَّا هُوَ ٱلْمَلِكُ ٱلْقُدُّوسُ ٱلسَّلَٰمُ ٱلْمُؤْمِنُ ٱلْمُهَيْمِنُ ٱلْعَزِيزُ ٱلْجَبَّارُ ٱلْمُتَكَبِّرُ ۚ سُبْحَٰنَ ٱللَّهِ عَمَّا يُشْرِكُونَ',
		number_in_surah: '23',
		page: '548',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5150',
		number: '5150',
		text: 'هُوَ ٱللَّهُ ٱلْخَٰلِقُ ٱلْبَارِئُ ٱلْمُصَوِّرُ ۖ لَهُ ٱلْأَسْمَآءُ ٱلْحُسْنَىٰ ۚ يُسَبِّحُ لَهُۥ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۖ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '24',
		page: '548',
		surah_id: '59',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5151',
		number: '5151',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَتَّخِذُوا۟ عَدُوِّى وَعَدُوَّكُمْ أَوْلِيَآءَ تُلْقُونَ إِلَيْهِم بِٱلْمَوَدَّةِ وَقَدْ كَفَرُوا۟ بِمَا جَآءَكُم مِّنَ ٱلْحَقِّ يُخْرِجُونَ ٱلرَّسُولَ وَإِيَّاكُمْ ۙ أَن تُؤْمِنُوا۟ بِٱللَّهِ رَبِّكُمْ إِن كُنتُمْ خَرَجْتُمْ جِهَٰدًۭا فِى سَبِيلِى وَٱبْتِغَآءَ مَرْضَاتِى ۚ تُسِرُّونَ إِلَيْهِم بِٱلْمَوَدَّةِ وَأَنَا۠ أَعْلَمُ بِمَآ أَخْفَيْتُمْ وَمَآ أَعْلَنتُمْ ۚ وَمَن يَفْعَلْهُ مِنكُمْ فَقَدْ ضَلَّ سَوَآءَ ٱلسَّبِيلِ',
		number_in_surah: '1',
		page: '549',
		surah_id: '60',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5152',
		number: '5152',
		text: 'إِن يَثْقَفُوكُمْ يَكُونُوا۟ لَكُمْ أَعْدَآءًۭ وَيَبْسُطُوٓا۟ إِلَيْكُمْ أَيْدِيَهُمْ وَأَلْسِنَتَهُم بِٱلسُّوٓءِ وَوَدُّوا۟ لَوْ تَكْفُرُونَ',
		number_in_surah: '2',
		page: '549',
		surah_id: '60',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5153',
		number: '5153',
		text: 'لَن تَنفَعَكُمْ أَرْحَامُكُمْ وَلَآ أَوْلَٰدُكُمْ ۚ يَوْمَ ٱلْقِيَٰمَةِ يَفْصِلُ بَيْنَكُمْ ۚ وَٱللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌۭ',
		number_in_surah: '3',
		page: '549',
		surah_id: '60',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5154',
		number: '5154',
		text: 'قَدْ كَانَتْ لَكُمْ أُسْوَةٌ حَسَنَةٌۭ فِىٓ إِبْرَٰهِيمَ وَٱلَّذِينَ مَعَهُۥٓ إِذْ قَالُوا۟ لِقَوْمِهِمْ إِنَّا بُرَءَٰٓؤُا۟ مِنكُمْ وَمِمَّا تَعْبُدُونَ مِن دُونِ ٱللَّهِ كَفَرْنَا بِكُمْ وَبَدَا بَيْنَنَا وَبَيْنَكُمُ ٱلْعَدَٰوَةُ وَٱلْبَغْضَآءُ أَبَدًا حَتَّىٰ تُؤْمِنُوا۟ بِٱللَّهِ وَحْدَهُۥٓ إِلَّا قَوْلَ إِبْرَٰهِيمَ لِأَبِيهِ لَأَسْتَغْفِرَنَّ لَكَ وَمَآ أَمْلِكُ لَكَ مِنَ ٱللَّهِ مِن شَىْءٍۢ ۖ رَّبَّنَا عَلَيْكَ تَوَكَّلْنَا وَإِلَيْكَ أَنَبْنَا وَإِلَيْكَ ٱلْمَصِيرُ',
		number_in_surah: '4',
		page: '549',
		surah_id: '60',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5155',
		number: '5155',
		text: 'رَبَّنَا لَا تَجْعَلْنَا فِتْنَةًۭ لِّلَّذِينَ كَفَرُوا۟ وَٱغْفِرْ لَنَا رَبَّنَآ ۖ إِنَّكَ أَنتَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '5',
		page: '549',
		surah_id: '60',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5156',
		number: '5156',
		text: 'لَقَدْ كَانَ لَكُمْ فِيهِمْ أُسْوَةٌ حَسَنَةٌۭ لِّمَن كَانَ يَرْجُوا۟ ٱللَّهَ وَٱلْيَوْمَ ٱلْءَاخِرَ ۚ وَمَن يَتَوَلَّ فَإِنَّ ٱللَّهَ هُوَ ٱلْغَنِىُّ ٱلْحَمِيدُ',
		number_in_surah: '6',
		page: '550',
		surah_id: '60',
		hizb_id: '219',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5157',
		number: '5157',
		text: '۞ عَسَى ٱللَّهُ أَن يَجْعَلَ بَيْنَكُمْ وَبَيْنَ ٱلَّذِينَ عَادَيْتُم مِّنْهُم مَّوَدَّةًۭ ۚ وَٱللَّهُ قَدِيرٌۭ ۚ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '7',
		page: '550',
		surah_id: '60',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5158',
		number: '5158',
		text: 'لَّا يَنْهَىٰكُمُ ٱللَّهُ عَنِ ٱلَّذِينَ لَمْ يُقَٰتِلُوكُمْ فِى ٱلدِّينِ وَلَمْ يُخْرِجُوكُم مِّن دِيَٰرِكُمْ أَن تَبَرُّوهُمْ وَتُقْسِطُوٓا۟ إِلَيْهِمْ ۚ إِنَّ ٱللَّهَ يُحِبُّ ٱلْمُقْسِطِينَ',
		number_in_surah: '8',
		page: '550',
		surah_id: '60',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5159',
		number: '5159',
		text: 'إِنَّمَا يَنْهَىٰكُمُ ٱللَّهُ عَنِ ٱلَّذِينَ قَٰتَلُوكُمْ فِى ٱلدِّينِ وَأَخْرَجُوكُم مِّن دِيَٰرِكُمْ وَظَٰهَرُوا۟ عَلَىٰٓ إِخْرَاجِكُمْ أَن تَوَلَّوْهُمْ ۚ وَمَن يَتَوَلَّهُمْ فَأُو۟لَٰٓئِكَ هُمُ ٱلظَّٰلِمُونَ',
		number_in_surah: '9',
		page: '550',
		surah_id: '60',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5160',
		number: '5160',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا جَآءَكُمُ ٱلْمُؤْمِنَٰتُ مُهَٰجِرَٰتٍۢ فَٱمْتَحِنُوهُنَّ ۖ ٱللَّهُ أَعْلَمُ بِإِيمَٰنِهِنَّ ۖ فَإِنْ عَلِمْتُمُوهُنَّ مُؤْمِنَٰتٍۢ فَلَا تَرْجِعُوهُنَّ إِلَى ٱلْكُفَّارِ ۖ لَا هُنَّ حِلٌّۭ لَّهُمْ وَلَا هُمْ يَحِلُّونَ لَهُنَّ ۖ وَءَاتُوهُم مَّآ أَنفَقُوا۟ ۚ وَلَا جُنَاحَ عَلَيْكُمْ أَن تَنكِحُوهُنَّ إِذَآ ءَاتَيْتُمُوهُنَّ أُجُورَهُنَّ ۚ وَلَا تُمْسِكُوا۟ بِعِصَمِ ٱلْكَوَافِرِ وَسْـَٔلُوا۟ مَآ أَنفَقْتُمْ وَلْيَسْـَٔلُوا۟ مَآ أَنفَقُوا۟ ۚ ذَٰلِكُمْ حُكْمُ ٱللَّهِ ۖ يَحْكُمُ بَيْنَكُمْ ۚ وَٱللَّهُ عَلِيمٌ حَكِيمٌۭ',
		number_in_surah: '10',
		page: '550',
		surah_id: '60',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5161',
		number: '5161',
		text: 'وَإِن فَاتَكُمْ شَىْءٌۭ مِّنْ أَزْوَٰجِكُمْ إِلَى ٱلْكُفَّارِ فَعَاقَبْتُمْ فَـَٔاتُوا۟ ٱلَّذِينَ ذَهَبَتْ أَزْوَٰجُهُم مِّثْلَ مَآ أَنفَقُوا۟ ۚ وَٱتَّقُوا۟ ٱللَّهَ ٱلَّذِىٓ أَنتُم بِهِۦ مُؤْمِنُونَ',
		number_in_surah: '11',
		page: '550',
		surah_id: '60',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5162',
		number: '5162',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ إِذَا جَآءَكَ ٱلْمُؤْمِنَٰتُ يُبَايِعْنَكَ عَلَىٰٓ أَن لَّا يُشْرِكْنَ بِٱللَّهِ شَيْـًۭٔا وَلَا يَسْرِقْنَ وَلَا يَزْنِينَ وَلَا يَقْتُلْنَ أَوْلَٰدَهُنَّ وَلَا يَأْتِينَ بِبُهْتَٰنٍۢ يَفْتَرِينَهُۥ بَيْنَ أَيْدِيهِنَّ وَأَرْجُلِهِنَّ وَلَا يَعْصِينَكَ فِى مَعْرُوفٍۢ ۙ فَبَايِعْهُنَّ وَٱسْتَغْفِرْ لَهُنَّ ٱللَّهَ ۖ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '12',
		page: '551',
		surah_id: '60',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5163',
		number: '5163',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تَتَوَلَّوْا۟ قَوْمًا غَضِبَ ٱللَّهُ عَلَيْهِمْ قَدْ يَئِسُوا۟ مِنَ ٱلْءَاخِرَةِ كَمَا يَئِسَ ٱلْكُفَّارُ مِنْ أَصْحَٰبِ ٱلْقُبُورِ',
		number_in_surah: '13',
		page: '551',
		surah_id: '60',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5164',
		number: '5164',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ سَبَّحَ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۖ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '1',
		page: '551',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5165',
		number: '5165',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لِمَ تَقُولُونَ مَا لَا تَفْعَلُونَ',
		number_in_surah: '2',
		page: '551',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5166',
		number: '5166',
		text: 'كَبُرَ مَقْتًا عِندَ ٱللَّهِ أَن تَقُولُوا۟ مَا لَا تَفْعَلُونَ',
		number_in_surah: '3',
		page: '551',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5167',
		number: '5167',
		text: 'إِنَّ ٱللَّهَ يُحِبُّ ٱلَّذِينَ يُقَٰتِلُونَ فِى سَبِيلِهِۦ صَفًّۭا كَأَنَّهُم بُنْيَٰنٌۭ مَّرْصُوصٌۭ',
		number_in_surah: '4',
		page: '551',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5168',
		number: '5168',
		text: 'وَإِذْ قَالَ مُوسَىٰ لِقَوْمِهِۦ يَٰقَوْمِ لِمَ تُؤْذُونَنِى وَقَد تَّعْلَمُونَ أَنِّى رَسُولُ ٱللَّهِ إِلَيْكُمْ ۖ فَلَمَّا زَاغُوٓا۟ أَزَاغَ ٱللَّهُ قُلُوبَهُمْ ۚ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلْفَٰسِقِينَ',
		number_in_surah: '5',
		page: '551',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5169',
		number: '5169',
		text: 'وَإِذْ قَالَ عِيسَى ٱبْنُ مَرْيَمَ يَٰبَنِىٓ إِسْرَٰٓءِيلَ إِنِّى رَسُولُ ٱللَّهِ إِلَيْكُم مُّصَدِّقًۭا لِّمَا بَيْنَ يَدَىَّ مِنَ ٱلتَّوْرَىٰةِ وَمُبَشِّرًۢا بِرَسُولٍۢ يَأْتِى مِنۢ بَعْدِى ٱسْمُهُۥٓ أَحْمَدُ ۖ فَلَمَّا جَآءَهُم بِٱلْبَيِّنَٰتِ قَالُوا۟ هَٰذَا سِحْرٌۭ مُّبِينٌۭ',
		number_in_surah: '6',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5170',
		number: '5170',
		text: 'وَمَنْ أَظْلَمُ مِمَّنِ ٱفْتَرَىٰ عَلَى ٱللَّهِ ٱلْكَذِبَ وَهُوَ يُدْعَىٰٓ إِلَى ٱلْإِسْلَٰمِ ۚ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '7',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5171',
		number: '5171',
		text: 'يُرِيدُونَ لِيُطْفِـُٔوا۟ نُورَ ٱللَّهِ بِأَفْوَٰهِهِمْ وَٱللَّهُ مُتِمُّ نُورِهِۦ وَلَوْ كَرِهَ ٱلْكَٰفِرُونَ',
		number_in_surah: '8',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5172',
		number: '5172',
		text: 'هُوَ ٱلَّذِىٓ أَرْسَلَ رَسُولَهُۥ بِٱلْهُدَىٰ وَدِينِ ٱلْحَقِّ لِيُظْهِرَهُۥ عَلَى ٱلدِّينِ كُلِّهِۦ وَلَوْ كَرِهَ ٱلْمُشْرِكُونَ',
		number_in_surah: '9',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5173',
		number: '5173',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ هَلْ أَدُلُّكُمْ عَلَىٰ تِجَٰرَةٍۢ تُنجِيكُم مِّنْ عَذَابٍ أَلِيمٍۢ',
		number_in_surah: '10',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5174',
		number: '5174',
		text: 'تُؤْمِنُونَ بِٱللَّهِ وَرَسُولِهِۦ وَتُجَٰهِدُونَ فِى سَبِيلِ ٱللَّهِ بِأَمْوَٰلِكُمْ وَأَنفُسِكُمْ ۚ ذَٰلِكُمْ خَيْرٌۭ لَّكُمْ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '11',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5175',
		number: '5175',
		text: 'يَغْفِرْ لَكُمْ ذُنُوبَكُمْ وَيُدْخِلْكُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ وَمَسَٰكِنَ طَيِّبَةًۭ فِى جَنَّٰتِ عَدْنٍۢ ۚ ذَٰلِكَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '12',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5176',
		number: '5176',
		text: 'وَأُخْرَىٰ تُحِبُّونَهَا ۖ نَصْرٌۭ مِّنَ ٱللَّهِ وَفَتْحٌۭ قَرِيبٌۭ ۗ وَبَشِّرِ ٱلْمُؤْمِنِينَ',
		number_in_surah: '13',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5177',
		number: '5177',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ كُونُوٓا۟ أَنصَارَ ٱللَّهِ كَمَا قَالَ عِيسَى ٱبْنُ مَرْيَمَ لِلْحَوَارِيِّۦنَ مَنْ أَنصَارِىٓ إِلَى ٱللَّهِ ۖ قَالَ ٱلْحَوَارِيُّونَ نَحْنُ أَنصَارُ ٱللَّهِ ۖ فَـَٔامَنَت طَّآئِفَةٌۭ مِّنۢ بَنِىٓ إِسْرَٰٓءِيلَ وَكَفَرَت طَّآئِفَةٌۭ ۖ فَأَيَّدْنَا ٱلَّذِينَ ءَامَنُوا۟ عَلَىٰ عَدُوِّهِمْ فَأَصْبَحُوا۟ ظَٰهِرِينَ',
		number_in_surah: '14',
		page: '552',
		surah_id: '61',
		hizb_id: '220',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5178',
		number: '5178',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يُسَبِّحُ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ٱلْمَلِكِ ٱلْقُدُّوسِ ٱلْعَزِيزِ ٱلْحَكِيمِ',
		number_in_surah: '1',
		page: '553',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5179',
		number: '5179',
		text: 'هُوَ ٱلَّذِى بَعَثَ فِى ٱلْأُمِّيِّۦنَ رَسُولًۭا مِّنْهُمْ يَتْلُوا۟ عَلَيْهِمْ ءَايَٰتِهِۦ وَيُزَكِّيهِمْ وَيُعَلِّمُهُمُ ٱلْكِتَٰبَ وَٱلْحِكْمَةَ وَإِن كَانُوا۟ مِن قَبْلُ لَفِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '2',
		page: '553',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5180',
		number: '5180',
		text: 'وَءَاخَرِينَ مِنْهُمْ لَمَّا يَلْحَقُوا۟ بِهِمْ ۚ وَهُوَ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '3',
		page: '553',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5181',
		number: '5181',
		text: 'ذَٰلِكَ فَضْلُ ٱللَّهِ يُؤْتِيهِ مَن يَشَآءُ ۚ وَٱللَّهُ ذُو ٱلْفَضْلِ ٱلْعَظِيمِ',
		number_in_surah: '4',
		page: '553',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5182',
		number: '5182',
		text: 'مَثَلُ ٱلَّذِينَ حُمِّلُوا۟ ٱلتَّوْرَىٰةَ ثُمَّ لَمْ يَحْمِلُوهَا كَمَثَلِ ٱلْحِمَارِ يَحْمِلُ أَسْفَارًۢا ۚ بِئْسَ مَثَلُ ٱلْقَوْمِ ٱلَّذِينَ كَذَّبُوا۟ بِـَٔايَٰتِ ٱللَّهِ ۚ وَٱللَّهُ لَا يَهْدِى ٱلْقَوْمَ ٱلظَّٰلِمِينَ',
		number_in_surah: '5',
		page: '553',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5183',
		number: '5183',
		text: 'قُلْ يَٰٓأَيُّهَا ٱلَّذِينَ هَادُوٓا۟ إِن زَعَمْتُمْ أَنَّكُمْ أَوْلِيَآءُ لِلَّهِ مِن دُونِ ٱلنَّاسِ فَتَمَنَّوُا۟ ٱلْمَوْتَ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '6',
		page: '553',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5184',
		number: '5184',
		text: 'وَلَا يَتَمَنَّوْنَهُۥٓ أَبَدًۢا بِمَا قَدَّمَتْ أَيْدِيهِمْ ۚ وَٱللَّهُ عَلِيمٌۢ بِٱلظَّٰلِمِينَ',
		number_in_surah: '7',
		page: '553',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5185',
		number: '5185',
		text: 'قُلْ إِنَّ ٱلْمَوْتَ ٱلَّذِى تَفِرُّونَ مِنْهُ فَإِنَّهُۥ مُلَٰقِيكُمْ ۖ ثُمَّ تُرَدُّونَ إِلَىٰ عَٰلِمِ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ فَيُنَبِّئُكُم بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '8',
		page: '553',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5186',
		number: '5186',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِذَا نُودِىَ لِلصَّلَوٰةِ مِن يَوْمِ ٱلْجُمُعَةِ فَٱسْعَوْا۟ إِلَىٰ ذِكْرِ ٱللَّهِ وَذَرُوا۟ ٱلْبَيْعَ ۚ ذَٰلِكُمْ خَيْرٌۭ لَّكُمْ إِن كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '9',
		page: '554',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5187',
		number: '5187',
		text: 'فَإِذَا قُضِيَتِ ٱلصَّلَوٰةُ فَٱنتَشِرُوا۟ فِى ٱلْأَرْضِ وَٱبْتَغُوا۟ مِن فَضْلِ ٱللَّهِ وَٱذْكُرُوا۟ ٱللَّهَ كَثِيرًۭا لَّعَلَّكُمْ تُفْلِحُونَ',
		number_in_surah: '10',
		page: '554',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5188',
		number: '5188',
		text: 'وَإِذَا رَأَوْا۟ تِجَٰرَةً أَوْ لَهْوًا ٱنفَضُّوٓا۟ إِلَيْهَا وَتَرَكُوكَ قَآئِمًۭا ۚ قُلْ مَا عِندَ ٱللَّهِ خَيْرٌۭ مِّنَ ٱللَّهْوِ وَمِنَ ٱلتِّجَٰرَةِ ۚ وَٱللَّهُ خَيْرُ ٱلرَّٰزِقِينَ',
		number_in_surah: '11',
		page: '554',
		surah_id: '62',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5189',
		number: '5189',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِذَا جَآءَكَ ٱلْمُنَٰفِقُونَ قَالُوا۟ نَشْهَدُ إِنَّكَ لَرَسُولُ ٱللَّهِ ۗ وَٱللَّهُ يَعْلَمُ إِنَّكَ لَرَسُولُهُۥ وَٱللَّهُ يَشْهَدُ إِنَّ ٱلْمُنَٰفِقِينَ لَكَٰذِبُونَ',
		number_in_surah: '1',
		page: '554',
		surah_id: '63',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5190',
		number: '5190',
		text: 'ٱتَّخَذُوٓا۟ أَيْمَٰنَهُمْ جُنَّةًۭ فَصَدُّوا۟ عَن سَبِيلِ ٱللَّهِ ۚ إِنَّهُمْ سَآءَ مَا كَانُوا۟ يَعْمَلُونَ',
		number_in_surah: '2',
		page: '554',
		surah_id: '63',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5191',
		number: '5191',
		text: 'ذَٰلِكَ بِأَنَّهُمْ ءَامَنُوا۟ ثُمَّ كَفَرُوا۟ فَطُبِعَ عَلَىٰ قُلُوبِهِمْ فَهُمْ لَا يَفْقَهُونَ',
		number_in_surah: '3',
		page: '554',
		surah_id: '63',
		hizb_id: '221',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5192',
		number: '5192',
		text: '۞ وَإِذَا رَأَيْتَهُمْ تُعْجِبُكَ أَجْسَامُهُمْ ۖ وَإِن يَقُولُوا۟ تَسْمَعْ لِقَوْلِهِمْ ۖ كَأَنَّهُمْ خُشُبٌۭ مُّسَنَّدَةٌۭ ۖ يَحْسَبُونَ كُلَّ صَيْحَةٍ عَلَيْهِمْ ۚ هُمُ ٱلْعَدُوُّ فَٱحْذَرْهُمْ ۚ قَٰتَلَهُمُ ٱللَّهُ ۖ أَنَّىٰ يُؤْفَكُونَ',
		number_in_surah: '4',
		page: '554',
		surah_id: '63',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5193',
		number: '5193',
		text: 'وَإِذَا قِيلَ لَهُمْ تَعَالَوْا۟ يَسْتَغْفِرْ لَكُمْ رَسُولُ ٱللَّهِ لَوَّوْا۟ رُءُوسَهُمْ وَرَأَيْتَهُمْ يَصُدُّونَ وَهُم مُّسْتَكْبِرُونَ',
		number_in_surah: '5',
		page: '555',
		surah_id: '63',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5194',
		number: '5194',
		text: 'سَوَآءٌ عَلَيْهِمْ أَسْتَغْفَرْتَ لَهُمْ أَمْ لَمْ تَسْتَغْفِرْ لَهُمْ لَن يَغْفِرَ ٱللَّهُ لَهُمْ ۚ إِنَّ ٱللَّهَ لَا يَهْدِى ٱلْقَوْمَ ٱلْفَٰسِقِينَ',
		number_in_surah: '6',
		page: '555',
		surah_id: '63',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5195',
		number: '5195',
		text: 'هُمُ ٱلَّذِينَ يَقُولُونَ لَا تُنفِقُوا۟ عَلَىٰ مَنْ عِندَ رَسُولِ ٱللَّهِ حَتَّىٰ يَنفَضُّوا۟ ۗ وَلِلَّهِ خَزَآئِنُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَلَٰكِنَّ ٱلْمُنَٰفِقِينَ لَا يَفْقَهُونَ',
		number_in_surah: '7',
		page: '555',
		surah_id: '63',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5196',
		number: '5196',
		text: 'يَقُولُونَ لَئِن رَّجَعْنَآ إِلَى ٱلْمَدِينَةِ لَيُخْرِجَنَّ ٱلْأَعَزُّ مِنْهَا ٱلْأَذَلَّ ۚ وَلِلَّهِ ٱلْعِزَّةُ وَلِرَسُولِهِۦ وَلِلْمُؤْمِنِينَ وَلَٰكِنَّ ٱلْمُنَٰفِقِينَ لَا يَعْلَمُونَ',
		number_in_surah: '8',
		page: '555',
		surah_id: '63',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5197',
		number: '5197',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ لَا تُلْهِكُمْ أَمْوَٰلُكُمْ وَلَآ أَوْلَٰدُكُمْ عَن ذِكْرِ ٱللَّهِ ۚ وَمَن يَفْعَلْ ذَٰلِكَ فَأُو۟لَٰٓئِكَ هُمُ ٱلْخَٰسِرُونَ',
		number_in_surah: '9',
		page: '555',
		surah_id: '63',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5198',
		number: '5198',
		text: 'وَأَنفِقُوا۟ مِن مَّا رَزَقْنَٰكُم مِّن قَبْلِ أَن يَأْتِىَ أَحَدَكُمُ ٱلْمَوْتُ فَيَقُولَ رَبِّ لَوْلَآ أَخَّرْتَنِىٓ إِلَىٰٓ أَجَلٍۢ قَرِيبٍۢ فَأَصَّدَّقَ وَأَكُن مِّنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '10',
		page: '555',
		surah_id: '63',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5199',
		number: '5199',
		text: 'وَلَن يُؤَخِّرَ ٱللَّهُ نَفْسًا إِذَا جَآءَ أَجَلُهَا ۚ وَٱللَّهُ خَبِيرٌۢ بِمَا تَعْمَلُونَ',
		number_in_surah: '11',
		page: '555',
		surah_id: '63',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5200',
		number: '5200',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يُسَبِّحُ لِلَّهِ مَا فِى ٱلسَّمَٰوَٰتِ وَمَا فِى ٱلْأَرْضِ ۖ لَهُ ٱلْمُلْكُ وَلَهُ ٱلْحَمْدُ ۖ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '1',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5201',
		number: '5201',
		text: 'هُوَ ٱلَّذِى خَلَقَكُمْ فَمِنكُمْ كَافِرٌۭ وَمِنكُم مُّؤْمِنٌۭ ۚ وَٱللَّهُ بِمَا تَعْمَلُونَ بَصِيرٌ',
		number_in_surah: '2',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5202',
		number: '5202',
		text: 'خَلَقَ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضَ بِٱلْحَقِّ وَصَوَّرَكُمْ فَأَحْسَنَ صُوَرَكُمْ ۖ وَإِلَيْهِ ٱلْمَصِيرُ',
		number_in_surah: '3',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5203',
		number: '5203',
		text: 'يَعْلَمُ مَا فِى ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَيَعْلَمُ مَا تُسِرُّونَ وَمَا تُعْلِنُونَ ۚ وَٱللَّهُ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '4',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5204',
		number: '5204',
		text: 'أَلَمْ يَأْتِكُمْ نَبَؤُا۟ ٱلَّذِينَ كَفَرُوا۟ مِن قَبْلُ فَذَاقُوا۟ وَبَالَ أَمْرِهِمْ وَلَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '5',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5205',
		number: '5205',
		text: 'ذَٰلِكَ بِأَنَّهُۥ كَانَت تَّأْتِيهِمْ رُسُلُهُم بِٱلْبَيِّنَٰتِ فَقَالُوٓا۟ أَبَشَرٌۭ يَهْدُونَنَا فَكَفَرُوا۟ وَتَوَلَّوا۟ ۚ وَّٱسْتَغْنَى ٱللَّهُ ۚ وَٱللَّهُ غَنِىٌّ حَمِيدٌۭ',
		number_in_surah: '6',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:16',
		updated_at: '2018-06-07 08:07:16',
	},
	{
		id: '5206',
		number: '5206',
		text: 'زَعَمَ ٱلَّذِينَ كَفَرُوٓا۟ أَن لَّن يُبْعَثُوا۟ ۚ قُلْ بَلَىٰ وَرَبِّى لَتُبْعَثُنَّ ثُمَّ لَتُنَبَّؤُنَّ بِمَا عَمِلْتُمْ ۚ وَذَٰلِكَ عَلَى ٱللَّهِ يَسِيرٌۭ',
		number_in_surah: '7',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5207',
		number: '5207',
		text: 'فَـَٔامِنُوا۟ بِٱللَّهِ وَرَسُولِهِۦ وَٱلنُّورِ ٱلَّذِىٓ أَنزَلْنَا ۚ وَٱللَّهُ بِمَا تَعْمَلُونَ خَبِيرٌۭ',
		number_in_surah: '8',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5208',
		number: '5208',
		text: 'يَوْمَ يَجْمَعُكُمْ لِيَوْمِ ٱلْجَمْعِ ۖ ذَٰلِكَ يَوْمُ ٱلتَّغَابُنِ ۗ وَمَن يُؤْمِنۢ بِٱللَّهِ وَيَعْمَلْ صَٰلِحًۭا يُكَفِّرْ عَنْهُ سَيِّـَٔاتِهِۦ وَيُدْخِلْهُ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدًۭا ۚ ذَٰلِكَ ٱلْفَوْزُ ٱلْعَظِيمُ',
		number_in_surah: '9',
		page: '556',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5209',
		number: '5209',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ وَكَذَّبُوا۟ بِـَٔايَٰتِنَآ أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلنَّارِ خَٰلِدِينَ فِيهَا ۖ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '10',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5210',
		number: '5210',
		text: 'مَآ أَصَابَ مِن مُّصِيبَةٍ إِلَّا بِإِذْنِ ٱللَّهِ ۗ وَمَن يُؤْمِنۢ بِٱللَّهِ يَهْدِ قَلْبَهُۥ ۚ وَٱللَّهُ بِكُلِّ شَىْءٍ عَلِيمٌۭ',
		number_in_surah: '11',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5211',
		number: '5211',
		text: 'وَأَطِيعُوا۟ ٱللَّهَ وَأَطِيعُوا۟ ٱلرَّسُولَ ۚ فَإِن تَوَلَّيْتُمْ فَإِنَّمَا عَلَىٰ رَسُولِنَا ٱلْبَلَٰغُ ٱلْمُبِينُ',
		number_in_surah: '12',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5212',
		number: '5212',
		text: 'ٱللَّهُ لَآ إِلَٰهَ إِلَّا هُوَ ۚ وَعَلَى ٱللَّهِ فَلْيَتَوَكَّلِ ٱلْمُؤْمِنُونَ',
		number_in_surah: '13',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5213',
		number: '5213',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوٓا۟ إِنَّ مِنْ أَزْوَٰجِكُمْ وَأَوْلَٰدِكُمْ عَدُوًّۭا لَّكُمْ فَٱحْذَرُوهُمْ ۚ وَإِن تَعْفُوا۟ وَتَصْفَحُوا۟ وَتَغْفِرُوا۟ فَإِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌ',
		number_in_surah: '14',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5214',
		number: '5214',
		text: 'إِنَّمَآ أَمْوَٰلُكُمْ وَأَوْلَٰدُكُمْ فِتْنَةٌۭ ۚ وَٱللَّهُ عِندَهُۥٓ أَجْرٌ عَظِيمٌۭ',
		number_in_surah: '15',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5215',
		number: '5215',
		text: 'فَٱتَّقُوا۟ ٱللَّهَ مَا ٱسْتَطَعْتُمْ وَٱسْمَعُوا۟ وَأَطِيعُوا۟ وَأَنفِقُوا۟ خَيْرًۭا لِّأَنفُسِكُمْ ۗ وَمَن يُوقَ شُحَّ نَفْسِهِۦ فَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ',
		number_in_surah: '16',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5216',
		number: '5216',
		text: 'إِن تُقْرِضُوا۟ ٱللَّهَ قَرْضًا حَسَنًۭا يُضَٰعِفْهُ لَكُمْ وَيَغْفِرْ لَكُمْ ۚ وَٱللَّهُ شَكُورٌ حَلِيمٌ',
		number_in_surah: '17',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5217',
		number: '5217',
		text: 'عَٰلِمُ ٱلْغَيْبِ وَٱلشَّهَٰدَةِ ٱلْعَزِيزُ ٱلْحَكِيمُ',
		number_in_surah: '18',
		page: '557',
		surah_id: '64',
		hizb_id: '222',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5218',
		number: '5218',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلنَّبِىُّ إِذَا طَلَّقْتُمُ ٱلنِّسَآءَ فَطَلِّقُوهُنَّ لِعِدَّتِهِنَّ وَأَحْصُوا۟ ٱلْعِدَّةَ ۖ وَٱتَّقُوا۟ ٱللَّهَ رَبَّكُمْ ۖ لَا تُخْرِجُوهُنَّ مِنۢ بُيُوتِهِنَّ وَلَا يَخْرُجْنَ إِلَّآ أَن يَأْتِينَ بِفَٰحِشَةٍۢ مُّبَيِّنَةٍۢ ۚ وَتِلْكَ حُدُودُ ٱللَّهِ ۚ وَمَن يَتَعَدَّ حُدُودَ ٱللَّهِ فَقَدْ ظَلَمَ نَفْسَهُۥ ۚ لَا تَدْرِى لَعَلَّ ٱللَّهَ يُحْدِثُ بَعْدَ ذَٰلِكَ أَمْرًۭا',
		number_in_surah: '1',
		page: '558',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5219',
		number: '5219',
		text: 'فَإِذَا بَلَغْنَ أَجَلَهُنَّ فَأَمْسِكُوهُنَّ بِمَعْرُوفٍ أَوْ فَارِقُوهُنَّ بِمَعْرُوفٍۢ وَأَشْهِدُوا۟ ذَوَىْ عَدْلٍۢ مِّنكُمْ وَأَقِيمُوا۟ ٱلشَّهَٰدَةَ لِلَّهِ ۚ ذَٰلِكُمْ يُوعَظُ بِهِۦ مَن كَانَ يُؤْمِنُ بِٱللَّهِ وَٱلْيَوْمِ ٱلْءَاخِرِ ۚ وَمَن يَتَّقِ ٱللَّهَ يَجْعَل لَّهُۥ مَخْرَجًۭا',
		number_in_surah: '2',
		page: '558',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5220',
		number: '5220',
		text: 'وَيَرْزُقْهُ مِنْ حَيْثُ لَا يَحْتَسِبُ ۚ وَمَن يَتَوَكَّلْ عَلَى ٱللَّهِ فَهُوَ حَسْبُهُۥٓ ۚ إِنَّ ٱللَّهَ بَٰلِغُ أَمْرِهِۦ ۚ قَدْ جَعَلَ ٱللَّهُ لِكُلِّ شَىْءٍۢ قَدْرًۭا',
		number_in_surah: '3',
		page: '558',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5221',
		number: '5221',
		text: 'وَٱلَّٰٓـِٔى يَئِسْنَ مِنَ ٱلْمَحِيضِ مِن نِّسَآئِكُمْ إِنِ ٱرْتَبْتُمْ فَعِدَّتُهُنَّ ثَلَٰثَةُ أَشْهُرٍۢ وَٱلَّٰٓـِٔى لَمْ يَحِضْنَ ۚ وَأُو۟لَٰتُ ٱلْأَحْمَالِ أَجَلُهُنَّ أَن يَضَعْنَ حَمْلَهُنَّ ۚ وَمَن يَتَّقِ ٱللَّهَ يَجْعَل لَّهُۥ مِنْ أَمْرِهِۦ يُسْرًۭا',
		number_in_surah: '4',
		page: '558',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5222',
		number: '5222',
		text: 'ذَٰلِكَ أَمْرُ ٱللَّهِ أَنزَلَهُۥٓ إِلَيْكُمْ ۚ وَمَن يَتَّقِ ٱللَّهَ يُكَفِّرْ عَنْهُ سَيِّـَٔاتِهِۦ وَيُعْظِمْ لَهُۥٓ أَجْرًا',
		number_in_surah: '5',
		page: '558',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5223',
		number: '5223',
		text: 'أَسْكِنُوهُنَّ مِنْ حَيْثُ سَكَنتُم مِّن وُجْدِكُمْ وَلَا تُضَآرُّوهُنَّ لِتُضَيِّقُوا۟ عَلَيْهِنَّ ۚ وَإِن كُنَّ أُو۟لَٰتِ حَمْلٍۢ فَأَنفِقُوا۟ عَلَيْهِنَّ حَتَّىٰ يَضَعْنَ حَمْلَهُنَّ ۚ فَإِنْ أَرْضَعْنَ لَكُمْ فَـَٔاتُوهُنَّ أُجُورَهُنَّ ۖ وَأْتَمِرُوا۟ بَيْنَكُم بِمَعْرُوفٍۢ ۖ وَإِن تَعَاسَرْتُمْ فَسَتُرْضِعُ لَهُۥٓ أُخْرَىٰ',
		number_in_surah: '6',
		page: '559',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5224',
		number: '5224',
		text: 'لِيُنفِقْ ذُو سَعَةٍۢ مِّن سَعَتِهِۦ ۖ وَمَن قُدِرَ عَلَيْهِ رِزْقُهُۥ فَلْيُنفِقْ مِمَّآ ءَاتَىٰهُ ٱللَّهُ ۚ لَا يُكَلِّفُ ٱللَّهُ نَفْسًا إِلَّا مَآ ءَاتَىٰهَا ۚ سَيَجْعَلُ ٱللَّهُ بَعْدَ عُسْرٍۢ يُسْرًۭا',
		number_in_surah: '7',
		page: '559',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5225',
		number: '5225',
		text: 'وَكَأَيِّن مِّن قَرْيَةٍ عَتَتْ عَنْ أَمْرِ رَبِّهَا وَرُسُلِهِۦ فَحَاسَبْنَٰهَا حِسَابًۭا شَدِيدًۭا وَعَذَّبْنَٰهَا عَذَابًۭا نُّكْرًۭا',
		number_in_surah: '8',
		page: '559',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5226',
		number: '5226',
		text: 'فَذَاقَتْ وَبَالَ أَمْرِهَا وَكَانَ عَٰقِبَةُ أَمْرِهَا خُسْرًا',
		number_in_surah: '9',
		page: '559',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5227',
		number: '5227',
		text: 'أَعَدَّ ٱللَّهُ لَهُمْ عَذَابًۭا شَدِيدًۭا ۖ فَٱتَّقُوا۟ ٱللَّهَ يَٰٓأُو۟لِى ٱلْأَلْبَٰبِ ٱلَّذِينَ ءَامَنُوا۟ ۚ قَدْ أَنزَلَ ٱللَّهُ إِلَيْكُمْ ذِكْرًۭا',
		number_in_surah: '10',
		page: '559',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5228',
		number: '5228',
		text: 'رَّسُولًۭا يَتْلُوا۟ عَلَيْكُمْ ءَايَٰتِ ٱللَّهِ مُبَيِّنَٰتٍۢ لِّيُخْرِجَ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ مِنَ ٱلظُّلُمَٰتِ إِلَى ٱلنُّورِ ۚ وَمَن يُؤْمِنۢ بِٱللَّهِ وَيَعْمَلْ صَٰلِحًۭا يُدْخِلْهُ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدًۭا ۖ قَدْ أَحْسَنَ ٱللَّهُ لَهُۥ رِزْقًا',
		number_in_surah: '11',
		page: '559',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5229',
		number: '5229',
		text: 'ٱللَّهُ ٱلَّذِى خَلَقَ سَبْعَ سَمَٰوَٰتٍۢ وَمِنَ ٱلْأَرْضِ مِثْلَهُنَّ يَتَنَزَّلُ ٱلْأَمْرُ بَيْنَهُنَّ لِتَعْلَمُوٓا۟ أَنَّ ٱللَّهَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ وَأَنَّ ٱللَّهَ قَدْ أَحَاطَ بِكُلِّ شَىْءٍ عِلْمًۢا',
		number_in_surah: '12',
		page: '559',
		surah_id: '65',
		hizb_id: '223',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5230',
		number: '5230',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلنَّبِىُّ لِمَ تُحَرِّمُ مَآ أَحَلَّ ٱللَّهُ لَكَ ۖ تَبْتَغِى مَرْضَاتَ أَزْوَٰجِكَ ۚ وَٱللَّهُ غَفُورٌۭ رَّحِيمٌۭ',
		number_in_surah: '1',
		page: '560',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5231',
		number: '5231',
		text: 'قَدْ فَرَضَ ٱللَّهُ لَكُمْ تَحِلَّةَ أَيْمَٰنِكُمْ ۚ وَٱللَّهُ مَوْلَىٰكُمْ ۖ وَهُوَ ٱلْعَلِيمُ ٱلْحَكِيمُ',
		number_in_surah: '2',
		page: '560',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5232',
		number: '5232',
		text: 'وَإِذْ أَسَرَّ ٱلنَّبِىُّ إِلَىٰ بَعْضِ أَزْوَٰجِهِۦ حَدِيثًۭا فَلَمَّا نَبَّأَتْ بِهِۦ وَأَظْهَرَهُ ٱللَّهُ عَلَيْهِ عَرَّفَ بَعْضَهُۥ وَأَعْرَضَ عَنۢ بَعْضٍۢ ۖ فَلَمَّا نَبَّأَهَا بِهِۦ قَالَتْ مَنْ أَنۢبَأَكَ هَٰذَا ۖ قَالَ نَبَّأَنِىَ ٱلْعَلِيمُ ٱلْخَبِيرُ',
		number_in_surah: '3',
		page: '560',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5233',
		number: '5233',
		text: 'إِن تَتُوبَآ إِلَى ٱللَّهِ فَقَدْ صَغَتْ قُلُوبُكُمَا ۖ وَإِن تَظَٰهَرَا عَلَيْهِ فَإِنَّ ٱللَّهَ هُوَ مَوْلَىٰهُ وَجِبْرِيلُ وَصَٰلِحُ ٱلْمُؤْمِنِينَ ۖ وَٱلْمَلَٰٓئِكَةُ بَعْدَ ذَٰلِكَ ظَهِيرٌ',
		number_in_surah: '4',
		page: '560',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5234',
		number: '5234',
		text: 'عَسَىٰ رَبُّهُۥٓ إِن طَلَّقَكُنَّ أَن يُبْدِلَهُۥٓ أَزْوَٰجًا خَيْرًۭا مِّنكُنَّ مُسْلِمَٰتٍۢ مُّؤْمِنَٰتٍۢ قَٰنِتَٰتٍۢ تَٰٓئِبَٰتٍ عَٰبِدَٰتٍۢ سَٰٓئِحَٰتٍۢ ثَيِّبَٰتٍۢ وَأَبْكَارًۭا',
		number_in_surah: '5',
		page: '560',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5235',
		number: '5235',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ قُوٓا۟ أَنفُسَكُمْ وَأَهْلِيكُمْ نَارًۭا وَقُودُهَا ٱلنَّاسُ وَٱلْحِجَارَةُ عَلَيْهَا مَلَٰٓئِكَةٌ غِلَاظٌۭ شِدَادٌۭ لَّا يَعْصُونَ ٱللَّهَ مَآ أَمَرَهُمْ وَيَفْعَلُونَ مَا يُؤْمَرُونَ',
		number_in_surah: '6',
		page: '560',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5236',
		number: '5236',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ كَفَرُوا۟ لَا تَعْتَذِرُوا۟ ٱلْيَوْمَ ۖ إِنَّمَا تُجْزَوْنَ مَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '7',
		page: '560',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5237',
		number: '5237',
		text: 'يَٰٓأَيُّهَا ٱلَّذِينَ ءَامَنُوا۟ تُوبُوٓا۟ إِلَى ٱللَّهِ تَوْبَةًۭ نَّصُوحًا عَسَىٰ رَبُّكُمْ أَن يُكَفِّرَ عَنكُمْ سَيِّـَٔاتِكُمْ وَيُدْخِلَكُمْ جَنَّٰتٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ يَوْمَ لَا يُخْزِى ٱللَّهُ ٱلنَّبِىَّ وَٱلَّذِينَ ءَامَنُوا۟ مَعَهُۥ ۖ نُورُهُمْ يَسْعَىٰ بَيْنَ أَيْدِيهِمْ وَبِأَيْمَٰنِهِمْ يَقُولُونَ رَبَّنَآ أَتْمِمْ لَنَا نُورَنَا وَٱغْفِرْ لَنَآ ۖ إِنَّكَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌۭ',
		number_in_surah: '8',
		page: '561',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5238',
		number: '5238',
		text: 'يَٰٓأَيُّهَا ٱلنَّبِىُّ جَٰهِدِ ٱلْكُفَّارَ وَٱلْمُنَٰفِقِينَ وَٱغْلُظْ عَلَيْهِمْ ۚ وَمَأْوَىٰهُمْ جَهَنَّمُ ۖ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '9',
		page: '561',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5239',
		number: '5239',
		text: 'ضَرَبَ ٱللَّهُ مَثَلًۭا لِّلَّذِينَ كَفَرُوا۟ ٱمْرَأَتَ نُوحٍۢ وَٱمْرَأَتَ لُوطٍۢ ۖ كَانَتَا تَحْتَ عَبْدَيْنِ مِنْ عِبَادِنَا صَٰلِحَيْنِ فَخَانَتَاهُمَا فَلَمْ يُغْنِيَا عَنْهُمَا مِنَ ٱللَّهِ شَيْـًۭٔا وَقِيلَ ٱدْخُلَا ٱلنَّارَ مَعَ ٱلدَّٰخِلِينَ',
		number_in_surah: '10',
		page: '561',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5240',
		number: '5240',
		text: 'وَضَرَبَ ٱللَّهُ مَثَلًۭا لِّلَّذِينَ ءَامَنُوا۟ ٱمْرَأَتَ فِرْعَوْنَ إِذْ قَالَتْ رَبِّ ٱبْنِ لِى عِندَكَ بَيْتًۭا فِى ٱلْجَنَّةِ وَنَجِّنِى مِن فِرْعَوْنَ وَعَمَلِهِۦ وَنَجِّنِى مِنَ ٱلْقَوْمِ ٱلظَّٰلِمِينَ',
		number_in_surah: '11',
		page: '561',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5241',
		number: '5241',
		text: 'وَمَرْيَمَ ٱبْنَتَ عِمْرَٰنَ ٱلَّتِىٓ أَحْصَنَتْ فَرْجَهَا فَنَفَخْنَا فِيهِ مِن رُّوحِنَا وَصَدَّقَتْ بِكَلِمَٰتِ رَبِّهَا وَكُتُبِهِۦ وَكَانَتْ مِنَ ٱلْقَٰنِتِينَ',
		number_in_surah: '12',
		page: '561',
		surah_id: '66',
		hizb_id: '224',
		juz_id: '28',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5242',
		number: '5242',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ تَبَٰرَكَ ٱلَّذِى بِيَدِهِ ٱلْمُلْكُ وَهُوَ عَلَىٰ كُلِّ شَىْءٍۢ قَدِيرٌ',
		number_in_surah: '1',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5243',
		number: '5243',
		text: 'ٱلَّذِى خَلَقَ ٱلْمَوْتَ وَٱلْحَيَوٰةَ لِيَبْلُوَكُمْ أَيُّكُمْ أَحْسَنُ عَمَلًۭا ۚ وَهُوَ ٱلْعَزِيزُ ٱلْغَفُورُ',
		number_in_surah: '2',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5244',
		number: '5244',
		text: 'ٱلَّذِى خَلَقَ سَبْعَ سَمَٰوَٰتٍۢ طِبَاقًۭا ۖ مَّا تَرَىٰ فِى خَلْقِ ٱلرَّحْمَٰنِ مِن تَفَٰوُتٍۢ ۖ فَٱرْجِعِ ٱلْبَصَرَ هَلْ تَرَىٰ مِن فُطُورٍۢ',
		number_in_surah: '3',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5245',
		number: '5245',
		text: 'ثُمَّ ٱرْجِعِ ٱلْبَصَرَ كَرَّتَيْنِ يَنقَلِبْ إِلَيْكَ ٱلْبَصَرُ خَاسِئًۭا وَهُوَ حَسِيرٌۭ',
		number_in_surah: '4',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5246',
		number: '5246',
		text: 'وَلَقَدْ زَيَّنَّا ٱلسَّمَآءَ ٱلدُّنْيَا بِمَصَٰبِيحَ وَجَعَلْنَٰهَا رُجُومًۭا لِّلشَّيَٰطِينِ ۖ وَأَعْتَدْنَا لَهُمْ عَذَابَ ٱلسَّعِيرِ',
		number_in_surah: '5',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5247',
		number: '5247',
		text: 'وَلِلَّذِينَ كَفَرُوا۟ بِرَبِّهِمْ عَذَابُ جَهَنَّمَ ۖ وَبِئْسَ ٱلْمَصِيرُ',
		number_in_surah: '6',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5248',
		number: '5248',
		text: 'إِذَآ أُلْقُوا۟ فِيهَا سَمِعُوا۟ لَهَا شَهِيقًۭا وَهِىَ تَفُورُ',
		number_in_surah: '7',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5249',
		number: '5249',
		text: 'تَكَادُ تَمَيَّزُ مِنَ ٱلْغَيْظِ ۖ كُلَّمَآ أُلْقِىَ فِيهَا فَوْجٌۭ سَأَلَهُمْ خَزَنَتُهَآ أَلَمْ يَأْتِكُمْ نَذِيرٌۭ',
		number_in_surah: '8',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5250',
		number: '5250',
		text: 'قَالُوا۟ بَلَىٰ قَدْ جَآءَنَا نَذِيرٌۭ فَكَذَّبْنَا وَقُلْنَا مَا نَزَّلَ ٱللَّهُ مِن شَىْءٍ إِنْ أَنتُمْ إِلَّا فِى ضَلَٰلٍۢ كَبِيرٍۢ',
		number_in_surah: '9',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5251',
		number: '5251',
		text: 'وَقَالُوا۟ لَوْ كُنَّا نَسْمَعُ أَوْ نَعْقِلُ مَا كُنَّا فِىٓ أَصْحَٰبِ ٱلسَّعِيرِ',
		number_in_surah: '10',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5252',
		number: '5252',
		text: 'فَٱعْتَرَفُوا۟ بِذَنۢبِهِمْ فَسُحْقًۭا لِّأَصْحَٰبِ ٱلسَّعِيرِ',
		number_in_surah: '11',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5253',
		number: '5253',
		text: 'إِنَّ ٱلَّذِينَ يَخْشَوْنَ رَبَّهُم بِٱلْغَيْبِ لَهُم مَّغْفِرَةٌۭ وَأَجْرٌۭ كَبِيرٌۭ',
		number_in_surah: '12',
		page: '562',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5254',
		number: '5254',
		text: 'وَأَسِرُّوا۟ قَوْلَكُمْ أَوِ ٱجْهَرُوا۟ بِهِۦٓ ۖ إِنَّهُۥ عَلِيمٌۢ بِذَاتِ ٱلصُّدُورِ',
		number_in_surah: '13',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5255',
		number: '5255',
		text: 'أَلَا يَعْلَمُ مَنْ خَلَقَ وَهُوَ ٱللَّطِيفُ ٱلْخَبِيرُ',
		number_in_surah: '14',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5256',
		number: '5256',
		text: 'هُوَ ٱلَّذِى جَعَلَ لَكُمُ ٱلْأَرْضَ ذَلُولًۭا فَٱمْشُوا۟ فِى مَنَاكِبِهَا وَكُلُوا۟ مِن رِّزْقِهِۦ ۖ وَإِلَيْهِ ٱلنُّشُورُ',
		number_in_surah: '15',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5257',
		number: '5257',
		text: 'ءَأَمِنتُم مَّن فِى ٱلسَّمَآءِ أَن يَخْسِفَ بِكُمُ ٱلْأَرْضَ فَإِذَا هِىَ تَمُورُ',
		number_in_surah: '16',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5258',
		number: '5258',
		text: 'أَمْ أَمِنتُم مَّن فِى ٱلسَّمَآءِ أَن يُرْسِلَ عَلَيْكُمْ حَاصِبًۭا ۖ فَسَتَعْلَمُونَ كَيْفَ نَذِيرِ',
		number_in_surah: '17',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5259',
		number: '5259',
		text: 'وَلَقَدْ كَذَّبَ ٱلَّذِينَ مِن قَبْلِهِمْ فَكَيْفَ كَانَ نَكِيرِ',
		number_in_surah: '18',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5260',
		number: '5260',
		text: 'أَوَلَمْ يَرَوْا۟ إِلَى ٱلطَّيْرِ فَوْقَهُمْ صَٰٓفَّٰتٍۢ وَيَقْبِضْنَ ۚ مَا يُمْسِكُهُنَّ إِلَّا ٱلرَّحْمَٰنُ ۚ إِنَّهُۥ بِكُلِّ شَىْءٍۭ بَصِيرٌ',
		number_in_surah: '19',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5261',
		number: '5261',
		text: 'أَمَّنْ هَٰذَا ٱلَّذِى هُوَ جُندٌۭ لَّكُمْ يَنصُرُكُم مِّن دُونِ ٱلرَّحْمَٰنِ ۚ إِنِ ٱلْكَٰفِرُونَ إِلَّا فِى غُرُورٍ',
		number_in_surah: '20',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5262',
		number: '5262',
		text: 'أَمَّنْ هَٰذَا ٱلَّذِى يَرْزُقُكُمْ إِنْ أَمْسَكَ رِزْقَهُۥ ۚ بَل لَّجُّوا۟ فِى عُتُوٍّۢ وَنُفُورٍ',
		number_in_surah: '21',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5263',
		number: '5263',
		text: 'أَفَمَن يَمْشِى مُكِبًّا عَلَىٰ وَجْهِهِۦٓ أَهْدَىٰٓ أَمَّن يَمْشِى سَوِيًّا عَلَىٰ صِرَٰطٍۢ مُّسْتَقِيمٍۢ',
		number_in_surah: '22',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5264',
		number: '5264',
		text: 'قُلْ هُوَ ٱلَّذِىٓ أَنشَأَكُمْ وَجَعَلَ لَكُمُ ٱلسَّمْعَ وَٱلْأَبْصَٰرَ وَٱلْأَفْـِٔدَةَ ۖ قَلِيلًۭا مَّا تَشْكُرُونَ',
		number_in_surah: '23',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5265',
		number: '5265',
		text: 'قُلْ هُوَ ٱلَّذِى ذَرَأَكُمْ فِى ٱلْأَرْضِ وَإِلَيْهِ تُحْشَرُونَ',
		number_in_surah: '24',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5266',
		number: '5266',
		text: 'وَيَقُولُونَ مَتَىٰ هَٰذَا ٱلْوَعْدُ إِن كُنتُمْ صَٰدِقِينَ',
		number_in_surah: '25',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5267',
		number: '5267',
		text: 'قُلْ إِنَّمَا ٱلْعِلْمُ عِندَ ٱللَّهِ وَإِنَّمَآ أَنَا۠ نَذِيرٌۭ مُّبِينٌۭ',
		number_in_surah: '26',
		page: '563',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5268',
		number: '5268',
		text: 'فَلَمَّا رَأَوْهُ زُلْفَةًۭ سِيٓـَٔتْ وُجُوهُ ٱلَّذِينَ كَفَرُوا۟ وَقِيلَ هَٰذَا ٱلَّذِى كُنتُم بِهِۦ تَدَّعُونَ',
		number_in_surah: '27',
		page: '564',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5269',
		number: '5269',
		text: 'قُلْ أَرَءَيْتُمْ إِنْ أَهْلَكَنِىَ ٱللَّهُ وَمَن مَّعِىَ أَوْ رَحِمَنَا فَمَن يُجِيرُ ٱلْكَٰفِرِينَ مِنْ عَذَابٍ أَلِيمٍۢ',
		number_in_surah: '28',
		page: '564',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5270',
		number: '5270',
		text: 'قُلْ هُوَ ٱلرَّحْمَٰنُ ءَامَنَّا بِهِۦ وَعَلَيْهِ تَوَكَّلْنَا ۖ فَسَتَعْلَمُونَ مَنْ هُوَ فِى ضَلَٰلٍۢ مُّبِينٍۢ',
		number_in_surah: '29',
		page: '564',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5271',
		number: '5271',
		text: 'قُلْ أَرَءَيْتُمْ إِنْ أَصْبَحَ مَآؤُكُمْ غَوْرًۭا فَمَن يَأْتِيكُم بِمَآءٍۢ مَّعِينٍۭ',
		number_in_surah: '30',
		page: '564',
		surah_id: '67',
		hizb_id: '225',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5272',
		number: '5272',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ نٓ ۚ وَٱلْقَلَمِ وَمَا يَسْطُرُونَ',
		number_in_surah: '1',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5273',
		number: '5273',
		text: 'مَآ أَنتَ بِنِعْمَةِ رَبِّكَ بِمَجْنُونٍۢ',
		number_in_surah: '2',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5274',
		number: '5274',
		text: 'وَإِنَّ لَكَ لَأَجْرًا غَيْرَ مَمْنُونٍۢ',
		number_in_surah: '3',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5275',
		number: '5275',
		text: 'وَإِنَّكَ لَعَلَىٰ خُلُقٍ عَظِيمٍۢ',
		number_in_surah: '4',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5276',
		number: '5276',
		text: 'فَسَتُبْصِرُ وَيُبْصِرُونَ',
		number_in_surah: '5',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5277',
		number: '5277',
		text: 'بِأَييِّكُمُ ٱلْمَفْتُونُ',
		number_in_surah: '6',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5278',
		number: '5278',
		text: 'إِنَّ رَبَّكَ هُوَ أَعْلَمُ بِمَن ضَلَّ عَن سَبِيلِهِۦ وَهُوَ أَعْلَمُ بِٱلْمُهْتَدِينَ',
		number_in_surah: '7',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5279',
		number: '5279',
		text: 'فَلَا تُطِعِ ٱلْمُكَذِّبِينَ',
		number_in_surah: '8',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5280',
		number: '5280',
		text: 'وَدُّوا۟ لَوْ تُدْهِنُ فَيُدْهِنُونَ',
		number_in_surah: '9',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5281',
		number: '5281',
		text: 'وَلَا تُطِعْ كُلَّ حَلَّافٍۢ مَّهِينٍ',
		number_in_surah: '10',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5282',
		number: '5282',
		text: 'هَمَّازٍۢ مَّشَّآءٍۭ بِنَمِيمٍۢ',
		number_in_surah: '11',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5283',
		number: '5283',
		text: 'مَّنَّاعٍۢ لِّلْخَيْرِ مُعْتَدٍ أَثِيمٍ',
		number_in_surah: '12',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5284',
		number: '5284',
		text: 'عُتُلٍّۭ بَعْدَ ذَٰلِكَ زَنِيمٍ',
		number_in_surah: '13',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5285',
		number: '5285',
		text: 'أَن كَانَ ذَا مَالٍۢ وَبَنِينَ',
		number_in_surah: '14',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5286',
		number: '5286',
		text: 'إِذَا تُتْلَىٰ عَلَيْهِ ءَايَٰتُنَا قَالَ أَسَٰطِيرُ ٱلْأَوَّلِينَ',
		number_in_surah: '15',
		page: '564',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5287',
		number: '5287',
		text: 'سَنَسِمُهُۥ عَلَى ٱلْخُرْطُومِ',
		number_in_surah: '16',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5288',
		number: '5288',
		text: 'إِنَّا بَلَوْنَٰهُمْ كَمَا بَلَوْنَآ أَصْحَٰبَ ٱلْجَنَّةِ إِذْ أَقْسَمُوا۟ لَيَصْرِمُنَّهَا مُصْبِحِينَ',
		number_in_surah: '17',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5289',
		number: '5289',
		text: 'وَلَا يَسْتَثْنُونَ',
		number_in_surah: '18',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5290',
		number: '5290',
		text: 'فَطَافَ عَلَيْهَا طَآئِفٌۭ مِّن رَّبِّكَ وَهُمْ نَآئِمُونَ',
		number_in_surah: '19',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5291',
		number: '5291',
		text: 'فَأَصْبَحَتْ كَٱلصَّرِيمِ',
		number_in_surah: '20',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5292',
		number: '5292',
		text: 'فَتَنَادَوْا۟ مُصْبِحِينَ',
		number_in_surah: '21',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5293',
		number: '5293',
		text: 'أَنِ ٱغْدُوا۟ عَلَىٰ حَرْثِكُمْ إِن كُنتُمْ صَٰرِمِينَ',
		number_in_surah: '22',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5294',
		number: '5294',
		text: 'فَٱنطَلَقُوا۟ وَهُمْ يَتَخَٰفَتُونَ',
		number_in_surah: '23',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5295',
		number: '5295',
		text: 'أَن لَّا يَدْخُلَنَّهَا ٱلْيَوْمَ عَلَيْكُم مِّسْكِينٌۭ',
		number_in_surah: '24',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5296',
		number: '5296',
		text: 'وَغَدَوْا۟ عَلَىٰ حَرْدٍۢ قَٰدِرِينَ',
		number_in_surah: '25',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5297',
		number: '5297',
		text: 'فَلَمَّا رَأَوْهَا قَالُوٓا۟ إِنَّا لَضَآلُّونَ',
		number_in_surah: '26',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5298',
		number: '5298',
		text: 'بَلْ نَحْنُ مَحْرُومُونَ',
		number_in_surah: '27',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5299',
		number: '5299',
		text: 'قَالَ أَوْسَطُهُمْ أَلَمْ أَقُل لَّكُمْ لَوْلَا تُسَبِّحُونَ',
		number_in_surah: '28',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5300',
		number: '5300',
		text: 'قَالُوا۟ سُبْحَٰنَ رَبِّنَآ إِنَّا كُنَّا ظَٰلِمِينَ',
		number_in_surah: '29',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5301',
		number: '5301',
		text: 'فَأَقْبَلَ بَعْضُهُمْ عَلَىٰ بَعْضٍۢ يَتَلَٰوَمُونَ',
		number_in_surah: '30',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5302',
		number: '5302',
		text: 'قَالُوا۟ يَٰوَيْلَنَآ إِنَّا كُنَّا طَٰغِينَ',
		number_in_surah: '31',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5303',
		number: '5303',
		text: 'عَسَىٰ رَبُّنَآ أَن يُبْدِلَنَا خَيْرًۭا مِّنْهَآ إِنَّآ إِلَىٰ رَبِّنَا رَٰغِبُونَ',
		number_in_surah: '32',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5304',
		number: '5304',
		text: 'كَذَٰلِكَ ٱلْعَذَابُ ۖ وَلَعَذَابُ ٱلْءَاخِرَةِ أَكْبَرُ ۚ لَوْ كَانُوا۟ يَعْلَمُونَ',
		number_in_surah: '33',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5305',
		number: '5305',
		text: 'إِنَّ لِلْمُتَّقِينَ عِندَ رَبِّهِمْ جَنَّٰتِ ٱلنَّعِيمِ',
		number_in_surah: '34',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5306',
		number: '5306',
		text: 'أَفَنَجْعَلُ ٱلْمُسْلِمِينَ كَٱلْمُجْرِمِينَ',
		number_in_surah: '35',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5307',
		number: '5307',
		text: 'مَا لَكُمْ كَيْفَ تَحْكُمُونَ',
		number_in_surah: '36',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5308',
		number: '5308',
		text: 'أَمْ لَكُمْ كِتَٰبٌۭ فِيهِ تَدْرُسُونَ',
		number_in_surah: '37',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5309',
		number: '5309',
		text: 'إِنَّ لَكُمْ فِيهِ لَمَا تَخَيَّرُونَ',
		number_in_surah: '38',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5310',
		number: '5310',
		text: 'أَمْ لَكُمْ أَيْمَٰنٌ عَلَيْنَا بَٰلِغَةٌ إِلَىٰ يَوْمِ ٱلْقِيَٰمَةِ ۙ إِنَّ لَكُمْ لَمَا تَحْكُمُونَ',
		number_in_surah: '39',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5311',
		number: '5311',
		text: 'سَلْهُمْ أَيُّهُم بِذَٰلِكَ زَعِيمٌ',
		number_in_surah: '40',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5312',
		number: '5312',
		text: 'أَمْ لَهُمْ شُرَكَآءُ فَلْيَأْتُوا۟ بِشُرَكَآئِهِمْ إِن كَانُوا۟ صَٰدِقِينَ',
		number_in_surah: '41',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5313',
		number: '5313',
		text: 'يَوْمَ يُكْشَفُ عَن سَاقٍۢ وَيُدْعَوْنَ إِلَى ٱلسُّجُودِ فَلَا يَسْتَطِيعُونَ',
		number_in_surah: '42',
		page: '565',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5314',
		number: '5314',
		text: 'خَٰشِعَةً أَبْصَٰرُهُمْ تَرْهَقُهُمْ ذِلَّةٌۭ ۖ وَقَدْ كَانُوا۟ يُدْعَوْنَ إِلَى ٱلسُّجُودِ وَهُمْ سَٰلِمُونَ',
		number_in_surah: '43',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5315',
		number: '5315',
		text: 'فَذَرْنِى وَمَن يُكَذِّبُ بِهَٰذَا ٱلْحَدِيثِ ۖ سَنَسْتَدْرِجُهُم مِّنْ حَيْثُ لَا يَعْلَمُونَ',
		number_in_surah: '44',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5316',
		number: '5316',
		text: 'وَأُمْلِى لَهُمْ ۚ إِنَّ كَيْدِى مَتِينٌ',
		number_in_surah: '45',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5317',
		number: '5317',
		text: 'أَمْ تَسْـَٔلُهُمْ أَجْرًۭا فَهُم مِّن مَّغْرَمٍۢ مُّثْقَلُونَ',
		number_in_surah: '46',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5318',
		number: '5318',
		text: 'أَمْ عِندَهُمُ ٱلْغَيْبُ فَهُمْ يَكْتُبُونَ',
		number_in_surah: '47',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5319',
		number: '5319',
		text: 'فَٱصْبِرْ لِحُكْمِ رَبِّكَ وَلَا تَكُن كَصَاحِبِ ٱلْحُوتِ إِذْ نَادَىٰ وَهُوَ مَكْظُومٌۭ',
		number_in_surah: '48',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5320',
		number: '5320',
		text: 'لَّوْلَآ أَن تَدَٰرَكَهُۥ نِعْمَةٌۭ مِّن رَّبِّهِۦ لَنُبِذَ بِٱلْعَرَآءِ وَهُوَ مَذْمُومٌۭ',
		number_in_surah: '49',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5321',
		number: '5321',
		text: 'فَٱجْتَبَٰهُ رَبُّهُۥ فَجَعَلَهُۥ مِنَ ٱلصَّٰلِحِينَ',
		number_in_surah: '50',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5322',
		number: '5322',
		text: 'وَإِن يَكَادُ ٱلَّذِينَ كَفَرُوا۟ لَيُزْلِقُونَكَ بِأَبْصَٰرِهِمْ لَمَّا سَمِعُوا۟ ٱلذِّكْرَ وَيَقُولُونَ إِنَّهُۥ لَمَجْنُونٌۭ',
		number_in_surah: '51',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5323',
		number: '5323',
		text: 'وَمَا هُوَ إِلَّا ذِكْرٌۭ لِّلْعَٰلَمِينَ',
		number_in_surah: '52',
		page: '566',
		surah_id: '68',
		hizb_id: '226',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5324',
		number: '5324',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱلْحَآقَّةُ',
		number_in_surah: '1',
		page: '566',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5325',
		number: '5325',
		text: 'مَا ٱلْحَآقَّةُ',
		number_in_surah: '2',
		page: '566',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5326',
		number: '5326',
		text: 'وَمَآ أَدْرَىٰكَ مَا ٱلْحَآقَّةُ',
		number_in_surah: '3',
		page: '566',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5327',
		number: '5327',
		text: 'كَذَّبَتْ ثَمُودُ وَعَادٌۢ بِٱلْقَارِعَةِ',
		number_in_surah: '4',
		page: '566',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5328',
		number: '5328',
		text: 'فَأَمَّا ثَمُودُ فَأُهْلِكُوا۟ بِٱلطَّاغِيَةِ',
		number_in_surah: '5',
		page: '566',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5329',
		number: '5329',
		text: 'وَأَمَّا عَادٌۭ فَأُهْلِكُوا۟ بِرِيحٍۢ صَرْصَرٍ عَاتِيَةٍۢ',
		number_in_surah: '6',
		page: '566',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5330',
		number: '5330',
		text: 'سَخَّرَهَا عَلَيْهِمْ سَبْعَ لَيَالٍۢ وَثَمَٰنِيَةَ أَيَّامٍ حُسُومًۭا فَتَرَى ٱلْقَوْمَ فِيهَا صَرْعَىٰ كَأَنَّهُمْ أَعْجَازُ نَخْلٍ خَاوِيَةٍۢ',
		number_in_surah: '7',
		page: '566',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5331',
		number: '5331',
		text: 'فَهَلْ تَرَىٰ لَهُم مِّنۢ بَاقِيَةٍۢ',
		number_in_surah: '8',
		page: '566',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5332',
		number: '5332',
		text: 'وَجَآءَ فِرْعَوْنُ وَمَن قَبْلَهُۥ وَٱلْمُؤْتَفِكَٰتُ بِٱلْخَاطِئَةِ',
		number_in_surah: '9',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5333',
		number: '5333',
		text: 'فَعَصَوْا۟ رَسُولَ رَبِّهِمْ فَأَخَذَهُمْ أَخْذَةًۭ رَّابِيَةً',
		number_in_surah: '10',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5334',
		number: '5334',
		text: 'إِنَّا لَمَّا طَغَا ٱلْمَآءُ حَمَلْنَٰكُمْ فِى ٱلْجَارِيَةِ',
		number_in_surah: '11',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5335',
		number: '5335',
		text: 'لِنَجْعَلَهَا لَكُمْ تَذْكِرَةًۭ وَتَعِيَهَآ أُذُنٌۭ وَٰعِيَةٌۭ',
		number_in_surah: '12',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5336',
		number: '5336',
		text: 'فَإِذَا نُفِخَ فِى ٱلصُّورِ نَفْخَةٌۭ وَٰحِدَةٌۭ',
		number_in_surah: '13',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5337',
		number: '5337',
		text: 'وَحُمِلَتِ ٱلْأَرْضُ وَٱلْجِبَالُ فَدُكَّتَا دَكَّةًۭ وَٰحِدَةًۭ',
		number_in_surah: '14',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5338',
		number: '5338',
		text: 'فَيَوْمَئِذٍۢ وَقَعَتِ ٱلْوَاقِعَةُ',
		number_in_surah: '15',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5339',
		number: '5339',
		text: 'وَٱنشَقَّتِ ٱلسَّمَآءُ فَهِىَ يَوْمَئِذٍۢ وَاهِيَةٌۭ',
		number_in_surah: '16',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5340',
		number: '5340',
		text: 'وَٱلْمَلَكُ عَلَىٰٓ أَرْجَآئِهَا ۚ وَيَحْمِلُ عَرْشَ رَبِّكَ فَوْقَهُمْ يَوْمَئِذٍۢ ثَمَٰنِيَةٌۭ',
		number_in_surah: '17',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5341',
		number: '5341',
		text: 'يَوْمَئِذٍۢ تُعْرَضُونَ لَا تَخْفَىٰ مِنكُمْ خَافِيَةٌۭ',
		number_in_surah: '18',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5342',
		number: '5342',
		text: 'فَأَمَّا مَنْ أُوتِىَ كِتَٰبَهُۥ بِيَمِينِهِۦ فَيَقُولُ هَآؤُمُ ٱقْرَءُوا۟ كِتَٰبِيَهْ',
		number_in_surah: '19',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5343',
		number: '5343',
		text: 'إِنِّى ظَنَنتُ أَنِّى مُلَٰقٍ حِسَابِيَهْ',
		number_in_surah: '20',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5344',
		number: '5344',
		text: 'فَهُوَ فِى عِيشَةٍۢ رَّاضِيَةٍۢ',
		number_in_surah: '21',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5345',
		number: '5345',
		text: 'فِى جَنَّةٍ عَالِيَةٍۢ',
		number_in_surah: '22',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5346',
		number: '5346',
		text: 'قُطُوفُهَا دَانِيَةٌۭ',
		number_in_surah: '23',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5347',
		number: '5347',
		text: 'كُلُوا۟ وَٱشْرَبُوا۟ هَنِيٓـًٔۢا بِمَآ أَسْلَفْتُمْ فِى ٱلْأَيَّامِ ٱلْخَالِيَةِ',
		number_in_surah: '24',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5348',
		number: '5348',
		text: 'وَأَمَّا مَنْ أُوتِىَ كِتَٰبَهُۥ بِشِمَالِهِۦ فَيَقُولُ يَٰلَيْتَنِى لَمْ أُوتَ كِتَٰبِيَهْ',
		number_in_surah: '25',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5349',
		number: '5349',
		text: 'وَلَمْ أَدْرِ مَا حِسَابِيَهْ',
		number_in_surah: '26',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5350',
		number: '5350',
		text: 'يَٰلَيْتَهَا كَانَتِ ٱلْقَاضِيَةَ',
		number_in_surah: '27',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5351',
		number: '5351',
		text: 'مَآ أَغْنَىٰ عَنِّى مَالِيَهْ ۜ',
		number_in_surah: '28',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5352',
		number: '5352',
		text: 'هَلَكَ عَنِّى سُلْطَٰنِيَهْ',
		number_in_surah: '29',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5353',
		number: '5353',
		text: 'خُذُوهُ فَغُلُّوهُ',
		number_in_surah: '30',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5354',
		number: '5354',
		text: 'ثُمَّ ٱلْجَحِيمَ صَلُّوهُ',
		number_in_surah: '31',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5355',
		number: '5355',
		text: 'ثُمَّ فِى سِلْسِلَةٍۢ ذَرْعُهَا سَبْعُونَ ذِرَاعًۭا فَٱسْلُكُوهُ',
		number_in_surah: '32',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:17',
		updated_at: '2018-06-07 08:07:17',
	},
	{
		id: '5356',
		number: '5356',
		text: 'إِنَّهُۥ كَانَ لَا يُؤْمِنُ بِٱللَّهِ ٱلْعَظِيمِ',
		number_in_surah: '33',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5357',
		number: '5357',
		text: 'وَلَا يَحُضُّ عَلَىٰ طَعَامِ ٱلْمِسْكِينِ',
		number_in_surah: '34',
		page: '567',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5358',
		number: '5358',
		text: 'فَلَيْسَ لَهُ ٱلْيَوْمَ هَٰهُنَا حَمِيمٌۭ',
		number_in_surah: '35',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5359',
		number: '5359',
		text: 'وَلَا طَعَامٌ إِلَّا مِنْ غِسْلِينٍۢ',
		number_in_surah: '36',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5360',
		number: '5360',
		text: 'لَّا يَأْكُلُهُۥٓ إِلَّا ٱلْخَٰطِـُٔونَ',
		number_in_surah: '37',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5361',
		number: '5361',
		text: 'فَلَآ أُقْسِمُ بِمَا تُبْصِرُونَ',
		number_in_surah: '38',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5362',
		number: '5362',
		text: 'وَمَا لَا تُبْصِرُونَ',
		number_in_surah: '39',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5363',
		number: '5363',
		text: 'إِنَّهُۥ لَقَوْلُ رَسُولٍۢ كَرِيمٍۢ',
		number_in_surah: '40',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5364',
		number: '5364',
		text: 'وَمَا هُوَ بِقَوْلِ شَاعِرٍۢ ۚ قَلِيلًۭا مَّا تُؤْمِنُونَ',
		number_in_surah: '41',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5365',
		number: '5365',
		text: 'وَلَا بِقَوْلِ كَاهِنٍۢ ۚ قَلِيلًۭا مَّا تَذَكَّرُونَ',
		number_in_surah: '42',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5366',
		number: '5366',
		text: 'تَنزِيلٌۭ مِّن رَّبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '43',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5367',
		number: '5367',
		text: 'وَلَوْ تَقَوَّلَ عَلَيْنَا بَعْضَ ٱلْأَقَاوِيلِ',
		number_in_surah: '44',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5368',
		number: '5368',
		text: 'لَأَخَذْنَا مِنْهُ بِٱلْيَمِينِ',
		number_in_surah: '45',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5369',
		number: '5369',
		text: 'ثُمَّ لَقَطَعْنَا مِنْهُ ٱلْوَتِينَ',
		number_in_surah: '46',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5370',
		number: '5370',
		text: 'فَمَا مِنكُم مِّنْ أَحَدٍ عَنْهُ حَٰجِزِينَ',
		number_in_surah: '47',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5371',
		number: '5371',
		text: 'وَإِنَّهُۥ لَتَذْكِرَةٌۭ لِّلْمُتَّقِينَ',
		number_in_surah: '48',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5372',
		number: '5372',
		text: 'وَإِنَّا لَنَعْلَمُ أَنَّ مِنكُم مُّكَذِّبِينَ',
		number_in_surah: '49',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5373',
		number: '5373',
		text: 'وَإِنَّهُۥ لَحَسْرَةٌ عَلَى ٱلْكَٰفِرِينَ',
		number_in_surah: '50',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5374',
		number: '5374',
		text: 'وَإِنَّهُۥ لَحَقُّ ٱلْيَقِينِ',
		number_in_surah: '51',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5375',
		number: '5375',
		text: 'فَسَبِّحْ بِٱسْمِ رَبِّكَ ٱلْعَظِيمِ',
		number_in_surah: '52',
		page: '568',
		surah_id: '69',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5376',
		number: '5376',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ سَأَلَ سَآئِلٌۢ بِعَذَابٍۢ وَاقِعٍۢ',
		number_in_surah: '1',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5377',
		number: '5377',
		text: 'لِّلْكَٰفِرِينَ لَيْسَ لَهُۥ دَافِعٌۭ',
		number_in_surah: '2',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5378',
		number: '5378',
		text: 'مِّنَ ٱللَّهِ ذِى ٱلْمَعَارِجِ',
		number_in_surah: '3',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5379',
		number: '5379',
		text: 'تَعْرُجُ ٱلْمَلَٰٓئِكَةُ وَٱلرُّوحُ إِلَيْهِ فِى يَوْمٍۢ كَانَ مِقْدَارُهُۥ خَمْسِينَ أَلْفَ سَنَةٍۢ',
		number_in_surah: '4',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5380',
		number: '5380',
		text: 'فَٱصْبِرْ صَبْرًۭا جَمِيلًا',
		number_in_surah: '5',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5381',
		number: '5381',
		text: 'إِنَّهُمْ يَرَوْنَهُۥ بَعِيدًۭا',
		number_in_surah: '6',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5382',
		number: '5382',
		text: 'وَنَرَىٰهُ قَرِيبًۭا',
		number_in_surah: '7',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5383',
		number: '5383',
		text: 'يَوْمَ تَكُونُ ٱلسَّمَآءُ كَٱلْمُهْلِ',
		number_in_surah: '8',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5384',
		number: '5384',
		text: 'وَتَكُونُ ٱلْجِبَالُ كَٱلْعِهْنِ',
		number_in_surah: '9',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5385',
		number: '5385',
		text: 'وَلَا يَسْـَٔلُ حَمِيمٌ حَمِيمًۭا',
		number_in_surah: '10',
		page: '568',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5386',
		number: '5386',
		text: 'يُبَصَّرُونَهُمْ ۚ يَوَدُّ ٱلْمُجْرِمُ لَوْ يَفْتَدِى مِنْ عَذَابِ يَوْمِئِذٍۭ بِبَنِيهِ',
		number_in_surah: '11',
		page: '569',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5387',
		number: '5387',
		text: 'وَصَٰحِبَتِهِۦ وَأَخِيهِ',
		number_in_surah: '12',
		page: '569',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5388',
		number: '5388',
		text: 'وَفَصِيلَتِهِ ٱلَّتِى تُـْٔوِيهِ',
		number_in_surah: '13',
		page: '569',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5389',
		number: '5389',
		text: 'وَمَن فِى ٱلْأَرْضِ جَمِيعًۭا ثُمَّ يُنجِيهِ',
		number_in_surah: '14',
		page: '569',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5390',
		number: '5390',
		text: 'كَلَّآ ۖ إِنَّهَا لَظَىٰ',
		number_in_surah: '15',
		page: '569',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5391',
		number: '5391',
		text: 'نَزَّاعَةًۭ لِّلشَّوَىٰ',
		number_in_surah: '16',
		page: '569',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5392',
		number: '5392',
		text: 'تَدْعُوا۟ مَنْ أَدْبَرَ وَتَوَلَّىٰ',
		number_in_surah: '17',
		page: '569',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5393',
		number: '5393',
		text: 'وَجَمَعَ فَأَوْعَىٰٓ',
		number_in_surah: '18',
		page: '569',
		surah_id: '70',
		hizb_id: '227',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5394',
		number: '5394',
		text: '۞ إِنَّ ٱلْإِنسَٰنَ خُلِقَ هَلُوعًا',
		number_in_surah: '19',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5395',
		number: '5395',
		text: 'إِذَا مَسَّهُ ٱلشَّرُّ جَزُوعًۭا',
		number_in_surah: '20',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5396',
		number: '5396',
		text: 'وَإِذَا مَسَّهُ ٱلْخَيْرُ مَنُوعًا',
		number_in_surah: '21',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5397',
		number: '5397',
		text: 'إِلَّا ٱلْمُصَلِّينَ',
		number_in_surah: '22',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5398',
		number: '5398',
		text: 'ٱلَّذِينَ هُمْ عَلَىٰ صَلَاتِهِمْ دَآئِمُونَ',
		number_in_surah: '23',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5399',
		number: '5399',
		text: 'وَٱلَّذِينَ فِىٓ أَمْوَٰلِهِمْ حَقٌّۭ مَّعْلُومٌۭ',
		number_in_surah: '24',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5400',
		number: '5400',
		text: 'لِّلسَّآئِلِ وَٱلْمَحْرُومِ',
		number_in_surah: '25',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5401',
		number: '5401',
		text: 'وَٱلَّذِينَ يُصَدِّقُونَ بِيَوْمِ ٱلدِّينِ',
		number_in_surah: '26',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5402',
		number: '5402',
		text: 'وَٱلَّذِينَ هُم مِّنْ عَذَابِ رَبِّهِم مُّشْفِقُونَ',
		number_in_surah: '27',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5403',
		number: '5403',
		text: 'إِنَّ عَذَابَ رَبِّهِمْ غَيْرُ مَأْمُونٍۢ',
		number_in_surah: '28',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5404',
		number: '5404',
		text: 'وَٱلَّذِينَ هُمْ لِفُرُوجِهِمْ حَٰفِظُونَ',
		number_in_surah: '29',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5405',
		number: '5405',
		text: 'إِلَّا عَلَىٰٓ أَزْوَٰجِهِمْ أَوْ مَا مَلَكَتْ أَيْمَٰنُهُمْ فَإِنَّهُمْ غَيْرُ مَلُومِينَ',
		number_in_surah: '30',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5406',
		number: '5406',
		text: 'فَمَنِ ٱبْتَغَىٰ وَرَآءَ ذَٰلِكَ فَأُو۟لَٰٓئِكَ هُمُ ٱلْعَادُونَ',
		number_in_surah: '31',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5407',
		number: '5407',
		text: 'وَٱلَّذِينَ هُمْ لِأَمَٰنَٰتِهِمْ وَعَهْدِهِمْ رَٰعُونَ',
		number_in_surah: '32',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5408',
		number: '5408',
		text: 'وَٱلَّذِينَ هُم بِشَهَٰدَٰتِهِمْ قَآئِمُونَ',
		number_in_surah: '33',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5409',
		number: '5409',
		text: 'وَٱلَّذِينَ هُمْ عَلَىٰ صَلَاتِهِمْ يُحَافِظُونَ',
		number_in_surah: '34',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5410',
		number: '5410',
		text: 'أُو۟لَٰٓئِكَ فِى جَنَّٰتٍۢ مُّكْرَمُونَ',
		number_in_surah: '35',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5411',
		number: '5411',
		text: 'فَمَالِ ٱلَّذِينَ كَفَرُوا۟ قِبَلَكَ مُهْطِعِينَ',
		number_in_surah: '36',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5412',
		number: '5412',
		text: 'عَنِ ٱلْيَمِينِ وَعَنِ ٱلشِّمَالِ عِزِينَ',
		number_in_surah: '37',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5413',
		number: '5413',
		text: 'أَيَطْمَعُ كُلُّ ٱمْرِئٍۢ مِّنْهُمْ أَن يُدْخَلَ جَنَّةَ نَعِيمٍۢ',
		number_in_surah: '38',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5414',
		number: '5414',
		text: 'كَلَّآ ۖ إِنَّا خَلَقْنَٰهُم مِّمَّا يَعْلَمُونَ',
		number_in_surah: '39',
		page: '569',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5415',
		number: '5415',
		text: 'فَلَآ أُقْسِمُ بِرَبِّ ٱلْمَشَٰرِقِ وَٱلْمَغَٰرِبِ إِنَّا لَقَٰدِرُونَ',
		number_in_surah: '40',
		page: '570',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5416',
		number: '5416',
		text: 'عَلَىٰٓ أَن نُّبَدِّلَ خَيْرًۭا مِّنْهُمْ وَمَا نَحْنُ بِمَسْبُوقِينَ',
		number_in_surah: '41',
		page: '570',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5417',
		number: '5417',
		text: 'فَذَرْهُمْ يَخُوضُوا۟ وَيَلْعَبُوا۟ حَتَّىٰ يُلَٰقُوا۟ يَوْمَهُمُ ٱلَّذِى يُوعَدُونَ',
		number_in_surah: '42',
		page: '570',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5418',
		number: '5418',
		text: 'يَوْمَ يَخْرُجُونَ مِنَ ٱلْأَجْدَاثِ سِرَاعًۭا كَأَنَّهُمْ إِلَىٰ نُصُبٍۢ يُوفِضُونَ',
		number_in_surah: '43',
		page: '570',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5419',
		number: '5419',
		text: 'خَٰشِعَةً أَبْصَٰرُهُمْ تَرْهَقُهُمْ ذِلَّةٌۭ ۚ ذَٰلِكَ ٱلْيَوْمُ ٱلَّذِى كَانُوا۟ يُوعَدُونَ',
		number_in_surah: '44',
		page: '570',
		surah_id: '70',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5420',
		number: '5420',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِنَّآ أَرْسَلْنَا نُوحًا إِلَىٰ قَوْمِهِۦٓ أَنْ أَنذِرْ قَوْمَكَ مِن قَبْلِ أَن يَأْتِيَهُمْ عَذَابٌ أَلِيمٌۭ',
		number_in_surah: '1',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5421',
		number: '5421',
		text: 'قَالَ يَٰقَوْمِ إِنِّى لَكُمْ نَذِيرٌۭ مُّبِينٌ',
		number_in_surah: '2',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5422',
		number: '5422',
		text: 'أَنِ ٱعْبُدُوا۟ ٱللَّهَ وَٱتَّقُوهُ وَأَطِيعُونِ',
		number_in_surah: '3',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5423',
		number: '5423',
		text: 'يَغْفِرْ لَكُم مِّن ذُنُوبِكُمْ وَيُؤَخِّرْكُمْ إِلَىٰٓ أَجَلٍۢ مُّسَمًّى ۚ إِنَّ أَجَلَ ٱللَّهِ إِذَا جَآءَ لَا يُؤَخَّرُ ۖ لَوْ كُنتُمْ تَعْلَمُونَ',
		number_in_surah: '4',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5424',
		number: '5424',
		text: 'قَالَ رَبِّ إِنِّى دَعَوْتُ قَوْمِى لَيْلًۭا وَنَهَارًۭا',
		number_in_surah: '5',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5425',
		number: '5425',
		text: 'فَلَمْ يَزِدْهُمْ دُعَآءِىٓ إِلَّا فِرَارًۭا',
		number_in_surah: '6',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5426',
		number: '5426',
		text: 'وَإِنِّى كُلَّمَا دَعَوْتُهُمْ لِتَغْفِرَ لَهُمْ جَعَلُوٓا۟ أَصَٰبِعَهُمْ فِىٓ ءَاذَانِهِمْ وَٱسْتَغْشَوْا۟ ثِيَابَهُمْ وَأَصَرُّوا۟ وَٱسْتَكْبَرُوا۟ ٱسْتِكْبَارًۭا',
		number_in_surah: '7',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5427',
		number: '5427',
		text: 'ثُمَّ إِنِّى دَعَوْتُهُمْ جِهَارًۭا',
		number_in_surah: '8',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5428',
		number: '5428',
		text: 'ثُمَّ إِنِّىٓ أَعْلَنتُ لَهُمْ وَأَسْرَرْتُ لَهُمْ إِسْرَارًۭا',
		number_in_surah: '9',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5429',
		number: '5429',
		text: 'فَقُلْتُ ٱسْتَغْفِرُوا۟ رَبَّكُمْ إِنَّهُۥ كَانَ غَفَّارًۭا',
		number_in_surah: '10',
		page: '570',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5430',
		number: '5430',
		text: 'يُرْسِلِ ٱلسَّمَآءَ عَلَيْكُم مِّدْرَارًۭا',
		number_in_surah: '11',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5431',
		number: '5431',
		text: 'وَيُمْدِدْكُم بِأَمْوَٰلٍۢ وَبَنِينَ وَيَجْعَل لَّكُمْ جَنَّٰتٍۢ وَيَجْعَل لَّكُمْ أَنْهَٰرًۭا',
		number_in_surah: '12',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5432',
		number: '5432',
		text: 'مَّا لَكُمْ لَا تَرْجُونَ لِلَّهِ وَقَارًۭا',
		number_in_surah: '13',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5433',
		number: '5433',
		text: 'وَقَدْ خَلَقَكُمْ أَطْوَارًا',
		number_in_surah: '14',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5434',
		number: '5434',
		text: 'أَلَمْ تَرَوْا۟ كَيْفَ خَلَقَ ٱللَّهُ سَبْعَ سَمَٰوَٰتٍۢ طِبَاقًۭا',
		number_in_surah: '15',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5435',
		number: '5435',
		text: 'وَجَعَلَ ٱلْقَمَرَ فِيهِنَّ نُورًۭا وَجَعَلَ ٱلشَّمْسَ سِرَاجًۭا',
		number_in_surah: '16',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5436',
		number: '5436',
		text: 'وَٱللَّهُ أَنۢبَتَكُم مِّنَ ٱلْأَرْضِ نَبَاتًۭا',
		number_in_surah: '17',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5437',
		number: '5437',
		text: 'ثُمَّ يُعِيدُكُمْ فِيهَا وَيُخْرِجُكُمْ إِخْرَاجًۭا',
		number_in_surah: '18',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5438',
		number: '5438',
		text: 'وَٱللَّهُ جَعَلَ لَكُمُ ٱلْأَرْضَ بِسَاطًۭا',
		number_in_surah: '19',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5439',
		number: '5439',
		text: 'لِّتَسْلُكُوا۟ مِنْهَا سُبُلًۭا فِجَاجًۭا',
		number_in_surah: '20',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5440',
		number: '5440',
		text: 'قَالَ نُوحٌۭ رَّبِّ إِنَّهُمْ عَصَوْنِى وَٱتَّبَعُوا۟ مَن لَّمْ يَزِدْهُ مَالُهُۥ وَوَلَدُهُۥٓ إِلَّا خَسَارًۭا',
		number_in_surah: '21',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5441',
		number: '5441',
		text: 'وَمَكَرُوا۟ مَكْرًۭا كُبَّارًۭا',
		number_in_surah: '22',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5442',
		number: '5442',
		text: 'وَقَالُوا۟ لَا تَذَرُنَّ ءَالِهَتَكُمْ وَلَا تَذَرُنَّ وَدًّۭا وَلَا سُوَاعًۭا وَلَا يَغُوثَ وَيَعُوقَ وَنَسْرًۭا',
		number_in_surah: '23',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5443',
		number: '5443',
		text: 'وَقَدْ أَضَلُّوا۟ كَثِيرًۭا ۖ وَلَا تَزِدِ ٱلظَّٰلِمِينَ إِلَّا ضَلَٰلًۭا',
		number_in_surah: '24',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5444',
		number: '5444',
		text: 'مِّمَّا خَطِيٓـَٰٔتِهِمْ أُغْرِقُوا۟ فَأُدْخِلُوا۟ نَارًۭا فَلَمْ يَجِدُوا۟ لَهُم مِّن دُونِ ٱللَّهِ أَنصَارًۭا',
		number_in_surah: '25',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5445',
		number: '5445',
		text: 'وَقَالَ نُوحٌۭ رَّبِّ لَا تَذَرْ عَلَى ٱلْأَرْضِ مِنَ ٱلْكَٰفِرِينَ دَيَّارًا',
		number_in_surah: '26',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5446',
		number: '5446',
		text: 'إِنَّكَ إِن تَذَرْهُمْ يُضِلُّوا۟ عِبَادَكَ وَلَا يَلِدُوٓا۟ إِلَّا فَاجِرًۭا كَفَّارًۭا',
		number_in_surah: '27',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5447',
		number: '5447',
		text: 'رَّبِّ ٱغْفِرْ لِى وَلِوَٰلِدَىَّ وَلِمَن دَخَلَ بَيْتِىَ مُؤْمِنًۭا وَلِلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ وَلَا تَزِدِ ٱلظَّٰلِمِينَ إِلَّا تَبَارًۢا',
		number_in_surah: '28',
		page: '571',
		surah_id: '71',
		hizb_id: '228',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5448',
		number: '5448',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ قُلْ أُوحِىَ إِلَىَّ أَنَّهُ ٱسْتَمَعَ نَفَرٌۭ مِّنَ ٱلْجِنِّ فَقَالُوٓا۟ إِنَّا سَمِعْنَا قُرْءَانًا عَجَبًۭا',
		number_in_surah: '1',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5449',
		number: '5449',
		text: 'يَهْدِىٓ إِلَى ٱلرُّشْدِ فَـَٔامَنَّا بِهِۦ ۖ وَلَن نُّشْرِكَ بِرَبِّنَآ أَحَدًۭا',
		number_in_surah: '2',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5450',
		number: '5450',
		text: 'وَأَنَّهُۥ تَعَٰلَىٰ جَدُّ رَبِّنَا مَا ٱتَّخَذَ صَٰحِبَةًۭ وَلَا وَلَدًۭا',
		number_in_surah: '3',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5451',
		number: '5451',
		text: 'وَأَنَّهُۥ كَانَ يَقُولُ سَفِيهُنَا عَلَى ٱللَّهِ شَطَطًۭا',
		number_in_surah: '4',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5452',
		number: '5452',
		text: 'وَأَنَّا ظَنَنَّآ أَن لَّن تَقُولَ ٱلْإِنسُ وَٱلْجِنُّ عَلَى ٱللَّهِ كَذِبًۭا',
		number_in_surah: '5',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5453',
		number: '5453',
		text: 'وَأَنَّهُۥ كَانَ رِجَالٌۭ مِّنَ ٱلْإِنسِ يَعُوذُونَ بِرِجَالٍۢ مِّنَ ٱلْجِنِّ فَزَادُوهُمْ رَهَقًۭا',
		number_in_surah: '6',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5454',
		number: '5454',
		text: 'وَأَنَّهُمْ ظَنُّوا۟ كَمَا ظَنَنتُمْ أَن لَّن يَبْعَثَ ٱللَّهُ أَحَدًۭا',
		number_in_surah: '7',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5455',
		number: '5455',
		text: 'وَأَنَّا لَمَسْنَا ٱلسَّمَآءَ فَوَجَدْنَٰهَا مُلِئَتْ حَرَسًۭا شَدِيدًۭا وَشُهُبًۭا',
		number_in_surah: '8',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5456',
		number: '5456',
		text: 'وَأَنَّا كُنَّا نَقْعُدُ مِنْهَا مَقَٰعِدَ لِلسَّمْعِ ۖ فَمَن يَسْتَمِعِ ٱلْءَانَ يَجِدْ لَهُۥ شِهَابًۭا رَّصَدًۭا',
		number_in_surah: '9',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5457',
		number: '5457',
		text: 'وَأَنَّا لَا نَدْرِىٓ أَشَرٌّ أُرِيدَ بِمَن فِى ٱلْأَرْضِ أَمْ أَرَادَ بِهِمْ رَبُّهُمْ رَشَدًۭا',
		number_in_surah: '10',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5458',
		number: '5458',
		text: 'وَأَنَّا مِنَّا ٱلصَّٰلِحُونَ وَمِنَّا دُونَ ذَٰلِكَ ۖ كُنَّا طَرَآئِقَ قِدَدًۭا',
		number_in_surah: '11',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5459',
		number: '5459',
		text: 'وَأَنَّا ظَنَنَّآ أَن لَّن نُّعْجِزَ ٱللَّهَ فِى ٱلْأَرْضِ وَلَن نُّعْجِزَهُۥ هَرَبًۭا',
		number_in_surah: '12',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5460',
		number: '5460',
		text: 'وَأَنَّا لَمَّا سَمِعْنَا ٱلْهُدَىٰٓ ءَامَنَّا بِهِۦ ۖ فَمَن يُؤْمِنۢ بِرَبِّهِۦ فَلَا يَخَافُ بَخْسًۭا وَلَا رَهَقًۭا',
		number_in_surah: '13',
		page: '572',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5461',
		number: '5461',
		text: 'وَأَنَّا مِنَّا ٱلْمُسْلِمُونَ وَمِنَّا ٱلْقَٰسِطُونَ ۖ فَمَنْ أَسْلَمَ فَأُو۟لَٰٓئِكَ تَحَرَّوْا۟ رَشَدًۭا',
		number_in_surah: '14',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5462',
		number: '5462',
		text: 'وَأَمَّا ٱلْقَٰسِطُونَ فَكَانُوا۟ لِجَهَنَّمَ حَطَبًۭا',
		number_in_surah: '15',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5463',
		number: '5463',
		text: 'وَأَلَّوِ ٱسْتَقَٰمُوا۟ عَلَى ٱلطَّرِيقَةِ لَأَسْقَيْنَٰهُم مَّآءً غَدَقًۭا',
		number_in_surah: '16',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5464',
		number: '5464',
		text: 'لِّنَفْتِنَهُمْ فِيهِ ۚ وَمَن يُعْرِضْ عَن ذِكْرِ رَبِّهِۦ يَسْلُكْهُ عَذَابًۭا صَعَدًۭا',
		number_in_surah: '17',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5465',
		number: '5465',
		text: 'وَأَنَّ ٱلْمَسَٰجِدَ لِلَّهِ فَلَا تَدْعُوا۟ مَعَ ٱللَّهِ أَحَدًۭا',
		number_in_surah: '18',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5466',
		number: '5466',
		text: 'وَأَنَّهُۥ لَمَّا قَامَ عَبْدُ ٱللَّهِ يَدْعُوهُ كَادُوا۟ يَكُونُونَ عَلَيْهِ لِبَدًۭا',
		number_in_surah: '19',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5467',
		number: '5467',
		text: 'قُلْ إِنَّمَآ أَدْعُوا۟ رَبِّى وَلَآ أُشْرِكُ بِهِۦٓ أَحَدًۭا',
		number_in_surah: '20',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5468',
		number: '5468',
		text: 'قُلْ إِنِّى لَآ أَمْلِكُ لَكُمْ ضَرًّۭا وَلَا رَشَدًۭا',
		number_in_surah: '21',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5469',
		number: '5469',
		text: 'قُلْ إِنِّى لَن يُجِيرَنِى مِنَ ٱللَّهِ أَحَدٌۭ وَلَنْ أَجِدَ مِن دُونِهِۦ مُلْتَحَدًا',
		number_in_surah: '22',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5470',
		number: '5470',
		text: 'إِلَّا بَلَٰغًۭا مِّنَ ٱللَّهِ وَرِسَٰلَٰتِهِۦ ۚ وَمَن يَعْصِ ٱللَّهَ وَرَسُولَهُۥ فَإِنَّ لَهُۥ نَارَ جَهَنَّمَ خَٰلِدِينَ فِيهَآ أَبَدًا',
		number_in_surah: '23',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5471',
		number: '5471',
		text: 'حَتَّىٰٓ إِذَا رَأَوْا۟ مَا يُوعَدُونَ فَسَيَعْلَمُونَ مَنْ أَضْعَفُ نَاصِرًۭا وَأَقَلُّ عَدَدًۭا',
		number_in_surah: '24',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5472',
		number: '5472',
		text: 'قُلْ إِنْ أَدْرِىٓ أَقَرِيبٌۭ مَّا تُوعَدُونَ أَمْ يَجْعَلُ لَهُۥ رَبِّىٓ أَمَدًا',
		number_in_surah: '25',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5473',
		number: '5473',
		text: 'عَٰلِمُ ٱلْغَيْبِ فَلَا يُظْهِرُ عَلَىٰ غَيْبِهِۦٓ أَحَدًا',
		number_in_surah: '26',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5474',
		number: '5474',
		text: 'إِلَّا مَنِ ٱرْتَضَىٰ مِن رَّسُولٍۢ فَإِنَّهُۥ يَسْلُكُ مِنۢ بَيْنِ يَدَيْهِ وَمِنْ خَلْفِهِۦ رَصَدًۭا',
		number_in_surah: '27',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5475',
		number: '5475',
		text: 'لِّيَعْلَمَ أَن قَدْ أَبْلَغُوا۟ رِسَٰلَٰتِ رَبِّهِمْ وَأَحَاطَ بِمَا لَدَيْهِمْ وَأَحْصَىٰ كُلَّ شَىْءٍ عَدَدًۢا',
		number_in_surah: '28',
		page: '573',
		surah_id: '72',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5476',
		number: '5476',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلْمُزَّمِّلُ',
		number_in_surah: '1',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5477',
		number: '5477',
		text: 'قُمِ ٱلَّيْلَ إِلَّا قَلِيلًۭا',
		number_in_surah: '2',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5478',
		number: '5478',
		text: 'نِّصْفَهُۥٓ أَوِ ٱنقُصْ مِنْهُ قَلِيلًا',
		number_in_surah: '3',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5479',
		number: '5479',
		text: 'أَوْ زِدْ عَلَيْهِ وَرَتِّلِ ٱلْقُرْءَانَ تَرْتِيلًا',
		number_in_surah: '4',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5480',
		number: '5480',
		text: 'إِنَّا سَنُلْقِى عَلَيْكَ قَوْلًۭا ثَقِيلًا',
		number_in_surah: '5',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5481',
		number: '5481',
		text: 'إِنَّ نَاشِئَةَ ٱلَّيْلِ هِىَ أَشَدُّ وَطْـًۭٔا وَأَقْوَمُ قِيلًا',
		number_in_surah: '6',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5482',
		number: '5482',
		text: 'إِنَّ لَكَ فِى ٱلنَّهَارِ سَبْحًۭا طَوِيلًۭا',
		number_in_surah: '7',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5483',
		number: '5483',
		text: 'وَٱذْكُرِ ٱسْمَ رَبِّكَ وَتَبَتَّلْ إِلَيْهِ تَبْتِيلًۭا',
		number_in_surah: '8',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5484',
		number: '5484',
		text: 'رَّبُّ ٱلْمَشْرِقِ وَٱلْمَغْرِبِ لَآ إِلَٰهَ إِلَّا هُوَ فَٱتَّخِذْهُ وَكِيلًۭا',
		number_in_surah: '9',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5485',
		number: '5485',
		text: 'وَٱصْبِرْ عَلَىٰ مَا يَقُولُونَ وَٱهْجُرْهُمْ هَجْرًۭا جَمِيلًۭا',
		number_in_surah: '10',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5486',
		number: '5486',
		text: 'وَذَرْنِى وَٱلْمُكَذِّبِينَ أُو۟لِى ٱلنَّعْمَةِ وَمَهِّلْهُمْ قَلِيلًا',
		number_in_surah: '11',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5487',
		number: '5487',
		text: 'إِنَّ لَدَيْنَآ أَنكَالًۭا وَجَحِيمًۭا',
		number_in_surah: '12',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5488',
		number: '5488',
		text: 'وَطَعَامًۭا ذَا غُصَّةٍۢ وَعَذَابًا أَلِيمًۭا',
		number_in_surah: '13',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5489',
		number: '5489',
		text: 'يَوْمَ تَرْجُفُ ٱلْأَرْضُ وَٱلْجِبَالُ وَكَانَتِ ٱلْجِبَالُ كَثِيبًۭا مَّهِيلًا',
		number_in_surah: '14',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5490',
		number: '5490',
		text: 'إِنَّآ أَرْسَلْنَآ إِلَيْكُمْ رَسُولًۭا شَٰهِدًا عَلَيْكُمْ كَمَآ أَرْسَلْنَآ إِلَىٰ فِرْعَوْنَ رَسُولًۭا',
		number_in_surah: '15',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5491',
		number: '5491',
		text: 'فَعَصَىٰ فِرْعَوْنُ ٱلرَّسُولَ فَأَخَذْنَٰهُ أَخْذًۭا وَبِيلًۭا',
		number_in_surah: '16',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5492',
		number: '5492',
		text: 'فَكَيْفَ تَتَّقُونَ إِن كَفَرْتُمْ يَوْمًۭا يَجْعَلُ ٱلْوِلْدَٰنَ شِيبًا',
		number_in_surah: '17',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5493',
		number: '5493',
		text: 'ٱلسَّمَآءُ مُنفَطِرٌۢ بِهِۦ ۚ كَانَ وَعْدُهُۥ مَفْعُولًا',
		number_in_surah: '18',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5494',
		number: '5494',
		text: 'إِنَّ هَٰذِهِۦ تَذْكِرَةٌۭ ۖ فَمَن شَآءَ ٱتَّخَذَ إِلَىٰ رَبِّهِۦ سَبِيلًا',
		number_in_surah: '19',
		page: '574',
		surah_id: '73',
		hizb_id: '229',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5495',
		number: '5495',
		text: '۞ إِنَّ رَبَّكَ يَعْلَمُ أَنَّكَ تَقُومُ أَدْنَىٰ مِن ثُلُثَىِ ٱلَّيْلِ وَنِصْفَهُۥ وَثُلُثَهُۥ وَطَآئِفَةٌۭ مِّنَ ٱلَّذِينَ مَعَكَ ۚ وَٱللَّهُ يُقَدِّرُ ٱلَّيْلَ وَٱلنَّهَارَ ۚ عَلِمَ أَن لَّن تُحْصُوهُ فَتَابَ عَلَيْكُمْ ۖ فَٱقْرَءُوا۟ مَا تَيَسَّرَ مِنَ ٱلْقُرْءَانِ ۚ عَلِمَ أَن سَيَكُونُ مِنكُم مَّرْضَىٰ ۙ وَءَاخَرُونَ يَضْرِبُونَ فِى ٱلْأَرْضِ يَبْتَغُونَ مِن فَضْلِ ٱللَّهِ ۙ وَءَاخَرُونَ يُقَٰتِلُونَ فِى سَبِيلِ ٱللَّهِ ۖ فَٱقْرَءُوا۟ مَا تَيَسَّرَ مِنْهُ ۚ وَأَقِيمُوا۟ ٱلصَّلَوٰةَ وَءَاتُوا۟ ٱلزَّكَوٰةَ وَأَقْرِضُوا۟ ٱللَّهَ قَرْضًا حَسَنًۭا ۚ وَمَا تُقَدِّمُوا۟ لِأَنفُسِكُم مِّنْ خَيْرٍۢ تَجِدُوهُ عِندَ ٱللَّهِ هُوَ خَيْرًۭا وَأَعْظَمَ أَجْرًۭا ۚ وَٱسْتَغْفِرُوا۟ ٱللَّهَ ۖ إِنَّ ٱللَّهَ غَفُورٌۭ رَّحِيمٌۢ',
		number_in_surah: '20',
		page: '575',
		surah_id: '73',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5496',
		number: '5496',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ يَٰٓأَيُّهَا ٱلْمُدَّثِّرُ',
		number_in_surah: '1',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5497',
		number: '5497',
		text: 'قُمْ فَأَنذِرْ',
		number_in_surah: '2',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5498',
		number: '5498',
		text: 'وَرَبَّكَ فَكَبِّرْ',
		number_in_surah: '3',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5499',
		number: '5499',
		text: 'وَثِيَابَكَ فَطَهِّرْ',
		number_in_surah: '4',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5500',
		number: '5500',
		text: 'وَٱلرُّجْزَ فَٱهْجُرْ',
		number_in_surah: '5',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5501',
		number: '5501',
		text: 'وَلَا تَمْنُن تَسْتَكْثِرُ',
		number_in_surah: '6',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5502',
		number: '5502',
		text: 'وَلِرَبِّكَ فَٱصْبِرْ',
		number_in_surah: '7',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:18',
		updated_at: '2018-06-07 08:07:18',
	},
	{
		id: '5503',
		number: '5503',
		text: 'فَإِذَا نُقِرَ فِى ٱلنَّاقُورِ',
		number_in_surah: '8',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5504',
		number: '5504',
		text: 'فَذَٰلِكَ يَوْمَئِذٍۢ يَوْمٌ عَسِيرٌ',
		number_in_surah: '9',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5505',
		number: '5505',
		text: 'عَلَى ٱلْكَٰفِرِينَ غَيْرُ يَسِيرٍۢ',
		number_in_surah: '10',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5506',
		number: '5506',
		text: 'ذَرْنِى وَمَنْ خَلَقْتُ وَحِيدًۭا',
		number_in_surah: '11',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5507',
		number: '5507',
		text: 'وَجَعَلْتُ لَهُۥ مَالًۭا مَّمْدُودًۭا',
		number_in_surah: '12',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5508',
		number: '5508',
		text: 'وَبَنِينَ شُهُودًۭا',
		number_in_surah: '13',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5509',
		number: '5509',
		text: 'وَمَهَّدتُّ لَهُۥ تَمْهِيدًۭا',
		number_in_surah: '14',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5510',
		number: '5510',
		text: 'ثُمَّ يَطْمَعُ أَنْ أَزِيدَ',
		number_in_surah: '15',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5511',
		number: '5511',
		text: 'كَلَّآ ۖ إِنَّهُۥ كَانَ لِءَايَٰتِنَا عَنِيدًۭا',
		number_in_surah: '16',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5512',
		number: '5512',
		text: 'سَأُرْهِقُهُۥ صَعُودًا',
		number_in_surah: '17',
		page: '575',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5513',
		number: '5513',
		text: 'إِنَّهُۥ فَكَّرَ وَقَدَّرَ',
		number_in_surah: '18',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5514',
		number: '5514',
		text: 'فَقُتِلَ كَيْفَ قَدَّرَ',
		number_in_surah: '19',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5515',
		number: '5515',
		text: 'ثُمَّ قُتِلَ كَيْفَ قَدَّرَ',
		number_in_surah: '20',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5516',
		number: '5516',
		text: 'ثُمَّ نَظَرَ',
		number_in_surah: '21',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5517',
		number: '5517',
		text: 'ثُمَّ عَبَسَ وَبَسَرَ',
		number_in_surah: '22',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5518',
		number: '5518',
		text: 'ثُمَّ أَدْبَرَ وَٱسْتَكْبَرَ',
		number_in_surah: '23',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5519',
		number: '5519',
		text: 'فَقَالَ إِنْ هَٰذَآ إِلَّا سِحْرٌۭ يُؤْثَرُ',
		number_in_surah: '24',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5520',
		number: '5520',
		text: 'إِنْ هَٰذَآ إِلَّا قَوْلُ ٱلْبَشَرِ',
		number_in_surah: '25',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5521',
		number: '5521',
		text: 'سَأُصْلِيهِ سَقَرَ',
		number_in_surah: '26',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5522',
		number: '5522',
		text: 'وَمَآ أَدْرَىٰكَ مَا سَقَرُ',
		number_in_surah: '27',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5523',
		number: '5523',
		text: 'لَا تُبْقِى وَلَا تَذَرُ',
		number_in_surah: '28',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5524',
		number: '5524',
		text: 'لَوَّاحَةٌۭ لِّلْبَشَرِ',
		number_in_surah: '29',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5525',
		number: '5525',
		text: 'عَلَيْهَا تِسْعَةَ عَشَرَ',
		number_in_surah: '30',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5526',
		number: '5526',
		text: 'وَمَا جَعَلْنَآ أَصْحَٰبَ ٱلنَّارِ إِلَّا مَلَٰٓئِكَةًۭ ۙ وَمَا جَعَلْنَا عِدَّتَهُمْ إِلَّا فِتْنَةًۭ لِّلَّذِينَ كَفَرُوا۟ لِيَسْتَيْقِنَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ وَيَزْدَادَ ٱلَّذِينَ ءَامَنُوٓا۟ إِيمَٰنًۭا ۙ وَلَا يَرْتَابَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ وَٱلْمُؤْمِنُونَ ۙ وَلِيَقُولَ ٱلَّذِينَ فِى قُلُوبِهِم مَّرَضٌۭ وَٱلْكَٰفِرُونَ مَاذَآ أَرَادَ ٱللَّهُ بِهَٰذَا مَثَلًۭا ۚ كَذَٰلِكَ يُضِلُّ ٱللَّهُ مَن يَشَآءُ وَيَهْدِى مَن يَشَآءُ ۚ وَمَا يَعْلَمُ جُنُودَ رَبِّكَ إِلَّا هُوَ ۚ وَمَا هِىَ إِلَّا ذِكْرَىٰ لِلْبَشَرِ',
		number_in_surah: '31',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5527',
		number: '5527',
		text: 'كَلَّا وَٱلْقَمَرِ',
		number_in_surah: '32',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5528',
		number: '5528',
		text: 'وَٱلَّيْلِ إِذْ أَدْبَرَ',
		number_in_surah: '33',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5529',
		number: '5529',
		text: 'وَٱلصُّبْحِ إِذَآ أَسْفَرَ',
		number_in_surah: '34',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5530',
		number: '5530',
		text: 'إِنَّهَا لَإِحْدَى ٱلْكُبَرِ',
		number_in_surah: '35',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5531',
		number: '5531',
		text: 'نَذِيرًۭا لِّلْبَشَرِ',
		number_in_surah: '36',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5532',
		number: '5532',
		text: 'لِمَن شَآءَ مِنكُمْ أَن يَتَقَدَّمَ أَوْ يَتَأَخَّرَ',
		number_in_surah: '37',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5533',
		number: '5533',
		text: 'كُلُّ نَفْسٍۭ بِمَا كَسَبَتْ رَهِينَةٌ',
		number_in_surah: '38',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5534',
		number: '5534',
		text: 'إِلَّآ أَصْحَٰبَ ٱلْيَمِينِ',
		number_in_surah: '39',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5535',
		number: '5535',
		text: 'فِى جَنَّٰتٍۢ يَتَسَآءَلُونَ',
		number_in_surah: '40',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5536',
		number: '5536',
		text: 'عَنِ ٱلْمُجْرِمِينَ',
		number_in_surah: '41',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5537',
		number: '5537',
		text: 'مَا سَلَكَكُمْ فِى سَقَرَ',
		number_in_surah: '42',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5538',
		number: '5538',
		text: 'قَالُوا۟ لَمْ نَكُ مِنَ ٱلْمُصَلِّينَ',
		number_in_surah: '43',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5539',
		number: '5539',
		text: 'وَلَمْ نَكُ نُطْعِمُ ٱلْمِسْكِينَ',
		number_in_surah: '44',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5540',
		number: '5540',
		text: 'وَكُنَّا نَخُوضُ مَعَ ٱلْخَآئِضِينَ',
		number_in_surah: '45',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5541',
		number: '5541',
		text: 'وَكُنَّا نُكَذِّبُ بِيَوْمِ ٱلدِّينِ',
		number_in_surah: '46',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5542',
		number: '5542',
		text: 'حَتَّىٰٓ أَتَىٰنَا ٱلْيَقِينُ',
		number_in_surah: '47',
		page: '576',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5543',
		number: '5543',
		text: 'فَمَا تَنفَعُهُمْ شَفَٰعَةُ ٱلشَّٰفِعِينَ',
		number_in_surah: '48',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5544',
		number: '5544',
		text: 'فَمَا لَهُمْ عَنِ ٱلتَّذْكِرَةِ مُعْرِضِينَ',
		number_in_surah: '49',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5545',
		number: '5545',
		text: 'كَأَنَّهُمْ حُمُرٌۭ مُّسْتَنفِرَةٌۭ',
		number_in_surah: '50',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5546',
		number: '5546',
		text: 'فَرَّتْ مِن قَسْوَرَةٍۭ',
		number_in_surah: '51',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5547',
		number: '5547',
		text: 'بَلْ يُرِيدُ كُلُّ ٱمْرِئٍۢ مِّنْهُمْ أَن يُؤْتَىٰ صُحُفًۭا مُّنَشَّرَةًۭ',
		number_in_surah: '52',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5548',
		number: '5548',
		text: 'كَلَّا ۖ بَل لَّا يَخَافُونَ ٱلْءَاخِرَةَ',
		number_in_surah: '53',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5549',
		number: '5549',
		text: 'كَلَّآ إِنَّهُۥ تَذْكِرَةٌۭ',
		number_in_surah: '54',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5550',
		number: '5550',
		text: 'فَمَن شَآءَ ذَكَرَهُۥ',
		number_in_surah: '55',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5551',
		number: '5551',
		text: 'وَمَا يَذْكُرُونَ إِلَّآ أَن يَشَآءَ ٱللَّهُ ۚ هُوَ أَهْلُ ٱلتَّقْوَىٰ وَأَهْلُ ٱلْمَغْفِرَةِ',
		number_in_surah: '56',
		page: '577',
		surah_id: '74',
		hizb_id: '230',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5552',
		number: '5552',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ لَآ أُقْسِمُ بِيَوْمِ ٱلْقِيَٰمَةِ',
		number_in_surah: '1',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5553',
		number: '5553',
		text: 'وَلَآ أُقْسِمُ بِٱلنَّفْسِ ٱللَّوَّامَةِ',
		number_in_surah: '2',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5554',
		number: '5554',
		text: 'أَيَحْسَبُ ٱلْإِنسَٰنُ أَلَّن نَّجْمَعَ عِظَامَهُۥ',
		number_in_surah: '3',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5555',
		number: '5555',
		text: 'بَلَىٰ قَٰدِرِينَ عَلَىٰٓ أَن نُّسَوِّىَ بَنَانَهُۥ',
		number_in_surah: '4',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5556',
		number: '5556',
		text: 'بَلْ يُرِيدُ ٱلْإِنسَٰنُ لِيَفْجُرَ أَمَامَهُۥ',
		number_in_surah: '5',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5557',
		number: '5557',
		text: 'يَسْـَٔلُ أَيَّانَ يَوْمُ ٱلْقِيَٰمَةِ',
		number_in_surah: '6',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5558',
		number: '5558',
		text: 'فَإِذَا بَرِقَ ٱلْبَصَرُ',
		number_in_surah: '7',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5559',
		number: '5559',
		text: 'وَخَسَفَ ٱلْقَمَرُ',
		number_in_surah: '8',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5560',
		number: '5560',
		text: 'وَجُمِعَ ٱلشَّمْسُ وَٱلْقَمَرُ',
		number_in_surah: '9',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5561',
		number: '5561',
		text: 'يَقُولُ ٱلْإِنسَٰنُ يَوْمَئِذٍ أَيْنَ ٱلْمَفَرُّ',
		number_in_surah: '10',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5562',
		number: '5562',
		text: 'كَلَّا لَا وَزَرَ',
		number_in_surah: '11',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5563',
		number: '5563',
		text: 'إِلَىٰ رَبِّكَ يَوْمَئِذٍ ٱلْمُسْتَقَرُّ',
		number_in_surah: '12',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5564',
		number: '5564',
		text: 'يُنَبَّؤُا۟ ٱلْإِنسَٰنُ يَوْمَئِذٍۭ بِمَا قَدَّمَ وَأَخَّرَ',
		number_in_surah: '13',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5565',
		number: '5565',
		text: 'بَلِ ٱلْإِنسَٰنُ عَلَىٰ نَفْسِهِۦ بَصِيرَةٌۭ',
		number_in_surah: '14',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5566',
		number: '5566',
		text: 'وَلَوْ أَلْقَىٰ مَعَاذِيرَهُۥ',
		number_in_surah: '15',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5567',
		number: '5567',
		text: 'لَا تُحَرِّكْ بِهِۦ لِسَانَكَ لِتَعْجَلَ بِهِۦٓ',
		number_in_surah: '16',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5568',
		number: '5568',
		text: 'إِنَّ عَلَيْنَا جَمْعَهُۥ وَقُرْءَانَهُۥ',
		number_in_surah: '17',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5569',
		number: '5569',
		text: 'فَإِذَا قَرَأْنَٰهُ فَٱتَّبِعْ قُرْءَانَهُۥ',
		number_in_surah: '18',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5570',
		number: '5570',
		text: 'ثُمَّ إِنَّ عَلَيْنَا بَيَانَهُۥ',
		number_in_surah: '19',
		page: '577',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5571',
		number: '5571',
		text: 'كَلَّا بَلْ تُحِبُّونَ ٱلْعَاجِلَةَ',
		number_in_surah: '20',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5572',
		number: '5572',
		text: 'وَتَذَرُونَ ٱلْءَاخِرَةَ',
		number_in_surah: '21',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5573',
		number: '5573',
		text: 'وُجُوهٌۭ يَوْمَئِذٍۢ نَّاضِرَةٌ',
		number_in_surah: '22',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5574',
		number: '5574',
		text: 'إِلَىٰ رَبِّهَا نَاظِرَةٌۭ',
		number_in_surah: '23',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5575',
		number: '5575',
		text: 'وَوُجُوهٌۭ يَوْمَئِذٍۭ بَاسِرَةٌۭ',
		number_in_surah: '24',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5576',
		number: '5576',
		text: 'تَظُنُّ أَن يُفْعَلَ بِهَا فَاقِرَةٌۭ',
		number_in_surah: '25',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5577',
		number: '5577',
		text: 'كَلَّآ إِذَا بَلَغَتِ ٱلتَّرَاقِىَ',
		number_in_surah: '26',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5578',
		number: '5578',
		text: 'وَقِيلَ مَنْ ۜ رَاقٍۢ',
		number_in_surah: '27',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5579',
		number: '5579',
		text: 'وَظَنَّ أَنَّهُ ٱلْفِرَاقُ',
		number_in_surah: '28',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5580',
		number: '5580',
		text: 'وَٱلْتَفَّتِ ٱلسَّاقُ بِٱلسَّاقِ',
		number_in_surah: '29',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5581',
		number: '5581',
		text: 'إِلَىٰ رَبِّكَ يَوْمَئِذٍ ٱلْمَسَاقُ',
		number_in_surah: '30',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5582',
		number: '5582',
		text: 'فَلَا صَدَّقَ وَلَا صَلَّىٰ',
		number_in_surah: '31',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5583',
		number: '5583',
		text: 'وَلَٰكِن كَذَّبَ وَتَوَلَّىٰ',
		number_in_surah: '32',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5584',
		number: '5584',
		text: 'ثُمَّ ذَهَبَ إِلَىٰٓ أَهْلِهِۦ يَتَمَطَّىٰٓ',
		number_in_surah: '33',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5585',
		number: '5585',
		text: 'أَوْلَىٰ لَكَ فَأَوْلَىٰ',
		number_in_surah: '34',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5586',
		number: '5586',
		text: 'ثُمَّ أَوْلَىٰ لَكَ فَأَوْلَىٰٓ',
		number_in_surah: '35',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5587',
		number: '5587',
		text: 'أَيَحْسَبُ ٱلْإِنسَٰنُ أَن يُتْرَكَ سُدًى',
		number_in_surah: '36',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5588',
		number: '5588',
		text: 'أَلَمْ يَكُ نُطْفَةًۭ مِّن مَّنِىٍّۢ يُمْنَىٰ',
		number_in_surah: '37',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5589',
		number: '5589',
		text: 'ثُمَّ كَانَ عَلَقَةًۭ فَخَلَقَ فَسَوَّىٰ',
		number_in_surah: '38',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5590',
		number: '5590',
		text: 'فَجَعَلَ مِنْهُ ٱلزَّوْجَيْنِ ٱلذَّكَرَ وَٱلْأُنثَىٰٓ',
		number_in_surah: '39',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5591',
		number: '5591',
		text: 'أَلَيْسَ ذَٰلِكَ بِقَٰدِرٍ عَلَىٰٓ أَن يُحْۦِىَ ٱلْمَوْتَىٰ',
		number_in_surah: '40',
		page: '578',
		surah_id: '75',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5592',
		number: '5592',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ هَلْ أَتَىٰ عَلَى ٱلْإِنسَٰنِ حِينٌۭ مِّنَ ٱلدَّهْرِ لَمْ يَكُن شَيْـًۭٔا مَّذْكُورًا',
		number_in_surah: '1',
		page: '578',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5593',
		number: '5593',
		text: 'إِنَّا خَلَقْنَا ٱلْإِنسَٰنَ مِن نُّطْفَةٍ أَمْشَاجٍۢ نَّبْتَلِيهِ فَجَعَلْنَٰهُ سَمِيعًۢا بَصِيرًا',
		number_in_surah: '2',
		page: '578',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5594',
		number: '5594',
		text: 'إِنَّا هَدَيْنَٰهُ ٱلسَّبِيلَ إِمَّا شَاكِرًۭا وَإِمَّا كَفُورًا',
		number_in_surah: '3',
		page: '578',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5595',
		number: '5595',
		text: 'إِنَّآ أَعْتَدْنَا لِلْكَٰفِرِينَ سَلَٰسِلَا۟ وَأَغْلَٰلًۭا وَسَعِيرًا',
		number_in_surah: '4',
		page: '578',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5596',
		number: '5596',
		text: 'إِنَّ ٱلْأَبْرَارَ يَشْرَبُونَ مِن كَأْسٍۢ كَانَ مِزَاجُهَا كَافُورًا',
		number_in_surah: '5',
		page: '578',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5597',
		number: '5597',
		text: 'عَيْنًۭا يَشْرَبُ بِهَا عِبَادُ ٱللَّهِ يُفَجِّرُونَهَا تَفْجِيرًۭا',
		number_in_surah: '6',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5598',
		number: '5598',
		text: 'يُوفُونَ بِٱلنَّذْرِ وَيَخَافُونَ يَوْمًۭا كَانَ شَرُّهُۥ مُسْتَطِيرًۭا',
		number_in_surah: '7',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5599',
		number: '5599',
		text: 'وَيُطْعِمُونَ ٱلطَّعَامَ عَلَىٰ حُبِّهِۦ مِسْكِينًۭا وَيَتِيمًۭا وَأَسِيرًا',
		number_in_surah: '8',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5600',
		number: '5600',
		text: 'إِنَّمَا نُطْعِمُكُمْ لِوَجْهِ ٱللَّهِ لَا نُرِيدُ مِنكُمْ جَزَآءًۭ وَلَا شُكُورًا',
		number_in_surah: '9',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5601',
		number: '5601',
		text: 'إِنَّا نَخَافُ مِن رَّبِّنَا يَوْمًا عَبُوسًۭا قَمْطَرِيرًۭا',
		number_in_surah: '10',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5602',
		number: '5602',
		text: 'فَوَقَىٰهُمُ ٱللَّهُ شَرَّ ذَٰلِكَ ٱلْيَوْمِ وَلَقَّىٰهُمْ نَضْرَةًۭ وَسُرُورًۭا',
		number_in_surah: '11',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5603',
		number: '5603',
		text: 'وَجَزَىٰهُم بِمَا صَبَرُوا۟ جَنَّةًۭ وَحَرِيرًۭا',
		number_in_surah: '12',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5604',
		number: '5604',
		text: 'مُّتَّكِـِٔينَ فِيهَا عَلَى ٱلْأَرَآئِكِ ۖ لَا يَرَوْنَ فِيهَا شَمْسًۭا وَلَا زَمْهَرِيرًۭا',
		number_in_surah: '13',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5605',
		number: '5605',
		text: 'وَدَانِيَةً عَلَيْهِمْ ظِلَٰلُهَا وَذُلِّلَتْ قُطُوفُهَا تَذْلِيلًۭا',
		number_in_surah: '14',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5606',
		number: '5606',
		text: 'وَيُطَافُ عَلَيْهِم بِـَٔانِيَةٍۢ مِّن فِضَّةٍۢ وَأَكْوَابٍۢ كَانَتْ قَوَارِيرَا۠',
		number_in_surah: '15',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5607',
		number: '5607',
		text: 'قَوَارِيرَا۟ مِن فِضَّةٍۢ قَدَّرُوهَا تَقْدِيرًۭا',
		number_in_surah: '16',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5608',
		number: '5608',
		text: 'وَيُسْقَوْنَ فِيهَا كَأْسًۭا كَانَ مِزَاجُهَا زَنجَبِيلًا',
		number_in_surah: '17',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5609',
		number: '5609',
		text: 'عَيْنًۭا فِيهَا تُسَمَّىٰ سَلْسَبِيلًۭا',
		number_in_surah: '18',
		page: '579',
		surah_id: '76',
		hizb_id: '231',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5610',
		number: '5610',
		text: '۞ وَيَطُوفُ عَلَيْهِمْ وِلْدَٰنٌۭ مُّخَلَّدُونَ إِذَا رَأَيْتَهُمْ حَسِبْتَهُمْ لُؤْلُؤًۭا مَّنثُورًۭا',
		number_in_surah: '19',
		page: '579',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5611',
		number: '5611',
		text: 'وَإِذَا رَأَيْتَ ثَمَّ رَأَيْتَ نَعِيمًۭا وَمُلْكًۭا كَبِيرًا',
		number_in_surah: '20',
		page: '579',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5612',
		number: '5612',
		text: 'عَٰلِيَهُمْ ثِيَابُ سُندُسٍ خُضْرٌۭ وَإِسْتَبْرَقٌۭ ۖ وَحُلُّوٓا۟ أَسَاوِرَ مِن فِضَّةٍۢ وَسَقَىٰهُمْ رَبُّهُمْ شَرَابًۭا طَهُورًا',
		number_in_surah: '21',
		page: '579',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5613',
		number: '5613',
		text: 'إِنَّ هَٰذَا كَانَ لَكُمْ جَزَآءًۭ وَكَانَ سَعْيُكُم مَّشْكُورًا',
		number_in_surah: '22',
		page: '579',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5614',
		number: '5614',
		text: 'إِنَّا نَحْنُ نَزَّلْنَا عَلَيْكَ ٱلْقُرْءَانَ تَنزِيلًۭا',
		number_in_surah: '23',
		page: '579',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5615',
		number: '5615',
		text: 'فَٱصْبِرْ لِحُكْمِ رَبِّكَ وَلَا تُطِعْ مِنْهُمْ ءَاثِمًا أَوْ كَفُورًۭا',
		number_in_surah: '24',
		page: '579',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5616',
		number: '5616',
		text: 'وَٱذْكُرِ ٱسْمَ رَبِّكَ بُكْرَةًۭ وَأَصِيلًۭا',
		number_in_surah: '25',
		page: '579',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5617',
		number: '5617',
		text: 'وَمِنَ ٱلَّيْلِ فَٱسْجُدْ لَهُۥ وَسَبِّحْهُ لَيْلًۭا طَوِيلًا',
		number_in_surah: '26',
		page: '580',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5618',
		number: '5618',
		text: 'إِنَّ هَٰٓؤُلَآءِ يُحِبُّونَ ٱلْعَاجِلَةَ وَيَذَرُونَ وَرَآءَهُمْ يَوْمًۭا ثَقِيلًۭا',
		number_in_surah: '27',
		page: '580',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5619',
		number: '5619',
		text: 'نَّحْنُ خَلَقْنَٰهُمْ وَشَدَدْنَآ أَسْرَهُمْ ۖ وَإِذَا شِئْنَا بَدَّلْنَآ أَمْثَٰلَهُمْ تَبْدِيلًا',
		number_in_surah: '28',
		page: '580',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5620',
		number: '5620',
		text: 'إِنَّ هَٰذِهِۦ تَذْكِرَةٌۭ ۖ فَمَن شَآءَ ٱتَّخَذَ إِلَىٰ رَبِّهِۦ سَبِيلًۭا',
		number_in_surah: '29',
		page: '580',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5621',
		number: '5621',
		text: 'وَمَا تَشَآءُونَ إِلَّآ أَن يَشَآءَ ٱللَّهُ ۚ إِنَّ ٱللَّهَ كَانَ عَلِيمًا حَكِيمًۭا',
		number_in_surah: '30',
		page: '580',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5622',
		number: '5622',
		text: 'يُدْخِلُ مَن يَشَآءُ فِى رَحْمَتِهِۦ ۚ وَٱلظَّٰلِمِينَ أَعَدَّ لَهُمْ عَذَابًا أَلِيمًۢا',
		number_in_surah: '31',
		page: '580',
		surah_id: '76',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5623',
		number: '5623',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلْمُرْسَلَٰتِ عُرْفًۭا',
		number_in_surah: '1',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5624',
		number: '5624',
		text: 'فَٱلْعَٰصِفَٰتِ عَصْفًۭا',
		number_in_surah: '2',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5625',
		number: '5625',
		text: 'وَٱلنَّٰشِرَٰتِ نَشْرًۭا',
		number_in_surah: '3',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5626',
		number: '5626',
		text: 'فَٱلْفَٰرِقَٰتِ فَرْقًۭا',
		number_in_surah: '4',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5627',
		number: '5627',
		text: 'فَٱلْمُلْقِيَٰتِ ذِكْرًا',
		number_in_surah: '5',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5628',
		number: '5628',
		text: 'عُذْرًا أَوْ نُذْرًا',
		number_in_surah: '6',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5629',
		number: '5629',
		text: 'إِنَّمَا تُوعَدُونَ لَوَٰقِعٌۭ',
		number_in_surah: '7',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5630',
		number: '5630',
		text: 'فَإِذَا ٱلنُّجُومُ طُمِسَتْ',
		number_in_surah: '8',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5631',
		number: '5631',
		text: 'وَإِذَا ٱلسَّمَآءُ فُرِجَتْ',
		number_in_surah: '9',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5632',
		number: '5632',
		text: 'وَإِذَا ٱلْجِبَالُ نُسِفَتْ',
		number_in_surah: '10',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5633',
		number: '5633',
		text: 'وَإِذَا ٱلرُّسُلُ أُقِّتَتْ',
		number_in_surah: '11',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5634',
		number: '5634',
		text: 'لِأَىِّ يَوْمٍ أُجِّلَتْ',
		number_in_surah: '12',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5635',
		number: '5635',
		text: 'لِيَوْمِ ٱلْفَصْلِ',
		number_in_surah: '13',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5636',
		number: '5636',
		text: 'وَمَآ أَدْرَىٰكَ مَا يَوْمُ ٱلْفَصْلِ',
		number_in_surah: '14',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5637',
		number: '5637',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '15',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5638',
		number: '5638',
		text: 'أَلَمْ نُهْلِكِ ٱلْأَوَّلِينَ',
		number_in_surah: '16',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5639',
		number: '5639',
		text: 'ثُمَّ نُتْبِعُهُمُ ٱلْءَاخِرِينَ',
		number_in_surah: '17',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5640',
		number: '5640',
		text: 'كَذَٰلِكَ نَفْعَلُ بِٱلْمُجْرِمِينَ',
		number_in_surah: '18',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5641',
		number: '5641',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '19',
		page: '580',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5642',
		number: '5642',
		text: 'أَلَمْ نَخْلُقكُّم مِّن مَّآءٍۢ مَّهِينٍۢ',
		number_in_surah: '20',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5643',
		number: '5643',
		text: 'فَجَعَلْنَٰهُ فِى قَرَارٍۢ مَّكِينٍ',
		number_in_surah: '21',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:19',
		updated_at: '2018-06-07 08:07:19',
	},
	{
		id: '5644',
		number: '5644',
		text: 'إِلَىٰ قَدَرٍۢ مَّعْلُومٍۢ',
		number_in_surah: '22',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5645',
		number: '5645',
		text: 'فَقَدَرْنَا فَنِعْمَ ٱلْقَٰدِرُونَ',
		number_in_surah: '23',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5646',
		number: '5646',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '24',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5647',
		number: '5647',
		text: 'أَلَمْ نَجْعَلِ ٱلْأَرْضَ كِفَاتًا',
		number_in_surah: '25',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5648',
		number: '5648',
		text: 'أَحْيَآءًۭ وَأَمْوَٰتًۭا',
		number_in_surah: '26',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5649',
		number: '5649',
		text: 'وَجَعَلْنَا فِيهَا رَوَٰسِىَ شَٰمِخَٰتٍۢ وَأَسْقَيْنَٰكُم مَّآءًۭ فُرَاتًۭا',
		number_in_surah: '27',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5650',
		number: '5650',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '28',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5651',
		number: '5651',
		text: 'ٱنطَلِقُوٓا۟ إِلَىٰ مَا كُنتُم بِهِۦ تُكَذِّبُونَ',
		number_in_surah: '29',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5652',
		number: '5652',
		text: 'ٱنطَلِقُوٓا۟ إِلَىٰ ظِلٍّۢ ذِى ثَلَٰثِ شُعَبٍۢ',
		number_in_surah: '30',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5653',
		number: '5653',
		text: 'لَّا ظَلِيلٍۢ وَلَا يُغْنِى مِنَ ٱللَّهَبِ',
		number_in_surah: '31',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5654',
		number: '5654',
		text: 'إِنَّهَا تَرْمِى بِشَرَرٍۢ كَٱلْقَصْرِ',
		number_in_surah: '32',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5655',
		number: '5655',
		text: 'كَأَنَّهُۥ جِمَٰلَتٌۭ صُفْرٌۭ',
		number_in_surah: '33',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5656',
		number: '5656',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '34',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5657',
		number: '5657',
		text: 'هَٰذَا يَوْمُ لَا يَنطِقُونَ',
		number_in_surah: '35',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5658',
		number: '5658',
		text: 'وَلَا يُؤْذَنُ لَهُمْ فَيَعْتَذِرُونَ',
		number_in_surah: '36',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5659',
		number: '5659',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '37',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5660',
		number: '5660',
		text: 'هَٰذَا يَوْمُ ٱلْفَصْلِ ۖ جَمَعْنَٰكُمْ وَٱلْأَوَّلِينَ',
		number_in_surah: '38',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5661',
		number: '5661',
		text: 'فَإِن كَانَ لَكُمْ كَيْدٌۭ فَكِيدُونِ',
		number_in_surah: '39',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5662',
		number: '5662',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '40',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5663',
		number: '5663',
		text: 'إِنَّ ٱلْمُتَّقِينَ فِى ظِلَٰلٍۢ وَعُيُونٍۢ',
		number_in_surah: '41',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5664',
		number: '5664',
		text: 'وَفَوَٰكِهَ مِمَّا يَشْتَهُونَ',
		number_in_surah: '42',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5665',
		number: '5665',
		text: 'كُلُوا۟ وَٱشْرَبُوا۟ هَنِيٓـًٔۢا بِمَا كُنتُمْ تَعْمَلُونَ',
		number_in_surah: '43',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5666',
		number: '5666',
		text: 'إِنَّا كَذَٰلِكَ نَجْزِى ٱلْمُحْسِنِينَ',
		number_in_surah: '44',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5667',
		number: '5667',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '45',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5668',
		number: '5668',
		text: 'كُلُوا۟ وَتَمَتَّعُوا۟ قَلِيلًا إِنَّكُم مُّجْرِمُونَ',
		number_in_surah: '46',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5669',
		number: '5669',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '47',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5670',
		number: '5670',
		text: 'وَإِذَا قِيلَ لَهُمُ ٱرْكَعُوا۟ لَا يَرْكَعُونَ',
		number_in_surah: '48',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5671',
		number: '5671',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '49',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5672',
		number: '5672',
		text: 'فَبِأَىِّ حَدِيثٍۭ بَعْدَهُۥ يُؤْمِنُونَ',
		number_in_surah: '50',
		page: '581',
		surah_id: '77',
		hizb_id: '232',
		juz_id: '29',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5673',
		number: '5673',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ عَمَّ يَتَسَآءَلُونَ',
		number_in_surah: '1',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5674',
		number: '5674',
		text: 'عَنِ ٱلنَّبَإِ ٱلْعَظِيمِ',
		number_in_surah: '2',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5675',
		number: '5675',
		text: 'ٱلَّذِى هُمْ فِيهِ مُخْتَلِفُونَ',
		number_in_surah: '3',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5676',
		number: '5676',
		text: 'كَلَّا سَيَعْلَمُونَ',
		number_in_surah: '4',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5677',
		number: '5677',
		text: 'ثُمَّ كَلَّا سَيَعْلَمُونَ',
		number_in_surah: '5',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5678',
		number: '5678',
		text: 'أَلَمْ نَجْعَلِ ٱلْأَرْضَ مِهَٰدًۭا',
		number_in_surah: '6',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5679',
		number: '5679',
		text: 'وَٱلْجِبَالَ أَوْتَادًۭا',
		number_in_surah: '7',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5680',
		number: '5680',
		text: 'وَخَلَقْنَٰكُمْ أَزْوَٰجًۭا',
		number_in_surah: '8',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5681',
		number: '5681',
		text: 'وَجَعَلْنَا نَوْمَكُمْ سُبَاتًۭا',
		number_in_surah: '9',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5682',
		number: '5682',
		text: 'وَجَعَلْنَا ٱلَّيْلَ لِبَاسًۭا',
		number_in_surah: '10',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5683',
		number: '5683',
		text: 'وَجَعَلْنَا ٱلنَّهَارَ مَعَاشًۭا',
		number_in_surah: '11',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5684',
		number: '5684',
		text: 'وَبَنَيْنَا فَوْقَكُمْ سَبْعًۭا شِدَادًۭا',
		number_in_surah: '12',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5685',
		number: '5685',
		text: 'وَجَعَلْنَا سِرَاجًۭا وَهَّاجًۭا',
		number_in_surah: '13',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5686',
		number: '5686',
		text: 'وَأَنزَلْنَا مِنَ ٱلْمُعْصِرَٰتِ مَآءًۭ ثَجَّاجًۭا',
		number_in_surah: '14',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5687',
		number: '5687',
		text: 'لِّنُخْرِجَ بِهِۦ حَبًّۭا وَنَبَاتًۭا',
		number_in_surah: '15',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5688',
		number: '5688',
		text: 'وَجَنَّٰتٍ أَلْفَافًا',
		number_in_surah: '16',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5689',
		number: '5689',
		text: 'إِنَّ يَوْمَ ٱلْفَصْلِ كَانَ مِيقَٰتًۭا',
		number_in_surah: '17',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5690',
		number: '5690',
		text: 'يَوْمَ يُنفَخُ فِى ٱلصُّورِ فَتَأْتُونَ أَفْوَاجًۭا',
		number_in_surah: '18',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5691',
		number: '5691',
		text: 'وَفُتِحَتِ ٱلسَّمَآءُ فَكَانَتْ أَبْوَٰبًۭا',
		number_in_surah: '19',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5692',
		number: '5692',
		text: 'وَسُيِّرَتِ ٱلْجِبَالُ فَكَانَتْ سَرَابًا',
		number_in_surah: '20',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5693',
		number: '5693',
		text: 'إِنَّ جَهَنَّمَ كَانَتْ مِرْصَادًۭا',
		number_in_surah: '21',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5694',
		number: '5694',
		text: 'لِّلطَّٰغِينَ مَـَٔابًۭا',
		number_in_surah: '22',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5695',
		number: '5695',
		text: 'لَّٰبِثِينَ فِيهَآ أَحْقَابًۭا',
		number_in_surah: '23',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5696',
		number: '5696',
		text: 'لَّا يَذُوقُونَ فِيهَا بَرْدًۭا وَلَا شَرَابًا',
		number_in_surah: '24',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5697',
		number: '5697',
		text: 'إِلَّا حَمِيمًۭا وَغَسَّاقًۭا',
		number_in_surah: '25',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5698',
		number: '5698',
		text: 'جَزَآءًۭ وِفَاقًا',
		number_in_surah: '26',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5699',
		number: '5699',
		text: 'إِنَّهُمْ كَانُوا۟ لَا يَرْجُونَ حِسَابًۭا',
		number_in_surah: '27',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5700',
		number: '5700',
		text: 'وَكَذَّبُوا۟ بِـَٔايَٰتِنَا كِذَّابًۭا',
		number_in_surah: '28',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5701',
		number: '5701',
		text: 'وَكُلَّ شَىْءٍ أَحْصَيْنَٰهُ كِتَٰبًۭا',
		number_in_surah: '29',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5702',
		number: '5702',
		text: 'فَذُوقُوا۟ فَلَن نَّزِيدَكُمْ إِلَّا عَذَابًا',
		number_in_surah: '30',
		page: '582',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5703',
		number: '5703',
		text: 'إِنَّ لِلْمُتَّقِينَ مَفَازًا',
		number_in_surah: '31',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5704',
		number: '5704',
		text: 'حَدَآئِقَ وَأَعْنَٰبًۭا',
		number_in_surah: '32',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5705',
		number: '5705',
		text: 'وَكَوَاعِبَ أَتْرَابًۭا',
		number_in_surah: '33',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5706',
		number: '5706',
		text: 'وَكَأْسًۭا دِهَاقًۭا',
		number_in_surah: '34',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5707',
		number: '5707',
		text: 'لَّا يَسْمَعُونَ فِيهَا لَغْوًۭا وَلَا كِذَّٰبًۭا',
		number_in_surah: '35',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5708',
		number: '5708',
		text: 'جَزَآءًۭ مِّن رَّبِّكَ عَطَآءً حِسَابًۭا',
		number_in_surah: '36',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5709',
		number: '5709',
		text: 'رَّبِّ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ وَمَا بَيْنَهُمَا ٱلرَّحْمَٰنِ ۖ لَا يَمْلِكُونَ مِنْهُ خِطَابًۭا',
		number_in_surah: '37',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5710',
		number: '5710',
		text: 'يَوْمَ يَقُومُ ٱلرُّوحُ وَٱلْمَلَٰٓئِكَةُ صَفًّۭا ۖ لَّا يَتَكَلَّمُونَ إِلَّا مَنْ أَذِنَ لَهُ ٱلرَّحْمَٰنُ وَقَالَ صَوَابًۭا',
		number_in_surah: '38',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5711',
		number: '5711',
		text: 'ذَٰلِكَ ٱلْيَوْمُ ٱلْحَقُّ ۖ فَمَن شَآءَ ٱتَّخَذَ إِلَىٰ رَبِّهِۦ مَـَٔابًا',
		number_in_surah: '39',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5712',
		number: '5712',
		text: 'إِنَّآ أَنذَرْنَٰكُمْ عَذَابًۭا قَرِيبًۭا يَوْمَ يَنظُرُ ٱلْمَرْءُ مَا قَدَّمَتْ يَدَاهُ وَيَقُولُ ٱلْكَافِرُ يَٰلَيْتَنِى كُنتُ تُرَٰبًۢا',
		number_in_surah: '40',
		page: '583',
		surah_id: '78',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5713',
		number: '5713',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلنَّٰزِعَٰتِ غَرْقًۭا',
		number_in_surah: '1',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5714',
		number: '5714',
		text: 'وَٱلنَّٰشِطَٰتِ نَشْطًۭا',
		number_in_surah: '2',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5715',
		number: '5715',
		text: 'وَٱلسَّٰبِحَٰتِ سَبْحًۭا',
		number_in_surah: '3',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5716',
		number: '5716',
		text: 'فَٱلسَّٰبِقَٰتِ سَبْقًۭا',
		number_in_surah: '4',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5717',
		number: '5717',
		text: 'فَٱلْمُدَبِّرَٰتِ أَمْرًۭا',
		number_in_surah: '5',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5718',
		number: '5718',
		text: 'يَوْمَ تَرْجُفُ ٱلرَّاجِفَةُ',
		number_in_surah: '6',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5719',
		number: '5719',
		text: 'تَتْبَعُهَا ٱلرَّادِفَةُ',
		number_in_surah: '7',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5720',
		number: '5720',
		text: 'قُلُوبٌۭ يَوْمَئِذٍۢ وَاجِفَةٌ',
		number_in_surah: '8',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5721',
		number: '5721',
		text: 'أَبْصَٰرُهَا خَٰشِعَةٌۭ',
		number_in_surah: '9',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5722',
		number: '5722',
		text: 'يَقُولُونَ أَءِنَّا لَمَرْدُودُونَ فِى ٱلْحَافِرَةِ',
		number_in_surah: '10',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5723',
		number: '5723',
		text: 'أَءِذَا كُنَّا عِظَٰمًۭا نَّخِرَةًۭ',
		number_in_surah: '11',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5724',
		number: '5724',
		text: 'قَالُوا۟ تِلْكَ إِذًۭا كَرَّةٌ خَاسِرَةٌۭ',
		number_in_surah: '12',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5725',
		number: '5725',
		text: 'فَإِنَّمَا هِىَ زَجْرَةٌۭ وَٰحِدَةٌۭ',
		number_in_surah: '13',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5726',
		number: '5726',
		text: 'فَإِذَا هُم بِٱلسَّاهِرَةِ',
		number_in_surah: '14',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5727',
		number: '5727',
		text: 'هَلْ أَتَىٰكَ حَدِيثُ مُوسَىٰٓ',
		number_in_surah: '15',
		page: '583',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5728',
		number: '5728',
		text: 'إِذْ نَادَىٰهُ رَبُّهُۥ بِٱلْوَادِ ٱلْمُقَدَّسِ طُوًى',
		number_in_surah: '16',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5729',
		number: '5729',
		text: 'ٱذْهَبْ إِلَىٰ فِرْعَوْنَ إِنَّهُۥ طَغَىٰ',
		number_in_surah: '17',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5730',
		number: '5730',
		text: 'فَقُلْ هَل لَّكَ إِلَىٰٓ أَن تَزَكَّىٰ',
		number_in_surah: '18',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5731',
		number: '5731',
		text: 'وَأَهْدِيَكَ إِلَىٰ رَبِّكَ فَتَخْشَىٰ',
		number_in_surah: '19',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5732',
		number: '5732',
		text: 'فَأَرَىٰهُ ٱلْءَايَةَ ٱلْكُبْرَىٰ',
		number_in_surah: '20',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5733',
		number: '5733',
		text: 'فَكَذَّبَ وَعَصَىٰ',
		number_in_surah: '21',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5734',
		number: '5734',
		text: 'ثُمَّ أَدْبَرَ يَسْعَىٰ',
		number_in_surah: '22',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5735',
		number: '5735',
		text: 'فَحَشَرَ فَنَادَىٰ',
		number_in_surah: '23',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5736',
		number: '5736',
		text: 'فَقَالَ أَنَا۠ رَبُّكُمُ ٱلْأَعْلَىٰ',
		number_in_surah: '24',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5737',
		number: '5737',
		text: 'فَأَخَذَهُ ٱللَّهُ نَكَالَ ٱلْءَاخِرَةِ وَٱلْأُولَىٰٓ',
		number_in_surah: '25',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5738',
		number: '5738',
		text: 'إِنَّ فِى ذَٰلِكَ لَعِبْرَةًۭ لِّمَن يَخْشَىٰٓ',
		number_in_surah: '26',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5739',
		number: '5739',
		text: 'ءَأَنتُمْ أَشَدُّ خَلْقًا أَمِ ٱلسَّمَآءُ ۚ بَنَىٰهَا',
		number_in_surah: '27',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5740',
		number: '5740',
		text: 'رَفَعَ سَمْكَهَا فَسَوَّىٰهَا',
		number_in_surah: '28',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5741',
		number: '5741',
		text: 'وَأَغْطَشَ لَيْلَهَا وَأَخْرَجَ ضُحَىٰهَا',
		number_in_surah: '29',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5742',
		number: '5742',
		text: 'وَٱلْأَرْضَ بَعْدَ ذَٰلِكَ دَحَىٰهَآ',
		number_in_surah: '30',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5743',
		number: '5743',
		text: 'أَخْرَجَ مِنْهَا مَآءَهَا وَمَرْعَىٰهَا',
		number_in_surah: '31',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5744',
		number: '5744',
		text: 'وَٱلْجِبَالَ أَرْسَىٰهَا',
		number_in_surah: '32',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5745',
		number: '5745',
		text: 'مَتَٰعًۭا لَّكُمْ وَلِأَنْعَٰمِكُمْ',
		number_in_surah: '33',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5746',
		number: '5746',
		text: 'فَإِذَا جَآءَتِ ٱلطَّآمَّةُ ٱلْكُبْرَىٰ',
		number_in_surah: '34',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5747',
		number: '5747',
		text: 'يَوْمَ يَتَذَكَّرُ ٱلْإِنسَٰنُ مَا سَعَىٰ',
		number_in_surah: '35',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5748',
		number: '5748',
		text: 'وَبُرِّزَتِ ٱلْجَحِيمُ لِمَن يَرَىٰ',
		number_in_surah: '36',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5749',
		number: '5749',
		text: 'فَأَمَّا مَن طَغَىٰ',
		number_in_surah: '37',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5750',
		number: '5750',
		text: 'وَءَاثَرَ ٱلْحَيَوٰةَ ٱلدُّنْيَا',
		number_in_surah: '38',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5751',
		number: '5751',
		text: 'فَإِنَّ ٱلْجَحِيمَ هِىَ ٱلْمَأْوَىٰ',
		number_in_surah: '39',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5752',
		number: '5752',
		text: 'وَأَمَّا مَنْ خَافَ مَقَامَ رَبِّهِۦ وَنَهَى ٱلنَّفْسَ عَنِ ٱلْهَوَىٰ',
		number_in_surah: '40',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5753',
		number: '5753',
		text: 'فَإِنَّ ٱلْجَنَّةَ هِىَ ٱلْمَأْوَىٰ',
		number_in_surah: '41',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5754',
		number: '5754',
		text: 'يَسْـَٔلُونَكَ عَنِ ٱلسَّاعَةِ أَيَّانَ مُرْسَىٰهَا',
		number_in_surah: '42',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5755',
		number: '5755',
		text: 'فِيمَ أَنتَ مِن ذِكْرَىٰهَآ',
		number_in_surah: '43',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5756',
		number: '5756',
		text: 'إِلَىٰ رَبِّكَ مُنتَهَىٰهَآ',
		number_in_surah: '44',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5757',
		number: '5757',
		text: 'إِنَّمَآ أَنتَ مُنذِرُ مَن يَخْشَىٰهَا',
		number_in_surah: '45',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5758',
		number: '5758',
		text: 'كَأَنَّهُمْ يَوْمَ يَرَوْنَهَا لَمْ يَلْبَثُوٓا۟ إِلَّا عَشِيَّةً أَوْ ضُحَىٰهَا',
		number_in_surah: '46',
		page: '584',
		surah_id: '79',
		hizb_id: '233',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5759',
		number: '5759',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ عَبَسَ وَتَوَلَّىٰٓ',
		number_in_surah: '1',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5760',
		number: '5760',
		text: 'أَن جَآءَهُ ٱلْأَعْمَىٰ',
		number_in_surah: '2',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5761',
		number: '5761',
		text: 'وَمَا يُدْرِيكَ لَعَلَّهُۥ يَزَّكَّىٰٓ',
		number_in_surah: '3',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5762',
		number: '5762',
		text: 'أَوْ يَذَّكَّرُ فَتَنفَعَهُ ٱلذِّكْرَىٰٓ',
		number_in_surah: '4',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5763',
		number: '5763',
		text: 'أَمَّا مَنِ ٱسْتَغْنَىٰ',
		number_in_surah: '5',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5764',
		number: '5764',
		text: 'فَأَنتَ لَهُۥ تَصَدَّىٰ',
		number_in_surah: '6',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5765',
		number: '5765',
		text: 'وَمَا عَلَيْكَ أَلَّا يَزَّكَّىٰ',
		number_in_surah: '7',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5766',
		number: '5766',
		text: 'وَأَمَّا مَن جَآءَكَ يَسْعَىٰ',
		number_in_surah: '8',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5767',
		number: '5767',
		text: 'وَهُوَ يَخْشَىٰ',
		number_in_surah: '9',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5768',
		number: '5768',
		text: 'فَأَنتَ عَنْهُ تَلَهَّىٰ',
		number_in_surah: '10',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5769',
		number: '5769',
		text: 'كَلَّآ إِنَّهَا تَذْكِرَةٌۭ',
		number_in_surah: '11',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5770',
		number: '5770',
		text: 'فَمَن شَآءَ ذَكَرَهُۥ',
		number_in_surah: '12',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5771',
		number: '5771',
		text: 'فِى صُحُفٍۢ مُّكَرَّمَةٍۢ',
		number_in_surah: '13',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5772',
		number: '5772',
		text: 'مَّرْفُوعَةٍۢ مُّطَهَّرَةٍۭ',
		number_in_surah: '14',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5773',
		number: '5773',
		text: 'بِأَيْدِى سَفَرَةٍۢ',
		number_in_surah: '15',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5774',
		number: '5774',
		text: 'كِرَامٍۭ بَرَرَةٍۢ',
		number_in_surah: '16',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5775',
		number: '5775',
		text: 'قُتِلَ ٱلْإِنسَٰنُ مَآ أَكْفَرَهُۥ',
		number_in_surah: '17',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5776',
		number: '5776',
		text: 'مِنْ أَىِّ شَىْءٍ خَلَقَهُۥ',
		number_in_surah: '18',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5777',
		number: '5777',
		text: 'مِن نُّطْفَةٍ خَلَقَهُۥ فَقَدَّرَهُۥ',
		number_in_surah: '19',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5778',
		number: '5778',
		text: 'ثُمَّ ٱلسَّبِيلَ يَسَّرَهُۥ',
		number_in_surah: '20',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:20',
		updated_at: '2018-06-07 08:07:20',
	},
	{
		id: '5779',
		number: '5779',
		text: 'ثُمَّ أَمَاتَهُۥ فَأَقْبَرَهُۥ',
		number_in_surah: '21',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5780',
		number: '5780',
		text: 'ثُمَّ إِذَا شَآءَ أَنشَرَهُۥ',
		number_in_surah: '22',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5781',
		number: '5781',
		text: 'كَلَّا لَمَّا يَقْضِ مَآ أَمَرَهُۥ',
		number_in_surah: '23',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5782',
		number: '5782',
		text: 'فَلْيَنظُرِ ٱلْإِنسَٰنُ إِلَىٰ طَعَامِهِۦٓ',
		number_in_surah: '24',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5783',
		number: '5783',
		text: 'أَنَّا صَبَبْنَا ٱلْمَآءَ صَبًّۭا',
		number_in_surah: '25',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5784',
		number: '5784',
		text: 'ثُمَّ شَقَقْنَا ٱلْأَرْضَ شَقًّۭا',
		number_in_surah: '26',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5785',
		number: '5785',
		text: 'فَأَنۢبَتْنَا فِيهَا حَبًّۭا',
		number_in_surah: '27',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5786',
		number: '5786',
		text: 'وَعِنَبًۭا وَقَضْبًۭا',
		number_in_surah: '28',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5787',
		number: '5787',
		text: 'وَزَيْتُونًۭا وَنَخْلًۭا',
		number_in_surah: '29',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5788',
		number: '5788',
		text: 'وَحَدَآئِقَ غُلْبًۭا',
		number_in_surah: '30',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5789',
		number: '5789',
		text: 'وَفَٰكِهَةًۭ وَأَبًّۭا',
		number_in_surah: '31',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5790',
		number: '5790',
		text: 'مَّتَٰعًۭا لَّكُمْ وَلِأَنْعَٰمِكُمْ',
		number_in_surah: '32',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5791',
		number: '5791',
		text: 'فَإِذَا جَآءَتِ ٱلصَّآخَّةُ',
		number_in_surah: '33',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5792',
		number: '5792',
		text: 'يَوْمَ يَفِرُّ ٱلْمَرْءُ مِنْ أَخِيهِ',
		number_in_surah: '34',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5793',
		number: '5793',
		text: 'وَأُمِّهِۦ وَأَبِيهِ',
		number_in_surah: '35',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5794',
		number: '5794',
		text: 'وَصَٰحِبَتِهِۦ وَبَنِيهِ',
		number_in_surah: '36',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5795',
		number: '5795',
		text: 'لِكُلِّ ٱمْرِئٍۢ مِّنْهُمْ يَوْمَئِذٍۢ شَأْنٌۭ يُغْنِيهِ',
		number_in_surah: '37',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5796',
		number: '5796',
		text: 'وُجُوهٌۭ يَوْمَئِذٍۢ مُّسْفِرَةٌۭ',
		number_in_surah: '38',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5797',
		number: '5797',
		text: 'ضَاحِكَةٌۭ مُّسْتَبْشِرَةٌۭ',
		number_in_surah: '39',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5798',
		number: '5798',
		text: 'وَوُجُوهٌۭ يَوْمَئِذٍ عَلَيْهَا غَبَرَةٌۭ',
		number_in_surah: '40',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5799',
		number: '5799',
		text: 'تَرْهَقُهَا قَتَرَةٌ',
		number_in_surah: '41',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5800',
		number: '5800',
		text: 'أُو۟لَٰٓئِكَ هُمُ ٱلْكَفَرَةُ ٱلْفَجَرَةُ',
		number_in_surah: '42',
		page: '585',
		surah_id: '80',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5801',
		number: '5801',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِذَا ٱلشَّمْسُ كُوِّرَتْ',
		number_in_surah: '1',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5802',
		number: '5802',
		text: 'وَإِذَا ٱلنُّجُومُ ٱنكَدَرَتْ',
		number_in_surah: '2',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5803',
		number: '5803',
		text: 'وَإِذَا ٱلْجِبَالُ سُيِّرَتْ',
		number_in_surah: '3',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5804',
		number: '5804',
		text: 'وَإِذَا ٱلْعِشَارُ عُطِّلَتْ',
		number_in_surah: '4',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5805',
		number: '5805',
		text: 'وَإِذَا ٱلْوُحُوشُ حُشِرَتْ',
		number_in_surah: '5',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5806',
		number: '5806',
		text: 'وَإِذَا ٱلْبِحَارُ سُجِّرَتْ',
		number_in_surah: '6',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5807',
		number: '5807',
		text: 'وَإِذَا ٱلنُّفُوسُ زُوِّجَتْ',
		number_in_surah: '7',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5808',
		number: '5808',
		text: 'وَإِذَا ٱلْمَوْءُۥدَةُ سُئِلَتْ',
		number_in_surah: '8',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5809',
		number: '5809',
		text: 'بِأَىِّ ذَنۢبٍۢ قُتِلَتْ',
		number_in_surah: '9',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5810',
		number: '5810',
		text: 'وَإِذَا ٱلصُّحُفُ نُشِرَتْ',
		number_in_surah: '10',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5811',
		number: '5811',
		text: 'وَإِذَا ٱلسَّمَآءُ كُشِطَتْ',
		number_in_surah: '11',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5812',
		number: '5812',
		text: 'وَإِذَا ٱلْجَحِيمُ سُعِّرَتْ',
		number_in_surah: '12',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5813',
		number: '5813',
		text: 'وَإِذَا ٱلْجَنَّةُ أُزْلِفَتْ',
		number_in_surah: '13',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5814',
		number: '5814',
		text: 'عَلِمَتْ نَفْسٌۭ مَّآ أَحْضَرَتْ',
		number_in_surah: '14',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5815',
		number: '5815',
		text: 'فَلَآ أُقْسِمُ بِٱلْخُنَّسِ',
		number_in_surah: '15',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5816',
		number: '5816',
		text: 'ٱلْجَوَارِ ٱلْكُنَّسِ',
		number_in_surah: '16',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5817',
		number: '5817',
		text: 'وَٱلَّيْلِ إِذَا عَسْعَسَ',
		number_in_surah: '17',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5818',
		number: '5818',
		text: 'وَٱلصُّبْحِ إِذَا تَنَفَّسَ',
		number_in_surah: '18',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5819',
		number: '5819',
		text: 'إِنَّهُۥ لَقَوْلُ رَسُولٍۢ كَرِيمٍۢ',
		number_in_surah: '19',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5820',
		number: '5820',
		text: 'ذِى قُوَّةٍ عِندَ ذِى ٱلْعَرْشِ مَكِينٍۢ',
		number_in_surah: '20',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5821',
		number: '5821',
		text: 'مُّطَاعٍۢ ثَمَّ أَمِينٍۢ',
		number_in_surah: '21',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5822',
		number: '5822',
		text: 'وَمَا صَاحِبُكُم بِمَجْنُونٍۢ',
		number_in_surah: '22',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5823',
		number: '5823',
		text: 'وَلَقَدْ رَءَاهُ بِٱلْأُفُقِ ٱلْمُبِينِ',
		number_in_surah: '23',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5824',
		number: '5824',
		text: 'وَمَا هُوَ عَلَى ٱلْغَيْبِ بِضَنِينٍۢ',
		number_in_surah: '24',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5825',
		number: '5825',
		text: 'وَمَا هُوَ بِقَوْلِ شَيْطَٰنٍۢ رَّجِيمٍۢ',
		number_in_surah: '25',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5826',
		number: '5826',
		text: 'فَأَيْنَ تَذْهَبُونَ',
		number_in_surah: '26',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5827',
		number: '5827',
		text: 'إِنْ هُوَ إِلَّا ذِكْرٌۭ لِّلْعَٰلَمِينَ',
		number_in_surah: '27',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5828',
		number: '5828',
		text: 'لِمَن شَآءَ مِنكُمْ أَن يَسْتَقِيمَ',
		number_in_surah: '28',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5829',
		number: '5829',
		text: 'وَمَا تَشَآءُونَ إِلَّآ أَن يَشَآءَ ٱللَّهُ رَبُّ ٱلْعَٰلَمِينَ',
		number_in_surah: '29',
		page: '586',
		surah_id: '81',
		hizb_id: '234',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5830',
		number: '5830',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِذَا ٱلسَّمَآءُ ٱنفَطَرَتْ',
		number_in_surah: '1',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5831',
		number: '5831',
		text: 'وَإِذَا ٱلْكَوَاكِبُ ٱنتَثَرَتْ',
		number_in_surah: '2',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5832',
		number: '5832',
		text: 'وَإِذَا ٱلْبِحَارُ فُجِّرَتْ',
		number_in_surah: '3',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5833',
		number: '5833',
		text: 'وَإِذَا ٱلْقُبُورُ بُعْثِرَتْ',
		number_in_surah: '4',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5834',
		number: '5834',
		text: 'عَلِمَتْ نَفْسٌۭ مَّا قَدَّمَتْ وَأَخَّرَتْ',
		number_in_surah: '5',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5835',
		number: '5835',
		text: 'يَٰٓأَيُّهَا ٱلْإِنسَٰنُ مَا غَرَّكَ بِرَبِّكَ ٱلْكَرِيمِ',
		number_in_surah: '6',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5836',
		number: '5836',
		text: 'ٱلَّذِى خَلَقَكَ فَسَوَّىٰكَ فَعَدَلَكَ',
		number_in_surah: '7',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5837',
		number: '5837',
		text: 'فِىٓ أَىِّ صُورَةٍۢ مَّا شَآءَ رَكَّبَكَ',
		number_in_surah: '8',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5838',
		number: '5838',
		text: 'كَلَّا بَلْ تُكَذِّبُونَ بِٱلدِّينِ',
		number_in_surah: '9',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5839',
		number: '5839',
		text: 'وَإِنَّ عَلَيْكُمْ لَحَٰفِظِينَ',
		number_in_surah: '10',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5840',
		number: '5840',
		text: 'كِرَامًۭا كَٰتِبِينَ',
		number_in_surah: '11',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5841',
		number: '5841',
		text: 'يَعْلَمُونَ مَا تَفْعَلُونَ',
		number_in_surah: '12',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5842',
		number: '5842',
		text: 'إِنَّ ٱلْأَبْرَارَ لَفِى نَعِيمٍۢ',
		number_in_surah: '13',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5843',
		number: '5843',
		text: 'وَإِنَّ ٱلْفُجَّارَ لَفِى جَحِيمٍۢ',
		number_in_surah: '14',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5844',
		number: '5844',
		text: 'يَصْلَوْنَهَا يَوْمَ ٱلدِّينِ',
		number_in_surah: '15',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5845',
		number: '5845',
		text: 'وَمَا هُمْ عَنْهَا بِغَآئِبِينَ',
		number_in_surah: '16',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5846',
		number: '5846',
		text: 'وَمَآ أَدْرَىٰكَ مَا يَوْمُ ٱلدِّينِ',
		number_in_surah: '17',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5847',
		number: '5847',
		text: 'ثُمَّ مَآ أَدْرَىٰكَ مَا يَوْمُ ٱلدِّينِ',
		number_in_surah: '18',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5848',
		number: '5848',
		text: 'يَوْمَ لَا تَمْلِكُ نَفْسٌۭ لِّنَفْسٍۢ شَيْـًۭٔا ۖ وَٱلْأَمْرُ يَوْمَئِذٍۢ لِّلَّهِ',
		number_in_surah: '19',
		page: '587',
		surah_id: '82',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5849',
		number: '5849',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَيْلٌۭ لِّلْمُطَفِّفِينَ',
		number_in_surah: '1',
		page: '587',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5850',
		number: '5850',
		text: 'ٱلَّذِينَ إِذَا ٱكْتَالُوا۟ عَلَى ٱلنَّاسِ يَسْتَوْفُونَ',
		number_in_surah: '2',
		page: '587',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5851',
		number: '5851',
		text: 'وَإِذَا كَالُوهُمْ أَو وَّزَنُوهُمْ يُخْسِرُونَ',
		number_in_surah: '3',
		page: '587',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5852',
		number: '5852',
		text: 'أَلَا يَظُنُّ أُو۟لَٰٓئِكَ أَنَّهُم مَّبْعُوثُونَ',
		number_in_surah: '4',
		page: '587',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5853',
		number: '5853',
		text: 'لِيَوْمٍ عَظِيمٍۢ',
		number_in_surah: '5',
		page: '587',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5854',
		number: '5854',
		text: 'يَوْمَ يَقُومُ ٱلنَّاسُ لِرَبِّ ٱلْعَٰلَمِينَ',
		number_in_surah: '6',
		page: '587',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5855',
		number: '5855',
		text: 'كَلَّآ إِنَّ كِتَٰبَ ٱلْفُجَّارِ لَفِى سِجِّينٍۢ',
		number_in_surah: '7',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5856',
		number: '5856',
		text: 'وَمَآ أَدْرَىٰكَ مَا سِجِّينٌۭ',
		number_in_surah: '8',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5857',
		number: '5857',
		text: 'كِتَٰبٌۭ مَّرْقُومٌۭ',
		number_in_surah: '9',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5858',
		number: '5858',
		text: 'وَيْلٌۭ يَوْمَئِذٍۢ لِّلْمُكَذِّبِينَ',
		number_in_surah: '10',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5859',
		number: '5859',
		text: 'ٱلَّذِينَ يُكَذِّبُونَ بِيَوْمِ ٱلدِّينِ',
		number_in_surah: '11',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5860',
		number: '5860',
		text: 'وَمَا يُكَذِّبُ بِهِۦٓ إِلَّا كُلُّ مُعْتَدٍ أَثِيمٍ',
		number_in_surah: '12',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5861',
		number: '5861',
		text: 'إِذَا تُتْلَىٰ عَلَيْهِ ءَايَٰتُنَا قَالَ أَسَٰطِيرُ ٱلْأَوَّلِينَ',
		number_in_surah: '13',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5862',
		number: '5862',
		text: 'كَلَّا ۖ بَلْ ۜ رَانَ عَلَىٰ قُلُوبِهِم مَّا كَانُوا۟ يَكْسِبُونَ',
		number_in_surah: '14',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5863',
		number: '5863',
		text: 'كَلَّآ إِنَّهُمْ عَن رَّبِّهِمْ يَوْمَئِذٍۢ لَّمَحْجُوبُونَ',
		number_in_surah: '15',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5864',
		number: '5864',
		text: 'ثُمَّ إِنَّهُمْ لَصَالُوا۟ ٱلْجَحِيمِ',
		number_in_surah: '16',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5865',
		number: '5865',
		text: 'ثُمَّ يُقَالُ هَٰذَا ٱلَّذِى كُنتُم بِهِۦ تُكَذِّبُونَ',
		number_in_surah: '17',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5866',
		number: '5866',
		text: 'كَلَّآ إِنَّ كِتَٰبَ ٱلْأَبْرَارِ لَفِى عِلِّيِّينَ',
		number_in_surah: '18',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5867',
		number: '5867',
		text: 'وَمَآ أَدْرَىٰكَ مَا عِلِّيُّونَ',
		number_in_surah: '19',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5868',
		number: '5868',
		text: 'كِتَٰبٌۭ مَّرْقُومٌۭ',
		number_in_surah: '20',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5869',
		number: '5869',
		text: 'يَشْهَدُهُ ٱلْمُقَرَّبُونَ',
		number_in_surah: '21',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5870',
		number: '5870',
		text: 'إِنَّ ٱلْأَبْرَارَ لَفِى نَعِيمٍ',
		number_in_surah: '22',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5871',
		number: '5871',
		text: 'عَلَى ٱلْأَرَآئِكِ يَنظُرُونَ',
		number_in_surah: '23',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5872',
		number: '5872',
		text: 'تَعْرِفُ فِى وُجُوهِهِمْ نَضْرَةَ ٱلنَّعِيمِ',
		number_in_surah: '24',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5873',
		number: '5873',
		text: 'يُسْقَوْنَ مِن رَّحِيقٍۢ مَّخْتُومٍ',
		number_in_surah: '25',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5874',
		number: '5874',
		text: 'خِتَٰمُهُۥ مِسْكٌۭ ۚ وَفِى ذَٰلِكَ فَلْيَتَنَافَسِ ٱلْمُتَنَٰفِسُونَ',
		number_in_surah: '26',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5875',
		number: '5875',
		text: 'وَمِزَاجُهُۥ مِن تَسْنِيمٍ',
		number_in_surah: '27',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5876',
		number: '5876',
		text: 'عَيْنًۭا يَشْرَبُ بِهَا ٱلْمُقَرَّبُونَ',
		number_in_surah: '28',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5877',
		number: '5877',
		text: 'إِنَّ ٱلَّذِينَ أَجْرَمُوا۟ كَانُوا۟ مِنَ ٱلَّذِينَ ءَامَنُوا۟ يَضْحَكُونَ',
		number_in_surah: '29',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5878',
		number: '5878',
		text: 'وَإِذَا مَرُّوا۟ بِهِمْ يَتَغَامَزُونَ',
		number_in_surah: '30',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5879',
		number: '5879',
		text: 'وَإِذَا ٱنقَلَبُوٓا۟ إِلَىٰٓ أَهْلِهِمُ ٱنقَلَبُوا۟ فَكِهِينَ',
		number_in_surah: '31',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5880',
		number: '5880',
		text: 'وَإِذَا رَأَوْهُمْ قَالُوٓا۟ إِنَّ هَٰٓؤُلَآءِ لَضَآلُّونَ',
		number_in_surah: '32',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5881',
		number: '5881',
		text: 'وَمَآ أُرْسِلُوا۟ عَلَيْهِمْ حَٰفِظِينَ',
		number_in_surah: '33',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5882',
		number: '5882',
		text: 'فَٱلْيَوْمَ ٱلَّذِينَ ءَامَنُوا۟ مِنَ ٱلْكُفَّارِ يَضْحَكُونَ',
		number_in_surah: '34',
		page: '588',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5883',
		number: '5883',
		text: 'عَلَى ٱلْأَرَآئِكِ يَنظُرُونَ',
		number_in_surah: '35',
		page: '589',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5884',
		number: '5884',
		text: 'هَلْ ثُوِّبَ ٱلْكُفَّارُ مَا كَانُوا۟ يَفْعَلُونَ',
		number_in_surah: '36',
		page: '589',
		surah_id: '83',
		hizb_id: '235',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5885',
		number: '5885',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِذَا ٱلسَّمَآءُ ٱنشَقَّتْ',
		number_in_surah: '1',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5886',
		number: '5886',
		text: 'وَأَذِنَتْ لِرَبِّهَا وَحُقَّتْ',
		number_in_surah: '2',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5887',
		number: '5887',
		text: 'وَإِذَا ٱلْأَرْضُ مُدَّتْ',
		number_in_surah: '3',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5888',
		number: '5888',
		text: 'وَأَلْقَتْ مَا فِيهَا وَتَخَلَّتْ',
		number_in_surah: '4',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5889',
		number: '5889',
		text: 'وَأَذِنَتْ لِرَبِّهَا وَحُقَّتْ',
		number_in_surah: '5',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5890',
		number: '5890',
		text: 'يَٰٓأَيُّهَا ٱلْإِنسَٰنُ إِنَّكَ كَادِحٌ إِلَىٰ رَبِّكَ كَدْحًۭا فَمُلَٰقِيهِ',
		number_in_surah: '6',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5891',
		number: '5891',
		text: 'فَأَمَّا مَنْ أُوتِىَ كِتَٰبَهُۥ بِيَمِينِهِۦ',
		number_in_surah: '7',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5892',
		number: '5892',
		text: 'فَسَوْفَ يُحَاسَبُ حِسَابًۭا يَسِيرًۭا',
		number_in_surah: '8',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5893',
		number: '5893',
		text: 'وَيَنقَلِبُ إِلَىٰٓ أَهْلِهِۦ مَسْرُورًۭا',
		number_in_surah: '9',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5894',
		number: '5894',
		text: 'وَأَمَّا مَنْ أُوتِىَ كِتَٰبَهُۥ وَرَآءَ ظَهْرِهِۦ',
		number_in_surah: '10',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5895',
		number: '5895',
		text: 'فَسَوْفَ يَدْعُوا۟ ثُبُورًۭا',
		number_in_surah: '11',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5896',
		number: '5896',
		text: 'وَيَصْلَىٰ سَعِيرًا',
		number_in_surah: '12',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5897',
		number: '5897',
		text: 'إِنَّهُۥ كَانَ فِىٓ أَهْلِهِۦ مَسْرُورًا',
		number_in_surah: '13',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5898',
		number: '5898',
		text: 'إِنَّهُۥ ظَنَّ أَن لَّن يَحُورَ',
		number_in_surah: '14',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5899',
		number: '5899',
		text: 'بَلَىٰٓ إِنَّ رَبَّهُۥ كَانَ بِهِۦ بَصِيرًۭا',
		number_in_surah: '15',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5900',
		number: '5900',
		text: 'فَلَآ أُقْسِمُ بِٱلشَّفَقِ',
		number_in_surah: '16',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5901',
		number: '5901',
		text: 'وَٱلَّيْلِ وَمَا وَسَقَ',
		number_in_surah: '17',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5902',
		number: '5902',
		text: 'وَٱلْقَمَرِ إِذَا ٱتَّسَقَ',
		number_in_surah: '18',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5903',
		number: '5903',
		text: 'لَتَرْكَبُنَّ طَبَقًا عَن طَبَقٍۢ',
		number_in_surah: '19',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5904',
		number: '5904',
		text: 'فَمَا لَهُمْ لَا يُؤْمِنُونَ',
		number_in_surah: '20',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5905',
		number: '5905',
		text: 'وَإِذَا قُرِئَ عَلَيْهِمُ ٱلْقُرْءَانُ لَا يَسْجُدُونَ ۩',
		number_in_surah: '21',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '1',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5906',
		number: '5906',
		text: 'بَلِ ٱلَّذِينَ كَفَرُوا۟ يُكَذِّبُونَ',
		number_in_surah: '22',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5907',
		number: '5907',
		text: 'وَٱللَّهُ أَعْلَمُ بِمَا يُوعُونَ',
		number_in_surah: '23',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5908',
		number: '5908',
		text: 'فَبَشِّرْهُم بِعَذَابٍ أَلِيمٍ',
		number_in_surah: '24',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5909',
		number: '5909',
		text: 'إِلَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَهُمْ أَجْرٌ غَيْرُ مَمْنُونٍۭ',
		number_in_surah: '25',
		page: '589',
		surah_id: '84',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5910',
		number: '5910',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلسَّمَآءِ ذَاتِ ٱلْبُرُوجِ',
		number_in_surah: '1',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5911',
		number: '5911',
		text: 'وَٱلْيَوْمِ ٱلْمَوْعُودِ',
		number_in_surah: '2',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5912',
		number: '5912',
		text: 'وَشَاهِدٍۢ وَمَشْهُودٍۢ',
		number_in_surah: '3',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5913',
		number: '5913',
		text: 'قُتِلَ أَصْحَٰبُ ٱلْأُخْدُودِ',
		number_in_surah: '4',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5914',
		number: '5914',
		text: 'ٱلنَّارِ ذَاتِ ٱلْوَقُودِ',
		number_in_surah: '5',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5915',
		number: '5915',
		text: 'إِذْ هُمْ عَلَيْهَا قُعُودٌۭ',
		number_in_surah: '6',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5916',
		number: '5916',
		text: 'وَهُمْ عَلَىٰ مَا يَفْعَلُونَ بِٱلْمُؤْمِنِينَ شُهُودٌۭ',
		number_in_surah: '7',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5917',
		number: '5917',
		text: 'وَمَا نَقَمُوا۟ مِنْهُمْ إِلَّآ أَن يُؤْمِنُوا۟ بِٱللَّهِ ٱلْعَزِيزِ ٱلْحَمِيدِ',
		number_in_surah: '8',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:21',
		updated_at: '2018-06-07 08:07:21',
	},
	{
		id: '5918',
		number: '5918',
		text: 'ٱلَّذِى لَهُۥ مُلْكُ ٱلسَّمَٰوَٰتِ وَٱلْأَرْضِ ۚ وَٱللَّهُ عَلَىٰ كُلِّ شَىْءٍۢ شَهِيدٌ',
		number_in_surah: '9',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5919',
		number: '5919',
		text: 'إِنَّ ٱلَّذِينَ فَتَنُوا۟ ٱلْمُؤْمِنِينَ وَٱلْمُؤْمِنَٰتِ ثُمَّ لَمْ يَتُوبُوا۟ فَلَهُمْ عَذَابُ جَهَنَّمَ وَلَهُمْ عَذَابُ ٱلْحَرِيقِ',
		number_in_surah: '10',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5920',
		number: '5920',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ لَهُمْ جَنَّٰتٌۭ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ ۚ ذَٰلِكَ ٱلْفَوْزُ ٱلْكَبِيرُ',
		number_in_surah: '11',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5921',
		number: '5921',
		text: 'إِنَّ بَطْشَ رَبِّكَ لَشَدِيدٌ',
		number_in_surah: '12',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5922',
		number: '5922',
		text: 'إِنَّهُۥ هُوَ يُبْدِئُ وَيُعِيدُ',
		number_in_surah: '13',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5923',
		number: '5923',
		text: 'وَهُوَ ٱلْغَفُورُ ٱلْوَدُودُ',
		number_in_surah: '14',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5924',
		number: '5924',
		text: 'ذُو ٱلْعَرْشِ ٱلْمَجِيدُ',
		number_in_surah: '15',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5925',
		number: '5925',
		text: 'فَعَّالٌۭ لِّمَا يُرِيدُ',
		number_in_surah: '16',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5926',
		number: '5926',
		text: 'هَلْ أَتَىٰكَ حَدِيثُ ٱلْجُنُودِ',
		number_in_surah: '17',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5927',
		number: '5927',
		text: 'فِرْعَوْنَ وَثَمُودَ',
		number_in_surah: '18',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5928',
		number: '5928',
		text: 'بَلِ ٱلَّذِينَ كَفَرُوا۟ فِى تَكْذِيبٍۢ',
		number_in_surah: '19',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5929',
		number: '5929',
		text: 'وَٱللَّهُ مِن وَرَآئِهِم مُّحِيطٌۢ',
		number_in_surah: '20',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5930',
		number: '5930',
		text: 'بَلْ هُوَ قُرْءَانٌۭ مَّجِيدٌۭ',
		number_in_surah: '21',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5931',
		number: '5931',
		text: 'فِى لَوْحٍۢ مَّحْفُوظٍۭ',
		number_in_surah: '22',
		page: '590',
		surah_id: '85',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5932',
		number: '5932',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلسَّمَآءِ وَٱلطَّارِقِ',
		number_in_surah: '1',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5933',
		number: '5933',
		text: 'وَمَآ أَدْرَىٰكَ مَا ٱلطَّارِقُ',
		number_in_surah: '2',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5934',
		number: '5934',
		text: 'ٱلنَّجْمُ ٱلثَّاقِبُ',
		number_in_surah: '3',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5935',
		number: '5935',
		text: 'إِن كُلُّ نَفْسٍۢ لَّمَّا عَلَيْهَا حَافِظٌۭ',
		number_in_surah: '4',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5936',
		number: '5936',
		text: 'فَلْيَنظُرِ ٱلْإِنسَٰنُ مِمَّ خُلِقَ',
		number_in_surah: '5',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5937',
		number: '5937',
		text: 'خُلِقَ مِن مَّآءٍۢ دَافِقٍۢ',
		number_in_surah: '6',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5938',
		number: '5938',
		text: 'يَخْرُجُ مِنۢ بَيْنِ ٱلصُّلْبِ وَٱلتَّرَآئِبِ',
		number_in_surah: '7',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5939',
		number: '5939',
		text: 'إِنَّهُۥ عَلَىٰ رَجْعِهِۦ لَقَادِرٌۭ',
		number_in_surah: '8',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5940',
		number: '5940',
		text: 'يَوْمَ تُبْلَى ٱلسَّرَآئِرُ',
		number_in_surah: '9',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5941',
		number: '5941',
		text: 'فَمَا لَهُۥ مِن قُوَّةٍۢ وَلَا نَاصِرٍۢ',
		number_in_surah: '10',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5942',
		number: '5942',
		text: 'وَٱلسَّمَآءِ ذَاتِ ٱلرَّجْعِ',
		number_in_surah: '11',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5943',
		number: '5943',
		text: 'وَٱلْأَرْضِ ذَاتِ ٱلصَّدْعِ',
		number_in_surah: '12',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5944',
		number: '5944',
		text: 'إِنَّهُۥ لَقَوْلٌۭ فَصْلٌۭ',
		number_in_surah: '13',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5945',
		number: '5945',
		text: 'وَمَا هُوَ بِٱلْهَزْلِ',
		number_in_surah: '14',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5946',
		number: '5946',
		text: 'إِنَّهُمْ يَكِيدُونَ كَيْدًۭا',
		number_in_surah: '15',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5947',
		number: '5947',
		text: 'وَأَكِيدُ كَيْدًۭا',
		number_in_surah: '16',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5948',
		number: '5948',
		text: 'فَمَهِّلِ ٱلْكَٰفِرِينَ أَمْهِلْهُمْ رُوَيْدًۢا',
		number_in_surah: '17',
		page: '591',
		surah_id: '86',
		hizb_id: '236',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5949',
		number: '5949',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ سَبِّحِ ٱسْمَ رَبِّكَ ٱلْأَعْلَى',
		number_in_surah: '1',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5950',
		number: '5950',
		text: 'ٱلَّذِى خَلَقَ فَسَوَّىٰ',
		number_in_surah: '2',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5951',
		number: '5951',
		text: 'وَٱلَّذِى قَدَّرَ فَهَدَىٰ',
		number_in_surah: '3',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5952',
		number: '5952',
		text: 'وَٱلَّذِىٓ أَخْرَجَ ٱلْمَرْعَىٰ',
		number_in_surah: '4',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5953',
		number: '5953',
		text: 'فَجَعَلَهُۥ غُثَآءً أَحْوَىٰ',
		number_in_surah: '5',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5954',
		number: '5954',
		text: 'سَنُقْرِئُكَ فَلَا تَنسَىٰٓ',
		number_in_surah: '6',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5955',
		number: '5955',
		text: 'إِلَّا مَا شَآءَ ٱللَّهُ ۚ إِنَّهُۥ يَعْلَمُ ٱلْجَهْرَ وَمَا يَخْفَىٰ',
		number_in_surah: '7',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5956',
		number: '5956',
		text: 'وَنُيَسِّرُكَ لِلْيُسْرَىٰ',
		number_in_surah: '8',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5957',
		number: '5957',
		text: 'فَذَكِّرْ إِن نَّفَعَتِ ٱلذِّكْرَىٰ',
		number_in_surah: '9',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5958',
		number: '5958',
		text: 'سَيَذَّكَّرُ مَن يَخْشَىٰ',
		number_in_surah: '10',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5959',
		number: '5959',
		text: 'وَيَتَجَنَّبُهَا ٱلْأَشْقَى',
		number_in_surah: '11',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5960',
		number: '5960',
		text: 'ٱلَّذِى يَصْلَى ٱلنَّارَ ٱلْكُبْرَىٰ',
		number_in_surah: '12',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5961',
		number: '5961',
		text: 'ثُمَّ لَا يَمُوتُ فِيهَا وَلَا يَحْيَىٰ',
		number_in_surah: '13',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5962',
		number: '5962',
		text: 'قَدْ أَفْلَحَ مَن تَزَكَّىٰ',
		number_in_surah: '14',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5963',
		number: '5963',
		text: 'وَذَكَرَ ٱسْمَ رَبِّهِۦ فَصَلَّىٰ',
		number_in_surah: '15',
		page: '591',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5964',
		number: '5964',
		text: 'بَلْ تُؤْثِرُونَ ٱلْحَيَوٰةَ ٱلدُّنْيَا',
		number_in_surah: '16',
		page: '592',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5965',
		number: '5965',
		text: 'وَٱلْءَاخِرَةُ خَيْرٌۭ وَأَبْقَىٰٓ',
		number_in_surah: '17',
		page: '592',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5966',
		number: '5966',
		text: 'إِنَّ هَٰذَا لَفِى ٱلصُّحُفِ ٱلْأُولَىٰ',
		number_in_surah: '18',
		page: '592',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5967',
		number: '5967',
		text: 'صُحُفِ إِبْرَٰهِيمَ وَمُوسَىٰ',
		number_in_surah: '19',
		page: '592',
		surah_id: '87',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5968',
		number: '5968',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ هَلْ أَتَىٰكَ حَدِيثُ ٱلْغَٰشِيَةِ',
		number_in_surah: '1',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5969',
		number: '5969',
		text: 'وُجُوهٌۭ يَوْمَئِذٍ خَٰشِعَةٌ',
		number_in_surah: '2',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5970',
		number: '5970',
		text: 'عَامِلَةٌۭ نَّاصِبَةٌۭ',
		number_in_surah: '3',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5971',
		number: '5971',
		text: 'تَصْلَىٰ نَارًا حَامِيَةًۭ',
		number_in_surah: '4',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5972',
		number: '5972',
		text: 'تُسْقَىٰ مِنْ عَيْنٍ ءَانِيَةٍۢ',
		number_in_surah: '5',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5973',
		number: '5973',
		text: 'لَّيْسَ لَهُمْ طَعَامٌ إِلَّا مِن ضَرِيعٍۢ',
		number_in_surah: '6',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5974',
		number: '5974',
		text: 'لَّا يُسْمِنُ وَلَا يُغْنِى مِن جُوعٍۢ',
		number_in_surah: '7',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5975',
		number: '5975',
		text: 'وُجُوهٌۭ يَوْمَئِذٍۢ نَّاعِمَةٌۭ',
		number_in_surah: '8',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5976',
		number: '5976',
		text: 'لِّسَعْيِهَا رَاضِيَةٌۭ',
		number_in_surah: '9',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5977',
		number: '5977',
		text: 'فِى جَنَّةٍ عَالِيَةٍۢ',
		number_in_surah: '10',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5978',
		number: '5978',
		text: 'لَّا تَسْمَعُ فِيهَا لَٰغِيَةًۭ',
		number_in_surah: '11',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5979',
		number: '5979',
		text: 'فِيهَا عَيْنٌۭ جَارِيَةٌۭ',
		number_in_surah: '12',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5980',
		number: '5980',
		text: 'فِيهَا سُرُرٌۭ مَّرْفُوعَةٌۭ',
		number_in_surah: '13',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5981',
		number: '5981',
		text: 'وَأَكْوَابٌۭ مَّوْضُوعَةٌۭ',
		number_in_surah: '14',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5982',
		number: '5982',
		text: 'وَنَمَارِقُ مَصْفُوفَةٌۭ',
		number_in_surah: '15',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5983',
		number: '5983',
		text: 'وَزَرَابِىُّ مَبْثُوثَةٌ',
		number_in_surah: '16',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5984',
		number: '5984',
		text: 'أَفَلَا يَنظُرُونَ إِلَى ٱلْإِبِلِ كَيْفَ خُلِقَتْ',
		number_in_surah: '17',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5985',
		number: '5985',
		text: 'وَإِلَى ٱلسَّمَآءِ كَيْفَ رُفِعَتْ',
		number_in_surah: '18',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5986',
		number: '5986',
		text: 'وَإِلَى ٱلْجِبَالِ كَيْفَ نُصِبَتْ',
		number_in_surah: '19',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5987',
		number: '5987',
		text: 'وَإِلَى ٱلْأَرْضِ كَيْفَ سُطِحَتْ',
		number_in_surah: '20',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5988',
		number: '5988',
		text: 'فَذَكِّرْ إِنَّمَآ أَنتَ مُذَكِّرٌۭ',
		number_in_surah: '21',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5989',
		number: '5989',
		text: 'لَّسْتَ عَلَيْهِم بِمُصَيْطِرٍ',
		number_in_surah: '22',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5990',
		number: '5990',
		text: 'إِلَّا مَن تَوَلَّىٰ وَكَفَرَ',
		number_in_surah: '23',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5991',
		number: '5991',
		text: 'فَيُعَذِّبُهُ ٱللَّهُ ٱلْعَذَابَ ٱلْأَكْبَرَ',
		number_in_surah: '24',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5992',
		number: '5992',
		text: 'إِنَّ إِلَيْنَآ إِيَابَهُمْ',
		number_in_surah: '25',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5993',
		number: '5993',
		text: 'ثُمَّ إِنَّ عَلَيْنَا حِسَابَهُم',
		number_in_surah: '26',
		page: '592',
		surah_id: '88',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5994',
		number: '5994',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلْفَجْرِ',
		number_in_surah: '1',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5995',
		number: '5995',
		text: 'وَلَيَالٍ عَشْرٍۢ',
		number_in_surah: '2',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5996',
		number: '5996',
		text: 'وَٱلشَّفْعِ وَٱلْوَتْرِ',
		number_in_surah: '3',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5997',
		number: '5997',
		text: 'وَٱلَّيْلِ إِذَا يَسْرِ',
		number_in_surah: '4',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5998',
		number: '5998',
		text: 'هَلْ فِى ذَٰلِكَ قَسَمٌۭ لِّذِى حِجْرٍ',
		number_in_surah: '5',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '5999',
		number: '5999',
		text: 'أَلَمْ تَرَ كَيْفَ فَعَلَ رَبُّكَ بِعَادٍ',
		number_in_surah: '6',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6000',
		number: '6000',
		text: 'إِرَمَ ذَاتِ ٱلْعِمَادِ',
		number_in_surah: '7',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6001',
		number: '6001',
		text: 'ٱلَّتِى لَمْ يُخْلَقْ مِثْلُهَا فِى ٱلْبِلَٰدِ',
		number_in_surah: '8',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6002',
		number: '6002',
		text: 'وَثَمُودَ ٱلَّذِينَ جَابُوا۟ ٱلصَّخْرَ بِٱلْوَادِ',
		number_in_surah: '9',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6003',
		number: '6003',
		text: 'وَفِرْعَوْنَ ذِى ٱلْأَوْتَادِ',
		number_in_surah: '10',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6004',
		number: '6004',
		text: 'ٱلَّذِينَ طَغَوْا۟ فِى ٱلْبِلَٰدِ',
		number_in_surah: '11',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6005',
		number: '6005',
		text: 'فَأَكْثَرُوا۟ فِيهَا ٱلْفَسَادَ',
		number_in_surah: '12',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6006',
		number: '6006',
		text: 'فَصَبَّ عَلَيْهِمْ رَبُّكَ سَوْطَ عَذَابٍ',
		number_in_surah: '13',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6007',
		number: '6007',
		text: 'إِنَّ رَبَّكَ لَبِٱلْمِرْصَادِ',
		number_in_surah: '14',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6008',
		number: '6008',
		text: 'فَأَمَّا ٱلْإِنسَٰنُ إِذَا مَا ٱبْتَلَىٰهُ رَبُّهُۥ فَأَكْرَمَهُۥ وَنَعَّمَهُۥ فَيَقُولُ رَبِّىٓ أَكْرَمَنِ',
		number_in_surah: '15',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6009',
		number: '6009',
		text: 'وَأَمَّآ إِذَا مَا ٱبْتَلَىٰهُ فَقَدَرَ عَلَيْهِ رِزْقَهُۥ فَيَقُولُ رَبِّىٓ أَهَٰنَنِ',
		number_in_surah: '16',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6010',
		number: '6010',
		text: 'كَلَّا ۖ بَل لَّا تُكْرِمُونَ ٱلْيَتِيمَ',
		number_in_surah: '17',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6011',
		number: '6011',
		text: 'وَلَا تَحَٰٓضُّونَ عَلَىٰ طَعَامِ ٱلْمِسْكِينِ',
		number_in_surah: '18',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6012',
		number: '6012',
		text: 'وَتَأْكُلُونَ ٱلتُّرَاثَ أَكْلًۭا لَّمًّۭا',
		number_in_surah: '19',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6013',
		number: '6013',
		text: 'وَتُحِبُّونَ ٱلْمَالَ حُبًّۭا جَمًّۭا',
		number_in_surah: '20',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6014',
		number: '6014',
		text: 'كَلَّآ إِذَا دُكَّتِ ٱلْأَرْضُ دَكًّۭا دَكًّۭا',
		number_in_surah: '21',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6015',
		number: '6015',
		text: 'وَجَآءَ رَبُّكَ وَٱلْمَلَكُ صَفًّۭا صَفًّۭا',
		number_in_surah: '22',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6016',
		number: '6016',
		text: 'وَجِا۟ىٓءَ يَوْمَئِذٍۭ بِجَهَنَّمَ ۚ يَوْمَئِذٍۢ يَتَذَكَّرُ ٱلْإِنسَٰنُ وَأَنَّىٰ لَهُ ٱلذِّكْرَىٰ',
		number_in_surah: '23',
		page: '593',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6017',
		number: '6017',
		text: 'يَقُولُ يَٰلَيْتَنِى قَدَّمْتُ لِحَيَاتِى',
		number_in_surah: '24',
		page: '594',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6018',
		number: '6018',
		text: 'فَيَوْمَئِذٍۢ لَّا يُعَذِّبُ عَذَابَهُۥٓ أَحَدٌۭ',
		number_in_surah: '25',
		page: '594',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6019',
		number: '6019',
		text: 'وَلَا يُوثِقُ وَثَاقَهُۥٓ أَحَدٌۭ',
		number_in_surah: '26',
		page: '594',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6020',
		number: '6020',
		text: 'يَٰٓأَيَّتُهَا ٱلنَّفْسُ ٱلْمُطْمَئِنَّةُ',
		number_in_surah: '27',
		page: '594',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6021',
		number: '6021',
		text: 'ٱرْجِعِىٓ إِلَىٰ رَبِّكِ رَاضِيَةًۭ مَّرْضِيَّةًۭ',
		number_in_surah: '28',
		page: '594',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6022',
		number: '6022',
		text: 'فَٱدْخُلِى فِى عِبَٰدِى',
		number_in_surah: '29',
		page: '594',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6023',
		number: '6023',
		text: 'وَٱدْخُلِى جَنَّتِى',
		number_in_surah: '30',
		page: '594',
		surah_id: '89',
		hizb_id: '237',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6024',
		number: '6024',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ لَآ أُقْسِمُ بِهَٰذَا ٱلْبَلَدِ',
		number_in_surah: '1',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6025',
		number: '6025',
		text: 'وَأَنتَ حِلٌّۢ بِهَٰذَا ٱلْبَلَدِ',
		number_in_surah: '2',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6026',
		number: '6026',
		text: 'وَوَالِدٍۢ وَمَا وَلَدَ',
		number_in_surah: '3',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6027',
		number: '6027',
		text: 'لَقَدْ خَلَقْنَا ٱلْإِنسَٰنَ فِى كَبَدٍ',
		number_in_surah: '4',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6028',
		number: '6028',
		text: 'أَيَحْسَبُ أَن لَّن يَقْدِرَ عَلَيْهِ أَحَدٌۭ',
		number_in_surah: '5',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6029',
		number: '6029',
		text: 'يَقُولُ أَهْلَكْتُ مَالًۭا لُّبَدًا',
		number_in_surah: '6',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6030',
		number: '6030',
		text: 'أَيَحْسَبُ أَن لَّمْ يَرَهُۥٓ أَحَدٌ',
		number_in_surah: '7',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6031',
		number: '6031',
		text: 'أَلَمْ نَجْعَل لَّهُۥ عَيْنَيْنِ',
		number_in_surah: '8',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6032',
		number: '6032',
		text: 'وَلِسَانًۭا وَشَفَتَيْنِ',
		number_in_surah: '9',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6033',
		number: '6033',
		text: 'وَهَدَيْنَٰهُ ٱلنَّجْدَيْنِ',
		number_in_surah: '10',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6034',
		number: '6034',
		text: 'فَلَا ٱقْتَحَمَ ٱلْعَقَبَةَ',
		number_in_surah: '11',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6035',
		number: '6035',
		text: 'وَمَآ أَدْرَىٰكَ مَا ٱلْعَقَبَةُ',
		number_in_surah: '12',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6036',
		number: '6036',
		text: 'فَكُّ رَقَبَةٍ',
		number_in_surah: '13',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6037',
		number: '6037',
		text: 'أَوْ إِطْعَٰمٌۭ فِى يَوْمٍۢ ذِى مَسْغَبَةٍۢ',
		number_in_surah: '14',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6038',
		number: '6038',
		text: 'يَتِيمًۭا ذَا مَقْرَبَةٍ',
		number_in_surah: '15',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6039',
		number: '6039',
		text: 'أَوْ مِسْكِينًۭا ذَا مَتْرَبَةٍۢ',
		number_in_surah: '16',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6040',
		number: '6040',
		text: 'ثُمَّ كَانَ مِنَ ٱلَّذِينَ ءَامَنُوا۟ وَتَوَاصَوْا۟ بِٱلصَّبْرِ وَتَوَاصَوْا۟ بِٱلْمَرْحَمَةِ',
		number_in_surah: '17',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6041',
		number: '6041',
		text: 'أُو۟لَٰٓئِكَ أَصْحَٰبُ ٱلْمَيْمَنَةِ',
		number_in_surah: '18',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6042',
		number: '6042',
		text: 'وَٱلَّذِينَ كَفَرُوا۟ بِـَٔايَٰتِنَا هُمْ أَصْحَٰبُ ٱلْمَشْـَٔمَةِ',
		number_in_surah: '19',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6043',
		number: '6043',
		text: 'عَلَيْهِمْ نَارٌۭ مُّؤْصَدَةٌۢ',
		number_in_surah: '20',
		page: '594',
		surah_id: '90',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6044',
		number: '6044',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلشَّمْسِ وَضُحَىٰهَا',
		number_in_surah: '1',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6045',
		number: '6045',
		text: 'وَٱلْقَمَرِ إِذَا تَلَىٰهَا',
		number_in_surah: '2',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6046',
		number: '6046',
		text: 'وَٱلنَّهَارِ إِذَا جَلَّىٰهَا',
		number_in_surah: '3',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6047',
		number: '6047',
		text: 'وَٱلَّيْلِ إِذَا يَغْشَىٰهَا',
		number_in_surah: '4',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6048',
		number: '6048',
		text: 'وَٱلسَّمَآءِ وَمَا بَنَىٰهَا',
		number_in_surah: '5',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6049',
		number: '6049',
		text: 'وَٱلْأَرْضِ وَمَا طَحَىٰهَا',
		number_in_surah: '6',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:22',
		updated_at: '2018-06-07 08:07:22',
	},
	{
		id: '6050',
		number: '6050',
		text: 'وَنَفْسٍۢ وَمَا سَوَّىٰهَا',
		number_in_surah: '7',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6051',
		number: '6051',
		text: 'فَأَلْهَمَهَا فُجُورَهَا وَتَقْوَىٰهَا',
		number_in_surah: '8',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6052',
		number: '6052',
		text: 'قَدْ أَفْلَحَ مَن زَكَّىٰهَا',
		number_in_surah: '9',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6053',
		number: '6053',
		text: 'وَقَدْ خَابَ مَن دَسَّىٰهَا',
		number_in_surah: '10',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6054',
		number: '6054',
		text: 'كَذَّبَتْ ثَمُودُ بِطَغْوَىٰهَآ',
		number_in_surah: '11',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6055',
		number: '6055',
		text: 'إِذِ ٱنۢبَعَثَ أَشْقَىٰهَا',
		number_in_surah: '12',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6056',
		number: '6056',
		text: 'فَقَالَ لَهُمْ رَسُولُ ٱللَّهِ نَاقَةَ ٱللَّهِ وَسُقْيَٰهَا',
		number_in_surah: '13',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6057',
		number: '6057',
		text: 'فَكَذَّبُوهُ فَعَقَرُوهَا فَدَمْدَمَ عَلَيْهِمْ رَبُّهُم بِذَنۢبِهِمْ فَسَوَّىٰهَا',
		number_in_surah: '14',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6058',
		number: '6058',
		text: 'وَلَا يَخَافُ عُقْبَٰهَا',
		number_in_surah: '15',
		page: '595',
		surah_id: '91',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6059',
		number: '6059',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلَّيْلِ إِذَا يَغْشَىٰ',
		number_in_surah: '1',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6060',
		number: '6060',
		text: 'وَٱلنَّهَارِ إِذَا تَجَلَّىٰ',
		number_in_surah: '2',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6061',
		number: '6061',
		text: 'وَمَا خَلَقَ ٱلذَّكَرَ وَٱلْأُنثَىٰٓ',
		number_in_surah: '3',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6062',
		number: '6062',
		text: 'إِنَّ سَعْيَكُمْ لَشَتَّىٰ',
		number_in_surah: '4',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6063',
		number: '6063',
		text: 'فَأَمَّا مَنْ أَعْطَىٰ وَٱتَّقَىٰ',
		number_in_surah: '5',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6064',
		number: '6064',
		text: 'وَصَدَّقَ بِٱلْحُسْنَىٰ',
		number_in_surah: '6',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6065',
		number: '6065',
		text: 'فَسَنُيَسِّرُهُۥ لِلْيُسْرَىٰ',
		number_in_surah: '7',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6066',
		number: '6066',
		text: 'وَأَمَّا مَنۢ بَخِلَ وَٱسْتَغْنَىٰ',
		number_in_surah: '8',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6067',
		number: '6067',
		text: 'وَكَذَّبَ بِٱلْحُسْنَىٰ',
		number_in_surah: '9',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6068',
		number: '6068',
		text: 'فَسَنُيَسِّرُهُۥ لِلْعُسْرَىٰ',
		number_in_surah: '10',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6069',
		number: '6069',
		text: 'وَمَا يُغْنِى عَنْهُ مَالُهُۥٓ إِذَا تَرَدَّىٰٓ',
		number_in_surah: '11',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6070',
		number: '6070',
		text: 'إِنَّ عَلَيْنَا لَلْهُدَىٰ',
		number_in_surah: '12',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6071',
		number: '6071',
		text: 'وَإِنَّ لَنَا لَلْءَاخِرَةَ وَٱلْأُولَىٰ',
		number_in_surah: '13',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6072',
		number: '6072',
		text: 'فَأَنذَرْتُكُمْ نَارًۭا تَلَظَّىٰ',
		number_in_surah: '14',
		page: '595',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6073',
		number: '6073',
		text: 'لَا يَصْلَىٰهَآ إِلَّا ٱلْأَشْقَى',
		number_in_surah: '15',
		page: '596',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6074',
		number: '6074',
		text: 'ٱلَّذِى كَذَّبَ وَتَوَلَّىٰ',
		number_in_surah: '16',
		page: '596',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6075',
		number: '6075',
		text: 'وَسَيُجَنَّبُهَا ٱلْأَتْقَى',
		number_in_surah: '17',
		page: '596',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6076',
		number: '6076',
		text: 'ٱلَّذِى يُؤْتِى مَالَهُۥ يَتَزَكَّىٰ',
		number_in_surah: '18',
		page: '596',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6077',
		number: '6077',
		text: 'وَمَا لِأَحَدٍ عِندَهُۥ مِن نِّعْمَةٍۢ تُجْزَىٰٓ',
		number_in_surah: '19',
		page: '596',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6078',
		number: '6078',
		text: 'إِلَّا ٱبْتِغَآءَ وَجْهِ رَبِّهِ ٱلْأَعْلَىٰ',
		number_in_surah: '20',
		page: '596',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6079',
		number: '6079',
		text: 'وَلَسَوْفَ يَرْضَىٰ',
		number_in_surah: '21',
		page: '596',
		surah_id: '92',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6080',
		number: '6080',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلضُّحَىٰ',
		number_in_surah: '1',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6081',
		number: '6081',
		text: 'وَٱلَّيْلِ إِذَا سَجَىٰ',
		number_in_surah: '2',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6082',
		number: '6082',
		text: 'مَا وَدَّعَكَ رَبُّكَ وَمَا قَلَىٰ',
		number_in_surah: '3',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6083',
		number: '6083',
		text: 'وَلَلْءَاخِرَةُ خَيْرٌۭ لَّكَ مِنَ ٱلْأُولَىٰ',
		number_in_surah: '4',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6084',
		number: '6084',
		text: 'وَلَسَوْفَ يُعْطِيكَ رَبُّكَ فَتَرْضَىٰٓ',
		number_in_surah: '5',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6085',
		number: '6085',
		text: 'أَلَمْ يَجِدْكَ يَتِيمًۭا فَـَٔاوَىٰ',
		number_in_surah: '6',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6086',
		number: '6086',
		text: 'وَوَجَدَكَ ضَآلًّۭا فَهَدَىٰ',
		number_in_surah: '7',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6087',
		number: '6087',
		text: 'وَوَجَدَكَ عَآئِلًۭا فَأَغْنَىٰ',
		number_in_surah: '8',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6088',
		number: '6088',
		text: 'فَأَمَّا ٱلْيَتِيمَ فَلَا تَقْهَرْ',
		number_in_surah: '9',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6089',
		number: '6089',
		text: 'وَأَمَّا ٱلسَّآئِلَ فَلَا تَنْهَرْ',
		number_in_surah: '10',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6090',
		number: '6090',
		text: 'وَأَمَّا بِنِعْمَةِ رَبِّكَ فَحَدِّثْ',
		number_in_surah: '11',
		page: '596',
		surah_id: '93',
		hizb_id: '238',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6091',
		number: '6091',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ أَلَمْ نَشْرَحْ لَكَ صَدْرَكَ',
		number_in_surah: '1',
		page: '596',
		surah_id: '94',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6092',
		number: '6092',
		text: 'وَوَضَعْنَا عَنكَ وِزْرَكَ',
		number_in_surah: '2',
		page: '596',
		surah_id: '94',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6093',
		number: '6093',
		text: 'ٱلَّذِىٓ أَنقَضَ ظَهْرَكَ',
		number_in_surah: '3',
		page: '596',
		surah_id: '94',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6094',
		number: '6094',
		text: 'وَرَفَعْنَا لَكَ ذِكْرَكَ',
		number_in_surah: '4',
		page: '596',
		surah_id: '94',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6095',
		number: '6095',
		text: 'فَإِنَّ مَعَ ٱلْعُسْرِ يُسْرًا',
		number_in_surah: '5',
		page: '596',
		surah_id: '94',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6096',
		number: '6096',
		text: 'إِنَّ مَعَ ٱلْعُسْرِ يُسْرًۭا',
		number_in_surah: '6',
		page: '596',
		surah_id: '94',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6097',
		number: '6097',
		text: 'فَإِذَا فَرَغْتَ فَٱنصَبْ',
		number_in_surah: '7',
		page: '596',
		surah_id: '94',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6098',
		number: '6098',
		text: 'وَإِلَىٰ رَبِّكَ فَٱرْغَب',
		number_in_surah: '8',
		page: '596',
		surah_id: '94',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6099',
		number: '6099',
		text: 'بِّسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلتِّينِ وَٱلزَّيْتُونِ',
		number_in_surah: '1',
		page: '597',
		surah_id: '95',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6100',
		number: '6100',
		text: 'وَطُورِ سِينِينَ',
		number_in_surah: '2',
		page: '597',
		surah_id: '95',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6101',
		number: '6101',
		text: 'وَهَٰذَا ٱلْبَلَدِ ٱلْأَمِينِ',
		number_in_surah: '3',
		page: '597',
		surah_id: '95',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6102',
		number: '6102',
		text: 'لَقَدْ خَلَقْنَا ٱلْإِنسَٰنَ فِىٓ أَحْسَنِ تَقْوِيمٍۢ',
		number_in_surah: '4',
		page: '597',
		surah_id: '95',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6103',
		number: '6103',
		text: 'ثُمَّ رَدَدْنَٰهُ أَسْفَلَ سَٰفِلِينَ',
		number_in_surah: '5',
		page: '597',
		surah_id: '95',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6104',
		number: '6104',
		text: 'إِلَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ فَلَهُمْ أَجْرٌ غَيْرُ مَمْنُونٍۢ',
		number_in_surah: '6',
		page: '597',
		surah_id: '95',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6105',
		number: '6105',
		text: 'فَمَا يُكَذِّبُكَ بَعْدُ بِٱلدِّينِ',
		number_in_surah: '7',
		page: '597',
		surah_id: '95',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6106',
		number: '6106',
		text: 'أَلَيْسَ ٱللَّهُ بِأَحْكَمِ ٱلْحَٰكِمِينَ',
		number_in_surah: '8',
		page: '597',
		surah_id: '95',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6107',
		number: '6107',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱقْرَأْ بِٱسْمِ رَبِّكَ ٱلَّذِى خَلَقَ',
		number_in_surah: '1',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6108',
		number: '6108',
		text: 'خَلَقَ ٱلْإِنسَٰنَ مِنْ عَلَقٍ',
		number_in_surah: '2',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6109',
		number: '6109',
		text: 'ٱقْرَأْ وَرَبُّكَ ٱلْأَكْرَمُ',
		number_in_surah: '3',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6110',
		number: '6110',
		text: 'ٱلَّذِى عَلَّمَ بِٱلْقَلَمِ',
		number_in_surah: '4',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6111',
		number: '6111',
		text: 'عَلَّمَ ٱلْإِنسَٰنَ مَا لَمْ يَعْلَمْ',
		number_in_surah: '5',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6112',
		number: '6112',
		text: 'كَلَّآ إِنَّ ٱلْإِنسَٰنَ لَيَطْغَىٰٓ',
		number_in_surah: '6',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6113',
		number: '6113',
		text: 'أَن رَّءَاهُ ٱسْتَغْنَىٰٓ',
		number_in_surah: '7',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6114',
		number: '6114',
		text: 'إِنَّ إِلَىٰ رَبِّكَ ٱلرُّجْعَىٰٓ',
		number_in_surah: '8',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6115',
		number: '6115',
		text: 'أَرَءَيْتَ ٱلَّذِى يَنْهَىٰ',
		number_in_surah: '9',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6116',
		number: '6116',
		text: 'عَبْدًا إِذَا صَلَّىٰٓ',
		number_in_surah: '10',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6117',
		number: '6117',
		text: 'أَرَءَيْتَ إِن كَانَ عَلَى ٱلْهُدَىٰٓ',
		number_in_surah: '11',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6118',
		number: '6118',
		text: 'أَوْ أَمَرَ بِٱلتَّقْوَىٰٓ',
		number_in_surah: '12',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6119',
		number: '6119',
		text: 'أَرَءَيْتَ إِن كَذَّبَ وَتَوَلَّىٰٓ',
		number_in_surah: '13',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6120',
		number: '6120',
		text: 'أَلَمْ يَعْلَم بِأَنَّ ٱللَّهَ يَرَىٰ',
		number_in_surah: '14',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6121',
		number: '6121',
		text: 'كَلَّا لَئِن لَّمْ يَنتَهِ لَنَسْفَعًۢا بِٱلنَّاصِيَةِ',
		number_in_surah: '15',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6122',
		number: '6122',
		text: 'نَاصِيَةٍۢ كَٰذِبَةٍ خَاطِئَةٍۢ',
		number_in_surah: '16',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6123',
		number: '6123',
		text: 'فَلْيَدْعُ نَادِيَهُۥ',
		number_in_surah: '17',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6124',
		number: '6124',
		text: 'سَنَدْعُ ٱلزَّبَانِيَةَ',
		number_in_surah: '18',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6125',
		number: '6125',
		text: 'كَلَّا لَا تُطِعْهُ وَٱسْجُدْ وَٱقْتَرِب ۩',
		number_in_surah: '19',
		page: '597',
		surah_id: '96',
		hizb_id: '239',
		juz_id: '30',
		sajda: '1',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6126',
		number: '6126',
		text: 'بِّسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِنَّآ أَنزَلْنَٰهُ فِى لَيْلَةِ ٱلْقَدْرِ',
		number_in_surah: '1',
		page: '598',
		surah_id: '97',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6127',
		number: '6127',
		text: 'وَمَآ أَدْرَىٰكَ مَا لَيْلَةُ ٱلْقَدْرِ',
		number_in_surah: '2',
		page: '598',
		surah_id: '97',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6128',
		number: '6128',
		text: 'لَيْلَةُ ٱلْقَدْرِ خَيْرٌۭ مِّنْ أَلْفِ شَهْرٍۢ',
		number_in_surah: '3',
		page: '598',
		surah_id: '97',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6129',
		number: '6129',
		text: 'تَنَزَّلُ ٱلْمَلَٰٓئِكَةُ وَٱلرُّوحُ فِيهَا بِإِذْنِ رَبِّهِم مِّن كُلِّ أَمْرٍۢ',
		number_in_surah: '4',
		page: '598',
		surah_id: '97',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6130',
		number: '6130',
		text: 'سَلَٰمٌ هِىَ حَتَّىٰ مَطْلَعِ ٱلْفَجْرِ',
		number_in_surah: '5',
		page: '598',
		surah_id: '97',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6131',
		number: '6131',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ لَمْ يَكُنِ ٱلَّذِينَ كَفَرُوا۟ مِنْ أَهْلِ ٱلْكِتَٰبِ وَٱلْمُشْرِكِينَ مُنفَكِّينَ حَتَّىٰ تَأْتِيَهُمُ ٱلْبَيِّنَةُ',
		number_in_surah: '1',
		page: '598',
		surah_id: '98',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6132',
		number: '6132',
		text: 'رَسُولٌۭ مِّنَ ٱللَّهِ يَتْلُوا۟ صُحُفًۭا مُّطَهَّرَةًۭ',
		number_in_surah: '2',
		page: '598',
		surah_id: '98',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6133',
		number: '6133',
		text: 'فِيهَا كُتُبٌۭ قَيِّمَةٌۭ',
		number_in_surah: '3',
		page: '598',
		surah_id: '98',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6134',
		number: '6134',
		text: 'وَمَا تَفَرَّقَ ٱلَّذِينَ أُوتُوا۟ ٱلْكِتَٰبَ إِلَّا مِنۢ بَعْدِ مَا جَآءَتْهُمُ ٱلْبَيِّنَةُ',
		number_in_surah: '4',
		page: '598',
		surah_id: '98',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6135',
		number: '6135',
		text: 'وَمَآ أُمِرُوٓا۟ إِلَّا لِيَعْبُدُوا۟ ٱللَّهَ مُخْلِصِينَ لَهُ ٱلدِّينَ حُنَفَآءَ وَيُقِيمُوا۟ ٱلصَّلَوٰةَ وَيُؤْتُوا۟ ٱلزَّكَوٰةَ ۚ وَذَٰلِكَ دِينُ ٱلْقَيِّمَةِ',
		number_in_surah: '5',
		page: '598',
		surah_id: '98',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6136',
		number: '6136',
		text: 'إِنَّ ٱلَّذِينَ كَفَرُوا۟ مِنْ أَهْلِ ٱلْكِتَٰبِ وَٱلْمُشْرِكِينَ فِى نَارِ جَهَنَّمَ خَٰلِدِينَ فِيهَآ ۚ أُو۟لَٰٓئِكَ هُمْ شَرُّ ٱلْبَرِيَّةِ',
		number_in_surah: '6',
		page: '598',
		surah_id: '98',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6137',
		number: '6137',
		text: 'إِنَّ ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ أُو۟لَٰٓئِكَ هُمْ خَيْرُ ٱلْبَرِيَّةِ',
		number_in_surah: '7',
		page: '598',
		surah_id: '98',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6138',
		number: '6138',
		text: 'جَزَآؤُهُمْ عِندَ رَبِّهِمْ جَنَّٰتُ عَدْنٍۢ تَجْرِى مِن تَحْتِهَا ٱلْأَنْهَٰرُ خَٰلِدِينَ فِيهَآ أَبَدًۭا ۖ رَّضِىَ ٱللَّهُ عَنْهُمْ وَرَضُوا۟ عَنْهُ ۚ ذَٰلِكَ لِمَنْ خَشِىَ رَبَّهُۥ',
		number_in_surah: '8',
		page: '599',
		surah_id: '98',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6139',
		number: '6139',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِذَا زُلْزِلَتِ ٱلْأَرْضُ زِلْزَالَهَا',
		number_in_surah: '1',
		page: '599',
		surah_id: '99',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6140',
		number: '6140',
		text: 'وَأَخْرَجَتِ ٱلْأَرْضُ أَثْقَالَهَا',
		number_in_surah: '2',
		page: '599',
		surah_id: '99',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6141',
		number: '6141',
		text: 'وَقَالَ ٱلْإِنسَٰنُ مَا لَهَا',
		number_in_surah: '3',
		page: '599',
		surah_id: '99',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6142',
		number: '6142',
		text: 'يَوْمَئِذٍۢ تُحَدِّثُ أَخْبَارَهَا',
		number_in_surah: '4',
		page: '599',
		surah_id: '99',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6143',
		number: '6143',
		text: 'بِأَنَّ رَبَّكَ أَوْحَىٰ لَهَا',
		number_in_surah: '5',
		page: '599',
		surah_id: '99',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6144',
		number: '6144',
		text: 'يَوْمَئِذٍۢ يَصْدُرُ ٱلنَّاسُ أَشْتَاتًۭا لِّيُرَوْا۟ أَعْمَٰلَهُمْ',
		number_in_surah: '6',
		page: '599',
		surah_id: '99',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6145',
		number: '6145',
		text: 'فَمَن يَعْمَلْ مِثْقَالَ ذَرَّةٍ خَيْرًۭا يَرَهُۥ',
		number_in_surah: '7',
		page: '599',
		surah_id: '99',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6146',
		number: '6146',
		text: 'وَمَن يَعْمَلْ مِثْقَالَ ذَرَّةٍۢ شَرًّۭا يَرَهُۥ',
		number_in_surah: '8',
		page: '599',
		surah_id: '99',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6147',
		number: '6147',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلْعَٰدِيَٰتِ ضَبْحًۭا',
		number_in_surah: '1',
		page: '599',
		surah_id: '100',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6148',
		number: '6148',
		text: 'فَٱلْمُورِيَٰتِ قَدْحًۭا',
		number_in_surah: '2',
		page: '599',
		surah_id: '100',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6149',
		number: '6149',
		text: 'فَٱلْمُغِيرَٰتِ صُبْحًۭا',
		number_in_surah: '3',
		page: '599',
		surah_id: '100',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6150',
		number: '6150',
		text: 'فَأَثَرْنَ بِهِۦ نَقْعًۭا',
		number_in_surah: '4',
		page: '599',
		surah_id: '100',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6151',
		number: '6151',
		text: 'فَوَسَطْنَ بِهِۦ جَمْعًا',
		number_in_surah: '5',
		page: '599',
		surah_id: '100',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6152',
		number: '6152',
		text: 'إِنَّ ٱلْإِنسَٰنَ لِرَبِّهِۦ لَكَنُودٌۭ',
		number_in_surah: '6',
		page: '599',
		surah_id: '100',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6153',
		number: '6153',
		text: 'وَإِنَّهُۥ عَلَىٰ ذَٰلِكَ لَشَهِيدٌۭ',
		number_in_surah: '7',
		page: '599',
		surah_id: '100',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6154',
		number: '6154',
		text: 'وَإِنَّهُۥ لِحُبِّ ٱلْخَيْرِ لَشَدِيدٌ',
		number_in_surah: '8',
		page: '599',
		surah_id: '100',
		hizb_id: '239',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6155',
		number: '6155',
		text: '۞ أَفَلَا يَعْلَمُ إِذَا بُعْثِرَ مَا فِى ٱلْقُبُورِ',
		number_in_surah: '9',
		page: '599',
		surah_id: '100',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6156',
		number: '6156',
		text: 'وَحُصِّلَ مَا فِى ٱلصُّدُورِ',
		number_in_surah: '10',
		page: '600',
		surah_id: '100',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6157',
		number: '6157',
		text: 'إِنَّ رَبَّهُم بِهِمْ يَوْمَئِذٍۢ لَّخَبِيرٌۢ',
		number_in_surah: '11',
		page: '600',
		surah_id: '100',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6158',
		number: '6158',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ ٱلْقَارِعَةُ',
		number_in_surah: '1',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6159',
		number: '6159',
		text: 'مَا ٱلْقَارِعَةُ',
		number_in_surah: '2',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6160',
		number: '6160',
		text: 'وَمَآ أَدْرَىٰكَ مَا ٱلْقَارِعَةُ',
		number_in_surah: '3',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6161',
		number: '6161',
		text: 'يَوْمَ يَكُونُ ٱلنَّاسُ كَٱلْفَرَاشِ ٱلْمَبْثُوثِ',
		number_in_surah: '4',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6162',
		number: '6162',
		text: 'وَتَكُونُ ٱلْجِبَالُ كَٱلْعِهْنِ ٱلْمَنفُوشِ',
		number_in_surah: '5',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6163',
		number: '6163',
		text: 'فَأَمَّا مَن ثَقُلَتْ مَوَٰزِينُهُۥ',
		number_in_surah: '6',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6164',
		number: '6164',
		text: 'فَهُوَ فِى عِيشَةٍۢ رَّاضِيَةٍۢ',
		number_in_surah: '7',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6165',
		number: '6165',
		text: 'وَأَمَّا مَنْ خَفَّتْ مَوَٰزِينُهُۥ',
		number_in_surah: '8',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6166',
		number: '6166',
		text: 'فَأُمُّهُۥ هَاوِيَةٌۭ',
		number_in_surah: '9',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6167',
		number: '6167',
		text: 'وَمَآ أَدْرَىٰكَ مَا هِيَهْ',
		number_in_surah: '10',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6168',
		number: '6168',
		text: 'نَارٌ حَامِيَةٌۢ',
		number_in_surah: '11',
		page: '600',
		surah_id: '101',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6169',
		number: '6169',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ أَلْهَىٰكُمُ ٱلتَّكَاثُرُ',
		number_in_surah: '1',
		page: '600',
		surah_id: '102',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6170',
		number: '6170',
		text: 'حَتَّىٰ زُرْتُمُ ٱلْمَقَابِرَ',
		number_in_surah: '2',
		page: '600',
		surah_id: '102',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6171',
		number: '6171',
		text: 'كَلَّا سَوْفَ تَعْلَمُونَ',
		number_in_surah: '3',
		page: '600',
		surah_id: '102',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6172',
		number: '6172',
		text: 'ثُمَّ كَلَّا سَوْفَ تَعْلَمُونَ',
		number_in_surah: '4',
		page: '600',
		surah_id: '102',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6173',
		number: '6173',
		text: 'كَلَّا لَوْ تَعْلَمُونَ عِلْمَ ٱلْيَقِينِ',
		number_in_surah: '5',
		page: '600',
		surah_id: '102',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:23',
		updated_at: '2018-06-07 08:07:23',
	},
	{
		id: '6174',
		number: '6174',
		text: 'لَتَرَوُنَّ ٱلْجَحِيمَ',
		number_in_surah: '6',
		page: '600',
		surah_id: '102',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6175',
		number: '6175',
		text: 'ثُمَّ لَتَرَوُنَّهَا عَيْنَ ٱلْيَقِينِ',
		number_in_surah: '7',
		page: '600',
		surah_id: '102',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6176',
		number: '6176',
		text: 'ثُمَّ لَتُسْـَٔلُنَّ يَوْمَئِذٍ عَنِ ٱلنَّعِيمِ',
		number_in_surah: '8',
		page: '600',
		surah_id: '102',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6177',
		number: '6177',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَٱلْعَصْرِ',
		number_in_surah: '1',
		page: '601',
		surah_id: '103',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6178',
		number: '6178',
		text: 'إِنَّ ٱلْإِنسَٰنَ لَفِى خُسْرٍ',
		number_in_surah: '2',
		page: '601',
		surah_id: '103',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6179',
		number: '6179',
		text: 'إِلَّا ٱلَّذِينَ ءَامَنُوا۟ وَعَمِلُوا۟ ٱلصَّٰلِحَٰتِ وَتَوَاصَوْا۟ بِٱلْحَقِّ وَتَوَاصَوْا۟ بِٱلصَّبْرِ',
		number_in_surah: '3',
		page: '601',
		surah_id: '103',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6180',
		number: '6180',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ وَيْلٌۭ لِّكُلِّ هُمَزَةٍۢ لُّمَزَةٍ',
		number_in_surah: '1',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6181',
		number: '6181',
		text: 'ٱلَّذِى جَمَعَ مَالًۭا وَعَدَّدَهُۥ',
		number_in_surah: '2',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6182',
		number: '6182',
		text: 'يَحْسَبُ أَنَّ مَالَهُۥٓ أَخْلَدَهُۥ',
		number_in_surah: '3',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6183',
		number: '6183',
		text: 'كَلَّا ۖ لَيُنۢبَذَنَّ فِى ٱلْحُطَمَةِ',
		number_in_surah: '4',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6184',
		number: '6184',
		text: 'وَمَآ أَدْرَىٰكَ مَا ٱلْحُطَمَةُ',
		number_in_surah: '5',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6185',
		number: '6185',
		text: 'نَارُ ٱللَّهِ ٱلْمُوقَدَةُ',
		number_in_surah: '6',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6186',
		number: '6186',
		text: 'ٱلَّتِى تَطَّلِعُ عَلَى ٱلْأَفْـِٔدَةِ',
		number_in_surah: '7',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6187',
		number: '6187',
		text: 'إِنَّهَا عَلَيْهِم مُّؤْصَدَةٌۭ',
		number_in_surah: '8',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6188',
		number: '6188',
		text: 'فِى عَمَدٍۢ مُّمَدَّدَةٍۭ',
		number_in_surah: '9',
		page: '601',
		surah_id: '104',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6189',
		number: '6189',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ أَلَمْ تَرَ كَيْفَ فَعَلَ رَبُّكَ بِأَصْحَٰبِ ٱلْفِيلِ',
		number_in_surah: '1',
		page: '601',
		surah_id: '105',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6190',
		number: '6190',
		text: 'أَلَمْ يَجْعَلْ كَيْدَهُمْ فِى تَضْلِيلٍۢ',
		number_in_surah: '2',
		page: '601',
		surah_id: '105',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6191',
		number: '6191',
		text: 'وَأَرْسَلَ عَلَيْهِمْ طَيْرًا أَبَابِيلَ',
		number_in_surah: '3',
		page: '601',
		surah_id: '105',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6192',
		number: '6192',
		text: 'تَرْمِيهِم بِحِجَارَةٍۢ مِّن سِجِّيلٍۢ',
		number_in_surah: '4',
		page: '601',
		surah_id: '105',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6193',
		number: '6193',
		text: 'فَجَعَلَهُمْ كَعَصْفٍۢ مَّأْكُولٍۭ',
		number_in_surah: '5',
		page: '601',
		surah_id: '105',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6194',
		number: '6194',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ لِإِيلَٰفِ قُرَيْشٍ',
		number_in_surah: '1',
		page: '602',
		surah_id: '106',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6195',
		number: '6195',
		text: 'إِۦلَٰفِهِمْ رِحْلَةَ ٱلشِّتَآءِ وَٱلصَّيْفِ',
		number_in_surah: '2',
		page: '602',
		surah_id: '106',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6196',
		number: '6196',
		text: 'فَلْيَعْبُدُوا۟ رَبَّ هَٰذَا ٱلْبَيْتِ',
		number_in_surah: '3',
		page: '602',
		surah_id: '106',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6197',
		number: '6197',
		text: 'ٱلَّذِىٓ أَطْعَمَهُم مِّن جُوعٍۢ وَءَامَنَهُم مِّنْ خَوْفٍۭ',
		number_in_surah: '4',
		page: '602',
		surah_id: '106',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6198',
		number: '6198',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ أَرَءَيْتَ ٱلَّذِى يُكَذِّبُ بِٱلدِّينِ',
		number_in_surah: '1',
		page: '602',
		surah_id: '107',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6199',
		number: '6199',
		text: 'فَذَٰلِكَ ٱلَّذِى يَدُعُّ ٱلْيَتِيمَ',
		number_in_surah: '2',
		page: '602',
		surah_id: '107',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6200',
		number: '6200',
		text: 'وَلَا يَحُضُّ عَلَىٰ طَعَامِ ٱلْمِسْكِينِ',
		number_in_surah: '3',
		page: '602',
		surah_id: '107',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6201',
		number: '6201',
		text: 'فَوَيْلٌۭ لِّلْمُصَلِّينَ',
		number_in_surah: '4',
		page: '602',
		surah_id: '107',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6202',
		number: '6202',
		text: 'ٱلَّذِينَ هُمْ عَن صَلَاتِهِمْ سَاهُونَ',
		number_in_surah: '5',
		page: '602',
		surah_id: '107',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6203',
		number: '6203',
		text: 'ٱلَّذِينَ هُمْ يُرَآءُونَ',
		number_in_surah: '6',
		page: '602',
		surah_id: '107',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6204',
		number: '6204',
		text: 'وَيَمْنَعُونَ ٱلْمَاعُونَ',
		number_in_surah: '7',
		page: '602',
		surah_id: '107',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6205',
		number: '6205',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِنَّآ أَعْطَيْنَٰكَ ٱلْكَوْثَرَ',
		number_in_surah: '1',
		page: '602',
		surah_id: '108',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6206',
		number: '6206',
		text: 'فَصَلِّ لِرَبِّكَ وَٱنْحَرْ',
		number_in_surah: '2',
		page: '602',
		surah_id: '108',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6207',
		number: '6207',
		text: 'إِنَّ شَانِئَكَ هُوَ ٱلْأَبْتَرُ',
		number_in_surah: '3',
		page: '602',
		surah_id: '108',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6208',
		number: '6208',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ قُلْ يَٰٓأَيُّهَا ٱلْكَٰفِرُونَ',
		number_in_surah: '1',
		page: '603',
		surah_id: '109',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6209',
		number: '6209',
		text: 'لَآ أَعْبُدُ مَا تَعْبُدُونَ',
		number_in_surah: '2',
		page: '603',
		surah_id: '109',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6210',
		number: '6210',
		text: 'وَلَآ أَنتُمْ عَٰبِدُونَ مَآ أَعْبُدُ',
		number_in_surah: '3',
		page: '603',
		surah_id: '109',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6211',
		number: '6211',
		text: 'وَلَآ أَنَا۠ عَابِدٌۭ مَّا عَبَدتُّمْ',
		number_in_surah: '4',
		page: '603',
		surah_id: '109',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6212',
		number: '6212',
		text: 'وَلَآ أَنتُمْ عَٰبِدُونَ مَآ أَعْبُدُ',
		number_in_surah: '5',
		page: '603',
		surah_id: '109',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6213',
		number: '6213',
		text: 'لَكُمْ دِينُكُمْ وَلِىَ دِينِ',
		number_in_surah: '6',
		page: '603',
		surah_id: '109',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6214',
		number: '6214',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ إِذَا جَآءَ نَصْرُ ٱللَّهِ وَٱلْفَتْحُ',
		number_in_surah: '1',
		page: '603',
		surah_id: '110',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6215',
		number: '6215',
		text: 'وَرَأَيْتَ ٱلنَّاسَ يَدْخُلُونَ فِى دِينِ ٱللَّهِ أَفْوَاجًۭا',
		number_in_surah: '2',
		page: '603',
		surah_id: '110',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6216',
		number: '6216',
		text: 'فَسَبِّحْ بِحَمْدِ رَبِّكَ وَٱسْتَغْفِرْهُ ۚ إِنَّهُۥ كَانَ تَوَّابًۢا',
		number_in_surah: '3',
		page: '603',
		surah_id: '110',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6217',
		number: '6217',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ تَبَّتْ يَدَآ أَبِى لَهَبٍۢ وَتَبَّ',
		number_in_surah: '1',
		page: '603',
		surah_id: '111',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6218',
		number: '6218',
		text: 'مَآ أَغْنَىٰ عَنْهُ مَالُهُۥ وَمَا كَسَبَ',
		number_in_surah: '2',
		page: '603',
		surah_id: '111',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6219',
		number: '6219',
		text: 'سَيَصْلَىٰ نَارًۭا ذَاتَ لَهَبٍۢ',
		number_in_surah: '3',
		page: '603',
		surah_id: '111',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6220',
		number: '6220',
		text: 'وَٱمْرَأَتُهُۥ حَمَّالَةَ ٱلْحَطَبِ',
		number_in_surah: '4',
		page: '603',
		surah_id: '111',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6221',
		number: '6221',
		text: 'فِى جِيدِهَا حَبْلٌۭ مِّن مَّسَدٍۭ',
		number_in_surah: '5',
		page: '603',
		surah_id: '111',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6222',
		number: '6222',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ قُلْ هُوَ ٱللَّهُ أَحَدٌ',
		number_in_surah: '1',
		page: '604',
		surah_id: '112',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6223',
		number: '6223',
		text: 'ٱللَّهُ ٱلصَّمَدُ',
		number_in_surah: '2',
		page: '604',
		surah_id: '112',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6224',
		number: '6224',
		text: 'لَمْ يَلِدْ وَلَمْ يُولَدْ',
		number_in_surah: '3',
		page: '604',
		surah_id: '112',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6225',
		number: '6225',
		text: 'وَلَمْ يَكُن لَّهُۥ كُفُوًا أَحَدٌۢ',
		number_in_surah: '4',
		page: '604',
		surah_id: '112',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6226',
		number: '6226',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ قُلْ أَعُوذُ بِرَبِّ ٱلْفَلَقِ',
		number_in_surah: '1',
		page: '604',
		surah_id: '113',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6227',
		number: '6227',
		text: 'مِن شَرِّ مَا خَلَقَ',
		number_in_surah: '2',
		page: '604',
		surah_id: '113',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6228',
		number: '6228',
		text: 'وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ',
		number_in_surah: '3',
		page: '604',
		surah_id: '113',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6229',
		number: '6229',
		text: 'وَمِن شَرِّ ٱلنَّفَّٰثَٰتِ فِى ٱلْعُقَدِ',
		number_in_surah: '4',
		page: '604',
		surah_id: '113',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6230',
		number: '6230',
		text: 'وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ',
		number_in_surah: '5',
		page: '604',
		surah_id: '113',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6231',
		number: '6231',
		text: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ قُلْ أَعُوذُ بِرَبِّ ٱلنَّاسِ',
		number_in_surah: '1',
		page: '604',
		surah_id: '114',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6232',
		number: '6232',
		text: 'مَلِكِ ٱلنَّاسِ',
		number_in_surah: '2',
		page: '604',
		surah_id: '114',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6233',
		number: '6233',
		text: 'إِلَٰهِ ٱلنَّاسِ',
		number_in_surah: '3',
		page: '604',
		surah_id: '114',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6234',
		number: '6234',
		text: 'مِن شَرِّ ٱلْوَسْوَاسِ ٱلْخَنَّاسِ',
		number_in_surah: '4',
		page: '604',
		surah_id: '114',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6235',
		number: '6235',
		text: 'ٱلَّذِى يُوَسْوِسُ فِى صُدُورِ ٱلنَّاسِ',
		number_in_surah: '5',
		page: '604',
		surah_id: '114',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
	{
		id: '6236',
		number: '6236',
		text: 'مِنَ ٱلْجِنَّةِ وَٱلنَّاسِ',
		number_in_surah: '6',
		page: '604',
		surah_id: '114',
		hizb_id: '240',
		juz_id: '30',
		sajda: '0',
		created_at: '2018-06-07 08:07:24',
		updated_at: '2018-06-07 08:07:24',
	},
];
